/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1594);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1504);


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(391);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(387);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(388);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(793), __esModule: true };

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = catchErrors;
	function catchErrors(_ref) {
	  var filename = _ref.filename;
	  var components = _ref.components;
	  var imports = _ref.imports;
	
	  var _imports = _slicedToArray(imports, 3);
	
	  var React = _imports[0];
	  var ErrorReporter = _imports[1];
	  var reporterOptions = _imports[2];
	
	  if (!React || !React.Component) {
	    throw new Error('imports[0] for react-transform-catch-errors does not look like React.');
	  }
	  if (typeof ErrorReporter !== 'function') {
	    throw new Error('imports[1] for react-transform-catch-errors does not look like a React component.');
	  }
	
	  return function wrapToCatchErrors(ReactClass, componentId) {
	    var originalRender = ReactClass.prototype.render;
	
	    ReactClass.prototype.render = function tryRender() {
	      try {
	        return originalRender.apply(this, arguments);
	      } catch (err) {
	        setTimeout(function () {
	          if (typeof console.reportErrorsAsExceptions !== 'undefined') {
	            var prevReportErrorAsExceptions = console.reportErrorsAsExceptions;
	            // We're in React Native. Don't throw.
	            // Stop react-native from triggering its own error handler
	            console.reportErrorsAsExceptions = false;
	            // Log an error
	            console.error(err);
	            // Reactivate it so other errors are still handled
	            console.reportErrorsAsExceptions = prevReportErrorAsExceptions;
	          } else {
	            throw err;
	          }
	        });
	
	        return React.createElement(ErrorReporter, _extends({
	          error: err,
	          filename: filename
	        }, reporterOptions));
	      }
	    };
	
	    return ReactClass;
	  };
	}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.RedBoxError = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _style = __webpack_require__(1560);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _errorStackParser = __webpack_require__(1060);
	
	var _errorStackParser2 = _interopRequireDefault(_errorStackParser);
	
	var _objectAssign = __webpack_require__(609);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _lib = __webpack_require__(1559);
	
	var _sourcemappedStacktrace = __webpack_require__(1571);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RedBoxError = exports.RedBoxError = function (_get__2) {
	  _inherits(RedBoxError, _get__2);
	
	  function RedBoxError(props) {
	    _classCallCheck(this, RedBoxError);
	
	    var _this = _possibleConstructorReturn(this, (RedBoxError.__proto__ || Object.getPrototypeOf(RedBoxError)).call(this, props));
	
	    _this.state = {
	      error: null,
	      mapped: false
	    };
	
	    _this.mapOnConstruction(props.error);
	    return _this;
	  }
	
	  // State is used to store the error mapped to the source map.
	
	
	  _createClass(RedBoxError, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.state.mapped) this.mapError(this.props.error);
	    }
	
	    // Try to map the error when the component gets constructed, this is possible
	    // in some cases like evals.
	
	  }, {
	    key: 'mapOnConstruction',
	    value: function mapOnConstruction(error) {
	      var stackLines = error.stack.split('\n');
	
	      // There's no stack, only the error message.
	      if (stackLines.length < 2) {
	        this.state = { error: error, mapped: true };
	        return;
	      }
	
	      // Using the “eval” setting on webpack already gives the correct location.
	      var isWebpackEval = stackLines[1].search(/\(webpack:\/{3}/) !== -1;
	      if (isWebpackEval) {
	        // No changes are needed here.
	        this.state = { error: error, mapped: true };
	        return;
	      }
	
	      // Other eval follow a specific pattern and can be easily parsed.
	      var isEval = stackLines[1].search(/\(eval at/) !== -1;
	      if (!isEval) {
	        // mapping will be deferred until `componentDidMount`
	        this.state = { error: error, mapped: false };
	        return;
	      }
	
	      // The first line is the error message.
	      var fixedLines = [stackLines.shift()];
	      // The rest needs to be fixed.
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = stackLines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var stackLine = _step.value;
	
	          var evalStackLine = stackLine.match(/(.+)\(eval at (.+) \(.+?\), .+(\:[0-9]+\:[0-9]+)\)/);
	          if (evalStackLine) {
	            var _evalStackLine = _slicedToArray(evalStackLine, 4),
	                atSomething = _evalStackLine[1],
	                file = _evalStackLine[2],
	                rowColumn = _evalStackLine[3];
	
	            fixedLines.push(atSomething + ' (' + file + rowColumn + ')');
	          } else {
	            // TODO: When stack frames of different types are detected, try to load the additional source maps
	            fixedLines.push(stackLine);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      error.stack = fixedLines.join('\n');
	      this.state = { error: error, mapped: true };
	    }
	  }, {
	    key: 'mapError',
	    value: function mapError(error) {
	      var _this2 = this;
	
	      _get__('mapStackTrace')(error.stack, function (mappedStack) {
	        error.stack = mappedStack.join('\n');
	        _this2.setState({ error: error, mapped: true });
	      });
	    }
	  }, {
	    key: 'renderFrames',
	    value: function renderFrames(frames) {
	      var _props = this.props,
	          filename = _props.filename,
	          editorScheme = _props.editorScheme,
	          useLines = _props.useLines,
	          useColumns = _props.useColumns;
	
	      var _get__3 = _get__('assign')({}, _get__('style'), this.props.style),
	          frame = _get__3.frame,
	          file = _get__3.file,
	          linkToFile = _get__3.linkToFile;
	
	      return frames.map(function (f, index) {
	        var text = void 0;
	        var url = void 0;
	
	        if (index === 0 && filename && !_get__('isFilenameAbsolute')(f.fileName)) {
	          url = _get__('makeUrl')(filename, editorScheme);
	          text = _get__('makeLinkText')(filename);
	        } else {
	          var lines = useLines ? f.lineNumber : null;
	          var columns = useColumns ? f.columnNumber : null;
	          url = _get__('makeUrl')(f.fileName, editorScheme, lines, columns);
	          text = _get__('makeLinkText')(f.fileName, lines, columns);
	        }
	
	        return _get__('React').createElement(
	          'div',
	          { style: frame, key: index },
	          _get__('React').createElement(
	            'div',
	            null,
	            f.functionName
	          ),
	          _get__('React').createElement(
	            'div',
	            { style: file },
	            _get__('React').createElement(
	              'a',
	              { href: url, style: linkToFile },
	              text
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // The error is received as a property to initialize state.error, which may
	      // be updated when it is mapped to the source map.
	      var error = this.state.error;
	      var className = this.props.className;
	
	      var _get__4 = _get__('assign')({}, _get__('style'), this.props.style),
	          redbox = _get__4.redbox,
	          message = _get__4.message,
	          stack = _get__4.stack,
	          frame = _get__4.frame;
	
	      var frames = void 0;
	      var parseError = void 0;
	      try {
	        frames = _get__('ErrorStackParser').parse(error);
	      } catch (e) {
	        parseError = new Error('Failed to parse stack trace. Stack trace information unavailable.');
	      }
	
	      if (parseError) {
	        frames = _get__('React').createElement(
	          'div',
	          { style: frame, key: 0 },
	          _get__('React').createElement(
	            'div',
	            null,
	            parseError.message
	          )
	        );
	      } else {
	        frames = this.renderFrames(frames);
	      }
	
	      return _get__('React').createElement(
	        'div',
	        { style: redbox, className: className },
	        _get__('React').createElement(
	          'div',
	          { style: message },
	          error.name,
	          ': ',
	          error.message
	        ),
	        _get__('React').createElement(
	          'div',
	          { style: stack },
	          frames
	        )
	      );
	    }
	  }]);
	
	  return RedBoxError;
	}(_get__('Component'));
	
	// "Portal" component for actual RedBoxError component to
	// render to (directly under body). Prevents bugs as in #27.
	
	
	RedBoxError.propTypes = {
	  error: _get__('PropTypes').instanceOf(Error).isRequired,
	  filename: _get__('PropTypes').string,
	  editorScheme: _get__('PropTypes').string,
	  useLines: _get__('PropTypes').bool,
	  useColumns: _get__('PropTypes').bool,
	  style: _get__('PropTypes').object,
	  className: _get__('PropTypes').string
	};
	RedBoxError.displayName = 'RedBoxError';
	RedBoxError.defaultProps = {
	  useLines: true,
	  useColumns: true };
	
	var RedBox = function (_get__5) {
	  _inherits(RedBox, _get__5);
	
	  function RedBox() {
	    _classCallCheck(this, RedBox);
	
	    return _possibleConstructorReturn(this, (RedBox.__proto__ || Object.getPrototypeOf(RedBox)).apply(this, arguments));
	  }
	
	  _createClass(RedBox, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.el = document.createElement('div');
	      document.body.appendChild(this.el);
	      this.renderRedBoxError();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderRedBoxError();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _get__('ReactDOM').unmountComponentAtNode(this.el);
	      document.body.removeChild(this.el);
	      this.el = null;
	    }
	  }, {
	    key: 'renderRedBoxError',
	    value: function renderRedBoxError() {
	      _get__('ReactDOM').render(_get__('React').createElement(_get__('RedBoxError'), this.props), this.el);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return RedBox;
	}(_get__('Component'));
	
	RedBox.propTypes = {
	  error: _get__('PropTypes').instanceOf(Error).isRequired
	};
	RedBox.displayName = 'RedBox';
	exports.default = RedBox;
	
	var _RewiredData__ = Object.create(null);
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  if (_RewiredData__ === undefined || _RewiredData__[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = _RewiredData__[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'PropTypes':
	      return _propTypes2.default;
	
	    case 'mapStackTrace':
	      return _sourcemappedStacktrace.mapStackTrace;
	
	    case 'assign':
	      return _objectAssign2.default;
	
	    case 'style':
	      return _style2.default;
	
	    case 'isFilenameAbsolute':
	      return _lib.isFilenameAbsolute;
	
	    case 'makeUrl':
	      return _lib.makeUrl;
	
	    case 'makeLinkText':
	      return _lib.makeLinkText;
	
	    case 'ErrorStackParser':
	      return _errorStackParser2.default;
	
	    case 'Component':
	      return _react.Component;
	
	    case 'ReactDOM':
	      return _reactDom2.default;
	
	    case 'React':
	      return _react2.default;
	
	    case 'RedBoxError':
	      return RedBoxError;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  if (_RewiredData__ === undefined || _RewiredData__[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return _RewiredData__[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      _RewiredData__[name] = variableName[name];
	    });
	  } else {
	    if (value === undefined) {
	      _RewiredData__[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      _RewiredData__[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  delete _RewiredData__[variableName];
	}
	
	function _with__(object) {
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      _RewiredData__[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = _RewiredData__[variableName];
	      _RewiredData__[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof RedBox === 'undefined' ? 'undefined' : _typeof(RedBox);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(RedBox, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(RedBox)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}
	
	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(142);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(22);
	var core = __webpack_require__(78);
	var hide = __webpack_require__(60);
	var redefine = __webpack_require__(61);
	var ctx = __webpack_require__(79);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.19.2
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return (Object.getOwnPropertyNames(obj).length === 0);
	    } else {
	        var k;
	        for (k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.weekdayMismatch &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	        }
	        else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function mod(n, x) {
	    return ((n % x) + x) % x;
	}
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            var aliasedRequire = require;
	            __webpack_require__(1250)("./" + name);
	            getSetGlobalLocale(oldLocale);
	        } catch (e) {}
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, tmpLocale, parentConfig = baseConfig;
	        // MERGE
	        tmpLocale = loadLocale(name);
	        if (tmpLocale != null) {
	            parentConfig = tmpLocale._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	
	    // check for mismatching day of week
	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
	        getParsingFlags(config).weekdayMismatch = true;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [
	        untruncateYear(yearStr),
	        defaultLocaleMonthsShort.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10)
	    ];
	
	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }
	
	    return result;
	}
	
	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}
	
	function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
	}
	
	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}
	
	var obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	};
	
	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10);
	        var m = hm % 100, h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i));
	    if (match) {
	        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	        if (!checkWeekday(match[1], parsedArray, config)) {
	            return;
	        }
	
	        config._a = parsedArray;
	        config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	        config._d = createUTCDate.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    switch (units) {
	        case 'year': output = monthDiff(this, that) / 12; break;
	        case 'month': output = monthDiff(this, that); break;
	        case 'quarter': output = monthDiff(this, that) / 3; break;
	        case 'second': output = (this - that) / 1e3; break; // 1000
	        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default: output = this - that;
	    }
	
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function clone$1 () {
	    return createDuration(this);
	}
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function sign(x) {
	    return ((x > 0) - (x < 0)) || +x;
	}
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    var totalSign = total < 0 ? '-' : '';
	    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	    return totalSign + 'P' +
	        (Y ? ymSign + Y + 'Y' : '') +
	        (M ? ymSign + M + 'M' : '') +
	        (D ? daysSign + D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? hmsSign + h + 'H' : '') +
	        (m ? hmsSign + m + 'M' : '') +
	        (s ? hmsSign + s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.clone          = clone$1;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.19.2';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(167)(module)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1447);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(1448);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrderHelper = exports.getCheckByOrder = exports.getCheck = exports.checkPicture = exports.isMobileDevice = exports.NotFoundDecorator = exports.ThemeHelper = exports.log = exports.Html = undefined;
	
	var _utils = __webpack_require__(31);
	
	Object.defineProperty(exports, 'isMobileDevice', {
	  enumerable: true,
	  get: function get() {
	    return _utils.isMobileDevice;
	  }
	});
	Object.defineProperty(exports, 'checkPicture', {
	  enumerable: true,
	  get: function get() {
	    return _utils.checkPicture;
	  }
	});
	Object.defineProperty(exports, 'getCheck', {
	  enumerable: true,
	  get: function get() {
	    return _utils.getCheck;
	  }
	});
	Object.defineProperty(exports, 'getCheckByOrder', {
	  enumerable: true,
	  get: function get() {
	    return _utils.getCheckByOrder;
	  }
	});
	
	var _Html2 = __webpack_require__(1856);
	
	var _Html3 = _interopRequireDefault(_Html2);
	
	var _log2 = __webpack_require__(764);
	
	var _log3 = _interopRequireDefault(_log2);
	
	var _ThemeHelper2 = __webpack_require__(113);
	
	var _ThemeHelper3 = _interopRequireDefault(_ThemeHelper2);
	
	var _NotFoundDecorator2 = __webpack_require__(1857);
	
	var _NotFoundDecorator3 = _interopRequireDefault(_NotFoundDecorator2);
	
	var _Order = __webpack_require__(1858);
	
	var _OrderHelper = _interopRequireWildcard(_Order);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Html = _Html3.default;
	exports.log = _log3.default;
	exports.ThemeHelper = _ThemeHelper3.default;
	exports.NotFoundDecorator = _NotFoundDecorator3.default;
	exports.OrderHelper = _OrderHelper;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MoneyValue = exports.SliderWithQR = exports.VoiceCode = exports.UserProfileMenu = exports.UserProfile = exports.SocialRow = exports.Slider = exports.ShortDescription = exports.Search = exports.SaldoItem = exports.Registration = exports.RegistrationHeader = exports.QuantityProduct = exports.ProductWishIcon = exports.Products = exports.Preloader = exports.PreloaderGlobal = exports.PhoneEmailInput = exports.PasswordChange = exports.PassRecovery = exports.Paginator = exports.OperationsItem = exports.Notification = exports.ModalWindow = exports.MiniBasket = exports.Menu = exports.Logo = exports.Header = exports.HeaderWishIcon = exports.Hamburger = exports.GoodsSlider = exports.FullDescription = exports.Footer = exports.DropdownSelect = exports.ConfirmChangePhone = exports.ConfirmPhone = exports.ConfirmOldMail = exports.ConfirmMail = exports.Basket = exports.AuthOneClick = exports.Auth = exports.AuthHeader = exports.AddToBasket = exports.TranslatePipo = exports.PaymentList = exports.OrderSteps = exports.OrderItemsDetail = exports.OrderItems = exports.IBonusPayment = exports.ColorChooser = exports.AlertError = exports.CouponSearchModal = exports.BuyInCreditModal = exports.ModifierModal = exports.AlcoModal = exports.AddressInput = undefined;
	
	var _AddressInput = __webpack_require__(1597);
	
	Object.defineProperty(exports, 'AddressInput', {
	  enumerable: true,
	  get: function get() {
	    return _AddressInput.AddressInput;
	  }
	});
	
	var _ModifierModal = __webpack_require__(1619);
	
	Object.defineProperty(exports, 'ModifierModal', {
	  enumerable: true,
	  get: function get() {
	    return _ModifierModal.ModifierModal;
	  }
	});
	
	var _BuyInCreditModal = __webpack_require__(1616);
	
	Object.defineProperty(exports, 'BuyInCreditModal', {
	  enumerable: true,
	  get: function get() {
	    return _BuyInCreditModal.BuyInCreditModal;
	  }
	});
	
	var _CouponSearchModal = __webpack_require__(1763);
	
	Object.defineProperty(exports, 'CouponSearchModal', {
	  enumerable: true,
	  get: function get() {
	    return _CouponSearchModal.CouponSearchModal;
	  }
	});
	
	var _AddToBasket = __webpack_require__(1613);
	
	Object.defineProperty(exports, 'AddToBasket', {
	  enumerable: true,
	  get: function get() {
	    return _AddToBasket.AddToBasket;
	  }
	});
	
	var _Auth = __webpack_require__(1609);
	
	Object.defineProperty(exports, 'AuthHeader', {
	  enumerable: true,
	  get: function get() {
	    return _Auth.AuthHeader;
	  }
	});
	Object.defineProperty(exports, 'Auth', {
	  enumerable: true,
	  get: function get() {
	    return _Auth.Auth;
	  }
	});
	Object.defineProperty(exports, 'AuthOneClick', {
	  enumerable: true,
	  get: function get() {
	    return _Auth.AuthOneClick;
	  }
	});
	
	var _Basket = __webpack_require__(1621);
	
	Object.defineProperty(exports, 'Basket', {
	  enumerable: true,
	  get: function get() {
	    return _Basket.Basket;
	  }
	});
	
	var _ConfirmMail = __webpack_require__(1648);
	
	Object.defineProperty(exports, 'ConfirmMail', {
	  enumerable: true,
	  get: function get() {
	    return _ConfirmMail.ConfirmMail;
	  }
	});
	
	var _ConfirmOldMail = __webpack_require__(1651);
	
	Object.defineProperty(exports, 'ConfirmOldMail', {
	  enumerable: true,
	  get: function get() {
	    return _ConfirmOldMail.ConfirmOldMail;
	  }
	});
	
	var _ConfirmPhone = __webpack_require__(1654);
	
	Object.defineProperty(exports, 'ConfirmPhone', {
	  enumerable: true,
	  get: function get() {
	    return _ConfirmPhone.ConfirmPhone;
	  }
	});
	
	var _ConfirmChangePhone = __webpack_require__(1645);
	
	Object.defineProperty(exports, 'ConfirmChangePhone', {
	  enumerable: true,
	  get: function get() {
	    return _ConfirmChangePhone.ConfirmChangePhone;
	  }
	});
	
	var _DropdownSelect = __webpack_require__(1658);
	
	Object.defineProperty(exports, 'DropdownSelect', {
	  enumerable: true,
	  get: function get() {
	    return _DropdownSelect.DropdownSelect;
	  }
	});
	
	var _Footer = __webpack_require__(1661);
	
	Object.defineProperty(exports, 'Footer', {
	  enumerable: true,
	  get: function get() {
	    return _Footer.Footer;
	  }
	});
	
	var _CartProduct = __webpack_require__(749);
	
	Object.defineProperty(exports, 'FullDescription', {
	  enumerable: true,
	  get: function get() {
	    return _CartProduct.FullDescription;
	  }
	});
	
	var _GoodsSlider = __webpack_require__(1666);
	
	Object.defineProperty(exports, 'GoodsSlider', {
	  enumerable: true,
	  get: function get() {
	    return _GoodsSlider.GoodsSlider;
	  }
	});
	
	var _Hamburger = __webpack_require__(1673);
	
	Object.defineProperty(exports, 'Hamburger', {
	  enumerable: true,
	  get: function get() {
	    return _Hamburger.Hamburger;
	  }
	});
	
	var _WishList = __webpack_require__(1792);
	
	Object.defineProperty(exports, 'HeaderWishIcon', {
	  enumerable: true,
	  get: function get() {
	    return _WishList.HeaderWishIcon;
	  }
	});
	
	var _Header = __webpack_require__(1679);
	
	Object.defineProperty(exports, 'Header', {
	  enumerable: true,
	  get: function get() {
	    return _Header.Header;
	  }
	});
	Object.defineProperty(exports, 'Logo', {
	  enumerable: true,
	  get: function get() {
	    return _Header.Logo;
	  }
	});
	
	var _Menu = __webpack_require__(1685);
	
	Object.defineProperty(exports, 'Menu', {
	  enumerable: true,
	  get: function get() {
	    return _Menu.Menu;
	  }
	});
	
	var _MiniBasket = __webpack_require__(1688);
	
	Object.defineProperty(exports, 'MiniBasket', {
	  enumerable: true,
	  get: function get() {
	    return _MiniBasket.MiniBasket;
	  }
	});
	
	var _Modal = __webpack_require__(1691);
	
	Object.defineProperty(exports, 'ModalWindow', {
	  enumerable: true,
	  get: function get() {
	    return _Modal.ModalWindow;
	  }
	});
	
	var _Notification = __webpack_require__(1697);
	
	Object.defineProperty(exports, 'Notification', {
	  enumerable: true,
	  get: function get() {
	    return _Notification.Notification;
	  }
	});
	
	var _Operations = __webpack_require__(1702);
	
	Object.defineProperty(exports, 'OperationsItem', {
	  enumerable: true,
	  get: function get() {
	    return _Operations.OperationsItem;
	  }
	});
	
	var _Paginator = __webpack_require__(1718);
	
	Object.defineProperty(exports, 'Paginator', {
	  enumerable: true,
	  get: function get() {
	    return _Paginator.Paginator;
	  }
	});
	
	var _PassRecovery = __webpack_require__(753);
	
	Object.defineProperty(exports, 'PassRecovery', {
	  enumerable: true,
	  get: function get() {
	    return _PassRecovery.PassRecovery;
	  }
	});
	
	var _PasswordChange = __webpack_require__(1733);
	
	Object.defineProperty(exports, 'PasswordChange', {
	  enumerable: true,
	  get: function get() {
	    return _PasswordChange.PasswordChange;
	  }
	});
	Object.defineProperty(exports, 'PhoneEmailInput', {
	  enumerable: true,
	  get: function get() {
	    return _Modal.PhoneEmailInput;
	  }
	});
	
	var _Preloader = __webpack_require__(1737);
	
	Object.defineProperty(exports, 'PreloaderGlobal', {
	  enumerable: true,
	  get: function get() {
	    return _Preloader.PreloaderGlobal;
	  }
	});
	Object.defineProperty(exports, 'Preloader', {
	  enumerable: true,
	  get: function get() {
	    return _Preloader.Preloader;
	  }
	});
	
	var _Products = __webpack_require__(1741);
	
	Object.defineProperty(exports, 'Products', {
	  enumerable: true,
	  get: function get() {
	    return _Products.Products;
	  }
	});
	Object.defineProperty(exports, 'ProductWishIcon', {
	  enumerable: true,
	  get: function get() {
	    return _WishList.ProductWishIcon;
	  }
	});
	
	var _QuantityProduct = __webpack_require__(1744);
	
	Object.defineProperty(exports, 'QuantityProduct', {
	  enumerable: true,
	  get: function get() {
	    return _QuantityProduct.QuantityProduct;
	  }
	});
	
	var _Registration = __webpack_require__(758);
	
	Object.defineProperty(exports, 'RegistrationHeader', {
	  enumerable: true,
	  get: function get() {
	    return _Registration.RegistrationHeader;
	  }
	});
	Object.defineProperty(exports, 'Registration', {
	  enumerable: true,
	  get: function get() {
	    return _Registration.Registration;
	  }
	});
	Object.defineProperty(exports, 'SaldoItem', {
	  enumerable: true,
	  get: function get() {
	    return _Operations.SaldoItem;
	  }
	});
	
	var _Search = __webpack_require__(759);
	
	Object.defineProperty(exports, 'Search', {
	  enumerable: true,
	  get: function get() {
	    return _Search.Search;
	  }
	});
	Object.defineProperty(exports, 'ShortDescription', {
	  enumerable: true,
	  get: function get() {
	    return _CartProduct.ShortDescription;
	  }
	});
	Object.defineProperty(exports, 'Slider', {
	  enumerable: true,
	  get: function get() {
	    return _CartProduct.Slider;
	  }
	});
	
	var _SocialRow = __webpack_require__(1774);
	
	Object.defineProperty(exports, 'SocialRow', {
	  enumerable: true,
	  get: function get() {
	    return _SocialRow.SocialRow;
	  }
	});
	
	var _UserProfile = __webpack_require__(382);
	
	Object.defineProperty(exports, 'UserProfile', {
	  enumerable: true,
	  get: function get() {
	    return _UserProfile.UserProfile;
	  }
	});
	Object.defineProperty(exports, 'UserProfileMenu', {
	  enumerable: true,
	  get: function get() {
	    return _UserProfile.UserProfileMenu;
	  }
	});
	
	var _VoiceCode = __webpack_require__(1789);
	
	Object.defineProperty(exports, 'VoiceCode', {
	  enumerable: true,
	  get: function get() {
	    return _VoiceCode.VoiceCode;
	  }
	});
	
	var _SliderWithQR = __webpack_require__(1771);
	
	Object.defineProperty(exports, 'SliderWithQR', {
	  enumerable: true,
	  get: function get() {
	    return _SliderWithQR.SliderWithQR;
	  }
	});
	
	var _MoneyValue = __webpack_require__(1694);
	
	Object.defineProperty(exports, 'MoneyValue', {
	  enumerable: true,
	  get: function get() {
	    return _MoneyValue.MoneyValue;
	  }
	});
	
	var _AlcoModal2 = __webpack_require__(746);
	
	var _AlcoModal3 = _interopRequireDefault(_AlcoModal2);
	
	var _AlertError2 = __webpack_require__(1599);
	
	var _AlertError3 = _interopRequireDefault(_AlertError2);
	
	var _ColorChooser2 = __webpack_require__(1642);
	
	var _ColorChooser3 = _interopRequireDefault(_ColorChooser2);
	
	var _IBonusPayment2 = __webpack_require__(1680);
	
	var _IBonusPayment3 = _interopRequireDefault(_IBonusPayment2);
	
	var _OrderItems2 = __webpack_require__(1703);
	
	var _OrderItems3 = _interopRequireDefault(_OrderItems2);
	
	var _OrderItemsDetail2 = __webpack_require__(1704);
	
	var _OrderItemsDetail3 = _interopRequireDefault(_OrderItemsDetail2);
	
	var _OrderSteps2 = __webpack_require__(1705);
	
	var _OrderSteps3 = _interopRequireDefault(_OrderSteps2);
	
	var _PaymentList2 = __webpack_require__(1707);
	
	var _PaymentList3 = _interopRequireDefault(_PaymentList2);
	
	var _TranslatePipo2 = __webpack_require__(1775);
	
	var _TranslatePipo3 = _interopRequireDefault(_TranslatePipo2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AlcoModal = _AlcoModal3.default;
	exports.AlertError = _AlertError3.default;
	exports.ColorChooser = _ColorChooser3.default;
	exports.IBonusPayment = _IBonusPayment3.default;
	exports.OrderItems = _OrderItems3.default;
	exports.OrderItemsDetail = _OrderItemsDetail3.default;
	exports.OrderSteps = _OrderSteps3.default;
	exports.PaymentList = _PaymentList3.default;
	exports.TranslatePipo = _TranslatePipo3.default;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(389);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _StyleConfig = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2['default'])(false, 'A `bsClass` prop is required for this component') : (0, _invariant2['default'])(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _react.PropTypes.string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _react.PropTypes.oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = propType._values = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _react.PropTypes.oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Personal = exports.TranslatePipoConstants = exports.AddressConstants = exports.CouponsConstants = exports.LangConstants = exports.VoiceCodeConstants = exports.OperationsNumericConstants = exports.OperationsConstants = exports.UserMenuItems = exports.UserConstants = exports.PageConstants = exports.PassRecoveryConstants = exports.SliderConstants = exports.PaymentConstants = exports.WishConstants = exports.SettingConstants = exports.ModalConstants = exports.HeadInfoConstants = exports.RegistrationConstants = exports.CurrencyConstants = exports.CatalogNumericConstants = exports.CatalogConstants = exports.BasketConstants = exports.AuthConstants = undefined;
	
	var _auth = __webpack_require__(1865);
	
	Object.defineProperty(exports, 'AuthConstants', {
	  enumerable: true,
	  get: function get() {
	    return _auth.AuthConstants;
	  }
	});
	
	var _basket = __webpack_require__(1866);
	
	Object.defineProperty(exports, 'BasketConstants', {
	  enumerable: true,
	  get: function get() {
	    return _basket.BasketConstants;
	  }
	});
	
	var _catalog = __webpack_require__(1867);
	
	Object.defineProperty(exports, 'CatalogConstants', {
	  enumerable: true,
	  get: function get() {
	    return _catalog.CatalogConstants;
	  }
	});
	Object.defineProperty(exports, 'CatalogNumericConstants', {
	  enumerable: true,
	  get: function get() {
	    return _catalog.CatalogNumericConstants;
	  }
	});
	
	var _currency = __webpack_require__(1869);
	
	Object.defineProperty(exports, 'CurrencyConstants', {
	  enumerable: true,
	  get: function get() {
	    return _currency.CurrencyConstants;
	  }
	});
	
	var _registration = __webpack_require__(1879);
	
	Object.defineProperty(exports, 'RegistrationConstants', {
	  enumerable: true,
	  get: function get() {
	    return _registration.RegistrationConstants;
	  }
	});
	
	var _headInfo = __webpack_require__(1870);
	
	Object.defineProperty(exports, 'HeadInfoConstants', {
	  enumerable: true,
	  get: function get() {
	    return _headInfo.HeadInfoConstants;
	  }
	});
	
	var _modal = __webpack_require__(1872);
	
	Object.defineProperty(exports, 'ModalConstants', {
	  enumerable: true,
	  get: function get() {
	    return _modal.ModalConstants;
	  }
	});
	
	var _setting = __webpack_require__(1880);
	
	Object.defineProperty(exports, 'SettingConstants', {
	  enumerable: true,
	  get: function get() {
	    return _setting.SettingConstants;
	  }
	});
	
	var _wish_list = __webpack_require__(1884);
	
	Object.defineProperty(exports, 'WishConstants', {
	  enumerable: true,
	  get: function get() {
	    return _wish_list.WishConstants;
	  }
	});
	
	var _payment = __webpack_require__(1876);
	
	Object.defineProperty(exports, 'PaymentConstants', {
	  enumerable: true,
	  get: function get() {
	    return _payment.PaymentConstants;
	  }
	});
	
	var _sliders = __webpack_require__(261);
	
	Object.defineProperty(exports, 'SliderConstants', {
	  enumerable: true,
	  get: function get() {
	    return _sliders.SliderConstants;
	  }
	});
	
	var _pass_recovery = __webpack_require__(1875);
	
	Object.defineProperty(exports, 'PassRecoveryConstants', {
	  enumerable: true,
	  get: function get() {
	    return _pass_recovery.PassRecoveryConstants;
	  }
	});
	
	var _page = __webpack_require__(1874);
	
	Object.defineProperty(exports, 'PageConstants', {
	  enumerable: true,
	  get: function get() {
	    return _page.PageConstants;
	  }
	});
	
	var _user = __webpack_require__(1882);
	
	Object.defineProperty(exports, 'UserConstants', {
	  enumerable: true,
	  get: function get() {
	    return _user.UserConstants;
	  }
	});
	Object.defineProperty(exports, 'UserMenuItems', {
	  enumerable: true,
	  get: function get() {
	    return _user.UserMenuItems;
	  }
	});
	
	var _operations = __webpack_require__(1873);
	
	Object.defineProperty(exports, 'OperationsConstants', {
	  enumerable: true,
	  get: function get() {
	    return _operations.OperationsConstants;
	  }
	});
	Object.defineProperty(exports, 'OperationsNumericConstants', {
	  enumerable: true,
	  get: function get() {
	    return _operations.OperationsNumericConstants;
	  }
	});
	
	var _voice_code = __webpack_require__(1883);
	
	Object.defineProperty(exports, 'VoiceCodeConstants', {
	  enumerable: true,
	  get: function get() {
	    return _voice_code.VoiceCodeConstants;
	  }
	});
	
	var _lang = __webpack_require__(1871);
	
	Object.defineProperty(exports, 'LangConstants', {
	  enumerable: true,
	  get: function get() {
	    return _lang.LangConstants;
	  }
	});
	
	var _coupons = __webpack_require__(1868);
	
	Object.defineProperty(exports, 'CouponsConstants', {
	  enumerable: true,
	  get: function get() {
	    return _coupons.CouponsConstants;
	  }
	});
	
	var _address = __webpack_require__(1864);
	
	Object.defineProperty(exports, 'AddressConstants', {
	  enumerable: true,
	  get: function get() {
	    return _address.AddressConstants;
	  }
	});
	
	var _translate_pipo = __webpack_require__(1881);
	
	Object.defineProperty(exports, 'TranslatePipoConstants', {
	  enumerable: true,
	  get: function get() {
	    return _translate_pipo.TranslatePipoConstants;
	  }
	});
	
	var _order_detail = __webpack_require__(1877);
	
	var _order_list = __webpack_require__(1878);
	
	var Personal = exports.Personal = { OrderDetail: _order_detail.OrderDetail, OrderList: _order_list.OrderList, OrderNumericConstants: _order_list.OrderNumericConstants };

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* components */
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Router2 = __webpack_require__(1461);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	exports.Router = _Router3['default'];
	
	var _Link2 = __webpack_require__(684);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	exports.Link = _Link3['default'];
	
	var _IndexLink2 = __webpack_require__(1455);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	exports.IndexLink = _IndexLink3['default'];
	
	/* components (configuration) */
	
	var _IndexRedirect2 = __webpack_require__(1456);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	exports.IndexRedirect = _IndexRedirect3['default'];
	
	var _IndexRoute2 = __webpack_require__(1457);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	exports.IndexRoute = _IndexRoute3['default'];
	
	var _Redirect2 = __webpack_require__(685);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	exports.Redirect = _Redirect3['default'];
	
	var _Route2 = __webpack_require__(1459);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	exports.Route = _Route3['default'];
	
	/* mixins */
	
	var _History2 = __webpack_require__(1454);
	
	var _History3 = _interopRequireDefault(_History2);
	
	exports.History = _History3['default'];
	
	var _Lifecycle2 = __webpack_require__(1458);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	exports.Lifecycle = _Lifecycle3['default'];
	
	var _RouteContext2 = __webpack_require__(1460);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	exports.RouteContext = _RouteContext3['default'];
	
	/* utils */
	
	var _useRoutes2 = __webpack_require__(1472);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	exports.useRoutes = _useRoutes3['default'];
	
	var _RouteUtils = __webpack_require__(110);
	
	exports.createRoutes = _RouteUtils.createRoutes;
	
	var _RouterContext2 = __webpack_require__(248);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	exports.RouterContext = _RouterContext3['default'];
	
	var _RoutingContext2 = __webpack_require__(1462);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	exports.RoutingContext = _RoutingContext3['default'];
	
	var _PropTypes2 = __webpack_require__(137);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	exports.PropTypes = _PropTypes3['default'];
	
	var _match2 = __webpack_require__(1470);
	
	var _match3 = _interopRequireDefault(_match2);
	
	exports.match = _match3['default'];
	
	var _useRouterHistory2 = __webpack_require__(690);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	exports.useRouterHistory = _useRouterHistory3['default'];
	
	var _PatternUtils = __webpack_require__(159);
	
	exports.formatPattern = _PatternUtils.formatPattern;
	
	/* histories */
	
	var _browserHistory2 = __webpack_require__(1464);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	exports.browserHistory = _browserHistory3['default'];
	
	var _hashHistory2 = __webpack_require__(1468);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	exports.hashHistory = _hashHistory3['default'];
	
	var _createMemoryHistory2 = __webpack_require__(687);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	exports.createMemoryHistory = _createMemoryHistory3['default'];

/***/ }),
/* 20 */
[1945, 25],
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.Well = exports.Tooltip = exports.Thumbnail = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressBar = exports.Popover = exports.PanelGroup = exports.Panel = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Label = exports.Jumbotron = exports.InputGroup = exports.Image = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.ControlLabel = exports.Clearfix = exports.Checkbox = exports.CarouselItem = exports.Carousel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.Accordion = undefined;
	
	var _Accordion2 = __webpack_require__(1296);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__(1297);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _Badge2 = __webpack_require__(1298);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__(1299);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__(627);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__(180);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__(628);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__(1300);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _Carousel2 = __webpack_require__(1301);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _CarouselItem2 = __webpack_require__(629);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	var _Checkbox2 = __webpack_require__(1303);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__(1304);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _ControlLabel2 = __webpack_require__(1306);
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__(1305);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__(335);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dropdown2 = __webpack_require__(233);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__(1307);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _Fade2 = __webpack_require__(234);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__(1309);
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__(1310);
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormGroup2 = __webpack_require__(1313);
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__(336);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__(631);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__(1314);
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Image2 = __webpack_require__(1315);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__(1316);
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _Jumbotron2 = __webpack_require__(1319);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _Label2 = __webpack_require__(1320);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _ListGroup2 = __webpack_require__(1321);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__(632);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _Media2 = __webpack_require__(337);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MenuItem2 = __webpack_require__(1328);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__(1329);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__(633);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalFooter2 = __webpack_require__(634);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__(635);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__(636);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__(637);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__(1332);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__(639);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavDropdown2 = __webpack_require__(1331);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__(638);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__(640);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__(1336);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _PageHeader2 = __webpack_require__(1337);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__(1338);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__(1339);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__(1340);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _Panel2 = __webpack_require__(1342);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	var _PanelGroup2 = __webpack_require__(642);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	var _Popover2 = __webpack_require__(1343);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _ProgressBar2 = __webpack_require__(1344);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _Radio2 = __webpack_require__(1345);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__(1346);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__(1347);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__(90);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _SplitButton2 = __webpack_require__(1348);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _Tab2 = __webpack_require__(1350);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__(338);
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__(339);
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__(1351);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__(643);
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__(1352);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Thumbnail2 = __webpack_require__(1353);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _Tooltip2 = __webpack_require__(1354);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__(1355);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__(1359);
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.Accordion = _Accordion3['default'];
	exports.Alert = _Alert3['default'];
	exports.Badge = _Badge3['default'];
	exports.Breadcrumb = _Breadcrumb3['default'];
	exports.BreadcrumbItem = _BreadcrumbItem3['default'];
	exports.Button = _Button3['default'];
	exports.ButtonGroup = _ButtonGroup3['default'];
	exports.ButtonToolbar = _ButtonToolbar3['default'];
	exports.Carousel = _Carousel3['default'];
	exports.CarouselItem = _CarouselItem3['default'];
	exports.Checkbox = _Checkbox3['default'];
	exports.Clearfix = _Clearfix3['default'];
	exports.ControlLabel = _ControlLabel3['default'];
	exports.Col = _Col3['default'];
	exports.Collapse = _Collapse3['default'];
	exports.Dropdown = _Dropdown3['default'];
	exports.DropdownButton = _DropdownButton3['default'];
	exports.Fade = _Fade3['default'];
	exports.Form = _Form3['default'];
	exports.FormControl = _FormControl3['default'];
	exports.FormGroup = _FormGroup3['default'];
	exports.Glyphicon = _Glyphicon3['default'];
	exports.Grid = _Grid3['default'];
	exports.HelpBlock = _HelpBlock3['default'];
	exports.Image = _Image3['default'];
	exports.InputGroup = _InputGroup3['default'];
	exports.Jumbotron = _Jumbotron3['default'];
	exports.Label = _Label3['default'];
	exports.ListGroup = _ListGroup3['default'];
	exports.ListGroupItem = _ListGroupItem3['default'];
	exports.Media = _Media3['default'];
	exports.MenuItem = _MenuItem3['default'];
	exports.Modal = _Modal3['default'];
	exports.ModalBody = _ModalBody3['default'];
	exports.ModalFooter = _ModalFooter3['default'];
	exports.ModalHeader = _ModalHeader3['default'];
	exports.ModalTitle = _ModalTitle3['default'];
	exports.Nav = _Nav3['default'];
	exports.Navbar = _Navbar3['default'];
	exports.NavbarBrand = _NavbarBrand3['default'];
	exports.NavDropdown = _NavDropdown3['default'];
	exports.NavItem = _NavItem3['default'];
	exports.Overlay = _Overlay3['default'];
	exports.OverlayTrigger = _OverlayTrigger3['default'];
	exports.PageHeader = _PageHeader3['default'];
	exports.PageItem = _PageItem3['default'];
	exports.Pager = _Pager3['default'];
	exports.Pagination = _Pagination3['default'];
	exports.Panel = _Panel3['default'];
	exports.PanelGroup = _PanelGroup3['default'];
	exports.Popover = _Popover3['default'];
	exports.ProgressBar = _ProgressBar3['default'];
	exports.Radio = _Radio3['default'];
	exports.ResponsiveEmbed = _ResponsiveEmbed3['default'];
	exports.Row = _Row3['default'];
	exports.SafeAnchor = _SafeAnchor3['default'];
	exports.SplitButton = _SplitButton3['default'];
	exports.Tab = _Tab3['default'];
	exports.TabContainer = _TabContainer3['default'];
	exports.TabContent = _TabContent3['default'];
	exports.Table = _Table3['default'];
	exports.TabPane = _TabPane3['default'];
	exports.Tabs = _Tabs3['default'];
	exports.Thumbnail = _Thumbnail3['default'];
	exports.Tooltip = _Tooltip3['default'];
	exports.Well = _Well3['default'];
	exports.utils = _utils;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.showModal = showModal;
	exports.hide = hide;
	
	var _constants = __webpack_require__(18);
	
	/**
	 * action для модального окна
	 * @param nextState объект
	 */
	function showModal(nextState) {
	    return {
	        type: _constants.ModalConstants.MODAL_SHOW,
	        state: nextState
	    };
	}
	
	function hide() {
	    return {
	        type: _constants.ModalConstants.MODAL_HIDE
	    };
	}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1253)();
	}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(708);


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.exports = assign;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(92);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PAY_PICKUP_ID = exports.PAY_PICKUP_SLUG = exports.PAY_COURIER_ID = exports.PAY_COURIER_SLUG = undefined;
	exports.isMobileDevice = isMobileDevice;
	exports.validateNumeric = validateNumeric;
	exports.checkPictureFirstPreview = checkPictureFirstPreview;
	exports.checkPictureFirstUrl = checkPictureFirstUrl;
	exports.checkPicture = checkPicture;
	exports.getCheck = getCheck;
	exports.getCheckByOrder = getCheckByOrder;
	exports.getClassColorByColorId = getClassColorByColorId;
	exports.getCurrentThemeByColorId = getCurrentThemeByColorId;
	exports.getPipoPageOnProcessInput = getPipoPageOnProcessInput;
	exports.getPipoPageOnApiPay = getPipoPageOnApiPay;
	exports.isInt = isInt;
	exports.sortCategoryBylength = sortCategoryBylength;
	exports.stripTags = stripTags;
	exports.cutText = cutText;
	exports.diffObjects = diffObjects;
	exports.replaceCharToArrayIndex = replaceCharToArrayIndex;
	
	var _config = __webpack_require__(192);
	
	var config = _interopRequireWildcard(_config);
	
	var _config2 = __webpack_require__(383);
	
	var _constants = __webpack_require__(743);
	
	var _lodash = __webpack_require__(177);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Created by maximus on 13.12.16.
	 */
	
	var PAY_COURIER_SLUG = exports.PAY_COURIER_SLUG = 'i_bonus_pay_courier';
	var PAY_COURIER_ID = exports.PAY_COURIER_ID = 149;
	var PAY_PICKUP_SLUG = exports.PAY_PICKUP_SLUG = 'i_bonus_pay_pickup';
	var PAY_PICKUP_ID = exports.PAY_PICKUP_ID = 150;
	
	/**
	 * Определяем, является ли устройство, с которого открыта страница, мобильным
	 * @returns {boolean}
	 */
	function isMobileDevice() {
	    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
	    );
	}
	
	/**
	 * Только цифры 0-9 или пустая строка
	 * @returns {boolean}
	 */
	function validateNumeric(value) {
	    return (/^\d+$/.test(value) || value === ''
	    );
	}
	
	function checkPictureFirstPreview(pictures) {
	    var pictureUrl = '';
	    if (pictures && pictures[0]) {
	        if (pictures[0].preview_url) {
	            pictureUrl = pictures[0].preview_url;
	        } else if (pictures[0].url) {
	            pictureUrl = pictures[0].url;
	        }
	    }
	    return pictureUrl;
	}
	
	function checkPictureFirstUrl(pictures) {
	    if (pictures && pictures[0]) {
	        if (pictures[0].url) {
	            return pictures[0].url;
	        } else if (pictures[0].preview_url) {
	            return pictures[0].preview_url;
	        }
	    }
	    return '';
	}
	
	/**
	 * Проверка на наличие картинки в продукте, подставляет picture_url или url в зависимости от наличия
	 * @param pictures массив объектов с картинками
	 * @returns {string} строка url картинки
	 */
	function checkPicture(pictures) {
	    var firstUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (firstUrl) {
	        return checkPictureFirstUrl(pictures);
	    } else {
	        return checkPictureFirstPreview(pictures);
	    }
	}
	
	function getCheck(token) {
	    window.open('' + config.apiHost + _constants.IBONUS_PATH_GET_CHECK + '?token=' + token, '', 'scrollbars=1,location=0,height=' + Math.min(500, screen.availHeight) + ',width=' + Math.min(500, screen.availWidth));
	}
	
	function getCheckByOrder(order) {
	    var iBonusData = null;
	    try {
	        iBonusData = JSON.parse(order.ibonus_data);
	    } catch (e) {
	        iBonusData = {};
	    }
	    if (iBonusData !== null && iBonusData.order_data !== undefined && iBonusData.order_data.receiptUrl !== undefined) {
	        var url = iBonusData.order_data.receiptUrl.replace('/purchase/', '/purchase/receipt/');
	        window.open('' + url, '', 'scrollbars=1,location=0,height=' + Math.min(500, screen.availHeight) + ',width=' + Math.min(500, screen.availWidth));
	    } else if (iBonusData !== null && iBonusData.order_data !== undefined && iBonusData.order_data.publicURL !== undefined && iBonusData.order_data.publicURL !== '/internal_fiscal_check/null/') {
	        window.open('' + config.checkUrl + iBonusData.order_data.publicURL, '', 'scrollbars=1,location=0,height=' + Math.min(500, screen.availHeight) + ',width=' + Math.min(500, screen.availWidth));
	    } else {
	
	        if (order.token !== undefined) {
	            window.open('' + config.apiHost + _constants.IBONUS_PATH_GET_CHECK + '?token=' + order.token, '', 'scrollbars=1,location=0,height=' + Math.min(500, screen.availHeight) + ',width=' + Math.min(500, screen.availWidth));
	        } else {
	            window.open('' + config.apiHost + _constants.IBONUS_PATH_GET_CHECK + '?token=' + order.view_token, '', 'scrollbars=1,location=0,height=' + Math.min(500, screen.availHeight) + ',width=' + Math.min(500, screen.availWidth));
	        }
	    }
	}
	
	function getClassColorByColorId(colorId) {
	    switch (colorId) {
	        case 6:
	            return 'dark-green-theme';
	        case 5:
	            return 'navy-theme';
	        case 4:
	            return 'orange-theme';
	        case 3:
	            return 'red-theme';
	        case 2:
	            return 'blue-theme';
	        case 7:
	            return 'dark-theme';
	        default:
	        case 1:
	            return 'green-theme';
	    }
	}
	
	function getCurrentThemeByColorId(themeColorId) {
	
	    var result = '';
	
	    switch (themeColorId) {
	        case 2:
	            result = 'blue';
	            break;
	        case 4:
	            result = 'orange';
	            break;
	        case 6:
	            result = 'dark-green';
	            break;
	        case 3:
	            result = 'red';
	            break;
	        case 5:
	            result = 'navy';
	            break;
	        case 7:
	            result = 'dark-theme';
	            break;
	        case 1:
	        default:
	            result = 'cube';
	            break;
	    }
	
	    return result;
	}
	
	function getPipoPageOnProcessInput(paymentId, slug) {
	    var additionalFieldName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var additionalFieldText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	    var orderId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	    var currency = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'RUR';
	
	    var url = '/api/process_input?operation_id=' + paymentId + '&group_slug=' + slug;
	    if (additionalFieldName && additionalFieldText) {
	        url += '&' + additionalFieldName + '=' + additionalFieldText;
	    }
	    if (orderId > 0) {
	        var pagePayment = window.location.protocol + '//' + window.location.host + '/payment-order/' + orderId;
	        var pageCreate = window.location.protocol + '//' + window.location.host + '/create-order/' + orderId;
	        url += '&shop_url=' + encodeURIComponent(pagePayment);
	        url += '&success_url=' + encodeURIComponent(pagePayment + '?success=1');
	        url += '&fail_url=' + encodeURIComponent(pageCreate + '?fail');
	        url += '&currency=' + encodeURIComponent('' + currency);
	    }
	
	    return _config2.pipoHost + url;
	}
	
	function getPipoPageOnApiPay(_ref) {
	    var paymentId = _ref.paymentId,
	        _ref$orderId = _ref.orderId,
	        orderId = _ref$orderId === undefined ? 0 : _ref$orderId,
	        _ref$currency = _ref.currency,
	        currency = _ref$currency === undefined ? 'RUR' : _ref$currency,
	        _ref$protocol = _ref.protocol,
	        protocol = _ref$protocol === undefined ? 'http' : _ref$protocol,
	        host = _ref.host;
	
	    var url = '/api/pay/' + paymentId;
	
	    if (orderId > 0) {
	        var pagePayment = '';
	
	        if (typeof window !== 'undefined') {
	            pagePayment = window.location.protocol + '//' + window.location.host + '/payment-order/' + orderId;
	        } else if (protocol && host) {
	            pagePayment = protocol + '://' + host + '/payment-order/' + orderId;
	        }
	
	        url += '?shop_url=' + encodeURIComponent(pagePayment);
	        url += '&success_url=' + encodeURIComponent(pagePayment + '?success=1');
	        url += '&fail_url=' + encodeURIComponent(pagePayment + '?fail');
	        url += '&currency=' + encodeURIComponent('' + currency);
	    }
	
	    return _config2.pipoHost + url;
	}
	
	/**
	 * Проверка, целое ли число
	 * @param num
	 * @returns {boolean}
	 */
	function isInt(num) {
	    return (num ^ 0) === num;
	}
	
	/**
	 * Сортировка категорий по количеству вложеных подкатегорий
	 * @param categories массив категорий
	 */
	function sortCategoryBylength() {
	    var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return categories;
	    categories.sort(function (a, b) {
	        var sortA = a.categories && a.categories.length || 0;
	        var sortB = b.categories && b.categories.length || 0;
	
	        if (sortA > sortB) {
	            return -1;
	        }
	        if (sortA < sortB) {
	            return 1;
	        }
	        return 0;
	    });
	    categories.forEach(function (category) {
	        if (category['categories']) {
	            sortCategoryBylength(category['categories']);
	        }
	    });
	}
	
	/**
	 * Метод очистки строки от html тегов
	 * @param str
	 */
	function stripTags() {
	    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    if (str) {
	        return str.replace(/<\/?[^>]+>/gi, '');
	    }
	    return '';
	}
	
	// Обрезка текста и подстановка ... в конце
	function cutText(text, length) {
	    if (typeof text === 'string') {
	        if (text.length > length - 3) {
	            text = text.substr(0, length) + '...';
	        }
	    }
	
	    return text;
	}
	
	// Сравниваем объект `a` с объектом `b` и возвращаем
	// те свойства из `a`, которых нет в `b` или есть, но
	// значения отличаются.
	// В случае отсутствия различий возвращаем `null`
	function diffObjects(a, b) {
	    var result = {};
	
	    (0, _lodash.each)(a, function (v, k) {
	        if (!(0, _lodash.isEqual)(v, b[k])) {
	            result[k] = v;
	        }
	    });
	
	    return (0, _lodash.isEmpty)(result) ? null : result;
	}
	
	/**
	 * Проверка строки, на содержанние в ней {n}, и вставка на эти места содержимого массива с соответствующим индексом.
	 * @param string
	 * @param array
	 * @returns {string}
	 */
	function replaceCharToArrayIndex() {
	    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    return string.replace(/{(\d)}/, function (str, p1) {
	        if (array[p1] !== undefined) {
	            return array[p1];
	        }
	        return '';
	    });
	}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 33 */
[1995, 215, 129, 22],
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(247);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(683);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(682);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(1453);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(1452);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 */
	
	"use strict";
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function(obj) {
	  var ret = {};
	  var key;
	  if (!(obj instanceof Object && !Array.isArray(obj))) {
	    throw new Error('keyMirror(...): Argument must be an object.');
	  }
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;


/***/ }),
/* 37 */
[1951, 23],
/* 38 */
[1970, 20, 421, 88, 37],
/* 39 */
[1990, 87],
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	__webpack_require__(1381);
	
	__webpack_require__(1382);
	
	__webpack_require__(1383);
	
	__webpack_require__(1384);
	
	__webpack_require__(1385);
	
	__webpack_require__(1386);
	
	__webpack_require__(1387);
	
	var _Helmet = __webpack_require__(1378);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	exports["default"] = _Helmet2["default"];
	module.exports = exports["default"];

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1473);

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.showModalRegistration = showModalRegistration;
	exports.showModalAuth = showModalAuth;
	exports.showModalAuthOneClick = showModalAuthOneClick;
	exports.showModalPassRecovery = showModalPassRecovery;
	exports.showModalConfirmPhone = showModalConfirmPhone;
	exports.showModalConfirmChangePhone = showModalConfirmChangePhone;
	exports.showModalConfirmMail = showModalConfirmMail;
	exports.showModalChangePassword = showModalChangePassword;
	exports.showModalConfirmOldMail = showModalConfirmOldMail;
	exports.showAlcoModal = showAlcoModal;
	exports.showModifierModal = showModifierModal;
	exports.showBuyInCreditModal = showBuyInCreditModal;
	exports.showSuccessfulModal = showSuccessfulModal;
	exports.showCouponSearchModal = showCouponSearchModal;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modal = __webpack_require__(26);
	
	var _components2 = __webpack_require__(16);
	
	var _constants = __webpack_require__(752);
	
	var _modals = __webpack_require__(1795);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function showModalRegistration(lang) {
	    var title = 'Registration';
	    if (lang) {
	        title = lang['store.register.register'];
	    }
	    return (0, _modal.showModal)({
	        title: title,
	        content: _react2.default.createElement(_components2.Registration, null),
	        modalType: _constants.REGISTRATION
	    });
	}
	
	function showModalAuth(lang) {
	    return (0, _modal.showModal)({
	        title: lang['login.logIn'],
	        content: _react2.default.createElement(_components2.Auth, null),
	        modalType: _constants.AUTH
	    });
	}
	
	function showModalAuthOneClick() {
	    var isCreateOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    return (0, _modal.showModal)({
	        title: '',
	        content: _react2.default.createElement(_components2.AuthOneClick, { isCreateOrder: isCreateOrder }),
	        modalType: _constants.AUTH_ONE_CLICK
	    });
	}
	
	function showModalPassRecovery(lang) {
	    return (0, _modal.showModal)({
	        title: lang['store.modals.restore_password'],
	        content: _react2.default.createElement(_components2.PassRecovery, null),
	        modalType: _constants.PASS_RECOVERY
	    });
	}
	
	function showModalConfirmPhone(pipoId, newPhone, title, succesOperationText) {
	    return (0, _modal.showModal)({
	        title: title,
	        content: _react2.default.createElement(_components2.ConfirmPhone, { pipoId: pipoId, newPhone: newPhone, succesOperationText: succesOperationText }),
	        modalType: _constants.CONFIRM_PHONE
	    });
	}
	
	function showModalConfirmChangePhone(pipoId, newPhone, title, succesOperationText) {
	    return (0, _modal.showModal)({
	        title: title,
	        content: _react2.default.createElement(_components2.ConfirmChangePhone, { pipoId: pipoId, newPhone: newPhone, succesOperationText: succesOperationText }),
	        modalType: _constants.CONFIRM_CHANGE_PHONE
	    });
	}
	
	function showModalConfirmMail(pipoId, newMail, message, lang) {
	    return (0, _modal.showModal)({
	        title: lang['store.modals.email_confirm'],
	        content: _react2.default.createElement(_components2.ConfirmMail, { pipoId: pipoId, newMail: newMail, message: message }),
	        modalType: _constants.CONFIRM_MAIL
	    });
	}
	
	function showModalChangePassword(lang) {
	    return (0, _modal.showModal)({
	        title: lang['store.modals.password_change'],
	        content: _react2.default.createElement(_components2.PasswordChange, null),
	        modalType: _constants.PASSWORD_CHANGE
	    });
	}
	
	function showModalConfirmOldMail() {
	    return (0, _modal.showModal)({
	        title: lang['store.modals.email_confirm'],
	        content: _react2.default.createElement(_components2.ConfirmOldMail, null),
	        modalType: _constants.CONFIRM_OLD_MAIL
	    });
	}
	
	function showAlcoModal(confirmModal, lang) {
	    return (0, _modal.showModal)({
	        title: lang['store.modals.alcohol'],
	        content: _react2.default.createElement(_components2.AlcoModal, null),
	        modalType: _constants.ALCOHOL_MODAL,
	        onSuccess: confirmModal
	    });
	}
	
	function showModifierModal(product_detail, title) {
	    var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	    return (0, _modal.showModal)({
	        title: title,
	        content: _react2.default.createElement(_components2.ModifierModal, { product_detail: product_detail, count: count }),
	        modalType: _constants.MODIFIER_MODAL
	    });
	}
	
	function showBuyInCreditModal(order_detail, title, buy_in_credit) {
	    return (0, _modal.showModal)({
	        title: title,
	        content: _react2.default.createElement(_components2.BuyInCreditModal, { order_detail: order_detail, buy_in_credit: buy_in_credit, title: title }),
	        modalType: _constants.BUY_IN_CREDIT_MODAL
	    });
	}
	
	function showSuccessfulModal(successfulMessage) {
	    return (0, _modal.showModal)({
	        title: 'Успешно',
	        content: _react2.default.createElement(_modals.SuccessfulModal, { successfulMessage: successfulMessage }),
	        modalType: _constants.SAVE_SUCCESS
	    });
	}
	
	function showCouponSearchModal(lang) {
	    return (0, _modal.showModal)({
	        title: lang['store.iBonus.modals.title'],
	        content: _react2.default.createElement(_components2.CouponSearchModal, null),
	        modalType: 'couponSearchModal'
	    });
	}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.asyncConnect = exports.loadSuccess = exports.clearKey = exports.reducer = exports.ReduxAsyncConnect = exports.loadOnServer = undefined;
	
	var _ReduxAsyncConnect = __webpack_require__(1562);
	
	var _ReduxAsyncConnect2 = _interopRequireDefault(_ReduxAsyncConnect);
	
	var _asyncConnect = __webpack_require__(737);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.loadOnServer = _ReduxAsyncConnect.loadOnServer;
	exports.ReduxAsyncConnect = _ReduxAsyncConnect2.default;
	exports.reducer = _asyncConnect.reducer;
	exports.clearKey = _asyncConnect.clearKey;
	exports.loadSuccess = _asyncConnect.loadSuccess;
	exports.asyncConnect = _asyncConnect.asyncConnect;

/***/ }),
/* 44 */
[1991, 85],
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(69);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(68);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Проксираем доступ к localStorage
	// Если не доступен localStorage или на серве,
	// то запись ведется в простой объект
	
	var LocalStorageProxy = function () {
	  function LocalStorageProxy() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, LocalStorageProxy);
	    this._storage = {};
	
	    var store = __webpack_require__(1573);
	    // if (__CLIENT__) {
	    try {
	      window.localStorage.setItem('__TEST__', 1);
	      window.localStorage.getItem('__TEST__');
	      window.localStorage.removeItem('__TEST__');
	      this._storage = window.localStorage;
	      this.setItem = function (key, value) {
	        return _this._storage.setItem(key, value);
	      };
	
	      if (!(typeof this.setItem === 'function')) {
	        throw new TypeError('Value of "this.setItem" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(this.setItem));
	      }
	
	      this.getItem = function (key) {
	        return _this._storage.getItem(key);
	      };
	
	      if (!(typeof this.getItem === 'function')) {
	        throw new TypeError('Value of "this.getItem" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(this.getItem));
	      }
	
	      this.removeItem = function (key) {
	        return _this._storage.removeItem(key);
	      };
	
	      if (!(typeof this.removeItem === 'function')) {
	        throw new TypeError('Value of "this.removeItem" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(this.removeItem));
	      }
	
	      this.clear = function () {
	        return _this._storage.clear();
	      };
	
	      if (!(typeof this.clear === 'function')) {
	        throw new TypeError('Value of "this.clear" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(this.clear));
	      }
	    } catch (e) {
	      this._storage = store;
	      this.setItem = function (key, value) {
	        return _this._storage.set(key, value);
	      };
	
	      if (!(typeof this.setItem === 'function')) {
	        throw new TypeError('Value of "this.setItem" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(this.setItem));
	      }
	
	      this.getItem = function (key) {
	        return _this._storage.get(key);
	      };
	
	      if (!(typeof this.getItem === 'function')) {
	        throw new TypeError('Value of "this.getItem" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(this.getItem));
	      }
	
	      this.removeItem = function (key) {
	        return _this._storage.remove(key);
	      };
	
	      if (!(typeof this.removeItem === 'function')) {
	        throw new TypeError('Value of "this.removeItem" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(this.removeItem));
	      }
	
	      this.clear = function () {
	        return _this._storage.clearAll();
	      };
	
	      if (!(typeof this.clear === 'function')) {
	        throw new TypeError('Value of "this.clear" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(this.clear));
	      }
	    }
	    // }
	  }
	
	  (0, _createClass3.default)(LocalStorageProxy, [{
	    key: 'setItem',
	    value: function setItem(key, value) {
	      this._storage[key] = this._toString(value);
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem(key) {
	      return this._storage[key] === undefined ? null : this._storage[key];
	    }
	  }, {
	    key: 'removeItem',
	    value: function removeItem(key) {
	      delete this._storage[key];
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this._storage = {};
	    }
	  }, {
	    key: '_toString',
	    value: function _toString(value) {
	      return typeof value !== 'string' ? (0, _stringify2.default)(value) : value;
	    }
	  }]);
	  return LocalStorageProxy;
	}();
	
	var storage = new LocalStorageProxy();
	exports.default = storage;
	
	function _inspect(input, depth) {
	  var maxDepth = 4;
	  var maxKeys = 15;
	
	  if (depth === undefined) {
	    depth = 0;
	  }
	
	  depth += 1;
	
	  if (input === null) {
	    return 'null';
	  } else if (input === undefined) {
	    return 'void';
	  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	  } else if (Array.isArray(input)) {
	    if (input.length > 0) {
	      if (depth > maxDepth) return '[...]';
	
	      var first = _inspect(input[0], depth);
	
	      if (input.every(function (item) {
	        return _inspect(item, depth) === first;
	      })) {
	        return first.trim() + '[]';
	      } else {
	        return '[' + input.slice(0, maxKeys).map(function (item) {
	          return _inspect(item, depth);
	        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	      }
	    } else {
	      return 'Array';
	    }
	  } else {
	    var keys = (0, _keys2.default)(input);
	
	    if (!keys.length) {
	      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	        return input.constructor.name;
	      } else {
	        return 'Object';
	      }
	    }
	
	    if (depth > maxDepth) return '{...}';
	    var indent = '  '.repeat(depth - 1);
	    var entries = keys.slice(0, maxKeys).map(function (key) {
	      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	    }).join('\n  ' + indent);
	
	    if (keys.length >= maxKeys) {
	      entries += '\n  ' + indent + '...';
	    }
	
	    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	    } else {
	      return '{\n  ' + indent + entries + '\n' + indent + '}';
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.exports = exports['default'];

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(266);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(777);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = routerWarning;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(83);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function routerWarning(falseToWarn, message) {
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	   false ? _warning2['default'].apply(undefined, [falseToWarn, message].concat(args)) : undefined;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isLoadedInServer = isLoadedInServer;
	exports.isLoaded = isLoaded;
	exports.load = load;
	exports.login = login;
	exports.logout = logout;
	exports.resetError = resetError;
	exports.resetAuth = resetAuth;
	exports.refreshLogout = refreshLogout;
	
	var _constants = __webpack_require__(18);
	
	function isLoadedInServer(globalState) {
	    return globalState.auth && globalState.auth.loadedInServer;
	}
	
	function isLoaded(globalState) {
	    return globalState.auth && globalState.auth.loaded;
	}
	
	function load() {
	    return {
	        types: [_constants.AuthConstants.AUTH_LOAD, _constants.AuthConstants.AUTH_LOAD_SUCCESS, _constants.AuthConstants.AUTH_LOAD_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getUserData();
	        }
	    };
	}
	
	function login(_ref) {
	    var login = _ref.login,
	        password = _ref.password,
	        _ref$captcha = _ref.captcha,
	        captcha = _ref$captcha === undefined ? null : _ref$captcha,
	        _ref$callback = _ref.callback,
	        callback = _ref$callback === undefined ? null : _ref$callback,
	        _ref$shopId = _ref.shopId,
	        shopId = _ref$shopId === undefined ? null : _ref$shopId;
	
	    return {
	        types: [_constants.AuthConstants.LOGIN, _constants.AuthConstants.LOGIN_SUCCESS, _constants.AuthConstants.LOGIN_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.userAuthentication(login, password, captcha, shopId).then(function (result) {
	                if (callback) callback();
	                return result;
	            });
	        }
	    };
	}
	
	function logout() {
	    return {
	        types: [_constants.AuthConstants.LOGOUT, _constants.AuthConstants.LOGOUT_SUCCESS, _constants.AuthConstants.LOGOUT_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.userLogout();
	        }
	    };
	}
	
	function resetError() {
	    return {
	        type: _constants.AuthConstants.AUTH_RESET_ERROR
	    };
	}
	
	function resetAuth() {
	    return {
	        type: _constants.AuthConstants.AUTH_RESET
	    };
	}
	
	function refreshLogout() {
	    return {
	        type: _constants.AuthConstants.REFRESH_LOGOUT_SUCCESS
	    };
	}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(55);
	var core = __webpack_require__(32);
	var ctx = __webpack_require__(145);
	var hide = __webpack_require__(118);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 55 */
22,
/* 56 */
[1995, 276, 202, 55],
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(160);
	var ReactBrowserEventEmitter = __webpack_require__(250);
	var ReactCurrentOwner = __webpack_require__(100);
	var ReactDOMFeatureFlags = __webpack_require__(709);
	var ReactElement = __webpack_require__(65);
	var ReactEmptyComponentRegistry = __webpack_require__(717);
	var ReactInstanceHandles = __webpack_require__(161);
	var ReactInstanceMap = __webpack_require__(188);
	var ReactMarkupChecksum = __webpack_require__(720);
	var ReactPerf = __webpack_require__(81);
	var ReactReconciler = __webpack_require__(138);
	var ReactUpdateQueue = __webpack_require__(368);
	var ReactUpdates = __webpack_require__(82);
	
	var assign = __webpack_require__(29);
	var emptyObject = __webpack_require__(190);
	var containsNode = __webpack_require__(732);
	var instantiateReactComponent = __webpack_require__(375);
	var invariant = __webpack_require__(21);
	var setInnerHTML = __webpack_require__(257);
	var shouldUpdateReactComponent = __webpack_require__(378);
	var validateDOMNesting = __webpack_require__(380);
	var warning = __webpack_require__(30);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if (false) {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        !!isValid(cached, id) ?  false ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    !(internalGetID(node) === id) ?  false ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
	  if (ReactDOMFeatureFlags.useCreateElement) {
	    context = assign({}, context);
	    if (container.nodeType === DOC_NODE_TYPE) {
	      context[ownerDocumentContextKey] = container;
	    } else {
	      context[ownerDocumentContextKey] = container.ownerDocument;
	    }
	  }
	  if (false) {
	    if (context === emptyObject) {
	      context = {};
	    }
	    var tag = container.nodeName.toLowerCase();
	    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
	  }
	  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
	  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* forceHTML */shouldReuseMarkup);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container) {
	  ReactReconciler.unmountComponent(instance);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(node) {
	  var reactRootID = getReactRootID(node);
	  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
	}
	
	/**
	 * Returns the first (deepest) ancestor of a node which is rendered by this copy
	 * of React.
	 */
	function findFirstReactDOMImpl(node) {
	  // This node might be from another React instance, so we make sure not to
	  // examine the node cache here
	  for (; node && node.parentNode !== node; node = node.parentNode) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      continue;
	    }
	    var nodeID = internalGetID(node);
	    if (!nodeID) {
	      continue;
	    }
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	
	    // If containersByReactRootID contains the container we find by crawling up
	    // the tree, we know that this instance of React rendered the node.
	    // nb. isValid's strategy (with containsNode) does not work because render
	    // trees may be nested and we don't want a false positive in that case.
	    var current = node;
	    var lastID;
	    do {
	      lastID = internalGetID(current);
	      current = current.parentNode;
	      if (current == null) {
	        // The passed-in node has been detached from the container it was
	        // originally rendered into.
	        return null;
	      }
	    } while (lastID !== reactRootID);
	
	    if (current === containersByReactRootID[reactRootID]) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var TopLevelWrapper = function () {};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function (nextComponent, container) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(componentInstance, container);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;
	
	    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function (container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var containerID = internalGetID(container);
	      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
	      }
	
	      return false;
	    }
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (false) {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function (id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if (false) {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        process.env.NODE_ENV !== 'production' ? warning(
	        // Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
	        var containerChild = container.firstChild;
	        if (containerChild && reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function (id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component rendered by this copy of React.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function (node) {
	    return findFirstReactDOMImpl(node);
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function (ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    if (false) {
	      // This will throw on the next line; give an early warning
	      process.env.NODE_ENV !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
	    }
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	     true ?  false ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
	  },
	
	  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      container.appendChild(markup);
	    } else {
	      setInnerHTML(container, markup);
	    }
	  },
	
	  ownerDocumentContextKey: ownerDocumentContextKey,
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  isValid: isValid,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(797), __esModule: true };

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 60 */
[1955, 38, 125, 37],
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(22);
	var hide = __webpack_require__(60);
	var has = __webpack_require__(59);
	var SRC = __webpack_require__(129)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(78).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var fails = __webpack_require__(23);
	var defined = __webpack_require__(85);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.map(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = undefined;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports['default'] = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(100);
	
	var assign = __webpack_require__(29);
	var canDefineProperty = __webpack_require__(255);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    Object.freeze(element.props);
	    Object.freeze(element);
	  }
	
	  return element;
	};
	
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
	  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);
	
	  if (false) {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	
	  return newElement;
	};
	
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _stringify = __webpack_require__(68);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(69);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _defineProperty2 = __webpack_require__(197);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BaseForm = function (_Component) {
	    (0, _inherits3.default)(BaseForm, _Component);
	
	    function BaseForm(props, context) {
	        (0, _classCallCheck3.default)(this, BaseForm);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BaseForm.__proto__ || (0, _getPrototypeOf2.default)(BaseForm)).call(this, props, context));
	
	        _this.changeField = _this.changeField.bind(_this);
	
	        if (!(typeof _this.changeField === 'function')) {
	            throw new TypeError("Value of \"this.changeField\" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n" + _inspect(_this.changeField));
	        }
	
	        _this.onSubmit = _this.onSubmit.bind(_this);
	
	        if (!(typeof _this.onSubmit === 'function')) {
	            throw new TypeError("Value of \"this.onSubmit\" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n" + _inspect(_this.onSubmit));
	        }
	
	        _this.isValid = _this.isValid.bind(_this);
	
	        if (!(typeof _this.isValid === 'function')) {
	            throw new TypeError("Value of \"this.isValid\" violates contract.\n\nExpected:\n() => any\n\nGot:\n" + _inspect(_this.isValid));
	        }
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(BaseForm, [{
	        key: "onSubmit",
	        value: function onSubmit(event) {
	            event.preventDefault();
	        }
	    }, {
	        key: "isValid",
	
	
	        /**
	         * Валидация по всем методам проверки
	         *
	         * @returns {boolean}
	         */
	        value: function isValid() {
	            return true;
	        }
	    }, {
	        key: "changeField",
	        value: function changeField(fieldName) {
	            var _this2 = this;
	
	            return function (event, value) {
	                if (value === undefined) {
	                    event.preventDefault();
	                    _this2.setState((0, _defineProperty3.default)({}, fieldName, event.target.value), function () {
	                        if (_this2.props.onChange) {
	                            _this2.props.onChange(_this2.state);
	                        }
	                    });
	                } else {
	                    _this2.setState((0, _defineProperty3.default)({}, fieldName, value), function () {
	                        if (_this2.props.onChange) {
	                            _this2.props.onChange(_this2.state);
	                        }
	                    });
	                }
	            };
	        }
	    }]);
	    return BaseForm;
	}(_react.Component);
	
	exports.default = BaseForm;
	
	function _inspect(input, depth) {
	    var maxDepth = 4;
	    var maxKeys = 15;
	
	    if (depth === undefined) {
	        depth = 0;
	    }
	
	    depth += 1;
	
	    if (input === null) {
	        return 'null';
	    } else if (input === undefined) {
	        return 'void';
	    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	        return typeof input === "undefined" ? "undefined" : (0, _typeof3.default)(input);
	    } else if (Array.isArray(input)) {
	        if (input.length > 0) {
	            if (depth > maxDepth) return '[...]';
	
	            var first = _inspect(input[0], depth);
	
	            if (input.every(function (item) {
	                return _inspect(item, depth) === first;
	            })) {
	                return first.trim() + '[]';
	            } else {
	                return '[' + input.slice(0, maxKeys).map(function (item) {
	                    return _inspect(item, depth);
	                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	            }
	        } else {
	            return 'Array';
	        }
	    } else {
	        var keys = (0, _keys2.default)(input);
	
	        if (!keys.length) {
	            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	                return input.constructor.name;
	            } else {
	                return 'Object';
	            }
	        }
	
	        if (depth > maxDepth) return '{...}';
	        var indent = '  '.repeat(depth - 1);
	        var entries = keys.slice(0, maxKeys).map(function (key) {
	            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	        }).join('\n  ' + indent);
	
	        if (keys.length >= maxKeys) {
	            entries += '\n  ' + indent + '...';
	        }
	
	        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	        } else {
	            return '{\n  ' + indent + entries + '\n' + indent + '}';
	        }
	    }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(58);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(69);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.hasOffersInRootCategory = hasOffersInRootCategory;
	exports.getCatalog = getCatalog;
	exports.getCategories = getCategories;
	exports.getProducts = getProducts;
	exports.getProduct = getProduct;
	exports.getProductByCategory = getProductByCategory;
	exports.getByCategory = getByCategory;
	exports.searchProducts = searchProducts;
	exports.resetSearchProducts = resetSearchProducts;
	exports.setSearchClose = setSearchClose;
	exports.getCategoryRecommended = getCategoryRecommended;
	exports.checkCatalogForUpdates = checkCatalogForUpdates;
	exports.refreshCatalog = refreshCatalog;
	
	var _constants = __webpack_require__(18);
	
	var _setting = __webpack_require__(1863);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasOffersInRootCategory() {
	    return {
	        types: [_constants.CatalogConstants.LOAD_HAS_OFFERS_IN_ROOT, _constants.CatalogConstants.LOAD_HAS_OFFERS_IN_ROOT_SUCCESS, _constants.CatalogConstants.LOAD_HAS_OFFERS_IN_ROOT_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getCatalog().then(function (response) {
	                // получим id рутовой категории
	                var rootCategoryId = (0, _keys2.default)(response)[0];
	                // получим товары рутовой категории
	                return iBonus.getByCategory(rootCategoryId, 0, _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT).then(function (products) {
	                    return products.count > 0;
	                });
	            });
	        }
	    };
	}
	
	function getCatalog() {
	    return {
	        types: [_constants.CatalogConstants.LOAD_CATALOG, _constants.CatalogConstants.LOAD_CATALOG_SUCCESS, _constants.CatalogConstants.LOAD_CATALOG_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getCatalog();
	        }
	    };
	}
	
	function getCategories() {
	    return {
	        types: [_constants.CatalogConstants.LOAD_CATEGORIES, _constants.CatalogConstants.LOAD_CATEGORIES_SUCCESS, _constants.CatalogConstants.LOAD_CATEGORIES_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getCategories();
	        }
	    };
	}
	
	function getProducts() {
	    var searchName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var activePage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.CatalogNumericConstants.SEARCH_PAGE_LIMIT;
	
	    return {
	        types: [_constants.CatalogConstants.LOAD, _constants.CatalogConstants.LOAD_SUCCESS, _constants.CatalogConstants.LOAD_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getProducts(searchName, activePage, limit).then(function (result) {
	                return (0, _extends3.default)({}, result, {
	                    searchName: searchName,
	                    activePage: ++activePage,
	                    limit: limit
	                });
	            });
	        }
	    };
	}
	
	function getProduct(id) {
	    return {
	        types: [_constants.CatalogConstants.LOAD_DETAIL, _constants.CatalogConstants.LOAD_DETAIL_SUCCESS, _constants.CatalogConstants.LOAD_DETAIL_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getProductById(id);
	        }
	    };
	}
	
	function getProductByCategory(_ref) {
	    var id = _ref.id,
	        _ref$page = _ref.page,
	        page = _ref$page === undefined ? 0 : _ref$page,
	        _ref$limit = _ref.limit,
	        limit = _ref$limit === undefined ? _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT : _ref$limit;
	
	    return {
	        types: [_constants.CatalogConstants.LOAD_PRODUCT_BY_CATEGORIES, _constants.CatalogConstants.LOAD_PRODUCT_BY_CATEGORIES_SUCCESS, _constants.CatalogConstants.LOAD_PRODUCT_BY_CATEGORIES_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getProductByCategory(id, page, limit).then(function (result) {
	                if (result.offers.length === 0) {
	                    return iBonus.getProductByCategory(id, 0, limit).then(function (result) {
	                        return (0, _extends3.default)({}, result, {
	                            activePage: 1,
	                            limit: limit
	                        });
	                    });
	                }
	                return (0, _extends3.default)({}, result, {
	                    activePage: ++page,
	                    limit: limit
	                });
	            });
	        }
	    };
	}
	
	function getByCategory(_ref2) {
	    var id = _ref2.id,
	        _ref2$page = _ref2.page,
	        page = _ref2$page === undefined ? 0 : _ref2$page,
	        _ref2$limit = _ref2.limit,
	        limit = _ref2$limit === undefined ? _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT : _ref2$limit;
	
	    return {
	        types: [_constants.CatalogConstants.LOAD_BY_CATEGORIES, _constants.CatalogConstants.LOAD_BY_CATEGORIES_SUCCESS, _constants.CatalogConstants.LOAD_BY_CATEGORIES_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getByCategory(id, page, limit).then(function (result) {
	                if (result.offers.length === 0) {
	                    return iBonus.getByCategory(id, 0, limit).then(function (result) {
	                        return (0, _extends3.default)({}, result, {
	                            activePage: 1,
	                            limit: limit
	                        });
	                    });
	                }
	                return (0, _extends3.default)({}, result, {
	                    activePage: ++page,
	                    limit: limit
	                });
	            });
	        }
	    };
	}
	
	function searchProducts() {
	    var searchName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.CatalogNumericConstants.SEARCH_PAGE_LIMIT;
	
	    return {
	        types: [_constants.CatalogConstants.SEARCH_PRODUCTS_LOAD, _constants.CatalogConstants.SEARCH_PRODUCTS_LOAD_SUCCESS, _constants.CatalogConstants.SEARCH_PRODUCTS_LOAD_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getProducts(searchName, 0, limit).then(function (result) {
	                return result.offers || [];
	            });
	        }
	    };
	}
	
	function resetSearchProducts() {
	    return {
	        type: _constants.CatalogConstants.SEARCH_PRODUCTS_RESET
	    };
	}
	
	function setSearchClose(close) {
	    return {
	        type: _constants.CatalogConstants.SET_SEARCH_CLOSE,
	        payload: {
	            close: close
	        }
	    };
	}
	
	function getCategoryRecommended(id) {
	    return {
	        types: [_constants.CatalogConstants.CATEGORY_RECOMENDED_LOAD, _constants.CatalogConstants.CATEGORY_RECOMENDED_LOAD_SUCCESS, _constants.CatalogConstants.CATEGORY_RECOMENDED_LOAD_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getCategoryRecommended(id).then(function (result) {
	                return (0, _extends3.default)({}, result, {
	                    id: id
	                });
	            });
	        }
	    };
	}
	
	function checkCatalogForUpdates() {
	    return {
	        types: [_constants.CatalogConstants.LOAD_LAST_CATALOG_UPDATE_DATE, _constants.CatalogConstants.LOAD_LAST_CATALOG_UPDATE_DATE_SUCCESS, _constants.CatalogConstants.LOAD_LAST_CATALOG_UPDATE_DATE_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getChannelActualCatalogLabel();
	        }
	    };
	}
	
	function refreshCatalog() {
	    return {
	        types: [_constants.CatalogConstants.REFRESH_CATALOG_LOAD, _constants.CatalogConstants.REFRESH_CATALOG_LOAD_SUCCESS, _constants.CatalogConstants.REFRESH_CATALOG_LOAD_FAIL],
	        promise: function promise(client, iBonus, _ref3) {
	            var getState = _ref3.getState,
	                dispatch = _ref3.dispatch;
	
	            return dispatch(checkCatalogForUpdates()).then(function () {
	                if (getState().catalog.hasUpdates) {
	                    // return dispatch(getCategories())
	                    //         .then(dispatch(loadSettings())
	                    //             .then((result) => {
	                    //                 const id = result.rootCategory.id,
	                    //                       limit = CatalogNumericConstants.CATEGORY_PAGE_LIMIT;
	                    //                 dispatch(getByCategory({id, limit, page: 1}));
	                    //             }));
	                } else {
	                    return _promise2.default.resolve();
	                }
	            });
	        }
	    };
	}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(785), __esModule: true };

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(794), __esModule: true };

/***/ }),
/* 70 */
[1972, 175, 125, 72, 88, 59, 421, 37],
/* 71 */
[1975, 59, 44, 299],
/* 72 */
[1989, 174, 85],
/* 73 */
/***/ (function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '2.0.3'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(659)('wks')
	  , uid        = __webpack_require__(241)
	  , Symbol     = __webpack_require__(109).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};

/***/ }),
/* 76 */
[1945, 94],
/* 77 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 78 */
32,
/* 79 */
[1950, 49],
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(23);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function (object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function (objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function () {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function (measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(362);
	var PooledClass = __webpack_require__(111);
	var ReactPerf = __webpack_require__(81);
	var ReactReconciler = __webpack_require__(138);
	var Transaction = __webpack_require__(254);
	
	var assign = __webpack_require__(29);
	var invariant = __webpack_require__(21);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
	}
	
	assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(79);
	var IObject = __webpack_require__(174);
	var toObject = __webpack_require__(44);
	var toLength = __webpack_require__(39);
	var asc = __webpack_require__(284);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 86 */
[1978, 10, 78, 23],
/* 87 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 88 */
[1992, 25],
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(475);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  href: _react2['default'].PropTypes.string,
	  onClick: _react2['default'].PropTypes.func,
	  disabled: _react2['default'].PropTypes.bool,
	  role: _react2['default'].PropTypes.string,
	  tabIndex: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3['default'])(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3['default'])(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'disabled']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3['default'])({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	      onClick: this.handleClick
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2['default'].Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports['default'] = SafeAnchor;
	module.exports = exports['default'];

/***/ }),
/* 91 */
83,
/* 92 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	"use strict";
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwitherDescription = undefined;
	
	var _SwitcherDescription = __webpack_require__(1759);
	
	var _SwitcherDescription2 = _interopRequireDefault(_SwitcherDescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SwitherDescription = _SwitcherDescription2.default;

/***/ }),
/* 94 */
25,
/* 95 */
[1970, 76, 393, 279, 104],
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(442);
	var $export = __webpack_require__(10);
	var shared = __webpack_require__(215)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(447))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(37)) {
	  var LIBRARY = __webpack_require__(121);
	  var global = __webpack_require__(22);
	  var fails = __webpack_require__(23);
	  var $export = __webpack_require__(10);
	  var $typed = __webpack_require__(217);
	  var $buffer = __webpack_require__(305);
	  var ctx = __webpack_require__(79);
	  var anInstance = __webpack_require__(119);
	  var propertyDesc = __webpack_require__(125);
	  var hide = __webpack_require__(60);
	  var redefineAll = __webpack_require__(126);
	  var toInteger = __webpack_require__(87);
	  var toLength = __webpack_require__(39);
	  var toIndex = __webpack_require__(440);
	  var toAbsoluteIndex = __webpack_require__(128);
	  var toPrimitive = __webpack_require__(88);
	  var has = __webpack_require__(59);
	  var classof = __webpack_require__(173);
	  var isObject = __webpack_require__(25);
	  var toObject = __webpack_require__(44);
	  var isArrayIter = __webpack_require__(291);
	  var create = __webpack_require__(122);
	  var getPrototypeOf = __webpack_require__(71);
	  var gOPN = __webpack_require__(123).f;
	  var getIterFn = __webpack_require__(307);
	  var uid = __webpack_require__(129);
	  var wks = __webpack_require__(33);
	  var createArrayMethod = __webpack_require__(84);
	  var createArrayIncludes = __webpack_require__(204);
	  var speciesConstructor = __webpack_require__(216);
	  var ArrayIterators = __webpack_require__(308);
	  var Iterators = __webpack_require__(148);
	  var $iterDetect = __webpack_require__(210);
	  var setSpecies = __webpack_require__(127);
	  var arrayFill = __webpack_require__(283);
	  var arrayCopyWithin = __webpack_require__(413);
	  var $DP = __webpack_require__(38);
	  var $GOPD = __webpack_require__(70);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(109)
	  , core      = __webpack_require__(74)
	  , hide      = __webpack_require__(135)
	  , redefine  = __webpack_require__(136)
	  , ctx       = __webpack_require__(236)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target && !own)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(258);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.addProduct = addProduct;
	exports.deleteProduct = deleteProduct;
	exports.changeCountProduct = changeCountProduct;
	exports.clearBasket = clearBasket;
	exports.createOrder = createOrder;
	exports.basketFromLocalStorage = basketFromLocalStorage;
	exports.shareBasket = shareBasket;
	exports.getSharedBasket = getSharedBasket;
	exports.resetShareCode = resetShareCode;
	exports.changeShareState = changeShareState;
	exports.getActualPrices = getActualPrices;
	exports.addCouponInBasket = addCouponInBasket;
	exports.editOrder = editOrder;
	exports.postponeBasket = postponeBasket;
	exports.getPostpone = getPostpone;
	exports.deletePostpone = deletePostpone;
	exports.mergePostpone = mergePostpone;
	
	var _constants = __webpack_require__(18);
	
	function addProduct(product) {
	    return {
	        type: _constants.BasketConstants.ADD_BASKET,
	        product: product
	    };
	}
	
	function deleteProduct(id) {
	    var modifier_option_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    var key = arguments[2];
	
	    return {
	        type: _constants.BasketConstants.REMOVE_BASKET,
	        id: id,
	        modifier_option_id: modifier_option_id,
	        keyArray: key
	    };
	}
	
	function changeCountProduct(id, count) {
	    var modifier_option_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	    return {
	        type: _constants.BasketConstants.CHANGE_COUNT_PRODUCT_IN_BASKET,
	        id: id,
	        count: count,
	        modifier_option_id: modifier_option_id,
	        keyArray: key
	    };
	}
	
	function clearBasket() {
	    return {
	        type: _constants.BasketConstants.CLEAR_BASKET
	    };
	}
	
	function createOrder(_ref) {
	    var sum = _ref.sum,
	        products = _ref.products,
	        userAgent = _ref.userAgent,
	        utmRedirectData = _ref.utmRedirectData,
	        currency_id = _ref.currency_id,
	        delivery_address = _ref.delivery_address,
	        customFields = _ref.customFields;
	
	    return {
	        types: [_constants.BasketConstants.ORDER_LOAD, _constants.BasketConstants.ORDER_LOAD_SUCCESS, _constants.BasketConstants.ORDER_LOAD_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.orderCreate(sum, products, userAgent, utmRedirectData, currency_id, delivery_address, customFields).then(function (result) {
	                return {
	                    result: result
	                };
	            });
	        }
	    };
	}
	
	function basketFromLocalStorage() {
	    return {
	        type: _constants.BasketConstants.COPY_TO_BASKET
	    };
	}
	
	function shareBasket() {
	    var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var customFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var arr = basketElements;
	
	    return {
	        types: [_constants.BasketConstants.SHARE_BASKET_LOAD, _constants.BasketConstants.SHARE_BASKET_SUCCESS, _constants.BasketConstants.SHARE_BASKET_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.shareBasket(arr, customFields).then(function (result) {
	                return result;
	            });
	        }
	    };
	}
	
	function getSharedBasket(code) {
	    return {
	        types: [_constants.BasketConstants.GET_SHARE_BASKET_LOAD, _constants.BasketConstants.GET_SHARE_BASKET_SUCCESS, _constants.BasketConstants.GET_SHARE_BASKET_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getSharedBasket(code);
	        }
	    };
	}
	
	function resetShareCode() {
	    return {
	        type: _constants.BasketConstants.BASKET_RESET_SHARE_CODE
	    };
	}
	
	function changeShareState(shareState) {
	    return {
	        type: _constants.BasketConstants.BASKET_CHANGE_SHARE,
	        payload: shareState
	    };
	}
	
	function getActualPrices() {
	    var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return {
	        types: [_constants.BasketConstants.GET_ACTUAL_PRICES_LOAD, _constants.BasketConstants.GET_ACTUAL_PRICES_SUCCESS, _constants.BasketConstants.GET_ACTUAL_PRICES_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getActualPrices(basketElements);
	        }
	    };
	}
	
	function addCouponInBasket(product) {
	    return {
	        type: _constants.BasketConstants.ADD_BASKET,
	        product: product
	    };
	}
	
	function editOrder(_ref2) {
	    var order_id = _ref2.order_id,
	        sum = _ref2.sum,
	        products = _ref2.products,
	        userAgent = _ref2.userAgent,
	        utmRedirectData = _ref2.utmRedirectData,
	        currency_id = _ref2.currency_id;
	
	    return {
	        types: [_constants.BasketConstants.ORDER_LOAD, _constants.BasketConstants.ORDER_LOAD_SUCCESS, _constants.BasketConstants.ORDER_LOAD_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.editOrder(order_id, sum, products, userAgent, utmRedirectData, currency_id).then(function (result) {
	                return {
	                    result: result
	                };
	            });
	        }
	    };
	}
	
	function postponeBasket() {
	    var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var customFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var arr = basketElements;
	    return {
	        types: [_constants.BasketConstants.POSTPONE_BASKET_LOAD, _constants.BasketConstants.POSTPONE_BASKET_SUCCESS, _constants.BasketConstants.POSTPONE_BASKET_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.postponeBasket(arr, customFields).then(function (result) {
	                return result;
	            });
	        }
	    };
	}
	
	function getPostpone() {
	    return {
	        types: [_constants.BasketConstants.GET_POSTPONE_BASKET_LOAD, _constants.BasketConstants.GET_POSTPONE_BASKET_SUCCESS, _constants.BasketConstants.GET_POSTPONE_BASKET_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getPostpone().then(function (result) {
	                return result;
	            });
	        }
	    };
	}
	
	function deletePostpone(id) {
	    return {
	        types: [_constants.BasketConstants.DELETE_POSTPONE_LOAD, _constants.BasketConstants.DELETE_POSTPONE_SUCCESS, _constants.BasketConstants.DELETE_POSTPONE_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.deletePostpone(id).then(function (result) {
	                return result;
	            });
	        }
	    };
	}
	
	function mergePostpone(mergeIds) {
	    return {
	        types: [_constants.BasketConstants.MERGE_POSTPONE_LOAD, _constants.BasketConstants.MERGE_POSTPONE_SUCCESS, _constants.BasketConstants.MERGE_POSTPONE_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.mergePostpone(mergeIds).then(function (result) {
	                return result;
	            });
	        }
	    };
	}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(390);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(196);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 104 */
[1951, 116],
/* 105 */
[1989, 395, 269],
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(33)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(60)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 107 */
[1965, 129, 25, 59, 38, 23],
/* 108 */
73,
/* 109 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function isValidChild(object) {
	  return object == null || _react2['default'].isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function checkPropTypes(componentName, propTypes, props) {
	  componentName = componentName || 'UnknownComponent';
	
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error = propTypes[propName](props, propName, componentName);
	
	      /* istanbul ignore if: error logging */
	      if (error instanceof Error)  false ? _routerWarning2['default'](false, error.message) : undefined;
	    }
	  }
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (type.propTypes) checkPropTypes(type.displayName || type.name, type.propTypes, route);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *   
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2['default'].Children.forEach(children, function (element) {
	    if (_react2['default'].isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _config = __webpack_require__(192);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThemeHelper = function () {
	    function ThemeHelper() {
	        (0, _classCallCheck3.default)(this, ThemeHelper);
	    }
	
	    (0, _createClass3.default)(ThemeHelper, null, [{
	        key: 'getViewForComponent',
	        value: function getViewForComponent(componentName) {
	            var themeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	                _ref$folderName = _ref.folderName,
	                folderName = _ref$folderName === undefined ? null : _ref$folderName;
	
	            var theme = themeName === null ? _config.theme : themeName;
	            folderName = folderName || componentName;
	            return __webpack_require__(1940)("./" + folderName + '/' + theme + '/' + componentName + 'View');
	        }
	    }, {
	        key: 'getViewForContainer',
	        value: function getViewForContainer(containerName) {
	            var themeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	                _ref2$folderName = _ref2.folderName,
	                folderName = _ref2$folderName === undefined ? null : _ref2$folderName;
	
	            var theme = themeName === null ? _config.theme : themeName;
	            folderName = folderName || containerName;
	            return __webpack_require__(1941)("./" + folderName + '/' + theme + '/' + containerName + 'View');
	        }
	    }, {
	        key: 'getThemeName',
	        value: function getThemeName() {
	            var themeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            return themeName === null ? _config.theme : themeName;
	        }
	    }, {
	        key: 'includeTheme',
	        value: function includeTheme() {
	            var themeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            var theme = themeName === null ? _config.theme : themeName;
	            return !(function webpackMissingModule() { var e = new Error("Cannot find module \"themes\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	        }
	    }]);
	    return ThemeHelper;
	}();
	
	exports.default = ThemeHelper;
	module.exports = exports['default'];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getPayment = getPayment;
	exports.setPaymentId = setPaymentId;
	exports.getPaymentsParamsFromPIPObyId = getPaymentsParamsFromPIPObyId;
	exports.paymentIbonus = paymentIbonus;
	exports.checkCodeSendForPaymentIbonus = checkCodeSendForPaymentIbonus;
	exports.resetPaymentIbonus = resetPaymentIbonus;
	exports.loadProcessInput = loadProcessInput;
	exports.resetProcessInput = resetProcessInput;
	exports.setCustomPayment = setCustomPayment;
	exports.resetCustomPayment = resetCustomPayment;
	exports.rePaymentByOrder = rePaymentByOrder;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPayment() {
	    return {
	        types: [_constants.PaymentConstants.SHOW, _constants.PaymentConstants.SHOW_SUCCESS, _constants.PaymentConstants.SHOW_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getPayment();
	        }
	    };
	}
	
	function setPaymentId(id) {
	    return {
	        type: _constants.Personal.OrderDetail.SET_PAYMENT_ID,
	        paymentId: id
	    };
	}
	
	function getPaymentsParamsFromPIPObyId(pipoShopId) {
	    return {
	        types: [_constants.PaymentConstants.PIPO_PAY_PARAMS_REQUEST, _constants.PaymentConstants.PIPO_PAY_PARAMS_SUCCESS, _constants.PaymentConstants.PIPO_PAY_PARAMS_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getPaymentsParamsFromPIPObyId(pipoShopId);
	        }
	    };
	}
	
	/**
	 * Оплата методами айбонуса
	 */
	function paymentIbonus(accountId, operationId) {
	    var checkCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    return {
	        types: [_constants.PaymentConstants.PAY_INNER_PIPO_REQUEST, _constants.PaymentConstants.PAY_INNER_PIPO_SUCCESS, _constants.PaymentConstants.PAY_INNER_PIPO_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.payInnerPipo(accountId, operationId, checkCode);
	        }
	    };
	}
	
	function checkCodeSendForPaymentIbonus() {
	    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var online_shop_id = arguments[1];
	    var orderId = arguments[2];
	
	    return {
	        types: [_constants.PaymentConstants.CHECK_CODE_SEND_INNER_PIPO_REQUEST, _constants.PaymentConstants.CHECK_CODE_SEND_INNER_PIPO_SUCCESS, _constants.PaymentConstants.CHECK_CODE_SEND_INNER_PIPO_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.checkCodeConfirmForPayInnerPipo(online_shop_id, orderId).then(function (result) {
	                if (callback) {
	                    callback(Boolean(result.secure));
	                }
	
	                return result;
	            });
	        }
	    };
	}
	
	function resetPaymentIbonus() {
	    return {
	        type: _constants.PaymentConstants.PAY_INNER_PIPO_RESET
	    };
	}
	
	function loadProcessInput(operation_id, group_slug) {
	    var additionalFieldName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var additionalFieldText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	    return {
	        types: [_constants.PaymentConstants.PIPO_PROCESS_INPUT_REQUEST, _constants.PaymentConstants.PIPO_PROCESS_INPUT_SUCCESS, _constants.PaymentConstants.PIPO_PROCESS_INPUT_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.pipoProcessInput(operation_id, group_slug, additionalFieldName, additionalFieldText).then(function (result) {
	                return (0, _extends3.default)({}, result, {
	                    slug: group_slug
	                });
	            });
	        }
	    };
	}
	
	function resetProcessInput() {
	    return {
	        type: _constants.PaymentConstants.PIPO_PROCESS_INPUT_RESET
	    };
	}
	
	function setCustomPayment() {
	    return {
	        type: _constants.PaymentConstants.SET_CUSTOM_PAYMENT
	    };
	}
	
	function resetCustomPayment() {
	    return {
	        type: _constants.PaymentConstants.RESET_CUSTOM_PAYMENT
	    };
	}
	
	function rePaymentByOrder(orderId, callback) {
	    return {
	        types: [_constants.PaymentConstants.REPAYMENT_ORDER_REQUEST, _constants.PaymentConstants.REPAYMENT_ORDER_SUCCESS, _constants.PaymentConstants.REPAYMENT_ORDER_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.paymentCreate(orderId).then(function (result) {
	                if (callback) {
	                    callback(result);
	                }
	                return result;
	            });
	        }
	    };
	}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.changeName = changeName;
	exports.changeMail = changeMail;
	exports.changeMailWithCode = changeMailWithCode;
	exports.changePhone = changePhone;
	exports.changePhoneWithCode = changePhoneWithCode;
	exports.confirmMail = confirmMail;
	exports.confirmMailWithCode = confirmMailWithCode;
	exports.confirmEMailBySignature = confirmEMailBySignature;
	exports.confirmPhone = confirmPhone;
	exports.confirmPhoneWithCode = confirmPhoneWithCode;
	exports.resetError = resetError;
	exports.changePassword = changePassword;
	exports.changeInn = changeInn;
	exports.changeUlName = changeUlName;
	exports.addAddress = addAddress;
	
	var _constants = __webpack_require__(18);
	
	var _auth = __webpack_require__(53);
	
	var handleChange = function handleChange(result, dispatch) {
	    console.log('handleChange', dispatch);
	    if (!!result) {
	        return dispatch((0, _auth.load)());
	    }
	    return !!result;
	};
	
	function changeName(pipo_id, name, new_name) {
	    return {
	        types: [_constants.UserConstants.USER_CHANGE, _constants.UserConstants.USER_CHANGE_SUCCESS, _constants.UserConstants.USER_CHANGE_FAIL],
	        promise: function promise(client, iBonus, _ref) {
	            var dispatch = _ref.dispatch;
	            return iBonus.changeName(pipo_id, name, new_name).then(function (result) {
	                return handleChange(result, dispatch);
	            });
	        }
	    };
	}
	
	function changeMail(pipo_id, new_email, code, callBackShowModal) {
	    return {
	        types: [_constants.UserConstants.USER_CHANGE_MAIL, _constants.UserConstants.USER_CHANGE_MAIL_SUCCESS, _constants.UserConstants.USER_CHANGE_MAIL_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.changeMail(pipo_id, new_email, code).then(function (result) {
	                callBackShowModal(result.code_send_to);
	                return result;
	            });
	        }
	    };
	}
	
	function changeMailWithCode(pipo_id, new_email, code) {
	    return {
	        types: [_constants.UserConstants.USER_CHANGE_MAIL_CODE, _constants.UserConstants.USER_CHANGE_MAIL_CODE_SUCCESS, _constants.UserConstants.USER_CHANGE_MAIL_CODE_FAIL],
	        promise: function promise(client, iBonus, _ref2) {
	            var dispatch = _ref2.dispatch;
	            return iBonus.changeMailWithCode(pipo_id, new_email, code).then(function (result) {
	                return handleChange(result, dispatch);
	            });
	        }
	    };
	}
	
	function changePhone(pipo_id, new_phone, code, callBackShowModal) {
	    return {
	        types: [_constants.UserConstants.USER_CHANGE_PHONE, _constants.UserConstants.USER_CHANGE_PHONE_SUCCESS, _constants.UserConstants.USER_CHANGE_PHONE_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.changePhone(pipo_id, new_phone, code).then(function (result) {
	                callBackShowModal();
	                return result;
	            });
	        }
	    };
	}
	
	function changePhoneWithCode(pipo_id, new_phone, code) {
	    return {
	        types: [_constants.UserConstants.USER_CHANGE_PHONE_CODE, _constants.UserConstants.USER_CHANGE_PHONE_CODE_SUCCESS, _constants.UserConstants.USER_CHANGE_PHONE_CODE_FAIL],
	        promise: function promise(client, iBonus, _ref3) {
	            var dispatch = _ref3.dispatch;
	            return iBonus.changePhoneWithCode(pipo_id, new_phone, code).then(function (result) {
	                return handleChange(result, dispatch);
	            });
	        }
	    };
	}
	
	function confirmMail(pipo_id, email, code) {
	    return {
	        types: [_constants.UserConstants.USER_CONFIRM_MAIL, _constants.UserConstants.USER_CONFIRM_MAIL_SUCCESS, _constants.UserConstants.USER_CONFIRM_MAIL_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.confirmMail(pipo_id, email, code);
	        }
	    };
	}
	
	function confirmMailWithCode(pipo_id, email, code) {
	    return {
	        types: [_constants.UserConstants.USER_CONFIRM_MAIL_CODE, _constants.UserConstants.USER_CONFIRM_MAIL_CODE_SUCCESS, _constants.UserConstants.USER_CONFIRM_MAIL_CODE_FAIL],
	        promise: function promise(client, iBonus, _ref4) {
	            var dispatch = _ref4.dispatch;
	            return iBonus.confirmMailWithCode(pipo_id, email, code).then(function (result) {
	                return handleChange(result, dispatch);
	            });
	        }
	    };
	}
	
	function confirmEMailBySignature(order_id, confirm_signature) {
	    return {
	        types: [_constants.UserConstants.USER_CONFIRM_MAIL_BY_SIGNATURE, _constants.UserConstants.USER_CONFIRM_MAIL_BY_SIGNATURE_SUCCESS, _constants.UserConstants.USER_CONFIRM_MAIL_BY_SIGNATURE_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.confirmEMailBySignature(order_id, confirm_signature);
	        }
	    };
	}
	
	function confirmPhone(pipo_id, phone, code) {
	    return {
	        types: [_constants.UserConstants.USER_CONFIRM_PHONE, _constants.UserConstants.USER_CONFIRM_PHONE_SUCCESS, _constants.UserConstants.USER_CONFIRM_PHONE_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.confirmPhone(pipo_id, phone, code);
	        }
	    };
	}
	
	function confirmPhoneWithCode(pipo_id, phone, code) {
	    return {
	        types: [_constants.UserConstants.USER_CONFIRM_PHONE_CODE, _constants.UserConstants.USER_CONFIRM_PHONE_CODE_SUCCESS, _constants.UserConstants.USER_CONFIRM_PHONE_CODE_FAIL],
	        promise: function promise(client, iBonus, _ref5) {
	            var dispatch = _ref5.dispatch;
	            return iBonus.confirmPhoneWithCode(pipo_id, phone, code).then(function (result) {
	                return handleChange(result, dispatch);
	            });
	        }
	    };
	}
	
	function resetError() {
	    return {
	        type: _constants.UserConstants.USER_RESET_ERROR
	    };
	}
	
	function changePassword(login, new_password, new_repassword, old_password) {
	    return {
	        types: [_constants.UserConstants.USER_CHANGE_PASSWORD, _constants.UserConstants.USER_CHANGE_PASSWORD_SUCCESS, _constants.UserConstants.USER_CHANGE_PASSWORD_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.changePassword(login, new_password, new_repassword, old_password);
	        }
	    };
	}
	
	function changeInn(inn) {
	    return {
	        types: [_constants.UserConstants.USER_CHANGE_INN, _constants.UserConstants.USER_CHANGE_INN_SUCCESS, _constants.UserConstants.USER_CHANGE_INN_FAIL],
	        promise: function promise(client, iBonus, _ref6) {
	            var dispatch = _ref6.dispatch;
	            return iBonus.updateInn(inn).then(function (result) {
	                return handleChange(result, dispatch);
	            });
	        }
	    };
	}
	
	function changeUlName(ul_name) {
	    return {
	        types: [_constants.UserConstants.USER_CHANGE_UL_NAME, _constants.UserConstants.USER_CHANGE_UL_NAME_SUCCESS, _constants.UserConstants.USER_CHANGE_UL_NAME_FAIL],
	        promise: function promise(client, iBonus, _ref7) {
	            var dispatch = _ref7.dispatch;
	            return iBonus.updateUlName(ul_name).then(function (result) {
	                return handleChange(result, dispatch);
	            });
	        }
	    };
	}
	
	function addAddress(address) {
	    return {
	        types: [_constants.UserConstants.USER_ADD_ADDRESS, _constants.UserConstants.USER_ADD_ADDRESS_SUCCESS, _constants.UserConstants.USER_ADD_ADDRESS_FAIL],
	        promise: function promise(client, iBonus, _ref8) {
	            var dispatch = _ref8.dispatch;
	            return iBonus.addAddress(address).then(function (result) {
	                return handleChange(result, dispatch);
	            });
	        }
	    };
	}

/***/ }),
/* 116 */
23,
/* 117 */
59,
/* 118 */
[1955, 95, 170, 104],
/* 119 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 120 */
[1954, 79, 424, 291, 20, 39, 307],
/* 121 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 122 */
[1969, 20, 430, 287, 299, 286, 289],
/* 123 */
[1974, 432, 287],
/* 124 */
[1977, 432, 287],
/* 125 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(61);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(22);
	var dP = __webpack_require__(38);
	var DESCRIPTORS = __webpack_require__(37);
	var SPECIES = __webpack_require__(33)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 128 */
[1988, 87],
/* 129 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(83);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(221),
	    getRawTag = __webpack_require__(1187),
	    objectToString = __webpack_require__(1214);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1158),
	    getValue = __webpack_require__(1190);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 133 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var store  = __webpack_require__(1283)('wks')
	  , uid    = __webpack_require__(623)
	  , Symbol = __webpack_require__(232).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
	};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(73)
	  , createDesc = __webpack_require__(348);
	module.exports = __webpack_require__(238) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	// add fake Function#toString
	// for correct work wrapped methods / constructors with methods like LoDash isNative
	var global    = __webpack_require__(109)
	  , hide      = __webpack_require__(135)
	  , SRC       = __webpack_require__(241)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(74).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  if(typeof val == 'function'){
	    val.hasOwnProperty(SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	    val.hasOwnProperty('name') || hide(val, 'name', key);
	  }
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = shape({
	  listen: func.isRequired,
	  pushState: func.isRequired,
	  replaceState: func.isRequired,
	  go: func.isRequired
	});
	
	exports.history = history;
	var location = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	exports.location = location;
	var component = oneOfType([func, string]);
	exports.component = component;
	var components = oneOfType([component, object]);
	exports.components = components;
	var route = oneOfType([object, element]);
	exports.route = route;
	var routes = oneOfType([route, arrayOf(route)]);
	
	exports.routes = routes;
	exports['default'] = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route
	};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1522);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(111);
	
	var assign = __webpack_require__(29);
	var emptyFunction = __webpack_require__(92);
	var warning = __webpack_require__(30);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(58);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.error = error;
	exports.disable404 = disable404;
	exports.show404 = show404;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function error(message) {
	    return {
	        type: 'error', // для фиксации ошибке не обязательный, но нужный для единообразия экшенов
	        show_error: true,
	        error: {
	            title: "",
	            message: message
	        }
	    };
	}
	
	function disable404() {
	    return {
	        type: 'error',
	        disable_404: true
	    };
	}
	
	function show404() {
	    return {
	        types: ['fake_request', 'fake_success', 'fake_fail'],
	        promise: function promise(client, iBonus) {
	            return new _promise2.default(function (resolve, reject) {
	                reject('404');
	            });
	        },
	        show_404: true
	    };
	}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sendVoiceCode = sendVoiceCode;
	exports.resetVoiceCode = resetVoiceCode;
	exports.startTimer = startTimer;
	
	var _constants = __webpack_require__(18);
	
	function sendVoiceCode(login, source, phone) {
	    return {
	        types: [_constants.VoiceCodeConstants.VOICE_CODE_FORM_REQUEST, _constants.VoiceCodeConstants.VOICE_CODE_FORM_SUCCESS, _constants.VoiceCodeConstants.VOICE_CODE_FORM_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.sendVoiceCode(login, source, phone);
	        }
	    };
	}
	
	function resetVoiceCode() {
	    return {
	        type: _constants.VoiceCodeConstants.VOICE_CODE_FORM_RESET
	    };
	}
	
	function startTimer(t) {
	    return {
	        type: _constants.VoiceCodeConstants.SET_TIMER,
	        timerState: 'start',
	        time: t
	    };
	}

/***/ }),
/* 142 */
[1944, 786],
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(796), __esModule: true };

/***/ }),
/* 144 */
49,
/* 145 */
[1950, 144],
/* 146 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 147 */
[1977, 403, 271],
/* 148 */
146,
/* 149 */
[1982, 38, 59, 33],
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var defined = __webpack_require__(85);
	var fails = __webpack_require__(23);
	var spaces = __webpack_require__(303);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(25);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 152 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1162),
	    baseMatchesProperty = __webpack_require__(1163),
	    identity = __webpack_require__(322),
	    isArray = __webpack_require__(63),
	    property = __webpack_require__(1241);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(323),
	    isLength = __webpack_require__(324);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 156 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function escapeSource(string) {
	  return escapeRegExp(string).replace(/\/+/g, '/+');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = undefined,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeSource(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/?#]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '([\\s\\S]*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '([\\s\\S]*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeSource(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = {};
	
	function compilePattern(pattern) {
	  if (!(pattern in CompiledPatternsCache)) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	
	function matchPattern(pattern, pathname) {
	  // Make leading slashes consistent between pattern and pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	  regexpSource += '/*'; // Capture path separators
	
	  // Special-case patterns like '*' for catch-all routes.
	  var captureRemaining = tokens[tokens.length - 1] !== '*';
	
	  if (captureRemaining) {
	    // This will match newlines in the remaining path.
	    regexpSource += '([\\s\\S]*?)';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource + '$', 'i'));
	
	  var remainingPathname = undefined,
	      paramValues = undefined;
	  if (match != null) {
	    if (captureRemaining) {
	      remainingPathname = match.pop();
	      var matchedPath = match[0].substr(0, match[0].length - remainingPathname.length);
	
	      // If we didn't match the entire pathname, then make sure that the match
	      // we did get ends at a path separator (potentially the one we added
	      // above at the beginning of the path, if the actual match was empty).
	      if (remainingPathname && matchedPath.charAt(matchedPath.length - 1) !== '/') {
	        return {
	          remainingPathname: null,
	          paramNames: paramNames,
	          paramValues: null
	        };
	      }
	    } else {
	      // If this matched at all, then the match was the entire pathname.
	      remainingPathname = '';
	    }
	
	    paramValues = match.slice(1).map(function (v) {
	      return v != null ? decodeURIComponent(v) : v;
	    });
	  } else {
	    remainingPathname = paramValues = null;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: paramValues
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var _matchPattern = matchPattern(pattern, pathname);
	
	  var paramNames = _matchPattern.paramNames;
	  var paramValues = _matchPattern.paramValues;
	
	  if (paramValues != null) {
	    return paramNames.reduce(function (memo, paramName, index) {
	      memo[paramName] = paramValues[index];
	      return memo;
	    }, {});
	  }
	
	  return null;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = undefined,
	      paramName = undefined,
	      paramValue = undefined;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? _invariant2['default'](false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : _invariant2['default'](false) : undefined;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? _invariant2['default'](false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : _invariant2['default'](false) : undefined;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(21);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ?  false ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseAttribute:
	   *   Whether the property must be accessed and mutated using `*Attribute()`.
	   *   (This includes anything that fails `<propName> in <element>`.)
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function (nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(725);
	
	var invariant = __webpack_require__(21);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 10000;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  !(isValidID(ancestorID) && isValidID(destinationID)) ?  false ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
	  !isAncestorIDOf(ancestorID, destinationID) ?  false ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  !isValidID(longestCommonID) ?  false ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {*} arg Argument to invoke the callback with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  !(start !== stop) ?  false ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
	  var traverseUp = isAncestorIDOf(stop, start);
	  !(traverseUp || isAncestorIDOf(start, stop)) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start;; /* until break */id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    !(depth++ < MAX_TREE_DEPTH) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function () {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function (rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function (id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Same as `traverseTwoPhase` but skips the `targetID`.
	   */
	  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, true);
	      traverseParentPath(targetID, '', cb, arg, true, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function (targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.exports = ReactInstanceHandles;

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var assign = make_assign()
	var create = make_create()
	var trim = make_trim()
	var Global = (typeof window !== 'undefined' ? window : global)
	
	module.exports = {
		assign: assign,
		create: create,
		trim: trim,
		bind: bind,
		slice: slice,
		each: each,
		map: map,
		pluck: pluck,
		isList: isList,
		isFunction: isFunction,
		isObject: isObject,
		Global: Global
	}
	
	function make_assign() {
		if (Object.assign) {
			return Object.assign
		} else {
			return function shimAssign(obj, props1, props2, etc) {
				for (var i = 1; i < arguments.length; i++) {
					each(Object(arguments[i]), function(val, key) {
						obj[key] = val
					})
				}			
				return obj
			}
		}
	}
	
	function make_create() {
		if (Object.create) {
			return function create(obj, assignProps1, assignProps2, etc) {
				var assignArgsList = slice(arguments, 1)
				return assign.apply(this, [Object.create(obj)].concat(assignArgsList))
			}
		} else {
			function F() {} // eslint-disable-line no-inner-declarations
			return function create(obj, assignProps1, assignProps2, etc) {
				var assignArgsList = slice(arguments, 1)
				F.prototype = obj
				return assign.apply(this, [new F()].concat(assignArgsList))
			}
		}
	}
	
	function make_trim() {
		if (String.prototype.trim) {
			return function trim(str) {
				return String.prototype.trim.call(str)
			}
		} else {
			return function trim(str) {
				return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '')
			}
		}
	}
	
	function bind(obj, fn) {
		return function() {
			return fn.apply(obj, Array.prototype.slice.call(arguments, 0))
		}
	}
	
	function slice(arr, index) {
		return Array.prototype.slice.call(arr, index || 0)
	}
	
	function each(obj, fn) {
		pluck(obj, function(val, key) {
			fn(val, key)
			return false
		})
	}
	
	function map(obj, fn) {
		var res = (isList(obj) ? [] : {})
		pluck(obj, function(v, k) {
			res[k] = fn(v, k)
			return false
		})
		return res
	}
	
	function pluck(obj, fn) {
		if (isList(obj)) {
			for (var i=0; i<obj.length; i++) {
				if (fn(obj[i], i)) {
					return obj[i]
				}
			}
		} else {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					if (fn(obj[key], key)) {
						return obj[key]
					}
				}
			}
		}
	}
	
	function isList(val) {
		return (val != null && typeof val != 'function' && typeof val.length == 'number')
	}
	
	function isFunction(val) {
		return val && {}.toString.call(val) === '[object Function]'
	}
	
	function isObject(val) {
		return val && {}.toString.call(val) === '[object Object]'
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(197);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PaymentStatusConstants = __webpack_require__(385);
	
	var constants = _interopRequireWildcard(_PaymentStatusConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentStatus = function () {
	    (0, _createClass3.default)(PaymentStatus, null, [{
	        key: 'create',
	        value: function create() {
	            var paymentStatusId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : constants.PAYMENT_STATUS_NOT_PAY;
	
	            return new PaymentStatus(paymentStatusId);
	        }
	    }]);
	
	    function PaymentStatus(paymentStatusId) {
	        (0, _classCallCheck3.default)(this, PaymentStatus);
	
	        this.paymentStatusId = parseInt(paymentStatusId, 10) || 0;
	    }
	
	    (0, _createClass3.default)(PaymentStatus, [{
	        key: 'isPayActionAvaliable',
	        value: function isPayActionAvaliable() {
	            return this.paymentStatusId === constants.PAYMENT_STATUS_NOT_PAY;
	        }
	    }, {
	        key: 'isCanceled',
	        value: function isCanceled() {
	            return this.paymentStatusId === constants.PAYMENT_STATUS_CANCEL;
	        }
	    }, {
	        key: 'isRevert',
	        value: function isRevert() {
	            return this.paymentStatusId === constants.PAYMENT_STATUS_RETURN || this.paymentStatusId === constants.PAYMENT_STATUS_PARTIALLY_RETURN;
	        }
	    }, {
	        key: 'toString',
	        value: function toString() {
	            return this.statusSlug;
	        }
	    }, {
	        key: 'status',
	        get: function get() {
	            return this.paymentStatusId;
	        }
	    }, {
	        key: 'isPay',
	        get: function get() {
	            return this.paymentStatusId === constants.PAYMENT_STATUS_PAY;
	        }
	    }, {
	        key: 'isOutdated',
	        get: function get() {
	            return this.paymentStatusId === constants.PAYMENT_STATUS_OUTDATED;
	        }
	    }, {
	        key: 'statusSlug',
	        get: function get() {
	            var _lablesTranslate;
	
	            var lablesTranslate = (_lablesTranslate = {}, (0, _defineProperty3.default)(_lablesTranslate, constants.PAYMENT_STATUS_MONEY_TRANSFER, 'store.order_status.money_transfer'), (0, _defineProperty3.default)(_lablesTranslate, constants.PAYMENT_STATUS_RETURN, 'store.order_status.return'), (0, _defineProperty3.default)(_lablesTranslate, constants.PAYMENT_STATUS_PARTIALLY_RETURN, 'store.order_status.partially_return'), (0, _defineProperty3.default)(_lablesTranslate, constants.PAYMENT_STATUS_PAY, 'store.order_status.paid'), (0, _defineProperty3.default)(_lablesTranslate, constants.PAYMENT_STATUS_NOT_PAY, 'store.order_status.not_paid'), (0, _defineProperty3.default)(_lablesTranslate, constants.PAYMENT_STATUS_OUTDATED, 'store.order_status.outdated'), (0, _defineProperty3.default)(_lablesTranslate, constants.PAYMENT_STATUS_CANCEL, 'store.order_status.cancelled'), _lablesTranslate);
	
	            if (this.paymentStatusId && this.paymentStatusId in lablesTranslate) {
	                return lablesTranslate[this.paymentStatusId];
	            }
	
	            return lablesTranslate[constants.PAYMENT_STATUS_NOT_PAY];
	        }
	    }]);
	    return PaymentStatus;
	}();
	
	exports.default = PaymentStatus;
	module.exports = exports['default'];

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sendCode = sendCode;
	exports.sendVoiceCode = sendVoiceCode;
	exports.resetVoiceCode = resetVoiceCode;
	exports.confirmPassRecovery = confirmPassRecovery;
	exports.resetStep = resetStep;
	exports.resetError = resetError;
	exports.sendPhoneToReducer = sendPhoneToReducer;
	exports.showError = showError;
	
	var _constants = __webpack_require__(18);
	
	function sendCode(phone, shopId) {
	    return {
	        types: [_constants.PassRecoveryConstants.PASS_RECOVERY_FORM_REQUEST, _constants.PassRecoveryConstants.PASS_RECOVERY_FORM_SUCCESS, _constants.PassRecoveryConstants.PASS_RECOVERY_FORM_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.passRecoverySend(phone, shopId);
	        }
	    };
	}
	
	function sendVoiceCode(phone) {
	    var source = 'restore_password';
	    return {
	        types: [_constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_FORM_REQUEST, _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_FORM_SUCCESS, _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_FORM_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.sendVoiceCode(phone, source);
	        }
	    };
	}
	
	function resetVoiceCode() {
	    return {
	        type: _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_RESET
	    };
	}
	
	function confirmPassRecovery(login, password, code) {
	    return {
	        types: [_constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_REQUEST, _constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_SUCCESS, _constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.userRestorePassword(login, password, code);
	        }
	    };
	}
	
	function resetStep() {
	    return {
	        type: _constants.PassRecoveryConstants.PASS_RECOVERY_RESET_STEP
	    };
	}
	
	function resetError() {
	    return {
	        type: _constants.PassRecoveryConstants.PASS_RECOVERY_RESET_ERROR
	    };
	}
	
	function sendPhoneToReducer(phone) {
	    return {
	        type: _constants.PassRecoveryConstants.PASS_RECOVERY_SET_PHONE,
	        phone: phone
	    };
	}
	
	function showError(error) {
	    return {
	        type: _constants.PassRecoveryConstants.PASS_RECOVERY_SHOW_ERROR,
	        error: error
	    };
	}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(58);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getPersonalOrderDetail = getPersonalOrderDetail;
	exports.getPersonalOrderList = getPersonalOrderList;
	exports.setOrder = setOrder;
	exports.setPayOrder = setPayOrder;
	exports.loadPage = loadPage;
	exports.cancelOrder = cancelOrder;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPersonalOrderDetail(id) {
	    return {
	        types: [_constants.Personal.OrderDetail.PERSONAL_ORDER_DETAIL_LOAD, _constants.Personal.OrderDetail.PERSONAL_ORDER_DETAIL_SUCCESS, _constants.Personal.OrderDetail.PERSONAL_ORDER_DETAIL_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getOrderById(id);
	        }
	    };
	}
	
	function getPersonalOrderList() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT;
	
	    return {
	        types: [_constants.Personal.OrderList.PERSONAL_ORDER_LIST_LOAD, _constants.Personal.OrderList.PERSONAL_ORDER_LIST_SUCCESS, _constants.Personal.OrderList.PERSONAL_ORDER_LIST_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getOrders(page - 1, limit).then(function (result) {
	                if (result.orders.length === 0) {
	                    return iBonus.getOrders(0, limit).then(function (result) {
	                        return (0, _extends3.default)({}, result, {
	                            activePage: 1,
	                            limit: limit
	                        });
	                    });
	                }
	                return (0, _extends3.default)({}, result, {
	                    limit: limit,
	                    activePage: page
	                });
	            });
	        }
	    };
	}
	
	function setOrder(order_id) {
	    var client_comment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    var service_in_slug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    var delivery_address = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	    return {
	        types: [_constants.Personal.OrderList.ORDER_SETTING_SEND, _constants.Personal.OrderList.ORDER_SETTING_SUCCESS, _constants.Personal.OrderList.ORDER_SETTING_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.setOrder(order_id, client_comment, service_in_slug, delivery_address);
	        }
	    };
	}
	
	function setPayOrder(order_id) {
	    var client_comment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    var service_in_slug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    var delivery_address = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	    var discount_sum = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	    var coupon_id = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	    var coupon_token = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
	    var customer_coupon_id = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
	    var custom_fields = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
	    var child_orders = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
	    var captcha = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
	
	    return {
	        types: [_constants.Personal.OrderList.ORDER_SETTING_SEND, _constants.Personal.OrderList.ORDER_SETTING_SUCCESS, _constants.Personal.OrderList.ORDER_SET_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.setPayOrder(order_id, client_comment, service_in_slug, delivery_address, discount_sum, coupon_id, coupon_token, customer_coupon_id, custom_fields, child_orders, captcha);
	        }
	    };
	}
	
	function loadPage(location) {
	    return {
	        types: [_constants.Personal.OrderDetail.LOAD_PAGE, _constants.Personal.OrderDetail.LOAD_PAGE, _constants.Personal.OrderDetail.LOAD_PAGE],
	        promise: function promise() {
	            return new _promise2.default(function (resolve) {
	                resolve({
	                    show_404: location.pathname
	                });
	            });
	        }
	    };
	}
	
	function cancelOrder(order) {
	    return {
	        types: [_constants.Personal.OrderList.ORDER_SETTING_SEND, _constants.Personal.OrderList.ORDER_SETTING_SUCCESS, _constants.Personal.OrderList.ORDER_SETTING_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.cancelOrder(order.id);
	        }
	    };
	}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by maximus on 16.12.16.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.addToWishList = addToWishList;
	exports.delFromWishList = delFromWishList;
	exports.wishListFromLocalStorage = wishListFromLocalStorage;
	exports.wishListUpdateProduct = wishListUpdateProduct;
	exports.getActualPricesWishList = getActualPricesWishList;
	exports.setWishList = setWishList;
	
	var _constants = __webpack_require__(18);
	
	function addToWishList(product) {
	    var user_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    return {
	        type: _constants.WishConstants.ADD_TO_WISHLIST,
	        product: product,
	        user_id: user_id
	    };
	}
	
	function delFromWishList(product) {
	    var user_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    return {
	        type: _constants.WishConstants.DEL_FROM_WISHLIST,
	        product: product,
	        user_id: user_id
	    };
	}
	
	function wishListFromLocalStorage() {
	    return {
	        type: _constants.WishConstants.COPY_TO_WISHLIST
	    };
	}
	
	function wishListUpdateProduct() {
	    return {
	        type: _constants.WishConstants.UPDATE_PRODUCT_FOR_WISHLIST
	    };
	}
	
	function getActualPricesWishList() {
	    var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return {
	        types: [_constants.WishConstants.GET_ACTUAL_PRICES_LOAD_WISHLIST, _constants.WishConstants.GET_ACTUAL_PRICES_SUCCESS_WISHLIST, _constants.WishConstants.GET_ACTUAL_PRICES_FAIL_WISHLIST],
	        promise: function promise(client, iBonus) {
	            return iBonus.getActualPrices(basketElements);
	        }
	    };
	}
	
	function setWishList(wishList) {
	    return {
	        types: [_constants.WishConstants.SET_WISHLIST, _constants.WishConstants.SET_WISHLIST_SUCCESS, _constants.WishConstants.SET_WISHLIST_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.setWishList(wishList);
	        }
	    };
	}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 168 */
77,
/* 169 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 170 */
125,
/* 171 */
[1991, 269],
/* 172 */
[2009, 818, 398],
/* 173 */
[1948, 77, 33],
/* 174 */
[1958, 77],
/* 175 */
169,
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1144),
	    baseKeys = __webpack_require__(1160),
	    isArrayLike = __webpack_require__(155);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(167)(module)))

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(108)
	  , createDesc = __webpack_require__(618);
	module.exports = __webpack_require__(230) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	module.exports = {};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(143);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _StyleConfig = __webpack_require__(50);
	
	var _SafeAnchor = __webpack_require__(90);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  block: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func,
	  componentClass: _elementType2['default'],
	  href: _react2['default'].PropTypes.string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _react2['default'].PropTypes.oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3['default'])(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3['default'])(this, Button);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        active = _props.active,
	        block = _props.block,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2['default'])(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2['default'].Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 182 */
179,
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(1393)
	  , defined = __webpack_require__(237);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(185);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerDocument;
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	module.exports = exports["default"];

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(704);
	var EventPluginUtils = __webpack_require__(1501);
	var ReactErrorUtils = __webpack_require__(718);
	
	var accumulateInto = __webpack_require__(727);
	var forEachAccumulated = __webpack_require__(728);
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
	   false ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function (InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (false) {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function () {
	      if (false) {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function (id, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(id, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (id, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(id, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function (id) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][id]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(id, registrationName);
	      }
	
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(99);
	var EventPluginHub = __webpack_require__(186);
	
	var warning = __webpack_require__(30);
	
	var accumulateInto = __webpack_require__(727);
	var forEachAccumulated = __webpack_require__(728);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(139);
	
	var getEventTarget = __webpack_require__(373);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _create = __webpack_require__(387);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _setPrototypeOf = __webpack_require__(391);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _from = __webpack_require__(196);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _construct = __webpack_require__(776);
	
	var _construct2 = _interopRequireDefault(_construct);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extendableBuiltin(cls) {
	    function ExtendableBuiltin() {
	        var instance = (0, _construct2.default)(cls, (0, _from2.default)(arguments));
	        (0, _setPrototypeOf2.default)(instance, (0, _getPrototypeOf2.default)(this));
	        return instance;
	    }
	
	    ExtendableBuiltin.prototype = (0, _create2.default)(cls.prototype, {
	        constructor: {
	            value: cls,
	            enumerable: false,
	            writable: true,
	            configurable: true
	        }
	    });
	
	    if (_setPrototypeOf2.default) {
	        (0, _setPrototypeOf2.default)(ExtendableBuiltin, cls);
	    } else {
	        ExtendableBuiltin.__proto__ = cls;
	    }
	
	    return ExtendableBuiltin;
	}
	
	var IBonusError = function (_extendableBuiltin2) {
	    (0, _inherits3.default)(IBonusError, _extendableBuiltin2);
	
	    function IBonusError(_ref) {
	        var message = _ref.message,
	            code = _ref.code,
	            title = _ref.title,
	            trace = _ref.trace,
	            dataError = _ref.dataError;
	        (0, _classCallCheck3.default)(this, IBonusError);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (IBonusError.__proto__ || (0, _getPrototypeOf2.default)(IBonusError)).call(this));
	
	        _this.message = message;
	        _this.code = code;
	        _this.title = title;
	        _this.dataError = dataError || [];
	        return _this;
	    }
	
	    (0, _createClass3.default)(IBonusError, [{
	        key: "toString",
	        value: function toString() {
	            return this.title + " " + this.message + " (" + this.code + ")";
	        }
	    }]);
	    return IBonusError;
	}(_extendableBuiltin(Error));
	
	exports.default = IBonusError;
	module.exports = exports['default'];

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(142);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(195);
	
	var environment = {
	    development: {
	        isProduction: false
	    },
	    production: {
	        isProduction: true
	    }
	}[("production") || 'development'];
	
	module.exports = (0, _assign2.default)({
	    host: 'localhost',
	    port: 666,
	    apiHost: 'https://my.i-retail.com',
	    app: {
	        title: 'IBonus',
	        description: 'IBonus',
	        head: {
	            titleTemplate: '%s',
	            meta: [{ charset: 'utf-8' }, { property: 'og:site_name', content: '' }, { property: 'og:locale', content: 'ru' }, { property: 'og:title', content: '' }, { property: 'og:description', content: '' }]
	        }
	    },
	    checkUrl: 'https://kassa.i-retail.com',
	    theme: 'default',
	    creditUrl: 'https://loans.tinkoff.ru/api/partners/v1/lightweight/create',
	    gapi: {
	        key: 'AIzaSyDWmAI4CBvb1gi7HRIuoSstZHqh_ol_ScU'
	    }
	}, environment);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(192);

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.registration = registration;
	exports.confirmRegistration = confirmRegistration;
	exports.registrationOneClick = registrationOneClick;
	exports.confirmRegistrationOneClick = confirmRegistrationOneClick;
	exports.resetStep = resetStep;
	exports.resetError = resetError;
	exports.sendVoiceCode = sendVoiceCode;
	exports.resetVoiceCode = resetVoiceCode;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function registration(_ref) {
	    var password = _ref.password,
	        shopId = _ref.shopId,
	        params = (0, _objectWithoutProperties3.default)(_ref, ['password', 'shopId']);
	
	    return {
	        types: [_constants.RegistrationConstants.REGISTRATION_FORM_REQUEST, _constants.RegistrationConstants.REGISTRATION_FORM_SUCCESS, _constants.RegistrationConstants.REGISTRATION_FORM_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.userRegistration(password, shopId, params);
	        }
	    };
	}
	
	function confirmRegistration(_ref2) {
	    var password = _ref2.password,
	        shopId = _ref2.shopId,
	        params = (0, _objectWithoutProperties3.default)(_ref2, ['password', 'shopId']);
	
	    return {
	        types: [_constants.RegistrationConstants.REGISTRATION_CONFIRM_REQUEST, _constants.RegistrationConstants.REGISTRATION_CONFIRM_SUCCESS, _constants.RegistrationConstants.REGISTRATION_CONFIRM_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.userConfirmRegistration(password, shopId, params);
	        }
	    };
	}
	
	function registrationOneClick(_ref3) {
	    var shopId = _ref3.shopId,
	        params = (0, _objectWithoutProperties3.default)(_ref3, ['shopId']);
	
	    return {
	        types: [_constants.AuthConstants.LOGIN, _constants.AuthConstants.ONE_CLICK_SUCCESS, _constants.AuthConstants.LOGIN_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.userRegistrationOneClick(shopId, params);
	        }
	    };
	}
	
	function confirmRegistrationOneClick(_ref4) {
	    var shopId = _ref4.shopId,
	        params = (0, _objectWithoutProperties3.default)(_ref4, ['shopId']);
	
	    return {
	        types: [_constants.AuthConstants.LOGIN, _constants.AuthConstants.LOGIN_SUCCESS, _constants.AuthConstants.ONE_CLICK_CONFIRM_ERROR],
	        promise: function promise(client, iBonus) {
	            return iBonus.userConfirmRegistrationOneClick(shopId, params);
	        }
	    };
	}
	
	function resetStep() {
	    return {
	        type: _constants.RegistrationConstants.REGISTRATION_RESET_STEP
	    };
	}
	
	function resetError() {
	    return {
	        type: _constants.RegistrationConstants.REGISTRATION_RESET_ERROR
	    };
	}
	
	function sendVoiceCode(phone) {
	    var source = 'registration';
	    return {
	        types: [_constants.RegistrationConstants.REGISTRATION_VOICE_FORM_REQUEST, _constants.RegistrationConstants.REGISTRATION_VOICE_FORM_SUCCESS, _constants.RegistrationConstants.REGISTRATION_VOICE_FORM_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.sendVoiceCode(phone, source);
	        }
	    };
	}
	
	function resetVoiceCode() {
	    return {
	        type: _constants.RegistrationConstants.REGISTRATION_VOICE_RESET
	    };
	}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(1036);
	
	__webpack_require__(772);
	
	__webpack_require__(781);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(782), __esModule: true };

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(388);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 199 */
[1969, 76, 814, 271, 275, 270, 392],
/* 200 */
[1978, 54, 32, 116],
/* 201 */
[1982, 95, 117, 56],
/* 202 */
129,
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(823);
	var global = __webpack_require__(55);
	var hide = __webpack_require__(118);
	var Iterators = __webpack_require__(146);
	var TO_STRING_TAG = __webpack_require__(56)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 204 */
[1946, 72, 39, 128],
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(22);
	var $export = __webpack_require__(10);
	var redefine = __webpack_require__(61);
	var redefineAll = __webpack_require__(126);
	var meta = __webpack_require__(107);
	var forOf = __webpack_require__(120);
	var anInstance = __webpack_require__(119);
	var isObject = __webpack_require__(25);
	var fails = __webpack_require__(23);
	var $iterDetect = __webpack_require__(210);
	var setToStringTag = __webpack_require__(149);
	var inheritIfRequired = __webpack_require__(290);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(60);
	var redefine = __webpack_require__(61);
	var fails = __webpack_require__(23);
	var defined = __webpack_require__(85);
	var wks = __webpack_require__(33);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(20);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 208 */
[1960, 77],
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(25);
	var cof = __webpack_require__(77);
	var MATCH = __webpack_require__(33)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 210 */
[1964, 33],
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(121) || !__webpack_require__(23)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(22)[K];
	});


/***/ }),
/* 212 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(10);
	var aFunction = __webpack_require__(49);
	var ctx = __webpack_require__(79);
	var forOf = __webpack_require__(120);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(10);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 215 */
[1984, 22],
/* 216 */
[1985, 20, 49, 33],
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(22);
	var hide = __webpack_require__(60);
	var uid = __webpack_require__(129);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 218 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(83);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(1261);
	
	var _runTransitionHook = __webpack_require__(314);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(130);
	
	var _deprecate = __webpack_require__(313);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1200),
	    listCacheDelete = __webpack_require__(1201),
	    listCacheGet = __webpack_require__(1202),
	    listCacheHas = __webpack_require__(1203),
	    listCacheSet = __webpack_require__(1204);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(89);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(227);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(1151),
	    createBaseEach = __webpack_require__(1179);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1198);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(132);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(228);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    isObjectLike = __webpack_require__(133);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(329)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 231 */
[2020, 232, 157, 328],
/* 232 */
109,
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__(1043);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(310);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__(315);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(245);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__(246);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(263);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__(91);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__(628);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(1308);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(630);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__(1356);
	
	var _ValidComponentChildren = __webpack_require__(64);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _react2['default'].PropTypes.bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  componentClass: _elementType2['default'],
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2['default'])((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _react2['default'].PropTypes.bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _react2['default'].PropTypes.bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _react2['default'].PropTypes.bool,
	
	  /**
	   * A callback fired when the Dropdown closes.
	   */
	  onClose: _react2['default'].PropTypes.func,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value.
	   *
	   * ```js
	   * function(Boolean isOpen) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _react2['default'].PropTypes.func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _react2['default'].PropTypes.string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   */
	  rootCloseEvent: _react2['default'].PropTypes.oneOf(['click', 'mousedown'])
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2['default']
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3['default'])(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3['default'])(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains2['default'])(_reactDom2['default'].findDOMNode(this.menu), (0, _activeElement2['default'])(document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu lets return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick() {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen('click');
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        if (!this.props.open) {
	          this.toggleOpen('keydown');
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.handleClose(event);
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen(eventType) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventType;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open);
	    }
	  };
	
	  Dropdown.prototype.handleClose = function handleClose() {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(null);
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2['default'].findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
	    var _this2 = this;
	
	    var ref = function ref(c) {
	      _this2.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction2['default'])(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
	    var _this3 = this;
	
	    var id = _ref.id,
	        onClose = _ref.onClose,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['id', 'onClose', 'onSelect', 'rootCloseEvent']);
	
	    var ref = function ref(c) {
	      _this3.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction2['default'])(child.props.onClose, onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, this.handleClose),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        id = _props.id,
	        dropup = _props.dropup,
	        disabled = _props.disabled,
	        pullRight = _props.pullRight,
	        open = _props.open,
	        onClose = _props.onClose,
	        onSelect = _props.onSelect,
	        role = _props.role,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onClose', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);
	
	
	    delete props.onToggle;
	
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    }
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        switch (child.props.bsRole) {
	          case TOGGLE_ROLE:
	            return _this4.renderToggle(child, {
	              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	            });
	          case MENU_ROLE:
	            return _this4.renderMenu(child, {
	              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onClose: onClose, onSelect: onSelect, rootCloseEvent: rootCloseEvent
	            });
	          default:
	            return child;
	        }
	      })
	    );
	  };
	
	  return Dropdown;
	}(_react2['default'].Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2['default'])(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2['default'];
	UncontrolledDropdown.Menu = _DropdownMenu2['default'];
	
	exports['default'] = UncontrolledDropdown;
	module.exports = exports['default'];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(669);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  'in': _react2['default'].PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2['default'].PropTypes.bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _react2['default'].PropTypes.number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3['default'])(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3['default'])(this, Fade);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, this.props, {
	      className: (0, _classnames2['default'])(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2['default'].Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports['default'] = Fade;
	module.exports = exports['default'];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__(389);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports["default"] = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2["default"])(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(1388);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 237 */
229,
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(181)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(73).setDesc
	  , has = __webpack_require__(239)
	  , TAG = __webpack_require__(75)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ALL_PRINTABLE_KEYS = exports.ALL_KEYS = exports.modifiers = undefined;
	
	__webpack_require__(780);
	
	// TODO: Need better, more complete, and more methodical key definitions
	
	var Keys = {
	  backspace: 8,
	  del: 46,
	  delete: 46,
	  tab: 9,
	  enter: 13,
	  'return': 13,
	  esc: 27,
	  space: 32,
	  pageUp: 33,
	  pageDown: 34,
	  end: 35,
	  home: 36,
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221
	};
	
	// Add uppercase versions of keys above for backwards compatibility
	Object.keys(Keys).forEach(function (key) {
	  return Keys[key.toUpperCase()] = Keys[key];
	});
	
	'0123456789'.split('').forEach(function (num, index) {
	  return Keys[num] = index + 48;
	});
	
	'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function (letter, index) {
	  Keys[letter] = index + 65;
	  Keys[letter.toLowerCase()] = index + 65;
	});
	
	// fn keys
	[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].forEach(function (item, index) {
	  return Keys['f' + index] = 111 + index;
	});
	
	var modifiers = exports.modifiers = {
	  control: 'ctrl',
	  ctrl: 'ctrl',
	  shift: 'shift',
	  meta: 'meta',
	  cmd: 'meta',
	  command: 'meta',
	  option: 'alt',
	  alt: 'alt'
	};
	
	var ALL_KEYS = exports.ALL_KEYS = Symbol('ALL_KEYS');
	
	var ALL_PRINTABLE_KEYS = exports.ALL_PRINTABLE_KEYS = Symbol('ALL_PRINTABLE_KEYS');
	
	exports.default = Keys;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports._resetStore = _resetStore;
	
	var _match_keys = __webpack_require__(665);
	
	var _match_keys2 = _interopRequireDefault(_match_keys);
	
	var _parse_keys = __webpack_require__(666);
	
	var _parse_keys2 = _interopRequireDefault(_parse_keys);
	
	var _uuid = __webpack_require__(1421);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
	                                                                                                                                                                                                     * @module store
	                                                                                                                                                                                                     *
	                                                                                                                                                                                                     */
	
	
	/**
	 * private
	 *
	 */
	
	// dict for class prototypes => bindings
	var _handlers = new Map();
	
	// all mounted instances that have keybindings
	var _instances = new Set();
	
	// for testing
	function _resetStore() {
	  _handlers.clear();
	  _instances.clear();
	}
	
	/**
	 * public
	 *
	 */
	
	var Store = {
	
	  /**
	   * activate
	   *
	   * @access public
	   * @param {object} instance Instantiated class that extended React.Component, to be focused to receive keydown events
	   */
	  activate: function activate(instances) {
	    var instancesArray = [].concat(instances);
	
	    // if no components were found as ancestors of the event target,
	    // effectively deactivate keydown handling by capping the set of instances
	    // with `null`.
	    if (!instancesArray.length) {
	      _instances.add(null);
	    } else {
	      _instances.delete(null);
	
	      // deleting and then adding the instance(s) has the effect of sorting the set
	      // according to instance activation (ascending)
	      instancesArray.forEach(function (instance) {
	        _instances.delete(instance);
	        _instances.add(instance);
	      });
	    }
	  },
	
	
	  /**
	   * deleteInstance
	   *
	   * @access public
	   * @param {object} target Instantiated class that extended React.Component
	   * @return {boolean} The value set.has( target ) would have returned prior to deletion
	   */
	  deleteInstance: function deleteInstance(target) {
	    _instances.delete(target);
	  },
	  findBindingForEvent: function findBindingForEvent(event) {
	    if (!_instances.has(null)) {
	      var keyMatchesEvent = function keyMatchesEvent(keySet) {
	        return (0, _match_keys2.default)({ keySet: keySet, event: event });
	      };
	
	      // loop through instances in reverse activation order so that most
	      // recently activated instance gets first dibs on event
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = [].concat(_toConsumableArray(_instances)).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var instance = _step.value;
	
	          var bindings = this.getBinding(instance.constructor.prototype);
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = bindings[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var _step2$value = _slicedToArray(_step2.value, 2),
	                  keySets = _step2$value[0],
	                  fn = _step2$value[1];
	
	              if (keySets.some(keyMatchesEvent)) {
	                // return when matching keybinding is found - i.e. only one
	                // keybound component can respond to a given key code. to get around this,
	                // scope a common ancestor component class with @keydown and use
	                // @keydownScoped to bind the duplicate keys in your child components
	                // (or just inspect nextProps.keydown.event).
	                return { fn: fn, instance: instance };
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	    return null;
	  },
	
	
	  /**
	   * getBinding
	   *
	   * @access public
	   * @param {object} target Class used as key in dict of key bindings
	   * @return {object} The object containing bindings for the given class
	   */
	  getBinding: function getBinding(_ref) {
	    var __reactKeydownUUID = _ref.__reactKeydownUUID;
	
	    return _handlers.get(__reactKeydownUUID);
	  },
	
	
	  /**
	   * getInstances
	   *
	   * @access public
	   * @return {set} All stored instances (all mounted component instances with keybindings)
	   */
	  getInstances: function getInstances() {
	    return _instances;
	  },
	
	
	  /**
	   * isEmpty
	   *
	   * @access public
	   * @return {number} Size of the set of all stored instances
	   */
	  isEmpty: function isEmpty() {
	    return !_instances.size;
	  },
	
	
	  /**
	   * setBinding
	   *
	   * @access public
	   * @param {object} args All arguments necessary to set the binding
	   * @param {array} args.keys Key codes that should trigger the fn
	   * @param {function} args.fn The callback to be triggered when given keys are pressed
	   * @param {object} args.target The decorated class
	   */
	  setBinding: function setBinding(_ref2) {
	    var keys = _ref2.keys,
	        fn = _ref2.fn,
	        target = _ref2.target;
	
	    var keySets = (0, _parse_keys2.default)(keys);
	
	    var __reactKeydownUUID = target.__reactKeydownUUID;
	
	    if (!__reactKeydownUUID) {
	      target.__reactKeydownUUID = (0, _uuid2.default)();
	      _handlers.set(target.__reactKeydownUUID, new Map([[keySets, fn]]));
	    } else {
	      _handlers.get(__reactKeydownUUID).set(keySets, fn);
	    }
	  }
	};
	
	exports.default = Store;

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWindow;
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	module.exports = exports["default"];

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(247);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(689);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(1467);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(110);
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = _react2['default'].createClass({
	  displayName: 'RouterContext',
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2['default'].createElement
	    };
	  },
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? _routerWarning2['default'](false, '`<RouterContext>` expects a `router` rather than a `history`') : undefined;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = _deprecateObjectProperties2['default'](location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = _getRouteParams2['default'](route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if (_RouteUtils.isReactChildren(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (element.hasOwnProperty(prop)) props[prop] = element[prop];
	          }
	        }
	
	        if (typeof components === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (components.hasOwnProperty(key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2['default'].isValidElement(element)) ?  false ? _invariant2['default'](false, 'The root route must render a single element') : _invariant2['default'](false) : undefined;
	
	    return element;
	  }
	
	});
	
	exports['default'] = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(1412);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _defaultArrowRenderer = __webpack_require__(696);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(697);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(360);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(361);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(694);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(695);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				if (enabled) {
					if (!document.addEventListener && document.attachEvent) {
						document.attachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.addEventListener('touchstart', this.handleTouchOutside);
					}
				} else {
					if (!document.removeEventListener && document.detachEvent) {
						document.detachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.removeEventListener('touchstart', this.handleTouchOutside);
					}
				}
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					className: className,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'span',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(99);
	var EventPluginHub = __webpack_require__(186);
	var EventPluginRegistry = __webpack_require__(704);
	var ReactEventEmitterMixin = __webpack_require__(1515);
	var ReactPerf = __webpack_require__(81);
	var ViewportMetrics = __webpack_require__(726);
	
	var assign = __webpack_require__(29);
	var isEventSupported = __webpack_require__(376);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
	  putListener: 'putListener',
	  deleteListener: 'deleteListener'
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(258);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(189);
	var ViewportMetrics = __webpack_require__(726);
	
	var getEventModifierState = __webpack_require__(372);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(21);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(52);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function (node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function (node, html) {
	    MSApp.execUnsafeLocalFunction(function () {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function (obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _register = __webpack_require__(1589);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _Base = __webpack_require__(1585);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Factory = function () {
	    function Factory() {
	        (0, _classCallCheck3.default)(this, Factory);
	    }
	
	    (0, _createClass3.default)(Factory, null, [{
	        key: 'create',
	        value: function create(ModelName, args) {
	            var composite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	            var clear = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	            if (!Factory.hasModel(ModelName)) {
	                return args;
	            }
	
	            try {
	                var OriginalModel = Factory.getModel(ModelName);
	                var Model = clear ? OriginalModel : (0, _Base2.default)(OriginalModel);
	
	                if (composite && Array.isArray(args)) {
	                    return args.map(function (item) {
	                        return new Model(item);
	                    });
	                }
	                return new Model(args);
	            } catch (error) {
	                return args;
	                console.log('create model error: ', error);
	            }
	        }
	    }, {
	        key: 'getModel',
	        value: function getModel(Name) {
	            if (Factory.hasModel(Name)) {
	                return _register2.default[Name];
	            }
	        }
	    }, {
	        key: 'hasModel',
	        value: function hasModel(Name) {
	            return _register2.default.hasOwnProperty(Name);
	        }
	    }]);
	    return Factory;
	}();
	
	exports.default = Factory;
	module.exports = exports['default'];

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.loadAddresses = loadAddresses;
	exports.addAddress = addAddress;
	exports.updateAddress = updateAddress;
	exports.deleteAddress = deleteAddress;
	
	var _constants = __webpack_require__(18);
	
	function loadAddresses() {
	    return {
	        types: [_constants.AddressConstants.ADDRESSES_LOAD, _constants.AddressConstants.ADDRESSES_LOAD_SUCCESS, _constants.AddressConstants.ADDRESSES_LOAD_FAIL],
	        promise: function promise(client, IBonus) {
	            return IBonus.getAddresses();
	        }
	    };
	}
	function addAddress(address) {
	    return {
	        types: [_constants.AddressConstants.ADDRESS_ADD, _constants.AddressConstants.ADDRESS_ADD_SUCCESS, _constants.AddressConstants.ADDRESS_ADD_FAIL],
	        promise: function promise(client, IBonus) {
	            return IBonus.addAddress(address);
	        }
	    };
	}
	function updateAddress(id, address, is_default) {
	    return {
	        types: [_constants.AddressConstants.ADDRESS_UPDATE, _constants.AddressConstants.ADDRESS_UPDATE_SUCCESS, _constants.AddressConstants.ADDRESS_UPDATE_FAIL],
	        payload: {
	            id: id,
	            address: address,
	            is_default: is_default
	        },
	        promise: function promise(client, IBonus) {
	            return IBonus.updateAddress(id, address, is_default);
	        }
	    };
	}
	function deleteAddress(id) {
	    return {
	        types: [_constants.AddressConstants.ADDRESS_DELETE, _constants.AddressConstants.ADDRESS_DELETE_SUCCESS, _constants.AddressConstants.ADDRESS_DELETE_FAIL],
	        payload: id,
	        promise: function promise(client, IBonus) {
	            return IBonus.deleteAddress(id);
	        }
	    };
	}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SliderConstants = exports.SLIDER_POPULAR = exports.SLIDER_HIT = exports.SLIDER_NEW = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SLIDER_NEW = exports.SLIDER_NEW = 1;
	var SLIDER_HIT = exports.SLIDER_HIT = 2;
	var SLIDER_POPULAR = exports.SLIDER_POPULAR = 3;
	
	var SliderConstants = exports.SliderConstants = (0, _keymirror2.default)({
	    SLIDER_LOAD: null,
	    SLIDER_LOAD_CATEGORY: null,
	    SLIDER_LOAD_SUCCESS: null,
	    SLIDER_LOAD_CATEGORY_SUCCESS: null,
	    SLIDER_LOAD_FAIL: null,
	    SLIDER_LOAD_CATEGORY_FAIL: null
	});

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = textEllipsis;
	
	function textEllipsis(str, maxLength) {
	  var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  var _ref$side = _ref.side;
	  var side = _ref$side === undefined ? 'end' : _ref$side;
	  var _ref$ellipsis = _ref.ellipsis;
	  var ellipsis = _ref$ellipsis === undefined ? '...' : _ref$ellipsis;
	
	  if (str.length > maxLength) {
	    switch (side) {
	      case 'start':
	        return ellipsis + str.slice(-(maxLength - ellipsis.length));
	      case 'end':
	      default:
	        return str.slice(0, maxLength - ellipsis.length) + ellipsis;
	    }
	  }
	  return str;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(1928);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (!component.unmounted) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ }),
/* 264 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict'
	module.exports = (typeof self === 'object' && self.self === self && self) ||
	  (typeof global === 'object' && global.global === global && global) ||
	  this
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 265 */
[1943, 783],
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(800), __esModule: true };

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(773);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(265);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 268 */
[1948, 168, 56],
/* 269 */
85,
/* 270 */
[1952, 94, 55],
/* 271 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 272 */
[1967, 144],
/* 273 */
[1972, 169, 170, 105, 279, 117, 393, 104],
/* 274 */
212,
/* 275 */
[1983, 276, 202],
/* 276 */
[1984, 55],
/* 277 */
87,
/* 278 */
[1990, 277],
/* 279 */
[1992, 94],
/* 280 */
[1993, 55, 32, 198, 281, 95],
/* 281 */
[1994, 56],
/* 282 */
[1996, 268, 56, 146, 32],
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(44);
	var toAbsoluteIndex = __webpack_require__(128);
	var toLength = __webpack_require__(39);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(840);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 285 */
[1949, 38, 125],
/* 286 */
[1952, 25, 22],
/* 287 */
271,
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(33)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 289 */
[1956, 22],
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(25);
	var setPrototypeOf = __webpack_require__(298).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 291 */
[1959, 148, 33],
/* 292 */
[1962, 122, 125, 149, 60, 33],
/* 293 */
[1963, 121, 10, 61, 60, 59, 148, 292, 149, 71, 33],
/* 294 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 296 */
[1966, 22, 304, 77],
/* 297 */
[1967, 49],
/* 298 */
[1981, 25, 20, 79, 70],
/* 299 */
[1983, 215, 129],
/* 300 */
[1986, 87, 85],
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(209);
	var defined = __webpack_require__(85);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(87);
	var defined = __webpack_require__(85);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 303 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 304 */
[1987, 79, 422, 289, 286, 22, 77],
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(22);
	var DESCRIPTORS = __webpack_require__(37);
	var LIBRARY = __webpack_require__(121);
	var $typed = __webpack_require__(217);
	var hide = __webpack_require__(60);
	var redefineAll = __webpack_require__(126);
	var fails = __webpack_require__(23);
	var anInstance = __webpack_require__(119);
	var toInteger = __webpack_require__(87);
	var toLength = __webpack_require__(39);
	var toIndex = __webpack_require__(440);
	var gOPN = __webpack_require__(123).f;
	var dP = __webpack_require__(38).f;
	var arrayFill = __webpack_require__(283);
	var setToStringTag = __webpack_require__(149);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 306 */
[1993, 22, 78, 121, 441, 38],
/* 307 */
[1996, 173, 33, 148, 78],
/* 308 */
[1998, 106, 425, 148, 72, 293],
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(1040);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1252)))

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(152);
	
	var contains = (function () {
	  var root = canUseDOM && document.documentElement;
	
	  return root && root.contains ? function (context, node) {
	    return context.contains(node);
	  } : root && root.compareDocumentPosition ? function (context, node) {
	    return context === node || !!(context.compareDocumentPosition(node) & 16);
	  } : function (context, node) {
	    if (node) do {
	      if (node === context) return true;
	    } while (node = node.parentNode);
	
	    return false;
	  };
	})();
	
	module.exports = contains;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(83);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(83);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(83);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(132),
	    root = __webpack_require__(89);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1205),
	    mapCacheDelete = __webpack_require__(1206),
	    mapCacheGet = __webpack_require__(1207),
	    mapCacheHas = __webpack_require__(1208),
	    mapCacheSet = __webpack_require__(1209);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1155),
	    isObjectLike = __webpack_require__(133);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(221),
	    arrayMap = __webpack_require__(464),
	    isArray = __webpack_require__(63),
	    isSymbol = __webpack_require__(228);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(63),
	    isSymbol = __webpack_require__(228);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    isObject = __webpack_require__(156);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 324 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    getPrototype = __webpack_require__(1186),
	    isObjectLike = __webpack_require__(133);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(319);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(332);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 328 */
[2019, 1272],
/* 329 */
181,
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(328)
	  , call        = __webpack_require__(1278)
	  , isArrayIter = __webpack_require__(1277)
	  , anObject    = __webpack_require__(327)
	  , toLength    = __webpack_require__(1286)
	  , getIterFn   = __webpack_require__(624);
	module.exports = function(iterable, entries, fn, that){
	  var iterFn = getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ }),
/* 331 */
239,
/* 332 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(1280)
	  , $export        = __webpack_require__(231)
	  , redefine       = __webpack_require__(620)
	  , hide           = __webpack_require__(178)
	  , has            = __webpack_require__(331)
	  , Iterators      = __webpack_require__(179)
	  , $iterCreate    = __webpack_require__(1279)
	  , setToStringTag = __webpack_require__(334)
	  , getProto       = __webpack_require__(108).getProto
	  , ITERATOR       = __webpack_require__(134)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if($native){
	    var IteratorPrototype = getProto($default.call(new Base));
	    // Set @@toStringTag to native iterators
	    setToStringTag(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    // fix Array#{values, @@iterator}.name in V8 / FF
	    if(DEF_VALUES && $native.name !== VALUES){
	      VALUES_BUG = true;
	      $default = function values(){ return $native.call(this); };
	    }
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES  ? $default : getMethod(VALUES),
	      keys:    IS_SET      ? $default : getMethod(KEYS),
	      entries: !DEF_VALUES ? $default : getMethod('entries')
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(108).setDesc
	  , has = __webpack_require__(331)
	  , TAG = __webpack_require__(134)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(1050);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(669);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _capitalize = __webpack_require__(644);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + (0, _capitalize2['default'])(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt((0, _style2['default'])(elem, margins[0]), 10) + parseInt((0, _style2['default'])(elem, margins[1]), 10);
	}
	
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  'in': _react2['default'].PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2['default'].PropTypes.bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _react2['default'].PropTypes.number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _react2['default'].PropTypes.func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.oneOf(['height', 'width']), _react2['default'].PropTypes.func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _react2['default'].PropTypes.func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3['default'])(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    (0, _classCallCheck3['default'])(this, Collapse);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleEntered = _this.handleEntered.bind(_this);
	    _this.handleExit = _this.handleExit.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	    return _this;
	  }
	
	  /* -- Expanding -- */
	
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  /* -- Collapsing -- */
	
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	    triggerBrowserReflow(elem);
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + (0, _capitalize2['default'])(dimension)] + 'px';
	  };
	
	  Collapse.prototype.render = function render() {
	    var _props = this.props,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);
	
	
	    delete props.dimension;
	    delete props.getDimensionValue;
	
	    var handleEnter = (0, _createChainedFunction2['default'])(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction2['default'])(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction2['default'])(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction2['default'])(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction2['default'])(this.handleExiting, onExiting);
	
	    var classes = {
	      width: this._dimension() === 'width'
	    };
	
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, props, {
	      'aria-expanded': props.role ? props['in'] : null,
	      className: (0, _classnames2['default'])(className, classes),
	      exitedClassName: 'collapse',
	      exitingClassName: 'collapsing',
	      enteredClassName: 'collapse in',
	      enteringClassName: 'collapsing',
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }));
	  };
	
	  return Collapse;
	}(_react2['default'].Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An icon name. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _react2['default'].PropTypes.string.isRequired
	};
	
	var Glyphicon = function (_React$Component) {
	  (0, _inherits3['default'])(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    (0, _classCallCheck3['default'])(this, Glyphicon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Glyphicon.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        glyph = _props.glyph,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['glyph', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	
	    return _react2['default'].createElement('span', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react2['default'].Component);
	
	Glyphicon.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	module.exports = exports['default'];

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _MediaBody = __webpack_require__(1322);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaHeading = __webpack_require__(1323);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaLeft = __webpack_require__(1324);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaList = __webpack_require__(1325);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(1326);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var _MediaRight = __webpack_require__(1327);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media = function (_React$Component) {
	  (0, _inherits3['default'])(Media, _React$Component);
	
	  function Media() {
	    (0, _classCallCheck3['default'])(this, Media);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Media.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react2['default'].Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	
	Media.Heading = _MediaHeading2['default'];
	Media.Body = _MediaBody2['default'];
	Media.Left = _MediaLeft2['default'];
	Media.Right = _MediaRight2['default'];
	Media.List = _MediaList2['default'];
	Media.ListItem = _MediaListItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', Media);
	module.exports = exports['default'];

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uncontrollable = __webpack_require__(263);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _react.PropTypes.func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _react.PropTypes.func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _react.PropTypes.any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _react2['default'].PropTypes.shape({
	    activeKey: _react.PropTypes.any,
	    onSelect: _react.PropTypes.func.isRequired,
	    getTabId: _react.PropTypes.func.isRequired,
	    getPaneId: _react.PropTypes.func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3['default'])(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3['default'])(this, TabContainer);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2['default'].cloneElement(_react2['default'].Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2['default'].Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _uncontrollable2['default'])(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _elementType2['default']]),
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _react.PropTypes.bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _react.PropTypes.shape({
	    activeKey: _react.PropTypes.any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _elementType2['default']]),
	    activeKey: _react.PropTypes.any,
	    unmountOnExit: _react.PropTypes.bool,
	    onPaneEnter: _react.PropTypes.func.isRequired,
	    onPaneExited: _react.PropTypes.func.isRequired,
	    exiting: _react.PropTypes.bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3['default'])(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3['default'])(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2['default'].Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(646)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _recaptcha = __webpack_require__(1361);
	
	var _recaptcha2 = _interopRequireDefault(_recaptcha);
	
	var _reactAsyncScript = __webpack_require__(1262);
	
	var _reactAsyncScript2 = _interopRequireDefault(_reactAsyncScript);
	
	var callbackName = "onloadcallback";
	var lang = typeof window !== "undefined" && window.recaptchaOptions && window.recaptchaOptions.lang ? "&hl=" + window.recaptchaOptions.lang : "";
	var URL = "https://www.google.com/recaptcha/api.js?onload=" + callbackName + "&render=explicit" + lang;
	var globalName = "grecaptcha";
	
	exports["default"] = (0, _reactAsyncScript2["default"])(_recaptcha2["default"], URL, {
	  callbackName: callbackName,
	  globalName: globalName,
	  exposeFuncs: ["getValue", "reset"]
	});
	module.exports = exports["default"];

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(345);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(343)
	  , TAG = __webpack_require__(75)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(236)
	  , call        = __webpack_require__(654)
	  , isArrayIter = __webpack_require__(653)
	  , anObject    = __webpack_require__(341)
	  , toLength    = __webpack_require__(350)
	  , getIterFn   = __webpack_require__(661);
	module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ }),
/* 345 */
332,
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(657)
	  , $export        = __webpack_require__(98)
	  , redefine       = __webpack_require__(136)
	  , hide           = __webpack_require__(135)
	  , has            = __webpack_require__(239)
	  , Iterators      = __webpack_require__(182)
	  , $iterCreate    = __webpack_require__(1395)
	  , setToStringTag = __webpack_require__(240)
	  , getProto       = __webpack_require__(73).getProto
	  , ITERATOR       = __webpack_require__(75)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getProto($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(241)('meta')
	  , isObject = __webpack_require__(345)
	  , has      = __webpack_require__(239)
	  , setDesc  = __webpack_require__(73).setDesc
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(181)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(349)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(1400)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(346)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(158);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM2.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = style;
	
	var _camelizeStyle = __webpack_require__(677);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	var _hyphenateStyle = __webpack_require__(1444);
	
	var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);
	
	var _getComputedStyle2 = __webpack_require__(1439);
	
	var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);
	
	var _removeStyle = __webpack_require__(1440);
	
	var _removeStyle2 = _interopRequireDefault(_removeStyle);
	
	var _properties = __webpack_require__(676);
	
	var _isTransform = __webpack_require__(1441);
	
	var _isTransform2 = _interopRequireDefault(_isTransform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	    if (!value && value !== 0) {
	      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
	    } else if ((0, _isTransform2.default)(key)) {
	      transforms += key + '(' + value + ') ';
	    } else {
	      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ': ' + transforms + ';';
	  }
	
	  node.style.cssText += ';' + css;
	}
	module.exports = exports['default'];

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(247);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = createTransitionManager;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _historyLibActions = __webpack_require__(153);
	
	var _computeChangedRoutes2 = __webpack_require__(1465);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1463);
	
	var _isActive2 = __webpack_require__(1469);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1466);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1471);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (object.hasOwnProperty(p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = undefined;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? _routerWarning2['default'](false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : undefined;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return _isActive3['default'](location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  function createLocationFromRedirectInfo(location) {
	    return history.createLocation(location, _historyLibActions.REPLACE);
	  }
	
	  var partialNextState = undefined;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      _matchRoutes2['default'](routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = _computeChangedRoutes3['default'](state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    _TransitionUtils.runLeaveHooks(leaveRoutes);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.forEach(removeListenBeforeHooksForRoute);
	
	    _TransitionUtils.runEnterHooks(enterRoutes, nextState, function (error, redirectInfo) {
	      if (error) {
	        callback(error);
	      } else if (redirectInfo) {
	        callback(null, createLocationFromRedirectInfo(redirectInfo));
	      } else {
	        // TODO: Fetch components after state is updated.
	        _getComponents2['default'](nextState, function (error, components) {
	          if (error) {
	            callback(error);
	          } else {
	            // TODO: Make match a pure function and have some other API
	            // for "match and update state".
	            callback(null, null, state = _extends({}, nextState, { components: components }));
	          }
	        });
	      }
	    });
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = {};
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    _matchRoutes2['default'](routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes(_computeChangedRoutes3['default'](state, partialNextState).leaveRoutes);
	
	      var result = undefined;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = undefined;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = undefined,
	      unlistenBeforeUnload = undefined;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and must return either a) a prompt message to show
	   * the user, to make sure they want to leave the page or b) false, to prevent
	   * the transition.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? _routerWarning2['default'](false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : undefined;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.transitionTo(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? _routerWarning2['default'](false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : undefined;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	module.exports = exports['default'];

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports);
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports);
	        global.sAlertStore = mod.exports;
	    }
	})(this, function (exports) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    function _toConsumableArray(arr) {
	        if (Array.isArray(arr)) {
	            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	                arr2[i] = arr[i];
	            }
	
	            return arr2;
	        } else {
	            return Array.from(arr);
	        }
	    }
	
	    // custom simple store based on a awesome Redux library https://github.com/rackt/redux
	
	    var createSAlertStore = function createSAlertStore(reducer) {
	        var state = void 0;
	        var listeners = [];
	        var getState = function getState() {
	            return state;
	        };
	        var dispatch = function dispatch(action) {
	            state = reducer(state, action);
	            listeners.forEach(function (listener) {
	                return listener();
	            });
	        };
	        var subscribe = function subscribe(listener) {
	            listeners.push(listener);
	            return function () {
	                listeners = listeners.filter(function (l) {
	                    return l !== listener;
	                });
	            };
	        };
	        dispatch({});
	        return {
	            getState: getState, dispatch: dispatch, subscribe: subscribe
	        };
	    };
	
	    var insert = function insert(state, action) {
	        return [].concat(_toConsumableArray(state), [action.data]);
	    };
	
	    var remove = function remove(state, action) {
	        var elemToRemoveArray = state.slice().filter(function (item) {
	            return item.id === action.data.id;
	        });
	        if (Array.isArray(elemToRemoveArray)) {
	            var elemToRemoveIndex = state.indexOf(elemToRemoveArray[0]);
	            return [].concat(_toConsumableArray(state.slice(0, elemToRemoveIndex)), _toConsumableArray(state.slice(elemToRemoveIndex + 1)));
	        }
	        return state;
	    };
	
	    var alertsReducer = function alertsReducer() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var action = arguments[1];
	
	        switch (action.type) {
	            case 'INSERT':
	                return insert(state, action);
	            case 'REMOVE':
	                return remove(state, action);
	            case 'REMOVEALL':
	                return [];
	            default:
	                return state;
	        }
	    };
	
	    var sAlertStore = createSAlertStore(alertsReducer);
	
	    exports.default = sAlertStore;
	});

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports);
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports);
	        global.sAlertTools = mod.exports;
	    }
	})(this, function (exports) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    var actualGlobalConfig = void 0;
	
	    var sAlertTools = {
	        randomId: function randomId() {
	            return Math.random().toString(36).split('.')[1];
	        },
	        returnFirstDefined: function returnFirstDefined() {
	            var value = void 0;
	            var i = void 0;
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            for (i = 0; i < args.length; i++) {
	                if (typeof args[i] !== 'undefined') {
	                    value = args[i];
	                    break;
	                }
	            }
	            return value;
	        },
	        styleToObj: function styleToObj(input) {
	            var result = {},
	                i = void 0,
	                entry = void 0,
	                attributes = input && input.split(';').filter(Boolean);
	
	            for (i = 0; i < attributes.length; i++) {
	                entry = attributes[i].split(':');
	                result[entry.splice(0, 1)[0].trim()] = entry.join(':').trim();
	            }
	            return result;
	        },
	        setGlobalConfig: function setGlobalConfig(config) {
	            if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
	                actualGlobalConfig = config;
	            }
	        },
	        getGlobalConfig: function getGlobalConfig() {
	            return actualGlobalConfig;
	        }
	    };
	
	    exports.default = sAlertTools;
	});

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(698);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(1479);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(111);
	
	var assign = __webpack_require__(29);
	var invariant = __webpack_require__(21);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(160);
	var ReactPerf = __webpack_require__(81);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1545);
	var warning = __webpack_require__(30);
	
	// Simplified subset
	var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (propertyInfo.mustUseAttribute) {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      } else {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseAttribute) {
	        node.removeAttribute(propertyInfo.attributeName);
	      } else {
	        var propName = propertyInfo.propertyName;
	        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
	  setValueForProperty: 'setValueForProperty',
	  setValueForAttribute: 'setValueForAttribute',
	  deleteValueForProperty: 'deleteValueForProperty'
	});
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(724);
	var ReactPropTypeLocations = __webpack_require__(252);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(367);
	var ReactMount = __webpack_require__(57);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(21);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(703);
	var DOMPropertyOperations = __webpack_require__(363);
	var ReactMount = __webpack_require__(57);
	var ReactPerf = __webpack_require__(81);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyByID()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function (id, name, value) {
	    var node = ReactMount.getNode(id);
	    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ?  false ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(100);
	var ReactElement = __webpack_require__(65);
	var ReactInstanceMap = __webpack_require__(188);
	var ReactUpdates = __webpack_require__(82);
	
	var assign = __webpack_require__(29);
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
	  },
	
	  enqueueSetPropsInternal: function (internalInstance, partialProps) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    var props = assign({}, element.props, partialProps);
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
	  },
	
	  enqueueReplacePropsInternal: function (internalInstance, props) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '0.14.9';

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(100);
	var ReactInstanceMap = __webpack_require__(188);
	var ReactMount = __webpack_require__(57);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
	   true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(1507);
	var ReactEmptyComponent = __webpack_require__(716);
	var ReactNativeComponent = __webpack_require__(722);
	
	var assign = __webpack_require__(29);
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function () {};
	assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = new ReactEmptyComponent(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(52);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = (eventName in document);
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(52);
	var escapeTextContentForBrowser = __webpack_require__(256);
	var setInnerHTML = __webpack_require__(257);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	  return false;
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(100);
	var ReactElement = __webpack_require__(65);
	var ReactInstanceHandles = __webpack_require__(161);
	
	var getIteratorFn = __webpack_require__(374);
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} text Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var assign = __webpack_require__(29);
	var emptyFunction = __webpack_require__(92);
	var warning = __webpack_require__(30);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    parentTag: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.parentTag = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    /*eslint-disable space-after-keywords */
	    do {
	      /*eslint-enable space-after-keywords */
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
	      }
	    }
	  };
	
	  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(739);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1565);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1564);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1563);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(738);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(740);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserProfileMenu = exports.UserInfo = exports.UserInfoRowItem = exports.UserProfile = undefined;
	
	var _UserInfoRowItem = __webpack_require__(1781);
	
	Object.defineProperty(exports, 'UserInfoRowItem', {
	  enumerable: true,
	  get: function get() {
	    return _UserInfoRowItem.UserInfoRowItem;
	  }
	});
	
	var _UserInfo = __webpack_require__(1778);
	
	Object.defineProperty(exports, 'UserInfo', {
	  enumerable: true,
	  get: function get() {
	    return _UserInfo.UserInfo;
	  }
	});
	
	var _UserProfileMenu = __webpack_require__(1785);
	
	Object.defineProperty(exports, 'UserProfileMenu', {
	  enumerable: true,
	  get: function get() {
	    return _UserProfileMenu.UserProfileMenu;
	  }
	});
	
	var _UserProfile2 = __webpack_require__(1782);
	
	var _UserProfile3 = _interopRequireDefault(_UserProfile2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.UserProfile = _UserProfile3.default;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(195);
	
	module.exports = {
	    pipoHost: 'https://lk.payin-payout.net'
	};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.mergePaymentParameters = mergePaymentParameters;
	exports.extractInstructions = extractInstructions;
	
	var _lodash = __webpack_require__(177);
	
	function mergePaymentParameters(defaultList, pipoList) {
	    return defaultList.slice().map(function (p) {
	        var found = (0, _lodash.find)(pipoList, { slug: p.slug });
	
	        if (found) {
	            p.title = p.lang_data_rus = found.title ? found.title : p.title;
	        }
	
	        return p;
	    });
	}
	
	function extractInstructions(pipoList) {
	    var result = {};
	
	    if (!Array.isArray(pipoList)) {
	        return result;
	    }
	
	    pipoList.reduce(function (r, p) {
	        if (p.instruction) {
	            r[p.slug] = p.instruction;
	        }
	        return r;
	    }, result);
	    return result;
	}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

	'use strict';
	
	/** Деньги в пути */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PAYMENT_STATUS_MONEY_TRANSFER = exports.PAYMENT_STATUS_MONEY_TRANSFER = 4;
	/** Возврат */
	var PAYMENT_STATUS_RETURN = exports.PAYMENT_STATUS_RETURN = 3;
	/** Частичный возврат */
	var PAYMENT_STATUS_PARTIALLY_RETURN = exports.PAYMENT_STATUS_PARTIALLY_RETURN = 13;
	/** Оплачен */
	var PAYMENT_STATUS_PAY = exports.PAYMENT_STATUS_PAY = 2;
	/** Не оплачен */
	var PAYMENT_STATUS_NOT_PAY = exports.PAYMENT_STATUS_NOT_PAY = 1;
	/** Устарел */
	var PAYMENT_STATUS_OUTDATED = exports.PAYMENT_STATUS_OUTDATED = 7;
	// Отменен
	var PAYMENT_STATUS_CANCEL = exports.PAYMENT_STATUS_CANCEL = 8;

/***/ }),
/* 386 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.findCategoryDeep = findCategoryDeep;
	function findCategoryDeep(tree, id) {
	    var result = null;
	    if (!Array.isArray(tree)) {
	        return result;
	    }
	    for (var idx in tree) {
	        result = tree[idx] != null && tree[idx].id == id ? tree[idx] : tree[idx] == null ? null : findCategoryDeep(tree[idx].children, id);
	        if (result !== null) {
	            return result;
	        }
	    }
	
	    return result;
	}
	
	var addMinValueToOffer = exports.addMinValueToOffer = function addMinValueToOffer(offer) {
	    // if (offer.childOffer && offer.childOffer.nestedOffers && offer.childOffer.nestedOffers.length) {
	    //     offer.childOffer.nestedOffers = offer.childOffer.nestedOffers.map(item => addMinValueToOffer(item))
	    // }
	    return offer;
	};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(787), __esModule: true };

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(788), __esModule: true };

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(789), __esModule: true };

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(790), __esModule: true };

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(795), __esModule: true };

/***/ }),
/* 392 */
[1956, 55],
/* 393 */
[1957, 104, 116, 270],
/* 394 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 395 */
[1958, 168],
/* 396 */
[1959, 146, 56],
/* 397 */
[1961, 76],
/* 398 */
[1963, 198, 54, 407, 118, 117, 146, 809, 201, 402, 56],
/* 399 */
[1964, 56],
/* 400 */
[1973, 105, 401],
/* 401 */
[1974, 403, 271],
/* 402 */
[1975, 117, 171, 275],
/* 403 */
[1976, 117, 105, 803, 275],
/* 404 */
[1979, 147, 105, 169],
/* 405 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 406 */
[1980, 76, 94, 272],
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(118);


/***/ }),
/* 408 */
[1985, 76, 144, 56],
/* 409 */
[1987, 145, 394, 392, 270, 55, 168],
/* 410 */
/***/ (function(module, exports) {



/***/ }),
/* 411 */
[2010, 55, 117, 104, 54, 407, 811, 116, 276, 201, 202, 56, 281, 280, 806, 808, 76, 105, 279, 170, 199, 400, 273, 95, 147, 401, 169, 274, 198, 118],
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(77);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(44);
	var toAbsoluteIndex = __webpack_require__(128);
	var toLength = __webpack_require__(39);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(120);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(49);
	var toObject = __webpack_require__(44);
	var IObject = __webpack_require__(174);
	var toLength = __webpack_require__(39);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 416 */
[1947, 49, 25, 422],
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(38).f;
	var create = __webpack_require__(122);
	var redefineAll = __webpack_require__(126);
	var ctx = __webpack_require__(79);
	var anInstance = __webpack_require__(119);
	var forOf = __webpack_require__(120);
	var $iterDefine = __webpack_require__(293);
	var step = __webpack_require__(425);
	var setSpecies = __webpack_require__(127);
	var DESCRIPTORS = __webpack_require__(37);
	var fastKey = __webpack_require__(107).fastKey;
	var validate = __webpack_require__(151);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(173);
	var from = __webpack_require__(414);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(126);
	var getWeak = __webpack_require__(107).getWeak;
	var anObject = __webpack_require__(20);
	var isObject = __webpack_require__(25);
	var anInstance = __webpack_require__(119);
	var forOf = __webpack_require__(120);
	var createArrayMethod = __webpack_require__(84);
	var $has = __webpack_require__(59);
	var validate = __webpack_require__(151);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(208);
	var isObject = __webpack_require__(25);
	var toLength = __webpack_require__(39);
	var ctx = __webpack_require__(79);
	var IS_CONCAT_SPREADABLE = __webpack_require__(33)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 421 */
[1957, 37, 23, 286],
/* 422 */
394,
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(25);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 424 */
[1961, 20],
/* 425 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(295);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 427 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 428 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 429 */
[1968, 124, 212, 175, 44, 174, 23],
/* 430 */
[1971, 38, 20, 124, 37],
/* 431 */
[1973, 72, 123],
/* 432 */
[1976, 59, 72, 204, 299],
/* 433 */
[1979, 124, 72, 175],
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(123);
	var gOPS = __webpack_require__(212);
	var anObject = __webpack_require__(20);
	var Reflect = __webpack_require__(22).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(22).parseFloat;
	var $trim = __webpack_require__(150).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(303) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(22).parseInt;
	var $trim = __webpack_require__(150).trim;
	var ws = __webpack_require__(303);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 437 */
405,
/* 438 */
[1980, 20, 25, 297],
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(39);
	var repeat = __webpack_require__(302);
	var defined = __webpack_require__(85);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(87);
	var toLength = __webpack_require__(39);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 441 */
[1994, 33],
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(417);
	var validate = __webpack_require__(151);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(205)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(173);
	var test = {};
	test[__webpack_require__(33)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(61)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(37) && /./g.flags != 'g') __webpack_require__(38).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(207)
	});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(417);
	var validate = __webpack_require__(151);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(205)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 446 */
[2010, 22, 59, 37, 10, 61, 107, 23, 215, 149, 129, 33, 441, 306, 843, 208, 20, 72, 88, 125, 122, 431, 70, 38, 124, 123, 175, 212, 121, 60],
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(84)(0);
	var redefine = __webpack_require__(61);
	var meta = __webpack_require__(107);
	var assign = __webpack_require__(429);
	var weak = __webpack_require__(419);
	var isObject = __webpack_require__(25);
	var fails = __webpack_require__(23);
	var validate = __webpack_require__(151);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(205)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(1042);
	var isArguments = __webpack_require__(1041);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(152);
	var off = function off() {};
	
	if (canUseDOM) {
	
	  off = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = off;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(152);
	var on = function on() {};
	
	if (canUseDOM) {
	  on = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = on;

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === "object") {
	    factory(exports);
	  } else {
	    factory(root.babelHelpers = {});
	  }
	})(this, function (global) {
	  var babelHelpers = global;
	
	  babelHelpers.interopRequireDefault = function (obj) {
	    return obj && obj.__esModule ? obj : {
	      "default": obj
	    };
	  };
	
	  babelHelpers._extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	})

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	
	'use strict';
	var camelize = __webpack_require__(1052);
	var msPattern = /^-ms-/;
	
	module.exports = function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	};

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
455,
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(218);
	
	var _DOMUtils = __webpack_require__(312);
	
	var _createHistory = __webpack_require__(460);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(83);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(153);
	
	var _PathUtils = __webpack_require__(130);
	
	var _ExecutionEnvironment = __webpack_require__(218);
	
	var _DOMUtils = __webpack_require__(312);
	
	var _DOMStateStorage = __webpack_require__(311);
	
	var _createDOMHistory = __webpack_require__(458);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(83);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(448);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(130);
	
	var _AsyncUtils = __webpack_require__(1129);
	
	var _Actions = __webpack_require__(153);
	
	var _createLocation2 = __webpack_require__(1131);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(314);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(313);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(83);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(218);
	
	var _PathUtils = __webpack_require__(130);
	
	var _runTransitionHook = __webpack_require__(314);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(313);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(220),
	    stackClear = __webpack_require__(1221),
	    stackDelete = __webpack_require__(1222),
	    stackGet = __webpack_require__(1223),
	    stackHas = __webpack_require__(1224),
	    stackSet = __webpack_require__(1225);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 463 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 465 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(467),
	    eq = __webpack_require__(227);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(473);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 468 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(472),
	    toKey = __webpack_require__(226);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(468),
	    baseIsNaN = __webpack_require__(1157),
	    strictIndexOf = __webpack_require__(1226);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 471 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(63),
	    isKey = __webpack_require__(321),
	    stringToPath = __webpack_require__(1228),
	    toString = __webpack_require__(326);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(132);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1140),
	    arraySome = __webpack_require__(465),
	    cacheHas = __webpack_require__(1172);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 475 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(227),
	    isArrayLike = __webpack_require__(155),
	    isIndex = __webpack_require__(320),
	    isObject = __webpack_require__(156);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 477 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(156);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 479 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 480 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 481 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(468),
	    baseIteratee = __webpack_require__(154),
	    toInteger = __webpack_require__(489);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1154),
	    isObjectLike = __webpack_require__(133);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(89),
	    stubFalse = __webpack_require__(1246);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(167)(module)))

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(318);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    isArray = __webpack_require__(63),
	    isObjectLike = __webpack_require__(133);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1159),
	    baseUnary = __webpack_require__(1171),
	    nodeUtil = __webpack_require__(1213);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(317);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(1248);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(156),
	    isSymbol = __webpack_require__(228);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	// Language contact person : Abdoufata Kane : https://github.com/abdoufata
	
	var bm = moment.defineLocale('bm', {
	    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'MMMM [tile] D [san] YYYY',
	        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bi lɛrɛ] LT',
	        nextDay : '[Sini lɛrɛ] LT',
	        nextWeek : 'dddd [don lɛrɛ] LT',
	        lastDay : '[Kunu lɛrɛ] LT',
	        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s kɔnɔ',
	        past : 'a bɛ %s bɔ',
	        s : 'sanga dama dama',
	        m : 'miniti kelen',
	        mm : 'miniti %d',
	        h : 'lɛrɛ kelen',
	        hh : 'lɛrɛ %d',
	        d : 'tile kelen',
	        dd : 'tile %d',
	        M : 'kalo kelen',
	        MM : 'kalo %d',
	        y : 'san kelen',
	        yy : 'san %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return bm;
	
	})));


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : 'D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish(United State) [es-us]
	//! author : bustta : https://github.com/bustta
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esUs = moment.defineLocale('es-us', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'MM/DD/YYYY',
	        LL : 'MMMM [de] D [de] YYYY',
	        LLL : 'MMMM [de] D [de] YYYY H:mm',
	        LLLL : 'dddd, MMMM [de] D [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return esUs;
	
	})));


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex : monthsRegex,
	    monthsShortRegex : monthsRegex,
	    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	        '1': '૧',
	        '2': '૨',
	        '3': '૩',
	        '4': '૪',
	        '5': '૫',
	        '6': '૬',
	        '7': '૭',
	        '8': '૮',
	        '9': '૯',
	        '0': '૦'
	    };
	var numberMap = {
	        '૧': '1',
	        '૨': '2',
	        '૩': '3',
	        '૪': '4',
	        '૫': '5',
	        '૬': '6',
	        '૭': '7',
	        '૮': '8',
	        '૯': '9',
	        '૦': '0'
	    };
	
	var gu = moment.defineLocale('gu', {
	    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm વાગ્યે',
	        LTS: 'A h:mm:ss વાગ્યે',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	    },
	    calendar: {
	        sameDay: '[આજ] LT',
	        nextDay: '[કાલે] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[ગઇકાલે] LT',
	        lastWeek: '[પાછલા] dddd, LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s મા',
	        past: '%s પેહલા',
	        s: 'અમુક પળો',
	        m: 'એક મિનિટ',
	        mm: '%d મિનિટ',
	        h: 'એક કલાક',
	        hh: '%d કલાક',
	        d: 'એક દિવસ',
	        dd: '%d દિવસ',
	        M: 'એક મહિનો',
	        MM: '%d મહિનો',
	        y: 'એક વર્ષ',
	        yy: '%d વર્ષ'
	    },
	    preparse: function (string) {
	        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'રાત') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'સવાર') {
	            return hour;
	        } else if (meridiem === 'બપોર') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'સાંજ') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'રાત';
	        } else if (hour < 10) {
	            return 'સવાર';
	        } else if (hour < 17) {
	            return 'બપોર';
	        } else if (hour < 20) {
	            return 'સાંજ';
	        } else {
	            return 'રાત';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return gu;
	
	})));


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '일';
	            case 'M':
	                return number + '월';
	            case 'w':
	            case 'W':
	                return number + '주';
	            default:
	                return number;
	        }
	    },
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W niedzielę o] LT';
	
	                case 2:
	                    return '[We wtorek o] LT';
	
	                case 3:
	                    return '[W środę o] LT';
	
	                case 6:
	                    return '[W sobotę o] LT';
	
	                default:
	                    return '[W] dddd [o] LT';
	            }
	        },
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[gelecek] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(11)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ }),
/* 609 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 610 */
/***/ (function(module, exports) {

	module.exports = {
		L : 1,
		M : 0,
		Q : 3,
		H : 2
	};
	


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	var math = __webpack_require__(612);
	
	function QRPolynomial(num, shift) {
	
		if (num.length == undefined) {
			throw new Error(num.length + "/" + shift);
		}
	
		var offset = 0;
	
		while (offset < num.length && num[offset] == 0) {
			offset++;
		}
	
		this.num = new Array(num.length - offset + shift);
		for (var i = 0; i < num.length - offset; i++) {
			this.num[i] = num[i + offset];
		}
	}
	
	QRPolynomial.prototype = {
	
		get : function(index) {
			return this.num[index];
		},
		
		getLength : function() {
			return this.num.length;
		},
		
		multiply : function(e) {
		
			var num = new Array(this.getLength() + e.getLength() - 1);
		
			for (var i = 0; i < this.getLength(); i++) {
				for (var j = 0; j < e.getLength(); j++) {
					num[i + j] ^= math.gexp(math.glog(this.get(i) ) + math.glog(e.get(j) ) );
				}
			}
		
			return new QRPolynomial(num, 0);
		},
		
		mod : function(e) {
		
			if (this.getLength() - e.getLength() < 0) {
				return this;
			}
		
			var ratio = math.glog(this.get(0) ) - math.glog(e.get(0) );
		
			var num = new Array(this.getLength() );
			
			for (var i = 0; i < this.getLength(); i++) {
				num[i] = this.get(i);
			}
			
			for (var i = 0; i < e.getLength(); i++) {
				num[i] ^= math.gexp(math.glog(e.get(i) ) + ratio);
			}
		
			// recursive call
			return new QRPolynomial(num, 0).mod(e);
		}
	};
	
	module.exports = QRPolynomial;


/***/ }),
/* 612 */
/***/ (function(module, exports) {

	var QRMath = {
	
		glog : function(n) {
		
			if (n < 1) {
				throw new Error("glog(" + n + ")");
			}
			
			return QRMath.LOG_TABLE[n];
		},
		
		gexp : function(n) {
		
			while (n < 0) {
				n += 255;
			}
		
			while (n >= 256) {
				n -= 255;
			}
		
			return QRMath.EXP_TABLE[n];
		},
		
		EXP_TABLE : new Array(256),
		
		LOG_TABLE : new Array(256)
	
	};
		
	for (var i = 0; i < 8; i++) {
		QRMath.EXP_TABLE[i] = 1 << i;
	}
	for (var i = 8; i < 256; i++) {
		QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
			^ QRMath.EXP_TABLE[i - 5]
			^ QRMath.EXP_TABLE[i - 6]
			^ QRMath.EXP_TABLE[i - 8];
	}
	for (var i = 0; i < 255; i++) {
		QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
	}
	
	module.exports = QRMath;


/***/ }),
/* 613 */
/***/ (function(module, exports) {

	module.exports = {
		MODE_NUMBER :		1 << 0,
		MODE_ALPHA_NUM : 	1 << 1,
		MODE_8BIT_BYTE : 	1 << 2,
		MODE_KANJI :		1 << 3
	};


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(615)
	  , TAG = __webpack_require__(134)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 615 */
343,
/* 616 */
[2021, 615],
/* 617 */
/***/ (function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ }),
/* 618 */
348,
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(620);
	module.exports = function(target, src){
	  for(var key in src)redefine(target, key, src[key]);
	  return target;
	};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(178);

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};

/***/ }),
/* 622 */
349,
/* 623 */
241,
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(614)
	  , ITERATOR  = __webpack_require__(134)('iterator')
	  , Iterators = __webpack_require__(179);
	module.exports = __webpack_require__(157).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(1284)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(333)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1289);
	var Iterators = __webpack_require__(179);
	Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(90);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _react2['default'].PropTypes.bool,
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _react2['default'].PropTypes.string,
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _react2['default'].PropTypes.node,
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem = function (_React$Component) {
	  (0, _inherits3['default'])(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    (0, _classCallCheck3['default'])(this, BreadcrumbItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  BreadcrumbItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        href = _props.href,
	        title = _props.title,
	        target = _props.target,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'href', 'title', 'target', 'className']);
	
	    // Don't try to render these props on non-active <span>.
	
	    var linkProps = { href: href, title: title, target: target };
	
	    return _react2['default'].createElement(
	      'li',
	      { className: (0, _classnames2['default'])(className, { active: active }) },
	      active ? _react2['default'].createElement('span', props) : _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, linkProps))
	    );
	  };
	
	  return BreadcrumbItem;
	}(_react2['default'].Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	
	exports['default'] = BreadcrumbItem;
	module.exports = exports['default'];

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _all = __webpack_require__(245);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _Button = __webpack_require__(180);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  vertical: _react2['default'].PropTypes.bool,
	  justified: _react2['default'].PropTypes.bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all2['default'])(_react2['default'].PropTypes.bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3['default'])(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonGroup.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        block = _props.block,
	        justified = _props.justified,
	        vertical = _props.vertical,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['block', 'justified', 'vertical', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2['default'].defaultProps, 'block')] = block, _extends2));
	
	    return _react2['default'].createElement('div', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react2['default'].Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__(1357);
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _react2['default'].PropTypes.oneOf(['prev', 'next']),
	  onAnimateOutEnd: _react2['default'].PropTypes.func,
	  active: _react2['default'].PropTypes.bool,
	  animateIn: _react2['default'].PropTypes.bool,
	  animateOut: _react2['default'].PropTypes.bool,
	  index: _react2['default'].PropTypes.number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3['default'])(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        active = _props.active,
	        animateIn = _props.animateIn,
	        animateOut = _props.animateOut,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2['default'].Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports['default'] = CarouselItem;
	module.exports = exports['default'];

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(180);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(90);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  noCaret: _react2['default'].PropTypes.bool,
	  open: _react2['default'].PropTypes.bool,
	  title: _react2['default'].PropTypes.string,
	  useAnchor: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3['default'])(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var _props = this.props,
	        noCaret = _props.noCaret,
	        open = _props.open,
	        useAnchor = _props.useAnchor,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	    delete props.bsRole;
	
	    var Component = useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
	    var useCaret = !noCaret;
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        role: 'button',
	        className: (0, _classnames2['default'])(className, bsClass),
	        'aria-haspopup': true,
	        'aria-expanded': open
	      }),
	      children || props.title,
	      useCaret && ' ',
	      useCaret && _react2['default'].createElement('span', { className: 'caret' })
	    );
	  };
	
	  return DropdownToggle;
	}(_react2['default'].Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	module.exports = exports['default'];

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _react2['default'].PropTypes.bool,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3['default'])(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3['default'])(this, Grid);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Grid.prototype.render = function render() {
	    var _props = this.props,
	        fluid = _props.fluid,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['fluid', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react2['default'].Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('container', Grid);
	module.exports = exports['default'];

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(143);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _StyleConfig = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _react2['default'].PropTypes.any,
	  disabled: _react2['default'].PropTypes.any,
	  header: _react2['default'].PropTypes.node,
	  listItem: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func,
	  href: _react2['default'].PropTypes.string,
	  type: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    (0, _classCallCheck3['default'])(this, ListGroupItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react2['default'].isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, headingClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'h4',
	      { className: headingClassName },
	      header
	    );
	  };
	
	  ListGroupItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        className = _props.className,
	        header = _props.header,
	        listItem = _props.listItem,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	
	    var Component = void 0;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames2['default'])(className, classes);
	
	    // TODO: Deprecate `header` prop.
	    if (header) {
	      return _react2['default'].createElement(
	        Component,
	        elementProps,
	        this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')),
	        _react2['default'].createElement(
	          'p',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'text') },
	          children
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      Component,
	      elementProps,
	      children
	    );
	  };
	
	  return ListGroupItem;
	}(_react2['default'].Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ListGroupItem));
	module.exports = exports['default'];

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3['default'])(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3['default'])(this, ModalBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3['default'])(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3['default'])(this, ModalFooter);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * The 'aria-label' attribute provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  'aria-label': _react2['default'].PropTypes.string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _react2['default'].PropTypes.bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  'aria-label': 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _react2['default'].PropTypes.shape({
	    onHide: _react2['default'].PropTypes.func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3['default'])(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3['default'])(this, ModalHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        label = _props['aria-label'],
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['aria-label', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      closeButton && _react2['default'].createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'close',
	          'aria-label': label,
	          onClick: (0, _createChainedFunction2['default'])(modal.onHide, onHide)
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '\xD7'
	        )
	      ),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2['default'].Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3['default'])(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3['default'])(this, ModalTitle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('h4', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(315);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(245);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__(91);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(64);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _react2['default'].PropTypes.any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _react2['default'].PropTypes.string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _react2['default'].PropTypes.bool,
	
	  justified: (0, _all2['default'])(_react2['default'].PropTypes.bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _react2['default'].PropTypes.string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _react2['default'].PropTypes.bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _react2['default'].PropTypes.bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _react2['default'].PropTypes.shape({
	    bsClass: _react2['default'].PropTypes.string,
	    onSelect: _react2['default'].PropTypes.func
	  }),
	
	  $bs_tabContainer: _react2['default'].PropTypes.shape({
	    activeKey: _react2['default'].PropTypes.any,
	    onSelect: _react2['default'].PropTypes.func.isRequired,
	    getTabId: _react2['default'].PropTypes.func.isRequired,
	    getPaneId: _react2['default'].PropTypes.func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3['default'])(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3['default'])(this, Nav);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps(),
	        activeKey = _getActiveProps.activeKey,
	        activeHref = _getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2['default'].toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2['default'].findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.left:
	      case _keycode2['default'].codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2['default'].codes.right:
	      case _keycode2['default'].codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps(),
	        activeKey = _getActiveProps2.activeKey,
	        activeHref = _getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2['default'])(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props,
	        stacked = _props.stacked,
	        justified = _props.justified,
	        onSelect = _props.onSelect,
	        propsRole = _props.role,
	        propsNavbar = _props.navbar,
	        pullRight = _props.pullRight,
	        pullLeft = _props.pullLeft,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps(),
	        activeKey = _getActiveProps3.activeKey,
	        activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends4['default'])({}, elementProps, {
	        role: role,
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4['default'])({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2['default'].Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(90);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  role: _react2['default'].PropTypes.string,
	  href: _react2['default'].PropTypes.string,
	  onClick: _react2['default'].PropTypes.func,
	  onSelect: _react2['default'].PropTypes.func,
	  eventKey: _react2['default'].PropTypes.any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3['default'])(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3['default'])(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        onClick = _props.onClick,
	        className = _props.className,
	        style = _props.style,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2['default'].Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports['default'] = NavItem;
	module.exports = exports['default'];

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _react2['default'].PropTypes.shape({
	    bsClass: _react2['default'].PropTypes.string
	  })
	};
	
	var NavbarBrand = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    (0, _classCallCheck3['default'])(this, NavbarBrand);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react2['default'].isValidElement(children)) {
	      return _react2['default'].cloneElement(children, {
	        className: (0, _classnames2['default'])(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	}(_react2['default'].Component);
	
	NavbarBrand.contextTypes = contextTypes;
	
	exports['default'] = NavbarBrand;
	module.exports = exports['default'];

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Overlay = __webpack_require__(1426);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(234);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2['default'].PropTypes.bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _react2['default'].PropTypes.bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _react2['default'].PropTypes.func,
	
	  /**
	   * Use animation
	   */
	  animation: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _elementType2['default']]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2['default'].PropTypes.func
	});
	
	var defaultProps = {
	  animation: _Fade2['default'],
	  rootClose: false,
	  show: false
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3['default'])(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3['default'])(this, Overlay);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        animation = _props.animation,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2['default'] : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2['default'])(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2['default'].Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports['default'] = Overlay;
	module.exports = exports['default'];

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(90);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  disabled: _react2['default'].PropTypes.bool,
	  previous: _react2['default'].PropTypes.bool,
	  next: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func,
	  onSelect: _react2['default'].PropTypes.func,
	  eventKey: _react2['default'].PropTypes.any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3['default'])(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3['default'])(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        previous = _props2.previous,
	        next = _props2.next,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2['default'].Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports['default'] = PagerItem;
	module.exports = exports['default'];

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(142);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(64);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  accordion: _react2['default'].PropTypes.bool,
	  activeKey: _react2['default'].PropTypes.any,
	  defaultActiveKey: _react2['default'].PropTypes.any,
	  onSelect: _react2['default'].PropTypes.func,
	  role: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  accordion: false
	};
	
	// TODO: Use uncontrollable.
	
	var PanelGroup = function (_React$Component) {
	  (0, _inherits3['default'])(PanelGroup, _React$Component);
	
	  function PanelGroup(props, context) {
	    (0, _classCallCheck3['default'])(this, PanelGroup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	
	    _this.state = {
	      activeKey: props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this.props.onSelect(key, e);
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({ activeKey: key });
	  };
	
	  PanelGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        accordion = _props.accordion,
	        propsActiveKey = _props.activeKey,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['accordion', 'activeKey', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultActiveKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeKey = void 0;
	    if (accordion) {
	      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var childProps = {
	          bsStyle: child.props.bsStyle || bsProps.bsStyle
	        };
	
	        if (accordion) {
	          (0, _assign2['default'])(childProps, {
	            headerRole: 'tab',
	            panelRole: 'tabpanel',
	            collapsible: true,
	            expanded: child.props.eventKey === activeKey,
	            onSelect: (0, _createChainedFunction2['default'])(_this2.handleSelect, child.props.onSelect)
	          });
	        }
	
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return PanelGroup;
	}(_react2['default'].Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(91);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(234);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _react.PropTypes.any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _elementType2['default']]),
	
	  /** @private **/
	  id: _react.PropTypes.string,
	
	  /** @private **/
	  'aria-labelledby': _react.PropTypes.string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _react2['default'].PropTypes.string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _react.PropTypes.func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _react.PropTypes.func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _react.PropTypes.func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _react.PropTypes.func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _react.PropTypes.func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _react.PropTypes.func,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _react.PropTypes.bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _react.PropTypes.shape({
	    getId: _react.PropTypes.func,
	    unmountOnExit: _react.PropTypes.bool
	  }),
	  $bs_tabContent: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _elementType2['default']]),
	    activeKey: _react.PropTypes.any,
	    unmountOnExit: _react.PropTypes.bool,
	    onPaneEnter: _react.PropTypes.func.isRequired,
	    onPaneExited: _react.PropTypes.func.isRequired,
	    exiting: _react.PropTypes.bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _react.PropTypes.oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3['default'])(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3['default'])(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this['in'] = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this['in']) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this['in']) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this['in'] = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this['in'] = false;
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2['default'] : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2['default'].createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2['default'])(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2['default'])(this.handleExited, onExited),
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2['default'].Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ }),
/* 644 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = capitalize;
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(711);


/***/ }),
/* 646 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};
	
	exports.__esModule = true;

/***/ }),
/* 647 */
157,
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(75)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(135)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ }),
/* 649 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $           = __webpack_require__(73)
	  , hide        = __webpack_require__(135)
	  , redefineAll = __webpack_require__(658)
	  , ctx         = __webpack_require__(236)
	  , anInstance  = __webpack_require__(649)
	  , defined     = __webpack_require__(237)
	  , forOf       = __webpack_require__(344)
	  , $iterDefine = __webpack_require__(346)
	  , step        = __webpack_require__(656)
	  , setSpecies  = __webpack_require__(1399)
	  , DESCRIPTORS = __webpack_require__(238)
	  , fastKey     = __webpack_require__(347).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = $.create(null); // index
	      that._f = undefined;      // first entry
	      that._l = undefined;      // last entry
	      that[SIZE] = 0;           // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(342)
	  , from    = __webpack_require__(1389);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(109)
	  , $export        = __webpack_require__(98)
	  , redefine       = __webpack_require__(136)
	  , redefineAll    = __webpack_require__(658)
	  , meta           = __webpack_require__(347)
	  , forOf          = __webpack_require__(344)
	  , anInstance     = __webpack_require__(649)
	  , isObject       = __webpack_require__(345)
	  , fails          = __webpack_require__(181)
	  , $iterDetect    = __webpack_require__(655)
	  , setToStringTag = __webpack_require__(240);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = new Base;
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(182)
	  , ITERATOR   = __webpack_require__(75)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(341);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(75)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ safe = true; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ }),
/* 656 */
617,
/* 657 */
/***/ (function(module, exports) {

	module.exports = false;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(136);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(109)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(237);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(342)
	  , ITERATOR  = __webpack_require__(75)('iterator')
	  , Iterators = __webpack_require__(182);
	module.exports = __webpack_require__(74).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(342)
	  , test    = {};
	test[__webpack_require__(75)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(136)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators     = __webpack_require__(1403)
	  , redefine       = __webpack_require__(136)
	  , global         = __webpack_require__(109)
	  , hide           = __webpack_require__(135)
	  , Iterators      = __webpack_require__(182)
	  , wks            = __webpack_require__(75)
	  , ITERATOR       = wks('iterator')
	  , TO_STRING_TAG  = wks('toStringTag')
	  , ArrayValues    = Iterators.Array;
	
	__webpack_require__(73).each.call(['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], function(NAME){
	  var Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	});

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.onUnmount = exports.onMount = undefined;
	exports._onClick = _onClick;
	exports._onKeyDown = _onKeyDown;
	exports._shouldConsider = _shouldConsider;
	
	var _dom_helpers = __webpack_require__(1419);
	
	var _dom_helpers2 = _interopRequireDefault(_dom_helpers);
	
	var _listeners = __webpack_require__(1420);
	
	var _listeners2 = _interopRequireDefault(_listeners);
	
	var _store = __webpack_require__(243);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	/**
	 * @module eventHandlers
	 *
	 */
	
	
	/**
	 * private
	 *
	 */
	
	/**
	 * _onClick
	 *
	 * @access private
	 * @param {object} event The click event object
	 * @param {object} event.target The DOM node from the click event
	 */
	function _onClick(_ref) {
	  var target = _ref.target;
	
	  _store2.default.activate([].concat(_toConsumableArray(_store2.default.getInstances())).reduce(_dom_helpers2.default.findContainerNodes(target), []).sort(_dom_helpers2.default.sortByDOMPosition).map(function (item) {
	    return item.instance;
	  }));
	}
	
	/**
	 * _onKeyDown: The keydown event callback
	 *
	 * @access private
	 * @param {object} event The keydown event object
	 * @param {number} event.which The key code (which) received from the keydown event
	 */
	function _onKeyDown(event) {
	  var forceConsider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (forceConsider || _shouldConsider(event)) {
	    var _ref2 = _store2.default.findBindingForEvent(event) || {},
	        fn = _ref2.fn,
	        instance = _ref2.instance;
	
	    if (fn) {
	      fn.call(instance, event);
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * _shouldConsider: Conditions for proceeding with key event handling
	 *
	 * @access private
	 * @param {object} event The keydown event object
	 * @param {object} event.target The node origin of the event
	 * @return {boolean} Whether to continue procesing the keydown event
	 */
	function _shouldConsider(_ref3) {
	  var ctrlKey = _ref3.ctrlKey,
	      target = _ref3.target;
	
	  return ctrlKey || !~['INPUT', 'SELECT', 'TEXTAREA'].indexOf(target.tagName) && (!target.getAttribute || target.getAttribute('role') !== 'textbox');
	}
	
	/**
	 * public
	 *
	 */
	
	/**
	 * onMount
	 *
	 * @access public
	 */
	function onMount(instance) {
	  _store2.default.activate(instance);
	  _listeners2.default.bindKeys(_onKeyDown);
	  _listeners2.default.bindClicks(_onClick);
	  _dom_helpers2.default.bindFocusables(instance, _store2.default.activate);
	}
	
	/**
	 * onUnmount
	 *
	 * @access public
	 */
	function onUnmount(instance) {
	  _store2.default.deleteInstance(instance);
	  if (_store2.default.isEmpty()) {
	    _listeners2.default.unbindClicks(_onClick);
	    _listeners2.default.unbindKeys(_onKeyDown);
	  }
	}
	
	exports.onMount = onMount;
	exports.onUnmount = onUnmount;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(242);
	
	var PRINTABLE_CHARACTERS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ~!@#$%^&*()-_+=[]\\{}|;\':",./<>?£';
	
	var modKeys = Object.keys(_keys.modifiers);
	
	function matchKeys(_ref) {
	  var keySet = _ref.keySet,
	      event = _ref.event;
	  var key = keySet.key,
	      _keySet$modifiers = keySet.modifiers,
	      modifiers = _keySet$modifiers === undefined ? [] : _keySet$modifiers;
	
	  var keysMatch = void 0;
	
	  keysMatch = key === _keys.ALL_KEYS;
	
	  if (key === _keys.ALL_PRINTABLE_KEYS) {
	    if (event.key) {
	      // Modern browsers implement `key`, so if `key` is length 1, we have a match. e.g. 'a' for the
	      // a key, or '2' for the 2 key. All other non-printable characters have names, e.g. 'Enter' or 'Backspace'.
	      keysMatch = event.key.length === 1;
	    } else {
	      // For browsers that do no support `event.key`, we test against a list of characters
	      var pressedChar = String.fromCharCode(event.charCode);
	      keysMatch = PRINTABLE_CHARACTERS.indexOf(pressedChar) >= 0;
	    }
	  }
	
	  if (key === event.which) {
	    var evtModKeys = modKeys.filter(function (modKey) {
	      return event[modKey + 'Key'];
	    }).sort();
	    keysMatch = modifiers.length === evtModKeys.length && modifiers.every(function (modKey, index) {
	      return evtModKeys[index] === modKey;
	    });
	  }
	
	  return keysMatch;
	}
	
	exports.default = matchKeys;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(242);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parseKeys(keysArray) {
	  return keysArray.map(function (key) {
	    var keySet = { key: key };
	    if (typeof key === 'string') {
	      var keyString = key.toLowerCase().trim();
	      var matches = keyString.split(/\s?\+\s?/);
	      keySet = matches.length === 1 ? { key: _keys2.default[keyString] } : {
	        key: _keys2.default[matches.pop()],
	        modifiers: matches.map(function (modKey) {
	          return _keys.modifiers[modKey];
	        }).sort()
	      };
	    }
	    return keySet;
	  });
	}
	
	exports.default = parseKeys;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(355);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _ownerDocument = __webpack_require__(184);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _getContainer = __webpack_require__(352);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = _react2.default.createClass({
	
	  displayName: 'Portal',
	
	  propTypes: {
	    /**
	     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	     * appended to it.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._renderOverlay();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderOverlay();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  },
	  _mountOverlayTarget: function _mountOverlayTarget() {
	    if (!this._overlayTarget) {
	      this._overlayTarget = document.createElement('div');
	      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  _unmountOverlayTarget: function _unmountOverlayTarget() {
	    if (this._overlayTarget) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._overlayTarget = null;
	    }
	    this._portalContainerNode = null;
	  },
	  _renderOverlay: function _renderOverlay() {
	
	    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
	    // Save reference for future access.
	    if (overlay !== null) {
	      this._mountOverlayTarget();
	      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	    } else {
	      // Unrender if the component is null for transitions to null
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  },
	  _unrenderOverlay: function _unrenderOverlay() {
	    if (this._overlayTarget) {
	      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  },
	  render: function render() {
	    return null;
	  },
	  getMountNode: function getMountNode() {
	    return this._overlayTarget;
	  },
	  getOverlayDOMNode: function getOverlayDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._overlayInstance) {
	      return _reactDom2.default.findDOMNode(this._overlayInstance);
	    }
	
	    return null;
	  }
	});
	
	exports.default = Portal;
	module.exports = exports['default'];

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contains = __webpack_require__(353);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(670);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(184);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, (RootCloseWrapper.__proto__ || Object.getPrototypeOf(RootCloseWrapper)).call(this, props, context));
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  _createClass(RootCloseWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.disabled) {
	        this.addEventListeners();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.disabled && prevProps.disabled) {
	        this.addEventListeners();
	      } else if (this.props.disabled && !prevProps.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.disabled) {
	        this.removeEventListeners();
	      }
	    }
	  }, {
	    key: 'addEventListeners',
	    value: function addEventListeners() {
	      var event = this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, this.handleMouseCapture, true);
	
	      this.documentMouseListener = (0, _addEventListener2.default)(doc, event, this.handleMouse);
	
	      this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'removeEventListeners',
	    value: function removeEventListeners() {
	      if (this.documentMouseCaptureListener) {
	        this.documentMouseCaptureListener.remove();
	      }
	
	      if (this.documentMouseListener) {
	        this.documentMouseListener.remove();
	      }
	
	      if (this.documentKeyupListener) {
	        this.documentKeyupListener.remove();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _react2.default.PropTypes.func,
	  /**
	   * Children to render.
	   */
	  children: _react2.default.PropTypes.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _react2.default.PropTypes.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _react2.default.PropTypes.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(673);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(676);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  _createClass(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var status = this.state.status;
	
	
	      if (nextProps.in) {
	        if (status === UNMOUNTED) {
	          this.setState({ status: EXITED });
	        }
	        if (status !== ENTERING && status !== ENTERED) {
	          this.nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          this.nextStatus = EXITING;
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateStatus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelNextCallback();
	    }
	  }, {
	    key: 'updateStatus',
	    value: function updateStatus() {
	      var _this2 = this;
	
	      if (this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(this);
	
	        if (this.nextStatus === ENTERING) {
	          this.props.onEnter(node);
	
	          this.safeSetState({ status: ENTERING }, function () {
	            _this2.props.onEntering(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: ENTERED }, function () {
	                _this2.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          this.props.onExit(node);
	
	          this.safeSetState({ status: EXITING }, function () {
	            _this2.props.onExiting(node);
	
	            _this2.onTransitionEnd(node, function () {
	              _this2.safeSetState({ status: EXITED }, function () {
	                _this2.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        this.nextStatus = null;
	      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	        this.setState({ status: UNMOUNTED });
	      }
	    }
	  }, {
	    key: 'cancelNextCallback',
	    value: function cancelNextCallback() {
	      if (this.nextCallback !== null) {
	        this.nextCallback.cancel();
	        this.nextCallback = null;
	      }
	    }
	  }, {
	    key: 'safeSetState',
	    value: function safeSetState(nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      this.setState(nextState, this.setNextCallback(callback));
	    }
	  }, {
	    key: 'setNextCallback',
	    value: function setNextCallback(callback) {
	      var _this3 = this;
	
	      var active = true;
	
	      this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this3.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return this.nextCallback;
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd(node, handler) {
	      this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
	        setTimeout(this.nextCallback, this.props.timeout);
	      } else {
	        setTimeout(this.nextCallback, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.state.status;
	      if (status === UNMOUNTED) {
	        return null;
	      }
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      Object.keys(Transition.propTypes).forEach(function (key) {
	        return delete childProps[key];
	      });
	
	      var transitionClassName = void 0;
	      if (status === EXITED) {
	        transitionClassName = this.props.exitedClassName;
	      } else if (status === ENTERING) {
	        transitionClassName = this.props.enteringClassName;
	      } else if (status === ENTERED) {
	        transitionClassName = this.props.enteredClassName;
	      } else if (status === EXITING) {
	        transitionClassName = this.props.exitingClassName;
	      }
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, _extends({}, childProps, {
	        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	      }));
	    }
	  }]);
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _react2.default.PropTypes.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _react2.default.PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _react2.default.PropTypes.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2.default.PropTypes.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _react2.default.PropTypes.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _react2.default.PropTypes.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _react2.default.PropTypes.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _react2.default.PropTypes.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(673);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(1435);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(244);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(185);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(158);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var on = function on() {};
	if (_inDOM2.default) {
	  on = function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	exports.default = on;
	module.exports = exports['default'];

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = offset;
	
	var _contains = __webpack_require__(353);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _isWindow = __webpack_require__(244);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(185);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function offset(node) {
	  var doc = (0, _ownerDocument2.default)(node),
	      win = (0, _isWindow2.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = { top: 0, left: 0, height: 0, width: 0 };
	
	  if (!doc) return;
	
	  // Make sure it's not a disconnected DOM node
	  if (!(0, _contains2.default)(docElem, node)) return box;
	
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
	
	  // IE8 getBoundingClientRect doesn't support width & height
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	
	  return box;
	}
	module.exports = exports['default'];

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(244);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	module.exports = exports['default'];

/***/ }),
/* 676 */
[2026, 158],
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelizeStyleName;
	
	var _camelize = __webpack_require__(1442);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var msPattern = /^-ms-/; /**
	                          * Copyright 2014-2015, Facebook, Inc.
	                          * All rights reserved.
	                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	                          */
	function camelizeStyleName(string) {
	  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
	}
	module.exports = exports['default'];

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),
/* 679 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	// This is largely taken from react-router/lib/Link.
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(19);
	
	var LinkContainer = (function (_React$Component) {
	  _inherits(LinkContainer, _React$Component);
	
	  function LinkContainer(props, context) {
	    _classCallCheck(this, LinkContainer);
	
	    _get(Object.getPrototypeOf(LinkContainer.prototype), 'constructor', this).call(this, props, context);
	
	    this.onClick = this.onClick.bind(this);
	  }
	
	  _createClass(LinkContainer, [{
	    key: 'onClick',
	    value: function onClick(event) {
	      if (this.props.disabled) {
	        event.preventDefault();
	        return;
	      }
	
	      if (this.props.children.props.onClick) {
	        this.props.children.props.onClick(event);
	      }
	
	      _reactRouter.Link.prototype.handleClick.call(this, event);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var router = this.context.router;
	      var _props = this.props;
	      var onlyActiveOnIndex = _props.onlyActiveOnIndex;
	      var to = _props.to;
	      var children = _props.children;
	
	      var props = _objectWithoutProperties(_props, ['onlyActiveOnIndex', 'to', 'children']);
	
	      props.onClick = this.onClick;
	
	      // Ignore if rendered outside Router context; simplifies unit testing.
	      if (router) {
	        props.href = router.createHref(to);
	
	        if (props.active == null) {
	          props.active = router.isActive(to, onlyActiveOnIndex);
	        }
	      }
	
	      return _react2['default'].cloneElement(_react2['default'].Children.only(children), props);
	    }
	  }]);
	
	  return LinkContainer;
	})(_react2['default'].Component);
	
	exports['default'] = LinkContainer;
	
	LinkContainer.propTypes = {
	  onlyActiveOnIndex: _react2['default'].PropTypes.bool.isRequired,
	  to: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.object]).isRequired,
	  onClick: _react2['default'].PropTypes.func,
	  active: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool.isRequired,
	  children: _react2['default'].PropTypes.node.isRequired
	};
	
	LinkContainer.contextTypes = {
	  router: _react2['default'].PropTypes.object
	};
	
	LinkContainer.defaultProps = {
	  onlyActiveOnIndex: false,
	  disabled: false
	};
	module.exports = exports['default'];

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _IndexLinkContainer2 = __webpack_require__(1451);
	
	var _IndexLinkContainer3 = _interopRequireDefault(_IndexLinkContainer2);
	
	exports.IndexLinkContainer = _IndexLinkContainer3['default'];
	
	var _LinkContainer2 = __webpack_require__(680);
	
	var _LinkContainer3 = _interopRequireDefault(_LinkContainer2);
	
	exports.LinkContainer = _LinkContainer3['default'];

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 683 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (object.hasOwnProperty(p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2['default'].createClass({
	  displayName: 'Link',
	
	  contextTypes: {
	    router: object
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]).isRequired,
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      className: '',
	      style: {}
	    };
	  },
	
	  handleClick: function handleClick(event) {
	    var allowTransition = true;
	
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    if (event.defaultPrevented === true) allowTransition = false;
	
	    // If target prop is set (e.g. to "_blank") let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) {
	      if (!allowTransition) event.preventDefault();
	
	      return;
	    }
	
	    event.preventDefault();
	
	    if (allowTransition) {
	      var _props = this.props;
	      var to = _props.to;
	      var query = _props.query;
	      var hash = _props.hash;
	      var state = _props.state;
	
	      var _location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	      this.context.router.push(_location);
	    }
	  },
	
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? _routerWarning2['default'](!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : undefined;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	    if (router) {
	      var _location2 = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(_location2);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(_location2, onlyActiveOnIndex)) {
	          if (activeClassName) props.className += props.className === '' ? activeClassName : ' ' + activeClassName;
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2['default'].createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	
	});
	
	exports['default'] = Link;
	module.exports = exports['default'];

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(110);
	
	var _PatternUtils = __webpack_require__(159);
	
	var _PropTypes = __webpack_require__(137);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	var Redirect = _react2['default'].createClass({
	  displayName: 'Redirect',
	
	  statics: {
	
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = _RouteUtils.createRouteFromReactElement(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	        var pathname = undefined;
	        if (route.to.charAt(0) === '/') {
	          pathname = _PatternUtils.formatPattern(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = _PatternUtils.formatPattern(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _PropTypes.falsy,
	    children: _PropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? _invariant2['default'](false, '<Redirect> elements are for router configuration only and should not be rendered') : _invariant2['default'](false) : undefined;
	  }
	
	});
	
	exports['default'] = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecateObjectProperties = __webpack_require__(689);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = _deprecateObjectProperties2['default'](history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createMemoryHistory;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _historyLibUseQueries = __webpack_require__(219);
	
	var _historyLibUseQueries2 = _interopRequireDefault(_historyLibUseQueries);
	
	var _historyLibUseBasename = __webpack_require__(461);
	
	var _historyLibUseBasename2 = _interopRequireDefault(_historyLibUseBasename);
	
	var _historyLibCreateMemoryHistory = __webpack_require__(1132);
	
	var _historyLibCreateMemoryHistory2 = _interopRequireDefault(_historyLibCreateMemoryHistory);
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = _historyLibCreateMemoryHistory2['default'](options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = _historyLibUseQueries2['default'](_historyLibUseBasename2['default'](createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _useRouterHistory = __webpack_require__(690);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports['default'] = function (createHistory) {
	  var history = undefined;
	  if (canUseDOM) history = _useRouterHistory2['default'](createHistory)();
	  return history;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint no-empty: 0*/
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = deprecateObjectProperties;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var useMembrane = false;
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', { get: function get() {
	        return true;
	      } }).x) {
	      useMembrane = true;
	    }
	  } catch (e) {}
	}
	
	// wraps an object in a membrane to warn about deprecated property access
	
	function deprecateObjectProperties(object, message) {
	  if (!useMembrane) return object;
	
	  var membrane = {};
	
	  var _loop = function (prop) {
	    if (typeof object[prop] === 'function') {
	      membrane[prop] = function () {
	         false ? _routerWarning2['default'](false, message) : undefined;
	        return object[prop].apply(object, arguments);
	      };
	    } else {
	      Object.defineProperty(membrane, prop, {
	        configurable: false,
	        enumerable: false,
	        get: function get() {
	           false ? _routerWarning2['default'](false, message) : undefined;
	          return object[prop];
	        }
	      });
	    }
	  };
	
	  for (var prop in object) {
	    _loop(prop);
	  }
	
	  return membrane;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = useRouterHistory;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _historyLibUseQueries = __webpack_require__(219);
	
	var _historyLibUseQueries2 = _interopRequireDefault(_historyLibUseQueries);
	
	var _historyLibUseBasename = __webpack_require__(461);
	
	var _historyLibUseBasename2 = _interopRequireDefault(_historyLibUseBasename);
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = _historyLibUseQueries2['default'](_historyLibUseBasename2['default'](createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(28), __webpack_require__(27), __webpack_require__(359), __webpack_require__(358), __webpack_require__(1474)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('react-dom'), require('prop-types'), require('./s-alert-parts/s-alert-tools'), require('./s-alert-parts/s-alert-store'), require('./SAlertContentTmpl'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.reactDom, global.propTypes, global.sAlertTools, global.sAlertStore, global.SAlertContentTmpl);
	        global.SAlertContent = mod.exports;
	    }
	})(this, function (exports, _react, _reactDom, _propTypes, _sAlertTools, _sAlertStore, _SAlertContentTmpl) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _reactDom2 = _interopRequireDefault(_reactDom);
	
	    var _propTypes2 = _interopRequireDefault(_propTypes);
	
	    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);
	
	    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);
	
	    var _SAlertContentTmpl2 = _interopRequireDefault(_SAlertContentTmpl);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var SAlertContent = function (_React$Component) {
	        _inherits(SAlertContent, _React$Component);
	
	        function SAlertContent(props) {
	            _classCallCheck(this, SAlertContent);
	
	            return _possibleConstructorReturn(this, (SAlertContent.__proto__ || Object.getPrototypeOf(SAlertContent)).call(this, props));
	        }
	
	        _createClass(SAlertContent, [{
	            key: 'handleCloseAlert',
	            value: function handleCloseAlert() {
	                var closingTimeout = void 0;
	                var alertId = this.props.id;
	                var currentAlertElem = _reactDom2.default.findDOMNode(this);
	                var animationClose = function animationClose() {
	                    currentAlertElem.style.display = 'none';
	                    _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: alertId } });
	                    clearTimeout(closingTimeout);
	                };
	                if (document.hidden || document.webkitHidden || !currentAlertElem.classList.contains('s-alert-is-effect')) {
	                    _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: alertId } });
	                } else {
	                    currentAlertElem.classList.remove('s-alert-show');
	                    closingTimeout = setTimeout(function () {
	                        currentAlertElem.classList.add('s-alert-hide');
	                    }, 100);
	                    currentAlertElem.removeEventListener('webkitAnimationEnd', animationClose, false);
	                    currentAlertElem.removeEventListener('animationend', animationClose, false);
	                    currentAlertElem.addEventListener('webkitAnimationEnd', animationClose, false);
	                    currentAlertElem.addEventListener('animationend', animationClose, false);
	                }
	                // stop audio when closing
	                this.alertAudio && this.alertAudio.load();
	            }
	        }, {
	            key: 'componentWillMount',
	            value: function componentWillMount() {
	                var beep = this.props.beep;
	                var condition = this.props.condition;
	                if (beep && typeof beep === 'string') {
	                    this.alertAudio = new Audio(beep);
	                    this.alertAudio.load();
	                    this.alertAudio.play();
	                }
	                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'info') {
	                    this.alertAudio = new Audio(beep.info);
	                    this.alertAudio.load();
	                    this.alertAudio.play();
	                }
	                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'error') {
	                    this.alertAudio = new Audio(beep.error);
	                    this.alertAudio.load();
	                    this.alertAudio.play();
	                }
	                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'success') {
	                    this.alertAudio = new Audio(beep.success);
	                    this.alertAudio.load();
	                    this.alertAudio.play();
	                }
	                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'warning') {
	                    this.alertAudio = new Audio(beep.warning);
	                    this.alertAudio.load();
	                    this.alertAudio.play();
	                }
	            }
	        }, {
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                var _this2 = this;
	
	                if (typeof this.props.timeout === 'number') {
	                    this.closeTimer = setTimeout(function () {
	                        _this2.handleCloseAlert();
	                    }, this.props.timeout);
	                }
	                if (this.props.onShow) {
	                    this.props.onShow();
	                }
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                if (this.closeTimer) {
	                    clearTimeout(this.closeTimer);
	                }
	                if (this.props.onClose) {
	                    this.props.onClose();
	                }
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var classNames = 's-alert-box s-alert-' + this.props.condition + ' s-alert-' + this.props.position + ' ' + (this.props.effect ? 's-alert-is-effect s-alert-effect-' + this.props.effect : '') + ' s-alert-show';
	                var message = this.props.html ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.props.message } }) : this.props.message;
	                var styles = this.props.boxPosition ? _sAlertTools2.default.styleToObj(this.props.boxPosition) : {};
	                var id = this.props.id;
	                var handleClose = this.handleCloseAlert.bind(this);
	                var contentTemplate = this.props.contentTemplate || _SAlertContentTmpl2.default;
	                var customFields = this.props.customFields || {};
	
	                return _react2.default.createElement(contentTemplate, { classNames: classNames, id: id, styles: styles, message: message, handleClose: handleClose, customFields: customFields });
	            }
	        }]);
	
	        return SAlertContent;
	    }(_react2.default.Component);
	
	    SAlertContent.propTypes = {
	        condition: _propTypes2.default.string.isRequired,
	        message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	        position: _propTypes2.default.string.isRequired,
	        boxPosition: _propTypes2.default.string,
	        id: _propTypes2.default.string.isRequired,
	        effect: _propTypes2.default.string,
	        beep: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]),
	        timeout: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none']), _propTypes2.default.number]),
	        html: _propTypes2.default.bool,
	        onClose: _propTypes2.default.func,
	        onShow: _propTypes2.default.func,
	        customFields: _propTypes2.default.object,
	        contentTemplate: _propTypes2.default.func
	    };
	
	    exports.default = SAlertContent;
	});

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(249);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(698);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(360);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(361);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(249);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						filteredOptions.unshift(this._createPlaceholderOption);
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func
	};
	
	exports.default = CreatableSelect;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(1478);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(1484);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(1483);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(701);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 700 */
158,
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(1498);
	var ReactMultiChildUpdateTypes = __webpack_require__(721);
	var ReactPerf = __webpack_require__(81);
	
	var setInnerHTML = __webpack_require__(257);
	var setTextContent = __webpack_require__(377);
	var invariant = __webpack_require__(21);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	
	  // fix render order error in safari
	  // IE8 will throw error when index out of list size.
	  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);
	
	  parentNode.insertBefore(childNode, beforeChild);
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function (updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        !updatedChild ?  false ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup;
	    // markupList is either a list of markup or just a list of elements
	    if (markupList.length && typeof markupList[0] === 'string') {
	      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	    } else {
	      renderedMarkup = markupList;
	    }
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
	  updateTextContent: 'updateTextContent'
	});
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(111);
	var ReactElement = __webpack_require__(65);
	
	var emptyFunction = __webpack_require__(92);
	var traverseAllChildren = __webpack_require__(379);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(707);
	var ReactElement = __webpack_require__(65);
	var ReactPropTypeLocations = __webpack_require__(252);
	var ReactPropTypeLocationNames = __webpack_require__(251);
	var ReactNoopUpdateQueue = __webpack_require__(723);
	
	var assign = __webpack_require__(29);
	var emptyObject = __webpack_require__(190);
	var invariant = __webpack_require__(21);
	var keyMirror = __webpack_require__(258);
	var keyOf = __webpack_require__(112);
	var warning = __webpack_require__(30);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	var warnedSetProps = false;
	function warnSetProps() {
	  if (!warnedSetProps) {
	    warnedSetProps = true;
	     false ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
	  }
	}
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = (name in RESERVED_SPEC_KEYS);
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;
	
	    var isInherited = (name in Constructor);
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function (partialProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueSetProps(this, partialProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function (newProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function () {};
	assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(723);
	
	var canDefineProperty = __webpack_require__(255);
	var emptyObject = __webpack_require__(190);
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
	    setProps: ['setProps', 'Instead, call render again at the top level.']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(100);
	var ReactDOMTextComponent = __webpack_require__(712);
	var ReactDefaultInjection = __webpack_require__(714);
	var ReactInstanceHandles = __webpack_require__(161);
	var ReactMount = __webpack_require__(57);
	var ReactPerf = __webpack_require__(81);
	var ReactReconciler = __webpack_require__(138);
	var ReactUpdates = __webpack_require__(82);
	var ReactVersion = __webpack_require__(369);
	
	var findDOMNode = __webpack_require__(370);
	var renderSubtreeIntoContainer = __webpack_require__(1546);
	var warning = __webpack_require__(30);
	
	ReactDefaultInjection.inject();
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,
	
	    // shams
	    Object.create, Object.freeze];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ }),
/* 709 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(364);
	var ReactMount = __webpack_require__(57);
	var ReactUpdates = __webpack_require__(82);
	
	var assign = __webpack_require__(29);
	var warning = __webpack_require__(30);
	
	var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactMount.getNode(inst._rootNodeID).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  valueContextKey: valueContextKey,
	
	  getNativeProps: function (inst, props, context) {
	    return assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	  },
	
	  processChildContext: function (inst, props, context) {
	    // Pass down initial value so initial generated markup has correct
	    // `selected` attributes
	    var childContext = assign({}, context);
	    childContext[valueContextKey] = inst._wrapperState.initialValue;
	    return childContext;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // the context value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  this._wrapperState.pendingUpdate = true;
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMServer
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(714);
	var ReactServerRendering = __webpack_require__(1524);
	var ReactVersion = __webpack_require__(369);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(703);
	var DOMPropertyOperations = __webpack_require__(363);
	var ReactComponentBrowserEnvironment = __webpack_require__(365);
	var ReactMount = __webpack_require__(57);
	
	var assign = __webpack_require__(29);
	var escapeTextContentForBrowser = __webpack_require__(256);
	var setTextContent = __webpack_require__(377);
	var validateDOMNesting = __webpack_require__(380);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function (text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    this._rootNodeID = rootID;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement('span');
	      DOMPropertyOperations.setAttributeForID(el, rootID);
	      // Populate node cache
	      ReactMount.getID(el);
	      setTextContent(el, this._stringText);
	      return el;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this in a `span` for the reasons stated above, but
	        // since this is a situation where React won't take over (static pages),
	        // we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var node = ReactMount.getNode(this._rootNodeID);
	        DOMChildrenOperations.updateTextContent(node, nextStringText);
	      }
	    }
	  },
	
	  unmountComponent: function () {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(82);
	var Transaction = __webpack_require__(254);
	
	var assign = __webpack_require__(29);
	var emptyFunction = __webpack_require__(92);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(1494);
	var ChangeEventPlugin = __webpack_require__(1496);
	var ClientReactRootIndex = __webpack_require__(1497);
	var DefaultEventPluginOrder = __webpack_require__(1499);
	var EnterLeaveEventPlugin = __webpack_require__(1500);
	var ExecutionEnvironment = __webpack_require__(52);
	var HTMLDOMPropertyConfig = __webpack_require__(1503);
	var ReactBrowserComponentMixin = __webpack_require__(1505);
	var ReactComponentBrowserEnvironment = __webpack_require__(365);
	var ReactDefaultBatchingStrategy = __webpack_require__(713);
	var ReactDOMComponent = __webpack_require__(1509);
	var ReactDOMTextComponent = __webpack_require__(712);
	var ReactEventListener = __webpack_require__(1516);
	var ReactInjection = __webpack_require__(1517);
	var ReactInstanceHandles = __webpack_require__(161);
	var ReactMount = __webpack_require__(57);
	var ReactReconcileTransaction = __webpack_require__(1521);
	var SelectEventPlugin = __webpack_require__(1527);
	var ServerReactRootIndex = __webpack_require__(1528);
	var SimpleEventPlugin = __webpack_require__(1529);
	var SVGDOMPropertyConfig = __webpack_require__(1526);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	
	  if (false) {
	    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	    if (/[?&]react_perf\b/.test(url)) {
	      var ReactDefaultPerf = require('./ReactDefaultPerf');
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(65);
	var ReactPropTypeLocations = __webpack_require__(252);
	var ReactPropTypeLocationNames = __webpack_require__(251);
	var ReactCurrentOwner = __webpack_require__(100);
	
	var canDefineProperty = __webpack_require__(255);
	var getIteratorFn = __webpack_require__(374);
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	        error = propTypes[propName](props, propName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(65);
	var ReactEmptyComponentRegistry = __webpack_require__(717);
	var ReactReconciler = __webpack_require__(138);
	
	var assign = __webpack_require__(29);
	
	var placeholderElement;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function (component) {
	    placeholderElement = ReactElement.createElement(component);
	  }
	};
	
	function registerNullComponentID() {
	  ReactEmptyComponentRegistry.registerNullComponentID(this._rootNodeID);
	}
	
	var ReactEmptyComponent = function (instantiate) {
	  this._currentElement = null;
	  this._rootNodeID = null;
	  this._renderedComponent = instantiate(placeholderElement);
	};
	assign(ReactEmptyComponent.prototype, {
	  construct: function (element) {},
	  mountComponent: function (rootID, transaction, context) {
	    transaction.getReactMountReady().enqueue(registerNullComponentID, this);
	    this._rootNodeID = rootID;
	    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
	  },
	  receiveComponent: function () {},
	  unmountComponent: function (rootID, transaction, context) {
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
	    this._rootNodeID = null;
	    this._renderedComponent = null;
	  }
	});
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponentRegistry
	 */
	
	'use strict';
	
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponentRegistry = {
	  isNullComponentID: isNullComponentID,
	  registerNullComponentID: registerNullComponentID,
	  deregisterNullComponentID: deregisterNullComponentID
	};
	
	module.exports = ReactEmptyComponentRegistry;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1513);
	
	var containsNode = __webpack_require__(732);
	var focusNode = __webpack_require__(733);
	var getActiveElement = __webpack_require__(734);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1538);
	
	var TAG_END = /\/?>/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags and self-closing tags)
	    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(258);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(29);
	var invariant = __webpack_require__(21);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(30);
	
	function warnTDZ(publicInstance, callerName) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    warnTDZ(publicInstance, 'setProps');
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    warnTDZ(publicInstance, 'replaceProps');
	  }
	
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(65);
	var ReactPropTypeLocationNames = __webpack_require__(251);
	
	var emptyFunction = __webpack_require__(92);
	var getIteratorFn = __webpack_require__(374);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED') == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return '<<anonymous>>';
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function (_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.exports = ReactRootIndex;

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(21);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(52);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 730 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(92);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function () {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function () {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isTextNode = __webpack_require__(1555);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var outerNode = _x,
	        innerNode = _x2;
	    _again = false;
	
	    if (!outerNode || !innerNode) {
	      return false;
	    } else if (outerNode === innerNode) {
	      return true;
	    } else if (isTextNode(outerNode)) {
	      return false;
	    } else if (isTextNode(innerNode)) {
	      _x = outerNode;
	      _x2 = innerNode.parentNode;
	      _again = true;
	      continue _function;
	    } else if (outerNode.contains) {
	      return outerNode.contains(innerNode);
	    } else if (outerNode.compareDocumentPosition) {
	      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	    } else {
	      return false;
	    }
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 733 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 734 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	'use strict';
	
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(52);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : undefined;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.END_GLOBAL_LOAD = exports.BEGIN_GLOBAL_LOAD = exports.CLEAR = exports.LOAD_FAIL = exports.LOAD_SUCCESS = exports.LOAD = undefined;
	exports.reducer = reducer;
	exports.clearKey = clearKey;
	exports.beginGlobalLoad = beginGlobalLoad;
	exports.endGlobalLoad = endGlobalLoad;
	exports.loadSuccess = loadSuccess;
	exports.asyncConnect = asyncConnect;
	
	var _reactRedux = __webpack_require__(12);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var LOAD = exports.LOAD = 'reduxAsyncConnect/LOAD';
	var LOAD_SUCCESS = exports.LOAD_SUCCESS = 'reduxAsyncConnect/LOAD_SUCCESS';
	var LOAD_FAIL = exports.LOAD_FAIL = 'reduxAsyncConnect/LOAD_FAIL';
	var CLEAR = exports.CLEAR = 'reduxAsyncConnect/CLEAR';
	var BEGIN_GLOBAL_LOAD = exports.BEGIN_GLOBAL_LOAD = 'reduxAsyncConnect/BEGIN_GLOBAL_LOAD';
	var END_GLOBAL_LOAD = exports.END_GLOBAL_LOAD = 'reduxAsyncConnect/END_GLOBAL_LOAD';
	
	function reducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? { loaded: false } : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  switch (action.type) {
	    case BEGIN_GLOBAL_LOAD:
	      return _extends({}, state, {
	        loaded: false
	      });
	    case END_GLOBAL_LOAD:
	      return _extends({}, state, {
	        loaded: true
	      });
	    case LOAD:
	      return _extends({}, state, {
	        loadState: _defineProperty({}, action.key, {
	          loading: true,
	          loaded: false
	        })
	      });
	    case LOAD_SUCCESS:
	      return _extends({}, state, _defineProperty({
	        loadState: _defineProperty({}, action.key, {
	          loading: false,
	          loaded: true,
	          error: null
	        })
	      }, action.key, action.data));
	    case LOAD_FAIL:
	      return _extends({}, state, _defineProperty({
	        loadState: _defineProperty({}, action.key, {
	          loading: false,
	          loaded: false,
	          error: action.error
	        })
	      }, action.key, null));
	    case CLEAR:
	      return _extends({}, state, _defineProperty({
	        loadState: _defineProperty({}, action.key, {
	          loading: false,
	          loaded: false,
	          error: null
	        })
	      }, action.key, null));
	    default:
	      return state;
	  }
	}
	
	function clearKey(key) {
	  return {
	    type: CLEAR,
	    key: key
	  };
	}
	
	function beginGlobalLoad() {
	  return { type: BEGIN_GLOBAL_LOAD };
	}
	
	function endGlobalLoad() {
	  return { type: END_GLOBAL_LOAD };
	}
	
	function load(key) {
	  return {
	    type: LOAD,
	    key: key
	  };
	}
	
	function loadSuccess(key, data) {
	  return {
	    type: LOAD_SUCCESS,
	    key: key,
	    data: data
	  };
	}
	
	function loadFail(key, error) {
	  return {
	    type: LOAD_FAIL,
	    key: key,
	    error: error
	  };
	}
	
	function wrapWithDispatch(asyncItems) {
	  return asyncItems.map(function (item) {
	    return item.key ? _extends({}, item, { promise: function promise(options) {
	        var dispatch = options.store.dispatch;
	
	        var promiseOrResult = item.promise(options);
	        if (promiseOrResult !== undefined) {
	          if (promiseOrResult.then instanceof Function) {
	            dispatch(load(item.key));
	            promiseOrResult.then(function (data) {
	              return dispatch(loadSuccess(item.key, data));
	            }).catch(function (err) {
	              return dispatch(loadFail(item.key, err));
	            });
	          } else {
	            dispatch(loadSuccess(item.key, promiseOrResult));
	          }
	        }
	        return promiseOrResult;
	      } }) : item;
	  });
	}
	
	function asyncConnect(asyncItems) {
	  return function (Component) {
	    Component.reduxAsyncConnect = wrapWithDispatch(asyncItems);
	
	    var finalMapStateToProps = function finalMapStateToProps(state) {
	      return asyncItems.reduce(function (result, item) {
	        return item.key ? _extends({}, result, _defineProperty({}, item.key, state.reduxAsyncConnect[item.key])) : result;
	      }, {});
	    };
	
	    return (0, _reactRedux.connect)(finalMapStateToProps)(Component);
	  };
	}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(325);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1924);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _promise = __webpack_require__(58);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _superagent = __webpack_require__(1920);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _config = __webpack_require__(193);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _errors = __webpack_require__(744);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = __webpack_require__(309)('ApiClient');
	log.useColors = true;
	
	var log2 = __webpack_require__(309)('ApiClient:data');
	log2.useColors = true;
	
	var methods = ['get', 'post', 'put', 'patch', 'del'];
	
	// todo: переделать данный функция
	function formatUrl(path) {
	    var pathToServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    var adjustedPath = path[0] !== '/' ? '/' + path : path;
	    if (pathToServer) {
	        return pathToServer + adjustedPath;
	    } else if (false) {
	        // Prepend host and port of the API server to the path.
	        return _config2.default.apiHost + adjustedPath;
	    }
	    // Prepend `/api` to relative URL, to proxy to API server.
	    return '/api' + adjustedPath;
	}
	
	var ApiClient = function () {
	    function ApiClient(req) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, ApiClient);
	
	        this.req = req;
	        methods.forEach(function (method) {
	            return _this[method] = function (path) {
	                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                    params = _ref.params,
	                    data = _ref.data;
	
	                var pathToServer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	                return new _promise2.default(function (resolve, reject) {
	
	                    var uuid = __webpack_require__(1930).v4();
	                    //region debug
	                    log('[' + uuid + ' url] ==> ', formatUrl(path, pathToServer));
	                    log('[' + uuid + ' method] ==> ', method);
	                    if (data) {
	                        log('[' + uuid + ' data] ==> ', data);
	                    }
	                    if (params) {
	                        log('[' + uuid + ' params] ==> ', params);
	                    }
	                    log('------------------------');
	                    //endregion
	
	                    var request = _superagent2.default[method](formatUrl(path, pathToServer));
	
	                    if (params) {
	                        request.query(params);
	                    }
	
	                    if (false) {
	                        request.set('cookie', req.get('cookie'));
	                    }
	
	                    var start = new Date();
	
	                    if (data) {
	                        request.send(data);
	                    }
	
	                    request.end(function (err) {
	                        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                            body = _ref2.body;
	
	                        // костыль (ответ - большая портанка)
	                        if (!/(get-lang-data)/g.test(path)) {
	                            var end = new Date();
	                            log2('[' + uuid + ' request end time] ==> ' + (end - start) + 'ms');
	                            log2('[' + uuid + ' request end method] ==> ', method);
	                            log2('[' + uuid + ' request end url] ==> ', formatUrl(path, pathToServer));
	                            log2('[' + uuid + ' request end err] ==> ', err);
	                            log2('[' + uuid + ' request end body] ==> ', body);
	                            log2('------------------------');
	                        }
	
	                        if (err) {
	                            _this.processError(err);
	                            return reject(body || err);
	                        }
	
	                        return resolve(body);
	                    });
	                });
	            };
	        });
	    }
	
	    (0, _createClass3.default)(ApiClient, [{
	        key: 'processError',
	        value: function processError(err) {
	            // Если во время запроса произошло резкое обрывание.
	            // Например, в фаерфоксе страница делает запрос, мы
	            // нажимаем F5 и не даем ему завершится - фаерфокс в
	            // таком случае просто обрубить его и выпадет ошибка
	            if (err.code == null && err.status == null && err.response == null && err instanceof Error) {
	                err.code = _errors.ERROR_CODE_CONNECTION_CLOSE_UBNORMAL;
	                err.status = _errors.ERROR_STATUS_FOR_INTERNAL_CASE;
	            }
	        }
	    }, {
	        key: 'getRaw',
	        value: function getRaw(path) {
	            var pathToServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            return new _promise2.default(function (resolve, reject) {
	
	                //region debug
	                log('[url] ==> ', formatUrl(path, pathToServer));
	                log('------------------------');
	                //endregion
	
	                var request = _superagent2.default.get(formatUrl(path, pathToServer));
	
	                request.end(function (err) {
	                    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	                        text = _ref3.text;
	
	                    // log2('[err] ==> ', err);
	                    // log2('[text] ==> ', text);
	                    if (err) {
	                        return reject(err);
	                    }
	
	                    return resolve(text);
	                });
	            });
	        }
	    }, {
	        key: 'empty',
	
	
	        /*
	         * There's a V8 bug where, when using Babel, exporting classes with only
	         * constructors sometimes fails. Until it's patched, this is a solution to
	         * "ApiClient is not defined" from issue #14.
	         * https://github.com/erikras/react-redux-universal-hot-example/issues/14
	         *
	         * Relevant Babel bug (but they claim it's V8): https://phabricator.babeljs.io/T2455
	         *
	         * Remove it at your own risk.
	         */
	        value: function empty() {}
	    }]);
	    return ApiClient;
	}();
	
	exports.default = ApiClient;
	module.exports = exports['default'];

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _IBonus2 = __webpack_require__(1590);
	
	var _IBonus3 = _interopRequireDefault(_IBonus2);
	
	var _Factory = __webpack_require__(259);
	
	var _Factory2 = _interopRequireDefault(_Factory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IBonusProxy = function (_IBonus) {
	    (0, _inherits3.default)(IBonusProxy, _IBonus);
	
	    function IBonusProxy(client, storage) {
	        (0, _classCallCheck3.default)(this, IBonusProxy);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (IBonusProxy.__proto__ || (0, _getPrototypeOf2.default)(IBonusProxy)).call(this, client, storage));
	
	        _this.client = client;
	        return _this;
	    }
	
	    (0, _createClass3.default)(IBonusProxy, [{
	        key: '_send',
	        value: function _send(command) {
	            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	            var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/command';
	
	            return this.client.post(path, {
	                data: {
	                    command: command, params: params, channelId: this.channelId, profileId: this.profileId, onlineShopId: this.onlineShopId
	                }
	            });
	        }
	    }, {
	        key: 'userAuthentication',
	        value: function userAuthentication(username, password) {
	            var captcha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	            var shopId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	            return this._send('userAuthentication', [username, password, captcha, shopId], '/user');
	        }
	    }, {
	        key: 'userRegistration',
	        value: function userRegistration(password, shopId, params) {
	            return this._send('userRegistration', [password, shopId, params], '/user');
	        }
	    }, {
	        key: 'userConfirmRegistration',
	        value: function userConfirmRegistration(_password, _shopId, _params) {
	            var _ModelFactory$create$ = _Factory2.default.create('ConfirmRegistrationRequest', (0, _extends3.default)({
	                shopId: _shopId,
	                password: _password
	            }, _params)).clearNullUndefinedProps(),
	                shopId = _ModelFactory$create$.shopId,
	                password = _ModelFactory$create$.password,
	                params = (0, _objectWithoutProperties3.default)(_ModelFactory$create$, ['shopId', 'password']);
	
	            return this._send('userConfirmRegistration', [password, shopId, params], '/user');
	        }
	    }, {
	        key: 'userRegistrationOneClick',
	        value: function userRegistrationOneClick(shopId, params) {
	            return this._send('userRegistrationOneClick', [shopId, params], '/user');
	        }
	    }, {
	        key: 'userConfirmRegistrationOneClick',
	        value: function userConfirmRegistrationOneClick(shopId, params) {
	            return this._send('userConfirmRegistrationOneClick', [shopId, params], '/user');
	        }
	    }, {
	        key: 'passRecoverySend',
	        value: function passRecoverySend(phone, id_shop) {
	            return this._send('passRecoverySend', [phone, id_shop], '/command');
	        }
	    }, {
	        key: 'sendVoiceCode',
	        value: function sendVoiceCode(login, source, phone) {
	            return this._send('sendVoiceCode', [login, source, phone], '/command');
	        }
	    }, {
	        key: 'userRestorePassword',
	        value: function userRestorePassword(login, newPassword, code) {
	            return this._send('userRestorePassword', [login, newPassword, code], '/user');
	        }
	    }, {
	        key: 'getUserData',
	        value: function getUserData(access_token) {
	            return this._send('getUserData', [access_token], '/user');
	        }
	    }, {
	        key: 'getWishList',
	        value: function getWishList(wish_list) {
	            var access_token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            return this._send('getWishList', [wish_list, access_token], '/user');
	        }
	    }, {
	        key: 'setWishList',
	        value: function setWishList(wish_list) {
	            return this._send('setWishList', [wish_list], '/user');
	        }
	    }, {
	        key: 'userLogout',
	        value: function userLogout() {
	            return this._send('userLogout', [], '/user');
	        }
	
	        /**
	         * @returns {Promise}
	         */
	
	    }, {
	        key: 'getCatalog',
	        value: function getCatalog() {
	            return this._send('getCatalog');
	        }
	        /**
	             * @returns {Promise}
	             */
	
	    }, {
	        key: 'getPayment',
	        value: function getPayment() {
	            return this._send('getPayment');
	        }
	    }, {
	        key: 'getPaymentsParamsFromPIPObyId',
	        value: function getPaymentsParamsFromPIPObyId(shopPipoId) {
	            return this._send('getPaymentsParamsFromPIPObyId', [shopPipoId]);
	        }
	
	        /**
	         * @returns {Promise}
	         */
	
	    }, {
	        key: 'getCategories',
	        value: function getCategories() {
	            return this._send('getCategories');
	        }
	    }, {
	        key: 'getProductByCategory',
	        value: function getProductByCategory(category_id) {
	            var page_number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	            var page_size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
	
	            return this._send('getProductByCategory', [category_id, page_number, page_size]);
	        }
	    }, {
	        key: 'getByCategory',
	        value: function getByCategory(category_id) {
	            var page_number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	            var page_size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
	
	            return this._send('getByCategory', [category_id, page_number, page_size]);
	        }
	    }, {
	        key: 'getCategoryRecommended',
	        value: function getCategoryRecommended(id) {
	            return this._send('getCategoryRecommended', [id]);
	        }
	    }, {
	        key: 'getProductById',
	        value: function getProductById(id) {
	            return this._send('getProductById', [id]);
	        }
	    }, {
	        key: 'getProducts',
	        value: function getProducts() {
	            var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	            var page_number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	            var page_size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
	            var categories = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	            var begin_time_create = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	            var end_time_create = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	            var begin_time_update = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
	            var end_time_update = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
	
	            return this._send('getProducts', [name, page_number, page_size, categories, begin_time_create, end_time_create, begin_time_update, end_time_update]);
	        }
	    }, {
	        key: 'orderCreate',
	        value: function orderCreate(sum) {
	            var products = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	            var user_agent = arguments[2];
	            var utm_redirect_data = arguments[3];
	            var currency_id = arguments[4];
	            var delivery_address = arguments[5];
	            var custom_fields = arguments[6];
	
	            return this._send('orderCreate', [sum, products, user_agent, utm_redirect_data, currency_id, delivery_address, custom_fields], '/user');
	        }
	    }, {
	        key: 'editOrder',
	        value: function editOrder(order_id, sum) {
	            var products = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	            var user_agent = arguments[3];
	            var utm_redirect_data = arguments[4];
	            var currency_id = arguments[5];
	
	            return this._send('editOrder', [order_id, sum, products, user_agent, utm_redirect_data, currency_id], '/user');
	        }
	    }, {
	        key: 'cancelOrder',
	        value: function cancelOrder(order_id) {
	            return this._send('cancelOrder', [order_id], '/user');
	        }
	
	        /**
	         * Создание нового счёта для заказа
	         */
	
	    }, {
	        key: 'paymentCreate',
	        value: function paymentCreate(order_id) {
	            return this._send('paymentCreate', [order_id], '/user');
	        }
	    }, {
	        key: 'getOrders',
	        value: function getOrders(page_number, page_size) {
	            return this._send('getOrders', [page_number, page_size], '/user');
	        }
	    }, {
	        key: 'getOrderById',
	        value: function getOrderById(id) {
	            return this._send('getOrderById', [id], '/user');
	        }
	
	        /**
	         *Метод для редактирования заказа
	         */
	
	    }, {
	        key: 'setOrder',
	        value: function setOrder(order_id, client_comment, service_in_slug, delivery_address) {
	            return this._send('setOrder', [order_id, client_comment, service_in_slug, delivery_address], '/user');
	        }
	    }, {
	        key: 'setPayOrder',
	        value: function setPayOrder(order_id, client_comment, service_in_slug, delivery_address, discount_sum, coupon_id, coupon_token, customer_coupon_id, custom_fields, child_orders, captcha) {
	            return this._send('setPayOrder', [order_id, client_comment, service_in_slug, delivery_address, discount_sum, coupon_id, coupon_token, customer_coupon_id, custom_fields, child_orders, captcha], '/user');
	        }
	
	        /**
	         * Пулучение выписки по счёту для пользователя
	         */
	
	    }, {
	        key: 'getPipoOperations',
	        value: function getPipoOperations(date_begin, date_end, id_account, page, page_size, channel_id) {
	            return this._send('getPipoOperations', [date_begin, date_end, id_account, page, page_size, channel_id], '/user');
	        }
	    }, {
	        key: 'paymentServices',
	        value: function paymentServices(paymentInId) {
	            return this._send('paymentServices', [paymentInId], '/user');
	        }
	    }, {
	        key: 'payInnerPipo',
	        value: function payInnerPipo(accountId, operationId) {
	            var checkCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	            return this._send('payInnerPipo', [accountId, operationId, checkCode], '/user');
	        }
	    }, {
	        key: 'checkCodeConfirmForPayInnerPipo',
	        value: function checkCodeConfirmForPayInnerPipo(online_shop_id, orderId) {
	            return this._send('checkCodeConfirmForPayInnerPipo', [online_shop_id, orderId], '/user');
	        }
	    }, {
	        key: 'getDetailPayIn',
	        value: function getDetailPayIn(operationId) {
	            return this._send('getDetailPayIn', [operationId], '/user');
	        }
	    }, {
	        key: 'getPageDetail',
	        value: function getPageDetail(id, shopId) {
	            return this._send('getPageDetail', [id, shopId], '/command');
	        }
	    }, {
	        key: 'getProductForSlider',
	        value: function getProductForSlider(type) {
	            return this._send('getProductForSlider', [type]);
	        }
	    }, {
	        key: 'getCategoryForSlider',
	        value: function getCategoryForSlider() {
	            return this._send('getCategoryForSlider', []);
	        }
	    }, {
	        key: 'getLang',
	        value: function getLang(lang) {
	            return this._send('getLang', [lang], '/user');
	        }
	    }, {
	        key: 'pipoProcessInput',
	        value: function pipoProcessInput(operation_id, group_slug) {
	            var additionalFieldName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	            var additionalFieldText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	            return this._send('pipoProcessInput', [operation_id, group_slug, additionalFieldName, additionalFieldText], '/user');
	        }
	    }, {
	        key: 'changeName',
	        value: function changeName(pipoId, name, newName) {
	            return this._send('changeName', [pipoId, name, newName], '/user');
	        }
	    }, {
	        key: 'changeMail',
	        value: function changeMail(pipoId, newEmail, code) {
	            return this._send('changeMail', [pipoId, newEmail, code], '/user');
	        }
	    }, {
	        key: 'changeMailWithCode',
	        value: function changeMailWithCode(pipoId, newEmail, code) {
	            return this._send('changeMailWithCode', [pipoId, newEmail, code], '/user');
	        }
	    }, {
	        key: 'changePhone',
	        value: function changePhone(pipoId, newPhone, code) {
	            return this._send('changePhone', [pipoId, newPhone, code], '/user');
	        }
	    }, {
	        key: 'changePhoneWithCode',
	        value: function changePhoneWithCode(pipoId, newPhone, code) {
	            return this._send('changePhoneWithCode', [pipoId, newPhone, code], '/user');
	        }
	    }, {
	        key: 'confirmMail',
	        value: function confirmMail(pipoId, email, code) {
	            return this._send('confirmMail', [pipoId, email, code], '/user');
	        }
	    }, {
	        key: 'confirmMailWithCode',
	        value: function confirmMailWithCode(pipoId, email, code) {
	            return this._send('confirmMailWithCode', [pipoId, email, code], '/user');
	        }
	    }, {
	        key: 'confirmEMailBySignature',
	        value: function confirmEMailBySignature(order_id, confirm_signature) {
	            return this._send('confirmEMailBySignature', [order_id, confirm_signature], '/user');
	        }
	    }, {
	        key: 'confirmPhone',
	        value: function confirmPhone(pipoId, phone, code) {
	            return this._send('confirmPhone', [pipoId, phone, code], '/user');
	        }
	    }, {
	        key: 'confirmPhoneWithCode',
	        value: function confirmPhoneWithCode(pipoId, phone, code) {
	            return this._send('confirmPhoneWithCode', [pipoId, phone, code], '/user');
	        }
	    }, {
	        key: 'changePassword',
	        value: function changePassword(login, newPassword, newRepassword, oldPassword) {
	            return this._send('changePassword', [login, newPassword, newRepassword, oldPassword], '/user');
	        }
	    }, {
	        key: 'shareBasket',
	        value: function shareBasket(basket, customFields) {
	            return this._send('shareBasket', [basket, customFields]);
	        }
	    }, {
	        key: 'getSharedBasket',
	        value: function getSharedBasket(code) {
	            return this._send('getSharedBasket', [code]);
	        }
	    }, {
	        key: 'postponeBasket',
	        value: function postponeBasket(basket, customFields) {
	            return this._send('postponeBasket', [basket, customFields], '/user');
	        }
	    }, {
	        key: 'getPostpone',
	        value: function getPostpone() {
	            return this._send('getPostpone', [], '/user');
	        }
	    }, {
	        key: 'deletePostpone',
	        value: function deletePostpone(id) {
	            return this._send('deletePostpone', [id], '/user');
	        }
	    }, {
	        key: 'mergePostpone',
	        value: function mergePostpone(mergeIds) {
	            return this._send('mergePostpone', [mergeIds], '/user');
	        }
	    }, {
	        key: 'getActualPrices',
	        value: function getActualPrices(basket) {
	            return this._send('getActualPrices', [basket]);
	        }
	    }, {
	        key: 'getCouponsByToken',
	        value: function getCouponsByToken(token) {
	            var user_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            return this._send('getCouponsByToken', [token, user_id]);
	        }
	    }, {
	        key: 'updateInn',
	        value: function updateInn(inn) {
	            return this._send('updateInn', [inn], '/user');
	        }
	    }, {
	        key: 'updateUlName',
	        value: function updateUlName(ul_name) {
	            return this._send('updateUlName', [ul_name], '/user');
	        }
	    }, {
	        key: 'addAddress',
	        value: function addAddress(address) {
	            return this._send('addAddress', [address], '/user');
	        }
	    }, {
	        key: 'getChannelLastUpdateDate',
	        value: function getChannelLastUpdateDate() {
	            return this._send('getChannelLastUpdateDate');
	        }
	    }, {
	        key: 'getChannelActualCatalogLabel',
	        value: function getChannelActualCatalogLabel() {
	            return this._send('getChannelActualCatalogLabel');
	        }
	    }, {
	        key: 'getDomainInfo',
	        value: function getDomainInfo(domain) {
	            return this._send('getDomainInfo', [domain]);
	        }
	    }, {
	        key: 'getAddresses',
	        value: function getAddresses() {
	            return this._send('getAddresses', [], '/user');
	        }
	    }, {
	        key: 'updateAddress',
	        value: function updateAddress(id, address, is_default) {
	            return this._send('updateAddress', [id, address, is_default], '/user');
	        }
	    }, {
	        key: 'deleteAddress',
	        value: function deleteAddress(id) {
	            return this._send('deleteAddress', [id], '/user');
	        }
	    }]);
	    return IBonusProxy;
	}(_IBonus3.default);
	
	exports.default = IBonusProxy;
	module.exports = exports['default'];

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IBONUS_PATH_SET_WISH_LIST = exports.IBONUS_PATH_GET_WISH_LIST = exports.IBONUS_PATH_GET_COUPONS_BY_TOKEN = exports.IBONUS_PATH_GET_ACTUAL_PRICES = exports.IBONUS_PATH_USER_CONFIRM_REGISTER_ONE_CLICK = exports.IBONUS_PATH_USER_REGISTER_ONE_CLICK = exports.IBONUS_PATH_ACTUAL_CATALOG_LABEL = exports.IBONUS_PATH_GET_TIME_UPDATE_CHANNEL = exports.IBONUS_PATH_LANG_GET_LANG_DATA = exports.IBONUS_PATH_GET_COUPONS_AND_BALANCE = exports.IBONUS_PATH_PIPO_GET_OPERATIONS = exports.IBONUS_PATH_ORDER_CANCEL = exports.IBONUS_PATH_ORDER_EDIT = exports.IBONUS_PATH_ORDER_UPDATE = exports.IBONUS_PATH_USER_ORDER_GET = exports.IBONUS_PATH_USER_ORDER_CREATE_PAY = exports.IBONUS_PATH_USER_ORDER_PAY = exports.IBONUS_PATH_USER_ORDER_CREATE = exports.IBONUS_PATH_USER_CONFIRM_EMAIL_TO_URL = exports.IBONUS_PATH_UPDATE_UL_NAME = exports.IBONUS_PATH_UPDATE_INN = exports.IBONUS_PATH_MERGE_POSTPONE_BASKET = exports.IBONUS_PATH_DELETE_POSTPONE_BASKET = exports.IBONUS_PATH_GET_POSTPONE_BASKET = exports.IBONUS_PATH_CREATE_POSTPONE_BASKET = exports.IBONUS_PATH_GET_SHARED_BASKET = exports.IBONUS_PATH_SHARE_BASKET = exports.IBONUS_PATH_GET_CATEGORY_RECOMENDED = exports.IBONUS_PATH_SLIDER_GET_CATEGORY = exports.IBONUS_PATH_SLIDER_GET_OFFER_BY_TYPE = exports.IBONUS_PATH_GET_PAYMENT_METHODS = exports.IBONUS_PATH_USER_CHANNEL_GET_ONLINE_SHOP_SETTINGS = exports.IBONUS_PATH_GET_PAGE_BY_ID = exports.IBONUS_PATH_OFFER_GET_IN_CATEGORY = exports.IBONUS_PATH_OFFER_GET_DEPTH_BY_CATEGORY = exports.IBONUS_PATH_OFFER_GET_BY_ID = exports.IBONUS_PATH_OFFER_GET = exports.IBONUS_PATH_USER_PAYMENT_IN_PAY = exports.IBONUS_PATH_USER_PAYMENT_IN_BEFORE_PAY = exports.IBONUS_PATH_GET_CATALOG = exports.IBONUS_PATH_USER_CHANGE_PASSWORD = exports.IBONUS_PATH_USER_CHANGE_PHONE = exports.IBONUS_PATH_USER_CONFIRM_REGISTER_BY_PHONE = exports.IBONUS_PATH_USER_REGISTER_BY_PHONE = exports.IBONUS_PATH_USER_DELETE_ADDRESS = exports.IBONUS_PATH_USER_UPDATE_ADDRESS = exports.IBONUS_PATH_USER_ADD_ADDRESS = exports.IBONUS_PATH_USER_GET_ADDRESS = exports.IBONUS_PATH_GET_CHECK = exports.IBONUS_PATH_GET_USER_AMOUNT = exports.IBONUS_PATH_OFFER_GET_BY_CATEGORY = exports.IBONUS_PATH_CATEGORY_GET_BY_CHANNEL = exports.IBONUS_PATH_USER_RESTORE_PASSWORD = exports.IBONUS_PATH_USER_SEND_VOICE_CODE = exports.IBONUS_PATH_USER_SEND_CODE = exports.IBONUS_PATH_USER_CONFIRM_MAIL = exports.IBONUS_PATH_USER_CONFIRM_PHONE = exports.IBONUS_PATH_USER_CHANGE_MAIL = exports.IBONUS_PATH_USER_CHANGE_NAME = exports.IBONUS_PATH_USER_LOGOUT = exports.IBONUS_PATH_USER_GET_DATA = exports.IBONUS_PATH_USER_UPDATE_ACCESS_TOKEN = exports.IBONUS_PATH_USER_AUTHENTICATION = undefined;
	
	var _config = __webpack_require__(761);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VERSION = 'v' + _config2.default.api_version;
	
	/** Private */
	var IBONUS_PATH_USER_AUTHENTICATION = exports.IBONUS_PATH_USER_AUTHENTICATION = '/api/user/authentication';
	var IBONUS_PATH_USER_UPDATE_ACCESS_TOKEN = exports.IBONUS_PATH_USER_UPDATE_ACCESS_TOKEN = '/api/user/update-access-token';
	var IBONUS_PATH_USER_GET_DATA = exports.IBONUS_PATH_USER_GET_DATA = '/api/user/get-data-by-confirms';
	var IBONUS_PATH_USER_LOGOUT = exports.IBONUS_PATH_USER_LOGOUT = '/api/user/logout';
	//export const IBONUS_PATH_ORDER_UPDATE = `/api/order/update`;
	var IBONUS_PATH_USER_CHANGE_NAME = exports.IBONUS_PATH_USER_CHANGE_NAME = '/api/user/change-name';
	var IBONUS_PATH_USER_CHANGE_MAIL = exports.IBONUS_PATH_USER_CHANGE_MAIL = '/api/user/change-email';
	var IBONUS_PATH_USER_CONFIRM_PHONE = exports.IBONUS_PATH_USER_CONFIRM_PHONE = '/api/user/confirm-phone';
	var IBONUS_PATH_USER_CONFIRM_MAIL = exports.IBONUS_PATH_USER_CONFIRM_MAIL = '/api/user/confirm-email';
	
	var IBONUS_PATH_USER_SEND_CODE = exports.IBONUS_PATH_USER_SEND_CODE = '/api/user/send-code';
	var IBONUS_PATH_USER_SEND_VOICE_CODE = exports.IBONUS_PATH_USER_SEND_VOICE_CODE = '/api/user/send-voice-code';
	var IBONUS_PATH_USER_RESTORE_PASSWORD = exports.IBONUS_PATH_USER_RESTORE_PASSWORD = '/api/user/restore-password';
	
	var IBONUS_PATH_CATEGORY_GET_BY_CHANNEL = exports.IBONUS_PATH_CATEGORY_GET_BY_CHANNEL = '/api/category/get-by-channel';
	var IBONUS_PATH_OFFER_GET_BY_CATEGORY = exports.IBONUS_PATH_OFFER_GET_BY_CATEGORY = '/api/offer/get-by-category';
	// export const IBONUS_PATH_GET_USER_AMOUNT = `/api/user/get-user-accounts`;
	var IBONUS_PATH_GET_USER_AMOUNT = exports.IBONUS_PATH_GET_USER_AMOUNT = '/api/ibonus/user/get-balance-bonus';
	var IBONUS_PATH_GET_CHECK = exports.IBONUS_PATH_GET_CHECK = '/api/check';
	
	var IBONUS_PATH_USER_GET_ADDRESS = exports.IBONUS_PATH_USER_GET_ADDRESS = '/api/user/get-address-user';
	var IBONUS_PATH_USER_ADD_ADDRESS = exports.IBONUS_PATH_USER_ADD_ADDRESS = '/api/user/add-address-user';
	var IBONUS_PATH_USER_UPDATE_ADDRESS = exports.IBONUS_PATH_USER_UPDATE_ADDRESS = '/api/user/update-address-user';
	var IBONUS_PATH_USER_DELETE_ADDRESS = exports.IBONUS_PATH_USER_DELETE_ADDRESS = '/api/user/delete-address-user';
	/** iBonusSpecial */
	var IBONUS_PATH_USER_REGISTER_BY_PHONE = exports.IBONUS_PATH_USER_REGISTER_BY_PHONE = '/api/ibonus/user/register';
	var IBONUS_PATH_USER_CONFIRM_REGISTER_BY_PHONE = exports.IBONUS_PATH_USER_CONFIRM_REGISTER_BY_PHONE = '/api/ibonus/user/confirm';
	var IBONUS_PATH_USER_CHANGE_PHONE = exports.IBONUS_PATH_USER_CHANGE_PHONE = '/api/ibonus/user/change-phone';
	
	var IBONUS_PATH_USER_CHANGE_PASSWORD = exports.IBONUS_PATH_USER_CHANGE_PASSWORD = '/api/ibonus/user/change-password';
	var IBONUS_PATH_GET_CATALOG = exports.IBONUS_PATH_GET_CATALOG = '/api/ibonus/category/get-by-profile'; // получить все категории
	var IBONUS_PATH_USER_PAYMENT_IN_BEFORE_PAY = exports.IBONUS_PATH_USER_PAYMENT_IN_BEFORE_PAY = '/api/ibonus/payment-in/before-pay';
	var IBONUS_PATH_USER_PAYMENT_IN_PAY = exports.IBONUS_PATH_USER_PAYMENT_IN_PAY = '/api/ibonus/payment-in/pay';
	
	var IBONUS_PATH_OFFER_GET = exports.IBONUS_PATH_OFFER_GET = '/api/ibonus/offer/get';
	var IBONUS_PATH_OFFER_GET_BY_ID = exports.IBONUS_PATH_OFFER_GET_BY_ID = '/api/ibonus/offer/get-by-id-new';
	var IBONUS_PATH_OFFER_GET_DEPTH_BY_CATEGORY = exports.IBONUS_PATH_OFFER_GET_DEPTH_BY_CATEGORY = '/api/ibonus/offer/get-depth-by-category';
	var IBONUS_PATH_OFFER_GET_IN_CATEGORY = exports.IBONUS_PATH_OFFER_GET_IN_CATEGORY = '/api/ibonus/offer/get-by-category';
	var IBONUS_PATH_GET_PAGE_BY_ID = exports.IBONUS_PATH_GET_PAGE_BY_ID = '/api/ibonus/online-shop/get-page-by-id ';
	var IBONUS_PATH_USER_CHANNEL_GET_ONLINE_SHOP_SETTINGS = exports.IBONUS_PATH_USER_CHANNEL_GET_ONLINE_SHOP_SETTINGS = '/api/ibonus/online-shop/get-settings';
	var IBONUS_PATH_GET_PAYMENT_METHODS = exports.IBONUS_PATH_GET_PAYMENT_METHODS = '/api/ibonus/channel/get-available-services-in-online-shop';
	var IBONUS_PATH_SLIDER_GET_OFFER_BY_TYPE = exports.IBONUS_PATH_SLIDER_GET_OFFER_BY_TYPE = '/api/ibonus/slider/get-offer-by-type';
	var IBONUS_PATH_SLIDER_GET_CATEGORY = exports.IBONUS_PATH_SLIDER_GET_CATEGORY = '/api/ibonus/slider/get-category';
	var IBONUS_PATH_GET_CATEGORY_RECOMENDED = exports.IBONUS_PATH_GET_CATEGORY_RECOMENDED = '/api/ibonus/category/get-recommended-offers';
	var IBONUS_PATH_SHARE_BASKET = exports.IBONUS_PATH_SHARE_BASKET = '/api/ibonus/cart/create-shared';
	var IBONUS_PATH_GET_SHARED_BASKET = exports.IBONUS_PATH_GET_SHARED_BASKET = '/api/ibonus/cart/get-shared';
	var IBONUS_PATH_CREATE_POSTPONE_BASKET = exports.IBONUS_PATH_CREATE_POSTPONE_BASKET = '/api/ibonus/cart/create-postpone';
	var IBONUS_PATH_GET_POSTPONE_BASKET = exports.IBONUS_PATH_GET_POSTPONE_BASKET = '/api/ibonus/cart/get-postpone';
	var IBONUS_PATH_DELETE_POSTPONE_BASKET = exports.IBONUS_PATH_DELETE_POSTPONE_BASKET = '/api/ibonus/cart/delete-postpone';
	var IBONUS_PATH_MERGE_POSTPONE_BASKET = exports.IBONUS_PATH_MERGE_POSTPONE_BASKET = '/api/ibonus/cart/merge-postpone';
	var IBONUS_PATH_UPDATE_INN = exports.IBONUS_PATH_UPDATE_INN = '/api/ibonus/user/update-inn';
	var IBONUS_PATH_UPDATE_UL_NAME = exports.IBONUS_PATH_UPDATE_UL_NAME = '/api/ibonus/user/update-ul-name';
	var IBONUS_PATH_USER_CONFIRM_EMAIL_TO_URL = exports.IBONUS_PATH_USER_CONFIRM_EMAIL_TO_URL = '/api/ibonus/user/confirm-email-to-url';
	
	/** Order */
	var IBONUS_PATH_USER_ORDER_CREATE = exports.IBONUS_PATH_USER_ORDER_CREATE = '/api/ibonus/order/create';
	var IBONUS_PATH_USER_ORDER_PAY = exports.IBONUS_PATH_USER_ORDER_PAY = '/api/ibonus/order/pay';
	var IBONUS_PATH_USER_ORDER_CREATE_PAY = exports.IBONUS_PATH_USER_ORDER_CREATE_PAY = '/api/ibonus/order/create-pay-order';
	var IBONUS_PATH_USER_ORDER_GET = exports.IBONUS_PATH_USER_ORDER_GET = '/api/ibonus/order/get';
	var IBONUS_PATH_ORDER_UPDATE = exports.IBONUS_PATH_ORDER_UPDATE = '/api/ibonus/order/update';
	var IBONUS_PATH_ORDER_EDIT = exports.IBONUS_PATH_ORDER_EDIT = '/api/ibonus/order/edit-order';
	var IBONUS_PATH_ORDER_CANCEL = exports.IBONUS_PATH_ORDER_CANCEL = '/api/ibonus/order/cancel-order';
	
	var IBONUS_PATH_PIPO_GET_OPERATIONS = exports.IBONUS_PATH_PIPO_GET_OPERATIONS = '/api/ibonus/user/get-balance-bonus-history';
	var IBONUS_PATH_GET_COUPONS_AND_BALANCE = exports.IBONUS_PATH_GET_COUPONS_AND_BALANCE = '/api/ibonus/user/get-coupons-and-balance';
	
	var IBONUS_PATH_LANG_GET_LANG_DATA = exports.IBONUS_PATH_LANG_GET_LANG_DATA = '/api/lang/get-lang-data';
	var IBONUS_PATH_GET_TIME_UPDATE_CHANNEL = exports.IBONUS_PATH_GET_TIME_UPDATE_CHANNEL = '/api/ibonus/channel/get-time-update-channel';
	var IBONUS_PATH_ACTUAL_CATALOG_LABEL = exports.IBONUS_PATH_ACTUAL_CATALOG_LABEL = '/api/ibonus/channel/get-actual-catalog-label';
	var IBONUS_PATH_USER_REGISTER_ONE_CLICK = exports.IBONUS_PATH_USER_REGISTER_ONE_CLICK = '/api/ibonus/user/register-one-click';
	var IBONUS_PATH_USER_CONFIRM_REGISTER_ONE_CLICK = exports.IBONUS_PATH_USER_CONFIRM_REGISTER_ONE_CLICK = '/api/ibonus/user/confirm-one-click';
	var IBONUS_PATH_GET_ACTUAL_PRICES = exports.IBONUS_PATH_GET_ACTUAL_PRICES = '/api/ibonus/offer/get-actual-prices';
	var IBONUS_PATH_GET_COUPONS_BY_TOKEN = exports.IBONUS_PATH_GET_COUPONS_BY_TOKEN = '/api/ibonus/offer/get-coupon-by-token';
	var IBONUS_PATH_GET_WISH_LIST = exports.IBONUS_PATH_GET_WISH_LIST = '/api/ibonus/cart/get-wish-list';
	var IBONUS_PATH_SET_WISH_LIST = exports.IBONUS_PATH_SET_WISH_LIST = '/api/ibonus/cart/set-wish-list';

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 Коды ошибок из системы i-retail
	 */
	
	/** Ошибка аутентификации пользователя по grant_type=password*/
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ERROR_CODE_AUTHENTICATION = exports.ERROR_CODE_AUTHENTICATION = 300;
	/** Ошибка запроса время жизни access token истекло*/
	var ERROR_CODE_INVALID_ACCESS_TOKEN = exports.ERROR_CODE_INVALID_ACCESS_TOKEN = 301;
	/** Ошибка аутентификации пользователя по refresh_token*/
	var ERROR_CODE_INVALID_REFRESH_TOKEN = exports.ERROR_CODE_INVALID_REFRESH_TOKEN = 302;
	/** Следующий запрос надо отправлять с подтверждением капчи */
	var ERROR_CODE_NEED_SEND_CAPTCHA = exports.ERROR_CODE_NEED_SEND_CAPTCHA = 303;
	/** Нет капчи или неверно введена */
	var ERROR_CODE_INVALID_CAPTCHA = exports.ERROR_CODE_INVALID_CAPTCHA = 304;
	/** Пользователь временно заблокирован по ip */
	var ERROR_CODE_USER_IP_BLOCKED = exports.ERROR_CODE_USER_IP_BLOCKED = 305;
	/** Пользователь заблокирован в системе i-Retail */
	var ERROR_CODE_USER_BLOCKED = exports.ERROR_CODE_USER_BLOCKED = 306;
	/** По преданному токену интернет-магазин для авторизации не найден */
	var ERROR_CODE_NOT_FOUND_CLOUD_FISCAL = exports.ERROR_CODE_NOT_FOUND_CLOUD_FISCAL = 307;
	/** Ошибка авторизации по логину и api_key */
	var ERROR_CODE_AUTH_BY_API_KEY_AND_LOGIN = exports.ERROR_CODE_AUTH_BY_API_KEY_AND_LOGIN = 308;
	/** Группа ошибок связанных с тарифами */
	var ERROR_CODE_TARIFF = exports.ERROR_CODE_TARIFF = 158;
	/** Неизвестная ошибка - для всех эксепшнов, не описанных в коде специально */
	var ERROR_CODE_GENERAL_ERROR = exports.ERROR_CODE_GENERAL_ERROR = 400;
	/** Неизвестная ошибка */
	var ERROR_UNKNOWN_ERROR = exports.ERROR_UNKNOWN_ERROR = 0;
	/** Недостаточно товара на складе */
	var ERROR_FEW_PRODUCTS = exports.ERROR_FEW_PRODUCTS = 160;
	
	var ERROR_SLUG_TARIFF = exports.ERROR_SLUG_TARIFF = 'error.issetLatePaymentTariff';
	
	var ERROR_SLUG_INVALID_ACCESS_TOKEN = exports.ERROR_SLUG_INVALID_ACCESS_TOKEN = 'user.invalid_access_token';
	
	var ERROR_SLUG_GENERAL_ERROR = exports.ERROR_SLUG_GENERAL_ERROR = 'common.errorGeneral';
	
	// Соединение прервано неожиданно
	var ERROR_CODE_CONNECTION_CLOSE_UBNORMAL = exports.ERROR_CODE_CONNECTION_CLOSE_UBNORMAL = -10;
	
	// Статус, для непонятных и глупых ошибок, которые не нужно особо обрабатывать
	var ERROR_STATUS_FOR_INTERNAL_CASE = exports.ERROR_STATUS_FOR_INTERNAL_CASE = 418;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _reactBootstrap = __webpack_require__(24);
	
	__webpack_require__(1062);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AddressListInputView: {
	        displayName: 'AddressListInputView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/AddressListInput/default/AddressListInputView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var AddressListInputView = _wrapComponent('AddressListInputView')(function (_React$Component) {
	    (0, _inherits3.default)(AddressListInputView, _React$Component);
	
	    function AddressListInputView() {
	        (0, _classCallCheck3.default)(this, AddressListInputView);
	        return (0, _possibleConstructorReturn3.default)(this, (AddressListInputView.__proto__ || (0, _getPrototypeOf2.default)(AddressListInputView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(AddressListInputView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                lang = _props.lang,
	                is_default = _props.is_default,
	                isNew = _props.isNew,
	                onSave = _props.onSave,
	                editMode = _props.editMode,
	                setEditMode = _props.setEditMode,
	                value = _props.value,
	                onChange = _props.onChange,
	                onCancel = _props.onCancel,
	                onMapButtonClick = _props.onMapButtonClick,
	                onDeleteButtonClick = _props.onDeleteButtonClick,
	                onDefaultButtonClick = _props.onDefaultButtonClick;
	
	
	            var isEditButtonShown = !editMode && !isNew;
	            var isMapButtonShown = editMode;
	            var isDefaultButtonShown = !editMode && !isNew;
	            var isSaveButtonShown = editMode;
	            var isDeleteButtonShown = !editMode && !isNew;
	            var isCancelButtonShown = editMode;
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'address-input__container' },
	                _react3.default.createElement(_reactBootstrap.FormControl, { onChange: onChange, value: value, disabled: !editMode, type: 'text' }),
	                isEditButtonShown && _react3.default.createElement(
	                    'button',
	                    { onClick: function onClick() {
	                            return setEditMode(true);
	                        }, className: 'le-button pay_order_button' },
	                    lang['store.common.addresses.edit']
	                ),
	                isSaveButtonShown && _react3.default.createElement(
	                    'button',
	                    { disabled: !value, onClick: onSave, className: 'le-button pay_order_button' },
	                    lang['store.common.addresses.save']
	                ),
	                isMapButtonShown && _react3.default.createElement(
	                    'button',
	                    { onClick: onMapButtonClick, className: 'le-button pay_order_button' },
	                    lang['store.common.select_on_map']
	                ),
	                isCancelButtonShown && _react3.default.createElement(
	                    'button',
	                    { onClick: onCancel, className: 'le-button pay_order_button' },
	                    lang['store.common.addresses.cancel']
	                ),
	                isDefaultButtonShown && _react3.default.createElement(
	                    'button',
	                    { onClick: onDefaultButtonClick, disabled: is_default, className: 'le-button pay_order_button ' + (is_default && 'disabled') },
	                    lang['store.common.addresses.default']
	                ),
	                isDeleteButtonShown && _react3.default.createElement(
	                    'button',
	                    { onClick: onDeleteButtonClick, className: 'le-button pay_order_button' },
	                    lang['store.common.addresses.delete']
	                )
	            );
	        }
	    }]);
	    return AddressListInputView;
	}(_react3.default.Component));
	
	exports.default = AddressListInputView;
	module.exports = exports['default'];

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(12);
	
	var _modal = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AlcoModal: {
	        displayName: 'AlcoModal'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Basket/AlcoModal.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var AlcoModal = _wrapComponent('AlcoModal')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        settings: state.setting,
	        lang: state.lang
	    };
	}, {
	    hide: _modal.hide
	}), _dec(_class = function (_Component) {
	    (0, _inherits3.default)(AlcoModal, _Component);
	
	    function AlcoModal() {
	        (0, _classCallCheck3.default)(this, AlcoModal);
	        return (0, _possibleConstructorReturn3.default)(this, (AlcoModal.__proto__ || (0, _getPrototypeOf2.default)(AlcoModal)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(AlcoModal, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                settings = _props.settings,
	                lang = _props.lang;
	
	
	            var firstLineStart = lang['store.alco_modal.notification.start'];
	            var firstLineEnd = lang['store.alco_modal.notification.end'];
	            var firstLine = firstLineStart + ' "' + settings.shopName + '" ' + firstLineEnd;
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(
	                    'p',
	                    null,
	                    firstLine
	                ),
	                _react3.default.createElement(
	                    'p',
	                    null,
	                    lang['store.alco_modal.buy_offline']
	                ),
	                _react3.default.createElement(
	                    'p',
	                    null,
	                    lang['store.alco_modal.remove_alco']
	                )
	            );
	        }
	    }]);
	    return AlcoModal;
	}(_react2.Component)) || _class));
	
	exports.default = AlcoModal;
	module.exports = exports['default'];

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _error = __webpack_require__(140);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _modal = __webpack_require__(26);
	
	var _modal_type = __webpack_require__(42);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	var _utils = __webpack_require__(31);
	
	var _IBonusError = __webpack_require__(191);
	
	var _IBonusError2 = _interopRequireDefault(_IBonusError);
	
	var _basket = __webpack_require__(101);
	
	var _copyToClipboard = __webpack_require__(779);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _helpers = __webpack_require__(15);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Basket: {
	        displayName: 'Basket'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Basket/Basket.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ALCO_TYPES = {
	    LOW_ALCOHOL: 3,
	    ALCOHOL: 2,
	    NO_ALCOHOL: 1
	};
	
	var Basket = _wrapComponent('Basket')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        basketElements: state.basket.items,
	        cartDescription: state.setting.cartDescription,
	        cartSubject: state.setting.cartSubject,
	        channelId: state.setting.channelId,
	        dataError: state.basket.dataError,
	        isCopedItems: state.basket.is_coped_items,
	        logo: state.setting.logo,
	        preload: state.basket.preload,
	        profileId: state.setting.profileId,
	        shareCode: state.basket.shareCode,
	        sharePreload: state.basket.sharePreload,
	        actualPricesPreload: state.basket.actualPricesPreload,
	        showShare: state.basket.showShare,
	        user: state.auth.user,
	        orderInOneClick: state.setting.orderInOneClick,
	        lang: state.lang,
	        currency: state.currency,
	        customFields: state.setting.customFields,
	        fieldsShare: state.basket.fields
	    };
	}, {
	    changeCountProduct: _basket.changeCountProduct,
	    changeShareState: _basket.changeShareState,
	    clearBasket: _basket.clearBasket,
	    createOrder: _basket.createOrder,
	    editOrder: _basket.editOrder,
	    deleteProduct: _basket.deleteProduct,
	    error: _error.error,
	    hide: _modal.hide,
	    push: _reactRouterRedux.push,
	    resetShareCode: _basket.resetShareCode,
	    shareBasket: _basket.shareBasket,
	    showAlcoModal: _modal_type.showAlcoModal,
	    showModal: _modal.showModal,
	    showModalAuth: _modal_type.showModalAuth,
	    showModalAuthOneClick: _modal_type.showModalAuthOneClick,
	    postponeBasket: _basket.postponeBasket
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Basket, _Component);
	
	    function Basket(props) {
	        (0, _classCallCheck3.default)(this, Basket);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Basket.__proto__ || (0, _getPrototypeOf2.default)(Basket)).call(this));
	
	        _this.onDelete = function (id) {
	            var modifier_option_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	            var lang = _this.props.lang;
	
	
	            var modalContent = _react3.default.createElement(
	                'div',
	                { className: 'row no-margin' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    lang['store.cart.on_delete.confirmation']
	                )
	            );
	
	            _this.props.showModal({
	                title: lang['store.cart.on_delete.title'],
	                content: modalContent,
	                titleSuccess: lang['store.common.yes'],
	                titleClose: lang['store.common.no'],
	                onSuccess: function onSuccess() {
	                    _this.props.deleteProduct(id, modifier_option_id, key);
	                    // this.props.dataError = null;
	                },
	                modalType: 'del'
	            });
	        };
	
	        _this.onChangeCount = function (productId, newCount) {
	            var modifier_option_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	            var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	            _this.props.changeCountProduct(productId, newCount, modifier_option_id, key);
	        };
	
	        _this.onCreateOrder = function () {
	            // проверим авторизацию пользователя
	            if (_this.props.user) {
	                if (_this.state.editOrderId) {
	                    _this.callEditOrder();
	                } else {
	                    _this.callCreateOrder();
	                }
	            } else {
	                if (_this.props.orderInOneClick) {
	                    _this.props.showModalAuthOneClick();
	                } else {
	                    _this.props.showModalAuth(_this.props.lang);
	                }
	                _this.setState({ wasOrderClick: true });
	            }
	        };
	
	        _this._removeAlcoElements = function () {
	            var alcoId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            var products = [];
	
	            _this.props.basketElements.forEach(function (item) {
	                if (alcoId.includes(item.id)) {
	                    _this.props.deleteProduct(item.id);
	                } else {
	                    products.push(item);
	                }
	            });
	
	            return products;
	        };
	
	        _this._compileOrder = function () {
	            var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            var sum = 0;
	            var products = [];
	            basketElements.map(function (element) {
	                sum += element.price * element.count;
	                products.push({
	                    offer_id: element.id,
	                    quantity: element.count,
	                    price: element.price,
	                    modifier_option_id: element.modifier_option_id,
	                    modifier_option_name: element.modifier_option_name,
	                    custom_fields: element.custom_fields,
	                    nestedOffers: element.nested_offer,
	                    coupon_id: element.coupon_id, coupon_token: element.coupon_token, customer_coupon_id: element.customer_coupon_id,
	                    basket_number: element.basket_number
	                });
	            });
	            if (sum < 1) {
	                var alertMessage = (0, _utils.replaceCharToArrayIndex)(_this.props.lang['error.pipo.operationInvalidMinimalSum'], [_this.props.currency.code]);
	                setTimeout(function () {
	                    _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                }, 0);
	                throw new _IBonusError2.default({
	                    message: alertMessage,
	                    title: alertMessage,
	                    code: '',
	                    trace: ''
	                });
	            }
	            var userAgent = navigator.userAgent || '';
	            var utmRedirectData = _LocalStorageProxy2.default.getItem('utm_redirect_data') || '';
	            var customFields = _this.state.customFields || [];
	            _LocalStorageProxy2.default.setItem('utm_redirect_data', '');
	
	            var currency_id = _this.props.currency.id;
	
	            if (_this.state.editOrderId) {
	                var order_id = _this.state.editOrderId;
	                return { order_id: order_id, sum: sum, products: products, userAgent: userAgent, utmRedirectData: utmRedirectData, currency_id: currency_id, customFields: customFields };
	            }
	            return { sum: sum, products: products, userAgent: userAgent, utmRedirectData: utmRedirectData, currency_id: currency_id, customFields: customFields };
	        };
	
	        _this._showAlcoWarning = function () {
	            var alcoId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            var lang = _this.props.lang;
	
	
	            var modalContent = _react3.default.createElement(
	                'div',
	                null,
	                lang['store.cart.alco_warning.confirmation']
	            );
	
	            var confirmModal = function confirmModal() {
	                _this.props.showModal({
	                    title: lang['store.modals.alcohol_removal'],
	                    content: modalContent,
	                    titleSuccess: lang['store.common.yes'],
	                    titleClose: lang['store.common.cancel'],
	                    onSuccess: function onSuccess() {
	                        if (_this.state.editOrderId) {
	                            _this.callEditOrder(_this._removeAlcoElements(alcoId));
	                        } else {
	                            _this.callCreateOrder(_this._removeAlcoElements(alcoId));
	                        }
	                    },
	                    modalType: 'del'
	                });
	            };
	
	            if (alcoId.length > 0) {
	                _this.props.showAlcoModal(confirmModal, lang);
	            }
	        };
	
	        _this.callCreateOrder = function () {
	            var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.basketElements;
	
	            if (basketElements.length > 0) {
	                _this.props.createOrder(_this._compileOrder(basketElements)).then(function (result) {
	                    _this.props.clearBasket();
	                    _this.props.push('/create-order/' + result.result.order_id);
	                }).catch(function (err) {
	                    //Ошибка "предложение не найдено"
	                    if (err.code === 139 && err.title === 'error.catalogOfferNotFind') {
	                        console.log('предложение не найдено', err);
	                        err.dataError.forEach(function (item) {
	                            _this.props.deleteProduct(item);
	                        });
	
	                        var alertMessage = _this.props.lang['store.cart.call_create_order.catalog_offer_not_found'];
	
	                        setTimeout(function () {
	                            _reactSAlert2.default.success(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                        }, 0);
	                    }
	
	                    //Ошибка: алкогольные товары в корзине
	                    if (err.code === 136 && err.title === 'error.orderExciseMarkBarcodeIsRequired') {
	                        _this._showAlcoWarning(err.dataError);
	                    }
	                });
	            }
	        };
	
	        _this.callEditOrder = function () {
	            var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.basketElements;
	
	            if (basketElements.length > 0) {
	                _this.props.editOrder(_this._compileOrder(basketElements)).then(function (result) {
	                    _this.props.clearBasket();
	                    _LocalStorageProxy2.default.removeItem('basket.edit_order_number');
	                    _LocalStorageProxy2.default.removeItem('basket.edit_order_id');
	                    _this.setState({ editOrderNumber: null });
	                    _this.setState({ editOrderId: null });
	                    _this.props.push('/create-order/' + result.result.order_id);
	                }).catch(function (err) {
	                    //Ошибка "предложение не найдено"
	                    if (err.code === 139 && err.title === 'error.catalogOfferNotFind') {
	                        console.log('предложение не найдено', err);
	                        err.dataError.forEach(function (item) {
	                            _this.props.deleteProduct(item);
	                        });
	
	                        var alertMessage = _this.props.lang['store.cart.call_create_order.catalog_offer_not_found'];
	
	                        setTimeout(function () {
	                            _reactSAlert2.default.success(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                        }, 0);
	                    }
	
	                    //Ошибка: алкогольные товары в корзине
	                    if (err.code === 136 && err.title === 'error.orderExciseMarkBarcodeIsRequired') {
	                        _this._showAlcoWarning(err.dataError);
	                    }
	                });
	            }
	        };
	
	        _this.handleDelayedBasket = function () {
	            _this.props.postponeBasket(_this.props.basketElements, _this.state.customFields).then(function (result) {
	                _this.props.clearBasket();
	                _this.props.push('/postpone');
	            });
	        };
	
	        _this.handleShareBasket = function () {
	            if (!_this.props.shareCode) {
	                _this.props.shareBasket(_this.props.basketElements, _this.state.customFields);
	            } else {
	                _this.props.changeShareState(true);
	            }
	        };
	
	        _this.handleHideShare = function () {
	            _this.props.changeShareState(false);
	        };
	
	        _this.changeCustomFields = function (e) {
	            if (_this.props.customFields[e.target.id].type === 'text') {
	                _this.props.customFields[e.target.id].value = e.target.value;
	            } else {
	                _this.props.customFields[e.target.id].value = e.target.checked;
	            }
	            // this.props.customFields[e.target.id].value = e.target.value;
	            _this.setState({ customFields: _this.props.customFields });
	            // this.props.shareCode = null;
	            _this.props.changeShareState(false);
	        };
	
	        _this.handleCopyToBuffer = function () {
	            (0, _copyToClipboard2.default)(global.location.origin + '/basket/' + _this.props.shareCode);
	            var alertMessage = _this.props.lang['store.common.link_copied'];
	            setTimeout(function () {
	                _reactSAlert2.default.success(alertMessage, { position: 'top-right', effect: 'slide', timeout: 5000 });
	            }, 0);
	        };
	
	        _this.cancelEditOrder = function () {
	            _LocalStorageProxy2.default.removeItem('basket.edit_order_number');
	            _LocalStorageProxy2.default.removeItem('basket.edit_order_id');
	            _this.setState({ editOrderNumber: null });
	            _this.setState({ editOrderId: null });
	        };
	
	        var fields = props.customFields;
	        if (props.fieldsShare !== undefined && props.fieldsShare.length > 0) {
	            fields = props.fieldsShare;
	        }
	        _this.state = {
	            wasOrderClick: false,
	            editOrderNumber: _LocalStorageProxy2.default.getItem('basket.edit_order_number'),
	            editOrderId: _LocalStorageProxy2.default.getItem('basket.edit_order_id'),
	            customFields: fields
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Basket, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            if (this.state.wasOrderClick && !!nextProps.user && !this.props.user) {
	                if (this.state.editOrderId) {
	                    this.callEditOrder();
	                } else {
	                    this.callCreateOrder();
	                }
	                this.setState({ wasOrderClick: false });
	                return false;
	            }
	
	            if (this.state.wasOrderClick) {
	                this.setState({ wasOrderClick: false });
	            }
	
	            return true;
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.changeShareState(false);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var basketElements = this.props.basketElements || [];
	            var View = _helpers.ThemeHelper.getViewForComponent('Basket');
	
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload || !this.props.isCopedItems || this.props.actualPricesPreload },
	                _react3.default.createElement(View, {
	                    before: this.props.before,
	                    copyToBuffer: this.handleCopyToBuffer,
	                    elements: basketElements,
	                    dataError: this.props.dataError,
	                    logo: this.props.logo,
	                    onDelete: this.onDelete,
	                    onChangeCount: this.onChangeCount,
	                    onCreateOrder: this.onCreateOrder,
	                    user: this.props.user,
	                    cartSubject: this.props.cartSubject,
	                    cartDescription: this.props.cartDescription,
	                    shareBasket: this.handleShareBasket,
	                    hideShare: this.handleHideShare,
	                    showShare: this.props.showShare,
	                    shareCode: this.props.shareCode,
	                    sharePreload: this.props.sharePreload,
	                    lang: this.props.lang,
	                    currency: this.props.currency,
	                    editOrderNumber: this.state.editOrderNumber,
	                    cancelEditOrder: this.cancelEditOrder,
	                    customFields: this.state.customFields,
	                    changeCustomFields: this.changeCustomFields,
	                    postponeBasket: this.handleDelayedBasket
	                })
	            );
	        }
	    }]);
	    return Basket;
	}(_react2.Component), _class2.propTypes = {
	    basketElements: _react2.PropTypes.array.isRequired,
	    changeCountProduct: _react2.PropTypes.func.isRequired,
	    deleteProduct: _react2.PropTypes.func.isRequired,
	    isCopedItems: _react2.PropTypes.bool,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _class2.defaultProps = {
	    basketElements: [],
	    isCopedItems: false,
	    user: null
	}, _temp)) || _class));
	
	exports.default = Basket;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactRouter = __webpack_require__(19);
	
	var _components2 = __webpack_require__(16);
	
	var _SHARE = __webpack_require__(93);
	
	__webpack_require__(455);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    BasketProductDetail: {
	        displayName: 'BasketProductDetail'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Basket/default/BasketProductDetail.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var BasketProductDetail = _wrapComponent('BasketProductDetail')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(BasketProductDetail, _Component);
	
	    function BasketProductDetail(props) {
	        (0, _classCallCheck3.default)(this, BasketProductDetail);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BasketProductDetail.__proto__ || (0, _getPrototypeOf2.default)(BasketProductDetail)).call(this, props));
	
	        _this.renderNested = function (itemChild, lang, itemError) {
	            var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	            if (itemChild.quantity == 0) {
	                return null;
	            }
	            var modifier_option_name = _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-2' },
	                _react3.default.createElement('div', { className: 'title' })
	            );
	            var sum = itemChild.price * itemChild.count;
	            if (itemChild.childOffer.modifierName !== null && itemChild.childOffer.modifierName !== undefined) {
	                modifier_option_name = _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2 hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        itemChild.childOffer.modifierName
	                    )
	                );
	            }
	            var childWeight = itemChild.quantity;
	            if ((itemChild.childOffer.unit.slug === 'kg' || itemChild.childOffer.unit.slug === 'mg') && itemChild.weight && itemChild.weight > 0 && itemChild.quantity > 0) {
	                childWeight = itemChild.weight * itemChild.quantity;
	                childWeight = childWeight.toFixed(3);
	                if (itemChild.weight < 0.01 && childItem.quantity < 1 || itemChild.weight < 1 && itemChild.quantity < 0.01) {
	                    childWeight = itemChild.weight * 1;
	                }
	                if (itemChild.weight < 0.1 && itemChild.quantity < 0.1) {
	                    childWeight = itemChild.weight * 1;
	                }
	            }
	            var paddingLeft = level * 30 + 'px';
	            return _react3.default.createElement(
	                'div',
	                { className: 'row no-margin', style: { clear: 'both' } },
	                _react3.default.createElement('div', { className: 'col-sm-1 col-xs-12' }),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-4 visible-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title', style: { paddingLeft: paddingLeft } },
	                        '- ',
	                        itemChild.childOffer.name,
	                        ' ',
	                        itemChild.childOffer.modifierName
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { style: { paddingLeft: '49px' } },
	                        _react3.default.createElement(
	                            'span',
	                            null,
	                            _this.props.lang['store.common.quantity'],
	                            ': ',
	                            childWeight,
	                            ' ',
	                            _this.props.lang[itemChild.childOffer.unit.title_lang_data]
	                        )
	                    )
	                ),
	                itemError && itemError.child_offer_id !== null && itemError.child_offer_id.indexOf(itemChild.childOffer.id) !== -1 ? _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-4 hidden-xs', style: { color: '#e9594a' } },
	                    _react3.default.createElement(
	                        'div',
	                        { style: { paddingLeft: paddingLeft }, className: 'title' },
	                        '- ',
	                        itemChild.childOffer.name
	                    )
	                ) : _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-4 hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { style: { paddingLeft: paddingLeft }, className: 'title' },
	                        '- ',
	                        itemChild.childOffer.name
	                    )
	                ),
	                modifier_option_name,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-3 hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'quantity_counter_child' },
	                        childWeight,
	                        ' ',
	                        lang[itemChild.childOffer.unit.title_lang_data]
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2' },
	                    _react3.default.createElement('div', { className: 'price' })
	                ),
	                itemChild.childOffer.type_id === 5 && itemChild.childOffer.nestedOffers ? itemChild.childOffer.nestedOffers.map(function (item, keyArray) {
	                    return _this.renderNested(item, lang, itemError, level + 1);
	                }) : null
	            );
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(BasketProductDetail, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                id = _props.id,
	                name = _props.name,
	                description = _props.description,
	                count = _props.count,
	                sum = _props.sum,
	                picture = _props.picture,
	                itemError = _props.itemError,
	                modifier_option_id = _props.modifier_option_id,
	                remainder_quantity = _props.remainder_quantity,
	                lang = _props.lang,
	                currency = _props.currency,
	                keyArray = _props.keyArray,
	                basket_number = _props.basket_number,
	                custom_fields = _props.custom_fields;
	
	
	            var outOfStock = lang['store.cart_detail.out_of_stock'];
	            var available = lang['store.cart_detail.available'];
	
	            if (picture && (picture.preview_url || picture.url)) {
	                picture = picture.preview_url ? picture.preview_url : picture.url;
	
	                picture = _react3.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/product/' + id, className: 'thumb-holder' },
	                    _react3.default.createElement('img', { className: 'lazy', style: { width: '73px' }, alt: name, src: picture })
	                );
	            } else {
	                picture = '';
	            }
	            var modifier_option_name = _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-2 prod_desc' },
	                _react3.default.createElement('div', { className: 'title' })
	            );
	            if (modifier_option_id !== null && modifier_option_id !== undefined) {
	                modifier_option_name = _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title prod_desc hidden-xs' },
	                        this.props.modifier_option.name
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title visible-xs' },
	                        this.props.modifier_option.name
	                    )
	                );
	            } else if (this.props.modifier_option_name !== null && this.props.modifier_option_name !== undefined) {
	                modifier_option_name = _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title prod_desc hidden-xs' },
	                        this.props.modifier_option_name
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title visible-xs' },
	                        this.props.modifier_option_name
	                    )
	                );
	            }
	            var childWeight = null;
	            var weight = null;
	            return _react3.default.createElement(
	                'div',
	                { className: 'row no-margin cart-item' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-1' },
	                    picture,
	                    _react3.default.createElement('a', { className: 'close-btn pointer visible-xs', onClick: function onClick(e) {
	                            _this2.props.onDelete(id, modifier_option_id, keyArray);
	                        } }),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'quantity_counter visible-xs' },
	                        itemError ? _react3.default.createElement(
	                            'div',
	                            null,
	                            _react3.default.createElement(_components2.QuantityProduct, { value: count, callback: function callback(newCount) {
	                                    _this2.props.onChangeCount(id, newCount, modifier_option_id, keyArray);
	                                } }),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'basket_item_error' },
	                                _react3.default.createElement('i', { className: 'fa fa-exclamation-circle' }),
	                                itemError.count_offer - 0 <= 0 ? outOfStock : available + ' ' + itemError.count_offer
	                            )
	                        ) : _react3.default.createElement(
	                            'div',
	                            null,
	                            _react3.default.createElement(_components2.QuantityProduct, { value: count,
	                                checkValue: remainder_quantity !== null && remainder_quantity !== undefined,
	                                checkCount: remainder_quantity,
	                                callback: function callback(newCount) {
	                                    _this2.props.onChangeCount(id, newCount, modifier_option_id, keyArray);
	                                } })
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'price' },
	                            _react3.default.createElement(_components2.MoneyValue, {
	                                value: sum,
	                                icon: currency.icon,
	                                iconAfterValue: currency.icon_after_value
	                            })
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-4' },
	                    basket_number !== undefined ? _react3.default.createElement(
	                        'div',
	                        { className: 'title prod_desc hidden-xs' },
	                        _react3.default.createElement(
	                            'h4',
	                            null,
	                            lang['store.postpone.basketNumber'] + (basket_number + 1)
	                        )
	                    ) : null,
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title prod_desc hidden-xs' },
	                        _react3.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/product/' + id },
	                            name
	                        ),
	                        _react3.default.createElement(_SHARE.SwitherDescription, { description: description }),
	                        custom_fields ? custom_fields.map(function (item, i) {
	                            return _react3.default.createElement(
	                                'label',
	                                null,
	                                item.name,
	                                ': ',
	                                item.value
	                            );
	                        }) : null,
	                        itemError && itemError.is_edited ? _react3.default.createElement(
	                            'div',
	                            { className: 'basket_item_error' },
	                            _react3.default.createElement('i', { className: 'fa fa-exclamation-circle' }),
	                            lang['store.cart_detail.error.editNested']
	                        ) : null
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title visible-xs' },
	                        _react3.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/product/' + id },
	                            name
	                        ),
	                        _react3.default.createElement(_SHARE.SwitherDescription, { description: description }),
	                        custom_fields ? custom_fields.map(function (item, i) {
	                            return _react3.default.createElement(
	                                'label',
	                                null,
	                                item.name,
	                                ': ',
	                                item.value
	                            );
	                        }) : null,
	                        itemError && itemError.is_edited ? _react3.default.createElement(
	                            'div',
	                            { className: 'basket_item_error' },
	                            _react3.default.createElement('i', { className: 'fa fa-exclamation-circle' }),
	                            lang['store.cart_detail.error.editNested']
	                        ) : null
	                    )
	                ),
	                modifier_option_name,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-3 hidden-xs' },
	                    itemError ? _react3.default.createElement(
	                        'div',
	                        null,
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'quantity_counter' },
	                            _react3.default.createElement(_components2.QuantityProduct, { value: count, callback: function callback(newCount) {
	                                    _this2.props.onChangeCount(id, newCount, modifier_option_id, keyArray);
	                                } })
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'basket_item_error' },
	                            _react3.default.createElement('i', { className: 'fa fa-exclamation-circle' }),
	                            itemError.count_offer - 0 <= 0 ? outOfStock : available + ' ' + itemError.count_offer
	                        )
	                    ) : _react3.default.createElement(
	                        'div',
	                        null,
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'quantity_counter' },
	                            _react3.default.createElement(_components2.QuantityProduct, { value: count,
	                                checkValue: remainder_quantity !== null && remainder_quantity !== undefined,
	                                checkCount: remainder_quantity,
	                                callback: function callback(newCount) {
	                                    _this2.props.onChangeCount(id, newCount, modifier_option_id, keyArray);
	                                } })
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2 hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'price' },
	                        _react3.default.createElement(_components2.MoneyValue, {
	                            value: sum,
	                            icon: currency.icon,
	                            iconAfterValue: currency.icon_after_value
	                        })
	                    ),
	                    _react3.default.createElement('a', { className: 'close-btn pointer hidden-xs', onClick: function onClick(e) {
	                            _this2.props.onDelete(id, modifier_option_id, keyArray);
	                        } })
	                ),
	                this.props.type_id === 5 && this.props.nested_offer ? this.props.nested_offer.map(function (item, keyArray) {
	                    var sum = item.price * item.count;
	                    if (item.quantity == 0) {
	                        return null;
	                    }
	                    modifier_option_name = _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2' },
	                        _react3.default.createElement('div', { className: 'title' })
	                    );
	                    if (item.childOffer.modifierName !== null && item.childOffer.modifierName !== undefined) {
	                        modifier_option_name = _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-2 hidden-xs' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'title' },
	                                item.childOffer.modifierName
	                            )
	                        );
	                    }
	                    weight = item.quantity;
	                    if ((item.childOffer.unit.slug === 'kg' || item.childOffer.unit.slug === 'mg') && item.weight && item.weight > 0 && item.quantity > 0) {
	                        weight = item.weight * item.quantity;
	                        weight = weight.toFixed(3);
	                        if (item.weight < 0.01 && item.quantity < 1 || item.weight < 1 && item.quantity < 0.01) {
	                            weight = item.weight * 1;
	                        }
	                        if (item.weight < 0.1 && item.quantity < 0.1) {
	                            weight = item.weight * 1;
	                        }
	                    }
	                    return _react3.default.createElement(
	                        'div',
	                        { className: 'row no-margin', style: { clear: 'both' } },
	                        _react3.default.createElement('div', { className: 'col-sm-1 col-xs-12' }),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-4 visible-xs' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'title', style: { paddingLeft: '20px' } },
	                                '\u2022 ',
	                                item.childOffer.name,
	                                ' ',
	                                item.childOffer.modifierName
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { style: { paddingLeft: '30px' } },
	                                _react3.default.createElement(
	                                    'span',
	                                    null,
	                                    _this2.props.lang['store.common.quantity'],
	                                    ': '
	                                ),
	                                item.childOffer.type_id === 5 ? _react3.default.createElement(
	                                    'span',
	                                    null,
	                                    item.quantity
	                                ) : _react3.default.createElement(
	                                    'span',
	                                    null,
	                                    weight,
	                                    ' ',
	                                    _this2.props.lang[item.childOffer.unit.title_lang_data]
	                                )
	                            )
	                        ),
	                        itemError && itemError.child_offer_id !== null && itemError.child_offer_id.indexOf(item.childOffer.id) !== -1 ? _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-4 hidden-xs', style: { color: '#e9594a' } },
	                            _react3.default.createElement(
	                                'div',
	                                { style: { paddingLeft: '20px' }, className: 'title' },
	                                '\u2022\u200E ',
	                                item.childOffer.name
	                            )
	                        ) : _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-4 hidden-xs' },
	                            _react3.default.createElement(
	                                'div',
	                                { style: { paddingLeft: '20px' }, className: 'title' },
	                                '\u2022\u200E ',
	                                item.childOffer.name
	                            )
	                        ),
	                        modifier_option_name,
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-3 hidden-xs' },
	                            item.childOffer.type_id === 5 ? _react3.default.createElement(
	                                'div',
	                                { className: 'quantity_counter_child' },
	                                item.quantity
	                            ) : _react3.default.createElement(
	                                'div',
	                                { className: 'quantity_counter_child' },
	                                weight,
	                                ' ',
	                                lang[item.childOffer.unit.title_lang_data]
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-2 hidden-xs' },
	                            _react3.default.createElement('div', { className: 'price' })
	                        ),
	                        item.childOffer.type_id === 5 && item.childOffer.nestedOffers ? item.childOffer.nestedOffers.map(function (itemChild, keyArray) {
	                            return _this2.renderNested(itemChild, lang, itemError);
	                        }) : null
	                    );
	                }) : null
	            );
	        }
	    }]);
	    return BasketProductDetail;
	}(_react2.Component), _class.defaultProps = {
	    itemError: null
	}, _class.propTypes = {
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp));
	
	exports.default = BasketProductDetail;
	module.exports = exports['default'];

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FullDescription = __webpack_require__(1629);
	
	Object.defineProperty(exports, 'FullDescription', {
	  enumerable: true,
	  get: function get() {
	    return _FullDescription.FullDescription;
	  }
	});
	
	var _ShortDescription = __webpack_require__(1632);
	
	Object.defineProperty(exports, 'ShortDescription', {
	  enumerable: true,
	  get: function get() {
	    return _ShortDescription.ShortDescription;
	  }
	});
	
	var _Slider = __webpack_require__(1637);
	
	Object.defineProperty(exports, 'Slider', {
	  enumerable: true,
	  get: function get() {
	    return _Slider.Slider;
	  }
	});
	
	var _Stars = __webpack_require__(1640);
	
	Object.defineProperty(exports, 'Stars', {
	  enumerable: true,
	  get: function get() {
	    return _Stars.Stars;
	  }
	});
	
	var _Breads = __webpack_require__(1626);
	
	Object.defineProperty(exports, 'Breads', {
	  enumerable: true,
	  get: function get() {
	    return _Breads.Breads;
	  }
	});

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GREEN = exports.GREEN = 'green';
	var BLUE = exports.BLUE = 'blue';
	var ORANGE = exports.ORANGE = 'orange';
	var RED = exports.RED = 'red';
	var NAVY = exports.NAVY = 'navy';
	var DARK_GREEN = exports.DARK_GREEN = 'dark-green';
	var DARK_THEME = exports.DARK_THEME = 'dark-theme';

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _reactRouter = __webpack_require__(19);
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    MenuItem: {
	        displayName: 'MenuItem'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Menu/default/MenuBody/MenuItem.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MenuItem = _wrapComponent('MenuItem')(function (_Component) {
	    (0, _inherits3.default)(MenuItem, _Component);
	
	    function MenuItem(props) {
	        (0, _classCallCheck3.default)(this, MenuItem);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call(this, props));
	
	        _this.handleClick = function (category) {
	            return function (e) {
	                e.preventDefault();
	                _this.props.onClick_Category(category);
	            };
	        };
	
	        _this.handleClickDescription = function (category) {
	            return function (e) {
	                e.preventDefault();
	                _this.toggleDescription();
	            };
	        };
	
	        _this.state = {
	            showDescription: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(MenuItem, [{
	        key: 'toggleDescription',
	        value: function toggleDescription() {
	            this.setState(function (prevState) {
	                return { showDescription: !prevState.showDescription };
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var encapsulatePadding = 10;
	            var _props = this.props,
	                encapsulate = _props.encapsulate,
	                category = _props.category;
	
	            var firstChild = '';
	            if (encapsulate === 0) {
	                firstChild = "first_category";
	            }
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(
	                    'li',
	                    { className: 'red_style', style: { position: 'relative' } },
	                    _react3.default.createElement(
	                        'a',
	                        { className: "drop_menu_item link_underline " + firstChild, style: { paddingLeft: 0 + encapsulate },
	                            href: '#',
	                            onClick: this.handleClick(category)
	                        },
	                        _react3.default.createElement(
	                            'div',
	                            { style: { display: 'flex' } },
	                            _react3.default.createElement(
	                                'div',
	                                { style: { width: '90%' } },
	                                category.title
	                            )
	                        )
	                    ),
	                    category.picture_menu ? _react3.default.createElement('img', { src: category.picture_menu, alt: '', style: { width: '60%' } }) : null,
	                    this.state.showDescription ? _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: category.description_menu } }) : null,
	                    category.children && category.children.length > 0 ? _react3.default.createElement(
	                        'ul',
	                        null,
	                        category.children.map(function (item, index) {
	                            return _react3.default.createElement(MenuItem, {
	                                key: index,
	                                category: item,
	                                encapsulate: encapsulate + encapsulatePadding,
	                                onClick_Category: _this2.props.onClick_Category,
	                                openMenu: _this2.props.openMenu,
	                                closeMenu: _this2.props.closeMenu,
	                                toggleMenu: _this2.props.toggleMenu
	                            });
	                        })
	                    ) : null,
	                    category.description_menu ? _react3.default.createElement(
	                        'div',
	                        { style: { height: '21px',
	                                width: '10%',
	                                display: 'inline-block', padding: '.3em .6em .4em',
	                                fontSize: '85%', fontWeight: 'bold', lineHeight: 1, color: '#fff',
	                                textAlign: 'center',
	                                verticalAlign: 'top',
	                                borderRadius: '.20em',
	                                backgroundColor: '#5bc0de',
	                                position: 'absolute',
	                                top: '14px',
	                                left: '90%'
	                            },
	                            onClick: this.handleClickDescription(category)
	                        },
	                        _react3.default.createElement(
	                            'i',
	                            null,
	                            'i'
	                        )
	                    ) : null
	                )
	            );
	        }
	    }]);
	    return MenuItem;
	}(_react2.Component));
	
	exports.default = MenuItem;
	;
	module.exports = exports['default'];

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Названия типов модальных окон
	 * @type {string}
	 */
	var ADD = exports.ADD = 'add';
	var DELETE = exports.DELETE = 'del';
	var EDIT = exports.EDIT = 'edit';
	var INFO = exports.INFO = 'info';
	var SAVE = exports.SAVE = 'save';
	var ADD_TO_CART = exports.ADD_TO_CART = 'addToCart';
	var ALCOHOL_MODAL = exports.ALCOHOL_MODAL = 'alcoModal';
	var MODIFIER_MODAL = exports.MODIFIER_MODAL = 'modifierModal';
	var BUY_IN_CREDIT_MODAL = exports.BUY_IN_CREDIT_MODAL = 'BuyInCreditModal';
	var AUTH = exports.AUTH = 'auth';
	var AUTH_ONE_CLICK = exports.AUTH_ONE_CLICK = 'authOneClick';
	var REGISTRATION = exports.REGISTRATION = 'registration';
	var CONFIRM_PHONE = exports.CONFIRM_PHONE = 'confirmPhone';
	var CONFIRM_CHANGE_PHONE = exports.CONFIRM_CHANGE_PHONE = 'confirmChangePhone';
	var CONFIRM_MAIL = exports.CONFIRM_MAIL = 'confirmMail';
	var PASSWORD_CHANGE = exports.PASSWORD_CHANGE = 'password_change';
	var CONFIRM_OLD_MAIL = exports.CONFIRM_OLD_MAIL = 'confirmOldMail';
	var PASS_RECOVERY = exports.PASS_RECOVERY = 'passRecovery';
	/** Открытие модального окна с картой */
	var MAP_MODAL = exports.MAP_MODAL = 'mapModal';
	/** Сохранение прошло успешно */
	var SAVE_SUCCESS = exports.SAVE_SUCCESS = 'successfulSave';

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PassRecoveryStepThree = exports.PassRecoveryStepTwo = exports.PassRecoveryStepOne = exports.PassRecovery = undefined;
	
	var _PassRecoveryStepOne = __webpack_require__(1722);
	
	Object.defineProperty(exports, 'PassRecoveryStepOne', {
	  enumerable: true,
	  get: function get() {
	    return _PassRecoveryStepOne.PassRecoveryStepOne;
	  }
	});
	
	var _PassRecoveryStepTwo = __webpack_require__(1728);
	
	Object.defineProperty(exports, 'PassRecoveryStepTwo', {
	  enumerable: true,
	  get: function get() {
	    return _PassRecoveryStepTwo.PassRecoveryStepTwo;
	  }
	});
	
	var _PassRecoveryStepThree = __webpack_require__(1725);
	
	Object.defineProperty(exports, 'PassRecoveryStepThree', {
	  enumerable: true,
	  get: function get() {
	    return _PassRecoveryStepThree.PassRecoveryStepThree;
	  }
	});
	
	var _PassRecovery2 = __webpack_require__(1719);
	
	var _PassRecovery3 = _interopRequireDefault(_PassRecovery2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.PassRecovery = _PassRecovery3.default;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(197);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _rawStatusToType, _class, _temp;
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(15);
	
	var _PaymentStatus = __webpack_require__(163);
	
	var _PaymentStatus2 = _interopRequireDefault(_PaymentStatus);
	
	var _PaymentStatusConstants = __webpack_require__(385);
	
	var PaymentStatusConstants = _interopRequireWildcard(_PaymentStatusConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PaymentStatusLabel: {
	        displayName: 'PaymentStatusLabel'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/PaymentStatusLabel/PaymentStatusLabel.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var rawStatusToType = (_rawStatusToType = {}, (0, _defineProperty3.default)(_rawStatusToType, PaymentStatusConstants.PAYMENT_STATUS_MONEY_TRANSFER, 'info'), (0, _defineProperty3.default)(_rawStatusToType, PaymentStatusConstants.PAYMENT_STATUS_RETURN, 'info'), (0, _defineProperty3.default)(_rawStatusToType, PaymentStatusConstants.PAYMENT_STATUS_PARTIALLY_RETURN, 'info'), (0, _defineProperty3.default)(_rawStatusToType, PaymentStatusConstants.PAYMENT_STATUS_PAY, 'success'), (0, _defineProperty3.default)(_rawStatusToType, PaymentStatusConstants.PAYMENT_STATUS_NOT_PAY, 'info'), (0, _defineProperty3.default)(_rawStatusToType, PaymentStatusConstants.PAYMENT_STATUS_OUTDATED, 'warning'), (0, _defineProperty3.default)(_rawStatusToType, PaymentStatusConstants.PAYMENT_STATUS_CANCEL, 'danger'), _rawStatusToType);
	
	var PaymentStatusLabel = _wrapComponent('PaymentStatusLabel')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(PaymentStatusLabel, _Component);
	
	    function PaymentStatusLabel(props) {
	        (0, _classCallCheck3.default)(this, PaymentStatusLabel);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentStatusLabel.__proto__ || (0, _getPrototypeOf2.default)(PaymentStatusLabel)).call(this, props));
	
	        _this.paymentStatusHelper = null;
	
	        _this.paymentStatusHelper = new _PaymentStatus2.default(props.rawStatus);
	        return _this;
	    }
	
	    (0, _createClass3.default)(PaymentStatusLabel, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nProp) {
	            if (this.props.rawStatus !== nProp.rawStatus) {
	                this.paymentStatusHelper = new _PaymentStatus2.default(nProp.rawStatus);
	            }
	        }
	    }, {
	        key: 'getLabelTypeForRawStatus',
	        value: function getLabelTypeForRawStatus() {
	            return rawStatusToType[this.props.rawStatus];
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('PaymentStatusLabel');
	
	            return _react3.default.createElement(View, {
	                type: this.getLabelTypeForRawStatus(),
	                labelText: this.paymentStatusHelper.toString()
	            });
	        }
	    }]);
	    return PaymentStatusLabel;
	}(_react2.Component), _class.propTypes = {
	    rawStatus: _propTypes2.default.number.isRequired
	}, _temp));
	
	exports.default = PaymentStatusLabel;
	module.exports = exports['default'];

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Preloader: {
	        displayName: 'Preloader'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Preloader/Preloader.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Preloader = _wrapComponent('Preloader')((_dec = (0, _reactRedux.connect)(function (state) {
	    return { theme: state.setting.theme };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Preloader, _Component);
	
	    function Preloader() {
	        (0, _classCallCheck3.default)(this, Preloader);
	        return (0, _possibleConstructorReturn3.default)(this, (Preloader.__proto__ || (0, _getPrototypeOf2.default)(Preloader)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Preloader, [{
	        key: 'render',
	        value: function render() {
	            var preload = this.props.preload;
	
	            var View = _helpers.ThemeHelper.getViewForComponent('Preloader');
	
	            if (preload) {
	                return _react3.default.createElement(View, { classNames: this.props.classNames, color: this.props.theme });
	            } else {
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'u-full-height' },
	                    this.props.children
	                );
	            }
	        }
	    }]);
	    return Preloader;
	}(_react2.Component), _class2.propTypes = {
	    preload: _react2.PropTypes.bool.isRequired,
	    children: _react2.PropTypes.object,
	    classNames: _react2.PropTypes.string
	}, _class2.defaultProps = {
	    classNames: ''
	}, _temp)) || _class));
	
	exports.default = Preloader;
	module.exports = exports['default'];

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _keys = __webpack_require__(69);
	
	var _keys2 = _interopRequireDefault2(_keys);
	
	var _getOwnPropertyNames = __webpack_require__(774);
	
	var _getOwnPropertyNames2 = _interopRequireDefault2(_getOwnPropertyNames);
	
	var _getOwnPropertySymbols = __webpack_require__(775);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault2(_getOwnPropertySymbols);
	
	var _from = __webpack_require__(196);
	
	var _from2 = _interopRequireDefault2(_from);
	
	var _assign = __webpack_require__(142);
	
	var _assign2 = _interopRequireDefault2(_assign);
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault2(_typeof2);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if (( false ? 'undefined' : (0, _typeof3.default)(exports)) === 'object' && ( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object') module.exports = factory(__webpack_require__(1), __webpack_require__(28));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(28)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object') exports["Slider"] = factory(require("react"), require("react-dom"));else root["Slider"] = factory(root["React"], root["ReactDOM"]);
	})(undefined, function (__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_6__) {
		return (/******/function (modules) {
				// webpackBootstrap
				/******/ // The module cache
				/******/var installedModules = {};
	
				/******/ // The require function
				/******/function __webpack_require__(moduleId) {
	
					/******/ // Check if module is in cache
					/******/if (installedModules[moduleId])
						/******/return installedModules[moduleId].exports;
	
					/******/ // Create a new module (and put it into the cache)
					/******/var module = installedModules[moduleId] = {
						/******/exports: {},
						/******/id: moduleId,
						/******/loaded: false
						/******/ };
	
					/******/ // Execute the module function
					/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
					/******/ // Flag the module as loaded
					/******/module.loaded = true;
	
					/******/ // Return the exports of the module
					/******/return module.exports;
					/******/
				}
	
				/******/ // expose the modules object (__webpack_modules__)
				/******/__webpack_require__.m = modules;
	
				/******/ // expose the module cache
				/******/__webpack_require__.c = installedModules;
	
				/******/ // __webpack_public_path__
				/******/__webpack_require__.p = "";
	
				/******/ // Load entry module and return exports
				/******/return __webpack_require__(0);
				/******/
			}(
			/************************************************************************/
			/******/[
			/* 0 */
			/***/function (module, exports, __webpack_require__) {
	
				'use strict';
	
				module.exports = __webpack_require__(1);
	
				/***/
			},
			/* 1 */
			/***/function (module, exports, __webpack_require__) {
	
				'use strict';
	
				var _extends = _assign2.default || function (target) {
					for (var i = 1; i < arguments.length; i++) {
						var source = arguments[i];for (var key in source) {
							if (Object.prototype.hasOwnProperty.call(source, key)) {
								target[key] = source[key];
							}
						}
					}return target;
				};
	
				var _react = __webpack_require__(2);
	
				var _react2 = _interopRequireDefault(_react);
	
				var _innerSlider = __webpack_require__(3);
	
				var _objectAssign = __webpack_require__(7);
	
				var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
				var _json2mq = __webpack_require__(15);
	
				var _json2mq2 = _interopRequireDefault(_json2mq);
	
				var _reactResponsiveMixin = __webpack_require__(17);
	
				var _reactResponsiveMixin2 = _interopRequireDefault(_reactResponsiveMixin);
	
				var _defaultProps = __webpack_require__(10);
	
				var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { default: obj };
				}
	
				var Slider = _react2.default.createClass({
					displayName: 'Slider',
	
					mixins: [_reactResponsiveMixin2.default],
					innerSlider: null,
					innerSliderRefHandler: function innerSliderRefHandler(ref) {
						this.innerSlider = ref;
					},
					getInitialState: function getInitialState() {
						return {
							breakpoint: null
						};
					},
					componentWillMount: function componentWillMount() {
						var _this = this;
	
						if (this.props.responsive) {
							var breakpoints = this.props.responsive.map(function (breakpt) {
								return breakpt.breakpoint;
							});
							breakpoints.sort(function (x, y) {
								return x - y;
							});
	
							breakpoints.forEach(function (breakpoint, index) {
								var bQuery;
								if (index === 0) {
									bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
								} else {
									bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
								}
								_this.media(bQuery, function () {
									_this.setState({ breakpoint: breakpoint });
								});
							});
	
							// Register media query for full screen. Need to support resize from small to large
							var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
							this.media(query, function () {
								_this.setState({ breakpoint: null });
							});
						}
					},
	
					slickPrev: function slickPrev() {
						this.innerSlider.slickPrev();
					},
	
					slickNext: function slickNext() {
						this.innerSlider.slickNext();
					},
	
					slickGoTo: function slickGoTo(slide) {
						this.innerSlider.slickGoTo(slide);
					},
	
					render: function render() {
						var _this2 = this;
	
						var settings;
						var newProps;
						if (this.state.breakpoint) {
							newProps = this.props.responsive.filter(function (resp) {
								return resp.breakpoint === _this2.state.breakpoint;
							});
							settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
						} else {
							settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
						}
	
						var children = this.props.children;
						if (!Array.isArray(children)) {
							children = [children];
						}
	
						// Children may contain false or null, so we should filter them
						children = children.filter(function (child) {
							return !!child;
						});
	
						if (settings === 'unslick') {
							// if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
							return _react2.default.createElement('div', null, children);
						} else {
							return _react2.default.createElement(_innerSlider.InnerSlider, _extends({ ref: this.innerSliderRefHandler }, settings), children);
						}
					}
				});
	
				module.exports = Slider;
	
				/***/
			},
			/* 2 */
			/***/function (module, exports) {
	
				module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
				/***/
			},
			/* 3 */
			/***/function (module, exports, __webpack_require__) {
	
				'use strict';
	
				exports.__esModule = true;
				exports.InnerSlider = undefined;
	
				var _extends = _assign2.default || function (target) {
					for (var i = 1; i < arguments.length; i++) {
						var source = arguments[i];for (var key in source) {
							if (Object.prototype.hasOwnProperty.call(source, key)) {
								target[key] = source[key];
							}
						}
					}return target;
				};
	
				var _react = __webpack_require__(2);
	
				var _react2 = _interopRequireDefault(_react);
	
				var _eventHandlers = __webpack_require__(4);
	
				var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
				var _helpers = __webpack_require__(8);
	
				var _helpers2 = _interopRequireDefault(_helpers);
	
				var _initialState = __webpack_require__(9);
	
				var _initialState2 = _interopRequireDefault(_initialState);
	
				var _defaultProps = __webpack_require__(10);
	
				var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
				var _classnames = __webpack_require__(11);
	
				var _classnames2 = _interopRequireDefault(_classnames);
	
				var _objectAssign = __webpack_require__(7);
	
				var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
				var _track = __webpack_require__(12);
	
				var _dots = __webpack_require__(13);
	
				var _arrows = __webpack_require__(14);
	
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { default: obj };
				}
	
				var InnerSlider = exports.InnerSlider = _react2.default.createClass({
					displayName: 'InnerSlider',
	
					mixins: [_helpers2.default, _eventHandlers2.default],
					list: null,
					track: null,
					serverRender: function serverRender() {
						return typeof window == 'undefined';
					},
					legacyFunctions: function legacyFunctions() {
						return this.props.variableWidth || this.props.vertical || this.props.centerMode;
					},
					listRefHandler: function listRefHandler(ref) {
						this.list = ref;
					},
					trackRefHandler: function trackRefHandler(ref) {
						this.track = ref;
					},
					getInitialState: function getInitialState() {
						return _extends({}, _initialState2.default, {
							currentSlide: this.props.initialSlide
						});
					},
					getDefaultProps: function getDefaultProps() {
						return _defaultProps2.default;
					},
					componentWillMount: function componentWillMount() {
						if (this.props.init) {
							this.props.init();
						}
						this.setState({
							mounted: true
						});
						var lazyLoadedList = [];
						for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
							if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
								lazyLoadedList.push(i);
							}
						}
	
						if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
							this.setState({
								lazyLoadedList: lazyLoadedList
							});
						}
	
						if (this.serverRender() && !this.legacyFunctions()) {
							this.serverInitialize(this.props);
						}
					},
					componentDidMount: function componentDidMount() {
						// Hack for autoplay -- Inspect Later
						// this.firstRender = false;
						if (!this.serverRender()) {
							this.initialize(this.props);
						}
						this.adaptHeight();
	
						// To support server-side rendering
						if (!window) {
							return;
						}
						if (window.addEventListener) {
							window.addEventListener('resize', this.onWindowResized);
						} else {
							window.attachEvent('onresize', this.onWindowResized);
						}
					},
					componentWillUnmount: function componentWillUnmount() {
						if (this.animationEndCallback) {
							clearTimeout(this.animationEndCallback);
						}
						if (window.addEventListener) {
							window.removeEventListener('resize', this.onWindowResized);
						} else {
							window.detachEvent('onresize', this.onWindowResized);
						}
						if (this.state.autoPlayTimer) {
							clearInterval(this.state.autoPlayTimer);
						}
					},
					componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
						if (this.props.slickGoTo != nextProps.slickGoTo) {
							if (undefined !== 'production') {
								console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
							}
							this.changeSlide({
								message: 'index',
								index: nextProps.slickGoTo,
								currentSlide: this.state.currentSlide
							});
						} else if (this.state.currentSlide >= nextProps.children.length) {
							this.update(nextProps);
							this.changeSlide({
								message: 'index',
								index: nextProps.children.length - nextProps.slidesToShow,
								currentSlide: this.state.currentSlide
							});
						} else {
							this.update(nextProps);
						}
					},
					componentDidUpdate: function componentDidUpdate() {
						this.adaptHeight();
					},
					onWindowResized: function onWindowResized() {
						this.update(this.props);
						// animating state should be cleared while resizing, otherwise autoplay stops working
						this.setState({
							animating: false
						});
						clearTimeout(this.animationEndCallback);
						delete this.animationEndCallback;
					},
					slickPrev: function slickPrev() {
						this.changeSlide({ message: 'previous' });
					},
					slickNext: function slickNext() {
						this.changeSlide({ message: 'next' });
					},
					slickGoTo: function slickGoTo(slide) {
						typeof slide === 'number' && this.changeSlide({
							message: 'index',
							index: slide,
							currentSlide: this.state.currentSlide
						});
					},
					render: function render() {
						var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
							'slick-vertical': this.props.vertical
						});
	
						var trackProps = {
							fade: this.props.fade,
							cssEase: this.props.cssEase,
							speed: this.props.speed,
							infinite: this.props.infinite,
							centerMode: this.props.centerMode,
							focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
							currentSlide: this.state.currentSlide,
							lazyLoad: this.props.lazyLoad,
							lazyLoadedList: this.state.lazyLoadedList,
							rtl: this.props.rtl,
							slideWidth: this.state.slideWidth,
							slidesToShow: this.props.slidesToShow,
							slidesToScroll: this.props.slidesToScroll,
							slideCount: this.state.slideCount,
							trackStyle: this.state.trackStyle,
							variableWidth: this.props.variableWidth,
							percentUnit: this.state.percentUnit
						};
	
						var dots;
	
						if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
							var dotProps = {
								dotsClass: this.props.dotsClass,
								slideCount: this.state.slideCount,
								slidesToShow: this.props.slidesToShow,
								currentSlide: this.state.currentSlide,
								slidesToScroll: this.props.slidesToScroll,
								clickHandler: this.changeSlide,
								children: this.props.children,
								customPaging: this.props.customPaging
							};
	
							dots = _react2.default.createElement(_dots.Dots, dotProps);
						}
	
						var prevArrow, nextArrow;
	
						var arrowProps = {
							infinite: this.props.infinite,
							centerMode: this.props.centerMode,
							currentSlide: this.state.currentSlide,
							slideCount: this.state.slideCount,
							slidesToShow: this.props.slidesToShow,
							prevArrow: this.props.prevArrow,
							nextArrow: this.props.nextArrow,
							clickHandler: this.changeSlide
						};
	
						if (this.props.arrows) {
							prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
							nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
						}
	
						var verticalHeightStyle = null;
	
						if (this.props.vertical) {
							verticalHeightStyle = {
								height: this.state.listHeight
							};
						}
	
						var centerPaddingStyle = null;
	
						if (this.props.vertical === false) {
							if (this.props.centerMode === true) {
								centerPaddingStyle = {
									padding: '0px ' + this.props.centerPadding
								};
							}
						} else {
							if (this.props.centerMode === true) {
								centerPaddingStyle = {
									padding: this.props.centerPadding + ' 0px'
								};
							}
						}
	
						var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
						return _react2.default.createElement('div', { className: className, onMouseEnter: this.onInnerSliderEnter, onMouseLeave: this.onInnerSliderLeave }, prevArrow, _react2.default.createElement('div', {
							ref: this.listRefHandler,
							className: 'slick-list',
							style: listStyle,
							onMouseDown: this.swipeStart,
							onMouseMove: this.state.dragging ? this.swipeMove : null,
							onMouseUp: this.swipeEnd,
							onMouseLeave: this.state.dragging ? this.swipeEnd : null,
							onTouchStart: this.swipeStart,
							onTouchMove: this.state.dragging ? this.swipeMove : null,
							onTouchEnd: this.swipeEnd,
							onTouchCancel: this.state.dragging ? this.swipeEnd : null,
							onKeyDown: this.props.accessibility ? this.keyHandler : null }, _react2.default.createElement(_track.Track, _extends({ ref: this.trackRefHandler }, trackProps), this.props.children)), nextArrow, dots);
					}
				});
	
				/***/
			},
			/* 4 */
			/***/function (module, exports, __webpack_require__) {
	
				'use strict';
	
				exports.__esModule = true;
	
				var _trackHelper = __webpack_require__(5);
	
				var _helpers = __webpack_require__(8);
	
				var _helpers2 = _interopRequireDefault(_helpers);
	
				var _objectAssign = __webpack_require__(7);
	
				var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
				var _reactDom = __webpack_require__(6);
	
				var _reactDom2 = _interopRequireDefault(_reactDom);
	
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { default: obj };
				}
	
				var EventHandlers = {
					// Event handler for previous and next
					changeSlide: function changeSlide(options) {
						var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
						var _props = this.props,
						    slidesToScroll = _props.slidesToScroll,
						    slidesToShow = _props.slidesToShow;
						var _state = this.state,
						    slideCount = _state.slideCount,
						    currentSlide = _state.currentSlide;
	
						unevenOffset = slideCount % slidesToScroll !== 0;
						indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
						if (options.message === 'previous') {
							slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
							targetSlide = currentSlide - slideOffset;
							if (this.props.lazyLoad) {
								previousInt = currentSlide - slideOffset;
								targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
							}
						} else if (options.message === 'next') {
							slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
							targetSlide = currentSlide + slideOffset;
							if (this.props.lazyLoad) {
								targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
							}
						} else if (options.message === 'dots' || options.message === 'children') {
							// Click on dots
							targetSlide = options.index * options.slidesToScroll;
							if (targetSlide === options.currentSlide) {
								return;
							}
						} else if (options.message === 'index') {
							targetSlide = parseInt(options.index);
							if (targetSlide === options.currentSlide) {
								return;
							}
						}
	
						this.slideHandler(targetSlide);
					},
					// Accessiblity handler for previous and next
					keyHandler: function keyHandler(e) {
						//Dont slide if the cursor is inside the form fields and arrow keys are pressed
						if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
							if (e.keyCode === 37 && this.props.accessibility === true) {
								this.changeSlide({
									message: this.props.rtl === true ? 'next' : 'previous'
								});
							} else if (e.keyCode === 39 && this.props.accessibility === true) {
								this.changeSlide({
									message: this.props.rtl === true ? 'previous' : 'next'
								});
							}
						}
					},
					// Focus on selecting a slide (click handler on track)
					selectHandler: function selectHandler(options) {
						this.changeSlide(options);
					},
					swipeStart: function swipeStart(e) {
						var touches, posX, posY;
	
						if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
							return;
						} else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
							return;
						}
						posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
						posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
						this.setState({
							dragging: true,
							touchObject: {
								startX: posX,
								startY: posY,
								curX: posX,
								curY: posY
							}
						});
					},
					swipeMove: function swipeMove(e) {
						if (!this.state.dragging) {
							e.preventDefault();
							return;
						}
						if (this.state.animating) {
							return;
						}
						if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
							e.preventDefault();
						}
						var swipeLeft;
						var curLeft, positionOffset;
						var touchObject = this.state.touchObject;
	
						curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
							slideIndex: this.state.currentSlide,
							trackRef: this.track
						}, this.props, this.state));
						touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
						touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
						touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	
						if (this.props.verticalSwiping) {
							touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
						}
	
						positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
						if (this.props.verticalSwiping) {
							positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
						}
	
						var currentSlide = this.state.currentSlide;
						var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
						var swipeDirection = this.swipeDirection(this.state.touchObject);
						var touchSwipeLength = touchObject.swipeLength;
	
						if (this.props.infinite === false) {
							if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
								touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
								if (this.state.edgeDragged === false && this.props.edgeEvent) {
									this.props.edgeEvent(swipeDirection);
									this.setState({ edgeDragged: true });
								}
							}
						}
	
						if (this.state.swiped === false && this.props.swipeEvent) {
							this.props.swipeEvent(swipeDirection);
							this.setState({ swiped: true });
						}
	
						if (!this.props.vertical) {
							swipeLeft = curLeft + touchSwipeLength * positionOffset;
						} else {
							swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
						}
	
						if (this.props.verticalSwiping) {
							swipeLeft = curLeft + touchSwipeLength * positionOffset;
						}
	
						this.setState({
							touchObject: touchObject,
							swipeLeft: swipeLeft,
							trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
						});
	
						if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
							return;
						}
						if (touchObject.swipeLength > 4) {
							e.preventDefault();
						}
					},
					getNavigableIndexes: function getNavigableIndexes() {
						var max = void 0;
						var breakPoint = 0;
						var counter = 0;
						var indexes = [];
	
						if (!this.props.infinite) {
							max = this.state.slideCount;
						} else {
							breakPoint = this.props.slidesToShow * -1;
							counter = this.props.slidesToShow * -1;
							max = this.state.slideCount * 2;
						}
	
						while (breakPoint < max) {
							indexes.push(breakPoint);
							breakPoint = counter + this.props.slidesToScroll;
	
							counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
						}
	
						return indexes;
					},
					checkNavigable: function checkNavigable(index) {
						var navigables = this.getNavigableIndexes();
						var prevNavigable = 0;
	
						if (index > navigables[navigables.length - 1]) {
							index = navigables[navigables.length - 1];
						} else {
							for (var n in navigables) {
								if (index < navigables[n]) {
									index = prevNavigable;
									break;
								}
	
								prevNavigable = navigables[n];
							}
						}
	
						return index;
					},
					getSlideCount: function getSlideCount() {
						var _this = this;
	
						var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
						if (this.props.swipeToSlide) {
							var swipedSlide = void 0;
	
							var slickList = _reactDom2.default.findDOMNode(this.list);
	
							var slides = slickList.querySelectorAll('.slick-slide');
	
							(0, _from2.default)(slides).every(function (slide) {
								if (!_this.props.vertical) {
									if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
										swipedSlide = slide;
										return false;
									}
								} else {
									if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
										swipedSlide = slide;
										return false;
									}
								}
	
								return true;
							});
	
							var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;
	
							return slidesTraversed;
						} else {
							return this.props.slidesToScroll;
						}
					},
	
					swipeEnd: function swipeEnd(e) {
						if (!this.state.dragging) {
							e.preventDefault();
							return;
						}
						var touchObject = this.state.touchObject;
						var minSwipe = this.state.listWidth / this.props.touchThreshold;
						var swipeDirection = this.swipeDirection(touchObject);
	
						if (this.props.verticalSwiping) {
							minSwipe = this.state.listHeight / this.props.touchThreshold;
						}
	
						// reset the state of touch related state variables.
						this.setState({
							dragging: false,
							edgeDragged: false,
							swiped: false,
							swipeLeft: null,
							touchObject: {}
						});
						// Fix for #13
						if (!touchObject.swipeLength) {
							return;
						}
						if (touchObject.swipeLength > minSwipe) {
							e.preventDefault();
	
							var slideCount = void 0,
							    newSlide = void 0;
	
							switch (swipeDirection) {
	
								case 'left':
								case 'down':
									newSlide = this.state.currentSlide + this.getSlideCount();
									slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
									this.state.currentDirection = 0;
									break;
	
								case 'right':
								case 'up':
									newSlide = this.state.currentSlide - this.getSlideCount();
									slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
									this.state.currentDirection = 1;
									break;
	
								default:
									slideCount = this.state.currentSlide;
	
							}
	
							this.slideHandler(slideCount);
						} else {
							// Adjust the track back to it's original position.
							var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
								slideIndex: this.state.currentSlide,
								trackRef: this.track
							}, this.props, this.state));
	
							this.setState({
								trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
							});
						}
					},
					onInnerSliderEnter: function onInnerSliderEnter(e) {
						if (this.props.autoplay && this.props.pauseOnHover) {
							this.pause();
						}
					},
					onInnerSliderLeave: function onInnerSliderLeave(e) {
						if (this.props.autoplay && this.props.pauseOnHover) {
							this.autoPlay();
						}
					}
				};
	
				exports.default = EventHandlers;
	
				/***/
			},
			/* 5 */
			/***/function (module, exports, __webpack_require__) {
	
				'use strict';
	
				exports.__esModule = true;
				exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	
				var _reactDom = __webpack_require__(6);
	
				var _reactDom2 = _interopRequireDefault(_reactDom);
	
				var _objectAssign = __webpack_require__(7);
	
				var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { default: obj };
				}
	
				var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
					return keysArray.reduce(function (value, key) {
						return value && spec.hasOwnProperty(key);
					}, true) ? null : console.error('Keys Missing', spec);
				};
	
				var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
					checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
					var trackWidth, trackHeight;
					var legacyFunctions = spec.variableWidth || spec.vertical || spec.centerMode;
					var percentUnit = spec.percentUnit;
	
					var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
					if (!spec.vertical) {
						if (spec.centerMode) {
							trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
						} else {
							if (percentUnit) {
								if (spec.slidesToShow == 1) {
									trackWidth = 100 * trackChildren;
								} else {
									trackWidth = 100 + (trackChildren - spec.slidesToShow) * (100 / spec.slidesToShow);
								}
							} else {
								trackWidth = trackChildren * spec.slideWidth;
							}
						}
					} else {
						trackHeight = trackChildren * spec.slideHeight;
					}
	
					var sizeUnit = percentUnit ? '%' : 'px';
	
					var style = {
						opacity: 1,
						WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + sizeUnit + ', 0px, 0px)' : 'translate3d(0px, ' + spec.left + sizeUnit + ', 0px)',
						transform: !spec.vertical ? 'translate3d(' + spec.left + sizeUnit + ', 0px, 0px)' : 'translate3d(0px, ' + spec.left + sizeUnit + ', 0px)',
						transition: '',
						WebkitTransition: '',
						msTransform: !spec.vertical ? 'translateX(' + spec.left + sizeUnit + ')' : 'translateY(' + spec.left + sizeUnit + ')'
					};
	
					if (trackWidth) {
						(0, _objectAssign2.default)(style, { width: trackWidth + sizeUnit });
					}
	
					if (trackHeight) {
						(0, _objectAssign2.default)(style, { height: trackHeight });
					}
	
					if (legacyFunctions) {
						// Fallback for IE8
						if (window && !window.addEventListener && window.attachEvent) {
							if (!spec.vertical) {
								style.marginLeft = spec.left + sizeUnit;
							} else {
								style.marginTop = spec.left + sizeUnit;
							}
						}
					}
	
					return style;
				};
	
				var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
					checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
					var style = getTrackCSS(spec);
					// useCSS is true by default so it can be undefined
					style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
					style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
					return style;
				};
	
				var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
					checkSpecKeys(spec, ['slideIndex', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
					var slideOffset = 0;
					var targetLeft;
					var targetSlide;
					var verticalOffset = 0;
	
					if (spec.fade) {
						return 0;
					}
	
					if (spec.infinite) {
						if (spec.slideCount >= spec.slidesToShow) {
							slideOffset = spec.slideWidth * spec.slidesToShow * -1;
							verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
						}
						if (spec.slideCount % spec.slidesToScroll !== 0) {
							if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
								if (spec.slideIndex > spec.slideCount) {
									slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
									verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
								} else {
									slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
									verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
								}
							}
						}
					} else {
	
						if (spec.slideCount % spec.slidesToScroll !== 0) {
							if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
								var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
								slideOffset = slidesToOffset * spec.slideWidth;
							}
						}
					}
	
					if (spec.centerMode) {
						if (spec.infinite) {
							slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
						} else {
							slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
						}
					}
	
					if (!spec.vertical) {
						targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
					} else {
						targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
					}
	
					if (spec.variableWidth === true) {
						var targetSlideIndex;
						if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
							targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
						} else {
							targetSlideIndex = spec.slideIndex + spec.slidesToShow;
							targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
						}
						targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
						if (spec.centerMode === true) {
							if (spec.infinite === false) {
								targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
							} else {
								targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
							}
	
							targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
							targetLeft += (spec.listWidth - targetSlide.offsetWidth) / 2;
						}
					}
	
					return targetLeft;
				};
	
				/***/
			},
			/* 6 */
			/***/function (module, exports) {
	
				module.exports = __WEBPACK_EXTERNAL_MODULE_6__;
	
				/***/
			},
			/* 7 */
			/***/function (module, exports) {
	
				/*
	   object-assign
	   (c) Sindre Sorhus
	   @license MIT
	   */
	
				'use strict';
				/* eslint-disable no-unused-vars */
	
				var getOwnPropertySymbols = _getOwnPropertySymbols2.default;
				var hasOwnProperty = Object.prototype.hasOwnProperty;
				var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
				function toObject(val) {
					if (val === null || val === undefined) {
						throw new TypeError('Object.assign cannot be called with null or undefined');
					}
	
					return Object(val);
				}
	
				function shouldUseNative() {
					try {
						if (!_assign2.default) {
							return false;
						}
	
						// Detect buggy property enumeration order in older V8 versions.
	
						// https://bugs.chromium.org/p/v8/issues/detail?id=4118
						var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
						test1[5] = 'de';
						if ((0, _getOwnPropertyNames2.default)(test1)[0] === '5') {
							return false;
						}
	
						// https://bugs.chromium.org/p/v8/issues/detail?id=3056
						var test2 = {};
						for (var i = 0; i < 10; i++) {
							test2['_' + String.fromCharCode(i)] = i;
						}
						var order2 = (0, _getOwnPropertyNames2.default)(test2).map(function (n) {
							return test2[n];
						});
						if (order2.join('') !== '0123456789') {
							return false;
						}
	
						// https://bugs.chromium.org/p/v8/issues/detail?id=3056
						var test3 = {};
						'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
							test3[letter] = letter;
						});
						if ((0, _keys2.default)((0, _assign2.default)({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
							return false;
						}
	
						return true;
					} catch (err) {
						// We don't expect any of the above to throw, but better to be safe.
						return false;
					}
				}
	
				module.exports = shouldUseNative() ? _assign2.default : function (target, source) {
					var from;
					var to = toObject(target);
					var symbols;
	
					for (var s = 1; s < arguments.length; s++) {
						from = Object(arguments[s]);
	
						for (var key in from) {
							if (hasOwnProperty.call(from, key)) {
								to[key] = from[key];
							}
						}
	
						if (getOwnPropertySymbols) {
							symbols = getOwnPropertySymbols(from);
							for (var i = 0; i < symbols.length; i++) {
								if (propIsEnumerable.call(from, symbols[i])) {
									to[symbols[i]] = from[symbols[i]];
								}
							}
						}
					}
	
					return to;
				};
	
				/***/
			},
			/* 8 */
			/***/function (module, exports, __webpack_require__) {
	
				'use strict';
	
				exports.__esModule = true;
	
				var _extends = _assign2.default || function (target) {
					for (var i = 1; i < arguments.length; i++) {
						var source = arguments[i];for (var key in source) {
							if (Object.prototype.hasOwnProperty.call(source, key)) {
								target[key] = source[key];
							}
						}
					}return target;
				};
	
				var _react = __webpack_require__(2);
	
				var _react2 = _interopRequireDefault(_react);
	
				var _reactDom = __webpack_require__(6);
	
				var _reactDom2 = _interopRequireDefault(_reactDom);
	
				var _trackHelper = __webpack_require__(5);
	
				var _objectAssign = __webpack_require__(7);
	
				var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { default: obj };
				}
	
				var helpers = {
					initialize: function initialize(props) {
						var slickList = _reactDom2.default.findDOMNode(this.list);
	
						var slideCount = _react2.default.Children.count(props.children);
						var listWidth = this.getWidth(slickList);
						var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
						var slideWidth = this.getSlideWidth(props);
	
						var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
						var listHeight = slideHeight * props.slidesToShow;
	
						var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
						var percentUnit = false;
	
						this.setState({
							slideCount: slideCount,
							slideWidth: slideWidth,
							listWidth: listWidth,
							trackWidth: trackWidth,
							currentSlide: currentSlide,
							slideHeight: slideHeight,
							listHeight: listHeight,
							percentUnit: percentUnit
						}, function () {
	
							var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
								slideIndex: this.state.currentSlide,
								trackRef: this.track
							}, props, this.state));
							// getCSS function needs previously set state
							var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
							this.setState({ trackStyle: trackStyle });
	
							this.autoPlay(); // once we're set up, trigger the initial autoplay.
						});
					},
					serverInitialize: function serverInitialize(props) {
						var slideCount = _react2.default.Children.count(props.children);
						var listWidth = 100;
						var trackWidth = 100;
						var slideWidth = this.getSlidePercentWidth(props);
						var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
						var slideHeight = null;
						var listHeight = null;
	
						var percentUnit = true;
	
						var stateValues = {
							slideCount: slideCount,
							slideWidth: slideWidth,
							listWidth: listWidth,
							trackWidth: trackWidth,
							currentSlide: currentSlide,
							slideHeight: slideHeight,
							listHeight: listHeight,
							percentUnit: percentUnit
						};
	
						var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
							trackRef: this.track,
							slideIndex: currentSlide
						}, props, this.state, stateValues));
						// getCSS function needs previously set state
						var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state, stateValues));
	
						this.setState({
							slideCount: slideCount,
							slideWidth: slideWidth,
							listWidth: listWidth,
							trackWidth: trackWidth,
							currentSlide: currentSlide,
							slideHeight: slideHeight,
							listHeight: listHeight,
							trackStyle: trackStyle,
							percentUnit: percentUnit
						});
					},
					update: function update(props) {
						var slickList = _reactDom2.default.findDOMNode(this.list);
						// This method has mostly same code as initialize method.
						// Refactor it
						var slideCount = _react2.default.Children.count(props.children);
						var listWidth = this.getWidth(slickList);
						var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
						var slideWidth = this.getSlideWidth(props);
	
						var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
						var listHeight = slideHeight * props.slidesToShow;
	
						var percentUnit = false;
	
						// pause slider if autoplay is set to false
						if (!props.autoplay) this.pause();
	
						this.setState({
							slideCount: slideCount,
							slideWidth: slideWidth,
							listWidth: listWidth,
							trackWidth: trackWidth,
							slideHeight: slideHeight,
							listHeight: listHeight,
							percentUnit: percentUnit
						}, function () {
	
							var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
								slideIndex: this.state.currentSlide,
								trackRef: this.track
							}, props, this.state));
							// getCSS function needs previously set state
							var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
							this.setState({ trackStyle: trackStyle });
						});
					},
					getWidth: function getWidth(elem) {
						return elem.getBoundingClientRect().width || elem.offsetWidth;
					},
					getSlideWidth: function getSlideWidth(props) {
						var slideWidth;
	
						if (!props.vertical) {
							var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
							slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
						} else {
							slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
						}
	
						return slideWidth;
					},
					getSlidePercentWidth: function getSlidePercentWidth(props) {
						var slideWidth = 100 / (props.children.length + 2 * props.slidesToShow);
	
						return slideWidth;
					},
					getHeight: function getHeight(elem) {
						return elem.getBoundingClientRect().height || elem.offsetHeight;
					},
	
					adaptHeight: function adaptHeight() {
						if (this.props.adaptiveHeight) {
							var selector = '[data-index="' + this.state.currentSlide + '"]';
							if (this.list) {
								var slickList = _reactDom2.default.findDOMNode(this.list);
								slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
							}
						}
					},
					canGoNext: function canGoNext(opts) {
						var canGo = true;
						if (!opts.infinite) {
							if (opts.centerMode) {
								// check if current slide is last slide
								if (opts.currentSlide >= opts.slideCount - 1) {
									canGo = false;
								}
							} else {
								// check if all slides are shown in slider
								if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
									canGo = false;
								}
							}
						}
						return canGo;
					},
					slideHandler: function slideHandler(index) {
						var _this = this;
	
						// Functionality of animateSlide and postSlide is merged into this function
						// console.log('slideHandler', index);
						var targetSlide, currentSlide;
						var targetLeft, currentLeft;
						var callback;
	
						if (this.props.waitForAnimate && this.state.animating) {
							return;
						}
	
						if (this.props.fade) {
							currentSlide = this.state.currentSlide;
	
							// Don't change slide if it's not infite and current slide is the first or last slide.
							if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
								return;
							}
	
							//  Shifting targetSlide back into the range
							if (index < 0) {
								targetSlide = index + this.state.slideCount;
							} else if (index >= this.state.slideCount) {
								targetSlide = index - this.state.slideCount;
							} else {
								targetSlide = index;
							}
	
							if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
								this.setState({
									lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
								});
							}
	
							callback = function callback() {
								_this.setState({
									animating: false
								});
								if (_this.props.afterChange) {
									_this.props.afterChange(targetSlide);
								}
								delete _this.animationEndCallback;
							};
	
							this.setState({
								animating: true,
								currentSlide: targetSlide
							}, function () {
								this.animationEndCallback = setTimeout(callback, this.props.speed);
							});
	
							if (this.props.beforeChange) {
								this.props.beforeChange(this.state.currentSlide, targetSlide);
							}
	
							this.autoPlay();
							return;
						}
	
						targetSlide = index;
						if (targetSlide < 0) {
							if (this.props.infinite === false) {
								currentSlide = 0;
							} else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
								currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
							} else {
								currentSlide = this.state.slideCount + targetSlide;
							}
						} else if (targetSlide >= this.state.slideCount) {
							if (this.props.infinite === false) {
								currentSlide = this.state.slideCount - this.props.slidesToShow;
							} else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
								currentSlide = 0;
							} else {
								currentSlide = targetSlide - this.state.slideCount;
							}
						} else {
							currentSlide = targetSlide;
						}
	
						targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
							slideIndex: targetSlide,
							trackRef: this.track
						}, this.props, this.state));
	
						currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
							slideIndex: currentSlide,
							trackRef: this.track
						}, this.props, this.state));
	
						if (this.props.infinite === false) {
							targetLeft = currentLeft;
						}
	
						if (this.props.beforeChange) {
							this.props.beforeChange(this.state.currentSlide, currentSlide);
						}
	
						if (this.props.lazyLoad) {
							var loaded = true;
							var slidesToLoad = [];
							for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
								loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
								if (!loaded) {
									slidesToLoad.push(i);
								}
							}
							if (!loaded) {
								this.setState({
									lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
								});
							}
						}
	
						// Slide Transition happens here.
						// animated transition happens to target Slide and
						// non - animated transition happens to current Slide
						// If CSS transitions are false, directly go the current slide.
	
						if (this.props.useCSS === false) {
	
							this.setState({
								currentSlide: currentSlide,
								trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
							}, function () {
								if (this.props.afterChange) {
									this.props.afterChange(currentSlide);
								}
							});
						} else {
	
							var nextStateChanges = {
								animating: false,
								currentSlide: currentSlide,
								trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
								swipeLeft: null
							};
	
							callback = function callback() {
								_this.setState(nextStateChanges);
								if (_this.props.afterChange) {
									_this.props.afterChange(currentSlide);
								}
								delete _this.animationEndCallback;
							};
	
							this.setState({
								animating: true,
								currentSlide: currentSlide,
								trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
							}, function () {
								this.animationEndCallback = setTimeout(callback, this.props.speed);
							});
						}
	
						this.autoPlay();
					},
					swipeDirection: function swipeDirection(touchObject) {
						var xDist, yDist, r, swipeAngle;
	
						xDist = touchObject.startX - touchObject.curX;
						yDist = touchObject.startY - touchObject.curY;
						r = Math.atan2(yDist, xDist);
	
						swipeAngle = Math.round(r * 180 / Math.PI);
						if (swipeAngle < 0) {
							swipeAngle = 360 - Math.abs(swipeAngle);
						}
						if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
							return this.props.rtl === false ? 'left' : 'right';
						}
						if (swipeAngle >= 135 && swipeAngle <= 225) {
							return this.props.rtl === false ? 'right' : 'left';
						}
						if (this.props.verticalSwiping === true) {
							if (swipeAngle >= 35 && swipeAngle <= 135) {
								return 'down';
							} else {
								return 'up';
							}
						}
	
						return 'vertical';
					},
					play: function play() {
						var nextIndex;
	
						if (!this.state.mounted) {
							return false;
						}
	
						if (this.props.rtl) {
							nextIndex = this.state.currentSlide - this.props.slidesToScroll;
						} else {
							if (this.canGoNext(_extends({}, this.props, this.state))) {
								nextIndex = this.state.currentSlide + this.props.slidesToScroll;
							} else {
								return false;
							}
						}
	
						this.slideHandler(nextIndex);
					},
					autoPlay: function autoPlay() {
						if (this.state.autoPlayTimer) {
							return;
						}
						if (this.props.autoplay) {
							this.setState({
								autoPlayTimer: setInterval(this.play, this.props.autoplaySpeed)
							});
						}
					},
					pause: function pause() {
						if (this.state.autoPlayTimer) {
							clearInterval(this.state.autoPlayTimer);
							this.setState({
								autoPlayTimer: null
							});
						}
					}
				};
	
				exports.default = helpers;
	
				/***/
			},
			/* 9 */
			/***/function (module, exports) {
	
				"use strict";
	
				var initialState = {
					animating: false,
					dragging: false,
					autoPlayTimer: null,
					currentDirection: 0,
					currentLeft: null,
					currentSlide: 0,
					direction: 1,
					listWidth: null,
					listHeight: null,
					// loadIndex: 0,
					slideCount: null,
					slideWidth: null,
					slideHeight: null,
					// sliding: false,
					// slideOffset: 0,
					swipeLeft: null,
					touchObject: {
						startX: 0,
						startY: 0,
						curX: 0,
						curY: 0
					},
	
					lazyLoadedList: [],
	
					// added for react
					initialized: false,
					edgeDragged: false,
					swiped: false, // used by swipeEvent. differentites between touch and swipe.
					trackStyle: {},
					trackWidth: 0
	
					// Removed
					// transformsEnabled: false,
					// $nextArrow: null,
					// $prevArrow: null,
					// $dots: null,
					// $list: null,
					// $slideTrack: null,
					// $slides: null,
				};
	
				module.exports = initialState;
	
				/***/
			},
			/* 10 */
			/***/function (module, exports, __webpack_require__) {
	
				'use strict';
	
				var _react = __webpack_require__(2);
	
				var _react2 = _interopRequireDefault(_react);
	
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { default: obj };
				}
	
				var defaultProps = {
					className: '',
					accessibility: true,
					adaptiveHeight: false,
					arrows: true,
					autoplay: false,
					autoplaySpeed: 3000,
					centerMode: false,
					centerPadding: '50px',
					cssEase: 'ease',
					customPaging: function customPaging(i) {
						return _react2.default.createElement('button', null, i + 1);
					},
					dots: false,
					dotsClass: 'slick-dots',
					draggable: true,
					easing: 'linear',
					edgeFriction: 0.35,
					fade: false,
					focusOnSelect: false,
					infinite: true,
					initialSlide: 0,
					lazyLoad: false,
					pauseOnHover: true,
					responsive: null,
					rtl: false,
					slide: 'div',
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 500,
					swipe: true,
					swipeToSlide: false,
					touchMove: true,
					touchThreshold: 5,
					useCSS: true,
					variableWidth: false,
					vertical: false,
					waitForAnimate: true,
					afterChange: null,
					beforeChange: null,
					edgeEvent: null,
					init: null,
					swipeEvent: null,
					// nextArrow, prevArrow are react componets
					nextArrow: null,
					prevArrow: null
				};
	
				module.exports = defaultProps;
	
				/***/
			},
			/* 11 */
			/***/function (module, exports, __webpack_require__) {
	
				var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
	                                                                    Copyright (c) 2016 Jed Watson.
	                                                                    Licensed under the MIT License (MIT), see
	                                                                    http://jedwatson.github.io/classnames
	                                                                    */
				/* global define */
	
				(function () {
					'use strict';
	
					var hasOwn = {}.hasOwnProperty;
	
					function classNames() {
						var classes = [];
	
						for (var i = 0; i < arguments.length; i++) {
							var arg = arguments[i];
							if (!arg) continue;
	
							var argType = typeof arg === 'undefined' ? 'undefined' : (0, _typeof3.default)(arg);
	
							if (argType === 'string' || argType === 'number') {
								classes.push(arg);
							} else if (Array.isArray(arg)) {
								classes.push(classNames.apply(null, arg));
							} else if (argType === 'object') {
								for (var key in arg) {
									if (hasOwn.call(arg, key) && arg[key]) {
										classes.push(key);
									}
								}
							}
						}
	
						return classes.join(' ');
					}
	
					if (typeof module !== 'undefined' && module.exports) {
						module.exports = classNames;
					} else if (true) {
						// register as 'classnames', consistent with npm package name
						!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
							return classNames;
						}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
					} else {
						window.classNames = classNames;
					}
				})();
	
				/***/
			},
			/* 12 */
			/***/function (module, exports, __webpack_require__) {
	
				'use strict';
	
				exports.__esModule = true;
				exports.Track = undefined;
	
				var _react = __webpack_require__(2);
	
				var _react2 = _interopRequireDefault(_react);
	
				var _objectAssign = __webpack_require__(7);
	
				var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
				var _classnames = __webpack_require__(11);
	
				var _classnames2 = _interopRequireDefault(_classnames);
	
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { default: obj };
				}
	
				var getSlideClasses = function getSlideClasses(spec) {
					var slickActive, slickCenter, slickCloned;
					var centerOffset, index;
	
					if (spec.rtl) {
						index = spec.slideCount - 1 - spec.index;
					} else {
						index = spec.index;
					}
	
					slickCloned = index < 0 || index >= spec.slideCount;
					if (spec.centerMode) {
						centerOffset = Math.floor(spec.slidesToShow / 2);
						slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
						if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
							slickActive = true;
						}
					} else {
						slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
					}
					return (0, _classnames2.default)({
						'slick-slide': true,
						'slick-active': slickActive,
						'slick-center': slickCenter,
						'slick-cloned': slickCloned
					});
				};
	
				var getSlideStyle = function getSlideStyle(spec) {
					var style = {};
					var percentUnit = spec.percentUnit;
					var sizeUnit = percentUnit ? '%' : 'px';
	
					if (spec.variableWidth === undefined || spec.variableWidth === false) {
						style.width = spec.slideWidth + sizeUnit;
					}
	
					if (spec.fade) {
						style.position = 'relative';
						style.left = -spec.index * spec.slideWidth;
						style.opacity = spec.currentSlide === spec.index ? 1 : 0;
						style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
						style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
					}
	
					return style;
				};
	
				var getKey = function getKey(child, fallbackKey) {
					// key could be a zero
					return child.key === null || child.key === undefined ? fallbackKey : child.key;
				};
	
				var renderSlides = function renderSlides(spec) {
					var key;
					var slides = [];
					var preCloneSlides = [];
					var postCloneSlides = [];
					var count = _react2.default.Children.count(spec.children);
	
					_react2.default.Children.forEach(spec.children, function (elem, index) {
						var child = void 0;
						var childOnClickOptions = {
							message: 'children',
							index: index,
							slidesToScroll: spec.slidesToScroll,
							currentSlide: spec.currentSlide
						};
	
						if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
							child = elem;
						} else {
							child = _react2.default.createElement('div', null);
						}
						var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
						var slickClasses = getSlideClasses((0, _objectAssign2.default)({ index: index }, spec));
						var cssClasses;
	
						if (child.props.className) {
							cssClasses = (0, _classnames2.default)(slickClasses, child.props.className);
						} else {
							cssClasses = slickClasses;
						}
	
						var onClick = function onClick(e) {
							child.props && child.props.onClick && child.props.onClick(e);
							if (spec.focusOnSelect) {
								spec.focusOnSelect(childOnClickOptions);
							}
						};
	
						slides.push(_react2.default.cloneElement(child, {
							key: 'original' + getKey(child, index),
							'data-index': index,
							className: cssClasses,
							tabIndex: '-1',
							style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
							onClick: onClick
						}));
	
						// variableWidth doesn't wrap properly.
						if (spec.infinite && spec.fade === false) {
							var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;
	
							if (index >= count - infiniteCount) {
								key = -(count - index);
								preCloneSlides.push(_react2.default.cloneElement(child, {
									key: 'precloned' + getKey(child, key),
									'data-index': key,
									className: cssClasses,
									style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
									onClick: onClick
								}));
							}
	
							if (index < infiniteCount) {
								key = count + index;
								postCloneSlides.push(_react2.default.cloneElement(child, {
									key: 'postcloned' + getKey(child, key),
									'data-index': key,
									className: cssClasses,
									style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
									onClick: onClick
								}));
							}
						}
					});
	
					if (spec.rtl) {
						return preCloneSlides.concat(slides, postCloneSlides).reverse();
					} else {
						return preCloneSlides.concat(slides, postCloneSlides);
					}
				};
	
				var Track = exports.Track = _react2.default.createClass({
					displayName: 'Track',
	
					render: function render() {
						var slides = renderSlides.call(this, this.props);
						return _react2.default.createElement('div', { className: 'slick-track', style: this.props.trackStyle }, slides);
					}
				});
	
				/***/
			},
			/* 13 */
			/***/function (module, exports, __webpack_require__) {
	
				'use strict';
	
				exports.__esModule = true;
				exports.Dots = undefined;
	
				var _react = __webpack_require__(2);
	
				var _react2 = _interopRequireDefault(_react);
	
				var _classnames = __webpack_require__(11);
	
				var _classnames2 = _interopRequireDefault(_classnames);
	
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { default: obj };
				}
	
				var getDotCount = function getDotCount(spec) {
					var dots;
					dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
					return dots;
				};
	
				var Dots = exports.Dots = _react2.default.createClass({
					displayName: 'Dots',
	
					clickHandler: function clickHandler(options, e) {
						// In Autoplay the focus stays on clicked button even after transition
						// to next slide. That only goes away by click somewhere outside
						e.preventDefault();
						this.props.clickHandler(options);
					},
					render: function render() {
						var _this = this;
	
						var dotCount = getDotCount({
							slideCount: this.props.slideCount,
							slidesToScroll: this.props.slidesToScroll
						});
	
						// Apply join & split to Array to pre-fill it for IE8
						//
						// Credit: http://stackoverflow.com/a/13735425/1849458
						var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
							var leftBound = i * _this.props.slidesToScroll;
							var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
							var className = (0, _classnames2.default)({
								'slick-active': _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
							});
	
							var dotOptions = {
								message: 'dots',
								index: i,
								slidesToScroll: _this.props.slidesToScroll,
								currentSlide: _this.props.currentSlide
							};
	
							var onClick = _this.clickHandler.bind(_this, dotOptions);
	
							return _react2.default.createElement('li', { key: i, className: className }, _react2.default.cloneElement(_this.props.customPaging(i), { onClick: onClick }));
						});
	
						return _react2.default.createElement('ul', { className: this.props.dotsClass, style: { display: 'block' } }, dots);
					}
				});
	
				/***/
			},
			/* 14 */
			/***/function (module, exports, __webpack_require__) {
	
				'use strict';
	
				exports.__esModule = true;
				exports.NextArrow = exports.PrevArrow = undefined;
	
				var _extends = _assign2.default || function (target) {
					for (var i = 1; i < arguments.length; i++) {
						var source = arguments[i];for (var key in source) {
							if (Object.prototype.hasOwnProperty.call(source, key)) {
								target[key] = source[key];
							}
						}
					}return target;
				};
	
				var _react = __webpack_require__(2);
	
				var _react2 = _interopRequireDefault(_react);
	
				var _classnames = __webpack_require__(11);
	
				var _classnames2 = _interopRequireDefault(_classnames);
	
				var _helpers = __webpack_require__(8);
	
				var _helpers2 = _interopRequireDefault(_helpers);
	
				function _interopRequireDefault(obj) {
					return obj && obj.__esModule ? obj : { default: obj };
				}
	
				var PrevArrow = exports.PrevArrow = _react2.default.createClass({
					displayName: 'PrevArrow',
	
					clickHandler: function clickHandler(options, e) {
						if (e) {
							e.preventDefault();
						}
						this.props.clickHandler(options, e);
					},
					render: function render() {
						var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
						var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
						if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
							prevClasses['slick-disabled'] = true;
							prevHandler = null;
						}
	
						var prevArrowProps = {
							key: '0',
							'data-role': 'none',
							className: (0, _classnames2.default)(prevClasses),
							style: { display: 'block' },
							onClick: prevHandler
						};
						var prevArrow;
	
						if (this.props.prevArrow) {
							prevArrow = _react2.default.cloneElement(this.props.prevArrow, prevArrowProps);
						} else {
							prevArrow = _react2.default.createElement('button', _extends({ key: '0', type: 'button' }, prevArrowProps), ' Previous');
						}
	
						return prevArrow;
					}
				});
	
				var NextArrow = exports.NextArrow = _react2.default.createClass({
					displayName: 'NextArrow',
	
					clickHandler: function clickHandler(options, e) {
						if (e) {
							e.preventDefault();
						}
						this.props.clickHandler(options, e);
					},
					render: function render() {
						var nextClasses = { 'slick-arrow': true, 'slick-next': true };
						var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
						if (!_helpers2.default.canGoNext(this.props)) {
							nextClasses['slick-disabled'] = true;
							nextHandler = null;
						}
	
						var nextArrowProps = {
							key: '1',
							'data-role': 'none',
							className: (0, _classnames2.default)(nextClasses),
							style: { display: 'block' },
							onClick: nextHandler
						};
	
						var nextArrow;
	
						if (this.props.nextArrow) {
							nextArrow = _react2.default.cloneElement(this.props.nextArrow, nextArrowProps);
						} else {
							nextArrow = _react2.default.createElement('button', _extends({ key: '1', type: 'button' }, nextArrowProps), ' Next');
						}
	
						return nextArrow;
					}
				});
	
				/***/
			},
			/* 15 */
			/***/function (module, exports, __webpack_require__) {
	
				var camel2hyphen = __webpack_require__(16);
	
				var isDimension = function isDimension(feature) {
					var re = /[height|width]$/;
					return re.test(feature);
				};
	
				var obj2mq = function obj2mq(obj) {
					var mq = '';
					var features = (0, _keys2.default)(obj);
					features.forEach(function (feature, index) {
						var value = obj[feature];
						feature = camel2hyphen(feature);
						// Add px to dimension features
						if (isDimension(feature) && typeof value === 'number') {
							value = value + 'px';
						}
						if (value === true) {
							mq += feature;
						} else if (value === false) {
							mq += 'not ' + feature;
						} else {
							mq += '(' + feature + ': ' + value + ')';
						}
						if (index < features.length - 1) {
							mq += ' and ';
						}
					});
					return mq;
				};
	
				var json2mq = function json2mq(query) {
					var mq = '';
					if (typeof query === 'string') {
						return query;
					}
					// Handling array of media queries
					if (query instanceof Array) {
						query.forEach(function (q, index) {
							mq += obj2mq(q);
							if (index < query.length - 1) {
								mq += ', ';
							}
						});
						return mq;
					}
					// Handling single media query
					return obj2mq(query);
				};
	
				module.exports = json2mq;
	
				/***/
			},
			/* 16 */
			/***/function (module, exports) {
	
				var camel2hyphen = function camel2hyphen(str) {
					return str.replace(/[A-Z]/g, function (match) {
						return '-' + match.toLowerCase();
					}).toLowerCase();
				};
	
				module.exports = camel2hyphen;
	
				/***/
			},
			/* 17 */
			/***/function (module, exports, __webpack_require__) {
	
				var canUseDOM = __webpack_require__(18);
				var enquire = canUseDOM && __webpack_require__(19);
				var json2mq = __webpack_require__(15);
	
				var ResponsiveMixin = {
					media: function media(query, handler) {
						query = json2mq(query);
						if (typeof handler === 'function') {
							handler = {
								match: handler
							};
						}
						canUseDOM && enquire.register(query, handler);
	
						// Queue the handlers to unregister them at unmount  
						if (!this._responsiveMediaHandlers) {
							this._responsiveMediaHandlers = [];
						}
						this._responsiveMediaHandlers.push({ query: query, handler: handler });
					},
					componentWillUnmount: function componentWillUnmount() {
						if (this._responsiveMediaHandlers) {
							this._responsiveMediaHandlers.forEach(function (obj) {
								canUseDOM && enquire.unregister(obj.query, obj.handler);
							});
						}
					}
				};
	
				module.exports = ResponsiveMixin;
	
				/***/
			},
			/* 18 */
			/***/function (module, exports) {
	
				var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
				module.exports = canUseDOM;
	
				/***/
			},
			/* 19 */
			/***/function (module, exports, __webpack_require__) {
	
				var __WEBPACK_AMD_DEFINE_RESULT__; /*!
	                                      * enquire.js v2.1.1 - Awesome Media Queries in JavaScript
	                                      * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
	                                      * License: MIT (http://www.opensource.org/licenses/mit-license.php)
	                                      */
	
				;(function (name, context, factory) {
					var matchMedia = window.matchMedia;
	
					if (typeof module !== 'undefined' && module.exports) {
						module.exports = factory(matchMedia);
					} else if (true) {
						!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
							return context[name] = factory(matchMedia);
						}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
					} else {
						context[name] = factory(matchMedia);
					}
				})('enquire', this, function (matchMedia) {
	
					'use strict';
	
					/*jshint unused:false */
					/**
	     * Helper function for iterating over a collection
	     *
	     * @param collection
	     * @param fn
	     */
	
					function each(collection, fn) {
						var i = 0,
						    length = collection.length,
						    cont;
	
						for (i; i < length; i++) {
							cont = fn(collection[i], i);
							if (cont === false) {
								break; //allow early exit
							}
						}
					}
	
					/**
	     * Helper function for determining whether target object is an array
	     *
	     * @param target the object under test
	     * @return {Boolean} true if array, false otherwise
	     */
					function isArray(target) {
						return Object.prototype.toString.apply(target) === '[object Array]';
					}
	
					/**
	     * Helper function for determining whether target object is a function
	     *
	     * @param target the object under test
	     * @return {Boolean} true if function, false otherwise
	     */
					function isFunction(target) {
						return typeof target === 'function';
					}
	
					/**
	     * Delegate to handle a media query being matched and unmatched.
	     *
	     * @param {object} options
	     * @param {function} options.match callback for when the media query is matched
	     * @param {function} [options.unmatch] callback for when the media query is unmatched
	     * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	     * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	     * @constructor
	     */
					function QueryHandler(options) {
						this.options = options;
						!options.deferSetup && this.setup();
					}
					QueryHandler.prototype = {
	
						/**
	      * coordinates setup of the handler
	      *
	      * @function
	      */
						setup: function setup() {
							if (this.options.setup) {
								this.options.setup();
							}
							this.initialised = true;
						},
	
						/**
	      * coordinates setup and triggering of the handler
	      *
	      * @function
	      */
						on: function on() {
							!this.initialised && this.setup();
							this.options.match && this.options.match();
						},
	
						/**
	      * coordinates the unmatch event for the handler
	      *
	      * @function
	      */
						off: function off() {
							this.options.unmatch && this.options.unmatch();
						},
	
						/**
	      * called when a handler is to be destroyed.
	      * delegates to the destroy or unmatch callbacks, depending on availability.
	      *
	      * @function
	      */
						destroy: function destroy() {
							this.options.destroy ? this.options.destroy() : this.off();
						},
	
						/**
	      * determines equality by reference.
	      * if object is supplied compare options, if function, compare match callback
	      *
	      * @function
	      * @param {object || function} [target] the target for comparison
	      */
						equals: function equals(target) {
							return this.options === target || this.options.match === target;
						}
	
					};
					/**
	     * Represents a single media query, manages it's state and registered handlers for this query
	     *
	     * @constructor
	     * @param {string} query the media query string
	     * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	     */
					function MediaQuery(query, isUnconditional) {
						this.query = query;
						this.isUnconditional = isUnconditional;
						this.handlers = [];
						this.mql = matchMedia(query);
	
						var self = this;
						this.listener = function (mql) {
							self.mql = mql;
							self.assess();
						};
						this.mql.addListener(this.listener);
					}
					MediaQuery.prototype = {
	
						/**
	      * add a handler for this query, triggering if already active
	      *
	      * @param {object} handler
	      * @param {function} handler.match callback for when query is activated
	      * @param {function} [handler.unmatch] callback for when query is deactivated
	      * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	      * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	      */
						addHandler: function addHandler(handler) {
							var qh = new QueryHandler(handler);
							this.handlers.push(qh);
	
							this.matches() && qh.on();
						},
	
						/**
	      * removes the given handler from the collection, and calls it's destroy methods
	      * 
	      * @param {object || function} handler the handler to remove
	      */
						removeHandler: function removeHandler(handler) {
							var handlers = this.handlers;
							each(handlers, function (h, i) {
								if (h.equals(handler)) {
									h.destroy();
									return !handlers.splice(i, 1); //remove from array and exit each early
								}
							});
						},
	
						/**
	      * Determine whether the media query should be considered a match
	      * 
	      * @return {Boolean} true if media query can be considered a match, false otherwise
	      */
						matches: function matches() {
							return this.mql.matches || this.isUnconditional;
						},
	
						/**
	      * Clears all handlers and unbinds events
	      */
						clear: function clear() {
							each(this.handlers, function (handler) {
								handler.destroy();
							});
							this.mql.removeListener(this.listener);
							this.handlers.length = 0; //clear array
						},
	
						/*
	      * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	      */
						assess: function assess() {
							var action = this.matches() ? 'on' : 'off';
	
							each(this.handlers, function (handler) {
								handler[action]();
							});
						}
					};
					/**
	     * Allows for registration of query handlers.
	     * Manages the query handler's state and is responsible for wiring up browser events
	     *
	     * @constructor
	     */
					function MediaQueryDispatch() {
						if (!matchMedia) {
							throw new Error('matchMedia not present, legacy browsers require a polyfill');
						}
	
						this.queries = {};
						this.browserIsIncapable = !matchMedia('only all').matches;
					}
	
					MediaQueryDispatch.prototype = {
	
						/**
	      * Registers a handler for the given media query
	      *
	      * @param {string} q the media query
	      * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	      * @param {function} options.match fired when query matched
	      * @param {function} [options.unmatch] fired when a query is no longer matched
	      * @param {function} [options.setup] fired when handler first triggered
	      * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	      * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	      */
						register: function register(q, options, shouldDegrade) {
							var queries = this.queries,
							    isUnconditional = shouldDegrade && this.browserIsIncapable;
	
							if (!queries[q]) {
								queries[q] = new MediaQuery(q, isUnconditional);
							}
	
							//normalise to object in an array
							if (isFunction(options)) {
								options = { match: options };
							}
							if (!isArray(options)) {
								options = [options];
							}
							each(options, function (handler) {
								queries[q].addHandler(handler);
							});
	
							return this;
						},
	
						/**
	      * unregisters a query and all it's handlers, or a specific handler for a query
	      *
	      * @param {string} q the media query to target
	      * @param {object || function} [handler] specific handler to unregister
	      */
						unregister: function unregister(q, handler) {
							var query = this.queries[q];
	
							if (query) {
								if (handler) {
									query.removeHandler(handler);
								} else {
									query.clear();
									delete this.queries[q];
								}
							}
	
							return this;
						}
					};
	
					return new MediaQueryDispatch();
				});
	
				/***/
			}
			/******/])
		);
	});
	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(167)(module)))

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REGISTRATION_STEP_FORM = exports.REGISTRATION_STEP_FORM = 'REGISTRATION_STEP_FORM';
	var REGISTRATION_STEP_CONFIRMED = exports.REGISTRATION_STEP_CONFIRMED = 'REGISTRATION_STEP_CONFIRMED';
	var REGISTRATION_STEP_CONFIRMED_SUCCESS = exports.REGISTRATION_STEP_CONFIRMED_SUCCESS = 'REGISTRATION_STEP_CONFIRMED_SUCCESS';

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Registration = exports.RegistrationSuccess = exports.RegistrationConfirm = exports.RegistrationForm = exports.RegistrationHeader = undefined;
	
	var _RegistrationHeader = __webpack_require__(1754);
	
	Object.defineProperty(exports, 'RegistrationHeader', {
	  enumerable: true,
	  get: function get() {
	    return _RegistrationHeader.RegistrationHeader;
	  }
	});
	
	var _RegistrationForm = __webpack_require__(1751);
	
	Object.defineProperty(exports, 'RegistrationForm', {
	  enumerable: true,
	  get: function get() {
	    return _RegistrationForm.RegistrationForm;
	  }
	});
	
	var _RegistrationConfirm = __webpack_require__(1748);
	
	Object.defineProperty(exports, 'RegistrationConfirm', {
	  enumerable: true,
	  get: function get() {
	    return _RegistrationConfirm.RegistrationConfirm;
	  }
	});
	
	var _RegistrationSuccess = __webpack_require__(1757);
	
	Object.defineProperty(exports, 'RegistrationSuccess', {
	  enumerable: true,
	  get: function get() {
	    return _RegistrationSuccess.RegistrationSuccess;
	  }
	});
	
	var _Registration2 = __webpack_require__(1745);
	
	var _Registration3 = _interopRequireDefault(_Registration2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Registration = _Registration3.default;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Autocomplete = exports.Search = undefined;
	
	var _Search2 = __webpack_require__(1764);
	
	var _Search3 = _interopRequireDefault(_Search2);
	
	var _Autocomplete2 = __webpack_require__(1760);
	
	var _Autocomplete3 = _interopRequireDefault(_Autocomplete2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Search = _Search3.default;
	exports.Autocomplete = _Autocomplete3.default;

/***/ }),
/* 760 */
[2027, 1766],
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(195);
	
	module.exports = {
	    api_version: '2.14.0',
	    client_id: 'IBONUS_ANDROID',
	    client_secret: '4sp4OOL6JMmzDbs9Dr8SWMBRLdZeKWfq'
	    // localhost: ''
	};

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _reactRouter = __webpack_require__(19);
	
	var _moment = __webpack_require__(11);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(15);
	
	var _PaymentStatus = __webpack_require__(163);
	
	var _PaymentStatus2 = _interopRequireDefault(_PaymentStatus);
	
	var _PaymentStatusLabel = __webpack_require__(754);
	
	var _PaymentStatusLabel2 = _interopRequireDefault(_PaymentStatusLabel);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    OrderListItemView: {
	        displayName: 'OrderListItemView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Personal/OrderList/default/OrderListItemView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	/**
	 * @return {string}
	 */
	function LinkPay(props) {
	    var show = props.show,
	        onPay = props.onPay,
	        getCheckByOrder = props.getCheckByOrder,
	        hideAll = props.hideAll,
	        lang = props.lang;
	
	
	    if (show && !hideAll) {
	        return _react3.default.createElement(
	            'a',
	            { href: '#', onClick: onPay, className: 'le-button' },
	            lang['store.order_list.pay']
	        );
	    } else if (hideAll) {
	        return _react3.default.createElement('a', null);
	    }
	
	    return _react3.default.createElement(
	        'a',
	        { href: '#', onClick: getCheckByOrder, className: 'le-button' },
	        lang['store.order_list.check']
	    );
	}
	
	var OrderListItemView = _wrapComponent('OrderListItemView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(OrderListItemView, _Component);
	
	    function OrderListItemView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, OrderListItemView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OrderListItemView.__proto__ || (0, _getPrototypeOf2.default)(OrderListItemView)).call.apply(_ref, [this].concat(args))), _this), _this.onPay = function (event) {
	            event.preventDefault();
	            _this.props.onPay();
	        }, _this.getCheckByOrder = function (e) {
	            e.preventDefault();
	            (0, _helpers.getCheckByOrder)(_this.props.order);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(OrderListItemView, [{
	        key: 'render',
	        value: function render() {
	            var order = this.props.order || {};
	            var date = (0, _moment2.default)(order.time_create);
	            /** @type PaymentStatus */
	            var paymentStatus = order.paymentStatus != null ? order.paymentStatus.id : null;
	            paymentStatus = new _PaymentStatus2.default(paymentStatus);
	            var sum = parseFloat(order.sum - order.discount_sum) || 0;
	
	            var _props = this.props,
	                lang = _props.lang,
	                currency = _props.currency;
	
	
	            return _react3.default.createElement(
	                'div',
	                { key: order.id, className: 'order-item order-item-holder' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'no-margin col-xs-12 col-sm-2' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'body' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'title' },
	                                lang['store.common.order']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'order-number' },
	                                _react3.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/personal/order/' + order.id },
	                                    order.order_number
	                                )
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'no-margin col-xs-12 col-sm-2' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'body' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'title' },
	                                lang['store.common.date']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'excerpt' },
	                                date.format("DD.MM.YYYY")
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'no-margin col-xs-12 col-sm-2' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'body' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'title' },
	                                lang['store.common.status']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'excerpt' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'status-payment' },
	                                    _react3.default.createElement(_PaymentStatusLabel2.default, { rawStatus: paymentStatus.status })
	                                )
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'no-margin col-xs-12 col-sm-3 block-order-sum content-block' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'body' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'title' },
	                                lang['store.common.sum']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'order-sum' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'price-current' },
	                                    _react3.default.createElement(_components2.MoneyValue, {
	                                        value: sum,
	                                        icon: currency.icon,
	                                        iconAfterValue: currency.icon_after_value
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'no-margin col-xs-12 col-sm-3 buttons' },
	                        _react3.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/personal/order/' + order.id, className: 'le-button' },
	                            lang['store.common.details']
	                        ),
	                        _react3.default.createElement(LinkPay, {
	                            show: paymentStatus.isPayActionAvaliable(),
	                            hideAll: paymentStatus.isOutdated || paymentStatus.isCanceled() || sum === 0,
	                            onPay: this.onPay,
	                            getCheckByOrder: this.getCheckByOrder,
	                            lang: lang
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	    return OrderListItemView;
	}(_react2.Component), _class.propTypes = {
	    order: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp2));
	
	exports.default = OrderListItemView;
	module.exports = exports['default'];

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Page = __webpack_require__(1825);
	
	Object.defineProperty(exports, 'Page', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Page).default;
	  }
	});
	
	var _App = __webpack_require__(1799);
	
	Object.defineProperty(exports, 'App', {
	  enumerable: true,
	  get: function get() {
	    return _App.App;
	  }
	});
	
	var _Basket = __webpack_require__(1802);
	
	Object.defineProperty(exports, 'Basket', {
	  enumerable: true,
	  get: function get() {
	    return _Basket.Basket;
	  }
	});
	
	var _CartProduct = __webpack_require__(1805);
	
	Object.defineProperty(exports, 'CartProduct', {
	  enumerable: true,
	  get: function get() {
	    return _CartProduct.CartProduct;
	  }
	});
	
	var _Category = __webpack_require__(1808);
	
	Object.defineProperty(exports, 'Category', {
	  enumerable: true,
	  get: function get() {
	    return _Category.Category;
	  }
	});
	
	var _CheckAuth = __webpack_require__(1810);
	
	Object.defineProperty(exports, 'CheckAuth', {
	  enumerable: true,
	  get: function get() {
	    return _CheckAuth.CheckAuth;
	  }
	});
	
	var _Order = __webpack_require__(1824);
	
	Object.defineProperty(exports, 'CreateOrder', {
	  enumerable: true,
	  get: function get() {
	    return _Order.CreateOrder;
	  }
	});
	Object.defineProperty(exports, 'PaymentOrder', {
	  enumerable: true,
	  get: function get() {
	    return _Order.PaymentOrder;
	  }
	});
	
	var _Main = __webpack_require__(1813);
	
	Object.defineProperty(exports, 'Main', {
	  enumerable: true,
	  get: function get() {
	    return _Main.Main;
	  }
	});
	
	var _NotFoundServer = __webpack_require__(1819);
	
	Object.defineProperty(exports, 'NotFoundServer', {
	  enumerable: true,
	  get: function get() {
	    return _NotFoundServer.NotFoundServer;
	  }
	});
	
	var _NotFound = __webpack_require__(1816);
	
	Object.defineProperty(exports, 'NotFound', {
	  enumerable: true,
	  get: function get() {
	    return _NotFound.NotFound;
	  }
	});
	
	var _Personal = __webpack_require__(1838);
	
	Object.defineProperty(exports, 'Operations', {
	  enumerable: true,
	  get: function get() {
	    return _Personal.Operations;
	  }
	});
	Object.defineProperty(exports, 'OrderList', {
	  enumerable: true,
	  get: function get() {
	    return _Personal.OrderList;
	  }
	});
	Object.defineProperty(exports, 'OrderDetail', {
	  enumerable: true,
	  get: function get() {
	    return _Personal.OrderDetail;
	  }
	});
	Object.defineProperty(exports, 'Profile', {
	  enumerable: true,
	  get: function get() {
	    return _Personal.Profile;
	  }
	});
	Object.defineProperty(exports, 'Personal', {
	  enumerable: true,
	  get: function get() {
	    return _Personal.Personal;
	  }
	});
	Object.defineProperty(exports, 'PersonalBasket', {
	  enumerable: true,
	  get: function get() {
	    return _Personal.PersonalBasket;
	  }
	});
	
	var _Registration = __webpack_require__(1844);
	
	Object.defineProperty(exports, 'Registration', {
	  enumerable: true,
	  get: function get() {
	    return _Registration.Registration;
	  }
	});
	
	var _Search = __webpack_require__(1847);
	
	Object.defineProperty(exports, 'Search', {
	  enumerable: true,
	  get: function get() {
	    return _Search.Search;
	  }
	});
	Object.defineProperty(exports, 'ShareBasket', {
	  enumerable: true,
	  get: function get() {
	    return _Basket.ShareBasket;
	  }
	});
	
	var _Static = __webpack_require__(1852);
	
	Object.defineProperty(exports, 'Static', {
	  enumerable: true,
	  get: function get() {
	    return _Static.Static;
	  }
	});
	
	var _Slide = __webpack_require__(1850);
	
	Object.defineProperty(exports, 'Slide', {
	  enumerable: true,
	  get: function get() {
	    return _Slide.Slide;
	  }
	});
	
	var _WishList = __webpack_require__(1855);
	
	Object.defineProperty(exports, 'WishList', {
	  enumerable: true,
	  get: function get() {
	    return _WishList.WishList;
	  }
	});
	
	var _PostponeBasket = __webpack_require__(1841);
	
	Object.defineProperty(exports, 'PostponeBasket', {
	  enumerable: true,
	  get: function get() {
	    return _PostponeBasket.PostponeBasket;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.log = log;
	function log(target, name, descriptor) {
	    var _old = descriptor.value;
	    descriptor.value = function () {
	        // console.log('> LOG >>> [' + name + '] with arguments ==> ', arguments);
	        return _old.apply(this, arguments);
	    };
	}

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.showSideMenu = showSideMenu;
	exports.hideSideMenu = hideSideMenu;
	
	var _constants = __webpack_require__(18);
	
	function showSideMenu() {
	    return {
	        type: _constants.HeadInfoConstants.SHOW_SIDEMENU
	    };
	} /**
	   * Created by maximus on 23.11.16.
	   */
	function hideSideMenu() {
	    return {
	        type: _constants.HeadInfoConstants.HIDE_SIDEMENU
	    };
	}

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setSettingPage = setSettingPage;
	exports.loadPageDetail = loadPageDetail;
	
	var _constants = __webpack_require__(18);
	
	function setSettingPage() {
	    var pageList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return {
	        type: _constants.PageConstants.SET_PAGE_LIST,
	        result: pageList
	    };
	}
	
	function loadPageDetail(id, shopId) {
	    return {
	        types: [_constants.PageConstants.PAGE_DETAIL_LOAD_REQUEST, _constants.PageConstants.PAGE_DETAIL_LOAD_SUCCES, _constants.PageConstants.PAGE_DETAIL_LOAD_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getPageDetail(id, shopId);
	        }
	    };
	}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by maximus on 11.01.17.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getProductForSlider = getProductForSlider;
	exports.getCategoryForSlider = getCategoryForSlider;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Получить список товаров по типу для слайдера
	 * @param sliderType Тип товаров
	 */
	function getProductForSlider(sliderType) {
	    return {
	        types: [_constants.SliderConstants.SLIDER_LOAD, _constants.SliderConstants.SLIDER_LOAD_SUCCESS, _constants.SliderConstants.SLIDER_LOAD_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getProductForSlider(sliderType).then(function (result) {
	                return (0, _extends3.default)({}, result, {
	                    sliderType: sliderType
	                });
	            });
	        }
	    };
	}
	
	/**
	 * Получить список категорий
	 */
	function getCategoryForSlider() {
	    return {
	        types: [_constants.SliderConstants.SLIDER_LOAD_CATEGORY, _constants.SliderConstants.SLIDER_LOAD_CATEGORY_SUCCESS, _constants.SliderConstants.SLIDER_LOAD_CATWGORY_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getCategoryForSlider();
	        }
	    };
	}

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getLang = getLang;
	
	var _constants = __webpack_require__(18);
	
	function getLang() {
	    var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ru';
	
	    return {
	        types: [_constants.TranslatePipoConstants.TRANSLATE_PIPO_REQUEST, _constants.TranslatePipoConstants.TRANSLATE_PIPO_SUCCESS, _constants.TranslatePipoConstants.TRANSLATE_PIPO_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getLang(lang);
	        }
	    };
	}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null != obj && 'object' == typeof obj;
	}
	
	module.exports = isObject;


/***/ }),
/* 770 */
/***/ (function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  return bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	module.exports = bytesToUuid;


/***/ }),
/* 771 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	var rng;
	
	var crypto = global.crypto || global.msCrypto; // for IE 11
	if (crypto && crypto.getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	  rng = function whatwgRNG() {
	    crypto.getRandomValues(rnds8);
	    return rnds8;
	  };
	}
	
	if (!rng) {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	  rng = function() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}
	
	module.exports = rng;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(784), __esModule: true };

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(791), __esModule: true };

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(792), __esModule: true };

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(798), __esModule: true };

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(799), __esModule: true };

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deselectCurrent = __webpack_require__(1927);
	
	var defaultMessage = 'Copy to clipboard: #{key}, Enter';
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl') + '+C';
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug, message, reselectPrevious, range, selection, mark, success = false;
	  if (!options) { options = {}; }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement('span');
	    mark.textContent = text;
	    // reset user styles for span element
	    mark.style.all = 'unset';
	    // prevents scrolling to the end of the page
	    mark.style.position = 'fixed';
	    mark.style.top = 0;
	    mark.style.clip = 'rect(0, 0, 0, 0)';
	    // used to preserve spaces and line breaks
	    mark.style.whiteSpace = 'pre';
	    // do not inherit user-select (it may be `none`)
	    mark.style.webkitUserSelect = 'text';
	    mark.style.MozUserSelect = 'text';
	    mark.style.msUserSelect = 'text';
	    mark.style.userSelect = 'text';
	
	    document.body.appendChild(mark);
	
	    range.selectNode(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand('copy');
	    if (!successful) {
	      throw new Error('copy command was unsuccessful');
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error('unable to copy using execCommand: ', err);
	    debug && console.warn('trying IE specific stuff');
	    try {
	      window.clipboardData.setData('text', text);
	      success = true;
	    } catch (err) {
	      debug && console.error('unable to copy using clipboardData: ', err);
	      debug && console.error('falling back to prompt');
	      message = format('message' in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == 'function') {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(446);
	__webpack_require__(443);
	module.exports = __webpack_require__(78).Symbol;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(846);
	module.exports = __webpack_require__(78).RegExp.escape;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(172);
	__webpack_require__(822);
	module.exports = __webpack_require__(32).Array.from;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(203);
	__webpack_require__(172);
	module.exports = __webpack_require__(820);


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(203);
	__webpack_require__(172);
	module.exports = __webpack_require__(821);


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(32);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(824);
	module.exports = __webpack_require__(32).Object.assign;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(825);
	var $Object = __webpack_require__(32).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(826);
	var $Object = __webpack_require__(32).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(834);
	module.exports = __webpack_require__(32).Object.entries;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(827);
	var $Object = __webpack_require__(32).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(828);
	var $Object = __webpack_require__(32).Object;
	module.exports = function getOwnPropertyNames(it) {
	  return $Object.getOwnPropertyNames(it);
	};


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(411);
	module.exports = __webpack_require__(32).Object.getOwnPropertySymbols;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(829);
	module.exports = __webpack_require__(32).Object.getPrototypeOf;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(830);
	module.exports = __webpack_require__(32).Object.keys;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(831);
	module.exports = __webpack_require__(32).Object.setPrototypeOf;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(835);
	module.exports = __webpack_require__(32).Object.values;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(410);
	__webpack_require__(172);
	__webpack_require__(203);
	__webpack_require__(832);
	__webpack_require__(836);
	__webpack_require__(837);
	module.exports = __webpack_require__(32).Promise;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(833);
	module.exports = __webpack_require__(32).Reflect.construct;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(411);
	__webpack_require__(410);
	__webpack_require__(838);
	__webpack_require__(839);
	module.exports = __webpack_require__(32).Symbol;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(172);
	__webpack_require__(203);
	module.exports = __webpack_require__(281).f('iterator');


/***/ }),
/* 801 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 802 */
119,
/* 803 */
[1946, 105, 278, 819],
/* 804 */
[1947, 144, 94, 394],
/* 805 */
[1949, 95, 170],
/* 806 */
[1953, 147, 274, 169],
/* 807 */
[1954, 145, 397, 396, 76, 278, 282],
/* 808 */
[1960, 168],
/* 809 */
[1962, 199, 170, 201, 118, 56],
/* 810 */
425,
/* 811 */
[1965, 202, 94, 117, 95, 116],
/* 812 */
[1966, 55, 409, 168],
/* 813 */
[1968, 147, 274, 169, 171, 395, 116],
/* 814 */
[1971, 95, 76, 147, 104],
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(118);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 816 */
[1981, 94, 76, 145, 273],
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(55);
	var core = __webpack_require__(32);
	var dP = __webpack_require__(95);
	var DESCRIPTORS = __webpack_require__(104);
	var SPECIES = __webpack_require__(56)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 818 */
[1986, 277, 269],
/* 819 */
[1988, 277],
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(76);
	var get = __webpack_require__(282);
	module.exports = __webpack_require__(32).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(268);
	var ITERATOR = __webpack_require__(56)('iterator');
	var Iterators = __webpack_require__(146);
	module.exports = __webpack_require__(32).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 822 */
[1997, 145, 54, 171, 397, 396, 278, 805, 282, 399],
/* 823 */
[1998, 801, 810, 146, 105, 398],
/* 824 */
[1999, 54, 813],
/* 825 */
[2000, 54, 199],
/* 826 */
[2001, 54, 104, 95],
/* 827 */
[2002, 105, 273, 200],
/* 828 */
[2003, 200, 400],
/* 829 */
[2004, 171, 402, 200],
/* 830 */
[2005, 171, 147, 200],
/* 831 */
[2006, 54, 816],
/* 832 */
[2007, 198, 55, 145, 268, 54, 94, 144, 802, 807, 408, 409, 812, 272, 405, 406, 56, 815, 201, 817, 32, 399],
/* 833 */
[2008, 54, 199, 144, 76, 94, 116, 804, 55],
/* 834 */
[2011, 54, 404],
/* 835 */
[2012, 54, 404],
/* 836 */
[2013, 54, 32, 55, 408, 406],
/* 837 */
[2014, 54, 272, 405],
/* 838 */
[2015, 280],
/* 839 */
[2016, 280],
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(25);
	var isArray = __webpack_require__(208);
	var SPECIES = __webpack_require__(33)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(23);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(20);
	var toPrimitive = __webpack_require__(88);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 843 */
[1953, 124, 212, 175],
/* 844 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 845 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(10);
	var $re = __webpack_require__(844)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(10);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(413) });
	
	__webpack_require__(106)('copyWithin');


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $every = __webpack_require__(84)(4);
	
	$export($export.P + $export.F * !__webpack_require__(80)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(10);
	
	$export($export.P, 'Array', { fill: __webpack_require__(283) });
	
	__webpack_require__(106)('fill');


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $filter = __webpack_require__(84)(2);
	
	$export($export.P + $export.F * !__webpack_require__(80)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(10);
	var $find = __webpack_require__(84)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(106)(KEY);


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(10);
	var $find = __webpack_require__(84)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(106)(KEY);


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $forEach = __webpack_require__(84)(0);
	var STRICT = __webpack_require__(80)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 854 */
[1997, 79, 10, 44, 424, 291, 39, 285, 307, 210],
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $indexOf = __webpack_require__(204)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(80)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(208) });


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(10);
	var toIObject = __webpack_require__(72);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(174) != Object || !__webpack_require__(80)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var toIObject = __webpack_require__(72);
	var toInteger = __webpack_require__(87);
	var toLength = __webpack_require__(39);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(80)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $map = __webpack_require__(84)(1);
	
	$export($export.P + $export.F * !__webpack_require__(80)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var createProperty = __webpack_require__(285);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(23)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $reduce = __webpack_require__(415);
	
	$export($export.P + $export.F * !__webpack_require__(80)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $reduce = __webpack_require__(415);
	
	$export($export.P + $export.F * !__webpack_require__(80)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var html = __webpack_require__(289);
	var cof = __webpack_require__(77);
	var toAbsoluteIndex = __webpack_require__(128);
	var toLength = __webpack_require__(39);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(23)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $some = __webpack_require__(84)(3);
	
	$export($export.P + $export.F * !__webpack_require__(80)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var aFunction = __webpack_require__(49);
	var toObject = __webpack_require__(44);
	var fails = __webpack_require__(23);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(80)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(127)('Array');


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(10);
	var toISOString = __webpack_require__(841);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var toObject = __webpack_require__(44);
	var toPrimitive = __webpack_require__(88);
	
	$export($export.P + $export.F * __webpack_require__(23)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(33)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(60)(proto, TO_PRIMITIVE, __webpack_require__(842));


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(61)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(10);
	
	$export($export.P, 'Function', { bind: __webpack_require__(416) });


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(25);
	var getPrototypeOf = __webpack_require__(71);
	var HAS_INSTANCE = __webpack_require__(33)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(38).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(38).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(37) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(10);
	var log1p = __webpack_require__(427);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(10);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(10);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(10);
	var sign = __webpack_require__(295);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(10);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(10);
	var $expm1 = __webpack_require__(294);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', { fround: __webpack_require__(426) });


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(10);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(10);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(23)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(427) });


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', { sign: __webpack_require__(295) });


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(10);
	var expm1 = __webpack_require__(294);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(23)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(10);
	var expm1 = __webpack_require__(294);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(22);
	var has = __webpack_require__(59);
	var cof = __webpack_require__(77);
	var inheritIfRequired = __webpack_require__(290);
	var toPrimitive = __webpack_require__(88);
	var fails = __webpack_require__(23);
	var gOPN = __webpack_require__(123).f;
	var gOPD = __webpack_require__(70).f;
	var dP = __webpack_require__(38).f;
	var $trim = __webpack_require__(150).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(122)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(37) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(61)(global, NUMBER, $Number);
	}


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(10);
	var _isFinite = __webpack_require__(22).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(423) });


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(10);
	var isInteger = __webpack_require__(423);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var $parseFloat = __webpack_require__(435);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var $parseInt = __webpack_require__(436);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var toInteger = __webpack_require__(87);
	var aNumberValue = __webpack_require__(412);
	var repeat = __webpack_require__(302);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(23)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $fails = __webpack_require__(23);
	var aNumberValue = __webpack_require__(412);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 904 */
[1999, 10, 429],
/* 905 */
[2000, 10, 122],
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(37), 'Object', { defineProperties: __webpack_require__(430) });


/***/ }),
/* 907 */
[2001, 10, 37, 38],
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(25);
	var meta = __webpack_require__(107).onFreeze;
	
	__webpack_require__(86)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 909 */
[2002, 72, 70, 86],
/* 910 */
[2003, 86, 431],
/* 911 */
[2004, 44, 71, 86],
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(25);
	
	__webpack_require__(86)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(25);
	
	__webpack_require__(86)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(25);
	
	__webpack_require__(86)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(10);
	$export($export.S, 'Object', { is: __webpack_require__(845) });


/***/ }),
/* 916 */
[2005, 44, 124, 86],
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(25);
	var meta = __webpack_require__(107).onFreeze;
	
	__webpack_require__(86)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(25);
	var meta = __webpack_require__(107).onFreeze;
	
	__webpack_require__(86)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 919 */
[2006, 10, 298],
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var $parseFloat = __webpack_require__(435);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var $parseInt = __webpack_require__(436);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 922 */
[2007, 121, 22, 79, 173, 10, 25, 49, 119, 120, 216, 304, 296, 297, 437, 438, 33, 126, 149, 127, 78, 210],
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(10);
	var aFunction = __webpack_require__(49);
	var anObject = __webpack_require__(20);
	var rApply = (__webpack_require__(22).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(23)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 924 */
[2008, 10, 122, 49, 20, 25, 23, 416, 22],
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(38);
	var $export = __webpack_require__(10);
	var anObject = __webpack_require__(20);
	var toPrimitive = __webpack_require__(88);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(23)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(10);
	var gOPD = __webpack_require__(70).f;
	var anObject = __webpack_require__(20);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(10);
	var anObject = __webpack_require__(20);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(292)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(70);
	var $export = __webpack_require__(10);
	var anObject = __webpack_require__(20);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(10);
	var getProto = __webpack_require__(71);
	var anObject = __webpack_require__(20);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(70);
	var getPrototypeOf = __webpack_require__(71);
	var has = __webpack_require__(59);
	var $export = __webpack_require__(10);
	var isObject = __webpack_require__(25);
	var anObject = __webpack_require__(20);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(10);
	var anObject = __webpack_require__(20);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(434) });


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(10);
	var anObject = __webpack_require__(20);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(10);
	var setProto = __webpack_require__(298);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(38);
	var gOPD = __webpack_require__(70);
	var getPrototypeOf = __webpack_require__(71);
	var has = __webpack_require__(59);
	var $export = __webpack_require__(10);
	var createDesc = __webpack_require__(125);
	var anObject = __webpack_require__(20);
	var isObject = __webpack_require__(25);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(22);
	var inheritIfRequired = __webpack_require__(290);
	var dP = __webpack_require__(38).f;
	var gOPN = __webpack_require__(123).f;
	var isRegExp = __webpack_require__(209);
	var $flags = __webpack_require__(207);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(37) && (!CORRECT_NEW || __webpack_require__(23)(function () {
	  re2[__webpack_require__(33)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(61)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(127)('RegExp');


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(206)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(206)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(206)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(206)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(209);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(444);
	var anObject = __webpack_require__(20);
	var $flags = __webpack_require__(207);
	var DESCRIPTORS = __webpack_require__(37);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(61)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(23)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(62)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(62)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(62)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(62)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $at = __webpack_require__(300)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(10);
	var toLength = __webpack_require__(39);
	var context = __webpack_require__(301);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(288)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(62)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(62)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(62)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var toAbsoluteIndex = __webpack_require__(128);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(10);
	var context = __webpack_require__(301);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(288)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(62)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 955 */
[2009, 300, 293],
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(62)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var toIObject = __webpack_require__(72);
	var toLength = __webpack_require__(39);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(302)
	});


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(62)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(10);
	var toLength = __webpack_require__(39);
	var context = __webpack_require__(301);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(288)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(62)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(62)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(62)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(150)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var $typed = __webpack_require__(217);
	var buffer = __webpack_require__(305);
	var anObject = __webpack_require__(20);
	var toAbsoluteIndex = __webpack_require__(128);
	var toLength = __webpack_require__(39);
	var isObject = __webpack_require__(25);
	var ArrayBuffer = __webpack_require__(22).ArrayBuffer;
	var speciesConstructor = __webpack_require__(216);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(23)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(127)(ARRAY_BUFFER);


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	$export($export.G + $export.W + $export.F * !__webpack_require__(217).ABV, {
	  DataView: __webpack_require__(305).DataView
	});


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(419);
	var validate = __webpack_require__(151);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(205)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(10);
	var flattenIntoArray = __webpack_require__(420);
	var toObject = __webpack_require__(44);
	var toLength = __webpack_require__(39);
	var aFunction = __webpack_require__(49);
	var arraySpeciesCreate = __webpack_require__(284);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(106)('flatMap');


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(10);
	var flattenIntoArray = __webpack_require__(420);
	var toObject = __webpack_require__(44);
	var toLength = __webpack_require__(39);
	var toInteger = __webpack_require__(87);
	var arraySpeciesCreate = __webpack_require__(284);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(106)('flatten');


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(10);
	var $includes = __webpack_require__(204)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(106)('includes');


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(10);
	var microtask = __webpack_require__(296)();
	var process = __webpack_require__(22).process;
	var isNode = __webpack_require__(77)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(10);
	var cof = __webpack_require__(77);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(10);
	
	$export($export.G, { global: __webpack_require__(22) });


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(213)('Map');


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(214)('Map');


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(10);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(418)('Map') });


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(10);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(10);
	var scale = __webpack_require__(428);
	var fround = __webpack_require__(426);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(10);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', { scale: __webpack_require__(428) });


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(10);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var toObject = __webpack_require__(44);
	var aFunction = __webpack_require__(49);
	var $defineProperty = __webpack_require__(38);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(37) && $export($export.P + __webpack_require__(211), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var toObject = __webpack_require__(44);
	var aFunction = __webpack_require__(49);
	var $defineProperty = __webpack_require__(38);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(37) && $export($export.P + __webpack_require__(211), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 1000 */
[2011, 10, 433],
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(10);
	var ownKeys = __webpack_require__(434);
	var toIObject = __webpack_require__(72);
	var gOPD = __webpack_require__(70);
	var createProperty = __webpack_require__(285);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var toObject = __webpack_require__(44);
	var toPrimitive = __webpack_require__(88);
	var getPrototypeOf = __webpack_require__(71);
	var getOwnPropertyDescriptor = __webpack_require__(70).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(37) && $export($export.P + __webpack_require__(211), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(10);
	var toObject = __webpack_require__(44);
	var toPrimitive = __webpack_require__(88);
	var getPrototypeOf = __webpack_require__(71);
	var getOwnPropertyDescriptor = __webpack_require__(70).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(37) && $export($export.P + __webpack_require__(211), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 1004 */
[2012, 10, 433],
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(10);
	var global = __webpack_require__(22);
	var core = __webpack_require__(78);
	var microtask = __webpack_require__(296)();
	var OBSERVABLE = __webpack_require__(33)('observable');
	var aFunction = __webpack_require__(49);
	var anObject = __webpack_require__(20);
	var anInstance = __webpack_require__(119);
	var redefineAll = __webpack_require__(126);
	var hide = __webpack_require__(60);
	var forOf = __webpack_require__(120);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(127)('Observable');


/***/ }),
/* 1006 */
[2013, 10, 78, 22, 216, 438],
/* 1007 */
[2014, 10, 297, 437],
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(20);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(20);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(445);
	var from = __webpack_require__(414);
	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(20);
	var getPrototypeOf = __webpack_require__(71);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(20);
	var getPrototypeOf = __webpack_require__(71);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(20);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(20);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(20);
	var getPrototypeOf = __webpack_require__(71);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(96);
	var anObject = __webpack_require__(20);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(96);
	var anObject = __webpack_require__(20);
	var aFunction = __webpack_require__(49);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(213)('Set');


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(214)('Set');


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(10);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(418)('Set') });


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(10);
	var $at = __webpack_require__(300)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(10);
	var defined = __webpack_require__(85);
	var toLength = __webpack_require__(39);
	var isRegExp = __webpack_require__(209);
	var getFlags = __webpack_require__(207);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(292)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(10);
	var $pad = __webpack_require__(439);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(10);
	var $pad = __webpack_require__(439);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(150)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(150)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 1026 */
[2015, 306],
/* 1027 */
[2016, 306],
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(10);
	
	$export($export.S, 'System', { global: __webpack_require__(22) });


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(213)('WeakMap');


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(214)('WeakMap');


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(213)('WeakSet');


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(214)('WeakSet');


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(308);
	var getKeys = __webpack_require__(124);
	var redefine = __webpack_require__(61);
	var global = __webpack_require__(22);
	var hide = __webpack_require__(60);
	var Iterators = __webpack_require__(148);
	var wks = __webpack_require__(33);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(10);
	var $task = __webpack_require__(304);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(22);
	var $export = __webpack_require__(10);
	var navigator = global.navigator;
	var slice = [].slice;
	var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(446);
	__webpack_require__(905);
	__webpack_require__(907);
	__webpack_require__(906);
	__webpack_require__(909);
	__webpack_require__(911);
	__webpack_require__(916);
	__webpack_require__(910);
	__webpack_require__(908);
	__webpack_require__(918);
	__webpack_require__(917);
	__webpack_require__(913);
	__webpack_require__(914);
	__webpack_require__(912);
	__webpack_require__(904);
	__webpack_require__(915);
	__webpack_require__(919);
	__webpack_require__(443);
	__webpack_require__(872);
	__webpack_require__(874);
	__webpack_require__(873);
	__webpack_require__(921);
	__webpack_require__(920);
	__webpack_require__(892);
	__webpack_require__(902);
	__webpack_require__(903);
	__webpack_require__(893);
	__webpack_require__(894);
	__webpack_require__(895);
	__webpack_require__(896);
	__webpack_require__(897);
	__webpack_require__(898);
	__webpack_require__(899);
	__webpack_require__(900);
	__webpack_require__(901);
	__webpack_require__(875);
	__webpack_require__(876);
	__webpack_require__(877);
	__webpack_require__(878);
	__webpack_require__(879);
	__webpack_require__(880);
	__webpack_require__(881);
	__webpack_require__(882);
	__webpack_require__(883);
	__webpack_require__(884);
	__webpack_require__(885);
	__webpack_require__(886);
	__webpack_require__(887);
	__webpack_require__(888);
	__webpack_require__(889);
	__webpack_require__(890);
	__webpack_require__(891);
	__webpack_require__(952);
	__webpack_require__(957);
	__webpack_require__(964);
	__webpack_require__(955);
	__webpack_require__(947);
	__webpack_require__(948);
	__webpack_require__(953);
	__webpack_require__(958);
	__webpack_require__(960);
	__webpack_require__(943);
	__webpack_require__(944);
	__webpack_require__(945);
	__webpack_require__(946);
	__webpack_require__(949);
	__webpack_require__(950);
	__webpack_require__(951);
	__webpack_require__(954);
	__webpack_require__(956);
	__webpack_require__(959);
	__webpack_require__(961);
	__webpack_require__(962);
	__webpack_require__(963);
	__webpack_require__(867);
	__webpack_require__(869);
	__webpack_require__(868);
	__webpack_require__(871);
	__webpack_require__(870);
	__webpack_require__(856);
	__webpack_require__(854);
	__webpack_require__(860);
	__webpack_require__(857);
	__webpack_require__(863);
	__webpack_require__(865);
	__webpack_require__(853);
	__webpack_require__(859);
	__webpack_require__(850);
	__webpack_require__(864);
	__webpack_require__(848);
	__webpack_require__(862);
	__webpack_require__(861);
	__webpack_require__(855);
	__webpack_require__(858);
	__webpack_require__(847);
	__webpack_require__(849);
	__webpack_require__(852);
	__webpack_require__(851);
	__webpack_require__(866);
	__webpack_require__(308);
	__webpack_require__(937);
	__webpack_require__(942);
	__webpack_require__(444);
	__webpack_require__(938);
	__webpack_require__(939);
	__webpack_require__(940);
	__webpack_require__(941);
	__webpack_require__(922);
	__webpack_require__(442);
	__webpack_require__(445);
	__webpack_require__(447);
	__webpack_require__(976);
	__webpack_require__(965);
	__webpack_require__(966);
	__webpack_require__(971);
	__webpack_require__(974);
	__webpack_require__(975);
	__webpack_require__(969);
	__webpack_require__(972);
	__webpack_require__(970);
	__webpack_require__(973);
	__webpack_require__(967);
	__webpack_require__(968);
	__webpack_require__(923);
	__webpack_require__(924);
	__webpack_require__(925);
	__webpack_require__(926);
	__webpack_require__(927);
	__webpack_require__(930);
	__webpack_require__(928);
	__webpack_require__(929);
	__webpack_require__(931);
	__webpack_require__(932);
	__webpack_require__(933);
	__webpack_require__(934);
	__webpack_require__(936);
	__webpack_require__(935);
	__webpack_require__(979);
	__webpack_require__(977);
	__webpack_require__(978);
	__webpack_require__(1020);
	__webpack_require__(1023);
	__webpack_require__(1022);
	__webpack_require__(1024);
	__webpack_require__(1025);
	__webpack_require__(1021);
	__webpack_require__(1026);
	__webpack_require__(1027);
	__webpack_require__(1001);
	__webpack_require__(1004);
	__webpack_require__(1000);
	__webpack_require__(998);
	__webpack_require__(999);
	__webpack_require__(1002);
	__webpack_require__(1003);
	__webpack_require__(985);
	__webpack_require__(1019);
	__webpack_require__(984);
	__webpack_require__(1018);
	__webpack_require__(1030);
	__webpack_require__(1032);
	__webpack_require__(983);
	__webpack_require__(1017);
	__webpack_require__(1029);
	__webpack_require__(1031);
	__webpack_require__(982);
	__webpack_require__(1028);
	__webpack_require__(981);
	__webpack_require__(986);
	__webpack_require__(987);
	__webpack_require__(988);
	__webpack_require__(989);
	__webpack_require__(990);
	__webpack_require__(992);
	__webpack_require__(991);
	__webpack_require__(993);
	__webpack_require__(994);
	__webpack_require__(995);
	__webpack_require__(997);
	__webpack_require__(996);
	__webpack_require__(1006);
	__webpack_require__(1007);
	__webpack_require__(1008);
	__webpack_require__(1009);
	__webpack_require__(1011);
	__webpack_require__(1010);
	__webpack_require__(1013);
	__webpack_require__(1012);
	__webpack_require__(1014);
	__webpack_require__(1015);
	__webpack_require__(1016);
	__webpack_require__(980);
	__webpack_require__(1005);
	__webpack_require__(1035);
	__webpack_require__(1034);
	__webpack_require__(1033);
	module.exports = __webpack_require__(78);


/***/ }),
/* 1037 */
/***/ (function(module, exports) {

	'use strict'
	
	var allCountries = [
	       [
	          'Afghanistan (‫افغانستان‬‎)',
	          'af',
	          '93',
	          '+..-..-...-....'
	       ],
	       [
	          'Albania (Shqipëri)',
	          'al',
	          '355',
	          '+...(...)...-...'
	       ],
	       [
	          'Algeria (‫الجزائر‬‎)',
	          'dz',
	          '213',
	          '+...-..-...-....'
	       ],
	       [
	          'American Samoa',
	          'as',
	          '1684',
	          '+.(...)...-....'
	       ],
	       [
	          'Andorra',
	          'ad',
	          '376',
	          '+...-...-...'
	       ],
	       [
	          'Angola',
	          'ao',
	          '244',
	          '+...(...)...-...'
	       ],
	       [
	          'Anguilla',
	          'ai',
	          '1264',
	          '+.(...)...-....'
	       ],
	       [
	          'Antigua and Barbuda',
	          'ag',
	          '1268',
	          '+.(...)...-....'
	       ],
	       [
	          'Argentina',
	          'ar',
	          '54',
	          '+..(...)...-....'
	       ],
	       [
	          'Armenia (Հայաստան)',
	          'am',
	          '374',
	          '+...-..-...-...'
	       ],
	       [
	          'Aruba',
	          'aw',
	          '297',
	          '+...-...-....'
	       ],
	       [
	          'Australia',
	          'au',
	          '61',
	          '+.. ... ... ...'
	       ],
	       [
	          'Austria (Österreich)',
	          'at',
	          '43',
	          '+..(...)...-....'
	       ],
	       [
	          'Azerbaijan (Azərbaycan)',
	          'az',
	          '994',
	          '+...-..-...-..-..'
	       ],
	       [
	          'Bahamas',
	          'bs',
	          '1242',
	          '+.(...)...-....'
	       ],
	       [
	          'Bahrain (‫البحرين‬‎)',
	          'bh',
	          '973',
	          '+...-....-....'
	       ],
	       [
	          'Bangladesh (বাংলাদেশ)',
	          'bd',
	          '880',
	          '+...-..-...-...'
	       ],
	       [
	          'Barbados',
	          'bb',
	          '1246',
	          '+.(...)...-....'
	       ],
	       [
	          'Belarus (Беларусь)',
	          'by',
	          '375',
	          '+...(..)...-..-..'
	       ],
	       [
	          'Belgium (België)',
	          'be',
	          '32',
	          '+.. ... .. .. ..'
	       ],
	       [
	          'Belize',
	          'bz',
	          '501',
	          '+...-...-....'
	       ],
	       [
	          'Benin (Bénin)',
	          'bj',
	          '229',
	          '+...-..-..-....'
	       ],
	       [
	          'Bermuda',
	          'bm',
	          '1441',
	          '+.(...)...-....'
	       ],
	       [
	          'Bhutan (འབྲུག)',
	          'bt',
	          '975',
	          '+...-.-...-...'
	       ],
	       [
	          'Bolivia',
	          'bo',
	          '591',
	          '+...-.-...-....'
	       ],
	       [
	          'Bosnia and Herzegovina (Босна и Херцеговина)',
	          'ba',
	          '387',
	          '+...-..-....'
	       ],
	       [
	          'Botswana',
	          'bw',
	          '267',
	          '+...-..-...-...'
	       ],
	       [
	          'Brazil (Brasil)',
	          'br',
	          '55',
	          '+..-..-....-....'
	       ],
	       [
	          'British Indian Ocean Territory',
	          'io',
	          '246',
	          '+...-...-....'
	       ],
	       [
	          'British Virgin Islands',
	          'vg',
	          '1284',
	          '+.(...)...-....'
	       ],
	       [
	          'Brunei',
	          'bn',
	          '673',
	          '+...-...-....'
	       ],
	       [
	          'Bulgaria (България)',
	          'bg',
	          '359',
	          '+...(...)...-...'
	       ],
	       [
	          'Burkina Faso',
	          'bf',
	          '226',
	          '+...-..-..-....'
	       ],
	       [
	          'Burundi (Uburundi)',
	          'bi',
	          '257',
	          '+...-..-..-....'
	       ],
	       [
	          'Cambodia (កម្ពុជា)',
	          'kh',
	          '855',
	          '+...-..-...-...'
	       ],
	       [
	          'Cameroon (Cameroun)',
	          'cm',
	          '237',
	          '+...-....-....'
	       ],
	       [
	          'Canada',
	          'ca',
	          '1',
	          '+. (...) ...-....',
	          1,
	          [
	             '204',
	             '236',
	             '249',
	             '250',
	             '289',
	             '306',
	             '343',
	             '365',
	             '387',
	             '403',
	             '416',
	             '418',
	             '431',
	             '437',
	             '438',
	             '450',
	             '506',
	             '514',
	             '519',
	             '548',
	             '579',
	             '581',
	             '587',
	             '604',
	             '613',
	             '639',
	             '647',
	             '672',
	             '705',
	             '709',
	             '742',
	             '778',
	             '780',
	             '782',
	             '807',
	             '819',
	             '825',
	             '867',
	             '873',
	             '902',
	             '905'
	          ]
	       ],
	       [
	          'Cape Verde (Kabu Verdi)',
	          'cv',
	          '238',
	          '+...(...)..-..'
	       ],
	       [
	          'Caribbean Netherlands',
	          'bq',
	          '599',
	          '+...-...-....',
	          1
	       ],
	       [
	          'Cayman Islands',
	          'ky',
	          '1345',
	          '+.(...)...-....'
	       ],
	       [
	          'Central African Republic (République centrafricaine)',
	          'cf',
	          '236',
	          '+...-..-..-....'
	       ],
	       [
	          'Chad (Tchad)',
	          'td',
	          '235',
	          '+...-..-..-..-..'
	       ],
	       [
	          'Chile',
	          'cl',
	          '56',
	          '+..-.-....-....'
	       ],
	       [
	          'China (中国)',
	          'cn',
	          '86',
	          '+.. ..-........'
	       ],
	       [
	          'Colombia',
	          'co',
	          '57',
	          '+..(...)...-....'
	       ],
	       [
	          'Comoros (‫جزر القمر‬‎)',
	          'km',
	          '269',
	          '+...-..-.....'
	       ],
	       [
	          'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
	          'cd',
	          '243',
	          '+...(...)...-...'
	       ],
	       [
	          'Congo (Republic) (Congo-Brazzaville)',
	          'cg',
	          '242',
	          '+...-..-...-....'
	       ],
	       [
	          'Cook Islands',
	          'ck',
	          '682',
	          '+...-..-...'
	       ],
	       [
	          'Costa Rica',
	          'cr',
	          '506',
	          '+... ....-....'
	       ],
	       [
	          'Côte d’Ivoire',
	          'ci',
	          '225',
	          '+...-..-...-...'
	       ],
	       [
	          'Croatia (Hrvatska)',
	          'hr',
	          '385',
	          '+...-..-...-...'
	       ],
	       [
	          'Cuba',
	          'cu',
	          '53',
	          '+..-.-...-....'
	       ],
	       [
	          'Curaçao',
	          'cw',
	          '599',
	          '+...-...-....',
	          0
	       ],
	       [
	          'Cyprus (Κύπρος)',
	          'cy',
	          '357',
	          '+...-..-...-...'
	       ],
	       [
	          'Czech Republic (Česká republika)',
	          'cz',
	          '420',
	          '+...(...)...-...'
	       ],
	       [
	          'Denmark (Danmark)',
	          'dk',
	          '45',
	          '+.. .. .. .. ..'
	       ],
	       [
	          'Djibouti',
	          'dj',
	          '253',
	          '+...-..-..-..-..'
	       ],
	       [
	          'Dominica',
	          'dm',
	          '1767',
	          '+.(...)...-....'
	       ],
	       [
	          'Dominican Republic (República Dominicana)',
	          'do',
	          '1',
	          '+.(...)...-....',
	          2,
	          [
	             '809',
	             '829',
	             '849'
	          ]
	       ],
	       [
	          'Ecuador',
	          'ec',
	          '593',
	          '+...-.-...-....'
	       ],
	       [
	          'Egypt (‫مصر‬‎)',
	          'eg',
	          '20',
	          '+..(...)...-....'
	       ],
	       [
	          'El Salvador',
	          'sv',
	          '503',
	          '+... ....-....'
	       ],
	       [
	          'Equatorial Guinea (Guinea Ecuatorial)',
	          'gq',
	          '240',
	          '+...-..-...-....'
	       ],
	       [
	          'Eritrea',
	          'er',
	          '291',
	          '+...-.-...-...'
	       ],
	       [
	          'Estonia (Eesti)',
	          'ee',
	          '372',
	          '+...-...-....'
	       ],
	       [
	          'Ethiopia',
	          'et',
	          '251',
	          '+...-..-...-....'
	       ],
	       [
	          'Falkland Islands (Islas Malvinas)',
	          'fk',
	          '500',
	          '+...-.....'
	       ],
	       [
	          'Faroe Islands (Føroyar)',
	          'fo',
	          '298',
	          '+...-...-...'
	       ],
	       [
	          'Fiji',
	          'fj',
	          '679',
	          '+...-..-.....'
	       ],
	       [
	          'Finland (Suomi)',
	          'fi',
	          '358',
	          '+... .. ... .. ..'
	       ],
	       [
	          'France',
	          'fr',
	          '33',
	          '+.. . .. .. .. ..'
	       ],
	       [
	          'French Guiana (Guyane française)',
	          'gf',
	          '594',
	          '+...-.....-....'
	       ],
	       [
	          'French Polynesia (Polynésie française)',
	          'pf',
	          '689',
	          '+...-..-..-..'
	       ],
	       [
	          'Gabon',
	          'ga',
	          '241',
	          '+...-.-..-..-..'
	       ],
	       [
	          'Gambia',
	          'gm',
	          '220',
	          '+...(...)..-..'
	       ],
	       [
	          'Georgia (საქართველო)',
	          'ge',
	          '995',
	          '+...(...)...-...'
	       ],
	       [
	          'Germany (Deutschland)',
	          'de',
	          '49',
	          '+.. ... .......'
	       ],
	       [
	          'Ghana (Gaana)',
	          'gh',
	          '233',
	          '+...(...)...-...'
	       ],
	       [
	          'Gibraltar',
	          'gi',
	          '350',
	          '+...-...-.....'
	       ],
	       [
	          'Greece (Ελλάδα)',
	          'gr',
	          '30',
	          '+..(...)...-....'
	       ],
	       [
	          'Greenland (Kalaallit Nunaat)',
	          'gl',
	          '299',
	          '+...-..-..-..'
	       ],
	       [
	          'Grenada',
	          'gd',
	          '1473',
	          '+.(...)...-....'
	       ],
	       [
	          'Guadeloupe',
	          'gp',
	          '590',
	          '',
	          0
	       ],
	       [
	          'Guam',
	          'gu',
	          '1671',
	          '+.(...)...-....'
	       ],
	       [
	          'Guatemala',
	          'gt',
	          '502',
	          '+... ....-....'
	       ],
	       [
	          'Guinea (Guinée)',
	          'gn',
	          '224',
	          '+...-..-...-...'
	       ],
	       [
	          'Guinea-Bissau (Guiné Bissau)',
	          'gw',
	          '245',
	          '+...-.-......'
	       ],
	       [
	          'Guyana',
	          'gy',
	          '592',
	          '+...-...-....'
	       ],
	       [
	          'Haiti',
	          'ht',
	          '509',
	          '+... ....-....'
	       ],
	       [
	          'Honduras',
	          'hn',
	          '504',
	          '+...-....-....'
	       ],
	       [
	          'Hong Kong (香港)',
	          'hk',
	          '852',
	          '+... .... ....'
	       ],
	       [
	          'Hungary (Magyarország)',
	          'hu',
	          '36',
	          '+..(...)...-...'
	       ],
	       [
	          'Iceland (Ísland)',
	          'is',
	          '354',
	          '+... ... ....'
	       ],
	       [
	          'India (भारत)',
	          'in',
	          '91',
	          '+.. .....-.....'
	       ],
	       [
	          'Indonesia',
	          'id',
	          '62',
	          '+..-..-...-..'
	       ],
	       [
	          'Iran (‫ایران‬‎)',
	          'ir',
	          '98',
	          '+..(...)...-....'
	       ],
	       [
	          'Iraq (‫العراق‬‎)',
	          'iq',
	          '964',
	          '+...(...)...-....'
	       ],
	       [
	          'Ireland',
	          'ie',
	          '353',
	          '+... .. .......'
	       ],
	       [
	          'Israel (‫ישראל‬‎)',
	          'il',
	          '972',
	          '+...-.-...-....'
	       ],
	       [
	          'Italy (Italia)',
	          'it',
	          '39',
	          '+.. ... ......',
	          0
	       ],
	       [
	          'Jamaica',
	          'jm',
	          '1876',
	          '+.(...)...-....'
	       ],
	       [
	          'Japan (日本)',
	          'jp',
	          '81',
	          '+.. ... .. ....'
	       ],
	       [
	          'Jordan (‫الأردن‬‎)',
	          'jo',
	          '962',
	          '+...-.-....-....'
	       ],
	       [
	          'Kazakhstan (Казахстан)',
	          'kz',
	          '7',
	          '+. ... ...-..-..',
	          1
	       ],
	       [
	          'Kenya',
	          'ke',
	          '254',
	          '+...-...-......'
	       ],
	       [
	          'Kiribati',
	          'ki',
	          '686',
	          '+...-..-...'
	       ],
	       [
	          'Kuwait (‫الكويت‬‎)',
	          'kw',
	          '965',
	          '+...-....-....'
	       ],
	       [
	          'Kyrgyzstan (Кыргызстан)',
	          'kg',
	          '996',
	          '+...(...)...-...'
	       ],
	       [
	          'Laos (ລາວ)',
	          'la',
	          '856',
	          '+...-..-...-...'
	       ],
	       [
	          'Latvia (Latvija)',
	          'lv',
	          '371',
	          '+...-..-...-...'
	       ],
	       [
	          'Lebanon (‫لبنان‬‎)',
	          'lb',
	          '961',
	          '+...-.-...-...'
	       ],
	       [
	          'Lesotho',
	          'ls',
	          '266',
	          '+...-.-...-....'
	       ],
	       [
	          'Liberia',
	          'lr',
	          '231',
	          '+...-..-...-...'
	       ],
	       [
	          'Libya (‫ليبيا‬‎)',
	          'ly',
	          '218',
	          '+...-..-...-...'
	       ],
	       [
	          'Liechtenstein',
	          'li',
	          '423',
	          '+...(...)...-....'
	       ],
	       [
	          'Lithuania (Lietuva)',
	          'lt',
	          '370',
	          '+...(...)..-...'
	       ],
	       [
	          'Luxembourg',
	          'lu',
	          '352',
	          '+...(...)...-...'
	       ],
	       [
	          'Macau (澳門)',
	          'mo',
	          '853',
	          '+...-....-....'
	       ],
	       [
	          'Macedonia (FYROM) (Македонија)',
	          'mk',
	          '389',
	          '+...-..-...-...'
	       ],
	       [
	          'Madagascar (Madagasikara)',
	          'mg',
	          '261',
	          '+...-..-..-.....'
	       ],
	       [
	          'Malawi',
	          'mw',
	          '265',
	          '+...-.-....-....'
	       ],
	       [
	          'Malaysia',
	          'my',
	          '60',
	          '+.. ..-....-....'
	       ],
	       [
	          'Maldives',
	          'mv',
	          '960',
	          '+...-...-....'
	       ],
	       [
	          'Mali',
	          'ml',
	          '223',
	          '+...-..-..-....'
	       ],
	       [
	          'Malta',
	          'mt',
	          '356',
	          '+...-....-....'
	       ],
	       [
	          'Marshall Islands',
	          'mh',
	          '692',
	          '+...-...-....'
	       ],
	       [
	          'Martinique',
	          'mq',
	          '596',
	          '+...(...)..-..-..'
	       ],
	       [
	          'Mauritania (‫موريتانيا‬‎)',
	          'mr',
	          '222',
	          '+...-..-..-....'
	       ],
	       [
	          'Mauritius (Moris)',
	          'mu',
	          '230',
	          '+...-...-....'
	       ],
	       [
	          'Mexico (México)',
	          'mx',
	          '52',
	          '+..-..-..-....'
	       ],
	       [
	          'Micronesia',
	          'fm',
	          '691',
	          '+...-...-....'
	       ],
	       [
	          'Moldova (Republica Moldova)',
	          'md',
	          '373',
	          '+...-....-....'
	       ],
	       [
	          'Monaco',
	          'mc',
	          '377',
	          '+...-..-...-...'
	       ],
	       [
	          'Mongolia (Монгол)',
	          'mn',
	          '976',
	          '+...-..-..-....'
	       ],
	       [
	          'Montenegro (Crna Gora)',
	          'me',
	          '382',
	          '+...-..-...-...'
	       ],
	       [
	          'Montserrat',
	          'ms',
	          '1664',
	          '+.(...)...-....'
	       ],
	       [
	          'Morocco (‫المغرب‬‎)',
	          'ma',
	          '212',
	          '+...-..-....-...'
	       ],
	       [
	          'Mozambique (Moçambique)',
	          'mz',
	          '258',
	          '+...-..-...-...'
	       ],
	       [
	          'Myanmar (Burma) (မြန်မာ)',
	          'mm',
	          '95',
	          '+..-...-...'
	       ],
	       [
	          'Namibia (Namibië)',
	          'na',
	          '264',
	          '+...-..-...-....'
	       ],
	       [
	          'Nauru',
	          'nr',
	          '674',
	          '+...-...-....'
	       ],
	       [
	          'Nepal (नेपाल)',
	          'np',
	          '977',
	          '+...-..-...-...'
	       ],
	       [
	          'Netherlands (Nederland)',
	          'nl',
	          '31',
	          '+.. .. ........'
	       ],
	       [
	          'New Caledonia (Nouvelle-Calédonie)',
	          'nc',
	          '687',
	          '+...-..-....'
	       ],
	       [
	          'New Zealand',
	          'nz',
	          '64',
	          '+.. ...-...-....'
	       ],
	       [
	          'Nicaragua',
	          'ni',
	          '505',
	          '+...-....-....'
	       ],
	       [
	          'Niger (Nijar)',
	          'ne',
	          '227',
	          '+...-..-..-....'
	       ],
	       [
	          'Nigeria',
	          'ng',
	          '234',
	          '+...-..-...-..'
	       ],
	       [
	          'Niue',
	          'nu',
	          '683',
	          '+...-....'
	       ],
	       [
	          'Norfolk Island',
	          'nf',
	          '672',
	          '+...-...-...'
	       ],
	       [
	          'North Korea (조선 민주주의 인민 공화국)',
	          'kp',
	          '850',
	          '+...-...-...'
	       ],
	       [
	          'Northern Mariana Islands',
	          'mp',
	          '1670',
	          '+.(...)...-....'
	       ],
	       [
	          'Norway (Norge)',
	          'no',
	          '47',
	          '+.. ... .. ...'
	       ],
	       [
	          'Oman (‫عُمان‬‎)',
	          'om',
	          '968',
	          '+...-..-...-...'
	       ],
	       [
	          'Pakistan (‫پاکستان‬‎)',
	          'pk',
	          '92',
	          '+.. ...-.......'
	       ],
	       [
	          'Palau',
	          'pw',
	          '680',
	          '+...-...-....'
	       ],
	       [
	          'Palestine (‫فلسطين‬‎)',
	          'ps',
	          '970',
	          '+...-..-...-....'
	       ],
	       [
	          'Panama (Panamá)',
	          'pa',
	          '507',
	          '+...-...-....'
	       ],
	       [
	          'Papua New Guinea',
	          'pg',
	          '675',
	          '+...(...)..-...'
	       ],
	       [
	          'Paraguay',
	          'py',
	          '595',
	          '+...(...)...-...'
	       ],
	       [
	          'Peru (Perú)',
	          'pe',
	          '51',
	          '+..(...)...-...'
	       ],
	       [
	          'Philippines',
	          'ph',
	          '63',
	          '+.. ... ....'
	       ],
	       [
	          'Poland (Polska)',
	          'pl',
	          '48',
	          '+.. ...-...-...'
	       ],
	       [
	          'Portugal',
	          'pt',
	          '351',
	          '+...-..-...-....'
	       ],
	       [
	          'Puerto Rico',
	          'pr',
	          '1',
	          '',
	          3,
	          [
	             '787',
	             '939'
	          ]
	       ],
	       [
	          'Qatar (‫قطر‬‎)',
	          'qa',
	          '974',
	          '+...-....-....'
	       ],
	       [
	          'Réunion (La Réunion)',
	          're',
	          '262',
	          '+...-.....-....'
	       ],
	       [
	          'Romania (România)',
	          'ro',
	          '40',
	          '+..-..-...-....'
	       ],
	       [
	          'Russia (Россия)',
	          'ru',
	          '7',
	          '+. ... ...-..-..',
	          0
	       ],
	       [
	          'Rwanda',
	          'rw',
	          '250',
	          '+...(...)...-...'
	       ],
	       [
	          'Saint Barthélemy (Saint-Barthélemy)',
	          'bl',
	          '590',
	          '',
	          1
	       ],
	       [
	          'Saint Helena',
	          'sh',
	          '290'
	       ],
	       [
	          'Saint Kitts and Nevis',
	          'kn',
	          '1869',
	          '+.(...)...-....'
	       ],
	       [
	          'Saint Lucia',
	          'lc',
	          '1758',
	          '+.(...)...-....'
	       ],
	       [
	          'Saint Martin (Saint-Martin (partie française))',
	          'mf',
	          '590',
	          '',
	          2
	       ],
	       [
	          'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
	          'pm',
	          '508'
	       ],
	       [
	          'Saint Vincent and the Grenadines',
	          'vc',
	          '1784',
	          '+.(...)...-....'
	       ],
	       [
	          'Samoa',
	          'ws',
	          '685',
	          '+...-..-....'
	       ],
	       [
	          'San Marino',
	          'sm',
	          '378',
	          '+...-....-......'
	       ],
	       [
	          'São Tomé and Príncipe (São Tomé e Príncipe)',
	          'st',
	          '239',
	          '+...-..-.....'
	       ],
	       [
	          'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
	          'sa',
	          '966',
	          '+...-.-...-....'
	       ],
	       [
	          'Senegal (Sénégal)',
	          'sn',
	          '221',
	          '+...-..-...-....'
	       ],
	       [
	          'Serbia (Србија)',
	          'rs',
	          '381',
	          '+...-..-...-....'
	       ],
	       [
	          'Seychelles',
	          'sc',
	          '248',
	          '+...-.-...-...'
	       ],
	       [
	          'Sierra Leone',
	          'sl',
	          '232',
	          '+...-..-......'
	       ],
	       [
	          'Singapore',
	          'sg',
	          '65',
	          '+.. ....-....'
	       ],
	       [
	          'Sint Maarten',
	          'sx',
	          '1721',
	          '+.(...)...-....'
	       ],
	       [
	          'Slovakia (Slovensko)',
	          'sk',
	          '421',
	          '+...(...)...-...'
	       ],
	       [
	          'Slovenia (Slovenija)',
	          'si',
	          '386',
	          '+...-..-...-...'
	       ],
	       [
	          'Solomon Islands',
	          'sb',
	          '677',
	          '+...-.....'
	       ],
	       [
	          'Somalia (Soomaaliya)',
	          'so',
	          '252',
	          '+...-.-...-...'
	       ],
	       [
	          'South Africa',
	          'za',
	          '27',
	          '+..-..-...-....'
	       ],
	       [
	          'South Korea (대한민국)',
	          'kr',
	          '82',
	          '+..-..-...-....'
	       ],
	       [
	          'South Sudan (‫جنوب السودان‬‎)',
	          'ss',
	          '211',
	          '+...-..-...-....'
	       ],
	       [
	          'Spain (España)',
	          'es',
	          '34',
	          '+.. ... ... ...'
	       ],
	       [
	          'Sri Lanka (ශ්‍රී ලංකාව)',
	          'lk',
	          '94',
	          '+..-..-...-....'
	       ],
	       [
	          'Sudan (‫السودان‬‎)',
	          'sd',
	          '249',
	          '+...-..-...-....'
	       ],
	       [
	          'Suriname',
	          'sr',
	          '597',
	          '+...-...-...'
	       ],
	       [
	          'Swaziland',
	          'sz',
	          '268',
	          '+...-..-..-....'
	       ],
	       [
	          'Sweden (Sverige)',
	          'se',
	          '46',
	          '+.. .. ... .. ..'
	       ],
	       [
	          'Switzerland (Schweiz)',
	          'ch',
	          '41',
	          '+.. .. ... .. ..'
	       ],
	       [
	          'Syria (‫سوريا‬‎)',
	          'sy',
	          '963',
	          '+...-..-....-...'
	       ],
	       [
	          'Taiwan (台灣)',
	          'tw',
	          '886',
	          '+...-....-....'
	       ],
	       [
	          'Tajikistan',
	          'tj',
	          '992',
	          '+...-..-...-....'
	       ],
	       [
	          'Tanzania',
	          'tz',
	          '255',
	          '+...-..-...-....'
	       ],
	       [
	          'Thailand (ไทย)',
	          'th',
	          '66',
	          '+..-..-...-...'
	       ],
	       [
	          'Timor-Leste',
	          'tl',
	          '670',
	          '+...-...-....'
	       ],
	       [
	          'Togo',
	          'tg',
	          '228',
	          '+...-..-...-...'
	       ],
	       [
	          'Tokelau',
	          'tk',
	          '690',
	          '+...-....'
	       ],
	       [
	          'Tonga',
	          'to',
	          '676',
	          '+...-.....'
	       ],
	       [
	          'Trinidad and Tobago',
	          'tt',
	          '1868',
	          '+.(...)...-....'
	       ],
	       [
	          'Tunisia (‫تونس‬‎)',
	          'tn',
	          '216',
	          '+...-..-...-...'
	       ],
	       [
	          'Turkey (Türkiye)',
	          'tr',
	          '90',
	          '+.. ... ... .. ..'
	       ],
	       [
	          'Turkmenistan',
	          'tm',
	          '993',
	          '+...-.-...-....'
	       ],
	       [
	          'Turks and Caicos Islands',
	          'tc',
	          '1649',
	          '+.(...)...-....'
	       ],
	       [
	          'Tuvalu',
	          'tv',
	          '688',
	          '+...-.....'
	       ],
	       [
	          'U.S. Virgin Islands',
	          'vi',
	          '1340',
	          '+.(...)...-....'
	       ],
	       [
	          'Uganda',
	          'ug',
	          '256',
	          '+...(...)...-...'
	       ],
	       [
	          'Ukraine (Україна)',
	          'ua',
	          '380',
	          '+...(..)...-..-..'
	       ],
	       [
	          'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
	          'ae',
	          '971',
	          '+...-.-...-....'
	       ],
	       [
	          'United Kingdom',
	          'gb',
	          '44',
	          '+.. .... ......'
	       ],
	       [
	          'United States',
	          'us',
	          '1',
	          '+. (...) ...-....',
	          0
	       ],
	       [
	          'Uruguay',
	          'uy',
	          '598',
	          '+...-.-...-..-..'
	       ],
	       [
	          'Uzbekistan (Oʻzbekiston)',
	          'uz',
	          '998',
	          '+...-..-...-....'
	       ],
	       [
	          'Vanuatu',
	          'vu',
	          '678',
	          '+...-.....'
	       ],
	       [
	          'Vatican City (Città del Vaticano)',
	          'va',
	          '39',
	          '+.. .. .... ....',
	          1
	       ],
	       [
	          'Venezuela',
	          've',
	          '58',
	          '+..(...)...-....'
	       ],
	       [
	          'Vietnam (Việt Nam)',
	          'vn',
	          '84',
	          '+..-..-....-...'
	       ],
	       [
	          'Wallis and Futuna',
	          'wf',
	          '681',
	          '+...-..-....'
	       ],
	       [
	          'Yemen (‫اليمن‬‎)',
	          'ye',
	          '967',
	          '+...-.-...-...'
	       ],
	       [
	          'Zambia',
	          'zm',
	          '260',
	          '+...-..-...-....'
	       ],
	       [
	          'Zimbabwe',
	          'zw',
	          '263',
	          '+...-.-......'
	       ]
	   ];
	
	// we will build this in the loop below
	var allCountryCodes = {};
	var iso2Lookup = {};
	var addCountryCode = function (iso2, dialCode, priority) {
	    if (!(dialCode in allCountryCodes)) {
	        allCountryCodes[dialCode] = [];
	    }
	    var index = priority || 0;
	    allCountryCodes[dialCode][index] = iso2;
	};
	
	for (var i = 0; i < allCountries.length; i++) {
	   // countries
	   var c = allCountries[i];
	   allCountries[i] = {
	       name: c[0],
	       iso2: c[1],
	       dialCode: c[2],
	       priority: c[4] || 0
	   };
	
	   // format
	   if (c[3]) {
	       allCountries[i].format = c[3];
	   }
	
	   // area codes
	   if (c[5]) {
	       allCountries[i].hasAreaCodes = true;
	       for (var j = 0; j < c[5].length; j++) {
	           // full dial code is country code + dial code
	           var dialCode = c[2] + c[5][j];
	           addCountryCode(c[1], dialCode);
	       }
	   }
	   iso2Lookup[allCountries[i].iso2] = i;
	
	   // dial codes
	   addCountryCode(c[1], c[2], c[4]);
	}
	
	module.exports = {
	           allCountries: allCountries,
	           iso2Lookup: iso2Lookup,
	           allCountryCodes: allCountryCodes
	       };


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(609);
	
	var emptyObject = __webpack_require__(1128);
	var _invariant = __webpack_require__(457);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(1038);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(1251);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 1042 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(453);
	
	exports.__esModule = true;
	
	/**
	 * document.activeElement
	 */
	exports['default'] = activeElement;
	
	var _ownerDocument = __webpack_require__(451);
	
	var _ownerDocument2 = babelHelpers.interopRequireDefault(_ownerDocument);
	
	function activeElement() {
	  var doc = arguments[0] === undefined ? document : arguments[0];
	
	  try {
	    return doc.activeElement;
	  } catch (e) {}
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var contains = __webpack_require__(310),
	    qsa = __webpack_require__(1046);
	
	module.exports = function (selector, handler) {
	  return function (e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = qsa(top, selector);
	
	    if (matches.some(function (match) {
	      return contains(match, target);
	    })) handler.call(this, e);
	  };
	};

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var on = __webpack_require__(450),
	    off = __webpack_require__(449),
	    filter = __webpack_require__(1044);
	
	module.exports = { on: on, off: off, filter: filter };

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

	'use strict';
	//     Zepto.js
	//     (c) 2010-2015 Thomas Fuchs
	//     Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/,
	    toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	module.exports = function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	};

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(452);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	};

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(452);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	};

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(453);
	
	var _utilCamelizeStyle = __webpack_require__(454);
	
	var _utilCamelizeStyle2 = babelHelpers.interopRequireDefault(_utilCamelizeStyle);
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	module.exports = function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : { //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _utilCamelizeStyle2['default'])(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	};

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var camelize = __webpack_require__(454),
	    hyphenate = __webpack_require__(1054),
	    _getComputedStyle = __webpack_require__(1049),
	    removeStyle = __webpack_require__(1051);
	
	var has = Object.prototype.hasOwnProperty;
	
	module.exports = function style(node, property, value) {
	  var css = '',
	      props = property;
	
	  if (typeof property === 'string') {
	
	    if (value === undefined) return node.style[camelize(property)] || _getComputedStyle(node).getPropertyValue(hyphenate(property));else (props = {})[property] = value;
	  }
	
	  for (var key in props) if (has.call(props, key)) {
	    !props[key] && props[key] !== 0 ? removeStyle(node, hyphenate(key)) : css += hyphenate(key) + ':' + props[key] + ';';
	  }
	
	  node.style.cssText += ';' + css;
	};

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	};

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

	"use strict";
	
	var rHyphen = /-(.)/g;
	
	module.exports = function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	};

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

	'use strict';
	
	var rUpper = /([A-Z])/g;
	
	module.exports = function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	};

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	
	"use strict";
	
	var hyphenate = __webpack_require__(1053);
	var msPattern = /^ms-/;
	
	module.exports = function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, "-ms-");
	};

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(152);
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'],
	    cancel = 'clearTimeout',
	    raf = fallback,
	    compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (canUseDOM) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function (cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function (cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  return window[cancel](id);
	};
	
	module.exports = compatRaf;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(152);
	
	var size;
	
	module.exports = function (recalc) {
	  if (!size || recalc) {
	    if (canUseDOM) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1058);


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(1059);
	
	function scrollIntoView(elem, container, config) {
	  config = config || {};
	  // document 归一化到 window
	  if (container.nodeType === 9) {
	    container = util.getWindow(container);
	  }
	
	  var allowHorizontalScroll = config.allowHorizontalScroll;
	  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
	  var alignWithTop = config.alignWithTop;
	  var alignWithLeft = config.alignWithLeft;
	
	  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;
	
	  var isWin = util.isWindow(container);
	  var elemOffset = util.offset(elem);
	  var eh = util.outerHeight(elem);
	  var ew = util.outerWidth(elem);
	  var containerOffset, ch, cw, containerScroll,
	    diffTop, diffBottom, win,
	    winScroll, ww, wh;
	
	  if (isWin) {
	    win = container;
	    wh = util.height(win);
	    ww = util.width(win);
	    winScroll = {
	      left: util.scrollLeft(win),
	      top: util.scrollTop(win)
	    };
	    // elem 相对 container 可视视窗的距离
	    diffTop = {
	      left: elemOffset.left - winScroll.left,
	      top: elemOffset.top - winScroll.top
	    };
	    diffBottom = {
	      left: elemOffset.left + ew - (winScroll.left + ww),
	      top: elemOffset.top + eh - (winScroll.top + wh)
	    };
	    containerScroll = winScroll;
	  } else {
	    containerOffset = util.offset(container);
	    ch = container.clientHeight;
	    cw = container.clientWidth;
	    containerScroll = {
	      left: container.scrollLeft,
	      top: container.scrollTop
	    };
	    // elem 相对 container 可视视窗的距离
	    // 注意边框, offset 是边框到根节点
	    diffTop = {
	      left: elemOffset.left - (containerOffset.left +
	      (parseFloat(util.css(container, 'borderLeftWidth')) || 0)),
	      top: elemOffset.top - (containerOffset.top +
	      (parseFloat(util.css(container, 'borderTopWidth')) || 0))
	    };
	    diffBottom = {
	      left: elemOffset.left + ew -
	      (containerOffset.left + cw +
	      (parseFloat(util.css(container, 'borderRightWidth')) || 0)),
	      top: elemOffset.top + eh -
	      (containerOffset.top + ch +
	      (parseFloat(util.css(container, 'borderBottomWidth')) || 0))
	    };
	  }
	
	  if (diffTop.top < 0 || diffBottom.top > 0) {
	    // 强制向上
	    if (alignWithTop === true) {
	      util.scrollTop(container, containerScroll.top + diffTop.top);
	    } else if (alignWithTop === false) {
	      util.scrollTop(container, containerScroll.top + diffBottom.top);
	    } else {
	      // 自动调整
	      if (diffTop.top < 0) {
	        util.scrollTop(container, containerScroll.top + diffTop.top);
	      } else {
	        util.scrollTop(container, containerScroll.top + diffBottom.top);
	      }
	    }
	  } else {
	    if (!onlyScrollIfNeeded) {
	      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
	      if (alignWithTop) {
	        util.scrollTop(container, containerScroll.top + diffTop.top);
	      } else {
	        util.scrollTop(container, containerScroll.top + diffBottom.top);
	      }
	    }
	  }
	
	  if (allowHorizontalScroll) {
	    if (diffTop.left < 0 || diffBottom.left > 0) {
	      // 强制向上
	      if (alignWithLeft === true) {
	        util.scrollLeft(container, containerScroll.left + diffTop.left);
	      } else if (alignWithLeft === false) {
	        util.scrollLeft(container, containerScroll.left + diffBottom.left);
	      } else {
	        // 自动调整
	        if (diffTop.left < 0) {
	          util.scrollLeft(container, containerScroll.left + diffTop.left);
	        } else {
	          util.scrollLeft(container, containerScroll.left + diffBottom.left);
	        }
	      }
	    } else {
	      if (!onlyScrollIfNeeded) {
	        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
	        if (alignWithLeft) {
	          util.scrollLeft(container, containerScroll.left + diffTop.left);
	        } else {
	          util.scrollLeft(container, containerScroll.left + diffBottom.left);
	        }
	      }
	    }
	  }
	}
	
	module.exports = scrollIntoView;


/***/ }),
/* 1059 */
/***/ (function(module, exports) {

	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	
	function getClientPosition(elem) {
	  var box, x, y;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = box.left;
	  y = box.top;
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	
	  return {left: x, top: y};
	}
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    //ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      //quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	function _getComputedStyle(elem, name, computedStyle) {
	  var val = '';
	  var d = elem.ownerDocument;
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if ((computedStyle = (computedStyle || d.defaultView.getComputedStyle(elem, null)))) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
	var RE_POS = /^(top|right|bottom|left)$/,
	  CURRENT_STYLE = 'currentStyle',
	  RUNTIME_STYLE = 'runtimeStyle',
	  LEFT = 'left',
	  PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style,
	      left = style[LEFT],
	      rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : (ret || 0);
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	
	var getComputedStyleX;
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setOffset(elem, offset) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	
	  var old = getOffset(elem),
	    ret = {},
	    current, key;
	
	  for (key in offset) {
	    current = parseFloat(css(elem, key)) || 0;
	    ret[key] = current + offset[key] - old[key];
	  }
	  css(elem, ret);
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'],
	  CONTENT_INDEX = -1,
	  PADDING_INDEX = 2,
	  BORDER_INDEX = 1,
	  MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {},
	    style = elem.style,
	    name;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    old[name] = style[name];
	    style[name] = options[name];
	  }
	
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    style[name] = old[name];
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0, prop, j, i;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp;
	        if (prop === 'border') {
	          cssProp = prop + which[i] + 'Width';
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /*jshint eqeqeq:false*/
	  return obj != null && obj == obj.window;
	}
	
	var domUtils = {};
	
	each(['Width', 'Height'], function (name) {
	  domUtils['doc' + name] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	      //firefox chrome documentElement.scrollHeight< body.scrollHeight
	      //ie standard mode : documentElement.scrollHeight> body.scrollHeight
	      d.documentElement['scroll' + name],
	      //quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	      d.body['scroll' + name],
	      domUtils['viewport' + name](d));
	  };
	
	  domUtils['viewport' + name] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = 'client' + name,
	      doc = win.document,
	      body = doc.body,
	      documentElement = doc.documentElement,
	      documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp ||
	      body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, extra) {
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'],
	    borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
	  var computedStyle = getComputedStyleX(elem);
	  var isBorderBox = isBorderBoxFn(elem, computedStyle);
	  var cssBoxValue = 0;
	  if (borderBoxValue == null || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue == null || (Number(cssBoxValue)) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'],
	          which, computedStyle);
	    } else {
	      return cssBoxValue;
	    }
	  } else if (borderBoxValueOrIsBorderBox) {
	    return val + (extra === BORDER_INDEX ? 0 :
	        (extra === PADDING_INDEX ?
	          -getPBMWidth(elem, ['border'], which, computedStyle) :
	          getPBMWidth(elem, ['margin'], which, computedStyle)));
	  } else {
	    return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra),
	        which, computedStyle);
	  }
	}
	
	var cssShow = {position: 'absolute', visibility: 'hidden', display: 'block'};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay(elem) {
	  var val, args = arguments;
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils['outer' + first] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, val) {
	    if (val !== undefined) {
	      if (elem) {
	        var computedStyle = getComputedStyleX(elem);
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
	        }
	        return css(elem, name, val);
	      }
	      return;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	function css(el, name, value) {
	  if (typeof name === 'object') {
	    for (var i in name) {
	      css(el, i, name[i]);
	    }
	    return;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = value + 'px';
	    }
	    el.style[name] = value;
	  } else {
	    return getComputedStyleX(el, name);
	  }
	}
	
	function mix(to, from) {
	  for (var i in from) {
	    to[i] = from[i];
	  }
	  return to;
	}
	
	var utils = module.exports = {
	  getWindow: function (node) {
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  offset: function (el, value) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value);
	    } else {
	      return getOffset(el);
	    }
	  },
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function (obj) {
	    var ret = {};
	    for (var i in obj) {
	      ret[i] = obj[i];
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (i in obj) {
	        ret.overflow[i] = obj.overflow[i];
	      }
	    }
	    return ret;
	  },
	  mix: mix,
	  scrollLeft: function (w, v) {
	    if (isWindow(w)) {
	      if (v === undefined) {
	        return getScrollLeft(w);
	      } else {
	        window.scrollTo(v, getScrollTop(w));
	      }
	    } else {
	      if (v === undefined) {
	        return w.scrollLeft;
	      } else {
	        w.scrollLeft = v;
	      }
	    }
	  },
	  scrollTop: function (w, v) {
	    if (isWindow(w)) {
	      if (v === undefined) {
	        return getScrollTop(w);
	      } else {
	        window.scrollTo(getScrollLeft(w), v);
	      }
	    } else {
	      if (v === undefined) {
	        return w.scrollTop;
	      } else {
	        w.scrollTop = v;
	      }
	    }
	  },
	  merge: function () {
	    var ret = {};
	    for (var i = 0; i < arguments.length; i++) {
	      utils.mix(ret, arguments[i]);
	    }
	    return ret;
	  },
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	
	mix(utils, domUtils);


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	    'use strict';
	    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
	
	    /* istanbul ignore next */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1572)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory(require('stackframe'));
	    } else {
	        root.ErrorStackParser = factory(root.StackFrame);
	    }
	}(this, function ErrorStackParser(StackFrame) {
	    'use strict';
	
	    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
	    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
	    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
	
	    function _map(array, fn, thisArg) {
	        if (typeof Array.prototype.map === 'function') {
	            return array.map(fn, thisArg);
	        } else {
	            var output = new Array(array.length);
	            for (var i = 0; i < array.length; i++) {
	                output[i] = fn.call(thisArg, array[i]);
	            }
	            return output;
	        }
	    }
	
	    function _filter(array, fn, thisArg) {
	        if (typeof Array.prototype.filter === 'function') {
	            return array.filter(fn, thisArg);
	        } else {
	            var output = [];
	            for (var i = 0; i < array.length; i++) {
	                if (fn.call(thisArg, array[i])) {
	                    output.push(array[i]);
	                }
	            }
	            return output;
	        }
	    }
	
	    function _indexOf(array, target) {
	        if (typeof Array.prototype.indexOf === 'function') {
	            return array.indexOf(target);
	        } else {
	            for (var i = 0; i < array.length; i++) {
	                if (array[i] === target) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	    }
	
	    return {
	        /**
	         * Given an Error object, extract the most information from it.
	         *
	         * @param {Error} error object
	         * @return {Array} of StackFrames
	         */
	        parse: function ErrorStackParser$$parse(error) {
	            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
	                return this.parseOpera(error);
	            } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
	                return this.parseV8OrIE(error);
	            } else if (error.stack) {
	                return this.parseFFOrSafari(error);
	            } else {
	                throw new Error('Cannot parse given Error object');
	            }
	        },
	
	        // Separate line and column numbers from a string of the form: (URI:Line:Column)
	        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
	            // Fail-fast but return locations like "(native)"
	            if (urlLike.indexOf(':') === -1) {
	                return [urlLike];
	            }
	
	            var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
	            var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
	            return [parts[1], parts[2] || undefined, parts[3] || undefined];
	        },
	
	        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
	            var filtered = _filter(error.stack.split('\n'), function(line) {
	                return !!line.match(CHROME_IE_STACK_REGEXP);
	            }, this);
	
	            return _map(filtered, function(line) {
	                if (line.indexOf('(eval ') > -1) {
	                    // Throw away eval information until we implement stacktrace.js/stackframe#8
	                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
	                }
	                var tokens = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').split(/\s+/).slice(1);
	                var locationParts = this.extractLocation(tokens.pop());
	                var functionName = tokens.join(' ') || undefined;
	                var fileName = _indexOf(['eval', '<anonymous>'], locationParts[0]) > -1 ? undefined : locationParts[0];
	
	                return new StackFrame(functionName, undefined, fileName, locationParts[1], locationParts[2], line);
	            }, this);
	        },
	
	        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
	            var filtered = _filter(error.stack.split('\n'), function(line) {
	                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
	            }, this);
	
	            return _map(filtered, function(line) {
	                // Throw away eval information until we implement stacktrace.js/stackframe#8
	                if (line.indexOf(' > eval') > -1) {
	                    line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
	                }
	
	                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
	                    // Safari eval frames only have function names and nothing else
	                    return new StackFrame(line);
	                } else {
	                    var tokens = line.split('@');
	                    var locationParts = this.extractLocation(tokens.pop());
	                    var functionName = tokens.join('@') || undefined;
	                    return new StackFrame(functionName,
	                        undefined,
	                        locationParts[0],
	                        locationParts[1],
	                        locationParts[2],
	                        line);
	                }
	            }, this);
	        },
	
	        parseOpera: function ErrorStackParser$$parseOpera(e) {
	            if (!e.stacktrace || (e.message.indexOf('\n') > -1 &&
	                e.message.split('\n').length > e.stacktrace.split('\n').length)) {
	                return this.parseOpera9(e);
	            } else if (!e.stack) {
	                return this.parseOpera10(e);
	            } else {
	                return this.parseOpera11(e);
	            }
	        },
	
	        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
	            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
	            var lines = e.message.split('\n');
	            var result = [];
	
	            for (var i = 2, len = lines.length; i < len; i += 2) {
	                var match = lineRE.exec(lines[i]);
	                if (match) {
	                    result.push(new StackFrame(undefined, undefined, match[2], match[1], undefined, lines[i]));
	                }
	            }
	
	            return result;
	        },
	
	        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
	            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
	            var lines = e.stacktrace.split('\n');
	            var result = [];
	
	            for (var i = 0, len = lines.length; i < len; i += 2) {
	                var match = lineRE.exec(lines[i]);
	                if (match) {
	                    result.push(
	                        new StackFrame(
	                            match[3] || undefined,
	                            undefined,
	                            match[2],
	                            match[1],
	                            undefined,
	                            lines[i]
	                        )
	                    );
	                }
	            }
	
	            return result;
	        },
	
	        // Opera 10.65+ Error.stack very similar to FF/Safari
	        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
	            var filtered = _filter(error.stack.split('\n'), function(line) {
	                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
	            }, this);
	
	            return _map(filtered, function(line) {
	                var tokens = line.split('@');
	                var locationParts = this.extractLocation(tokens.pop());
	                var functionCall = (tokens.shift() || '');
	                var functionName = functionCall
	                        .replace(/<anonymous function(: (\w+))?>/, '$2')
	                        .replace(/\([^\)]*\)/g, '') || undefined;
	                var argsRaw;
	                if (functionCall.match(/\(([^\)]*)\)/)) {
	                    argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
	                }
	                var args = (argsRaw === undefined || argsRaw === '[arguments not available]') ?
	                    undefined : argsRaw.split(',');
	                return new StackFrame(
	                    functionName,
	                    args,
	                    locationParts[0],
	                    locationParts[1],
	                    locationParts[2],
	                    line);
	            }, this);
	        }
	    };
	}));
	


/***/ }),
/* 1061 */
455,
/* 1062 */
455,
/* 1063 */
455,
/* 1064 */
455,
/* 1065 */
455,
/* 1066 */
455,
/* 1067 */
455,
/* 1068 */
455,
/* 1069 */
455,
/* 1070 */
455,
/* 1071 */
455,
/* 1072 */
455,
/* 1073 */
455,
/* 1074 */
455,
/* 1075 */
455,
/* 1076 */
455,
/* 1077 */
455,
/* 1078 */
455,
/* 1079 */
455,
/* 1080 */
455,
/* 1081 */
455,
/* 1082 */
455,
/* 1083 */
455,
/* 1084 */
455,
/* 1085 */
455,
/* 1086 */
455,
/* 1087 */
455,
/* 1088 */
455,
/* 1089 */
455,
/* 1090 */
455,
/* 1091 */
455,
/* 1092 */
455,
/* 1093 */
455,
/* 1094 */
455,
/* 1095 */
455,
/* 1096 */
455,
/* 1097 */
455,
/* 1098 */
455,
/* 1099 */
455,
/* 1100 */
455,
/* 1101 */
455,
/* 1102 */
455,
/* 1103 */
455,
/* 1104 */
455,
/* 1105 */
455,
/* 1106 */
455,
/* 1107 */
455,
/* 1108 */
455,
/* 1109 */
455,
/* 1110 */
455,
/* 1111 */
455,
/* 1112 */
455,
/* 1113 */
455,
/* 1114 */
455,
/* 1115 */
455,
/* 1116 */
455,
/* 1117 */
455,
/* 1118 */
455,
/* 1119 */
455,
/* 1120 */
455,
/* 1121 */
455,
/* 1122 */
455,
/* 1123 */
455,
/* 1124 */
455,
/* 1125 */
455,
/* 1126 */
455,
/* 1127 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(153);
	
	var _PathUtils = __webpack_require__(130);
	
	var _ExecutionEnvironment = __webpack_require__(218);
	
	var _DOMUtils = __webpack_require__(312);
	
	var _DOMStateStorage = __webpack_require__(311);
	
	var _createDOMHistory = __webpack_require__(458);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(83);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(153);
	
	var _PathUtils = __webpack_require__(130);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(83);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(130);
	
	var _Actions = __webpack_require__(153);
	
	var _createHistory = __webpack_require__(460);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 1134 */
/***/ (function(module, exports) {

	'use strict'
	
	function extend(dest, src) {
	  if (src) {
	    var props = Object.keys(src)
	    for (var i = 0, l = props.length; i < l ; i++) {
	      dest[props[i]] = src[props[i]]
	    }
	  }
	  return dest
	}
	
	function copy(obj) {
	  return extend({}, obj)
	}
	
	/**
	 * Merge an object defining format characters into the defaults.
	 * Passing null/undefined for en existing format character removes it.
	 * Passing a definition for an existing format character overrides it.
	 * @param {?Object} formatCharacters.
	 */
	function mergeFormatCharacters(formatCharacters) {
	  var merged = copy(DEFAULT_FORMAT_CHARACTERS)
	  if (formatCharacters) {
	    var chars = Object.keys(formatCharacters)
	    for (var i = 0, l = chars.length; i < l ; i++) {
	      var char = chars[i]
	      if (formatCharacters[char] == null) {
	        delete merged[char]
	      }
	      else {
	        merged[char] = formatCharacters[char]
	      }
	    }
	  }
	  return merged
	}
	
	var ESCAPE_CHAR = '\\'
	
	var DIGIT_RE = /^\d$/
	var LETTER_RE = /^[A-Za-z]$/
	var ALPHANNUMERIC_RE = /^[\dA-Za-z]$/
	
	var DEFAULT_PLACEHOLDER_CHAR = '_'
	var DEFAULT_FORMAT_CHARACTERS = {
	  '*': {
	    validate: function(char) { return ALPHANNUMERIC_RE.test(char) }
	  },
	  '1': {
	    validate: function(char) { return DIGIT_RE.test(char) }
	  },
	  'a': {
	    validate: function(char) { return LETTER_RE.test(char) }
	  },
	  'A': {
	    validate: function(char) { return LETTER_RE.test(char) },
	    transform: function(char) { return char.toUpperCase() }
	  },
	  '#': {
	    validate: function(char) { return ALPHANNUMERIC_RE.test(char) },
	    transform: function(char) { return char.toUpperCase() }
	  }
	}
	
	/**
	 * @param {string} source
	 * @patam {?Object} formatCharacters
	 */
	function Pattern(source, formatCharacters, placeholderChar, isRevealingMask) {
	  if (!(this instanceof Pattern)) {
	    return new Pattern(source, formatCharacters, placeholderChar)
	  }
	
	  /** Placeholder character */
	  this.placeholderChar = placeholderChar || DEFAULT_PLACEHOLDER_CHAR
	  /** Format character definitions. */
	  this.formatCharacters = formatCharacters || DEFAULT_FORMAT_CHARACTERS
	  /** Pattern definition string with escape characters. */
	  this.source = source
	  /** Pattern characters after escape characters have been processed. */
	  this.pattern = []
	  /** Length of the pattern after escape characters have been processed. */
	  this.length = 0
	  /** Index of the first editable character. */
	  this.firstEditableIndex = null
	  /** Index of the last editable character. */
	  this.lastEditableIndex = null
	  /** Lookup for indices of editable characters in the pattern. */
	  this._editableIndices = {}
	  /** If true, only the pattern before the last valid value character shows. */
	  this.isRevealingMask = isRevealingMask || false
	
	  this._parse()
	}
	
	Pattern.prototype._parse = function parse() {
	  var sourceChars = this.source.split('')
	  var patternIndex = 0
	  var pattern = []
	
	  for (var i = 0, l = sourceChars.length; i < l; i++) {
	    var char = sourceChars[i]
	    if (char === ESCAPE_CHAR) {
	      if (i === l - 1) {
	        throw new Error('InputMask: pattern ends with a raw ' + ESCAPE_CHAR)
	      }
	      char = sourceChars[++i]
	    }
	    else if (char in this.formatCharacters) {
	      if (this.firstEditableIndex === null) {
	        this.firstEditableIndex = patternIndex
	      }
	      this.lastEditableIndex = patternIndex
	      this._editableIndices[patternIndex] = true
	    }
	
	    pattern.push(char)
	    patternIndex++
	  }
	
	  if (this.firstEditableIndex === null) {
	    throw new Error(
	      'InputMask: pattern "' + this.source + '" does not contain any editable characters.'
	    )
	  }
	
	  this.pattern = pattern
	  this.length = pattern.length
	}
	
	/**
	 * @param {Array<string>} value
	 * @return {Array<string>}
	 */
	Pattern.prototype.formatValue = function format(value) {
	  var valueBuffer = new Array(this.length)
	  var valueIndex = 0
	
	  for (var i = 0, l = this.length; i < l ; i++) {
	    if (this.isEditableIndex(i)) {
	      if (this.isRevealingMask &&
	          value.length <= valueIndex &&
	          !this.isValidAtIndex(value[valueIndex], i)) {
	        break
	      }
	      valueBuffer[i] = (value.length > valueIndex && this.isValidAtIndex(value[valueIndex], i)
	                        ? this.transform(value[valueIndex], i)
	                        : this.placeholderChar)
	      valueIndex++
	    }
	    else {
	      valueBuffer[i] = this.pattern[i]
	      // Also allow the value to contain static values from the pattern by
	      // advancing its index.
	      if (value.length > valueIndex && value[valueIndex] === this.pattern[i]) {
	        valueIndex++
	      }
	    }
	  }
	
	  return valueBuffer
	}
	
	/**
	 * @param {number} index
	 * @return {boolean}
	 */
	Pattern.prototype.isEditableIndex = function isEditableIndex(index) {
	  return !!this._editableIndices[index]
	}
	
	/**
	 * @param {string} char
	 * @param {number} index
	 * @return {boolean}
	 */
	Pattern.prototype.isValidAtIndex = function isValidAtIndex(char, index) {
	  return this.formatCharacters[this.pattern[index]].validate(char)
	}
	
	Pattern.prototype.transform = function transform(char, index) {
	  var format = this.formatCharacters[this.pattern[index]]
	  return typeof format.transform == 'function' ? format.transform(char) : char
	}
	
	function InputMask(options) {
	  if (!(this instanceof InputMask)) { return new InputMask(options) }
	  options = extend({
	    formatCharacters: null,
	    pattern: null,
	    isRevealingMask: false,
	    placeholderChar: DEFAULT_PLACEHOLDER_CHAR,
	    selection: {start: 0, end: 0},
	    value: ''
	  }, options)
	
	  if (options.pattern == null) {
	    throw new Error('InputMask: you must provide a pattern.')
	  }
	
	  if (typeof options.placeholderChar !== 'string' || options.placeholderChar.length > 1) {
	    throw new Error('InputMask: placeholderChar should be a single character or an empty string.')
	  }
	
	  this.placeholderChar = options.placeholderChar
	  this.formatCharacters = mergeFormatCharacters(options.formatCharacters)
	  this.setPattern(options.pattern, {
	    value: options.value,
	    selection: options.selection,
	    isRevealingMask: options.isRevealingMask
	  })
	}
	
	// Editing
	
	/**
	 * Applies a single character of input based on the current selection.
	 * @param {string} char
	 * @return {boolean} true if a change has been made to value or selection as a
	 *   result of the input, false otherwise.
	 */
	InputMask.prototype.input = function input(char) {
	  // Ignore additional input if the cursor's at the end of the pattern
	  if (this.selection.start === this.selection.end &&
	      this.selection.start === this.pattern.length) {
	    return false
	  }
	
	  var selectionBefore = copy(this.selection)
	  var valueBefore = this.getValue()
	
	  var inputIndex = this.selection.start
	
	  // If the cursor or selection is prior to the first editable character, make
	  // sure any input given is applied to it.
	  if (inputIndex < this.pattern.firstEditableIndex) {
	    inputIndex = this.pattern.firstEditableIndex
	  }
	
	  // Bail out or add the character to input
	  if (this.pattern.isEditableIndex(inputIndex)) {
	    if (!this.pattern.isValidAtIndex(char, inputIndex)) {
	      return false
	    }
	    this.value[inputIndex] = this.pattern.transform(char, inputIndex)
	  }
	
	  // If multiple characters were selected, blank the remainder out based on the
	  // pattern.
	  var end = this.selection.end - 1
	  while (end > inputIndex) {
	    if (this.pattern.isEditableIndex(end)) {
	      this.value[end] = this.placeholderChar
	    }
	    end--
	  }
	
	  // Advance the cursor to the next character
	  this.selection.start = this.selection.end = inputIndex + 1
	
	  // Skip over any subsequent static characters
	  while (this.pattern.length > this.selection.start &&
	         !this.pattern.isEditableIndex(this.selection.start)) {
	    this.selection.start++
	    this.selection.end++
	  }
	
	  // History
	  if (this._historyIndex != null) {
	    // Took more input after undoing, so blow any subsequent history away
	    this._history.splice(this._historyIndex, this._history.length - this._historyIndex)
	    this._historyIndex = null
	  }
	  if (this._lastOp !== 'input' ||
	      selectionBefore.start !== selectionBefore.end ||
	      this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
	    this._history.push({value: valueBefore, selection: selectionBefore, lastOp: this._lastOp})
	  }
	  this._lastOp = 'input'
	  this._lastSelection = copy(this.selection)
	
	  return true
	}
	
	/**
	 * Attempts to delete from the value based on the current cursor position or
	 * selection.
	 * @return {boolean} true if the value or selection changed as the result of
	 *   backspacing, false otherwise.
	 */
	InputMask.prototype.backspace = function backspace() {
	  // If the cursor is at the start there's nothing to do
	  if (this.selection.start === 0 && this.selection.end === 0) {
	    return false
	  }
	
	  var selectionBefore = copy(this.selection)
	  var valueBefore = this.getValue()
	
	  // No range selected - work on the character preceding the cursor
	  if (this.selection.start === this.selection.end) {
	    if (this.pattern.isEditableIndex(this.selection.start - 1)) {
	      this.value[this.selection.start - 1] = this.placeholderChar
	    }
	    this.selection.start--
	    this.selection.end--
	  }
	  // Range selected - delete characters and leave the cursor at the start of the selection
	  else {
	    var end = this.selection.end - 1
	    while (end >= this.selection.start) {
	      if (this.pattern.isEditableIndex(end)) {
	        this.value[end] = this.placeholderChar
	      }
	      end--
	    }
	    this.selection.end = this.selection.start
	  }
	
	  // History
	  if (this._historyIndex != null) {
	    // Took more input after undoing, so blow any subsequent history away
	    this._history.splice(this._historyIndex, this._history.length - this._historyIndex)
	  }
	  if (this._lastOp !== 'backspace' ||
	      selectionBefore.start !== selectionBefore.end ||
	      this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
	    this._history.push({value: valueBefore, selection: selectionBefore, lastOp: this._lastOp})
	  }
	  this._lastOp = 'backspace'
	  this._lastSelection = copy(this.selection)
	
	  return true
	}
	
	/**
	 * Attempts to paste a string of input at the current cursor position or over
	 * the top of the current selection.
	 * Invalid content at any position will cause the paste to be rejected, and it
	 * may contain static parts of the mask's pattern.
	 * @param {string} input
	 * @return {boolean} true if the paste was successful, false otherwise.
	 */
	InputMask.prototype.paste = function paste(input) {
	  // This is necessary because we're just calling input() with each character
	  // and rolling back if any were invalid, rather than checking up-front.
	  var initialState = {
	    value: this.value.slice(),
	    selection: copy(this.selection),
	    _lastOp: this._lastOp,
	    _history: this._history.slice(),
	    _historyIndex: this._historyIndex,
	    _lastSelection: copy(this._lastSelection)
	  }
	
	  // If there are static characters at the start of the pattern and the cursor
	  // or selection is within them, the static characters must match for a valid
	  // paste.
	  if (this.selection.start < this.pattern.firstEditableIndex) {
	    for (var i = 0, l = this.pattern.firstEditableIndex - this.selection.start; i < l; i++) {
	      if (input.charAt(i) !== this.pattern.pattern[i]) {
	        return false
	      }
	    }
	
	    // Continue as if the selection and input started from the editable part of
	    // the pattern.
	    input = input.substring(this.pattern.firstEditableIndex - this.selection.start)
	    this.selection.start = this.pattern.firstEditableIndex
	  }
	
	  for (i = 0, l = input.length;
	       i < l && this.selection.start <= this.pattern.lastEditableIndex;
	       i++) {
	    var valid = this.input(input.charAt(i))
	    // Allow static parts of the pattern to appear in pasted input - they will
	    // already have been stepped over by input(), so verify that the value
	    // deemed invalid by input() was the expected static character.
	    if (!valid) {
	      if (this.selection.start > 0) {
	        // XXX This only allows for one static character to be skipped
	        var patternIndex = this.selection.start - 1
	        if (!this.pattern.isEditableIndex(patternIndex) &&
	            input.charAt(i) === this.pattern.pattern[patternIndex]) {
	          continue
	        }
	      }
	      extend(this, initialState)
	      return false
	    }
	  }
	
	  return true
	}
	
	// History
	
	InputMask.prototype.undo = function undo() {
	  // If there is no history, or nothing more on the history stack, we can't undo
	  if (this._history.length === 0 || this._historyIndex === 0) {
	    return false
	  }
	
	  var historyItem
	  if (this._historyIndex == null) {
	    // Not currently undoing, set up the initial history index
	    this._historyIndex = this._history.length - 1
	    historyItem = this._history[this._historyIndex]
	    // Add a new history entry if anything has changed since the last one, so we
	    // can redo back to the initial state we started undoing from.
	    var value = this.getValue()
	    if (historyItem.value !== value ||
	        historyItem.selection.start !== this.selection.start ||
	        historyItem.selection.end !== this.selection.end) {
	      this._history.push({value: value, selection: copy(this.selection), lastOp: this._lastOp, startUndo: true})
	    }
	  }
	  else {
	    historyItem = this._history[--this._historyIndex]
	  }
	
	  this.value = historyItem.value.split('')
	  this.selection = historyItem.selection
	  this._lastOp = historyItem.lastOp
	  return true
	}
	
	InputMask.prototype.redo = function redo() {
	  if (this._history.length === 0 || this._historyIndex == null) {
	    return false
	  }
	  var historyItem = this._history[++this._historyIndex]
	  // If this is the last history item, we're done redoing
	  if (this._historyIndex === this._history.length - 1) {
	    this._historyIndex = null
	    // If the last history item was only added to start undoing, remove it
	    if (historyItem.startUndo) {
	      this._history.pop()
	    }
	  }
	  this.value = historyItem.value.split('')
	  this.selection = historyItem.selection
	  this._lastOp = historyItem.lastOp
	  return true
	}
	
	// Getters & setters
	
	InputMask.prototype.setPattern = function setPattern(pattern, options) {
	  options = extend({
	    selection: {start: 0, end: 0},
	    value: ''
	  }, options)
	  this.pattern = new Pattern(pattern, this.formatCharacters, this.placeholderChar, options.isRevealingMask)
	  this.setValue(options.value)
	  this.emptyValue = this.pattern.formatValue([]).join('')
	  this.selection = options.selection
	  this._resetHistory()
	}
	
	InputMask.prototype.setSelection = function setSelection(selection) {
	  this.selection = copy(selection)
	  if (this.selection.start === this.selection.end) {
	    if (this.selection.start < this.pattern.firstEditableIndex) {
	      this.selection.start = this.selection.end = this.pattern.firstEditableIndex
	      return true
	    }
	    // Set selection to the first editable, non-placeholder character before the selection
	    // OR to the beginning of the pattern
	    var index = this.selection.start
	    while (index >= this.pattern.firstEditableIndex) {
	      if (this.pattern.isEditableIndex(index - 1) &&
	          this.value[index - 1] !== this.placeholderChar ||
	          index === this.pattern.firstEditableIndex) {
	        this.selection.start = this.selection.end = index
	        break
	      }
	      index--
	    }
	    return true
	  }
	  return false
	}
	
	InputMask.prototype.setValue = function setValue(value) {
	  if (value == null) {
	    value = ''
	  }
	  this.value = this.pattern.formatValue(value.split(''))
	}
	
	InputMask.prototype.getValue = function getValue() {
	  return this.value.join('')
	}
	
	InputMask.prototype.getRawValue = function getRawValue() {
	  var rawValue = []
	  for (var i = 0; i < this.value.length; i++) {
	    if (this.pattern._editableIndices[i] === true) {
	      rawValue.push(this.value[i])
	    }
	  }
	  return rawValue.join('')
	}
	
	InputMask.prototype._resetHistory = function _resetHistory() {
	  this._history = []
	  this._historyIndex = null
	  this._lastOp = null
	  this._lastSelection = copy(this.selection)
	}
	
	InputMask.Pattern = Pattern
	
	module.exports = InputMask


/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(132),
	    root = __webpack_require__(89);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1193),
	    hashDelete = __webpack_require__(1194),
	    hashGet = __webpack_require__(1195),
	    hashHas = __webpack_require__(1196),
	    hashSet = __webpack_require__(1197);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(132),
	    root = __webpack_require__(89);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(132),
	    root = __webpack_require__(89);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(317),
	    setCacheAdd = __webpack_require__(1216),
	    setCacheHas = __webpack_require__(1217);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(89);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(132),
	    root = __webpack_require__(89);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 1143 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1170),
	    isArguments = __webpack_require__(483),
	    isArray = __webpack_require__(63),
	    isBuffer = __webpack_require__(484),
	    isIndex = __webpack_require__(320),
	    isTypedArray = __webpack_require__(487);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 1145 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 1146 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 1147 */
/***/ (function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ }),
/* 1148 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(223);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1180);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1150),
	    keys = __webpack_require__(176);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1145),
	    isArray = __webpack_require__(63);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 1153 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    isObjectLike = __webpack_require__(133);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(462),
	    equalArrays = __webpack_require__(474),
	    equalByTag = __webpack_require__(1182),
	    equalObjects = __webpack_require__(1183),
	    getTag = __webpack_require__(1189),
	    isArray = __webpack_require__(63),
	    isBuffer = __webpack_require__(484),
	    isTypedArray = __webpack_require__(487);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(462),
	    baseIsEqual = __webpack_require__(318);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 1157 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(323),
	    isMasked = __webpack_require__(1199),
	    isObject = __webpack_require__(156),
	    toSource = __webpack_require__(481);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(131),
	    isLength = __webpack_require__(324),
	    isObjectLike = __webpack_require__(133);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(477),
	    nativeKeys = __webpack_require__(1212);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(223),
	    isArrayLike = __webpack_require__(155);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1156),
	    getMatchData = __webpack_require__(1185),
	    matchesStrictComparable = __webpack_require__(479);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(318),
	    get = __webpack_require__(1236),
	    hasIn = __webpack_require__(1237),
	    isKey = __webpack_require__(321),
	    isStrictComparable = __webpack_require__(478),
	    matchesStrictComparable = __webpack_require__(479),
	    toKey = __webpack_require__(226);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 1164 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(469);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 1166 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(322),
	    overRest = __webpack_require__(1215),
	    setToString = __webpack_require__(1219);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1231),
	    defineProperty = __webpack_require__(473),
	    identity = __webpack_require__(322);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(223);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ }),
/* 1170 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 1171 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 1172 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(471);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(470);
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the last unmatched string symbol.
	 */
	function charsEndIndex(strSymbols, chrSymbols) {
	  var index = strSymbols.length;
	
	  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsEndIndex;


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(470);
	
	/**
	 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the first unmatched string symbol.
	 */
	function charsStartIndex(strSymbols, chrSymbols) {
	  var index = -1,
	      length = strSymbols.length;
	
	  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsStartIndex;


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(466),
	    baseAssignValue = __webpack_require__(467);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(89);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(1167),
	    isIterateeCall = __webpack_require__(476);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(155);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 1180 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(154),
	    isArrayLike = __webpack_require__(155),
	    keys = __webpack_require__(176);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(221),
	    Uint8Array = __webpack_require__(1141),
	    eq = __webpack_require__(227),
	    equalArrays = __webpack_require__(474),
	    mapToArray = __webpack_require__(1210),
	    setToArray = __webpack_require__(1218);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1184);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1152),
	    getSymbols = __webpack_require__(1188),
	    keys = __webpack_require__(176);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(478),
	    keys = __webpack_require__(176);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(480);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(221);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(463),
	    stubArray = __webpack_require__(1245);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1136),
	    Map = __webpack_require__(316),
	    Promise = __webpack_require__(1138),
	    Set = __webpack_require__(1139),
	    WeakMap = __webpack_require__(1142),
	    baseGetTag = __webpack_require__(131),
	    toSource = __webpack_require__(481);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 1190 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(472),
	    isArguments = __webpack_require__(483),
	    isArray = __webpack_require__(63),
	    isIndex = __webpack_require__(320),
	    isLength = __webpack_require__(324),
	    toKey = __webpack_require__(226);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 1192 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(225);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 1194 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(225);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(225);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(225);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 1198 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1177);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 1200 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(222);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(222);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(222);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(222);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1137),
	    ListCache = __webpack_require__(220),
	    Map = __webpack_require__(316);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(224);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(224);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(224);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(224);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 1210 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(488);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(480);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(475);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(167)(module)))

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1143);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 1216 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 1217 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 1218 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1168),
	    shortOut = __webpack_require__(1220);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 1220 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(220);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 1222 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 1224 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(220),
	    Map = __webpack_require__(316),
	    MapCache = __webpack_require__(317);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 1226 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(1147),
	    hasUnicode = __webpack_require__(1192),
	    unicodeToArray = __webpack_require__(1229);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1211);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 1229 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(466),
	    copyObject = __webpack_require__(1176),
	    createAssigner = __webpack_require__(1178),
	    isArrayLike = __webpack_require__(155),
	    isPrototype = __webpack_require__(477),
	    keys = __webpack_require__(176);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ }),
/* 1231 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(156),
	    now = __webpack_require__(1240),
	    toNumber = __webpack_require__(490);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(463),
	    baseFilter = __webpack_require__(1149),
	    baseIteratee = __webpack_require__(154),
	    isArray = __webpack_require__(63);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(1181),
	    findIndex = __webpack_require__(482);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1238);


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(469);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1153),
	    hasPath = __webpack_require__(1191);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 1238 */
/***/ (function(module, exports) {

	/**
	 * Gets the first element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias first
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the first element of `array`.
	 * @example
	 *
	 * _.head([1, 2, 3]);
	 * // => 1
	 *
	 * _.head([]);
	 * // => undefined
	 */
	function head(array) {
	  return (array && array.length) ? array[0] : undefined;
	}
	
	module.exports = head;


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(464),
	    baseIteratee = __webpack_require__(154),
	    baseMap = __webpack_require__(1161),
	    isArray = __webpack_require__(63);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(89);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1164),
	    basePropertyDeep = __webpack_require__(1165),
	    isKey = __webpack_require__(321),
	    toKey = __webpack_require__(226);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(1146),
	    baseEach = __webpack_require__(223),
	    baseIteratee = __webpack_require__(154),
	    baseReduce = __webpack_require__(1166),
	    isArray = __webpack_require__(63);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(465),
	    baseIteratee = __webpack_require__(154),
	    baseSome = __webpack_require__(1169),
	    isArray = __webpack_require__(63),
	    isIterateeCall = __webpack_require__(476);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(1148),
	    baseToString = __webpack_require__(319),
	    toInteger = __webpack_require__(489),
	    toString = __webpack_require__(326);
	
	/**
	 * Checks if `string` starts with the given target string.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {string} [target] The string to search for.
	 * @param {number} [position=0] The position to search from.
	 * @returns {boolean} Returns `true` if `string` starts with `target`,
	 *  else `false`.
	 * @example
	 *
	 * _.startsWith('abc', 'a');
	 * // => true
	 *
	 * _.startsWith('abc', 'b');
	 * // => false
	 *
	 * _.startsWith('abc', 'b', 1);
	 * // => true
	 */
	function startsWith(string, target, position) {
	  string = toString(string);
	  position = position == null
	    ? 0
	    : baseClamp(toInteger(position), 0, string.length);
	
	  target = baseToString(target);
	  return string.slice(position, position + target.length) == target;
	}
	
	module.exports = startsWith;


/***/ }),
/* 1245 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 1246 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(471);
	
	/**
	 * Gets all but the first element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.tail([1, 2, 3]);
	 * // => [2, 3]
	 */
	function tail(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseSlice(array, 1, length) : [];
	}
	
	module.exports = tail;


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(490);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(319),
	    castSlice = __webpack_require__(1173),
	    charsEndIndex = __webpack_require__(1174),
	    charsStartIndex = __webpack_require__(1175),
	    stringToArray = __webpack_require__(1227),
	    toString = __webpack_require__(326);
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/**
	 * Removes leading and trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trim('  abc  ');
	 * // => 'abc'
	 *
	 * _.trim('-_-abc-_-', '_-');
	 * // => 'abc'
	 *
	 * _.map(['  foo  ', '  bar  '], _.trim);
	 * // => ['foo', 'bar']
	 */
	function trim(string, chars, guard) {
	  string = toString(string);
	  if (string && (guard || chars === undefined)) {
	    return string.replace(reTrim, '');
	  }
	  if (!string || !(chars = baseToString(chars))) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      chrSymbols = stringToArray(chars),
	      start = charsStartIndex(strSymbols, chrSymbols),
	      end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	  return castSlice(strSymbols, start, end).join('');
	}
	
	module.exports = trim;


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 491,
		"./af.js": 491,
		"./ar": 498,
		"./ar-dz": 492,
		"./ar-dz.js": 492,
		"./ar-kw": 493,
		"./ar-kw.js": 493,
		"./ar-ly": 494,
		"./ar-ly.js": 494,
		"./ar-ma": 495,
		"./ar-ma.js": 495,
		"./ar-sa": 496,
		"./ar-sa.js": 496,
		"./ar-tn": 497,
		"./ar-tn.js": 497,
		"./ar.js": 498,
		"./az": 499,
		"./az.js": 499,
		"./be": 500,
		"./be.js": 500,
		"./bg": 501,
		"./bg.js": 501,
		"./bm": 502,
		"./bm.js": 502,
		"./bn": 503,
		"./bn.js": 503,
		"./bo": 504,
		"./bo.js": 504,
		"./br": 505,
		"./br.js": 505,
		"./bs": 506,
		"./bs.js": 506,
		"./ca": 507,
		"./ca.js": 507,
		"./cs": 508,
		"./cs.js": 508,
		"./cv": 509,
		"./cv.js": 509,
		"./cy": 510,
		"./cy.js": 510,
		"./da": 511,
		"./da.js": 511,
		"./de": 514,
		"./de-at": 512,
		"./de-at.js": 512,
		"./de-ch": 513,
		"./de-ch.js": 513,
		"./de.js": 514,
		"./dv": 515,
		"./dv.js": 515,
		"./el": 516,
		"./el.js": 516,
		"./en-au": 517,
		"./en-au.js": 517,
		"./en-ca": 518,
		"./en-ca.js": 518,
		"./en-gb": 519,
		"./en-gb.js": 519,
		"./en-ie": 520,
		"./en-ie.js": 520,
		"./en-nz": 521,
		"./en-nz.js": 521,
		"./eo": 522,
		"./eo.js": 522,
		"./es": 525,
		"./es-do": 523,
		"./es-do.js": 523,
		"./es-us": 524,
		"./es-us.js": 524,
		"./es.js": 525,
		"./et": 526,
		"./et.js": 526,
		"./eu": 527,
		"./eu.js": 527,
		"./fa": 528,
		"./fa.js": 528,
		"./fi": 529,
		"./fi.js": 529,
		"./fo": 530,
		"./fo.js": 530,
		"./fr": 533,
		"./fr-ca": 531,
		"./fr-ca.js": 531,
		"./fr-ch": 532,
		"./fr-ch.js": 532,
		"./fr.js": 533,
		"./fy": 534,
		"./fy.js": 534,
		"./gd": 535,
		"./gd.js": 535,
		"./gl": 536,
		"./gl.js": 536,
		"./gom-latn": 537,
		"./gom-latn.js": 537,
		"./gu": 538,
		"./gu.js": 538,
		"./he": 539,
		"./he.js": 539,
		"./hi": 540,
		"./hi.js": 540,
		"./hr": 541,
		"./hr.js": 541,
		"./hu": 542,
		"./hu.js": 542,
		"./hy-am": 543,
		"./hy-am.js": 543,
		"./id": 544,
		"./id.js": 544,
		"./is": 545,
		"./is.js": 545,
		"./it": 546,
		"./it.js": 546,
		"./ja": 547,
		"./ja.js": 547,
		"./jv": 548,
		"./jv.js": 548,
		"./ka": 549,
		"./ka.js": 549,
		"./kk": 550,
		"./kk.js": 550,
		"./km": 551,
		"./km.js": 551,
		"./kn": 552,
		"./kn.js": 552,
		"./ko": 553,
		"./ko.js": 553,
		"./ky": 554,
		"./ky.js": 554,
		"./lb": 555,
		"./lb.js": 555,
		"./lo": 556,
		"./lo.js": 556,
		"./lt": 557,
		"./lt.js": 557,
		"./lv": 558,
		"./lv.js": 558,
		"./me": 559,
		"./me.js": 559,
		"./mi": 560,
		"./mi.js": 560,
		"./mk": 561,
		"./mk.js": 561,
		"./ml": 562,
		"./ml.js": 562,
		"./mr": 563,
		"./mr.js": 563,
		"./ms": 565,
		"./ms-my": 564,
		"./ms-my.js": 564,
		"./ms.js": 565,
		"./my": 566,
		"./my.js": 566,
		"./nb": 567,
		"./nb.js": 567,
		"./ne": 568,
		"./ne.js": 568,
		"./nl": 570,
		"./nl-be": 569,
		"./nl-be.js": 569,
		"./nl.js": 570,
		"./nn": 571,
		"./nn.js": 571,
		"./pa-in": 572,
		"./pa-in.js": 572,
		"./pl": 573,
		"./pl.js": 573,
		"./pt": 575,
		"./pt-br": 574,
		"./pt-br.js": 574,
		"./pt.js": 575,
		"./ro": 576,
		"./ro.js": 576,
		"./ru": 577,
		"./ru.js": 577,
		"./sd": 578,
		"./sd.js": 578,
		"./se": 579,
		"./se.js": 579,
		"./si": 580,
		"./si.js": 580,
		"./sk": 581,
		"./sk.js": 581,
		"./sl": 582,
		"./sl.js": 582,
		"./sq": 583,
		"./sq.js": 583,
		"./sr": 585,
		"./sr-cyrl": 584,
		"./sr-cyrl.js": 584,
		"./sr.js": 585,
		"./ss": 586,
		"./ss.js": 586,
		"./sv": 587,
		"./sv.js": 587,
		"./sw": 588,
		"./sw.js": 588,
		"./ta": 589,
		"./ta.js": 589,
		"./te": 590,
		"./te.js": 590,
		"./tet": 591,
		"./tet.js": 591,
		"./th": 592,
		"./th.js": 592,
		"./tl-ph": 593,
		"./tl-ph.js": 593,
		"./tlh": 594,
		"./tlh.js": 594,
		"./tr": 595,
		"./tr.js": 595,
		"./tzl": 596,
		"./tzl.js": 596,
		"./tzm": 598,
		"./tzm-latn": 597,
		"./tzm-latn.js": 597,
		"./tzm.js": 598,
		"./uk": 599,
		"./uk.js": 599,
		"./ur": 600,
		"./ur.js": 600,
		"./uz": 602,
		"./uz-latn": 601,
		"./uz-latn.js": 601,
		"./uz.js": 602,
		"./vi": 603,
		"./vi.js": 603,
		"./x-pseudo": 604,
		"./x-pseudo.js": 604,
		"./yo": 605,
		"./yo.js": 605,
		"./zh-cn": 606,
		"./zh-cn.js": 606,
		"./zh-hk": 607,
		"./zh-hk.js": 607,
		"./zh-tw": 608,
		"./zh-tw.js": 608
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1250;


/***/ }),
/* 1251 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 1252 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(1127);
	var invariant = __webpack_require__(457);
	var ReactPropTypesSecret = __webpack_require__(1254);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1254 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	var mode = __webpack_require__(613);
	
	function QR8bitByte(data) {
		this.mode = mode.MODE_8BIT_BYTE;
		this.data = data;
	}
	
	QR8bitByte.prototype = {
	
		getLength : function(buffer) {
			return this.data.length;
		},
		
		write : function(buffer) {
			for (var i = 0; i < this.data.length; i++) {
				// not JIS ...
				buffer.put(this.data.charCodeAt(i), 8);
			}
		}
	};
	
	module.exports = QR8bitByte;
	


/***/ }),
/* 1256 */
/***/ (function(module, exports) {

	function QRBitBuffer() {
		this.buffer = new Array();
		this.length = 0;
	}
	
	QRBitBuffer.prototype = {
	
		get : function(index) {
			var bufIndex = Math.floor(index / 8);
			return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
		},
		
		put : function(num, length) {
			for (var i = 0; i < length; i++) {
				this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
			}
		},
		
		getLengthInBits : function() {
			return this.length;
		},
		
		putBit : function(bit) {
		
			var bufIndex = Math.floor(this.length / 8);
			if (this.buffer.length <= bufIndex) {
				this.buffer.push(0);
			}
		
			if (bit) {
				this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
			}
		
			this.length++;
		}
	};
	
	module.exports = QRBitBuffer;


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	var BitByte = __webpack_require__(1255);
	var RSBlock = __webpack_require__(1258);
	var BitBuffer = __webpack_require__(1256);
	var util = __webpack_require__(1259);
	var Polynomial = __webpack_require__(611);
	
	function QRCode(typeNumber, errorCorrectLevel) {
		this.typeNumber = typeNumber;
		this.errorCorrectLevel = errorCorrectLevel;
		this.modules = null;
		this.moduleCount = 0;
		this.dataCache = null;
		this.dataList = [];
	}
	
	// for client side minification
	var proto = QRCode.prototype;
	
	proto.addData = function(data) {
		var newData = new BitByte(data);
		this.dataList.push(newData);
		this.dataCache = null;
	};
	
	proto.isDark = function(row, col) {
		if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
			throw new Error(row + "," + col);
		}
		return this.modules[row][col];
	};
	
	proto.getModuleCount = function() {
		return this.moduleCount;
	};
	
	proto.make = function() {
		// Calculate automatically typeNumber if provided is < 1
		if (this.typeNumber < 1 ){
			var typeNumber = 1;
			for (typeNumber = 1; typeNumber < 40; typeNumber++) {
				var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);
	
				var buffer = new BitBuffer();
				var totalDataCount = 0;
				for (var i = 0; i < rsBlocks.length; i++) {
					totalDataCount += rsBlocks[i].dataCount;
				}
	
				for (var i = 0; i < this.dataList.length; i++) {
					var data = this.dataList[i];
					buffer.put(data.mode, 4);
					buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
					data.write(buffer);
				}
				if (buffer.getLengthInBits() <= totalDataCount * 8)
					break;
			}
			this.typeNumber = typeNumber;
		}
		this.makeImpl(false, this.getBestMaskPattern() );
	};
	
	proto.makeImpl = function(test, maskPattern) {
		
		this.moduleCount = this.typeNumber * 4 + 17;
		this.modules = new Array(this.moduleCount);
		
		for (var row = 0; row < this.moduleCount; row++) {
			
			this.modules[row] = new Array(this.moduleCount);
			
			for (var col = 0; col < this.moduleCount; col++) {
				this.modules[row][col] = null;//(col + row) % 3;
			}
		}
	
		this.setupPositionProbePattern(0, 0);
		this.setupPositionProbePattern(this.moduleCount - 7, 0);
		this.setupPositionProbePattern(0, this.moduleCount - 7);
		this.setupPositionAdjustPattern();
		this.setupTimingPattern();
		this.setupTypeInfo(test, maskPattern);
		
		if (this.typeNumber >= 7) {
			this.setupTypeNumber(test);
		}
	
		if (this.dataCache == null) {
			this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
		}
	
		this.mapData(this.dataCache, maskPattern);
	};
	
	proto.setupPositionProbePattern = function(row, col)  {
		
		for (var r = -1; r <= 7; r++) {
			
			if (row + r <= -1 || this.moduleCount <= row + r) continue;
			
			for (var c = -1; c <= 7; c++) {
				
				if (col + c <= -1 || this.moduleCount <= col + c) continue;
				
				if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
						|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
						|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
					this.modules[row + r][col + c] = true;
				} else {
					this.modules[row + r][col + c] = false;
				}
			}		
		}		
	};
	
	proto.getBestMaskPattern = function() {
	
		var minLostPoint = 0;
		var pattern = 0;
	
		for (var i = 0; i < 8; i++) {
			
			this.makeImpl(true, i);
	
			var lostPoint = util.getLostPoint(this);
	
			if (i == 0 || minLostPoint >  lostPoint) {
				minLostPoint = lostPoint;
				pattern = i;
			}
		}
	
		return pattern;
	};
	
	proto.createMovieClip = function(target_mc, instance_name, depth) {
	
		var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
		var cs = 1;
	
		this.make();
	
		for (var row = 0; row < this.modules.length; row++) {
			
			var y = row * cs;
			
			for (var col = 0; col < this.modules[row].length; col++) {
	
				var x = col * cs;
				var dark = this.modules[row][col];
			
				if (dark) {
					qr_mc.beginFill(0, 100);
					qr_mc.moveTo(x, y);
					qr_mc.lineTo(x + cs, y);
					qr_mc.lineTo(x + cs, y + cs);
					qr_mc.lineTo(x, y + cs);
					qr_mc.endFill();
				}
			}
		}
		
		return qr_mc;
	};
	
	proto.setupTimingPattern = function() {
		
		for (var r = 8; r < this.moduleCount - 8; r++) {
			if (this.modules[r][6] != null) {
				continue;
			}
			this.modules[r][6] = (r % 2 == 0);
		}
	
		for (var c = 8; c < this.moduleCount - 8; c++) {
			if (this.modules[6][c] != null) {
				continue;
			}
			this.modules[6][c] = (c % 2 == 0);
		}
	};
	
	proto.setupPositionAdjustPattern = function() {
	
		var pos = util.getPatternPosition(this.typeNumber);
		
		for (var i = 0; i < pos.length; i++) {
		
			for (var j = 0; j < pos.length; j++) {
			
				var row = pos[i];
				var col = pos[j];
				
				if (this.modules[row][col] != null) {
					continue;
				}
				
				for (var r = -2; r <= 2; r++) {
				
					for (var c = -2; c <= 2; c++) {
					
						if (r == -2 || r == 2 || c == -2 || c == 2
								|| (r == 0 && c == 0) ) {
							this.modules[row + r][col + c] = true;
						} else {
							this.modules[row + r][col + c] = false;
						}
					}
				}
			}
		}
	};
	
	proto.setupTypeNumber = function(test) {
	
		var bits = util.getBCHTypeNumber(this.typeNumber);
	
		for (var i = 0; i < 18; i++) {
			var mod = (!test && ( (bits >> i) & 1) == 1);
			this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
		}
	
		for (var i = 0; i < 18; i++) {
			var mod = (!test && ( (bits >> i) & 1) == 1);
			this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
		}
	};
	
	proto.setupTypeInfo = function(test, maskPattern) {
	
		var data = (this.errorCorrectLevel << 3) | maskPattern;
		var bits = util.getBCHTypeInfo(data);
	
		// vertical		
		for (var i = 0; i < 15; i++) {
	
			var mod = (!test && ( (bits >> i) & 1) == 1);
	
			if (i < 6) {
				this.modules[i][8] = mod;
			} else if (i < 8) {
				this.modules[i + 1][8] = mod;
			} else {
				this.modules[this.moduleCount - 15 + i][8] = mod;
			}
		}
	
		// horizontal
		for (var i = 0; i < 15; i++) {
	
			var mod = (!test && ( (bits >> i) & 1) == 1);
			
			if (i < 8) {
				this.modules[8][this.moduleCount - i - 1] = mod;
			} else if (i < 9) {
				this.modules[8][15 - i - 1 + 1] = mod;
			} else {
				this.modules[8][15 - i - 1] = mod;
			}
		}
	
		// fixed module
		this.modules[this.moduleCount - 8][8] = (!test);
	};
	
	proto.mapData = function(data, maskPattern) {
		
		var inc = -1;
		var row = this.moduleCount - 1;
		var bitIndex = 7;
		var byteIndex = 0;
		
		for (var col = this.moduleCount - 1; col > 0; col -= 2) {
	
			if (col == 6) col--;
	
			while (true) {
	
				for (var c = 0; c < 2; c++) {
					
					if (this.modules[row][col - c] == null) {
						
						var dark = false;
	
						if (byteIndex < data.length) {
							dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
						}
	
						var mask = util.getMask(maskPattern, row, col - c);
	
						if (mask) {
							dark = !dark;
						}
						
						this.modules[row][col - c] = dark;
						bitIndex--;
	
						if (bitIndex == -1) {
							byteIndex++;
							bitIndex = 7;
						}
					}
				}
								
				row += inc;
	
				if (row < 0 || this.moduleCount <= row) {
					row -= inc;
					inc = -inc;
					break;
				}
			}
		}
	};
	
	QRCode.PAD0 = 0xEC;
	QRCode.PAD1 = 0x11;
	
	QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
		
		var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
		
		var buffer = new BitBuffer();
		
		for (var i = 0; i < dataList.length; i++) {
			var data = dataList[i];
			buffer.put(data.mode, 4);
			buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
			data.write(buffer);
		}
	
		// calc num max data.
		var totalDataCount = 0;
		for (var i = 0; i < rsBlocks.length; i++) {
			totalDataCount += rsBlocks[i].dataCount;
		}
	
		if (buffer.getLengthInBits() > totalDataCount * 8) {
			throw new Error("code length overflow. ("
				+ buffer.getLengthInBits()
				+ ">"
				+  totalDataCount * 8
				+ ")");
		}
	
		// end code
		if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
			buffer.put(0, 4);
		}
	
		// padding
		while (buffer.getLengthInBits() % 8 != 0) {
			buffer.putBit(false);
		}
	
		// padding
		while (true) {
			
			if (buffer.getLengthInBits() >= totalDataCount * 8) {
				break;
			}
			buffer.put(QRCode.PAD0, 8);
			
			if (buffer.getLengthInBits() >= totalDataCount * 8) {
				break;
			}
			buffer.put(QRCode.PAD1, 8);
		}
	
		return QRCode.createBytes(buffer, rsBlocks);
	};
	
	QRCode.createBytes = function(buffer, rsBlocks) {
	
		var offset = 0;
		
		var maxDcCount = 0;
		var maxEcCount = 0;
		
		var dcdata = new Array(rsBlocks.length);
		var ecdata = new Array(rsBlocks.length);
		
		for (var r = 0; r < rsBlocks.length; r++) {
	
			var dcCount = rsBlocks[r].dataCount;
			var ecCount = rsBlocks[r].totalCount - dcCount;
	
			maxDcCount = Math.max(maxDcCount, dcCount);
			maxEcCount = Math.max(maxEcCount, ecCount);
			
			dcdata[r] = new Array(dcCount);
			
			for (var i = 0; i < dcdata[r].length; i++) {
				dcdata[r][i] = 0xff & buffer.buffer[i + offset];
			}
			offset += dcCount;
			
			var rsPoly = util.getErrorCorrectPolynomial(ecCount);
			var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);
	
			var modPoly = rawPoly.mod(rsPoly);
			ecdata[r] = new Array(rsPoly.getLength() - 1);
			for (var i = 0; i < ecdata[r].length; i++) {
	            var modIndex = i + modPoly.getLength() - ecdata[r].length;
				ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
			}
	
		}
		
		var totalCodeCount = 0;
		for (var i = 0; i < rsBlocks.length; i++) {
			totalCodeCount += rsBlocks[i].totalCount;
		}
	
		var data = new Array(totalCodeCount);
		var index = 0;
	
		for (var i = 0; i < maxDcCount; i++) {
			for (var r = 0; r < rsBlocks.length; r++) {
				if (i < dcdata[r].length) {
					data[index++] = dcdata[r][i];
				}
			}
		}
	
		for (var i = 0; i < maxEcCount; i++) {
			for (var r = 0; r < rsBlocks.length; r++) {
				if (i < ecdata[r].length) {
					data[index++] = ecdata[r][i];
				}
			}
		}
	
		return data;
	};
	
	module.exports = QRCode;
	


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	// ErrorCorrectLevel
	var ECL = __webpack_require__(610);
	
	function QRRSBlock(totalCount, dataCount) {
		this.totalCount = totalCount;
		this.dataCount  = dataCount;
	}
	
	QRRSBlock.RS_BLOCK_TABLE = [
	
		// L
		// M
		// Q
		// H
	
		// 1
		[1, 26, 19],
		[1, 26, 16],
		[1, 26, 13],
		[1, 26, 9],
		
		// 2
		[1, 44, 34],
		[1, 44, 28],
		[1, 44, 22],
		[1, 44, 16],
	
		// 3
		[1, 70, 55],
		[1, 70, 44],
		[2, 35, 17],
		[2, 35, 13],
	
		// 4		
		[1, 100, 80],
		[2, 50, 32],
		[2, 50, 24],
		[4, 25, 9],
		
		// 5
		[1, 134, 108],
		[2, 67, 43],
		[2, 33, 15, 2, 34, 16],
		[2, 33, 11, 2, 34, 12],
		
		// 6
		[2, 86, 68],
		[4, 43, 27],
		[4, 43, 19],
		[4, 43, 15],
		
		// 7		
		[2, 98, 78],
		[4, 49, 31],
		[2, 32, 14, 4, 33, 15],
		[4, 39, 13, 1, 40, 14],
		
		// 8
		[2, 121, 97],
		[2, 60, 38, 2, 61, 39],
		[4, 40, 18, 2, 41, 19],
		[4, 40, 14, 2, 41, 15],
		
		// 9
		[2, 146, 116],
		[3, 58, 36, 2, 59, 37],
		[4, 36, 16, 4, 37, 17],
		[4, 36, 12, 4, 37, 13],
		
		// 10		
		[2, 86, 68, 2, 87, 69],
		[4, 69, 43, 1, 70, 44],
		[6, 43, 19, 2, 44, 20],
		[6, 43, 15, 2, 44, 16],
	
		// 11
		[4, 101, 81],
		[1, 80, 50, 4, 81, 51],
		[4, 50, 22, 4, 51, 23],
		[3, 36, 12, 8, 37, 13],
	
		// 12
		[2, 116, 92, 2, 117, 93],
		[6, 58, 36, 2, 59, 37],
		[4, 46, 20, 6, 47, 21],
		[7, 42, 14, 4, 43, 15],
	
		// 13
		[4, 133, 107],
		[8, 59, 37, 1, 60, 38],
		[8, 44, 20, 4, 45, 21],
		[12, 33, 11, 4, 34, 12],
	
		// 14
		[3, 145, 115, 1, 146, 116],
		[4, 64, 40, 5, 65, 41],
		[11, 36, 16, 5, 37, 17],
		[11, 36, 12, 5, 37, 13],
	
		// 15
		[5, 109, 87, 1, 110, 88],
		[5, 65, 41, 5, 66, 42],
		[5, 54, 24, 7, 55, 25],
		[11, 36, 12],
	
		// 16
		[5, 122, 98, 1, 123, 99],
		[7, 73, 45, 3, 74, 46],
		[15, 43, 19, 2, 44, 20],
		[3, 45, 15, 13, 46, 16],
	
		// 17
		[1, 135, 107, 5, 136, 108],
		[10, 74, 46, 1, 75, 47],
		[1, 50, 22, 15, 51, 23],
		[2, 42, 14, 17, 43, 15],
	
		// 18
		[5, 150, 120, 1, 151, 121],
		[9, 69, 43, 4, 70, 44],
		[17, 50, 22, 1, 51, 23],
		[2, 42, 14, 19, 43, 15],
	
		// 19
		[3, 141, 113, 4, 142, 114],
		[3, 70, 44, 11, 71, 45],
		[17, 47, 21, 4, 48, 22],
		[9, 39, 13, 16, 40, 14],
	
		// 20
		[3, 135, 107, 5, 136, 108],
		[3, 67, 41, 13, 68, 42],
		[15, 54, 24, 5, 55, 25],
		[15, 43, 15, 10, 44, 16],
	
		// 21
		[4, 144, 116, 4, 145, 117],
		[17, 68, 42],
		[17, 50, 22, 6, 51, 23],
		[19, 46, 16, 6, 47, 17],
	
		// 22
		[2, 139, 111, 7, 140, 112],
		[17, 74, 46],
		[7, 54, 24, 16, 55, 25],
		[34, 37, 13],
	
		// 23
		[4, 151, 121, 5, 152, 122],
		[4, 75, 47, 14, 76, 48],
		[11, 54, 24, 14, 55, 25],
		[16, 45, 15, 14, 46, 16],
	
		// 24
		[6, 147, 117, 4, 148, 118],
		[6, 73, 45, 14, 74, 46],
		[11, 54, 24, 16, 55, 25],
		[30, 46, 16, 2, 47, 17],
	
		// 25
		[8, 132, 106, 4, 133, 107],
		[8, 75, 47, 13, 76, 48],
		[7, 54, 24, 22, 55, 25],
		[22, 45, 15, 13, 46, 16],
	
		// 26
		[10, 142, 114, 2, 143, 115],
		[19, 74, 46, 4, 75, 47],
		[28, 50, 22, 6, 51, 23],
		[33, 46, 16, 4, 47, 17],
	
		// 27
		[8, 152, 122, 4, 153, 123],
		[22, 73, 45, 3, 74, 46],
		[8, 53, 23, 26, 54, 24],
		[12, 45, 15, 28, 46, 16],
	
		// 28
		[3, 147, 117, 10, 148, 118],
		[3, 73, 45, 23, 74, 46],
		[4, 54, 24, 31, 55, 25],
		[11, 45, 15, 31, 46, 16],
	
		// 29
		[7, 146, 116, 7, 147, 117],
		[21, 73, 45, 7, 74, 46],
		[1, 53, 23, 37, 54, 24],
		[19, 45, 15, 26, 46, 16],
	
		// 30
		[5, 145, 115, 10, 146, 116],
		[19, 75, 47, 10, 76, 48],
		[15, 54, 24, 25, 55, 25],
		[23, 45, 15, 25, 46, 16],
	
		// 31
		[13, 145, 115, 3, 146, 116],
		[2, 74, 46, 29, 75, 47],
		[42, 54, 24, 1, 55, 25],
		[23, 45, 15, 28, 46, 16],
	
		// 32
		[17, 145, 115],
		[10, 74, 46, 23, 75, 47],
		[10, 54, 24, 35, 55, 25],
		[19, 45, 15, 35, 46, 16],
	
		// 33
		[17, 145, 115, 1, 146, 116],
		[14, 74, 46, 21, 75, 47],
		[29, 54, 24, 19, 55, 25],
		[11, 45, 15, 46, 46, 16],
	
		// 34
		[13, 145, 115, 6, 146, 116],
		[14, 74, 46, 23, 75, 47],
		[44, 54, 24, 7, 55, 25],
		[59, 46, 16, 1, 47, 17],
	
		// 35
		[12, 151, 121, 7, 152, 122],
		[12, 75, 47, 26, 76, 48],
		[39, 54, 24, 14, 55, 25],
		[22, 45, 15, 41, 46, 16],
	
		// 36
		[6, 151, 121, 14, 152, 122],
		[6, 75, 47, 34, 76, 48],
		[46, 54, 24, 10, 55, 25],
		[2, 45, 15, 64, 46, 16],
	
		// 37
		[17, 152, 122, 4, 153, 123],
		[29, 74, 46, 14, 75, 47],
		[49, 54, 24, 10, 55, 25],
		[24, 45, 15, 46, 46, 16],
	
		// 38
		[4, 152, 122, 18, 153, 123],
		[13, 74, 46, 32, 75, 47],
		[48, 54, 24, 14, 55, 25],
		[42, 45, 15, 32, 46, 16],
	
		// 39
		[20, 147, 117, 4, 148, 118],
		[40, 75, 47, 7, 76, 48],
		[43, 54, 24, 22, 55, 25],
		[10, 45, 15, 67, 46, 16],
	
		// 40
		[19, 148, 118, 6, 149, 119],
		[18, 75, 47, 31, 76, 48],
		[34, 54, 24, 34, 55, 25],
		[20, 45, 15, 61, 46, 16]
	];
	
	QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
		
		var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
		
		if (rsBlock == undefined) {
			throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
		}
	
		var length = rsBlock.length / 3;
		
		var list = new Array();
		
		for (var i = 0; i < length; i++) {
	
			var count = rsBlock[i * 3 + 0];
			var totalCount = rsBlock[i * 3 + 1];
			var dataCount  = rsBlock[i * 3 + 2];
	
			for (var j = 0; j < count; j++) {
				list.push(new QRRSBlock(totalCount, dataCount) );	
			}
		}
		
		return list;
	}
	
	QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
	
		switch(errorCorrectLevel) {
		case ECL.L :
			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
		case ECL.M :
			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
		case ECL.Q :
			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
		case ECL.H :
			return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
		default :
			return undefined;
		}
	}
	
	module.exports = QRRSBlock;


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	var Mode = __webpack_require__(613);
	var Polynomial = __webpack_require__(611);
	var math = __webpack_require__(612);
	
	var QRMaskPattern = {
		PATTERN000 : 0,
		PATTERN001 : 1,
		PATTERN010 : 2,
		PATTERN011 : 3,
		PATTERN100 : 4,
		PATTERN101 : 5,
		PATTERN110 : 6,
		PATTERN111 : 7
	};
	
	var QRUtil = {
	
	    PATTERN_POSITION_TABLE : [
		    [],
		    [6, 18],
		    [6, 22],
		    [6, 26],
		    [6, 30],
		    [6, 34],
		    [6, 22, 38],
		    [6, 24, 42],
		    [6, 26, 46],
		    [6, 28, 50],
		    [6, 30, 54],		
		    [6, 32, 58],
		    [6, 34, 62],
		    [6, 26, 46, 66],
		    [6, 26, 48, 70],
		    [6, 26, 50, 74],
		    [6, 30, 54, 78],
		    [6, 30, 56, 82],
		    [6, 30, 58, 86],
		    [6, 34, 62, 90],
		    [6, 28, 50, 72, 94],
		    [6, 26, 50, 74, 98],
		    [6, 30, 54, 78, 102],
		    [6, 28, 54, 80, 106],
		    [6, 32, 58, 84, 110],
		    [6, 30, 58, 86, 114],
		    [6, 34, 62, 90, 118],
		    [6, 26, 50, 74, 98, 122],
		    [6, 30, 54, 78, 102, 126],
		    [6, 26, 52, 78, 104, 130],
		    [6, 30, 56, 82, 108, 134],
		    [6, 34, 60, 86, 112, 138],
		    [6, 30, 58, 86, 114, 142],
		    [6, 34, 62, 90, 118, 146],
		    [6, 30, 54, 78, 102, 126, 150],
		    [6, 24, 50, 76, 102, 128, 154],
		    [6, 28, 54, 80, 106, 132, 158],
		    [6, 32, 58, 84, 110, 136, 162],
		    [6, 26, 54, 82, 110, 138, 166],
		    [6, 30, 58, 86, 114, 142, 170]
	    ],
	
	    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
	    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
	    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),
	
	    getBCHTypeInfo : function(data) {
		    var d = data << 10;
		    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
			    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
		    }
		    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
	    },
	
	    getBCHTypeNumber : function(data) {
		    var d = data << 12;
		    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
			    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
		    }
		    return (data << 12) | d;
	    },
	
	    getBCHDigit : function(data) {
	
		    var digit = 0;
	
		    while (data != 0) {
			    digit++;
			    data >>>= 1;
		    }
	
		    return digit;
	    },
	
	    getPatternPosition : function(typeNumber) {
		    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
	    },
	
	    getMask : function(maskPattern, i, j) {
		    
		    switch (maskPattern) {
			    
		    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
		    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
		    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
		    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
		    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
		    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
		    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
		    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;
	
		    default :
			    throw new Error("bad maskPattern:" + maskPattern);
		    }
	    },
	
	    getErrorCorrectPolynomial : function(errorCorrectLength) {
	
		    var a = new Polynomial([1], 0);
	
		    for (var i = 0; i < errorCorrectLength; i++) {
			    a = a.multiply(new Polynomial([1, math.gexp(i)], 0) );
		    }
	
		    return a;
	    },
	
	    getLengthInBits : function(mode, type) {
	
		    if (1 <= type && type < 10) {
	
			    // 1 - 9
	
			    switch(mode) {
			    case Mode.MODE_NUMBER 	: return 10;
			    case Mode.MODE_ALPHA_NUM 	: return 9;
			    case Mode.MODE_8BIT_BYTE	: return 8;
			    case Mode.MODE_KANJI  	: return 8;
			    default :
				    throw new Error("mode:" + mode);
			    }
	
		    } else if (type < 27) {
	
			    // 10 - 26
	
			    switch(mode) {
			    case Mode.MODE_NUMBER 	: return 12;
			    case Mode.MODE_ALPHA_NUM 	: return 11;
			    case Mode.MODE_8BIT_BYTE	: return 16;
			    case Mode.MODE_KANJI  	: return 10;
			    default :
				    throw new Error("mode:" + mode);
			    }
	
		    } else if (type < 41) {
	
			    // 27 - 40
	
			    switch(mode) {
			    case Mode.MODE_NUMBER 	: return 14;
			    case Mode.MODE_ALPHA_NUM	: return 13;
			    case Mode.MODE_8BIT_BYTE	: return 16;
			    case Mode.MODE_KANJI  	: return 12;
			    default :
				    throw new Error("mode:" + mode);
			    }
	
		    } else {
			    throw new Error("type:" + type);
		    }
	    },
	
	    getLostPoint : function(qrCode) {
		    
		    var moduleCount = qrCode.getModuleCount();
		    
		    var lostPoint = 0;
		    
		    // LEVEL1
		    
		    for (var row = 0; row < moduleCount; row++) {
	
			    for (var col = 0; col < moduleCount; col++) {
	
				    var sameCount = 0;
				    var dark = qrCode.isDark(row, col);
	
					for (var r = -1; r <= 1; r++) {
	
					    if (row + r < 0 || moduleCount <= row + r) {
						    continue;
					    }
	
					    for (var c = -1; c <= 1; c++) {
	
						    if (col + c < 0 || moduleCount <= col + c) {
							    continue;
						    }
	
						    if (r == 0 && c == 0) {
							    continue;
						    }
	
						    if (dark == qrCode.isDark(row + r, col + c) ) {
							    sameCount++;
						    }
					    }
				    }
	
				    if (sameCount > 5) {
					    lostPoint += (3 + sameCount - 5);
				    }
			    }
		    }
	
		    // LEVEL2
	
		    for (var row = 0; row < moduleCount - 1; row++) {
			    for (var col = 0; col < moduleCount - 1; col++) {
				    var count = 0;
				    if (qrCode.isDark(row,     col    ) ) count++;
				    if (qrCode.isDark(row + 1, col    ) ) count++;
				    if (qrCode.isDark(row,     col + 1) ) count++;
				    if (qrCode.isDark(row + 1, col + 1) ) count++;
				    if (count == 0 || count == 4) {
					    lostPoint += 3;
				    }
			    }
		    }
	
		    // LEVEL3
	
		    for (var row = 0; row < moduleCount; row++) {
			    for (var col = 0; col < moduleCount - 6; col++) {
				    if (qrCode.isDark(row, col)
						    && !qrCode.isDark(row, col + 1)
						    &&  qrCode.isDark(row, col + 2)
						    &&  qrCode.isDark(row, col + 3)
						    &&  qrCode.isDark(row, col + 4)
						    && !qrCode.isDark(row, col + 5)
						    &&  qrCode.isDark(row, col + 6) ) {
					    lostPoint += 40;
				    }
			    }
		    }
	
		    for (var col = 0; col < moduleCount; col++) {
			    for (var row = 0; row < moduleCount - 6; row++) {
				    if (qrCode.isDark(row, col)
						    && !qrCode.isDark(row + 1, col)
						    &&  qrCode.isDark(row + 2, col)
						    &&  qrCode.isDark(row + 3, col)
						    &&  qrCode.isDark(row + 4, col)
						    && !qrCode.isDark(row + 5, col)
						    &&  qrCode.isDark(row + 6, col) ) {
					    lostPoint += 40;
				    }
			    }
		    }
	
		    // LEVEL4
		    
		    var darkCount = 0;
	
		    for (var col = 0; col < moduleCount; col++) {
			    for (var row = 0; row < moduleCount; row++) {
				    if (qrCode.isDark(row, col) ) {
					    darkCount++;
				    }
			    }
		    }
		    
		    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
		    lostPoint += ratio * 10;
	
		    return lostPoint;		
	    }
	};
	
	module.exports = QRUtil;


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(27);
	// qr.js doesn't handle error level of zero (M) so we need to do it right,
	// thus the deep require.
	var QRCodeImpl = __webpack_require__(1257);
	var ErrorCorrectLevel = __webpack_require__(610);
	
	function getBackingStorePixelRatio(ctx) {
	  return (
	    // $FlowFixMe
	    ctx.webkitBackingStorePixelRatio ||
	    // $FlowFixMe
	    ctx.mozBackingStorePixelRatio ||
	    // $FlowFixMe
	    ctx.msBackingStorePixelRatio ||
	    // $FlowFixMe
	    ctx.oBackingStorePixelRatio ||
	    // $FlowFixMe
	    ctx.backingStorePixelRatio || 1
	  );
	}
	
	var QRCode = function (_React$Component) {
	  _inherits(QRCode, _React$Component);
	
	  function QRCode() {
	    _classCallCheck(this, QRCode);
	
	    return _possibleConstructorReturn(this, (QRCode.__proto__ || Object.getPrototypeOf(QRCode)).apply(this, arguments));
	  }
	
	  _createClass(QRCode, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      return Object.keys(QRCode.propTypes).some(function (k) {
	        return _this2.props[k] !== nextProps[k];
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.update();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.update();
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _props = this.props,
	          value = _props.value,
	          size = _props.size,
	          level = _props.level,
	          bgColor = _props.bgColor,
	          fgColor = _props.fgColor;
	
	      // We'll use type===-1 to force QRCode to automatically pick the best type
	
	      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
	      qrcode.addData(value);
	      qrcode.make();
	
	      if (this._canvas != null) {
	        var canvas = this._canvas;
	
	        var ctx = canvas.getContext('2d');
	        if (!ctx) {
	          return;
	        }
	        var cells = qrcode.modules;
	        if (cells === null) {
	          return;
	        }
	        var tileW = size / cells.length;
	        var tileH = size / cells.length;
	        var scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx);
	        canvas.height = canvas.width = size * scale;
	        ctx.scale(scale, scale);
	
	        cells.forEach(function (row, rdx) {
	          row.forEach(function (cell, cdx) {
	            ctx && (ctx.fillStyle = cell ? fgColor : bgColor);
	            var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
	            var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
	            ctx && ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return React.createElement('canvas', {
	        style: { height: this.props.size, width: this.props.size },
	        height: this.props.size,
	        width: this.props.size,
	        ref: function ref(_ref) {
	          return _this3._canvas = _ref;
	        }
	      });
	    }
	  }]);
	
	  return QRCode;
	}(React.Component);
	
	Object.defineProperty(QRCode, 'defaultProps', {
	  enumerable: true,
	  writable: true,
	  value: {
	    size: 128,
	    level: 'L',
	    bgColor: '#FFFFFF',
	    fgColor: '#000000'
	  }
	});
	Object.defineProperty(QRCode, 'propTypes', {
	  enumerable: true,
	  writable: true,
	  value: {
	    value: PropTypes.string.isRequired,
	    size: PropTypes.number,
	    level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),
	    bgColor: PropTypes.string,
	    fgColor: PropTypes.string
	  }
	});
	
	
	module.exports = QRCode;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1584);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _objectWithoutProperties = __webpack_require__(1268)["default"];
	
	var _extends = __webpack_require__(1266)["default"];
	
	var _Map = __webpack_require__(1264)["default"];
	
	var _getIterator = __webpack_require__(1263)["default"];
	
	var _interopRequireDefault = __webpack_require__(1267)["default"];
	
	exports.__esModule = true;
	exports["default"] = makeAsyncScript;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var SCRIPT_MAP = new _Map();
	
	// A counter used to generate a unique id for each component that uses the function
	var idCount = 0;
	
	function makeAsyncScript(Component, scriptURL, options) {
	  options = options || {};
	  var funcs = {
	    displayName: "AsyncScriptLoader",
	
	    propTypes: {
	      asyncScriptOnLoad: _react.PropTypes.func
	    },
	
	    statics: {
	      asyncScriptLoaderTriggerOnScriptLoaded: function asyncScriptLoaderTriggerOnScriptLoaded() {
	        var mapEntry = SCRIPT_MAP.get(scriptURL);
	        if (!mapEntry || !mapEntry.loaded) {
	          throw new Error("Script is not loaded.");
	        }
	        for (var _iterator = mapEntry.observers.values(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	          var _ref;
	
	          if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref = _iterator[_i++];
	          } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref = _i.value;
	          }
	
	          var observer = _ref;
	
	          observer(mapEntry);
	        }
	        delete window[options.callbackName];
	      }
	    },
	
	    getInitialState: function getInitialState() {
	      return {};
	    },
	
	    asyncScriptLoaderGetScriptLoaderID: function asyncScriptLoaderGetScriptLoaderID() {
	      if (!this.__scriptLoaderID) {
	        this.__scriptLoaderID = "async-script-loader-" + idCount++;
	      }
	      return this.__scriptLoaderID;
	    },
	
	    getComponent: function getComponent() {
	      return this.childComponent;
	    },
	
	    componentDidMount: function componentDidMount() {
	      var _this = this;
	
	      var key = this.asyncScriptLoaderGetScriptLoaderID();
	      var _options = options;
	      var globalName = _options.globalName;
	      var callbackName = _options.callbackName;
	
	      if (globalName && typeof window[globalName] !== "undefined") {
	        SCRIPT_MAP.set(scriptURL, { loaded: true, observers: new _Map() });
	      }
	
	      if (SCRIPT_MAP.has(scriptURL)) {
	        var entry = SCRIPT_MAP.get(scriptURL);
	        if (entry.loaded || entry.errored) {
	          this.asyncScriptLoaderHandleLoad(entry);
	          return;
	        }
	        entry.observers.set(key, this.asyncScriptLoaderHandleLoad);
	        return;
	      }
	
	      var observers = new _Map();
	      observers.set(key, this.asyncScriptLoaderHandleLoad);
	      SCRIPT_MAP.set(scriptURL, {
	        loaded: false,
	        observers: observers
	      });
	
	      var script = document.createElement("script");
	
	      script.src = scriptURL;
	      script.async = 1;
	
	      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
	        if (SCRIPT_MAP.has(scriptURL)) {
	          var mapEntry = SCRIPT_MAP.get(scriptURL);
	          var observersMap = mapEntry.observers;
	
	          for (var _iterator2 = observersMap, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	            var _ref2;
	
	            if (_isArray2) {
	              if (_i2 >= _iterator2.length) break;
	              _ref2 = _iterator2[_i2++];
	            } else {
	              _i2 = _iterator2.next();
	              if (_i2.done) break;
	              _ref2 = _i2.value;
	            }
	
	            var obsKey = _ref2[0];
	            var observer = _ref2[1];
	
	            if (func(observer)) {
	              observersMap["delete"](obsKey);
	            }
	          }
	        }
	      };
	
	      if (callbackName && typeof window !== "undefined") {
	        window[callbackName] = AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded;
	      }
	
	      script.onload = function () {
	        var mapEntry = SCRIPT_MAP.get(scriptURL);
	        mapEntry.loaded = true;
	        callObserverFuncAndRemoveObserver(function (observer) {
	          if (callbackName) {
	            return false;
	          }
	          observer(mapEntry);
	          return true;
	        });
	      };
	      script.onerror = function (event) {
	        var mapEntry = SCRIPT_MAP.get(scriptURL);
	        mapEntry.errored = true;
	        callObserverFuncAndRemoveObserver(function (observer) {
	          observer(mapEntry);
	          return true;
	        });
	      };
	
	      // (old) MSIE browsers may call "onreadystatechange" instead of "onload"
	      script.onreadystatechange = function () {
	        if (_this.readyState === "loaded") {
	          // wait for other events, then call onload if default onload hadn't been called
	          window.setTimeout(function () {
	            if (SCRIPT_MAP.get(scriptURL).loaded !== true) {
	              script.onload();
	            }
	          }, 0);
	        }
	      };
	
	      document.body.appendChild(script);
	    },
	
	    asyncScriptLoaderHandleLoad: function asyncScriptLoaderHandleLoad(state) {
	      this.setState(state, this.props.asyncScriptOnLoad);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      // Clean the observer entry
	      var mapEntry = SCRIPT_MAP.get(scriptURL);
	      if (mapEntry) {
	        mapEntry.observers["delete"](this.asyncScriptLoaderGetScriptLoaderID());
	      }
	    },
	
	    render: function render() {
	      var _this2 = this;
	
	      var globalName = options.globalName;
	      var _props = this.props;
	      var asyncScriptOnLoad = _props.asyncScriptOnLoad;
	
	      var childProps = _objectWithoutProperties(_props, ["asyncScriptOnLoad"]);
	
	      if (globalName && typeof window !== "undefined") {
	        childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
	      }
	      return _react2["default"].createElement(Component, _extends({ ref: function (comp) {
	          _this2.childComponent = comp;
	        } }, childProps));
	    }
	
	  };
	
	  if (options.exposeFuncs) {
	    var _loop = function () {
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) return "break";
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) return "break";
	        _ref3 = _i3.value;
	      }
	
	      var funcToExpose = _ref3;
	
	      /* eslint-disable no-loop-func */
	      funcs[funcToExpose] = function () {
	        var _childComponent;
	
	        return (_childComponent = this.childComponent)[funcToExpose].apply(_childComponent, arguments);
	      };
	      /* eslint-enable no-loop-func */
	    };
	
	    for (var _iterator3 = options.exposeFuncs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	      var _ref3;
	
	      var _ret = _loop();
	
	      if (_ret === "break") break;
	    }
	  }
	  var AsyncScriptLoader = _react2["default"].createClass(funcs);
	
	  return AsyncScriptLoader;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1263 */
[1943, 1269],
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1270), __esModule: true };

/***/ }),
/* 1265 */
[1944, 1271],
/* 1266 */
[2017, 1265],
/* 1267 */
646,
/* 1268 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(626);
	__webpack_require__(625);
	module.exports = __webpack_require__(1288);

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1292);
	__webpack_require__(625);
	__webpack_require__(626);
	__webpack_require__(1290);
	__webpack_require__(1293);
	module.exports = __webpack_require__(157).Map;

/***/ }),
/* 1271 */
[2018, 1291, 157],
/* 1272 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $            = __webpack_require__(108)
	  , hide         = __webpack_require__(178)
	  , redefineAll  = __webpack_require__(619)
	  , ctx          = __webpack_require__(328)
	  , strictNew    = __webpack_require__(621)
	  , defined      = __webpack_require__(229)
	  , forOf        = __webpack_require__(330)
	  , $iterDefine  = __webpack_require__(333)
	  , step         = __webpack_require__(617)
	  , ID           = __webpack_require__(623)('id')
	  , $has         = __webpack_require__(331)
	  , isObject     = __webpack_require__(332)
	  , setSpecies   = __webpack_require__(1282)
	  , DESCRIPTORS  = __webpack_require__(230)
	  , isExtensible = Object.isExtensible || isObject
	  , SIZE         = DESCRIPTORS ? '_s' : 'size'
	  , id           = 0;
	
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!$has(it, ID)){
	    // can't set id to frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add id
	    if(!create)return 'E';
	    // add missing object id
	    hide(it, ID, ++id);
	  // return object id with prefix
	  } return 'O' + it[ID];
	};
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      strictNew(that, C, NAME);
	      that._i = $.create(null); // index
	      that._f = undefined;      // first entry
	      that._l = undefined;      // last entry
	      that[SIZE] = 0;           // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var forOf   = __webpack_require__(330)
	  , classof = __webpack_require__(614);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    var arr = [];
	    forOf(this, false, arr.push, arr);
	    return arr;
	  };
	};

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(108)
	  , global         = __webpack_require__(232)
	  , $export        = __webpack_require__(231)
	  , fails          = __webpack_require__(329)
	  , hide           = __webpack_require__(178)
	  , redefineAll    = __webpack_require__(619)
	  , forOf          = __webpack_require__(330)
	  , strictNew      = __webpack_require__(621)
	  , isObject       = __webpack_require__(332)
	  , setToStringTag = __webpack_require__(334)
	  , DESCRIPTORS    = __webpack_require__(230);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	  } else {
	    C = wrapper(function(target, iterable){
	      strictNew(target, C, NAME);
	      target._c = new Base;
	      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    $.each.call('add,clear,delete,forEach,get,has,set,keys,values,entries'.split(','),function(KEY){
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
	        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    if('size' in proto)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(179)
	  , ITERATOR   = __webpack_require__(134)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(327);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(108)
	  , descriptor     = __webpack_require__(618)
	  , setToStringTag = __webpack_require__(334)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(178)(IteratorPrototype, __webpack_require__(134)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

	module.exports = true;

/***/ }),
/* 1281 */
[2022, 108, 1287, 616, 329],
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var core        = __webpack_require__(157)
	  , $           = __webpack_require__(108)
	  , DESCRIPTORS = __webpack_require__(230)
	  , SPECIES     = __webpack_require__(134)('species');
	
	module.exports = function(KEY){
	  var C = core[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(232)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(622)
	  , defined   = __webpack_require__(229);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(616)
	  , defined = __webpack_require__(229);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(622)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 1287 */
[2023, 229],
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(327)
	  , get      = __webpack_require__(624);
	module.exports = __webpack_require__(157).getIterator = function(it){
	  var iterFn = get(it);
	  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(1273)
	  , step             = __webpack_require__(617)
	  , Iterators        = __webpack_require__(179)
	  , toIObject        = __webpack_require__(1285);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(333)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(1274);
	
	// 23.1 Map Objects
	__webpack_require__(1276)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ }),
/* 1291 */
[2024, 231, 1281],
/* 1292 */
410,
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(231);
	
	$export($export.P, 'Map', {toJSON: __webpack_require__(1275)('Map')});

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(27);
	
	var _require = __webpack_require__(28),
	    findDOMNode = _require.findDOMNode;
	
	var scrollIntoView = __webpack_require__(1057);
	
	var IMPERATIVE_API = ['blur', 'checkValidity', 'click', 'focus', 'select', 'setCustomValidity', 'setSelectionRange', 'setRangeText'];
	
	function getScrollOffset() {
	  return {
	    x: window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft,
	    y: window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
	  };
	}
	
	var Autocomplete = function (_React$Component) {
	  _inherits(Autocomplete, _React$Component);
	
	  function Autocomplete(props) {
	    _classCallCheck(this, Autocomplete);
	
	    var _this = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, props));
	
	    _this.state = {
	      isOpen: false,
	      highlightedIndex: null
	    };
	    _this._debugStates = [];
	    _this.ensureHighlightedIndex = _this.ensureHighlightedIndex.bind(_this);
	    _this.exposeAPI = _this.exposeAPI.bind(_this);
	    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
	    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleInputClick = _this.handleInputClick.bind(_this);
	    _this.maybeAutoCompleteText = _this.maybeAutoCompleteText.bind(_this);
	    return _this;
	  }
	
	  _createClass(Autocomplete, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // this.refs is frozen, so we need to assign a new object to it
	      this.refs = {};
	      this._ignoreBlur = false;
	      this._ignoreFocus = false;
	      this._scrollOffset = null;
	      this._scrollTimer = null;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._scrollTimer);
	      this._scrollTimer = null;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.highlightedIndex !== null) {
	        this.setState(this.ensureHighlightedIndex);
	      }
	      if (nextProps.autoHighlight && (this.props.value !== nextProps.value || this.state.highlightedIndex === null)) {
	        this.setState(this.maybeAutoCompleteText);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.isOpen()) {
	        this.setMenuPositions();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.state.isOpen && !prevState.isOpen || 'open' in this.props && this.props.open && !prevProps.open) this.setMenuPositions();
	
	      this.maybeScrollItemIntoView();
	      if (prevState.isOpen !== this.state.isOpen) {
	        this.props.onMenuVisibilityChange(this.state.isOpen);
	      }
	    }
	  }, {
	    key: 'exposeAPI',
	    value: function exposeAPI(el) {
	      var _this2 = this;
	
	      this.refs.input = el;
	      IMPERATIVE_API.forEach(function (ev) {
	        return _this2[ev] = el && el[ev] && el[ev].bind(el);
	      });
	    }
	  }, {
	    key: 'maybeScrollItemIntoView',
	    value: function maybeScrollItemIntoView() {
	      if (this.isOpen() && this.state.highlightedIndex !== null) {
	        var itemNode = this.refs['item-' + this.state.highlightedIndex];
	        var menuNode = this.refs.menu;
	        scrollIntoView(findDOMNode(itemNode), findDOMNode(menuNode), { onlyScrollIfNeeded: true });
	      }
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      if (Autocomplete.keyDownHandlers[event.key]) Autocomplete.keyDownHandlers[event.key].call(this, event);else if (!this.isOpen()) {
	        this.setState({
	          isOpen: true
	        });
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      this.props.onChange(event, event.target.value);
	    }
	  }, {
	    key: 'getFilteredItems',
	    value: function getFilteredItems(props) {
	      var items = props.items;
	
	      if (props.shouldItemRender) {
	        items = items.filter(function (item) {
	          return props.shouldItemRender(item, props.value);
	        });
	      }
	
	      if (props.sortItems) {
	        items.sort(function (a, b) {
	          return props.sortItems(a, b, props.value);
	        });
	      }
	
	      return items;
	    }
	  }, {
	    key: 'maybeAutoCompleteText',
	    value: function maybeAutoCompleteText(state, props) {
	      var highlightedIndex = state.highlightedIndex;
	      var value = props.value,
	          getItemValue = props.getItemValue;
	
	      var index = highlightedIndex === null ? 0 : highlightedIndex;
	      var matchedItem = this.getFilteredItems(props)[index];
	      if (value !== '' && matchedItem) {
	        var itemValue = getItemValue(matchedItem);
	        var itemValueDoesMatch = itemValue.toLowerCase().indexOf(value.toLowerCase()) === 0;
	        if (itemValueDoesMatch) {
	          return { highlightedIndex: index };
	        }
	      }
	      return { highlightedIndex: null };
	    }
	  }, {
	    key: 'ensureHighlightedIndex',
	    value: function ensureHighlightedIndex(state, props) {
	      if (state.highlightedIndex >= this.getFilteredItems(props).length) {
	        return { highlightedIndex: null };
	      }
	    }
	  }, {
	    key: 'setMenuPositions',
	    value: function setMenuPositions() {
	      var node = this.refs.input;
	      var rect = node.getBoundingClientRect();
	      var computedStyle = global.window.getComputedStyle(node);
	      var marginBottom = parseInt(computedStyle.marginBottom, 10) || 0;
	      var marginLeft = parseInt(computedStyle.marginLeft, 10) || 0;
	      var marginRight = parseInt(computedStyle.marginRight, 10) || 0;
	      this.setState({
	        menuTop: rect.bottom + marginBottom,
	        menuLeft: rect.left + marginLeft,
	        menuWidth: rect.width + marginLeft + marginRight
	      });
	    }
	  }, {
	    key: 'highlightItemFromMouse',
	    value: function highlightItemFromMouse(index) {
	      this.setState({ highlightedIndex: index });
	    }
	  }, {
	    key: 'selectItemFromMouse',
	    value: function selectItemFromMouse(item) {
	      var _this3 = this;
	
	      var value = this.props.getItemValue(item);
	      // The menu will de-render before a mouseLeave event
	      // happens. Clear the flag to release control over focus
	      this.setIgnoreBlur(false);
	      this.setState({
	        isOpen: false,
	        highlightedIndex: null
	      }, function () {
	        _this3.props.onSelect(value, item);
	      });
	    }
	  }, {
	    key: 'setIgnoreBlur',
	    value: function setIgnoreBlur(ignore) {
	      this._ignoreBlur = ignore;
	    }
	  }, {
	    key: 'renderMenu',
	    value: function renderMenu() {
	      var _this4 = this;
	
	      var items = this.getFilteredItems(this.props).map(function (item, index) {
	        var element = _this4.props.renderItem(item, _this4.state.highlightedIndex === index, { cursor: 'default' });
	        return React.cloneElement(element, {
	          onMouseEnter: function onMouseEnter() {
	            return _this4.highlightItemFromMouse(index);
	          },
	          onClick: function onClick() {
	            return _this4.selectItemFromMouse(item);
	          },
	          ref: function ref(e) {
	            return _this4.refs['item-' + index] = e;
	          }
	        });
	      });
	      var style = {
	        left: this.state.menuLeft,
	        top: this.state.menuTop,
	        minWidth: this.state.menuWidth
	      };
	      var menu = this.props.renderMenu(items, this.props.value, style);
	      return React.cloneElement(menu, {
	        ref: function ref(e) {
	          return _this4.refs.menu = e;
	        },
	        // Ignore blur to prevent menu from de-rendering before we can process click
	        onMouseEnter: function onMouseEnter() {
	          return _this4.setIgnoreBlur(true);
	        },
	        onMouseLeave: function onMouseLeave() {
	          return _this4.setIgnoreBlur(false);
	        }
	      });
	    }
	  }, {
	    key: 'handleInputBlur',
	    value: function handleInputBlur(event) {
	      var _this5 = this;
	
	      if (this._ignoreBlur) {
	        this._ignoreFocus = true;
	        this._scrollOffset = getScrollOffset();
	        this.refs.input.focus();
	        return;
	      }
	      var setStateCallback = void 0;
	      var highlightedIndex = this.state.highlightedIndex;
	
	      if (this.props.selectOnBlur && highlightedIndex !== null) {
	        var items = this.getFilteredItems(this.props);
	        var item = items[highlightedIndex];
	        var value = this.props.getItemValue(item);
	        setStateCallback = function setStateCallback() {
	          return _this5.props.onSelect(value, item);
	        };
	      }
	      this.setState({
	        isOpen: false,
	        highlightedIndex: null
	      }, setStateCallback);
	      var onBlur = this.props.inputProps.onBlur;
	
	      if (onBlur) {
	        onBlur(event);
	      }
	    }
	  }, {
	    key: 'handleInputFocus',
	    value: function handleInputFocus(event) {
	      var _this6 = this;
	
	      if (this._ignoreFocus) {
	        this._ignoreFocus = false;
	        var _scrollOffset = this._scrollOffset,
	            x = _scrollOffset.x,
	            y = _scrollOffset.y;
	
	        this._scrollOffset = null;
	        // Focus will cause the browser to scroll the <input> into view.
	        // This can cause the mouse coords to change, which in turn
	        // could cause a new highlight to happen, cancelling the click
	        // event (when selecting with the mouse)
	        window.scrollTo(x, y);
	        // Some browsers wait until all focus event handlers have been
	        // processed before scrolling the <input> into view, so let's
	        // scroll again on the next tick to ensure we're back to where
	        // the user was before focus was lost. We could do the deferred
	        // scroll only, but that causes a jarring split second jump in
	        // some browsers that scroll before the focus event handlers
	        // are triggered.
	        clearTimeout(this._scrollTimer);
	        this._scrollTimer = setTimeout(function () {
	          _this6._scrollTimer = null;
	          window.scrollTo(x, y);
	        }, 0);
	        return;
	      }
	      this.setState({ isOpen: true });
	      var onFocus = this.props.inputProps.onFocus;
	
	      if (onFocus) {
	        onFocus(event);
	      }
	    }
	  }, {
	    key: 'isInputFocused',
	    value: function isInputFocused() {
	      var el = this.refs.input;
	      return el.ownerDocument && el === el.ownerDocument.activeElement;
	    }
	  }, {
	    key: 'handleInputClick',
	    value: function handleInputClick() {
	      // Input will not be focused if it's disabled
	      if (this.isInputFocused() && !this.isOpen()) this.setState({ isOpen: true });
	    }
	  }, {
	    key: 'composeEventHandlers',
	    value: function composeEventHandlers(internal, external) {
	      return external ? function (e) {
	        internal(e);external(e);
	      } : internal;
	    }
	  }, {
	    key: 'isOpen',
	    value: function isOpen() {
	      return 'open' in this.props ? this.props.open : this.state.isOpen;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.debug) {
	        // you don't like it, you love it
	        this._debugStates.push({
	          id: this._debugStates.length,
	          state: this.state
	        });
	      }
	
	      var inputProps = this.props.inputProps;
	
	      var open = this.isOpen();
	      return React.createElement(
	        'div',
	        _extends({ style: _extends({}, this.props.wrapperStyle) }, this.props.wrapperProps),
	        this.props.renderInput(_extends({}, inputProps, {
	          role: 'combobox',
	          'aria-autocomplete': 'list',
	          'aria-expanded': open,
	          autoComplete: 'off',
	          ref: this.exposeAPI,
	          onFocus: this.handleInputFocus,
	          onBlur: this.handleInputBlur,
	          onChange: this.handleChange,
	          onKeyDown: this.composeEventHandlers(this.handleKeyDown, inputProps.onKeyDown),
	          onClick: this.composeEventHandlers(this.handleInputClick, inputProps.onClick),
	          value: this.props.value
	        })),
	        open && this.renderMenu(),
	        this.props.debug && React.createElement(
	          'pre',
	          { style: { marginLeft: 300 } },
	          JSON.stringify(this._debugStates.slice(Math.max(0, this._debugStates.length - 5), this._debugStates.length), null, 2)
	        )
	      );
	    }
	  }]);
	
	  return Autocomplete;
	}(React.Component);
	
	Autocomplete.propTypes = {
	  /**
	   * The items to display in the dropdown menu
	   */
	  items: PropTypes.array.isRequired,
	  /**
	   * The value to display in the input field
	   */
	  value: PropTypes.any,
	  /**
	   * Arguments: `event: Event, value: String`
	   *
	   * Invoked every time the user changes the input's value.
	   */
	  onChange: PropTypes.func,
	  /**
	   * Arguments: `value: String, item: Any`
	   *
	   * Invoked when the user selects an item from the dropdown menu.
	   */
	  onSelect: PropTypes.func,
	  /**
	   * Arguments: `item: Any, value: String`
	   *
	   * Invoked for each entry in `items` and its return value is used to
	   * determine whether or not it should be displayed in the dropdown menu.
	   * By default all items are always rendered.
	   */
	  shouldItemRender: PropTypes.func,
	  /**
	   * Arguments: `itemA: Any, itemB: Any, value: String`
	   *
	   * The function which is used to sort `items` before display.
	   */
	  sortItems: PropTypes.func,
	  /**
	   * Arguments: `item: Any`
	   *
	   * Used to read the display value from each entry in `items`.
	   */
	  getItemValue: PropTypes.func.isRequired,
	  /**
	   * Arguments: `item: Any, isHighlighted: Boolean, styles: Object`
	   *
	   * Invoked for each entry in `items` that also passes `shouldItemRender` to
	   * generate the render tree for each item in the dropdown menu. `styles` is
	   * an optional set of styles that can be applied to improve the look/feel
	   * of the items in the dropdown menu.
	   */
	  renderItem: PropTypes.func.isRequired,
	  /**
	   * Arguments: `items: Array<Any>, value: String, styles: Object`
	   *
	   * Invoked to generate the render tree for the dropdown menu. Ensure the
	   * returned tree includes every entry in `items` or else the highlight order
	   * and keyboard navigation logic will break. `styles` will contain
	   * { top, left, minWidth } which are the coordinates of the top-left corner
	   * and the width of the dropdown menu.
	   */
	  renderMenu: PropTypes.func,
	  /**
	   * Styles that are applied to the dropdown menu in the default `renderMenu`
	   * implementation. If you override `renderMenu` and you want to use
	   * `menuStyle` you must manually apply them (`this.props.menuStyle`).
	   */
	  menuStyle: PropTypes.object,
	  /**
	   * Arguments: `props: Object`
	   *
	   * Invoked to generate the input element. The `props` argument is the result
	   * of merging `props.inputProps` with a selection of props that are required
	   * both for functionality and accessibility. At the very least you need to
	   * apply `props.ref` and all `props.on<event>` event handlers. Failing to do
	   * this will cause `Autocomplete` to behave unexpectedly.
	   */
	  renderInput: PropTypes.func,
	  /**
	   * Props passed to `props.renderInput`. By default these props will be
	   * applied to the `<input />` element rendered by `Autocomplete`, unless you
	   * have specified a custom value for `props.renderInput`. Any properties
	   * supported by `HTMLInputElement` can be specified, apart from the
	   * following which are set by `Autocomplete`: value, autoComplete, role,
	   * aria-autocomplete. `inputProps` is commonly used for (but not limited to)
	   * placeholder, event handlers (onFocus, onBlur, etc.), autoFocus, etc..
	   */
	  inputProps: PropTypes.object,
	  /**
	   * Props that are applied to the element which wraps the `<input />` and
	   * dropdown menu elements rendered by `Autocomplete`.
	   */
	  wrapperProps: PropTypes.object,
	  /**
	   * This is a shorthand for `wrapperProps={{ style: <your styles> }}`.
	   * Note that `wrapperStyle` is applied before `wrapperProps`, so the latter
	   * will win if it contains a `style` entry.
	   */
	  wrapperStyle: PropTypes.object,
	  /**
	   * Whether or not to automatically highlight the top match in the dropdown
	   * menu.
	   */
	  autoHighlight: PropTypes.bool,
	  /**
	   * Whether or not to automatically select the highlighted item when the
	   * `<input>` loses focus.
	   */
	  selectOnBlur: PropTypes.bool,
	  /**
	   * Arguments: `isOpen: Boolean`
	   *
	   * Invoked every time the dropdown menu's visibility changes (i.e. every
	   * time it is displayed/hidden).
	   */
	  onMenuVisibilityChange: PropTypes.func,
	  /**
	   * Used to override the internal logic which displays/hides the dropdown
	   * menu. This is useful if you want to force a certain state based on your
	   * UX/business logic. Use it together with `onMenuVisibilityChange` for
	   * fine-grained control over the dropdown menu dynamics.
	   */
	  open: PropTypes.bool,
	  debug: PropTypes.bool
	};
	Autocomplete.defaultProps = {
	  value: '',
	  wrapperProps: {},
	  wrapperStyle: {
	    display: 'inline-block'
	  },
	  inputProps: {},
	  renderInput: function renderInput(props) {
	    return React.createElement('input', props);
	  },
	  onChange: function onChange() {},
	  onSelect: function onSelect() {},
	  renderMenu: function renderMenu(items, value, style) {
	    return React.createElement('div', { style: _extends({}, style, this.menuStyle), children: items });
	  },
	
	  menuStyle: {
	    borderRadius: '3px',
	    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
	    background: 'rgba(255, 255, 255, 0.9)',
	    padding: '2px 0',
	    fontSize: '90%',
	    position: 'fixed',
	    overflow: 'auto',
	    maxHeight: '50%' },
	  autoHighlight: true,
	  selectOnBlur: false,
	  onMenuVisibilityChange: function onMenuVisibilityChange() {}
	};
	Autocomplete.keyDownHandlers = {
	  ArrowDown: function ArrowDown(event) {
	    event.preventDefault();
	    var itemsLength = this.getFilteredItems(this.props).length;
	    if (!itemsLength) return;
	    var highlightedIndex = this.state.highlightedIndex;
	
	    var index = highlightedIndex === null || highlightedIndex === itemsLength - 1 ? 0 : highlightedIndex + 1;
	    this.setState({
	      highlightedIndex: index,
	      isOpen: true
	    });
	  },
	  ArrowUp: function ArrowUp(event) {
	    event.preventDefault();
	    var itemsLength = this.getFilteredItems(this.props).length;
	    if (!itemsLength) return;
	    var highlightedIndex = this.state.highlightedIndex;
	
	    var index = highlightedIndex === 0 || highlightedIndex === null ? itemsLength - 1 : highlightedIndex - 1;
	    this.setState({
	      highlightedIndex: index,
	      isOpen: true
	    });
	  },
	  Enter: function Enter(event) {
	    var _this7 = this;
	
	    // Key code 229 is used for selecting items from character selectors (Pinyin, Kana, etc)
	    if (event.keyCode !== 13) return;
	    if (!this.isOpen()) {
	      // menu is closed so there is no selection to accept -> do nothing
	      return;
	    } else if (this.state.highlightedIndex == null) {
	      // input has focus but no menu item is selected + enter is hit -> close the menu, highlight whatever's in input
	      this.setState({
	        isOpen: false
	      }, function () {
	        _this7.refs.input.select();
	      });
	    } else {
	      // text entered + menu item has been highlighted + enter is hit -> update value to that of selected menu item, close the menu
	      event.preventDefault();
	      var item = this.getFilteredItems(this.props)[this.state.highlightedIndex];
	      var value = this.props.getItemValue(item);
	      this.setState({
	        isOpen: false,
	        highlightedIndex: null
	      }, function () {
	        //this.refs.input.focus() // TODO: file issue
	        _this7.refs.input.setSelectionRange(value.length, value.length);
	        _this7.props.onSelect(value, item);
	      });
	    }
	  },
	  Escape: function Escape() {
	    // In case the user is currently hovering over the menu
	    this.setIgnoreBlur(false);
	    this.setState({
	      highlightedIndex: null,
	      isOpen: false
	    });
	  },
	  Tab: function Tab() {
	    // In case the user is currently hovering over the menu
	    this.setIgnoreBlur(false);
	  }
	};
	
	
	module.exports = Autocomplete;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactBootstrap = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var instanceCount = 0; // See http://jszen.blogspot.com/2007/03/how-to-build-simple-calendar-with.html for calendar logic.
	
	var CalendarHeader = _react2.default.createClass({
	  displayName: 'DatePickerHeader',
	
	  propTypes: {
	    displayDate: _react2.default.PropTypes.object.isRequired,
	    onChange: _react2.default.PropTypes.func.isRequired,
	    monthLabels: _react2.default.PropTypes.array.isRequired,
	    previousButtonElement: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]).isRequired,
	    nextButtonElement: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]).isRequired
	  },
	
	  handleClickPrevious: function handleClickPrevious() {
	    var newDisplayDate = new Date(this.props.displayDate);
	    newDisplayDate.setMonth(newDisplayDate.getMonth() - 1);
	    this.props.onChange(newDisplayDate);
	  },
	  handleClickNext: function handleClickNext() {
	    var newDisplayDate = new Date(this.props.displayDate);
	    newDisplayDate.setMonth(newDisplayDate.getMonth() + 1);
	    this.props.onChange(newDisplayDate);
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'text-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'text-muted pull-left', onClick: this.handleClickPrevious, style: { cursor: 'pointer' } },
	        this.props.previousButtonElement
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        this.props.monthLabels[this.props.displayDate.getMonth()],
	        ' ',
	        this.props.displayDate.getFullYear()
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'text-muted pull-right', onClick: this.handleClickNext, style: { cursor: 'pointer' } },
	        this.props.nextButtonElement
	      )
	    );
	  }
	});
	
	var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	var Calendar = _react2.default.createClass({
	  displayName: 'DatePickerCalendar',
	
	  propTypes: {
	    selectedDate: _react2.default.PropTypes.object,
	    displayDate: _react2.default.PropTypes.object.isRequired,
	    onChange: _react2.default.PropTypes.func.isRequired,
	    dayLabels: _react2.default.PropTypes.array.isRequired,
	    cellPadding: _react2.default.PropTypes.string.isRequired,
	    weekStartsOnMonday: _react2.default.PropTypes.bool,
	    showTodayButton: _react2.default.PropTypes.bool,
	    todayButtonLabel: _react2.default.PropTypes.string
	  },
	
	  handleClick: function handleClick(day) {
	    var newSelectedDate = new Date(this.props.displayDate);
	    newSelectedDate.setHours(12);
	    newSelectedDate.setMinutes(0);
	    newSelectedDate.setSeconds(0);
	    newSelectedDate.setMilliseconds(0);
	    newSelectedDate.setDate(day);
	    this.props.onChange(newSelectedDate);
	  },
	  handleClickToday: function handleClickToday() {
	    var newSelectedDate = new Date();
	    newSelectedDate.setHours(12);
	    newSelectedDate.setMinutes(0);
	    newSelectedDate.setSeconds(0);
	    newSelectedDate.setMilliseconds(0);
	    this.props.onChange(newSelectedDate);
	  },
	  render: function render() {
	    var _this = this;
	
	    var currentDate = new Date();
	    var currentDay = currentDate.getDate();
	    var currentMonth = currentDate.getMonth();
	    var currentYear = currentDate.getFullYear();
	    var selectedDay = this.props.selectedDate ? this.props.selectedDate.getDate() : null;
	    var selectedMonth = this.props.selectedDate ? this.props.selectedDate.getMonth() : null;
	    var selectedYear = this.props.selectedDate ? this.props.selectedDate.getFullYear() : null;
	    var year = this.props.displayDate.getFullYear();
	    var month = this.props.displayDate.getMonth();
	    var firstDay = new Date(year, month, 1);
	    var startingDay = this.props.weekStartsOnMonday ? firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1 : firstDay.getDay();
	
	    var monthLength = daysInMonth[month];
	    if (month == 1) {
	      if (year % 4 == 0 && year % 100 != 0 || year % 400 == 0) {
	        monthLength = 29;
	      }
	    }
	
	    var weeks = [];
	    var day = 1;
	    for (var i = 0; i < 9; i++) {
	      var week = [];
	      for (var j = 0; j <= 6; j++) {
	        if (day <= monthLength && (i > 0 || j >= startingDay)) {
	          var selected = day === selectedDay && month == selectedMonth && year === selectedYear;
	          var current = day === currentDay && month == currentMonth && year === currentYear;
	          week.push(_react2.default.createElement(
	            'td',
	            {
	              key: j,
	              onClick: this.handleClick.bind(this, day),
	              style: { cursor: 'pointer', padding: this.props.cellPadding },
	              className: selected ? 'bg-primary' : current ? 'text-muted' : null },
	            day
	          ));
	          day++;
	        } else {
	          week.push(_react2.default.createElement('td', { key: j }));
	        }
	      }
	
	      weeks.push(_react2.default.createElement(
	        'tr',
	        { key: i },
	        week
	      ));
	      if (day > monthLength) {
	        break;
	      }
	    }
	
	    return _react2.default.createElement(
	      'table',
	      { className: 'text-center' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          this.props.dayLabels.map(function (label, index) {
	            return _react2.default.createElement(
	              'td',
	              {
	                key: index,
	                className: 'text-muted',
	                style: { padding: _this.props.cellPadding } },
	              _react2.default.createElement(
	                'small',
	                null,
	                label
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        weeks
	      ),
	      this.props.showTodayButton && _react2.default.createElement(
	        'tfoot',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            { colSpan: this.props.dayLabels.length, style: { paddingTop: '9px' } },
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                block: true,
	                bsSize: 'xsmall',
	                className: 'u-today-button',
	                onClick: this.handleClickToday },
	              this.props.todayButtonLabel
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = _react2.default.createClass({
	  displayName: 'DatePicker',
	
	  propTypes: {
	    defaultValue: _react2.default.PropTypes.string,
	    value: _react2.default.PropTypes.string,
	    className: _react2.default.PropTypes.string,
	    style: _react2.default.PropTypes.object,
	    cellPadding: _react2.default.PropTypes.string,
	    placeholder: _react2.default.PropTypes.string,
	    dayLabels: _react2.default.PropTypes.array,
	    monthLabels: _react2.default.PropTypes.array,
	    onChange: _react2.default.PropTypes.func,
	    onClear: _react2.default.PropTypes.func,
	    onBlur: _react2.default.PropTypes.func,
	    onFocus: _react2.default.PropTypes.func,
	    autoFocus: _react2.default.PropTypes.bool,
	    disabled: _react2.default.PropTypes.bool,
	    weekStartsOnMonday: _react2.default.PropTypes.bool,
	    clearButtonElement: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]),
	    showClearButton: _react2.default.PropTypes.bool,
	    previousButtonElement: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]),
	    nextButtonElement: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]),
	    calendarPlacement: _react2.default.PropTypes.string,
	    dateFormat: _react2.default.PropTypes.string, // 'MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD', 'DD-MM-YYYY'
	    bsClass: _react2.default.PropTypes.string,
	    bsSize: _react2.default.PropTypes.string,
	    calendarContainer: _react2.default.PropTypes.object,
	    id: _react2.default.PropTypes.string,
	    name: _react2.default.PropTypes.string,
	    showTodayButton: _react2.default.PropTypes.bool,
	    todayButtonLabel: _react2.default.PropTypes.string,
	    customControl: _react2.default.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    var language = typeof window !== 'undefined' && window.navigator ? (window.navigator.userLanguage || window.navigator.language || '').toLowerCase() : '';
	    var dateFormat = !language || language === 'en-us' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
	    return {
	      cellPadding: '5px',
	      dayLabels: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	      monthLabels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	      clearButtonElement: '×',
	      previousButtonElement: '<',
	      nextButtonElement: '>',
	      calendarPlacement: 'bottom',
	      dateFormat: dateFormat,
	      showClearButton: true,
	      autoFocus: false,
	      disabled: false,
	      showTodayButton: false,
	      todayButtonLabel: 'Today',
	      instanceCount: instanceCount++,
	      style: {
	        width: '100%'
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    if (this.props.value && this.props.defaultValue) {
	      throw new Error('Conflicting DatePicker properties \'value\' and \'defaultValue\'');
	    }
	    var state = this.makeDateValues(this.props.value || this.props.defaultValue);
	    if (this.props.weekStartsOnMonday) {
	      state.dayLabels = this.props.dayLabels.slice(1).concat(this.props.dayLabels.slice(0, 1));
	    } else {
	      state.dayLabels = this.props.dayLabels;
	    }
	    state.focused = false;
	    state.inputFocused = false;
	    state.placeholder = this.props.placeholder || this.props.dateFormat;
	    state.separator = this.props.dateFormat.match(/[^A-Z]/)[0];
	    return state;
	  },
	  makeDateValues: function makeDateValues(isoString) {
	    var displayDate = void 0;
	    var selectedDate = isoString ? new Date(isoString.slice(0, 10) + 'T12:00:00.000Z') : null;
	    var inputValue = isoString ? this.makeInputValueString(selectedDate) : null;
	    if (selectedDate) {
	      displayDate = new Date(selectedDate);
	    } else {
	      displayDate = new Date(new Date().toISOString().slice(0, 10) + 'T12:00:00.000Z');
	    }
	
	    return {
	      value: selectedDate ? selectedDate.toISOString() : null,
	      displayDate: displayDate,
	      selectedDate: selectedDate,
	      inputValue: inputValue
	    };
	  },
	  clear: function clear() {
	    if (this.props.onClear) {
	      this.props.onClear();
	    } else {
	      this.setState(this.makeDateValues(null));
	    }
	
	    if (this.props.onChange) {
	      this.props.onChange(null, null);
	    }
	  },
	  handleHide: function handleHide() {
	    if (this.state.inputFocused) {
	      return;
	    }
	    this.setState({
	      focused: false
	    });
	    if (this.props.onBlur) {
	      var event = document.createEvent('CustomEvent');
	      event.initEvent('Change Date', true, false);
	      _reactDom2.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
	      this.props.onBlur(event);
	    }
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    if (e.which === 9 && this.state.inputFocused) {
	      this.setState({
	        focused: false
	      });
	
	      if (this.props.onBlur) {
	        var event = document.createEvent('CustomEvent');
	        event.initEvent('Change Date', true, false);
	        _reactDom2.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
	        this.props.onBlur(event);
	      }
	    }
	  },
	  handleFocus: function handleFocus() {
	    if (this.state.focused === true) {
	      return;
	    }
	
	    this.setState({
	      inputFocused: true,
	      focused: true
	    });
	
	    if (this.props.onFocus) {
	      var event = document.createEvent('CustomEvent');
	      event.initEvent('Change Date', true, false);
	      _reactDom2.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
	      this.props.onFocus(event);
	    }
	  },
	  handleBlur: function handleBlur() {
	    this.setState({
	      inputFocused: false
	    });
	  },
	
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !(this.state.inputFocused === true && nextState.inputFocused === false);
	  },
	
	  getValue: function getValue() {
	    return this.state.selectedDate ? this.state.selectedDate.toISOString() : null;
	  },
	  getFormattedValue: function getFormattedValue() {
	    return this.state.displayDate ? this.state.inputValue : null;
	  },
	  makeInputValueString: function makeInputValueString(date) {
	    var month = date.getMonth() + 1;
	    var day = date.getDate();
	
	    //this method is executed during intialState setup... handle a missing state properly
	    var separator = this.state ? this.state.separator : this.props.dateFormat.match(/[^A-Z]/)[0];
	    if (this.props.dateFormat.match(/MM.DD.YYYY/)) {
	      return (month > 9 ? month : '0' + month) + separator + (day > 9 ? day : '0' + day) + separator + date.getFullYear();
	    } else if (this.props.dateFormat.match(/DD.MM.YYYY/)) {
	      return (day > 9 ? day : '0' + day) + separator + (month > 9 ? month : '0' + month) + separator + date.getFullYear();
	    } else {
	      return date.getFullYear() + separator + (month > 9 ? month : '0' + month) + separator + (day > 9 ? day : '0' + day);
	    }
	  },
	  handleBadInput: function handleBadInput(originalValue) {
	    var parts = originalValue.replace(new RegExp('[^0-9' + this.state.separator + ']'), '').split(this.state.separator);
	    if (this.props.dateFormat.match(/MM.DD.YYYY/) || this.props.dateFormat.match(/DD.MM.YYYY/)) {
	      if (parts[0] && parts[0].length > 2) {
	        parts[1] = parts[0].slice(2) + (parts[1] || '');
	        parts[0] = parts[0].slice(0, 2);
	      }
	      if (parts[1] && parts[1].length > 2) {
	        parts[2] = parts[1].slice(2) + (parts[2] || '');
	        parts[1] = parts[1].slice(0, 2);
	      }
	      if (parts[2]) {
	        parts[2] = parts[2].slice(0, 4);
	      }
	    } else {
	      if (parts[0] && parts[0].length > 4) {
	        parts[1] = parts[0].slice(4) + (parts[1] || '');
	        parts[0] = parts[0].slice(0, 4);
	      }
	      if (parts[1] && parts[1].length > 2) {
	        parts[2] = parts[1].slice(2) + (parts[2] || '');
	        parts[1] = parts[1].slice(0, 2);
	      }
	      if (parts[2]) {
	        parts[2] = parts[2].slice(0, 2);
	      }
	    }
	    this.setState({
	      inputValue: parts.join(this.state.separator)
	    });
	  },
	  handleInputChange: function handleInputChange() {
	
	    var originalValue = _reactDom2.default.findDOMNode(this.refs.input).value;
	    var inputValue = originalValue.replace(/(-|\/\/)/g, this.state.separator).slice(0, 10);
	
	    var month = void 0,
	        day = void 0,
	        year = void 0;
	    if (this.props.dateFormat.match(/MM.DD.YYYY/)) {
	      if (!inputValue.match(/[0-1][0-9].[0-3][0-9].[1-2][0-9][0-9][0-9]/)) {
	        return this.handleBadInput(originalValue);
	      }
	
	      month = inputValue.slice(0, 2).replace(/[^0-9]/g, '');
	      day = inputValue.slice(3, 5).replace(/[^0-9]/g, '');
	      year = inputValue.slice(6, 10).replace(/[^0-9]/g, '');
	    } else if (this.props.dateFormat.match(/DD.MM.YYYY/)) {
	      if (!inputValue.match(/[0-3][0-9].[0-1][0-9].[1-2][0-9][0-9][0-9]/)) {
	        return this.handleBadInput(originalValue);
	      }
	
	      day = inputValue.slice(0, 2).replace(/[^0-9]/g, '');
	      month = inputValue.slice(3, 5).replace(/[^0-9]/g, '');
	      year = inputValue.slice(6, 10).replace(/[^0-9]/g, '');
	    } else {
	      if (!inputValue.match(/[1-2][0-9][0-9][0-9].[0-1][0-9].[0-3][0-9]/)) {
	        return this.handleBadInput(originalValue);
	      }
	
	      year = inputValue.slice(0, 4).replace(/[^0-9]/g, '');
	      month = inputValue.slice(5, 7).replace(/[^0-9]/g, '');
	      day = inputValue.slice(8, 10).replace(/[^0-9]/g, '');
	    }
	
	    var monthInteger = parseInt(month, 10);
	    var dayInteger = parseInt(day, 10);
	    var yearInteger = parseInt(year, 10);
	    if (monthInteger > 12 || dayInteger > 31) {
	      return this.handleBadInput(originalValue);
	    }
	
	    if (!isNaN(monthInteger) && !isNaN(dayInteger) && !isNaN(yearInteger) && monthInteger <= 12 && dayInteger <= 31 && yearInteger > 999) {
	      var selectedDate = new Date(yearInteger, monthInteger - 1, dayInteger, 12, 0, 0, 0);
	      this.setState({
	        selectedDate: selectedDate,
	        displayDate: selectedDate,
	        value: selectedDate.toISOString()
	      });
	
	      if (this.props.onChange) {
	        this.props.onChange(selectedDate.toISOString(), inputValue);
	      }
	    }
	
	    this.setState({
	      inputValue: inputValue
	    });
	  },
	  onChangeMonth: function onChangeMonth(newDisplayDate) {
	    this.setState({
	      displayDate: newDisplayDate
	    });
	  },
	  onChangeDate: function onChangeDate(newSelectedDate) {
	    var inputValue = this.makeInputValueString(newSelectedDate);
	    this.setState({
	      inputValue: inputValue,
	      selectedDate: newSelectedDate,
	      displayDate: newSelectedDate,
	      value: newSelectedDate.toISOString(),
	      focused: false
	    });
	
	    if (this.props.onBlur) {
	      var event = document.createEvent('CustomEvent');
	      event.initEvent('Change Date', true, false);
	      _reactDom2.default.findDOMNode(this.refs.hiddenInput).dispatchEvent(event);
	      this.props.onBlur(event);
	    }
	
	    if (this.props.onChange) {
	      this.props.onChange(newSelectedDate.toISOString(), inputValue);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var value = newProps.value;
	    if (this.getValue() !== value) {
	      this.setState(this.makeDateValues(value));
	    }
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var calendarHeader = _react2.default.createElement(CalendarHeader, {
	      previousButtonElement: this.props.previousButtonElement,
	      nextButtonElement: this.props.nextButtonElement,
	      displayDate: this.state.displayDate,
	      onChange: this.onChangeMonth,
	      monthLabels: this.props.monthLabels,
	      dateFormat: this.props.dateFormat });
	
	    var control = this.props.customControl ? _react2.default.cloneElement(this.props.customControl, {
	      onKeyDown: this.handleKeyDown,
	      value: this.state.inputValue || '',
	      placeholder: this.state.focused ? this.props.dateFormat : this.state.placeholder,
	      ref: 'input',
	      disabled: this.props.disabled,
	      onFocus: this.handleFocus,
	      onBlur: this.handleBlur,
	      onChange: this.handleInputChange,
	      className: this.props.className,
	      style: this.props.style
	    }) : _react2.default.createElement(_reactBootstrap.FormControl, {
	      onKeyDown: this.handleKeyDown,
	      value: this.state.inputValue || '',
	      ref: 'input',
	      type: 'text',
	      className: this.props.className,
	      style: this.props.style,
	      autoFocus: this.props.autoFocus,
	      disabled: this.props.disabled,
	      placeholder: this.state.focused ? this.props.dateFormat : this.state.placeholder,
	      onFocus: this.handleFocus,
	      onBlur: this.handleBlur,
	      onChange: this.handleInputChange
	    });
	
	    return _react2.default.createElement(
	      _reactBootstrap.InputGroup,
	      {
	        ref: 'inputGroup',
	        bsClass: this.props.showClearButton ? this.props.bsClass : '',
	        bsSize: this.props.bsSize,
	        id: this.props.id ? this.props.id + '_group' : null },
	      _react2.default.createElement(
	        _reactBootstrap.Overlay,
	        {
	          rootClose: true,
	          onHide: this.handleHide,
	          show: this.state.focused,
	          container: function container() {
	            return _this2.props.calendarContainer || _reactDom2.default.findDOMNode(_this2.refs.overlayContainer);
	          },
	          target: function target() {
	            return _reactDom2.default.findDOMNode(_this2.refs.input);
	          },
	          placement: this.props.calendarPlacement,
	          delayHide: 200 },
	        _react2.default.createElement(
	          _reactBootstrap.Popover,
	          { id: 'date-picker-popover-' + this.props.instanceCount, className: 'date-picker-popover', title: calendarHeader },
	          _react2.default.createElement(Calendar, {
	            cellPadding: this.props.cellPadding,
	            selectedDate: this.state.selectedDate,
	            displayDate: this.state.displayDate,
	            onChange: this.onChangeDate,
	            dayLabels: this.state.dayLabels,
	            weekStartsOnMonday: this.props.weekStartsOnMonday,
	            showTodayButton: this.props.showTodayButton,
	            todayButtonLabel: this.props.todayButtonLabel })
	        )
	      ),
	      _react2.default.createElement('div', { ref: 'overlayContainer', style: { position: 'relative' } }),
	      _react2.default.createElement('input', { ref: 'hiddenInput', type: 'hidden', id: this.props.id, name: this.props.name, value: this.state.value || '', 'data-formattedvalue': this.state.value ? this.state.inputValue : '' }),
	      control,
	      this.props.showClearButton && !this.props.customControl && _react2.default.createElement(
	        _reactBootstrap.InputGroup.Addon,
	        {
	          onClick: this.props.disabled ? null : this.clear,
	          style: { cursor: this.state.inputValue && !this.props.disabled ? 'pointer' : 'not-allowed' } },
	        _react2.default.createElement(
	          'div',
	          { style: { opacity: this.state.inputValue && !this.props.disabled ? 1 : 0.5 } },
	          this.props.clearButtonElement
	        )
	      )
	    );
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(642);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Accordion = function (_React$Component) {
	  (0, _inherits3['default'])(Accordion, _React$Component);
	
	  function Accordion() {
	    (0, _classCallCheck3['default'])(this, Accordion);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Accordion.prototype.render = function render() {
	    return _react2['default'].createElement(
	      _PanelGroup2['default'],
	      (0, _extends3['default'])({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  };
	
	  return Accordion;
	}(_react2['default'].Component);
	
	exports['default'] = Accordion;
	module.exports = exports['default'];

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(143);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _StyleConfig = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onDismiss: _react2['default'].PropTypes.func,
	  closeLabel: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert = function (_React$Component) {
	  (0, _inherits3['default'])(Alert, _React$Component);
	
	  function Alert() {
	    (0, _classCallCheck3['default'])(this, Alert);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Alert.prototype.renderDismissButton = function renderDismissButton(onDismiss) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onDismiss,
	        'aria-hidden': 'true',
	        tabIndex: '-1'
	      },
	      _react2['default'].createElement(
	        'span',
	        null,
	        '\xD7'
	      )
	    );
	  };
	
	  Alert.prototype.renderSrOnlyDismissButton = function renderSrOnlyDismissButton(onDismiss, closeLabel) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close sr-only',
	        onClick: onDismiss
	      },
	      closeLabel
	    );
	  };
	
	  Alert.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        onDismiss = _props.onDismiss,
	        closeLabel = _props.closeLabel,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onDismiss', 'closeLabel', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'alert',
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      dismissable && this.renderDismissButton(onDismiss),
	      children,
	      dismissable && this.renderSrOnlyDismissButton(onDismiss, closeLabel)
	    );
	  };
	
	  return Alert;
	}(_react2['default'].Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	module.exports = exports['default'];

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	
	var propTypes = {
	  pullRight: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge = function (_React$Component) {
	  (0, _inherits3['default'])(Badge, _React$Component);
	
	  function Badge() {
	    (0, _classCallCheck3['default'])(this, Badge);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Badge.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Badge.prototype.render = function render() {
	    var _props = this.props,
	        pullRight = _props.pullRight,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['pullRight', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Badge;
	}(_react2['default'].Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('badge', Badge);
	module.exports = exports['default'];

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbItem = __webpack_require__(627);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3['default'])(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3['default'])(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Breadcrumb.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ol', (0, _extends3['default'])({}, elementProps, {
	      role: 'navigation',
	      'aria-label': 'breadcrumbs',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react2['default'].Component);
	
	Breadcrumb.Item = _BreadcrumbItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	module.exports = exports['default'];

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(180);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3['default'])(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-toolbar', (0, _bootstrapUtils.bsSizes)(_Button2['default'].SIZES, ButtonToolbar));
	module.exports = exports['default'];

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CarouselCaption = __webpack_require__(1302);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(629);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(336);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__(90);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _ValidComponentChildren = __webpack_require__(64);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _react2['default'].PropTypes.bool,
	  indicators: _react2['default'].PropTypes.bool,
	  interval: _react2['default'].PropTypes.number,
	  controls: _react2['default'].PropTypes.bool,
	  pauseOnHover: _react2['default'].PropTypes.bool,
	  wrap: _react2['default'].PropTypes.bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _react2['default'].PropTypes.func,
	  onSlideEnd: _react2['default'].PropTypes.func,
	  activeIndex: _react2['default'].PropTypes.number,
	  defaultActiveIndex: _react2['default'].PropTypes.number,
	  direction: _react2['default'].PropTypes.oneOf(['prev', 'next']),
	  prevIcon: _react2['default'].PropTypes.node,
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _react2['default'].PropTypes.string,
	  nextIcon: _react2['default'].PropTypes.node,
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-left' }),
	  prevLabel: 'Previous',
	  nextIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-right' }),
	  nextLabel: 'Next'
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3['default'])(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3['default'])(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	  };
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2['default'].count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2['default'].count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.getActiveIndex();
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props,
	        slide = _props.slide,
	        interval = _props.interval,
	        activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2['default'].forEach(children, function (child, index) {
	      indicators.push(_react2['default'].createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2['default'].createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2['default'].count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'prev',
	        className: (0, _classnames2['default'])(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon,
	      prevLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        prevLabel
	      )
	    ), (wrap || activeIndex !== count - 1) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'next',
	        className: (0, _classnames2['default'])(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon,
	      nextLabel && _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        nextLabel
	      )
	    )];
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        slide = _props2.slide,
	        indicators = _props2.indicators,
	        controls = _props2.controls,
	        wrap = _props2.wrap,
	        prevIcon = _props2.prevIcon,
	        prevLabel = _props2.prevLabel,
	        nextIcon = _props2.nextIcon,
	        nextLabel = _props2.nextLabel,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);
	    var _state = this.state,
	        previousActiveIndex = _state.previousActiveIndex,
	        direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2['default'].map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls({
	        wrap: wrap,
	        children: children,
	        activeIndex: activeIndex,
	        prevIcon: prevIcon,
	        prevLabel: prevLabel,
	        nextIcon: nextIcon,
	        nextLabel: nextLabel,
	        bsProps: bsProps
	      })
	    );
	  };
	
	  return Carousel;
	}(_react2['default'].Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2['default'];
	Carousel.Item = _CarouselItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3['default'])(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2['default'].Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(91);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3['default'])(Checkbox, _React$Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3['default'])(this, Checkbox);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	}(_react2['default'].Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _capitalize = __webpack_require__(644);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _StyleConfig = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _react2['default'].PropTypes.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _react2['default'].PropTypes.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _react2['default'].PropTypes.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix = function (_React$Component) {
	  (0, _inherits3['default'])(Clearfix, _React$Component);
	
	  function Clearfix() {
	    (0, _classCallCheck3['default'])(this, Clearfix);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Clearfix.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = 'visible' + (0, _capitalize2['default'])(size) + 'Block';
	      if (elementProps[propName]) {
	        classes['visible-' + size + '-block'] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react2['default'].Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	module.exports = exports['default'];

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _StyleConfig = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _react2['default'].PropTypes.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _react2['default'].PropTypes.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _react2['default'].PropTypes.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _react2['default'].PropTypes.number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _react2['default'].PropTypes.bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _react2['default'].PropTypes.bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _react2['default'].PropTypes.bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _react2['default'].PropTypes.bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _react2['default'].PropTypes.number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _react2['default'].PropTypes.number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _react2['default'].PropTypes.number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _react2['default'].PropTypes.number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3['default'])(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3['default'])(this, Col);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react2['default'].Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(91);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _react2['default'].PropTypes.string,
	  srOnly: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object
	};
	
	var ControlLabel = function (_React$Component) {
	  (0, _inherits3['default'])(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    (0, _classCallCheck3['default'])(this, ControlLabel);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        _props$htmlFor = _props.htmlFor,
	        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
	        srOnly = _props.srOnly,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['htmlFor', 'srOnly', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	
	    return _react2['default'].createElement('label', (0, _extends3['default'])({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react2['default'].Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(233);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(235);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _react2['default'].PropTypes.string,
	  bsSize: _react2['default'].PropTypes.string,
	  title: _react2['default'].PropTypes.node.isRequired,
	  noCaret: _react2['default'].PropTypes.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _react2['default'].PropTypes.node
	});
	
	var DropdownButton = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    (0, _classCallCheck3['default'])(this, DropdownButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, {
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	}(_react2['default'].Component);
	
	DropdownButton.propTypes = propTypes;
	
	exports['default'] = DropdownButton;
	module.exports = exports['default'];

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _from = __webpack_require__(196);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(315);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RootCloseWrapper = __webpack_require__(668);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(64);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  open: _react2['default'].PropTypes.bool,
	  pullRight: _react2['default'].PropTypes.bool,
	  onClose: _react2['default'].PropTypes.func,
	  labelledBy: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	  onSelect: _react2['default'].PropTypes.func,
	  rootCloseEvent: _react2['default'].PropTypes.oneOf(['click', 'mousedown'])
	};
	
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    (0, _classCallCheck3['default'])(this, DropdownMenu);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.props.onClose(event);
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	
	    return { items: items, activeIndex: activeIndex };
	  };
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom2['default'].findDOMNode(this);
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from2['default'])(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd.items,
	        activeIndex = _getItemsAndActiveInd.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd2.items,
	        activeIndex = _getItemsAndActiveInd2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props = this.props,
	        open = _props.open,
	        pullRight = _props.pullRight,
	        onClose = _props.onClose,
	        labelledBy = _props.labelledBy,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['open', 'pullRight', 'onClose', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	
	    return _react2['default'].createElement(
	      _RootCloseWrapper2['default'],
	      {
	        disabled: !open,
	        onRootClose: onClose,
	        event: rootCloseEvent
	      },
	      _react2['default'].createElement(
	        'ul',
	        (0, _extends4['default'])({}, elementProps, {
	          role: 'menu',
	          className: (0, _classnames2['default'])(className, classes),
	          'aria-labelledby': labelledBy
	        }),
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, _this2.handleKeyDown),
	            onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	          });
	        })
	      )
	    );
	  };
	
	  return DropdownMenu;
	}(_react2['default'].Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	module.exports = exports['default'];

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  horizontal: _react2['default'].PropTypes.bool,
	  inline: _react2['default'].PropTypes.bool,
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3['default'])(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3['default'])(this, Form);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        inline = _props.inline,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2['default'].Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(91);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__(1311);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(1312);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _react2['default'].PropTypes.string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3['default'])(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3['default'])(this, FormControl);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        type = _props.type,
	        _props$id = _props.id,
	        id = _props$id === undefined ? controlId : _props$id,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'type', 'id', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      type: type,
	      id: id,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2['default'].Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2['default'];
	FormControl.Static = _FormControlStatic2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control', FormControl);
	module.exports = exports['default'];

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Glyphicon = __webpack_require__(336);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3['default'])(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2['default'].createElement(_Glyphicon2['default'], (0, _extends3['default'])({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2['default'].Children.only(children);
	    return _react2['default'].cloneElement(child, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2['default'].Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3['default'])(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2['default'].Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _StyleConfig = __webpack_require__(50);
	
	var _ValidComponentChildren = __webpack_require__(64);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _react2['default'].PropTypes.string,
	  validationState: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error'])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3['default'])(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3['default'])(this, FormGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        controlId = _props.controlId,
	        validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2['default'].some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props,
	        validationState = _props2.validationState,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2['default'].Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3['default'])(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3['default'])(this, HelpBlock);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _react2['default'].PropTypes.bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _react2['default'].PropTypes.bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _react2['default'].PropTypes.bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3['default'])(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3['default'])(this, Image);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Image.prototype.render = function render() {
	    var _classes;
	
	    var _props = this.props,
	        responsive = _props.responsive,
	        rounded = _props.rounded,
	        circle = _props.circle,
	        thumbnail = _props.thumbnail,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	
	    return _react2['default'].createElement('img', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react2['default'].Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('img', Image);
	module.exports = exports['default'];

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__(1317);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(1318);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _StyleConfig = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3['default'])(this, InputGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2['default'].Component);
	
	InputGroup.Addon = _InputGroupAddon2['default'];
	InputGroup.Button = _InputGroupButton2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3['default'])(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3['default'])(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron = function (_React$Component) {
	  (0, _inherits3['default'])(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    (0, _classCallCheck3['default'])(this, Jumbotron);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Jumbotron.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react2['default'].Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	module.exports = exports['default'];

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(143);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _StyleConfig = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3['default'])(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3['default'])(this, Label);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _ListGroupItem = __webpack_require__(632);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _ValidComponentChildren = __webpack_require__(64);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType2['default']
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren2['default'].some(children, function (child) {
	    return child.type !== _ListGroupItem2['default'] || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroup, _React$Component);
	
	  function ListGroup() {
	    (0, _classCallCheck3['default'])(this, ListGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        _props$componentClass = _props.componentClass,
	        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren2['default'].every(children, function (child) {
	      return child.type === _ListGroupItem2['default'];
	    });
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      useListItem ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { listItem: true });
	      }) : children
	    );
	  };
	
	  return ListGroup;
	}(_react2['default'].Component);
	
	ListGroup.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	module.exports = exports['default'];

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody = function (_React$Component) {
	  (0, _inherits3['default'])(MediaBody, _React$Component);
	
	  function MediaBody() {
	    (0, _classCallCheck3['default'])(this, MediaBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react2['default'].Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	module.exports = exports['default'];

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading = function (_React$Component) {
	  (0, _inherits3['default'])(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    (0, _classCallCheck3['default'])(this, MediaHeading);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaHeading.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react2['default'].Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	module.exports = exports['default'];

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Media = __webpack_require__(337);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _react2['default'].PropTypes.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft = function (_React$Component) {
	  (0, _inherits3['default'])(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    (0, _classCallCheck3['default'])(this, MediaLeft);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaLeft.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react2['default'].Component);
	
	MediaLeft.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	module.exports = exports['default'];

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaList = function (_React$Component) {
	  (0, _inherits3['default'])(MediaList, _React$Component);
	
	  function MediaList() {
	    (0, _classCallCheck3['default'])(this, MediaList);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaList.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ul', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	module.exports = exports['default'];

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaListItem = function (_React$Component) {
	  (0, _inherits3['default'])(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    (0, _classCallCheck3['default'])(this, MediaListItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaListItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	module.exports = exports['default'];

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Media = __webpack_require__(337);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _react2['default'].PropTypes.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight = function (_React$Component) {
	  (0, _inherits3['default'])(MediaRight, _React$Component);
	
	  function MediaRight() {
	    (0, _classCallCheck3['default'])(this, MediaRight);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaRight.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react2['default'].Component);
	
	MediaRight.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	module.exports = exports['default'];

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _all = __webpack_require__(245);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _SafeAnchor = __webpack_require__(90);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _react2['default'].PropTypes.bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _react2['default'].PropTypes.bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all2['default'])(_react2['default'].PropTypes.bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _react2['default'].PropTypes.any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _react2['default'].PropTypes.bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _react2['default'].PropTypes.string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3['default'])(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    (0, _classCallCheck3['default'])(this, MenuItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        href = _props.href,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        divider = _props2.divider,
	        header = _props2.header,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'separator',
	        className: (0, _classnames2['default'])(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'heading',
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, elementProps, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	}(_react2['default'].Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(1045);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(451);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(152);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(1056);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(1424);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(671);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(234);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(633);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(1330);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(634);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(635);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(636);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(235);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Modal2['default'].propTypes, _ModalDialog2['default'].propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _react2['default'].PropTypes.oneOf(['static', true, false]),
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _react2['default'].PropTypes.bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _react2['default'].PropTypes.bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2['default'],
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _react2['default'].PropTypes.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _react2['default'].PropTypes.bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _react2['default'].PropTypes.bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _react2['default'].PropTypes.func,
	
	  /**
	   * @private
	   */
	  container: _Modal2['default'].propTypes.container
	});
	
	var defaultProps = (0, _extends3['default'])({}, _Modal2['default'].defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2['default']
	});
	
	var childContextTypes = {
	  $bs_modal: _react2['default'].PropTypes.shape({
	    onHide: _react2['default'].PropTypes.func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3['default'])(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3['default'])(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2['default']) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2['default'])(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2['default'])(_reactDom2['default'].findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['backdrop', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Modal2['default']),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2['default'].createElement(
	      _Modal2['default'],
	      (0, _extends3['default'])({}, baseModalProps, {
	        ref: function ref(c) {
	          _this2._modal = c;
	        },
	        show: show,
	        onEntering: (0, _createChainedFunction2['default'])(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2['default'])(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2['default'])((0, _bootstrapUtils.prefix)(props, 'backdrop'), inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2['default'] : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2['default'].createElement(
	        Dialog,
	        (0, _extends3['default'])({}, dialogProps, {
	          style: (0, _extends3['default'])({}, this.state.style, style),
	          className: (0, _classnames2['default'])(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2['default'].Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2['default'];
	Modal.Header = _ModalHeader2['default'];
	Modal.Title = _ModalTitle2['default'];
	Modal.Footer = _ModalFooter2['default'];
	
	Modal.Dialog = _ModalDialog2['default'];
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _StyleConfig = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _react2['default'].PropTypes.string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3['default'])(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3['default'])(this, ModalDialog);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4['default'])({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2['default'])(className, bsClassName)
	      }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(dialogClassName, dialogClasses) },
	        _react2['default'].createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2['default'].Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(233);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(235);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _ValidComponentChildren = __webpack_require__(64);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  title: _react2['default'].PropTypes.node.isRequired,
	  noCaret: _react2['default'].PropTypes.bool,
	  active: _react2['default'].PropTypes.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _react2['default'].PropTypes.node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3['default'])(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3['default'])(this, NavDropdown);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
	    var props = _ref.props;
	
	    var _this2 = this;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren2['default'].some(props.children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  NavDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        activeKey = _props.activeKey,
	        activeHref = _props.activeHref,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);
	
	
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        componentClass: 'li',
	        className: (0, _classnames2['default'])(className, { active: active }),
	        style: style
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, { useAnchor: true }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            active: _this3.isActive(child, activeKey, activeHref)
	          });
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2['default'].Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports['default'] = NavDropdown;
	module.exports = exports['default'];

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _uncontrollable = __webpack_require__(263);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Grid = __webpack_require__(631);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__(639);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__(1333);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__(1334);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(1335);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _StyleConfig = __webpack_require__(50);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	/* eslint-disable react/no-multi-comp */
	
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _react2['default'].PropTypes.bool,
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _react2['default'].PropTypes.bool,
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _react2['default'].PropTypes.bool,
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _react2['default'].PropTypes.bool,
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _react2['default'].PropTypes.bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType2['default'],
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `navExpanded`
	   * boolean value.
	   *
	   * @controllable navExpanded
	   */
	  onToggle: _react2['default'].PropTypes.func,
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _react2['default'].PropTypes.func,
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _react2['default'].PropTypes.bool,
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _react2['default'].PropTypes.bool,
	
	  role: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	
	var childContextTypes = {
	  $bs_navbar: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    expanded: _react.PropTypes.bool,
	    onToggle: _react.PropTypes.func.isRequired,
	    onSelect: _react.PropTypes.func
	  })
	};
	
	var Navbar = function (_React$Component) {
	  (0, _inherits3['default'])(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    (0, _classCallCheck3['default'])(this, Navbar);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleCollapse = _this.handleCollapse.bind(_this);
	    return _this;
	  }
	
	  Navbar.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        expanded = _props.expanded,
	        onSelect = _props.onSelect,
	        collapseOnSelect = _props.collapseOnSelect;
	
	
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction2['default'])(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  Navbar.prototype.handleCollapse = function handleCollapse() {
	    var _props2 = this.props,
	        onToggle = _props2.onToggle,
	        expanded = _props2.expanded;
	
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  Navbar.prototype.handleToggle = function handleToggle() {
	    var _props3 = this.props,
	        onToggle = _props3.onToggle,
	        expanded = _props3.expanded;
	
	
	    onToggle(!expanded);
	  };
	
	  Navbar.prototype.render = function render() {
	    var _extends2;
	
	    var _props4 = this.props,
	        Component = _props4.componentClass,
	        fixedTop = _props4.fixedTop,
	        fixedBottom = _props4.fixedBottom,
	        staticTop = _props4.staticTop,
	        inverse = _props4.inverse,
	        fluid = _props4.fluid,
	        className = _props4.className,
	        children = _props4.children,
	        props = (0, _objectWithoutProperties3['default'])(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        children
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2['default'].Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	
	var UncontrollableNavbar = (0, _uncontrollable2['default'])(Navbar, { expanded: 'onToggle' });
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	
	  Wrapper.propTypes = {
	    componentClass: _elementType2['default'],
	    pullRight: _react2['default'].PropTypes.bool,
	    pullLeft: _react2['default'].PropTypes.bool
	  };
	
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  Wrapper.contextTypes = {
	    $bs_navbar: _react.PropTypes.shape({
	      bsClass: _react.PropTypes.string
	    })
	  };
	
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand2['default'];
	UncontrollableNavbar.Header = _NavbarHeader2['default'];
	UncontrollableNavbar.Toggle = _NavbarToggle2['default'];
	UncontrollableNavbar.Collapse = _NavbarCollapse2['default'];
	
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	// Set bsStyles here so they can be overridden.
	exports['default'] = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	module.exports = exports['default'];

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Collapse = __webpack_require__(335);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    expanded: _react.PropTypes.bool
	  })
	};
	
	var NavbarCollapse = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    (0, _classCallCheck3['default'])(this, NavbarCollapse);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarCollapse.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': navbarProps.expanded }, props),
	      _react2['default'].createElement(
	        'div',
	        { className: bsClassName },
	        children
	      )
	    );
	  };
	
	  return NavbarCollapse;
	}(_react2['default'].Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	
	exports['default'] = NavbarCollapse;
	module.exports = exports['default'];

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _react2['default'].PropTypes.shape({
	    bsClass: _react2['default'].PropTypes.string
	  })
	};
	
	var NavbarHeader = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    (0, _classCallCheck3['default'])(this, NavbarHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }));
	  };
	
	  return NavbarHeader;
	}(_react2['default'].Component);
	
	NavbarHeader.contextTypes = contextTypes;
	
	exports['default'] = NavbarHeader;
	module.exports = exports['default'];

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onClick: _react.PropTypes.func,
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _react.PropTypes.node
	};
	
	var contextTypes = {
	  $bs_navbar: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    expanded: _react.PropTypes.bool,
	    onToggle: _react.PropTypes.func.isRequired
	  })
	};
	
	var NavbarToggle = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    (0, _classCallCheck3['default'])(this, NavbarToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarToggle.prototype.render = function render() {
	    var _props = this.props,
	        onClick = _props.onClick,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onClick', 'className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var buttonProps = (0, _extends3['default'])({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction2['default'])(onClick, navbarProps.onToggle),
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2['default'].createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      buttonProps,
	      _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' })
	    );
	  };
	
	  return NavbarToggle;
	}(_react2['default'].Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	
	exports['default'] = NavbarToggle;
	module.exports = exports['default'];

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__(310);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(91);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(640);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _react2['default'].PropTypes.oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	  * Specify which action or actions trigger Overlay visibility
	  */
	  trigger: _react2['default'].PropTypes.oneOfType([triggerType, _react2['default'].PropTypes.arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _react2['default'].PropTypes.number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _react2['default'].PropTypes.number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _react2['default'].PropTypes.number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _react2['default'].PropTypes.bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _react2['default'].PropTypes.node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _react2['default'].PropTypes.func,
	  /**
	   * @private
	   */
	  onClick: _react2['default'].PropTypes.func,
	  /**
	   * @private
	   */
	  onFocus: _react2['default'].PropTypes.func,
	  /**
	   * @private
	   */
	  onMouseOut: _react2['default'].PropTypes.func,
	  /**
	   * @private
	   */
	  onMouseOver: _react2['default'].PropTypes.func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _react2['default'].PropTypes.oneOf([null]),
	  /**
	  * @private
	  */
	  onHide: _react2['default'].PropTypes.oneOf([null]),
	  /**
	   * @private
	   */
	  show: _react2['default'].PropTypes.oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3['default'])(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3['default'])(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this2 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this2._hoverShowDelay = null;
	      _this2.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this3 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this3._hoverHideDelay = null;
	      _this3.hide();
	    }, delay);
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if (!related || related !== target && !(0, _contains2['default'])(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props,
	        trigger = _props.trigger,
	        overlay = _props.overlay,
	        children = _props.children,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onMouseOut = _props.onMouseOut,
	        onMouseOver = _props.onMouseOver,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2['default'].Children.only(children);
	    var childProps = child.props;
	
	    var triggerProps = {
	      'aria-describedby': overlay.props.id
	    };
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2['default'])(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2['default'])(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2['default'])(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2['default'])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2['default'])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2['default'])(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2['default'])(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2['default'].Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports['default'] = OverlayTrigger;
	module.exports = exports['default'];

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3['default'])(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3['default'])(this, PageHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagerItem = __webpack_require__(641);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _deprecationWarning = __webpack_require__(1358);
	
	var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _deprecationWarning2['default'].wrapper(_PagerItem2['default'], '`<PageItem>`', '`<Pager.Item>`');
	module.exports = exports['default'];

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PagerItem = __webpack_require__(641);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(64);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onSelect: _react2['default'].PropTypes.func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3['default'])(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3['default'])(this, Pager);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2['default'].Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _PaginationButton = __webpack_require__(1341);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  activePage: _react2['default'].PropTypes.number,
	  items: _react2['default'].PropTypes.number,
	  maxButtons: _react2['default'].PropTypes.number,
	
	  /**
	   * When `true`, will display the first and the last button page
	   */
	  boundaryLinks: _react2['default'].PropTypes.bool,
	
	  /**
	   * When `true`, will display the default node value ('&hellip;').
	   * Otherwise, will display provided node (when specified).
	   */
	  ellipsis: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  /**
	   * When `true`, will display the default node value ('&laquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  first: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  /**
	   * When `true`, will display the default node value ('&raquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  last: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  /**
	   * When `true`, will display the default node value ('&lsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  prev: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  /**
	   * When `true`, will display the default node value ('&rsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  next: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * You can use a custom element for the buttons
	   */
	  buttonComponentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  activePage: 1,
	  items: 1,
	  maxButtons: 0,
	  first: false,
	  last: false,
	  prev: false,
	  next: false,
	  ellipsis: true,
	  boundaryLinks: false
	};
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3['default'])(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3['default'])(this, Pagination);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
	    var pageButtons = [];
	
	    var startPage = void 0;
	    var endPage = void 0;
	    var hasHiddenPagesAfter = void 0;
	
	    if (maxButtons) {
	      var hiddenPagesBefore = activePage - parseInt(maxButtons / 2, 10);
	      startPage = Math.max(hiddenPagesBefore, 1);
	      hasHiddenPagesAfter = items >= startPage + maxButtons;
	
	      if (!hasHiddenPagesAfter) {
	        endPage = items;
	        startPage = items - maxButtons + 1;
	        if (startPage < 1) {
	          startPage = 1;
	        }
	      } else {
	        endPage = startPage + maxButtons - 1;
	      }
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var pagenumber = startPage; pagenumber <= endPage; pagenumber++) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: pagenumber,
	          eventKey: pagenumber,
	          active: pagenumber === activePage
	        }),
	        pagenumber
	      ));
	    }
	
	    if (boundaryLinks && ellipsis && startPage !== 1) {
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 'ellipsisFirst',
	          disabled: true,
	          componentClass: buttonProps.componentClass
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'More' },
	          ellipsis === true ? '\u2026' : ellipsis
	        )
	      ));
	
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: 1,
	          eventKey: 1,
	          active: false
	        }),
	        '1'
	      ));
	    }
	
	    if (maxButtons && hasHiddenPagesAfter && ellipsis) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 'ellipsis',
	          disabled: true,
	          componentClass: buttonProps.componentClass
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'More' },
	          ellipsis === true ? '\u2026' : ellipsis
	        )
	      ));
	
	      if (boundaryLinks && endPage !== items) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          (0, _extends3['default'])({}, buttonProps, {
	            key: items,
	            eventKey: items,
	            active: false
	          }),
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  };
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props,
	        activePage = _props.activePage,
	        items = _props.items,
	        maxButtons = _props.maxButtons,
	        boundaryLinks = _props.boundaryLinks,
	        ellipsis = _props.ellipsis,
	        first = _props.first,
	        last = _props.last,
	        prev = _props.prev,
	        next = _props.next,
	        onSelect = _props.onSelect,
	        buttonComponentClass = _props.buttonComponentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var buttonProps = {
	      onSelect: onSelect,
	      componentClass: buttonComponentClass
	    };
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      first && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'First' },
	          first === true ? '\xAB' : first
	        )
	      ),
	      prev && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage - 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Previous' },
	          prev === true ? '\u2039' : prev
	        )
	      ),
	      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
	      next && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage + 1,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Next' },
	          next === true ? '\u203A' : next
	        )
	      ),
	      last && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: items,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Last' },
	          last === true ? '\xBB' : last
	        )
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2['default'].Component);
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pagination', Pagination);
	module.exports = exports['default'];

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _SafeAnchor = __webpack_require__(90);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(46);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should be `<Pagination.Item>`.
	
	// TODO: This should use `componentClass` like other components.
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  className: _react2['default'].PropTypes.string,
	  eventKey: _react2['default'].PropTypes.any,
	  onSelect: _react2['default'].PropTypes.func,
	  disabled: _react2['default'].PropTypes.bool,
	  active: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  componentClass: _SafeAnchor2['default'],
	  active: false,
	  disabled: false
	};
	
	var PaginationButton = function (_React$Component) {
	  (0, _inherits3['default'])(PaginationButton, _React$Component);
	
	  function PaginationButton(props, context) {
	    (0, _classCallCheck3['default'])(this, PaginationButton);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PaginationButton.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  PaginationButton.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    if (Component === _SafeAnchor2['default']) {
	      // Assume that custom components want `eventKey`.
	      delete props.eventKey;
	    }
	
	    delete props.onSelect;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return PaginationButton;
	}(_react2['default'].Component);
	
	PaginationButton.propTypes = propTypes;
	PaginationButton.defaultProps = defaultProps;
	
	exports['default'] = PaginationButton;
	module.exports = exports['default'];

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(143);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Collapse = __webpack_require__(335);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _StyleConfig = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _react2['default'].PropTypes.bool,
	  onSelect: _react2['default'].PropTypes.func,
	  header: _react2['default'].PropTypes.node,
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	  footer: _react2['default'].PropTypes.node,
	  defaultExpanded: _react2['default'].PropTypes.bool,
	  expanded: _react2['default'].PropTypes.bool,
	  eventKey: _react2['default'].PropTypes.any,
	  headerRole: _react2['default'].PropTypes.string,
	  panelRole: _react2['default'].PropTypes.string,
	
	  // From Collapse.
	  onEnter: _react2['default'].PropTypes.func,
	  onEntering: _react2['default'].PropTypes.func,
	  onEntered: _react2['default'].PropTypes.func,
	  onExit: _react2['default'].PropTypes.func,
	  onExiting: _react2['default'].PropTypes.func,
	  onExited: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3['default'])(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3['default'])(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.shouldRenderFill = function shouldRenderFill(child) {
	    return _react2['default'].isValidElement(child) && child.props.fill != null;
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2['default'].isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2['default'].isValidElement(header)) {
	      return _react2['default'].createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2['default'])(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2['default'].createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded,
	        className: expanded ? null : 'collapsed'
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': expanded }, animationHooks),
	      _react2['default'].createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2['default'].createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2['default'].Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2['default'].isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        collapsible = _props.collapsible,
	        header = _props.header,
	        id = _props.id,
	        footer = _props.footer,
	        propsExpanded = _props.expanded,
	        headerRole = _props.headerRole,
	        panelRole = _props.panelRole,
	        className = _props.className,
	        children = _props.children,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2['default'].Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isRequiredForA11y = __webpack_require__(246);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	
	  /**
	   * Title content
	   */
	  title: _react2['default'].PropTypes.node
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3['default'])(Popover, _React$Component);
	
	  function Popover() {
	    (0, _classCallCheck3['default'])(this, Popover);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Popover.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        title = _props.title,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: 'arrow', style: arrowStyle }),
	      title && _react2['default'].createElement(
	        'h3',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
	        title
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
	        children
	      )
	    );
	  };
	
	  return Popover;
	}(_react2['default'].Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('popover', Popover);
	module.exports = exports['default'];

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(143);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _StyleConfig = __webpack_require__(50);
	
	var _ValidComponentChildren = __webpack_require__(64);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2['default'].isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _react.PropTypes.number,
	  now: _react.PropTypes.number,
	  max: _react.PropTypes.number,
	  label: _react.PropTypes.node,
	  srOnly: _react.PropTypes.bool,
	  striped: _react.PropTypes.bool,
	  active: _react.PropTypes.bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _react.PropTypes.bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3['default'])(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3['default'])(this, ProgressBar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutProperties3['default'])(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'progressbar',
	        className: (0, _classnames2['default'])(className, classes),
	        style: (0, _extends4['default'])({ width: getPercentage(now, min, max) + '%' }, style),
	        'aria-valuenow': now,
	        'aria-valuemin': min,
	        'aria-valuemax': max
	      }),
	      srOnly ? _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      ) : label
	    );
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        isChild = _props.isChild,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['isChild']);
	
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutProperties3['default'])(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);
	
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, wrapperProps, {
	        className: (0, _classnames2['default'])(className, 'progress')
	      }),
	      children ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { isChild: true });
	      }) : this.renderProgressBar({
	        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react2['default'].Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ProgressBar));
	module.exports = exports['default'];

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(91);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Radio = function (_React$Component) {
	  (0, _inherits3['default'])(Radio, _React$Component);
	
	  function Radio() {
	    (0, _classCallCheck3['default'])(this, Radio);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	}(_react2['default'].Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('radio', Radio);
	module.exports = exports['default'];

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(91);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should probably take a single `aspectRatio` prop.
	
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _react.PropTypes.element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _react.PropTypes.bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _react.PropTypes.bool
	};
	
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed = function (_React$Component) {
	  (0, _inherits3['default'])(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    (0, _classCallCheck3['default'])(this, ResponsiveEmbed);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        a16by9 = _props.a16by9,
	        a4by3 = _props.a4by3,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['a16by9', 'a4by3', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2['default'])(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning2['default'])(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(classes) },
	      (0, _react.cloneElement)(children, (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	}(_react2['default'].Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	module.exports = exports['default'];

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3['default'])(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3['default'])(this, Row);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react2['default'].Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(180);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(233);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(1349);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _splitComponentProps2 = __webpack_require__(235);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _react2['default'].PropTypes.string,
	  bsSize: _react2['default'].PropTypes.string,
	  href: _react2['default'].PropTypes.string,
	  onClick: _react2['default'].PropTypes.func,
	  /**
	   * The content of the split button.
	   */
	  title: _react2['default'].PropTypes.node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _react2['default'].PropTypes.string,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _react2['default'].PropTypes.node
	});
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3['default'])(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3['default'])(this, SplitButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        toggleLabel = _props.toggleLabel,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Button2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          disabled: props.disabled,
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(_SplitToggle2['default'], {
	        'aria-label': toggleLabel || title,
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	}(_react2['default'].Component);
	
	SplitButton.propTypes = propTypes;
	
	SplitButton.Toggle = _SplitToggle2['default'];
	
	exports['default'] = SplitButton;
	module.exports = exports['default'];

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(630);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SplitToggle = function (_React$Component) {
	  (0, _inherits3['default'])(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    (0, _classCallCheck3['default'])(this, SplitToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2['default'].createElement(_DropdownToggle2['default'], (0, _extends3['default'])({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react2['default'].Component);
	
	SplitToggle.defaultProps = _DropdownToggle2['default'].defaultProps;
	
	exports['default'] = SplitToggle;
	module.exports = exports['default'];

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabContainer = __webpack_require__(338);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(339);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(643);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _TabPane2['default'].propTypes, {
	
	  disabled: _react2['default'].PropTypes.bool,
	
	  title: _react2['default'].PropTypes.node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _react2['default'].PropTypes.string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3['default'])(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3['default'])(this, Tab);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2['default'].createElement(_TabPane2['default'], props);
	  };
	
	  return Tab;
	}(_react2['default'].Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2['default'];
	Tab.Content = _TabContent2['default'];
	Tab.Pane = _TabPane2['default'];
	
	exports['default'] = Tab;
	module.exports = exports['default'];

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  striped: _react2['default'].PropTypes.bool,
	  bordered: _react2['default'].PropTypes.bool,
	  condensed: _react2['default'].PropTypes.bool,
	  hover: _react2['default'].PropTypes.bool,
	  responsive: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3['default'])(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3['default'])(this, Table);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        striped = _props.striped,
	        bordered = _props.bordered,
	        condensed = _props.condensed,
	        hover = _props.hover,
	        responsive = _props.responsive,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2['default'].createElement('table', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2['default'].Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isRequiredForA11y = __webpack_require__(246);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(263);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(637);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(638);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(338);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(339);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _ValidComponentChildren = __webpack_require__(64);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabContainer = _TabContainer2['default'].ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _react2['default'].PropTypes.any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _react2['default'].PropTypes.oneOf(['tabs', 'pills']),
	
	  animation: _react2['default'].PropTypes.bool,
	
	  id: (0, _isRequiredForA11y2['default'])(_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2['default'].forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3['default'])(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3['default'])(this, Tabs);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _NavItem2['default'],
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['id', 'onSelect', 'animation', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2['default'].createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Nav2['default'],
	          (0, _extends3['default'])({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2['default'].map(children, this.renderTab)
	        ),
	        _react2['default'].createElement(
	          _TabContent2['default'],
	          {
	            bsClass: bsClass,
	            animation: animation,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2['default'].Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports['default'] = (0, _uncontrollable2['default'])(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(90);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  src: _react2['default'].PropTypes.string,
	  alt: _react2['default'].PropTypes.string,
	  href: _react2['default'].PropTypes.string
	};
	
	var Thumbnail = function (_React$Component) {
	  (0, _inherits3['default'])(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    (0, _classCallCheck3['default'])(this, Thumbnail);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Thumbnail.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['src', 'alt', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor2['default'] : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement('img', { src: src, alt: alt }),
	      children && _react2['default'].createElement(
	        'div',
	        { className: 'caption' },
	        children
	      )
	    );
	  };
	
	  return Thumbnail;
	}(_react2['default'].Component);
	
	Thumbnail.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isRequiredForA11y = __webpack_require__(246);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3['default'])(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3['default'])(this, Tooltip);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2['default'].Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(17);
	
	var _StyleConfig = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Well = function (_React$Component) {
	  (0, _inherits3['default'])(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3['default'])(this, Well);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Well.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	module.exports = exports['default'];

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _createChainableTypeChecker = __webpack_require__(247);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	var _ValidComponentChildren = __webpack_require__(64);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function requiredRoles() {
	  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	    roles[_key] = arguments[_key];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var missing = void 0;
	
	    roles.every(function (role) {
	      if (!_ValidComponentChildren2['default'].some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var duplicate = void 0;
	
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren2['default'].filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(91);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = void 0;
	
	  if ((typeof oldname === 'undefined' ? 'undefined' : (0, _typeof3['default'])(oldname)) === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning2['default'])(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return function (_Component) {
	    (0, _inherits3['default'])(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      (0, _classCallCheck3['default'])(this, DeprecatedComponent);
	      return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  }(Component);
	};
	
	exports['default'] = deprecationWarning;
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;
	
	var _bootstrapUtils2 = __webpack_require__(17);
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	var _createChainedFunction2 = __webpack_require__(46);
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	var _ValidComponentChildren2 = __webpack_require__(64);
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	exports.bootstrapUtils = _bootstrapUtils;
	exports.createChainedFunction = _createChainedFunction3['default'];
	exports.ValidComponentChildren = _ValidComponentChildren3['default'];

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var linkEl;
	
	function drawIcon(src, num, cb) {
	  var img = document.createElement('img');
	  img.onload = function () {
	    var canvas = document.createElement('canvas');
	    canvas.width = img.width;
	    canvas.height = img.height;
	
	    var context = canvas.getContext('2d');
	    context.clearRect(0, 0, img.width, img.height);
	    context.drawImage(img, 0, 0);
	
	    var top = img.height - 9,
	        left = img.width - 7 - 1,
	        bottom = 16,
	        right = 16,
	        radius = 2;
	
	    context.fillStyle = '#F03D25';
	    context.strokeStyle = '#F03D25';
	    context.lineWidth = 1;
	
	    context.beginPath();
	    context.moveTo(left + radius, top);
	    context.quadraticCurveTo(left, top, left, top + radius);
	    context.lineTo(left, bottom - radius);
	    context.quadraticCurveTo(left, bottom, left + radius, bottom);
	    context.lineTo(right - radius, bottom);
	    context.quadraticCurveTo(right, bottom, right, bottom - radius);
	    context.lineTo(right, top + radius);
	    context.quadraticCurveTo(right, top, right - radius, top);
	    context.closePath();
	    context.fill();
	
	    context.font = 'bold 10px arial';
	    context.fillStyle = '#FFF';
	    context.textAlign = 'right';
	    context.textBaseline = 'top';
	    context.fillText(num, 15, 6);
	
	    cb(null, context.canvas.toDataURL());
	  };
	  img.src = src;
	}
	
	var Favicon = React.createClass({
	  displayName: 'Favicon',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      alertCount: null,
	      animated: true,
	      animationDelay: 500
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      animationIndex: 0,
	      animationLoop: null,
	      animationRunning: false
	    };
	  },
	
	  statics: {
	    mountedInstances: [],
	
	    getActiveInstance: function getActiveInstance() {
	      return Favicon.mountedInstances[Favicon.mountedInstances.length - 1];
	    },
	
	    draw: function draw() {
	      if (typeof document === 'undefined') {
	        return;
	      }if (typeof linkEl === 'undefined') {
	        var head = document.getElementsByTagName('head')[0];
	        linkEl = document.createElement('link');
	        linkEl.type = 'image/x-icon';
	        linkEl.rel = 'icon';
	
	        // remove existing favicons
	        var links = head.getElementsByTagName('link');
	        for (var i = links.length; --i >= 0; /\bicon\b/i.test(links[i].getAttribute('rel')) && head.removeChild(links[i])) {}
	
	        head.appendChild(linkEl);
	      }
	
	      var activeInstance = Favicon.getActiveInstance();
	      var currentUrl;
	
	      if (activeInstance.props.url instanceof Array) {
	        currentUrl = activeInstance.props.url[activeInstance.state.animationIndex];
	      } else {
	        currentUrl = activeInstance.props.url;
	      }
	
	      if (activeInstance.props.alertCount) {
	        drawIcon(currentUrl, activeInstance.props.alertCount, function (err, url) {
	          linkEl.href = url;
	        });
	      } else {
	        linkEl.href = currentUrl;
	      }
	    },
	
	    update: function update() {
	      if (typeof document === 'undefined') {
	        return;
	      }var activeInstance = Favicon.getActiveInstance();
	      var isAnimated = activeInstance.props.url instanceof Array && activeInstance.props.animated;
	
	      // clear any running animations
	      var intervalId = null;
	      clearInterval(activeInstance.state.animationLoop);
	
	      if (isAnimated) {
	        var animateFavicon = function animateFavicon() {
	          var nextAnimationIndex = (activeInstance.state.animationIndex + 1) % activeInstance.props.url.length;
	          Favicon.draw();
	          activeInstance.setState({ animationIndex: nextAnimationIndex });
	        };
	        intervalId = setInterval(animateFavicon, activeInstance.props.animationDelay);
	        animateFavicon();
	      } else {
	        Favicon.draw();
	      }
	
	      activeInstance.setState({ animationLoop: intervalId });
	    }
	  },
	
	  componentWillMount: function componentWillMount() {
	    Favicon.mountedInstances.push(this);
	    Favicon.update();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.url === this.props.url && prevProps.animated === this.props.animated && prevProps.alertCount === this.props.alertCount) {
	      return;
	    }Favicon.update();
	  },
	
	  render: function render() {
	    return null;
	  }
	});
	
	module.exports = Favicon;
	


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _objectWithoutProperties = __webpack_require__(1364)["default"];
	
	var _extends = __webpack_require__(1363)["default"];
	
	var _interopRequireDefault = __webpack_require__(646)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var ReCAPTCHA = _react2["default"].createClass({
	  displayName: "reCAPTCHA",
	  propTypes: {
	    sitekey: _react.PropTypes.string.isRequired,
	    onChange: _react.PropTypes.func.isRequired,
	    grecaptcha: _react.PropTypes.object,
	    theme: _react.PropTypes.oneOf(["dark", "light"]),
	    type: _react.PropTypes.oneOf(["image", "audio"]),
	    tabindex: _react.PropTypes.number,
	    onExpired: _react.PropTypes.func,
	    size: _react.PropTypes.oneOf(["compact", "normal"]),
	    stoken: _react.PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      theme: "light",
	      type: "image",
	      tabindex: 0,
	      size: "normal"
	    };
	  },
	
	  getValue: function getValue() {
	    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
	      return this.props.grecaptcha.getResponse(this.state.widgetId);
	    }
	    return null;
	  },
	
	  reset: function reset() {
	    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
	      this.props.grecaptcha.reset(this.state.widgetId);
	    }
	  },
	
	  handleExpired: function handleExpired() {
	    if (this.props.onExpired) {
	      this.props.onExpired();
	    } else if (this.props.onChange) {
	      this.props.onChange(null);
	    }
	  },
	
	  explicitRender: function explicitRender(cb) {
	    if (this.props.grecaptcha && this.state.widgetId === undefined) {
	      var id = this.props.grecaptcha.render(this.refs.captcha, {
	        sitekey: this.props.sitekey,
	        callback: this.props.onChange,
	        theme: this.props.theme,
	        type: this.props.type,
	        tabindex: this.props.tabindex,
	        "expired-callback": this.handleExpired,
	        size: this.props.size,
	        stoken: this.props.stoken
	      });
	      this.setState({
	        widgetId: id
	      }, cb);
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.explicitRender();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.explicitRender();
	  },
	
	  render: function render() {
	    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
	    /* eslint-disable no-unused-vars */
	    var _props = this.props;
	    var sitekey = _props.sitekey;
	    var onChange = _props.onChange;
	    var theme = _props.theme;
	    var type = _props.type;
	    var tabindex = _props.tabindex;
	    var onExpired = _props.onExpired;
	    var size = _props.size;
	    var stoken = _props.stoken;
	    var grecaptcha = _props.grecaptcha;
	
	    var childProps = _objectWithoutProperties(_props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "size", "stoken", "grecaptcha"]);
	
	    /* eslint-enable no-unused-vars */
	    return _react2["default"].createElement("div", _extends({}, childProps, { ref: "captcha" }));
	  }
	});
	
	exports["default"] = ReCAPTCHA;
	module.exports = exports["default"];

/***/ }),
/* 1362 */
[1944, 1365],
/* 1363 */
[2017, 1362],
/* 1364 */
1268,
/* 1365 */
[2018, 1377, 647],
/* 1366 */
1272,
/* 1367 */
343,
/* 1368 */
[2019, 1366],
/* 1369 */
229,
/* 1370 */
[2020, 1372, 647, 1368],
/* 1371 */
181,
/* 1372 */
109,
/* 1373 */
[2021, 1367],
/* 1374 */
73,
/* 1375 */
[2022, 1374, 1376, 1373, 1371],
/* 1376 */
[2023, 1369],
/* 1377 */
[2024, 1370, 1375],
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSideEffect = __webpack_require__(1480);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(448);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetConstantsJs = __webpack_require__(1379);
	
	var _PlainComponent = __webpack_require__(1380);
	
	var _PlainComponent2 = _interopRequireDefault(_PlainComponent);
	
	var HELMET_ATTRIBUTE = "data-react-helmet";
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = [].concat(_toConsumableArray(propsList)).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var props = _step.value;
	
	            if (props[property]) {
	                return props[property];
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator["return"]) {
	                _iterator["return"]();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return null;
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, "title");
	    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");
	
	    if (innermostTemplate && innermostTitle) {
	        return innermostTemplate.replace(/\%s/g, innermostTitle);
	    }
	
	    return innermostTitle || "";
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(validTags, propsList) {
	    return propsList.filter(function (props) {
	        return !Object.is(typeof props[_HelmetConstantsJs.TAG_NAMES.BASE], "undefined");
	    }).map(function (props) {
	        return props[_HelmetConstantsJs.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = Object.keys(tag)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var attributeKey = _step2.value;
	
	                    var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                    if (validTags.includes(lowerCaseAttributeKey)) {
	                        return innermostBaseTag.concat(tag);
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2["return"]) {
	                        _iterator2["return"]();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, validTags, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = new Map();
	
	    var tagList = propsList.filter(function (props) {
	        return !Object.is(typeof props[tagName], "undefined");
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = new Map();
	
	        instanceTags.filter(function (tag) {
	            var validAttributeKey = undefined;
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	                for (var _iterator3 = Object.keys(tag)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var attributeKey = _step3.value;
	
	                    var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                    // Special rule with link tags, since rel and href are both valid tags, rel takes priority
	                    if (validTags.includes(lowerCaseAttributeKey) && !(Object.is(validAttributeKey, _HelmetConstantsJs.TAG_PROPERTIES.REL) && Object.is(tag[validAttributeKey].toLowerCase(), "canonical")) && !(Object.is(lowerCaseAttributeKey, _HelmetConstantsJs.TAG_PROPERTIES.REL) && Object.is(tag[lowerCaseAttributeKey].toLowerCase(), "stylesheet"))) {
	                        validAttributeKey = lowerCaseAttributeKey;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion3 && _iterator3["return"]) {
	                        _iterator3["return"]();
	                    }
	                } finally {
	                    if (_didIteratorError3) {
	                        throw _iteratorError3;
	                    }
	                }
	            }
	
	            if (!validAttributeKey) {
	                return false;
	            }
	
	            var value = tag[validAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags.has(validAttributeKey)) {
	                approvedSeenTags.set(validAttributeKey, new Set());
	            }
	
	            if (!instanceSeenTags.has(validAttributeKey)) {
	                instanceSeenTags.set(validAttributeKey, new Set());
	            }
	
	            if (!approvedSeenTags.get(validAttributeKey).has(value)) {
	                instanceSeenTags.get(validAttributeKey).add(value);
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	            for (var _iterator4 = instanceSeenTags.keys()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var attributeKey = _step4.value;
	
	                var tagUnion = new Set([].concat(_toConsumableArray(approvedSeenTags.get(attributeKey)), _toConsumableArray(instanceSeenTags.get(attributeKey))));
	
	                approvedSeenTags.set(attributeKey, tagUnion);
	            }
	        } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion4 && _iterator4["return"]) {
	                    _iterator4["return"]();
	                }
	            } finally {
	                if (_didIteratorError4) {
	                    throw _iteratorError4;
	                }
	            }
	        }
	
	        instanceSeenTags.clear();
	        return approvedTags;
	    }, []).reverse();
	
	    return tagList;
	};
	
	var updateTitle = function updateTitle(title) {
	    document.title = title || document.title;
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector("head");
	    var oldTags = [].concat(_toConsumableArray(headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]")));
	    var newTags = [];
	    var indexToDelete = undefined;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    newElement.setAttribute(attribute, tag[attribute]);
	                }
	            }
	
	            newElement.setAttribute(HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title) {
	    var stringifiedMarkup = "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";
	
	    return stringifiedMarkup;
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags) {
	    var stringifiedMarkup = tags.map(function (tag) {
	        var attributeHtml = Object.keys(tag).map(function (attribute) {
	            var encodedValue = encodeSpecialCharacters(tag[attribute]);
	            return attribute + "=\"" + encodedValue + "\"";
	        }).join(" ");
	
	        return "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (Object.is(type, _HelmetConstantsJs.TAG_NAMES.SCRIPT) ? "></" + type + ">" : "/>");
	    }).join("");
	
	    return stringifiedMarkup;
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title) {
	    // assigning into an array to define toString function on it
	    var component = [_react2["default"].createElement(_HelmetConstantsJs.TAG_NAMES.TITLE, _defineProperty({
	        key: title
	    }, HELMET_ATTRIBUTE, true), title)];
	
	    return component;
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    /* eslint-disable react/display-name */
	    var component = [].concat(_toConsumableArray(tags)).map(function (tag, i) {
	        var mappedTag = _defineProperty({
	            key: i
	        }, HELMET_ATTRIBUTE, true);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstantsJs.REACT_TAG_MAP[attribute] || attribute;
	
	            mappedTag[mappedAttribute] = tag[attribute];
	        });
	
	        return _react2["default"].createElement(type, mappedTag);
	    });
	
	    return component;
	    /* eslint-enable react/display-name */
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags) {
	    return {
	        toComponent: type === _HelmetConstantsJs.TAG_NAMES.TITLE ? function () {
	            return generateTitleAsReactComponent(type, tags);
	        } : function () {
	            return generateTagsAsReactComponent(type, tags);
	        },
	        toString: type === _HelmetConstantsJs.TAG_NAMES.TITLE ? function () {
	            return generateTitleAsString(type, tags);
	        } : function () {
	            return generateTagsAsString(type, tags);
	        }
	    };
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var title = _ref.title;
	    var baseTag = _ref.baseTag;
	    var metaTags = _ref.metaTags;
	    var linkTags = _ref.linkTags;
	    var scriptTags = _ref.scriptTags;
	    return {
	        title: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.TITLE, title),
	        base: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.BASE, baseTag),
	        meta: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.META, metaTags),
	        link: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.LINK, linkTags),
	        script: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.SCRIPT, scriptTags)
	    };
	};
	
	var Helmet = function Helmet(Component) {
	    /* eslint-disable react/no-multi-comp */
	
	    var HelmetWrapper = (function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            _get(Object.getPrototypeOf(HelmetWrapper.prototype), "constructor", this).apply(this, arguments);
	        }
	
	        /* eslint-enable react/no-multi-comp */
	
	        _createClass(HelmetWrapper, [{
	            key: "shouldComponentUpdate",
	            value: function shouldComponentUpdate(nextProps) {
	                return !(0, _deepEqual2["default"])(this.props, nextProps);
	            }
	        }, {
	            key: "render",
	            value: function render() {
	                return _react2["default"].createElement(Component, this.props);
	            }
	        }], [{
	            key: "propTypes",
	
	            /**
	             * @param {String} title: "Title"
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {String} titleTemplate: "MySite.com - %s"
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} script: [{"src": "http://mysite.com/js/test.js", "type": "text/javascript"}]
	             */
	            value: {
	                title: _react2["default"].PropTypes.string,
	                onChangeClientState: _react2["default"].PropTypes.func,
	                titleTemplate: _react2["default"].PropTypes.string,
	                base: _react2["default"].PropTypes.object,
	                meta: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object),
	                link: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object),
	                script: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object)
	            },
	            enumerable: true
	        }, {
	            key: "peek",
	            value: Component.peek,
	            enumerable: true
	        }, {
	            key: "rewind",
	            value: function value() {
	                var mappedState = Component.rewind();
	                if (!mappedState) {
	                    // provide fallback if mappedState is undefined
	                    mappedState = mapStateOnServer({
	                        title: "",
	                        baseTag: [],
	                        metaTags: [],
	                        linkTags: [],
	                        scriptTags: []
	                    });
	                }
	
	                return mappedState;
	            },
	            enumerable: true
	        }, {
	            key: "canUseDOM",
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    })(_react2["default"].Component);
	
	    return HelmetWrapper;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        title: getTitleFromPropsList(propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        baseTag: getBaseTagFromPropsList([_HelmetConstantsJs.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.META, [_HelmetConstantsJs.TAG_PROPERTIES.NAME, _HelmetConstantsJs.TAG_PROPERTIES.CHARSET, _HelmetConstantsJs.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstantsJs.TAG_PROPERTIES.PROPERTY], propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.LINK, [_HelmetConstantsJs.TAG_PROPERTIES.REL, _HelmetConstantsJs.TAG_PROPERTIES.HREF], propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.SCRIPT, [_HelmetConstantsJs.TAG_PROPERTIES.SRC], propsList)
	    };
	};
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    var title = newState.title;
	    var baseTag = newState.baseTag;
	    var metaTags = newState.metaTags;
	    var linkTags = newState.linkTags;
	    var scriptTags = newState.scriptTags;
	    var onChangeClientState = newState.onChangeClientState;
	
	    updateTitle(title);
	
	    var tagUpdates = {
	        scriptTags: updateTags(_HelmetConstantsJs.TAG_NAMES.SCRIPT, scriptTags),
	        linkTags: updateTags(_HelmetConstantsJs.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstantsJs.TAG_NAMES.META, metaTags),
	        baseTag: updateTags(_HelmetConstantsJs.TAG_NAMES.BASE, baseTag)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType];
	        var newTags = _tagUpdates$tagType.newTags;
	        var oldTags = _tagUpdates$tagType.oldTags;
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var SideEffect = (0, _reactSideEffect2["default"])(reducePropsToState, handleClientStateChange, mapStateOnServer);
	
	// PlainComponent is used to be a blank component decorated by react-side-effect
	exports["default"] = Helmet(SideEffect(_PlainComponent2["default"]));
	module.exports = exports["default"];

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TAG_NAMES = {
	    TITLE: "title",
	    BASE: "base",
	    META: "meta",
	    LINK: "link",
	    SCRIPT: "script"
	};
	
	exports.TAG_NAMES = TAG_NAMES;
	var TAG_PROPERTIES = {
	    NAME: "name",
	    CHARSET: "charset",
	    HTTPEQUIV: "http-equiv",
	    REL: "rel",
	    HREF: "href",
	    PROPERTY: "property",
	    SRC: "src"
	};
	
	exports.TAG_PROPERTIES = TAG_PROPERTIES;
	var REACT_TAG_MAP = {
	    "charset": "charSet",
	    "http-equiv": "httpEquiv"
	};
	exports.REACT_TAG_MAP = REACT_TAG_MAP;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var PlainComponent = (function (_React$Component) {
	    _inherits(PlainComponent, _React$Component);
	
	    function PlainComponent() {
	        _classCallCheck(this, PlainComponent);
	
	        _get(Object.getPrototypeOf(PlainComponent.prototype), "constructor", this).apply(this, arguments);
	    }
	
	    _createClass(PlainComponent, [{
	        key: "render",
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return PlainComponent;
	})(_react2["default"].Component);
	
	exports["default"] = PlainComponent;
	module.exports = exports["default"];

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(351);
	__webpack_require__(1402);
	module.exports = __webpack_require__(74).Array.from;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1409);
	module.exports = __webpack_require__(74).Array.includes;

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(662);
	__webpack_require__(351);
	__webpack_require__(663);
	__webpack_require__(1404);
	__webpack_require__(1410);
	module.exports = __webpack_require__(74).Map;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1408);
	module.exports = __webpack_require__(74).Object.getOwnPropertySymbols;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1405);
	module.exports = __webpack_require__(74).Object.is;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1406);
	module.exports = __webpack_require__(74).Object.keys;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(662);
	__webpack_require__(351);
	__webpack_require__(663);
	__webpack_require__(1407);
	__webpack_require__(1411);
	module.exports = __webpack_require__(74).Set;

/***/ }),
/* 1388 */
1272,
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(344);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(183)
	  , toLength  = __webpack_require__(350)
	  , toIndex   = __webpack_require__(1401);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(73);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(183)
	  , getNames  = __webpack_require__(73).getNames
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.get = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : getNames(toIObject(it));
	};

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(343);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(343);
	module.exports = Array.isArray || function(arg){
	  return cof(arg) == 'Array';
	};

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(73)
	  , descriptor     = __webpack_require__(348)
	  , setToStringTag = __webpack_require__(240)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(135)(IteratorPrototype, __webpack_require__(75)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(73)
	  , toIObject = __webpack_require__(183);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(98)
	  , core    = __webpack_require__(74)
	  , fails   = __webpack_require__(181);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(109)
	  , $           = __webpack_require__(73)
	  , DESCRIPTORS = __webpack_require__(238)
	  , SPECIES     = __webpack_require__(75)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(349)
	  , defined   = __webpack_require__(237);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(349)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx         = __webpack_require__(236)
	  , $export     = __webpack_require__(98)
	  , toObject    = __webpack_require__(660)
	  , call        = __webpack_require__(654)
	  , isArrayIter = __webpack_require__(653)
	  , toLength    = __webpack_require__(350)
	  , getIterFn   = __webpack_require__(661);
	$export($export.S + $export.F * !__webpack_require__(655)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        result[index] = mapping ? mapfn(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(648)
	  , step             = __webpack_require__(656)
	  , Iterators        = __webpack_require__(182)
	  , toIObject        = __webpack_require__(183);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(346)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(650);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(652)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(98);
	$export($export.S, 'Object', {is: __webpack_require__(1398)});

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(660);
	
	__webpack_require__(1397)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(650);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(652)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var $              = __webpack_require__(73)
	  , global         = __webpack_require__(109)
	  , core           = __webpack_require__(74)
	  , has            = __webpack_require__(239)
	  , DESCRIPTORS    = __webpack_require__(238)
	  , $export        = __webpack_require__(98)
	  , redefine       = __webpack_require__(136)
	  , META           = __webpack_require__(347).KEY
	  , $fails         = __webpack_require__(181)
	  , shared         = __webpack_require__(659)
	  , setToStringTag = __webpack_require__(240)
	  , uid            = __webpack_require__(241)
	  , wks            = __webpack_require__(75)
	  , keyOf          = __webpack_require__(1396)
	  , $names         = __webpack_require__(1392)
	  , enumKeys       = __webpack_require__(1391)
	  , isArray        = __webpack_require__(1394)
	  , anObject       = __webpack_require__(341)
	  , toIObject      = __webpack_require__(183)
	  , createDesc     = __webpack_require__(348)
	  , getDesc        = $.getDesc
	  , setDesc        = $.setDesc
	  , _create        = $.create
	  , getNames       = $names.get
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , setter         = false
	  , HIDDEN         = wks('_hidden')
	  , isEnum         = $.isEnum
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , ObjectProto    = Object.prototype
	  , USE_NATIVE     = typeof $Symbol == 'function';
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(setDesc({}, 'a', {
	    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = getDesc(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  setDesc(it, key, D);
	  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	} : setDesc;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol.prototype);
	  sym._k = tag;
	  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    }
	  });
	  return sym;
	};
	
	var isSymbol = function(it){
	  return typeof it == 'symbol';
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toIObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	};
	var $stringify = function stringify(it){
	  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	  var args = [it]
	    , i    = 1
	    , replacer, $replacer;
	  while(arguments.length > i)args.push(arguments[i++]);
	  replacer = args[1];
	  if(typeof replacer == 'function')$replacer = replacer;
	  if($replacer || !isArray(replacer))replacer = function(key, value){
	    if($replacer)value = $replacer.call(this, key, value);
	    if(!isSymbol(value))return value;
	  };
	  args[1] = replacer;
	  return _stringify.apply($JSON, args);
	};
	var BUGGY_JSON = $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	});
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
	  };
	  redefine($Symbol.prototype, 'toString', function toString(){
	    return this._k;
	  });
	
	  isSymbol = function(it){
	    return it instanceof $Symbol;
	  };
	
	  $.create     = $create;
	  $.isEnum     = $propertyIsEnumerable;
	  $.getDesc    = $getOwnPropertyDescriptor;
	  $.setDesc    = $defineProperty;
	  $.setDescs   = $defineProperties;
	  $.getNames   = $names.get = $getOwnPropertyNames;
	  $.getSymbols = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(657)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	  'species,split,toPrimitive,toStringTag,unscopables'
	).split(','), function(it){
	  var Wrapper = core.Symbol
	    , sym     = wks(it);
	  if(!(it in Wrapper))setDesc(Wrapper, it, {value: USE_NATIVE ? sym : wrap(sym)});
	});
	
	setter = true;
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || BUGGY_JSON), 'JSON', {stringify: $stringify});
	
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(98)
	  , $includes = __webpack_require__(1390)(true);
	
	$export($export.P, 'Array', {
	  // https://github.com/domenic/Array.prototype.includes
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(648)('includes');

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(98);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(651)('Map')});

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(98);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(651)('Set')});

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'UNSAFE_componentWillReceiveProps',
			value: function UNSAFE_componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _store = __webpack_require__(243);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _event_handlers = __webpack_require__(664);
	
	var _keys = __webpack_require__(242);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module componentWrapper
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * componentWrapper
	 *
	 * @access public
	 * @param {object} WrappedComponent React component class to be wrapped
	 * @param {array} [keys] The key(s) bound to the class
	 * @return {object} The higher-order function that wraps the decorated class
	 */
	function componentWrapper(WrappedComponent) {
	  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _keys.ALL_KEYS;
	
	  var KeyBoardHelper = function (_React$Component) {
	    _inherits(KeyBoardHelper, _React$Component);
	
	    function KeyBoardHelper(props) {
	      _classCallCheck(this, KeyBoardHelper);
	
	      var _this = _possibleConstructorReturn(this, (KeyBoardHelper.__proto__ || Object.getPrototypeOf(KeyBoardHelper)).call(this, props));
	
	      _this.state = {
	        event: null
	      };
	      return _this;
	    }
	
	    _createClass(KeyBoardHelper, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        (0, _event_handlers.onMount)(this);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        (0, _event_handlers.onUnmount)(this);
	      }
	    }, {
	      key: 'handleKeyDown',
	      value: function handleKeyDown(event) {
	        var _this2 = this;
	
	        // to simulate a keypress, set the event and then clear it in the callback
	        this.setState({ event: event }, function () {
	          return _this2.setState({ event: null });
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { keydown: this.state }));
	      }
	    }]);
	
	    return KeyBoardHelper;
	  }(_react2.default.Component);
	
	  _store2.default.setBinding({ keys: [].concat(keys), fn: KeyBoardHelper.prototype.handleKeyDown, target: KeyBoardHelper.prototype });
	
	  return KeyBoardHelper;
	}
	
	exports.default = componentWrapper;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.keydownScoped = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * @module decorators
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               */
	
	
	var _class_decorator = __webpack_require__(1413);
	
	var _class_decorator2 = _interopRequireDefault(_class_decorator);
	
	var _method_decorator = __webpack_require__(1415);
	
	var _method_decorator2 = _interopRequireDefault(_method_decorator);
	
	var _method_decorator_scoped = __webpack_require__(1416);
	
	var _method_decorator_scoped2 = _interopRequireDefault(_method_decorator_scoped);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * noopDecorator
	 *
	 * @access private
	 * @return {undefined} Returns `undefined` so that the original undecorated instance/method is used
	 */
	function noopDecorator() {
	  return undefined;
	}
	
	/**
	 * _decorator
	 *
	 * @access private
	 * @param {Function} methodFn The method wrapper to delegate to, based on whether user has specified a scoped decorator or not
	 * @param {Array} ...args Remainder of arguments passed in
	 * @return {Function} The decorated class or method
	 */
	function _decorator(methodFn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  // check the first argument to see if it's a user-supplied keycode or array
	  // of keycodes, or if it's the wrapped class or method
	  var testArg = args[0];
	  var isArray = Array.isArray(testArg);
	
	  // if the test argument is not an object or function, it is user-supplied
	  // keycodes. else there are no arguments and it's just the wrapped class
	  if (isArray || ~['string', 'number', 'symbol'].indexOf(typeof testArg === 'undefined' ? 'undefined' : _typeof(testArg))) {
	    var keys = isArray ? testArg : args;
	
	    // return the decorator function, which on the next call will look for
	    // the presence of a method name to determine if this is a wrapped method
	    // or component
	    return function (target, methodName, descriptor) {
	      return methodName ? methodFn({ target: target, descriptor: descriptor, keys: keys }) : (0, _class_decorator2.default)(target, keys);
	    };
	  } else {
	    var WrappedComponent = args[0];
	    var methodName = args[1];
	
	    // method decorators without keycode (which) arguments are not allowed.
	    if (WrappedComponent && !methodName) {
	      return _class_decorator2.default.apply(undefined, args);
	    } else {
	      console.warn(methodName + ': Method decorators must have keycode arguments, so the decorator for this method will not do anything');
	      return noopDecorator;
	    }
	  }
	}
	
	/**
	 * keydownScoped
	 *
	 * Method decorator that will look for changes to its targeted component's
	 * `keydown` props to decide when to trigger, rather than responding directly
	 * to keydown events. This lets you specify a @keydown decorated class higher
	 * up in the view hierarchy for larger scoping of keydown events, or for
	 * programmatically sending keydown events as props into the components in order
	 * to trigger decorated methods with matching keys.
	 *
	 * @access public
	 * @param {Array} ...args  All (or no) arguments passed in from decoration
	 * @return {Function} The decorated class or method
	 */
	function keydownScoped() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  return _decorator.apply(undefined, [_method_decorator_scoped2.default].concat(args));
	}
	
	/**
	 * keydown
	 *
	 * The main decorator and default export, handles both classes and methods.
	 *
	 * @access public
	 * @param {Array} ...args  All (or no) arguments passed in from decoration
	 * @return {Function} The decorated class or method
	 */
	function keydown() {
	  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  return _decorator.apply(undefined, [_method_decorator2.default].concat(args));
	}
	
	exports.default = keydown;
	exports.keydownScoped = keydownScoped;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * @module methodWrapper
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               */
	
	
	var _store = __webpack_require__(243);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _event_handlers = __webpack_require__(664);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * _isReactKeyDown
	 *
	 * @access private
	 * @param {object} event The possibly synthetic event passed as an argument with
	 * the method invocation.
	 * @return {boolean}
	 */
	function _isReactKeyDown(event) {
	  return event && (typeof event === 'undefined' ? 'undefined' : _typeof(event)) === 'object' && event.nativeEvent instanceof window.KeyboardEvent && event.type === 'keydown';
	}
	
	/**
	 * methodWrapper
	 *
	 * @access public
	 * @param {object} args All arguments necessary for wrapping method
	 * @param {object} args.target The decorated class
	 * @param {object} args.descriptor Method descriptor
	 * @param {array} args.keys The array of keys bound to the given method
	 * @return {object} The method descriptor
	 */
	function methodWrapper(_ref) {
	  var target = _ref.target,
	      descriptor = _ref.descriptor,
	      keys = _ref.keys;
	
	
	  var fn = descriptor.value;
	
	  // if we haven't already created a binding for this class (via another
	  // decorated method), wrap these lifecycle methods.
	  if (!_store2.default.getBinding(target)) {
	    var componentDidMount = target.componentDidMount,
	        componentWillUnmount = target.componentWillUnmount;
	
	
	    target.componentDidMount = function () {
	      (0, _event_handlers.onMount)(this);
	      if (componentDidMount) return componentDidMount.call(this);
	    };
	
	    target.componentWillUnmount = function () {
	      (0, _event_handlers.onUnmount)(this);
	      if (componentWillUnmount) return componentWillUnmount.call(this);
	    };
	  }
	
	  // add this binding of keys and method to the target's bindings
	  _store2.default.setBinding({ keys: keys, target: target, fn: fn });
	
	  descriptor.value = function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var maybeEvent = args[0];
	
	    if (_isReactKeyDown(maybeEvent)) {
	      // proxy method in order to use @keydown as filter for keydown events coming
	      // from an actual onKeyDown binding (as identified by react's addition of
	      // 'nativeEvent' + type === 'keydown')
	      if (!maybeEvent.ctrlKey) {
	        // we already whitelist shortcuts with ctrl modifiers so if we were to
	        // fire it again here the method would trigger twice. see https://github.com/glortho/react-keydown/issues/38
	        return (0, _event_handlers._onKeyDown)(maybeEvent, true);
	      }
	    } else if (!maybeEvent || !(maybeEvent instanceof window.KeyboardEvent) || maybeEvent.type !== 'keydown') {
	      // if our first argument is a keydown event it is being handled by our
	      // binding system. if it's anything else, just pass through.
	      return fn.call.apply(fn, [this].concat(args));
	    }
	  };
	
	  return descriptor;
	}
	
	exports.default = methodWrapper;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _match_keys = __webpack_require__(665);
	
	var _match_keys2 = _interopRequireDefault(_match_keys);
	
	var _parse_keys = __webpack_require__(666);
	
	var _parse_keys2 = _interopRequireDefault(_parse_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * methodWrapperScoped
	 *
	 * @access public
	 * @param {object} args All args necessary for decorating the method
	 * @param {object} args.target The decorated method's class object
	 * @param {object} args.descriptor The method's descriptor object
	 * @param {array} args.keys The key codes bound to the decorated method
	 * @return {object} The method's descriptor object
	 */
	/**
	 * @module methodWrapperScoped
	 *
	 */
	function methodWrapperScoped(_ref) {
	  var target = _ref.target,
	      descriptor = _ref.descriptor,
	      keys = _ref.keys;
	  var componentWillReceiveProps = target.componentWillReceiveProps;
	
	  var fn = descriptor.value;
	  if (!keys) {
	    console.warn(fn + ': keydownScoped requires one or more keys');
	  } else {
	
	    /**
	     * _shouldTrigger
	     *
	     * @access private
	     * @param {object} thisProps Exsting props from the wrapped component
	     * @param {object} thisProps.keydown The namespaced state from the higher-order
	     * component (class_decorator)
	     * @param {object} nextProps The incoming props from the wrapped component
	     * @param {object} nextProps.keydown The namescaped state from the higher-order
	     * component (class_decorator)
	     * @param {array} keys The keys bound to the decorated method
	     * @return {boolean} Whether all tests have passed
	     */
	    var _shouldTrigger = function _shouldTrigger(keydownThis, keydownNext) {
	      if (!(keydownNext && keydownNext.event && !keydownThis.event)) return false;
	
	      return keySets.some(function (keySet) {
	        return (0, _match_keys2.default)({ keySet: keySet, event: keydownNext.event });
	      });
	    };
	
	    // wrap the component's lifecycle method to intercept key codes coming down
	    // from the wrapped/scoped component up the view hierarchy. if new keydown
	    // event has arrived and the key codes match what was specified in the
	    // decorator, call the wrapped method.
	
	
	    var keySets = (0, _parse_keys2.default)(keys);target.componentWillReceiveProps = function (nextProps) {
	      var keydownNext = nextProps.keydown;
	      var keydownThis = this.props.keydown;
	
	
	      if (_shouldTrigger(keydownThis, keydownNext)) {
	        return fn.call(this, keydownNext.event);
	      }
	
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      if (componentWillReceiveProps) return componentWillReceiveProps.call.apply(componentWillReceiveProps, [this, nextProps].concat(args));
	    };
	  }
	
	  return descriptor;
	}
	
	exports.default = methodWrapperScoped;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ALL_PRINTABLE_KEYS = exports.ALL_KEYS = exports.Keys = exports.setBinding = exports.keydownScoped = exports.default = undefined;
	
	var _decorators = __webpack_require__(1414);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_decorators).default;
	  }
	});
	Object.defineProperty(exports, 'keydownScoped', {
	  enumerable: true,
	  get: function get() {
	    return _decorators.keydownScoped;
	  }
	});
	
	var _store = __webpack_require__(243);
	
	Object.defineProperty(exports, 'setBinding', {
	  enumerable: true,
	  get: function get() {
	    return _store.setBinding;
	  }
	});
	
	var _keys = __webpack_require__(242);
	
	Object.defineProperty(exports, 'Keys', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_keys).default;
	  }
	});
	Object.defineProperty(exports, 'ALL_KEYS', {
	  enumerable: true,
	  get: function get() {
	    return _keys.ALL_KEYS;
	  }
	});
	Object.defineProperty(exports, 'ALL_PRINTABLE_KEYS', {
	  enumerable: true,
	  get: function get() {
	    return _keys.ALL_PRINTABLE_KEYS;
	  }
	});
	
	__webpack_require__(1418);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

	'use strict';
	
	// Production steps of ECMA-262, Edition 6, 22.1.2.1
	// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from
	if (!Array.from) {
	  Array.from = function () {
	    var toStr = Object.prototype.toString;
	    var isCallable = function isCallable(fn) {
	      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
	    };
	    var toInteger = function toInteger(value) {
	      var number = Number(value);
	      if (isNaN(number)) {
	        return 0;
	      }
	      if (number === 0 || !isFinite(number)) {
	        return number;
	      }
	      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
	    };
	    var maxSafeInteger = Math.pow(2, 53) - 1;
	    var toLength = function toLength(value) {
	      var len = toInteger(value);
	      return Math.min(Math.max(len, 0), maxSafeInteger);
	    };
	
	    // The length property of the from method is 1.
	    return function from(arrayLike /*, mapFn, thisArg */) {
	      // 1. Let C be the this value.
	      var C = this;
	
	      // 2. Let items be ToObject(arrayLike).
	      var items = Object(arrayLike);
	
	      // 3. ReturnIfAbrupt(items).
	      if (arrayLike == null) {
	        throw new TypeError("Array.from requires an array-like object - not null or undefined");
	      }
	
	      // 4. If mapfn is undefined, then let mapping be false.
	      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
	      var T;
	      if (typeof mapFn !== 'undefined') {
	        // 5. else
	        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
	        if (!isCallable(mapFn)) {
	          throw new TypeError('Array.from: when provided, the second argument must be a function');
	        }
	
	        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
	        if (arguments.length > 2) {
	          T = arguments[2];
	        }
	      }
	
	      // 10. Let lenValue be Get(items, "length").
	      // 11. Let len be ToLength(lenValue).
	      var len = toLength(items.length);
	
	      // 13. If IsConstructor(C) is true, then
	      // 13. a. Let A be the result of calling the [[Construct]] internal method 
	      // of C with an argument list containing the single item len.
	      // 14. a. Else, Let A be ArrayCreate(len).
	      var A = isCallable(C) ? Object(new C(len)) : new Array(len);
	
	      // 16. Let k be 0.
	      var k = 0;
	      // 17. Repeat, while k < len… (also steps a - h)
	      var kValue;
	      while (k < len) {
	        kValue = items[k];
	        if (mapFn) {
	          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
	        } else {
	          A[k] = kValue;
	        }
	        k += 1;
	      }
	      // 18. Let putStatus be Put(A, "length", len, true).
	      A.length = len;
	      // 20. Return A.
	      return A;
	    };
	  }();
	}

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusableSelector = 'a[href], button, input, object, select, textarea, [tabindex]';
	
	/**
	 * bindFocusables: Find any focusable child elements of the component instance and
	 * add an onFocus handler to focus our keydown handlers on the parent component
	 * when user keys applies focus to the element.
	 *
	 * NOTE: One limitation of this right now is that if you tab out of the
	 * component, _focusedInstance will still be set until next click or mount or
	 * controlled focus.
	 *
	 * @access public
	 * @param {object} instance The key-bound component instance
	 * @param {callback} activateOnFocus The fn to fire when element is focused
	 */
	/**
	 * @module domHelpers
	 *
	 */
	function bindFocusables(instance, activateOnFocus) {
	  if (document.querySelectorAll) {
	    var node = _reactDom2.default.findDOMNode(instance);
	    if (node) {
	      var focusables = node.querySelectorAll(focusableSelector);
	      if (focusables.length) {
	        var onFocus = function onFocus(element) {
	          var onFocusPrev = element.onfocus;
	          return function (event) {
	            activateOnFocus(instance);
	            if (onFocusPrev) onFocusPrev.call(element, event);
	          };
	        };
	        Array.prototype.slice.call(focusables).forEach(function (element) {
	          return element.onfocus = onFocus(element);
	        });
	      }
	    }
	  }
	}
	
	/**
	 * findContainerNodes: Called by our click handler to find instances with nodes
	 * that are equal to or that contain the click target. Any that pass this test
	 * will be recipients of the next keydown event.
	 *
	 * @access public
	 * @param {object} target The click event.target DOM element
	 * @return {function} Reducer function
	 */
	function findContainerNodes(target) {
	  return function (memo, instance) {
	    try {
	      var node = _reactDom2.default.findDOMNode(instance);
	      if (node && (node === target || node.contains(target))) {
	        memo.push({ instance: instance, node: node });
	      }
	    } finally {
	      return memo;
	    }
	  };
	}
	
	/**
	 * sortByDOMPosition: Called by our click handler to sort a list of instances
	 * according to least -> most nested. This is so that if multiple keybound
	 * instances have nodes that are ancestors of the click target, they will be
	 * sorted to let the instance closest to the click target get first dibs on the
	 * next key down event.
	 */
	function sortByDOMPosition(a, b) {
	  return a.node.compareDocumentPosition(b.node) === 10 ? 1 : -1;
	}
	
	exports.default = { bindFocusables: bindFocusables, findContainerNodes: findContainerNodes, sortByDOMPosition: sortByDOMPosition };

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @module Listeners
	 *
	 */
	
	// flag for whether click listener has been bound to document
	var _clicksBound = false;
	
	// flag for whether keydown listener has been bound to document
	var _keysBound = false;
	
	var Listeners = {
	  /**
	   * _bindKeys
	   *
	   * @access public
	   */
	  bindKeys: function bindKeys(callback) {
	    if (!_keysBound) {
	      document.addEventListener('keydown', callback);
	      _keysBound = true;
	    }
	  },
	
	
	  /**
	   * unbindKeys
	   *
	   * @access public
	   */
	  unbindKeys: function unbindKeys(callback) {
	    if (_keysBound) {
	      document.removeEventListener('keydown', callback);
	      _keysBound = false;
	    }
	  },
	
	
	  /**
	   * bindClicks
	   *
	   * @access public
	   */
	  bindClicks: function bindClicks(callback) {
	    if (!_clicksBound) {
	      document.addEventListener('click', callback, true);
	      _clicksBound = true;
	    }
	  },
	
	
	  /**
	   * unbindClicks
	   *
	   * @access public
	   */
	  unbindClicks: function unbindClicks(callback) {
	    if (_clicksBound) {
	      document.removeEventListener('click', callback, true);
	      _clicksBound = false;
	    }
	  }
	};
	
	exports.default = Listeners;

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = uuid;
	// Counter being incremented. JS is single-threaded, so it'll Just Work™.
	var __counter = 1;
	
	/**
	 * Returns a process-wide unique identifier.
	 */
	function uuid() {
	  return "uid-" + __counter++;
	}

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var InputMask = __webpack_require__(1134);
	
	var KEYCODE_Z = 90;
	var KEYCODE_Y = 89;
	
	function isUndo(e) {
	  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Y : KEYCODE_Z);
	}
	
	function isRedo(e) {
	  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Z : KEYCODE_Y);
	}
	
	function getSelection(el) {
	  var start, end, rangeEl, clone;
	
	  if (el.selectionStart !== undefined) {
	    start = el.selectionStart;
	    end = el.selectionEnd;
	  } else {
	    try {
	      el.focus();
	      rangeEl = el.createTextRange();
	      clone = rangeEl.duplicate();
	
	      rangeEl.moveToBookmark(document.selection.createRange().getBookmark());
	      clone.setEndPoint('EndToStart', rangeEl);
	
	      start = clone.text.length;
	      end = start + rangeEl.text.length;
	    } catch (e) {/* not focused or not visible */}
	  }
	
	  return { start: start, end: end };
	}
	
	function setSelection(el, selection) {
	  var rangeEl;
	
	  try {
	    if (el.selectionStart !== undefined) {
	      el.focus();
	      el.setSelectionRange(selection.start, selection.end);
	    } else {
	      el.focus();
	      rangeEl = el.createTextRange();
	      rangeEl.collapse(true);
	      rangeEl.moveStart('character', selection.start);
	      rangeEl.moveEnd('character', selection.end - selection.start);
	      rangeEl.select();
	    }
	  } catch (e) {/* not focused or not visible */}
	}
	
	var MaskedInput = React.createClass({
	  displayName: 'MaskedInput',
	
	  propTypes: {
	    mask: React.PropTypes.string.isRequired,
	
	    formatCharacters: React.PropTypes.object,
	    placeholderChar: React.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      value: ''
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    var options = {
	      pattern: this.props.mask,
	      value: this.props.value,
	      formatCharacters: this.props.formatCharacters
	    };
	    if (this.props.placeholderChar) {
	      options.placeholderChar = this.props.placeholderChar;
	    }
	    this.mask = new InputMask(options);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.mask !== nextProps.mask && this.props.value !== nextProps.mask) {
	      // if we get a new value and a new mask at the same time
	      // check if the mask.value is still the initial value
	      // - if so use the nextProps value
	      // - otherwise the `this.mask` has a value for us (most likely from paste action)
	      if (this.mask.getValue() === this.mask.emptyValue) {
	        this.mask.setPattern(nextProps.mask, { value: nextProps.value });
	      } else {
	        this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
	      }
	    } else if (this.props.mask !== nextProps.mask) {
	      this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
	    } else if (this.props.value !== nextProps.value) {
	      this.mask.setValue(nextProps.value);
	    }
	  },
	
	  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
	    if (nextProps.mask !== this.props.mask) {
	      this._updatePattern(nextProps);
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.mask !== this.props.mask && this.mask.selection.start) {
	      this._updateInputSelection();
	    }
	  },
	
	  _updatePattern: function _updatePattern(props) {
	    this.mask.setPattern(props.mask, {
	      value: this.mask.getRawValue(),
	      selection: getSelection(this.input)
	    });
	  },
	
	  _updateMaskSelection: function _updateMaskSelection() {
	    this.mask.selection = getSelection(this.input);
	  },
	
	  _updateInputSelection: function _updateInputSelection() {
	    setSelection(this.input, this.mask.selection);
	  },
	
	  _onChange: function _onChange(e) {
	    // console.log('onChange', JSON.stringify(getSelection(this.input)), e.target.value)
	
	    var maskValue = this.mask.getValue();
	    if (e.target.value !== maskValue) {
	      // Cut or delete operations will have shortened the value
	      if (e.target.value.length < maskValue.length) {
	        var sizeDiff = maskValue.length - e.target.value.length;
	        this._updateMaskSelection();
	        this.mask.selection.end = this.mask.selection.start + sizeDiff;
	        this.mask.backspace();
	      }
	      var value = this._getDisplayValue();
	      e.target.value = value;
	      if (value) {
	        this._updateInputSelection();
	      }
	    }
	    if (this.props.onChange) {
	      this.props.onChange(e);
	    }
	  },
	
	  _onKeyDown: function _onKeyDown(e) {
	    // console.log('onKeyDown', JSON.stringify(getSelection(this.input)), e.key, e.target.value)
	
	    if (isUndo(e)) {
	      e.preventDefault();
	      if (this.mask.undo()) {
	        e.target.value = this._getDisplayValue();
	        this._updateInputSelection();
	        if (this.props.onChange) {
	          this.props.onChange(e);
	        }
	      }
	      return;
	    } else if (isRedo(e)) {
	      e.preventDefault();
	      if (this.mask.redo()) {
	        e.target.value = this._getDisplayValue();
	        this._updateInputSelection();
	        if (this.props.onChange) {
	          this.props.onChange(e);
	        }
	      }
	      return;
	    }
	
	    if (e.key === 'Backspace') {
	      e.preventDefault();
	      this._updateMaskSelection();
	      if (this.mask.backspace()) {
	        var value = this._getDisplayValue();
	        e.target.value = value;
	        if (value) {
	          this._updateInputSelection();
	        }
	        if (this.props.onChange) {
	          this.props.onChange(e);
	        }
	      }
	    }
	  },
	
	  _onKeyPress: function _onKeyPress(e) {
	    // console.log('onKeyPress', JSON.stringify(getSelection(this.input)), e.key, e.target.value)
	
	    // Ignore modified key presses
	    // Ignore enter key to allow form submission
	    if (e.metaKey || e.altKey || e.ctrlKey || e.key === 'Enter') {
	      return;
	    }
	
	    e.preventDefault();
	    this._updateMaskSelection();
	    if (this.mask.input(e.key || e.data)) {
	      e.target.value = this.mask.getValue();
	      this._updateInputSelection();
	      if (this.props.onChange) {
	        this.props.onChange(e);
	      }
	    }
	  },
	
	  _onPaste: function _onPaste(e) {
	    // console.log('onPaste', JSON.stringify(getSelection(this.input)), e.clipboardData.getData('Text'), e.target.value)
	
	    e.preventDefault();
	    this._updateMaskSelection();
	    // getData value needed for IE also works in FF & Chrome
	    if (this.mask.paste(e.clipboardData.getData('Text'))) {
	      e.target.value = this.mask.getValue();
	      // Timeout needed for IE
	      setTimeout(this._updateInputSelection, 0);
	      if (this.props.onChange) {
	        this.props.onChange(e);
	      }
	    }
	  },
	
	  _getDisplayValue: function _getDisplayValue() {
	    var value = this.mask.getValue();
	    return value === this.mask.emptyValue ? '' : value;
	  },
	
	  _keyPressPropName: function _keyPressPropName() {
	    if (typeof navigator !== 'undefined') {
	      return navigator.userAgent.match(/Android/i) ? 'onBeforeInput' : 'onKeyPress';
	    }
	    return 'onKeyPress';
	  },
	
	  _getEventHandlers: function _getEventHandlers() {
	    return _defineProperty({
	      onChange: this._onChange,
	      onKeyDown: this._onKeyDown,
	      onPaste: this._onPaste
	    }, this._keyPressPropName(), this._onKeyPress);
	  },
	
	  focus: function focus() {
	    this.input.focus();
	  },
	
	  blur: function blur() {
	    this.input.blur();
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var ref = function ref(r) {
	      return _this.input = r;
	    };
	    var maxLength = this.mask.pattern.length;
	    var value = this._getDisplayValue();
	    var eventHandlers = this._getEventHandlers();
	    var _props = this.props;
	    var _props$size = _props.size;
	    var size = _props$size === undefined ? maxLength : _props$size;
	    var _props$placeholder = _props.placeholder;
	    var placeholder = _props$placeholder === undefined ? this.mask.emptyValue : _props$placeholder;
	    var _props2 = this.props;
	    var placeholderChar = _props2.placeholderChar;
	    var formatCharacters = _props2.formatCharacters;
	
	    var cleanedProps = _objectWithoutProperties(_props2, ['placeholderChar', 'formatCharacters']);
	
	    var inputProps = _extends({}, cleanedProps, eventHandlers, { ref: ref, maxLength: maxLength, value: value, size: size, placeholder: placeholder });
	    return React.createElement('input', inputProps);
	  }
	});
	
	module.exports = MaskedInput;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * A higher-order-component for handling onClickOutside for React components.
	 */
	(function(root) {
	
	  // administrative
	  var registeredComponents = [];
	  var handlers = [];
	  var IGNORE_CLASS = 'ignore-react-onclickoutside';
	  var DEFAULT_EVENTS = ['mousedown', 'touchstart'];
	
	  /**
	   * Check whether some DOM node is our Component's node.
	   */
	  var isNodeFound = function(current, componentNode, ignoreClass) {
	    if (current === componentNode) {
	      return true;
	    }
	    // SVG <use/> elements do not technically reside in the rendered DOM, so
	    // they do not have classList directly, but they offer a link to their
	    // corresponding element, which can have classList. This extra check is for
	    // that case.
	    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	    if (current.correspondingElement) {
	      return current.correspondingElement.classList.contains(ignoreClass);
	    }
	    return current.classList.contains(ignoreClass);
	  };
	
	  /**
	   * Try to find our node in a hierarchy of nodes, returning the document
	   * node as highest noode if our node is not found in the path up.
	   */
	  var findHighest = function(current, componentNode, ignoreClass) {
	    if (current === componentNode) {
	      return true;
	    }
	
	    // If source=local then this event came from 'somewhere'
	    // inside and should be ignored. We could handle this with
	    // a layered approach, too, but that requires going back to
	    // thinking in terms of Dom node nesting, running counter
	    // to React's 'you shouldn't care about the DOM' philosophy.
	    while(current.parentNode) {
	      if (isNodeFound(current, componentNode, ignoreClass)) {
	        return true;
	      }
	      current = current.parentNode;
	    }
	    return current;
	  };
	
	  /**
	   * Check if the browser scrollbar was clicked
	   */
	  var clickedScrollbar = function(evt) {
	    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	  };
	
	  /**
	   * Generate the event handler that checks whether a clicked DOM node
	   * is inside of, or lives outside of, our Component's node tree.
	   */
	  var generateOutsideCheck = function(componentNode, componentInstance, eventHandler, ignoreClass, excludeScrollbar, preventDefault, stopPropagation) {
	    return function(evt) {
	      if (preventDefault) {
	        evt.preventDefault();
	      }
	      if (stopPropagation) {
	        evt.stopPropagation();
	      }
	      var current = evt.target;
	      if((excludeScrollbar && clickedScrollbar(evt)) || (findHighest(current, componentNode, ignoreClass) !== document)) {
	        return;
	      }
	      eventHandler(evt);
	    };
	  };
	
	  /**
	   * This function generates the HOC function that you'll use
	   * in order to impart onOutsideClick listening to an
	   * arbitrary component. It gets called at the end of the
	   * bootstrapping code to yield an instance of the
	   * onClickOutsideHOC function defined inside setupHOC().
	   */
	  function setupHOC(root, React, ReactDOM, createReactClass) {
	
	    // The actual Component-wrapping HOC:
	    return function onClickOutsideHOC(Component, config) {
	      var wrapComponentWithOnClickOutsideHandling = createReactClass({
	        statics: {
	          /**
	           * Access the wrapped Component's class.
	           */
	          getClass: function() {
	            if (Component.getClass) {
	              return Component.getClass();
	            }
	            return Component;
	          }
	        },
	
	        /**
	         * Access the wrapped Component's instance.
	         */
	        getInstance: function() {
	          return Component.prototype.isReactComponent ? this.refs.instance : this;
	        },
	
	        // this is given meaning in componentDidMount
	        __outsideClickHandler: function() {},
	
	        getDefaultProps: function() {
	          return {
	            excludeScrollbar: config && config.excludeScrollbar
	          };
	        },
	
	        /**
	         * Add click listeners to the current document,
	         * linked to this component's state.
	         */
	        componentDidMount: function() {
	          // If we are in an environment without a DOM such
	          // as shallow rendering or snapshots then we exit
	          // early to prevent any unhandled errors being thrown.
	          if (typeof document === 'undefined' || !document.createElement){
	            return;
	          }
	
	          var instance = this.getInstance();
	          var clickOutsideHandler;
	
	          if(config && typeof config.handleClickOutside === 'function') {
	            clickOutsideHandler = config.handleClickOutside(instance);
	            if(typeof clickOutsideHandler !== 'function') {
	              throw new Error('Component lacks a function for processing outside click events specified by the handleClickOutside config option.');
	            }
	          } else if(typeof instance.handleClickOutside === 'function') {
	            if (React.Component.prototype.isPrototypeOf(instance)) {
	              clickOutsideHandler = instance.handleClickOutside.bind(instance);
	            } else {
	              clickOutsideHandler = instance.handleClickOutside;
	            }
	          } else if(typeof instance.props.handleClickOutside === 'function') {
	            clickOutsideHandler = instance.props.handleClickOutside;
	          } else {
	            throw new Error('Component lacks a handleClickOutside(event) function for processing outside click events.');
	          }
	
	          var componentNode = ReactDOM.findDOMNode(instance);
	          if (componentNode === null) {
	            console.warn('Antipattern warning: there was no DOM node associated with the component that is being wrapped by outsideClick.');
	            console.warn([
	              'This is typically caused by having a component that starts life with a render function that',
	              'returns `null` (due to a state or props value), so that the component \'exist\' in the React',
	              'chain of components, but not in the DOM.\n\nInstead, you need to refactor your code so that the',
	              'decision of whether or not to show your component is handled by the parent, in their render()',
	              'function.\n\nIn code, rather than:\n\n  A{render(){return check? <.../> : null;}\n  B{render(){<A check=... />}\n\nmake sure that you',
	              'use:\n\n  A{render(){return <.../>}\n  B{render(){return <...>{ check ? <A/> : null }<...>}}\n\nThat is:',
	              'the parent is always responsible for deciding whether or not to render any of its children.',
	              'It is not the child\'s responsibility to decide whether a render instruction from above should',
	              'get ignored or not by returning `null`.\n\nWhen any component gets its render() function called,',
	              'that is the signal that it should be rendering its part of the UI. It may in turn decide not to',
	              'render all of *its* children, but it should never return `null` for itself. It is not responsible',
	              'for that decision.'
	            ].join(' '));
	          }
	
	          var fn = this.__outsideClickHandler = generateOutsideCheck(
	            componentNode,
	            instance,
	            clickOutsideHandler,
	            this.props.outsideClickIgnoreClass || IGNORE_CLASS,
	            this.props.excludeScrollbar, // fallback not needed, prop always exists because of getDefaultProps
	            this.props.preventDefault || false,
	            this.props.stopPropagation || false
	          );
	
	          var pos = registeredComponents.length;
	          registeredComponents.push(this);
	          handlers[pos] = fn;
	
	          // If there is a truthy disableOnClickOutside property for this
	          // component, don't immediately start listening for outside events.
	          if (!this.props.disableOnClickOutside) {
	            this.enableOnClickOutside();
	          }
	        },
	
	        /**
	        * Track for disableOnClickOutside props changes and enable/disable click outside
	        */
	        componentWillReceiveProps: function(nextProps) {
	          if (this.props.disableOnClickOutside && !nextProps.disableOnClickOutside) {
	            this.enableOnClickOutside();
	          } else if (!this.props.disableOnClickOutside && nextProps.disableOnClickOutside) {
	            this.disableOnClickOutside();
	          }
	        },
	
	        /**
	         * Remove the document's event listeners
	         */
	        componentWillUnmount: function() {
	          this.disableOnClickOutside();
	          this.__outsideClickHandler = false;
	          var pos = registeredComponents.indexOf(this);
	          if( pos>-1) {
	            // clean up so we don't leak memory
	            if (handlers[pos]) { handlers.splice(pos, 1); }
	            registeredComponents.splice(pos, 1);
	          }
	        },
	
	        /**
	         * Can be called to explicitly enable event listening
	         * for clicks and touches outside of this element.
	         */
	        enableOnClickOutside: function() {
	          var fn = this.__outsideClickHandler;
	          if (typeof document !== 'undefined') {
	            var events = this.props.eventTypes || DEFAULT_EVENTS;
	            if (!events.forEach) {
	              events = [events];
	            }
	            events.forEach(function (eventName) {
	              document.addEventListener(eventName, fn);
	            });
	          }
	        },
	
	        /**
	         * Can be called to explicitly disable event listening
	         * for clicks and touches outside of this element.
	         */
	        disableOnClickOutside: function() {
	          var fn = this.__outsideClickHandler;
	          if (typeof document !== 'undefined') {
	            var events = this.props.eventTypes || DEFAULT_EVENTS;
	            if (!events.forEach) {
	              events = [events];
	            }
	            events.forEach(function (eventName) {
	              document.removeEventListener(eventName, fn);
	            });
	          }
	        },
	
	        /**
	         * Pass-through render
	         */
	        render: function() {
	          var passedProps = this.props;
	          var props = {};
	          Object.keys(this.props).forEach(function(key) {
	            if (key !== 'excludeScrollbar') {
	              props[key] = passedProps[key];
	            }
	          });
	          if (Component.prototype.isReactComponent) {
	            props.ref = 'instance';
	          }
	          props.disableOnClickOutside = this.disableOnClickOutside;
	          props.enableOnClickOutside = this.enableOnClickOutside;
	          return React.createElement(Component, props);
	        }
	      });
	
	      // Add display name for React devtools
	      (function bindWrappedComponentName(c, wrapper) {
	        var componentName = c.displayName || c.name || 'Component';
	        wrapper.displayName = 'OnClickOutside(' + componentName + ')';
	      }(Component, wrapComponentWithOnClickOutsideHandling));
	
	      return wrapComponentWithOnClickOutsideHandling;
	    };
	  }
	
	  /**
	   * This function sets up the library in ways that
	   * work with the various modulde loading solutions
	   * used in JavaScript land today.
	   */
	  function setupBinding(root, factory) {
	    if (true) {
	      // AMD. Register as an anonymous module.
	      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1),__webpack_require__(28),__webpack_require__(1039)], __WEBPACK_AMD_DEFINE_RESULT__ = function(React, ReactDom, createReactClass) {
	        if (!createReactClass) createReactClass = React.createClass;
	        return factory(root, React, ReactDom, createReactClass);
	      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	      // Node. Note that this does not work with strict
	      // CommonJS, but only CommonJS-like environments
	      // that support module.exports
	      module.exports = factory(root, require('react'), require('react-dom'), require('create-react-class'));
	    } else {
	      // Browser globals (root is window)
	      var createReactClass = React.createClass ? React.createClass : window.createReactClass;
	      root.onClickOutside = factory(root, React, ReactDOM, createReactClass);
	    }
	  }
	
	  // Make it all happen
	  setupBinding(root, setupHOC);
	
	}(this));


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(1446);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _componentOrElement = __webpack_require__(355);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Portal = __webpack_require__(667);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalManager = __webpack_require__(1425);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _ownerDocument = __webpack_require__(184);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _addEventListener = __webpack_require__(670);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(1428);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _inDOM = __webpack_require__(158);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _activeElement = __webpack_require__(1431);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(353);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _getContainer = __webpack_require__(352);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	var Modal = _react2.default.createClass({
	  displayName: 'Modal',
	
	
	  propTypes: _extends({}, _Portal2.default.propTypes, {
	
	    /**
	     * Set the visibility of the Modal
	     */
	    show: _react2.default.PropTypes.bool,
	
	    /**
	     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	     *
	     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	     * page content can be placed behind a virtual backdrop as well as a visual one.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	    /**
	     * A callback fired when the Modal is opening.
	     */
	    onShow: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	     *
	     * The `onHide` callback only signals intent from the Modal,
	     * you must actually set the `show` prop to `false` for the Modal to close.
	     */
	    onHide: _react2.default.PropTypes.func,
	
	    /**
	     * Include a backdrop component.
	     */
	    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),
	
	    /**
	     * A function that returns a backdrop component. Useful for custom
	     * backdrop rendering.
	     *
	     * ```js
	     *  renderBackdrop={props => <MyBackdrop {...props} />}
	     * ```
	     */
	    renderBackdrop: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	     */
	    onEscapeKeyUp: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the backdrop, if specified, is clicked.
	     */
	    onBackdropClick: _react2.default.PropTypes.func,
	
	    /**
	     * A style object for the backdrop component.
	     */
	    backdropStyle: _react2.default.PropTypes.object,
	
	    /**
	     * A css class or classes for the backdrop component.
	     */
	    backdropClassName: _react2.default.PropTypes.string,
	
	    /**
	     * A css class or set of classes applied to the modal container when the modal is open,
	     * and removed when it is closed.
	     */
	    containerClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2.default.PropTypes.bool,
	
	    /**
	     * A `<Transition/>` component to use for the dialog and backdrop components.
	     */
	    transition: _elementType2.default,
	
	    /**
	     * The `timeout` of the dialog transition if specified. This number is used to ensure that
	     * transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    dialogTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * The `timeout` of the backdrop transition if specified. This number is used to
	     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    backdropTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and
	     * replace it to the last focused element when it closes. This also
	     * works correctly with any Modal children that have the `autoFocus` prop.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    autoFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    enforceFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will restore focus to previously focused element once
	     * modal is hidden
	     */
	    restoreFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2.default.PropTypes.func,
	
	    /**
	     * A ModalManager instance used to track and manage the state of open
	     * Modals. Useful when customizing how modals interact within a container
	     */
	    manager: _react2.default.PropTypes.object.isRequired
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    var noop = function noop() {};
	
	    return {
	      show: false,
	      backdrop: true,
	      keyboard: true,
	      autoFocus: true,
	      enforceFocus: true,
	      restoreFocus: true,
	      onHide: noop,
	      manager: modalManager,
	      renderBackdrop: function renderBackdrop(props) {
	        return _react2.default.createElement('div', props);
	      }
	    };
	  },
	  omitProps: function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  },
	  getInitialState: function getInitialState() {
	    return { exited: !this.props.show };
	  },
	  render: function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: 'modal',
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        dialog
	      )
	    );
	  },
	  renderBackdrop: function renderBackdrop() {
	    var _this = this;
	
	    var _props2 = this.props,
	        backdropStyle = _props2.backdropStyle,
	        backdropClassName = _props2.backdropClassName,
	        renderBackdrop = _props2.renderBackdrop,
	        Transition = _props2.transition,
	        backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this.backdrop = ref;
	    };
	
	    var backdrop = _react2.default.createElement('div', {
	      ref: backdropRef,
	      style: this.props.backdropStyle,
	      className: this.props.backdropClassName,
	      onClick: this.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': this.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        renderBackdrop({
	          ref: backdropRef,
	          style: backdropStyle,
	          className: backdropClassName,
	          onClick: this.handleBackdropClick
	        })
	      );
	    }
	
	    return backdrop;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this.onShow();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _props3 = this.props,
	        show = _props3.show,
	        transition = _props3.transition;
	
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  },
	  onShow: function onShow() {
	    var doc = (0, _ownerDocument2.default)(this);
	    var container = (0, _getContainer2.default)(this.props.container, doc.body);
	
	    this.props.manager.add(this, container, this.props.containerClassName);
	
	    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	
	    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);
	
	    this.focus();
	
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  onHide: function onHide() {
	    this.props.manager.remove(this);
	
	    this._onDocumentKeyupListener.remove();
	
	    this._onFocusinListener.remove();
	
	    if (this.props.restoreFocus) {
	      this.restoreLastFocus();
	    }
	  },
	  setMountNode: function setMountNode(ref) {
	    this.mountNode = ref ? ref.getMountNode() : ref;
	  },
	  handleHidden: function handleHidden() {
	    this.setState({ exited: true });
	    this.onHide();
	
	    if (this.props.onExited) {
	      var _props4;
	
	      (_props4 = this.props).onExited.apply(_props4, arguments);
	    }
	  },
	  handleBackdropClick: function handleBackdropClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (this.props.onBackdropClick) {
	      this.props.onBackdropClick(e);
	    }
	
	    if (this.props.backdrop === true) {
	      this.props.onHide();
	    }
	  },
	  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
	    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
	      if (this.props.onEscapeKeyUp) {
	        this.props.onEscapeKeyUp(e);
	      }
	      this.props.onHide();
	    }
	  },
	  checkForFocus: function checkForFocus() {
	    if (_inDOM2.default) {
	      this.lastFocus = (0, _activeElement2.default)();
	    }
	  },
	  focus: function focus() {
	    var autoFocus = this.props.autoFocus;
	    var modalContent = this.getDialogElement();
	    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var focusInModal = current && (0, _contains2.default)(modalContent, current);
	
	    if (modalContent && autoFocus && !focusInModal) {
	      this.lastFocus = current;
	
	      if (!modalContent.hasAttribute('tabIndex')) {
	        modalContent.setAttribute('tabIndex', -1);
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
	      }
	
	      modalContent.focus();
	    }
	  },
	  restoreLastFocus: function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  },
	  enforceFocus: function enforceFocus() {
	    var enforceFocus = this.props.enforceFocus;
	
	
	    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
	      return;
	    }
	
	    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var modal = this.getDialogElement();
	
	    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
	      modal.focus();
	    }
	  },
	
	
	  //instead of a ref, which might conflict with one the parent applied.
	  getDialogElement: function getDialogElement() {
	    var node = this.refs.modal;
	    return node && node.lastChild;
	  },
	  isTopModal: function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  }
	});
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__(354);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _class = __webpack_require__(1433);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _scrollbarSize = __webpack_require__(1445);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(671);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(1430);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function () {
	  function ModalManager() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	        _ref2$handleContainer = _ref2.handleContainerOverflow,
	        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	    _classCallCheck(this, ModalManager);
	
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	  }
	
	  _createClass(ModalManager, [{
	    key: 'add',
	    value: function add(modal, container, className) {
	      var modalIdx = this.modals.indexOf(modal);
	      var containerIdx = this.containers.indexOf(container);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal);
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	      }
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        //right now only the first modal of a container will have its classes applied
	        classes: className ? className.split(/\s+/) : [],
	
	        overflowing: (0, _isOverflowing2.default)(container)
	      };
	
	      if (this.handleContainerOverflow) {
	        setContainerStyle(data, container);
	      }
	
	      data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	      this.containers.push(container);
	      this.data.push(data);
	
	      return modalIdx;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return;
	      }
	
	      var containerIdx = findContainer(this.data, modal);
	      var data = this.data[containerIdx];
	      var container = this.containers[containerIdx];
	
	      data.modals.splice(data.modals.indexOf(modal), 1);
	
	      this.modals.splice(modalIdx, 1);
	
	      // if that was the last modal in a container,
	      // clean up the container
	      if (data.modals.length === 0) {
	        data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	        if (this.handleContainerOverflow) {
	          removeContainerStyle(data, container);
	        }
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	        }
	        this.containers.splice(containerIdx, 1);
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        //otherwise make sure the next top modal is visible to a SR
	        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	      }
	    }
	  }, {
	    key: 'isTopModal',
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	
	  return ModalManager;
	}();
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(667);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(1427);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(668);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _elementType = __webpack_require__(34);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show) {
	        this.setState({ exited: false });
	      } else if (!nextProps.transition) {
	        // Otherwise let handleHidden take care of marking exited.
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          container = _props.container,
	          containerPadding = _props.containerPadding,
	          target = _props.target,
	          placement = _props.placement,
	          shouldUpdatePosition = _props.shouldUpdatePosition,
	          rootClose = _props.rootClose,
	          children = _props.children,
	          Transition = _props.transition,
	          props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	      // Don't un-render the overlay while it's transitioning out.
	
	
	      var mountOverlay = props.show || Transition && !this.state.exited;
	      if (!mountOverlay) {
	        // Don't bother showing anything if we don't have to.
	        return null;
	      }
	
	      var child = children;
	
	      // Position is be inner-most because it adds inline styles into the child,
	      // which the other wrappers don't forward correctly.
	      child = _react2.default.createElement(
	        _Position2.default,
	        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	        child
	      );
	
	      if (Transition) {
	        var onExit = props.onExit,
	            onExiting = props.onExiting,
	            onEnter = props.onEnter,
	            onEntering = props.onEntering,
	            onEntered = props.onEntered;
	
	        // This animates the child node by injecting props, so it must precede
	        // anything that adds a wrapping div.
	
	        child = _react2.default.createElement(
	          Transition,
	          {
	            'in': props.show,
	            transitionAppear: true,
	            onExit: onExit,
	            onExiting: onExiting,
	            onExited: this.onHiddenListener,
	            onEnter: onEnter,
	            onEntering: onEntering,
	            onEntered: onEntered
	          },
	          child
	        );
	      }
	
	      // This goes after everything else because it adds a wrapping div.
	      if (rootClose) {
	        child = _react2.default.createElement(
	          _RootCloseWrapper2.default,
	          { onRootClose: props.onHide },
	          child
	        );
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { container: container },
	        child
	      );
	    }
	  }, {
	    key: 'handleHidden',
	    value: function handleHidden() {
	      this.setState({ exited: true });
	
	      if (this.props.onExited) {
	        var _props2;
	
	        (_props2 = this.props).onExited.apply(_props2, arguments);
	      }
	    }
	  }]);
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2.default.PropTypes.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _react2.default.PropTypes.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _react2.default.PropTypes.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2.default.PropTypes.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(355);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _calculatePosition = __webpack_require__(1429);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(352);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(184);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  _createClass(Position, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updatePosition(this.getTarget());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this._needsFlush = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this._needsFlush) {
	        this._needsFlush = false;
	        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var _state = this.state,
	          positionLeft = _state.positionLeft,
	          positionTop = _state.positionTop,
	          arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	      // These should not be forwarded to the child.
	
	
	      delete props.target;
	      delete props.container;
	      delete props.containerPadding;
	      delete props.shouldUpdatePosition;
	
	      var child = _react2.default.Children.only(children);
	      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	        // and `props.style`.
	        positionLeft: positionLeft,
	        positionTop: positionTop,
	        className: (0, _classnames2.default)(className, child.props.className),
	        style: _extends({}, child.props.style, {
	          left: positionLeft,
	          top: positionTop
	        })
	      }));
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget() {
	      var target = this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    }
	  }, {
	    key: 'maybeUpdatePosition',
	    value: function maybeUpdatePosition(placementChanged) {
	      var target = this.getTarget();
	
	      if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      this.updatePosition(target);
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(target) {
	      this._lastTarget = target;
	
	      if (!target) {
	        this.setState({
	          positionLeft: 0,
	          positionTop: 0,
	          arrowOffsetLeft: null,
	          arrowOffsetTop: null
	        });
	
	        return;
	      }
	
	      var overlay = _reactDom2.default.findDOMNode(this);
	      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	    }
	  }]);
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _react2.default.PropTypes.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _react2.default.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _react2.default.PropTypes.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(674);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(1437);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(675);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(184);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = activeElement;
	
	var _ownerDocument = __webpack_require__(185);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function activeElement() {
	  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();
	
	  try {
	    return doc.activeElement;
	  } catch (e) {/* ie throws if no active element */}
	}
	module.exports = exports['default'];

/***/ }),
/* 1432 */
[2025, 672],
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasClass = exports.removeClass = exports.addClass = undefined;
	
	var _addClass = __webpack_require__(1432);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(1434);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _hasClass = __webpack_require__(672);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.addClass = _addClass2.default;
	exports.removeClass = _removeClass2.default;
	exports.hasClass = _hasClass2.default;
	exports.default = { addClass: _addClass2.default, removeClass: _removeClass2.default, hasClass: _hasClass2.default };

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	};

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(158);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var off = function off() {};
	if (_inDOM2.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	exports.default = off;
	module.exports = exports['default'];

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = offsetParent;
	
	var _ownerDocument = __webpack_require__(185);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _style = __webpack_require__(354);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument2.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style2.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	module.exports = exports['default'];

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = position;
	
	var _offset = __webpack_require__(674);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _offsetParent = __webpack_require__(1436);
	
	var _offsetParent2 = _interopRequireDefault(_offsetParent);
	
	var _scrollTop = __webpack_require__(675);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _scrollLeft = __webpack_require__(1438);
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _style = __webpack_require__(354);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = { top: 0, left: 0 },
	      offset;
	
	  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	  if ((0, _style2.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent2.default)(node);
	    offset = (0, _offset2.default)(node);
	
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2.default)(offsetParent);
	
	    parentOffset.top += parseInt((0, _style2.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style2.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2.default)(offsetParent) || 0;
	  }
	
	  // Subtract parent offsets and node margins
	  return _extends({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style2.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style2.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(244);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	module.exports = exports['default'];

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = __webpack_require__(677);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _camelizeStyle2.default)(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeStyle;
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	module.exports = exports['default'];

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	module.exports = exports["default"];

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	module.exports = exports["default"];

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenate;
	
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	module.exports = exports['default'];

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateStyleName;
	
	var _hyphenate = __webpack_require__(1443);
	
	var _hyphenate2 = _interopRequireDefault(_hyphenate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var msPattern = /^ms-/; /**
	                         * Copyright 2013-2014, Facebook, Inc.
	                         * All rights reserved.
	                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	                         */
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
	}
	module.exports = exports['default'];

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (recalc) {
	  if (!size || recalc) {
	    if (_inDOM2.default) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};
	
	var _inDOM = __webpack_require__(158);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = void 0;
	
	module.exports = exports['default'];

/***/ }),
/* 1446 */
83,
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(678);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(679);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(678);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(1449);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(1450);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(679);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(325);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(1133);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(381);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LinkContainer = __webpack_require__(680);
	
	var _LinkContainer2 = _interopRequireDefault(_LinkContainer);
	
	var IndexLinkContainer = (function (_React$Component) {
	  _inherits(IndexLinkContainer, _React$Component);
	
	  function IndexLinkContainer() {
	    _classCallCheck(this, IndexLinkContainer);
	
	    _get(Object.getPrototypeOf(IndexLinkContainer.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(IndexLinkContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(_LinkContainer2['default'], _extends({}, this.props, { onlyActiveOnIndex: true }));
	    }
	  }]);
	
	  return IndexLinkContainer;
	})(_react2['default'].Component);
	
	exports['default'] = IndexLinkContainer;
	module.exports = exports['default'];

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(682);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(683);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _PropTypes = __webpack_require__(137);
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _PropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? _routerWarning2['default'](false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : undefined;
	    this.history = this.context.history;
	  }
	
	};
	
	exports['default'] = History;
	module.exports = exports['default'];

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(684);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2['default'].createClass({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2['default'].createElement(_Link2['default'], _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	
	});
	
	exports['default'] = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(685);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _PropTypes = __webpack_require__(137);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	var IndexRedirect = _react2['default'].createClass({
	  displayName: 'IndexRedirect',
	
	  statics: {
	
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2['default'].createRouteFromReactElement(element);
	      } else {
	         false ? _routerWarning2['default'](false, 'An <IndexRedirect> does not make sense at the root of your route config') : undefined;
	      }
	    }
	
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _PropTypes.falsy,
	    children: _PropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? _invariant2['default'](false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : _invariant2['default'](false) : undefined;
	  }
	
	});
	
	exports['default'] = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(110);
	
	var _PropTypes = __webpack_require__(137);
	
	var func = _react2['default'].PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	var IndexRoute = _react2['default'].createClass({
	  displayName: 'IndexRoute',
	
	  statics: {
	
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _RouteUtils.createRouteFromReactElement(element);
	      } else {
	         false ? _routerWarning2['default'](false, 'An <IndexRoute> does not make sense at the root of your route config') : undefined;
	      }
	    }
	
	  },
	
	  propTypes: {
	    path: _PropTypes.falsy,
	    component: _PropTypes.component,
	    components: _PropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? _invariant2['default'](false, '<IndexRoute> elements are for router configuration only and should not be rendered') : _invariant2['default'](false) : undefined;
	  }
	
	});
	
	exports['default'] = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var object = _react2['default'].PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? _routerWarning2['default'](false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : undefined;
	    !this.routerWillLeave ?  false ? _invariant2['default'](false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : _invariant2['default'](false) : undefined;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? _invariant2['default'](false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : _invariant2['default'](false) : undefined;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	
	};
	
	exports['default'] = Lifecycle;
	module.exports = exports['default'];

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(110);
	
	var _PropTypes = __webpack_require__(137);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	var Route = _react2['default'].createClass({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _PropTypes.component,
	    components: _PropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? _invariant2['default'](false, '<Route> elements are for router configuration only and should not be rendered') : _invariant2['default'](false) : undefined;
	  }
	
	});
	
	exports['default'] = Route;
	module.exports = exports['default'];

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var object = _react2['default'].PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? _routerWarning2['default'](false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : undefined;
	  }
	
	};
	
	exports['default'] = RouteContext;
	module.exports = exports['default'];

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _historyLibCreateHashHistory = __webpack_require__(459);
	
	var _historyLibCreateHashHistory2 = _interopRequireDefault(_historyLibCreateHashHistory);
	
	var _historyLibUseQueries = __webpack_require__(219);
	
	var _historyLibUseQueries2 = _interopRequireDefault(_historyLibUseQueries);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(357);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _PropTypes = __webpack_require__(137);
	
	var _RouterContext = __webpack_require__(248);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(110);
	
	var _RouterUtils = __webpack_require__(686);
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = _react2['default'].createClass({
	  displayName: 'Router',
	
	  propTypes: {
	    history: object,
	    children: _PropTypes.routes,
	    routes: _PropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2['default'].createElement(_RouterContext2['default'], props);
	      }
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? _routerWarning2['default'](!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : undefined;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = _createTransitionManager2['default'](history, _RouteUtils.createRoutes(routes || children));
	    var router = _RouterUtils.createRouterObject(history, transitionManager);
	    var routingHistory = _RouterUtils.createRoutingHistory(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	    var createHistory = undefined;
	    if (history) {
	       false ? _routerWarning2['default'](false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : undefined;
	      createHistory = function () {
	        return history;
	      };
	    } else {
	       false ? _routerWarning2['default'](false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : undefined;
	      createHistory = _historyLibCreateHashHistory2['default'];
	    }
	
	    return _historyLibUseQueries2['default'](createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? _routerWarning2['default'](nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : undefined;
	
	     false ? _routerWarning2['default']((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : undefined;
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	
	});
	
	exports['default'] = Router;
	module.exports = exports['default'];

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(248);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var RoutingContext = _react2['default'].createClass({
	  displayName: 'RoutingContext',
	
	  componentWillMount: function componentWillMount() {
	     false ? _routerWarning2['default'](false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : undefined;
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(_RouterContext2['default'], this.props);
	  }
	});
	
	exports['default'] = RoutingContext;
	module.exports = exports['default'];

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _AsyncUtils = __webpack_require__(356);
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function createEnterHook(hook, route) {
	  return function (a, b, callback) {
	    hook.apply(route, arguments);
	
	    if (hook.length < 3) {
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createEnterHook(route.onEnter, route));
	
	    return hooks;
	  }, []);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	
	  if (!hooks.length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = undefined;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? _routerWarning2['default'](false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : undefined;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  _AsyncUtils.loopAsync(hooks.length, function (index, next, done) {
	    hooks[index](nextState, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	          next();
	        }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	
	function runLeaveHooks(routes) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i]);
	  }
	}

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _historyLibCreateBrowserHistory = __webpack_require__(1130);
	
	var _historyLibCreateBrowserHistory2 = _interopRequireDefault(_historyLibCreateBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(688);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	exports['default'] = _createRouterHistory2['default'](_historyLibCreateBrowserHistory2['default']);
	module.exports = exports['default'];

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(159);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = _PatternUtils.getParamNames(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = undefined,
	      enterRoutes = undefined;
	  if (prevRoutes) {
	    leaveRoutes = prevRoutes.filter(function (route) {
	      return nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = nextRoutes.filter(function (route) {
	      return prevRoutes.indexOf(route) === -1 || leaveRoutes.indexOf(route) !== -1;
	    });
	  } else {
	    leaveRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports['default'] = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(356);
	
	function getComponentsForRoute(location, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	  } else if (route.getComponent) {
	    route.getComponent(location, callback);
	  } else if (route.getComponents) {
	    route.getComponents(location, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  _AsyncUtils.mapAsync(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState.location, route, callback);
	  }, callback);
	}
	
	exports['default'] = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(159);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  var paramNames = _PatternUtils.getParamNames(route.path);
	
	  for (var p in params) {
	    if (params.hasOwnProperty(p) && paramNames.indexOf(p) !== -1) routeParams[p] = params[p];
	  }return routeParams;
	}
	
	exports['default'] = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _historyLibCreateHashHistory = __webpack_require__(459);
	
	var _historyLibCreateHashHistory2 = _interopRequireDefault(_historyLibCreateHashHistory);
	
	var _createRouterHistory = __webpack_require__(688);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	exports['default'] = _createRouterHistory2['default'](_historyLibCreateHashHistory2['default']);
	module.exports = exports['default'];

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isActive;
	
	var _PatternUtils = __webpack_require__(159);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if (typeof a === 'object') {
	    for (var p in a) {
	      if (!a.hasOwnProperty(p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!b.hasOwnProperty(p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	function paramsAreActive(paramNames, paramValues, activeParams) {
	  // FIXME: This doesn't work on repeated params in activeParams.
	  return paramNames.every(function (paramName, index) {
	    return String(paramValues[index]) === String(activeParams[paramName]);
	  });
	}
	
	function getMatchingRouteIndex(pathname, activeRoutes, activeParams) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  for (var i = 0, len = activeRoutes.length; i < len; ++i) {
	    var route = activeRoutes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null) {
	      var matched = _PatternUtils.matchPattern(pattern, remainingPathname);
	      remainingPathname = matched.remainingPathname;
	      paramNames = [].concat(paramNames, matched.paramNames);
	      paramValues = [].concat(paramValues, matched.paramValues);
	    }
	
	    if (remainingPathname === '' && route.path && paramsAreActive(paramNames, paramValues, activeParams)) return i;
	  }
	
	  return null;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes
	 * and params.
	 */
	function routeIsActive(pathname, routes, params, indexOnly) {
	  var i = getMatchingRouteIndex(pathname, routes, params);
	
	  if (i === null) {
	    // No match.
	    return false;
	  } else if (!indexOnly) {
	    // Any match is good enough.
	    return true;
	  }
	
	  // If any remaining routes past the match index have paths, then we can't
	  // be on the index route.
	  return routes.slice(i + 1).every(function (route) {
	    return !route.path;
	  });
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  if (!routeIsActive(pathname, routes, params, indexOnly)) return false;
	
	  return queryIsActive(query, currentLocation.query);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(687);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(357);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(110);
	
	var _RouterUtils = __webpack_require__(686);
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? _invariant2['default'](false, 'match needs a history or a location') : _invariant2['default'](false) : undefined;
	
	  history = history ? history : _createMemoryHistory2['default'](options);
	  var transitionManager = _createTransitionManager2['default'](history, _RouteUtils.createRoutes(routes));
	
	  var unlisten = undefined;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = _RouterUtils.createRouterObject(history, transitionManager);
	  history = _RouterUtils.createRoutingHistory(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation, nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports['default'] = match;
	module.exports = exports['default'];

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _AsyncUtils = __webpack_require__(356);
	
	var _PatternUtils = __webpack_require__(159);
	
	var _RouteUtils = __webpack_require__(110);
	
	function getChildRoutes(route, location, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = undefined;
	
	  route.getChildRoutes(location, function (error, childRoutes) {
	    childRoutes = !error && _RouteUtils.createRoutes(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    route.getIndexRoute(location, function (error, indexRoute) {
	      callback(error, !error && _RouteUtils.createRoutes(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (obj) {
	        return !obj.hasOwnProperty('path');
	      });
	
	      _AsyncUtils.loopAsync(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  if (remainingPathname !== null) {
	    var matched = _PatternUtils.matchPattern(pattern, remainingPathname);
	    remainingPathname = matched.remainingPathname;
	    paramNames = [].concat(paramNames, matched.paramNames);
	    paramValues = [].concat(paramValues, matched.paramValues);
	
	    if (remainingPathname === '' && route.path) {
	      var _ret2 = (function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? _routerWarning2['default'](indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : undefined;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? _routerWarning2['default'](!indexRoute.path, 'Index routes should not have paths') : undefined;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	        return {
	          v: undefined
	        };
	      })();
	
	      if (typeof _ret2 === 'object') return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback) {
	  var remainingPathname = arguments.length <= 3 || arguments[3] === undefined ? location.pathname : arguments[3];
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	  return (function () {
	    _AsyncUtils.loopAsync(routes.length, function (index, next, done) {
	      matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	        if (error || match) {
	          done(error, match);
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  })();
	}
	
	exports['default'] = matchRoutes;
	module.exports = exports['default'];

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _historyLibUseQueries = __webpack_require__(219);
	
	var _historyLibUseQueries2 = _interopRequireDefault(_historyLibUseQueries);
	
	var _createTransitionManager = __webpack_require__(357);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(51);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? _routerWarning2['default'](false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : undefined;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = _historyLibUseQueries2['default'](createHistory)(options);
	    var transitionManager = _createTransitionManager2['default'](history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports['default'] = useRoutes;
	module.exports = exports['default'];

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(691), __webpack_require__(27), __webpack_require__(358), __webpack_require__(359), __webpack_require__(1475)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('./SAlertContent'), require('prop-types'), require('./s-alert-parts/s-alert-store'), require('./s-alert-parts/s-alert-tools'), require('./s-alert-parts/s-alert-data-prep'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.SAlertContent, global.propTypes, global.sAlertStore, global.sAlertTools, global.sAlertDataPrep);
	        global.SAlert = mod.exports;
	    }
	})(this, function (exports, _react, _SAlertContent, _propTypes, _sAlertStore, _sAlertTools, _sAlertDataPrep) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _SAlertContent2 = _interopRequireDefault(_SAlertContent);
	
	    var _propTypes2 = _interopRequireDefault(_propTypes);
	
	    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);
	
	    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);
	
	    var _sAlertDataPrep2 = _interopRequireDefault(_sAlertDataPrep);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var _extends = Object.assign || function (target) {
	        for (var i = 1; i < arguments.length; i++) {
	            var source = arguments[i];
	
	            for (var key in source) {
	                if (Object.prototype.hasOwnProperty.call(source, key)) {
	                    target[key] = source[key];
	                }
	            }
	        }
	
	        return target;
	    };
	
	    var insertFunc = function insertFunc(msg, data, condition) {
	        var id = _sAlertTools2.default.randomId();
	        _sAlertStore2.default.dispatch({
	            type: 'INSERT',
	            data: _extends({}, data, {
	                id: id,
	                condition: condition,
	                message: msg
	            })
	        });
	        return id;
	    };
	
	    var SAlert = function (_React$Component) {
	        _inherits(SAlert, _React$Component);
	
	        function SAlert(props) {
	            _classCallCheck(this, SAlert);
	
	            var _this = _possibleConstructorReturn(this, (SAlert.__proto__ || Object.getPrototypeOf(SAlert)).call(this, props));
	
	            _this.state = {
	                dataRight: [],
	                dataLeft: [],
	                dataTop: [],
	                dataBottom: []
	            };
	            return _this;
	        }
	
	        _createClass(SAlert, [{
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                var _this2 = this;
	
	                var storeStateLeft = void 0;
	                var storeStateRight = void 0;
	                var storeStateTop = void 0;
	                var storeStateBottom = void 0;
	
	                var addToStoreRight = function addToStoreRight() {
	                    requestAnimationFrame(function () {
	                        return requestAnimationFrame(function () {
	                            var length = void 0;
	                            storeStateRight = (0, _sAlertDataPrep2.default)('right') || [];
	                            length = storeStateRight.length;
	                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
	                                var id = storeStateRight[0].id;
	                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
	                                storeStateRight = (0, _sAlertDataPrep2.default)('right') || [];
	                            }
	                            _this2.setState({ dataRight: storeStateRight });
	                        });
	                    });
	                };
	                this.unsubStoreRight = _sAlertStore2.default.subscribe(addToStoreRight);
	
	                var addToStoreLeft = function addToStoreLeft() {
	                    requestAnimationFrame(function () {
	                        return requestAnimationFrame(function () {
	                            var length = void 0;
	                            storeStateLeft = (0, _sAlertDataPrep2.default)('left') || [];
	                            length = storeStateLeft.length;
	                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
	                                var id = storeStateLeft[0].id;
	                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
	                                storeStateLeft = (0, _sAlertDataPrep2.default)('left') || [];
	                            }
	                            _this2.setState({ dataLeft: storeStateLeft });
	                        });
	                    });
	                };
	                this.unsubStoreLeft = _sAlertStore2.default.subscribe(addToStoreLeft);
	
	                var addToStoreTop = function addToStoreTop() {
	                    requestAnimationFrame(function () {
	                        return requestAnimationFrame(function () {
	                            var length = void 0;
	                            storeStateTop = (0, _sAlertDataPrep2.default)('full-top') || [];
	                            length = storeStateTop.length;
	                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
	                                var id = storeStateTop[0].id;
	                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
	                                storeStateTop = (0, _sAlertDataPrep2.default)('full-top') || [];
	                            }
	                            _this2.setState({ dataTop: storeStateTop });
	                        });
	                    });
	                };
	                this.unsubStoreTop = _sAlertStore2.default.subscribe(addToStoreTop);
	
	                var addToStoreBottom = function addToStoreBottom() {
	                    requestAnimationFrame(function () {
	                        return requestAnimationFrame(function () {
	                            var length = void 0;
	                            storeStateBottom = (0, _sAlertDataPrep2.default)('full-bottom') || [];
	                            length = storeStateBottom.length;
	                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
	                                var id = storeStateBottom[0].id;
	                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
	                                storeStateBottom = (0, _sAlertDataPrep2.default)('full-bottom') || [];
	                            }
	                            _this2.setState({ dataBottom: storeStateBottom });
	                        });
	                    });
	                };
	                this.unsubStoreBottom = _sAlertStore2.default.subscribe(addToStoreBottom);
	
	                // set up global config from global SAlert props
	                // only stuff needed for getAlertData
	                var globalConfig = {
	                    contentTemplate: this.props.contentTemplate,
	                    offset: this.props.offset,
	                    message: this.props.message,
	                    stack: this.props.stack,
	                    html: this.props.html,
	                    customFields: this.props.customFields,
	                    position: this.props.position || 'top-right'
	                };
	                _sAlertTools2.default.setGlobalConfig(globalConfig);
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                this.unsubStoreTop();
	                this.unsubStoreBottom();
	                this.unsubStoreLeft();
	                this.unsubStoreRight();
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _this3 = this;
	
	                var mapFunc = function mapFunc(alert, index) {
	                    var customKey = 'alert-key-' + alert.id + '-' + alert.position;
	                    var id = alert.id;
	                    var condition = _sAlertTools2.default.returnFirstDefined(alert.condition, 'info');
	                    var message = _sAlertTools2.default.returnFirstDefined(alert.message, _this3.props.message, '');
	                    var position = _sAlertTools2.default.returnFirstDefined(alert.position, _this3.props.position, 'top-right');
	                    var offset = _sAlertTools2.default.returnFirstDefined(alert.offset, _this3.props.offset, 0);
	                    var effect = _sAlertTools2.default.returnFirstDefined(alert.effect, _this3.props.effect);
	                    var boxPosition = alert.boxPosition;
	                    var beep = _sAlertTools2.default.returnFirstDefined(alert.beep, _this3.props.beep, false);
	                    var timeout = _sAlertTools2.default.returnFirstDefined(alert.timeout, _this3.props.timeout, 5000);
	                    var html = _sAlertTools2.default.returnFirstDefined(alert.html, _this3.props.html);
	                    var onClose = _sAlertTools2.default.returnFirstDefined(alert.onClose, _this3.props.onClose);
	                    var onShow = _sAlertTools2.default.returnFirstDefined(alert.onShow, _this3.props.onShow);
	                    var customFields = _sAlertTools2.default.returnFirstDefined(alert.customFields, _this3.props.customFields);
	                    var contentTemplate = _this3.props.contentTemplate;
	                    return _react2.default.createElement(_SAlertContent2.default, {
	                        key: customKey,
	                        id: id,
	                        customFields: customFields,
	                        condition: condition,
	                        message: message,
	                        position: position,
	                        effect: effect,
	                        boxPosition: boxPosition,
	                        beep: beep,
	                        timeout: timeout,
	                        html: html,
	                        onClose: onClose,
	                        onShow: onShow,
	                        contentTemplate: contentTemplate });
	                };
	                var sAlertElemsRight = this.state.dataRight.map(mapFunc);
	                var sAlertElemsLeft = this.state.dataLeft.map(mapFunc);
	                var sAlertElemsTop = this.state.dataTop.map(mapFunc);
	                var sAlertElemsBottom = this.state.dataBottom.map(mapFunc);
	                return _react2.default.createElement(
	                    'div',
	                    { className: 's-alert-wrapper' },
	                    sAlertElemsRight,
	                    sAlertElemsLeft,
	                    sAlertElemsTop,
	                    sAlertElemsBottom
	                );
	            }
	        }], [{
	            key: 'info',
	            value: function info(msg, data) {
	                return insertFunc(msg, data, 'info');
	            }
	        }, {
	            key: 'error',
	            value: function error(msg, data) {
	                return insertFunc(msg, data, 'error');
	            }
	        }, {
	            key: 'warning',
	            value: function warning(msg, data) {
	                return insertFunc(msg, data, 'warning');
	            }
	        }, {
	            key: 'success',
	            value: function success(msg, data) {
	                return insertFunc(msg, data, 'success');
	            }
	        }, {
	            key: 'close',
	            value: function close(id) {
	                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
	            }
	        }, {
	            key: 'closeAll',
	            value: function closeAll() {
	                _sAlertStore2.default.dispatch({ type: 'REMOVEALL' });
	            }
	        }]);
	
	        return SAlert;
	    }(_react2.default.Component);
	
	    SAlert.propTypes = {
	        message: _propTypes2.default.string,
	        position: _propTypes2.default.string,
	        offset: _propTypes2.default.number,
	        stack: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	        effect: _propTypes2.default.string,
	        beep: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]),
	        timeout: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none']), _propTypes2.default.number]),
	        html: _propTypes2.default.bool,
	        onClose: _propTypes2.default.func,
	        onShow: _propTypes2.default.func,
	        customFields: _propTypes2.default.object,
	        contentTemplate: _propTypes2.default.func
	    };
	
	    exports.default = SAlert;
	});

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(27)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('prop-types'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.propTypes);
	        global.SAlertContentTmpl = mod.exports;
	    }
	})(this, function (exports, _react, _propTypes) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _propTypes2 = _interopRequireDefault(_propTypes);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var SAlertContentTmpl = function (_React$Component) {
	        _inherits(SAlertContentTmpl, _React$Component);
	
	        function SAlertContentTmpl(props) {
	            _classCallCheck(this, SAlertContentTmpl);
	
	            return _possibleConstructorReturn(this, (SAlertContentTmpl.__proto__ || Object.getPrototypeOf(SAlertContentTmpl)).call(this, props));
	        }
	
	        _createClass(SAlertContentTmpl, [{
	            key: 'render',
	            value: function render() {
	                return _react2.default.createElement(
	                    'div',
	                    { className: this.props.classNames, id: this.props.id, style: this.props.styles },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 's-alert-box-inner' },
	                        this.props.message
	                    ),
	                    _react2.default.createElement('span', { className: 's-alert-close', onClick: this.props.handleClose })
	                );
	            }
	        }]);
	
	        return SAlertContentTmpl;
	    }(_react2.default.Component);
	
	    SAlertContentTmpl.propTypes = {
	        id: _propTypes2.default.string.isRequired,
	        classNames: _propTypes2.default.string.isRequired,
	        styles: _propTypes2.default.object.isRequired,
	        message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	        handleClose: _propTypes2.default.func.isRequired,
	        customFields: _propTypes2.default.object
	    };
	
	    exports.default = SAlertContentTmpl;
	});

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(28), __webpack_require__(691), __webpack_require__(358), __webpack_require__(359)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(exports, require('react'), require('react-dom'), require('../SAlertContent'), require('./s-alert-store'), require('./s-alert-tools'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod.exports, global.react, global.reactDom, global.SAlertContent, global.sAlertStore, global.sAlertTools);
	        global.sAlertDataPrep = mod.exports;
	    }
	})(this, function (exports, _react, _reactDom, _SAlertContent, _sAlertStore, _sAlertTools) {
	    'use strict';
	
	    Object.defineProperty(exports, "__esModule", {
	        value: true
	    });
	
	    var _react2 = _interopRequireDefault(_react);
	
	    var _reactDom2 = _interopRequireDefault(_reactDom);
	
	    var _SAlertContent2 = _interopRequireDefault(_SAlertContent);
	
	    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);
	
	    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _extends = Object.assign || function (target) {
	        for (var i = 1; i < arguments.length; i++) {
	            var source = arguments[i];
	
	            for (var key in source) {
	                if (Object.prototype.hasOwnProperty.call(source, key)) {
	                    target[key] = source[key];
	                }
	            }
	        }
	
	        return target;
	    };
	
	    var getAlertData = function getAlertData(sAlertPosition) {
	        var positionTop = 0;
	        var positionBottom = 0;
	        var padding = 0;
	        var alerts = {};
	        var style = void 0;
	        var docElement = void 0;
	        var sAlertBoxHeight = void 0;
	        var positionTypeTop = void 0;
	        var positionTypeBottom = void 0;
	        var checkFirst = function checkFirst(type, objId) {
	            var collectionOfType = sAlertCollection.filter(function (obj) {
	                return obj.position === type || sAlertGlobalConfig.position === type;
	            });
	            return collectionOfType && collectionOfType[0].id === objId;
	        };
	        var positionFunc = function positionFunc(position, positionType, alert, docElement, sAlertBoxHeight, reactComponent) {
	            padding = aStack.spacing || parseInt(getComputedStyle(_reactDom2.default.findDOMNode(reactComponent))[positionType]);
	            if (checkFirst(aPosition, alert.id) && aOffset) {
	                position = 0;
	                position = position + parseInt(aOffset);
	            }
	            if (checkFirst(aPosition, alert.id) && aStack.spacing) {
	                position = position;
	            } else {
	                position = position + parseInt(padding);
	            }
	            style = positionType + ': ' + position + 'px;';
	            position = position + sAlertBoxHeight;
	            return position;
	        };
	
	        var sAlertGlobalConfig = _sAlertTools2.default.getGlobalConfig();
	        var aStack = void 0;
	        var aContentTemplate = void 0;
	        var aOffset = void 0;
	        var aMessage = void 0;
	        var aHtml = void 0;
	        var aCustomFields = void 0;
	        var aPosition = void 0;
	
	        var query = {};
	        if (sAlertPosition === 'left') {
	            query = function query(item) {
	                return item.position === 'top-left' || item.position === 'bottom-left' || !item.position && (sAlertGlobalConfig.position === 'top-left' || sAlertGlobalConfig.position === 'bottom-left');
	            };
	        }
	        if (sAlertPosition === 'right') {
	            query = function query(item) {
	                return item.position === 'top-right' || item.position === 'bottom-right' || !item.position && (sAlertGlobalConfig.position === 'top-right' || sAlertGlobalConfig.position === 'bottom-right');
	            };
	        }
	        if (sAlertPosition === 'full-top') {
	            query = function query(item) {
	                return item.position === 'top' || !item.position && sAlertGlobalConfig.position === 'top';
	            };
	        }
	        if (sAlertPosition === 'full-bottom') {
	            query = function query(item) {
	                return item.position === 'bottom' || !item.position && sAlertGlobalConfig.position === 'bottom';
	            };
	        }
	
	        var currentState = _sAlertStore2.default.getState();
	        var sAlertCollection = currentState.slice().filter(query);
	
	        return sAlertCollection.map(function (alert) {
	            aStack = sAlertGlobalConfig.stack;
	            aContentTemplate = sAlertGlobalConfig.contentTemplate;
	            aOffset = _sAlertTools2.default.returnFirstDefined(alert.offset, sAlertGlobalConfig.offset);
	            aMessage = _sAlertTools2.default.returnFirstDefined(alert.message, sAlertGlobalConfig.message);
	            aHtml = _sAlertTools2.default.returnFirstDefined(alert.html, sAlertGlobalConfig.html);
	            aCustomFields = _sAlertTools2.default.returnFirstDefined(alert.customFields, sAlertGlobalConfig.customFields);
	            aPosition = _sAlertTools2.default.returnFirstDefined(alert.position, sAlertGlobalConfig.position);
	            positionTypeTop = aPosition && /top/g.test(aPosition);
	            positionTypeBottom = aPosition && /bottom/g.test(aPosition);
	            if (aStack) {
	                // checking alert box height - needed to calculate position
	                docElement = document.createElement('div');
	                docElement.classList.add('s-alert-box-height');
	
	                // mock element, needed for positions calculations
	                var reactElement = _react2.default.createElement(_SAlertContent2.default, {
	                    key: _sAlertTools2.default.randomId(),
	                    id: _sAlertTools2.default.randomId(),
	                    condition: alert.condition,
	                    message: aMessage,
	                    position: aPosition,
	                    effect: alert.effect,
	                    boxPosition: alert.boxPosition,
	                    beep: false,
	                    timeout: 'none',
	                    html: aHtml,
	                    contentTemplate: aContentTemplate,
	                    customFields: aCustomFields
	                });
	                var reactComponent = _reactDom2.default.render(reactElement, docElement);
	
	                document.body.appendChild(docElement);
	                sAlertBoxHeight = parseInt(getComputedStyle(_reactDom2.default.findDOMNode(reactComponent))['height']);
	                if (positionTypeTop) {
	                    positionTop = positionFunc(positionTop, 'top', alert, docElement, sAlertBoxHeight, reactComponent);
	                }
	                if (positionTypeBottom) {
	                    positionBottom = positionFunc(positionBottom, 'bottom', alert, docElement, sAlertBoxHeight, reactComponent);
	                }
	                var sAlertComputedStyle = getComputedStyle(_reactDom2.default.findDOMNode(reactComponent));
	                if (sAlertPosition === 'left') {
	                    style = style + 'left: ' + (aStack.spacing || parseInt(sAlertComputedStyle.left)) + 'px;';
	                }
	                if (sAlertPosition === 'right') {
	                    style = style + 'right: ' + (aStack.spacing || parseInt(sAlertComputedStyle.right)) + 'px;';
	                }
	                alerts = _extends({}, alert, { boxPosition: style });
	                _reactDom2.default.unmountComponentAtNode(docElement);
	                docElement.parentNode.removeChild(docElement);
	            } else if (aOffset && positionTypeTop) {
	                alerts = _extends({}, alert, { boxPosition: 'top: ' + parseInt(aOffset) + 'px;' });
	            } else if (aOffset && positionTypeBottom) {
	                alerts = _extends({}, alert, { boxPosition: 'bottom: ' + parseInt(aOffset) + 'px;' });
	            } else {
	                alerts = alert;
	            }
	            return alerts;
	        });
	    };
	
	    exports.default = getAlertData;
	});

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(692);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(693);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(249);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(249);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(692);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(1476);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(693);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(695);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(694);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(361);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(696);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(697);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(360);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fbjsLibExecutionEnvironment = __webpack_require__(1481);
	
	var _fbjsLibExecutionEnvironment2 = _interopRequireDefault(_fbjsLibExecutionEnvironment);
	
	var _fbjsLibShallowEqual = __webpack_require__(1482);
	
	var _fbjsLibShallowEqual2 = _interopRequireDefault(_fbjsLibShallowEqual);
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = undefined;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = (function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        _Component.apply(this, arguments);
	      }
	
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may ony call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !_fbjsLibShallowEqual2['default'](nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2['default'].createElement(WrappedComponent, this.props);
	      };
	
	      _createClass(SideEffect, null, [{
	        key: 'displayName',
	
	        // Try to use displayName of wrapped component
	        value: 'SideEffect(' + getDisplayName(WrappedComponent) + ')',
	
	        // Expose canUseDOM so tests can monkeypatch it
	        enumerable: true
	      }, {
	        key: 'canUseDOM',
	        value: _fbjsLibExecutionEnvironment2['default'].canUseDOM,
	        enumerable: true
	      }]);
	
	      return SideEffect;
	    })(_react.Component);
	
	    return SideEffect;
	  };
	};

/***/ }),
/* 1481 */
52,
/* 1482 */
736,
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(1485);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(1487);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(1489);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(1488);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(28);
	
	var _PropTypes = __webpack_require__(701);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(778);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(1490);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(1491);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 1485 */
[2025, 1486],
/* 1486 */
672,
/* 1487 */
1434,
/* 1488 */
[2026, 700],
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(700);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf = void 0;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM2.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	exports.default = compatRaf;
	module.exports = exports['default'];

/***/ }),
/* 1490 */
83,
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isEqual = __webpack_require__(485);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _youtubePlayer = __webpack_require__(1938);
	
	var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Check whether a `props` change should result in the video being updated.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	function shouldUpdateVideo(prevProps, props) {
	  // A changing video should always trigger an update
	  if (prevProps.videoId !== props.videoId) {
	    return true;
	  }
	
	  // Otherwise, a change in the start/end time playerVars also requires a player
	  // update.
	  var prevVars = prevProps.opts.playerVars || {};
	  var vars = props.opts.playerVars || {};
	
	  return prevVars.start !== vars.start || prevVars.end !== vars.end;
	}
	
	/**
	 * Neutralise API options that only require a video update, leaving only options
	 * that require a player reset. The results can then be compared to see if a
	 * player reset is necessary.
	 *
	 * @param {Object} opts
	 */
	function filterResetOptions(opts) {
	  return _extends({}, opts, {
	    playerVars: _extends({}, opts.playerVars, {
	      autoplay: 0,
	      start: 0,
	      end: 0
	    })
	  });
	}
	
	/**
	 * Check whether a `props` change should result in the player being reset.
	 * The player is reset when the `props.opts` change, except if the only change
	 * is in the `start` and `end` playerVars, because a video update can deal with
	 * those.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	function shouldResetPlayer(prevProps, props) {
	  return !(0, _isEqual2.default)(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
	}
	
	/**
	 * Check whether a props change should result in an id or className update.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	function shouldUpdatePlayer(prevProps, props) {
	  return prevProps.id === props.id || prevProps.className === props.className;
	}
	
	var YouTube = function (_React$Component) {
	  _inherits(YouTube, _React$Component);
	
	  function YouTube(props) {
	    _classCallCheck(this, YouTube);
	
	    var _this = _possibleConstructorReturn(this, (YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call(this, props));
	
	    _this.onPlayerReady = function (event) {
	      return _this.props.onReady(event);
	    };
	
	    _this.onPlayerError = function (event) {
	      return _this.props.onError(event);
	    };
	
	    _this.onPlayerStateChange = function (event) {
	      _this.props.onStateChange(event);
	      switch (event.data) {
	
	        case YouTube.PlayerState.ENDED:
	          _this.props.onEnd(event);
	          break;
	
	        case YouTube.PlayerState.PLAYING:
	          _this.props.onPlay(event);
	          break;
	
	        case YouTube.PlayerState.PAUSED:
	          _this.props.onPause(event);
	          break;
	
	        default:
	          return;
	      }
	    };
	
	    _this.onPlayerPlaybackRateChange = function (event) {
	      return _this.props.onPlaybackRateChange(event);
	    };
	
	    _this.onPlayerPlaybackQualityChange = function (event) {
	      return _this.props.onPlaybackQualityChange(event);
	    };
	
	    _this.createPlayer = function () {
	      // do not attempt to create a player server-side, it won't work
	      if (typeof document === 'undefined') return;
	      // create player
	      var playerOpts = _extends({}, _this.props.opts, {
	        // preload the `videoId` video if one is already given
	        videoId: _this.props.videoId
	      });
	      _this.internalPlayer = (0, _youtubePlayer2.default)(_this.container, playerOpts);
	      // attach event handlers
	      _this.internalPlayer.on('ready', _this.onPlayerReady);
	      _this.internalPlayer.on('error', _this.onPlayerError);
	      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);
	      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);
	      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
	    };
	
	    _this.resetPlayer = function () {
	      return _this.internalPlayer.destroy().then(_this.createPlayer);
	    };
	
	    _this.updatePlayer = function () {
	      _this.internalPlayer.getIframe().then(function (iframe) {
	        iframe.setAttribute('id', _this.props.id);
	        iframe.setAttribute('class', _this.props.className);
	      });
	    };
	
	    _this.updateVideo = function () {
	      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
	        _this.internalPlayer.stopVideo();
	        return;
	      }
	
	      // set queueing options
	      var autoplay = false;
	      var opts = {
	        videoId: _this.props.videoId
	      };
	      if ('playerVars' in _this.props.opts) {
	        autoplay = _this.props.opts.playerVars.autoplay === 1;
	        if ('start' in _this.props.opts.playerVars) {
	          opts.startSeconds = _this.props.opts.playerVars.start;
	        }
	        if ('end' in _this.props.opts.playerVars) {
	          opts.endSeconds = _this.props.opts.playerVars.end;
	        }
	      }
	
	      // if autoplay is enabled loadVideoById
	      if (autoplay) {
	        _this.internalPlayer.loadVideoById(opts);
	        return;
	      }
	      // default behaviour just cues the video
	      _this.internalPlayer.cueVideoById(opts);
	    };
	
	    _this.refContainer = function (container) {
	      _this.container = container;
	    };
	
	    _this.container = null;
	    _this.internalPlayer = null;
	    return _this;
	  }
	
	  /**
	    * Expose PlayerState constants for convenience. These constants can also be
	    * accessed through the global YT object after the YouTube IFrame API is instantiated.
	    * https://developers.google.com/youtube/iframe_api_reference#onStateChange
	    */
	
	
	  _createClass(YouTube, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.createPlayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (shouldUpdatePlayer(prevProps, this.props)) {
	        this.updatePlayer();
	      }
	
	      if (shouldResetPlayer(prevProps, this.props)) {
	        this.resetPlayer();
	      }
	
	      if (shouldUpdateVideo(prevProps, this.props)) {
	        this.updateVideo();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      /**
	       * Note: The `youtube-player` package that is used promisifies all Youtube
	       * Player API calls, which introduces a delay of a tick before it actually
	       * gets destroyed. Since React attempts to remove the element instantly
	       * this method isn't quick enough to reset the container element.
	       */
	      this.internalPlayer.destroy();
	    }
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onReady
	     *
	     * @param {Object} event
	     *   @param {Object} target - player object
	     */
	
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onError
	     *
	     * @param {Object} event
	     *   @param {Integer} data  - error type
	     *   @param {Object} target - player object
	     */
	
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onStateChange
	     *
	     * @param {Object} event
	     *   @param {Integer} data  - status change type
	     *   @param {Object} target - actual YT player
	     */
	
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackRateChange
	     *
	     * @param {Object} event
	     *   @param {Float} data    - playback rate
	     *   @param {Object} target - actual YT player
	     */
	
	
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackQualityChange
	     *
	     * @param {Object} event
	     *   @param {String} data   - playback quality
	     *   @param {Object} target - actual YT player
	     */
	
	
	    /**
	     * Initialize the Youtube Player API on the container and attach event handlers
	     */
	
	
	    /**
	     * Shorthand for destroying and then re-creating the Youtube Player
	     */
	
	
	    /**
	     * Method to update the id and class of the Youtube Player iframe.
	     * React should update this automatically but since the Youtube Player API
	     * replaced the DIV that is mounted by React we need to do this manually.
	     */
	
	
	    /**
	     * Call Youtube Player API methods to update the currently playing video.
	     * Depeding on the `opts.playerVars.autoplay` this function uses one of two
	     * Youtube Player API methods to update the video.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement('div', { id: this.props.id, className: this.props.className, ref: this.refContainer })
	      );
	    }
	  }]);
	
	  return YouTube;
	}(_react2.default.Component);
	
	YouTube.propTypes = {
	  videoId: _propTypes2.default.string,
	
	  // custom ID for player element
	  id: _propTypes2.default.string,
	
	  // custom class name for player element
	  className: _propTypes2.default.string,
	
	  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
	  opts: _propTypes2.default.object,
	
	  // event subscriptions
	  onReady: _propTypes2.default.func,
	  onError: _propTypes2.default.func,
	  onPlay: _propTypes2.default.func,
	  onPause: _propTypes2.default.func,
	  onEnd: _propTypes2.default.func,
	  onStateChange: _propTypes2.default.func,
	  onPlaybackRateChange: _propTypes2.default.func,
	  onPlaybackQualityChange: _propTypes2.default.func
	};
	YouTube.defaultProps = {
	  opts: {},
	  onReady: function onReady() {},
	  onError: function onError() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onEnd: function onEnd() {},
	  onStateChange: function onStateChange() {},
	  onPlaybackRateChange: function onPlaybackRateChange() {},
	  onPlaybackQualityChange: function onPlaybackQualityChange() {}
	};
	YouTube.PlayerState = {
	  UNSTARTED: -1,
	  ENDED: 0,
	  PLAYING: 1,
	  PAUSED: 2,
	  BUFFERING: 3,
	  CUED: 5
	};
	exports.default = YouTube;

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(57);
	
	var findDOMNode = __webpack_require__(370);
	var focusNode = __webpack_require__(733);
	
	var Mixin = {
	  componentDidMount: function () {
	    if (this.props.autoFocus) {
	      focusNode(findDOMNode(this));
	    }
	  }
	};
	
	var AutoFocusUtils = {
	  Mixin: Mixin,
	
	  focusDOMComponent: function () {
	    focusNode(ReactMount.getNode(this._rootNodeID));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(99);
	var EventPropagators = __webpack_require__(187);
	var ExecutionEnvironment = __webpack_require__(52);
	var FallbackCompositionState = __webpack_require__(1502);
	var SyntheticCompositionEvent = __webpack_require__(1531);
	var SyntheticInputEvent = __webpack_require__(1534);
	
	var keyOf = __webpack_require__(112);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(702);
	var ExecutionEnvironment = __webpack_require__(52);
	var ReactPerf = __webpack_require__(81);
	
	var camelizeStyleName = __webpack_require__(1548);
	var dangerousStyleValue = __webpack_require__(1539);
	var hyphenateStyleName = __webpack_require__(1553);
	var memoizeStringOnly = __webpack_require__(1557);
	var warning = __webpack_require__(30);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
	  };
	
	  var warnBadVendoredStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function (name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function (node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
	  setValueForStyles: 'setValueForStyles'
	});
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(99);
	var EventPluginHub = __webpack_require__(186);
	var EventPropagators = __webpack_require__(187);
	var ExecutionEnvironment = __webpack_require__(52);
	var ReactUpdates = __webpack_require__(82);
	var SyntheticEvent = __webpack_require__(139);
	
	var getEventTarget = __webpack_require__(373);
	var isEventSupported = __webpack_require__(376);
	var isTextInputElement = __webpack_require__(730);
	var keyOf = __webpack_require__(112);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function () {
	    return nextReactRootIndex++;
	  }
	};
	
	module.exports = ClientReactRootIndex;

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(52);
	
	var createNodesFromMarkup = __webpack_require__(1550);
	var emptyFunction = __webpack_require__(92);
	var getMarkupWrap = __webpack_require__(735);
	var invariant = __webpack_require__(21);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (false) {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;
	
	    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
	    !(oldChild.tagName.toLowerCase() !== 'html') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;
	
	    var newChild;
	    if (typeof markup === 'string') {
	      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    } else {
	      newChild = markup;
	    }
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.exports = Danger;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(112);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(99);
	var EventPropagators = __webpack_require__(187);
	var SyntheticMouseEvent = __webpack_require__(253);
	
	var ReactMount = __webpack_require__(57);
	var keyOf = __webpack_require__(112);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    var fromID = '';
	    var toID = '';
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      fromID = topLevelTargetID;
	      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
	      if (to) {
	        toID = ReactMount.getID(to);
	      } else {
	        to = win;
	      }
	      to = to || win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	      toID = topLevelTargetID;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(99);
	var ReactErrorUtils = __webpack_require__(718);
	
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function (InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, simulated, listener, domID) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = injection.Mount.getNode(domID);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
	  }
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
	  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getNode: function (id) {
	    return injection.Mount.getNode(id);
	  },
	  getID: function (node) {
	    return injection.Mount.getID(node);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(111);
	
	var assign = __webpack_require__(29);
	var getTextContentAccessor = __webpack_require__(729);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(160);
	var ExecutionEnvironment = __webpack_require__(52);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
	}
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    challenge: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    inputMode: MUST_USE_ATTRIBUTE,
	    integrity: null,
	    is: MUST_USE_ATTRIBUTE,
	    keyParams: MUST_USE_ATTRIBUTE,
	    keyType: MUST_USE_ATTRIBUTE,
	    kind: null,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    minLength: MUST_USE_ATTRIBUTE,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    nonce: MUST_USE_ATTRIBUTE,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcLang: null,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    summary: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	    wrap: null,
	
	    /**
	     * RDFa Properties
	     */
	    about: MUST_USE_ATTRIBUTE,
	    datatype: MUST_USE_ATTRIBUTE,
	    inlist: MUST_USE_ATTRIBUTE,
	    prefix: MUST_USE_ATTRIBUTE,
	    // property is also supported for OpenGraph in meta tags.
	    property: MUST_USE_ATTRIBUTE,
	    resource: MUST_USE_ATTRIBUTE,
	    'typeof': MUST_USE_ATTRIBUTE,
	    vocab: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: MUST_USE_ATTRIBUTE,
	    autoCorrect: MUST_USE_ATTRIBUTE,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: null,
	    // color is for Safari mask-icon link
	    color: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: null,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: MUST_USE_ATTRIBUTE,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoComplete: 'autocomplete',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    autoSave: 'autosave',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(708);
	var ReactDOMServer = __webpack_require__(711);
	var ReactIsomorphic = __webpack_require__(1518);
	
	var assign = __webpack_require__(29);
	var deprecated = __webpack_require__(1540);
	
	// `version` will be added here by ReactIsomorphic.
	var React = {};
	
	assign(React, ReactIsomorphic);
	
	assign(React, {
	  // ReactDOM
	  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
	  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
	  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),
	
	  // ReactDOMServer
	  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
	  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
	});
	
	React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
	React.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMServer;
	
	module.exports = React;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var ReactInstanceMap = __webpack_require__(188);
	
	var findDOMNode = __webpack_require__(370);
	var warning = __webpack_require__(30);
	
	var didWarnKey = '_getDOMNodeDidWarn';
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function () {
	     false ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
	    this.constructor[didWarnKey] = true;
	    return findDOMNode(this);
	  }
	};
	
	module.exports = ReactBrowserComponentMixin;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(138);
	
	var instantiateReactComponent = __webpack_require__(375);
	var shouldUpdateReactComponent = __webpack_require__(378);
	var traverseAllChildren = __webpack_require__(379);
	var warning = __webpack_require__(30);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, null);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, null);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(366);
	var ReactCurrentOwner = __webpack_require__(100);
	var ReactElement = __webpack_require__(65);
	var ReactInstanceMap = __webpack_require__(188);
	var ReactPerf = __webpack_require__(81);
	var ReactPropTypeLocations = __webpack_require__(252);
	var ReactPropTypeLocationNames = __webpack_require__(251);
	var ReactReconciler = __webpack_require__(138);
	var ReactUpdateQueue = __webpack_require__(368);
	
	var assign = __webpack_require__(29);
	var emptyObject = __webpack_require__(190);
	var invariant = __webpack_require__(21);
	var shouldUpdateReactComponent = __webpack_require__(378);
	var warning = __webpack_require__(30);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  return Component(this.props, this.context, this.updater);
	};
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst;
	    var renderedElement;
	
	    // This is a way to detect if Component is a stateless arrow function
	    // component, which is not newable. It might not be 100% reliable but is
	    // something we can do until we start detecting that Component extends
	    // React.Component. We already assume that typeof Component === 'function'.
	    var canInstantiate = ('prototype' in Component);
	
	    if (canInstantiate) {
	      if (false) {
	        ReactCurrentOwner.current = this;
	        try {
	          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	        } finally {
	          ReactCurrentOwner.current = null;
	        }
	      } else {
	        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	      }
	    }
	
	    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
	      renderedElement = inst;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
	      } else {
	        // We support ES6 inheriting from React.Component, the module pattern,
	        // and stateless components, but not ES6 classes that don't extend
	        process.env.NODE_ENV !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
	      }
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    if (inst.componentWillMount) {
	      inst.componentWillMount();
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function () {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      inst.componentWillUnmount();
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	    this._instance = null;
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var maskedContext = null;
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	      if (false) {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
	      }
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	          error = propTypes[propName](props, propName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
	          } else {
	             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	
	    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
	    var nextProps;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent',
	  _renderValidatedComponent: '_renderValidatedComponent'
	});
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var mouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: function (inst, props, context) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.exports = ReactDOMButton;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var AutoFocusUtils = __webpack_require__(1493);
	var CSSPropertyOperations = __webpack_require__(1495);
	var DOMProperty = __webpack_require__(160);
	var DOMPropertyOperations = __webpack_require__(363);
	var EventConstants = __webpack_require__(99);
	var ReactBrowserEventEmitter = __webpack_require__(250);
	var ReactComponentBrowserEnvironment = __webpack_require__(365);
	var ReactDOMButton = __webpack_require__(1508);
	var ReactDOMInput = __webpack_require__(1511);
	var ReactDOMOption = __webpack_require__(1512);
	var ReactDOMSelect = __webpack_require__(710);
	var ReactDOMTextarea = __webpack_require__(1514);
	var ReactMount = __webpack_require__(57);
	var ReactMultiChild = __webpack_require__(1519);
	var ReactPerf = __webpack_require__(81);
	var ReactUpdateQueue = __webpack_require__(368);
	
	var assign = __webpack_require__(29);
	var canDefineProperty = __webpack_require__(255);
	var escapeTextContentForBrowser = __webpack_require__(256);
	var invariant = __webpack_require__(21);
	var isEventSupported = __webpack_require__(376);
	var keyOf = __webpack_require__(112);
	var setInnerHTML = __webpack_require__(257);
	var setTextContent = __webpack_require__(377);
	var shallowEqual = __webpack_require__(736);
	var validateDOMNesting = __webpack_require__(380);
	var warning = __webpack_require__(30);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var CHILDREN = keyOf({ children: null });
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	
	var ELEMENT_NODE_TYPE = 1;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	var legacyPropsDescriptor;
	if (false) {
	  legacyPropsDescriptor = {
	    props: {
	      enumerable: false,
	      get: function () {
	        var component = this._reactInternalComponent;
	        process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
	        return component._currentElement.props;
	      }
	    }
	  };
	}
	
	function legacyGetDOMNode() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return this;
	}
	
	function legacyIsMounted() {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return !!component;
	}
	
	function legacySetStateEtc() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	}
	
	function legacySetProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function legacyReplaceProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined becauses undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (false) {
	    if (voidElementTags[component._tag]) {
	      process.env.NODE_ENV !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
	    }
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
	    process.env.NODE_ENV !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
	}
	
	function enqueuePutListener(id, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getReactMountReady().enqueue(putListener, {
	    id: id,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
	  var node = ReactMount.getNode(inst._rootNodeID);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;
	
	  switch (inst._tag) {
	    case 'iframe':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	  }
	}
	
	function mountReadyInputWrapper() {
	  ReactDOMInput.mountReadyWrapper(this);
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = ({}).hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function processChildContextDev(context, inst) {
	  // Pass down our tag name to child components for validation purposes
	  context = assign({}, context);
	  var info = context[validateDOMNesting.ancestorInfoContextKey];
	  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
	  return context;
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag.toLowerCase();
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._nodeWithLegacyProperties = null;
	  if (false) {
	    this._unprocessedContextDev = null;
	    this._processedContextDev = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function (element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._rootNodeID = rootID;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, context);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, context);
	        props = ReactDOMInput.getNativeProps(this, props, context);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, context);
	        props = ReactDOMOption.getNativeProps(this, props, context);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, context);
	        props = ReactDOMSelect.getNativeProps(this, props, context);
	        context = ReactDOMSelect.processChildContext(this, props, context);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, context);
	        props = ReactDOMTextarea.getNativeProps(this, props, context);
	        break;
	    }
	
	    assertValidProps(this, props);
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    if (false) {
	      this._unprocessedContextDev = context;
	      this._processedContextDev = processChildContextDev(context, this);
	      context = this._processedContextDev;
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement(this._currentElement.type);
	      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
	      // Populate node cache
	      ReactMount.getID(el);
	      this._updateDOMProperties({}, props, transaction, el);
	      this._createInitialChildren(transaction, props, context, el);
	      mountImage = el;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
	      // falls through
	      case 'button':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (propKey !== CHILDREN) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, el) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        setInnerHTML(el, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        setTextContent(el, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          el.appendChild(mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    if (false) {
	      // If the context is reference-equal to the old one, pass down the same
	      // processed object so the update bailout in ReactReconciler behaves
	      // correctly (and identically in dev and prod). See #5005.
	      if (this._unprocessedContextDev !== context) {
	        this._unprocessedContextDev = context;
	        this._processedContextDev = processChildContextDev(context, this);
	      }
	      context = this._processedContextDev;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction, null);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (!canDefineProperty && this._nodeWithLegacyProperties) {
	      this._nodeWithLegacyProperties.props = nextProps;
	    }
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        DOMPropertyOperations.deleteValueForProperty(node, propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        if (propKey === CHILDREN) {
	          nextProp = null;
	        }
	        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertantly setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      if (!node) {
	        node = ReactMount.getNode(this._rootNodeID);
	      }
	      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function () {
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	        ReactDOMInput.unmountWrapper(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
	        break;
	    }
	
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._wrapperState = null;
	    if (this._nodeWithLegacyProperties) {
	      var node = this._nodeWithLegacyProperties;
	      node._reactInternalComponent = null;
	      this._nodeWithLegacyProperties = null;
	    }
	  },
	
	  getPublicInstance: function () {
	    if (!this._nodeWithLegacyProperties) {
	      var node = ReactMount.getNode(this._rootNodeID);
	
	      node._reactInternalComponent = this;
	      node.getDOMNode = legacyGetDOMNode;
	      node.isMounted = legacyIsMounted;
	      node.setState = legacySetStateEtc;
	      node.replaceState = legacySetStateEtc;
	      node.forceUpdate = legacySetStateEtc;
	      node.setProps = legacySetProps;
	      node.replaceProps = legacyReplaceProps;
	
	      if (false) {
	        if (canDefineProperty) {
	          Object.defineProperties(node, legacyPropsDescriptor);
	        } else {
	          // updateComponent will update this property on subsequent renders
	          node.props = this._currentElement.props;
	        }
	      } else {
	        // updateComponent will update this property on subsequent renders
	        node.props = this._currentElement.props;
	      }
	
	      this._nodeWithLegacyProperties = node;
	    }
	    return this._nodeWithLegacyProperties;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(65);
	var ReactElementValidator = __webpack_require__(715);
	
	var mapObject = __webpack_require__(1556);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(367);
	var LinkedValueUtils = __webpack_require__(364);
	var ReactMount = __webpack_require__(57);
	var ReactUpdates = __webpack_require__(82);
	
	var assign = __webpack_require__(29);
	var invariant = __webpack_require__(21);
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props, context) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = assign({}, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  mountReadyWrapper: function (inst) {
	    // Can't be in mountWrapper or else server rendering leaks.
	    instancesByReactID[inst._rootNodeID] = inst;
	  },
	
	  unmountWrapper: function (inst) {
	    delete instancesByReactID[inst._rootNodeID];
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactMount.getNode(this._rootNodeID);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React with non-React.
	      var otherID = ReactMount.getID(otherNode);
	      !otherID ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
	      var otherInstance = instancesByReactID[otherID];
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(705);
	var ReactDOMSelect = __webpack_require__(710);
	
	var assign = __webpack_require__(29);
	var warning = __webpack_require__(30);
	
	var valueContextKey = ReactDOMSelect.valueContextKey;
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, context) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
	    }
	
	    // Look up whether this option is 'selected' via context
	    var selectValue = context[valueContextKey];
	
	    // If context key is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  getNativeProps: function (inst, props, context) {
	    var nativeProps = assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
	      }
	    });
	
	    if (content) {
	      nativeProps.children = content;
	    }
	
	    return nativeProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(52);
	
	var getNodeForCharacterOffset = __webpack_require__(1543);
	var getTextContentAccessor = __webpack_require__(729);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(364);
	var ReactDOMIDOperations = __webpack_require__(367);
	var ReactUpdates = __webpack_require__(82);
	
	var assign = __webpack_require__(29);
	var invariant = __webpack_require__(21);
	var warning = __webpack_require__(30);
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props, context) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = assign({}, props, {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
	      }
	      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(186);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(731);
	var ExecutionEnvironment = __webpack_require__(52);
	var PooledClass = __webpack_require__(111);
	var ReactInstanceHandles = __webpack_require__(161);
	var ReactMount = __webpack_require__(57);
	var ReactUpdates = __webpack_require__(82);
	
	var assign = __webpack_require__(29);
	var getEventTarget = __webpack_require__(373);
	var getUnboundedScrollPosition = __webpack_require__(1551);
	
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  // TODO: Re-enable event.path handling
	  //
	  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
	  //   // New browsers have a path attribute on native events
	  //   handleTopLevelWithPath(bookKeeping);
	  // } else {
	  //   // Legacy browsers don't have a path attribute on native events
	  //   handleTopLevelWithoutPath(bookKeeping);
	  // }
	
	  void handleTopLevelWithPath; // temporarily unused
	  handleTopLevelWithoutPath(bookKeeping);
	}
	
	// Legacy browsers don't have a path attribute on native events
	function handleTopLevelWithoutPath(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	// New browsers have a path attribute on native events
	function handleTopLevelWithPath(bookKeeping) {
	  var path = bookKeeping.nativeEvent.path;
	  var currentNativeTarget = path[0];
	  var eventsFired = 0;
	  for (var i = 0; i < path.length; i++) {
	    var currentPathElement = path[i];
	    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
	      currentNativeTarget = path[i + 1];
	    }
	    // TODO: slow
	    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
	    if (reactParent === currentPathElement) {
	      var currentPathElementID = ReactMount.getID(currentPathElement);
	      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
	      bookKeeping.ancestors.push(currentPathElement);
	
	      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
	      eventsFired++;
	      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);
	
	      // Jump to the root of this React render tree
	      while (currentPathElementID !== newRootID) {
	        i++;
	        currentPathElement = path[i];
	        currentPathElementID = ReactMount.getID(currentPathElement);
	      }
	    }
	  }
	  if (eventsFired === 0) {
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(160);
	var EventPluginHub = __webpack_require__(186);
	var ReactComponentEnvironment = __webpack_require__(366);
	var ReactClass = __webpack_require__(706);
	var ReactEmptyComponent = __webpack_require__(716);
	var ReactBrowserEventEmitter = __webpack_require__(250);
	var ReactNativeComponent = __webpack_require__(722);
	var ReactPerf = __webpack_require__(81);
	var ReactRootIndex = __webpack_require__(725);
	var ReactUpdates = __webpack_require__(82);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactIsomorphic
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(705);
	var ReactComponent = __webpack_require__(707);
	var ReactClass = __webpack_require__(706);
	var ReactDOMFactories = __webpack_require__(1510);
	var ReactElement = __webpack_require__(65);
	var ReactElementValidator = __webpack_require__(715);
	var ReactPropTypes = __webpack_require__(724);
	var ReactVersion = __webpack_require__(369);
	
	var assign = __webpack_require__(29);
	var onlyChild = __webpack_require__(1544);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	module.exports = React;

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(366);
	var ReactMultiChildUpdateTypes = __webpack_require__(721);
	
	var ReactCurrentOwner = __webpack_require__(100);
	var ReactReconciler = __webpack_require__(138);
	var ReactChildReconciler = __webpack_require__(1506);
	
	var flattenChildren = __webpack_require__(1541);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueInsertMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    content: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the markup of a node.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function enqueueSetMarkup(parentID, markup) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    markupIndex: null,
	    content: markup,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    content: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChild(prevChildren[name]);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        this.setMarkup(nextMarkup);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildrenElements, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChild(prevChild);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChild(prevChildren[name]);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function () {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, mountImage) {
	      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function (textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Sets this markup string.
	     *
	     * @param {string} markup Markup to set.
	     * @protected
	     */
	    setMarkup: function (markup) {
	      enqueueSetMarkup(this._rootNodeID, markup);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(21);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(362);
	var PooledClass = __webpack_require__(111);
	var ReactBrowserEventEmitter = __webpack_require__(250);
	var ReactDOMFeatureFlags = __webpack_require__(709);
	var ReactInputSelection = __webpack_require__(719);
	var Transaction = __webpack_require__(254);
	
	var assign = __webpack_require__(29);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(forceHTML) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1520);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerBatchingStrategy
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactDefaultBatchingStrategy = __webpack_require__(713);
	var ReactElement = __webpack_require__(65);
	var ReactInstanceHandles = __webpack_require__(161);
	var ReactMarkupChecksum = __webpack_require__(720);
	var ReactServerBatchingStrategy = __webpack_require__(1523);
	var ReactServerRenderingTransaction = __webpack_require__(1525);
	var ReactUpdates = __webpack_require__(82);
	
	var emptyObject = __webpack_require__(190);
	var instantiateReactComponent = __webpack_require__(375);
	var invariant = __webpack_require__(21);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(111);
	var CallbackQueue = __webpack_require__(362);
	var Transaction = __webpack_require__(254);
	
	var assign = __webpack_require__(29);
	var emptyFunction = __webpack_require__(92);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = false;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(160);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    xlinkActuate: MUST_USE_ATTRIBUTE,
	    xlinkArcrole: MUST_USE_ATTRIBUTE,
	    xlinkHref: MUST_USE_ATTRIBUTE,
	    xlinkRole: MUST_USE_ATTRIBUTE,
	    xlinkShow: MUST_USE_ATTRIBUTE,
	    xlinkTitle: MUST_USE_ATTRIBUTE,
	    xlinkType: MUST_USE_ATTRIBUTE,
	    xmlBase: MUST_USE_ATTRIBUTE,
	    xmlLang: MUST_USE_ATTRIBUTE,
	    xmlSpace: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(99);
	var EventPropagators = __webpack_require__(187);
	var ExecutionEnvironment = __webpack_require__(52);
	var ReactInputSelection = __webpack_require__(719);
	var SyntheticEvent = __webpack_require__(139);
	
	var getActiveElement = __webpack_require__(734);
	var isTextInputElement = __webpack_require__(730);
	var keyOf = __webpack_require__(112);
	var shallowEqual = __webpack_require__(736);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function () {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.exports = ServerReactRootIndex;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(99);
	var EventListener = __webpack_require__(731);
	var EventPropagators = __webpack_require__(187);
	var ReactMount = __webpack_require__(57);
	var SyntheticClipboardEvent = __webpack_require__(1530);
	var SyntheticEvent = __webpack_require__(139);
	var SyntheticFocusEvent = __webpack_require__(1533);
	var SyntheticKeyboardEvent = __webpack_require__(1535);
	var SyntheticMouseEvent = __webpack_require__(253);
	var SyntheticDragEvent = __webpack_require__(1532);
	var SyntheticTouchEvent = __webpack_require__(1536);
	var SyntheticUIEvent = __webpack_require__(189);
	var SyntheticWheelEvent = __webpack_require__(1537);
	
	var emptyFunction = __webpack_require__(92);
	var getEventCharCode = __webpack_require__(371);
	var invariant = __webpack_require__(21);
	var keyOf = __webpack_require__(112);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
	    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var node = ReactMount.getNode(id);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (id, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(139);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(139);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(253);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(189);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(139);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(189);
	
	var getEventCharCode = __webpack_require__(371);
	var getEventKey = __webpack_require__(1542);
	var getEventModifierState = __webpack_require__(372);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(189);
	
	var getEventModifierState = __webpack_require__(372);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(253);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    for (; i < Math.min(i + 4096, m); i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(702);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule deprecated
	 */
	
	'use strict';
	
	var assign = __webpack_require__(29);
	var warning = __webpack_require__(30);
	
	/**
	 * This will log a single deprecation notice per function and forward the call
	 * on to the new API.
	 *
	 * @param {string} fnName The name of the function
	 * @param {string} newModule The module that fn will exist in
	 * @param {string} newPackage The module that fn will exist in
	 * @param {*} ctx The context this forwarded call should run in
	 * @param {function} fn The function to forward on to
	 * @return {function} The function that will warn once and then call fn
	 */
	function deprecated(fnName, newModule, newPackage, ctx, fn) {
	  var warned = false;
	  if (false) {
	    var newFn = function () {
	      process.env.NODE_ENV !== 'production' ? warning(warned,
	      // Require examples in this string must be split to prevent React's
	      // build tools from mistaking them for real requires.
	      // Otherwise the build tools will attempt to build a '%s' module.
	      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
	      warned = true;
	      return fn.apply(ctx, arguments);
	    };
	    // We need to make sure all properties of the original fn are copied over.
	    // In particular, this is needed to support PropTypes
	    return assign(newFn, fn);
	  }
	
	  return fn;
	}
	
	module.exports = deprecated;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(379);
	var warning = __webpack_require__(30);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(371);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(65);
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(256);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(57);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	"use strict";
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1547);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	'use strict';
	
	var toArray = __webpack_require__(1558);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(52);
	
	var createArrayFromMixed = __webpack_require__(1549);
	var getMarkupWrap = __webpack_require__(735);
	var invariant = __webpack_require__(21);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : undefined;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : undefined;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	'use strict';
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1552);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	'use strict';
	
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isNode = __webpack_require__(1554);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(21);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : undefined;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : undefined;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : undefined;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.exports = toArray;

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var filenameWithoutLoaders = exports.filenameWithoutLoaders = function filenameWithoutLoaders() {
	  var filename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var index = filename.lastIndexOf('!');
	
	  return index < 0 ? filename : filename.substr(index + 1);
	};
	
	var filenameHasLoaders = exports.filenameHasLoaders = function filenameHasLoaders(filename) {
	  var actualFilename = _get__('filenameWithoutLoaders')(filename);
	
	  return actualFilename !== filename;
	};
	
	var filenameHasSchema = exports.filenameHasSchema = function filenameHasSchema(filename) {
	  return (/^[\w]+\:/.test(filename)
	  );
	};
	
	var isFilenameAbsolute = exports.isFilenameAbsolute = function isFilenameAbsolute(filename) {
	  var actualFilename = _get__('filenameWithoutLoaders')(filename);
	
	  if (actualFilename.indexOf('/') === 0) {
	    return true;
	  }
	
	  return false;
	};
	
	var makeUrl = exports.makeUrl = function makeUrl(filename, scheme, line, column) {
	  var actualFilename = _get__('filenameWithoutLoaders')(filename);
	
	  if (_get__('filenameHasSchema')(filename)) {
	    return actualFilename;
	  }
	
	  var url = 'file://' + actualFilename;
	
	  if (scheme === 'vscode') {
	    url = scheme + '://file/' + url;
	    url = url.replace(/file:\/\/\//, ''); // visual studio code does not need file:/// in its scheme
	    if (line && actualFilename === filename) {
	      url = url + ':' + line;
	
	      if (column) {
	        url = url + ':' + column;
	      }
	    }
	  } else if (scheme) {
	    url = scheme + '://open?url=' + url;
	
	    if (line && actualFilename === filename) {
	      url = url + '&line=' + line;
	
	      if (column) {
	        url = url + '&column=' + column;
	      }
	    }
	  }
	
	  return url;
	};
	
	var makeLinkText = exports.makeLinkText = function makeLinkText(filename, line, column) {
	  var text = _get__('filenameWithoutLoaders')(filename);
	
	  if (line && text === filename) {
	    text = text + ':' + line;
	
	    if (column) {
	      text = text + ':' + column;
	    }
	  }
	
	  return text;
	};
	
	var _RewiredData__ = Object.create(null);
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  if (_RewiredData__ === undefined || _RewiredData__[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = _RewiredData__[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'filenameWithoutLoaders':
	      return filenameWithoutLoaders;
	
	    case 'filenameHasSchema':
	      return filenameHasSchema;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  if (_RewiredData__ === undefined || _RewiredData__[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return _RewiredData__[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      _RewiredData__[name] = variableName[name];
	    });
	  } else {
	    if (value === undefined) {
	      _RewiredData__[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      _RewiredData__[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  delete _RewiredData__[variableName];
	}
	
	function _with__(object) {
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      _RewiredData__[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = _RewiredData__[variableName];
	      _RewiredData__[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	exports.default = _RewireAPI__;

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _DefaultExportValue = {
	  redbox: {
	    boxSizing: 'border-box',
	    fontFamily: 'sans-serif',
	    position: 'fixed',
	    padding: 10,
	    top: '0px',
	    left: '0px',
	    bottom: '0px',
	    right: '0px',
	    width: '100%',
	    background: 'rgb(204, 0, 0)',
	    color: 'white',
	    zIndex: 2147483647,
	    textAlign: 'left',
	    fontSize: '16px',
	    lineHeight: 1.2,
	    overflow: 'auto'
	  },
	  message: {
	    fontWeight: 'bold'
	  },
	  stack: {
	    fontFamily: 'monospace',
	    marginTop: '2em'
	  },
	  frame: {
	    marginTop: '1em'
	  },
	  file: {
	    fontSize: '0.8em',
	    color: 'rgba(255, 255, 255, 0.7)'
	  },
	  linkToFile: {
	    textDecoration: 'none',
	    color: 'rgba(255, 255, 255, 0.7)'
	  }
	};
	exports.default = _DefaultExportValue;

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */
	
	module.exports = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];
	
	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadOnServer = loadOnServer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(248);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _asyncConnect = __webpack_require__(737);
	
	var _reactRedux = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	var any = _React$PropTypes.any;
	
	/**
	 * We need to iterate over all components for specified routes.
	 * Components array can include objects if named components are used:
	 * https://github.com/rackt/react-router/blob/latest/docs/API.md#named-components
	 *
	 * @param components
	 * @param iterator
	 */
	
	function eachComponents(components, iterator) {
	  for (var i = 0, l = components.length; i < l; i++) {
	    // eslint-disable-line id-length
	    if (_typeof(components[i]) === 'object') {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = Object.entries(components[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _slicedToArray(_step.value, 2);
	
	          var key = _step$value[0];
	          var value = _step$value[1];
	
	          iterator(value, i, key);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    } else {
	      iterator(components[i], i);
	    }
	  }
	}
	
	function filterAndFlattenComponents(components) {
	  var flattened = [];
	  eachComponents(components, function (Component) {
	    if (Component && Component.reduxAsyncConnect) {
	      flattened.push(Component);
	    }
	  });
	  return flattened;
	}
	
	function loadAsyncConnect(_ref) {
	  var components = _ref.components;
	  var _ref$filter = _ref.filter;
	  var filter = _ref$filter === undefined ? function () {
	    return true;
	  } : _ref$filter;
	
	  var rest = _objectWithoutProperties(_ref, ['components', 'filter']);
	
	  var async = false;
	  var promise = Promise.all(filterAndFlattenComponents(components).map(function (Component) {
	    var asyncItems = Component.reduxAsyncConnect;
	
	    return Promise.all(asyncItems.reduce(function (itemsResults, item) {
	      var promiseOrResult = item.promise(rest);
	
	      if (filter(item, Component)) {
	        if (promiseOrResult && promiseOrResult.then instanceof Function) {
	          async = true;
	          promiseOrResult = promiseOrResult.catch(function (error) {
	            return { error: error };
	          });
	        }
	        return [].concat(_toConsumableArray(itemsResults), [promiseOrResult]);
	      } else {
	        return itemsResults;
	      }
	    }, [])).then(function (results) {
	      return asyncItems.reduce(function (result, item, i) {
	        return _extends({}, result, _defineProperty({}, item.key, results[i]));
	      }, {});
	    });
	  }));
	
	  return { promise: promise, async: async };
	}
	
	function loadOnServer(args) {
	  var result = loadAsyncConnect(args);
	  if (result.async) {
	    result.promise.then(function () {
	      args.store.dispatch((0, _asyncConnect.endGlobalLoad)());
	    });
	  }
	  return result.promise;
	}
	
	var loadDataCounter = 0;
	
	var ReduxAsyncConnect = function (_React$Component) {
	  _inherits(ReduxAsyncConnect, _React$Component);
	
	  _createClass(ReduxAsyncConnect, [{
	    key: 'isLoaded',
	    value: function isLoaded() {
	      return this.context.store.getState().reduxAsyncConnect.loaded;
	    }
	  }]);
	
	  function ReduxAsyncConnect(props, context) {
	    _classCallCheck(this, ReduxAsyncConnect);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReduxAsyncConnect).call(this, props, context));
	
	    _this.state = {
	      propsToShow: _this.isLoaded() ? props : null
	    };
	    return _this;
	  }
	
	  _createClass(ReduxAsyncConnect, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataLoaded = this.isLoaded();
	
	      if (!dataLoaded) {
	        // we dont need it if we already made it on server-side
	        this.loadAsyncData(this.props);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.loadAsyncData(nextProps);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return this.state.propsToShow !== nextState.propsToShow;
	    }
	  }, {
	    key: 'loadAsyncData',
	    value: function loadAsyncData(props) {
	      var _this2 = this;
	
	      var store = this.context.store;
	      var loadResult = loadAsyncConnect(_extends({}, props, { store: store }));
	
	      loadDataCounter++;
	
	      if (loadResult.async) {
	        this.props.beginGlobalLoad();
	        (function (loadDataCounterOriginal) {
	          loadResult.promise.then(function () {
	            // We need to change propsToShow only if loadAsyncData that called this promise
	            // is the last invocation of loadAsyncData method. Otherwise we can face situation
	            // when user is changing route several times and we finally show him route that has
	            // loaded props last time and not the last called route
	            if (loadDataCounter === loadDataCounterOriginal) {
	              _this2.setState({ propsToShow: props });
	            }
	            _this2.props.endGlobalLoad();
	          });
	        })(loadDataCounter);
	      } else {
	        this.setState({ propsToShow: props });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var propsToShow = this.state.propsToShow;
	
	      return propsToShow && this.props.render(propsToShow);
	    }
	  }]);
	
	  return ReduxAsyncConnect;
	}(_react2.default.Component);
	
	ReduxAsyncConnect.propTypes = {
	  components: array.isRequired,
	  params: object.isRequired,
	  render: func.isRequired,
	  beginGlobalLoad: func.isRequired,
	  endGlobalLoad: func.isRequired,
	  helpers: any
	};
	ReduxAsyncConnect.contextTypes = {
	  store: object.isRequired
	};
	ReduxAsyncConnect.defaultProps = {
	  render: function render(props) {
	    return _react2.default.createElement(_RouterContext2.default, props);
	  }
	};
	exports.default = (0, _reactRedux.connect)(null, { beginGlobalLoad: _asyncConnect.beginGlobalLoad, endGlobalLoad: _asyncConnect.endGlobalLoad })(ReduxAsyncConnect);

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(738);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(739);
	
	var _isPlainObject = __webpack_require__(325);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(740);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = useStandardScroll;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _domHelpersEventsOff = __webpack_require__(449);
	
	var _domHelpersEventsOff2 = _interopRequireDefault(_domHelpersEventsOff);
	
	var _domHelpersEventsOn = __webpack_require__(450);
	
	var _domHelpersEventsOn2 = _interopRequireDefault(_domHelpersEventsOn);
	
	var _domHelpersQueryScrollLeft = __webpack_require__(1047);
	
	var _domHelpersQueryScrollLeft2 = _interopRequireDefault(_domHelpersQueryScrollLeft);
	
	var _domHelpersQueryScrollTop = __webpack_require__(1048);
	
	var _domHelpersQueryScrollTop2 = _interopRequireDefault(_domHelpersQueryScrollTop);
	
	var _domHelpersUtilRequestAnimationFrame = __webpack_require__(1055);
	
	var _domHelpersUtilRequestAnimationFrame2 = _interopRequireDefault(_domHelpersUtilRequestAnimationFrame);
	
	var _historyLibDOMStateStorage = __webpack_require__(311);
	
	var _utilsCreateUseScroll = __webpack_require__(1567);
	
	var _utilsCreateUseScroll2 = _interopRequireDefault(_utilsCreateUseScroll);
	
	var _utilsSetScrollRestoration = __webpack_require__(1568);
	
	var _utilsSetScrollRestoration2 = _interopRequireDefault(_utilsSetScrollRestoration);
	
	/**
	 * `useStandardScroll` attempts to imitate native browser scroll behavior by
	 * recording updates to the window scroll position, then restoring the previous
	 * scroll position upon a `POP` transition.
	 */
	
	function useStandardScroll(createHistory) {
	  var currentKey = undefined;
	
	  function getScrollPosition() {
	    var state = _historyLibDOMStateStorage.readState(currentKey);
	    if (!state) {
	      return null;
	    }
	
	    return state.scrollPosition;
	  }
	
	  // `history` will invoke this listener synchronously, so `currentKey` will
	  // always be defined.
	  function updateLocation(_ref) {
	    var key = _ref.key;
	
	    currentKey = key;
	  }
	
	  function updateScroll() {
	    var _ref2 = getScrollPosition() || [0, 0];
	
	    var x = _ref2[0];
	    var y = _ref2[1];
	
	    window.scrollTo(x, y);
	  }
	
	  var unsetScrollRestoration = undefined,
	      unlistenScroll = undefined,
	      unlistenBefore = undefined;
	
	  function start(history) {
	    // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	    unsetScrollRestoration = _utilsSetScrollRestoration2['default']('manual');
	
	    var savePositionHandle = null;
	
	    // We have to listen to each scroll update rather than to just location
	    // updates, because some browsers will update scroll position before
	    // emitting the location change.
	    function onScroll() {
	      if (savePositionHandle !== null) {
	        return;
	      }
	
	      // It's possible that this scroll operation was triggered by what will be
	      // a `POP` transition. Instead of updating the saved location
	      // immediately, we have to enqueue the update, then potentially cancel it
	      // if we observe a location update.
	      savePositionHandle = _domHelpersUtilRequestAnimationFrame2['default'](function () {
	        savePositionHandle = null;
	
	        var state = _historyLibDOMStateStorage.readState(currentKey);
	        var scrollPosition = [_domHelpersQueryScrollLeft2['default'](window), _domHelpersQueryScrollTop2['default'](window)];
	
	        // We have to directly update `DOMStateStorage`, because actually
	        // updating the location could cause e.g. React Router to re-render the
	        // entire page, which would lead to observably bad scroll performance.
	        _historyLibDOMStateStorage.saveState(currentKey, _extends({}, state, { scrollPosition: scrollPosition }));
	      });
	    }
	
	    _domHelpersEventsOn2['default'](window, 'scroll', onScroll);
	    unlistenScroll = function () {
	      return _domHelpersEventsOff2['default'](window, 'scroll', onScroll);
	    };
	
	    unlistenBefore = history.listenBefore(function () {
	      if (savePositionHandle !== null) {
	        _domHelpersUtilRequestAnimationFrame2['default'].cancel(savePositionHandle);
	        savePositionHandle = null;
	      }
	    });
	  }
	
	  function stop() {
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if (unsetScrollRestoration) {
	      unsetScrollRestoration();
	    }
	
	    unlistenScroll();
	    unlistenBefore();
	  }
	
	  return _utilsCreateUseScroll2['default'](updateScroll, start, stop, updateLocation)(createHistory);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = createUseScroll;
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function createUseScroll(updateScroll, start, stop, updateLocation) {
	  return function (createHistory) {
	    return function () {
	      var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	      var shouldUpdateScroll = options.shouldUpdateScroll;
	
	      var historyOptions = _objectWithoutProperties(options, ["shouldUpdateScroll"]);
	
	      var history = createHistory(historyOptions);
	
	      var numListeners = 0;
	
	      function checkStart() {
	        if (++numListeners === 1 && start) {
	          start(history);
	        }
	      }
	
	      function checkStop() {
	        if (--numListeners === 0 && stop) {
	          stop();
	        }
	      }
	
	      function listenBefore(hook) {
	        checkStart();
	        var unlisten = history.listenBefore(hook);
	
	        return function () {
	          unlisten();
	          checkStop();
	        };
	      }
	
	      var oldLocation = undefined;
	      var listeners = [],
	          currentLocation = undefined,
	          unlisten = undefined;
	
	      function onChange(location) {
	        oldLocation = currentLocation;
	        currentLocation = location;
	
	        listeners.forEach(function (listener) {
	          return listener(location);
	        });
	
	        // useStandardScroll needs the new location even when not updating the
	        // scroll position, to update the current key.
	        if (updateLocation) {
	          updateLocation(location);
	        }
	
	        if (!shouldUpdateScroll || shouldUpdateScroll(oldLocation, currentLocation)) {
	          updateScroll(location);
	        }
	      }
	
	      function listen(listener) {
	        checkStart();
	
	        if (listeners.length === 0) {
	          unlisten = history.listen(onChange);
	        }
	
	        // Add the listener to the list afterward so we can manage calling it
	        // initially with the current location.
	        listeners.push(listener);
	        listener(currentLocation);
	
	        return function () {
	          listeners = listeners.filter(function (item) {
	            return item !== listener;
	          });
	          if (listeners.length === 0) {
	            unlisten();
	          }
	
	          checkStop();
	        };
	      }
	
	      return _extends({}, history, {
	        listenBefore: listenBefore,
	        listen: listen
	      });
	    };
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = setScrollRestoration;
	
	function setScrollRestoration(scrollRestoration) {
	  /* istanbul ignore if: not supported by any browsers on Travis */
	  if ('scrollRestoration' in window.history) {
	    var _ret = (function () {
	      var oldScrollRestoration = window.history.scrollRestoration;
	      window.history.scrollRestoration = scrollRestoration;
	
	      return {
	        v: function () {
	          window.history.scrollRestoration = oldScrollRestoration;
	        }
	      };
	    })();
	
	    if (typeof _ret === 'object') return _ret.v;
	  }
	
	  return null;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	'use strict';
	
	// Generate an internal UID to make the regexp pattern harder to guess.
	var UID                 = Math.floor(Math.random() * 0x10000000000).toString(16);
	var PLACE_HOLDER_REGEXP = new RegExp('"@__(F|R|D)-' + UID + '-(\\d+)__@"', 'g');
	
	var IS_NATIVE_CODE_REGEXP = /\{\s*\[native code\]\s*\}/g;
	var UNSAFE_CHARS_REGEXP   = /[<>\/\u2028\u2029]/g;
	
	// Mapping of unsafe HTML and invalid JavaScript line terminator chars to their
	// Unicode char counterparts which are safe to use in JavaScript strings.
	var ESCAPED_CHARS = {
	    '<'     : '\\u003C',
	    '>'     : '\\u003E',
	    '/'     : '\\u002F',
	    '\u2028': '\\u2028',
	    '\u2029': '\\u2029'
	};
	
	function escapeUnsafeChars(unsafeChar) {
	    return ESCAPED_CHARS[unsafeChar];
	}
	
	module.exports = function serialize(obj, options) {
	    options || (options = {});
	
	    // Backwards-compatability for `space` as the second argument.
	    if (typeof options === 'number' || typeof options === 'string') {
	        options = {space: options};
	    }
	
	    var functions = [];
	    var regexps   = [];
	    var dates     = [];
	
	    // Returns placeholders for functions and regexps (identified by index)
	    // which are later replaced by their string representation.
	    function replacer(key, value) {
	        if (!value) {
	            return value;
	        }
	
	        // If the value is an object w/ a toJSON method, toJSON is called before
	        // the replacer runs, so we use this[key] to get the non-toJSONed value.
	        var origValue = this[key];
	        var type = typeof origValue;
	
	        if (type === 'object') {
	            if(origValue instanceof RegExp) {
	                return '@__R-' + UID + '-' + (regexps.push(origValue) - 1) + '__@';
	            }
	
	            if(origValue instanceof Date) {
	                return '@__D-' + UID + '-' + (dates.push(origValue) - 1) + '__@';
	            }
	        }
	
	        if (type === 'function') {
	            return '@__F-' + UID + '-' + (functions.push(origValue) - 1) + '__@';
	        }
	
	        return value;
	    }
	
	    var str;
	
	    // Creates a JSON string representation of the value.
	    // NOTE: Node 0.12 goes into slow mode with extra JSON.stringify() args.
	    if (options.isJSON && !options.space) {
	        str = JSON.stringify(obj);
	    } else {
	        str = JSON.stringify(obj, options.isJSON ? null : replacer, options.space);
	    }
	
	    // Protects against `JSON.stringify()` returning `undefined`, by serializing
	    // to the literal string: "undefined".
	    if (typeof str !== 'string') {
	        return String(str);
	    }
	
	    // Replace unsafe HTML and invalid JavaScript line terminator chars with
	    // their safe Unicode char counterpart. This _must_ happen before the
	    // regexps and functions are serialized and added back to the string.
	    str = str.replace(UNSAFE_CHARS_REGEXP, escapeUnsafeChars);
	
	    if (functions.length === 0 && regexps.length === 0 && dates.length === 0) {
	        return str;
	    }
	
	    // Replaces all occurrences of function, regexp and date placeholders in the
	    // JSON string with their string representations. If the original value can
	    // not be found, then `undefined` is used.
	    return str.replace(PLACE_HOLDER_REGEXP, function (match, type, valueIndex) {
	        if (type === 'D') {
	            return "new Date(\"" + dates[valueIndex].toISOString() + "\")";
	        }
	
	        if (type === 'R') {
	            return regexps[valueIndex].toString();
	        }
	
	        var fn           = functions[valueIndex];
	        var serializedFn = fn.toString();
	
	        if (IS_NATIVE_CODE_REGEXP.test(serializedFn)) {
	            throw new TypeError('Serializing native function: ' + fn.name);
	        }
	
	        return serializedFn;
	    });
	}


/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	* @link https://github.com/gajus/sister for the canonical source repository
	* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
	*/
	function Sister () {
	    var sister = {},
	        events = {};
	
	    /**
	     * @name handler
	     * @function
	     * @param {Object} data Event data.
	     */
	
	    /**
	     * @param {String} name Event name.
	     * @param {handler} handler
	     * @return {listener}
	     */
	    sister.on = function (name, handler) {
	        var listener = {name: name, handler: handler};
	        events[name] = events[name] || [];
	        events[name].unshift(listener);
	        return listener;
	    };
	
	    /**
	     * @param {listener}
	     */
	    sister.off = function (listener) {
	        var index = events[listener.name].indexOf(listener);
	
	        if (index != -1) {
	            events[listener.name].splice(index, 1);
	        }
	    };
	
	    /**
	     * @param {String} name Event name.
	     * @param {Object} data Event data.
	     */
	    sister.trigger = function (name, data) {
	        var listeners = events[name],
	            i;
	
	        if (listeners) {
	            i = listeners.length;
	            while (i--) {
	                listeners[i].handler(data);
	            }
	        }
	    };
	
	    return sister;
	}
	
	global.gajus = global.gajus || {};
	global.gajus.Sister = Sister;
	
	module.exports = Sister;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["sourceMappedStackTrace"] = factory();
		else
			root["sourceMappedStackTrace"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
		 * sourcemapped-stacktrace.js
		 * created by James Salter <iteration@gmail.com> (2014)
		 *
		 * https://github.com/novocaine/sourcemapped-stacktrace
		 *
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		/*global define */
	
		// note we only include source-map-consumer, not the whole source-map library,
		// which includes gear for generating source maps that we don't need
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(source_map_consumer) {
	
		  var global_mapForUri = {};
	
		  /**
		   * Re-map entries in a stacktrace using sourcemaps if available.
		   *
		   * @param {str} stack - The stacktrace from the browser.
		   * @param {function} done - Callback invoked with the transformed stacktrace
		   *                          (an Array of Strings) passed as the first
		   *                          argument
		   * @param {Object} [opts] - Optional options object.
		   * @param {Function} [opts.filter] - Filter function applied to each stackTrace line.
		   *                                   Lines which do not pass the filter won't be processesd.
		   * @param {boolean} [opts.cacheGlobally] - Whether to cache sourcemaps globally across multiple calls.
		   * @param {boolean} [opts.sync] - Whether to use synchronous ajax to load the sourcemaps.
		   * @param {string} [opts.traceFormat] - If `error.stack` is formatted according to chrome or
		   *                                      Firefox's style.  Can be either `"chrome"`, `"firefox"`
		   *                                      or `undefined` (default).  If `undefined`, this library
		   *                                      will guess based on `navigator.userAgent`.
		   */
		  var mapStackTrace = function(stack, done, opts) {
		    var lines;
		    var line;
		    var mapForUri = {};
		    var rows = {};
		    var fields;
		    var uri;
		    var expected_fields;
		    var regex;
		    var skip_lines;
	
		    var fetcher = new Fetcher(opts);
	
		    var traceFormat = opts && opts.traceFormat;
		    if (traceFormat !== "chrome" && traceFormat !== "firefox") {
		      if (traceFormat) {
		        throw new Error("unknown traceFormat \"" + traceFormat + "\" :(");
		      } else if (isChromeOrEdge() || isIE11Plus()) {
		        traceFormat = "chrome";
		      } else if (isFirefox() || isSafari()) {
		        traceFormat = "firefox";
		      } else {
		        throw new Error("unknown browser :(");
		      }
		    }
	
		    if (traceFormat === "chrome") {
		      regex = /^ +at.+\((.*):([0-9]+):([0-9]+)/;
		      expected_fields = 4;
		      // (skip first line containing exception message)
		      skip_lines = 1;
		    } else {
		      regex = /@(.*):([0-9]+):([0-9]+)/;
		      expected_fields = 4;
		      skip_lines = 0;
		    }
	
		    lines = stack.split("\n").slice(skip_lines);
	
		    for (var i=0; i < lines.length; i++) {
		      line = lines[i];
		      if ( opts && opts.filter && !opts.filter(line) ) continue;
		      
		      fields = line.match(regex);
		      if (fields && fields.length === expected_fields) {
		        rows[i] = fields;
		        uri = fields[1];
		        if (!uri.match(/<anonymous>/)) {
		          fetcher.fetchScript(uri);
		        }
		      }
		    }
	
		    fetcher.sem.whenReady(function() {
		      var result = processSourceMaps(lines, rows, fetcher.mapForUri, traceFormat);
		      done(result);
		    });
		  };
	
		  var isChromeOrEdge = function() {
		    return navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
		  };
	
		  var isFirefox = function() {
		    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
		  };  
	
		  var isSafari = function() {
		    return navigator.userAgent.toLowerCase().indexOf('safari') > -1;
		  };
				
		  var isIE11Plus = function() {
		   	return document.documentMode && document.documentMode >= 11;
		  };
	
	
		  var Semaphore = function() {
		    this.count = 0;
		    this.pending = [];
		  };
	
		  Semaphore.prototype.incr = function() {
		    this.count++;
		  };
	
		  Semaphore.prototype.decr = function() {
		    this.count--;
		    this.flush();
		  };
	
		  Semaphore.prototype.whenReady = function(fn) {
		    this.pending.push(fn);
		    this.flush();
		  };
	
		  Semaphore.prototype.flush = function() {
		    if (this.count === 0) {
		        this.pending.forEach(function(fn) { fn(); });
		        this.pending = [];
		    }
		  };
	
	
		  var Fetcher = function(opts) {
		    this.sem = new Semaphore();
		    this.sync = opts && opts.sync;
		    this.mapForUri = opts && opts.cacheGlobally ? global_mapForUri : {};
		  };
	
		  Fetcher.prototype.ajax = function(uri, callback) {
		    var xhr = createXMLHTTPObject();
		    var that = this;
		    xhr.onreadystatechange = function() {
		      if (xhr.readyState == 4) {
		        callback.call(that, xhr, uri);
		      }
		    };
		    xhr.open("GET", uri, !this.sync);
		    xhr.send();
		  }
	
		  Fetcher.prototype.fetchScript = function(uri) {
		    if (!(uri in this.mapForUri)) {
		      this.sem.incr();
		      this.mapForUri[uri] = null;
		    } else {
		      return;
		    }
	
		    this.ajax(uri, this.onScriptLoad);
		  };
	
		  var absUrlRegex = new RegExp('^(?:[a-z]+:)?//', 'i');
	
		  Fetcher.prototype.onScriptLoad = function(xhr, uri) {
		    if (xhr.status === 200 || (uri.slice(0, 7) === "file://" && xhr.status === 0)) {
		      // find .map in file.
		      //
		      // attempt to find it at the very end of the file, but tolerate trailing
		      // whitespace inserted by some packers.
		      var match = xhr.responseText.match("//# [s]ourceMappingURL=(.*)[\\s]*$", "m");
		      if (match && match.length === 2) {
		        // get the map
		        var mapUri = match[1];
	
		        var embeddedSourceMap = mapUri.match("data:application/json;(charset=[^;]+;)?base64,(.*)");
	
		        if (embeddedSourceMap && embeddedSourceMap[2]) {
		          this.mapForUri[uri] = new source_map_consumer.SourceMapConsumer(atob(embeddedSourceMap[2]));
		          this.sem.decr();
		        } else {
		          if (!absUrlRegex.test(mapUri)) {
		            // relative url; according to sourcemaps spec is 'source origin'
		            var origin;
		            var lastSlash = uri.lastIndexOf('/');
		            if (lastSlash !== -1) {
		              origin = uri.slice(0, lastSlash + 1);
		              mapUri = origin + mapUri;
		              // note if lastSlash === -1, actual script uri has no slash
		              // somehow, so no way to use it as a prefix... we give up and try
		              // as absolute
		            }
		          }
	
		          this.ajax(mapUri, function(xhr) {
		            if (xhr.status === 200 || (mapUri.slice(0, 7) === "file://" && xhr.status === 0)) {
		              this.mapForUri[uri] = new source_map_consumer.SourceMapConsumer(xhr.responseText);
		            }
		            this.sem.decr();
		          });
		        }
		      } else {
		        // no map
		        this.sem.decr();
		      }
		    } else {
		      // HTTP error fetching uri of the script
		      this.sem.decr();
		    }
		  };
	
		  var processSourceMaps = function(lines, rows, mapForUri, traceFormat) {
		    var result = [];
		    var map;
		    var origName = traceFormat === "chrome" ? origNameChrome : origNameFirefox;
		    for (var i=0; i < lines.length; i++) {
		      var row = rows[i];
		      if (row) {
		        var uri = row[1];
		        var line = parseInt(row[2], 10);
		        var column = parseInt(row[3], 10);
		        map = mapForUri[uri];
	
		        if (map) {
		          // we think we have a map for that uri. call source-map library
		          var origPos = map.originalPositionFor(
		            { line: line, column: column });
		          result.push(formatOriginalPosition(origPos.source,
		            origPos.line, origPos.column, origPos.name || origName(lines[i])));
		        } else {
		          // we can't find a map for that url, but we parsed the row.
		          // reformat unchanged line for consistency with the sourcemapped
		          // lines.
		          result.push(formatOriginalPosition(uri, line, column, origName(lines[i])));
		        }
		      } else {
		        // we weren't able to parse the row, push back what we were given
		        result.push(lines[i]);
		      }
		    }
	
		    return result;
		  };
	
		  function origNameChrome(origLine) {
		    var match = / +at +([^ ]*).*/.exec(origLine);
		    return match && match[1];
		  }
	
		  function origNameFirefox(origLine) {
		    var match = /([^@]*)@.*/.exec(origLine);
		    return match && match[1];
		  }
	
		  var formatOriginalPosition = function(source, line, column, name) {
		    // mimic chrome's format
		    return "    at " + (name ? name : "(unknown)") +
		      " (" + source + ":" + line + ":" + column + ")";
		  };
	
		  // xmlhttprequest boilerplate
		  var XMLHttpFactories = [
			function () {return new XMLHttpRequest();},
			function () {return new ActiveXObject("Msxml2.XMLHTTP");},
			function () {return new ActiveXObject("Msxml3.XMLHTTP");},
			function () {return new ActiveXObject("Microsoft.XMLHTTP");}
		  ];
	
		  function createXMLHTTPObject() {
		      var xmlhttp = false;
		      for (var i=0;i<XMLHttpFactories.length;i++) {
		          try {
		              xmlhttp = XMLHttpFactories[i]();
		          }
		          catch (e) {
		              continue;
		          }
		          break;
		      }
		      return xmlhttp;
		  }
	
		  return {
		    mapStackTrace: mapStackTrace
		  }
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		var util = __webpack_require__(2);
		var binarySearch = __webpack_require__(3);
		var ArraySet = __webpack_require__(4).ArraySet;
		var base64VLQ = __webpack_require__(5);
		var quickSort = __webpack_require__(7).quickSort;
	
		function SourceMapConsumer(aSourceMap) {
		  var sourceMap = aSourceMap;
		  if (typeof aSourceMap === 'string') {
		    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
		  }
	
		  return sourceMap.sections != null
		    ? new IndexedSourceMapConsumer(sourceMap)
		    : new BasicSourceMapConsumer(sourceMap);
		}
	
		SourceMapConsumer.fromSourceMap = function(aSourceMap) {
		  return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
		}
	
		/**
		 * The version of the source mapping spec that we are consuming.
		 */
		SourceMapConsumer.prototype._version = 3;
	
		// `__generatedMappings` and `__originalMappings` are arrays that hold the
		// parsed mapping coordinates from the source map's "mappings" attribute. They
		// are lazily instantiated, accessed via the `_generatedMappings` and
		// `_originalMappings` getters respectively, and we only parse the mappings
		// and create these arrays once queried for a source location. We jump through
		// these hoops because there can be many thousands of mappings, and parsing
		// them is expensive, so we only want to do it if we must.
		//
		// Each object in the arrays is of the form:
		//
		//     {
		//       generatedLine: The line number in the generated code,
		//       generatedColumn: The column number in the generated code,
		//       source: The path to the original source file that generated this
		//               chunk of code,
		//       originalLine: The line number in the original source that
		//                     corresponds to this chunk of generated code,
		//       originalColumn: The column number in the original source that
		//                       corresponds to this chunk of generated code,
		//       name: The name of the original symbol which generated this chunk of
		//             code.
		//     }
		//
		// All properties except for `generatedLine` and `generatedColumn` can be
		// `null`.
		//
		// `_generatedMappings` is ordered by the generated positions.
		//
		// `_originalMappings` is ordered by the original positions.
	
		SourceMapConsumer.prototype.__generatedMappings = null;
		Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
		  get: function () {
		    if (!this.__generatedMappings) {
		      this._parseMappings(this._mappings, this.sourceRoot);
		    }
	
		    return this.__generatedMappings;
		  }
		});
	
		SourceMapConsumer.prototype.__originalMappings = null;
		Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
		  get: function () {
		    if (!this.__originalMappings) {
		      this._parseMappings(this._mappings, this.sourceRoot);
		    }
	
		    return this.__originalMappings;
		  }
		});
	
		SourceMapConsumer.prototype._charIsMappingSeparator =
		  function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
		    var c = aStr.charAt(index);
		    return c === ";" || c === ",";
		  };
	
		/**
		 * Parse the mappings in a string in to a data structure which we can easily
		 * query (the ordered arrays in the `this.__generatedMappings` and
		 * `this.__originalMappings` properties).
		 */
		SourceMapConsumer.prototype._parseMappings =
		  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
		    throw new Error("Subclasses must implement _parseMappings");
		  };
	
		SourceMapConsumer.GENERATED_ORDER = 1;
		SourceMapConsumer.ORIGINAL_ORDER = 2;
	
		SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
		SourceMapConsumer.LEAST_UPPER_BOUND = 2;
	
		/**
		 * Iterate over each mapping between an original source/line/column and a
		 * generated line/column in this source map.
		 *
		 * @param Function aCallback
		 *        The function that is called with each mapping.
		 * @param Object aContext
		 *        Optional. If specified, this object will be the value of `this` every
		 *        time that `aCallback` is called.
		 * @param aOrder
		 *        Either `SourceMapConsumer.GENERATED_ORDER` or
		 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
		 *        iterate over the mappings sorted by the generated file's line/column
		 *        order or the original's source/line/column order, respectively. Defaults to
		 *        `SourceMapConsumer.GENERATED_ORDER`.
		 */
		SourceMapConsumer.prototype.eachMapping =
		  function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
		    var context = aContext || null;
		    var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
	
		    var mappings;
		    switch (order) {
		    case SourceMapConsumer.GENERATED_ORDER:
		      mappings = this._generatedMappings;
		      break;
		    case SourceMapConsumer.ORIGINAL_ORDER:
		      mappings = this._originalMappings;
		      break;
		    default:
		      throw new Error("Unknown order of iteration.");
		    }
	
		    var sourceRoot = this.sourceRoot;
		    mappings.map(function (mapping) {
		      var source = mapping.source === null ? null : this._sources.at(mapping.source);
		      if (source != null && sourceRoot != null) {
		        source = util.join(sourceRoot, source);
		      }
		      return {
		        source: source,
		        generatedLine: mapping.generatedLine,
		        generatedColumn: mapping.generatedColumn,
		        originalLine: mapping.originalLine,
		        originalColumn: mapping.originalColumn,
		        name: mapping.name === null ? null : this._names.at(mapping.name)
		      };
		    }, this).forEach(aCallback, context);
		  };
	
		/**
		 * Returns all generated line and column information for the original source,
		 * line, and column provided. If no column is provided, returns all mappings
		 * corresponding to a either the line we are searching for or the next
		 * closest line that has any mappings. Otherwise, returns all mappings
		 * corresponding to the given line and either the column we are searching for
		 * or the next closest column that has any offsets.
		 *
		 * The only argument is an object with the following properties:
		 *
		 *   - source: The filename of the original source.
		 *   - line: The line number in the original source.
		 *   - column: Optional. the column number in the original source.
		 *
		 * and an array of objects is returned, each with the following properties:
		 *
		 *   - line: The line number in the generated source, or null.
		 *   - column: The column number in the generated source, or null.
		 */
		SourceMapConsumer.prototype.allGeneratedPositionsFor =
		  function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
		    var line = util.getArg(aArgs, 'line');
	
		    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
		    // returns the index of the closest mapping less than the needle. By
		    // setting needle.originalColumn to 0, we thus find the last mapping for
		    // the given line, provided such a mapping exists.
		    var needle = {
		      source: util.getArg(aArgs, 'source'),
		      originalLine: line,
		      originalColumn: util.getArg(aArgs, 'column', 0)
		    };
	
		    if (this.sourceRoot != null) {
		      needle.source = util.relative(this.sourceRoot, needle.source);
		    }
		    if (!this._sources.has(needle.source)) {
		      return [];
		    }
		    needle.source = this._sources.indexOf(needle.source);
	
		    var mappings = [];
	
		    var index = this._findMapping(needle,
		                                  this._originalMappings,
		                                  "originalLine",
		                                  "originalColumn",
		                                  util.compareByOriginalPositions,
		                                  binarySearch.LEAST_UPPER_BOUND);
		    if (index >= 0) {
		      var mapping = this._originalMappings[index];
	
		      if (aArgs.column === undefined) {
		        var originalLine = mapping.originalLine;
	
		        // Iterate until either we run out of mappings, or we run into
		        // a mapping for a different line than the one we found. Since
		        // mappings are sorted, this is guaranteed to find all mappings for
		        // the line we found.
		        while (mapping && mapping.originalLine === originalLine) {
		          mappings.push({
		            line: util.getArg(mapping, 'generatedLine', null),
		            column: util.getArg(mapping, 'generatedColumn', null),
		            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
		          });
	
		          mapping = this._originalMappings[++index];
		        }
		      } else {
		        var originalColumn = mapping.originalColumn;
	
		        // Iterate until either we run out of mappings, or we run into
		        // a mapping for a different line than the one we were searching for.
		        // Since mappings are sorted, this is guaranteed to find all mappings for
		        // the line we are searching for.
		        while (mapping &&
		               mapping.originalLine === line &&
		               mapping.originalColumn == originalColumn) {
		          mappings.push({
		            line: util.getArg(mapping, 'generatedLine', null),
		            column: util.getArg(mapping, 'generatedColumn', null),
		            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
		          });
	
		          mapping = this._originalMappings[++index];
		        }
		      }
		    }
	
		    return mappings;
		  };
	
		exports.SourceMapConsumer = SourceMapConsumer;
	
		/**
		 * A BasicSourceMapConsumer instance represents a parsed source map which we can
		 * query for information about the original file positions by giving it a file
		 * position in the generated source.
		 *
		 * The only parameter is the raw source map (either as a JSON string, or
		 * already parsed to an object). According to the spec, source maps have the
		 * following attributes:
		 *
		 *   - version: Which version of the source map spec this map is following.
		 *   - sources: An array of URLs to the original source files.
		 *   - names: An array of identifiers which can be referrenced by individual mappings.
		 *   - sourceRoot: Optional. The URL root from which all sources are relative.
		 *   - sourcesContent: Optional. An array of contents of the original source files.
		 *   - mappings: A string of base64 VLQs which contain the actual mappings.
		 *   - file: Optional. The generated file this source map is associated with.
		 *
		 * Here is an example source map, taken from the source map spec[0]:
		 *
		 *     {
		 *       version : 3,
		 *       file: "out.js",
		 *       sourceRoot : "",
		 *       sources: ["foo.js", "bar.js"],
		 *       names: ["src", "maps", "are", "fun"],
		 *       mappings: "AA,AB;;ABCDE;"
		 *     }
		 *
		 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
		 */
		function BasicSourceMapConsumer(aSourceMap) {
		  var sourceMap = aSourceMap;
		  if (typeof aSourceMap === 'string') {
		    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
		  }
	
		  var version = util.getArg(sourceMap, 'version');
		  var sources = util.getArg(sourceMap, 'sources');
		  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
		  // requires the array) to play nice here.
		  var names = util.getArg(sourceMap, 'names', []);
		  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
		  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
		  var mappings = util.getArg(sourceMap, 'mappings');
		  var file = util.getArg(sourceMap, 'file', null);
	
		  // Once again, Sass deviates from the spec and supplies the version as a
		  // string rather than a number, so we use loose equality checking here.
		  if (version != this._version) {
		    throw new Error('Unsupported version: ' + version);
		  }
	
		  sources = sources
		    .map(String)
		    // Some source maps produce relative source paths like "./foo.js" instead of
		    // "foo.js".  Normalize these first so that future comparisons will succeed.
		    // See bugzil.la/1090768.
		    .map(util.normalize)
		    // Always ensure that absolute sources are internally stored relative to
		    // the source root, if the source root is absolute. Not doing this would
		    // be particularly problematic when the source root is a prefix of the
		    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
		    .map(function (source) {
		      return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source)
		        ? util.relative(sourceRoot, source)
		        : source;
		    });
	
		  // Pass `true` below to allow duplicate names and sources. While source maps
		  // are intended to be compressed and deduplicated, the TypeScript compiler
		  // sometimes generates source maps with duplicates in them. See Github issue
		  // #72 and bugzil.la/889492.
		  this._names = ArraySet.fromArray(names.map(String), true);
		  this._sources = ArraySet.fromArray(sources, true);
	
		  this.sourceRoot = sourceRoot;
		  this.sourcesContent = sourcesContent;
		  this._mappings = mappings;
		  this.file = file;
		}
	
		BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
		BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
	
		/**
		 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
		 *
		 * @param SourceMapGenerator aSourceMap
		 *        The source map that will be consumed.
		 * @returns BasicSourceMapConsumer
		 */
		BasicSourceMapConsumer.fromSourceMap =
		  function SourceMapConsumer_fromSourceMap(aSourceMap) {
		    var smc = Object.create(BasicSourceMapConsumer.prototype);
	
		    var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
		    var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
		    smc.sourceRoot = aSourceMap._sourceRoot;
		    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(),
		                                                            smc.sourceRoot);
		    smc.file = aSourceMap._file;
	
		    // Because we are modifying the entries (by converting string sources and
		    // names to indices into the sources and names ArraySets), we have to make
		    // a copy of the entry or else bad things happen. Shared mutable state
		    // strikes again! See github issue #191.
	
		    var generatedMappings = aSourceMap._mappings.toArray().slice();
		    var destGeneratedMappings = smc.__generatedMappings = [];
		    var destOriginalMappings = smc.__originalMappings = [];
	
		    for (var i = 0, length = generatedMappings.length; i < length; i++) {
		      var srcMapping = generatedMappings[i];
		      var destMapping = new Mapping;
		      destMapping.generatedLine = srcMapping.generatedLine;
		      destMapping.generatedColumn = srcMapping.generatedColumn;
	
		      if (srcMapping.source) {
		        destMapping.source = sources.indexOf(srcMapping.source);
		        destMapping.originalLine = srcMapping.originalLine;
		        destMapping.originalColumn = srcMapping.originalColumn;
	
		        if (srcMapping.name) {
		          destMapping.name = names.indexOf(srcMapping.name);
		        }
	
		        destOriginalMappings.push(destMapping);
		      }
	
		      destGeneratedMappings.push(destMapping);
		    }
	
		    quickSort(smc.__originalMappings, util.compareByOriginalPositions);
	
		    return smc;
		  };
	
		/**
		 * The version of the source mapping spec that we are consuming.
		 */
		BasicSourceMapConsumer.prototype._version = 3;
	
		/**
		 * The list of original sources.
		 */
		Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
		  get: function () {
		    return this._sources.toArray().map(function (s) {
		      return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
		    }, this);
		  }
		});
	
		/**
		 * Provide the JIT with a nice shape / hidden class.
		 */
		function Mapping() {
		  this.generatedLine = 0;
		  this.generatedColumn = 0;
		  this.source = null;
		  this.originalLine = null;
		  this.originalColumn = null;
		  this.name = null;
		}
	
		/**
		 * Parse the mappings in a string in to a data structure which we can easily
		 * query (the ordered arrays in the `this.__generatedMappings` and
		 * `this.__originalMappings` properties).
		 */
		BasicSourceMapConsumer.prototype._parseMappings =
		  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
		    var generatedLine = 1;
		    var previousGeneratedColumn = 0;
		    var previousOriginalLine = 0;
		    var previousOriginalColumn = 0;
		    var previousSource = 0;
		    var previousName = 0;
		    var length = aStr.length;
		    var index = 0;
		    var cachedSegments = {};
		    var temp = {};
		    var originalMappings = [];
		    var generatedMappings = [];
		    var mapping, str, segment, end, value;
	
		    while (index < length) {
		      if (aStr.charAt(index) === ';') {
		        generatedLine++;
		        index++;
		        previousGeneratedColumn = 0;
		      }
		      else if (aStr.charAt(index) === ',') {
		        index++;
		      }
		      else {
		        mapping = new Mapping();
		        mapping.generatedLine = generatedLine;
	
		        // Because each offset is encoded relative to the previous one,
		        // many segments often have the same encoding. We can exploit this
		        // fact by caching the parsed variable length fields of each segment,
		        // allowing us to avoid a second parse if we encounter the same
		        // segment again.
		        for (end = index; end < length; end++) {
		          if (this._charIsMappingSeparator(aStr, end)) {
		            break;
		          }
		        }
		        str = aStr.slice(index, end);
	
		        segment = cachedSegments[str];
		        if (segment) {
		          index += str.length;
		        } else {
		          segment = [];
		          while (index < end) {
		            base64VLQ.decode(aStr, index, temp);
		            value = temp.value;
		            index = temp.rest;
		            segment.push(value);
		          }
	
		          if (segment.length === 2) {
		            throw new Error('Found a source, but no line and column');
		          }
	
		          if (segment.length === 3) {
		            throw new Error('Found a source and line, but no column');
		          }
	
		          cachedSegments[str] = segment;
		        }
	
		        // Generated column.
		        mapping.generatedColumn = previousGeneratedColumn + segment[0];
		        previousGeneratedColumn = mapping.generatedColumn;
	
		        if (segment.length > 1) {
		          // Original source.
		          mapping.source = previousSource + segment[1];
		          previousSource += segment[1];
	
		          // Original line.
		          mapping.originalLine = previousOriginalLine + segment[2];
		          previousOriginalLine = mapping.originalLine;
		          // Lines are stored 0-based
		          mapping.originalLine += 1;
	
		          // Original column.
		          mapping.originalColumn = previousOriginalColumn + segment[3];
		          previousOriginalColumn = mapping.originalColumn;
	
		          if (segment.length > 4) {
		            // Original name.
		            mapping.name = previousName + segment[4];
		            previousName += segment[4];
		          }
		        }
	
		        generatedMappings.push(mapping);
		        if (typeof mapping.originalLine === 'number') {
		          originalMappings.push(mapping);
		        }
		      }
		    }
	
		    quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
		    this.__generatedMappings = generatedMappings;
	
		    quickSort(originalMappings, util.compareByOriginalPositions);
		    this.__originalMappings = originalMappings;
		  };
	
		/**
		 * Find the mapping that best matches the hypothetical "needle" mapping that
		 * we are searching for in the given "haystack" of mappings.
		 */
		BasicSourceMapConsumer.prototype._findMapping =
		  function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName,
		                                         aColumnName, aComparator, aBias) {
		    // To return the position we are searching for, we must first find the
		    // mapping for the given position and then return the opposite position it
		    // points to. Because the mappings are sorted, we can use binary search to
		    // find the best mapping.
	
		    if (aNeedle[aLineName] <= 0) {
		      throw new TypeError('Line must be greater than or equal to 1, got '
		                          + aNeedle[aLineName]);
		    }
		    if (aNeedle[aColumnName] < 0) {
		      throw new TypeError('Column must be greater than or equal to 0, got '
		                          + aNeedle[aColumnName]);
		    }
	
		    return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
		  };
	
		/**
		 * Compute the last column for each generated mapping. The last column is
		 * inclusive.
		 */
		BasicSourceMapConsumer.prototype.computeColumnSpans =
		  function SourceMapConsumer_computeColumnSpans() {
		    for (var index = 0; index < this._generatedMappings.length; ++index) {
		      var mapping = this._generatedMappings[index];
	
		      // Mappings do not contain a field for the last generated columnt. We
		      // can come up with an optimistic estimate, however, by assuming that
		      // mappings are contiguous (i.e. given two consecutive mappings, the
		      // first mapping ends where the second one starts).
		      if (index + 1 < this._generatedMappings.length) {
		        var nextMapping = this._generatedMappings[index + 1];
	
		        if (mapping.generatedLine === nextMapping.generatedLine) {
		          mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
		          continue;
		        }
		      }
	
		      // The last mapping for each line spans the entire line.
		      mapping.lastGeneratedColumn = Infinity;
		    }
		  };
	
		/**
		 * Returns the original source, line, and column information for the generated
		 * source's line and column positions provided. The only argument is an object
		 * with the following properties:
		 *
		 *   - line: The line number in the generated source.
		 *   - column: The column number in the generated source.
		 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
		 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
		 *     closest element that is smaller than or greater than the one we are
		 *     searching for, respectively, if the exact element cannot be found.
		 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
		 *
		 * and an object is returned with the following properties:
		 *
		 *   - source: The original source file, or null.
		 *   - line: The line number in the original source, or null.
		 *   - column: The column number in the original source, or null.
		 *   - name: The original identifier, or null.
		 */
		BasicSourceMapConsumer.prototype.originalPositionFor =
		  function SourceMapConsumer_originalPositionFor(aArgs) {
		    var needle = {
		      generatedLine: util.getArg(aArgs, 'line'),
		      generatedColumn: util.getArg(aArgs, 'column')
		    };
	
		    var index = this._findMapping(
		      needle,
		      this._generatedMappings,
		      "generatedLine",
		      "generatedColumn",
		      util.compareByGeneratedPositionsDeflated,
		      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
		    );
	
		    if (index >= 0) {
		      var mapping = this._generatedMappings[index];
	
		      if (mapping.generatedLine === needle.generatedLine) {
		        var source = util.getArg(mapping, 'source', null);
		        if (source !== null) {
		          source = this._sources.at(source);
		          if (this.sourceRoot != null) {
		            source = util.join(this.sourceRoot, source);
		          }
		        }
		        var name = util.getArg(mapping, 'name', null);
		        if (name !== null) {
		          name = this._names.at(name);
		        }
		        return {
		          source: source,
		          line: util.getArg(mapping, 'originalLine', null),
		          column: util.getArg(mapping, 'originalColumn', null),
		          name: name
		        };
		      }
		    }
	
		    return {
		      source: null,
		      line: null,
		      column: null,
		      name: null
		    };
		  };
	
		/**
		 * Return true if we have the source content for every source in the source
		 * map, false otherwise.
		 */
		BasicSourceMapConsumer.prototype.hasContentsOfAllSources =
		  function BasicSourceMapConsumer_hasContentsOfAllSources() {
		    if (!this.sourcesContent) {
		      return false;
		    }
		    return this.sourcesContent.length >= this._sources.size() &&
		      !this.sourcesContent.some(function (sc) { return sc == null; });
		  };
	
		/**
		 * Returns the original source content. The only argument is the url of the
		 * original source file. Returns null if no original source content is
		 * available.
		 */
		BasicSourceMapConsumer.prototype.sourceContentFor =
		  function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
		    if (!this.sourcesContent) {
		      return null;
		    }
	
		    if (this.sourceRoot != null) {
		      aSource = util.relative(this.sourceRoot, aSource);
		    }
	
		    if (this._sources.has(aSource)) {
		      return this.sourcesContent[this._sources.indexOf(aSource)];
		    }
	
		    var url;
		    if (this.sourceRoot != null
		        && (url = util.urlParse(this.sourceRoot))) {
		      // XXX: file:// URIs and absolute paths lead to unexpected behavior for
		      // many users. We can help them out when they expect file:// URIs to
		      // behave like it would if they were running a local HTTP server. See
		      // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
		      var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
		      if (url.scheme == "file"
		          && this._sources.has(fileUriAbsPath)) {
		        return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)]
		      }
	
		      if ((!url.path || url.path == "/")
		          && this._sources.has("/" + aSource)) {
		        return this.sourcesContent[this._sources.indexOf("/" + aSource)];
		      }
		    }
	
		    // This function is used recursively from
		    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
		    // don't want to throw if we can't find the source - we just want to
		    // return null, so we provide a flag to exit gracefully.
		    if (nullOnMissing) {
		      return null;
		    }
		    else {
		      throw new Error('"' + aSource + '" is not in the SourceMap.');
		    }
		  };
	
		/**
		 * Returns the generated line and column information for the original source,
		 * line, and column positions provided. The only argument is an object with
		 * the following properties:
		 *
		 *   - source: The filename of the original source.
		 *   - line: The line number in the original source.
		 *   - column: The column number in the original source.
		 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
		 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
		 *     closest element that is smaller than or greater than the one we are
		 *     searching for, respectively, if the exact element cannot be found.
		 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
		 *
		 * and an object is returned with the following properties:
		 *
		 *   - line: The line number in the generated source, or null.
		 *   - column: The column number in the generated source, or null.
		 */
		BasicSourceMapConsumer.prototype.generatedPositionFor =
		  function SourceMapConsumer_generatedPositionFor(aArgs) {
		    var source = util.getArg(aArgs, 'source');
		    if (this.sourceRoot != null) {
		      source = util.relative(this.sourceRoot, source);
		    }
		    if (!this._sources.has(source)) {
		      return {
		        line: null,
		        column: null,
		        lastColumn: null
		      };
		    }
		    source = this._sources.indexOf(source);
	
		    var needle = {
		      source: source,
		      originalLine: util.getArg(aArgs, 'line'),
		      originalColumn: util.getArg(aArgs, 'column')
		    };
	
		    var index = this._findMapping(
		      needle,
		      this._originalMappings,
		      "originalLine",
		      "originalColumn",
		      util.compareByOriginalPositions,
		      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
		    );
	
		    if (index >= 0) {
		      var mapping = this._originalMappings[index];
	
		      if (mapping.source === needle.source) {
		        return {
		          line: util.getArg(mapping, 'generatedLine', null),
		          column: util.getArg(mapping, 'generatedColumn', null),
		          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
		        };
		      }
		    }
	
		    return {
		      line: null,
		      column: null,
		      lastColumn: null
		    };
		  };
	
		exports.BasicSourceMapConsumer = BasicSourceMapConsumer;
	
		/**
		 * An IndexedSourceMapConsumer instance represents a parsed source map which
		 * we can query for information. It differs from BasicSourceMapConsumer in
		 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
		 * input.
		 *
		 * The only parameter is a raw source map (either as a JSON string, or already
		 * parsed to an object). According to the spec for indexed source maps, they
		 * have the following attributes:
		 *
		 *   - version: Which version of the source map spec this map is following.
		 *   - file: Optional. The generated file this source map is associated with.
		 *   - sections: A list of section definitions.
		 *
		 * Each value under the "sections" field has two fields:
		 *   - offset: The offset into the original specified at which this section
		 *       begins to apply, defined as an object with a "line" and "column"
		 *       field.
		 *   - map: A source map definition. This source map could also be indexed,
		 *       but doesn't have to be.
		 *
		 * Instead of the "map" field, it's also possible to have a "url" field
		 * specifying a URL to retrieve a source map from, but that's currently
		 * unsupported.
		 *
		 * Here's an example source map, taken from the source map spec[0], but
		 * modified to omit a section which uses the "url" field.
		 *
		 *  {
		 *    version : 3,
		 *    file: "app.js",
		 *    sections: [{
		 *      offset: {line:100, column:10},
		 *      map: {
		 *        version : 3,
		 *        file: "section.js",
		 *        sources: ["foo.js", "bar.js"],
		 *        names: ["src", "maps", "are", "fun"],
		 *        mappings: "AAAA,E;;ABCDE;"
		 *      }
		 *    }],
		 *  }
		 *
		 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
		 */
		function IndexedSourceMapConsumer(aSourceMap) {
		  var sourceMap = aSourceMap;
		  if (typeof aSourceMap === 'string') {
		    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
		  }
	
		  var version = util.getArg(sourceMap, 'version');
		  var sections = util.getArg(sourceMap, 'sections');
	
		  if (version != this._version) {
		    throw new Error('Unsupported version: ' + version);
		  }
	
		  this._sources = new ArraySet();
		  this._names = new ArraySet();
	
		  var lastOffset = {
		    line: -1,
		    column: 0
		  };
		  this._sections = sections.map(function (s) {
		    if (s.url) {
		      // The url field will require support for asynchronicity.
		      // See https://github.com/mozilla/source-map/issues/16
		      throw new Error('Support for url field in sections not implemented.');
		    }
		    var offset = util.getArg(s, 'offset');
		    var offsetLine = util.getArg(offset, 'line');
		    var offsetColumn = util.getArg(offset, 'column');
	
		    if (offsetLine < lastOffset.line ||
		        (offsetLine === lastOffset.line && offsetColumn < lastOffset.column)) {
		      throw new Error('Section offsets must be ordered and non-overlapping.');
		    }
		    lastOffset = offset;
	
		    return {
		      generatedOffset: {
		        // The offset fields are 0-based, but we use 1-based indices when
		        // encoding/decoding from VLQ.
		        generatedLine: offsetLine + 1,
		        generatedColumn: offsetColumn + 1
		      },
		      consumer: new SourceMapConsumer(util.getArg(s, 'map'))
		    }
		  });
		}
	
		IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
		IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
	
		/**
		 * The version of the source mapping spec that we are consuming.
		 */
		IndexedSourceMapConsumer.prototype._version = 3;
	
		/**
		 * The list of original sources.
		 */
		Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
		  get: function () {
		    var sources = [];
		    for (var i = 0; i < this._sections.length; i++) {
		      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
		        sources.push(this._sections[i].consumer.sources[j]);
		      }
		    }
		    return sources;
		  }
		});
	
		/**
		 * Returns the original source, line, and column information for the generated
		 * source's line and column positions provided. The only argument is an object
		 * with the following properties:
		 *
		 *   - line: The line number in the generated source.
		 *   - column: The column number in the generated source.
		 *
		 * and an object is returned with the following properties:
		 *
		 *   - source: The original source file, or null.
		 *   - line: The line number in the original source, or null.
		 *   - column: The column number in the original source, or null.
		 *   - name: The original identifier, or null.
		 */
		IndexedSourceMapConsumer.prototype.originalPositionFor =
		  function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
		    var needle = {
		      generatedLine: util.getArg(aArgs, 'line'),
		      generatedColumn: util.getArg(aArgs, 'column')
		    };
	
		    // Find the section containing the generated position we're trying to map
		    // to an original position.
		    var sectionIndex = binarySearch.search(needle, this._sections,
		      function(needle, section) {
		        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
		        if (cmp) {
		          return cmp;
		        }
	
		        return (needle.generatedColumn -
		                section.generatedOffset.generatedColumn);
		      });
		    var section = this._sections[sectionIndex];
	
		    if (!section) {
		      return {
		        source: null,
		        line: null,
		        column: null,
		        name: null
		      };
		    }
	
		    return section.consumer.originalPositionFor({
		      line: needle.generatedLine -
		        (section.generatedOffset.generatedLine - 1),
		      column: needle.generatedColumn -
		        (section.generatedOffset.generatedLine === needle.generatedLine
		         ? section.generatedOffset.generatedColumn - 1
		         : 0),
		      bias: aArgs.bias
		    });
		  };
	
		/**
		 * Return true if we have the source content for every source in the source
		 * map, false otherwise.
		 */
		IndexedSourceMapConsumer.prototype.hasContentsOfAllSources =
		  function IndexedSourceMapConsumer_hasContentsOfAllSources() {
		    return this._sections.every(function (s) {
		      return s.consumer.hasContentsOfAllSources();
		    });
		  };
	
		/**
		 * Returns the original source content. The only argument is the url of the
		 * original source file. Returns null if no original source content is
		 * available.
		 */
		IndexedSourceMapConsumer.prototype.sourceContentFor =
		  function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
		    for (var i = 0; i < this._sections.length; i++) {
		      var section = this._sections[i];
	
		      var content = section.consumer.sourceContentFor(aSource, true);
		      if (content) {
		        return content;
		      }
		    }
		    if (nullOnMissing) {
		      return null;
		    }
		    else {
		      throw new Error('"' + aSource + '" is not in the SourceMap.');
		    }
		  };
	
		/**
		 * Returns the generated line and column information for the original source,
		 * line, and column positions provided. The only argument is an object with
		 * the following properties:
		 *
		 *   - source: The filename of the original source.
		 *   - line: The line number in the original source.
		 *   - column: The column number in the original source.
		 *
		 * and an object is returned with the following properties:
		 *
		 *   - line: The line number in the generated source, or null.
		 *   - column: The column number in the generated source, or null.
		 */
		IndexedSourceMapConsumer.prototype.generatedPositionFor =
		  function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
		    for (var i = 0; i < this._sections.length; i++) {
		      var section = this._sections[i];
	
		      // Only consider this section if the requested source is in the list of
		      // sources of the consumer.
		      if (section.consumer.sources.indexOf(util.getArg(aArgs, 'source')) === -1) {
		        continue;
		      }
		      var generatedPosition = section.consumer.generatedPositionFor(aArgs);
		      if (generatedPosition) {
		        var ret = {
		          line: generatedPosition.line +
		            (section.generatedOffset.generatedLine - 1),
		          column: generatedPosition.column +
		            (section.generatedOffset.generatedLine === generatedPosition.line
		             ? section.generatedOffset.generatedColumn - 1
		             : 0)
		        };
		        return ret;
		      }
		    }
	
		    return {
		      line: null,
		      column: null
		    };
		  };
	
		/**
		 * Parse the mappings in a string in to a data structure which we can easily
		 * query (the ordered arrays in the `this.__generatedMappings` and
		 * `this.__originalMappings` properties).
		 */
		IndexedSourceMapConsumer.prototype._parseMappings =
		  function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
		    this.__generatedMappings = [];
		    this.__originalMappings = [];
		    for (var i = 0; i < this._sections.length; i++) {
		      var section = this._sections[i];
		      var sectionMappings = section.consumer._generatedMappings;
		      for (var j = 0; j < sectionMappings.length; j++) {
		        var mapping = sectionMappings[j];
	
		        var source = section.consumer._sources.at(mapping.source);
		        if (section.consumer.sourceRoot !== null) {
		          source = util.join(section.consumer.sourceRoot, source);
		        }
		        this._sources.add(source);
		        source = this._sources.indexOf(source);
	
		        var name = section.consumer._names.at(mapping.name);
		        this._names.add(name);
		        name = this._names.indexOf(name);
	
		        // The mappings coming from the consumer for the section have
		        // generated positions relative to the start of the section, so we
		        // need to offset them to be relative to the start of the concatenated
		        // generated file.
		        var adjustedMapping = {
		          source: source,
		          generatedLine: mapping.generatedLine +
		            (section.generatedOffset.generatedLine - 1),
		          generatedColumn: mapping.generatedColumn +
		            (section.generatedOffset.generatedLine === mapping.generatedLine
		            ? section.generatedOffset.generatedColumn - 1
		            : 0),
		          originalLine: mapping.originalLine,
		          originalColumn: mapping.originalColumn,
		          name: name
		        };
	
		        this.__generatedMappings.push(adjustedMapping);
		        if (typeof adjustedMapping.originalLine === 'number') {
		          this.__originalMappings.push(adjustedMapping);
		        }
		      }
		    }
	
		    quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
		    quickSort(this.__originalMappings, util.compareByOriginalPositions);
		  };
	
		exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		/**
		 * This is a helper function for getting values from parameter/options
		 * objects.
		 *
		 * @param args The object we are extracting values from
		 * @param name The name of the property we are getting.
		 * @param defaultValue An optional value to return if the property is missing
		 * from the object. If this is not specified and the property is missing, an
		 * error will be thrown.
		 */
		function getArg(aArgs, aName, aDefaultValue) {
		  if (aName in aArgs) {
		    return aArgs[aName];
		  } else if (arguments.length === 3) {
		    return aDefaultValue;
		  } else {
		    throw new Error('"' + aName + '" is a required argument.');
		  }
		}
		exports.getArg = getArg;
	
		var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
		var dataUrlRegexp = /^data:.+\,.+$/;
	
		function urlParse(aUrl) {
		  var match = aUrl.match(urlRegexp);
		  if (!match) {
		    return null;
		  }
		  return {
		    scheme: match[1],
		    auth: match[2],
		    host: match[3],
		    port: match[4],
		    path: match[5]
		  };
		}
		exports.urlParse = urlParse;
	
		function urlGenerate(aParsedUrl) {
		  var url = '';
		  if (aParsedUrl.scheme) {
		    url += aParsedUrl.scheme + ':';
		  }
		  url += '//';
		  if (aParsedUrl.auth) {
		    url += aParsedUrl.auth + '@';
		  }
		  if (aParsedUrl.host) {
		    url += aParsedUrl.host;
		  }
		  if (aParsedUrl.port) {
		    url += ":" + aParsedUrl.port
		  }
		  if (aParsedUrl.path) {
		    url += aParsedUrl.path;
		  }
		  return url;
		}
		exports.urlGenerate = urlGenerate;
	
		/**
		 * Normalizes a path, or the path portion of a URL:
		 *
		 * - Replaces consecutive slashes with one slash.
		 * - Removes unnecessary '.' parts.
		 * - Removes unnecessary '<dir>/..' parts.
		 *
		 * Based on code in the Node.js 'path' core module.
		 *
		 * @param aPath The path or url to normalize.
		 */
		function normalize(aPath) {
		  var path = aPath;
		  var url = urlParse(aPath);
		  if (url) {
		    if (!url.path) {
		      return aPath;
		    }
		    path = url.path;
		  }
		  var isAbsolute = exports.isAbsolute(path);
	
		  var parts = path.split(/\/+/);
		  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
		    part = parts[i];
		    if (part === '.') {
		      parts.splice(i, 1);
		    } else if (part === '..') {
		      up++;
		    } else if (up > 0) {
		      if (part === '') {
		        // The first part is blank if the path is absolute. Trying to go
		        // above the root is a no-op. Therefore we can remove all '..' parts
		        // directly after the root.
		        parts.splice(i + 1, up);
		        up = 0;
		      } else {
		        parts.splice(i, 2);
		        up--;
		      }
		    }
		  }
		  path = parts.join('/');
	
		  if (path === '') {
		    path = isAbsolute ? '/' : '.';
		  }
	
		  if (url) {
		    url.path = path;
		    return urlGenerate(url);
		  }
		  return path;
		}
		exports.normalize = normalize;
	
		/**
		 * Joins two paths/URLs.
		 *
		 * @param aRoot The root path or URL.
		 * @param aPath The path or URL to be joined with the root.
		 *
		 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
		 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
		 *   first.
		 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
		 *   is updated with the result and aRoot is returned. Otherwise the result
		 *   is returned.
		 *   - If aPath is absolute, the result is aPath.
		 *   - Otherwise the two paths are joined with a slash.
		 * - Joining for example 'http://' and 'www.example.com' is also supported.
		 */
		function join(aRoot, aPath) {
		  if (aRoot === "") {
		    aRoot = ".";
		  }
		  if (aPath === "") {
		    aPath = ".";
		  }
		  var aPathUrl = urlParse(aPath);
		  var aRootUrl = urlParse(aRoot);
		  if (aRootUrl) {
		    aRoot = aRootUrl.path || '/';
		  }
	
		  // `join(foo, '//www.example.org')`
		  if (aPathUrl && !aPathUrl.scheme) {
		    if (aRootUrl) {
		      aPathUrl.scheme = aRootUrl.scheme;
		    }
		    return urlGenerate(aPathUrl);
		  }
	
		  if (aPathUrl || aPath.match(dataUrlRegexp)) {
		    return aPath;
		  }
	
		  // `join('http://', 'www.example.com')`
		  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
		    aRootUrl.host = aPath;
		    return urlGenerate(aRootUrl);
		  }
	
		  var joined = aPath.charAt(0) === '/'
		    ? aPath
		    : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);
	
		  if (aRootUrl) {
		    aRootUrl.path = joined;
		    return urlGenerate(aRootUrl);
		  }
		  return joined;
		}
		exports.join = join;
	
		exports.isAbsolute = function (aPath) {
		  return aPath.charAt(0) === '/' || !!aPath.match(urlRegexp);
		};
	
		/**
		 * Make a path relative to a URL or another path.
		 *
		 * @param aRoot The root path or URL.
		 * @param aPath The path or URL to be made relative to aRoot.
		 */
		function relative(aRoot, aPath) {
		  if (aRoot === "") {
		    aRoot = ".";
		  }
	
		  aRoot = aRoot.replace(/\/$/, '');
	
		  // It is possible for the path to be above the root. In this case, simply
		  // checking whether the root is a prefix of the path won't work. Instead, we
		  // need to remove components from the root one by one, until either we find
		  // a prefix that fits, or we run out of components to remove.
		  var level = 0;
		  while (aPath.indexOf(aRoot + '/') !== 0) {
		    var index = aRoot.lastIndexOf("/");
		    if (index < 0) {
		      return aPath;
		    }
	
		    // If the only part of the root that is left is the scheme (i.e. http://,
		    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
		    // have exhausted all components, so the path is not relative to the root.
		    aRoot = aRoot.slice(0, index);
		    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
		      return aPath;
		    }
	
		    ++level;
		  }
	
		  // Make sure we add a "../" for each component we removed from the root.
		  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
		}
		exports.relative = relative;
	
		var supportsNullProto = (function () {
		  var obj = Object.create(null);
		  return !('__proto__' in obj);
		}());
	
		function identity (s) {
		  return s;
		}
	
		/**
		 * Because behavior goes wacky when you set `__proto__` on objects, we
		 * have to prefix all the strings in our set with an arbitrary character.
		 *
		 * See https://github.com/mozilla/source-map/pull/31 and
		 * https://github.com/mozilla/source-map/issues/30
		 *
		 * @param String aStr
		 */
		function toSetString(aStr) {
		  if (isProtoString(aStr)) {
		    return '$' + aStr;
		  }
	
		  return aStr;
		}
		exports.toSetString = supportsNullProto ? identity : toSetString;
	
		function fromSetString(aStr) {
		  if (isProtoString(aStr)) {
		    return aStr.slice(1);
		  }
	
		  return aStr;
		}
		exports.fromSetString = supportsNullProto ? identity : fromSetString;
	
		function isProtoString(s) {
		  if (!s) {
		    return false;
		  }
	
		  var length = s.length;
	
		  if (length < 9 /* "__proto__".length */) {
		    return false;
		  }
	
		  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
		      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
		      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
		      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
		      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
		      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
		      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
		      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
		      s.charCodeAt(length - 9) !== 95  /* '_' */) {
		    return false;
		  }
	
		  for (var i = length - 10; i >= 0; i--) {
		    if (s.charCodeAt(i) !== 36 /* '$' */) {
		      return false;
		    }
		  }
	
		  return true;
		}
	
		/**
		 * Comparator between two mappings where the original positions are compared.
		 *
		 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
		 * mappings with the same original source/line/column, but different generated
		 * line and column the same. Useful when searching for a mapping with a
		 * stubbed out mapping.
		 */
		function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
		  var cmp = mappingA.source - mappingB.source;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalLine - mappingB.originalLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalColumn - mappingB.originalColumn;
		  if (cmp !== 0 || onlyCompareOriginal) {
		    return cmp;
		  }
	
		  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.generatedLine - mappingB.generatedLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  return mappingA.name - mappingB.name;
		}
		exports.compareByOriginalPositions = compareByOriginalPositions;
	
		/**
		 * Comparator between two mappings with deflated source and name indices where
		 * the generated positions are compared.
		 *
		 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
		 * mappings with the same generated line and column, but different
		 * source/name/original line and column the same. Useful when searching for a
		 * mapping with a stubbed out mapping.
		 */
		function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
		  var cmp = mappingA.generatedLine - mappingB.generatedLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
		  if (cmp !== 0 || onlyCompareGenerated) {
		    return cmp;
		  }
	
		  cmp = mappingA.source - mappingB.source;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalLine - mappingB.originalLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalColumn - mappingB.originalColumn;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  return mappingA.name - mappingB.name;
		}
		exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
	
		function strcmp(aStr1, aStr2) {
		  if (aStr1 === aStr2) {
		    return 0;
		  }
	
		  if (aStr1 > aStr2) {
		    return 1;
		  }
	
		  return -1;
		}
	
		/**
		 * Comparator between two mappings with inflated source and name strings where
		 * the generated positions are compared.
		 */
		function compareByGeneratedPositionsInflated(mappingA, mappingB) {
		  var cmp = mappingA.generatedLine - mappingB.generatedLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = strcmp(mappingA.source, mappingB.source);
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalLine - mappingB.originalLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalColumn - mappingB.originalColumn;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  return strcmp(mappingA.name, mappingB.name);
		}
		exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		exports.GREATEST_LOWER_BOUND = 1;
		exports.LEAST_UPPER_BOUND = 2;
	
		/**
		 * Recursive implementation of binary search.
		 *
		 * @param aLow Indices here and lower do not contain the needle.
		 * @param aHigh Indices here and higher do not contain the needle.
		 * @param aNeedle The element being searched for.
		 * @param aHaystack The non-empty array being searched.
		 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
		 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
		 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
		 *     closest element that is smaller than or greater than the one we are
		 *     searching for, respectively, if the exact element cannot be found.
		 */
		function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
		  // This function terminates when one of the following is true:
		  //
		  //   1. We find the exact element we are looking for.
		  //
		  //   2. We did not find the exact element, but we can return the index of
		  //      the next-closest element.
		  //
		  //   3. We did not find the exact element, and there is no next-closest
		  //      element than the one we are searching for, so we return -1.
		  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
		  var cmp = aCompare(aNeedle, aHaystack[mid], true);
		  if (cmp === 0) {
		    // Found the element we are looking for.
		    return mid;
		  }
		  else if (cmp > 0) {
		    // Our needle is greater than aHaystack[mid].
		    if (aHigh - mid > 1) {
		      // The element is in the upper half.
		      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
		    }
	
		    // The exact needle element was not found in this haystack. Determine if
		    // we are in termination case (3) or (2) and return the appropriate thing.
		    if (aBias == exports.LEAST_UPPER_BOUND) {
		      return aHigh < aHaystack.length ? aHigh : -1;
		    } else {
		      return mid;
		    }
		  }
		  else {
		    // Our needle is less than aHaystack[mid].
		    if (mid - aLow > 1) {
		      // The element is in the lower half.
		      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
		    }
	
		    // we are in termination case (3) or (2) and return the appropriate thing.
		    if (aBias == exports.LEAST_UPPER_BOUND) {
		      return mid;
		    } else {
		      return aLow < 0 ? -1 : aLow;
		    }
		  }
		}
	
		/**
		 * This is an implementation of binary search which will always try and return
		 * the index of the closest element if there is no exact hit. This is because
		 * mappings between original and generated line/col pairs are single points,
		 * and there is an implicit region between each of them, so a miss just means
		 * that you aren't on the very start of a region.
		 *
		 * @param aNeedle The element you are looking for.
		 * @param aHaystack The array that is being searched.
		 * @param aCompare A function which takes the needle and an element in the
		 *     array and returns -1, 0, or 1 depending on whether the needle is less
		 *     than, equal to, or greater than the element, respectively.
		 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
		 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
		 *     closest element that is smaller than or greater than the one we are
		 *     searching for, respectively, if the exact element cannot be found.
		 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
		 */
		exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
		  if (aHaystack.length === 0) {
		    return -1;
		  }
	
		  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack,
		                              aCompare, aBias || exports.GREATEST_LOWER_BOUND);
		  if (index < 0) {
		    return -1;
		  }
	
		  // We have found either the exact element, or the next-closest element than
		  // the one we are searching for. However, there may be more than one such
		  // element. Make sure we always return the smallest of these.
		  while (index - 1 >= 0) {
		    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
		      break;
		    }
		    --index;
		  }
	
		  return index;
		};
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		var util = __webpack_require__(2);
		var has = Object.prototype.hasOwnProperty;
	
		/**
		 * A data structure which is a combination of an array and a set. Adding a new
		 * member is O(1), testing for membership is O(1), and finding the index of an
		 * element is O(1). Removing elements from the set is not supported. Only
		 * strings are supported for membership.
		 */
		function ArraySet() {
		  this._array = [];
		  this._set = Object.create(null);
		}
	
		/**
		 * Static method for creating ArraySet instances from an existing array.
		 */
		ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
		  var set = new ArraySet();
		  for (var i = 0, len = aArray.length; i < len; i++) {
		    set.add(aArray[i], aAllowDuplicates);
		  }
		  return set;
		};
	
		/**
		 * Return how many unique items are in this ArraySet. If duplicates have been
		 * added, than those do not count towards the size.
		 *
		 * @returns Number
		 */
		ArraySet.prototype.size = function ArraySet_size() {
		  return Object.getOwnPropertyNames(this._set).length;
		};
	
		/**
		 * Add the given string to this set.
		 *
		 * @param String aStr
		 */
		ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
		  var sStr = util.toSetString(aStr);
		  var isDuplicate = has.call(this._set, sStr);
		  var idx = this._array.length;
		  if (!isDuplicate || aAllowDuplicates) {
		    this._array.push(aStr);
		  }
		  if (!isDuplicate) {
		    this._set[sStr] = idx;
		  }
		};
	
		/**
		 * Is the given string a member of this set?
		 *
		 * @param String aStr
		 */
		ArraySet.prototype.has = function ArraySet_has(aStr) {
		  var sStr = util.toSetString(aStr);
		  return has.call(this._set, sStr);
		};
	
		/**
		 * What is the index of the given string in the array?
		 *
		 * @param String aStr
		 */
		ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
		  var sStr = util.toSetString(aStr);
		  if (has.call(this._set, sStr)) {
		    return this._set[sStr];
		  }
		  throw new Error('"' + aStr + '" is not in the set.');
		};
	
		/**
		 * What is the element at the given index?
		 *
		 * @param Number aIdx
		 */
		ArraySet.prototype.at = function ArraySet_at(aIdx) {
		  if (aIdx >= 0 && aIdx < this._array.length) {
		    return this._array[aIdx];
		  }
		  throw new Error('No element indexed by ' + aIdx);
		};
	
		/**
		 * Returns the array representation of this set (which has the proper indices
		 * indicated by indexOf). Note that this is a copy of the internal array used
		 * for storing the members so that no one can mess with internal state.
		 */
		ArraySet.prototype.toArray = function ArraySet_toArray() {
		  return this._array.slice();
		};
	
		exports.ArraySet = ArraySet;
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 *
		 * Based on the Base 64 VLQ implementation in Closure Compiler:
		 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
		 *
		 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
		 * Redistribution and use in source and binary forms, with or without
		 * modification, are permitted provided that the following conditions are
		 * met:
		 *
		 *  * Redistributions of source code must retain the above copyright
		 *    notice, this list of conditions and the following disclaimer.
		 *  * Redistributions in binary form must reproduce the above
		 *    copyright notice, this list of conditions and the following
		 *    disclaimer in the documentation and/or other materials provided
		 *    with the distribution.
		 *  * Neither the name of Google Inc. nor the names of its
		 *    contributors may be used to endorse or promote products derived
		 *    from this software without specific prior written permission.
		 *
		 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
		 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
		 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
		 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
		 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
		 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
		 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
		 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
		 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
		 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
		 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		 */
	
		var base64 = __webpack_require__(6);
	
		// A single base 64 digit can contain 6 bits of data. For the base 64 variable
		// length quantities we use in the source map spec, the first bit is the sign,
		// the next four bits are the actual value, and the 6th bit is the
		// continuation bit. The continuation bit tells us whether there are more
		// digits in this value following this digit.
		//
		//   Continuation
		//   |    Sign
		//   |    |
		//   V    V
		//   101011
	
		var VLQ_BASE_SHIFT = 5;
	
		// binary: 100000
		var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
	
		// binary: 011111
		var VLQ_BASE_MASK = VLQ_BASE - 1;
	
		// binary: 100000
		var VLQ_CONTINUATION_BIT = VLQ_BASE;
	
		/**
		 * Converts from a two-complement value to a value where the sign bit is
		 * placed in the least significant bit.  For example, as decimals:
		 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
		 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
		 */
		function toVLQSigned(aValue) {
		  return aValue < 0
		    ? ((-aValue) << 1) + 1
		    : (aValue << 1) + 0;
		}
	
		/**
		 * Converts to a two-complement value from a value where the sign bit is
		 * placed in the least significant bit.  For example, as decimals:
		 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
		 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
		 */
		function fromVLQSigned(aValue) {
		  var isNegative = (aValue & 1) === 1;
		  var shifted = aValue >> 1;
		  return isNegative
		    ? -shifted
		    : shifted;
		}
	
		/**
		 * Returns the base 64 VLQ encoded value.
		 */
		exports.encode = function base64VLQ_encode(aValue) {
		  var encoded = "";
		  var digit;
	
		  var vlq = toVLQSigned(aValue);
	
		  do {
		    digit = vlq & VLQ_BASE_MASK;
		    vlq >>>= VLQ_BASE_SHIFT;
		    if (vlq > 0) {
		      // There are still more digits in this value, so we must make sure the
		      // continuation bit is marked.
		      digit |= VLQ_CONTINUATION_BIT;
		    }
		    encoded += base64.encode(digit);
		  } while (vlq > 0);
	
		  return encoded;
		};
	
		/**
		 * Decodes the next base 64 VLQ value from the given string and returns the
		 * value and the rest of the string via the out parameter.
		 */
		exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
		  var strLen = aStr.length;
		  var result = 0;
		  var shift = 0;
		  var continuation, digit;
	
		  do {
		    if (aIndex >= strLen) {
		      throw new Error("Expected more digits in base 64 VLQ value.");
		    }
	
		    digit = base64.decode(aStr.charCodeAt(aIndex++));
		    if (digit === -1) {
		      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
		    }
	
		    continuation = !!(digit & VLQ_CONTINUATION_BIT);
		    digit &= VLQ_BASE_MASK;
		    result = result + (digit << shift);
		    shift += VLQ_BASE_SHIFT;
		  } while (continuation);
	
		  aOutParam.value = fromVLQSigned(result);
		  aOutParam.rest = aIndex;
		};
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
	
		/**
		 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
		 */
		exports.encode = function (number) {
		  if (0 <= number && number < intToCharMap.length) {
		    return intToCharMap[number];
		  }
		  throw new TypeError("Must be between 0 and 63: " + number);
		};
	
		/**
		 * Decode a single base 64 character code digit to an integer. Returns -1 on
		 * failure.
		 */
		exports.decode = function (charCode) {
		  var bigA = 65;     // 'A'
		  var bigZ = 90;     // 'Z'
	
		  var littleA = 97;  // 'a'
		  var littleZ = 122; // 'z'
	
		  var zero = 48;     // '0'
		  var nine = 57;     // '9'
	
		  var plus = 43;     // '+'
		  var slash = 47;    // '/'
	
		  var littleOffset = 26;
		  var numberOffset = 52;
	
		  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
		  if (bigA <= charCode && charCode <= bigZ) {
		    return (charCode - bigA);
		  }
	
		  // 26 - 51: abcdefghijklmnopqrstuvwxyz
		  if (littleA <= charCode && charCode <= littleZ) {
		    return (charCode - littleA + littleOffset);
		  }
	
		  // 52 - 61: 0123456789
		  if (zero <= charCode && charCode <= nine) {
		    return (charCode - zero + numberOffset);
		  }
	
		  // 62: +
		  if (charCode == plus) {
		    return 62;
		  }
	
		  // 63: /
		  if (charCode == slash) {
		    return 63;
		  }
	
		  // Invalid base64 digit.
		  return -1;
		};
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		// It turns out that some (most?) JavaScript engines don't self-host
		// `Array.prototype.sort`. This makes sense because C++ will likely remain
		// faster than JS when doing raw CPU-intensive sorting. However, when using a
		// custom comparator function, calling back and forth between the VM's C++ and
		// JIT'd JS is rather slow *and* loses JIT type information, resulting in
		// worse generated code for the comparator function than would be optimal. In
		// fact, when sorting with a comparator, these costs outweigh the benefits of
		// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
		// a ~3500ms mean speed-up in `bench/bench.html`.
	
		/**
		 * Swap the elements indexed by `x` and `y` in the array `ary`.
		 *
		 * @param {Array} ary
		 *        The array.
		 * @param {Number} x
		 *        The index of the first item.
		 * @param {Number} y
		 *        The index of the second item.
		 */
		function swap(ary, x, y) {
		  var temp = ary[x];
		  ary[x] = ary[y];
		  ary[y] = temp;
		}
	
		/**
		 * Returns a random integer within the range `low .. high` inclusive.
		 *
		 * @param {Number} low
		 *        The lower bound on the range.
		 * @param {Number} high
		 *        The upper bound on the range.
		 */
		function randomIntInRange(low, high) {
		  return Math.round(low + (Math.random() * (high - low)));
		}
	
		/**
		 * The Quick Sort algorithm.
		 *
		 * @param {Array} ary
		 *        An array to sort.
		 * @param {function} comparator
		 *        Function to use to compare two items.
		 * @param {Number} p
		 *        Start index of the array
		 * @param {Number} r
		 *        End index of the array
		 */
		function doQuickSort(ary, comparator, p, r) {
		  // If our lower bound is less than our upper bound, we (1) partition the
		  // array into two pieces and (2) recurse on each half. If it is not, this is
		  // the empty array and our base case.
	
		  if (p < r) {
		    // (1) Partitioning.
		    //
		    // The partitioning chooses a pivot between `p` and `r` and moves all
		    // elements that are less than or equal to the pivot to the before it, and
		    // all the elements that are greater than it after it. The effect is that
		    // once partition is done, the pivot is in the exact place it will be when
		    // the array is put in sorted order, and it will not need to be moved
		    // again. This runs in O(n) time.
	
		    // Always choose a random pivot so that an input array which is reverse
		    // sorted does not cause O(n^2) running time.
		    var pivotIndex = randomIntInRange(p, r);
		    var i = p - 1;
	
		    swap(ary, pivotIndex, r);
		    var pivot = ary[r];
	
		    // Immediately after `j` is incremented in this loop, the following hold
		    // true:
		    //
		    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
		    //
		    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
		    for (var j = p; j < r; j++) {
		      if (comparator(ary[j], pivot) <= 0) {
		        i += 1;
		        swap(ary, i, j);
		      }
		    }
	
		    swap(ary, i + 1, j);
		    var q = i + 1;
	
		    // (2) Recurse on each half.
	
		    doQuickSort(ary, comparator, p, q - 1);
		    doQuickSort(ary, comparator, q + 1, r);
		  }
		}
	
		/**
		 * Sort the given array in-place with the given comparator function.
		 *
		 * @param {Array} ary
		 *        An array to sort.
		 * @param {function} comparator
		 *        Function to use to compare two items.
		 */
		exports.quickSort = function (ary, comparator) {
		  doQuickSort(ary, comparator, 0, ary.length - 1);
		};
	
	
	/***/ })
	/******/ ])
	});
	;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	    'use strict';
	    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
	
	    /* istanbul ignore next */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory();
	    } else {
	        root.StackFrame = factory();
	    }
	}(this, function () {
	    'use strict';
	    function _isNumber(n) {
	        return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	
	    function StackFrame(functionName, args, fileName, lineNumber, columnNumber, source) {
	        if (functionName !== undefined) {
	            this.setFunctionName(functionName);
	        }
	        if (args !== undefined) {
	            this.setArgs(args);
	        }
	        if (fileName !== undefined) {
	            this.setFileName(fileName);
	        }
	        if (lineNumber !== undefined) {
	            this.setLineNumber(lineNumber);
	        }
	        if (columnNumber !== undefined) {
	            this.setColumnNumber(columnNumber);
	        }
	        if (source !== undefined) {
	            this.setSource(source);
	        }
	    }
	
	    StackFrame.prototype = {
	        getFunctionName: function () {
	            return this.functionName;
	        },
	        setFunctionName: function (v) {
	            this.functionName = String(v);
	        },
	
	        getArgs: function () {
	            return this.args;
	        },
	        setArgs: function (v) {
	            if (Object.prototype.toString.call(v) !== '[object Array]') {
	                throw new TypeError('Args must be an Array');
	            }
	            this.args = v;
	        },
	
	        // NOTE: Property name may be misleading as it includes the path,
	        // but it somewhat mirrors V8's JavaScriptStackTraceApi
	        // https://code.google.com/p/v8/wiki/JavaScriptStackTraceApi and Gecko's
	        // http://mxr.mozilla.org/mozilla-central/source/xpcom/base/nsIException.idl#14
	        getFileName: function () {
	            return this.fileName;
	        },
	        setFileName: function (v) {
	            this.fileName = String(v);
	        },
	
	        getLineNumber: function () {
	            return this.lineNumber;
	        },
	        setLineNumber: function (v) {
	            if (!_isNumber(v)) {
	                throw new TypeError('Line Number must be a Number');
	            }
	            this.lineNumber = Number(v);
	        },
	
	        getColumnNumber: function () {
	            return this.columnNumber;
	        },
	        setColumnNumber: function (v) {
	            if (!_isNumber(v)) {
	                throw new TypeError('Column Number must be a Number');
	            }
	            this.columnNumber = Number(v);
	        },
	
	        getSource: function () {
	            return this.source;
	        },
	        setSource: function (v) {
	            this.source = String(v);
	        },
	
	        toString: function() {
	            var functionName = this.getFunctionName() || '{anonymous}';
	            var args = '(' + (this.getArgs() || []).join(',') + ')';
	            var fileName = this.getFileName() ? ('@' + this.getFileName()) : '';
	            var lineNumber = _isNumber(this.getLineNumber()) ? (':' + this.getLineNumber()) : '';
	            var columnNumber = _isNumber(this.getColumnNumber()) ? (':' + this.getColumnNumber()) : '';
	            return functionName + args + fileName + lineNumber + columnNumber;
	        }
	    };
	
	    return StackFrame;
	}));


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	var engine = __webpack_require__(1576)
	
	var storages = __webpack_require__(1577)
	var plugins = [__webpack_require__(1574)]
	
	module.exports = engine.createStore(storages, plugins)


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = json2Plugin
	
	function json2Plugin() {
		__webpack_require__(1575)
		return {}
	}


/***/ }),
/* 1575 */
/***/ (function(module, exports) {

	/* eslint-disable */
	
	//  json2.js
	//  2016-10-28
	//  Public Domain.
	//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
	//  See http://www.JSON.org/js.html
	//  This code should be minified before deployment.
	//  See http://javascript.crockford.com/jsmin.html
	
	//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
	//  NOT CONTROL.
	
	//  This file creates a global JSON object containing two methods: stringify
	//  and parse. This file provides the ES5 JSON capability to ES3 systems.
	//  If a project might run on IE8 or earlier, then this file should be included.
	//  This file does nothing on ES5 systems.
	
	//      JSON.stringify(value, replacer, space)
	//          value       any JavaScript value, usually an object or array.
	//          replacer    an optional parameter that determines how object
	//                      values are stringified for objects. It can be a
	//                      function or an array of strings.
	//          space       an optional parameter that specifies the indentation
	//                      of nested structures. If it is omitted, the text will
	//                      be packed without extra whitespace. If it is a number,
	//                      it will specify the number of spaces to indent at each
	//                      level. If it is a string (such as "\t" or "&nbsp;"),
	//                      it contains the characters used to indent at each level.
	//          This method produces a JSON text from a JavaScript value.
	//          When an object value is found, if the object contains a toJSON
	//          method, its toJSON method will be called and the result will be
	//          stringified. A toJSON method does not serialize: it returns the
	//          value represented by the name/value pair that should be serialized,
	//          or undefined if nothing should be serialized. The toJSON method
	//          will be passed the key associated with the value, and this will be
	//          bound to the value.
	
	//          For example, this would serialize Dates as ISO strings.
	
	//              Date.prototype.toJSON = function (key) {
	//                  function f(n) {
	//                      // Format integers to have at least two digits.
	//                      return (n < 10)
	//                          ? "0" + n
	//                          : n;
	//                  }
	//                  return this.getUTCFullYear()   + "-" +
	//                       f(this.getUTCMonth() + 1) + "-" +
	//                       f(this.getUTCDate())      + "T" +
	//                       f(this.getUTCHours())     + ":" +
	//                       f(this.getUTCMinutes())   + ":" +
	//                       f(this.getUTCSeconds())   + "Z";
	//              };
	
	//          You can provide an optional replacer method. It will be passed the
	//          key and value of each member, with this bound to the containing
	//          object. The value that is returned from your method will be
	//          serialized. If your method returns undefined, then the member will
	//          be excluded from the serialization.
	
	//          If the replacer parameter is an array of strings, then it will be
	//          used to select the members to be serialized. It filters the results
	//          such that only members with keys listed in the replacer array are
	//          stringified.
	
	//          Values that do not have JSON representations, such as undefined or
	//          functions, will not be serialized. Such values in objects will be
	//          dropped; in arrays they will be replaced with null. You can use
	//          a replacer function to replace those with JSON values.
	
	//          JSON.stringify(undefined) returns undefined.
	
	//          The optional space parameter produces a stringification of the
	//          value that is filled with line breaks and indentation to make it
	//          easier to read.
	
	//          If the space parameter is a non-empty string, then that string will
	//          be used for indentation. If the space parameter is a number, then
	//          the indentation will be that many spaces.
	
	//          Example:
	
	//          text = JSON.stringify(["e", {pluribus: "unum"}]);
	//          // text is '["e",{"pluribus":"unum"}]'
	
	//          text = JSON.stringify(["e", {pluribus: "unum"}], null, "\t");
	//          // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'
	
	//          text = JSON.stringify([new Date()], function (key, value) {
	//              return this[key] instanceof Date
	//                  ? "Date(" + this[key] + ")"
	//                  : value;
	//          });
	//          // text is '["Date(---current time---)"]'
	
	//      JSON.parse(text, reviver)
	//          This method parses a JSON text to produce an object or array.
	//          It can throw a SyntaxError exception.
	
	//          The optional reviver parameter is a function that can filter and
	//          transform the results. It receives each of the keys and values,
	//          and its return value is used instead of the original value.
	//          If it returns what it received, then the structure is not modified.
	//          If it returns undefined then the member is deleted.
	
	//          Example:
	
	//          // Parse the text. Values that look like ISO date strings will
	//          // be converted to Date objects.
	
	//          myData = JSON.parse(text, function (key, value) {
	//              var a;
	//              if (typeof value === "string") {
	//                  a =
	//   /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
	//                  if (a) {
	//                      return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
	//                          +a[5], +a[6]));
	//                  }
	//              }
	//              return value;
	//          });
	
	//          myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
	//              var d;
	//              if (typeof value === "string" &&
	//                      value.slice(0, 5) === "Date(" &&
	//                      value.slice(-1) === ")") {
	//                  d = new Date(value.slice(5, -1));
	//                  if (d) {
	//                      return d;
	//                  }
	//              }
	//              return value;
	//          });
	
	//  This is a reference implementation. You are free to copy, modify, or
	//  redistribute.
	
	/*jslint
	    eval, for, this
	*/
	
	/*property
	    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
	    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
	    lastIndex, length, parse, prototype, push, replace, slice, stringify,
	    test, toJSON, toString, valueOf
	*/
	
	
	// Create a JSON object only if one does not already exist. We create the
	// methods in a closure to avoid creating global variables.
	
	if (typeof JSON !== "object") {
	    JSON = {};
	}
	
	(function () {
	    "use strict";
	
	    var rx_one = /^[\],:{}\s]*$/;
	    var rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	    var rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	    var rx_four = /(?:^|:|,)(?:\s*\[)+/g;
	    var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
	    var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
	
	    function f(n) {
	        // Format integers to have at least two digits.
	        return n < 10
	            ? "0" + n
	            : n;
	    }
	
	    function this_value() {
	        return this.valueOf();
	    }
	
	    if (typeof Date.prototype.toJSON !== "function") {
	
	        Date.prototype.toJSON = function () {
	
	            return isFinite(this.valueOf())
	                ? this.getUTCFullYear() + "-" +
	                        f(this.getUTCMonth() + 1) + "-" +
	                        f(this.getUTCDate()) + "T" +
	                        f(this.getUTCHours()) + ":" +
	                        f(this.getUTCMinutes()) + ":" +
	                        f(this.getUTCSeconds()) + "Z"
	                : null;
	        };
	
	        Boolean.prototype.toJSON = this_value;
	        Number.prototype.toJSON = this_value;
	        String.prototype.toJSON = this_value;
	    }
	
	    var gap;
	    var indent;
	    var meta;
	    var rep;
	
	
	    function quote(string) {
	
	// If the string contains no control characters, no quote characters, and no
	// backslash characters, then we can safely slap some quotes around it.
	// Otherwise we must also replace the offending characters with safe escape
	// sequences.
	
	        rx_escapable.lastIndex = 0;
	        return rx_escapable.test(string)
	            ? "\"" + string.replace(rx_escapable, function (a) {
	                var c = meta[a];
	                return typeof c === "string"
	                    ? c
	                    : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
	            }) + "\""
	            : "\"" + string + "\"";
	    }
	
	
	    function str(key, holder) {
	
	// Produce a string from holder[key].
	
	        var i;          // The loop counter.
	        var k;          // The member key.
	        var v;          // The member value.
	        var length;
	        var mind = gap;
	        var partial;
	        var value = holder[key];
	
	// If the value has a toJSON method, call it to obtain a replacement value.
	
	        if (value && typeof value === "object" &&
	                typeof value.toJSON === "function") {
	            value = value.toJSON(key);
	        }
	
	// If we were called with a replacer function, then call the replacer to
	// obtain a replacement value.
	
	        if (typeof rep === "function") {
	            value = rep.call(holder, key, value);
	        }
	
	// What happens next depends on the value's type.
	
	        switch (typeof value) {
	        case "string":
	            return quote(value);
	
	        case "number":
	
	// JSON numbers must be finite. Encode non-finite numbers as null.
	
	            return isFinite(value)
	                ? String(value)
	                : "null";
	
	        case "boolean":
	        case "null":
	
	// If the value is a boolean or null, convert it to a string. Note:
	// typeof null does not produce "null". The case is included here in
	// the remote chance that this gets fixed someday.
	
	            return String(value);
	
	// If the type is "object", we might be dealing with an object or an array or
	// null.
	
	        case "object":
	
	// Due to a specification blunder in ECMAScript, typeof null is "object",
	// so watch out for that case.
	
	            if (!value) {
	                return "null";
	            }
	
	// Make an array to hold the partial results of stringifying this object value.
	
	            gap += indent;
	            partial = [];
	
	// Is the value an array?
	
	            if (Object.prototype.toString.apply(value) === "[object Array]") {
	
	// The value is an array. Stringify every element. Use null as a placeholder
	// for non-JSON values.
	
	                length = value.length;
	                for (i = 0; i < length; i += 1) {
	                    partial[i] = str(i, value) || "null";
	                }
	
	// Join all of the elements together, separated with commas, and wrap them in
	// brackets.
	
	                v = partial.length === 0
	                    ? "[]"
	                    : gap
	                        ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]"
	                        : "[" + partial.join(",") + "]";
	                gap = mind;
	                return v;
	            }
	
	// If the replacer is an array, use it to select the members to be stringified.
	
	            if (rep && typeof rep === "object") {
	                length = rep.length;
	                for (i = 0; i < length; i += 1) {
	                    if (typeof rep[i] === "string") {
	                        k = rep[i];
	                        v = str(k, value);
	                        if (v) {
	                            partial.push(quote(k) + (
	                                gap
	                                    ? ": "
	                                    : ":"
	                            ) + v);
	                        }
	                    }
	                }
	            } else {
	
	// Otherwise, iterate through all of the keys in the object.
	
	                for (k in value) {
	                    if (Object.prototype.hasOwnProperty.call(value, k)) {
	                        v = str(k, value);
	                        if (v) {
	                            partial.push(quote(k) + (
	                                gap
	                                    ? ": "
	                                    : ":"
	                            ) + v);
	                        }
	                    }
	                }
	            }
	
	// Join all of the member texts together, separated with commas,
	// and wrap them in braces.
	
	            v = partial.length === 0
	                ? "{}"
	                : gap
	                    ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}"
	                    : "{" + partial.join(",") + "}";
	            gap = mind;
	            return v;
	        }
	    }
	
	// If the JSON object does not yet have a stringify method, give it one.
	
	    if (typeof JSON.stringify !== "function") {
	        meta = {    // table of character substitutions
	            "\b": "\\b",
	            "\t": "\\t",
	            "\n": "\\n",
	            "\f": "\\f",
	            "\r": "\\r",
	            "\"": "\\\"",
	            "\\": "\\\\"
	        };
	        JSON.stringify = function (value, replacer, space) {
	
	// The stringify method takes a value and an optional replacer, and an optional
	// space parameter, and returns a JSON text. The replacer can be a function
	// that can replace values, or an array of strings that will select the keys.
	// A default replacer method can be provided. Use of the space parameter can
	// produce text that is more easily readable.
	
	            var i;
	            gap = "";
	            indent = "";
	
	// If the space parameter is a number, make an indent string containing that
	// many spaces.
	
	            if (typeof space === "number") {
	                for (i = 0; i < space; i += 1) {
	                    indent += " ";
	                }
	
	// If the space parameter is a string, it will be used as the indent string.
	
	            } else if (typeof space === "string") {
	                indent = space;
	            }
	
	// If there is a replacer, it must be a function or an array.
	// Otherwise, throw an error.
	
	            rep = replacer;
	            if (replacer && typeof replacer !== "function" &&
	                    (typeof replacer !== "object" ||
	                    typeof replacer.length !== "number")) {
	                throw new Error("JSON.stringify");
	            }
	
	// Make a fake root object containing our value under the key of "".
	// Return the result of stringifying the value.
	
	            return str("", {"": value});
	        };
	    }
	
	
	// If the JSON object does not yet have a parse method, give it one.
	
	    if (typeof JSON.parse !== "function") {
	        JSON.parse = function (text, reviver) {
	
	// The parse method takes a text and an optional reviver function, and returns
	// a JavaScript value if the text is a valid JSON text.
	
	            var j;
	
	            function walk(holder, key) {
	
	// The walk method is used to recursively walk the resulting structure so
	// that modifications can be made.
	
	                var k;
	                var v;
	                var value = holder[key];
	                if (value && typeof value === "object") {
	                    for (k in value) {
	                        if (Object.prototype.hasOwnProperty.call(value, k)) {
	                            v = walk(value, k);
	                            if (v !== undefined) {
	                                value[k] = v;
	                            } else {
	                                delete value[k];
	                            }
	                        }
	                    }
	                }
	                return reviver.call(holder, key, value);
	            }
	
	
	// Parsing happens in four stages. In the first stage, we replace certain
	// Unicode characters with escape sequences. JavaScript handles many characters
	// incorrectly, either silently deleting them, or treating them as line endings.
	
	            text = String(text);
	            rx_dangerous.lastIndex = 0;
	            if (rx_dangerous.test(text)) {
	                text = text.replace(rx_dangerous, function (a) {
	                    return "\\u" +
	                            ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
	                });
	            }
	
	// In the second stage, we run the text against regular expressions that look
	// for non-JSON patterns. We are especially concerned with "()" and "new"
	// because they can cause invocation, and "=" because it can cause mutation.
	// But just to be safe, we want to reject all unexpected forms.
	
	// We split the second stage into 4 regexp operations in order to work around
	// crippling inefficiencies in IE's and Safari's regexp engines. First we
	// replace the JSON backslash pairs with "@" (a non-JSON character). Second, we
	// replace all simple value tokens with "]" characters. Third, we delete all
	// open brackets that follow a colon or comma or that begin the text. Finally,
	// we look to see that the remaining characters are only whitespace or "]" or
	// "," or ":" or "{" or "}". If that is so, then the text is safe for eval.
	
	            if (
	                rx_one.test(
	                    text
	                        .replace(rx_two, "@")
	                        .replace(rx_three, "]")
	                        .replace(rx_four, "")
	                )
	            ) {
	
	// In the third stage we use the eval function to compile the text into a
	// JavaScript structure. The "{" operator is subject to a syntactic ambiguity
	// in JavaScript: it can begin a block or an object literal. We wrap the text
	// in parens to eliminate the ambiguity.
	
	                j = eval("(" + text + ")");
	
	// In the optional fourth stage, we recursively walk the new structure, passing
	// each name/value pair to a reviver function for possible transformation.
	
	                return (typeof reviver === "function")
	                    ? walk({"": j}, "")
	                    : j;
	            }
	
	// If the text is not JSON parseable, then a SyntaxError is thrown.
	
	            throw new SyntaxError("JSON.parse");
	        };
	    }
	}());

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(162)
	var slice = util.slice
	var pluck = util.pluck
	var each = util.each
	var bind = util.bind
	var create = util.create
	var isList = util.isList
	var isFunction = util.isFunction
	var isObject = util.isObject
	
	module.exports = {
		createStore: createStore
	}
	
	var storeAPI = {
		version: '2.0.12',
		enabled: false,
		
		// get returns the value of the given key. If that value
		// is undefined, it returns optionalDefaultValue instead.
		get: function(key, optionalDefaultValue) {
			var data = this.storage.read(this._namespacePrefix + key)
			return this._deserialize(data, optionalDefaultValue)
		},
	
		// set will store the given value at key and returns value.
		// Calling set with value === undefined is equivalent to calling remove.
		set: function(key, value) {
			if (value === undefined) {
				return this.remove(key)
			}
			this.storage.write(this._namespacePrefix + key, this._serialize(value))
			return value
		},
	
		// remove deletes the key and value stored at the given key.
		remove: function(key) {
			this.storage.remove(this._namespacePrefix + key)
		},
	
		// each will call the given callback once for each key-value pair
		// in this store.
		each: function(callback) {
			var self = this
			this.storage.each(function(val, namespacedKey) {
				callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''))
			})
		},
	
		// clearAll will remove all the stored key-value pairs in this store.
		clearAll: function() {
			this.storage.clearAll()
		},
	
		// additional functionality that can't live in plugins
		// ---------------------------------------------------
	
		// hasNamespace returns true if this store instance has the given namespace.
		hasNamespace: function(namespace) {
			return (this._namespacePrefix == '__storejs_'+namespace+'_')
		},
	
		// createStore creates a store.js instance with the first
		// functioning storage in the list of storage candidates,
		// and applies the the given mixins to the instance.
		createStore: function() {
			return createStore.apply(this, arguments)
		},
		
		addPlugin: function(plugin) {
			this._addPlugin(plugin)
		},
		
		namespace: function(namespace) {
			return createStore(this.storage, this.plugins, namespace)
		}
	}
	
	function _warn() {
		var _console = (typeof console == 'undefined' ? null : console)
		if (!_console) { return }
		var fn = (_console.warn ? _console.warn : _console.log)
		fn.apply(_console, arguments)
	}
	
	function createStore(storages, plugins, namespace) {
		if (!namespace) {
			namespace = ''
		}
		if (storages && !isList(storages)) {
			storages = [storages]
		}
		if (plugins && !isList(plugins)) {
			plugins = [plugins]
		}
	
		var namespacePrefix = (namespace ? '__storejs_'+namespace+'_' : '')
		var namespaceRegexp = (namespace ? new RegExp('^'+namespacePrefix) : null)
		var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
		if (!legalNamespaces.test(namespace)) {
			throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes')
		}
		
		var _privateStoreProps = {
			_namespacePrefix: namespacePrefix,
			_namespaceRegexp: namespaceRegexp,
	
			_testStorage: function(storage) {
				try {
					var testStr = '__storejs__test__'
					storage.write(testStr, testStr)
					var ok = (storage.read(testStr) === testStr)
					storage.remove(testStr)
					return ok
				} catch(e) {
					return false
				}
			},
	
			_assignPluginFnProp: function(pluginFnProp, propName) {
				var oldFn = this[propName]
				this[propName] = function pluginFn() {
					var args = slice(arguments, 0)
					var self = this
	
					// super_fn calls the old function which was overwritten by
					// this mixin.
					function super_fn() {
						if (!oldFn) { return }
						each(arguments, function(arg, i) {
							args[i] = arg
						})
						return oldFn.apply(self, args)
					}
	
					// Give mixing function access to super_fn by prefixing all mixin function
					// arguments with super_fn.
					var newFnArgs = [super_fn].concat(args)
	
					return pluginFnProp.apply(self, newFnArgs)
				}
			},
	
			_serialize: function(obj) {
				return JSON.stringify(obj)
			},
	
			_deserialize: function(strVal, defaultVal) {
				if (!strVal) { return defaultVal }
				// It is possible that a raw string value has been previously stored
				// in a storage without using store.js, meaning it will be a raw
				// string value instead of a JSON serialized string. By defaulting
				// to the raw string value in case of a JSON parse error, we allow
				// for past stored values to be forwards-compatible with store.js
				var val = ''
				try { val = JSON.parse(strVal) }
				catch(e) { val = strVal }
	
				return (val !== undefined ? val : defaultVal)
			},
			
			_addStorage: function(storage) {
				if (this.enabled) { return }
				if (this._testStorage(storage)) {
					this.storage = storage
					this.enabled = true
				}
			},
	
			_addPlugin: function(plugin) {
				var self = this
	
				// If the plugin is an array, then add all plugins in the array.
				// This allows for a plugin to depend on other plugins.
				if (isList(plugin)) {
					each(plugin, function(plugin) {
						self._addPlugin(plugin)
					})
					return
				}
	
				// Keep track of all plugins we've seen so far, so that we
				// don't add any of them twice.
				var seenPlugin = pluck(this.plugins, function(seenPlugin) {
					return (plugin === seenPlugin)
				})
				if (seenPlugin) {
					return
				}
				this.plugins.push(plugin)
	
				// Check that the plugin is properly formed
				if (!isFunction(plugin)) {
					throw new Error('Plugins must be function values that return objects')
				}
	
				var pluginProperties = plugin.call(this)
				if (!isObject(pluginProperties)) {
					throw new Error('Plugins must return an object of function properties')
				}
	
				// Add the plugin function properties to this store instance.
				each(pluginProperties, function(pluginFnProp, propName) {
					if (!isFunction(pluginFnProp)) {
						throw new Error('Bad plugin property: '+propName+' from plugin '+plugin.name+'. Plugins should only return functions.')
					}
					self._assignPluginFnProp(pluginFnProp, propName)
				})
			},
			
			// Put deprecated properties in the private API, so as to not expose it to accidential
			// discovery through inspection of the store object.
			
			// Deprecated: addStorage
			addStorage: function(storage) {
				_warn('store.addStorage(storage) is deprecated. Use createStore([storages])')
				this._addStorage(storage)
			}
		}
	
		var store = create(_privateStoreProps, storeAPI, {
			plugins: []
		})
		store.raw = {}
		each(store, function(prop, propName) {
			if (isFunction(prop)) {
				store.raw[propName] = bind(store, prop)			
			}
		})
		each(storages, function(storage) {
			store._addStorage(storage)
		})
		each(plugins, function(plugin) {
			store._addPlugin(plugin)
		})
		return store
	}


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = [
		// Listed in order of usage preference
		__webpack_require__(1579),
		__webpack_require__(1581),
		__webpack_require__(1582),
		__webpack_require__(1578),
		__webpack_require__(1583),
		__webpack_require__(1580)
	]


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	// cookieStorage is useful Safari private browser mode, where localStorage
	// doesn't work but cookies do. This implementation is adopted from
	// https://developer.mozilla.org/en-US/docs/Web/API/Storage/LocalStorage
	
	var util = __webpack_require__(162)
	var Global = util.Global
	var trim = util.trim
	
	module.exports = {
		name: 'cookieStorage',
		read: read,
		write: write,
		each: each,
		remove: remove,
		clearAll: clearAll,
	}
	
	var doc = Global.document
	
	function read(key) {
		if (!key || !_has(key)) { return null }
		var regexpStr = "(?:^|.*;\\s*)" +
			escape(key).replace(/[\-\.\+\*]/g, "\\$&") +
			"\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*"
		return unescape(doc.cookie.replace(new RegExp(regexpStr), "$1"))
	}
	
	function each(callback) {
		var cookies = doc.cookie.split(/; ?/g)
		for (var i = cookies.length - 1; i >= 0; i--) {
			if (!trim(cookies[i])) {
				continue
			}
			var kvp = cookies[i].split('=')
			var key = unescape(kvp[0])
			var val = unescape(kvp[1])
			callback(val, key)
		}
	}
	
	function write(key, data) {
		if(!key) { return }
		doc.cookie = escape(key) + "=" + escape(data) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/"
	}
	
	function remove(key) {
		if (!key || !_has(key)) {
			return
		}
		doc.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/"
	}
	
	function clearAll() {
		each(function(_, key) {
			remove(key)
		})
	}
	
	function _has(key) {
		return (new RegExp("(?:^|;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(doc.cookie)
	}


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(162)
	var Global = util.Global
	
	module.exports = {
		name: 'localStorage',
		read: read,
		write: write,
		each: each,
		remove: remove,
		clearAll: clearAll,
	}
	
	function localStorage() {
		return Global.localStorage
	}
	
	function read(key) {
		return localStorage().getItem(key)
	}
	
	function write(key, data) {
		return localStorage().setItem(key, data)
	}
	
	function each(fn) {
		for (var i = localStorage().length - 1; i >= 0; i--) {
			var key = localStorage().key(i)
			fn(read(key), key)
		}
	}
	
	function remove(key) {
		return localStorage().removeItem(key)
	}
	
	function clearAll() {
		return localStorage().clear()
	}


/***/ }),
/* 1580 */
/***/ (function(module, exports) {

	// memoryStorage is a useful last fallback to ensure that the store
	// is functions (meaning store.get(), store.set(), etc will all function).
	// However, stored values will not persist when the browser navigates to
	// a new page or reloads the current page.
	
	module.exports = {
		name: 'memoryStorage',
		read: read,
		write: write,
		each: each,
		remove: remove,
		clearAll: clearAll,
	}
	
	var memoryStorage = {}
	
	function read(key) {
		return memoryStorage[key]
	}
	
	function write(key, data) {
		memoryStorage[key] = data
	}
	
	function each(callback) {
		for (var key in memoryStorage) {
			if (memoryStorage.hasOwnProperty(key)) {
				callback(memoryStorage[key], key)
			}
		}
	}
	
	function remove(key) {
		delete memoryStorage[key]
	}
	
	function clearAll(key) {
		memoryStorage = {}
	}


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	// oldFF-globalStorage provides storage for Firefox
	// versions 6 and 7, where no localStorage, etc
	// is available.
	
	var util = __webpack_require__(162)
	var Global = util.Global
	
	module.exports = {
		name: 'oldFF-globalStorage',
		read: read,
		write: write,
		each: each,
		remove: remove,
		clearAll: clearAll,
	}
	
	var globalStorage = Global.globalStorage
	
	function read(key) {
		return globalStorage[key]
	}
	
	function write(key, data) {
		globalStorage[key] = data
	}
	
	function each(fn) {
		for (var i = globalStorage.length - 1; i >= 0; i--) {
			var key = globalStorage.key(i)
			fn(globalStorage[key], key)
		}
	}
	
	function remove(key) {
		return globalStorage.removeItem(key)
	}
	
	function clearAll() {
		each(function(key, _) {
			delete globalStorage[key]
		})
	}


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	// oldIE-userDataStorage provides storage for Internet Explorer
	// versions 6 and 7, where no localStorage, sessionStorage, etc
	// is available.
	
	var util = __webpack_require__(162)
	var Global = util.Global
	
	module.exports = {
		name: 'oldIE-userDataStorage',
		write: write,
		read: read,
		each: each,
		remove: remove,
		clearAll: clearAll,
	}
	
	var storageName = 'storejs'
	var doc = Global.document
	var _withStorageEl = _makeIEStorageElFunction()
	var disable = (Global.navigator ? Global.navigator.userAgent : '').match(/ (MSIE 8|MSIE 9|MSIE 10)\./) // MSIE 9.x, MSIE 10.x
	
	function write(unfixedKey, data) {
		if (disable) { return }
		var fixedKey = fixKey(unfixedKey)
		_withStorageEl(function(storageEl) {
			storageEl.setAttribute(fixedKey, data)
			storageEl.save(storageName)
		})
	}
	
	function read(unfixedKey) {
		if (disable) { return }
		var fixedKey = fixKey(unfixedKey)
		var res = null
		_withStorageEl(function(storageEl) {
			res = storageEl.getAttribute(fixedKey)
		})
		return res
	}
	
	function each(callback) {
		_withStorageEl(function(storageEl) {
			var attributes = storageEl.XMLDocument.documentElement.attributes
			for (var i=attributes.length-1; i>=0; i--) {
				var attr = attributes[i]
				callback(storageEl.getAttribute(attr.name), attr.name)
			}
		})
	}
	
	function remove(unfixedKey) {
		var fixedKey = fixKey(unfixedKey)
		_withStorageEl(function(storageEl) {
			storageEl.removeAttribute(fixedKey)
			storageEl.save(storageName)
		})
	}
	
	function clearAll() {
		_withStorageEl(function(storageEl) {
			var attributes = storageEl.XMLDocument.documentElement.attributes
			storageEl.load(storageName)
			for (var i=attributes.length-1; i>=0; i--) {
				storageEl.removeAttribute(attributes[i].name)
			}
			storageEl.save(storageName)
		})
	}
	
	// Helpers
	//////////
	
	// In IE7, keys cannot start with a digit or contain certain chars.
	// See https://github.com/marcuswestin/store.js/issues/40
	// See https://github.com/marcuswestin/store.js/issues/83
	var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g")
	function fixKey(key) {
		return key.replace(/^\d/, '___$&').replace(forbiddenCharsRegex, '___')
	}
	
	function _makeIEStorageElFunction() {
		if (!doc || !doc.documentElement || !doc.documentElement.addBehavior) {
			return null
		}
		var scriptTag = 'script',
			storageOwner,
			storageContainer,
			storageEl
	
		// Since #userData storage applies only to specific paths, we need to
		// somehow link our data to a specific path.  We choose /favicon.ico
		// as a pretty safe option, since all browsers already make a request to
		// this URL anyway and being a 404 will not hurt us here.  We wrap an
		// iframe pointing to the favicon in an ActiveXObject(htmlfile) object
		// (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
		// since the iframe access rules appear to allow direct access and
		// manipulation of the document element, even for a 404 page.  This
		// document can be used instead of the current document (which would
		// have been limited to the current path) to perform #userData storage.
		try {
			/* global ActiveXObject */
			storageContainer = new ActiveXObject('htmlfile')
			storageContainer.open()
			storageContainer.write('<'+scriptTag+'>document.w=window</'+scriptTag+'><iframe src="/favicon.ico"></iframe>')
			storageContainer.close()
			storageOwner = storageContainer.w.frames[0].document
			storageEl = storageOwner.createElement('div')
		} catch(e) {
			// somehow ActiveXObject instantiation failed (perhaps some special
			// security settings or otherwse), fall back to per-path storage
			storageEl = doc.createElement('div')
			storageOwner = doc.body
		}
	
		return function(storeFunction) {
			var args = [].slice.call(arguments, 0)
			args.unshift(storageEl)
			// See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
			// and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
			storageOwner.appendChild(storageEl)
			storageEl.addBehavior('#default#userData')
			storageEl.load(storageName)
			storeFunction.apply(this, args)
			storageOwner.removeChild(storageEl)
			return
		}
	}


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(162)
	var Global = util.Global
	
	module.exports = {
		name: 'sessionStorage',
		read: read,
		write: write,
		each: each,
		remove: remove,
		clearAll: clearAll
	}
	
	function sessionStorage() {
		return Global.sessionStorage
	}
	
	function read(key) {
		return sessionStorage().getItem(key)
	}
	
	function write(key, data) {
		return sessionStorage().setItem(key, data)
	}
	
	function each(fn) {
		for (var i = sessionStorage().length - 1; i >= 0; i--) {
			var key = sessionStorage().key(i)
			fn(read(key), key)
		}
	}
	
	function remove(key) {
		return sessionStorage().removeItem(key)
	}
	
	function clearAll() {
		return sessionStorage().clear()
	}


/***/ }),
/* 1584 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = BaseMixin;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BaseMixin(origin) {
	    return function (_origin) {
	        (0, _inherits3.default)(_class, _origin);
	
	        function _class() {
	            (0, _classCallCheck3.default)(this, _class);
	            return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));
	        }
	
	        (0, _createClass3.default)(_class, [{
	            key: "clearNullUndefinedProps",
	            value: function clearNullUndefinedProps() {
	                for (var key in this) {
	                    if (this[key] == null) {
	                        delete this[key];
	                    }
	                }
	
	                return this;
	            }
	        }]);
	        return _class;
	    }(origin);
	}
	module.exports = exports['default'];

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmRegistrationRequestModel = function ConfirmRegistrationRequestModel(props) {
	    (0, _classCallCheck3.default)(this, ConfirmRegistrationRequestModel);
	
	    this.shopId = props.shopId;
	    this.password = props.password;
	    // Бакэнд-и просят, чтобы не отправляли email eсли кода нет
	    this.email = props.email_code ? props.email : undefined;
	    this.ul_name = props.ul_name;
	    this.username = props.username;
	    // Бакэнд-и просят, чтобы не отправляли phone eсли кода нет
	    this.phone = props.sms_code ? props.phone : undefined;
	    this.inn = props.inn;
	    this.sms_code = props.sms_code ? props.sms_code : undefined;
	    this.email_code = props.email_code ? props.email_code : undefined;
	};
	
	exports.default = ConfirmRegistrationRequestModel;
	module.exports = exports['default'];

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _assign = __webpack_require__(142);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShopParameters = function () {
	    //
	
	    function ShopParameters(data) {
	        (0, _classCallCheck3.default)(this, ShopParameters);
	        this.params = null;
	
	        (0, _assign2.default)(this, data);
	
	        this.normalizeParams();
	    }
	
	    (0, _createClass3.default)(ShopParameters, [{
	        key: 'normalizeParams',
	        value: function normalizeParams() {
	            var params = this.params;
	
	            if (typeof params === 'string') {
	                try {
	                    params = JSON.parse(params);
	                } catch (e) {}
	            }
	
	            if ((typeof params === 'undefined' ? 'undefined' : (0, _typeof3.default)(params)) === 'object') {
	                var nParams = [];
	                for (var key in params) {
	                    params[key].slug = key;
	                    nParams.push(params[key]);
	                }
	
	                params = nParams;
	            }
	
	            this.params = Array.isArray(params) ? params : [];
	        }
	    }]);
	    return ShopParameters;
	}();
	
	exports.default = ShopParameters;
	module.exports = exports['default'];

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _utils = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShopSettingsResponseModel = function ShopSettingsResponseModel(settings) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ShopSettingsResponseModel);
	
	    this.channelId = settings.id;
	    this.profileId = settings.profile_id;
	
	    if (settings.seo) {
	        this.seoSlug = settings.seo.slug;
	        this.seoTitle = settings.seo.title;
	        this.seoH1 = settings.seo.h1;
	        this.seoDescription = settings.seo.description;
	        this.seoKeywords = settings.seo.keywords;
	        this.seoSemanticUrl = settings.seo.semantic_url;
	        this.seoIndexation = settings.seo.indexation;
	    }
	
	    if (settings.currency) {
	        this.currency = settings.currency;
	    }
	
	    if (settings.additionalFieldSettings) {
	        this.additionalFieldSettings = settings.additionalFieldSettings;
	    }
	
	    if (settings.onlineShop) {
	        this.shopName = settings.onlineShop.name;
	        this.shopId = settings.onlineShop.id;
	        this.shopIsOpen = !!settings.onlineShop.is_open;
	        this.shopWorkSuspended = !!settings.onlineShop.work_suspended;
	        this.onlineAdvisorCode = settings.onlineShop.online_advisor_code ? settings.onlineShop.online_advisor_code : '';
	        this.googleAnalyticsCode = settings.onlineShop.google_analytics_code ? settings.onlineShop.google_analytics_code : '';
	        this.yandexMetrikaCode = settings.onlineShop.yandex_metrika_code ? settings.onlineShop.yandex_metrika_code : '';
	        this.pipoOnlineShopId = settings.onlineShop.pipo_online_shop_id;
	        this.rootCategory = settings.onlineShop.root_category;
	        this.orderInOneClick = settings.onlineShop.order_in_one_click;
	        this.googleTagManagerHead = settings.onlineShop.google_tag_manager_head ? settings.onlineShop.google_tag_manager_head : '';
	        this.googleTagManagerBody = settings.onlineShop.google_tag_manager_body ? settings.onlineShop.google_tag_manager_body : '';
	        var contacts = JSON.parse(settings.onlineShop.contacts);
	        if (contacts.cartButtons === undefined) {
	            contacts.cartButtons = {
	                buttonName: 'В корзину',
	                buttonOneClickName: 'Купить в один клик'
	            };
	        }
	        this.addBasketButtonName = contacts.cartButtons.buttonName ? contacts.cartButtons.buttonName : 'В корзину';
	        this.addBasketButtonOneClickName = contacts.cartButtons.buttonOneClickName ? contacts.cartButtons.buttonOneClickName : 'Купить в один клик';
	        if (contacts.customFields === undefined) {
	            contacts.customFields = [];
	        }
	        this.customFields = contacts.customFields;
	        this.buyInCreditActive = false;
	        this.buyInCredit = {};
	        if (settings.onlineShop.buyInCredit) {
	            this.buyInCreditActive = settings.onlineShop.buyInCredit.enable;
	            this.buyInCredit = settings.onlineShop.buyInCredit;
	        }
	        this.googleCaptcha = settings.onlineShop.google_captcha;
	        this.googleCaptchaSitekey = settings.onlineShop.google_captcha_sitekey ? settings.onlineShop.google_captcha_sitekey : '';
	        this.turnstileCaptcha = settings.onlineShop.turnstile_captcha;
	        this.turnstileCaptchaSitekey = settings.onlineShop.turnstile_captcha_sitekey ? settings.onlineShop.turnstile_captcha_sitekey : '';
	    }
	
	    if (settings.onlineShopContent) {
	        this.logo = settings.onlineShopContent.logo;
	        this.logoPreview = settings.onlineShopContent.logo_preview;
	        this.favicon = settings.onlineShopContent.favicon;
	        this.faviconPreview = settings.onlineShopContent.favicon_preview;
	        this.phoneShow = settings.onlineShopContent.phone_show;
	        this.phone = settings.onlineShopContent.phone;
	        this.operationModeShow = settings.onlineShopContent.operation_mode_show;
	        this.operationMode = settings.onlineShopContent.operation_mode;
	        this.basementText = settings.onlineShopContent.basement_text;
	        this.slider_novelty = settings.onlineShopContent.slider_novelty;
	        this.slider_hits = settings.onlineShopContent.slider_hits;
	        this.slider_popular = settings.onlineShopContent.slider_popular;
	        this.slider_category = settings.onlineShopContent.slider_category;
	        this.themeColorId = parseInt(settings.onlineShopContent.theme_color_id) || 1;
	        this.theme = (0, _utils.getCurrentThemeByColorId)(this.themeColorId);
	        this.cartDescription = settings.onlineShopContent.cart_description;
	        this.cartSubject = settings.onlineShopContent.cart_subject;
	
	        this.deliveryFieldShow = !!settings.onlineShopContent.delivery_field_show; // показ textarea при создании заказа
	        this.commentFieldShow = !!settings.onlineShopContent.comment_field_show; // показ textarea при создании заказа
	        this.commentFieldTitle = settings.onlineShopContent.comment_field_title; // показ название textarea при создании заказа
	        this.commentFieldPlaceholder = settings.onlineShopContent.comment_field_placeholder; // показ placeholder textarea при создании заказа
	    }
	
	    if (settings.onlineShopPages) {
	        this.onlineShopPages = settings.onlineShopPages;
	        if (this.buyInCreditActive) {
	            this.onlineShopPages.forEach(function (page) {
	                if (page.id === _this.buyInCredit.page_id) {
	                    _this.buyInCredit.page = page.url_pages;
	                }
	            });
	        }
	    }
	    this.loyaltySettingsActive = false;
	    if (settings.loyaltySettings) {
	        this.loyaltySettingsActive = settings.loyaltySettings.active;
	        this.loyaltySettingsData = settings.loyaltySettings.settingsForShop;
	    }
	    if (settings.use_ibonus_loyalty !== true) {
	        this.loyaltySettingsActive = false;
	    }
	};
	
	exports.default = ShopSettingsResponseModel;
	module.exports = exports['default'];

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ConfirmRegistrationRequest = __webpack_require__(1586);
	
	var _ConfirmRegistrationRequest2 = _interopRequireDefault(_ConfirmRegistrationRequest);
	
	var _ShopParameters = __webpack_require__(1587);
	
	var _ShopParameters2 = _interopRequireDefault(_ShopParameters);
	
	var _ShopSettingsResponse = __webpack_require__(1588);
	
	var _ShopSettingsResponse2 = _interopRequireDefault(_ShopSettingsResponse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var map = {
	    ConfirmRegistrationRequest: _ConfirmRegistrationRequest2.default,
	    ShopParameters: _ShopParameters2.default,
	    ShopSettingsResponse: _ShopSettingsResponse2.default
	};
	
	exports.default = map;
	module.exports = exports['default'];

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(390);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(267);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(58);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _desc, _value, _class;
	
	var _IBonusApi = __webpack_require__(1591);
	
	var _IBonusApi2 = _interopRequireDefault(_IBonusApi);
	
	var _PIPOApi = __webpack_require__(1592);
	
	var _PIPOApi2 = _interopRequireDefault(_PIPOApi);
	
	var _IBonusError = __webpack_require__(191);
	
	var _IBonusError2 = _interopRequireDefault(_IBonusError);
	
	var _log = __webpack_require__(764);
	
	var _config = __webpack_require__(761);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Factory = __webpack_require__(259);
	
	var _Factory2 = _interopRequireDefault(_Factory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	    var desc = {};
	    Object['ke' + 'ys'](descriptor).forEach(function (key) {
	        desc[key] = descriptor[key];
	    });
	    desc.enumerable = !!desc.enumerable;
	    desc.configurable = !!desc.configurable;
	
	    if ('value' in desc || desc.initializer) {
	        desc.writable = true;
	    }
	
	    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	        return decorator(target, property, desc) || desc;
	    }, desc);
	
	    if (context && desc.initializer !== void 0) {
	        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	        desc.initializer = undefined;
	    }
	
	    if (desc.initializer === void 0) {
	        Object['define' + 'Property'](target, property, desc);
	        desc = null;
	    }
	
	    return desc;
	}
	
	var ERROR_USER_INVALID_ACCESS_TOKEN = 'user.invalid_access_token';
	
	var IBonus = (_class = function () {
	    function IBonus(client, storage) {
	        (0, _classCallCheck3.default)(this, IBonus);
	
	        this.config = {};
	        this.storage = storage;
	        this.api = new _IBonusApi2.default(client, storage);
	        this.pipo = new _PIPOApi2.default(client);
	
	        this.channelId = 0;
	        this.profileId = 0;
	        this.onlineShopId = 0;
	        this.currentAccessToken = '';
	    }
	
	    (0, _createClass3.default)(IBonus, [{
	        key: 'onRefresh',
	        value: function onRefresh(callback) {
	            var _this = this;
	
	            if (this.access_token) {
	                return callback().then(function (res) {
	                    return res;
	                }, function (err) {
	                    if (err.title && err.title === ERROR_USER_INVALID_ACCESS_TOKEN) {
	                        if (_this.refresh_token) {
	                            return _this.api.user.updateAccessToken({
	                                client_id: _config2.default.client_id,
	                                client_secret: _config2.default.client_secret,
	                                refresh_token: _this.refresh_token
	                            }).then(function (result) {
	                                if (result.access_token) {
	                                    _this.access_token = result.access_token;
	                                }
	                                if (result.refresh_token) {
	                                    _this.refresh_token = result.refresh_token;
	                                }
	                                return callback();
	                            }, function (err) {
	                                _this.access_token = null;
	                                _this.refresh_token = null;
	                                throw err;
	                            });
	                        }
	                    }
	
	                    throw err;
	                });
	            }
	
	            console.log('\n\nREFRESH_TOKEN_ERROR\n\n');
	
	            return _promise2.default.reject({
	                code: 301
	            });
	        }
	    }, {
	        key: 'userAuthentication',
	        value: function userAuthentication(username, password) {
	            var captcha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	            var shopId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	            return _promise2.default.all([this.api.user.authentication({
	                username: username,
	                password: password,
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                captcha: captcha,
	                shopId: shopId
	            })]
	            //this.pipo.login(username, password)
	            ).then(function (result) {
	                var _result = (0, _slicedToArray3.default)(result, 1),
	                    resultIRetail = _result[0];
	
	                resultIRetail.api_key = 'TbFWtJ3oTxFOzQeF8spkDNAv'; //не используется, выпилить
	                resultIRetail.pipo_user_id = resultIRetail.user_id;
	
	                return resultIRetail;
	            });
	        }
	    }, {
	        key: 'userRegistration',
	        value: function userRegistration(password, shopId, params) {
	            return this.api.user.register((0, _extends3.default)({
	                password: password,
	                shopId: shopId
	            }, params));
	        }
	    }, {
	        key: 'userConfirmRegistration',
	        value: function userConfirmRegistration(_password, _shopId, _params) {
	            var _ModelFactory$create = _Factory2.default.create('ConfirmRegistrationRequest', (0, _extends3.default)({
	                shopId: _shopId,
	                password: _password
	            }, _params)),
	                password = _ModelFactory$create.password,
	                shopId = _ModelFactory$create.shopId,
	                params = (0, _objectWithoutProperties3.default)(_ModelFactory$create, ['password', 'shopId']);
	
	            return this.api.user.confirmRegister((0, _extends3.default)({
	                password: password,
	                shopId: shopId
	            }, params)).then(function (result) {
	                var message = [];
	
	                if (result === true) {
	                    return result;
	                } else {
	                    if (result.errorCodePhone) {
	                        message.push('Проверочный код из смс введён неверно. Повторите попытку.');
	                    }
	
	                    if (result.errorCodeEmail) {
	                        message.push('Проверочный код, отправленный на email, введён неверно. Повторите попытку.');
	                    }
	
	                    throw new _IBonusError2.default({
	                        message: message.length === 2 ? message : message[0],
	                        title: 'Неверный проверочный код',
	                        code: '',
	                        trace: ''
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'userRegistrationOneClick',
	        value: function userRegistrationOneClick(shopId, params) {
	            return this.api.user.registerOneClick((0, _extends3.default)({
	                shopId: shopId
	            }, params));
	        }
	    }, {
	        key: 'userConfirmRegistrationOneClick',
	        value: function userConfirmRegistrationOneClick(shopId, params) {
	            return this.api.user.confirmRegisterOneClick((0, _extends3.default)({
	                shopId: shopId
	            }, params)).then(function (result) {
	                var message = [];
	                if (result.access_token) {
	                    return result;
	                } else {
	                    if (result.errorCodePhone) {
	                        message.push('Проверочный код из смс введён неверно. Повторите попытку.');
	                    }
	
	                    if (result.errorCodeEmail) {
	                        message.push('Проверочный код, отправленный на email, введён неверно. Повторите попытку.');
	                    }
	
	                    throw new _IBonusError2.default({
	                        message: message.length === 2 ? message : message[0],
	                        title: 'Неверный проверочный код',
	                        code: '',
	                        trace: ''
	                    });
	                }
	            });
	        }
	
	        /**
	         *Отправка СМС для востановления пароля
	         */
	
	    }, {
	        key: 'passRecoverySend',
	        value: function passRecoverySend(login, id_shop) {
	            return this.api.user.sendCode({ login: login, id_shop: id_shop });
	        }
	    }, {
	        key: 'getPaymentsParamsFromPIPObyId',
	        value: function getPaymentsParamsFromPIPObyId(shopPipoId) {
	            return this.pipo.getPaymentsParamsFromPIPObyId(shopPipoId);
	        }
	    }, {
	        key: 'sendVoiceCode',
	        value: function sendVoiceCode(login, source, phone) {
	            return this.api.user.sendVoiceCode({ login: login, source: source, phone: phone });
	        }
	    }, {
	        key: 'userRestorePassword',
	        value: function userRestorePassword(login, newPassword, code) {
	            return this.api.user.restorePassword({
	                code: code,
	                login: login,
	                new_password: newPassword,
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                remember_me: true
	            }).then(function (result) {
	                if (!result) {
	                    throw new _IBonusError2.default({
	                        message: 'Проверочный код введён неверно. Повторите попытку.',
	                        title: 'Неверный проверочный код',
	                        code: '',
	                        trace: ''
	                    });
	                } else {
	                    return result;
	                }
	            });
	        }
	    }, {
	        key: 'getUserData',
	        value: function getUserData() {
	            var _this2 = this;
	
	            var access_token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	            if (access_token !== '' && access_token !== null) {
	                this.access_token = access_token;
	                this.storage.setItem('access_token', access_token);
	            } else {
	                access_token = this.access_token;
	            }
	            return this.onRefresh(function () {
	                return _this2.api.user.getData({
	                    access_token: access_token || _this2.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret,
	                    channel_id: _this2.channelId
	                });
	            });
	        }
	    }, {
	        key: 'getWishList',
	        value: function getWishList(wish_list) {
	            var access_token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            return this.api.user.getWishList({
	                access_token: access_token || this.access_token,
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                channel_id: this.channelId,
	                wish_list: wish_list
	            });
	        }
	    }, {
	        key: 'setWishList',
	        value: function setWishList(wish_list) {
	            return this.api.user.setWishList({
	                access_token: this.access_token,
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                channel_id: this.channelId,
	                wish_list: wish_list
	            }).catch(function (error) {
	                return null;
	            });
	        }
	    }, {
	        key: 'userLogout',
	        value: function userLogout() {
	            return this.api.user.logout({
	                access_token: this.access_token,
	                refresh_token: this.refresh_token,
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret
	            });
	        }
	
	        /**
	         * @returns {Promise}
	         */
	
	    }, {
	        key: 'getCatalog',
	        value: function getCatalog() {
	            return this.api.offer.getCategoryByProfile({
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                channel_id: this.channelId,
	                profile_id: this.profileId,
	                ignore_empty_categories: true
	            });
	        }
	
	        /**
	         * @returns {Promise}
	         */
	
	    }, {
	        key: 'getPayment',
	        value: function getPayment() {
	            return this.api.offer.getPaymentMethods({
	                channel_id: this.channelId
	            });
	        }
	
	        /**
	         * @returns {Promise}
	         */
	
	    }, {
	        key: 'getCategories',
	        value: function getCategories() {
	            return this.api.offer.getCategoryByProfile({
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                channel_id: this.channelId,
	                profile_id: this.profileId,
	                ignore_empty_categories: true
	            }).then(function (result) {
	                return result;
	
	                var filterCategories = function filterCategories(category) {
	
	                    if (!category.show_in_catalog) {
	                        return null;
	                    }
	
	                    if (category.children.length) {
	                        category.categories = category.children.map(filterCategories).filter(function (item) {
	                            return item;
	                        }); //удаление null
	                    }
	                    delete category.children;
	
	                    return category;
	                };
	
	                for (var key in result) {
	                    if (result[key].children) {
	                        return result[key].children.map(filterCategories);
	                    }
	                }
	
	                return result.map(filterCategories);
	            });
	        }
	    }, {
	        key: 'getProductByCategory',
	        value: function getProductByCategory(category_id, page_number, page_size) {
	            var _this3 = this;
	
	            var params = {
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                channel_id: this.channelId,
	                profile_id: this.profileId,
	                page_number: page_number,
	                page_size: page_size
	            };
	
	            if (/\D/.test(category_id)) {
	                //если хоть один символ не число
	                return this.api.offer.getDepthByCategory((0, _extends3.default)({}, params, { semantic_url: category_id }));
	            }
	            return this.api.offer.getDepthByCategory((0, _extends3.default)({}, params, { category_id: category_id })).then(function (result) {
	                return result;
	            }, function (error) {
	                if (error.code == 139) {
	                    //если товар не найден пробуем по ЧПУ
	                    return _this3.api.offer.getDepthByCategory((0, _extends3.default)({}, params, { semantic_url: category_id }));
	                }
	                throw error;
	            });
	        }
	    }, {
	        key: 'getByCategory',
	        value: function getByCategory(category_id, page_number, page_size) {
	            var _this4 = this;
	
	            var params = {
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                channel_id: this.channelId,
	                profile_id: this.profileId,
	                page_number: page_number,
	                page_size: page_size
	            };
	
	            if (/\D/.test(category_id)) {
	                //если хоть один символ не число
	                return this.api.offer.getInCategory((0, _extends3.default)({}, params, { semantic_url: category_id }));
	            }
	            return this.api.offer.getInCategory((0, _extends3.default)({}, params, { category_id: category_id })).then(function (result) {
	                return result;
	            }, function (error) {
	                if (error.code == 139) {
	                    //если товар не найден пробуем по ЧПУ
	                    return _this4.api.offer.getInCategory((0, _extends3.default)({}, params, { semantic_url: category_id }));
	                }
	                throw error;
	            });
	        }
	    }, {
	        key: 'getCategoryRecommended',
	        value: function getCategoryRecommended(category_id) {
	            var params = {
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                channel_id: this.channelId,
	                profile_id: this.profileId,
	                category_id: category_id
	            };
	            return this.api.offer.getCategoryRecommended(params);
	        }
	    }, {
	        key: 'getProductById',
	        value: function getProductById(id) {
	            var _this5 = this;
	
	            var params = {
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                channel_id: this.channelId,
	                profile_id: this.profileId
	            };
	
	            if (/\D/.test(id)) {
	                //если хоть один символ не число
	                return this.api.offer.getById((0, _extends3.default)({}, params, { semantic_url: id }));
	            }
	            return this.api.offer.getById((0, _extends3.default)({}, params, { offer_id: id })).then(function (result) {
	                return result;
	            }, function (error) {
	                if (error.code == 109) {
	                    return _this5.api.offer.getById((0, _extends3.default)({}, params, { semantic_url: id }));
	                }
	                throw error;
	            });
	        }
	    }, {
	        key: 'getProducts',
	        value: function getProducts() {
	            var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	            var page_number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	            var page_size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
	            var categories = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	            var begin_time_create = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	            var end_time_create = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	            var begin_time_update = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
	            var end_time_update = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
	
	            return this.api.offer.get({
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                channels: [this.channelId],
	                profile_id: this.profileId,
	                name: name,
	                page_number: page_number,
	                page_size: page_size,
	                categories: categories,
	                begin_time_create: begin_time_create,
	                end_time_create: end_time_create,
	                begin_time_update: begin_time_update,
	                end_time_update: end_time_update
	            });
	        }
	    }, {
	        key: 'orderCreate',
	        value: function orderCreate(sum) {
	            var products = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	            var user_agent = arguments[2];
	            var utm_redirect_data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	            var currency_id = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 643;
	
	            var _this6 = this;
	
	            var delivery_address = arguments[5];
	            var custom_fields = arguments[6];
	            //currency_id = 643 id валюты
	            return this.onRefresh(function () {
	                return _this6.api.user.order.create({
	                    channel_id: _this6.channelId,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret,
	                    access_token: _this6.access_token,
	                    currency_id: currency_id,
	                    time_create: new Date().toUTCString(),
	                    utm_redirect_data: utm_redirect_data,
	                    delivery_address: delivery_address,
	                    sum: sum,
	                    products: products,
	                    user_agent: user_agent,
	                    custom_fields: custom_fields
	                }).then(function (result) {
	                    return result;
	                    // return this.paymentCreate(result.order_id);
	                });
	            });
	        }
	    }, {
	        key: 'editOrder',
	        value: function editOrder(order_id, sum) {
	            var products = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	            var user_agent = arguments[3];
	
	            var _this7 = this;
	
	            var utm_redirect_data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
	            var currency_id = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 643;
	            //currency_id = 643 id валюты
	            return this.onRefresh(function () {
	                return _this7.api.user.order.edit({
	                    order_id: order_id,
	                    channel_id: _this7.channelId,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret,
	                    access_token: _this7.access_token,
	                    currency_id: currency_id,
	                    time_create: new Date().toUTCString(),
	                    utm_redirect_data: utm_redirect_data,
	                    sum: sum,
	                    products: products,
	                    user_agent: user_agent
	                }).then(function (result) {
	                    return result;
	                    // return this.paymentCreate(result.order_id);
	                });
	            });
	        }
	
	        /**
	         * Создание нового счёта для заказа
	         */
	
	    }, {
	        key: 'paymentCreate',
	        value: function paymentCreate(order_id) {
	            var _this8 = this;
	
	            return this.onRefresh(function () {
	                return _this8.api.user.order.pay({
	                    order_id: order_id,
	                    access_token: _this8.access_token,
	                    channel_id: _this8.channelId,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                });
	            });
	        }
	    }, {
	        key: 'getOrders',
	        value: function getOrders(page_number, page_size) {
	            var _this9 = this;
	
	            return this.onRefresh(function () {
	                return _this9.api.user.order.get({
	                    page_number: page_number,
	                    page_size: page_size,
	                    channel: _this9.channelId,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret,
	                    access_token: _this9.access_token
	                });
	            });
	        }
	    }, {
	        key: 'getOrderById',
	        value: function getOrderById(id) {
	            var _this10 = this;
	
	            return this.onRefresh(function () {
	                return _this10.api.user.order.get({
	                    channel: _this10.channelId,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret,
	                    access_token: _this10.access_token,
	                    number: parseInt(id, 10) || 0
	                }).then(function (result) {
	                    if (result.orders) {
	                        if (result.count) {
	                            return result.orders[0];
	                        } else {
	                            return null;
	                            throw new _IBonusError2.default({
	                                message: 'Страница не существует',
	                                title: 'Страница не существует',
	                                code: '404',
	                                trace: ''
	                            });
	                        }
	                    }
	                    return result;
	                });
	            });
	        }
	
	        /**
	         *Метод для редактирования заказа
	         */
	
	    }, {
	        key: 'setOrder',
	        value: function setOrder(order_id, client_comment, service_in_slug, delivery_address) {
	            var _this11 = this;
	
	            return this.onRefresh(function () {
	                return _this11.api.user.order.set({
	                    order_id: order_id,
	                    client_comment: client_comment,
	                    service_in_slug: service_in_slug,
	                    delivery_address: delivery_address,
	                    access_token: _this11.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                });
	            });
	        }
	    }, {
	        key: 'setPayOrder',
	        value: function setPayOrder(order_id, client_comment, service_in_slug, delivery_address, discount_sum, coupon_id, coupon_token, customer_coupon_id, custom_fields, child_orders) {
	            var _this12 = this;
	
	            var captcha = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
	
	            return this.onRefresh(function () {
	                return _this12.api.user.order.setPayOrder({
	                    order_id: order_id,
	                    client_comment: client_comment,
	                    service_in_slug: service_in_slug,
	                    delivery_address: delivery_address,
	                    access_token: _this12.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret,
	                    discount_sum: discount_sum,
	                    coupon_id: coupon_id,
	                    coupon_token: coupon_token,
	                    customer_coupon_id: customer_coupon_id,
	                    custom_fields: custom_fields,
	                    child_orders: child_orders,
	                    captcha: captcha
	                });
	            });
	        }
	    }, {
	        key: 'cancelOrder',
	        value: function cancelOrder(order_id) {
	            var _this13 = this;
	
	            return this.onRefresh(function () {
	                return _this13.api.user.order.cancel({
	                    order_id: order_id,
	                    channel_id: _this13.channelId,
	                    access_token: _this13.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                });
	            });
	        }
	    }, {
	        key: 'payInnerPipo',
	        value: function payInnerPipo(accountId, operationId) {
	            var _this14 = this;
	
	            var checkCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	            return this.onRefresh(function () {
	                return _this14.api.user.paymentIn.pay({
	                    account_id: accountId,
	                    operation_id: operationId,
	                    access_token: _this14.access_token,
	                    channel_id: _this14.channelId,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret,
	                    check_code: checkCode
	                });
	            });
	        }
	    }, {
	        key: 'checkCodeConfirmForPayInnerPipo',
	        value: function checkCodeConfirmForPayInnerPipo(online_shop_id, orderId) {
	            var _this15 = this;
	
	            return this.onRefresh(function () {
	                return _this15.api.user.paymentIn.beforePay({
	                    access_token: _this15.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret,
	                    online_shop_id: _this15.onlineShopId,
	                    order_id: orderId
	                });
	            });
	        }
	    }, {
	        key: 'paymentServices',
	        value: function paymentServices(paymentInId, user_id, api_key) {
	            return this.pipo.getInputGroupsByPaymentInId(paymentInId, this.storage.getItem('pipo_user_id'), this.storage.getItem('api_key'));
	        }
	    }, {
	        key: 'getDetailPayIn',
	        value: function getDetailPayIn(operationId) {
	            return this.pipo.getDetailPayIn(operationId, this.storage.getItem('pipo_user_id'), this.storage.getItem('api_key'));
	        }
	
	        /**
	         * Пулучение выписки по счёту для пользователя
	         */
	
	    }, {
	        key: 'getPipoOperations',
	        value: function getPipoOperations(date_begin, date_end, id_account, page, page_size) {
	            var _this16 = this;
	
	            return this.onRefresh(function () {
	                return _this16.api.user.getPipoOperations({
	                    date_begin: date_begin,
	                    date_end: date_end,
	                    id_account: id_account,
	                    page: page,
	                    page_size: page_size,
	                    channel_id: _this16.channelId,
	                    access_token: _this16.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                });
	            });
	        }
	
	        /**
	         * Получение настроек магазина по доменному имени
	         *
	         * @param {String} domain
	         *
	         * @return {Promise}
	         */
	
	    }, {
	        key: 'getDomainInfo',
	        value: function getDomainInfo(domain) {
	            domain = domain ? domain : _config2.default.localhost || this.api.client.req && this.api.client.req.hostname;
	
	            return this.api.user.channel.getOnlineShopSettings({ domain: domain }).then(function (result) {
	                if (result === null) {
	                    throw new Error('Not found domain: ' + domain);
	                }
	                return result;
	            });
	        }
	    }, {
	        key: 'getPageDetail',
	        value: function getPageDetail(page_id, online_shop_id) {
	            return this.api.user.onlineShop.getPageById({ page_id: page_id, online_shop_id: online_shop_id });
	        }
	
	        /**
	         * Получение списка товаров для слайдера
	         */
	
	    }, {
	        key: 'getProductForSlider',
	        value: function getProductForSlider(type) {
	            return this.api.offer.getSliderOfferByType({
	                type: type,
	                profile_id: this.profileId,
	                channel_id: this.channelId
	            });
	        }
	
	        /**
	         * Получение списка категорий для слайдера
	         */
	
	    }, {
	        key: 'getCategoryForSlider',
	        value: function getCategoryForSlider() {
	            return this.api.offer.getSliderByCategory({
	                profile_id: this.profileId
	            });
	        }
	    }, {
	        key: 'getLang',
	        value: function getLang(lang) {
	            return this.pipo.getLang(lang);
	        }
	    }, {
	        key: 'pipoProcessInput',
	        value: function pipoProcessInput(operation_id, group_slug) {
	            var additionalFieldName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	            var additionalFieldText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	            var params = {
	                operation_id: operation_id,
	                group_slug: group_slug,
	                json: 1
	            };
	            if (additionalFieldName && additionalFieldText) {
	                params[additionalFieldName] = additionalFieldText;
	            }
	            return this.pipo.processInput(params);
	        }
	    }, {
	        key: 'changeName',
	        value: function changeName(pipoId, name, newName, access_token) {
	            var _this17 = this;
	
	            return this.onRefresh(function () {
	                return _this17.api.user.changeName({
	                    pipo_id: pipoId,
	                    name: name,
	                    new_name: newName,
	                    access_token: access_token || _this17.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                });
	            });
	        }
	    }, {
	        key: 'changeMail',
	        value: function changeMail(pipoId, newEmail, code, access_token) {
	            var _this18 = this;
	
	            return this.onRefresh(function () {
	                return _this18.api.user.changeMail({
	                    pipo_id: pipoId,
	                    new_email: newEmail,
	                    code: code,
	                    access_token: access_token || _this18.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                });
	            });
	        }
	    }, {
	        key: 'changeMailWithCode',
	        value: function changeMailWithCode(pipoId, newEmail, code, access_token) {
	            var _this19 = this;
	
	            return this.onRefresh(function () {
	                return _this19.api.user.changeMailWithCode({
	                    pipo_id: pipoId,
	                    new_email: newEmail,
	                    code: code,
	                    access_token: access_token || _this19.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                }).then(function (result, err) {
	                    if (!result) {
	                        throw new _IBonusError2.default({
	                            message: 'Проверочный код введён неверно. Повторите попытку.',
	                            title: 'Неверный проверочный код',
	                            code: '',
	                            trace: ''
	                        });
	                    } else {
	                        return result;
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'changePhone',
	        value: function changePhone(pipoId, newPhone, code, access_token) {
	            var _this20 = this;
	
	            //let numberPhone = Number(newPhone.replace(/\D+/g,""));
	            return this.onRefresh(function () {
	                return _this20.api.user.changePhone({
	                    pipo_id: pipoId,
	                    new_phone: newPhone,
	                    code: code,
	                    access_token: access_token || _this20.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                });
	            });
	        }
	    }, {
	        key: 'changePhoneWithCode',
	        value: function changePhoneWithCode(pipoId, newPhone, code, access_token) {
	            var _this21 = this;
	
	            //let numberPhone = Number(newPhone.replace(/\D+/g,""));
	            return this.onRefresh(function () {
	                return _this21.api.user.changePhoneWithCode({
	                    pipo_id: pipoId,
	                    new_phone: newPhone,
	                    code: code,
	                    access_token: access_token || _this21.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                }).then(function (result) {
	                    if (!result) {
	                        throw new _IBonusError2.default({
	                            message: 'Проверочный код введён неверно. Повторите попытку.',
	                            title: 'Неверный проверочный код',
	                            code: '',
	                            trace: ''
	                        });
	                    } else {
	                        return result;
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'confirmPhone',
	        value: function confirmPhone(pipoId, phone, code, access_token) {
	            var _this22 = this;
	
	            //let numberPhone = Number(phone.replace(/\D+/g,""));
	            return this.onRefresh(function () {
	                return _this22.api.user.confirmPhone({
	                    pipo_id: pipoId,
	                    phone: phone,
	                    code: code,
	                    access_token: access_token || _this22.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                });
	            });
	        }
	    }, {
	        key: 'confirmPhoneWithCode',
	        value: function confirmPhoneWithCode(pipoId, phone, code, access_token) {
	            var _this23 = this;
	
	            //let numberPhone = Number(phone.replace(/\D+/g,""));
	            return this.onRefresh(function () {
	                return _this23.api.user.confirmPhoneWithCode({
	                    pipo_id: pipoId,
	                    phone: phone,
	                    code: code,
	                    access_token: access_token || _this23.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                }).then(function (result) {
	                    if (!result) {
	                        throw new _IBonusError2.default({
	                            message: 'Проверочный код введён неверно. Повторите попытку.',
	                            title: 'Неверный проверочный код',
	                            code: '',
	                            trace: ''
	                        });
	                    } else {
	                        return result;
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'confirmMail',
	        value: function confirmMail(pipoId, email, code, access_token) {
	            var _this24 = this;
	
	            return this.onRefresh(function () {
	                return _this24.api.user.confirmMail({
	                    pipo_id: pipoId,
	                    email: email,
	                    code: code,
	                    access_token: access_token || _this24.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                });
	            });
	        }
	    }, {
	        key: 'confirmMailWithCode',
	        value: function confirmMailWithCode(pipoId, email, code, access_token) {
	            var _this25 = this;
	
	            return this.onRefresh(function () {
	                return _this25.api.user.confirmMailWithCode({
	                    pipo_id: pipoId,
	                    email: email,
	                    code: code,
	                    access_token: access_token || _this25.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                }).then(function (result) {
	                    if (!result) {
	                        throw new _IBonusError2.default({
	                            message: 'Проверочный код введён неверно. Повторите попытку.',
	                            title: 'Неверный проверочный код',
	                            code: '',
	                            trace: ''
	                        });
	                    } else {
	                        return result;
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'confirmEMailBySignature',
	        value: function confirmEMailBySignature(order_id, confirm_signature) {
	            return this.api.user.confirmEMailBySignature({
	                access_token: this.access_token,
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                order_id: order_id,
	                confirm_signature: confirm_signature
	            });
	        }
	    }, {
	        key: 'changePassword',
	        value: function changePassword(login, newPassword, newRepassword, oldPassword, access_token) {
	            var _this26 = this;
	
	            return this.onRefresh(function () {
	                return _this26.api.user.changePassword({
	                    login: login,
	                    new_password: newPassword,
	                    new_repassword: newRepassword,
	                    old_password: oldPassword,
	                    access_token: access_token || _this26.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                }).then(function (result) {
	                    if (!result) {
	                        throw new _IBonusError2.default({
	                            message: 'Повторите попытку.',
	                            title: 'Не удалось сменить пароль',
	                            code: '',
	                            trace: ''
	                        });
	                    } else {
	                        return result;
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'shareBasket',
	        value: function shareBasket(basket, customFields) {
	            return this.api.offer.shareBasket({
	                channel_id: this.channelId,
	                products: basket,
	                custom_fields: customFields
	            });
	        }
	    }, {
	        key: 'postponeBasket',
	        value: function postponeBasket(basket, customFields) {
	            return this.api.user.postponeBasket({
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                access_token: this.access_token,
	                channel_id: this.channelId,
	                products: basket,
	                custom_fields: customFields
	            });
	        }
	    }, {
	        key: 'getPostpone',
	        value: function getPostpone() {
	            return this.api.user.getPostpone({
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                access_token: this.access_token,
	                channel_id: this.channelId
	            });
	        }
	    }, {
	        key: 'deletePostpone',
	        value: function deletePostpone(id) {
	            return this.api.user.deletePostpone({
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                access_token: this.access_token,
	                channel_id: this.channelId,
	                id: id
	            });
	        }
	    }, {
	        key: 'mergePostpone',
	        value: function mergePostpone(mergeIds) {
	            return this.api.user.mergePostpone({
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                access_token: this.access_token,
	                channel_id: this.channelId,
	                merge_ids: mergeIds
	            });
	        }
	    }, {
	        key: 'getSharedBasket',
	        value: function getSharedBasket(code) {
	            return this.api.offer.getSharedBasket({
	                code: code
	            }).then(function (res) {
	                if (res) {
	                    // res.cartItems.forEach((item) => {
	                    //    if (item.modifierOption) {
	                    //        item.offer.modifier_option_id = item.modifierOption.id;
	                    //        item.offer.modifier_option = item.modifierOption;
	                    //    }
	                    // });
	                    return res;
	                }
	                throw new _IBonusError2.default({
	                    message: 'Нет такой корзины',
	                    title: 'Нет такой корзины',
	                    code: '404',
	                    trace: ''
	                });
	            });
	        }
	    }, {
	        key: 'getActualPrices',
	        value: function getActualPrices(basketElements) {
	            return this.api.offer.getActualPrices({
	                products: basketElements,
	                channel_id: this.channelId
	            });
	        }
	    }, {
	        key: 'getCouponsByToken',
	        value: function getCouponsByToken(token) {
	            var user_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            var params = {
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                channel_id: this.channelId,
	                token: token,
	                user_id: user_id
	            };
	            return this.api.offer.getCouponsByToken(params);
	        }
	    }, {
	        key: 'updateInn',
	        value: function updateInn(inn, access_token) {
	            var _this27 = this;
	
	            return this.onRefresh(function () {
	                return _this27.api.user.updateInn({
	                    access_token: access_token || _this27.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret,
	                    inn: inn
	                });
	            });
	        }
	    }, {
	        key: 'updateUlName',
	        value: function updateUlName(ul_name, access_token) {
	            var _this28 = this;
	
	            return this.onRefresh(function () {
	                return _this28.api.user.updateUlName({
	                    access_token: access_token || _this28.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret,
	                    ul_name: ul_name
	                });
	            });
	        }
	    }, {
	        key: 'getAddresses',
	        value: function getAddresses(access_token) {
	            var _this29 = this;
	
	            return this.onRefresh(function () {
	                return _this29.api.user.loadAddresses({
	                    access_token: access_token || _this29.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                });
	            });
	        }
	    }, {
	        key: 'updateAddress',
	        value: function updateAddress(id, address, is_default, access_token) {
	            var _this30 = this;
	
	            return this.onRefresh(function () {
	                return _this30.api.user.updateAddress({
	                    access_token: access_token || _this30.access_token,
	                    id: id,
	                    address: address,
	                    is_default: is_default,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                });
	            });
	        }
	    }, {
	        key: 'deleteAddress',
	        value: function deleteAddress(id, access_token) {
	            var _this31 = this;
	
	            return this.onRefresh(function () {
	                return _this31.api.user.deleteAddress({
	                    access_token: access_token || _this31.access_token,
	                    id: id,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret
	                });
	            });
	        }
	    }, {
	        key: 'addAddress',
	        value: function addAddress(address, access_token) {
	            var _this32 = this;
	
	            return this.onRefresh(function () {
	                return _this32.api.user.addAddress({
	                    access_token: access_token || _this32.access_token,
	                    client_id: _config2.default.client_id,
	                    client_secret: _config2.default.client_secret,
	                    address: address
	                });
	            });
	        }
	    }, {
	        key: 'getLangData',
	        value: function getLangData() {
	            return this.api.lang.getLangData();
	        }
	    }, {
	        key: 'getChannelLastUpdateDate',
	        value: function getChannelLastUpdateDate() {
	            return this.api.channel.getLastUpdateDate({
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                channel_id: this.channelId
	            });
	        }
	    }, {
	        key: 'getChannelActualCatalogLabel',
	        value: function getChannelActualCatalogLabel() {
	            return this.api.channel.getActualCatalogLabel({
	                client_id: _config2.default.client_id,
	                client_secret: _config2.default.client_secret,
	                channel_id: this.channelId
	            });
	        }
	    }, {
	        key: 'access_token',
	        get: function get() {
	            return this.storage.getItem('access_token') ? this.storage.getItem('access_token') : this.currentAccessToken;
	        },
	        set: function set(value) {
	            if (value != null && value !== '') {
	                this.currentAccessToken = value;
	                this.storage.setItem('access_token', value);
	            }
	        }
	    }, {
	        key: 'refresh_token',
	        get: function get() {
	            return this.storage.getItem('refresh_token');
	        },
	        set: function set(value) {
	            this.storage.setItem('refresh_token', value);
	        }
	
	        /**
	         * Обёртка для методов с access токеном
	         * @param callback
	         * @returns {Request|Promise.<TResult>|*}
	         */
	
	    }]);
	    return IBonus;
	}(), (_applyDecoratedDescriptor(_class.prototype, 'onRefresh', [_log.log], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onRefresh'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getProductById', [_log.log], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getProductById'), _class.prototype)), _class);
	exports.default = IBonus;
	module.exports = exports['default'];

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _promise = __webpack_require__(58);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(743);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _IBonusError = __webpack_require__(191);
	
	var _IBonusError2 = _interopRequireDefault(_IBonusError);
	
	var _Factory = __webpack_require__(259);
	
	var _Factory2 = _interopRequireDefault(_Factory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IBonusApi = function () {
	    function IBonusApi(client, storage) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, IBonusApi);
	
	        this._send = function (path) {
	            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            return _this.client.post(path, { data: data }).then(function (result) {
	                var status = !!result.status;
	                var dataError = [];
	
	                //Для быстрой отладки
	                //  console.log('path', path);
	                //  console.log('data', data);
	                //  console.log('status', status);
	
	                if (status) {
	                    return result.result;
	                } else {
	                    if (result.result.hasOwnProperty('dataError')) {
	                        dataError = result.result.dataError;
	                    }
	                    if (result.result.params && result.result.params.length) {
	                        dataError = dataError.concat(result.result.params);
	                    }
	                    throw new _IBonusError2.default({
	                        message: result.result.error ? result.result.error.message : null,
	                        title: result.result.title || '',
	                        code: result.result.code || '',
	                        trace: result.result.error ? result.result.error.trace : null,
	                        dataError: dataError
	                    });
	                }
	            });
	        };
	
	        this.client = client;
	        this.storage = storage;
	    }
	
	    (0, _createClass3.default)(IBonusApi, [{
	        key: 'user',
	        get: function get() {
	            var _this2 = this;
	
	            return {
	                /**
	                 * Авторизует пользователя по логину и паролю
	                 * @param {String} username Логин пользователя (Email)
	                 * @param {String} password Пароль пользователя
	                 * @param {String} client_id ID клиента (приложения)
	                 * @param {String} client_secret Секретный ключ клиента (приложения)
	                 * @param {String} captcha Ре-капча
	                 * @param shopId
	                 *
	                 * @returns {Promise}
	                 */
	                authentication: function authentication(_ref) {
	                    var username = _ref.username,
	                        password = _ref.password,
	                        client_id = _ref.client_id,
	                        client_secret = _ref.client_secret,
	                        _ref$captcha = _ref.captcha,
	                        captcha = _ref$captcha === undefined ? null : _ref$captcha,
	                        _ref$shopId = _ref.shopId,
	                        shopId = _ref$shopId === undefined ? null : _ref$shopId;
	
	                    var data = {
	                        username: username, password: password, client_id: client_id, client_secret: client_secret, remember_me: false
	                    };
	                    if (captcha) {
	                        data.captcha_token = captcha;
	                    }
	                    if (shopId) {
	                        data.online_shop_id = shopId;
	                    }
	                    return _this2._send(constants.IBONUS_PATH_USER_AUTHENTICATION, data);
	                },
	                register: function register(_ref2) {
	                    var password = _ref2.password,
	                        shopId = _ref2.shopId,
	                        params = (0, _objectWithoutProperties3.default)(_ref2, ['password', 'shopId']);
	
	                    return _this2._send(constants.IBONUS_PATH_USER_REGISTER_BY_PHONE, (0, _extends3.default)({
	                        password: password, online_shop_id: shopId }, params));
	                },
	                confirmRegister: function confirmRegister(_ref3) {
	                    var password = _ref3.password,
	                        shopId = _ref3.shopId,
	                        params = (0, _objectWithoutProperties3.default)(_ref3, ['password', 'shopId']);
	
	                    return _this2._send(constants.IBONUS_PATH_USER_CONFIRM_REGISTER_BY_PHONE, (0, _extends3.default)({
	                        password: password, online_shop_id: shopId }, params));
	                },
	                registerOneClick: function registerOneClick(_ref4) {
	                    var shopId = _ref4.shopId,
	                        params = (0, _objectWithoutProperties3.default)(_ref4, ['shopId']);
	
	                    return _this2._send(constants.IBONUS_PATH_USER_REGISTER_ONE_CLICK, (0, _extends3.default)({
	                        online_shop_id: shopId }, params));
	                },
	                confirmRegisterOneClick: function confirmRegisterOneClick(_ref5) {
	                    var shopId = _ref5.shopId,
	                        params = (0, _objectWithoutProperties3.default)(_ref5, ['shopId']);
	
	                    return _this2._send(constants.IBONUS_PATH_USER_CONFIRM_REGISTER_ONE_CLICK, (0, _extends3.default)({
	                        online_shop_id: shopId }, params));
	                },
	                updateAccessToken: function updateAccessToken(_ref6) {
	                    var client_id = _ref6.client_id,
	                        client_secret = _ref6.client_secret,
	                        refresh_token = _ref6.refresh_token;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_UPDATE_ACCESS_TOKEN, {
	                        client_id: client_id, client_secret: client_secret, refresh_token: refresh_token
	                    });
	                },
	                getData: function getData(_ref7) {
	                    var client_id = _ref7.client_id,
	                        client_secret = _ref7.client_secret,
	                        access_token = _ref7.access_token,
	                        channel_id = _ref7.channel_id;
	
	                    return _promise2.default.all([_this2._send(constants.IBONUS_PATH_USER_GET_DATA, {
	                        client_id: client_id, client_secret: client_secret, access_token: access_token
	                    }), _this2._send(constants.IBONUS_PATH_GET_COUPONS_AND_BALANCE, {
	                        client_id: client_id, client_secret: client_secret, access_token: access_token, channel_id: channel_id
	                    })]).then(function (result) {
	
	                        var userData = (0, _extends3.default)({}, result[0], { amount: result[1].amount, coupons: result[1].coupons,
	                            loyaltySettings: result[1].settings, count_postpone: result[1].count_postpone });
	                        return userData;
	                    });
	                },
	                getWishList: function getWishList(_ref8) {
	                    var client_id = _ref8.client_id,
	                        client_secret = _ref8.client_secret,
	                        access_token = _ref8.access_token,
	                        channel_id = _ref8.channel_id,
	                        wish_list = _ref8.wish_list;
	
	                    return _this2._send(constants.IBONUS_PATH_GET_WISH_LIST, {
	                        client_id: client_id, client_secret: client_secret, access_token: access_token, channel_id: channel_id, wish_list: wish_list
	                    }).then(function (result) {
	                        return result;
	                    });
	                },
	                setWishList: function setWishList(_ref9) {
	                    var client_id = _ref9.client_id,
	                        client_secret = _ref9.client_secret,
	                        access_token = _ref9.access_token,
	                        channel_id = _ref9.channel_id,
	                        wish_list = _ref9.wish_list;
	
	                    return _this2._send(constants.IBONUS_PATH_SET_WISH_LIST, {
	                        client_id: client_id, client_secret: client_secret, access_token: access_token, channel_id: channel_id, wish_list: wish_list
	                    });
	                },
	                postponeBasket: function postponeBasket(params) {
	                    return _this2._send(constants.IBONUS_PATH_CREATE_POSTPONE_BASKET, params);
	                },
	                getPostpone: function getPostpone(params) {
	                    return _this2._send(constants.IBONUS_PATH_GET_POSTPONE_BASKET, params);
	                },
	                deletePostpone: function deletePostpone(params) {
	                    return _this2._send(constants.IBONUS_PATH_DELETE_POSTPONE_BASKET, params);
	                },
	                mergePostpone: function mergePostpone(params) {
	                    return _this2._send(constants.IBONUS_PATH_MERGE_POSTPONE_BASKET, params);
	                },
	                logout: function logout(_ref10) {
	                    var client_id = _ref10.client_id,
	                        client_secret = _ref10.client_secret,
	                        access_token = _ref10.access_token,
	                        refresh_token = _ref10.refresh_token;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_LOGOUT, {
	                        client_id: client_id, client_secret: client_secret, access_token: access_token, refresh_token: refresh_token
	                    });
	                },
	                getCouponsAndBalance: function getCouponsAndBalance(_ref11) {
	                    var client_id = _ref11.client_id,
	                        client_secret = _ref11.client_secret,
	                        access_token = _ref11.access_token,
	                        channel_id = _ref11.channel_id;
	
	                    return _this2._send(constants.IBONUS_PATH_GET_COUPONS_AND_BALANCE, {
	                        client_id: client_id, client_secret: client_secret, access_token: access_token, channel_id: channel_id
	                    });
	                },
	                order: {
	                    create: function create(params) {
	                        return _this2._send(constants.IBONUS_PATH_USER_ORDER_CREATE, params);
	                    },
	                    /**
	                     * Получить массив заказов покупателя в соответствии с фильтром Необязательные параметры
	                     *
	                     * @param {channel, service_in_id, status_id, order_id, cashier_id, device_id, begin_date, end_date, payment_in_number, page_number, page_size} params
	                     */
	                    get: function get() {
	                        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                        return _this2._send(constants.IBONUS_PATH_USER_ORDER_GET, params);
	                    },
	                    pay: function pay(_ref12) {
	                        var channel_id = _ref12.channel_id,
	                            client_secret = _ref12.client_secret,
	                            client_id = _ref12.client_id,
	                            order_id = _ref12.order_id,
	                            access_token = _ref12.access_token;
	
	                        return _this2._send(constants.IBONUS_PATH_USER_ORDER_PAY, { channel_id: channel_id, client_secret: client_secret, client_id: client_id, order_id: order_id, access_token: access_token });
	                    },
	                    /**
	                     *Метод для редактирования заказа
	                     */
	                    set: function set(_ref13) {
	                        var order_id = _ref13.order_id,
	                            client_secret = _ref13.client_secret,
	                            client_id = _ref13.client_id,
	                            _ref13$client_comment = _ref13.client_comment,
	                            client_comment = _ref13$client_comment === undefined ? null : _ref13$client_comment,
	                            _ref13$delivery_addre = _ref13.delivery_address,
	                            delivery_address = _ref13$delivery_addre === undefined ? null : _ref13$delivery_addre,
	                            _ref13$service_in_slu = _ref13.service_in_slug,
	                            service_in_slug = _ref13$service_in_slu === undefined ? null : _ref13$service_in_slu,
	                            access_token = _ref13.access_token;
	
	                        var params = { client_secret: client_secret, client_id: client_id, order_id: order_id, access_token: access_token };
	                        if (client_comment) {
	                            params['client_comment'] = client_comment;
	                        }
	                        if (service_in_slug) {
	                            params['service_in_slug'] = service_in_slug;
	                        }
	                        if (delivery_address) {
	                            params['delivery_address'] = delivery_address;
	                        }
	                        return _this2._send(constants.IBONUS_PATH_ORDER_UPDATE, params);
	                    },
	                    setPayOrder: function setPayOrder(_ref14) {
	                        var order_id = _ref14.order_id,
	                            client_secret = _ref14.client_secret,
	                            client_id = _ref14.client_id,
	                            _ref14$client_comment = _ref14.client_comment,
	                            client_comment = _ref14$client_comment === undefined ? null : _ref14$client_comment,
	                            _ref14$service_in_slu = _ref14.service_in_slug,
	                            service_in_slug = _ref14$service_in_slu === undefined ? null : _ref14$service_in_slu,
	                            _ref14$delivery_addre = _ref14.delivery_address,
	                            delivery_address = _ref14$delivery_addre === undefined ? null : _ref14$delivery_addre,
	                            access_token = _ref14.access_token,
	                            _ref14$discount_sum = _ref14.discount_sum,
	                            discount_sum = _ref14$discount_sum === undefined ? 0 : _ref14$discount_sum,
	                            _ref14$coupon_id = _ref14.coupon_id,
	                            coupon_id = _ref14$coupon_id === undefined ? null : _ref14$coupon_id,
	                            _ref14$coupon_token = _ref14.coupon_token,
	                            coupon_token = _ref14$coupon_token === undefined ? null : _ref14$coupon_token,
	                            _ref14$customer_coupo = _ref14.customer_coupon_id,
	                            customer_coupon_id = _ref14$customer_coupo === undefined ? null : _ref14$customer_coupo,
	                            _ref14$custom_fields = _ref14.custom_fields,
	                            custom_fields = _ref14$custom_fields === undefined ? null : _ref14$custom_fields,
	                            _ref14$child_orders = _ref14.child_orders,
	                            child_orders = _ref14$child_orders === undefined ? null : _ref14$child_orders,
	                            _ref14$captcha = _ref14.captcha,
	                            captcha = _ref14$captcha === undefined ? null : _ref14$captcha;
	
	
	                        var params = { client_secret: client_secret, client_id: client_id, order_id: order_id, access_token: access_token };
	                        if (client_comment) {
	                            params['client_comment'] = client_comment;
	                        }
	                        if (service_in_slug) {
	                            params['service_in_slug'] = service_in_slug;
	                        }
	                        if (discount_sum) {
	                            params['discount_sum'] = discount_sum;
	                        }
	                        if (coupon_id) {
	                            params['coupon_id'] = coupon_id;
	                        }
	                        if (customer_coupon_id) {
	                            params['customer_coupon_id'] = customer_coupon_id;
	                        }
	                        if (coupon_token) {
	                            params['coupon_token'] = coupon_token;
	                        }
	                        if (delivery_address) {
	                            params['delivery_address'] = delivery_address;
	                        }
	                        if (custom_fields) {
	                            params['custom_fields'] = custom_fields;
	                        }
	                        if (child_orders) {
	                            params['child_orders'] = child_orders;
	                        }
	                        if (captcha) {
	                            params['captcha'] = captcha;
	                        }
	                        return _this2._send(constants.IBONUS_PATH_USER_ORDER_CREATE_PAY, params);
	                    },
	                    edit: function edit(params) {
	                        return _this2._send(constants.IBONUS_PATH_ORDER_EDIT, params);
	                    },
	                    cancel: function cancel(_ref15) {
	                        var order_id = _ref15.order_id,
	                            channel_id = _ref15.channel_id,
	                            client_secret = _ref15.client_secret,
	                            client_id = _ref15.client_id,
	                            access_token = _ref15.access_token;
	
	                        var params = { client_secret: client_secret, client_id: client_id, order_id: order_id, channel_id: channel_id, access_token: access_token };
	
	                        return _this2._send(constants.IBONUS_PATH_ORDER_CANCEL, params);
	                    }
	                },
	                channel: {
	                    /**
	                     * Получить массив настроек онлайн магазина
	                     *
	                     * @param {int} channel_id id канала продаж, если не передан будем искать по домену
	                     * @param {String} domain Домен
	                     *
	                     * @return {Promise}
	                     */
	                    getOnlineShopSettings: function getOnlineShopSettings(_ref16) {
	                        var _ref16$channel_id = _ref16.channel_id,
	                            channel_id = _ref16$channel_id === undefined ? null : _ref16$channel_id,
	                            _ref16$domain = _ref16.domain,
	                            domain = _ref16$domain === undefined ? null : _ref16$domain;
	
	                        var params = {};
	                        if (channel_id) {
	                            params['channel_id'] = channel_id;
	                        }
	                        if (domain) {
	                            params['domain'] = domain;
	                        }
	                        return _this2._send(constants.IBONUS_PATH_USER_CHANNEL_GET_ONLINE_SHOP_SETTINGS, params).then(function (result) {
	                            return _Factory2.default.create('ShopSettingsResponse', result);
	                        });
	                    }
	                },
	                paymentIn: {
	                    pay: function pay(_ref17) {
	                        var account_id = _ref17.account_id,
	                            operation_id = _ref17.operation_id,
	                            access_token = _ref17.access_token,
	                            channel_id = _ref17.channel_id,
	                            client_id = _ref17.client_id,
	                            client_secret = _ref17.client_secret,
	                            _ref17$check_code = _ref17.check_code,
	                            check_code = _ref17$check_code === undefined ? null : _ref17$check_code;
	
	                        var params = {
	                            account_id: account_id,
	                            operation_id: operation_id,
	                            access_token: access_token,
	                            channel_id: channel_id,
	                            client_id: client_id,
	                            client_secret: client_secret
	                        };
	                        if (check_code) {
	                            params['check_code'] = check_code;
	                        }
	                        return _this2._send(constants.IBONUS_PATH_USER_PAYMENT_IN_PAY, params);
	                    },
	
	                    beforePay: function beforePay(params) {
	                        return _this2._send(constants.IBONUS_PATH_USER_PAYMENT_IN_BEFORE_PAY, params);
	                    }
	                },
	                /**
	                 * Пулучение выписки по счёту для пользователя
	                 */
	                getPipoOperations: function getPipoOperations(params) {
	                    return _this2._send(constants.IBONUS_PATH_PIPO_GET_OPERATIONS, (0, _extends3.default)({}, params));
	                },
	
	                onlineShop: {
	                    getPageById: function getPageById(params) {
	                        return _this2._send(constants.IBONUS_PATH_GET_PAGE_BY_ID, params);
	                    }
	                },
	                sendCode: function sendCode(_ref18) {
	                    var login = _ref18.login,
	                        id_shop = _ref18.id_shop;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_SEND_CODE, { login: login, online_shop_id: id_shop });
	                },
	                /*
	                    login - логин юзера (телефон)
	                    source - <надо описать>
	                    phone - телефон, куда слать
	                    Если телефон еще не заполнен, то login и phone идентичны -
	                    phone в этом случае нужен серву, чтобо отослать код, потому как по login
	                    он не найдет юзера(телефон не заполнял же).
	                */
	
	                sendVoiceCode: function sendVoiceCode(_ref19) {
	                    var login = _ref19.login,
	                        source = _ref19.source,
	                        phone = _ref19.phone;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_SEND_VOICE_CODE, { login: login, source: source, phone: phone });
	                },
	
	                restorePassword: function restorePassword(_ref20) {
	                    var login = _ref20.login,
	                        new_password = _ref20.new_password,
	                        code = _ref20.code,
	                        client_id = _ref20.client_id,
	                        client_secret = _ref20.client_secret,
	                        remember_me = _ref20.remember_me;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_RESTORE_PASSWORD, {
	                        code: code,
	                        client_id: client_id,
	                        client_secret: client_secret,
	                        remember_me: remember_me,
	                        login: login,
	                        new_password: new_password,
	                        new_repassword: new_password
	
	                    });
	                },
	                changeName: function changeName(_ref21) {
	                    var pipo_id = _ref21.pipo_id,
	                        name = _ref21.name,
	                        new_name = _ref21.new_name,
	                        access_token = _ref21.access_token,
	                        client_id = _ref21.client_id,
	                        client_secret = _ref21.client_secret;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_CHANGE_NAME, {
	                        pipo_id: pipo_id, name: name, new_name: new_name, access_token: access_token, client_id: client_id, client_secret: client_secret
	                    });
	                },
	                changeMail: function changeMail(_ref22) {
	                    var pipo_id = _ref22.pipo_id,
	                        email = _ref22.email,
	                        new_email = _ref22.new_email,
	                        code = _ref22.code,
	                        access_token = _ref22.access_token,
	                        client_id = _ref22.client_id,
	                        client_secret = _ref22.client_secret;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_CHANGE_MAIL, {
	                        pipo_id: pipo_id, email: email, new_email: new_email, code: code, access_token: access_token, client_id: client_id, client_secret: client_secret
	                    });
	                },
	                changeMailWithCode: function changeMailWithCode(_ref23) {
	                    var pipo_id = _ref23.pipo_id,
	                        email = _ref23.email,
	                        new_email = _ref23.new_email,
	                        code = _ref23.code,
	                        access_token = _ref23.access_token,
	                        client_id = _ref23.client_id,
	                        client_secret = _ref23.client_secret;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_CHANGE_MAIL, {
	                        pipo_id: pipo_id, email: email, new_email: new_email, code: code, access_token: access_token, client_id: client_id, client_secret: client_secret
	                    });
	                },
	                changePhone: function changePhone(_ref24) {
	                    var pipo_id = _ref24.pipo_id,
	                        new_phone = _ref24.new_phone,
	                        code = _ref24.code,
	                        access_token = _ref24.access_token,
	                        client_id = _ref24.client_id,
	                        client_secret = _ref24.client_secret;
	
	                    var newPhone = '+' + new_phone;
	                    return _this2._send(constants.IBONUS_PATH_USER_CHANGE_PHONE, {
	                        pipo_id: pipo_id, newPhone: newPhone, access_token: access_token, client_id: client_id, client_secret: client_secret
	                    });
	                },
	                changePhoneWithCode: function changePhoneWithCode(_ref25) {
	                    var pipo_id = _ref25.pipo_id,
	                        new_phone = _ref25.new_phone,
	                        code = _ref25.code,
	                        access_token = _ref25.access_token,
	                        client_id = _ref25.client_id,
	                        client_secret = _ref25.client_secret;
	
	                    var newPhone = '+' + new_phone;
	                    return _this2._send(constants.IBONUS_PATH_USER_CHANGE_PHONE, {
	                        pipo_id: pipo_id, newPhone: newPhone, code: code, access_token: access_token, client_id: client_id, client_secret: client_secret
	                    });
	                },
	                confirmMail: function confirmMail(_ref26) {
	                    var pipo_id = _ref26.pipo_id,
	                        code = _ref26.code,
	                        access_token = _ref26.access_token,
	                        client_id = _ref26.client_id,
	                        client_secret = _ref26.client_secret;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_CONFIRM_MAIL, {
	                        pipo_id: pipo_id, code: code, access_token: access_token, client_id: client_id, client_secret: client_secret
	                    });
	                },
	                confirmMailWithCode: function confirmMailWithCode(_ref27) {
	                    var pipo_id = _ref27.pipo_id,
	                        code = _ref27.code,
	                        access_token = _ref27.access_token,
	                        client_id = _ref27.client_id,
	                        client_secret = _ref27.client_secret;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_CONFIRM_MAIL, {
	                        pipo_id: pipo_id, code: code, access_token: access_token, client_id: client_id, client_secret: client_secret
	                    });
	                },
	                confirmPhone: function confirmPhone(_ref28) {
	                    var pipo_id = _ref28.pipo_id,
	                        phone = _ref28.phone,
	                        code = _ref28.code,
	                        access_token = _ref28.access_token,
	                        client_id = _ref28.client_id,
	                        client_secret = _ref28.client_secret;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_CONFIRM_PHONE, {
	                        pipo_id: pipo_id, phone: phone, code: code, access_token: access_token, client_id: client_id, client_secret: client_secret
	                    });
	                },
	                confirmPhoneWithCode: function confirmPhoneWithCode(_ref29) {
	                    var pipo_id = _ref29.pipo_id,
	                        phone = _ref29.phone,
	                        code = _ref29.code,
	                        access_token = _ref29.access_token,
	                        client_id = _ref29.client_id,
	                        client_secret = _ref29.client_secret;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_CONFIRM_PHONE, {
	                        pipo_id: pipo_id, phone: phone, code: code, access_token: access_token, client_id: client_id, client_secret: client_secret
	                    });
	                },
	                changePassword: function changePassword(_ref30) {
	                    var login = _ref30.login,
	                        new_password = _ref30.new_password,
	                        new_repassword = _ref30.new_repassword,
	                        old_password = _ref30.old_password,
	                        access_token = _ref30.access_token,
	                        client_id = _ref30.client_id,
	                        client_secret = _ref30.client_secret;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_CHANGE_PASSWORD, {
	                        login: login, new_password: new_password, new_repassword: new_repassword, old_password: old_password, access_token: access_token, client_id: client_id, client_secret: client_secret
	                    });
	                },
	                updateInn: function updateInn(_ref31) {
	                    var access_token = _ref31.access_token,
	                        client_id = _ref31.client_id,
	                        client_secret = _ref31.client_secret,
	                        inn = _ref31.inn;
	
	                    return _this2._send(constants.IBONUS_PATH_UPDATE_INN, { access_token: access_token, client_id: client_id, client_secret: client_secret, inn: inn });
	                },
	                updateUlName: function updateUlName(_ref32) {
	                    var access_token = _ref32.access_token,
	                        client_id = _ref32.client_id,
	                        client_secret = _ref32.client_secret,
	                        ul_name = _ref32.ul_name;
	
	                    return _this2._send(constants.IBONUS_PATH_UPDATE_UL_NAME, { access_token: access_token, client_id: client_id, client_secret: client_secret, ul_name: ul_name });
	                },
	                addAddress: function addAddress(_ref33) {
	                    var access_token = _ref33.access_token,
	                        client_id = _ref33.client_id,
	                        client_secret = _ref33.client_secret,
	                        address = _ref33.address;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_ADD_ADDRESS, { access_token: access_token, client_id: client_id, client_secret: client_secret, address: address });
	                },
	                loadAddresses: function loadAddresses(_ref34) {
	                    var access_token = _ref34.access_token,
	                        client_id = _ref34.client_id,
	                        client_secret = _ref34.client_secret;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_GET_ADDRESS, {
	                        access_token: access_token,
	                        client_id: client_id,
	                        client_secret: client_secret
	                    });
	                },
	                updateAddress: function updateAddress(_ref35) {
	                    var access_token = _ref35.access_token,
	                        id = _ref35.id,
	                        address = _ref35.address,
	                        is_default = _ref35.is_default,
	                        client_id = _ref35.client_id,
	                        client_secret = _ref35.client_secret;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_UPDATE_ADDRESS, {
	                        access_token: access_token,
	                        id: id,
	                        address: address,
	                        is_default: is_default,
	                        client_id: client_id,
	                        client_secret: client_secret
	                    });
	                },
	                deleteAddress: function deleteAddress(_ref36) {
	                    var access_token = _ref36.access_token,
	                        id = _ref36.id,
	                        client_id = _ref36.client_id,
	                        client_secret = _ref36.client_secret;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_DELETE_ADDRESS, {
	                        access_token: access_token,
	                        id: id,
	                        client_id: client_id,
	                        client_secret: client_secret
	                    });
	                },
	                confirmEMailBySignature: function confirmEMailBySignature(_ref37) {
	                    var access_token = _ref37.access_token,
	                        client_id = _ref37.client_id,
	                        client_secret = _ref37.client_secret,
	                        confirm_signature = _ref37.confirm_signature,
	                        order_id = _ref37.order_id;
	
	                    return _this2._send(constants.IBONUS_PATH_USER_CONFIRM_EMAIL_TO_URL, {
	                        access_token: access_token,
	                        client_id: client_id,
	                        client_secret: client_secret,
	                        confirm_signature: confirm_signature,
	                        order_id: order_id
	                    });
	                }
	            };
	        }
	    }, {
	        key: 'offer',
	        get: function get() {
	            var _this3 = this;
	
	            return {
	                /**
	                 * Получить список товаров по типу для слайдера
	                 * @param type Тип товаров(Новинки - 1, Хиты - 2, Популярное - 3)
	                 * @param profile_id
	                 */
	                getSliderOfferByType: function getSliderOfferByType(_ref38) {
	                    var type = _ref38.type,
	                        profile_id = _ref38.profile_id,
	                        channel_id = _ref38.channel_id;
	
	                    return _this3._send(constants.IBONUS_PATH_SLIDER_GET_OFFER_BY_TYPE, {
	                        type: type, profile_id: profile_id, channel_id: channel_id
	                    });
	                },
	                /**
	                 * Получить список категорий для слайдера
	                 * @param profile_id
	                 */
	                getSliderByCategory: function getSliderByCategory(_ref39) {
	                    var profile_id = _ref39.profile_id;
	
	                    return _this3._send(constants.IBONUS_PATH_SLIDER_GET_CATEGORY, {
	                        profile_id: profile_id
	                    });
	                },
	
	                /**
	                 * Вернуть предложения канала продаж, сгруппированные по категориям
	                 */
	                getCategoryByProfile: function getCategoryByProfile(params) {
	                    return _this3._send(constants.IBONUS_PATH_GET_CATALOG, params);
	                },
	                getByCategory: function getByCategory(_ref40) {
	                    var client_id = _ref40.client_id,
	                        client_secret = _ref40.client_secret,
	                        access_token = _ref40.access_token,
	                        category_id = _ref40.category_id,
	                        channel_id = _ref40.channel_id,
	                        profile_id = _ref40.profile_id;
	
	                    return _this3._send(constants.IBONUS_PATH_OFFER_GET_BY_CATEGORY, {
	                        client_id: client_id, client_secret: client_secret, access_token: access_token, category_id: category_id, channel_id: channel_id, profile_id: profile_id
	                    });
	                },
	                /**
	                 * Получение методов оплаты доступных для указанного канала продаж
	                 * @param channel_id
	                 *
	                 * @returns {Promise}
	                 */
	                getPaymentMethods: function getPaymentMethods(_ref41) {
	                    var channel_id = _ref41.channel_id;
	                    return _this3._send(constants.IBONUS_PATH_GET_PAYMENT_METHODS, { channel_id: channel_id });
	                },
	
	                'get': function get(_ref42) {
	                    var client_id = _ref42.client_id,
	                        client_secret = _ref42.client_secret,
	                        channel_id = _ref42.channel_id,
	                        profile_id = _ref42.profile_id,
	                        _ref42$name = _ref42.name,
	                        name = _ref42$name === undefined ? '' : _ref42$name,
	                        _ref42$barcode = _ref42.barcode,
	                        barcode = _ref42$barcode === undefined ? '' : _ref42$barcode,
	                        _ref42$begin_time_cre = _ref42.begin_time_create,
	                        begin_time_create = _ref42$begin_time_cre === undefined ? null : _ref42$begin_time_cre,
	                        _ref42$end_time_creat = _ref42.end_time_create,
	                        end_time_create = _ref42$end_time_creat === undefined ? null : _ref42$end_time_creat,
	                        _ref42$begin_time_upd = _ref42.begin_time_update,
	                        begin_time_update = _ref42$begin_time_upd === undefined ? null : _ref42$begin_time_upd,
	                        _ref42$end_time_updat = _ref42.end_time_update,
	                        end_time_update = _ref42$end_time_updat === undefined ? null : _ref42$end_time_updat,
	                        _ref42$categories = _ref42.categories,
	                        categories = _ref42$categories === undefined ? [] : _ref42$categories,
	                        _ref42$channels = _ref42.channels,
	                        channels = _ref42$channels === undefined ? [] : _ref42$channels,
	                        _ref42$page_number = _ref42.page_number,
	                        page_number = _ref42$page_number === undefined ? 0 : _ref42$page_number,
	                        _ref42$page_size = _ref42.page_size,
	                        page_size = _ref42$page_size === undefined ? 20 : _ref42$page_size;
	
	                    // todo: переделать данное уродство
	                    var params = { client_id: client_id, client_secret: client_secret, channel_id: channel_id, profile_id: profile_id, page_number: page_number, page_size: page_size };
	                    var _fillParams = function _fillParams(key, value) {
	                        if (value) {
	                            params[key] = value;
	                        }
	                    };
	                    _fillParams('name', name);
	                    _fillParams('barcode', barcode);
	                    _fillParams('begin_time_create', begin_time_create);
	                    _fillParams('end_time_create', end_time_create);
	                    _fillParams('begin_time_update', begin_time_update);
	                    _fillParams('end_time_update', end_time_update);
	                    if (categories.length > 0) {
	                        params.categories = categories;
	                    }
	                    if (channels.length > 0) {
	                        params.channels = channels;
	                    }
	
	                    return _this3._send(constants.IBONUS_PATH_OFFER_GET, params);
	                },
	                getCategoryRecommended: function getCategoryRecommended(params) {
	                    return _this3._send(constants.IBONUS_PATH_GET_CATEGORY_RECOMENDED, params);
	                },
	                getDepthByCategory: function getDepthByCategory(params) {
	                    return _this3._send(constants.IBONUS_PATH_OFFER_GET_DEPTH_BY_CATEGORY, params);
	                },
	                getInCategory: function getInCategory(params) {
	                    return _this3._send(constants.IBONUS_PATH_OFFER_GET_IN_CATEGORY, params);
	                },
	                getById: function getById(params) {
	                    return _this3._send(constants.IBONUS_PATH_OFFER_GET_BY_ID, params);
	                },
	                shareBasket: function shareBasket(params) {
	                    return _this3._send(constants.IBONUS_PATH_SHARE_BASKET, params);
	                },
	                getSharedBasket: function getSharedBasket(params) {
	                    return _this3._send(constants.IBONUS_PATH_GET_SHARED_BASKET, params);
	                },
	                getActualPrices: function getActualPrices(params) {
	                    return _this3._send(constants.IBONUS_PATH_GET_ACTUAL_PRICES, params);
	                },
	                getCouponsByToken: function getCouponsByToken(params) {
	                    return _this3._send(constants.IBONUS_PATH_GET_COUPONS_BY_TOKEN, params);
	                }
	            };
	        }
	    }, {
	        key: 'category',
	        get: function get() {
	            var _this4 = this;
	
	            return {
	                getByChannel: function getByChannel(_ref43) {
	                    var client_id = _ref43.client_id,
	                        client_secret = _ref43.client_secret,
	                        access_token = _ref43.access_token,
	                        channel_id = _ref43.channel_id;
	
	                    return _this4._send(constants.IBONUS_PATH_CATEGORY_GET_BY_CHANNEL, {
	                        client_id: client_id, client_secret: client_secret, access_token: access_token, channel_id: channel_id
	                    });
	                }
	            };
	        }
	    }, {
	        key: 'channel',
	        get: function get() {
	            var _this5 = this;
	
	            return {
	                getLastUpdateDate: function getLastUpdateDate(_ref44) {
	                    var client_id = _ref44.client_id,
	                        channel_id = _ref44.channel_id,
	                        client_secret = _ref44.client_secret;
	
	                    return _this5._send(constants.IBONUS_PATH_GET_TIME_UPDATE_CHANNEL, {
	                        client_id: client_id,
	                        client_secret: client_secret,
	                        channel_id: channel_id
	                    });
	                },
	                getActualCatalogLabel: function getActualCatalogLabel(_ref45) {
	                    var client_id = _ref45.client_id,
	                        channel_id = _ref45.channel_id,
	                        client_secret = _ref45.client_secret;
	
	                    return _this5._send(constants.IBONUS_PATH_ACTUAL_CATALOG_LABEL, {
	                        client_id: client_id,
	                        client_secret: client_secret,
	                        channel_id: channel_id
	                    });
	                }
	            };
	        }
	    }, {
	        key: 'lang',
	        get: function get() {
	            var _this6 = this;
	
	            return {
	                getLangData: function getLangData() {
	                    return _this6._send(constants.IBONUS_PATH_LANG_GET_LANG_DATA);
	                }
	            };
	        }
	    }]);
	    return IBonusApi;
	}();
	
	exports.default = IBonusApi;
	module.exports = exports['default'];

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(1593);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _config = __webpack_require__(383);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _IBonusError = __webpack_require__(191);
	
	var _IBonusError2 = _interopRequireDefault(_IBonusError);
	
	var _isString = __webpack_require__(486);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _Factory = __webpack_require__(259);
	
	var _Factory2 = _interopRequireDefault(_Factory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PIPOApi = function () {
	    function PIPOApi(client) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, PIPOApi);
	
	        this._send = function (path, data) {
	            return _this.client.post(path, { data: data }, _config2.default.pipoHost);
	            // .then((result) =>{
	            //
	            //     let status = !!result.status;
	            //
	            //     if(status){
	            //         return result.result;
	            //     }else{
	            //
	            //     }
	            // });
	        };
	
	        this.client = client;
	    }
	
	    (0, _createClass3.default)(PIPOApi, [{
	        key: 'getApiKey',
	        value: function getApiKey(userId) {
	            return this._send(constants.PIPO_PATH_GET_API_KEY, { id_user: userId }).then(function (result) {
	                if (result && result.result) {
	                    return result.result;
	                }
	
	                return result;
	            });
	        }
	    }, {
	        key: 'login',
	        value: function login(_login, password) {
	            var checkCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	            var fields = { login: _login, password: password };
	
	            if (checkCode) {
	                fields['check_code'] = checkCode;
	            }
	
	            return this._send(constants.PIPO_PATH_LOGIN, fields);
	        }
	    }, {
	        key: 'getInputGroupsByPaymentInId',
	        value: function getInputGroupsByPaymentInId(paymentInId, user_id, api_key) {
	            return this._send(constants.PIPO_PATH_GET_INPUT_GROUPS_BY_PAYMENT_IN_ID, {
	                paymentInId: paymentInId, user_id: user_id, api_key: api_key
	            });
	        }
	    }, {
	        key: 'getPaymentsParamsFromPIPObyId',
	        value: function getPaymentsParamsFromPIPObyId(shopPipoId) {
	            return this._send(constants.PIPO_PATH_GET_GET_BY_ID, {
	                id_shop: shopPipoId
	            }).then(function (data) {
	                return _Factory2.default.create('ShopParameters', data.result);
	            });
	        }
	
	        // getPaymentsParamsFromPIPObyId(shopPipoId) {
	        //     // console.log(shopPipoId);
	        //     const data = require('./params.json');
	        //
	        //     return Promise.resolve(new ShopParameters(data.result));
	        // }
	
	    }, {
	        key: 'getDetailPayIn',
	        value: function getDetailPayIn(id_operation, id_user, api_key) {
	            return this._send(constants.PIPO_PATH_GET_DETAIL_PAYIN, {
	                id_operation: id_operation, id_user: id_user, api_key: api_key
	            });
	        }
	    }, {
	        key: 'getLang',
	        value: function getLang(lang) {
	            var langCrutch = '';
	            switch (lang) {
	                case 'ru':
	                    langCrutch = 'ru';
	                    break;
	                case 'rus':
	                    langCrutch = 'ru';
	                    break;
	                case 'kaz':
	                    langCrutch = 'ru';
	                    break;
	                case 'ukr':
	                    langCrutch = 'ru';
	                    break;
	                case 'en':
	                    langCrutch = 'en';
	                    break;
	                case 'eng':
	                    langCrutch = 'en';
	                    break;
	                case 'gbr':
	                    langCrutch = 'en';
	                    break;
	                case 'eur':
	                    langCrutch = 'en';
	                    break;
	                default:
	                    langCrutch = 'ru';
	                    break;
	            }
	
	            return this.client.getRaw('lang/' + langCrutch + '.json', _config2.default.pipoHost).then(function (text) {
	                return JSON.parse(text);
	            });
	        }
	    }, {
	        key: 'processInput',
	        value: function processInput(params) {
	            return this.client.get(constants.PIPO_PATH_PROCESS_INPUT, { params: params }, _config2.default.pipoHost).then(function (result) {
	                return result;
	                var status = !!result.status;
	
	                if (status) {
	                    return result.result;
	                } else {
	                    var message = '',
	                        title = '',
	                        code = 0,
	                        trace = '';
	                    if ((0, _isString2.default)(result.result)) {
	                        message = result.result;
	                        title = result.result;
	                    } else if (result.hasOwnProperty('user_msg')) {
	                        message = result.user_msg;
	                        title = result.user_msg;
	                    } else {
	                        message = result.result.error.message || '';
	                        title = result.result.title || 0;
	                        code = result.result.code || 0;
	                        trace = result.result.error.trace || '';
	                    }
	                    throw new _IBonusError2.default({
	                        message: message,
	                        title: title,
	                        code: code,
	                        trace: trace
	                    });
	                }
	            });
	        }
	    }]);
	    return PIPOApi;
	}();
	
	exports.default = PIPOApi;
	module.exports = exports['default'];

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PIPO_PATH_GET_API_KEY = exports.PIPO_PATH_GET_API_KEY = '/ajax/action_user/set_api_key';
	var PIPO_PATH_GET_GET_BY_ID = exports.PIPO_PATH_GET_GET_BY_ID = '/action_shop/get_by_id';
	var PIPO_PATH_LOGIN = exports.PIPO_PATH_LOGIN = '/ajax/action_user/login';
	var PIPO_PATH_GET_INPUT_GROUPS_BY_PAYMENT_IN_ID = exports.PIPO_PATH_GET_INPUT_GROUPS_BY_PAYMENT_IN_ID = '/ajax/action_api/get_input_groups_by_payment_in_id';
	var PIPO_PATH_GET_DETAIL_PAYIN = exports.PIPO_PATH_GET_DETAIL_PAYIN = '/ajax/action_account/get_detail_payin';
	var PIPO_PATH_PROCESS_INPUT = exports.PIPO_PATH_PROCESS_INPUT = '/api/process_input';

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	__webpack_require__(195);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _create = __webpack_require__(1885);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _ApiClient = __webpack_require__(741);
	
	var _ApiClient2 = _interopRequireDefault(_ApiClient);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(19);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _useStandardScroll = __webpack_require__(1566);
	
	var _useStandardScroll2 = _interopRequireDefault(_useStandardScroll);
	
	var _routes = __webpack_require__(1919);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _IBonusProxy = __webpack_require__(742);
	
	var _IBonusProxy2 = _interopRequireDefault(_IBonusProxy);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var client = new _ApiClient2.default();
	var ibonus = new _IBonusProxy2.default(client, _LocalStorageProxy2.default, {});
	var _browserHistory = (0, _useStandardScroll2.default)(function () {
	    return _reactRouter.browserHistory;
	})();
	var dest = document.getElementById('content');
	var store = (0, _create2.default)(_browserHistory, client, ibonus, window.__data);
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_browserHistory, store);
	
	ibonus.channelId = store.getState().setting.channelId;
	ibonus.profileId = store.getState().setting.profileId;
	ibonus.onlineShopId = store.getState().setting.shopId;
	
	var component = _react2.default.createElement(
	    _reactRouter.Router,
	    { render: function render(props) {
	            return _react2.default.createElement(_reduxAsyncConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, { helpers: { client: client }, filter: function filter(item) {
	                    return !item.deferred;
	                } }));
	        }, history: history
	    },
	    (0, _routes2.default)(store)
	);
	
	_reactDom2.default.render(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store, key: 'provider' },
	    component
	), dest);
	
	if (false) {
	    window.React = _react2.default; // enable debugger
	
	    if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
	        console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
	    }
	}
	
	if (false) {
	    var DevTools = require('./containers/DevTools/DevTools');
	    _reactDom2.default.render(_react2.default.createElement(
	        _reactRedux.Provider,
	        { store: store, key: 'provider' },
	        _react2.default.createElement(
	            'div',
	            { className: 'u-full-height' },
	            component,
	            _react2.default.createElement(DevTools, null)
	        )
	    ), dest);
	}

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(15);
	
	var _modal = __webpack_require__(26);
	
	var _config = __webpack_require__(193);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  AddressInput: {
	    displayName: 'AddressInput'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/usr/local/ibonus/src/components/AddressInput/AddressInput.jsx',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var AddressInput = _wrapComponent('AddressInput')((_dec = (0, _reactRedux.connect)(function (state) {
	  return {
	    lang: state.lang,
	    currency: state.currency
	  };
	}, {
	  showModal: _modal.showModal, hide: _modal.hide
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(AddressInput, _Component);
	
	  function AddressInput(props) {
	    (0, _classCallCheck3.default)(this, AddressInput);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AddressInput.__proto__ || (0, _getPrototypeOf2.default)(AddressInput)).call(this, props));
	
	    _this.openMapModal = function () {
	      var _this$props = _this.props,
	          label = _this$props.label,
	          value = _this$props.value;
	
	
	      _this.props.showModal({
	        title: label,
	        content: _react3.default.createElement('div', {
	          id: 'g-map-in-modal',
	          style: { width: '100%', height: '500px' }
	        }),
	        modalType: 'mapModal'
	      });
	
	      /** Если в инпуте уже есть введенный адрес */
	      if (!!value && !!value.trim()) {
	        _this._initGoogleMapFromAddress();
	      } else {
	        _this._initDefaultGoogleMap();
	      }
	    };
	
	    _this._buildAddress = function (address) {
	      var region = address.region;
	      if (region) {
	        if (true) {
	          region = '';
	        }
	      }
	      return (address.country ? address.country : '') + region + (address.city ? ', ' + address.city : '') + (address.street ? ', ' + address.street : '') + (address.building ? ', ' + address.building : '') + (address.chamber ? ', ' + address.chamber : '');
	    };
	
	    _this.onAddressSelect = function (selectedOption) {
	      _this.setState({ selectedOption: selectedOption });
	      var event = {
	        target: {
	          value: selectedOption.address || ''
	        }
	      };
	      _this.props.onAddressChange(event);
	    };
	
	    _this._addConfirmationButton = function () {
	      var lang = _this.props.lang;
	
	
	      var parentDiv = document.createElement('div');
	      parentDiv.style.marginBottom = '22px';
	      _this._confirmationButton = new ConfirmationButton(parentDiv, lang);
	
	      // Дефолтное состояние кнопки
	      _this._confirmationButton.setIsEnabled(false);
	
	      parentDiv.index = 1;
	      _this.map.controls[window.google.maps.ControlPosition.BOTTOM_CENTER].push(parentDiv);
	      parentDiv.addEventListener('click', function () {
	        if (_this._confirmationButton.isEnabled) {
	          var event = {
	            target: {
	              value: _this.address
	            }
	          };
	
	          _this.props.onAddressChange(event);
	          _this.props.hide();
	        }
	      });
	    };
	
	    _this._addWhereIamButton = function () {
	      var lang = _this.props.lang;
	
	
	      var parentDiv = document.createElement('div');
	      _this._whereIamButton = new WhereIamButton(parentDiv, lang);
	
	      parentDiv.index = 2;
	      _this.map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(parentDiv);
	      parentDiv.addEventListener('click', function () {
	        if (navigator.geolocation) {
	          try {
	            navigator.geolocation.getCurrentPosition(function (position) {
	              var latlng = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude);
	              _this.mapMarker.setPosition(latlng);
	              _this._geocodePosition(_this.mapMarker.getPosition());
	              _this.map.setCenter(latlng);
	            }, function (error) {
	              _this._findUserGeolocation().then(function (response) {
	                return response.json();
	              }).then(function (response) {
	                var latlng = new window.google.maps.LatLng(response.location.lat, response.location.lng);
	                _this.mapMarker.setPosition(latlng);
	                _this._geocodePosition(_this.mapMarker.getPosition());
	                _this.map.setCenter(latlng);
	              });
	            });
	          } catch (error) {
	            if (_this.countErrorElementGmaps < 10) {
	              _this.countErrorElementGmaps += 1;
	              setTimeout(function () {
	                _this._addWhereIamButton();
	              }, 100);
	            } else {
	              _this._initDefaultGoogleMap();
	            }
	          }
	        } else {
	          _this._findUserGeolocation().then(function (response) {
	            return response.json();
	          }).then(function (response) {
	            var latlng = new window.google.maps.LatLng(response.location.lat, response.location.lng);
	            _this.mapMarker.setPosition(latlng);
	            _this._geocodePosition(_this.mapMarker.getPosition());
	            _this.map.setCenter(latlng);
	          });
	        }
	        $('#you-location-img').addClass('_active');
	      });
	    };
	
	    _this.geocoder = null;
	    _this.infoWindow = null;
	    _this.geolocation = null;
	    _this.address = props.value;
	
	    var selected = {};
	    if (props.value) {
	      //если есть сохраненный адрес
	      selected = { address: props.value };
	    } else {
	      if (props.options) {
	        _this.props.options.forEach(function (option) {
	          if (option.is_default === true) {
	            selected = option;
	          }
	        });
	      }
	    }
	    _this.state = {
	      selectedOption: selected
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(AddressInput, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.geocoder = null;
	      this.infoWindow = null;
	      this.mapMarker = null;
	      this.map = null;
	    }
	  }, {
	    key: '_currentLangToGoogleLangCode',
	    value: function _currentLangToGoogleLangCode(langSlug) {
	      switch (langSlug) {
	        case 'rus':
	          return 'ru';
	        case 'eng':
	        case 'gbr':
	        case 'eur':
	          return 'en';
	        case 'kaz':
	          return 'kk';
	        case 'ukr':
	          return 'uk';
	        default:
	          return 'en';
	      }
	    }
	
	    /**
	     * Возвращает данные о местоположении по названию адреса
	     * @returns {Promise<Response>}
	     * @private
	     */
	
	  }, {
	    key: '_findGeolocationByAddress',
	    value: function _findGeolocationByAddress() {
	      var _props = this.props,
	          currency = _props.currency,
	          value = _props.value;
	
	      var lang = 'en';
	      if (currency && !!currency.lang) {
	        lang = this._currentLangToGoogleLangCode(currency.lang.slug);
	      }
	      /**
	       * response : {
	       *     address_components: (7) [{…}, {…}, {…}, {…}, {…}, {…}, {…}],
	       *     types: ["premise", "street_address"],
	       *     geometry:
	       *       bounds: {northeast: {…}, southwest: {…}}
	       *       location: {lat: 57.9966685, lng: 56.23020349999999}
	       * }
	       */
	      return fetch('\n                https://maps.googleapis.com/maps/api/geocode/json?key=' + _config2.default.gapi.key + '\n                &address=' + encodeURIComponent(value) + '\n                &language=' + lang + '\n        ', {
	        method: 'POST'
	      });
	    }
	
	    /**
	     * Поиск геолокации юзера
	     * @returns {Promise<Response>}
	     * @private
	     */
	
	  }, {
	    key: '_findUserGeolocation',
	    value: function _findUserGeolocation() {
	      return fetch('https://www.googleapis.com/geolocation/v1/geolocate?key=' + _config2.default.gapi.key, {
	        method: 'POST'
	      });
	    }
	  }, {
	    key: '_initDefaultGoogleMap',
	    value: function _initDefaultGoogleMap() {
	      var _this2 = this;
	
	      if (!this.map) {
	        try {
	          this._findUserGeolocation().then(function (response) {
	            return response.json();
	          }).then(function (response) {
	            var location = response.location;
	            _this2.geolocation = location;
	            _this2._createGoogleMap(location);
	            _this2._initGeoCoder();
	            _this2._initInfoWindow();
	            _this2._addMapMarker(response);
	            _this2._addConfirmationButton();
	            _this2._addWhereIamButton();
	            _this2._addSearchInput();
	            _this2._addEventHandlers();
	          });
	        } catch (error) {
	          if (this.countErrorElementGmaps < 10) {
	            this.countErrorElementGmaps += 1;
	            setTimeout(function () {
	              _this2._initDefaultGoogleMap();
	            }, 100);
	          } else {
	            throw error;
	          }
	        }
	      } else {
	        setTimeout(function () {
	          _this2._getOldMapData();
	          // this._addEventHandlers();
	        }, 100);
	      }
	    }
	  }, {
	    key: '_initGoogleMapFromAddress',
	    value: function _initGoogleMapFromAddress() {
	      var _this3 = this;
	
	      if (!this.map) {
	        try {
	          this._findGeolocationByAddress().then(function (response) {
	            return response.json();
	          }).then(function (response) {
	            try {
	              var result = response.results;
	              if (result.length > 0) {
	                _this3._createGoogleMap(result[0].geometry.location);
	                _this3._initGeoCoder();
	                _this3._initInfoWindow();
	                _this3._addConfirmationButton();
	                _this3._addWhereIamButton();
	                _this3._createMapMarkerFromAddressLocation(response);
	                _this3._addSearchInput();
	                _this3._addEventHandlers();
	              } else {
	                _this3._initDefaultGoogleMap();
	              }
	            } catch (e) {
	              throw e;
	            }
	          });
	        } catch (error) {
	          if (this.countErrorElementGmaps < 10) {
	            this.countErrorElementGmaps += 1;
	            setTimeout(function () {
	              _this3._initGoogleMapFromAddress();
	            }, 100);
	          } else {
	            this._initDefaultGoogleMap();
	          }
	        }
	      } else {
	        setTimeout(function () {
	          _this3._getOldMapData();
	          // this._addEventHandlers();
	        }, 100);
	      }
	    }
	
	    /**
	     * создаем инстанс попапа
	     * @private
	     */
	
	  }, {
	    key: '_initInfoWindow',
	    value: function _initInfoWindow() {
	      this.infoWindow = new window.google.maps.InfoWindow();
	    }
	  }, {
	    key: '_initGeoCoder',
	    value: function _initGeoCoder() {
	      this.geocoder = new window.google.maps.Geocoder();
	    }
	  }, {
	    key: '_getOldMapData',
	    value: function _getOldMapData() {
	      var value = this.props.value;
	
	
	      var oldMap = this.map;
	
	      var oldMapState = {
	        center: oldMap.center,
	        bounds: oldMap.getBounds(),
	        zoom: oldMap.zoom,
	        mapTypeControl: true,
	        mapTypeControlOptions: {
	          style: window.google.maps.MapTypeControlStyle.DROPDOWN_MENU
	        }
	      };
	
	      var parentDivElement = document.getElementById('g-map-in-modal');
	
	      this.map = new window.google.maps.Map(parentDivElement, oldMapState);
	
	      /** Если в инпуте введен адрес - получаем из него метку на карте */
	      if (!!value && value.trim().length > 0) {
	        this._createMapMarkerFromAddress();
	      } else {
	        // Если мы зашли сюда и в инпуте нет адреса, значит уже был создан маркер с дефолтной позицией
	        this._createDefaultMapMarker({
	          lat: this.mapMarker.position.lat(),
	          lng: this.mapMarker.position.lng()
	        });
	        this._addEventHandlers();
	      }
	
	      this._addSearchInput();
	      this._addConfirmationButton();
	      this._addWhereIamButton();
	    }
	
	    /**
	     * @param location location { lat: 34, lng: 45 }
	     * @private
	     */
	
	  }, {
	    key: '_createGoogleMap',
	    value: function _createGoogleMap(location) {
	      var parentDivElement = document.getElementById('g-map-in-modal');
	      this.map = new window.google.maps.Map(parentDivElement, {
	        zoom: 10,
	        center: location,
	        mapTypeControl: true,
	        mapTypeControlOptions: {
	          style: window.google.maps.MapTypeControlStyle.DROPDOWN_MENU
	        }
	      });
	    }
	
	    /**
	     * После переключения языков, инпут с поиском куда-то пропадает (удаляется из дом-дерева),
	     * поэтому каждый раз создаем новый инпут элемент для поиска
	     * @private
	     */
	
	  }, {
	    key: '_initSearchInputElement',
	    value: function _initSearchInputElement() {
	      var searchInputElement = document.createElement('input');
	      searchInputElement.type = 'text';
	      searchInputElement.id = 'pac-input';
	      searchInputElement.className = 'controls';
	      var modalMapParent = document.getElementById('g-map-in-modal');
	      modalMapParent.appendChild(searchInputElement);
	    }
	
	    /**
	     * Каждый раз, при создании нового инпута с поиском, в дом-дерево добавляется элемент с class=pac-container
	     * И он отображается позади модалки
	     * поэтому самостоятельно выставляем ему стили
	     * @private
	     */
	
	  }, {
	    key: '_initSearchResponseOutput',
	    value: function _initSearchResponseOutput() {
	      var searchResponseOutput = document.getElementsByClassName('pac-container');
	      if (searchResponseOutput.length > 1) {
	        searchResponseOutput[0].parentNode.removeChild(searchResponseOutput[0]);
	      }
	      if (searchResponseOutput[0]) {
	        searchResponseOutput[0].style.cssText = 'z-index: 10000; width: 300px;';
	      }
	    }
	  }, {
	    key: '_addSearchInput',
	    value: function _addSearchInput() {
	      /**
	       * Чтоб устранить баг, когда открывается полный экран и в нем нет инпута
	       * поиска
	       * https://stackoverflow.com/a/56712072
	       */
	      document.onfullscreenchange = function (event) {
	        var target = event.target;
	        var pacContainerElements = document.getElementsByClassName('pac-container');
	        if (pacContainerElements.length > 0) {
	          var pacContainer = document.getElementsByClassName('pac-container')[0];
	          if (pacContainer.parentElement === target) {
	            document.getElementsByTagName('body')[0].appendChild(pacContainer);
	          } else {
	            target.appendChild(pacContainer);
	          }
	        }
	      };
	
	      this._initSearchInputElement();
	      // Create the search box and link it to the UI element.
	      var input = document.getElementById('pac-input');
	      // в _addEventHandlers навешаны два обработчика
	      this.searchBox = new window.google.maps.places.SearchBox(input);
	      this.map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);
	
	      // для адекватного появления инпута в модалке
	      setTimeout(function () {
	        input.style.display = 'block';
	      }, 500);
	    }
	
	    /**
	     * Создание дефолтного маркера на карте по гео позиции юзера
	     * @param location { lat: 34, lng: 45 }
	     * @private
	     */
	
	  }, {
	    key: '_createDefaultMapMarker',
	    value: function _createDefaultMapMarker(location) {
	      var lang = this.props.lang;
	
	      this.mapMarker = new window.google.maps.Marker({
	        map: this.map,
	        draggable: true,
	        position: location
	      });
	
	      // Попап над маркером
	      this.infoWindow.open(this.map, this.mapMarker);
	      // Дефолтный текст при первом открытии
	      this.infoWindow.setContent(lang['createTradePoint.placemark.iconContent']);
	    }
	
	    /**
	     *
	     * @param response  - _findGeolocationByAddress описание ответа здесь
	     * @private
	     */
	
	  }, {
	    key: '_createMapMarkerFromAddressLocation',
	    value: function _createMapMarkerFromAddressLocation(response) {
	      this.mapMarker = new window.google.maps.Marker({
	        map: this.map,
	        draggable: true,
	        position: response.results[0].geometry.location // { lat: 34, lng: 34 }
	      });
	      // Попап над маркером
	      this.infoWindow.open(this.map, this.mapMarker);
	      this._setGeolocationData([response.results[0]]);
	    }
	  }, {
	    key: '_createMapMarkerFromAddress',
	    value: function _createMapMarkerFromAddress() {
	      var _this4 = this;
	
	      this._findGeolocationByAddress().then(function (response) {
	        return response.json();
	      }).then(function (response) {
	        if (response.results.length === 0) {
	          _this4._createDefaultMapMarker(_this4.geolocation);
	          _this4._addEventHandlers();
	        } else {
	          _this4.mapMarker = new window.google.maps.Marker({
	            map: _this4.map,
	            draggable: true,
	            position: response.results[0].geometry.location // { lat: 34, lng: 34 }
	          });
	          // Попап над маркером
	          _this4.infoWindow.open(_this4.map, _this4.mapMarker);
	          _this4._setGeolocationData([response.results[0]]);
	          _this4._addEventHandlers();
	        }
	      }).catch(function (error) {
	        console.log('_createMapMarkerFromAddress catch err', error);
	      });
	    }
	
	    /**
	     * Добавление метки на карту
	     * @param response
	     * @private
	     */
	
	  }, {
	    key: '_addMapMarker',
	    value: function _addMapMarker(response) {
	      var value = this.props.value;
	
	
	      if (!!value && !!value.trim()) {
	        this._createMapMarkerFromAddress(value);
	      } else {
	        this._createDefaultMapMarker(response.location);
	      }
	    }
	
	    /**
	     * Получение данных об конкретном месте на карте (адрес, страна и т.д.)
	     * @param pos { lat: ƒ, lng: ƒ }
	     * @private
	     */
	
	  }, {
	    key: '_geocodePosition',
	    value: function _geocodePosition(pos) {
	      var _this5 = this;
	
	      this.geocoder.geocode({
	        latLng: pos
	      }, function (results, status) {
	        if (status === window.google.maps.GeocoderStatus.OK) {
	          _this5._setGeolocationData(results);
	        }
	      });
	    }
	
	    /**
	     * Добавляем обработчики событий на карту и маркер
	     * @private
	     */
	
	  }, {
	    key: '_addEventHandlers',
	    value: function _addEventHandlers() {
	      var _this6 = this;
	
	      /** Обработка клика по карте */
	      window.google.maps.event.addListener(this.map, 'click', function (event) {
	        _this6.mapMarker.setPosition(new window.google.maps.LatLng(event.latLng.lat(), event.latLng.lng()));
	        _this6._geocodePosition(_this6.mapMarker.getPosition());
	        $('#you-location-img').removeClass('_active');
	      });
	
	      /** Когда перемещаем карту */
	      window.google.maps.event.addListener(this.map, 'dragend', function () {
	        $('#you-location-img').removeClass('_active');
	      });
	
	      if (this.mapMarker) {
	        /** Когда тащим маркер */
	        window.google.maps.event.addListener(this.mapMarker, 'drag', function (event) {
	          _this6.mapMarker.setPosition(new window.google.maps.LatLng(event.latLng.lat(), event.latLng.lng()));
	        });
	
	        /** Когда тащим маркер */
	        window.google.maps.event.addListener(this.mapMarker, 'dragend', function (event) {
	          _this6._geocodePosition(_this6.mapMarker.getPosition());
	          $('#you-location-img').removeClass('_active');
	        });
	      } else {
	        setTimeout(function () {
	          /** Когда тащим маркер */
	          window.google.maps.event.addListener(_this6.mapMarker, 'drag', function (event) {
	            _this6.mapMarker.setPosition(new window.google.maps.LatLng(event.latLng.lat(), event.latLng.lng()));
	          });
	
	          /** Когда тащим маркер */
	          window.google.maps.event.addListener(_this6.mapMarker, 'dragend', function (event) {
	            _this6._geocodePosition(_this6.mapMarker.getPosition());
	            $('#you-location-img').removeClass('_active');
	          });
	        }, 300);
	      }
	
	      // Bias the SearchBox results towards current map's viewport.
	      this.map.addListener('bounds_changed', function () {
	        _this6._initSearchResponseOutput();
	        _this6.searchBox.setBounds(_this6.map.getBounds());
	      });
	
	      this.searchBox.addListener('places_changed', function () {
	        var places = _this6.searchBox.getPlaces();
	
	        if (places.length === 0) {
	          return;
	        }
	        if (!places[0].geometry) {
	          return;
	        }
	
	        _this6.mapMarker.setPosition(new window.google.maps.LatLng(places[0].geometry.location.lat(), // число
	        places[0].geometry.location.lng()) // число
	        );
	        _this6._geocodePosition(_this6.mapMarker.getPosition());
	      });
	    }
	
	    /**
	     * Заполняем модельки формы данными о полученном адресе
	     * @param resultGeolocation
	     * @private
	     */
	
	  }, {
	    key: '_setGeolocationData',
	    value: function _setGeolocationData(resultGeolocation) {
	      var lang = this.props.lang;
	      /** Если на карте нормальный адрес улицы, то можно получить нужные данные и показать кнопку сохранения */
	
	      var addressData = resultGeolocation.find(function (item) {
	        return item.types.includes('street_address') || item.types.includes('premise');
	      });
	      // Иногда может вернуться номер улицы без названия
	      if (!!addressData && addressData.address_components.length > 6) {
	        /** Получение адреса */
	        var address = addressData.address_components;
	        var currentCountry = address.find(function (item) {
	          return item.types.includes('country');
	        }).long_name;
	        var region = address.find(function (item) {
	          return item.types.includes('administrative_area_level_1') || item.types.includes('administrative_area_level_2') || item.types.includes('administrative_area_level_3') || item.types.includes('administrative_area_level_4') || item.types.includes('administrative_area_level_5');
	        }).long_name;
	        var city = address.find(function (item) {
	          return item.types.includes('locality');
	        }).long_name;
	        var streetName = address.find(function (item) {
	          return item.types.includes('route');
	        }).long_name;
	        var streetNumber = address.find(function (item) {
	          return item.types.includes('street_number');
	        }).long_name;
	
	        /** Смена  контента попапа */
	        this.infoWindow.setContent(streetName + ', ' + streetNumber);
	        /** Делаем кнопку подтверждения активной */
	        this._confirmationButton.setIsEnabled(true);
	
	        var addressResult = {
	          country: currentCountry,
	          region: region,
	          city: city,
	          street: streetName,
	          building: streetNumber,
	          chamber: ''
	        };
	        this.address = this._buildAddress(addressResult);
	        this.onAddressSelect({ address: this.address });
	      } else {
	        this._confirmationButton.setIsEnabled(false);
	        this.infoWindow.setContent(lang['createTradePoint.placemark.iconContent']);
	      }
	    }
	
	    /**
	     * Собрать строку адреса {Регион}, {Город}, {Улица}, {Номер дома}, {Офис/квартира}
	     * @param {Object} address
	     * @returns {string}
	     */
	
	
	    /**
	     * Добавление кнопки подтверждения на карту
	     * @private
	     */
	
	
	    /**
	     * Добавление кнопки "Где я?"
	     * @private
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var _props2 = this.props,
	          placeholder = _props2.placeholder,
	          label = _props2.label,
	          buttonText = _props2.buttonText,
	          options = _props2.options,
	          _onAddressSave = _props2.onAddressSave,
	          onAddAddress = _props2.onAddAddress,
	          lang = _props2.lang,
	          isOrderWasPaid = _props2.isOrderWasPaid;
	      var selectedOption = this.state.selectedOption;
	
	
	      var View = _helpers.ThemeHelper.getViewForComponent('AddressInput');
	
	      return _react3.default.createElement(View, {
	        isOrderWasPaid: isOrderWasPaid,
	        placeholder: placeholder,
	        value: selectedOption,
	        options: options,
	        label: label,
	        buttonText: buttonText ? buttonText : lang['store.common.select_on_map'],
	        buttonAddAddressText: lang['user.address.button.addNewAddress'],
	        noOptionsMessageText: lang['user.address.noAddress'],
	        onAddressChange: this.onAddressSelect,
	        onAddAddress: onAddAddress,
	        onAddressSave: function onAddressSave() {
	          return _onAddressSave({ address: _this7.address });
	        },
	        buttonSaveText: lang['store.common.save_address'],
	        onButtonClick: this.openMapModal
	      });
	    }
	  }]);
	  return AddressInput;
	}(_react2.Component), _class2.propTypes = {
	  isOrderWasPaid: _react2.PropTypes.bool,
	  placeholder: _react2.PropTypes.string,
	  value: _react2.PropTypes.string,
	  options: _react2.PropTypes.array,
	  label: _react2.PropTypes.string,
	  buttonText: _react2.PropTypes.string,
	  onAddressSave: _react2.PropTypes.func,
	  onAddressChange: _react2.PropTypes.func.isRequired,
	  onAddAddress: _react2.PropTypes.func.isRequired,
	  lang: _react2.PropTypes.object.isRequired,
	  currency: _react2.PropTypes.object.isRequired
	}, _temp)) || _class));
	
	exports.default = AddressInput;
	
	/**
	 * Кнопка подтверждения на карте
	 * @param parentDiv html div
	 * @param language
	 * @constructor
	 */
	
	function ConfirmationButton(parentDiv, language) {
	  var _this8 = this;
	
	  this.isEnabled = false;
	  var controlUI = document.createElement('div');
	  parentDiv.appendChild(controlUI);
	
	  // Текст
	  var controlText = document.createElement('div');
	  controlText.innerHTML = '\n                    <button\n                        class=\'le-button button_width_100\'\n                    >\n                        ' + language['createTradePoint.indicateOnMap.confirmationButton'] + '\n                    </button>';
	  controlUI.appendChild(controlText);
	
	  this.setIsEnabled = function (isEnabled) {
	    _this8.isEnabled = isEnabled;
	    // Пробовал через класс, но стили почему-то не применялись, поэтому пришлось сделать прямо
	    if (isEnabled) {
	      controlUI.setAttribute('disabled', 'false');
	      controlUI.setAttribute('style', 'opacity: 1');
	    } else {
	      controlUI.setAttribute('style', 'opacity: .6');
	      controlUI.setAttribute('disabled', 'true');
	    }
	  };
	}
	
	/**
	 * Кнопка "Где я?" на карте
	 * @param parentDiv html div
	 * @param language
	 * @constructor
	 */
	function WhereIamButton(parentDiv, language) {
	  var firstChild = document.createElement('button');
	  firstChild.id = 'whereiam-button';
	  firstChild.className = 'map-whereiam-button';
	  firstChild.title = language['createTradePoint.indicateOnMap.whereIamButton'];
	  parentDiv.appendChild(firstChild);
	
	  var secondChild = document.createElement('div');
	  secondChild.id = 'you-location-img';
	  firstChild.appendChild(secondChild);
	}
	module.exports = exports['default'];

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(68);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(69);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _reactSelect = __webpack_require__(1477);
	
	__webpack_require__(1126);
	
	__webpack_require__(1061);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AddressInputView: {
	        displayName: 'AddressInputView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/AddressInput/default/AddressInputView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var AddressInputView = _wrapComponent('AddressInputView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(AddressInputView, _Component);
	
	    function AddressInputView(props) {
	        (0, _classCallCheck3.default)(this, AddressInputView);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AddressInputView.__proto__ || (0, _getPrototypeOf2.default)(AddressInputView)).call(this, props));
	
	        _this.sortAddresses = function (addresses) {
	            var defaultIdx = addresses.findIndex(function (address) {
	                return address.is_default;
	            });
	            if (defaultIdx < 0) return addresses.sort(function (a, b) {
	                return b.id - a.id;
	            });
	            var defaultAddress = (0, _extends3.default)({}, addresses[defaultIdx]);
	            addresses.splice(defaultIdx, 1);
	            addresses.sort(function (a, b) {
	                return b.id - a.id;
	            });
	            addresses.unshift(defaultAddress);
	            return addresses;
	        };
	
	        _this.state = {
	            isSelectOpen: false
	        };
	
	        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	
	        if (!(typeof _this.handleClickOutside === 'function')) {
	            throw new TypeError('Value of "this.handleClickOutside" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.handleClickOutside));
	        }
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(AddressInputView, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            document.addEventListener('mousedown', this.handleClickOutside);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('mousedown', this.handleClickOutside);
	        }
	
	        /**
	         * Alert if clicked on outside of element
	         */
	
	    }, {
	        key: 'handleClickOutside',
	        value: function handleClickOutside(event) {
	            var select = document.getElementById('address-select');
	            if (select && !select.contains(event.target)) {
	                this.setState({ isSelectOpen: false });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                placeholder = _props.placeholder,
	                value = _props.value,
	                options = _props.options,
	                label = _props.label,
	                buttonText = _props.buttonText,
	                buttonAddAddressText = _props.buttonAddAddressText,
	                noOptionsMessageText = _props.noOptionsMessageText,
	                onAddressChange = _props.onAddressChange,
	                onButtonClick = _props.onButtonClick,
	                onAddAddress = _props.onAddAddress,
	                isOrderWasPaid = _props.isOrderWasPaid;
	
	            /** Если оставить по дефолту, то клавиша "," создает новую опцию */
	
	            var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(keyCode) {
	                return [9, // tab
	                13].indexOf(keyCode) !== -1;
	            };
	
	            var isAddButtonDisabled = !value.address || !!options.find(function (option) {
	                return option.address === (value || {}).address && typeof option.id === 'number';
	            });
	            var isSelectOpen = this.state.isSelectOpen;
	
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'address-select__container' },
	                _react3.default.createElement(
	                    _reactBootstrap.FormGroup,
	                    { className: 'address-select__from-group col-xs-12 col-sm-6' },
	                    _react3.default.createElement(
	                        _reactBootstrap.ControlLabel,
	                        null,
	                        label
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'address-select__input-select' },
	                        _react3.default.createElement(
	                            'svg',
	                            { onClick: function onClick() {
	                                    return onAddressChange({ address: null });
	                                }, id: 'Capa_1', className: 'clear', 'enable-background': 'new 0 0 386.667 386.667', height: '10px', viewBox: '0 0 386.667 386.667', width: '10px', xmlns: 'http://www.w3.org/2000/svg' },
	                            _react3.default.createElement('path', { d: 'm386.667 45.564-45.564-45.564-147.77 147.769-147.769-147.769-45.564 45.564 147.769 147.769-147.769 147.77 45.564 45.564 147.769-147.769 147.769 147.769 45.564-45.564-147.768-147.77z' })
	                        ),
	                        _react3.default.createElement('input', {
	                            onChange: function onChange(e) {
	                                return onAddressChange({ address: e.target.value });
	                            },
	                            value: value.address,
	                            onFocus: function onFocus() {
	                                return _this2.setState({ isSelectOpen: true });
	                            },
	                            placeholder: placeholder,
	                            className: 'form-control',
	                            type: 'text',
	                            list: 'list'
	                        }),
	                        isSelectOpen && _react3.default.createElement(
	                            'ul',
	                            { id: 'address-select' },
	                            this.sortAddresses(options).map(function (option) {
	                                return _react3.default.createElement(
	                                    'li',
	                                    { onClick: function onClick(e) {
	                                            onAddressChange({ address: e.target.innerText });
	                                            _this2.setState({ isSelectOpen: false });
	                                        } },
	                                    option.address
	                                );
	                            })
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-3 col-xs-12 text-right' },
	                    _react3.default.createElement(
	                        'button',
	                        {
	                            disabled: isOrderWasPaid,
	                            onClick: onButtonClick,
	                            className: 'le-button pay_order_button button_width_100 ' + (isOrderWasPaid ? 'disabled' : '')
	                        },
	                        buttonText
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-3 text-center' },
	                    _react3.default.createElement(
	                        'button',
	                        {
	                            disabled: isAddButtonDisabled,
	                            onClick: function onClick() {
	                                return onAddAddress({ address: (value || {}).address });
	                            },
	                            className: 'le-button pay_order_button button_width_100}'
	                        },
	                        buttonAddAddressText
	                    )
	                )
	            );
	        }
	    }]);
	    return AddressInputView;
	}(_react2.Component), _class.propTypes = {
	    isOrderWasPaid: _react2.PropTypes.bool,
	    placeholder: _react2.PropTypes.string.isRequired,
	    value: _react2.PropTypes.object.isRequired,
	    options: _react2.PropTypes.array.isRequired,
	    label: _react2.PropTypes.string.isRequired,
	    buttonText: _react2.PropTypes.string.isRequired,
	    buttonAddAddressText: _react2.PropTypes.string.isRequired,
	    noOptionsMessageText: _react2.PropTypes.string.isRequired,
	    buttonSaveText: _react2.PropTypes.string.isRequired,
	    onAddressChange: _react2.PropTypes.func.isRequired,
	    onAddressSave: _react2.PropTypes.func,
	    onButtonClick: _react2.PropTypes.func.isRequired,
	    onAddAddress: _react2.PropTypes.func.isRequired,
	    disableAddNewAddress: _react2.PropTypes.bool
	}, _temp));
	
	exports.default = AddressInputView;
	
	function _inspect(input, depth) {
	    var maxDepth = 4;
	    var maxKeys = 15;
	
	    if (depth === undefined) {
	        depth = 0;
	    }
	
	    depth += 1;
	
	    if (input === null) {
	        return 'null';
	    } else if (input === undefined) {
	        return 'void';
	    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	    } else if (Array.isArray(input)) {
	        if (input.length > 0) {
	            if (depth > maxDepth) return '[...]';
	
	            var first = _inspect(input[0], depth);
	
	            if (input.every(function (item) {
	                return _inspect(item, depth) === first;
	            })) {
	                return first.trim() + '[]';
	            } else {
	                return '[' + input.slice(0, maxKeys).map(function (item) {
	                    return _inspect(item, depth);
	                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	            }
	        } else {
	            return 'Array';
	        }
	    } else {
	        var keys = (0, _keys2.default)(input);
	
	        if (!keys.length) {
	            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	                return input.constructor.name;
	            } else {
	                return 'Object';
	            }
	        }
	
	        if (depth > maxDepth) return '{...}';
	        var indent = '  '.repeat(depth - 1);
	        var entries = keys.slice(0, maxKeys).map(function (key) {
	            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	        }).join('\n  ' + indent);
	
	        if (keys.length >= maxKeys) {
	            entries += '\n  ' + indent + '...';
	        }
	
	        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	        } else {
	            return '{\n  ' + indent + entries + '\n' + indent + '}';
	        }
	    }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddressInput = undefined;
	
	var _AddressInput2 = __webpack_require__(1595);
	
	var _AddressInput3 = _interopRequireDefault(_AddressInput2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AddressInput = _AddressInput3.default;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class;
	
	var _AddressListInputView = __webpack_require__(745);
	
	var _AddressListInputView2 = _interopRequireDefault(_AddressListInputView);
	
	var _reactRedux = __webpack_require__(12);
	
	var _modal = __webpack_require__(26);
	
	var _config = __webpack_require__(193);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AddressListInput: {
	        displayName: 'AddressListInput'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/AddressListInput/AddressListInput.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var AddressListInput = _wrapComponent('AddressListInput')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang,
	        currency: state.currency
	    };
	}, {
	    showModal: _modal.showModal, hide: _modal.hide
	}), _dec(_class = function (_React$Component) {
	    (0, _inherits3.default)(AddressListInput, _React$Component);
	
	    function AddressListInput(props) {
	        (0, _classCallCheck3.default)(this, AddressListInput);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AddressListInput.__proto__ || (0, _getPrototypeOf2.default)(AddressListInput)).call(this, props));
	
	        _this.openMapModal = function () {
	            var _this$props = _this.props,
	                lang = _this$props.lang,
	                value = _this$props.value;
	
	
	            _this.props.showModal({
	                title: lang['store.common.select_on_map'],
	                content: _react3.default.createElement('div', {
	                    id: 'g-map-in-modal',
	                    style: { width: '100%', height: '500px' }
	                }),
	                modalType: 'mapModal'
	            });
	
	            /** Если в инпуте уже есть введенный адрес */
	            if (!!value && !!value.trim()) {
	                _this._initGoogleMapFromAddress();
	            } else {
	                _this._initDefaultGoogleMap();
	            }
	        };
	
	        _this._buildAddress = function (address) {
	            var region = address.region;
	            if (region) {
	                if (true) {
	                    region = '';
	                }
	            }
	            return (address.country ? address.country : '') + region + (address.city ? ', ' + address.city : '') + (address.street ? ', ' + address.street : '') + (address.building ? ', ' + address.building : '') + (address.chamber ? ', ' + address.chamber : '');
	        };
	
	        _this.onAddressSelect = function (selectedOption) {
	            _this.setState({ selectedOption: selectedOption });
	            var event = {
	                target: {
	                    value: selectedOption.address || ''
	                }
	            };
	            _this.setState({ value: event.target.value });
	        };
	
	        _this._addConfirmationButton = function () {
	            var lang = _this.props.lang;
	
	
	            var parentDiv = document.createElement('div');
	            parentDiv.style.marginBottom = '22px';
	            _this._confirmationButton = new ConfirmationButton(parentDiv, lang);
	
	            // Дефолтное состояние кнопки
	            _this._confirmationButton.setIsEnabled(false);
	
	            parentDiv.index = 1;
	            _this.map.controls[window.google.maps.ControlPosition.BOTTOM_CENTER].push(parentDiv);
	            parentDiv.addEventListener('click', function () {
	                if (_this._confirmationButton.isEnabled) {
	                    var event = {
	                        target: {
	                            value: _this.address
	                        }
	                    };
	
	                    _this.props.isNew ? _this.props.handleAddressAdd(event.target.value) : _this.handleUpdate(_this.props.id, event.target.value, _this.props.is_default);
	                    _this.props.hide();
	                }
	            });
	        };
	
	        _this._addWhereIamButton = function () {
	            var lang = _this.props.lang;
	
	
	            var parentDiv = document.createElement('div');
	            _this._whereIamButton = new WhereIamButton(parentDiv, lang);
	
	            parentDiv.index = 2;
	            _this.map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(parentDiv);
	            parentDiv.addEventListener('click', function () {
	                if (navigator.geolocation) {
	                    try {
	                        navigator.geolocation.getCurrentPosition(function (position) {
	                            var latlng = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude);
	                            _this.mapMarker.setPosition(latlng);
	                            _this._geocodePosition(_this.mapMarker.getPosition());
	                            _this.map.setCenter(latlng);
	                        }, function (error) {
	                            _this._findUserGeolocation().then(function (response) {
	                                return response.json();
	                            }).then(function (response) {
	                                var latlng = new window.google.maps.LatLng(response.location.lat, response.location.lng);
	                                _this.mapMarker.setPosition(latlng);
	                                _this._geocodePosition(_this.mapMarker.getPosition());
	                                _this.map.setCenter(latlng);
	                            });
	                        });
	                    } catch (error) {
	                        if (_this.countErrorElementGmaps < 10) {
	                            _this.countErrorElementGmaps += 1;
	                            setTimeout(function () {
	                                _this._addWhereIamButton();
	                            }, 100);
	                        } else {
	                            _this._initDefaultGoogleMap();
	                        }
	                    }
	                } else {
	                    _this._findUserGeolocation().then(function (response) {
	                        return response.json();
	                    }).then(function (response) {
	                        var latlng = new window.google.maps.LatLng(response.location.lat, response.location.lng);
	                        _this.mapMarker.setPosition(latlng);
	                        _this._geocodePosition(_this.mapMarker.getPosition());
	                        _this.map.setCenter(latlng);
	                    });
	                }
	                $('#you-location-img').addClass('_active');
	            });
	        };
	
	        _this.setEditMode = function (value) {
	            _this.setState({ editMode: value });
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState({ value: e.target.value });
	        };
	
	        _this.handleCancel = function () {
	            _this.setEditMode(false);
	            _this.setState({ value: _this.props.value });
	        };
	
	        _this.handleUpdate = function (id, value, is_default) {
	            _this.props.handleUpdateAddress(id, value, is_default);
	            _this.setEditMode(false);
	        };
	
	        _this.state = {
	            editMode: props.isNew,
	            value: props.value
	        };
	        _this.geocoder = null;
	        _this.infoWindow = null;
	        _this.geolocation = null;
	        _this.address = props.value;
	        return _this;
	    }
	
	    /*
	        MAP METHODS BEGIN
	    */
	
	
	    (0, _createClass3.default)(AddressListInput, [{
	        key: '_currentLangToGoogleLangCode',
	        value: function _currentLangToGoogleLangCode(langSlug) {
	            switch (langSlug) {
	                case 'rus':
	                    return 'ru';
	                case 'eng':
	                case 'gbr':
	                case 'eur':
	                    return 'en';
	                case 'kaz':
	                    return 'kk';
	                case 'ukr':
	                    return 'uk';
	                default:
	                    return 'en';
	            }
	        }
	
	        /**
	         * Возвращает данные о местоположении по названию адреса
	         * @returns {Promise<Response>}
	         * @private
	         */
	
	    }, {
	        key: '_findGeolocationByAddress',
	        value: function _findGeolocationByAddress() {
	            var _props = this.props,
	                currency = _props.currency,
	                value = _props.value;
	
	            var lang = 'en';
	            if (currency && !!currency.lang) {
	                lang = this._currentLangToGoogleLangCode(currency.lang.slug);
	            }
	            /**
	             * response : {
	             *     address_components: (7) [{…}, {…}, {…}, {…}, {…}, {…}, {…}],
	             *     types: ["premise", "street_address"],
	             *     geometry:
	             *       bounds: {northeast: {…}, southwest: {…}}
	             *       location: {lat: 57.9966685, lng: 56.23020349999999}
	             * }
	             */
	            return fetch('\n                https://maps.googleapis.com/maps/api/geocode/json?key=' + _config2.default.gapi.key + '\n                &address=' + encodeURIComponent(value) + '\n                &language=' + lang + '\n        ', {
	                method: 'POST'
	            });
	        }
	
	        /**
	         * Поиск геолокации юзера
	         * @returns {Promise<Response>}
	         * @private
	         */
	
	    }, {
	        key: '_findUserGeolocation',
	        value: function _findUserGeolocation() {
	            return fetch('https://www.googleapis.com/geolocation/v1/geolocate?key=' + _config2.default.gapi.key, {
	                method: 'POST'
	            });
	        }
	    }, {
	        key: '_initDefaultGoogleMap',
	        value: function _initDefaultGoogleMap() {
	            var _this2 = this;
	
	            if (!this.map) {
	                try {
	                    this._findUserGeolocation().then(function (response) {
	                        return response.json();
	                    }).then(function (response) {
	                        var location = response.location;
	                        _this2.geolocation = location;
	                        _this2._createGoogleMap(location);
	                        _this2._initGeoCoder();
	                        _this2._initInfoWindow();
	                        _this2._addMapMarker(response);
	                        _this2._addConfirmationButton();
	                        _this2._addWhereIamButton();
	                        _this2._addSearchInput();
	                        _this2._addEventHandlers();
	                    });
	                } catch (error) {
	                    if (this.countErrorElementGmaps < 10) {
	                        this.countErrorElementGmaps += 1;
	                        setTimeout(function () {
	                            _this2._initDefaultGoogleMap();
	                        }, 100);
	                    } else {
	                        throw error;
	                    }
	                }
	            } else {
	                setTimeout(function () {
	                    _this2._getOldMapData();
	                    // this._addEventHandlers();
	                }, 100);
	            }
	        }
	    }, {
	        key: '_initGoogleMapFromAddress',
	        value: function _initGoogleMapFromAddress() {
	            var _this3 = this;
	
	            if (!this.map) {
	                try {
	                    this._findGeolocationByAddress().then(function (response) {
	                        return response.json();
	                    }).then(function (response) {
	                        try {
	                            var result = response.results;
	                            if (result.length > 0) {
	                                _this3._createGoogleMap(result[0].geometry.location);
	                                _this3._initGeoCoder();
	                                _this3._initInfoWindow();
	                                _this3._addConfirmationButton();
	                                _this3._addWhereIamButton();
	                                _this3._createMapMarkerFromAddressLocation(response);
	                                _this3._addSearchInput();
	                                _this3._addEventHandlers();
	                            } else {
	                                _this3._initDefaultGoogleMap();
	                            }
	                        } catch (e) {
	                            throw e;
	                        }
	                    });
	                } catch (error) {
	                    if (this.countErrorElementGmaps < 10) {
	                        this.countErrorElementGmaps += 1;
	                        setTimeout(function () {
	                            _this3._initGoogleMapFromAddress();
	                        }, 100);
	                    } else {
	                        this._initDefaultGoogleMap();
	                    }
	                }
	            } else {
	                setTimeout(function () {
	                    _this3._getOldMapData();
	                    // this._addEventHandlers();
	                }, 100);
	            }
	        }
	
	        /**
	         * создаем инстанс попапа
	         * @private
	         */
	
	    }, {
	        key: '_initInfoWindow',
	        value: function _initInfoWindow() {
	            this.infoWindow = new window.google.maps.InfoWindow();
	        }
	    }, {
	        key: '_initGeoCoder',
	        value: function _initGeoCoder() {
	            this.geocoder = new window.google.maps.Geocoder();
	        }
	    }, {
	        key: '_getOldMapData',
	        value: function _getOldMapData() {
	            var value = this.props.value;
	
	
	            var oldMap = this.map;
	
	            var oldMapState = {
	                center: oldMap.center,
	                bounds: oldMap.getBounds(),
	                zoom: oldMap.zoom,
	                mapTypeControl: true,
	                mapTypeControlOptions: {
	                    style: window.google.maps.MapTypeControlStyle.DROPDOWN_MENU
	                }
	            };
	
	            var parentDivElement = document.getElementById('g-map-in-modal');
	
	            this.map = new window.google.maps.Map(parentDivElement, oldMapState);
	
	            /** Если в инпуте введен адрес - получаем из него метку на карте */
	            if (!!value && value.trim().length > 0) {
	                this._createMapMarkerFromAddress();
	            } else {
	                // Если мы зашли сюда и в инпуте нет адреса, значит уже был создан маркер с дефолтной позицией
	                this._createDefaultMapMarker({
	                    lat: this.mapMarker.position.lat(),
	                    lng: this.mapMarker.position.lng()
	                });
	                this._addEventHandlers();
	            }
	
	            this._addSearchInput();
	            this._addConfirmationButton();
	            this._addWhereIamButton();
	        }
	
	        /**
	         * @param location location { lat: 34, lng: 45 }
	         * @private
	         */
	
	    }, {
	        key: '_createGoogleMap',
	        value: function _createGoogleMap(location) {
	            var parentDivElement = document.getElementById('g-map-in-modal');
	            this.map = new window.google.maps.Map(parentDivElement, {
	                zoom: 10,
	                center: location,
	                mapTypeControl: true,
	                mapTypeControlOptions: {
	                    style: window.google.maps.MapTypeControlStyle.DROPDOWN_MENU
	                }
	            });
	        }
	
	        /**
	         * После переключения языков, инпут с поиском куда-то пропадает (удаляется из дом-дерева),
	         * поэтому каждый раз создаем новый инпут элемент для поиска
	         * @private
	         */
	
	    }, {
	        key: '_initSearchInputElement',
	        value: function _initSearchInputElement() {
	            var searchInputElement = document.createElement('input');
	            searchInputElement.type = 'text';
	            searchInputElement.id = 'pac-input';
	            searchInputElement.className = 'controls';
	            var modalMapParent = document.getElementById('g-map-in-modal');
	            modalMapParent.appendChild(searchInputElement);
	        }
	
	        /**
	         * Каждый раз, при создании нового инпута с поиском, в дом-дерево добавляется элемент с class=pac-container
	         * И он отображается позади модалки
	         * поэтому самостоятельно выставляем ему стили
	         * @private
	         */
	
	    }, {
	        key: '_initSearchResponseOutput',
	        value: function _initSearchResponseOutput() {
	            var searchResponseOutput = document.getElementsByClassName('pac-container');
	            if (searchResponseOutput.length > 1) {
	                searchResponseOutput[0].parentNode.removeChild(searchResponseOutput[0]);
	            }
	            if (searchResponseOutput[0]) {
	                searchResponseOutput[0].style.cssText = 'z-index: 10000; width: 300px;';
	            }
	        }
	    }, {
	        key: '_addSearchInput',
	        value: function _addSearchInput() {
	            /**
	             * Чтоб устранить баг, когда открывается полный экран и в нем нет инпута
	             * поиска
	             * https://stackoverflow.com/a/56712072
	             */
	            document.onfullscreenchange = function (event) {
	                var target = event.target;
	                var pacContainerElements = document.getElementsByClassName('pac-container');
	                if (pacContainerElements.length > 0) {
	                    var pacContainer = document.getElementsByClassName('pac-container')[0];
	                    if (pacContainer.parentElement === target) {
	                        document.getElementsByTagName('body')[0].appendChild(pacContainer);
	                    } else {
	                        target.appendChild(pacContainer);
	                    }
	                }
	            };
	
	            this._initSearchInputElement();
	            // Create the search box and link it to the UI element.
	            var input = document.getElementById('pac-input');
	            // в _addEventHandlers навешаны два обработчика
	            this.searchBox = new window.google.maps.places.SearchBox(input);
	            this.map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);
	
	            // для адекватного появления инпута в модалке
	            setTimeout(function () {
	                input.style.display = 'block';
	            }, 500);
	        }
	
	        /**
	         * Создание дефолтного маркера на карте по гео позиции юзера
	         * @param location { lat: 34, lng: 45 }
	         * @private
	         */
	
	    }, {
	        key: '_createDefaultMapMarker',
	        value: function _createDefaultMapMarker(location) {
	            var lang = this.props.lang;
	
	            this.mapMarker = new window.google.maps.Marker({
	                map: this.map,
	                draggable: true,
	                position: location
	            });
	
	            // Попап над маркером
	            this.infoWindow.open(this.map, this.mapMarker);
	            // Дефолтный текст при первом открытии
	            this.infoWindow.setContent(lang['createTradePoint.placemark.iconContent']);
	        }
	
	        /**
	         *
	         * @param response  - _findGeolocationByAddress описание ответа здесь
	         * @private
	         */
	
	    }, {
	        key: '_createMapMarkerFromAddressLocation',
	        value: function _createMapMarkerFromAddressLocation(response) {
	            this.mapMarker = new window.google.maps.Marker({
	                map: this.map,
	                draggable: true,
	                position: response.results[0].geometry.location // { lat: 34, lng: 34 }
	            });
	            // Попап над маркером
	            this.infoWindow.open(this.map, this.mapMarker);
	            this._setGeolocationData([response.results[0]]);
	        }
	    }, {
	        key: '_createMapMarkerFromAddress',
	        value: function _createMapMarkerFromAddress() {
	            var _this4 = this;
	
	            this._findGeolocationByAddress().then(function (response) {
	                return response.json();
	            }).then(function (response) {
	                if (response.results.length === 0) {
	                    _this4._createDefaultMapMarker(_this4.geolocation);
	                    _this4._addEventHandlers();
	                } else {
	                    _this4.mapMarker = new window.google.maps.Marker({
	                        map: _this4.map,
	                        draggable: true,
	                        position: response.results[0].geometry.location // { lat: 34, lng: 34 }
	                    });
	                    // Попап над маркером
	                    _this4.infoWindow.open(_this4.map, _this4.mapMarker);
	                    _this4._setGeolocationData([response.results[0]]);
	                    _this4._addEventHandlers();
	                }
	            }).catch(function (error) {
	                console.log('_createMapMarkerFromAddress catch err', error);
	            });
	        }
	
	        /**
	         * Добавление метки на карту
	         * @param response
	         * @private
	         */
	
	    }, {
	        key: '_addMapMarker',
	        value: function _addMapMarker(response) {
	            var value = this.props.value;
	
	
	            if (!!value && !!value.trim()) {
	                this._createMapMarkerFromAddress(value);
	            } else {
	                this._createDefaultMapMarker(response.location);
	            }
	        }
	
	        /**
	         * Получение данных об конкретном месте на карте (адрес, страна и т.д.)
	         * @param pos { lat: ƒ, lng: ƒ }
	         * @private
	         */
	
	    }, {
	        key: '_geocodePosition',
	        value: function _geocodePosition(pos) {
	            var _this5 = this;
	
	            this.geocoder.geocode({
	                latLng: pos
	            }, function (results, status) {
	                if (status === window.google.maps.GeocoderStatus.OK) {
	                    _this5._setGeolocationData(results);
	                }
	            });
	        }
	
	        /**
	         * Добавляем обработчики событий на карту и маркер
	         * @private
	         */
	
	    }, {
	        key: '_addEventHandlers',
	        value: function _addEventHandlers() {
	            var _this6 = this;
	
	            /** Обработка клика по карте */
	            window.google.maps.event.addListener(this.map, 'click', function (event) {
	                _this6.mapMarker.setPosition(new window.google.maps.LatLng(event.latLng.lat(), event.latLng.lng()));
	                _this6._geocodePosition(_this6.mapMarker.getPosition());
	                $('#you-location-img').removeClass('_active');
	            });
	
	            /** Когда перемещаем карту */
	            window.google.maps.event.addListener(this.map, 'dragend', function () {
	                $('#you-location-img').removeClass('_active');
	            });
	
	            if (this.mapMarker) {
	                /** Когда тащим маркер */
	                window.google.maps.event.addListener(this.mapMarker, 'drag', function (event) {
	                    _this6.mapMarker.setPosition(new window.google.maps.LatLng(event.latLng.lat(), event.latLng.lng()));
	                });
	
	                /** Когда тащим маркер */
	                window.google.maps.event.addListener(this.mapMarker, 'dragend', function (event) {
	                    _this6._geocodePosition(_this6.mapMarker.getPosition());
	                    $('#you-location-img').removeClass('_active');
	                });
	            } else {
	                setTimeout(function () {
	                    /** Когда тащим маркер */
	                    window.google.maps.event.addListener(_this6.mapMarker, 'drag', function (event) {
	                        _this6.mapMarker.setPosition(new window.google.maps.LatLng(event.latLng.lat(), event.latLng.lng()));
	                    });
	
	                    /** Когда тащим маркер */
	                    window.google.maps.event.addListener(_this6.mapMarker, 'dragend', function (event) {
	                        _this6._geocodePosition(_this6.mapMarker.getPosition());
	                        $('#you-location-img').removeClass('_active');
	                    });
	                }, 300);
	            }
	
	            // Bias the SearchBox results towards current map's viewport.
	            this.map.addListener('bounds_changed', function () {
	                _this6._initSearchResponseOutput();
	                _this6.searchBox.setBounds(_this6.map.getBounds());
	            });
	
	            this.searchBox.addListener('places_changed', function () {
	                var places = _this6.searchBox.getPlaces();
	
	                if (places.length === 0) {
	                    return;
	                }
	                if (!places[0].geometry) {
	                    return;
	                }
	
	                _this6.mapMarker.setPosition(new window.google.maps.LatLng(places[0].geometry.location.lat(), // число
	                places[0].geometry.location.lng()) // число
	                );
	                _this6._geocodePosition(_this6.mapMarker.getPosition());
	            });
	        }
	
	        /**
	         * Заполняем модельки формы данными о полученном адресе
	         * @param resultGeolocation
	         * @private
	         */
	
	    }, {
	        key: '_setGeolocationData',
	        value: function _setGeolocationData(resultGeolocation) {
	            var lang = this.props.lang;
	            /** Если на карте нормальный адрес улицы, то можно получить нужные данные и показать кнопку сохранения */
	
	            var addressData = resultGeolocation.find(function (item) {
	                return item.types.includes('street_address') || item.types.includes('premise');
	            });
	            // Иногда может вернуться номер улицы без названия
	            if (!!addressData && addressData.address_components.length > 6) {
	                /** Получение адреса */
	                var address = addressData.address_components;
	                var currentCountry = address.find(function (item) {
	                    return item.types.includes('country');
	                }).long_name;
	                var region = address.find(function (item) {
	                    return item.types.includes('administrative_area_level_1') || item.types.includes('administrative_area_level_2') || item.types.includes('administrative_area_level_3') || item.types.includes('administrative_area_level_4') || item.types.includes('administrative_area_level_5');
	                }).long_name;
	                var city = address.find(function (item) {
	                    return item.types.includes('locality');
	                }).long_name;
	                var streetName = address.find(function (item) {
	                    return item.types.includes('route');
	                }).long_name;
	                var streetNumber = address.find(function (item) {
	                    return item.types.includes('street_number');
	                }).long_name;
	
	                /** Смена  контента попапа */
	                this.infoWindow.setContent(streetName + ', ' + streetNumber);
	                /** Делаем кнопку подтверждения активной */
	                this._confirmationButton.setIsEnabled(true);
	
	                var addressResult = {
	                    country: currentCountry,
	                    region: region,
	                    city: city,
	                    street: streetName,
	                    building: streetNumber,
	                    chamber: ''
	                };
	                this.address = this._buildAddress(addressResult);
	                this.onAddressSelect({ address: this.address });
	            } else {
	                this._confirmationButton.setIsEnabled(false);
	                this.infoWindow.setContent(lang['createTradePoint.placemark.iconContent']);
	            }
	        }
	
	        /**
	         * Собрать строку адреса {Регион}, {Город}, {Улица}, {Номер дома}, {Офис/квартира}
	         * @param {Object} address
	         * @returns {string}
	         */
	
	
	        /**
	         * Добавление кнопки подтверждения на карту
	         * @private
	         */
	
	
	        /**
	         * Добавление кнопки "Где я?"
	         * @private
	         */
	
	
	        /*
	            MAP METHODS END
	        */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            var _props2 = this.props,
	                lang = _props2.lang,
	                is_default = _props2.is_default,
	                isNew = _props2.isNew,
	                handleAddressAdd = _props2.handleAddressAdd,
	                disableNewMode = _props2.disableNewMode,
	                id = _props2.id,
	                handleDeleteAddress = _props2.handleDeleteAddress;
	            var _state = this.state,
	                editMode = _state.editMode,
	                value = _state.value;
	
	
	            return _react3.default.createElement(_AddressListInputView2.default, {
	                onDeleteButtonClick: function onDeleteButtonClick() {
	                    return handleDeleteAddress(id);
	                },
	                onDefaultButtonClick: function onDefaultButtonClick() {
	                    return _this7.handleUpdate(id, value, true);
	                },
	                onSave: isNew ? function () {
	                    return handleAddressAdd(value);
	                } : function () {
	                    return _this7.handleUpdate(id, value, is_default);
	                },
	                onMapButtonClick: this.openMapModal,
	                onChange: this.handleChange,
	                onCancel: isNew ? disableNewMode : this.handleCancel,
	                value: value,
	                setEditMode: this.setEditMode,
	                editMode: editMode,
	                isNew: isNew,
	                handleAddressAdd: handleAddressAdd,
	                is_default: is_default,
	                lang: lang
	            });
	        }
	    }]);
	    return AddressListInput;
	}(_react3.default.Component)) || _class));
	
	exports.default = AddressListInput;
	
	
	function ConfirmationButton(parentDiv, language) {
	    var _this8 = this;
	
	    this.isEnabled = false;
	    var controlUI = document.createElement('div');
	    parentDiv.appendChild(controlUI);
	
	    // Текст
	    var controlText = document.createElement('div');
	    controlText.innerHTML = '\n                    <button\n                        class=\'le-button button_width_100\'\n                    >\n                        ' + language['createTradePoint.indicateOnMap.confirmationButton'] + '\n                    </button>';
	    controlUI.appendChild(controlText);
	
	    this.setIsEnabled = function (isEnabled) {
	        _this8.isEnabled = isEnabled;
	        // Пробовал через класс, но стили почему-то не применялись, поэтому пришлось сделать прямо
	        if (isEnabled) {
	            controlUI.setAttribute('disabled', 'false');
	            controlUI.setAttribute('style', 'opacity: 1');
	        } else {
	            controlUI.setAttribute('style', 'opacity: .6');
	            controlUI.setAttribute('disabled', 'true');
	        }
	    };
	}
	
	/**
	 * Кнопка "Где я?" на карте
	 * @param parentDiv html div
	 * @param language
	 * @constructor
	 */
	function WhereIamButton(parentDiv, language) {
	    var firstChild = document.createElement('button');
	    firstChild.id = 'whereiam-button';
	    firstChild.className = 'map-whereiam-button';
	    firstChild.title = language['createTradePoint.indicateOnMap.whereIamButton'];
	    parentDiv.appendChild(firstChild);
	
	    var secondChild = document.createElement('div');
	    secondChild.id = 'you-location-img';
	    firstChild.appendChild(secondChild);
	}
	module.exports = exports['default'];

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp2;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	__webpack_require__(1125);
	
	__webpack_require__(1124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AlertError: {
	        displayName: 'AlertError'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/AlertError/index.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var AlertError = _wrapComponent('AlertError')((_dec = (0, _reactRedux.connect)(function (state) {
	    return { error: state.error };
	}), _dec(_class = (_temp2 = _class2 = function (_Component) {
	    (0, _inherits3.default)(AlertError, _Component);
	
	    function AlertError() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, AlertError);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AlertError.__proto__ || (0, _getPrototypeOf2.default)(AlertError)).call.apply(_ref, [this].concat(args))), _this), _this.showAlert = function (isShowError, message) {
	            // показ popup с ошибкой
	            if (isShowError) {
	                setTimeout(function () {
	                    _reactSAlert2.default.error(message, { position: 'top-right', effect: 'slide', timeout: 5000 });
	                }, 1000);
	            }
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(AlertError, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.showAlert(this.props.error.show_error, this.props.error.message_error, this.props.error.error_code, this.props.error.error_title);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.showAlert(nextProps.error.show_error, nextProps.error.message_error, nextProps.error.error_code, nextProps.error.error_title);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react3.default.createElement(_reactSAlert2.default, { stack: { limit: 3 } });
	        }
	    }]);
	    return AlertError;
	}(_react2.Component), _class2.propTypes = {
	    error: _react2.PropTypes.object
	}, _temp2)) || _class));
	
	exports.default = AlertError;
	module.exports = exports['default'];

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var RUB = exports.RUB = 643;
	var EUR = exports.EUR = 978;
	var USD = exports.USD = 840;
	var GBP = exports.GBP = 826;
	var UAH = exports.UAH = 980;
	var MDL = exports.MDL = 498;
	var BYN = exports.BYN = 933;
	var TRY = exports.TRY = 949;
	var AED = exports.AED = 784;
	var SGD = exports.SGD = 702;
	var UZS = exports.UZS = 860;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getFlagByCurrency = getFlagByCurrency;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(1600);
	
	var constants = _interopRequireWildcard(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFlagByCurrency(currencyId) {
	    switch (currencyId) {
	        case constants.RUB:
	            return _react2.default.createElement('span', { className: 'fa fa-rub' });
	            break;
	        case constants.EUR:
	            return _react2.default.createElement('span', { className: 'fa fa-eur' });
	            break;
	        case constants.USD:
	            return _react2.default.createElement('span', { className: 'fa fa-usd' });
	            break;
	        case constants.GBP:
	            return _react2.default.createElement('span', { className: 'fa fa-gbp' });
	            break;
	        case constants.UAH:
	            return _react2.default.createElement(
	                'span',
	                { className: 'ukr' },
	                '\u20B4'
	            );
	            break;
	        case constants.MDL:
	            return _react2.default.createElement(
	                'span',
	                { className: 'mdl' },
	                'L'
	            );
	            break;
	        case constants.BYN:
	            return _react2.default.createElement(
	                'span',
	                { className: 'byn' },
	                'L'
	            );
	            break;
	        case constants.TRY:
	            return _react2.default.createElement(
	                'span',
	                { className: 'try' },
	                '\u20BA'
	            );
	            break;
	        case constants.AED:
	            return _react2.default.createElement(
	                'span',
	                { className: 'try' },
	                'Dh'
	            );
	            break;
	        case constants.SGD:
	            return _react2.default.createElement(
	                'span',
	                { className: 'sgd' },
	                'S$'
	            );
	            break;
	        case constants.UZS:
	            return _react2.default.createElement(
	                'span',
	                { className: 'sgd' },
	                '\u0441\u045E\u043C'
	            );
	            break;
	        default:
	            return null;
	            break;
	    }
	}

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _currenciesTools = __webpack_require__(1601);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AmountFormat: {
	        displayName: 'AmountFormat'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/AmountFormat/index.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var AmountFormat = _wrapComponent('AmountFormat')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(AmountFormat, _Component);
	
	    function AmountFormat() {
	        (0, _classCallCheck3.default)(this, AmountFormat);
	        return (0, _possibleConstructorReturn3.default)(this, (AmountFormat.__proto__ || (0, _getPrototypeOf2.default)(AmountFormat)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(AmountFormat, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$amount = _props.amount,
	                amount = _props$amount.amount,
	                id = _props$amount.id,
	                currency_id = _props$amount.currency_id,
	                wrapProps = _props.wrapProps,
	                wrapTag = _props.wrapTag;
	
	
	            var flag = (0, _currenciesTools.getFlagByCurrency)(currency_id);
	
	            var props = (0, _extends3.default)({}, wrapProps, {
	                id: id
	            });
	
	            return _react3.default.createElement(
	                'wrapTag',
	                props,
	                amount,
	                flag
	            );
	        }
	    }]);
	    return AmountFormat;
	}(_react2.Component), _class.propTypes = {
	    amount: _react2.PropTypes.shape({
	        id: _react2.PropTypes.number,
	        amount: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.number]),
	        currency: _react2.PropTypes.string,
	        currency_id: _react2.PropTypes.number
	    }).isRequired,
	    wrapTag: _react2.PropTypes.string,
	    wrapProps: _react2.PropTypes.object
	}, _class.defaultProps = {
	    wrapTag: 'div',
	    wrapProps: {}
	}, _temp));
	
	exports.default = AmountFormat;
	module.exports = exports['default'];

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactGoogleRecaptcha = __webpack_require__(340);
	
	var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _auth = __webpack_require__(53);
	
	var _modal = __webpack_require__(26);
	
	var _modal_type = __webpack_require__(42);
	
	var _pass_recovery = __webpack_require__(164);
	
	var _BaseForm2 = __webpack_require__(66);
	
	var _BaseForm3 = _interopRequireDefault(_BaseForm2);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Auth = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        loginError: state.auth.loginError,
	        loginErrorCode: state.auth.loginErrorCode,
	        user: state.auth.user,
	        preload: state.auth.preload,
	        shopId: state.setting.shopId,
	        googleCaptcha: state.setting.googleCaptcha,
	        googleCaptchaSitekey: state.setting.googleCaptchaSitekey,
	        lang: state.lang
	    };
	}, { login: _auth.login, hide: _modal.hide, showModalRegistration: _modal_type.showModalRegistration, resetError: _auth.resetError, showModalPassRecovery: _modal_type.showModalPassRecovery, sendPhoneToReducer: _pass_recovery.sendPhoneToReducer, resetStep: _pass_recovery.resetStep }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
	    (0, _inherits3.default)(Auth, _BaseForm);
	
	    function Auth(props) {
	        (0, _classCallCheck3.default)(this, Auth);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Auth.__proto__ || (0, _getPrototypeOf2.default)(Auth)).call(this, props));
	
	        _this.validateField = function (field) {
	            // if(this.state[field].length > 0){
	            //     return 'success';
	            // }
	            //
	            // return 'error';
	        };
	
	        _this.onClickRegistration = function (event) {
	            _this.props.showModalRegistration(_this.props.lang);
	        };
	
	        _this.onClickPassRecovery = function (event) {
	            _this.props.resetStep();
	            _this.props.sendPhoneToReducer(_this.state.login);
	            _this.props.showModalPassRecovery(_this.props.lang);
	        };
	
	        _this.onSuccessCaptcha = function (value) {
	            _this.setState({ captcha: value });
	        };
	
	        _this.showCaptcha = function () {
	            if (_this.props.googleCaptcha) {
	                setTimeout(function () {
	                    grecaptcha.execute(_this.props.googleCaptchaSitekey, { action: 'submit' }).then(_this.onSuccessCaptcha);
	                }, 500);
	                // return (
	                //     <Recaptcha
	                //         sitekey={this.props.googleCaptchaSitekey}
	                //         render="explicit"
	                //         onChange={this.onSuccessCaptcha}
	                //     />
	                // );
	            }
	
	            return '';
	        };
	
	        _this.state = {
	            login: '',
	            password: '',
	            captcha: null,
	            needCaptcha: true
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Auth, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.loginError && nextProps.loginErrorCode === 'user.errorInvalidCaptcha') {
	                this.setState({ needCaptcha: true });
	            }
	
	            if (nextProps.user && (nextProps.user.phone || nextProps.user.email)) {
	                this.setState({ login: '', password: '' });
	                this.props.hide();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.resetError();
	        }
	    }, {
	        key: 'isValid',
	        value: function isValid() {
	            return this.state.login.length > 0 && this.state.password.length > 0;
	        }
	    }, {
	        key: 'onSubmit',
	
	
	        /**
	         * @param {SyntheticMouseEvent} event
	         */
	        value: function onSubmit(event) {
	            event.preventDefault();
	            if (this.props.googleCaptcha && this.state.captcha == null) {
	                var alertMessage = this.props.lang['user.errorInvalidCaptcha'];
	                setTimeout(function () {
	                    _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                }, 0);
	                return null;
	            }
	            this.props.login({ login: this.state.login, password: this.state.password, captcha: this.state.captcha, callback: null, shopId: this.props.shopId });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('Auth');
	            return _react2.default.createElement(View, { loginError: this.props.loginError,
	                validateField: this.validateField,
	                changeField: this.changeField,
	                onSubmit: this.onSubmit,
	                onClickRegistration: this.onClickRegistration,
	                onClickPassRecovery: this.onClickPassRecovery,
	                disabledSubmit: !this.isValid(),
	                login: this.state.login,
	                password: this.state.password,
	                preload: this.props.preload,
	                showCaptcha: this.showCaptcha,
	                loginErrorCode: this.props.loginErrorCode,
	                lang: this.props.lang
	            });
	        }
	    }]);
	    return Auth;
	}(_BaseForm3.default), _class2.propTypes = {
	    showModalRegistration: _react.PropTypes.func.isRequired,
	    resetError: _react.PropTypes.func.isRequired,
	    hide: _react.PropTypes.func.isRequired,
	    lang: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = Auth;
	module.exports = exports['default'];

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _auth = __webpack_require__(53);
	
	var _modal_type = __webpack_require__(42);
	
	var _headInfo = __webpack_require__(765);
	
	var _components2 = __webpack_require__(16);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AuthHeader: {
	        displayName: 'AuthHeader'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Auth/AuthHeader.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var AuthHeader = _wrapComponent('AuthHeader')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        setting: state.setting,
	        user: state.auth.user,
	        lang: state.lang
	    };
	}, {
	    hideSideMenu: _headInfo.hideSideMenu,
	    logout: _auth.logout,
	    showModalAuth: _modal_type.showModalAuth
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(AuthHeader, _Component);
	
	    function AuthHeader(props) {
	        (0, _classCallCheck3.default)(this, AuthHeader);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AuthHeader.__proto__ || (0, _getPrototypeOf2.default)(AuthHeader)).call(this, props));
	
	        _this.closeSideMenu = function () {
	            _this.props.hideSideMenu();
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(AuthHeader, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('AuthHeader', null, { folderName: 'Auth' });
	
	            return _react3.default.createElement(View, {
	                closeSideMenu: this.closeSideMenu,
	                logout: this.props.logout,
	                setting: this.props.setting,
	                show: this.props.showModalAuth,
	                user: this.props.user,
	                lang: this.props.lang
	            });
	        }
	    }]);
	    return AuthHeader;
	}(_react2.Component), _class2.propTypes = {
	    hideSideMenu: _react2.PropTypes.func.isRequired,
	    logout: _react2.PropTypes.func.isRequired,
	    setting: _react2.PropTypes.object.isRequired,
	    showModalAuth: _react2.PropTypes.func.isRequired,
	    user: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = AuthHeader;
	module.exports = exports['default'];

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _reactGoogleRecaptcha = __webpack_require__(340);
	
	var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);
	
	var _basket = __webpack_require__(101);
	
	var _auth = __webpack_require__(53);
	
	var _registration = __webpack_require__(194);
	
	var _modal = __webpack_require__(26);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _voice_code = __webpack_require__(141);
	
	var _modal_type = __webpack_require__(42);
	
	var _pass_recovery = __webpack_require__(164);
	
	var _BaseForm2 = __webpack_require__(66);
	
	var _BaseForm3 = _interopRequireDefault(_BaseForm2);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthOneClick = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        loginError: state.auth.loginError,
	        loginErrorCode: state.auth.loginErrorCode,
	        user: state.auth.user,
	        preload: state.auth.preload,
	        orderInOneClick: state.setting.orderInOneClick,
	        shopId: state.setting.shopId,
	        googleCaptcha: state.setting.googleCaptcha,
	        googleCaptchaSitekey: state.setting.googleCaptchaSitekey,
	        basketElements: state.basket.items,
	        lang: state.lang,
	        currency: state.currency
	    };
	}, {
	    login: _auth.login,
	    hide: _modal.hide,
	    showModalRegistration: _modal_type.showModalRegistration,
	    resetError: _auth.resetError,
	    showModalPassRecovery: _modal_type.showModalPassRecovery,
	    sendPhoneToReducer: _pass_recovery.sendPhoneToReducer,
	    registrationOneClick: _registration.registrationOneClick,
	    confirmRegistrationOneClick: _registration.confirmRegistrationOneClick,
	    resetVoiceCode: _voice_code.resetVoiceCode,
	    resetStep: _pass_recovery.resetStep,
	    createOrder: _basket.createOrder, clearBasket: _basket.clearBasket, push: _reactRouterRedux.push
	}), _dec(_class = (_temp = _class2 = function (_BaseForm) {
	    (0, _inherits3.default)(AuthOneClick, _BaseForm);
	
	    function AuthOneClick(props) {
	        (0, _classCallCheck3.default)(this, AuthOneClick);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AuthOneClick.__proto__ || (0, _getPrototypeOf2.default)(AuthOneClick)).call(this, props));
	
	        _this.callCreateOrder = function () {
	            var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.basketElements;
	
	            _this.props.push('/basket');
	            _this.props.createOrder(_this._compileOrder(basketElements)).then(function (result) {
	                _this.props.clearBasket();
	                _this.props.push('/create-order/' + result.result.order_id);
	            }).catch(function (err) {
	                //Ошибка "предложение не найдено"
	                if (err.code === 139 && err.title === 'error.catalogOfferNotFind') {
	                    console.log('предложение не найдено', err);
	                    err.dataError.forEach(function (item) {
	                        _this.props.deleteProduct(item);
	                    });
	
	                    var alertMessage = _this.props.lang['store.cart.call_create_order.catalog_offer_not_found'];
	
	                    setTimeout(function () {
	                        _reactSAlert2.default.success(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                    }, 0);
	                }
	
	                //Ошибка: алкогольные товары в корзине
	                if (err.code === 136 && err.title === 'error.orderExciseMarkBarcodeIsRequired') {
	                    _this._showAlcoWarning(err.dataError);
	                }
	            });
	        };
	
	        _this._compileOrder = function () {
	            var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            var sum = 0;
	            var products = [];
	            basketElements.map(function (element) {
	                sum += element.price * element.count;
	                products.push({
	                    offer_id: element.id,
	                    quantity: element.count,
	                    price: element.price,
	                    modifier_option_id: element.modifier_option_id,
	                    modifier_option_name: element.modifier_option_name,
	                    nestedOffers: element.nested_offer,
	                    coupon_id: element.coupon_id, coupon_token: element.coupon_token, customer_coupon_id: element.customer_coupon_id
	                });
	            });
	            var userAgent = navigator.userAgent || '';
	            var utmRedirectData = _LocalStorageProxy2.default.getItem('utm_redirect_data') || '';
	            _LocalStorageProxy2.default.setItem('utm_redirect_data', '');
	            var currency_id = _this.props.currency.id;
	            if (_this.state.editOrderId) {
	                var order_id = _this.state.editOrderId;
	                return { order_id: order_id, sum: sum, products: products, userAgent: userAgent, utmRedirectData: utmRedirectData, currency_id: currency_id };
	            }
	            return { sum: sum, products: products, userAgent: userAgent, utmRedirectData: utmRedirectData, currency_id: currency_id };
	        };
	
	        _this.validateField = function (field) {};
	
	        _this.onClickConfirmOneClick = function (event) {
	            _this.props.confirmRegistrationOneClick({
	                shopId: _this.props.shopId,
	                login: _this.state.login,
	                emailCode: _this.state.emailCode,
	                smsCode: _this.state.phoneCode });
	        };
	
	        _this.onClickOneClick = function (event) {
	            if (_this.props.googleCaptcha && _this.state.captcha == null) {
	                var alertMessage = _this.props.lang['user.errorInvalidCaptcha'];
	                setTimeout(function () {
	                    _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                }, 0);
	                return null;
	            }
	            _this.props.registrationOneClick({ shopId: _this.props.shopId, login: _this.state.login, captcha: _this.state.captcha }).then(function (result) {
	                _this.setState({ newUser: result.new_user });
	                if (result.send_for_phone) {
	                    _this.setState({ codeSendFor: 'phone' });
	                } else if (result.send_for_email) {
	                    _this.setState({ codeSendFor: 'email' });
	                }
	            });
	        };
	
	        _this.onClickResendCode = function (event) {
	            _this.props.registrationOneClick({ shopId: _this.props.shopId, login: _this.state.login }).then(function (result) {
	                _this.setState({ timeToResentCode: 60 });
	                var timerId = setInterval(function () {
	                    _this.setState({ timeToResentCode: _this.state.timeToResentCode - 1 });
	                }, 1000);
	                setTimeout(function () {
	                    clearInterval(timerId);
	                }, 60000);
	            });
	        };
	
	        _this.onClickRegistration = function (event) {
	            _this.props.showModalRegistration(_this.props.lang);
	        };
	
	        _this.onClickPassRecovery = function (event) {
	            _this.props.resetStep();
	            _this.props.sendPhoneToReducer(_this.state.login);
	            _this.props.showModalPassRecovery(_this.props.lang);
	        };
	
	        _this.onSuccessCaptcha = function (value) {
	            _this.setState({ captcha: value });
	        };
	
	        _this.showCaptcha = function () {
	            if (_this.props.googleCaptcha) {
	                setTimeout(function () {
	                    grecaptcha.execute(_this.props.googleCaptchaSitekey, { action: 'submit' }).then(_this.onSuccessCaptcha);
	                }, 500);
	                // return (
	                //     <Recaptcha
	                //         sitekey={this.props.googleCaptchaSitekey}
	                //         render="explicit"
	                //         onChange={this.onSuccessCaptcha}
	                //     />
	                // );
	            }
	
	            return '';
	        };
	
	        _this.show = function () {
	            if (_this.props.googleCaptcha) {
	                setTimeout(function () {
	                    grecaptcha.execute(_this.props.googleCaptchaSitekey, { action: 'submit' }).then(_this.onSuccessCaptcha);
	                }, 500);
	                // return (
	                //     <Recaptcha
	                //         sitekey={this.props.googleCaptchaSitekey}
	                //         render="explicit"
	                //         onChange={this.onSuccessCaptcha}
	                //     />
	                // );
	            }
	
	            return '';
	        };
	
	        _this.state = {
	            login: '',
	            password: '',
	            captcha: null,
	            needCaptcha: false,
	            waitingCode: false,
	            codeSendFor: '',
	            emailCode: '',
	            phoneCode: '',
	            newUser: true,
	            timeToResentCode: 0
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(AuthOneClick, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.loginError && nextProps.loginErrorCode === 'user.errorInvalidCaptcha') {
	                this.setState({ needCaptcha: true });
	            }
	
	            if (nextProps.user && (nextProps.user.phone || nextProps.user.email)) {
	                this.setState({ login: '', password: '' });
	                this.props.hide();
	                if (this.props.isCreateOrder) {
	                    this.callCreateOrder();
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.resetError();
	        }
	    }, {
	        key: 'isValid',
	        value: function isValid() {
	            return this.state.login.length > 0 && this.state.password.length > 0;
	        }
	    }, {
	        key: 'onSubmit',
	
	
	        /**
	         * @param {SyntheticMouseEvent} event
	         */
	        value: function onSubmit(event) {
	            event.preventDefault();
	            if (this.props.googleCaptcha && this.state.captcha == null) {
	                var alertMessage = this.props.lang['user.errorInvalidCaptcha'];
	                setTimeout(function () {
	                    _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                }, 0);
	                return null;
	            }
	            this.props.login({ login: this.state.login, password: this.state.password, captcha: this.state.captcha, callback: null, shopId: this.props.shopId });
	        }
	    }, {
	        key: 'isValidOneClick',
	        value: function isValidOneClick() {
	            if (this.state.codeSendFor === 'phone') {
	                return this.state.phoneCode.length > 0;
	            }
	            if (this.state.codeSendFor === 'email') {
	                return this.state.emailCode.length > 0;
	            }
	            return this.state.login.length > 5;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('AuthOneClick', null, { folderName: 'Auth' });
	            return _react2.default.createElement(View, { loginError: this.props.loginError,
	                validateField: this.validateField,
	                changeField: this.changeField,
	                onSubmit: this.onSubmit,
	                onClickOneClick: this.onClickOneClick,
	                onClickConfirmOneClick: this.onClickConfirmOneClick,
	                onClickRegistration: this.onClickRegistration,
	                onClickPassRecovery: this.onClickPassRecovery,
	                disabledSubmit: !this.isValid(),
	                disabledSubmitOneClick: !this.isValidOneClick(),
	                login: this.state.login,
	                password: this.state.password,
	                preload: this.props.preload,
	                orderInOneClick: this.props.orderInOneClick,
	                showCaptcha: this.showCaptcha,
	                loginErrorCode: this.props.loginErrorCode,
	                codeSendFor: this.state.codeSendFor,
	                newUser: this.state.newUser,
	                emailCode: this.state.emailCode,
	                phoneCode: this.state.phoneCode,
	                timeToResentCode: this.state.timeToResentCode,
	                onClickResendCode: this.onClickResendCode,
	                lang: this.props.lang
	            });
	        }
	    }]);
	    return AuthOneClick;
	}(_BaseForm3.default), _class2.propTypes = {
	    showModalRegistration: _react.PropTypes.func.isRequired,
	    resetError: _react.PropTypes.func.isRequired,
	    hide: _react.PropTypes.func.isRequired,
	    lang: _react.PropTypes.object,
	    currency: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = AuthOneClick;
	module.exports = exports['default'];

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//TODO определиться или выпилить href, или впилить везде e.preventDefault. Макар
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _reactRouterBootstrap = __webpack_require__(681);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _constants = __webpack_require__(18);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AuthHeader: {
	        displayName: 'AuthHeader'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Auth/default/AuthHeaderView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var AuthHeader = _wrapComponent('AuthHeader')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(AuthHeader, _Component);
	
	    function AuthHeader() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, AuthHeader);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AuthHeader.__proto__ || (0, _getPrototypeOf2.default)(AuthHeader)).call.apply(_ref, [this].concat(args))), _this), _this.show = function (e) {
	            e.preventDefault();
	            _this.props.show(_this.props.lang);
	        }, _this.logout = function (e) {
	            e.preventDefault();
	            _this.props.logout();
	            _this.handleClick();
	        }, _this.handleClick = function () {
	            _this.props.closeSideMenu();
	            document.documentElement.classList.remove('scroll_hide');
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(AuthHeader, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                user = _props.user,
	                lang = _props.lang;
	
	
	            if (!!user) {
	                var name = user.name || user.phone || user.email || '';
	
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'auth_holder' },
	                    _react3.default.createElement(
	                        _reactBootstrap.DropdownButton,
	                        { bsStyle: 'link', title: name, noCaret: true, id: 'dropdown-basic' },
	                        _constants.UserMenuItems.map(function (item, i) {
	                            var notification = null;
	                            var item_name = lang[item.lang_mark] ? lang[item.lang_mark] : item.name;
	
	                            if (item.showNotification) {
	                                notification = _react3.default.createElement(_components2.Notification, { isLink: false, className: 'holder_login_icon dropmenu_notification' });
	                            }
	
	                            if (item.link) {
	                                return _react3.default.createElement(
	                                    _reactRouterBootstrap.LinkContainer,
	                                    { key: 'LinkContainer-' + i, to: item.link, onClick: _this2.handleClick },
	                                    _react3.default.createElement(
	                                        _reactBootstrap.MenuItem,
	                                        { eventKey: i },
	                                        _react3.default.createElement(
	                                            'span',
	                                            null,
	                                            item_name
	                                        ),
	                                        notification
	                                    )
	                                );
	                            } else {
	                                return _react3.default.createElement(
	                                    _reactBootstrap.MenuItem,
	                                    { key: 'LinkContainer-' + i, eventKey: i, onClick: _this2[item.method] },
	                                    _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        item_name
	                                    )
	                                );
	                            }
	                        })
	                    ),
	                    _react3.default.createElement(_components2.Notification, {
	                        className: 'holder_login_icon',
	                        onClick: this.handleClick
	                    })
	                );
	            }
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(
	                    'a',
	                    { href: '#', onClick: this.show },
	                    _react3.default.createElement(
	                        'span',
	                        { className: 'auth_span' },
	                        lang['login.logIn']
	                    )
	                )
	            );
	        }
	    }]);
	    return AuthHeader;
	}(_react2.Component), _class.propTypes = {
	    closeSideMenu: _react2.PropTypes.func.isRequired,
	    logout: _react2.PropTypes.func.isRequired,
	    setting: _react2.PropTypes.object.isRequired,
	    show: _react2.PropTypes.func.isRequired,
	    user: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object
	}, _temp2));
	
	exports.default = AuthHeader;
	module.exports = exports['default'];

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(19);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _utils = __webpack_require__(31);
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1063);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AuthOneClickView: {
	        displayName: 'AuthOneClickView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Auth/default/AuthOneClickView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var AuthOneClickView = _wrapComponent('AuthOneClickView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(AuthOneClickView, _Component);
	
	    function AuthOneClickView(props, context) {
	        (0, _classCallCheck3.default)(this, AuthOneClickView);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AuthOneClickView.__proto__ || (0, _getPrototypeOf2.default)(AuthOneClickView)).call(this, props, context));
	
	        _this.refInput = function (input) {
	            _this.inputLogin = input;
	        };
	
	        _this.showError = function () {
	            var _this$props = _this.props,
	                loginError = _this$props.loginError,
	                loginErrorCode = _this$props.loginErrorCode,
	                lang = _this$props.lang;
	
	
	            if (loginError) {
	                if (loginErrorCode === null || loginErrorCode === undefined) {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang['store.auth_one_click.default_alert']
	                    );
	                } else {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang[loginError]
	                    );
	                }
	            }
	
	            return '';
	        };
	
	        _this.onClickRegistration = function (event) {
	            event.preventDefault();
	            if (_this.props.onClickRegistration) {
	                _this.props.onClickRegistration(event);
	            }
	        };
	
	        _this.onClickOneClick = function (event) {
	            event.preventDefault();
	            _this.props.onClickOneClick(event);
	        };
	
	        _this.onClickConfirmOneClick = function (event) {
	            event.preventDefault();
	            _this.props.onClickConfirmOneClick(event);
	        };
	
	        _this.onClickPassRecovery = function (event) {
	            event.preventDefault();
	            if (_this.props.onClickPassRecovery) {
	                _this.props.onClickPassRecovery(event);
	            }
	        };
	
	        _this.showCaptcha = function () {
	            if (_this.props.showCaptcha) {
	                return _react3.default.createElement(
	                    _reactBootstrap.FormGroup,
	                    null,
	                    _this.props.showCaptcha()
	                );
	            }
	
	            return '';
	        };
	
	        _this.showOneClickConfirm = function () {
	            var lang = _this.props.lang;
	
	
	            if (_this.props.codeSendFor !== '') {
	                if (_this.props.codeSendFor === 'email') {
	                    var _description = lang['store.auth_one_click.confirm.description_email'];
	                    var _header = lang['store.auth_one_click.confirm.header_email_in_use'];
	                    if (_this.props.newUser) {
	                        _header = lang['store.auth_one_click.confirm.header_guest'];
	                    }
	                    return _react3.default.createElement(
	                        'div',
	                        { className: 'bordered' },
	                        _react3.default.createElement(
	                            'h2',
	                            null,
	                            _header
	                        ),
	                        _react3.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            null,
	                            _description
	                        ),
	                        _react3.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            { style: { marginBottom: '0px' } },
	                            _react3.default.createElement(
	                                _reactBootstrap.ControlLabel,
	                                null,
	                                lang['store.auth_one_click.confirm.enter_email_code'],
	                                '*'
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-7 text-right no-padding' },
	                            _react3.default.createElement(_reactBootstrap.FormControl, {
	                                type: (0, _utils.isMobileDevice)() ? "number" : "text",
	                                pattern: '\\d*',
	                                placeholder: '1234',
	                                value: _this.props.emailCode,
	                                onChange: function onChange(e) {
	                                    if ((0, _utils.validateNumeric)(e.target.value)) {
	                                        _this.props.changeField('emailCode')(e);
	                                    }
	                                }
	                            })
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-5 text-right inline_block button_width_100' },
	                            _react3.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    type: 'submit',
	                                    bsStyle: 'primary',
	                                    className: 'form-control',
	                                    disabled: _this.props.disabledSubmitOneClick,
	                                    onClick: _this.onClickConfirmOneClick
	                                },
	                                lang['store.auth_one_click.confirm.confirm']
	                            )
	                        ),
	                        _react3.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            { style: { paddingTop: '26px', marginTop: '20px' } },
	                            _this.renderTimer()
	                        )
	                    );
	                }
	                var description = lang['store.auth_one_click.confirm.description_phone'];
	                var header = lang['store.auth_one_click.confirm.header_phone_in_use'];
	                if (_this.props.newUser) {
	                    header = lang['store.auth_one_click.confirm.header_guest'];
	                }
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'bordered' },
	                    _react3.default.createElement(
	                        'h2',
	                        null,
	                        header
	                    ),
	                    _react3.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        null,
	                        description
	                    ),
	                    _react3.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        { style: { marginBottom: '0px' } },
	                        _react3.default.createElement(
	                            _reactBootstrap.ControlLabel,
	                            null,
	                            lang['store.auth_one_click.confirm.enter_sms_code'],
	                            '*'
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-7 text-right no-padding' },
	                        _react3.default.createElement(_reactBootstrap.FormControl, {
	                            type: (0, _utils.isMobileDevice)() ? "number" : "text",
	                            pattern: '\\d*',
	                            placeholder: '1234',
	                            value: _this.props.phoneCode,
	                            onChange: function onChange(e) {
	                                if ((0, _utils.validateNumeric)(e.target.value)) {
	                                    _this.props.changeField('phoneCode')(e);
	                                }
	                            }
	                        })
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-5 text-right inline_block button_width_100' },
	                        _react3.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                type: 'submit',
	                                bsStyle: 'primary',
	                                className: 'form-control',
	                                disabled: _this.props.disabledSubmitOneClick,
	                                onClick: _this.onClickConfirmOneClick
	                            },
	                            lang['store.auth_one_click.confirm.confirm']
	                        )
	                    ),
	                    _react3.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        { style: { paddingTop: '26px', marginTop: '20px' } },
	                        _this.renderVoiceCode()
	                    ),
	                    _react3.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        null,
	                        _this.renderTimer()
	                    )
	                );
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'bordered' },
	                _react3.default.createElement(
	                    'form',
	                    { name: 'loginOneClick', autoComplete: 'on', className: 'login-form' },
	                    _react3.default.createElement(
	                        'h2',
	                        null,
	                        lang['store.auth_one_click.confirm.header_guest']
	                    ),
	                    _react3.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        null,
	                        lang['store.auth_one_click.confirm.cta']
	                    ),
	                    _react3.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        { style: { marginBottom: '0px' } },
	                        _react3.default.createElement(
	                            _reactBootstrap.ControlLabel,
	                            { className: 'no-padding' },
	                            lang['store.login.phone_or_email']
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-8 text-right no-padding' },
	                        _react3.default.createElement(_reactBootstrap.FormControl, {
	                            type: 'text',
	                            name: 'username',
	                            controlId: 'login',
	                            value: _this.props.login,
	                            onChange: _this.props.changeField('login'),
	                            placeholder: lang['store.login.email_or_phone_placeholder']
	                        })
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-3 text-right inlinediv' },
	                        _react3.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                type: 'submit',
	                                className: 'le-button inlinebutton g-recaptcha',
	                                disabled: _this.props.disabledSubmitOneClick,
	                                onClick: _this.onClickOneClick
	                            },
	                            lang['store.auth_one_click.next']
	                        )
	                    ),
	                    _this.showCaptcha(),
	                    _react3.default.createElement(_reactBootstrap.FormGroup, { className: 'inlineform' }),
	                    _react3.default.createElement(_reactBootstrap.FormGroup, null)
	                )
	            );
	        };
	
	        _this.renderVoiceCode = function () {
	            if (_this.props.codeSendFor === 'phone') {
	                return _react3.default.createElement(_components2.VoiceCode, {
	                    login: _this.props.login,
	                    source: 'registration',
	                    showAlert: _this.showOuterAlert,
	                    whiteList: false
	                });
	            }
	            return null;
	        };
	
	        _this.renderTimer = function () {
	            var lang = _this.props.lang;
	
	            var retry_in = lang['store.timer.retry'] + ' ';
	            var seconds = ' ' + lang['store.timer.sec'] + ' ';
	
	            return _react3.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'voice_wrap text-center' },
	                    _this.props.timeToResentCode > 0 ? _react3.default.createElement(
	                        'p',
	                        { id: 'voice_call_time_wrap', className: 'active' },
	                        retry_in,
	                        _react3.default.createElement(
	                            'span',
	                            { id: 'voice_call_time active' },
	                            _this.props.timeToResentCode
	                        ),
	                        seconds
	                    ) : _react3.default.createElement(
	                        _components2.Preloader,
	                        { classNames: 'mini_preload', preload: _this.props.preloader },
	                        _react3.default.createElement(
	                            'a',
	                            { id: 'get_voice_call', href: '#', onClick: _this.props.onClickResendCode },
	                            lang['store.auth_one_click.timer.resend']
	                        )
	                    )
	                )
	            );
	        };
	
	        _this.showOuterAlert = function (alert) {
	            // this.setState({outerAlert: alert});
	        };
	
	        _this.handlePhoneChange = function (phone, country) {
	            _this.props.changeField('login')(null, phone);
	        };
	
	        _this.setActiveClick = function (key) {
	            return function (e) {
	                var elem = document.getElementsByName('inset');
	                elem.forEach(function (item) {
	                    item.className = '';
	                });
	                document.getElementById(key).className = 'checked';
	            };
	        };
	
	        _this.inputLogin = null;
	
	        _this.context.registerEvent('onEntering', function () {
	            if (_this.inputLogin) {
	                _reactDom2.default.findDOMNode(_this.inputLogin).focus();
	            }
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(AuthOneClickView, [{
	        key: 'render',
	        value: function render() {
	            var lang = this.props.lang;
	
	
	            if (this.props.orderInOneClick) {
	                return _react3.default.createElement(
	                    _components2.Preloader,
	                    { preload: this.props.preload },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'tabs' },
	                        _react3.default.createElement('input', { type: 'radio', name: 'inset', value: '', id: 'tab_1', className: 'checked' }),
	                        _react3.default.createElement(
	                            'label',
	                            { htmlFor: 'tab_2', onClick: this.setActiveClick('tab_1') },
	                            lang['store.auth_one_click.one_click_purchase']
	                        ),
	                        _react3.default.createElement('input', { type: 'radio', name: 'inset', value: '', id: 'tab_2' }),
	                        _react3.default.createElement(
	                            'label',
	                            { htmlFor: 'tab_1', onClick: this.setActiveClick('tab_2') },
	                            lang['store.auth_one_click.sign_in_and_buy']
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { id: 'txt_1' },
	                            _react3.default.createElement(
	                                'main',
	                                { id: 'authentication' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'container__' },
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'col-md-12' },
	                                            this.showError(),
	                                            _react3.default.createElement(
	                                                'section',
	                                                { id: 'one-click-form', className: 'sign-in' },
	                                                this.showOneClickConfirm()
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { id: 'txt_2' },
	                            _react3.default.createElement(
	                                'main',
	                                { id: 'authentication' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'container__' },
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'row' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'col-md-12' },
	                                            this.showError(),
	                                            _react3.default.createElement(
	                                                'section',
	                                                { id: 'auth-form', className: 'sign-in' },
	                                                _react3.default.createElement(
	                                                    'div',
	                                                    { className: 'bordered' },
	                                                    _react3.default.createElement(
	                                                        'form',
	                                                        { name: 'login', autoComplete: 'on', className: 'login-form',
	                                                            onSubmit: this.props.onSubmit },
	                                                        _react3.default.createElement(
	                                                            _reactBootstrap.FormGroup,
	                                                            null,
	                                                            lang['store.auth_one_click.sign_in_and_make_order']
	                                                        ),
	                                                        _react3.default.createElement(
	                                                            _reactBootstrap.FormGroup,
	                                                            { controlId: 'username',
	                                                                validationState: this.props.validateField('login') },
	                                                            _react3.default.createElement(
	                                                                _reactBootstrap.ControlLabel,
	                                                                null,
	                                                                lang['store.login.phone_or_email']
	                                                            ),
	                                                            _react3.default.createElement(_reactBootstrap.FormControl, {
	                                                                type: 'text',
	                                                                name: 'username',
	                                                                controlId: 'login',
	                                                                value: this.props.login,
	                                                                onChange: this.props.changeField('login'),
	                                                                placeholder: lang['store.login.email_or_phone_placeholder']
	                                                            })
	                                                        ),
	                                                        _react3.default.createElement(
	                                                            _reactBootstrap.FormGroup,
	                                                            {
	                                                                validationState: this.props.validateField('password'),
	                                                                controlId: 'password' },
	                                                            _react3.default.createElement(
	                                                                _reactBootstrap.ControlLabel,
	                                                                null,
	                                                                lang['login.password']
	                                                            ),
	                                                            _react3.default.createElement(_reactBootstrap.FormControl, {
	                                                                type: 'password',
	                                                                name: 'password',
	                                                                controlId: 'password',
	                                                                autoComplete: 'password',
	                                                                placeholder: lang['login.password'],
	                                                                value: this.props.password,
	                                                                onChange: this.props.changeField('password') })
	                                                        ),
	                                                        this.showCaptcha(),
	                                                        _react3.default.createElement(
	                                                            _reactBootstrap.FormGroup,
	                                                            null,
	                                                            _react3.default.createElement(
	                                                                _reactBootstrap.Button,
	                                                                {
	                                                                    type: 'submit',
	                                                                    bsStyle: 'primary',
	                                                                    className: 'form-control',
	                                                                    disabled: this.props.disabledSubmit
	                                                                },
	                                                                lang['store.auth_one_click.enter']
	                                                            )
	                                                        ),
	                                                        _react3.default.createElement(
	                                                            _reactBootstrap.FormGroup,
	                                                            null,
	                                                            _react3.default.createElement(
	                                                                'div',
	                                                                { className: 'text-center to_page_passrecovery' },
	                                                                _react3.default.createElement(
	                                                                    'a',
	                                                                    { onClick: this.onClickPassRecovery },
	                                                                    lang['login.forgotYourPassword']
	                                                                )
	                                                            )
	                                                        ),
	                                                        _react3.default.createElement(
	                                                            _reactBootstrap.FormGroup,
	                                                            null,
	                                                            _react3.default.createElement(
	                                                                'div',
	                                                                { className: 'text-center to-page-registration' },
	                                                                _react3.default.createElement(
	                                                                    _reactRouter.Link,
	                                                                    { to: '/registration',
	                                                                        onClick: this.onClickRegistration },
	                                                                    lang['store.common.sign_up']
	                                                                )
	                                                            )
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                );
	            }
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload },
	                _react3.default.createElement(
	                    'main',
	                    { id: 'authentication' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'container__' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                this.showError(),
	                                _react3.default.createElement(
	                                    'section',
	                                    { id: 'auth-form', className: 'sign-in' },
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'bordered' },
	                                        _react3.default.createElement(
	                                            'form',
	                                            { name: 'login', autoComplete: 'on', className: 'login-form', onSubmit: this.props.onSubmit },
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                { controlId: 'username', validationState: this.props.validateField('login') },
	                                                _react3.default.createElement(
	                                                    _reactBootstrap.ControlLabel,
	                                                    null,
	                                                    lang['store.login.phone_or_email']
	                                                ),
	                                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                                    type: 'text',
	                                                    name: 'username',
	                                                    controlId: 'login',
	                                                    value: this.props.login,
	                                                    onChange: this.props.changeField('login'),
	                                                    placeholder: lang['store.login.email_or_phone_placeholder']
	                                                })
	                                            ),
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                { validationState: this.props.validateField('password'), controlId: 'password' },
	                                                _react3.default.createElement(
	                                                    _reactBootstrap.ControlLabel,
	                                                    null,
	                                                    lang['login.password']
	                                                ),
	                                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                                    type: 'password',
	                                                    name: 'password',
	                                                    controlId: 'password',
	                                                    autoComplete: 'password',
	                                                    placeholder: lang['login.password'],
	                                                    value: this.props.password,
	                                                    onChange: this.props.changeField('password') })
	                                            ),
	                                            this.showCaptcha(),
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                null,
	                                                _react3.default.createElement(
	                                                    _reactBootstrap.Button,
	                                                    {
	                                                        type: 'submit',
	                                                        bsStyle: 'primary',
	                                                        className: 'form-control g-recaptcha',
	                                                        disabled: this.props.disabledSubmit
	                                                    },
	                                                    lang['store.auth_one_click.enter']
	                                                )
	                                            ),
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                null,
	                                                _react3.default.createElement(
	                                                    'div',
	                                                    { className: 'text-center to_page_passrecovery' },
	                                                    _react3.default.createElement(
	                                                        'a',
	                                                        { onClick: this.onClickPassRecovery },
	                                                        lang['login.forgotYourPassword']
	                                                    )
	                                                )
	                                            ),
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                null,
	                                                _react3.default.createElement(
	                                                    'div',
	                                                    { className: 'text-center to-page-registration' },
	                                                    _react3.default.createElement(
	                                                        _reactRouter.Link,
	                                                        { to: '/registration', onClick: this.onClickRegistration },
	                                                        lang['store.common.sign_up']
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return AuthOneClickView;
	}(_react2.Component), _class.propTypes = {
	    validateField: _react2.PropTypes.func.isRequired,
	    showCaptcha: _react2.PropTypes.func,
	    lang: _react2.PropTypes.object
	}, _class.contextTypes = {
	    registerEvent: _react2.PropTypes.func
	}, _temp));
	
	exports.default = AuthOneClickView;
	module.exports = exports['default'];

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(19);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1064);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AuthView: {
	        displayName: 'AuthView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Auth/default/AuthView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var AuthView = _wrapComponent('AuthView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(AuthView, _Component);
	
	    function AuthView(props, context) {
	        (0, _classCallCheck3.default)(this, AuthView);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AuthView.__proto__ || (0, _getPrototypeOf2.default)(AuthView)).call(this, props, context));
	
	        _this.refInput = function (input) {
	            _this.inputLogin = input;
	        };
	
	        _this.showError = function () {
	            var _this$props = _this.props,
	                loginError = _this$props.loginError,
	                loginErrorCode = _this$props.loginErrorCode,
	                lang = _this$props.lang;
	
	
	            if (loginError) {
	                if (loginErrorCode === null || loginErrorCode === undefined) {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang['store.common.server_is_unavailable']
	                    );
	                } else {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang[loginError]
	                    );
	                }
	            }
	
	            return '';
	        };
	
	        _this.onClickRegistration = function (event) {
	            event.preventDefault();
	            if (_this.props.onClickRegistration) {
	                _this.props.onClickRegistration(event);
	            }
	        };
	
	        _this.onClickPassRecovery = function (event) {
	            event.preventDefault();
	            if (_this.props.onClickPassRecovery) {
	                _this.props.onClickPassRecovery(event);
	            }
	        };
	
	        _this.showCaptcha = function () {
	            if (_this.props.showCaptcha) {
	                return _react3.default.createElement(
	                    _reactBootstrap.FormGroup,
	                    null,
	                    _this.props.showCaptcha()
	                );
	            }
	
	            return '';
	        };
	
	        _this.handlePhoneChange = function (phone, country) {
	            _this.props.changeField('login')(null, phone);
	        };
	
	        _this.inputLogin = null;
	
	        _this.context.registerEvent('onEntering', function () {
	            if (_this.inputLogin) {
	                _reactDom2.default.findDOMNode(_this.inputLogin).focus();
	            }
	        });
	        return _this;
	    }
	
	    (0, _createClass3.default)(AuthView, [{
	        key: 'render',
	        value: function render() {
	            var lang = this.props.lang;
	
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload },
	                _react3.default.createElement(
	                    'main',
	                    { id: 'authentication' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'container__' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                this.showError(),
	                                _react3.default.createElement(
	                                    'section',
	                                    { id: 'auth-form', className: 'sign-in' },
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'bordered' },
	                                        _react3.default.createElement(
	                                            'form',
	                                            { name: 'login', autoComplete: 'on', className: 'login-form', onSubmit: this.props.onSubmit },
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                { controlId: 'username', validationState: this.props.validateField('login') },
	                                                _react3.default.createElement(
	                                                    _reactBootstrap.ControlLabel,
	                                                    null,
	                                                    lang['store.login.phone_or_email']
	                                                ),
	                                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                                    type: 'text',
	                                                    name: 'username',
	                                                    controlId: 'login',
	                                                    value: this.props.login,
	                                                    onChange: this.props.changeField('login'),
	                                                    placeholder: lang['store.login.email_or_phone_placeholder']
	                                                })
	                                            ),
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                { validationState: this.props.validateField('password'), controlId: 'password' },
	                                                _react3.default.createElement(
	                                                    _reactBootstrap.ControlLabel,
	                                                    null,
	                                                    lang['login.password']
	                                                ),
	                                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                                    type: 'password',
	                                                    name: 'password',
	                                                    controlId: 'password',
	                                                    autoComplete: 'password',
	                                                    placeholder: lang['login.password'],
	                                                    value: this.props.password,
	                                                    onChange: this.props.changeField('password') })
	                                            ),
	                                            this.showCaptcha(),
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                null,
	                                                _react3.default.createElement(
	                                                    _reactBootstrap.Button,
	                                                    {
	                                                        type: 'submit',
	                                                        bsStyle: 'primary',
	                                                        className: 'form-control g-recaptcha',
	                                                        disabled: this.props.disabledSubmit
	                                                    },
	                                                    lang['login.logIn']
	                                                )
	                                            ),
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                null,
	                                                _react3.default.createElement(
	                                                    'div',
	                                                    { className: 'text-center to_page_passrecovery' },
	                                                    _react3.default.createElement(
	                                                        'a',
	                                                        { onClick: this.onClickPassRecovery },
	                                                        lang['login.forgotYourPassword']
	                                                    )
	                                                )
	                                            ),
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                null,
	                                                _react3.default.createElement(
	                                                    'div',
	                                                    { className: 'text-center to-page-registration' },
	                                                    _react3.default.createElement(
	                                                        _reactRouter.Link,
	                                                        { to: '/registration', onClick: this.onClickRegistration },
	                                                        lang['store.common.sign_up']
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return AuthView;
	}(_react2.Component), _class.propTypes = {
	    validateField: _react2.PropTypes.func.isRequired,
	    showCaptcha: _react2.PropTypes.func,
	    lang: _react2.PropTypes.object
	}, _class.contextTypes = {
	    registerEvent: _react2.PropTypes.func
	}, _temp));
	
	exports.default = AuthView;
	module.exports = exports['default'];

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AuthOneClick = exports.Auth = exports.AuthHeader = undefined;
	
	var _AuthHeader2 = __webpack_require__(1604);
	
	var _AuthHeader3 = _interopRequireDefault(_AuthHeader2);
	
	var _Auth2 = __webpack_require__(1603);
	
	var _Auth3 = _interopRequireDefault(_Auth2);
	
	var _AuthOneClick2 = __webpack_require__(1605);
	
	var _AuthOneClick3 = _interopRequireDefault(_AuthOneClick2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AuthHeader = _AuthHeader3.default;
	exports.Auth = _Auth3.default;
	exports.AuthOneClick = _AuthOneClick3.default;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _promise = __webpack_require__(58);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(68);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _basket = __webpack_require__(101);
	
	var _modal = __webpack_require__(26);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _modal_type = __webpack_require__(42);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	var _catalog = __webpack_require__(67);
	
	var _helpers = __webpack_require__(15);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AddToBasket: {
	        displayName: 'AddToBasket'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Basket/AddToBasket/AddToBasket.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var AddToBasket = _wrapComponent('AddToBasket')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        orderInOneClick: state.setting.orderInOneClick,
	        buyInCreditActive: state.setting.buyInCreditActive,
	        buyInCredit: state.setting.buyInCredit,
	        addBasketButtonName: state.setting.addBasketButtonName,
	        addBasketButtonOneClickName: state.setting.addBasketButtonOneClickName,
	        user: state.auth.user,
	        basketElements: state.basket.items,
	        currency: state.currency,
	        lang: state.lang
	    };
	}, { addProduct: _basket.addProduct, showModal: _modal.showModal, hide: _modal.hide, push: _reactRouterRedux.push, showModalAuth: _modal_type.showModalAuth, createOrder: _basket.createOrder, clearBasket: _basket.clearBasket, showModalAuthOneClick: _modal_type.showModalAuthOneClick, showModifierModal: _modal_type.showModifierModal, getProduct: _catalog.getProduct }), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(AddToBasket, _Component);
	
	    function AddToBasket(props) {
	        (0, _classCallCheck3.default)(this, AddToBasket);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AddToBasket.__proto__ || (0, _getPrototypeOf2.default)(AddToBasket)).call(this));
	
	        _this.showErrorAlert = function (message) {
	            _reactSAlert2.default.error(message, { position: 'top-right', effect: 'slide', timeout: 3000 });
	        };
	
	        _this.onAddToCartCallback = function (e) {
	            var lang = _this.props.lang;
	
	
	            if (_this.props.product.modifier !== undefined && _this.props.product.modifier !== null && _this.props.product.modifier.length !== 0 && !_this.props.isModal || _this.props.product.is_quantity_change && !_this.props.isModal) {
	                var modNames = [];
	                if (_this.props.product.modifier[0] !== undefined) {
	                    modNames.push(_this.props.product.modifier[0].name);
	                }
	                if (_this.props.product.modifier[1] !== undefined) {
	                    modNames.push(_this.props.product.modifier[1].name);
	                }
	                if (_this.props.product.modifier[2] !== undefined) {
	                    modNames.push(_this.props.product.modifier[2].name);
	                }
	                var choose = lang['store.add_to_cart.choose'];
	                var copyProduct = JSON.parse((0, _stringify2.default)(_this.props.product));
	                _this.props.showModifierModal(copyProduct, choose + ' ' + modNames.join(', '), _this.props.count);
	            } else {
	                if (_this.props.isModal) {
	                    _this.props.close();
	                }
	                if (_this.props.updateProducts) {
	                    _promise2.default.all(_this.props.updateProducts()).then(function (resp) {
	                        var addingProd = resp.filter(function (item) {
	                            return item.offers.find(function (elem) {
	                                return elem.id === _this.props.product.id;
	                            });
	                        });
	                        if (addingProd.length > 0) {
	                            _LocalStorageProxy2.default.removeItem('buy_in_credit');
	                            _this.addToCart(e);
	                        } else {
	                            _this.showErrorAlert(lang['store.add_to_cart.item_not_exist']);
	                        }
	                    });
	                } else {
	                    _LocalStorageProxy2.default.removeItem('buy_in_credit');
	                    _this.addToCart(e);
	                }
	            }
	        };
	
	        _this.onBuyInOneClickCallback = function (e) {
	            var isBuyInCredit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	            var _this$props = _this.props,
	                lang = _this$props.lang,
	                product = _this$props.product;
	
	
	            if (_this.props.product.modifier !== undefined && _this.props.product.modifier !== null && _this.props.product.modifier.length !== 0 && !_this.props.isModal || _this.props.product.is_quantity_change && !_this.props.isModal) {
	                var modNames = [];
	                if (product.modifier[0] !== undefined) {
	                    modNames.push(product.modifier[0].name);
	                }
	                if (product.modifier[1] !== undefined) {
	                    modNames.push(product.modifier[1].name);
	                }
	                if (product.modifier[2] !== undefined) {
	                    modNames.push(product.modifier[2].name);
	                }
	                var choose = lang['store.add_to_cart.choose'];
	                var copyProduct = JSON.parse((0, _stringify2.default)(product));
	                _this.props.showModifierModal(copyProduct, choose + ' ' + modNames.join(', '));
	            } else {
	                _this.props.clearBasket();
	                if (_this.props.user) {
	                    if (isBuyInCredit === true) {
	                        _LocalStorageProxy2.default.setItem('buy_in_credit', 'true');
	                    } else {
	                        _LocalStorageProxy2.default.removeItem('buy_in_credit');
	                    }
	                    _this.addToCart(e);
	                    _this.callCreateOrder();
	                    if (_this.props.isModal) {
	                        _this.props.close();
	                    }
	                } else {
	                    if (isBuyInCredit === true) {
	                        _LocalStorageProxy2.default.setItem('buy_in_credit', 'true');
	                    } else {
	                        _LocalStorageProxy2.default.removeItem('buy_in_credit');
	                    }
	                    _this.addToCart(e);
	                    _this.setState({ wasOrderClick: true });
	                    if (_this.props.isModal) {
	                        _this.props.showModalAuthOneClick(true);
	                    } else {
	                        _this.props.showModalAuthOneClick(true);
	                    }
	                }
	            }
	        };
	
	        _this.callCreateOrder = function () {
	            var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.basketElements;
	
	            _this.props.push('/basket');
	            _this.props.createOrder(_this._compileOrder(basketElements)).then(function (result) {
	                _this.props.clearBasket();
	                _this.props.push('/create-order/' + result.result.order_id);
	            }).catch(function (err) {
	                //Ошибка "предложение не найдено"
	                if (err.code === 139 && err.title === 'error.catalogOfferNotFind') {
	                    console.log('предложение не найдено', err);
	                    err.dataError.forEach(function (item) {
	                        _this.props.deleteProduct(item);
	                    });
	
	                    var alertMessage = _this.props.lang['store.cart.call_create_order.catalog_offer_not_found'];
	
	                    setTimeout(function () {
	                        _reactSAlert2.default.success(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                    }, 0);
	                }
	
	                //Ошибка: алкогольные товары в корзине
	                if (err.code === 136 && err.title === 'error.orderExciseMarkBarcodeIsRequired') {
	                    _this._showAlcoWarning(err.dataError);
	                }
	            });
	        };
	
	        _this._compileOrder = function () {
	            var product = _this.props.product;
	            var count = _this.props.count || 1;
	            var sum = 0;
	            var products = [];
	            sum += product.price * count;
	            products.push({
	                offer_id: product.id,
	                quantity: count,
	                price: product.price,
	                modifier_option_id: product.modifier_option_id,
	                modifier_option_name: product.modifierName,
	                nestedOffers: product.nestedOffers
	            });
	
	            var userAgent = navigator.userAgent || '';
	            var utmRedirectData = _LocalStorageProxy2.default.getItem('utm_redirect_data') || '';
	            _LocalStorageProxy2.default.setItem('utm_redirect_data', '');
	            var currency_id = _this.props.currency.id;
	            return { sum: sum, products: products, userAgent: userAgent, utmRedirectData: utmRedirectData, currency_id: currency_id };
	        };
	
	        _this.addToCart = function (event) {
	            var ModalContent = _helpers.ThemeHelper.getViewForComponent('ModalContent', null, { folderName: 'Basket/AddToBasket' });
	            var product = _this.props.product;
	            var count = _this.props.count || 1;
	            var remainderQuantity = null;
	            if (_this.state.customFields) {
	                var isError = false;
	                _this.state.customFields.forEach(function (customField) {
	                    if (customField.isRequired && (customField.value == null || customField.value == '')) {
	                        isError = true;
	                        var alertMessage = _this.props.lang['store.customFields.error.required'] + customField.name;
	                        setTimeout(function () {
	                            _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                        }, 0);
	                        return null;
	                    }
	                    if (customField.onlyLatin) {
	                        var regexp = /^[0-9A-Za-z @_-]+$/;
	                        var result = !regexp.test(customField.value);
	                        if (result) {
	                            isError = true;
	                            var _alertMessage = _this.props.lang['store.customFields.error.noLatin'] + customField.name;
	                            setTimeout(function () {
	                                _reactSAlert2.default.error(_alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                            }, 0);
	                            return null;
	                        }
	                    }
	                    var matches = customField.value.match(/\S+/g) || [];
	                    if (customField.maxWords && matches.length > customField.maxWords * 1) {
	                        isError = true;
	                        var _alertMessage2 = _this.props.lang['store.customFields.error.noLatin'] + customField.name;
	                        setTimeout(function () {
	                            _reactSAlert2.default.error(_alertMessage2, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                        }, 0);
	                        return null;
	                    }
	                });
	                if (isError) {
	                    return null;
	                }
	            }
	
	            if (product.modifier_option_id !== undefined && product.modifier_option_id !== null && product.modifier_option.storable && product.modifier_option.storage_strict && product.modifier_option.remainder[0] && product.type_id !== 5) {
	                _this.props.getProduct(product.id).then(function (result) {
	                    product.modifier_option = result.modifiedOption.filter(function (value) {
	                        return value.id === product.modifier_option_id;
	                    })[0];
	                    remainderQuantity = product.modifier_option.remainder[0].quantity;
	                    _this.props.addProduct({
	                        description: product.description,
	                        id: product.id,
	                        name: product.name,
	                        price: parseFloat(product.price),
	                        picture: product.pictures ? product.pictures[0] : {},
	                        count: count,
	                        type_id: product.type_id,
	                        modifier_option_id: product.modifier_option_id !== undefined ? product.modifier_option_id : null,
	                        modifier_option: product.modifier_option,
	                        remainder_quantity: remainderQuantity,
	                        modifier_option_name: product.modifierName,
	                        custom_fields: JSON.parse((0, _stringify2.default)(_this.state.customFields))
	                    });
	                    if (_this.props.isModal) {
	                        _this.props.product.modifier_option_id = undefined;
	                    }
	                });
	            } else if (product.modifier_option_id === undefined && product.storable && product.storage_strict && product.remainder[0] && product.type_id !== 5) {
	                _this.props.getProduct(product.id).then(function (result) {
	                    product = result;
	                    remainderQuantity = product.remainder[0].quantity;
	                    _this.props.addProduct({
	                        description: product.description,
	                        id: product.id,
	                        name: product.name,
	                        price: parseFloat(product.price),
	                        picture: product.pictures ? product.pictures[0] : {},
	                        count: count,
	                        type_id: product.type_id,
	                        modifier_option_id: product.modifier_option_id !== undefined ? product.modifier_option_id : null,
	                        modifier_option: null,
	                        remainder_quantity: remainderQuantity,
	                        custom_fields: JSON.parse((0, _stringify2.default)(_this.state.customFields))
	                    });
	                });
	            } else if (product.storable && product.remainder[0] && product.type_id === 5) {
	                _this.props.getProduct(product.id).then(function (result) {
	                    var quantityTechCard = 1;
	                    result.remainder = [];
	                    var childOffers = [];
	                    var childOffer = void 0;
	                    var childOffersTwo = [];
	                    var childOfferTwo = void 0;
	                    var quantity = void 0;
	                    result.nestedOffers.forEach(function (nestedOffer) {
	                        product.nestedOffers.forEach(function (actualNestedOffer) {
	                            if (actualNestedOffer.id === nestedOffer.id) {
	                                nestedOffer.quantity = actualNestedOffer.quantity;
	                            }
	                        });
	                        if (nestedOffer.quantity > 0) {
	                            if (nestedOffer.childOffer.type_id === 5) {
	                                nestedOffer.childOffer.remainder = [];
	                                nestedOffer.childOffer.storable = false;
	                                nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
	                                    _this.getRemainder(nestedOfferTwo, nestedOffer.quantity, result);
	                                });
	                            } else {
	                                _this.getRemainder(nestedOffer, quantityTechCard, result);
	                            }
	                        }
	                    });
	                    remainderQuantity = result.remainder[0].quantity;
	                    _this.props.addProduct({
	                        description: product.description,
	                        id: product.id,
	                        name: product.name,
	                        price: parseFloat(product.price),
	                        picture: product.pictures ? product.pictures[0] : {},
	                        count: count,
	                        type_id: product.type_id,
	                        modifier_option_id: product.modifier_option_id !== undefined ? product.modifier_option_id : null,
	                        modifier_option: product.modifier_option,
	                        remainder_quantity: remainderQuantity,
	                        modifier_option_name: product.modifierName,
	                        nested_offer: product.nestedOffers,
	                        values_mods: product.valuesMods,
	                        custom_fields: JSON.parse((0, _stringify2.default)(_this.state.customFields))
	                    });
	                });
	            } else {
	                _this.props.addProduct({
	                    description: product.description,
	                    id: product.id,
	                    name: product.name,
	                    price: parseFloat(product.price),
	                    picture: product.pictures ? product.pictures[0] : {},
	                    count: count,
	                    type_id: product.type_id,
	                    modifier_option_id: product.modifier_option_id !== undefined ? product.modifier_option_id : null,
	                    modifier_option: product.modifier_option,
	                    remainder_quantity: remainderQuantity,
	                    modifier_option_name: product.modifierName,
	                    nested_offer: product.nestedOffers,
	                    values_mods: product.valuesMods,
	                    custom_fields: JSON.parse((0, _stringify2.default)(_this.state.customFields))
	                });
	                if (_this.props.isModal) {
	                    _this.props.product.modifier_option_id = undefined;
	                }
	            }
	            var cart = $('.ibonus-shopping-cart');
	            var imgtodrag = event.target ? $(event.target).parents("div.flying-to-cart-holder").find("img.flying-to-cart-img").eq(0) : null;
	
	            if (imgtodrag && _this.props.isModal !== true) {
	                var imgclone = imgtodrag.clone().offset({
	                    top: imgtodrag.offset().top,
	                    left: imgtodrag.offset().left
	                }).css({
	                    'opacity': '0.7',
	                    'position': 'absolute',
	                    'height': imgtodrag.height(),
	                    'width': imgtodrag.width(),
	                    'z-index': '1200'
	                }).appendTo($('body')).animate({
	                    'top': cart.offset().top + 10,
	                    'left': cart.offset().left + 10,
	                    'width': 30,
	                    'height': 30
	                }, 1000, 'easeInOutExpo');
	
	                imgclone.animate({
	                    'width': 0,
	                    'height': 0
	                }, function () {
	                    $(this).detach();
	                });
	            }
	        };
	
	        _this.changeCustomFields = function (e) {
	            _this.state.customFields[e.target.id].value = e.target.value;
	            _this.setState({ customFields: _this.state.customFields });
	        };
	
	        var customFields = null;
	        var additionalInfo = props.product.additional_info ? JSON.parse(props.product.additional_info) : null;
	        if (additionalInfo !== null && additionalInfo.customFields) {
	            customFields = additionalInfo.customFields;
	            customFields.map(function (item) {
	                if (!item.value) {
	                    item.value = null;
	                }
	                return item;
	            });
	        }
	        _this.state = {
	            wasOrderClick: false,
	            customFields: customFields
	        };
	        return _this;
	    }
	
	    // shouldComponentUpdate(nextProps, nextState) {
	    //     if (this.state.wasOrderClick && this.props.user) {
	    //         this.callCreateOrder();
	    //         this.setState({wasOrderClick: false});
	    //         return false;
	    //     }
	    //
	    //     if (this.state.wasOrderClick) {
	    //         this.setState({wasOrderClick: false});
	    //     }
	    //
	    //     return true;
	    // };
	
	    (0, _createClass3.default)(AddToBasket, [{
	        key: 'getRemainder',
	        value: function getRemainder(nestedOffer, quantityParent, product_detail) {
	            var _this2 = this;
	
	            if (nestedOffer.childOffer === null) {
	                return null;
	            }
	            if (nestedOffer.quantity > 0) {
	                var quantity = void 0;
	                var quantityTechCard = void 0;
	                quantity = nestedOffer.quantity;
	                if (nestedOffer.childOffer.modifier_option_id !== null && nestedOffer.childOffer.modOption === null) {
	                    nestedOffer.childOffer.modOption = nestedOffer.childOffer.modifiedOption.reduce(function (mod, modifier) {
	                        if (modifier.id === nestedOffer.childOffer.modifier_option_id) {
	                            return modifier;
	                        }
	                        return mod;
	                    }, null);
	                }
	                if (nestedOffer.childOffer.modOption !== null && nestedOffer.childOffer.type_id !== 5) {
	                    nestedOffer.childOffer.unit = nestedOffer.childOffer.modOption.unit;
	                    if (nestedOffer.childOffer.modOption.storable === true && nestedOffer.childOffer.modOption.storage_strict) {
	                        product_detail.storable = true;
	                        if (nestedOffer.childOffer.modOption.remainder.length === 0) {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        } else if (nestedOffer.childOffer.modOption.remainder[0].quantity > 0) {
	                            if ((nestedOffer.childOffer.modOption.unit_id === 2 || nestedOffer.childOffer.modOption.unit_id === 8) && nestedOffer.childOffer.modOption.weight && nestedOffer.childOffer.modOption.weight > 0) {
	                                quantity = nestedOffer.childOffer.modOption.weight * nestedOffer.quantity;
	                            }
	                            quantity = quantity * quantityParent;
	                            quantityTechCard = Math.floor(nestedOffer.childOffer.modOption.remainder[0].quantity / quantity);
	                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
	                                product_detail.remainder = [{ quantity: quantityTechCard }];
	                            }
	                        } else {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        }
	                    }
	                }
	                if (nestedOffer.childOffer.modOption === null && nestedOffer.childOffer.type_id !== 5) {
	                    if (nestedOffer.childOffer.storable === true && nestedOffer.childOffer.storage_strict) {
	                        product_detail.storable = true;
	                        if (nestedOffer.childOffer.remainder.length === 0) {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        } else if (nestedOffer.childOffer.remainder[0].quantity > 0) {
	                            if ((nestedOffer.childOffer.unit_id === 2 || nestedOffer.childOffer.unit_id === 8) && nestedOffer.childOffer.weight && nestedOffer.childOffer.weight > 0) {
	                                quantity = nestedOffer.childOffer.weight * nestedOffer.quantity;
	                            }
	                            quantity = quantity * quantityParent;
	                            quantityTechCard = Math.floor(nestedOffer.childOffer.remainder[0].quantity / quantity);
	                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
	                                product_detail.remainder = [{ quantity: quantityTechCard }];
	                            }
	                        } else {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        }
	                    }
	                }
	                if (nestedOffer.childOffer.type_id === 5) {
	                    nestedOffer.childOffer.remainder = [];
	                    nestedOffer.childOffer.storable = false;
	                    quantity = nestedOffer.quantity * quantityParent;
	                    nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
	                        _this2.getRemainder(nestedOfferTwo, quantity, product_detail);
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('AddToBasket', null, { folderName: 'Basket/AddToBasket' });
	
	            var _props = this.props,
	                product = _props.product,
	                className = _props.className,
	                callback = _props.callback,
	                addProduct = _props.addProduct,
	                count = _props.count,
	                lang = _props.lang,
	                props = (0, _objectWithoutProperties3.default)(_props, ['product', 'className', 'callback', 'addProduct', 'count', 'lang']);
	
	
	            return _react3.default.createElement(View, (0, _extends3.default)({
	                callback: this.onAddToCartCallback,
	                className: className,
	                callbackOneClick: this.onBuyInOneClickCallback
	            }, props, {
	                product: product,
	                count: count,
	                customFields: this.state.customFields,
	                changeCustomFields: this.changeCustomFields,
	                lang: lang
	            }));
	        }
	    }]);
	    return AddToBasket;
	}(_react2.Component), _class2.propTypes = {
	    updateProducts: _react2.PropTypes.func,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _class2.defaultProps = {
	    user: null
	}, _temp)) || _class));
	
	exports.default = AddToBasket;
	module.exports = exports['default'];

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(103);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _BasketProductDetail = __webpack_require__(748);
	
	var _BasketProductDetail2 = _interopRequireDefault(_BasketProductDetail);
	
	var _reactBootstrap = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AddToBasketView: {
	        displayName: 'AddToBasketView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Basket/AddToBasket/default/AddToBasketView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var AddToBasketView = _wrapComponent('AddToBasketView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(AddToBasketView, _Component);
	
	    function AddToBasketView() {
	        (0, _classCallCheck3.default)(this, AddToBasketView);
	        return (0, _possibleConstructorReturn3.default)(this, (AddToBasketView.__proto__ || (0, _getPrototypeOf2.default)(AddToBasketView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(AddToBasketView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                callback = _props.callback,
	                callbackOneClick = _props.callbackOneClick,
	                product = _props.product,
	                lang = _props.lang,
	                count = _props.count,
	                customFields = _props.customFields,
	                changeCustomFields = _props.changeCustomFields,
	                props = (0, _objectWithoutProperties3.default)(_props, ['className', 'callback', 'callbackOneClick', 'product', 'lang', 'count', 'customFields', 'changeCustomFields']),
	                storable = product.storable,
	                _product$remainder = product.remainder,
	                remainder = _product$remainder === undefined ? [] : _product$remainder;
	
	            if (count === undefined || count === null) {
	                count = 1;
	            }
	            if (!className) {
	                className = [];
	            }
	
	            className = [].concat((0, _toConsumableArray3.default)(className), ['le-button']);
	
	            var addBasketButtonName = this.props.addBasketButtonName;
	            var addBasketButtonOneClickName = this.props.addBasketButtonOneClickName;
	            var buttonSettings = product.additional_info ? JSON.parse(product.additional_info) : null;
	            if (buttonSettings !== null && buttonSettings.cartButtonSettings !== undefined && buttonSettings.cartButtonSettings !== null) {
	                if (buttonSettings.cartButtonSettings.isCustomCartButton === true) {
	                    addBasketButtonName = buttonSettings.cartButtonSettings.buttonName;
	                    addBasketButtonOneClickName = buttonSettings.cartButtonSettings.buttonOneClickName;
	                }
	            }
	            var customFieldsView = null;
	            if (customFields) {
	                customFieldsView = _react3.default.createElement(
	                    'div',
	                    null,
	                    customFields.map(function (item, i) {
	                        return _react3.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            null,
	                            _react3.default.createElement(
	                                _reactBootstrap.ControlLabel,
	                                null,
	                                item.name
	                            ),
	                            _react3.default.createElement('input', {
	                                id: i,
	                                value: item.value,
	                                className: 'form-control',
	                                placeholder: item.hint,
	                                type: 'text',
	                                onChange: changeCustomFields
	                            })
	                        );
	                    })
	                );
	            }
	
	            var productOutOfStock = lang['store.add_to_cart.product_out_of_stock'];
	
	            if (product.modifier_option_id && product.modifier_option.storable && product.modifier_option.storage_strict && (product.modifier_option.remainder[0] && product.modifier_option.remainder[0].quantity <= 0 || product.modifier_option.remainder.length === 0)) {
	                return _react3.default.createElement(
	                    'div',
	                    { id: 'noProductInStore', className: 'inline text-theme' },
	                    productOutOfStock
	                );
	            } else if (product.modifiedOption.length > 0 && (product.modifier_option_id === null || product.modifier_option_id === undefined)) {
	                var noProductInStore = true;
	                if (product.type_id !== 5) {
	                    product.modifiedOption.forEach(function (item) {
	                        if (!(item.storable && item.storage_strict && (item.remainder[0] && item.remainder[0].quantity <= 0 || item.remainder.length === 0))) {
	                            noProductInStore = false;
	                        }
	                    });
	                } else {
	                    if (storable && (remainder[0] && remainder[0].quantity <= 0 || remainder.length === 0)) {
	                        noProductInStore = true;
	                    } else {
	                        noProductInStore = false;
	                    }
	                }
	                if (noProductInStore) {
	                    return _react3.default.createElement(
	                        'div',
	                        { id: 'noProductInStore', className: 'inline text-theme' },
	                        productOutOfStock
	                    );
	                }
	            } else if ((product.modifier_option_id === null || product.modifier_option_id === undefined) && storable && product.storage_strict && (remainder[0] && remainder[0].quantity <= 0 || remainder.length === 0)) {
	                return _react3.default.createElement(
	                    'div',
	                    { id: 'noProductInStore', className: 'inline text-theme' },
	                    productOutOfStock
	                );
	            }
	            var buyInCreditActive = null;
	            var buyInCreditSumMonth = 0;
	            var buyInCreditButtonName = lang['onlineShop.buyInCredit.service'];
	            if (this.props.buyInCredit.is_credit === false) {
	                buyInCreditButtonName = lang['settingsBuyInCreditForm.title.installment'];
	            }
	            if (this.props.buyInCreditActive && product.price * count <= 500000 && product.price * count >= 3000) {
	                buyInCreditButtonName = lang['onlineShop.buyInCredit.button1'] + parseFloat(product.price * count / 19 || 0).toFixed(2) + ' ' + lang['onlineShop.buyInCredit.button2'];
	                if (this.props.buyInCredit.is_credit === false) {
	                    buyInCreditButtonName = lang['onlineShop.buyInCredit.installments.button1'] + parseFloat(product.price * count / 19 || 0).toFixed(2) + ' ' + lang['onlineShop.buyInCredit.button2'];
	                }
	                buyInCreditActive = _react3.default.createElement(
	                    'button',
	                    (0, _extends3.default)({
	                        style: { width: '100%', paddingLeft: '5px', paddingRight: '5px' },
	                        className: 'button_credit' }, props, {
	                        onClick: function onClick(event) {
	                            return callbackOneClick(event, true);
	                        } }),
	                    buyInCreditButtonName
	                );
	            }
	            if (this.props.orderInOneClick && !this.props.buyInCreditActive) {
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'inline' },
	                    customFieldsView,
	                    _react3.default.createElement(
	                        'button',
	                        (0, _extends3.default)({ style: { marginBottom: '10px', width: '90%' }, className: className.join(' ') }, props, { onClick: callback }),
	                        addBasketButtonName
	                    ),
	                    _react3.default.createElement(
	                        'button',
	                        (0, _extends3.default)({ style: { width: '90%' }, className: 'le-button' }, props, { onClick: callbackOneClick }),
	                        addBasketButtonOneClickName
	                    )
	                );
	            } else if (!this.props.orderInOneClick && this.props.buyInCreditActive) {
	                var style = { marginBottom: '10px', width: '100%' };
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'inline' },
	                    customFieldsView,
	                    _react3.default.createElement(
	                        'button',
	                        (0, _extends3.default)({ style: style, className: className.join(' ') }, props, { onClick: callback }),
	                        addBasketButtonName
	                    ),
	                    buyInCreditActive
	                );
	            } else if (this.props.orderInOneClick && this.props.buyInCreditActive) {
	                var _buyInCreditActive = null;
	                if (this.props.buyInCreditActive && product.price * count <= 500000 && product.price * count >= 3000) {
	                    _buyInCreditActive = _react3.default.createElement(
	                        'button',
	                        (0, _extends3.default)({
	                            style: { marginBottom: '10px', width: '90%', paddingLeft: '5px', paddingRight: '5px' },
	                            className: 'button_credit' }, props, {
	                            onClick: function onClick(event) {
	                                return callbackOneClick(event, true);
	                            } }),
	                        buyInCreditButtonName
	                    );
	                }
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'inline', style: { textAlign: 'center' } },
	                    customFieldsView,
	                    _react3.default.createElement(
	                        'button',
	                        (0, _extends3.default)({ style: { marginBottom: '10px', width: '100%' }, className: className.join(' ') }, props, { onClick: callback }),
	                        addBasketButtonName
	                    ),
	                    _buyInCreditActive,
	                    _react3.default.createElement(
	                        'button',
	                        (0, _extends3.default)({ style: { width: '100%' }, className: 'le-button' }, props, { onClick: callbackOneClick }),
	                        addBasketButtonOneClickName
	                    )
	                );
	            } else {
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'inline', style: { textAlign: 'center' } },
	                    customFieldsView,
	                    _react3.default.createElement(
	                        'button',
	                        (0, _extends3.default)({ style: { width: '100%' }, className: className.join(' ') }, props, { onClick: callback }),
	                        addBasketButtonName
	                    )
	                );
	            }
	        }
	    }]);
	    return AddToBasketView;
	}(_react2.Component), _class.propTypes = {
	    lang: _react2.PropTypes.object
	}, _temp));
	
	exports.default = AddToBasketView;
	module.exports = exports['default'];

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1065);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ModalContent: {
	        displayName: 'ModalContent'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Basket/AddToBasket/default/ModalContentView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	} /**
	   * Created by maximus on 01.12.16.
	   */
	
	
	var ModalContent = _wrapComponent('ModalContent')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(ModalContent, _Component);
	
	    function ModalContent(props) {
	        (0, _classCallCheck3.default)(this, ModalContent);
	        return (0, _possibleConstructorReturn3.default)(this, (ModalContent.__proto__ || (0, _getPrototypeOf2.default)(ModalContent)).call(this, props));
	    }
	
	    (0, _createClass3.default)(ModalContent, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                product = _props.product,
	                count = _props.count,
	                lang = _props.lang,
	                currency = _props.currency;
	            var pictures = this.props.product.pictures;
	
	
	            var imgSrc = '/assets/images/placeholder.png';
	            if (pictures && pictures[0]) {
	                if (pictures[0].preview_url) {
	                    imgSrc = pictures[0].preview_url;
	                } else {
	                    if (pictures[0].url) {
	                        imgSrc = pictures[0].url;
	                    }
	                }
	            }
	
	            var callbackSuccessBtnText = lang['store.add_to_cart.modal_content.go_to_cart'];
	            var callbackCloseBtnText = lang['store.add_to_cart.modal_content.continue_shopping'];
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'modal_content' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'content_holder' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'product_title' },
	                        product.name
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'image_holder' },
	                        _react3.default.createElement('img', { className: 'img-responsive', src: imgSrc })
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'product_price' },
	                        _react3.default.createElement(_components2.MoneyValue, {
	                            value: parseFloat(product.price),
	                            icon: currency.icon,
	                            iconAfterValue: currency.icon_after_value
	                        })
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'button_holder' },
	                    _react3.default.createElement(
	                        'button',
	                        { onClick: this.props.callBackSuccess, className: 'le-button' },
	                        callbackSuccessBtnText
	                    ),
	                    _react3.default.createElement(
	                        'button',
	                        { onClick: this.props.callBackClose, className: 'le-button button_close' },
	                        callbackCloseBtnText
	                    )
	                )
	            );
	        }
	    }]);
	    return ModalContent;
	}(_react2.Component), _class.propTypes = {
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp));
	
	exports.default = ModalContent;
	module.exports = exports['default'];

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddToBasket = undefined;
	
	var _AddToBasket2 = __webpack_require__(1610);
	
	var _AddToBasket3 = _interopRequireDefault(_AddToBasket2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AddToBasket = _AddToBasket3.default;

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _config = __webpack_require__(192);
	
	var config = _interopRequireWildcard(_config);
	
	var _modal = __webpack_require__(26);
	
	var _helpers = __webpack_require__(15);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    BuyInCreditModal: {
	        displayName: 'BuyInCreditModal'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Basket/BuyInCreditModal/BuyInCreditModal.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var BuyInCreditModal = _wrapComponent('BuyInCreditModal')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang,
	        currency: state.currency,
	        user: state.auth.user
	    };
	}, { hide: _modal.hide }), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(BuyInCreditModal, _Component);
	
	    function BuyInCreditModal(props, context) {
	        (0, _classCallCheck3.default)(this, BuyInCreditModal);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BuyInCreditModal.__proto__ || (0, _getPrototypeOf2.default)(BuyInCreditModal)).call(this, props, context));
	
	        _this.closeModal = function () {
	            _this.props.hide();
	        };
	
	        _LocalStorageProxy2.default.removeItem('buy_in_credit');
	        _this.state = {
	            changeQuantity: 10,
	            changeChildMods: 10
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(BuyInCreditModal, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('BuyInCreditModal', null, { folderName: "Basket/BuyInCreditModal" });
	
	            return _react3.default.createElement(View, (0, _extends3.default)({}, this.props, {
	                closeModal: this.closeModal,
	                creditUrl: config.creditUrl
	            }));
	        }
	    }]);
	    return BuyInCreditModal;
	}(_react2.Component), _class2.propTypes = {
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = BuyInCreditModal;
	module.exports = exports['default'];

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	__webpack_require__(1066);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    BuyInCreditModalView: {
	        displayName: 'BuyInCreditModalView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Basket/BuyInCreditModal/default/BuyInCreditModalView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var BuyInCreditModalView = _wrapComponent('BuyInCreditModalView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(BuyInCreditModalView, _Component);
	
	    function BuyInCreditModalView(props) {
	        (0, _classCallCheck3.default)(this, BuyInCreditModalView);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BuyInCreditModalView.__proto__ || (0, _getPrototypeOf2.default)(BuyInCreditModalView)).call(this, props));
	
	        _this.state = {
	            countForSendBasket: 1
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(BuyInCreditModalView, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var discountEpsilon = this.props.order_detail.discount_sum;
	            var discountPercent = this.props.order_detail.discount_sum / (this.props.order_detail.sum / 100);
	            return _react3.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react3.default.createElement(
	                    'form',
	                    { action: this.props.creditUrl, method: 'post' },
	                    _react3.default.createElement('input', { name: 'shopId', value: this.props.buy_in_credit.external_shop_id, type: 'hidden' }),
	                    _react3.default.createElement('input', { name: 'promoCode', value: this.props.buy_in_credit.promo_code === '' ? 'default' : this.props.buy_in_credit.promo_code, type: 'hidden' }),
	                    _react3.default.createElement('input', { name: 'sum', value: parseFloat(this.props.order_detail.sum - this.props.order_detail.discount_sum).toFixed(2), type: 'hidden' }),
	                    _react3.default.createElement('input', { name: 'orderNumber', value: this.props.order_detail.order_number, type: 'hidden' }),
	                    this.props.order_detail.products.map(function (item, index) {
	                        var modifierOptionName = '';
	                        var sale = parseFloat(item.base_price * (discountPercent / 100)).toFixed(2);
	                        var price = parseFloat(item.base_price - sale).toFixed(2);
	                        discountEpsilon = discountEpsilon - sale * item.quantity;
	                        if (item.modifier_option_name !== null) {
	                            modifierOptionName = item.modifier_option_name;
	                        }
	                        if (index === _this2.props.order_detail.products.length) {
	                            price = parseFloat(item.base_price - (sale + discountEpsilon / item.quantity)).toFixed(2);
	                        }
	                        return _react3.default.createElement(
	                            'div',
	                            { key: index },
	                            _react3.default.createElement('input', { name: 'itemName_' + index, value: item.name + modifierOptionName, type: 'hidden' }),
	                            _react3.default.createElement('input', { name: 'itemQuantity_' + index, value: item.quantity, type: 'hidden' }),
	                            _react3.default.createElement('input', { name: 'itemPrice_' + index, value: price, type: 'hidden' }),
	                            _react3.default.createElement('input', { name: 'itemVendorCode_' + index, value: item.id_yml, type: 'hidden' })
	                        );
	                    }),
	                    _react3.default.createElement('input', { name: 'customerNumber', value: this.props.user.id, type: 'hidden' }),
	                    _react3.default.createElement('input', { name: 'customerEmail', value: this.props.user.email, type: 'hidden' }),
	                    _react3.default.createElement('input', { name: 'customerPhone', value: this.props.user.phone, type: 'hidden' }),
	                    _react3.default.createElement('input', { type: 'submit', className: 'le-button big pay_order_button button_width_100', value: this.props.title })
	                )
	            );
	        }
	    }]);
	    return BuyInCreditModalView;
	}(_react2.Component), _class.propTypes = {
	    lang: _react2.PropTypes.object.isRequired,
	    currency: _react2.PropTypes.object.isRequired
	}, _temp));
	
	exports.default = BuyInCreditModalView;
	module.exports = exports['default'];

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BuyInCreditModal = undefined;
	
	var _BuyInCreditModal2 = __webpack_require__(1614);
	
	var _BuyInCreditModal3 = _interopRequireDefault(_BuyInCreditModal2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BuyInCreditModal = _BuyInCreditModal3.default;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp, _initialiseProps;
	
	var _reactRedux = __webpack_require__(12);
	
	var _wish_list = __webpack_require__(166);
	
	var _modal = __webpack_require__(26);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ModifierModal: {
	        displayName: 'ModifierModal'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Basket/ModifierModal/ModifierModal.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ModifierModal = _wrapComponent('ModifierModal')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang,
	        currency: state.currency
	    };
	}, { wishListUpdateProduct: _wish_list.wishListUpdateProduct, hide: _modal.hide }), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(ModifierModal, _Component);
	
	    function ModifierModal(props, context) {
	        (0, _classCallCheck3.default)(this, ModifierModal);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ModifierModal.__proto__ || (0, _getPrototypeOf2.default)(ModifierModal)).call(this, props, context));
	
	        _initialiseProps.call(_this);
	
	        var modValuesId0 = 'all';
	        var modValuesId1 = 'all';
	        var modValuesId2 = 'all';
	        var modValueDefault = null;
	        _this.props.product_detail.modifier_option_id = undefined;
	
	        if (_this.props.product_detail.modifiedOption !== undefined && _this.props.product_detail.type_id !== 5) {
	            if (_this.props.product_detail.price_backup === undefined) {
	                _this.props.product_detail.price_backup = _this.props.product_detail.price;
	            }
	            _this.props.product_detail.modifiedOption.forEach(function (item) {
	                if (item.is_default) {
	                    modValueDefault = item.id;
	                    _this.props.product_detail.modifier_option_id = item.id;
	                    _this.props.product_detail.modifier_option = item;
	                    _this.props.product_detail.modifierName = _this.props.product_detail.modifier_option.name;
	                    if (_this.props.product_detail.type_id === 5) {
	                        _this.props.product_detail.price = _this.props.product_detail.price_backup * 1 + _this.props.product_detail.modifier_option.price * 1;
	                    } else {
	                        _this.props.product_detail.price = _this.props.product_detail.modifier_option.price;
	                    }
	                    _this.props.product_detail.id_yml = _this.props.product_detail.modifier_option.id_yml;
	                }
	            });
	            if (modValueDefault) {
	                var modValueId = [];
	                _this.props.product_detail.valueOption.forEach(function (item) {
	                    if (item.option_id === modValueDefault) {
	                        modValueId.push(item.value_id);
	                    }
	                });
	                if (_this.props.product_detail.modifier[0] !== undefined) {
	                    var modValues0 = _this.props.product_detail.modifier[0].values.filter(function (value) {
	                        return modValueId.indexOf(value.id) !== -1;
	                    });
	                    if (modValues0.length === 1) {
	                        modValuesId0 = modValues0[0].id;
	                    }
	                }
	                if (_this.props.product_detail.modifier[1] !== undefined) {
	                    var modValues1 = _this.props.product_detail.modifier[1].values.filter(function (value) {
	                        return modValueId.indexOf(value.id) !== -1;
	                    });
	                    if (modValues1.length === 1) {
	                        modValuesId1 = modValues1[0].id;
	                    }
	                }
	                if (_this.props.product_detail.modifier[2] !== undefined) {
	                    var modValues2 = _this.props.product_detail.modifier[2].values.filter(function (value) {
	                        return modValueId.indexOf(value.id) !== -1;
	                    });
	                    if (modValues2.length === 1) {
	                        modValuesId2 = modValues2[0].id;
	                    }
	                }
	            }
	        }
	        if (_this.props.product_detail.type_id === 5) {
	            _this.listNested = [];
	            _this.props.product_detail.nestedOffers.forEach(function (nestedOffer) {
	                _this.getNestedOfferAllList(nestedOffer, 1);
	                if (nestedOffer.childOffer.type_id === 5) {
	                    if (nestedOffer.valuesMods === undefined || nestedOffer.valuesMods === null) {
	                        nestedOffer.valuesMods = ['all', 'all', 'all'];
	                        nestedOffer.modifierName = '';
	                        nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferChild) {
	                            if (nestedOfferChild.modifierOption !== null) {
	                                nestedOfferChild.childOffer.modifier_option_id = nestedOfferChild.modifierOption.id;
	                                nestedOfferChild.childOffer.modOption = nestedOfferChild.modifierOption;
	                                nestedOfferChild.childOffer.price = nestedOfferChild.modifierOption.price;
	                                nestedOfferChild.childOffer.modifierName = nestedOfferChild.modifierOption.name;
	                            }
	                        });
	                    }
	                } else {
	                    if (nestedOffer.modifierOption !== null) {
	                        nestedOffer.childOffer.modifier_option_id = nestedOffer.modifierOption.id;
	                        nestedOffer.childOffer.modOption = nestedOffer.modifierOption;
	                        nestedOffer.childOffer.price = nestedOffer.modifierOption.price;
	                        nestedOffer.childOffer.modifierName = nestedOffer.modifierOption.name;
	                    }
	                }
	            });
	            _this.props.product_detail.modifierName = '';
	            if (_this.props.product_detail.valuesMods === undefined || _this.props.product_detail.valuesMods === null) {
	                _this.props.product_detail.valuesMods = [modValuesId0, modValuesId1, modValuesId2];
	                _this.props.product_detail.modifierName = '';
	            } else {
	                modValuesId0 = _this.props.product_detail.valuesMods[0];
	                modValuesId1 = _this.props.product_detail.valuesMods[1];
	                modValuesId2 = _this.props.product_detail.valuesMods[2];
	            }
	            var currentValue = null;
	            if (modValuesId0 !== 'all') {
	                currentValue = null;
	                currentValue = _this.props.product_detail.modifier[0].values.filter(function (value) {
	                    return value.id == modValuesId0;
	                });
	                _this.props.product_detail.modifierName += _this.props.product_detail.modifier[0].name + ': ' + currentValue[0].name + ' ';
	            }
	            if (modValuesId1 !== 'all') {
	                _currentValue = null;
	                var _currentValue = _this.props.product_detail.modifier[1].values.filter(function (value) {
	                    return value.id == modValuesId1;
	                });
	                _this.props.product_detail.modifierName += _this.props.product_detail.modifier[1].name + ': ' + _currentValue[0].name + ' ';
	            }
	            if (modValuesId2 !== 'all') {
	                _currentValue2 = null;
	                var _currentValue2 = _this.props.product_detail.modifier[2].values.filter(function (value) {
	                    return value.id == modValuesId2;
	                });
	                _this.props.product_detail.modifierName += _this.props.product_detail.modifier[2].name + ': ' + _currentValue2[0].name + ' ';
	            }
	        }
	
	        _this.state = {
	            modValues0: _this.props.product_detail.modifier[0] !== undefined ? _this.props.product_detail.modifier[0].values : null,
	            modValues1: _this.props.product_detail.modifier[1] !== undefined ? _this.props.product_detail.modifier[1].values : null,
	            modValues2: _this.props.product_detail.modifier[2] !== undefined ? _this.props.product_detail.modifier[2].values : null,
	            modValuesId0: modValuesId0,
	            modValuesId1: modValuesId1,
	            modValuesId2: modValuesId2,
	            changeQuantity: 10,
	            changeChildMods: 10
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(ModifierModal, [{
	        key: 'getNestedOfferAllList',
	        value: function getNestedOfferAllList(nestedOffer, level) {
	            var _this2 = this;
	
	            var parentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	            nestedOffer.level = level;
	            nestedOffer.parentId = parentId;
	            this.listNested.push(nestedOffer);
	            if (nestedOffer.childOffer.type_id === 5) {
	                nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferChild) {
	                    _this2.getNestedOfferAllList(nestedOfferChild, level + 1, nestedOffer.id);
	                });
	            }
	        }
	    }, {
	        key: 'setModOptionIdActive',
	        value: function setModOptionIdActive(modOptionIdActive) {
	            var _this3 = this;
	
	            if (modOptionIdActive.length === 1) {
	                this.props.product_detail.modifier_option_id = modOptionIdActive[0];
	                this.setState({ modifier_option_id: modOptionIdActive[0] });
	                this.props.product_detail.modifier_option = this.props.product_detail.modifiedOption.filter(function (value) {
	                    return value.id === _this3.props.product_detail.modifier_option_id;
	                })[0];
	                this.props.product_detail.modifierName = this.props.product_detail.modifier_option.name;
	                if (this.props.product_detail.type_id === 5) {
	                    if (this.props.product_detail.price_backup === undefined) {
	                        this.props.product_detail.price_backup = this.props.product_detail.price;
	                    }
	                    this.props.product_detail.price = this.props.product_detail.price_backup * 1 + this.props.product_detail.modifier_option.price * 1;
	                } else {
	                    this.props.product_detail.price = this.props.product_detail.modifier_option.price;
	                }
	                this.props.product_detail.id_yml = this.props.product_detail.modifier_option.id_yml;
	            }
	        }
	    }, {
	        key: 'recalculatePriceForMods',
	        value: function recalculatePriceForMods() {
	            var _this4 = this;
	
	            if (this.props.product_detail.type_id === 5) {
	                if (this.props.product_detail.price_backup === undefined) {
	                    this.props.product_detail.price_backup = this.props.product_detail.price;
	                }
	                if (this.props.product_detail.price_backup_no_mod === undefined) {
	                    this.props.product_detail.price_backup_no_mod = this.props.product_detail.price;
	                }
	                this.props.product_detail.price = this.props.product_detail.price_backup_no_mod * 1;
	                var modValuesId0 = this.state.modValuesId0;
	                if (this.props.product_detail.modifier[0] !== undefined) {
	                    this.props.product_detail.modifier[0].values.forEach(function (item) {
	                        if (item.id == modValuesId0) {
	                            _this4.props.product_detail.price = _this4.props.product_detail.price + item.price;
	                        }
	                    });
	                }
	                var modValuesId1 = this.state.modValuesId1;
	                if (this.props.product_detail.modifier[1] !== undefined) {
	                    this.props.product_detail.modifier[1].values.forEach(function (item) {
	                        if (item.id == modValuesId1) {
	                            _this4.props.product_detail.price = _this4.props.product_detail.price + item.price;
	                        }
	                    });
	                }
	                var modValuesId2 = this.state.modValuesId2;
	                if (this.props.product_detail.modifier[2] !== undefined) {
	                    this.props.product_detail.modifier[2].values.forEach(function (item) {
	                        if (item.id == modValuesId2) {
	                            _this4.props.product_detail.price = _this4.props.product_detail.price + item.price;
	                        }
	                    });
	                }
	                this.props.product_detail.nestedOffers.forEach(function (nestedOffer) {
	                    if (nestedOffer.childOffer.type_id === 5) {
	                        if (nestedOffer.valuesMods === undefined) {
	                            nestedOffer.valuesMods = ['all', 'all', 'all'];
	                        }
	                        nestedOffer.modifierName = '';
	                        if (nestedOffer.childOffer.modifier[0] !== undefined && nestedOffer.valuesMods[0] !== null) {
	                            nestedOffer.childOffer.modifier[0].values.forEach(function (item) {
	                                if (item.id == nestedOffer.valuesMods[0]) {
	                                    _this4.props.product_detail.price = _this4.props.product_detail.price + item.price * nestedOffer.quantity;
	                                    nestedOffer.modifierName += nestedOffer.childOffer.modifier[0].name + ': ' + item.name + ' ';
	                                }
	                            });
	                        }
	                        if (nestedOffer.childOffer.modifier[1] !== undefined && nestedOffer.valuesMods[1] !== null) {
	                            nestedOffer.childOffer.modifier[1].values.forEach(function (item) {
	                                if (item.id == nestedOffer.valuesMods[1]) {
	                                    _this4.props.product_detail.price = _this4.props.product_detail.price + item.price * nestedOffer.quantity;
	                                    nestedOffer.modifierName += nestedOffer.childOffer.modifier[1].name + ': ' + item.name + ' ';
	                                }
	                            });
	                        }
	                        if (nestedOffer.childOffer.modifier[2] !== undefined && nestedOffer.valuesMods[2] !== null) {
	                            nestedOffer.childOffer.modifier[2].values.forEach(function (item) {
	                                if (item.id == nestedOffer.valuesMods[2]) {
	                                    _this4.props.product_detail.price = _this4.props.product_detail.price + item.price * nestedOffer.quantity;
	                                    nestedOffer.modifierName += nestedOffer.childOffer.modifier[2].name + ': ' + item.name + ' ';
	                                }
	                            });
	                        }
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'recalculatePrice',
	        value: function recalculatePrice(id, priceDiff) {
	            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'plus';
	
	            for (var key in this.listNested) {
	                if (this.listNested[key].id === id) {
	                    if (type === 'minus') {
	                        this.listNested[key].childOffer.price = this.listNested[key].childOffer.price * 1 - priceDiff * 1;
	                    } else {
	                        this.listNested[key].childOffer.price = this.listNested[key].childOffer.price * 1 + priceDiff * 1;
	                    }
	                    if (this.listNested[key].parentId) {
	                        this.recalculatePrice(this.listNested[key].parentId, priceDiff * this.listNested[key].quantity, type);
	                    } else {
	                        if (type === 'minus') {
	                            this.props.product_detail.price = this.props.product_detail.price * 1 - priceDiff * this.listNested[key].quantity;
	                        } else {
	                            this.props.product_detail.price = this.props.product_detail.price * 1 + priceDiff * this.listNested[key].quantity;
	                        }
	                    }
	                    break;
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('ModifierModal', null, { folderName: 'Basket/ModifierModal' });
	
	            return _react3.default.createElement(View, (0, _extends3.default)({}, this.props, {
	                modValues0: this.state.modValues0,
	                modValues1: this.state.modValues1,
	                modValues2: this.state.modValues2,
	                modValuesId: this.state.modValuesId,
	                handleSelect0: this.handleSelect0,
	                handleSelect1: this.handleSelect1,
	                handleSelect2: this.handleSelect2,
	                modValuesId0: this.state.modValuesId0,
	                modValuesId1: this.state.modValuesId1,
	                modValuesId2: this.state.modValuesId2,
	                closeModal: this.closeModal,
	                lang: this.props.lang,
	                currency: this.props.currency,
	                onClickPlusNested: this.onClickPlusNested,
	                onClickMinusNested: this.onClickMinusNested,
	                onClickPlusChildNested: this.onClickPlusChildNested,
	                onClickMinusChildNested: this.onClickMinusChildNested,
	                changeQuantity: this.state.changeQuantity,
	                handleSelectChildOffer: this.handleSelectChildOffer,
	                changeChildMods: this.state.changeChildMods,
	                listNested: this.listNested
	            }));
	        }
	    }]);
	    return ModifierModal;
	}(_react2.Component), _class2.propTypes = {
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _initialiseProps = function _initialiseProps() {
	    var _this5 = this;
	
	    this.closeModal = function () {
	        _this5.props.hide();
	    };
	
	    this.handleSelect0 = function (e) {
	        if (_this5.props.product_detail.type_id === 5) {
	            if (_this5.props.product_detail.price_backup === undefined) {
	                _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
	            }
	            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
	                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
	            }
	            _this5.props.product_detail.price = _this5.props.product_detail.price_backup_no_mod * 1;
	            var modValuesId0 = e.target.value;
	            _this5.setState({ modValuesId0: e.target.value });
	            if (_this5.props.product_detail.modifier[0] !== undefined) {
	                _this5.props.product_detail.modifier[0].values.forEach(function (item) {
	                    if (item.id == modValuesId0) {
	                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
	                    }
	                });
	            }
	            var modValuesId1 = _this5.state.modValuesId1;
	            if (_this5.props.product_detail.modifier[1] !== undefined) {
	                _this5.props.product_detail.modifier[1].values.forEach(function (item) {
	                    if (item.id == modValuesId1) {
	                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
	                    }
	                });
	            }
	            var modValuesId2 = _this5.state.modValuesId2;
	            if (_this5.props.product_detail.modifier[2] !== undefined) {
	                _this5.props.product_detail.modifier[2].values.forEach(function (item) {
	                    if (item.id == modValuesId2) {
	                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
	                    }
	                });
	            }
	            _this5.props.product_detail.modValuesId0 = modValuesId0;
	            _this5.props.product_detail.modValuesId1 = modValuesId1;
	            _this5.props.product_detail.modValuesId2 = modValuesId2;
	            _this5.props.product_detail.valuesMods = [modValuesId0, modValuesId1, modValuesId2];
	            _this5.props.product_detail.modifierName = '';
	            var currentValue = null;
	            if (modValuesId0 !== 'all') {
	                currentValue = null;
	                currentValue = _this5.props.product_detail.modifier[0].values.filter(function (value) {
	                    return value.id == modValuesId0;
	                });
	                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[0].name + ': ' + currentValue[0].name + ' ';
	            }
	            if (modValuesId1 !== 'all') {
	                currentValue = null;
	                currentValue = _this5.props.product_detail.modifier[1].values.filter(function (value) {
	                    return value.id == modValuesId1;
	                });
	                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[1].name + ': ' + currentValue[0].name + ' ';
	            }
	            if (modValuesId2 !== 'all') {
	                currentValue = null;
	                currentValue = _this5.props.product_detail.modifier[2].values.filter(function (value) {
	                    return value.id == modValuesId2;
	                });
	                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[2].name + ': ' + currentValue[0].name + ' ';
	            }
	            return true;
	        }
	        if (e.target.value == 'all') {
	            _this5.setState({ modValuesId0: e.target.value });
	            if (_this5.props.product_detail.modifier[1] !== undefined) {
	                _this5.setState({ modValues1: _this5.props.product_detail.modifier[1].values });
	            }
	            if (_this5.props.product_detail.modifier[2] !== undefined) {
	                _this5.setState({ modValues2: _this5.props.product_detail.modifier[2].values });
	            }
	            _this5.props.product_detail.modifier_option_id = undefined;
	        } else {
	            _this5.setState({ modValuesId0: e.target.value * 1 });
	            var modOptionId = [];
	            var filterModOptionId = [];
	            _this5.props.product_detail.valueOption.forEach(function (item) {
	                if (item.value_id === e.target.value * 1) {
	                    modOptionId.push(item.option_id);
	                }
	            });
	            var modOptionIdActive = [];
	            _this5.props.product_detail.modifiedOption.forEach(function (item) {
	                if (modOptionId.indexOf(item.id) !== -1) {
	                    if (item.enable === true) {
	                        modOptionIdActive.push(item.id);
	                    }
	                }
	            });
	            var modValueId = [];
	            _this5.props.product_detail.valueOption.forEach(function (item) {
	                if (modOptionIdActive.indexOf(item.option_id) !== -1) {
	                    modValueId.push(item.value_id);
	                }
	            });
	            var _modValuesId = _this5.state.modValuesId1;
	            if (_this5.props.product_detail.modifier[1] !== undefined) {
	                var modValues1 = _this5.props.product_detail.modifier[1].values.filter(function (value) {
	                    return modValueId.indexOf(value.id) !== -1;
	                });
	                _this5.setState({ modValues1: modValues1 });
	                if (modValues1.length === 1) {
	                    _modValuesId = modValues1[0].id;
	                    _this5.setState({ modValuesId1: modValues1[0].id });
	                }
	            }
	            var _modValuesId2 = _this5.state.modValuesId2;
	            if (_this5.props.product_detail.modifier[2] !== undefined) {
	                var modValues2 = _this5.props.product_detail.modifier[2].values.filter(function (value) {
	                    return modValueId.indexOf(value.id) !== -1;
	                });
	                _this5.setState({ modValues2: modValues2 });
	                if (modValues2.length === 1) {
	                    _modValuesId2 = modValues2[0].id;
	                    _this5.setState({ modValuesId2: modValues2[0].id });
	                }
	            }
	            if (_modValuesId !== 'all') {
	                filterModOptionId = modOptionId;
	                modOptionId = [];
	                _this5.props.product_detail.valueOption.forEach(function (item) {
	                    if (item.value_id === _modValuesId && filterModOptionId.indexOf(item.option_id) !== -1) {
	                        modOptionId.push(item.option_id);
	                    }
	                });
	            }
	            if (_modValuesId2 !== 'all') {
	                filterModOptionId = modOptionId;
	                modOptionId = [];
	                _this5.props.product_detail.valueOption.forEach(function (item) {
	                    if (item.value_id === _modValuesId2 && filterModOptionId.indexOf(item.option_id) !== -1) {
	                        modOptionId.push(item.option_id);
	                    }
	                });
	            }
	            modOptionIdActive = [];
	            _this5.props.product_detail.modifiedOption.forEach(function (item) {
	                if (modOptionId.indexOf(item.id) !== -1) {
	                    if (item.enable === true) {
	                        modOptionIdActive.push(item.id);
	                    }
	                }
	            });
	            _this5.setModOptionIdActive(modOptionIdActive);
	        }
	        _this5.props.wishListUpdateProduct();
	    };
	
	    this.handleSelect1 = function (e) {
	        if (_this5.props.product_detail.type_id === 5) {
	            if (_this5.props.product_detail.price_backup === undefined) {
	                _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
	            }
	            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
	                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
	            }
	            _this5.props.product_detail.price = _this5.props.product_detail.price_backup_no_mod * 1;
	            var modValuesId0 = _this5.state.modValuesId0;
	            if (_this5.props.product_detail.modifier[0] !== undefined) {
	                _this5.props.product_detail.modifier[0].values.forEach(function (item) {
	                    if (item.id == modValuesId0) {
	                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
	                    }
	                });
	            }
	            var modValuesId1 = e.target.value;
	            _this5.setState({ modValuesId1: e.target.value });
	            if (_this5.props.product_detail.modifier[1] !== undefined) {
	                _this5.props.product_detail.modifier[1].values.forEach(function (item) {
	                    if (item.id == modValuesId1) {
	                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
	                    }
	                });
	            }
	            var modValuesId2 = _this5.state.modValuesId2;
	            if (_this5.props.product_detail.modifier[2] !== undefined) {
	                _this5.props.product_detail.modifier[2].values.forEach(function (item) {
	                    if (item.id == modValuesId2) {
	                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
	                    }
	                });
	            }
	            _this5.props.product_detail.modValuesId0 = modValuesId0;
	            _this5.props.product_detail.modValuesId1 = modValuesId1;
	            _this5.props.product_detail.modValuesId2 = modValuesId2;
	            _this5.props.product_detail.valuesMods = [modValuesId0, modValuesId1, modValuesId2];
	            _this5.props.product_detail.modifierName = '';
	            var currentValue = null;
	            if (modValuesId0 !== 'all') {
	                currentValue = null;
	                currentValue = _this5.props.product_detail.modifier[0].values.filter(function (value) {
	                    return value.id == modValuesId0;
	                });
	                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[0].name + ': ' + currentValue[0].name + ' ';
	            }
	            if (modValuesId1 !== 'all') {
	                currentValue = null;
	                currentValue = _this5.props.product_detail.modifier[1].values.filter(function (value) {
	                    return value.id == modValuesId1;
	                });
	                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[1].name + ': ' + currentValue[0].name + ' ';
	            }
	            if (modValuesId2 !== 'all') {
	                currentValue = null;
	                currentValue = _this5.props.product_detail.modifier[2].values.filter(function (value) {
	                    return value.id == modValuesId2;
	                });
	                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[2].name + ': ' + currentValue[0].name + ' ';
	            }
	            return true;
	        }
	        if (e.target.value == 'all') {
	            _this5.setState({ modValuesId1: e.target.value });
	            if (_this5.props.product_detail.modifier[0] !== undefined) {
	                _this5.setState({ modValues0: _this5.props.product_detail.modifier[0].values });
	            }
	            if (_this5.props.product_detail.modifier[2] !== undefined) {
	                _this5.setState({ modValues2: _this5.props.product_detail.modifier[2].values });
	            }
	            _this5.props.product_detail.modifier_option_id = undefined;
	        } else {
	            _this5.setState({ modValuesId1: e.target.value * 1 });
	            var modOptionId = [];
	            var filterModOptionId = [];
	            _this5.props.product_detail.valueOption.forEach(function (item) {
	                if (item.value_id === e.target.value * 1) {
	                    modOptionId.push(item.option_id);
	                }
	            });
	            var modOptionIdActive = [];
	            _this5.props.product_detail.modifiedOption.forEach(function (item) {
	                if (modOptionId.indexOf(item.id) !== -1) {
	                    if (item.enable === true) {
	                        modOptionIdActive.push(item.id);
	                    }
	                }
	            });
	            var modValueId = [];
	            _this5.props.product_detail.valueOption.forEach(function (item) {
	                if (modOptionIdActive.indexOf(item.option_id) !== -1) {
	                    modValueId.push(item.value_id);
	                }
	            });
	            var _modValuesId3 = _this5.state.modValuesId0;
	            if (_this5.props.product_detail.modifier[0] !== undefined) {
	                var modValues0 = _this5.props.product_detail.modifier[0].values.filter(function (value) {
	                    return modValueId.indexOf(value.id) !== -1;
	                });
	                _this5.setState({ modValues0: modValues0 });
	                if (modValues0.length === 1) {
	                    _modValuesId3 = modValues0[0].id;
	                    _this5.setState({ modValuesId0: modValues0[0].id });
	                }
	            }
	            var _modValuesId4 = _this5.state.modValuesId2;
	            if (_this5.props.product_detail.modifier[2] !== undefined) {
	                var modValues2 = _this5.props.product_detail.modifier[2].values.filter(function (value) {
	                    return modValueId.indexOf(value.id) !== -1;
	                });
	                _this5.setState({ modValues2: modValues2 });
	                if (modValues2.length === 1) {
	                    _modValuesId4 = modValues2[0].id;
	                    _this5.setState({ modValuesId2: modValues2[0].id });
	                }
	            }
	            if (_modValuesId3 !== 'all') {
	                filterModOptionId = modOptionId;
	                modOptionId = [];
	                _this5.props.product_detail.valueOption.forEach(function (item) {
	                    if (item.value_id === _modValuesId3 && filterModOptionId.indexOf(item.option_id) !== -1) {
	                        modOptionId.push(item.option_id);
	                    }
	                });
	            }
	            if (_modValuesId4 !== 'all') {
	                filterModOptionId = modOptionId;
	                modOptionId = [];
	                _this5.props.product_detail.valueOption.forEach(function (item) {
	                    if (item.value_id === _modValuesId4 && filterModOptionId.indexOf(item.option_id) !== -1) {
	                        modOptionId.push(item.option_id);
	                    }
	                });
	            }
	            modOptionIdActive = [];
	            _this5.props.product_detail.modifiedOption.forEach(function (item) {
	                if (modOptionId.indexOf(item.id) !== -1) {
	                    if (item.enable === true) {
	                        modOptionIdActive.push(item.id);
	                    }
	                }
	            });
	            _this5.setModOptionIdActive(modOptionIdActive);
	        }
	        _this5.props.wishListUpdateProduct();
	    };
	
	    this.handleSelect2 = function (e) {
	        if (_this5.props.product_detail.type_id === 5) {
	            if (_this5.props.product_detail.price_backup === undefined) {
	                _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
	            }
	            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
	                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
	            }
	            _this5.props.product_detail.price = _this5.props.product_detail.price_backup_no_mod * 1;
	            var modValuesId0 = _this5.state.modValuesId0;
	            if (_this5.props.product_detail.modifier[0] !== undefined) {
	                _this5.props.product_detail.modifier[0].values.forEach(function (item) {
	                    if (item.id == modValuesId0) {
	                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
	                    }
	                });
	            }
	            var modValuesId1 = _this5.state.modValuesId1;
	            if (_this5.props.product_detail.modifier[1] !== undefined) {
	                _this5.props.product_detail.modifier[1].values.forEach(function (item) {
	                    if (item.id == modValuesId1) {
	                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
	                    }
	                });
	            }
	
	            var modValuesId2 = e.target.value;
	            _this5.setState({ modValuesId2: e.target.value });
	            if (_this5.props.product_detail.modifier[2] !== undefined) {
	                _this5.props.product_detail.modifier[2].values.forEach(function (item) {
	                    if (item.id == modValuesId2) {
	                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
	                    }
	                });
	            }
	            _this5.props.product_detail.modValuesId0 = modValuesId0;
	            _this5.props.product_detail.modValuesId1 = modValuesId1;
	            _this5.props.product_detail.modValuesId2 = modValuesId2;
	            _this5.props.product_detail.valuesMods = [modValuesId0, modValuesId1, modValuesId2];
	            _this5.props.product_detail.modifierName = '';
	            var currentValue = null;
	            if (modValuesId0 !== 'all') {
	                currentValue = null;
	                currentValue = _this5.props.product_detail.modifier[0].values.filter(function (value) {
	                    return value.id == modValuesId0;
	                });
	                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[0].name + ': ' + currentValue[0].name + ' ';
	            }
	            if (modValuesId1 !== 'all') {
	                currentValue = null;
	                currentValue = _this5.props.product_detail.modifier[1].values.filter(function (value) {
	                    return value.id == modValuesId1;
	                });
	                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[1].name + ': ' + currentValue[0].name + ' ';
	            }
	            if (modValuesId2 !== 'all') {
	                currentValue = null;
	                currentValue = _this5.props.product_detail.modifier[2].values.filter(function (value) {
	                    return value.id == modValuesId2;
	                });
	                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[2].name + ': ' + currentValue[0].name + ' ';
	            }
	            return true;
	        }
	        if (e.target.value == 'all') {
	            _this5.setState({ modValuesId2: e.target.value });
	            if (_this5.props.product_detail.modifier[0] !== undefined) {
	                _this5.setState({ modValues0: _this5.props.product_detail.modifier[0].values });
	            }
	            if (_this5.props.product_detail.modifier[1] !== undefined) {
	                _this5.setState({ modValues1: _this5.props.product_detail.modifier[1].values });
	            }
	            _this5.props.product_detail.modifier_option_id = undefined;
	        } else {
	            _this5.setState({ modValuesId2: e.target.value * 1 });
	            var modOptionId = [];
	            var filterModOptionId = [];
	            _this5.props.product_detail.valueOption.forEach(function (item) {
	                if (item.value_id === e.target.value * 1) {
	                    modOptionId.push(item.option_id);
	                }
	            });
	            var modOptionIdActive = [];
	            _this5.props.product_detail.modifiedOption.forEach(function (item) {
	                if (modOptionId.indexOf(item.id) !== -1) {
	                    if (item.enable === true) {
	                        modOptionIdActive.push(item.id);
	                    }
	                }
	            });
	            var modValueId = [];
	            _this5.props.product_detail.valueOption.forEach(function (item) {
	                if (modOptionIdActive.indexOf(item.option_id) !== -1) {
	                    modValueId.push(item.value_id);
	                }
	            });
	            var _modValuesId5 = _this5.state.modValuesId0;
	            if (_this5.props.product_detail.modifier[0] !== undefined) {
	                var modValues0 = _this5.props.product_detail.modifier[0].values.filter(function (value) {
	                    return modValueId.indexOf(value.id) !== -1;
	                });
	                _this5.setState({ modValues0: modValues0 });
	                if (modValues0.length === 1) {
	                    _modValuesId5 = modValues0[0].id;
	                    _this5.setState({ modValuesId0: modValues0[0].id });
	                }
	            }
	            var _modValuesId6 = _this5.state.modValuesId1;
	            if (_this5.props.product_detail.modifier[1] !== undefined) {
	                var modValues1 = _this5.props.product_detail.modifier[1].values.filter(function (value) {
	                    return modValueId.indexOf(value.id) !== -1;
	                });
	                _this5.setState({ modValues1: modValues1 });
	                if (modValues1.length === 1) {
	                    _modValuesId6 = modValues1[0].id;
	                    _this5.setState({ modValuesId1: modValues1[0].id });
	                }
	            }
	            if (_modValuesId5 !== 'all') {
	                filterModOptionId = modOptionId;
	                modOptionId = [];
	                _this5.props.product_detail.valueOption.forEach(function (item) {
	                    if (item.value_id === _modValuesId5 && filterModOptionId.indexOf(item.option_id) !== -1) {
	                        modOptionId.push(item.option_id);
	                    }
	                });
	            }
	            if (_modValuesId6 !== 'all') {
	                filterModOptionId = modOptionId;
	                modOptionId = [];
	                _this5.props.product_detail.valueOption.forEach(function (item) {
	                    if (item.value_id === _modValuesId6 && filterModOptionId.indexOf(item.option_id) !== -1) {
	                        modOptionId.push(item.option_id);
	                    }
	                });
	            }
	            modOptionIdActive = [];
	            _this5.props.product_detail.modifiedOption.forEach(function (item) {
	                if (modOptionId.indexOf(item.id) !== -1) {
	                    if (item.enable === true) {
	                        modOptionIdActive.push(item.id);
	                    }
	                }
	            });
	            _this5.setModOptionIdActive(modOptionIdActive);
	        }
	        _this5.props.wishListUpdateProduct();
	    };
	
	    this.handleSelectChildOffer = function (e, mod_id, child_offer_id) {
	        if (_this5.props.product_detail.type_id === 5) {
	            if (_this5.props.product_detail.price_backup === undefined) {
	                _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
	            }
	            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
	                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
	            }
	            _this5.props.product_detail.price = _this5.props.product_detail.price_backup_no_mod * 1;
	            var modValuesId0 = _this5.state.modValuesId0;
	            if (_this5.props.product_detail.modifier[0] !== undefined) {
	                _this5.props.product_detail.modifier[0].values.forEach(function (item) {
	                    if (item.id == modValuesId0) {
	                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
	                    }
	                });
	            }
	            var modValuesId1 = _this5.state.modValuesId1;
	            if (_this5.props.product_detail.modifier[1] !== undefined) {
	                _this5.props.product_detail.modifier[1].values.forEach(function (item) {
	                    if (item.id == modValuesId1) {
	                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
	                    }
	                });
	            }
	            var modValuesId2 = _this5.state.modValuesId2;
	            if (_this5.props.product_detail.modifier[2] !== undefined) {
	                _this5.props.product_detail.modifier[2].values.forEach(function (item) {
	                    if (item.id == modValuesId2) {
	                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
	                    }
	                });
	            }
	            _this5.props.product_detail.nestedOffers.forEach(function (nestedOffer) {
	                if (nestedOffer.id === child_offer_id && nestedOffer.childOffer.type_id === 5) {
	                    if (nestedOffer.valuesMods === undefined) {
	                        nestedOffer.valuesMods = ['all', 'all', 'all'];
	                    }
	                    nestedOffer.modifierName = '';
	                    nestedOffer.valuesMods[mod_id] = e.target.value;
	                    if (nestedOffer.childOffer.modifier[0] !== undefined && nestedOffer.valuesMods[0] !== null) {
	                        nestedOffer.childOffer.modifier[0].values.forEach(function (item) {
	                            if (item.id == nestedOffer.valuesMods[0]) {
	                                _this5.props.product_detail.price = _this5.props.product_detail.price + item.price * nestedOffer.quantity;
	                                nestedOffer.modifierName += nestedOffer.childOffer.modifier[0].name + ': ' + item.name + ' ';
	                            }
	                        });
	                    }
	                    if (nestedOffer.childOffer.modifier[1] !== undefined && nestedOffer.valuesMods[1] !== null) {
	                        nestedOffer.childOffer.modifier[1].values.forEach(function (item) {
	                            if (item.id == nestedOffer.valuesMods[1]) {
	                                _this5.props.product_detail.price = _this5.props.product_detail.price + item.price * nestedOffer.quantity;
	                                nestedOffer.modifierName += nestedOffer.childOffer.modifier[1].name + ': ' + item.name + ' ';
	                            }
	                        });
	                    }
	                    if (nestedOffer.childOffer.modifier[2] !== undefined && nestedOffer.valuesMods[2] !== null) {
	                        nestedOffer.childOffer.modifier[2].values.forEach(function (item) {
	                            if (item.id == nestedOffer.valuesMods[2]) {
	                                _this5.props.product_detail.price = _this5.props.product_detail.price + item.price * nestedOffer.quantity;
	                                nestedOffer.modifierName += nestedOffer.childOffer.modifier[2].name + ': ' + item.name + ' ';
	                            }
	                        });
	                    }
	                    var changeChildMods = _this5.state.changeChildMods;
	                    changeChildMods++;
	                    _this5.setState({ changeChildMods: changeChildMods });
	                    return true;
	                }
	            });
	        }
	    };
	
	    this.onClickMinusNested = function (event, id) {
	        event.preventDefault();
	        if (_this5.props.product_detail.type_id === 5) {
	            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
	                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
	            }
	            for (var key in _this5.listNested) {
	                var nestedOffer = _this5.listNested[key];
	                if (nestedOffer.id === id && nestedOffer.quantity > 0) {
	                    var MIN_COUNT_OF_NESTED_OFFER = nestedOffer.hasOwnProperty('quantity_min') ? nestedOffer.quantity_min : 0;
	                    nestedOffer.stepQuantity = nestedOffer.ratio;
	                    if (!nestedOffer.stepQuantity || nestedOffer.stepQuantity === 0) {
	                        nestedOffer.stepQuantity = 1;
	                    }
	                    if (nestedOffer.quantity - nestedOffer.stepQuantity >= MIN_COUNT_OF_NESTED_OFFER) {
	                        nestedOffer.quantity = nestedOffer.quantity - nestedOffer.stepQuantity;
	                        if (nestedOffer.quantity < 0) {
	                            nestedOffer.quantity = 0;
	                        }
	                        if (nestedOffer.childOffer.unit.slug === 'kg' || nestedOffer.childOffer.unit.slug === 'mg') {
	                            nestedOffer.quantity = parseFloat(nestedOffer.quantity.toFixed(3));
	                        } else {
	                            nestedOffer.quantity = parseFloat(nestedOffer.quantity.toFixed(2));
	                        }
	                        _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
	                        if (nestedOffer.parentId) {
	                            _this5.recalculatePrice(nestedOffer.parentId, nestedOffer.childOffer.price * nestedOffer.stepQuantity, 'minus');
	                        } else {
	                            _this5.props.product_detail.price = _this5.props.product_detail.price * 1 - nestedOffer.childOffer.price * nestedOffer.stepQuantity;
	                        }
	                    }
	                    break;
	                }
	            }
	            var changeQuantity = _this5.state.changeQuantity;
	            changeQuantity++;
	            _this5.setState({ changeQuantity: changeQuantity });
	        }
	    };
	
	    this.onClickPlusNested = function (event, id) {
	        event.preventDefault();
	        if (_this5.props.product_detail.type_id === 5) {
	            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
	                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
	            }
	
	            for (var key in _this5.listNested) {
	                var nestedOffer = _this5.listNested[key];
	                if (nestedOffer.id === id) {
	                    var MAX_COUNT_OF_NESTED_OFFER = nestedOffer.quantity_max === null ? 999999999999999999 : nestedOffer.quantity_max;
	                    nestedOffer.stepQuantity = nestedOffer.ratio;
	                    if (!nestedOffer.stepQuantity || nestedOffer.stepQuantity === 0) {
	                        nestedOffer.stepQuantity = 1;
	                    }
	                    if (nestedOffer.quantity * 1 + nestedOffer.stepQuantity * 1 <= MAX_COUNT_OF_NESTED_OFFER) {
	                        nestedOffer.quantity = nestedOffer.quantity * 1 + nestedOffer.stepQuantity * 1;
	                        if (nestedOffer.childOffer.unit.slug === 'kg' || nestedOffer.childOffer.unit.slug === 'mg') {
	                            nestedOffer.quantity = parseFloat(nestedOffer.quantity.toFixed(3));
	                        } else {
	                            nestedOffer.quantity = parseFloat(nestedOffer.quantity.toFixed(2));
	                        }
	                        _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
	                        if (nestedOffer.parentId) {
	                            _this5.recalculatePrice(nestedOffer.parentId, nestedOffer.childOffer.price * nestedOffer.stepQuantity, 'plus');
	                        } else {
	                            _this5.props.product_detail.price = _this5.props.product_detail.price * 1 + nestedOffer.childOffer.price * nestedOffer.stepQuantity;
	                        }
	                    }
	                    break;
	                }
	            }
	            var changeQuantity = _this5.state.changeQuantity;
	            changeQuantity++;
	            _this5.setState({ changeQuantity: changeQuantity });
	        }
	    };
	
	    this.onClickMinusChildNested = function (event, id, child_id) {
	        event.preventDefault();
	        if (_this5.props.product_detail.type_id === 5) {
	            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
	                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
	            }
	            _this5.props.product_detail.nestedOffers.forEach(function (nestedOffer) {
	                if (nestedOffer.id === id && nestedOffer.childOffer.type_id === 5) {
	                    _this5.props.product_detail.price = _this5.props.product_detail.price * 1 - nestedOffer.childOffer.price * nestedOffer.quantity;
	                    _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price_backup_no_mod * 1 - nestedOffer.childOffer.price * nestedOffer.quantity;
	                    nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferChild) {
	                        if (nestedOfferChild.id === child_id && nestedOfferChild.quantity > 0) {
	                            var MIN_COUNT_OF_NESTED_OFFER = nestedOfferChild.hasOwnProperty('quantity_min') ? nestedOfferChild.quantity_min : 0;
	                            nestedOfferChild.stepQuantity = nestedOfferChild.ratio;
	                            if (!nestedOfferChild.stepQuantity || nestedOfferChild.stepQuantity === 0) {
	                                nestedOfferChild.stepQuantity = 1;
	                            }
	                            if (nestedOfferChild.quantity - nestedOfferChild.stepQuantity >= MIN_COUNT_OF_NESTED_OFFER) {
	                                nestedOfferChild.quantity = nestedOfferChild.quantity - nestedOfferChild.stepQuantity;
	                                if (nestedOfferChild.quantity < 0) {
	                                    nestedOfferChild.quantity = 0;
	                                }
	                                if (nestedOfferChild.childOffer.unit.slug === 'kg' || nestedOfferChild.childOffer.unit.slug === 'mg') {
	                                    nestedOfferChild.quantity = parseFloat(nestedOfferChild.quantity.toFixed(3));
	                                } else {
	                                    nestedOfferChild.quantity = parseFloat(nestedOfferChild.quantity.toFixed(2));
	                                }
	                                nestedOffer.childOffer.price = nestedOffer.childOffer.price - nestedOfferChild.childOffer.price * nestedOfferChild.stepQuantity;
	                            }
	                        }
	                    });
	                    _this5.props.product_detail.price = _this5.props.product_detail.price * 1 + nestedOffer.childOffer.price * nestedOffer.quantity;
	                    _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price_backup_no_mod * 1 + nestedOffer.childOffer.price * nestedOffer.quantity;
	                    _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
	                }
	            });
	            _this5.recalculatePriceForMods();
	            var changeQuantity = _this5.state.changeQuantity;
	            changeQuantity++;
	            _this5.setState({ changeQuantity: changeQuantity });
	        }
	    };
	
	    this.onClickPlusChildNested = function (event, id, child_id) {
	        event.preventDefault();
	        if (_this5.props.product_detail.type_id === 5) {
	            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
	                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
	            }
	            _this5.props.product_detail.nestedOffers.forEach(function (nestedOffer) {
	                if (nestedOffer.id === id && nestedOffer.childOffer.type_id === 5) {
	                    _this5.props.product_detail.price = _this5.props.product_detail.price - nestedOffer.childOffer.price * nestedOffer.quantity;
	                    _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price_backup_no_mod - nestedOffer.childOffer.price * nestedOffer.quantity;
	                    nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferChild) {
	                        if (nestedOfferChild.id === child_id) {
	                            var MAX_COUNT_OF_NESTED_CHILD_OFFER = nestedOfferChild.quantity_max === null ? 999999999999999999 : nestedOfferChild.quantity_max;
	                            nestedOfferChild.stepQuantity = nestedOfferChild.ratio;
	                            if (!nestedOfferChild.stepQuantity || nestedOfferChild.stepQuantity === 0) {
	                                nestedOfferChild.stepQuantity = 1;
	                            }
	                            if (nestedOfferChild.quantity * 1 + nestedOfferChild.stepQuantity * 1 <= MAX_COUNT_OF_NESTED_CHILD_OFFER) {
	                                nestedOfferChild.quantity = nestedOfferChild.quantity + nestedOfferChild.stepQuantity;
	                                if (nestedOfferChild.childOffer.unit.slug === 'kg' || nestedOfferChild.childOffer.unit.slug === 'mg') {
	                                    nestedOfferChild.quantity = parseFloat(nestedOfferChild.quantity.toFixed(3));
	                                } else {
	                                    nestedOfferChild.quantity = parseFloat(nestedOfferChild.quantity.toFixed(2));
	                                }
	                                nestedOffer.childOffer.price = nestedOffer.childOffer.price * 1 + nestedOfferChild.childOffer.price * nestedOfferChild.stepQuantity;
	                            }
	                        }
	                    });
	                    _this5.props.product_detail.price = _this5.props.product_detail.price * 1 + nestedOffer.childOffer.price * nestedOffer.quantity;
	                    _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price_backup_no_mod * 1 + nestedOffer.childOffer.price * nestedOffer.quantity;
	                    _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
	                }
	            });
	            _this5.recalculatePriceForMods();
	            var changeQuantity = _this5.state.changeQuantity;
	            changeQuantity++;
	            _this5.setState({ changeQuantity: changeQuantity });
	        }
	    };
	}, _temp)) || _class));
	
	exports.default = ModifierModal;
	module.exports = exports['default'];

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1067);
	
	var _reactRedux = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ModifierModalView: {
	        displayName: 'ModifierModalView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Basket/ModifierModal/default/ModifierModalView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ModifierModalView = _wrapComponent('ModifierModalView')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        translations: state.lang
	    };
	}, {}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(ModifierModalView, _Component);
	
	    function ModifierModalView(props) {
	        (0, _classCallCheck3.default)(this, ModifierModalView);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ModifierModalView.__proto__ || (0, _getPrototypeOf2.default)(ModifierModalView)).call(this, props));
	
	        _this.renderModSelect = function () {
	            return _react3.default.createElement(
	                'div',
	                { className: 'no-margin col-xs-12 col-sn-12 col-md-12' },
	                _this.props.product_detail.modifier[0] !== undefined ? _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
	                    _this.props.product_detail.modifier[0].name,
	                    _react3.default.createElement(
	                        'select',
	                        { className: 'form-control', onChange: _this.props.handleSelect0,
	                            value: _this.props.modValuesId0 },
	                        _react3.default.createElement(
	                            'option',
	                            { value: 'all' },
	                            _this.props.lang['store.common.choose']
	                        ),
	                        _this.props.modValues0.map(function (item, i) {
	                            return _react3.default.createElement(
	                                'option',
	                                { key: item.id, value: item.id },
	                                '' + item.name
	                            );
	                        })
	                    )
	                ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' }),
	                _this.props.product_detail.modifier[1] !== undefined ? _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
	                    _this.props.product_detail.modifier[1].name,
	                    _react3.default.createElement(
	                        'select',
	                        { className: 'form-control', onChange: _this.props.handleSelect1,
	                            value: _this.props.modValuesId1 },
	                        _react3.default.createElement(
	                            'option',
	                            { value: 'all' },
	                            _this.props.lang['store.common.choose']
	                        ),
	                        _this.props.modValues1.map(function (item, i) {
	                            return _react3.default.createElement(
	                                'option',
	                                { key: item.id, value: item.id },
	                                '' + item.name
	                            );
	                        })
	                    )
	                ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' }),
	                _this.props.product_detail.modifier[2] !== undefined ? _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
	                    _this.props.product_detail.modifier[2].name,
	                    _react3.default.createElement(
	                        'select',
	                        { className: 'form-control', onChange: _this.props.handleSelect2,
	                            value: _this.props.modValuesId2 },
	                        _react3.default.createElement(
	                            'option',
	                            { value: 'all' },
	                            _this.props.lang['store.common.choose']
	                        ),
	                        _this.props.modValues2.map(function (item, i) {
	                            return _react3.default.createElement(
	                                'option',
	                                { key: item.id, value: item.id },
	                                '' + item.name
	                            );
	                        })
	                    )
	                ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' })
	            );
	        };
	
	        _this.renderNestedOffers = function () {
	            var weight = 0;
	            var childWeight = 0;
	            return _react3.default.createElement(
	                'div',
	                { className: 'no-margin col-xs-12 col-sn-12 col-md-12', style: { paddingTop: '10px' } },
	                _react3.default.createElement(
	                    'table',
	                    { style: { width: '100%' } },
	                    _react3.default.createElement(
	                        'tbody',
	                        null,
	                        _react3.default.createElement(
	                            'tr',
	                            { style: { background: '#E0E0E0' } },
	                            _react3.default.createElement(
	                                'th',
	                                { style: { width: '5%', padding: '5px' } },
	                                '#'
	                            ),
	                            _react3.default.createElement(
	                                'th',
	                                { style: { width: '70%', padding: '5px' } },
	                                _this.props.lang['store.short_description.component_title']
	                            ),
	                            _react3.default.createElement(
	                                'th',
	                                { style: { width: '15%', padding: '5px', textAlign: 'center' } },
	                                _this.props.lang['store.short_description.quantity']
	                            ),
	                            _react3.default.createElement('th', { style: { width: '10%' } })
	                        ),
	                        _this.props.product_detail.nestedOffers.map(function (item, index) {
	                            weight = item.quantity;
	                            if ((item.childOffer.unit.slug === 'kg' || item.childOffer.unit.slug === 'mg') && item.weight && item.weight > 0 && item.quantity > 0) {
	                                weight = item.weight * item.quantity;
	                                weight = weight.toFixed(3);
	                                if (item.weight < 0.01 && item.quantity < 1 || item.weight < 1 && item.quantity < 0.01) {
	                                    weight = item.weight * 1;
	                                }
	                                if (item.weight < 0.1 && item.quantity < 0.1) {
	                                    weight = item.weight * 1;
	                                }
	                            }
	                            // проверяем наличие свойств и то, что они больше нуля - если нет, меняем значение.
	                            var maxValue = item.hasOwnProperty('quantity_max') && item.quantity_max > 0 ? +item.quantity_max : ModifierModalView.MaxValue;
	                            var minValue = item.hasOwnProperty('quantity_min') && item.quantity_min > 0 ? +item.quantity_min : 0;
	                            // определяем шаг изменения
	                            var step = item.stepQuantity ? item.stepQuantity : 1;
	                            var classPlus = item.quantity + step > maxValue ? 'plus _disabled' : 'plus';
	                            var classMinus = item.quantity - step < minValue ? 'minus _disabled' : 'minus';
	                            if (item.quantity > 0 && item.is_quantity_change !== true && item.childOffer.type_id !== 5) {
	                                return _react3.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react3.default.createElement(
	                                        'td',
	                                        { style: { width: '5%', padding: '5px' } },
	                                        _react3.default.createElement(
	                                            'b',
	                                            null,
	                                            index + 1
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'td',
	                                        { style: { width: '70%', padding: '5px' } },
	                                        _react3.default.createElement(
	                                            'b',
	                                            null,
	                                            item.childOffer.name,
	                                            ' ',
	                                            item.childOffer.modOption ? '(' + item.childOffer.modOption.name + ')' : ''
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'td',
	                                        { colSpan: 2, style: {
	                                                width: '25%',
	                                                padding: '5px',
	                                                textAlign: 'center'
	                                            } },
	                                        _react3.default.createElement(
	                                            'b',
	                                            null,
	                                            weight,
	                                            ' ',
	                                            _this.props.translations[item.childOffer.unit.title_lang_data]
	                                        )
	                                    )
	                                );
	                            } else if (item.is_quantity_change && item.childOffer.type_id !== 5) {
	                                return _react3.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react3.default.createElement(
	                                        'td',
	                                        { style: { width: '5%', padding: '5px' } },
	                                        _react3.default.createElement(
	                                            'b',
	                                            null,
	                                            index + 1
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'td',
	                                        { style: { width: '70%', padding: '5px' } },
	                                        _react3.default.createElement(
	                                            'b',
	                                            null,
	                                            item.childOffer.name,
	                                            ' ',
	                                            item.childOffer.modOption ? '(' + item.childOffer.modOption.name + ')' : ''
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'td',
	                                        { style: {
	                                                width: '15%',
	                                                padding: '5px',
	                                                textAlign: 'center'
	                                            } },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { style: { transform: 'scale(0.9 , 0.9)' }, className: 'le-quantity inline' },
	                                            _react3.default.createElement('a', { className: classMinus, onClick: function onClick(e) {
	                                                    _this.props.onClickMinusNested(e, item.id);
	                                                } }),
	                                            _react3.default.createElement('input', { name: 'quantity', readOnly: 'readonly', type: 'text', value: weight, style: { width: '100px' } }),
	                                            _react3.default.createElement('a', { className: classPlus, onClick: function onClick(e) {
	                                                    _this.props.onClickPlusNested(e, item.id);
	                                                } })
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'td',
	                                        { style: { width: '10%' } },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'inline', style: { paddingTop: '5px', paddingLeft: '1px', paddingRight: '5px' } },
	                                            _react3.default.createElement(
	                                                'b',
	                                                null,
	                                                _this.props.translations[item.childOffer.unit.title_lang_data]
	                                            )
	                                        )
	                                    )
	                                );
	                            } else if (item.is_quantity_change && item.childOffer.type_id === 5) {
	                                return _react3.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react3.default.createElement(
	                                        'td',
	                                        { colSpan: '4' },
	                                        _react3.default.createElement(
	                                            'table',
	                                            { width: '100%' },
	                                            _react3.default.createElement(
	                                                'tbody',
	                                                null,
	                                                _react3.default.createElement(
	                                                    'tr',
	                                                    null,
	                                                    _react3.default.createElement(
	                                                        'td',
	                                                        { style: { width: '5%', padding: '5px' } },
	                                                        _react3.default.createElement(
	                                                            'b',
	                                                            null,
	                                                            index + 1
	                                                        )
	                                                    ),
	                                                    _react3.default.createElement(
	                                                        'td',
	                                                        { style: { width: '70%', padding: '5px', textAlign: 'left' } },
	                                                        _react3.default.createElement(
	                                                            'b',
	                                                            null,
	                                                            item.childOffer.name
	                                                        )
	                                                    ),
	                                                    _react3.default.createElement('td', { colSpan: '2', style: {
	                                                            width: '25%',
	                                                            padding: '5px',
	                                                            textAlign: 'center'
	                                                        } })
	                                                ),
	                                                _react3.default.createElement(
	                                                    'tr',
	                                                    null,
	                                                    _react3.default.createElement(
	                                                        'td',
	                                                        { colSpan: '4' },
	                                                        _react3.default.createElement(
	                                                            'div',
	                                                            { className: 'no-margin col-xs-12 col-sn-12 col-md-12' },
	                                                            item.childOffer.modifier[0] !== undefined ? _react3.default.createElement(
	                                                                'div',
	                                                                { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
	                                                                item.childOffer.modifier[0].name,
	                                                                _react3.default.createElement(
	                                                                    'select',
	                                                                    { className: 'form-control', onChange: function onChange(e) {
	                                                                            _this.props.handleSelectChildOffer(e, 0, item.id);
	                                                                        },
	                                                                        value: item.valuesMods[0] },
	                                                                    _react3.default.createElement(
	                                                                        'option',
	                                                                        { value: 'all' },
	                                                                        _this.props.lang['store.common.choose']
	                                                                    ),
	                                                                    item.childOffer.modifier[0].values.map(function (value, i) {
	                                                                        return _react3.default.createElement(
	                                                                            'option',
	                                                                            { key: value.id, value: value.id },
	                                                                            '' + value.name
	                                                                        );
	                                                                    })
	                                                                )
	                                                            ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' }),
	                                                            item.childOffer.modifier[1] !== undefined ? _react3.default.createElement(
	                                                                'div',
	                                                                { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
	                                                                item.childOffer.modifier[1].name,
	                                                                _react3.default.createElement(
	                                                                    'select',
	                                                                    { className: 'form-control', onChange: function onChange(e) {
	                                                                            _this.props.handleSelectChildOffer(e, 1, item.id);
	                                                                        },
	                                                                        value: item.valuesMods[1] },
	                                                                    _react3.default.createElement(
	                                                                        'option',
	                                                                        { value: 'all' },
	                                                                        _this.props.lang['store.common.choose']
	                                                                    ),
	                                                                    item.childOffer.modifier[1].values.map(function (value, i) {
	                                                                        return _react3.default.createElement(
	                                                                            'option',
	                                                                            { key: value.id, value: value.id },
	                                                                            '' + value.name
	                                                                        );
	                                                                    })
	                                                                )
	                                                            ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' }),
	                                                            item.childOffer.modifier[2] !== undefined ? _react3.default.createElement(
	                                                                'div',
	                                                                { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
	                                                                item.childOffer.modifier[2].name,
	                                                                _react3.default.createElement(
	                                                                    'select',
	                                                                    { className: 'form-control', onChange: function onChange(e) {
	                                                                            _this.props.handleSelectChildOffer(e, 2, item.id);
	                                                                        },
	                                                                        value: item.childOffer.modValuesId2 },
	                                                                    _react3.default.createElement(
	                                                                        'option',
	                                                                        { value: 'all' },
	                                                                        _this.props.lang['store.common.choose']
	                                                                    ),
	                                                                    item.childOffer.modifier[2].values.map(function (value, i) {
	                                                                        return _react3.default.createElement(
	                                                                            'option',
	                                                                            { key: value.id, value: value.id },
	                                                                            '' + value.name
	                                                                        );
	                                                                    })
	                                                                )
	                                                            ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' })
	                                                        )
	                                                    )
	                                                ),
	                                                item.childOffer.nestedOffers.map(function (childItem, childIndex) {
	                                                    childWeight = childItem.quantity;
	                                                    if ((childItem.childOffer.unit.slug === 'kg' || childItem.childOffer.unit.slug === 'mg') && childItem.weight && childItem.weight > 0 && childItem.quantity > 0) {
	                                                        childWeight = childItem.weight * childItem.quantity;
	                                                        childWeight = childWeight.toFixed(3);
	                                                        if (childItem.weight < 0.01 && childItem.quantity < 1 || childItem.weight < 1 && childItem.quantity < 0.01) {
	                                                            childWeight = childItem.weight * 1;
	                                                        }
	                                                        if (childItem.weight < 0.1 && childItem.quantity < 0.1) {
	                                                            childWeight = childItem.weight * 1;
	                                                        }
	                                                    }
	                                                    if (childItem.quantity > 0 && childItem.is_quantity_change !== true) {
	                                                        return _react3.default.createElement(
	                                                            'tr',
	                                                            null,
	                                                            _react3.default.createElement('td', { style: { width: '5%', padding: '5px' } }),
	                                                            _react3.default.createElement(
	                                                                'td',
	                                                                { style: { width: '70%', padding: '5px' } },
	                                                                childItem.childOffer.name,
	                                                                ' ',
	                                                                childItem.childOffer.modOption ? '(' + childItem.childOffer.modOption.name + ')' : ''
	                                                            ),
	                                                            _react3.default.createElement(
	                                                                'td',
	                                                                { colSpan: '2', style: {
	                                                                        width: '25%',
	                                                                        padding: '5px',
	                                                                        textAlign: 'center'
	                                                                    } },
	                                                                childWeight,
	                                                                ' ',
	                                                                _this.props.translations[childItem.childOffer.unit.title_lang_data]
	                                                            )
	                                                        );
	                                                    } else if (childItem.is_quantity_change === true) {
	                                                        // проверяем наличие свойств и то, что они больше нуля - если нет, меняем значение.
	                                                        var _maxValue = childItem.hasOwnProperty('quantity_max') && childItem.quantity_max > 0 ? +childItem.quantity_max : ModifierModalView.MaxValue;
	                                                        var _minValue = childItem.hasOwnProperty('quantity_min') && childItem.quantity_min > 0 ? +childItem.quantity_min : 0;
	                                                        // определяем шаг изменения
	                                                        var _step = childItem.stepQuantity ? childItem.stepQuantity : 1;
	                                                        var _classPlus = _step + childItem.quantity > _maxValue ? 'plus _disabled' : 'plus';
	                                                        var _classMinus = childItem.quantity - _step < _minValue ? 'minus _disabled' : 'minus';
	                                                        return _react3.default.createElement(
	                                                            'tr',
	                                                            null,
	                                                            _react3.default.createElement('td', { style: { width: '5%', padding: '5px' } }),
	                                                            _react3.default.createElement(
	                                                                'td',
	                                                                { style: { width: '70%', padding: '5px' } },
	                                                                childItem.childOffer.name,
	                                                                ' ',
	                                                                childItem.modOption ? '(' + childItem.modOption.name + ')' : ''
	                                                            ),
	                                                            _react3.default.createElement(
	                                                                'td',
	                                                                { style: {
	                                                                        width: '15%',
	                                                                        padding: '5px',
	                                                                        textAlign: 'center'
	                                                                    } },
	                                                                _react3.default.createElement(
	                                                                    'div',
	                                                                    { style: { transform: 'scale(0.8 , 0.8)' }, className: 'le-quantity inline' },
	                                                                    _react3.default.createElement('a', { className: _classMinus, onClick: function onClick(e) {
	                                                                            _this.props.onClickMinusChildNested(e, item.id, childItem.id);
	                                                                        } }),
	                                                                    _react3.default.createElement('input', { name: 'quantity', readOnly: 'readonly', type: 'text', value: childWeight, style: { width: '100px' } }),
	                                                                    _react3.default.createElement('a', { className: _classPlus, onClick: function onClick(e) {
	                                                                            _this.props.onClickPlusChildNested(e, item.id, childItem.id);
	                                                                        } })
	                                                                )
	                                                            ),
	                                                            _react3.default.createElement(
	                                                                'td',
	                                                                { style: { width: '10%' } },
	                                                                _react3.default.createElement(
	                                                                    'div',
	                                                                    { className: 'inline', style: { paddingTop: '5px', paddingLeft: '1px', paddingRight: '5px' } },
	                                                                    _react3.default.createElement(
	                                                                        'b',
	                                                                        null,
	                                                                        _this.props.translations[childItem.childOffer.unit.title_lang_data]
	                                                                    )
	                                                                )
	                                                            )
	                                                        );
	                                                    }
	                                                }),
	                                                _react3.default.createElement(
	                                                    'tr',
	                                                    null,
	                                                    _react3.default.createElement('td', null),
	                                                    _react3.default.createElement('td', null),
	                                                    _react3.default.createElement(
	                                                        'td',
	                                                        { style: {
	                                                                padding: '5px',
	                                                                textAlign: 'center'
	                                                            } },
	                                                        _react3.default.createElement(
	                                                            'div',
	                                                            { style: { transform: 'scale(0.9 , 0.9)' }, className: 'le-quantity inline' },
	                                                            _react3.default.createElement('a', { className: classMinus, onClick: function onClick(e) {
	                                                                    _this.props.onClickMinusNested(e, item.id);
	                                                                } }),
	                                                            _react3.default.createElement('input', { name: 'quantity', readOnly: 'readonly', type: 'text',
	                                                                value: weight, style: { width: '100px' } }),
	                                                            _react3.default.createElement('a', { className: classPlus, onClick: function onClick(e) {
	                                                                    _this.props.onClickPlusNested(e, item.id);
	                                                                } })
	                                                        ),
	                                                        _react3.default.createElement(
	                                                            'div',
	                                                            { className: 'inline',
	                                                                style: { paddingTop: '10px', paddingLeft: '10px' } },
	                                                            _this.props.translations[item.childOffer.unit.title_lang_data]
	                                                        )
	                                                    ),
	                                                    _react3.default.createElement('td', null)
	                                                )
	                                            )
	                                        )
	                                    )
	                                );
	                            } else if (item.quantity > 0 && item.is_quantity_change !== true && item.childOffer.type_id === 5) {
	                                return _react3.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react3.default.createElement(
	                                        'td',
	                                        { colSpan: '4' },
	                                        _react3.default.createElement(
	                                            'table',
	                                            { width: '100%' },
	                                            _react3.default.createElement(
	                                                'tbody',
	                                                null,
	                                                _react3.default.createElement(
	                                                    'tr',
	                                                    null,
	                                                    _react3.default.createElement(
	                                                        'td',
	                                                        { style: { width: '5%', padding: '5px' } },
	                                                        _react3.default.createElement(
	                                                            'b',
	                                                            null,
	                                                            index + 1
	                                                        )
	                                                    ),
	                                                    _react3.default.createElement(
	                                                        'td',
	                                                        { style: { width: '70%', padding: '5px', textAlign: 'left' } },
	                                                        _react3.default.createElement(
	                                                            'b',
	                                                            null,
	                                                            item.childOffer.name
	                                                        )
	                                                    ),
	                                                    _react3.default.createElement('td', { colSpan: '2', style: {
	                                                            width: '25%',
	                                                            padding: '5px',
	                                                            textAlign: 'center'
	                                                        } })
	                                                ),
	                                                _react3.default.createElement(
	                                                    'tr',
	                                                    null,
	                                                    _react3.default.createElement(
	                                                        'td',
	                                                        { colSpan: '4' },
	                                                        _react3.default.createElement(
	                                                            'div',
	                                                            { className: 'no-margin col-xs-12 col-sn-12 col-md-12' },
	                                                            item.childOffer.modifier[0] !== undefined ? _react3.default.createElement(
	                                                                'div',
	                                                                { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
	                                                                item.childOffer.modifier[0].name,
	                                                                _react3.default.createElement(
	                                                                    'select',
	                                                                    { className: 'form-control', onChange: function onChange(e) {
	                                                                            _this.props.handleSelectChildOffer(e, 0, item.id);
	                                                                        },
	                                                                        value: item.valuesMods[0] },
	                                                                    _react3.default.createElement(
	                                                                        'option',
	                                                                        { value: 'all' },
	                                                                        _this.props.lang['store.common.choose']
	                                                                    ),
	                                                                    item.childOffer.modifier[0].values.map(function (value, i) {
	                                                                        return _react3.default.createElement(
	                                                                            'option',
	                                                                            { key: value.id, value: value.id },
	                                                                            '' + value.name
	                                                                        );
	                                                                    })
	                                                                )
	                                                            ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' }),
	                                                            item.childOffer.modifier[1] !== undefined ? _react3.default.createElement(
	                                                                'div',
	                                                                { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
	                                                                item.childOffer.modifier[1].name,
	                                                                _react3.default.createElement(
	                                                                    'select',
	                                                                    { className: 'form-control', onChange: function onChange(e) {
	                                                                            _this.props.handleSelectChildOffer(e, 1, item.id);
	                                                                        },
	                                                                        value: item.valuesMods[1] },
	                                                                    _react3.default.createElement(
	                                                                        'option',
	                                                                        { value: 'all' },
	                                                                        _this.props.lang['store.common.choose']
	                                                                    ),
	                                                                    item.childOffer.modifier[1].values.map(function (value, i) {
	                                                                        return _react3.default.createElement(
	                                                                            'option',
	                                                                            { key: value.id, value: value.id },
	                                                                            '' + value.name
	                                                                        );
	                                                                    })
	                                                                )
	                                                            ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' }),
	                                                            item.childOffer.modifier[2] !== undefined ? _react3.default.createElement(
	                                                                'div',
	                                                                { className: 'col-xs-12 col-sn-12 col-md-4 filter_item', style: { paddingLeft: '0px' } },
	                                                                item.childOffer.modifier[2].name,
	                                                                _react3.default.createElement(
	                                                                    'select',
	                                                                    { className: 'form-control', onChange: function onChange(e) {
	                                                                            _this.props.handleSelectChildOffer(e, 2, item.id);
	                                                                        },
	                                                                        value: item.childOffer.modValuesId2 },
	                                                                    _react3.default.createElement(
	                                                                        'option',
	                                                                        { value: 'all' },
	                                                                        _this.props.lang['store.common.choose']
	                                                                    ),
	                                                                    item.childOffer.modifier[2].values.map(function (value, i) {
	                                                                        return _react3.default.createElement(
	                                                                            'option',
	                                                                            { key: value.id, value: value.id },
	                                                                            '' + value.name
	                                                                        );
	                                                                    })
	                                                                )
	                                                            ) : _react3.default.createElement('div', { className: 'col-xs-12 col-sn-12 col-md-4 filter_item' })
	                                                        )
	                                                    )
	                                                ),
	                                                item.childOffer.nestedOffers.map(function (childItem, childIndex) {
	                                                    childWeight = childItem.quantity;
	                                                    if ((childItem.childOffer.unit.slug === 'kg' || childItem.childOffer.unit.slug === 'mg') && childItem.weight && childItem.weight > 0 && childItem.quantity > 0) {
	                                                        childWeight = childItem.weight * childItem.quantity;
	                                                        childWeight = childWeight.toFixed(3);
	                                                        if (childItem.weight < 0.01 && childItem.quantity < 1 || childItem.weight < 1 && childItem.quantity < 0.01) {
	                                                            childWeight = childItem.weight * 1;
	                                                        }
	                                                        if (childItem.weight < 0.1 && childItem.quantity < 0.1) {
	                                                            childWeight = childItem.weight * 1;
	                                                        }
	                                                    }
	                                                    if (childItem.quantity > 0 && childItem.is_quantity_change !== true) {
	                                                        return _react3.default.createElement(
	                                                            'tr',
	                                                            null,
	                                                            _react3.default.createElement('td', { style: { width: '5%', padding: '5px' } }),
	                                                            _react3.default.createElement(
	                                                                'td',
	                                                                { style: { width: '70%', padding: '5px' } },
	                                                                childItem.childOffer.name,
	                                                                ' ',
	                                                                childItem.childOffer.modOption ? '(' + childItem.childOffer.modOption.name + ')' : ''
	                                                            ),
	                                                            _react3.default.createElement(
	                                                                'td',
	                                                                { colSpan: '2', style: {
	                                                                        width: '25%',
	                                                                        padding: '5px',
	                                                                        textAlign: 'center'
	                                                                    } },
	                                                                childWeight,
	                                                                ' ',
	                                                                _this.props.translations[childItem.childOffer.unit.title_lang_data]
	                                                            )
	                                                        );
	                                                    } else if (childItem.is_quantity_change === true) {
	                                                        // проверяем наличие свойств и то, что они больше нуля - если нет, меняем значение.
	                                                        var _maxValue2 = childItem.hasOwnProperty('quantity_max') && childItem.quantity_max > 0 ? +childItem.quantity_max : ModifierModalView.MaxValue;
	                                                        var _minValue2 = childItem.hasOwnProperty('quantity_min') && childItem.quantity_min > 0 ? +childItem.quantity_min : 0;
	                                                        // определяем шаг изменения
	                                                        var _step2 = childItem.stepQuantity ? childItem.stepQuantity : 1;
	                                                        var _classPlus2 = _step2 + childItem.quantity > _maxValue2 ? 'plus _disabled' : 'plus';
	                                                        var _classMinus2 = childItem.quantity - _step2 < _minValue2 ? 'minus _disabled' : 'minus';
	                                                        return _react3.default.createElement(
	                                                            'tr',
	                                                            null,
	                                                            _react3.default.createElement('td', { style: { width: '5%', padding: '5px' } }),
	                                                            _react3.default.createElement(
	                                                                'td',
	                                                                { style: { width: '70%', padding: '5px' } },
	                                                                childItem.childOffer.name,
	                                                                ' ',
	                                                                childItem.modOption ? '(' + childItem.modOption.name + ')' : ''
	                                                            ),
	                                                            _react3.default.createElement(
	                                                                'td',
	                                                                { style: {
	                                                                        width: '15%',
	                                                                        padding: '5px',
	                                                                        textAlign: 'center'
	                                                                    } },
	                                                                _react3.default.createElement(
	                                                                    'div',
	                                                                    { style: { transform: 'scale(0.8 , 0.8)' }, className: 'le-quantity inline' },
	                                                                    _react3.default.createElement('a', { className: _classMinus2, onClick: function onClick(e) {
	                                                                            _this.props.onClickMinusChildNested(e, item.id, childItem.id);
	                                                                        } }),
	                                                                    _react3.default.createElement('input', { name: 'quantity', readOnly: 'readonly', type: 'text', value: childWeight, style: { width: '100px' } }),
	                                                                    _react3.default.createElement('a', { className: _classPlus2, onClick: function onClick(e) {
	                                                                            _this.props.onClickPlusChildNested(e, item.id, childItem.id);
	                                                                        } })
	                                                                )
	                                                            ),
	                                                            _react3.default.createElement(
	                                                                'td',
	                                                                { style: { width: '10%' } },
	                                                                _react3.default.createElement(
	                                                                    'div',
	                                                                    { className: 'inline', style: { paddingTop: '5px', paddingLeft: '1px', paddingRight: '5px' } },
	                                                                    _react3.default.createElement(
	                                                                        'b',
	                                                                        null,
	                                                                        _this.props.translations[childItem.childOffer.unit.title_lang_data]
	                                                                    )
	                                                                )
	                                                            )
	                                                        );
	                                                    }
	                                                }),
	                                                _react3.default.createElement(
	                                                    'tr',
	                                                    null,
	                                                    _react3.default.createElement('td', null),
	                                                    _react3.default.createElement('td', null),
	                                                    _react3.default.createElement(
	                                                        'td',
	                                                        { colSpan: 2, style: {
	                                                                width: '25%',
	                                                                padding: '5px',
	                                                                textAlign: 'center'
	                                                            } },
	                                                        _react3.default.createElement(
	                                                            'b',
	                                                            null,
	                                                            weight,
	                                                            ' ',
	                                                            _this.props.translations[item.childOffer.unit.title_lang_data]
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                );
	                            }
	                        })
	                    )
	                )
	            );
	        };
	
	        _this.renderListNested = function () {
	            var weight = 0;
	            var childWeight = 0;
	            return _react3.default.createElement(
	                'div',
	                { className: 'no-margin col-xs-12 col-sn-12 col-md-12', style: { paddingTop: '10px' } },
	                _react3.default.createElement(
	                    'table',
	                    { style: { width: '100%' } },
	                    _react3.default.createElement(
	                        'tbody',
	                        null,
	                        _react3.default.createElement(
	                            'tr',
	                            { style: { background: '#E0E0E0' } },
	                            _react3.default.createElement(
	                                'th',
	                                { style: { width: '5%', padding: '5px' } },
	                                '#'
	                            ),
	                            _react3.default.createElement(
	                                'th',
	                                { style: { width: '70%', padding: '5px' } },
	                                _this.props.lang['store.short_description.component_title']
	                            ),
	                            _react3.default.createElement(
	                                'th',
	                                { style: { width: '15%', padding: '5px', textAlign: 'center' } },
	                                _this.props.lang['store.short_description.quantity']
	                            ),
	                            _react3.default.createElement('th', { style: { width: '10%' } })
	                        ),
	                        _this.props.listNested.map(function (item, index) {
	                            weight = item.quantity;
	                            if ((item.childOffer.unit.slug === 'kg' || item.childOffer.unit.slug === 'mg') && item.weight && item.weight > 0 && item.quantity > 0) {
	                                weight = item.weight * item.quantity;
	                                weight = weight.toFixed(3);
	                                if (item.weight < 0.01 && item.quantity < 1 || item.weight < 1 && item.quantity < 0.01) {
	                                    weight = item.weight * 1;
	                                }
	                                if (item.weight < 0.1 && item.quantity < 0.1) {
	                                    weight = item.weight * 1;
	                                }
	                            }
	                            // проверяем наличие свойств и то, что они больше нуля - если нет, меняем значение.
	                            var maxValue = item.hasOwnProperty('quantity_max') && item.quantity_max > 0 ? +item.quantity_max : ModifierModalView.MaxValue;
	                            var minValue = item.hasOwnProperty('quantity_min') && item.quantity_min > 0 ? +item.quantity_min : 0;
	                            // определяем шаг изменения
	                            var step = item.stepQuantity ? item.stepQuantity : 1;
	                            var classPlus = item.quantity + step > maxValue ? 'plus _disabled' : 'plus';
	                            var classMinus = item.quantity - step < minValue ? 'minus _disabled' : 'minus';
	                            var paddingLeft = '0px';
	                            if (item.level > 1) {
	                                paddingLeft = (item.level - 1) * 30 + 'px';
	                            }
	                            if (item.quantity > 0 && item.is_quantity_change !== true) {
	                                return _react3.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react3.default.createElement(
	                                        'td',
	                                        { style: { width: '5%', padding: '5px' } },
	                                        item.level === 1 ? _react3.default.createElement(
	                                            'b',
	                                            null,
	                                            index + 1
	                                        ) : null
	                                    ),
	                                    _react3.default.createElement(
	                                        'td',
	                                        { style: { width: '70%', padding: '5px' } },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { style: {
	                                                    paddingLeft: paddingLeft,
	                                                    fontWeight: item.childOffer.type_id == 5 ? 'bold' : 'normal'
	                                                } },
	                                            item.childOffer.name,
	                                            ' ',
	                                            item.childOffer.modOption ? '(' + item.childOffer.modOption.name + ')' : ''
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'td',
	                                        { colSpan: 2, style: {
	                                                width: '25%',
	                                                padding: '5px',
	                                                textAlign: 'center'
	                                            } },
	                                        _react3.default.createElement(
	                                            'b',
	                                            null,
	                                            weight,
	                                            ' ',
	                                            _this.props.translations[item.childOffer.unit.title_lang_data]
	                                        )
	                                    )
	                                );
	                            } else if (item.is_quantity_change) {
	                                return _react3.default.createElement(
	                                    'tr',
	                                    null,
	                                    _react3.default.createElement(
	                                        'td',
	                                        { style: { width: '5%', padding: '5px' } },
	                                        item.level === 1 ? _react3.default.createElement(
	                                            'b',
	                                            null,
	                                            index + 1
	                                        ) : null
	                                    ),
	                                    _react3.default.createElement(
	                                        'td',
	                                        { style: { width: '70%', padding: '5px' } },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { style: {
	                                                    paddingLeft: paddingLeft,
	                                                    fontWeight: item.childOffer.type_id == 5 ? 'bold' : 'normal'
	                                                } },
	                                            item.childOffer.name,
	                                            ' ',
	                                            item.childOffer.modOption ? '(' + item.childOffer.modOption.name + ')' : ''
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'td',
	                                        { style: {
	                                                width: '15%',
	                                                padding: '5px',
	                                                textAlign: 'center'
	                                            } },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { style: { transform: 'scale(0.9 , 0.9)' }, className: 'le-quantity inline' },
	                                            _react3.default.createElement('a', { className: classMinus, onClick: function onClick(e) {
	                                                    _this.props.onClickMinusNested(e, item.id);
	                                                } }),
	                                            _react3.default.createElement('input', { name: 'quantity', readOnly: 'readonly', type: 'text', value: weight, style: { width: '100px' } }),
	                                            _react3.default.createElement('a', { className: classPlus, onClick: function onClick(e) {
	                                                    _this.props.onClickPlusNested(e, item.id);
	                                                } })
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'td',
	                                        { style: { width: '10%' } },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'inline', style: { paddingTop: '5px', paddingLeft: '1px', paddingRight: '5px' } },
	                                            _react3.default.createElement(
	                                                'b',
	                                                null,
	                                                _this.props.translations[item.childOffer.unit.title_lang_data]
	                                            )
	                                        )
	                                    )
	                                );
	                            }
	                        })
	                    )
	                )
	            );
	        };
	
	        _this.state = {
	            countForSendBasket: props.count
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(ModifierModalView, [{
	        key: 'getRemainder',
	        value: function getRemainder(nestedOffer, quantityParent, product_detail) {
	            var _this2 = this;
	
	            if (nestedOffer.childOffer === null) {
	                return null;
	            }
	            if (nestedOffer.quantity > 0) {
	                var quantity = void 0;
	                var quantityTechCard = void 0;
	                quantity = nestedOffer.quantity;
	                if (nestedOffer.childOffer.modifier_option_id !== null && nestedOffer.childOffer.modOption === null) {
	                    nestedOffer.childOffer.modOption = nestedOffer.childOffer.modifiedOption.reduce(function (mod, modifier) {
	                        if (modifier.id === nestedOffer.childOffer.modifier_option_id) {
	                            return modifier;
	                        }
	                        return mod;
	                    }, null);
	                }
	                if (nestedOffer.childOffer.modOption !== null && nestedOffer.childOffer.type_id !== 5) {
	                    nestedOffer.childOffer.unit = nestedOffer.childOffer.modOption.unit;
	                    if (nestedOffer.childOffer.modOption.storable === true && nestedOffer.childOffer.modOption.storage_strict) {
	                        product_detail.storable = true;
	                        if (nestedOffer.childOffer.modOption.remainder.length === 0) {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        } else if (nestedOffer.childOffer.modOption.remainder[0].quantity > 0) {
	                            if ((nestedOffer.childOffer.modOption.unit_id === 2 || nestedOffer.childOffer.modOption.unit_id === 8) && nestedOffer.childOffer.modOption.weight && nestedOffer.childOffer.modOption.weight > 0) {
	                                quantity = nestedOffer.childOffer.modOption.weight * nestedOffer.quantity;
	                            }
	                            quantity = quantity * quantityParent;
	                            quantityTechCard = Math.floor(nestedOffer.childOffer.modOption.remainder[0].quantity / quantity);
	                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
	                                product_detail.remainder = [{ quantity: quantityTechCard }];
	                            }
	                        } else {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        }
	                    }
	                }
	                if (nestedOffer.childOffer.modOption === null && nestedOffer.childOffer.type_id !== 5) {
	                    if (nestedOffer.childOffer.storable === true && nestedOffer.childOffer.storage_strict) {
	                        product_detail.storable = true;
	                        if (nestedOffer.childOffer.remainder.length === 0) {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        } else if (nestedOffer.childOffer.remainder[0].quantity > 0) {
	                            if ((nestedOffer.childOffer.unit_id === 2 || nestedOffer.childOffer.unit_id === 8) && nestedOffer.childOffer.weight && nestedOffer.childOffer.weight > 0) {
	                                quantity = nestedOffer.childOffer.weight * nestedOffer.quantity;
	                            }
	                            quantity = quantity * quantityParent;
	                            quantityTechCard = Math.floor(nestedOffer.childOffer.remainder[0].quantity / quantity);
	                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
	                                product_detail.remainder = [{ quantity: quantityTechCard }];
	                            }
	                        } else {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        }
	                    }
	                }
	                if (nestedOffer.childOffer.type_id === 5) {
	                    nestedOffer.childOffer.remainder = [];
	                    nestedOffer.childOffer.storable = false;
	                    quantity = nestedOffer.quantity * quantityParent;
	                    nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
	                        _this2.getRemainder(nestedOfferTwo, quantity, product_detail);
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                product_detail = _props.product_detail,
	                lang = _props.lang,
	                currency = _props.currency,
	                categories = product_detail.categories,
	                id_yml = product_detail.id_yml,
	                storable = product_detail.storable,
	                storage_strict = product_detail.storage_strict,
	                seo = product_detail.seo,
	                vendor = '',
	                old_price = void 0,
	                price = 0,
	                available = lang['store.modifier_modal.out_of_stock'],
	                child_offers = '',
	                add_to_cart = '';
	
	            var seoH1 = product_detail.name;
	            if (product_detail.old_price) {
	                old_price = _react3.default.createElement(
	                    'div',
	                    { className: 'price-prev' },
	                    _react3.default.createElement(_components2.MoneyValue, {
	                        value: product_detail.old_price,
	                        icon: currency.icon,
	                        iconAfterValue: currency.icon_after_value
	                    })
	                );
	            }
	            if (product_detail.vendor) {
	                vendor = product_detail.vendor;
	            }
	
	            // округляем число до сотых
	            if (product_detail.price) {
	                price = parseFloat(product_detail.price);
	            }
	
	            if (product_detail.available) {
	                available = lang['store.modifier_modal.in_stock'];
	            }
	            if (product_detail.type_id === 5) {
	                product_detail.storable = false;
	                product_detail.remainder = [];
	                var quantityTechCard = 1;
	                var priceComponent = 0;
	                var modifierComponent = null;
	                var storableComponent = false;
	                var modifierComponentTwo = null;
	                product_detail.nestedOffers.forEach(function (nestedOffer) {
	                    if (nestedOffer.quantity > 0 && nestedOffer.childOffer) {
	                        modifierComponent = null;
	                        if (nestedOffer.childOffer.type_id === 5) {
	                            nestedOffer.childOffer.remainder = [];
	                            nestedOffer.childOffer.storable = false;
	                            nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
	                                _this3.getRemainder(nestedOfferTwo, nestedOffer.quantity, product_detail);
	                            });
	                        } else {
	                            _this3.getRemainder(nestedOffer, quantityTechCard, product_detail);
	                        }
	                    }
	                });
	                price = parseFloat(product_detail.price * this.state.countForSendBasket);
	                if (product_detail.modifier_option_id !== undefined) {
	                    product_detail.modifier_option.storable = product_detail.storable;
	                    product_detail.modifier_option.remainder[0] = product_detail.remainder[0];
	                }
	            }
	
	            if (product_detail.modifier_option_id && product_detail.modifier_option.storable && product_detail.modifier_option.storage_strict && (product_detail.modifier_option.remainder[0] && product_detail.modifier_option.remainder[0].quantity <= 0 || product_detail.modifier_option.remainder.length === 0)) {
	                add_to_cart = _react3.default.createElement(
	                    'p',
	                    { className: 'no_good' },
	                    lang['store.add_to_cart.product_out_of_stock']
	                );
	            } else {
	                if (product_detail.modifier_option_id && product_detail.modifier_option.storable && product_detail.modifier_option.storage_strict) {
	                    add_to_cart = _react3.default.createElement(
	                        'div',
	                        null,
	                        _react3.default.createElement(_components2.QuantityProduct, {
	                            value: this.state.countForSendBasket,
	                            checkValue: product_detail.modifier_option.storable && product_detail.modifier_option.storage_strict && product_detail.modifier_option.remainder[0] ? true : false,
	                            checkCount: product_detail.modifier_option.remainder[0] !== undefined ? product_detail.modifier_option.remainder[0].quantity : null,
	                            callback: function callback(newCount) {
	                                _this3.setState({ countForSendBasket: newCount });
	                            } }),
	                        product_detail.modifier_option_id && product_detail.modifier_option.storable && product_detail.modifier_option.storage_strict && product_detail.modifier_option.remainder[0] && product_detail.modifier_option.remainder[0].quantity < this.state.countForSendBasket ? _react3.default.createElement('p', { className: 'no_good' }) : _react3.default.createElement(_components2.AddToBasket, { id: 'addto-cart-modal', className: ['huge'], product: product_detail,
	                            count: this.state.countForSendBasket, isModal: true,
	                            close: this.props.closeModal })
	                    );
	                } else {
	                    add_to_cart = _react3.default.createElement(
	                        'div',
	                        null,
	                        _react3.default.createElement(_components2.QuantityProduct, {
	                            value: this.state.countForSendBasket,
	                            checkValue: product_detail.storable && product_detail.remainder[0] ? true : false,
	                            checkCount: product_detail.remainder[0] !== undefined ? product_detail.remainder[0].quantity : null,
	                            callback: function callback(newCount) {
	                                _this3.setState({ countForSendBasket: newCount });
	                            } }),
	                        product_detail.modifier_option_id && product_detail.storable && product_detail.storage_strict && product_detail.remainder[0] && product_detail.remainder[0].quantity < this.state.countForSendBasket ? _react3.default.createElement('p', { className: 'no_good' }) : _react3.default.createElement(_components2.AddToBasket, { id: 'addto-cart-modal', className: ['huge'], product: product_detail,
	                            count: this.state.countForSendBasket, isModal: true,
	                            close: this.props.closeModal })
	                    );
	                }
	            }
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'title' },
	                    _react3.default.createElement(
	                        'h4',
	                        null,
	                        seoH1
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'brand' },
	                    vendor
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { id: 'single-product' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'body-holder' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'body' },
	                            product_detail.modifier_option_id || product_detail.type_id === 5 ? _react3.default.createElement(_components2.ProductWishIcon, { product: product_detail, isModal: true, close: this.props.closeModal }) : null,
	                            this.renderModSelect(),
	                            product_detail.type_id === 5 ? this.renderListNested() : null,
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'prices', style: { fontSize: '40px', fontWeight: '700', color: '@black' } },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'price-current' },
	                                    _react3.default.createElement(_components2.MoneyValue, {
	                                        value: price,
	                                        icon: currency.icon,
	                                        iconAfterValue: currency.icon_after_value
	                                    })
	                                ),
	                                old_price
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'qnt-holder-modal' },
	                                add_to_cart
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return ModifierModalView;
	}(_react2.Component), _class2.propTypes = {
	    lang: _react2.PropTypes.object.isRequired,
	    currency: _react2.PropTypes.object.isRequired
	}, _class2.MaxValue = 99999999999999, _temp)) || _class));
	
	exports.default = ModifierModalView;
	module.exports = exports['default'];

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModifierModal = undefined;
	
	var _ModifierModal2 = __webpack_require__(1617);
	
	var _ModifierModal3 = _interopRequireDefault(_ModifierModal2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ModifierModal = _ModifierModal3.default;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _BasketProductDetail = __webpack_require__(748);
	
	var _BasketProductDetail2 = _interopRequireDefault(_BasketProductDetail);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(455);
	
	var _utils = __webpack_require__(31);
	
	var _components2 = __webpack_require__(16);
	
	var _reactBootstrap = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    BasketView: {
	        displayName: 'BasketView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Basket/default/BasketView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var yandexShareButtons = null;
	var sharingURL = '';
	
	var BasketView = _wrapComponent('BasketView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(BasketView, _Component);
	
	    function BasketView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, BasketView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BasketView.__proto__ || (0, _getPrototypeOf2.default)(BasketView)).call.apply(_ref, [this].concat(args))), _this), _this.onCreateOrder = function (event) {
	            event.preventDefault();
	            _this.props.onCreateOrder(event);
	        }, _this.cancelEditOrder = function (event) {
	            event.preventDefault();
	            _this.props.cancelEditOrder(event);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(BasketView, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var shareCode = this.props.shareCode;
	            sharingURL = global.location.origin + '/basket/';
	
	            if (this.props.elements.length) {
	                try {
	                    yandexShareButtons = Ya.share2(this.refs.yandex_buttons, {
	                        content: {
	                            url: global.location.origin + '/basket/' + shareCode,
	                            title: this.props.cartSubject || '',
	                            image: this.props.elements[0].picture && this.props.elements[0].picture.url || this.props.logo,
	                            description: (0, _utils.stripTags)(this.props.cartDescription) || ''
	                        },
	                        theme: {
	                            services: 'vkontakte,facebook,twitter,odnoklassniki'
	                        }
	                    });
	                } catch (e) {}
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.shareCode && nextProps.shareCode !== this.props.shareCode) {
	                yandexShareButtons.updateContent({
	                    url: global.location.origin + '/basket/' + nextProps.shareCode
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                cartSubject = _props.cartSubject,
	                cartDescription = _props.cartDescription,
	                dataError = _props.dataError,
	                shareCode = _props.shareCode,
	                sharePreload = _props.sharePreload,
	                showShare = _props.showShare,
	                lang = _props.lang,
	                currency = _props.currency,
	                customFields = _props.customFields,
	                changeCustomFields = _props.changeCustomFields;
	
	            var elements = this.props.elements || [];
	            var total = 0;
	
	            cartSubject = cartSubject || '';
	            cartDescription = cartDescription || '';
	
	            var editOrder = null;
	            if (this.props.editOrderNumber) {
	                editOrder = _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-8' },
	                        _react3.default.createElement(
	                            'h2',
	                            { className: 'section-title special_title', style: { paddingLeft: '10px' } },
	                            _react3.default.createElement(
	                                'span',
	                                null,
	                                lang['store.common.editOrder.title'],
	                                ' \u2116 ',
	                                this.props.editOrderNumber
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-4 col-xs-12 text-right' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'buttons-holder', style: { paddingTop: '10px' } },
	                            _react3.default.createElement(
	                                'button',
	                                { onClick: this.cancelEditOrder, className: 'le-button' },
	                                lang['store.common.editOrder.button.cancel']
	                            )
	                        )
	                    )
	                );
	            }
	            if (elements.length <= 0) {
	                return _react3.default.createElement(
	                    'section',
	                    { id: 'cart-page' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'row text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'basket-empty' },
	                            lang['store.cart.empty']
	                        )
	                    )
	                );
	            }
	
	            var helmet = _react3.default.createElement(_reactHelmet2.default, {
	                meta: [{ property: "og:url", content: sharingURL + shareCode }, { property: "og:type", content: "article" }, { property: "og:title", content: cartSubject }, { property: "og:description", content: (0, _utils.stripTags)(cartDescription) }, { property: "twitter:description", content: (0, _utils.stripTags)(cartDescription) }, { property: "twitter:title", content: cartSubject }]
	            });
	
	            var mailBody = encodeURIComponent((cartDescription || '') + ' \n' + global.location.origin + '/basket/' + shareCode) || "";
	            var mailSubject = encodeURIComponent(cartSubject);
	
	            return _react3.default.createElement(
	                'section',
	                { id: 'cart-page' },
	                editOrder,
	                this.props.before,
	                helmet,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin cart-item hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-1' },
	                        lang['store.cart.photo']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-4' },
	                        lang['store.cart.title']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2' },
	                        lang['store.cart.modifiers']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-3 hidden-xs text-center' },
	                        lang['store.cart.quantity']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2 hidden-xs text-center' },
	                        lang['store.cart.price']
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'items-holder' },
	                    elements.map(function (item, keyArray) {
	                        var sum = item.price * item.count;
	                        var itemError = null;
	                        total += sum;
	
	                        for (var i = 0; i < dataError.length; i++) {
	                            if (dataError[i].offer_id == item.id && dataError[i].modifier_option_id == item.modifier_option_id) {
	                                itemError = dataError[i];
	                                break;
	                            }
	                        }
	
	                        var props_item = (0, _extends3.default)({}, item, {
	                            sum: sum,
	                            itemError: itemError,
	                            onChangeCount: _this2.props.onChangeCount,
	                            onDelete: _this2.props.onDelete
	                        });
	                        var key = item.id;
	                        if (item.modifier_option_id !== null) {
	                            key = key + '_' + item.modifier_option_id;
	                        }
	                        if (item.modifier_option_name !== null) {
	                            key = key + '_' + item.modifier_option_name;
	                        }
	                        return _react3.default.createElement(_BasketProductDetail2.default, (0, _extends3.default)({ key: keyArray, lang: lang, currency: currency, keyArray: keyArray }, props_item));
	                    })
	                ),
	                customFields.length > 0 ? _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin summ_row' },
	                    customFields.map(function (item, i) {
	                        return _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-12 no-margin' },
	                            item.type === 'text' ? _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { className: 'col-xs-12 col-sm-7' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.ControlLabel,
	                                    null,
	                                    item.name
	                                ),
	                                _react3.default.createElement('input', {
	                                    id: i,
	                                    value: item.value,
	                                    className: 'form-control',
	                                    type: 'text',
	                                    onChange: changeCustomFields
	                                })
	                            ) : _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { className: 'col-xs-12 col-sm-7' },
	                                _react3.default.createElement('input', { type: 'checkbox', className: 'form-check-input', id: i, onChange: changeCustomFields, checked: item.value }),
	                                _react3.default.createElement(
	                                    'label',
	                                    { className: 'form-check-label', htmlFor: i },
	                                    '\xA0 ',
	                                    item.name
	                                )
	                            )
	                        );
	                    })
	                ) : null,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin summ_row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-3 no-margin' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'social_row ' + (showShare ? "enable" : "") },
	                            !showShare ? _react3.default.createElement(
	                                'div',
	                                { className: 'buttons-holder inline_block button_width_100' },
	                                _react3.default.createElement(
	                                    'a',
	                                    { onClick: this.props.shareBasket, className: 'le-button big button_width_100' },
	                                    _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        _react3.default.createElement('i', { className: 'fa fa-share-alt' }),
	                                        ' ',
	                                        lang['store.cart.share'],
	                                        ' '
	                                    )
	                                )
	                            ) : _react3.default.createElement(
	                                'a',
	                                { className: 'le-button button_share', onClick: this.props.hideShare },
	                                _react3.default.createElement('i', { className: 'fa fa-times' })
	                            ),
	                            showShare ? _react3.default.createElement(
	                                'a',
	                                { href: 'mailto:?subject=' + mailSubject + '&body=' + mailBody, title: lang['store.cart.send_email'], className: 'le-button button_share button_add' },
	                                _react3.default.createElement('i', { className: 'fa fa-envelope' })
	                            ) : null,
	                            showShare ? _react3.default.createElement(
	                                'a',
	                                { className: 'le-button button_share button_add', title: lang['store.cart.copy_to_clipboard'], onClick: this.props.copyToBuffer },
	                                _react3.default.createElement('i', { className: 'fa fa-clone' })
	                            ) : null
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2 no-margin' },
	                        this.props.user ? _react3.default.createElement(
	                            'div',
	                            null,
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'buttons-holder inline_block button_width_100' },
	                                _react3.default.createElement(
	                                    'a',
	                                    { onClick: this.props.postponeBasket, className: 'le-button big button_width_100' },
	                                    _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        lang['store.postpone.buttonPostpone'],
	                                        ' '
	                                    )
	                                )
	                            )
	                        ) : null
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-6 no-margin text-right' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'total_price' },
	                            _react3.default.createElement(_components2.MoneyValue, {
	                                value: total,
	                                icon: currency.icon,
	                                iconAfterValue: currency.icon_after_value,
	                                prefix: lang['store.cart.total'] + ': '
	                            })
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'buttons-holder inline_block button_width_100' },
	                            _react3.default.createElement(
	                                'a',
	                                { href: '#', onClick: this.onCreateOrder, className: 'le-button big button_width_100' },
	                                lang['store.cart.checkout']
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return BasketView;
	}(_react2.Component), _class.defaultProps = {
	    dataError: []
	}, _class.propTypes = {
	    elements: _react2.PropTypes.array.isRequired,
	    onDelete: _react2.PropTypes.func.isRequired,
	    onChangeCount: _react2.PropTypes.func.isRequired,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp2));
	
	exports.default = BasketView;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlcoModal = exports.Basket = undefined;
	
	var _Basket2 = __webpack_require__(747);
	
	var _Basket3 = _interopRequireDefault(_Basket2);
	
	var _AlcoModal2 = __webpack_require__(746);
	
	var _AlcoModal3 = _interopRequireDefault(_AlcoModal2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Basket = _Basket3.default;
	exports.AlcoModal = _AlcoModal3.default;

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class;
	
	var _ThemeHelper = __webpack_require__(113);
	
	var _ThemeHelper2 = _interopRequireDefault(_ThemeHelper);
	
	var _reactRedux = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Breads: {
	        displayName: 'Breads'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/CartProduct/Breads/Breads.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Breads = _wrapComponent('Breads')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang
	    };
	}), _dec(_class = function (_Component) {
	    (0, _inherits3.default)(Breads, _Component);
	
	    function Breads() {
	        (0, _classCallCheck3.default)(this, Breads);
	        return (0, _possibleConstructorReturn3.default)(this, (Breads.__proto__ || (0, _getPrototypeOf2.default)(Breads)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Breads, [{
	        key: 'render',
	        value: function render() {
	            var View = _ThemeHelper2.default.getViewForComponent('Breads', null, { folderName: 'CartProduct/Breads' });
	
	            return _react3.default.createElement(View, this.props);
	        }
	    }]);
	    return Breads;
	}(_react2.Component)) || _class));
	
	exports.default = Breads;
	module.exports = exports['default'];

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 25.10.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactRouter = __webpack_require__(19);
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Bread: {
	        displayName: 'Bread'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/CartProduct/Breads/default/Bread/Bread.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Bread = _wrapComponent('Bread')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(Bread, _Component);
	
	    function Bread() {
	        (0, _classCallCheck3.default)(this, Bread);
	        return (0, _possibleConstructorReturn3.default)(this, (Bread.__proto__ || (0, _getPrototypeOf2.default)(Bread)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Bread, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                title = _props.title,
	                id = _props.id;
	
	            var toUrl = '/category/' + id + '?limit=' + _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT + '&page=1';
	
	            return _react3.default.createElement(
	                'span',
	                null,
	                _react3.default.createElement(
	                    _reactRouter.Link,
	                    {
	                        to: toUrl,
	                        onClick: function onClick(e) {
	                            return _this2.props.onClick_Link(id, e);
	                        }
	                    },
	                    title
	                )
	            );
	        }
	    }]);
	    return Bread;
	}(_react2.Component), _class.defaultProps = {
	    onClick_Link: function onClick_Link() {}
	}, _temp));
	
	exports.default = Bread;
	module.exports = exports['default'];

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Bread = undefined;
	
	var _Bread2 = __webpack_require__(1623);
	
	var _Bread3 = _interopRequireDefault(_Bread2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Bread = _Bread3.default;

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 25.10.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _Bread = __webpack_require__(1624);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    BreadsView: {
	        displayName: 'BreadsView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/CartProduct/Breads/default/BreadsView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var BreadsView = _wrapComponent('BreadsView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(BreadsView, _Component);
	
	    function BreadsView() {
	        (0, _classCallCheck3.default)(this, BreadsView);
	        return (0, _possibleConstructorReturn3.default)(this, (BreadsView.__proto__ || (0, _getPrototypeOf2.default)(BreadsView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(BreadsView, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                categories = _props.categories,
	                lang = _props.lang,
	                res = void 0;
	
	
	            if (categories) {
	                res = categories.map(function (item, i) {
	                    var title = lang[item.title] || item.title;
	
	                    return _react3.default.createElement(_Bread.Bread, {
	                        key: 'Bread_' + i,
	                        id: item.id,
	                        title: title,
	                        onClick_Link: _this2.props.onClick_Link
	                    });
	                });
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'brand bread' },
	                res
	            );
	        }
	    }]);
	    return BreadsView;
	}(_react2.Component), _class.defaultProps = {
	    onClick_Link: function onClick_Link() {}
	}, _temp));
	
	exports.default = BreadsView;
	module.exports = exports['default'];

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Breads = undefined;
	
	var _Breads2 = __webpack_require__(1622);
	
	var _Breads3 = _interopRequireDefault(_Breads2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Breads = _Breads3.default;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _ThemeHelper = __webpack_require__(113);
	
	var _ThemeHelper2 = _interopRequireDefault(_ThemeHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    FullDescription: {
	        displayName: 'FullDescription'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/CartProduct/FullDescription/FullDescription.js',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var FullDescription = _wrapComponent('FullDescription')(function (_Component) {
	    (0, _inherits3.default)(FullDescription, _Component);
	
	    function FullDescription() {
	        (0, _classCallCheck3.default)(this, FullDescription);
	        return (0, _possibleConstructorReturn3.default)(this, (FullDescription.__proto__ || (0, _getPrototypeOf2.default)(FullDescription)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(FullDescription, [{
	        key: 'render',
	        value: function render() {
	            var View = _ThemeHelper2.default.getViewForComponent('FullDescription', null, { folderName: 'CartProduct/FullDescription' });
	
	            return _react3.default.createElement(View, this.props);
	        }
	    }]);
	    return FullDescription;
	}(_react2.Component));
	
	exports.default = FullDescription;
	module.exports = exports['default'];

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 14.10.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    FullDescriptionView: {
	        displayName: 'FullDescriptionView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/CartProduct/FullDescription/default/FullDescriptionView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var FullDescriptionView = _wrapComponent('FullDescriptionView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(FullDescriptionView, _Component);
	
	    function FullDescriptionView(props) {
	        (0, _classCallCheck3.default)(this, FullDescriptionView);
	        return (0, _possibleConstructorReturn3.default)(this, (FullDescriptionView.__proto__ || (0, _getPrototypeOf2.default)(FullDescriptionView)).call(this, props));
	    }
	
	    (0, _createClass3.default)(FullDescriptionView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                product_detail = _props.product_detail,
	                lang = _props.lang,
	                weight = void 0,
	                weight_unit_id = void 0,
	                vendor = void 0,
	                country_of_origin = void 0,
	                characteristics = [];
	
	            // todo получить отображаемые характеристики товара с АПИ. Прописывать их здесь - не прикольно (с) Илья
	
	            if (product_detail.hasOwnProperty('weight')) {
	                // если свойство есть
	                if (product_detail.weight) {
	                    // если оно объявленно
	                    weight = product_detail.weight;
	                } else {
	                    // если оно не объявленно
	                    weight = 0;
	                }
	            }
	
	            if (product_detail.hasOwnProperty('weight_unit_id')) {
	                // если свойство есть
	                if (product_detail.weight_unit_id) {
	                    // если оно объявленно
	                    weight_unit_id = product_detail.weight_unit_id;
	                } else {
	                    // если оно не объявленно
	                    weight_unit_id = lang['store.full_description.weight_unit_id'];
	                }
	            }
	
	            // если в характеристиках присутствует вес, отобразим его в характеристиках
	            if (product_detail.hasOwnProperty('weight') && product_detail.hasOwnProperty('weight_unit_id')) {
	                characteristics.push(_react3.default.createElement(
	                    'li',
	                    { key: "weight" },
	                    _react3.default.createElement(
	                        'label',
	                        null,
	                        lang['store.common.weight']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'value' },
	                        weight,
	                        ' ',
	                        weight_unit_id
	                    )
	                ));
	            }
	
	            // если есть производитель
	            if (product_detail.hasOwnProperty('vendor')) {
	                if (product_detail.vendor) {
	                    vendor = product_detail.vendor;
	                } else {
	                    vendor = lang['store.full_description.vendor'];
	                }
	                characteristics.push(_react3.default.createElement(
	                    'li',
	                    { key: "vendor" },
	                    _react3.default.createElement(
	                        'label',
	                        null,
	                        lang['store.full_description.vendor']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'value' },
	                        vendor
	                    )
	                ));
	            }
	
	            // если указана страна производства
	            if (product_detail.hasOwnProperty('country_of_origin')) {
	
	                if (product_detail.country_of_origin) {
	                    country_of_origin = product_detail.country_of_origin;
	                } else {
	                    country_of_origin = lang['store.common.russia'];
	                }
	
	                characteristics.push(_react3.default.createElement(
	                    'li',
	                    { key: "country_of_origin" },
	                    _react3.default.createElement(
	                        'label',
	                        null,
	                        lang['store.full_description.country_of_origin']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'value' },
	                        country_of_origin
	                    )
	                ));
	            }
	
	            return _react3.default.createElement(
	                'section',
	                { id: 'single-product-tab' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'containers' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'tab-holder' },
	                        _react3.default.createElement(
	                            'ul',
	                            { className: 'nav nav-tabs simple' },
	                            _react3.default.createElement(
	                                'li',
	                                { className: 'active' },
	                                _react3.default.createElement(
	                                    'a',
	                                    { href: '#additional-info', 'data-toggle': 'tab' },
	                                    lang['store.full_description.сharacteristics']
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'li',
	                                null,
	                                _react3.default.createElement(
	                                    'a',
	                                    { href: '#reviews', 'data-toggle': 'tab' },
	                                    lang['store.full_description.reviews'],
	                                    ' (1)'
	                                )
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'tab-content' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'tab-pane active', id: 'additional-info' },
	                                _react3.default.createElement(
	                                    'ul',
	                                    { className: 'tabled-data' },
	                                    characteristics
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'tab-pane', id: 'reviews' },
	                                _react3.default.createElement(_components2.ShowReview, null),
	                                _react3.default.createElement(_components2.AddReview, null)
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return FullDescriptionView;
	}(_react2.Component), _class.propTypes = {
	    lang: _react2.PropTypes.object
	}, _temp));
	
	exports.default = FullDescriptionView;
	module.exports = exports['default'];

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FullDescription = undefined;
	
	var _FullDescription2 = __webpack_require__(1627);
	
	var _FullDescription3 = _interopRequireDefault(_FullDescription2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.FullDescription = _FullDescription3.default;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class;
	
	var _ThemeHelper = __webpack_require__(113);
	
	var _ThemeHelper2 = _interopRequireDefault(_ThemeHelper);
	
	var _wish_list = __webpack_require__(166);
	
	var _reactRedux = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ShortDescription: {
	        displayName: 'ShortDescription'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/CartProduct/ShortDescription/ShortDescription.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ShortDescription = _wrapComponent('ShortDescription')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {};
	}, { wishListUpdateProduct: _wish_list.wishListUpdateProduct }), _dec(_class = function (_Component) {
	    (0, _inherits3.default)(ShortDescription, _Component);
	
	    function ShortDescription() {
	        (0, _classCallCheck3.default)(this, ShortDescription);
	        return (0, _possibleConstructorReturn3.default)(this, (ShortDescription.__proto__ || (0, _getPrototypeOf2.default)(ShortDescription)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(ShortDescription, [{
	        key: 'render',
	        value: function render() {
	            var View = _ThemeHelper2.default.getViewForComponent('ShortDescription', null, { folderName: 'CartProduct/ShortDescription' });
	            if (this.props.product_detail.catalog.profile.currency_id === 933) {
	                this.props.product_detail.price = parseFloat(this.props.product_detail.price).toFixed(4);
	            } else {
	                this.props.product_detail.price = parseFloat(this.props.product_detail.price).toFixed(2);
	            }
	            return _react3.default.createElement(View, this.props);
	        }
	    }]);
	    return ShortDescription;
	}(_react2.Component)) || _class));
	
	exports.default = ShortDescription;
	module.exports = exports['default'];

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 14.10.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _components2 = __webpack_require__(16);
	
	var _CartProduct = __webpack_require__(749);
	
	__webpack_require__(1068);
	
	var _constants = __webpack_require__(18);
	
	var _reactRouter = __webpack_require__(19);
	
	var _utils = __webpack_require__(386);
	
	var _catalog = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ShortDescriptionView: {
	        displayName: 'ShortDescriptionView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/CartProduct/ShortDescription/default/ShortDescriptionView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ShortDescriptionView = _wrapComponent('ShortDescriptionView')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        categories: state.catalog.categories,
	        lang: state.lang,
	        currency: state.currency
	    };
	}, {
	    refreshCatalog: _catalog.refreshCatalog
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(ShortDescriptionView, _Component);
	
	    function ShortDescriptionView(props) {
	        (0, _classCallCheck3.default)(this, ShortDescriptionView);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ShortDescriptionView.__proto__ || (0, _getPrototypeOf2.default)(ShortDescriptionView)).call(this, props));
	
	        _this.setActiveClick = function (key) {
	            return function (e) {
	                var elem = document.getElementsByName('inset');
	                elem.forEach(function (item) {
	                    item.className = '';
	                });
	                document.getElementById(key).className = 'checked';
	            };
	        };
	
	        _this.state = {
	            countForSendBasket: 1
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(ShortDescriptionView, [{
	        key: 'getRemainder',
	        value: function getRemainder(nestedOffer, quantityParent, product_detail) {
	            var _this2 = this;
	
	            if (nestedOffer.childOffer === null) {
	                return null;
	            }
	            if (nestedOffer.quantity > 0) {
	                var quantity = void 0;
	                var quantityTechCard = void 0;
	                quantity = nestedOffer.quantity;
	                if (nestedOffer.childOffer.modifier_option_id !== null && nestedOffer.childOffer.modOption === null) {
	                    nestedOffer.childOffer.modOption = nestedOffer.childOffer.modifiedOption.reduce(function (mod, modifier) {
	                        if (modifier.id === nestedOffer.childOffer.modifier_option_id) {
	                            return modifier;
	                        }
	                        return mod;
	                    }, null);
	                }
	                if (nestedOffer.childOffer.modOption !== null && nestedOffer.childOffer.type_id !== 5) {
	                    nestedOffer.childOffer.unit = nestedOffer.childOffer.modOption.unit;
	                    if (nestedOffer.childOffer.modOption.storable === true && nestedOffer.childOffer.modOption.storage_strict) {
	                        product_detail.storable = true;
	                        if (nestedOffer.childOffer.modOption.remainder.length === 0) {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        } else if (nestedOffer.childOffer.modOption.remainder[0].quantity > 0) {
	                            if ((nestedOffer.childOffer.modOption.unit_id === 2 || nestedOffer.childOffer.modOption.unit_id === 8) && nestedOffer.childOffer.modOption.weight && nestedOffer.childOffer.modOption.weight > 0) {
	                                quantity = nestedOffer.childOffer.modOption.weight * nestedOffer.quantity;
	                            }
	                            quantity = quantity * quantityParent;
	                            quantityTechCard = Math.floor(nestedOffer.childOffer.modOption.remainder[0].quantity / quantity);
	                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
	                                product_detail.remainder = [{ quantity: quantityTechCard }];
	                            }
	                        } else {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        }
	                    }
	                }
	                if (nestedOffer.childOffer.modOption === null && nestedOffer.childOffer.type_id !== 5) {
	                    if (nestedOffer.childOffer.storable === true && nestedOffer.childOffer.storage_strict) {
	                        product_detail.storable = true;
	                        if (nestedOffer.childOffer.remainder.length === 0) {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        } else if (nestedOffer.childOffer.remainder[0].quantity > 0) {
	                            if ((nestedOffer.childOffer.unit_id === 2 || nestedOffer.childOffer.unit_id === 8) && nestedOffer.childOffer.weight && nestedOffer.childOffer.weight > 0) {
	                                quantity = nestedOffer.childOffer.weight * nestedOffer.quantity;
	                            }
	                            quantity = quantity * quantityParent;
	                            quantityTechCard = Math.floor(nestedOffer.childOffer.remainder[0].quantity / quantity);
	                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
	                                product_detail.remainder = [{ quantity: quantityTechCard }];
	                            }
	                        } else {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        }
	                    }
	                }
	                if (nestedOffer.childOffer.type_id === 5) {
	                    nestedOffer.childOffer.remainder = [];
	                    nestedOffer.childOffer.storable = false;
	                    quantity = nestedOffer.quantity * quantityParent;
	                    nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
	                        _this2.getRemainder(nestedOfferTwo, quantity, product_detail);
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                product_detail = _props.product_detail,
	                lang = _props.lang,
	                currency = _props.currency,
	                categories = product_detail.categories,
	                id_yml = product_detail.id_yml,
	                storable = product_detail.storable,
	                _product_detail$remai = product_detail.remainder,
	                remainder = _product_detail$remai === undefined ? [] : _product_detail$remai,
	                seo = product_detail.seo,
	                vendor = '',
	                old_price = void 0,
	                price = 0,
	                available = lang['store.common.out_of_stock'],
	                child_offers = '',
	                add_to_cart = '';
	
	            var seoH1 = product_detail.name;
	
	            if (product_detail.old_price) {
	                old_price = _react3.default.createElement(
	                    'div',
	                    { className: 'price-prev' },
	                    _react3.default.createElement(_components2.MoneyValue, {
	                        value: product_detail.old_price,
	                        icon: currency.icon,
	                        iconAfterValue: currency.icon_after_value
	                    })
	                );
	            }
	
	            if (product_detail.vendor) {
	                vendor = product_detail.vendor;
	            }
	
	            // округляем число до сотых
	            if (product_detail.price) {
	                price = parseFloat(product_detail.price).toFixed(2);
	            }
	            storable = product_detail.storable && product_detail.storage_strict;
	            if (product_detail.type.slug === 'technology_card') {
	                var quantityTechCard = 1;
	                product_detail.storable = false;
	                product_detail.remainder = [];
	                var childOffers = [];
	                var childOffer = void 0;
	                var childOffersTwo = [];
	                var childOfferTwo = void 0;
	                var priceComponent = 0;
	                var modifierComponent = null;
	                var modifierComponentTwo = null;
	                var storableComponent = false;
	                product_detail.is_quantity_change = false;
	                product_detail.nestedOffers.forEach(function (nestedOffer) {
	                    if (nestedOffer.quantity > 0 && nestedOffer.childOffer) {
	                        modifierComponent = null;
	                        if (nestedOffer.childOffer.type_id === 5) {
	                            nestedOffer.childOffer.remainder = [];
	                            nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
	                                _this3.getRemainder(nestedOfferTwo, nestedOffer.quantity, product_detail);
	                            });
	                        } else {
	                            _this3.getRemainder(nestedOffer, quantityTechCard, product_detail);
	                        }
	                    }
	                    if (nestedOffer.is_quantity_change) {
	                        product_detail.is_quantity_change = true;
	                    }
	                });
	                remainder[0] = product_detail.remainder[0];
	                storable = product_detail.storable;
	                if (product_detail.modifier_option_id !== undefined) {
	                    product_detail.modifier_option.storable = storable;
	                    product_detail.modifier_option.remainder[0] = product_detail.remainder[0];
	                }
	                price = parseFloat(product_detail.price).toFixed(2);
	
	                if (product_detail.show_composition === true) {
	                    var weight = 0;
	                    var countOffers = 0;
	                    child_offers = _react3.default.createElement(
	                        'div',
	                        { className: 'no-margin col-xs-12 col-sn-12 col-md-12', style: { paddingTop: '10px' } },
	                        _react3.default.createElement(
	                            'table',
	                            null,
	                            _react3.default.createElement(
	                                'tbody',
	                                null,
	                                _react3.default.createElement(
	                                    'tr',
	                                    { style: { background: '#E0E0E0' } },
	                                    _react3.default.createElement(
	                                        'th',
	                                        { style: { padding: '5px' } },
	                                        '#'
	                                    ),
	                                    _react3.default.createElement(
	                                        'th',
	                                        { style: { padding: '5px' } },
	                                        lang['store.short_description.component_title']
	                                    ),
	                                    _react3.default.createElement(
	                                        'th',
	                                        { style: { padding: '5px' } },
	                                        lang['store.short_description.quantity']
	                                    )
	                                ),
	                                product_detail.nestedOffers.map(function (item, index) {
	                                    weight = item.quantity;
	                                    if ((item.childOffer.unit.slug === 'kg' || item.childOffer.unit.slug === 'mg') && item.weight && item.weight > 0) {
	                                        weight = item.weight * item.quantity;
	                                        if (item.weight < 0.01 && item.quantity < 1 || item.weight < 1 && item.quantity < 0.01) {
	                                            weight = item.weight * 1;
	                                        }
	                                        if (item.weight < 0.1 && item.quantity < 0.1) {
	                                            weight = item.weight * 1;
	                                        }
	                                    }
	                                    if (item.quantity > 0) {
	                                        countOffers++;
	                                        return _react3.default.createElement(
	                                            'tr',
	                                            { key: index },
	                                            _react3.default.createElement(
	                                                'td',
	                                                { style: { padding: '5px' } },
	                                                countOffers
	                                            ),
	                                            _react3.default.createElement(
	                                                'td',
	                                                { style: { padding: '5px' } },
	                                                item.childOffer.name,
	                                                ' ',
	                                                item.modifierOption ? '(' + item.modifierOption.name + ')' : ''
	                                            ),
	                                            _react3.default.createElement(
	                                                'td',
	                                                { style: {
	                                                        padding: '5px',
	                                                        textAlign: 'center'
	                                                    } },
	                                                weight,
	                                                ' ',
	                                                lang[item.childOffer.unit.title_lang_data]
	                                            )
	                                        );
	                                    }
	                                })
	                            )
	                        )
	                    );
	                    if (countOffers === 0) {
	                        child_offers = '';
	                    }
	                }
	            } else if (product_detail.modifiedOption.length > 0 && (product_detail.modifier_option_id === null || product_detail.modifier_option_id === undefined)) {
	                storable = true;
	                product_detail.modifiedOption.forEach(function (item) {
	                    if (!(item.storable && item.storage_strict && (item.remainder[0] && item.remainder[0].quantity <= 0 || item.remainder.length === 0))) {
	                        storable = false;
	                    }
	                });
	            }
	
	            if (product_detail.available) {
	                available = lang['store.common.in_stock'];
	            }
	            if (storable && (remainder[0] && remainder[0].quantity <= 0 || remainder.length === 0)) {
	                add_to_cart = _react3.default.createElement(
	                    'p',
	                    { className: 'no_good text-theme' },
	                    lang['store.common.product_out_of_stock']
	                );
	            } else {
	                add_to_cart = _react3.default.createElement(
	                    'div',
	                    null,
	                    _react3.default.createElement(_components2.QuantityProduct, {
	                        value: this.state.countForSendBasket,
	                        checkValue: storable && remainder[0] && product_detail.modifiedOption.length === 0 ? true : false,
	                        checkCount: product_detail.remainder[0] !== undefined ? remainder[0].quantity : null,
	                        callback: function callback(newCount) {
	                            _this3.setState({ countForSendBasket: newCount });
	                        } }),
	                    storable && remainder[0] && remainder[0].quantity < this.state.countForSendBasket ? _react3.default.createElement('p', { className: 'no_good' }) : _react3.default.createElement(_components2.AddToBasket, { id: 'addto-cart', className: ['huge'], product: product_detail, count: this.state.countForSendBasket })
	                );
	            }
	
	            if (seo && seo.h1) {
	                // если есть СЕО и в нем есть заголовок
	                seoH1 = seo.h1; // отображаем его
	            } else if (product_detail.name) {
	                // иначе - хватаем оыбчное название товара
	                seoH1 = product_detail.name;
	            }
	            if (product_detail.description !== null && product_detail.description !== '' && product_detail.description.indexOf('href="') !== -1) {
	                product_detail.description = product_detail.description.replace(new RegExp('href="', 'g'), 'href="http://');
	                product_detail.description = product_detail.description.replace(new RegExp('href="http://http', 'g'), 'href="http');
	            }
	            if (product_detail.faq !== null && product_detail.faq !== '' && product_detail.faq.indexOf('href="') !== -1) {
	                product_detail.faq = product_detail.faq.replace(new RegExp('href="', 'g'), 'href="http://');
	                product_detail.faq = product_detail.faq.replace(new RegExp('href="http://http', 'g'), 'href="http');
	            }
	
	            if (product_detail.faq) {
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'no-margin col-xs-12 col-sm-7 body-holder' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'body' },
	                        _react3.default.createElement(_CartProduct.Breads, {
	                            categories: categories,
	                            onClick_Link: function onClick_Link(id, e) {
	                                return _this3.onClick_BreadLink(id, e);
	                            }
	                        }),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'tabs' },
	                            _react3.default.createElement('input', { type: 'radio', name: 'inset', value: '', id: 'tab_1', className: 'checked' }),
	                            _react3.default.createElement(
	                                'label',
	                                { htmlFor: 'tab_2', onClick: this.setActiveClick('tab_1') },
	                                lang['store.short_description.description']
	                            ),
	                            _react3.default.createElement('input', { type: 'radio', name: 'inset', value: '', id: 'tab_2' }),
	                            _react3.default.createElement(
	                                'label',
	                                { htmlFor: 'tab_1', onClick: this.setActiveClick('tab_2') },
	                                lang['store.short_description.faq']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { id: 'txt_1' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'title' },
	                                    _react3.default.createElement(
	                                        'h1',
	                                        { className: 'text-theme' },
	                                        seoH1
	                                    )
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'brand' },
	                                    vendor
	                                ),
	                                _react3.default.createElement(_components2.SocialRow, { product: product_detail }),
	                                _react3.default.createElement(_components2.ProductWishIcon, { product: product_detail, isCartProduct: true }),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'vendor_code' },
	                                    _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        lang['store.common.product_vendor_code'],
	                                        ': '
	                                    ),
	                                    _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        id_yml
	                                    )
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'excerpt' },
	                                    _react3.default.createElement('p', { dangerouslySetInnerHTML: { __html: product_detail.description } })
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { id: 'txt_2' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'excerpt' },
	                                    _react3.default.createElement('p', { dangerouslySetInnerHTML: { __html: product_detail.faq } })
	                                )
	                            )
	                        ),
	                        child_offers,
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'prices text-theme' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'price-current text-theme' },
	                                _react3.default.createElement(_components2.MoneyValue, {
	                                    value: price,
	                                    icon: currency.icon,
	                                    iconAfterValue: currency.icon_after_value
	                                })
	                            ),
	                            old_price
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'qnt-holder' },
	                            add_to_cart
	                        )
	                    )
	                );
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'no-margin col-xs-12 col-sm-7 body-holder' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'body' },
	                    _react3.default.createElement(_CartProduct.Breads, {
	                        categories: categories,
	                        onClick_Link: function onClick_Link(id, e) {
	                            return _this3.onClick_BreadLink(id, e);
	                        }
	                    }),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        _react3.default.createElement(
	                            'h1',
	                            { className: 'text-theme' },
	                            seoH1
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'brand' },
	                        vendor
	                    ),
	                    _react3.default.createElement(_components2.SocialRow, { product: product_detail }),
	                    _react3.default.createElement(_components2.ProductWishIcon, { product: product_detail, isCartProduct: true }),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'vendor_code' },
	                        _react3.default.createElement(
	                            'span',
	                            null,
	                            lang['store.common.product_vendor_code'],
	                            ': '
	                        ),
	                        _react3.default.createElement(
	                            'span',
	                            null,
	                            id_yml
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'excerpt' },
	                        _react3.default.createElement('p', { dangerouslySetInnerHTML: { __html: product_detail.description } })
	                    ),
	                    child_offers,
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'prices text-theme' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'price-current text-theme' },
	                            _react3.default.createElement(_components2.MoneyValue, {
	                                value: this.props.product_detail.price,
	                                icon: currency.icon,
	                                iconAfterValue: currency.icon_after_value
	                            })
	                        ),
	                        old_price
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'qnt-holder' },
	                        add_to_cart
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'onClick_BreadLink',
	        value: function onClick_BreadLink(id, e) {
	            var _this4 = this;
	
	            e.preventDefault();
	            if (id == null) {
	                return;
	            }
	            this.props.refreshCatalog().then(function () {
	                var found = (0, _utils.findCategoryDeep)(_this4.props.categories, id);
	                if (found != null) {
	                    _reactRouter.browserHistory.push('/category/' + id + '?limit=' + _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT + '&page=1');
	                } else {
	                    _reactRouter.browserHistory.push('/');
	                }
	            });
	        }
	    }]);
	    return ShortDescriptionView;
	}(_react2.Component), _class2.propTypes = {
	    lang: _react2.PropTypes.object.isRequired,
	    currency: _react2.PropTypes.object.isRequired
	}, _temp)) || _class));
	
	exports.default = ShortDescriptionView;
	module.exports = exports['default'];

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShortDescription = undefined;
	
	var _ShortDescription2 = __webpack_require__(1630);
	
	var _ShortDescription3 = _interopRequireDefault(_ShortDescription2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ShortDescription = _ShortDescription3.default;

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _ThemeHelper = __webpack_require__(113);
	
	var _ThemeHelper2 = _interopRequireDefault(_ThemeHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Slider: {
	        displayName: 'Slider'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/CartProduct/Slider/Slider.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Slider = _wrapComponent('Slider')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        currency: state.currency,
	        lang: state.lang
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Slider, _Component);
	
	    function Slider() {
	        (0, _classCallCheck3.default)(this, Slider);
	        return (0, _possibleConstructorReturn3.default)(this, (Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Slider, [{
	        key: 'render',
	        value: function render() {
	            var View = _ThemeHelper2.default.getViewForComponent('Slider', null, { folderName: 'CartProduct/Slider' });
	
	            return _react3.default.createElement(View, this.props);
	        }
	    }]);
	    return Slider;
	}(_react2.Component), _class2.propTypes = {
	    currency: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Slider;
	module.exports = exports['default'];

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 21.10.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Slide: {
	        displayName: 'Slide'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/CartProduct/Slider/default/Slide/Slide.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Slide = _wrapComponent('Slide')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(Slide, _Component);
	
	    function Slide() {
	        (0, _classCallCheck3.default)(this, Slide);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Slide.__proto__ || (0, _getPrototypeOf2.default)(Slide)).call(this));
	
	        _this.handleOnLoadImg = function (e) {
	            _this.setState({ imgLoad: true });
	        };
	
	        _this.clickChangeSlide = function () {
	            var changeSlide = _this.props.changeSlide;
	
	            changeSlide(_this.props.id);
	        };
	
	        _this.clickOnActiveSlide = function () {
	            var clickOnActive = _this.props.clickOnActive;
	
	            clickOnActive();
	        };
	
	        _this.state = { imgLoad: false };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Slide, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                type = _props.type,
	                src = _props.src,
	                active = _props.active,
	                firstImg = _props.firstImg,
	                realImg = _props.realImg,
	                slide = void 0;
	            var imgLoad = this.state.imgLoad;
	
	
	            if (type == 'big') {
	                if (false) {
	                    slide = _react3.default.createElement(
	                        'span',
	                        { className: 'link' },
	                        _react3.default.createElement(
	                            'a',
	                            { onClick: this.clickOnActiveSlide },
	                            _react3.default.createElement('img', {
	                                className: 'img-responsive flying-to-cart-img',
	                                alt: '',
	                                src: src
	                            })
	                        )
	                    );
	                } else {
	                    slide = _react3.default.createElement(
	                        'span',
	                        { className: 'link' },
	                        _react3.default.createElement(
	                            'a',
	                            { onClick: this.clickOnActiveSlide },
	                            _react3.default.createElement('img', {
	                                onLoad: this.handleOnLoadImg,
	                                className: 'img-responsive flying-to-cart-img ' + (!imgLoad ? "hidden" : ""),
	                                alt: '',
	                                src: src
	                            }),
	                            _react3.default.createElement(_components2.Preloader, { preload: !imgLoad })
	                        )
	                    );
	                }
	            } else if (type == 'small') {
	                slide = _react3.default.createElement(
	                    'span',
	                    null,
	                    _react3.default.createElement(
	                        'a',
	                        { className: 'horizontal-thumb', onClick: this.clickChangeSlide },
	                        _react3.default.createElement('img', { className: active ? "active" : "", width: '67', alt: '', src: src })
	                    )
	                );
	            }
	
	            return _react3.default.createElement(
	                'span',
	                { className: 'image_small_holder' },
	                slide
	            );
	        }
	    }]);
	    return Slide;
	}(_react2.Component), _class.propTypes = {
	    type: _react2.PropTypes.string.isRequired,
	    active: _react2.PropTypes.bool,
	    id: _react2.PropTypes.number,
	    src: _react2.PropTypes.string.isRequired,
	    changeSlide: _react2.PropTypes.func,
	    clickOnActive: _react2.PropTypes.func
	}, _temp));
	
	exports.default = Slide;
	module.exports = exports['default'];

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slide = undefined;
	
	var _Slide2 = __webpack_require__(1634);
	
	var _Slide3 = _interopRequireDefault(_Slide2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Slide = _Slide3.default;

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactYoutube = __webpack_require__(1492);
	
	var _reactYoutube2 = _interopRequireDefault(_reactYoutube);
	
	var _Slide = __webpack_require__(1635);
	
	var _index = __webpack_require__(16);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SliderView: {
	        displayName: 'SliderView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/CartProduct/Slider/default/SliderView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MAX_COUNT_BIG_SLIDER = 8;
	var MAX_COUNT_SMAL_SLIDER = 5;
	
	var SliderView = _wrapComponent('SliderView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(SliderView, _Component);
	
	    function SliderView(props) {
	        (0, _classCallCheck3.default)(this, SliderView);
	
	        // вызовем родительский конструктор, чтобы ничего не сломалось
	        var _this = (0, _possibleConstructorReturn3.default)(this, (SliderView.__proto__ || (0, _getPrototypeOf2.default)(SliderView)).call(this, props));
	
	        _this.getVideoId = function (url) {
	            if (url.includes('youtube')) {
	                return url.substr(url.indexOf('=') + 1);
	            } else if (url.includes('youtu.be')) {
	                return url.split('/').reverse()[0];
	            }
	        };
	
	        _this.state = {
	            countForSendBasket: 1
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(SliderView, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                product_detail = _props.product_detail,
	                clickOnActive = _props.clickOnActive,
	                clickOnVideo = _props.clickOnVideo,
	                full_screen_mode = _props.full_screen_mode,
	                video_mode = _props.video_mode,
	                start_index_preview = _props.start_index_preview,
	                currency = _props.currency,
	                lang = _props.lang,
	                pictures = product_detail.pictures,
	                withVideo = product_detail.url_video_review && product_detail.url_video_review.length > 0,
	                video = withVideo ? _react3.default.createElement(
	                'div',
	                { className: 'descr-video', onClick: clickOnVideo },
	                ' ',
	                lang['store.common.video'],
	                ' '
	            ) : null;
	
	
	            var active = void 0,
	                result_active = void 0,
	                preview = void 0,
	                previews = void 0,
	                old_price = void 0,
	                price = 0,
	                next = void 0,
	                prev = void 0;
	            var itr = 0,
	                countPreview = 0;
	            var imgSrc = '/assets/images/placeholder.png';
	
	            // Приводим к типу int и округляем число до сотых
	            if (product_detail.price) {
	                price = parseInt(product_detail.price).toFixed(2);
	            }
	
	            if (pictures || video_mode) {
	                var firstImg = product_detail.pictures[0] && product_detail.pictures[0].id || imgSrc;
	                if (!video_mode || !full_screen_mode) {
	                    active = pictures.map(function (item, i) {
	                        // Устанавливаем активный слайд
	                        if (item.id == _this2.props.active_slide) {
	                            return _react3.default.createElement(_Slide.Slide, {
	                                key: "Slide_active_" + i,
	                                type: 'big',
	                                src: item.url,
	                                clickOnActive: clickOnActive,
	                                firstImg: firstImg,
	                                realImg: item.id });
	                        }
	                    });
	                } else {
	
	                    active = _react3.default.createElement(
	                        'div',
	                        { className: 'active-video' },
	                        _react3.default.createElement(_reactYoutube2.default, {
	                            videoId: this.getVideoId(product_detail.url_video_review),
	                            onReady: function onReady(event) {
	                                return event.target.pauseVideo();
	                            }
	                        })
	                    );
	                }
	
	                if (!full_screen_mode && pictures) {
	                    // для маленького слайдера
	                    if (pictures.length > 1) {
	                        result_active = _react3.default.createElement(
	                            'div',
	                            { id: 'owl-single-product' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'prev', onClick: function onClick() {
	                                        _this2.props.clickOnPrev(countPreview);
	                                    } },
	                                _react3.default.createElement('img', { src: '/assets/images/prev.svg', alt: '' })
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'single-product-gallery-item not_full_slider', id: 'slide1' },
	                                active
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'next', onClick: function onClick() {
	                                        _this2.props.clickOnNext(countPreview);
	                                    } },
	                                _react3.default.createElement('img', { src: '/assets/images/next.svg', alt: '' })
	                            )
	                        );
	                    } else if (pictures.length === 1) {
	                        result_active = _react3.default.createElement(
	                            'div',
	                            { id: 'owl-single-product' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'single-product-gallery-item not_full_slider', id: 'slide1' },
	                                active
	                            )
	                        );
	                    } else if (pictures.length === 0) {
	                        result_active = _react3.default.createElement(
	                            'div',
	                            { id: 'owl-single-product' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'single-product-gallery-item not_full_slider', id: 'slide1' },
	                                _react3.default.createElement(_Slide.Slide, {
	                                    type: 'big',
	                                    src: imgSrc,
	                                    clickOnActive: function clickOnActive() {}
	                                })
	                            )
	                        );
	                    }
	                }
	
	                preview = pictures.map(function (item, i) {
	
	                    if (i >= start_index_preview) {
	                        if (!full_screen_mode) {
	                            countPreview = MAX_COUNT_SMAL_SLIDER; // для неполноэкранного режима отображаем 5 превьюх
	                        } else {
	                            countPreview = MAX_COUNT_BIG_SLIDER; // для полноэкранного режима отображаем 8 превьюх
	                        }
	                        if (withVideo) {
	                            countPreview--;
	                        }
	
	                        if (itr < countPreview) {
	                            ++itr;
	                            return _react3.default.createElement(_Slide.Slide, {
	                                key: "Slide_" + i,
	                                active: item.id == _this2.props.active_slide,
	                                type: 'small',
	                                id: item.id,
	                                src: item.preview_url,
	                                changeSlide: _this2.props.handleChangeSlide });
	                        }
	                    }
	                });
	            }
	
	            if (preview.length > 1) {
	                if (full_screen_mode) {
	                    previews = _react3.default.createElement(
	                        'div',
	                        { className: 'slide-container' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'center ' + (withVideo ? 'with-video' : '') },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'small-prev', onClick: this.props.clickOnPrevPreview },
	                                _react3.default.createElement('img', { src: '/assets/images/prev.svg', alt: '' })
	                            ),
	                            preview,
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'small-next', onClick: function onClick() {
	                                        _this2.props.clickOnNextPreview(countPreview);
	                                    } },
	                                _react3.default.createElement('img', { src: '/assets/images/next.svg', alt: '' })
	                            )
	                        ),
	                        video
	                    );
	                } else {
	                    previews = _react3.default.createElement(
	                        'div',
	                        { className: 'slide-container' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'center ' + (withVideo ? 'with-video' : '') },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'small-prev', onClick: this.props.clickOnPrevPreview },
	                                _react3.default.createElement('img', { src: '/assets/images/prev.svg', alt: '' })
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'single-product-gallery-thumbs gallery-thumbs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { id: 'owl-single-product-thumbnails' },
	                                    preview
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'small-next', onClick: function onClick() {
	                                        _this2.props.clickOnNextPreview(countPreview);
	                                    } },
	                                _react3.default.createElement('img', { src: '/assets/images/next.svg', alt: '' })
	                            )
	                        ),
	                        video
	                    );
	                }
	            } else if (preview.length == 1 && full_screen_mode && withVideo) {
	                previews = _react3.default.createElement(
	                    'div',
	                    { className: 'slide-container' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'center with-video' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'single-product-gallery-thumbs gallery-thumbs' },
	                            _react3.default.createElement(
	                                'div',
	                                { id: 'owl-single-product-thumbnails' },
	                                preview
	                            )
	                        )
	                    ),
	                    video
	                );
	            } else if (withVideo) {
	                previews = _react3.default.createElement(
	                    'div',
	                    { className: 'slide-container' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'center' },
	                        video
	                    )
	                );
	            }
	
	            if (full_screen_mode) {
	                // полноэкранный режим слайдера
	                if (product_detail.old_price) {
	                    old_price = _react3.default.createElement(
	                        'div',
	                        { className: 'price-prev' },
	                        _react3.default.createElement(_components2.MoneyValue, {
	                            value: product_detail.old_price,
	                            icon: currency.icon,
	                            iconAfterValue: currency.icon_after_value
	                        })
	                    );
	                }
	
	                if (pictures.length > 1 && !video_mode) {
	                    prev = _react3.default.createElement(
	                        'span',
	                        { className: 'prev', onClick: function onClick() {
	                                _this2.props.clickOnPrev(countPreview);
	                            } },
	                        _react3.default.createElement('img', { src: '/assets/images/prev.svg', alt: '' })
	                    );
	
	                    next = _react3.default.createElement(
	                        'span',
	                        { className: 'next', onClick: function onClick() {
	                                _this2.props.clickOnNext(countPreview);
	                            } },
	                        _react3.default.createElement('img', { src: '/assets/images/next.svg', alt: '' })
	                    );
	                }
	
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    prev,
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'product-item-holder size-big single-product-gallery small-gallery' },
	                        _react3.default.createElement(
	                            'div',
	                            { id: 'owl-single-product', className: 'flying-to-cart-holder' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'single-product-gallery-item big', id: 'slide1' },
	                                active
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'row bottom-active' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-lg-6' },
	                                    previews
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-12 col-lg-6 counter' },
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'body-holder', id: 'active' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'body' },
	                                            _react3.default.createElement(
	                                                'div',
	                                                { className: 'prices' },
	                                                _react3.default.createElement(
	                                                    'div',
	                                                    { className: 'price-current' },
	                                                    _react3.default.createElement(_components2.MoneyValue, {
	                                                        value: price,
	                                                        icon: currency.icon,
	                                                        iconAfterValue: currency.icon_after_value
	                                                    })
	                                                ),
	                                                old_price
	                                            ),
	                                            _react3.default.createElement(
	                                                'div',
	                                                { className: 'qnt-holder' },
	                                                _react3.default.createElement(_index.QuantityProduct, { value: this.state.countForSendBasket,
	                                                    callback: function callback(newCount) {
	                                                        _this2.setState({ countForSendBasket: newCount });
	                                                    } }),
	                                                _react3.default.createElement(_index.AddToBasket, { id: 'addto-cart', product: product_detail,
	                                                    className: ['huge'],
	                                                    count: this.state.countForSendBasket })
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    next,
	                    _react3.default.createElement(
	                        'span',
	                        { className: 'close' },
	                        _react3.default.createElement('i', { className: 'fa fa-times fa-6', onClick: clickOnActive, 'aria-hidden': 'true' })
	                    )
	                );
	            } else {
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-12 col-md-5 gallery-holder' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'product-item-holder size-big single-product-gallery small-gallery' },
	                        result_active,
	                        previews
	                    )
	                );
	            }
	        }
	    }]);
	    return SliderView;
	}(_react2.Component), _class.propTypes = {
	    currency: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object
	}, _temp));
	
	exports.default = SliderView;
	module.exports = exports['default'];

/***/ }),
/* 1637 */
[2027, 1633],
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _ThemeHelper = __webpack_require__(113);
	
	var _ThemeHelper2 = _interopRequireDefault(_ThemeHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Stars: {
	        displayName: 'Stars'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/CartProduct/Stars/Stars.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Stars = _wrapComponent('Stars')(function (_Component) {
	    (0, _inherits3.default)(Stars, _Component);
	
	    function Stars() {
	        (0, _classCallCheck3.default)(this, Stars);
	        return (0, _possibleConstructorReturn3.default)(this, (Stars.__proto__ || (0, _getPrototypeOf2.default)(Stars)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Stars, [{
	        key: 'render',
	        value: function render() {
	            var View = _ThemeHelper2.default.getViewForComponent('Stars', null, { folderName: 'CartProduct/Stars' });
	
	            return _react3.default.createElement(View, this.props);
	        }
	    }]);
	    return Stars;
	}(_react2.Component));
	
	exports.default = Stars;
	module.exports = exports['default'];

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    StarsView: {
	        displayName: 'StarsView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/CartProduct/Stars/default/StarsView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var StarsView = _wrapComponent('StarsView')(function (_Component) {
	    (0, _inherits3.default)(StarsView, _Component);
	
	    function StarsView() {
	        (0, _classCallCheck3.default)(this, StarsView);
	        return (0, _possibleConstructorReturn3.default)(this, (StarsView.__proto__ || (0, _getPrototypeOf2.default)(StarsView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(StarsView, [{
	        key: 'render',
	        value: function render() {
	            // todo количество звезд получить с API, их количество отображать по какой-то логике (с) Илья
	            return _react3.default.createElement(
	                'div',
	                { className: 'star-holder inline' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'star', 'data-score': '4' },
	                    _react3.default.createElement('img', { src: '../assets/images/star-on.png', alt: '1' }),
	                    _react3.default.createElement('img', { src: '../assets/images/star-on.png', alt: '1' }),
	                    _react3.default.createElement('img', { src: '../assets/images/star-on.png', alt: '1' }),
	                    _react3.default.createElement('img', { src: '../assets/images/star-on.png', alt: '1' }),
	                    _react3.default.createElement('img', { src: '../assets/images/star-off.png', alt: '1' })
	                )
	            );
	        }
	    }]);
	    return StarsView;
	}(_react2.Component));
	
	exports.default = StarsView;
	module.exports = exports['default'];

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Stars = undefined;
	
	var _Stars2 = __webpack_require__(1638);
	
	var _Stars3 = _interopRequireDefault(_Stars2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Stars = _Stars3.default;

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(750);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChooserClassColor = function () {
	    function ChooserClassColor() {
	        (0, _classCallCheck3.default)(this, ChooserClassColor);
	
	        this.themesClass = ['green-theme', 'blue-theme', 'orange-theme', 'red-theme', 'navy-theme', 'dark-green-theme', 'dark-theme'];
	    }
	
	    (0, _createClass3.default)(ChooserClassColor, [{
	        key: 'chooseClass',
	        value: function chooseClass(color) {
	            if (true) {
	                var doc = window.document.getElementsByTagName('body')[0];
	                this.themesClass.forEach(function (item) {
	                    doc.classList.remove(item);
	                });
	                switch (color) {
	                    case _constants.GREEN:
	                        doc.classList.add('green-theme');
	                        break;
	                    case _constants.BLUE:
	                        doc.classList.add('blue-theme');
	                        break;
	                    case _constants.ORANGE:
	                        doc.classList.add('orange-theme');
	                        break;
	                    case _constants.RED:
	                        doc.classList.add('red-theme');
	                        break;
	                    case _constants.NAVY:
	                        doc.classList.add('navy-theme');
	                        break;
	                    case _constants.DARK_THEME:
	                        doc.classList.add('dark-theme');
	                        break;
	                }
	            }
	        }
	    }]);
	    return ChooserClassColor;
	}();
	
	exports.default = ChooserClassColor;
	module.exports = exports['default'];

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _ChooserClassColor = __webpack_require__(1641);
	
	var _ChooserClassColor2 = _interopRequireDefault(_ChooserClassColor);
	
	var _constants = __webpack_require__(750);
	
	__webpack_require__(1069);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ColorChooser: {
	        displayName: 'ColorChooser'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/ColorChooser/index.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ColorChooser = _wrapComponent('ColorChooser')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(ColorChooser, _Component);
	
	    function ColorChooser() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, ColorChooser);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ColorChooser.__proto__ || (0, _getPrototypeOf2.default)(ColorChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (color) {
	            new _ChooserClassColor2.default().chooseClass(color);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(ColorChooser, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'color-chooser' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'color-chooser-options' },
	                    _react3.default.createElement(
	                        'ul',
	                        { className: 'list-unstyled' },
	                        _react3.default.createElement(
	                            'li',
	                            null,
	                            _react3.default.createElement(
	                                'a',
	                                { className: 'changecolor', href: '#', title: '\u0417\u0435\u043B\u0451\u043D\u044B\u0439', onClick: function onClick(e) {
	                                        e.preventDefault();
	                                        _this2.onClick(_constants.GREEN);
	                                    } },
	                                _react3.default.createElement('div', { className: 'color-box color-box-green' })
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'li',
	                            null,
	                            _react3.default.createElement(
	                                'a',
	                                { className: 'changecolor', href: '#', title: '\u0413\u043E\u043B\u0443\u0431\u043E\u0439', onClick: function onClick(e) {
	                                        e.preventDefault();
	                                        _this2.onClick(_constants.BLUE);
	                                    } },
	                                _react3.default.createElement('div', { className: 'color-box color-box-blue' })
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'li',
	                            null,
	                            _react3.default.createElement(
	                                'a',
	                                { className: 'changecolor', href: '#', title: '\u041A\u0440\u0430\u0441\u043D\u044B\u0439', onClick: function onClick(e) {
	                                        e.preventDefault();
	                                        _this2.onClick(_constants.RED);
	                                    } },
	                                _react3.default.createElement('div', { className: 'color-box color-box-red' })
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'li',
	                            null,
	                            _react3.default.createElement(
	                                'a',
	                                { className: 'changecolor', href: '#', title: '\u041E\u0440\u0430\u043D\u0436\u0435\u0432\u044B\u0439', onClick: function onClick(e) {
	                                        e.preventDefault();
	                                        _this2.onClick(_constants.ORANGE);
	                                    } },
	                                _react3.default.createElement('div', { className: 'color-box color-box-orange' })
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'li',
	                            null,
	                            _react3.default.createElement(
	                                'a',
	                                { className: 'changecolor', href: '#', title: '>\u0422\u0435\u043C\u043D\u043E-\u0441\u0438\u043D\u0438\u0439', onClick: function onClick(e) {
	                                        e.preventDefault();
	                                        _this2.onClick(_constants.NAVY);
	                                    } },
	                                _react3.default.createElement('div', { className: 'color-box color-box-navy' })
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'li',
	                            null,
	                            _react3.default.createElement(
	                                'a',
	                                { className: 'changecolor', href: '#', title: '\u0422\u0435\u043C\u043D\u043E-\u0437\u0435\u043B\u0451\u043D\u044B\u0439', onClick: function onClick(e) {
	                                        e.preventDefault();
	                                        _this2.onClick(_constants.DARK_GREEN);
	                                    } },
	                                _react3.default.createElement('div', { className: 'color-box color-box-dark-green' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return ColorChooser;
	}(_react2.Component), _class.propTypes = {}, _temp2));
	
	exports.default = ColorChooser;
	module.exports = exports['default'];

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(102);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _user = __webpack_require__(115);
	
	var _BaseForm2 = __webpack_require__(66);
	
	var _BaseForm3 = _interopRequireDefault(_BaseForm2);
	
	var _modal = __webpack_require__(26);
	
	var _voice_code = __webpack_require__(141);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmChangePhone = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        error: state.user.error,
	        errorCode: state.user.errorCode,
	        preload: state.user.preload,
	        changeWithCode: state.user.changeWithCode,
	        user: state.user,
	        profile: state.auth.user,
	        lang: state.lang
	    };
	}, { changePhoneWithCode: _user.changePhoneWithCode, resetError: _user.resetError, resetVoiceCode: _voice_code.resetVoiceCode, hide: _modal.hide }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
	    (0, _inherits3.default)(ConfirmChangePhone, _BaseForm);
	
	    function ConfirmChangePhone(props, context) {
	        (0, _classCallCheck3.default)(this, ConfirmChangePhone);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ConfirmChangePhone.__proto__ || (0, _getPrototypeOf2.default)(ConfirmChangePhone)).call(this, props, context));
	
	        _this.handlerChangeInput = function (event) {
	            _this.setState({
	                sms: event.target.value
	            });
	        };
	
	        _this.showOuterAlert = function (alert) {
	            _this.setState({ outerAlert: alert });
	        };
	
	        _this.state = {
	            sms: '',
	            outerAlert: null
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(ConfirmChangePhone, [{
	        key: 'onSubmit',
	        value: function onSubmit(event) {
	            (0, _get3.default)(ConfirmChangePhone.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConfirmChangePhone.prototype), 'onSubmit', this).call(this, event);
	
	            if (this.isValid()) {
	                this.props.changePhoneWithCode(this.props.pipoId, this.props.newPhone, this.state.sms);
	                this.props.resetError();
	                this.props.resetVoiceCode();
	                this.setState({
	                    sms: ''
	                });
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            var changeWithCode = this.props.changeWithCode;
	
	
	            if (changeWithCode !== nextProps.changeWithCode && nextProps.changeWithCode) {
	                this.props.hide();
	                setTimeout(function () {
	                    _reactSAlert2.default.success(_this2.props.succesOperationText, { position: 'top-right', effect: 'slide', timeout: 5000 });
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.resetError();
	            this.props.resetVoiceCode();
	        }
	
	        /**
	         * Валидация по всем методам проверки
	         *
	         * @returns {boolean}
	         */
	
	    }, {
	        key: 'isValid',
	        value: function isValid() {
	            return this.state.sms.length > 0;
	        }
	    }, {
	        key: 'getLogin',
	        value: function getLogin() {
	            var profile = this.props.profile;
	
	
	            return profile.confirmed.confirmed_email ? profile.email : profile.confirmed.confirmed_phone ? profile.phone : profile.phone ? profile.phone : profile.email;
	        }
	
	        /**
	         * Получение номера телефона пользователя
	         * @returns {*}
	         */
	
	    }, {
	        key: 'getUserPhone',
	        value: function getUserPhone() {
	            var phone = this.props.profile.phone;
	            return phone ? phone : this.props.newPhone;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('ConfirmChangePhone', null, { folderName: "ConfirmChangePhone" });
	
	            return _react2.default.createElement(View, {
	                sms: this.state.sms,
	                onSubmit: this.onSubmit,
	                disabledSubmit: !this.isValid(),
	                preload: this.props.preload,
	                error: this.props.error,
	                onChange: this.handlerChangeInput,
	                showOuterAlert: this.showOuterAlert,
	                outerAlert: this.state.outerAlert,
	                login: this.getLogin(),
	                phone: this.getUserPhone(),
	                errorCode: this.props.errorCode,
	                lang: this.props.lang
	            });
	        }
	    }]);
	    return ConfirmChangePhone;
	}(_BaseForm3.default), _class2.propTypes = {
	    lang: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = ConfirmChangePhone;
	module.exports = exports['default'];

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _utils = __webpack_require__(31);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ConfirmChangePhoneView: {
	        displayName: 'ConfirmChangePhoneView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/ConfirmChangePhone/default/ConfirmChangePhoneView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ConfirmChangePhoneView = _wrapComponent('ConfirmChangePhoneView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(ConfirmChangePhoneView, _Component);
	
	    function ConfirmChangePhoneView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, ConfirmChangePhoneView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmChangePhoneView.__proto__ || (0, _getPrototypeOf2.default)(ConfirmChangePhoneView)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
	            event.preventDefault();
	            _this.props.onSubmit(event);
	        }, _this.showAlert = function (alert) {
	            var _this$props = _this.props,
	                error = _this$props.error,
	                errorCode = _this$props.errorCode,
	                lang = _this$props.lang;
	
	
	            if (error) {
	                if (errorCode === null || errorCode === undefined) {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang['store.common.server_is_unavailable']
	                    );
	                } else {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang[error]
	                    );
	                }
	            } else if (_this.props.alert || alert) {
	                var _ref2 = _this.props.alert || alert,
	                    message = _ref2.message,
	                    style = _ref2.style;
	
	                return _react3.default.createElement(
	                    _reactBootstrap.Alert,
	                    { bsStyle: style || 'danger', className: 'inner-right-xs' },
	                    message
	                );
	            }
	
	            return '';
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(ConfirmChangePhoneView, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var lang = this.props.lang;
	
	
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload },
	                this.props.outerAlert ? this.showAlert(this.props.outerAlert) : this.showAlert(),
	                _react3.default.createElement(
	                    'section',
	                    { id: 'registration-form' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'bordered' },
	                        _react3.default.createElement(
	                            _reactBootstrap.Form,
	                            { onSubmit: this.onSubmit },
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { controlId: 'sms' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.ControlLabel,
	                                    null,
	                                    lang['store.common.enter_sms_code']
	                                ),
	                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                    type: (0, _utils.isMobileDevice)() ? "number" : "text",
	                                    pattern: '\\d*',
	                                    placeholder: '1234',
	                                    value: this.props.sms,
	                                    onChange: function onChange(e) {
	                                        if ((0, _utils.validateNumeric)(e.target.value)) {
	                                            _this2.props.onChange(e);
	                                        }
	                                    }
	                                })
	                            ),
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                null,
	                                _react3.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        type: 'submit',
	                                        className: 'form-control',
	                                        bsStyle: 'primary',
	                                        disabled: this.props.disabledSubmit
	                                    },
	                                    lang['store.common.confirm']
	                                )
	                            ),
	                            _react3.default.createElement(_components2.VoiceCode, {
	                                login: this.props.login,
	                                phone: this.props.phone,
	                                source: 'change_phone',
	                                showAlert: this.props.showOuterAlert,
	                                whiteList: true
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return ConfirmChangePhoneView;
	}(_react2.Component), _class.propTypes = {
	    sms: _react2.PropTypes.string.isRequired,
	    onSubmit: _react2.PropTypes.func.isRequired,
	    disabledSubmit: _react2.PropTypes.bool.isRequired,
	    error: _react2.PropTypes.string,
	    lang: _react2.PropTypes.object
	}, _temp2));
	
	exports.default = ConfirmChangePhoneView;
	module.exports = exports['default'];

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConfirmChangePhone = undefined;
	
	var _ConfirmChangePhone2 = __webpack_require__(1643);
	
	var _ConfirmChangePhone3 = _interopRequireDefault(_ConfirmChangePhone2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ConfirmChangePhone = _ConfirmChangePhone3.default;

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(102);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _user = __webpack_require__(115);
	
	var _BaseForm2 = __webpack_require__(66);
	
	var _BaseForm3 = _interopRequireDefault(_BaseForm2);
	
	var _modal = __webpack_require__(26);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmMail = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        error: state.user.error,
	        errorCode: state.user.errorCode,
	        preload: state.user.preload,
	        changeWithCode: state.user.changeWithCode,
	        lang: state.lang
	    };
	}, { changeMailWithCode: _user.changeMailWithCode, resetError: _user.resetError, hide: _modal.hide }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
	    (0, _inherits3.default)(ConfirmMail, _BaseForm);
	
	    function ConfirmMail(props, context) {
	        (0, _classCallCheck3.default)(this, ConfirmMail);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ConfirmMail.__proto__ || (0, _getPrototypeOf2.default)(ConfirmMail)).call(this, props, context));
	
	        _this.handlerChangeInput = function (event) {
	            _this.setState({
	                code: event.target.value
	            });
	        };
	
	        _this.state = {
	            code: ''
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(ConfirmMail, [{
	        key: 'onSubmit',
	        value: function onSubmit(event) {
	            (0, _get3.default)(ConfirmMail.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConfirmMail.prototype), 'onSubmit', this).call(this, event);
	
	            if (this.isValid()) {
	                this.props.changeMailWithCode(this.props.pipoId, this.props.newMail, this.state.code);
	                this.props.resetError();
	                this.setState({
	                    code: ''
	                });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.resetError();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _props = this.props,
	                changeWithCode = _props.changeWithCode,
	                lang = _props.lang;
	
	
	            if (changeWithCode !== nextProps.changeWithCode && nextProps.changeWithCode) {
	                this.props.hide();
	                setTimeout(function () {
	                    _reactSAlert2.default.success(lang['store.confirm_mail.success'], { position: 'top-right', effect: 'slide', timeout: 5000 });
	                }, 1000);
	            }
	        }
	
	        /**
	         * Валидация по всем методам проверки
	         *
	         * @returns {boolean}
	         */
	
	    }, {
	        key: 'isValid',
	        value: function isValid() {
	            return this.state.code.length > 0;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('ConfirmMail', null, { folderName: "ConfirmMail" });
	
	            return _react2.default.createElement(View, {
	                code: this.state.code,
	                onSubmit: this.onSubmit,
	                disabledSubmit: !this.isValid(),
	                preload: this.props.preload,
	                error: this.props.error,
	                onChange: this.handlerChangeInput,
	                message: this.props.message,
	                errorCode: this.props.errorCode,
	                lang: this.props.lang
	            });
	        }
	    }]);
	    return ConfirmMail;
	}(_BaseForm3.default), _class2.propTypes = {
	    lang: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = ConfirmMail;
	module.exports = exports['default'];

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _components2 = __webpack_require__(16);
	
	var _utils = __webpack_require__(31);
	
	__webpack_require__(1070);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ConfirmMailView: {
	        displayName: 'ConfirmMailView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/ConfirmMail/default/ConfirmMailView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ConfirmMailView = _wrapComponent('ConfirmMailView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(ConfirmMailView, _Component);
	
	    function ConfirmMailView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, ConfirmMailView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmMailView.__proto__ || (0, _getPrototypeOf2.default)(ConfirmMailView)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
	            event.preventDefault();
	            _this.props.onSubmit(event);
	        }, _this.showError = function () {
	            var _this$props = _this.props,
	                error = _this$props.error,
	                errorCode = _this$props.errorCode,
	                lang = _this$props.lang;
	
	
	            if (error) {
	                if (errorCode === null || errorCode === undefined) {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang['store.common.server_is_unavailable']
	                    );
	                } else {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang[error]
	                    );
	                }
	            }
	
	            return '';
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(ConfirmMailView, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var lang = this.props.lang;
	
	
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload },
	                this.showError(),
	                _react3.default.createElement(
	                    'section',
	                    { id: 'registration-form' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'bordered' },
	                        _react3.default.createElement(
	                            _reactBootstrap.Form,
	                            null,
	                            _react3.default.createElement(
	                                'div',
	                                null,
	                                lang['store.confirm_mail.code_sent'],
	                                ' ',
	                                _react3.default.createElement(
	                                    'span',
	                                    { className: 'destination' },
	                                    this.props.message
	                                )
	                            )
	                        ),
	                        _react3.default.createElement(
	                            _reactBootstrap.Form,
	                            { onSubmit: this.onSubmit },
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { controlId: 'sms' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.ControlLabel,
	                                    null,
	                                    lang['store.confirm_mail.enter_code']
	                                ),
	                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                    type: (0, _utils.isMobileDevice)() ? "number" : "text",
	                                    pattern: '\\d*',
	                                    placeholder: '1234',
	                                    value: this.props.code,
	                                    onChange: function onChange(e) {
	                                        if ((0, _utils.validateNumeric)(e.target.value)) {
	                                            _this2.props.onChange(e);
	                                        }
	                                    }
	                                })
	                            ),
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                null,
	                                _react3.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        type: 'submit',
	                                        className: 'form-control',
	                                        bsStyle: 'primary',
	                                        disabled: this.props.disabledSubmit
	                                    },
	                                    lang['store.common.confirm']
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return ConfirmMailView;
	}(_react2.Component), _class.propTypes = {
	    code: _react2.PropTypes.string.isRequired,
	    onSubmit: _react2.PropTypes.func.isRequired,
	    disabledSubmit: _react2.PropTypes.bool.isRequired,
	    error: _react2.PropTypes.string,
	    lang: _react2.PropTypes.object
	}, _temp2));
	
	exports.default = ConfirmMailView;
	module.exports = exports['default'];

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConfirmMail = undefined;
	
	var _ConfirmMail2 = __webpack_require__(1646);
	
	var _ConfirmMail3 = _interopRequireDefault(_ConfirmMail2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ConfirmMail = _ConfirmMail3.default;

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(102);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _user = __webpack_require__(115);
	
	var _BaseForm2 = __webpack_require__(66);
	
	var _BaseForm3 = _interopRequireDefault(_BaseForm2);
	
	var _modal = __webpack_require__(26);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmOldMail = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        error: state.user.error,
	        errorCode: state.user.errorCode,
	        preload: state.user.preload,
	        changeWithCode: state.user.changeWithCode,
	        user: state.auth.user,
	        lang: state.lang
	    };
	}, { confirmMailWithCode: _user.confirmMailWithCode, resetError: _user.resetError, hide: _modal.hide }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
	    (0, _inherits3.default)(ConfirmOldMail, _BaseForm);
	
	    function ConfirmOldMail(props, context) {
	        (0, _classCallCheck3.default)(this, ConfirmOldMail);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ConfirmOldMail.__proto__ || (0, _getPrototypeOf2.default)(ConfirmOldMail)).call(this, props, context));
	
	        _this.handlerChangeInput = function (event) {
	            _this.setState({
	                code: event.target.value
	            });
	        };
	
	        _this.state = {
	            code: ''
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(ConfirmOldMail, [{
	        key: 'onSubmit',
	        value: function onSubmit(event) {
	            (0, _get3.default)(ConfirmOldMail.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConfirmOldMail.prototype), 'onSubmit', this).call(this, event);
	
	            if (this.isValid()) {
	                this.props.confirmMailWithCode(this.props.user.pipo_id, this.props.user.email, this.state.code);
	                this.props.resetError();
	                this.setState({
	                    code: ''
	                });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.resetError();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _props = this.props,
	                changeWithCode = _props.changeWithCode,
	                lang = _props.lang;
	
	
	            if (changeWithCode !== nextProps.changeWithCode && nextProps.changeWithCode) {
	                this.props.hide();
	                setTimeout(function () {
	                    _reactSAlert2.default.success(lang['store.confirm_old_mail.success'], { position: 'top-right', effect: 'slide', timeout: 5000 });
	                }, 1000);
	            }
	        }
	
	        /**
	         * Валидация по всем методам проверки
	         *
	         * @returns {boolean}
	         */
	
	    }, {
	        key: 'isValid',
	        value: function isValid() {
	            return this.state.code.length > 0;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('ConfirmOldMail', null, { folderName: "ConfirmOldMail" });
	
	            return _react2.default.createElement(View, {
	                code: this.state.code,
	                onSubmit: this.onSubmit,
	                disabledSubmit: !this.isValid(),
	                preload: this.props.preload,
	                error: this.props.error,
	                onChange: this.handlerChangeInput,
	                errorCode: this.props.errorCode,
	                lang: this.props.lang
	            });
	        }
	    }]);
	    return ConfirmOldMail;
	}(_BaseForm3.default), _class2.propTypes = {
	    lang: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = ConfirmOldMail;
	module.exports = exports['default'];

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ConfirmOldMailView: {
	        displayName: 'ConfirmOldMailView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/ConfirmOldMail/default/ConfirmOldMailView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ConfirmOldMailView = _wrapComponent('ConfirmOldMailView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(ConfirmOldMailView, _Component);
	
	    function ConfirmOldMailView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, ConfirmOldMailView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmOldMailView.__proto__ || (0, _getPrototypeOf2.default)(ConfirmOldMailView)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
	            event.preventDefault();
	            _this.props.onSubmit(event);
	        }, _this.showError = function () {
	            var _this$props = _this.props,
	                error = _this$props.error,
	                errorCode = _this$props.errorCode,
	                lang = _this$props.lang;
	
	
	            if (error) {
	                if (errorCode === null || errorCode === undefined) {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang['store.common.server_is_unavailable']
	                    );
	                } else {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang[error]
	                    );
	                }
	            }
	
	            return '';
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(ConfirmOldMailView, [{
	        key: 'render',
	        value: function render() {
	            var lang = this.props.lang;
	
	
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload },
	                this.showError(),
	                _react3.default.createElement(
	                    'section',
	                    { id: 'registration-form' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'bordered' },
	                        _react3.default.createElement(
	                            _reactBootstrap.Form,
	                            { onSubmit: this.onSubmit },
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { controlId: 'sms' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.ControlLabel,
	                                    null,
	                                    lang['store.confirm_old_mail.enter_code']
	                                ),
	                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                    type: 'text',
	                                    placeholder: '1234',
	                                    value: this.props.code,
	                                    onChange: this.props.onChange
	                                })
	                            ),
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                null,
	                                _react3.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        type: 'submit',
	                                        className: 'form-control',
	                                        bsStyle: 'primary',
	                                        disabled: this.props.disabledSubmit
	                                    },
	                                    lang['store.common.confirm']
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return ConfirmOldMailView;
	}(_react2.Component), _class.propTypes = {
	    code: _react2.PropTypes.string.isRequired,
	    onSubmit: _react2.PropTypes.func.isRequired,
	    disabledSubmit: _react2.PropTypes.bool.isRequired,
	    error: _react2.PropTypes.string,
	    lang: _react2.PropTypes.object
	}, _temp2));
	
	exports.default = ConfirmOldMailView;
	module.exports = exports['default'];

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConfirmOldMail = undefined;
	
	var _ConfirmOldMail2 = __webpack_require__(1649);
	
	var _ConfirmOldMail3 = _interopRequireDefault(_ConfirmOldMail2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ConfirmOldMail = _ConfirmOldMail3.default;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(102);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _user = __webpack_require__(115);
	
	var _BaseForm2 = __webpack_require__(66);
	
	var _BaseForm3 = _interopRequireDefault(_BaseForm2);
	
	var _modal = __webpack_require__(26);
	
	var _voice_code = __webpack_require__(141);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmPhone = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        error: state.user.error,
	        errorCode: state.user.errorCode,
	        preload: state.user.preload,
	        changeWithCode: state.user.changeWithCode,
	        user: state.user,
	        profile: state.auth.user,
	        lang: state.lang
	    };
	}, { confirmPhoneWithCode: _user.confirmPhoneWithCode, resetError: _user.resetError, resetVoiceCode: _voice_code.resetVoiceCode, hide: _modal.hide }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
	    (0, _inherits3.default)(ConfirmPhone, _BaseForm);
	
	    function ConfirmPhone(props, context) {
	        (0, _classCallCheck3.default)(this, ConfirmPhone);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ConfirmPhone.__proto__ || (0, _getPrototypeOf2.default)(ConfirmPhone)).call(this, props, context));
	
	        _this.handlerChangeInput = function (event) {
	            _this.setState({
	                sms: event.target.value
	            });
	        };
	
	        _this.showOuterAlert = function (alert) {
	            _this.setState({ outerAlert: alert });
	        };
	
	        _this.state = {
	            sms: '',
	            outerAlert: null
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(ConfirmPhone, [{
	        key: 'onSubmit',
	        value: function onSubmit(event) {
	            (0, _get3.default)(ConfirmPhone.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConfirmPhone.prototype), 'onSubmit', this).call(this, event);
	
	            if (this.isValid()) {
	                this.props.confirmPhoneWithCode(this.props.pipoId, this.props.newPhone, this.state.sms);
	                this.props.resetError();
	                this.props.resetVoiceCode();
	                this.setState({
	                    sms: ''
	                });
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            var changeWithCode = this.props.changeWithCode;
	
	
	            if (changeWithCode !== nextProps.changeWithCode && nextProps.changeWithCode) {
	                this.props.hide();
	                setTimeout(function () {
	                    _reactSAlert2.default.success(_this2.props.succesOperationText, { position: 'top-right', effect: 'slide', timeout: 5000 });
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.resetError();
	            this.props.resetVoiceCode();
	        }
	
	        /**
	         * Валидация по всем методам проверки
	         *
	         * @returns {boolean}
	         */
	
	    }, {
	        key: 'isValid',
	        value: function isValid() {
	            return this.state.sms.length > 0;
	        }
	    }, {
	        key: 'getLogin',
	        value: function getLogin() {
	            var profile = this.props.profile;
	
	
	            return profile.confirmed.confirmed_email ? profile.email : profile.confirmed.confirmed_phone ? profile.phone : profile.phone ? profile.phone : profile.email;
	        }
	
	        /**
	         * Получение номера телефона пользователя
	         * @returns {*}
	         */
	
	    }, {
	        key: 'getUserPhone',
	        value: function getUserPhone() {
	            var phone = this.props.profile.phone;
	            return phone ? phone : this.props.newPhone;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('ConfirmPhone', null, { folderName: "ConfirmPhone" });
	
	            return _react2.default.createElement(View, {
	                sms: this.state.sms,
	                onSubmit: this.onSubmit,
	                disabledSubmit: !this.isValid(),
	                preload: this.props.preload,
	                error: this.props.error,
	                onChange: this.handlerChangeInput,
	                showOuterAlert: this.showOuterAlert,
	                outerAlert: this.state.outerAlert,
	                login: this.getLogin(),
	                phone: this.getUserPhone(),
	                errorCode: this.props.errorCode,
	                lang: this.props.lang
	            });
	        }
	    }]);
	    return ConfirmPhone;
	}(_BaseForm3.default), _class2.propTypes = {
	    lang: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = ConfirmPhone;
	module.exports = exports['default'];

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _utils = __webpack_require__(31);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ConfirmPhoneView: {
	        displayName: 'ConfirmPhoneView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/ConfirmPhone/default/ConfirmPhoneView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ConfirmPhoneView = _wrapComponent('ConfirmPhoneView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(ConfirmPhoneView, _Component);
	
	    function ConfirmPhoneView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, ConfirmPhoneView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmPhoneView.__proto__ || (0, _getPrototypeOf2.default)(ConfirmPhoneView)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
	            event.preventDefault();
	            _this.props.onSubmit(event);
	        }, _this.showAlert = function (alert) {
	            var _this$props = _this.props,
	                error = _this$props.error,
	                errorCode = _this$props.errorCode,
	                lang = _this$props.lang;
	
	
	            if (error) {
	                if (errorCode === null || errorCode === undefined) {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang['store.common.server_is_unavailable']
	                    );
	                } else {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang[error]
	                    );
	                }
	            } else if (_this.props.alert || alert) {
	                var _ref2 = _this.props.alert || alert,
	                    message = _ref2.message,
	                    style = _ref2.style;
	
	                return _react3.default.createElement(
	                    _reactBootstrap.Alert,
	                    { bsStyle: style || 'danger', className: 'inner-right-xs' },
	                    message
	                );
	            }
	
	            return '';
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(ConfirmPhoneView, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var lang = this.props.lang;
	
	
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload },
	                this.props.outerAlert ? this.showAlert(this.props.outerAlert) : this.showAlert(),
	                _react3.default.createElement(
	                    'section',
	                    { id: 'registration-form' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'bordered' },
	                        _react3.default.createElement(
	                            _reactBootstrap.Form,
	                            { onSubmit: this.onSubmit },
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { controlId: 'sms' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.ControlLabel,
	                                    null,
	                                    lang['store.common.enter_sms_code']
	                                ),
	                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                    type: (0, _utils.isMobileDevice)() ? "number" : "text",
	                                    pattern: '\\d*',
	                                    placeholder: '1234',
	                                    value: this.props.sms,
	                                    onChange: function onChange(e) {
	                                        if ((0, _utils.validateNumeric)(e.target.value)) {
	                                            _this2.props.onChange(e);
	                                        }
	                                    }
	                                })
	                            ),
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                null,
	                                _react3.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        type: 'submit',
	                                        className: 'form-control',
	                                        bsStyle: 'primary',
	                                        disabled: this.props.disabledSubmit
	                                    },
	                                    lang['store.common.confirm']
	                                )
	                            ),
	                            _react3.default.createElement(_components2.VoiceCode, {
	                                login: this.props.login,
	                                phone: this.props.phone,
	                                source: 'change_phone',
	                                showAlert: this.props.showOuterAlert,
	                                whiteList: true
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return ConfirmPhoneView;
	}(_react2.Component), _class.propTypes = {
	    sms: _react2.PropTypes.string.isRequired,
	    onSubmit: _react2.PropTypes.func.isRequired,
	    disabledSubmit: _react2.PropTypes.bool.isRequired,
	    error: _react2.PropTypes.string,
	    lang: _react2.PropTypes.object
	}, _temp2));
	
	exports.default = ConfirmPhoneView;
	module.exports = exports['default'];

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConfirmPhone = undefined;
	
	var _ConfirmPhone2 = __webpack_require__(1652);
	
	var _ConfirmPhone3 = _interopRequireDefault(_ConfirmPhone2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ConfirmPhone = _ConfirmPhone3.default;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    DropdownSelect: {
	        displayName: 'DropdownSelect'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/DropdownSelect/DropdownSelect.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var DropdownSelect = _wrapComponent('DropdownSelect')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(DropdownSelect, _Component);
	
	    function DropdownSelect(props) {
	        (0, _classCallCheck3.default)(this, DropdownSelect);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (DropdownSelect.__proto__ || (0, _getPrototypeOf2.default)(DropdownSelect)).call(this, props));
	
	        _this.handleBlur = function () {
	            _this.setState({ open: false });
	        };
	
	        _this.handleChange = function (id) {
	            _this.setState({ open: false });
	            _this.props.onChange(id);
	        };
	
	        _this.handleClick = function () {
	            _this.setState({ open: !_this.state.open });
	            if (_this.props.onClick) {
	                _this.props.onClick();
	            }
	        };
	
	        _this.state = {
	            open: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(DropdownSelect, [{
	        key: 'render',
	        value: function render() {
	
	            var View = _helpers.ThemeHelper.getViewForComponent('DropdownSelect');
	
	            var _props = this.props,
	                title = _props.title,
	                items = _props.items,
	                selected = _props.selected,
	                textField = _props.textField,
	                idField = _props.idField;
	
	
	            return _react3.default.createElement(View, {
	                title: title,
	                items: items,
	                selected: selected,
	                textField: textField,
	                idField: idField,
	                open: this.state.open,
	                handleBlur: this.handleBlur,
	                handleChange: this.handleChange,
	                handleClick: this.handleClick
	            });
	        }
	    }]);
	    return DropdownSelect;
	}(_react2.Component), _class.propTypes = {
	    onChange: _react2.PropTypes.func.isRequired,
	    title: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.number]).isRequired,
	    items: _react2.PropTypes.array.isRequired
	}, _temp));
	
	exports.default = DropdownSelect;
	module.exports = exports['default'];

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    DropdownSelectRow: {
	        displayName: 'DropdownSelectRow'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/DropdownSelect/default/DropdownSelectRow.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var DropdownSelectRow = _wrapComponent('DropdownSelectRow')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(DropdownSelectRow, _Component);
	
	    function DropdownSelectRow() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, DropdownSelectRow);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropdownSelectRow.__proto__ || (0, _getPrototypeOf2.default)(DropdownSelectRow)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
	            e.preventDefault();
	            var _this$props = _this.props,
	                id = _this$props.id,
	                selected = _this$props.selected,
	                onClick = _this$props.onClick;
	
	            if (!selected) {
	                onClick(id);
	            }
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(DropdownSelectRow, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                text = _props.text,
	                selected = _props.selected;
	
	            return _react3.default.createElement(
	                'li',
	                { className: selected ? 'disabled' : '', onMouseDown: this.handleClick },
	                _react3.default.createElement(
	                    'a',
	                    { disabled: selected, className: selected ? 'disabled' : '' },
	                    text
	                )
	            );
	        }
	    }]);
	    return DropdownSelectRow;
	}(_react2.Component), _class.propTypes = {
	    selected: _react2.PropTypes.bool.isRequired,
	    onClick: _react2.PropTypes.func.isRequired,
	    text: _react2.PropTypes.string.isRequired,
	    id: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.number, _react2.PropTypes.object]).isRequired
	}, _temp2));
	
	exports.default = DropdownSelectRow;
	module.exports = exports['default'];

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _DropdownSelectRow = __webpack_require__(1656);
	
	var _DropdownSelectRow2 = _interopRequireDefault(_DropdownSelectRow);
	
	__webpack_require__(1071);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    DropdownSelectView: {
	        displayName: 'DropdownSelectView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/DropdownSelect/default/DropdownSelectView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var DropdownSelectView = _wrapComponent('DropdownSelectView')(function (_Component) {
	    (0, _inherits3.default)(DropdownSelectView, _Component);
	
	    function DropdownSelectView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, DropdownSelectView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropdownSelectView.__proto__ || (0, _getPrototypeOf2.default)(DropdownSelectView)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (item, index) {
	            var id = index,
	                text = '';
	            if ((typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object') {
	                id = item[_this.props.idField];
	                text = item[_this.props.textField];
	            } else if (typeof item === 'string') {
	                text = item;
	            }
	
	            return _react3.default.createElement(_DropdownSelectRow2.default, {
	                key: index,
	                id: id,
	                selected: _this.props.selected === id,
	                text: text,
	                onClick: _this.props.handleChange
	            });
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(DropdownSelectView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                title = _props.title,
	                _props$items = _props.items,
	                items = _props$items === undefined ? [] : _props$items,
	                open = _props.open,
	                handleBlur = _props.handleBlur,
	                handleClick = _props.handleClick;
	
	            var classText = open ? ' open' : '';
	            return _react3.default.createElement(
	                'div',
	                {
	                    className: 'dropdown dropdown-select btn-group' + classText,
	                    id: this.props.id ? this.props.id : "dropdown",
	                    onBlur: handleBlur
	                },
	                _react3.default.createElement(
	                    'button',
	                    {
	                        type: 'button',
	                        className: 'btn btn-default dropdown-toggle',
	                        onClick: handleClick
	                    },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'dropdown-title' },
	                        title,
	                        _react3.default.createElement('span', { className: 'caret' })
	                    )
	                ),
	                _react3.default.createElement(
	                    'ul',
	                    { className: 'dropdown-menu' },
	                    items.map(this.renderItem)
	                )
	            );
	        }
	    }]);
	    return DropdownSelectView;
	}(_react2.Component));
	
	exports.default = DropdownSelectView;
	module.exports = exports['default'];

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DropdownSelect = undefined;
	
	var _DropdownSelect2 = __webpack_require__(1655);
	
	var _DropdownSelect3 = _interopRequireDefault(_DropdownSelect2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DropdownSelect = _DropdownSelect3.default; /**
	                                                    * Created by maximus on 14.11.16.
	                                                    */

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Footer: {
	        displayName: 'Footer'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Footer/Footer.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var POSITION_ABOUT = 2;
	var POSITION_HELP = 3;
	var POSITION_INFORMATION = 4;
	
	var Footer = _wrapComponent('Footer')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        basementText: state.setting.basementText,
	        phone: state.setting.phone,
	        pageList: state.page.list,
	        lang: state.lang
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Footer, _Component);
	
	    function Footer() {
	        (0, _classCallCheck3.default)(this, Footer);
	        return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Footer, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('Footer');
	            var about = [],
	                help = [],
	                information = [];
	            var _props = this.props,
	                basementText = _props.basementText,
	                phone = _props.phone,
	                lang = _props.lang;
	
	
	            this.props.pageList.forEach(function (page) {
	                switch (page.in_basement) {
	                    case POSITION_ABOUT:
	                        about.push({
	                            title: page.title,
	                            url: page.url_pages
	                        });
	                        break;
	                    case POSITION_HELP:
	                        help.push({
	                            title: page.title,
	                            url: page.url_pages
	                        });
	                        break;
	                    case POSITION_INFORMATION:
	                        information.push({
	                            title: page.title,
	                            url: page.url_pages
	                        });
	                        break;
	                }
	            });
	
	            return _react3.default.createElement(View, {
	                about: about,
	                help: help,
	                information: information,
	                basementText: basementText,
	                phone: phone,
	                lang: lang
	            });
	        }
	    }]);
	    return Footer;
	}(_react2.Component), _class2.propsType = {
	    pageList: _react2.PropTypes.array,
	    lang: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 26.10.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _reactRouter = __webpack_require__(19);
	
	__webpack_require__(1072);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    FooterView: {
	        displayName: 'FooterView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Footer/default/FooterView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var FooterView = _wrapComponent('FooterView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(FooterView, _Component);
	
	    function FooterView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, FooterView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FooterView.__proto__ || (0, _getPrototypeOf2.default)(FooterView)).call.apply(_ref, [this].concat(args))), _this), _this.renderBlock = function () {
	            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	            if (items.length > 0) {
	                return _react3.default.createElement(
	                    'div',
	                    null,
	                    _react3.default.createElement(
	                        'p',
	                        { className: 'main_nav_element' },
	                        title
	                    ),
	                    items.map(function (page, index) {
	                        return _react3.default.createElement(
	                            'p',
	                            { key: index },
	                            _react3.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/page/' + page.url },
	                                page.title
	                            )
	                        );
	                    })
	                );
	            }
	
	            return null;
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(FooterView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$about = _props.about,
	                about = _props$about === undefined ? [] : _props$about,
	                _props$help = _props.help,
	                help = _props$help === undefined ? [] : _props$help,
	                _props$information = _props.information,
	                information = _props$information === undefined ? [] : _props$information,
	                phone = _props.phone,
	                basementText = _props.basementText,
	                lang = _props.lang;
	
	            var footerText = '';
	
	            if (basementText) {
	                footerText = basementText.replace(/\r\n|\r|\n/g, '<br>');
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'Footer' },
	                _react3.default.createElement(
	                    'footer',
	                    { id: 'footer', className: 'Footer__content color-bg' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'copyright-bar' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'container' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'row footer-item' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-6 col-sm-4 col-md-2 visible-xs' },
	                                    _react3.default.createElement('div', { className: 'copyright', dangerouslySetInnerHTML: { __html: footerText } })
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-6 col-sm-4 col-md-2 visible-xs' },
	                                    _react3.default.createElement(
	                                        'p',
	                                        { className: 'copyright_phone' },
	                                        phone
	                                    )
	                                ),
	                                _react3.default.createElement('div', { className: 'clearfix' }),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'menu_items' },
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-4 col-md-2 hidden-xs' },
	                                        _react3.default.createElement('div', { className: 'copyright', dangerouslySetInnerHTML: { __html: footerText } }),
	                                        _react3.default.createElement(
	                                            'p',
	                                            { className: 'copyright_phone' },
	                                            phone
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-6 col-sm-4 col-sm-offset-0 col-md-2 col-md-offset-1' },
	                                        this.renderBlock(about, lang['store.footer.about_us'])
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-6 col-sm-4 col-md-2' },
	                                        this.renderBlock(help, lang['store.footer.help'])
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-6 col-sm-4 col-md-2' },
	                                        this.renderBlock(information, lang['store.footer.info'])
	                                    ),
	                                    _react3.default.createElement('div', { className: 'col-xs-6 col-sm-4 col-md-2' })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return FooterView;
	}(_react2.Component), _class.propsType = {
	    lang: _react2.PropTypes.object
	}, _temp2));
	
	exports.default = FooterView;
	module.exports = exports['default'];

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Footer = undefined;
	
	var _Footer2 = __webpack_require__(1659);
	
	var _Footer3 = _interopRequireDefault(_Footer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Footer = _Footer3.default;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    GoodsSlider: {
	        displayName: 'GoodsSlider'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/GoodsSlider/GoodsSlider.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	} /**
	   * Created by maximus on 30.12.16.
	   */
	
	var GoodsSlider = _wrapComponent('GoodsSlider')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(GoodsSlider, _Component);
	
	    function GoodsSlider() {
	        (0, _classCallCheck3.default)(this, GoodsSlider);
	        return (0, _possibleConstructorReturn3.default)(this, (GoodsSlider.__proto__ || (0, _getPrototypeOf2.default)(GoodsSlider)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(GoodsSlider, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('GoodsSlider', null, { folderName: 'GoodsSlider' });
	            return _react3.default.createElement(View, {
	                items: this.props.items,
	                count: this.props.count,
	                contentType: this.props.contentType,
	                updateProducts: this.props.updateProducts,
	                orderInOneClick: this.props.orderInOneClick,
	                buyInCreditActive: this.props.buyInCreditActive
	            });
	        }
	    }]);
	    return GoodsSlider;
	}(_react2.Component), _class.propTypes = {
	    items: _react2.PropTypes.array,
	    count: _react2.PropTypes.number,
	    contentType: _react2.PropTypes.string,
	    updateProducts: _react2.PropTypes.func,
	    orderInOneClick: _react2.PropTypes.bool
	}, _temp));
	
	exports.default = GoodsSlider;
	module.exports = exports['default'];

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactSlick = __webpack_require__(756);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _SliderProductItem = __webpack_require__(1665);
	
	var _SliderProductItem2 = _interopRequireDefault(_SliderProductItem);
	
	var _SliderCategoryItem = __webpack_require__(1664);
	
	var _SliderCategoryItem2 = _interopRequireDefault(_SliderCategoryItem);
	
	__webpack_require__(1075);
	
	__webpack_require__(1074);
	
	__webpack_require__(1073);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    GoodsSliderView: {
	        displayName: 'GoodsSliderView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/GoodsSlider/default/GoodsSliderView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	} /**
	   * Created by maximus on 30.12.16.
	   */
	
	var GoodsSliderView = _wrapComponent('GoodsSliderView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(GoodsSliderView, _Component);
	
	    function GoodsSliderView() {
	        (0, _classCallCheck3.default)(this, GoodsSliderView);
	        return (0, _possibleConstructorReturn3.default)(this, (GoodsSliderView.__proto__ || (0, _getPrototypeOf2.default)(GoodsSliderView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(GoodsSliderView, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                items = _props.items,
	                contentType = _props.contentType;
	
	
	            var prevArrow = _react3.default.createElement(
	                'span',
	                { className: 'arrow prev' },
	                _react3.default.createElement('img', { src: '/assets/images/prev.svg', alt: '' })
	            );
	
	            var nextArrow = _react3.default.createElement(
	                'span',
	                { className: 'arrow next' },
	                _react3.default.createElement('img', { src: '/assets/images/next.svg', alt: '' })
	            );
	            var slideCount = this.props.count || 3;
	            var sliderON = true;
	            if (items.length == 1) {
	                sliderON = false;
	            }
	
	            var settings = {
	                arrows: sliderON,
	                className: "goods_slider",
	                centerMode: false,
	                dots: false,
	                infinite: sliderON,
	                lazyLoad: false,
	                responsive: [{ breakpoint: 480, settings: { slidesToShow: 1 } }, { breakpoint: 768, settings: { slidesToShow: 2 } }, { breakpoint: 992, settings: { slidesToShow: slideCount - 1 } }, { breakpoint: 12000, settings: { slidesToShow: slideCount } }],
	                nextArrow: nextArrow,
	                prevArrow: prevArrow,
	                speed: 500, //?
	                slidesToShow: slideCount,
	                slidesToScroll: 1,
	                swipeToSlide: sliderON
	            };
	            return _react3.default.createElement(
	                _reactSlick2.default,
	                settings,
	                items.map(function (item, i) {
	                    if (contentType === 'product') {
	                        return _react3.default.createElement(
	                            'div',
	                            { key: i },
	                            _react3.default.createElement(_SliderProductItem2.default, {
	                                key: item.id,
	                                product: item,
	                                updateProducts: _this2.props.updateProducts,
	                                orderInOneClick: _this2.props.orderInOneClick,
	                                buyInCreditActive: _this2.props.buyInCreditActive
	                            })
	                        );
	                    }
	                    if (contentType === 'category') {
	                        return _react3.default.createElement(
	                            'div',
	                            { key: i },
	                            _react3.default.createElement(_SliderCategoryItem2.default, { key: item.id, category: item })
	                        );
	                    }
	                    return null;
	                })
	            );
	        }
	    }]);
	    return GoodsSliderView;
	}(_react2.Component), _class.propTypes = {
	    items: _react2.PropTypes.array,
	    count: _react2.PropTypes.number,
	    contentType: _react2.PropTypes.string,
	    updateProducts: _react2.PropTypes.func,
	    orderInOneClick: _react2.PropTypes.bool
	}, _temp));
	
	exports.default = GoodsSliderView;
	module.exports = exports['default'];

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactRouter = __webpack_require__(19);
	
	var _textEllipsis = __webpack_require__(262);
	
	var _textEllipsis2 = _interopRequireDefault(_textEllipsis);
	
	var _helpers = __webpack_require__(15);
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SliderCategoryItem: {
	        displayName: 'SliderCategoryItem'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/GoodsSlider/default/SliderCategoryItem.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	} /**
	   * Created by maximus on 10.01.17.
	   */
	
	// TODO: если этот слайдер будет использоваться, то нужно будет сделал проверку на актуальность категорий, пример:
	// components/Menu - там по клику рефрешим список категорий
	var SliderCategoryItem = _wrapComponent('SliderCategoryItem')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(SliderCategoryItem, _Component);
	
	    function SliderCategoryItem() {
	        (0, _classCallCheck3.default)(this, SliderCategoryItem);
	        return (0, _possibleConstructorReturn3.default)(this, (SliderCategoryItem.__proto__ || (0, _getPrototypeOf2.default)(SliderCategoryItem)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(SliderCategoryItem, [{
	        key: 'render',
	        value: function render() {
	            var _props$category = this.props.category,
	                id = _props$category.id,
	                title = _props$category.title,
	                pictures = _props$category.pictures;
	
	            var imgSrc = (0, _helpers.checkPicture)(pictures);
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'product-item-holder hover' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'product-item' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'image' },
	                        _react3.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/category/' + id + '/' + _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT + '/0' },
	                            _react3.default.createElement('img', { alt: '', src: imgSrc })
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'body' },
	                        _react3.default.createElement('div', { className: 'label-discount clear' }),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'title text-center' },
	                            _react3.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/category/' + id + '/' + _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT + '/0' },
	                                _react3.default.createElement(
	                                    'span',
	                                    { className: 'visible-lg text-theme-color' },
	                                    (0, _textEllipsis2.default)(name, 160, { ellipsis: '...' })
	                                ),
	                                _react3.default.createElement(
	                                    'span',
	                                    { className: 'hidden-lg hidden-xs text-theme-color' },
	                                    (0, _textEllipsis2.default)(name, 80, { ellipsis: '...' })
	                                ),
	                                _react3.default.createElement(
	                                    'span',
	                                    { className: 'visible-xs text-theme-color' },
	                                    (0, _textEllipsis2.default)(name, 120, { ellipsis: '...' })
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return SliderCategoryItem;
	}(_react2.Component), _class.propTypes = {
	    category: _react2.PropTypes.object
	}, _temp));
	
	exports.default = SliderCategoryItem;
	module.exports = exports['default'];

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(19);
	
	var _textEllipsis = __webpack_require__(262);
	
	var _textEllipsis2 = _interopRequireDefault(_textEllipsis);
	
	var _helpers = __webpack_require__(15);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SliderProductItem: {
	        displayName: 'SliderProductItem'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/GoodsSlider/default/SliderProductItem.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	} /**
	   * Created by maximus on 10.01.17.
	   */
	
	var SliderProductItem = _wrapComponent('SliderProductItem')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        currency: state.currency
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(SliderProductItem, _Component);
	
	    function SliderProductItem() {
	        (0, _classCallCheck3.default)(this, SliderProductItem);
	        return (0, _possibleConstructorReturn3.default)(this, (SliderProductItem.__proto__ || (0, _getPrototypeOf2.default)(SliderProductItem)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(SliderProductItem, [{
	        key: 'getRemainder',
	        value: function getRemainder(nestedOffer, quantityParent, product_detail) {
	            var _this2 = this;
	
	            if (nestedOffer.childOffer === null) {
	                return null;
	            }
	            if (nestedOffer.quantity > 0) {
	                var quantity = void 0;
	                var quantityTechCard = void 0;
	                quantity = nestedOffer.quantity;
	                if (nestedOffer.childOffer.modifier_option_id !== null && nestedOffer.childOffer.modOption === null) {
	                    nestedOffer.childOffer.modOption = nestedOffer.childOffer.modifiedOption.reduce(function (mod, modifier) {
	                        if (modifier.id === nestedOffer.childOffer.modifier_option_id) {
	                            return modifier;
	                        }
	                        return mod;
	                    }, null);
	                }
	                if (nestedOffer.childOffer.modOption !== null && nestedOffer.childOffer.type_id !== 5) {
	                    nestedOffer.childOffer.unit = nestedOffer.childOffer.modOption.unit;
	                    if (nestedOffer.childOffer.modOption.storable === true && nestedOffer.childOffer.modOption.storage_strict) {
	                        product_detail.storable = true;
	                        if (nestedOffer.childOffer.modOption.remainder.length === 0) {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        } else if (nestedOffer.childOffer.modOption.remainder[0].quantity > 0) {
	                            if ((nestedOffer.childOffer.modOption.unit_id === 2 || nestedOffer.childOffer.modOption.unit_id === 8) && nestedOffer.childOffer.modOption.weight && nestedOffer.childOffer.modOption.weight > 0) {
	                                quantity = nestedOffer.childOffer.modOption.weight * nestedOffer.quantity;
	                            }
	                            quantity = quantity * quantityParent;
	                            quantityTechCard = Math.floor(nestedOffer.childOffer.modOption.remainder[0].quantity / quantity);
	                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
	                                product_detail.remainder = [{ quantity: quantityTechCard }];
	                            }
	                        } else {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        }
	                    }
	                }
	                if (nestedOffer.childOffer.modOption === null && nestedOffer.childOffer.type_id !== 5) {
	                    if (nestedOffer.childOffer.storable === true && nestedOffer.childOffer.storage_strict) {
	                        product_detail.storable = true;
	                        if (nestedOffer.childOffer.remainder.length === 0) {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        } else if (nestedOffer.childOffer.remainder[0].quantity > 0) {
	                            if ((nestedOffer.childOffer.unit_id === 2 || nestedOffer.childOffer.unit_id === 8) && nestedOffer.childOffer.weight && nestedOffer.childOffer.weight > 0) {
	                                quantity = nestedOffer.childOffer.weight * nestedOffer.quantity;
	                            }
	                            quantity = quantity * quantityParent;
	                            quantityTechCard = Math.floor(nestedOffer.childOffer.remainder[0].quantity / quantity);
	                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
	                                product_detail.remainder = [{ quantity: quantityTechCard }];
	                            }
	                        } else {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        }
	                    }
	                }
	                if (nestedOffer.childOffer.type_id === 5) {
	                    nestedOffer.childOffer.remainder = [];
	                    nestedOffer.childOffer.storable = false;
	                    quantity = nestedOffer.quantity * quantityParent;
	                    nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
	                        _this2.getRemainder(nestedOfferTwo, quantity, product_detail);
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                product = _props.product,
	                orderInOneClick = _props.orderInOneClick,
	                currency = _props.currency;
	            var _props$product = this.props.product,
	                id = _props$product.id,
	                price = _props$product.price,
	                name = _props$product.name,
	                pictures = _props$product.pictures;
	
	            price = parseFloat(price);
	            var imgSrc = (0, _helpers.checkPicture)(pictures);
	            var withSlider = { height: '465px', marginBottom: '20px' };
	            var cartButtonClassName = 'add-cart-button';
	            if (this.props.orderInOneClick || this.props.buyInCreditActive) {
	                withSlider = { height: '465px', marginBottom: '20px' };
	            }
	            if (this.props.orderInOneClick && this.props.buyInCreditActive) {
	                withSlider = { height: '465px', marginBottom: '80px' };
	                cartButtonClassName = 'add-cart-button-three';
	            }
	            if (product.type_id === 5) {
	                product.storable = false;
	                product.storage_strict = true;
	                product.remainder = [];
	                var quantityTechCard = 1;
	                var priceComponent = 0;
	                var modifierComponent = null;
	                var modifierComponentTwo = null;
	                var storableComponent = false;
	                product.is_quantity_change = false;
	                product.nestedOffers.forEach(function (nestedOffer) {
	                    if (nestedOffer.quantity > 0 && nestedOffer.childOffer) {
	                        modifierComponent = null;
	                        if (nestedOffer.childOffer.type_id === 5) {
	                            nestedOffer.childOffer.remainder = [];
	                            nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
	                                _this3.getRemainder(nestedOfferTwo, nestedOffer.quantity, product);
	                            });
	                        } else {
	                            _this3.getRemainder(nestedOffer, quantityTechCard, product);
	                        }
	                    }
	                    if (nestedOffer.is_quantity_change) {
	                        product.is_quantity_change = true;
	                    }
	                });
	                price = parseFloat(product.price);
	                if (product.modifier_option_id !== undefined) {
	                    product.modifier_option.storable = product.storable;
	                    product.modifier_option.remainder[0] = product.remainder[0];
	                }
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'product-item-holder hover', style: withSlider },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'product-item flying-to-cart-holder' },
	                    _react3.default.createElement(_components2.ProductWishIcon, { product: product, inCard: true }),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'image' },
	                        _react3.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/product/' + id },
	                            _react3.default.createElement('img', { className: ' flying-to-cart-img', alt: '', src: imgSrc })
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'body' },
	                        _react3.default.createElement('div', { className: 'label-discount clear' }),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'title text-center' },
	                            _react3.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/product/' + id },
	                                _react3.default.createElement(
	                                    'span',
	                                    { className: 'visible-lg text-theme-color' },
	                                    (0, _textEllipsis2.default)(name, 160, { ellipsis: '...' })
	                                ),
	                                _react3.default.createElement(
	                                    'span',
	                                    { className: 'hidden-lg hidden-xs text-theme-color' },
	                                    (0, _textEllipsis2.default)(name, 80, { ellipsis: '...' })
	                                ),
	                                _react3.default.createElement(
	                                    'span',
	                                    { className: 'visible-xs text-theme-color' },
	                                    (0, _textEllipsis2.default)(name, 120, { ellipsis: '...' })
	                                )
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'prices' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'price-current text-center text-theme-color' },
	                            _react3.default.createElement(_components2.MoneyValue, {
	                                value: price,
	                                icon: currency.icon,
	                                iconAfterValue: currency.icon_after_value
	                            })
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'hover-area' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: cartButtonClassName },
	                            _react3.default.createElement(_components2.AddToBasket, { product: product, updateProducts: this.props.updateProducts })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return SliderProductItem;
	}(_react2.Component), _class2.propTypes = {
	    product: _react2.PropTypes.object,
	    updateProducts: _react2.PropTypes.func,
	    orderInOneClick: _react2.PropTypes.bool,
	    currency: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = SliderProductItem;
	module.exports = exports['default'];

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GoodsSlider = undefined;
	
	var _GoodsSlider2 = __webpack_require__(1662);
	
	var _GoodsSlider3 = _interopRequireDefault(_GoodsSlider2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.GoodsSlider = _GoodsSlider3.default; /**
	                                              * Created by maximus on 30.12.16.
	                                              */

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by maximus on 14.10.16.
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(15);
	
	var _auth = __webpack_require__(53);
	
	var _modal_type = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Hamburger: {
	        displayName: 'Hamburger'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Hamburger/Hamburger.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Hamburger = _wrapComponent('Hamburger')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        categories: state.catalog.categories,
	        lang: state.lang
	    };
	}, {
	    logout: _auth.logout, showModalAuth: _modal_type.showModalAuth, showModalRegistration: _modal_type.showModalRegistration
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Hamburger, _Component);
	
	    function Hamburger(props) {
	        (0, _classCallCheck3.default)(this, Hamburger);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Hamburger.__proto__ || (0, _getPrototypeOf2.default)(Hamburger)).call(this, props));
	
	        _this.handleCloseHamburger = function () {
	            var handleClick = _this.props.handleClick;
	
	            handleClick();
	            document.documentElement.classList.remove('scroll_hide');
	            _this.setState({ showCatalog: false });
	        };
	
	        _this.handleCatalogClick = function (e) {
	            e.preventDefault();
	            _this.setState({ showCatalog: "catalog" });
	        };
	
	        _this.handleBackClick = function () {
	            _this.setState({ showCatalog: false });
	        };
	
	        _this.handleMyMenuClick = function () {
	            _this.setState({ showCatalog: "menu" });
	        };
	
	        _this.handleLogout = function () {
	            _this.props.logout();
	            _this.handleCloseHamburger();
	        };
	
	        _this.state = {
	            showCatalog: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Hamburger, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('Hamburger'),
	                _props = this.props,
	                categories = _props.categories,
	                logo = _props.logo,
	                phone = _props.phone,
	                show = _props.show,
	                pages = _props.pages,
	                title = _props.title,
	                user = _props.user,
	                lang = _props.lang,
	                visible = show || false,
	                hamburgerClass = visible ? "hamburger" : "hamburger hamburger_hide";
	
	
	            var hiddenArea = void 0;
	
	            if (visible) {
	                hiddenArea = _react3.default.createElement(
	                    'div',
	                    { className: 'invisible-area', onClick: this.handleCloseHamburger },
	                    _react3.default.createElement('div', { className: 'invisible-area-before-hamburger' })
	                );
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'Header__hamburger Hamburger wrap-hamburger' },
	                hiddenArea,
	                _react3.default.createElement(View, {
	                    categories: categories,
	                    hamburgerClass: hamburgerClass,
	                    logo: logo,
	                    phone: phone,
	                    pages: pages,
	                    title: title,
	                    showCatalog: this.state.showCatalog,
	                    user: user,
	                    close: this.handleCloseHamburger,
	                    handleBackClick: this.handleBackClick,
	                    handleCatalogClick: this.handleCatalogClick,
	                    handleAuthClick: this.props.showModalAuth,
	                    handleMyMenuClick: this.handleMyMenuClick,
	                    handleRegisterClick: this.props.showModalRegistration,
	                    logout: this.handleLogout,
	                    lang: lang
	                })
	            );
	        }
	    }]);
	    return Hamburger;
	}(_react2.Component), _class2.propTypes = {
	    handleClick: _react2.PropTypes.func.isRequired,
	    logo: _react2.PropTypes.string.isRequired,
	    phone: _react2.PropTypes.string,
	    show: _react2.PropTypes.bool.isRequired,
	    title: _react2.PropTypes.string.isRequired,
	    lang: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Hamburger;
	module.exports = exports['default'];

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by maximus on 14.10.16.
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    MobileCatalog: {
	        displayName: "MobileCatalog"
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: "/usr/local/ibonus/src/components/Hamburger/MobileCatalog/MobileCatalog.jsx",
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MobileCatalog = _wrapComponent("MobileCatalog")((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(MobileCatalog, _Component);
	
	    function MobileCatalog(props) {
	        (0, _classCallCheck3.default)(this, MobileCatalog);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (MobileCatalog.__proto__ || (0, _getPrototypeOf2.default)(MobileCatalog)).call(this, props));
	
	        _this.handleInDepthClick = function (_ref) {
	            var item = _ref.item,
	                array = _ref.array;
	
	            _this.setState({
	                title: item.title,
	                category: array,
	                prev: (0, _extends3.default)({}, _this.state),
	                animationType: 'slide_to_left'
	            });
	        };
	
	        _this.handleBackClick = function (e) {
	            if (_this.state.prev) {
	                _this.setState((0, _extends3.default)({}, _this.state.prev, {
	                    animationType: 'slide_to_right'
	                }));
	            } else {
	                _this.props.handleBackClick();
	            }
	        };
	
	        _this.state = {
	            title: _this.props.title,
	            category: _this.props.categories,
	            prev: null,
	            animationType: 'slide_to_left'
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(MobileCatalog, [{
	        key: "render",
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('MobileCatalog', null, { folderName: "Hamburger/MobileCatalog" });
	
	            return _react3.default.createElement(View, (0, _extends3.default)({}, this.state, {
	                handleClick: this.props.handleClick,
	                handleInDepthClick: this.handleInDepthClick,
	                handleBackClick: this.handleBackClick
	            }));
	        }
	    }]);
	    return MobileCatalog;
	}(_react2.Component), _class.propTypes = {}, _temp));
	
	exports.default = MobileCatalog;
	module.exports = exports['default'];

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 29.11.16.
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactRouter = __webpack_require__(19);
	
	var _CSSTransitionGroup = __webpack_require__(699);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _constants = __webpack_require__(18);
	
	__webpack_require__(1076);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    MobileCatalogView: {
	        displayName: 'MobileCatalogView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Hamburger/MobileCatalog/default/MobileCatalogView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MobileCatalogView = _wrapComponent('MobileCatalogView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(MobileCatalogView, _Component);
	
	    function MobileCatalogView(props) {
	        (0, _classCallCheck3.default)(this, MobileCatalogView);
	        return (0, _possibleConstructorReturn3.default)(this, (MobileCatalogView.__proto__ || (0, _getPrototypeOf2.default)(MobileCatalogView)).call(this, props));
	    }
	
	    (0, _createClass3.default)(MobileCatalogView, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                category = _props.category,
	                title = _props.title;
	
	
	            return _react3.default.createElement(
	                _CSSTransitionGroup2.default,
	                {
	                    transitionName: this.props.animationType,
	                    transitionEnterTimeout: 300,
	                    transitionLeaveTimeout: 300
	                },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'mobile_catalog', key: this.props.title },
	                    _react3.default.createElement('span', { className: 'fa fa-arrow-left back_button', onClick: this.props.handleBackClick }),
	                    _react3.default.createElement(
	                        'span',
	                        { className: 'catalog_title' },
	                        title
	                    ),
	                    _react3.default.createElement(
	                        'ul',
	                        null,
	                        category ? category.map(function (categoryItem, i) {
	                            return _react3.default.createElement(
	                                'li',
	                                { key: i, className: 'row no-margin' },
	                                _react3.default.createElement(
	                                    _reactRouter.Link,
	                                    {
	                                        to: '/category/' + categoryItem.id + '?limit=' + _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT + '&page=1',
	                                        onClick: _this2.props.handleClick,
	                                        className: categoryItem.categories ? 'col-xs-10' : 'col-xs-12'
	                                    },
	                                    categoryItem.title
	                                ),
	                                categoryItem.categories ? _react3.default.createElement(
	                                    'div',
	                                    {
	                                        className: 'col-xs-2 no-margin in_depth_button',
	                                        onClick: function onClick() {
	                                            return _this2.props.handleInDepthClick({ item: categoryItem, array: categoryItem.categories });
	                                        }
	                                    },
	                                    _react3.default.createElement('span', { className: 'fa fa-chevron-right' })
	                                ) : null
	                            );
	                        }) : null
	                    )
	                )
	            );
	        }
	    }]);
	    return MobileCatalogView;
	}(_react2.Component), _class.propTypes = {}, _temp));
	
	exports.default = MobileCatalogView;
	module.exports = exports['default'];

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by maximus on 14.10.16.
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    MyMenu: {
	        displayName: "MyMenu"
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: "/usr/local/ibonus/src/components/Hamburger/MyMenu/MyMenu.jsx",
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MyMenu = _wrapComponent("MyMenu")(function (_Component) {
	    (0, _inherits3.default)(MyMenu, _Component);
	
	    function MyMenu(props) {
	        (0, _classCallCheck3.default)(this, MyMenu);
	        return (0, _possibleConstructorReturn3.default)(this, (MyMenu.__proto__ || (0, _getPrototypeOf2.default)(MyMenu)).call(this, props));
	    }
	
	    (0, _createClass3.default)(MyMenu, [{
	        key: "render",
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('MyMenu', null, { folderName: "Hamburger/MyMenu" });
	
	            return _react3.default.createElement(View, this.props);
	        }
	    }]);
	    return MyMenu;
	}(_react2.Component));
	
	exports.default = MyMenu;
	module.exports = exports['default'];

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 29.11.16.
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactRouter = __webpack_require__(19);
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1077);
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    MyMenuView: {
	        displayName: 'MyMenuView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Hamburger/MyMenu/default/MyMenuView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MyMenuView = _wrapComponent('MyMenuView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(MyMenuView, _Component);
	
	    function MyMenuView(props) {
	        (0, _classCallCheck3.default)(this, MyMenuView);
	        return (0, _possibleConstructorReturn3.default)(this, (MyMenuView.__proto__ || (0, _getPrototypeOf2.default)(MyMenuView)).call(this, props));
	    }
	
	    (0, _createClass3.default)(MyMenuView, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var lang = this.props.lang;
	
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'mobile_catalog', key: this.props.title },
	                _react3.default.createElement('span', { className: 'fa fa-arrow-left back_button', onClick: this.props.handleBackClick }),
	                _react3.default.createElement(
	                    'span',
	                    { className: 'catalog_title' },
	                    lang['store.my_menu.title']
	                ),
	                _react3.default.createElement(
	                    'ul',
	                    null,
	                    _constants.UserMenuItems.map(function (item, i) {
	                        var item_name = lang[item.lang_mark] ? lang[item.lang_mark] : item.name;
	
	                        if (item.link) {
	                            return _react3.default.createElement(
	                                'li',
	                                { key: 'li-' + i, className: 'row no-margin' },
	                                _react3.default.createElement(
	                                    _reactRouter.Link,
	                                    {
	                                        to: item.link,
	                                        onClick: _this2.props.handleClick
	                                    },
	                                    item_name
	                                ),
	                                item.showNotification ? _react3.default.createElement(_components2.Notification, { className: 'holder_login_icon' }) : null
	                            );
	                        } else {
	                            return _react3.default.createElement(
	                                'li',
	                                { key: 'li-' + i, className: 'row no-margin' },
	                                _react3.default.createElement(
	                                    'a',
	                                    { onClick: _this2.props[item.method] },
	                                    item_name
	                                ),
	                                item.showNotification ? _react3.default.createElement(_components2.Notification, { className: 'holder_login_icon' }) : null
	                            );
	                        }
	                    })
	                )
	            );
	        }
	    }]);
	    return MyMenuView;
	}(_react2.Component), _class.propTypes = {
	    lang: _react2.PropTypes.object
	}, _temp));
	
	exports.default = MyMenuView;
	module.exports = exports['default'];

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 29.11.16.
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactRouter = __webpack_require__(19);
	
	var _CSSTransitionGroup = __webpack_require__(699);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _components2 = __webpack_require__(16);
	
	var _MobileCatalog = __webpack_require__(1668);
	
	var _MobileCatalog2 = _interopRequireDefault(_MobileCatalog);
	
	var _MyMenu = __webpack_require__(1670);
	
	var _MyMenu2 = _interopRequireDefault(_MyMenu);
	
	__webpack_require__(1078);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    HamburgerView: {
	        displayName: 'HamburgerView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Hamburger/default/HamburgerView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var HamburgerView = _wrapComponent('HamburgerView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(HamburgerView, _Component);
	
	    function HamburgerView(props) {
	        (0, _classCallCheck3.default)(this, HamburgerView);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (HamburgerView.__proto__ || (0, _getPrototypeOf2.default)(HamburgerView)).call(this, props));
	
	        _this.handleClick = function () {
	            _this.props.close();
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(HamburgerView, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                categories = _props.categories,
	                hamburgerClass = _props.hamburgerClass,
	                logo = _props.logo,
	                phone = _props.phone,
	                pages = _props.pages,
	                title = _props.title,
	                showCatalog = _props.showCatalog,
	                user = _props.user,
	                lang = _props.lang;
	
	            var name = '';
	
	            if (user) {
	                name = user.name || user.phone || user.email || '';
	            }
	
	            var hamburgerBody = null;
	            switch (showCatalog) {
	                case 'catalog':
	                    hamburgerBody = _react3.default.createElement(_MobileCatalog2.default, {
	                        handleClick: this.handleClick,
	                        handleBackClick: this.props.handleBackClick,
	                        title: lang['store.hamburger.catalog'],
	                        categories: categories,
	                        key: "catalog"
	                    });
	                    break;
	                case 'menu':
	                    hamburgerBody = _react3.default.createElement(_MyMenu2.default, {
	                        handleClick: this.handleClick,
	                        handleBackClick: this.props.handleBackClick,
	                        logout: this.props.logout,
	                        key: "menu",
	                        lang: lang
	                    });
	                    break;
	                default:
	                    hamburgerBody = _react3.default.createElement(
	                        'div',
	                        { key: 'default' },
	                        _react3.default.createElement(_components2.Logo, { onClick: this.handleClick, logo: logo, imgClassName: 'hamburger_logo' }),
	                        _react3.default.createElement(
	                            'h2',
	                            null,
	                            title
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'registration' },
	                            user ? _react3.default.createElement(
	                                'div',
	                                { className: 'registration_item', onClick: this.props.handleMyMenuClick },
	                                _react3.default.createElement('i', { className: 'fa fa-user-o prev_icon' }),
	                                _react3.default.createElement(
	                                    'span',
	                                    null,
	                                    name
	                                ),
	                                _react3.default.createElement(_components2.Notification, { iconClassName: 'hamburger_warning_icon' }),
	                                _react3.default.createElement('i', { className: 'fa fa-chevron-right post_icon' })
	                            ) : _react3.default.createElement(
	                                'div',
	                                { className: 'registration_item', onClick: function onClick() {
	                                        return _this2.props.handleAuthClick(lang);
	                                    } },
	                                _react3.default.createElement('i', { className: 'fa fa-sign-in prev_icon' }),
	                                _react3.default.createElement(
	                                    'span',
	                                    null,
	                                    lang['login.logIn']
	                                )
	                            ),
	                            !user ? _react3.default.createElement(
	                                'div',
	                                { className: 'registration_item', onClick: function onClick() {
	                                        return _this2.props.handleRegisterClick(lang);
	                                    } },
	                                _react3.default.createElement('i', { className: 'fa fa-user-plus prev_icon' }),
	                                _react3.default.createElement(
	                                    'span',
	                                    null,
	                                    lang['store.register.register']
	                                )
	                            ) : null
	                        ),
	                        _react3.default.createElement(
	                            'ul',
	                            { className: 'hamburger_list' },
	                            _react3.default.createElement(
	                                'li',
	                                null,
	                                _react3.default.createElement(
	                                    'a',
	                                    { href: '#', onClick: this.props.handleCatalogClick },
	                                    _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        lang['store.hamburger.catalog']
	                                    ),
	                                    _react3.default.createElement('i', { className: 'fa fa-chevron-right post_icon' })
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'li',
	                                null,
	                                _react3.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/', onClick: this.handleClick },
	                                    _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        lang['store.hamburger.main']
	                                    )
	                                )
	                            ),
	                            pages.map(function (page, index) {
	                                return _react3.default.createElement(
	                                    'li',
	                                    { key: index },
	                                    _react3.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/page/' + page.url, onClick: _this2.handleClick },
	                                        _react3.default.createElement(
	                                            'span',
	                                            null,
	                                            page.title
	                                        )
	                                    )
	                                );
	                            })
	                        )
	                    );
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: hamburgerClass },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'hamburger_container' },
	                    _react3.default.createElement('span', { className: 'fa fa-times close_button', onClick: this.handleClick }),
	                    _react3.default.createElement(
	                        _CSSTransitionGroup2.default,
	                        { transitionName: showCatalog ? "slide_to_left" : "slide_to_right",
	                            transitionEnterTimeout: 300,
	                            transitionLeaveTimeout: 300 },
	                        hamburgerBody
	                    )
	                )
	            );
	        }
	    }]);
	    return HamburgerView;
	}(_react2.Component), _class.propTypes = {
	    hamburgerClass: _react2.PropTypes.string.isRequired,
	    logo: _react2.PropTypes.string.isRequired,
	    phone: _react2.PropTypes.string,
	    title: _react2.PropTypes.string.isRequired,
	    lang: _react2.PropTypes.object
	}, _temp));
	
	exports.default = HamburgerView;
	module.exports = exports['default'];

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hamburger = undefined;
	
	var _Hamburger2 = __webpack_require__(1667);
	
	var _Hamburger3 = _interopRequireDefault(_Hamburger2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Hamburger = _Hamburger3.default; /**
	                                          * Created by maximus on 15.11.16.
	                                          */

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by maximus on 14.10.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactKeydown = __webpack_require__(1417);
	
	var _reactKeydown2 = _interopRequireDefault(_reactKeydown);
	
	var _reactFavicon = __webpack_require__(1360);
	
	var _reactFavicon2 = _interopRequireDefault(_reactFavicon);
	
	var _headInfo = __webpack_require__(765);
	
	var _helpers = __webpack_require__(15);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Header: {
	        displayName: 'Header'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Header/Header.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Header = _wrapComponent('Header')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        user: state.auth.user,
	        show_404: state.error.is_show_404,
	        settings: state.setting,
	        isShowSideMenu: state.headInfo.isShowSideMenu,
	        pageList: state.page.list,
	        lang: state.lang
	    };
	}, { showSideMenu: _headInfo.showSideMenu, hideSideMenu: _headInfo.hideSideMenu }), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Header, _Component);
	
	    function Header(props) {
	        (0, _classCallCheck3.default)(this, Header);
	
	        // this.state = {
	        //     hamburgerShow: false
	        // };
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call(this, props));
	
	        _this.handleClick = function (e) {
	            //this.state.hamburgerShow ? this.setState({hamburgerShow: false}) : this.setState({hamburgerShow: true});
	            var _this$props = _this.props,
	                isShowSideMenu = _this$props.isShowSideMenu,
	                hideSideMenu = _this$props.hideSideMenu,
	                showSideMenu = _this$props.showSideMenu;
	
	            isShowSideMenu ? hideSideMenu() : showSideMenu();
	        };
	
	        return _this;
	    }
	
	    /**
	     * Обработчик показа/скрытия гамбургера
	     * @param e
	     */
	
	
	    (0, _createClass3.default)(Header, [{
	        key: 'render',
	
	
	        // @keydown('Esc')
	        // submit(event) {
	        //     const {hamburgerShow} = this.state;
	        //     if (hamburgerShow && event.which === 27) {
	        //         this.handleClick();
	        //     }
	        // }
	
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('Header'),
	                _props = this.props,
	                isShowSideMenu = _props.isShowSideMenu,
	                user = _props.user,
	                lang = _props.lang,
	                _props$settings = this.props.settings,
	                favicon = _props$settings.favicon,
	                logo = _props$settings.logo,
	                operationMode = _props$settings.operationMode,
	                operationModeShow = _props$settings.operationModeShow,
	                phone = _props$settings.phone,
	                phoneShow = _props$settings.phoneShow,
	                shopName = _props$settings.shopName;
	
	
	            var pages = [];
	
	            this.props.pageList.forEach(function (page) {
	                if (page.show_in_header) {
	                    pages.push({
	                        title: page.title,
	                        url: page.url_pages,
	                        position: page.position
	                    });
	                }
	            });
	
	            var params = {
	                logo: logo === 'default' || logo === undefined ? '' : logo,
	                operationMode: operationMode,
	                operationModeShow: operationModeShow,
	                pages: pages,
	                phone: phone,
	                phoneShow: phoneShow,
	                user: user,
	                show: isShowSideMenu,
	                title: shopName,
	                handleClick: this.handleClick,
	                lang: lang
	            };
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'Header' },
	                _react3.default.createElement(View, params),
	                _react3.default.createElement(_components2.Hamburger, params)
	            );
	        }
	    }]);
	    return Header;
	}(_react2.Component), _class2.propTypes = {
	    user: _react2.PropTypes.object,
	    settings: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object
	}, _class2.defaultProps = {
	    settings: {}
	}, _temp)) || _class));
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by maximus on 14.10.16.
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Logo: {
	        displayName: 'Logo'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Header/Logo/Logo.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Logo = _wrapComponent('Logo')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Logo, _Component);
	
	    function Logo(props) {
	        (0, _classCallCheck3.default)(this, Logo);
	        return (0, _possibleConstructorReturn3.default)(this, (Logo.__proto__ || (0, _getPrototypeOf2.default)(Logo)).call(this, props));
	    }
	
	    (0, _createClass3.default)(Logo, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('Logo', null, { folderName: "Header/Logo" });
	
	            return _react3.default.createElement(View, this.props);
	        }
	    }]);
	    return Logo;
	}(_react2.Component), _class2.propTypes = {
	    logo: _react2.PropTypes.string,
	    onClick: _react2.PropTypes.func,
	    imgClassName: _react2.PropTypes.string,
	    lang: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by maximus on 03.05.17.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactRouter = __webpack_require__(19);
	
	__webpack_require__(1079);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    LogoView: {
	        displayName: 'LogoView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Header/Logo/default/LogoView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var LogoView = _wrapComponent('LogoView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(LogoView, _Component);
	
	    function LogoView() {
	        (0, _classCallCheck3.default)(this, LogoView);
	        return (0, _possibleConstructorReturn3.default)(this, (LogoView.__proto__ || (0, _getPrototypeOf2.default)(LogoView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(LogoView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                imgClassName = _props.imgClassName,
	                logo = _props.logo,
	                onClick = _props.onClick,
	                lang = _props.lang;
	
	
	            var logoTitle = lang['store.header.your_logo'];
	            var goToMain = lang['store.common.go_to_main'];
	
	            return _react3.default.createElement(
	                _reactRouter.Link,
	                { to: '/', onClick: onClick },
	                logo ? _react3.default.createElement('img', { className: imgClassName, src: logo, alt: goToMain, title: goToMain }) : _react3.default.createElement(
	                    'div',
	                    { className: 'logo ' + imgClassName, title: goToMain },
	                    logoTitle
	                )
	            );
	        }
	    }]);
	    return LogoView;
	}(_react2.Component), _class.propTypes = {
	    logo: _react2.PropTypes.string,
	    onClick: _react2.PropTypes.func,
	    imgClassName: _react2.PropTypes.string,
	    lang: _react2.PropTypes.object
	}, _temp));
	
	exports.default = LogoView;
	module.exports = exports['default'];

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _reactRouter = __webpack_require__(19);
	
	var _reactRouterBootstrap = __webpack_require__(681);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _RightPanel = __webpack_require__(1678);
	
	var _RightPanel2 = _interopRequireDefault(_RightPanel);
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1080);
	
	__webpack_require__(1081);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    HeaderView: {
	        displayName: 'HeaderView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Header/default/HeaderView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var HeaderView = _wrapComponent('HeaderView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(HeaderView, _Component);
	
	    function HeaderView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, HeaderView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HeaderView.__proto__ || (0, _getPrototypeOf2.default)(HeaderView)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickOpen = function () {
	            _this.props.handleClick();
	            document.documentElement.classList.add('scroll_hide');
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(HeaderView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                logo = _props.logo,
	                operationMode = _props.operationMode,
	                operationModeShow = _props.operationModeShow,
	                pages = _props.pages,
	                phone = _props.phone,
	                phoneShow = _props.phoneShow,
	                title = _props.title,
	                user = _props.user,
	                lang = _props.lang;
	
	
	            return _react3.default.createElement(
	                'header',
	                { className: 'Header__view navbar-fixed-top top-bar animate-dropdown' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'row no-margin add_container' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-9 col-sm-8 col-md-9 col-lg-9 no-margin container_header_left_flex' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'hamburger-icon' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'hamburger-icon__bars' },
	                                    _react3.default.createElement('i', { className: 'fa fa-bars icon_hamburger', onClick: this.handleClickOpen })
	                                ),
	                                _react3.default.createElement(_components2.Notification, { className: 'hidden-lg auth_holder hamburger-icon__warning' })
	                            ),
	                            _react3.default.createElement(_components2.Logo, { logo: logo, imgClassName: 'header_logo' }),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'title_holder' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'title_flex' },
	                                    _react3.default.createElement(
	                                        'h2',
	                                        { className: 'default_header hidden-xs default-header-sm' },
	                                        title
	                                    ),
	                                    _react3.default.createElement(
	                                        _reactRouter.Link,
	                                        { className: 'default_header visible-xs default-header-xs', to: '/' },
	                                        title
	                                    ),
	                                    phoneShow ? _react3.default.createElement(
	                                        'div',
	                                        { className: 'default_header_phone' },
	                                        phone
	                                    ) : null
	                                ),
	                                operationModeShow ? _react3.default.createElement(
	                                    'div',
	                                    { className: 'operation_mode' },
	                                    operationMode
	                                ) : null
	                            ),
	                            _react3.default.createElement(
	                                'ul',
	                                { className: 'default_header_static hidden-xs hidden-sm hidden-md' },
	                                pages.map(function (page, index) {
	                                    return index < 2 ? _react3.default.createElement(
	                                        'li',
	                                        { key: index },
	                                        _react3.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: '/page/' + page.url },
	                                            page.title
	                                        )
	                                    ) : null;
	                                }),
	                                pages.length > 2 ? _react3.default.createElement(
	                                    'li',
	                                    null,
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'dropdown-holder hidden-xs hidden-sm hidden-md' },
	                                        _react3.default.createElement(
	                                            _reactBootstrap.DropdownButton,
	                                            {
	                                                bsStyle: 'link',
	                                                id: 'dropdown-basic',
	                                                noCaret: true,
	                                                title: lang['store.header.menu_more']
	                                            },
	                                            pages.map(function (page, i) {
	                                                return i >= 2 ? _react3.default.createElement(
	                                                    _reactRouterBootstrap.LinkContainer,
	                                                    {
	                                                        key: i,
	                                                        to: '/page/' + page.url
	                                                    },
	                                                    _react3.default.createElement(
	                                                        _reactBootstrap.MenuItem,
	                                                        { eventKey: i + 1 },
	                                                        page.title
	                                                    )
	                                                ) : null;
	                                            })
	                                        )
	                                    )
	                                ) : null
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'header_more dropdown-holder hidden-xs hidden-lg' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.DropdownButton,
	                                    { bsStyle: 'link', title: lang['store.header.menu'], noCaret: true, id: 'dropdown-basic' },
	                                    pages.map(function (page, i) {
	                                        return _react3.default.createElement(
	                                            _reactRouterBootstrap.LinkContainer,
	                                            { key: i, to: '/page/' + page.url },
	                                            _react3.default.createElement(
	                                                _reactBootstrap.MenuItem,
	                                                { eventKey: i + 1 },
	                                                page.title
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-3 col-sm-4 col-md-3 col-lg-3 no-margin container_header_right_flex' },
	                            _react3.default.createElement(_RightPanel2.default, { user: user, lang: lang })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return HeaderView;
	}(_react2.Component), _class.propTypes = {
	    handleClick: _react2.PropTypes.func.isRequired,
	    logo: _react2.PropTypes.string.isRequired,
	    operationMode: _react2.PropTypes.any,
	    operationModeShow: _react2.PropTypes.any,
	    pages: _react2.PropTypes.array,
	    phone: _react2.PropTypes.string,
	    phoneShow: _react2.PropTypes.any,
	    title: _react2.PropTypes.string.isRequired,
	    user: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object
	}, _temp2));
	
	exports.default = HeaderView;
	module.exports = exports['default'];

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _components2 = __webpack_require__(16);
	
	var _reactRouter = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    RightPanel: {
	        displayName: 'RightPanel'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Header/default/RightPanel.js',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var RightPanel = _wrapComponent('RightPanel')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(RightPanel, _Component);
	
	    function RightPanel() {
	        (0, _classCallCheck3.default)(this, RightPanel);
	        return (0, _possibleConstructorReturn3.default)(this, (RightPanel.__proto__ || (0, _getPrototypeOf2.default)(RightPanel)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(RightPanel, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                lang = _props.lang;
	
	            var result = void 0;
	            var postpone = void 0;
	            if (!user) {
	                result = _react3.default.createElement(
	                    'li',
	                    { className: 'hidden-xs' },
	                    _react3.default.createElement(_components2.RegistrationHeader, null)
	                );
	            } else {
	                if (user.count_postpone > 0) {
	                    var isActive = " active_icon";
	                    postpone = _react3.default.createElement(
	                        'li',
	                        null,
	                        _react3.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/postpone', className: 'ibonus-shopping-cart' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'header_icon-holder' },
	                                _react3.default.createElement('i', { className: "fa fa-cart-arrow-down header_icon " + isActive }),
	                                user.count_postpone ? _react3.default.createElement(
	                                    'div',
	                                    { className: 'header_icon_text-holder' },
	                                    _react3.default.createElement(
	                                        'span',
	                                        { className: 'header_icon_text' },
	                                        user.count_postpone
	                                    )
	                                ) : null
	                            )
	                        )
	                    );
	                }
	            }
	
	            return _react3.default.createElement(
	                'ul',
	                { className: 'right' },
	                postpone,
	                _react3.default.createElement(
	                    'li',
	                    null,
	                    _react3.default.createElement(_components2.HeaderWishIcon, null)
	                ),
	                _react3.default.createElement(
	                    'li',
	                    null,
	                    _react3.default.createElement(_components2.MiniBasket, null)
	                ),
	                _react3.default.createElement(
	                    'li',
	                    { className: 'hidden-xs' },
	                    _react3.default.createElement(_components2.AuthHeader, null)
	                ),
	                result
	            );
	        }
	    }]);
	    return RightPanel;
	}(_react2.Component), _class.propTypes = {
	    lang: _react2.PropTypes.object,
	    user: _react2.PropTypes.object
	}, _temp));
	
	exports.default = RightPanel;
	module.exports = exports['default'];

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Logo = exports.Header = undefined;
	
	var _Header2 = __webpack_require__(1674);
	
	var _Header3 = _interopRequireDefault(_Header2);
	
	var _Logo2 = __webpack_require__(1675);
	
	var _Logo3 = _interopRequireDefault(_Logo2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Header = _Header3.default;
	exports.Logo = _Logo3.default;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.IBONUS_PAYMENT_SLUG = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _Slider = __webpack_require__(760);
	
	var _components2 = __webpack_require__(16);
	
	var _AmountFormat = __webpack_require__(1602);
	
	var _AmountFormat2 = _interopRequireDefault(_AmountFormat);
	
	var _payment = __webpack_require__(114);
	
	var _voice_code = __webpack_require__(141);
	
	var _modal = __webpack_require__(26);
	
	var _utils = __webpack_require__(31);
	
	__webpack_require__(1082);
	
	var _reactBootstrap = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    IBonusPayment: {
	        displayName: 'IBonusPayment'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/IBonusPayment/index.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var IBONUS_PAYMENT_SLUG = exports.IBONUS_PAYMENT_SLUG = 'i_bonus';
	
	var IBonusPayment = _wrapComponent('IBonusPayment')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        user: state.auth.user,
	        isPayOrder: state.payment.isPayOrder,
	        preload: state.payment.preload,
	        errorPay: state.payment.errorPay,
	        errorCode: state.payment.errorCode,
	        shopId: state.setting.shopId,
	        sum: state.personal_order_detail.order.sum,
	        lang: state.lang
	    };
	}, { paymentIbonus: _payment.paymentIbonus, resetPaymentIbonus: _payment.resetPaymentIbonus, resetVoiceCode: _voice_code.resetVoiceCode, checkCodeSendForPaymentIbonus: _payment.checkCodeSendForPaymentIbonus, modalHide: _modal.hide }), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(IBonusPayment, _Component);
	    (0, _createClass3.default)(IBonusPayment, null, [{
	        key: 'checkSlug',
	        value: function checkSlug(name) {
	            return name === IBONUS_PAYMENT_SLUG;
	        }
	    }]);
	
	    function IBonusPayment(props, context) {
	        (0, _classCallCheck3.default)(this, IBonusPayment);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (IBonusPayment.__proto__ || (0, _getPrototypeOf2.default)(IBonusPayment)).call(this, props, context));
	
	        _this._elements = {};
	
	        _this.onSubmit = function (event) {
	            var alert = {};
	            alert.message = _this.props.lang['store.ibonus_payment.not_enough_funds'];
	            event.preventDefault();
	            // TODO LANG проверить, как работает условие при установке языка, отличного от русского
	            if (_this.props.error == "Введите пожалуйста ранее высланный вам код") {
	                _this.props.setStepConfirm(true);
	                _this.setState({ stepConfirmIn: true });
	            }
	            if (_this.state.checkedPaymentAmount === 0 || _this.state.checkedPaymentAmount < Number(_this.props.sum)) {
	                _this.showOuterAlert(alert);
	            } else {
	                _this.props.checkCodeSendForPaymentIbonus(function (isSendCode) {
	                    if (isSendCode) {
	                        _this.props.setStepConfirm(true);
	                        _this.setState({ stepConfirmIn: true, outerAlert: null });
	                    } else {
	                        _this.props.paymentIbonus(_this.state.checkedPaymentId, _this.props.operationId);
	                    }
	                }, _this.props.shopId, _this.props.orderId);
	            }
	        };
	
	        _this.onSubmitConfirm = function (event) {
	            event.preventDefault();
	            _this.props.paymentIbonus(_this.state.checkedPaymentId, _this.props.operationId, _this.state.code);
	            _this.props.resetVoiceCode();
	        };
	
	        _this.onSlide = function (_ref) {
	            var index = _ref.index,
	                lastIndex = _ref.lastIndex,
	                element = _ref.element;
	
	            if (_this._elements.hasOwnProperty(index)) {
	                _this.setState({
	                    checkedPaymentId: parseInt(_this._elements[index].id, 10) || 0,
	                    checkedPaymentAmount: parseInt(_this.props.user.amount[index].amount, 10) || 0,
	                    selectSlide: index
	                });
	                if (_this.props.errorPay) {
	                    _this.props.resetPaymentIbonus();
	                }
	            }
	        };
	
	        _this.showAlert = function (alert) {
	            if (_this.props.errorPay) {
	                if (_this.props.errorCode === null || _this.props.errorCode === undefined) {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        _this.props.lang['store.common.server_is_unavailable']
	                    );
	                } else {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        _this.props.errorPay
	                    );
	                }
	            } else if (_this.props.alert || alert) {
	                var _ref2 = _this.props.alert || alert,
	                    message = _ref2.message,
	                    style = _ref2.style;
	
	                return _react3.default.createElement(
	                    _reactBootstrap.Alert,
	                    { bsStyle: style || 'danger', className: 'inner-right-xs' },
	                    message
	                );
	            }
	
	            return '';
	        };
	
	        _this.showOuterAlert = function (alert) {
	            _this.setState({ outerAlert: alert });
	        };
	
	        _this.renderPayments = function () {
	            var user = _this.props.user || {};
	            var _user$amount = user.amount,
	                amount = _user$amount === undefined ? [] : _user$amount;
	
	            var elements = amount.map(function (amount, index) {
	                return _react3.default.createElement(_AmountFormat2.default, { key: index, amount: amount, wrapProps: {
	                        className: "one_slider",
	                        ref: function ref(element) {
	                            _this._elements[index] = {
	                                id: amount.id
	                            };
	                        }
	                    } });
	            });
	
	            return _react3.default.createElement(
	                _Slider.Slider,
	                {
	                    loop: false,
	                    selected: _this.state.selectSlide,
	                    showArrows: true,
	                    showNav: true,
	                    onSlide: _this.onSlide
	                },
	                elements
	            );
	        };
	
	        _this.renderAccountForm = function () {
	            return _react3.default.createElement(
	                'form',
	                { onSubmit: _this.onSubmit },
	                _this.state.outerAlert ? _this.showAlert(_this.state.outerAlert) : _this.showAlert(),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'amount-wrap' },
	                    _react3.default.createElement(
	                        'p',
	                        { className: 'amount-title' },
	                        _this.props.lang['store.ibonus_payment.select_account'],
	                        ':'
	                    ),
	                    _this.renderPayments()
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 submit' },
	                        _react3.default.createElement('input', { type: 'submit', value: '\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C', className: 'le-button big' })
	                    )
	                )
	            );
	        };
	
	        _this.renderConfirmCodeForm = function () {
	            var lang = _this.props.lang;
	
	
	            return _react3.default.createElement(
	                'form',
	                { onSubmit: _this.onSubmitConfirm, className: 'confirm-send-code-payment-pipo' },
	                _this.state.outerAlert ? _this.showAlert(_this.state.outerAlert) : _this.showAlert(),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'form-group confirm-send-code-payment-pipo__wrap' },
	                    _react3.default.createElement(
	                        'label',
	                        { htmlFor: 'confirmCode', className: 'control-label' },
	                        lang['store.ibonus_payment.confirmation_code'],
	                        ':'
	                    ),
	                    _react3.default.createElement('input', {
	                        name: 'code',
	                        onChange: function onChange(e) {
	                            if ((0, _utils.validateNumeric)(e.target.value)) {
	                                _this.setState({ code: e.target.value });
	                            }
	                        },
	                        placeholder: lang['store.ibonus_payment.confirmation_code'],
	                        type: (0, _utils.isMobileDevice)() ? "number" : "text",
	                        pattern: '\\d*',
	                        id: 'confirmCode',
	                        className: 'form-control'
	                    })
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 submit' },
	                        _react3.default.createElement('input', { type: 'submit', value: lang['store.common.confirm'], className: 'le-button big' })
	                    )
	                ),
	                _react3.default.createElement(_components2.VoiceCode, {
	                    login: _this.props.user.phone,
	                    source: 'confirm_payout',
	                    showAlert: _this.showOuterAlert,
	                    whiteList: true
	                })
	            );
	        };
	
	        _this.state = {
	            selectSlide: 0,
	            checkedPaymentId: parseInt(_this.props.user.amount[0].id, 10) || 0,
	            checkedPaymentAmount: parseInt(_this.props.user.amount[0].amount, 10) || 0,
	            code: '',
	            outerAlert: null,
	            stepConfirmLocal: _this.props.stepConfirm,
	            stepConfirmIn: false
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(IBonusPayment, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _props = this.props,
	                stepConfirm = _props.stepConfirm,
	                errorPay = _props.errorPay,
	                lang = _props.lang;
	
	            // TODO LANG проверить, как работает условие при установке языка, отличного от русского
	
	            if (nextProps.errorPay == "Введите пожалуйста ранее высланный вам код") {
	                this.setState({
	                    stepConfirmLocal: true
	                });
	            }
	
	            if (stepConfirm !== nextProps.stepConfirm) {
	                this.setState({
	                    stepConfirmLocal: nextProps.stepConfirm
	                });
	            }
	
	            if (!nextProps.user) {
	                this.props.modalHide();
	                return;
	            }
	
	            if (this.props.isPayOrder === false && nextProps.isPayOrder === true) {
	                this.props.resetPaymentIbonus();
	                if (this.props.callbackPay) {
	                    this.props.callbackPay();
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.resetPaymentIbonus();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var content = void 0;
	
	            if (this.state.stepConfirmLocal || this.state.stepConfirmIn) {
	                content = this.renderConfirmCodeForm();
	            } else {
	                content = this.renderAccountForm();
	            }
	
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'i-bonus-payment-form', id: 'auth-form' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'bordered' },
	                        content
	                    )
	                )
	            );
	        }
	    }]);
	    return IBonusPayment;
	}(_react2.Component), _class2.propTypes = {
	    user: _react2.PropTypes.object,
	    operationId: _react2.PropTypes.number.isRequired,
	    orderId: _react2.PropTypes.number.isRequired,
	    isPayOrder: _react2.PropTypes.bool,
	    preload: _react2.PropTypes.bool,
	    callbackPay: _react2.PropTypes.func,
	    errorPay: _react2.PropTypes.string,
	    modalHide: _react2.PropTypes.func.isRequired,
	    lang: _react2.PropTypes.object
	}, _class2.defaultProps = {
	    // user: {},
	    modalHide: function modalHide() {},
	    orderId: 0,
	    operationId: 0
	}, _temp)) || _class));
	
	exports.default = IBonusPayment;

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(15);
	
	var _constants = __webpack_require__(18);
	
	var _reactRouter = __webpack_require__(19);
	
	var _catalog = __webpack_require__(67);
	
	var _utils = __webpack_require__(386);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Menu: {
	        displayName: "Menu"
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: "/usr/local/ibonus/src/components/Menu/Menu.jsx",
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Menu = _wrapComponent("Menu")((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        location: state.routing.locationBeforeTransitions.pathname,
	        categories: state.catalog.categories,
	        categoriesLoading: state.catalog.categoriesLoading,
	        lang: state.lang,
	        setting: state.setting
	    };
	}, {
	    refreshCatalog: _catalog.refreshCatalog,
	    getCatalog: _catalog.getCatalog,
	    getByCategory: _catalog.getByCategory,
	    hasOffersInRootCategory: _catalog.hasOffersInRootCategory
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Menu, _Component);
	
	    function Menu(props) {
	        (0, _classCallCheck3.default)(this, Menu);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props));
	
	        _this.state = {
	            showMenu: false // скрывать по умолчанию на главной в мобильной!
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Menu, [{
	        key: "componentWillReceiveProps",
	
	
	        // Сброс состояния при обновлении компонента
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.categoriesLoading !== nextProps.categoriesLoading) {
	                this.props.categoriesLoading ? this.closeMenu() : this.openMenu();
	            }
	
	            if (this.props.drop !== nextProps.drop) {
	                nextProps.drop && this.closeMenu();
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var View = _helpers.ThemeHelper.getViewForComponent("Menu");
	
	            return _react3.default.createElement(View, (0, _extends3.default)({}, this.props, {
	                onClick_Category: function onClick_Category(data) {
	                    return _this2.onClick_Category(data);
	                },
	                openMenu: function openMenu() {
	                    return _this2.openMenu();
	                },
	                closeMenu: function closeMenu() {
	                    return _this2.closeMenu();
	                },
	                toggleMenu: function toggleMenu() {
	                    return _this2.toggleMenu();
	                },
	                showMenu: this.state.showMenu,
	                buyInCreditActive: this.props.setting.buyInCreditActive,
	                buyInCredit: this.props.setting.buyInCredit
	            }));
	        }
	    }, {
	        key: "onClick_Category",
	        value: function onClick_Category(_ref) {
	            var _this3 = this;
	
	            var id = _ref.id,
	                children = _ref.children;
	
	            if (id === null) {
	                return;
	            }
	            this.props.refreshCatalog().then(function () {
	                var found = (0, _utils.findCategoryDeep)(_this3.props.categories, id);
	                if (found !== null) {
	                    _reactRouter.browserHistory.push("/category/" + id + "?limit=" + _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT + "&page=1");
	                } else {
	                    _reactRouter.browserHistory.push("/");
	                }
	            });
	
	            this.closeMenu();
	        }
	    }, {
	        key: "openMenu",
	        value: function openMenu() {
	            this.setState({ showMenu: true });
	        }
	    }, {
	        key: "closeMenu",
	        value: function closeMenu() {
	            this.setState({ showMenu: false });
	        }
	    }, {
	        key: "toggleMenu",
	        value: function toggleMenu() {
	            this.setState(function (prevState) {
	                return { showMenu: !prevState.showMenu };
	            });
	        }
	    }]);
	    return Menu;
	}(_react2.Component), _class2.propTypes = {
	    categories: _react2.PropTypes.array.isRequired,
	    lang: _react2.PropTypes.object
	}, _class2.defaultProps = {
	    categories: []
	}, _temp)) || _class));
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _MenuItem = __webpack_require__(751);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    MenuBody: {
	        displayName: 'MenuBody'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Menu/default/MenuBody/MenuBody.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MenuBody = _wrapComponent('MenuBody')(function (_Component) {
	    (0, _inherits3.default)(MenuBody, _Component);
	
	    function MenuBody(props) {
	        (0, _classCallCheck3.default)(this, MenuBody);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (MenuBody.__proto__ || (0, _getPrototypeOf2.default)(MenuBody)).call(this, props));
	
	        _this.handleClick = function (category) {
	            return function (e) {
	                e.preventDefault();
	                _this.props.onClick_Category(category);
	            };
	        };
	
	        _this.handleClickDescription = function (category) {
	            return function (e) {
	                e.preventDefault();
	                _this.toggleDescription();
	            };
	        };
	
	        _this.state = {
	            showDescription: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(MenuBody, [{
	        key: 'toggleDescription',
	        value: function toggleDescription() {
	            this.setState(function (prevState) {
	                return { showDescription: !prevState.showDescription };
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var category = this.props.category;
	
	            return _react3.default.createElement(
	                'li',
	                { className: 'dropdown menu-item' },
	                _react3.default.createElement(
	                    'a',
	                    { className: category.children && category.children.length > 0 ? "dropdown-toggle " : "" + "link_underline",
	                        href: '#',
	                        onClick: this.handleClick(category)
	                    },
	                    _react3.default.createElement(
	                        'div',
	                        { style: { display: 'flex' } },
	                        _react3.default.createElement(
	                            'div',
	                            { style: { width: '75%' } },
	                            category.title
	                        )
	                    )
	                ),
	                category.picture_menu ? _react3.default.createElement(
	                    'div',
	                    null,
	                    _react3.default.createElement('img', { src: category.picture_menu, alt: '', style: { width: '60%' } })
	                ) : null,
	                this.state.showDescription ? _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: category.description_menu } }) : null,
	                category.children && category.children.length > 0 ? _react3.default.createElement(
	                    'ul',
	                    { className: 'dropdown-menu drop_box' },
	                    _react3.default.createElement(
	                        'li',
	                        { className: 'yamm-content' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react3.default.createElement(
	                                    'ul',
	                                    null,
	                                    category.children.map(function (item, index) {
	                                        return _react3.default.createElement(_MenuItem2.default, {
	                                            key: index,
	                                            category: item,
	                                            encapsulate: 0,
	                                            onClick_Category: _this2.props.onClick_Category,
	                                            openMenu: _this2.props.openMenu,
	                                            closeMenu: _this2.props.closeMenu,
	                                            toggleMenu: _this2.props.toggleMenu
	                                        });
	                                    })
	                                )
	                            )
	                        )
	                    )
	                ) : null,
	                category.description_menu ? _react3.default.createElement(
	                    'div',
	                    { style: {
	                            width: '25px',
	                            display: 'inline-block',
	                            cursor: 'pointer',
	                            textAlign: 'center',
	                            verticalAlign: 'top',
	                            position: 'absolute',
	                            top: '5px',
	                            left: '75%'
	                        },
	                        onClick: this.handleClickDescription(category)
	                    },
	                    _react3.default.createElement('img', { src: '/assets/images/info.svg', alt: '' })
	                ) : null
	            );
	        }
	    }]);
	    return MenuBody;
	}(_react2.Component));
	
	exports.default = MenuBody;
	;
	module.exports = exports['default'];

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuBody = exports.MenuItem = undefined;
	
	var _MenuItem2 = __webpack_require__(751);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _MenuBody2 = __webpack_require__(1682);
	
	var _MenuBody3 = _interopRequireDefault(_MenuBody2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MenuItem = _MenuItem3.default;
	exports.MenuBody = _MenuBody3.default;

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactRouter = __webpack_require__(19);
	
	var _MenuBody = __webpack_require__(1683);
	
	__webpack_require__(1083);
	
	__webpack_require__(1084);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Menu: {
	        displayName: 'Menu'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Menu/default/MenuView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MIN_SCROLL_HEIGHT = 250;
	var FPS = 1000 / 60;
	var SCROLL_DELAY = 100;
	
	var Menu = _wrapComponent('Menu')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(Menu, _Component);
	
	    function Menu(props) {
	        (0, _classCallCheck3.default)(this, Menu);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props));
	
	        _this.handleScroll = function (e) {
	            if (window.pageYOffset > _this.refs.menu.offsetHeight && window.pageYOffset > MIN_SCROLL_HEIGHT) {
	                if (!_this.state.showUpButton) {
	                    _this.setState({ showUpButton: true });
	                }
	            } else {
	                if (_this.state.showUpButton) {
	                    _this.setState({ showUpButton: false });
	                }
	            }
	        };
	
	        _this.handleUpButtonClick = function (e) {
	            setTimeout(function animateScroll() {
	                window.scrollBy(0, -SCROLL_DELAY);
	                if (window.pageYOffset - SCROLL_DELAY > 0) {
	                    setTimeout(animateScroll, FPS);
	                } else {
	                    window.scrollTo(0, 0);
	                }
	            }, FPS);
	        };
	
	        _this.state = {
	            showMenu: false,
	            showUpButton: false,
	            isLink: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Menu, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('scroll', this.handleScroll);
	
	            // если в корне есть товары, то "Каталог" будет ссылкой на корень каталога
	            // this.props.hasOffersInRootCategory()
	            //     .then((isLink) => {
	            //         if (this.refs.menu) {
	            //             this.setState({isLink: isLink});
	            //         }
	            //     });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('scroll', this.handleScroll);
	        }
	
	        //Сброс состояния при обновлении компонента
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            nextProps.drop && this.setState({ showMenu: false });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                showMenu = _props.showMenu,
	                categories = _props.categories,
	                lang = _props.lang;
	            var _state = this.state,
	                showUpButton = _state.showUpButton,
	                isLink = _state.isLink;
	
	            var classShowMenu = showMenu ? ' show_menu ' : '';
	            var classShowBtn = showMenu ? ' show_btn ' : '';
	            var classStaticMenu = this.props.drop ? '' : ' my_container_static ';
	            var classDropBtn = this.props.drop ? ' drop_btn ' : '';
	            var pattern = /^[\/]\w*/;
	            var path = this.props.location.match(pattern);
	            var isRoot = true;
	            var isBannerVisible = path && (path[0] === '/' || path[0] === '/category');
	            var creditPageBanner = null;
	            if (isBannerVisible) {
	                if (this.props.buyInCreditActive) {
	                    creditPageBanner = _react3.default.createElement(
	                        'div',
	                        { style: { paddingTop: '3px' } },
	                        _react3.default.createElement(
	                            'a',
	                            { href: 'https://acdn.tinkoff.ru/static/documents/706fc26a-4917-4ee8-ae95-7a2abab59a4b.pdf',
	                                target: '__blank' },
	                            _react3.default.createElement('img', { src: 'assets/images/banners/credit-banner.png', alt: '' })
	                        )
	                    );
	                    if (this.props.buyInCredit.page) {
	                        creditPageBanner = _react3.default.createElement(
	                            'div',
	                            { style: { paddingTop: '3px' } },
	                            _react3.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/page/' + this.props.buyInCredit.page, target: '__blank' },
	                                _react3.default.createElement('img', { src: 'assets/images/banners/credit-banner.png', alt: '' })
	                            )
	                        );
	                    }
	                }
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-4 col-md-3 sidemenu-holder ' + classStaticMenu },
	                _react3.default.createElement(
	                    'div',
	                    { ref: 'menu', className: 'side-menu animate-dropdown my_dropdown', onMouseLeave: this.handleMouseLeave },
	                    isLink && !isRoot ? _react3.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'head my_dropdown_btn ' + classShowBtn + classDropBtn },
	                            _react3.default.createElement('i', { className: 'fa fa-folder-o' }),
	                            lang['store.menu.catalog']
	                        )
	                    ) : _react3.default.createElement(
	                        'div',
	                        { className: 'head my_dropdown_btn ' + classShowBtn + classDropBtn, onClick: this.props.toggleMenu },
	                        _react3.default.createElement('i', { className: 'fa fa-folder-o' }),
	                        lang['store.menu.catalog']
	                    ),
	                    _react3.default.createElement(
	                        'nav',
	                        { className: 'yamm megamenu-horizontal my_dropdown_content ' + classShowMenu, role: 'navigation' },
	                        _react3.default.createElement(
	                            'ul',
	                            { className: 'nav' },
	                            categories ? categories.map(function (category, index) {
	                                return _react3.default.createElement(_MenuBody.MenuBody, {
	                                    onClick_Category: _this2.props.onClick_Category,
	                                    openMenu: _this2.props.openMenu,
	                                    closeMenu: _this2.props.closeMenu,
	                                    toggleMenu: _this2.props.toggleMenu,
	                                    category: category,
	                                    key: index
	                                });
	                            }) : null
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'up_button ' + (showUpButton ? ' show ' : ' hide '), title: lang['store.menu.up'], onClick: this.handleUpButtonClick },
	                    _react3.default.createElement('i', { className: 'fa fa-angle-double-up', 'aria-hidden': 'true' })
	                ),
	                creditPageBanner
	            );
	        }
	    }]);
	    return Menu;
	}(_react2.Component), _class.propTypes = {
	    categories: _react2.PropTypes.array.isRequired,
	    lang: _react2.PropTypes.object
	}, _temp));
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Menu = undefined;
	
	var _Menu2 = __webpack_require__(1681);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Menu = _Menu3.default;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    MiniBasket: {
	        displayName: 'MiniBasket'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/MiniBasket/MiniBasket.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MiniBasket = _wrapComponent('MiniBasket')((_dec = (0, _reactRedux.connect)(function (state) {
	    return { items: state.basket.items };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(MiniBasket, _Component);
	
	    function MiniBasket() {
	        (0, _classCallCheck3.default)(this, MiniBasket);
	        return (0, _possibleConstructorReturn3.default)(this, (MiniBasket.__proto__ || (0, _getPrototypeOf2.default)(MiniBasket)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MiniBasket, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('MiniBasket');
	
	            var count = 0;
	            this.props.items.forEach(function (item) {
	                count += item.count;
	            });
	
	            return _react3.default.createElement(View, { length: count });
	        }
	    }]);
	    return MiniBasket;
	}(_react2.Component), _class2.propTypes = {
	    items: _react2.PropTypes.array.isRequired
	}, _class2.defaultProps = {
	    items: []
	}, _temp)) || _class));
	
	exports.default = MiniBasket;
	module.exports = exports['default'];

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 26.10.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _reactRouter = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    MiniBasketView: {
	        displayName: 'MiniBasketView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/MiniBasket/default/MiniBasketView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MiniBasketView = _wrapComponent('MiniBasketView')(function (_Component) {
	    (0, _inherits3.default)(MiniBasketView, _Component);
	
	    function MiniBasketView() {
	        (0, _classCallCheck3.default)(this, MiniBasketView);
	        return (0, _possibleConstructorReturn3.default)(this, (MiniBasketView.__proto__ || (0, _getPrototypeOf2.default)(MiniBasketView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MiniBasketView, [{
	        key: 'render',
	        value: function render() {
	            var length = this.props.length;
	
	            var isActive = length ? " active_icon" : "";
	            return _react3.default.createElement(
	                _reactRouter.Link,
	                { to: '/basket', className: 'ibonus-shopping-cart' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'header_icon-holder' },
	                    _react3.default.createElement('i', { className: "fa fa-shopping-cart header_icon " + isActive }),
	                    length ? _react3.default.createElement(
	                        'div',
	                        { className: 'header_icon_text-holder' },
	                        _react3.default.createElement(
	                            'span',
	                            { className: 'header_icon_text' },
	                            length
	                        )
	                    ) : null
	                )
	            );
	        }
	    }]);
	    return MiniBasketView;
	}(_react2.Component));
	
	exports.default = MiniBasketView;
	module.exports = exports['default'];

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MiniBasket = undefined;
	
	var _MiniBasket2 = __webpack_require__(1686);
	
	var _MiniBasket3 = _interopRequireDefault(_MiniBasket2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MiniBasket = _MiniBasket3.default;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Created by maximus on 29.11.16.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _isFunction = __webpack_require__(323);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _constants = __webpack_require__(752);
	
	var _modal = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ModalWindow: {
	        displayName: 'ModalWindow'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Modal/ModalWindow.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ModalWindow = _wrapComponent('ModalWindow')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        modal: state.modal
	    };
	}, {
	    hide: _modal.hide,
	    pushState: _reactRouterRedux.push
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(ModalWindow, _Component);
	
	    function ModalWindow(props, context) {
	        (0, _classCallCheck3.default)(this, ModalWindow);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ModalWindow.__proto__ || (0, _getPrototypeOf2.default)(ModalWindow)).call(this, props, context));
	
	        _this.registerEvent = function (eventName, callback) {
	            _this.events[eventName] = callback;
	        };
	
	        _this.onEntering = function () {
	            if (_this.events.hasOwnProperty('onEntering') && (0, _isFunction2.default)(_this.events.onEntering)) {
	                var _this$events;
	
	                (_this$events = _this.events).onEntering.apply(_this$events, arguments);
	            }
	        };
	
	        _this.handleSuccess = function () {
	            _this.props.modal.onSuccess();
	            _this.props.hide();
	        };
	
	        _this.handleClose = function () {
	            _this.props.hide();
	        };
	
	        _this.onHide = function () {
	            var pushState = _this.props.pushState;
	
	
	            var REGEXP_ORDER_ROUTE = /(\/personal\/order\/)[\d]+/g;
	
	            if (REGEXP_ORDER_ROUTE.test(location.pathname)) {
	                pushState('/');
	            }
	
	            _this.props.hide();
	        };
	
	        _this.events = {};
	        return _this;
	    }
	
	    (0, _createClass3.default)(ModalWindow, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                registerEvent: this.registerEvent
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props$modal = this.props.modal,
	                is_show = _props$modal.is_show,
	                title = _props$modal.title,
	                content = _props$modal.content,
	                titleSuccess = _props$modal.titleSuccess,
	                titleClose = _props$modal.titleClose,
	                onSuccess = _props$modal.onSuccess,
	                modalType = _props$modal.modalType,
	                _props$modal$modalSet = _props$modal.modalSettings,
	                modalSettings = _props$modal$modalSet === undefined ? {} : _props$modal$modalSet;
	
	            var modalClass = 'modal';
	            var settings = {};
	            global.onwheel = undefined;
	            var successBtn = null;
	            var cancelBtn = _react3.default.createElement(
	                _reactBootstrap.Button,
	                { onClick: this.handleClose },
	                titleClose
	            );
	
	            switch (modalType) {
	                case _constants.ADD:
	                    successBtn = _react3.default.createElement(
	                        _reactBootstrap.Button,
	                        { bsStyle: 'success', onClick: this.handleSuccess },
	                        titleSuccess
	                    );
	                    break;
	                case _constants.DELETE:
	                    successBtn = _react3.default.createElement(
	                        _reactBootstrap.Button,
	                        { bsStyle: 'danger', onClick: this.handleSuccess },
	                        titleSuccess
	                    );
	                    break;
	                case _constants.EDIT:
	                    successBtn = _react3.default.createElement(
	                        _reactBootstrap.Button,
	                        { bsStyle: 'primary', onClick: this.handleSuccess },
	                        titleSuccess
	                    );
	                    break;
	                case _constants.INFO:
	                    successBtn = _react3.default.createElement(
	                        _reactBootstrap.Button,
	                        { bsStyle: 'info', onClick: this.handleSuccess },
	                        titleSuccess
	                    );
	                    break;
	                case _constants.SAVE:
	                    successBtn = _react3.default.createElement(
	                        _reactBootstrap.Button,
	                        { bsStyle: 'success', onClick: this.handleSuccess },
	                        titleSuccess
	                    );
	                    break;
	                case _constants.ADD_TO_CART:
	                    modalClass = 'addtocart modal';
	                    global.onwheel = function () {
	                        _this2.props.hide();
	                    };
	                    break;
	                case _constants.ALCOHOL_MODAL:
	                    successBtn = _react3.default.createElement(
	                        _reactBootstrap.Button,
	                        { bsStyle: 'danger', onClick: this.props.modal.onSuccess },
	                        'OK'
	                    );
	                    cancelBtn = null;
	                    break;
	                case _constants.MODIFIER_MODAL:
	                    modalClass = 'addtocart modal';
	                    // successBtn = <Button bsStyle="danger" onClick={this.props.modal.onSuccess}>OK</Button>;
	                    cancelBtn = null;
	                    break;
	                case _constants.COUPON_SEARCH_MODAL:
	                    // modalClass = 'addtocart modal';
	                    // successBtn = <Button bsStyle="danger" onClick={this.props.modal.onSuccess}>OK</Button>;
	                    cancelBtn = null;
	                    break;
	                case _constants.AUTH:
	                    settings.dialogClassName = 'registration-and-auth-modal';
	                    settings.onEntering = this.onEntering;
	                    break;
	                case _constants.AUTH_ONE_CLICK:
	                    settings.dialogClassName = 'registration-and-auth-modal';
	                    settings.onEntering = this.onEntering;
	                    break;
	                case _constants.REGISTRATION:
	                    settings.dialogClassName = 'registration-and-auth-modal';
	                    break;
	                case _constants.CONFIRM_PHONE:
	                    settings.dialogClassName = 'confirm-phone-modal';
	                    break;
	                case _constants.CONFIRM_CHANGE_PHONE:
	                    settings.dialogClassName = 'confirm-change-phone-modal';
	                    break;
	                case _constants.CONFIRM_MAIL:
	                    settings.dialogClassName = 'confirm-mail-modal';
	                    break;
	                case _constants.PASSWORD_CHANGE:
	                    settings.dialogClassName = 'password-change-modal';
	                    break;
	                case _constants.CONFIRM_OLD_MAIL:
	                    settings.dialogClassName = 'confirm-old-mail-modal';
	                    break;
	                case _constants.MAP_MODAL:
	                    this.onHide = function () {
	                        _this2.props.hide();
	                    };
	                    break;
	                case _constants.SAVE_SUCCESS:
	                    {
	                        this.onHide = function () {
	                            _this2.props.hide();
	                        };
	                        break;
	                    }
	            }
	
	            return _react3.default.createElement(
	                _reactBootstrap.Modal,
	                (0, _extends3.default)({
	                    show: is_show,
	                    onHide: this.onHide,
	                    backdrop: true,
	                    keyboard: true,
	                    bsClass: modalClass
	                }, content, settings),
	                _react3.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    { closeButton: true },
	                    _react3.default.createElement(
	                        _reactBootstrap.Modal.Title,
	                        null,
	                        ' ',
	                        title
	                    )
	                ),
	                _react3.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    content
	                ),
	                successBtn ? _react3.default.createElement(
	                    _reactBootstrap.Modal.Footer,
	                    null,
	                    cancelBtn,
	                    successBtn
	                ) : null
	            );
	        }
	    }]);
	    return ModalWindow;
	}(_react2.Component), _class2.propsType = {
	    hide: _react2.PropTypes.func.isRequired,
	    pushState: _react2.PropTypes.func.isRequired
	}, _class2.childContextTypes = {
	    registerEvent: _react2.PropTypes.func
	}, _temp)) || _class));
	
	exports.default = ModalWindow;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PhoneEmailInput = undefined;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    _component: {}
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Modal/PhoneEmailInput/PhoneEmailInput.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var some = __webpack_require__(1243);
	var find = __webpack_require__(1234);
	var reduce = __webpack_require__(1242);
	var map = __webpack_require__(1239);
	var filter = __webpack_require__(1233);
	var findIndex = __webpack_require__(482);
	var first = __webpack_require__(1235);
	var tail = __webpack_require__(1247);
	var debounce = __webpack_require__(1232);
	var memoize = __webpack_require__(488);
	var assign = __webpack_require__(1230);
	var isEqual = __webpack_require__(485);
	var trim = __webpack_require__(1249);
	var startsWith = __webpack_require__(1244);
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(28);
	var onClickOutside = __webpack_require__(1423);
	var classNames = __webpack_require__(14);
	var countryData = __webpack_require__(1037);
	var allCountries = countryData.allCountries;
	allCountries.unshift({ dialCode: '', format: '', iso2: '', name: '', priority: 0 });
	var iso2Lookup = countryData.iso2Lookup;
	var allCountryCodes = countryData.allCountryCodes;
	
	if (typeof document !== 'undefined') {
	    var isModernBrowser = Boolean(document.createElement('input').setSelectionRange);
	} else {
	    var isModernBrowser = true;
	}
	
	var keys = {
	    UP: 38,
	    DOWN: 40,
	    RIGHT: 39,
	    LEFT: 37,
	    ENTER: 13,
	    ESC: 27,
	    PLUS: 43,
	    A: 65,
	    Z: 90,
	    SPACE: 32
	};
	
	function isNumberValid(inputNumber) {
	    var countries = countryData.allCountries;
	    return some(countries, function (country) {
	        return startsWith(inputNumber, country.dialCode) || startsWith(country.dialCode, inputNumber);
	    });
	}
	
	var PhoneEmailInput = exports.PhoneEmailInput = _wrapComponent('_component')(React.createClass({
	    displayName: 'PhoneEmailInput',
	    getInitialState: function getInitialState() {
	        var preferredCountries = this.props.preferredCountries.map(function (iso2) {
	            return iso2Lookup.hasOwnProperty(iso2) ? allCountries[iso2Lookup[iso2]] : null;
	        }).filter(function (val) {
	            return val !== null;
	        });
	
	        return assign({}, {
	            preferredCountries: preferredCountries,
	            showDropDown: false,
	            queryString: '',
	            freezeSelection: false,
	            debouncedQueryStingSearcher: debounce(this.searchCountry, 300)
	        }, this._mapPropsToState(this.props, true));
	    },
	
	    propTypes: {
	        value: React.PropTypes.string,
	        initialValue: React.PropTypes.string,
	        autoFormat: React.PropTypes.bool,
	        defaultCountry: React.PropTypes.string,
	        onlyCountries: React.PropTypes.arrayOf(React.PropTypes.object),
	        preferredCountries: React.PropTypes.arrayOf(React.PropTypes.string),
	        classNames: React.PropTypes.string,
	        className: React.PropTypes.string,
	        inputId: React.PropTypes.string,
	        onChange: React.PropTypes.func,
	        onEnterKeyPress: React.PropTypes.func,
	        onBlur: React.PropTypes.func,
	        onFocus: React.PropTypes.func,
	        disabled: React.PropTypes.bool,
	        pattern: React.PropTypes.string,
	        required: React.PropTypes.bool,
	        type: React.PropTypes.string
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            autoFormat: false,
	            onlyCountries: allCountries,
	            defaultCountry: allCountries[0].iso2,
	            isValid: isNumberValid,
	            flagsImagePath: 'flags.png',
	            onEnterKeyPress: function onEnterKeyPress() {},
	            preferredCountries: [],
	            disabled: false,
	            placeholder: 'Email или телефон начиная с +',
	            autoComplete: 'login',
	            required: false,
	            type: 'text'
	        };
	    },
	    getNumber: function getNumber() {
	        return this.state.formattedNumber !== '+' ? this.state.formattedNumber : '';
	    },
	    getValue: function getValue() {
	        return this.getNumber();
	    },
	    componentDidMount: function componentDidMount() {
	        document.addEventListener('keydown', this.handleKeydown);
	
	        this._cursorToEnd(true);
	        if (typeof this.props.onChange === 'function') {
	            this.props.onChange(this.state.formattedNumber, this.state.selectedCountry);
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this.setState(this._mapPropsToState(nextProps));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('keydown', this.handleKeydown);
	    },
	    scrollTo: function scrollTo(country, middle) {
	        if (!country) {
	            return;
	        }
	
	        var container = ReactDOM.findDOMNode(this.refs.flagDropdownList);
	
	        if (!container) {
	            return;
	        }
	
	        var containerHeight = container.offsetHeight;
	        var containerOffset = container.getBoundingClientRect();
	        var containerTop = containerOffset.top + document.body.scrollTop;
	        var containerBottom = containerTop + containerHeight;
	
	        var element = country;
	        var elementOffset = element.getBoundingClientRect();
	
	        var elementHeight = element.offsetHeight;
	        var elementTop = elementOffset.top + document.body.scrollTop;
	        var elementBottom = elementTop + elementHeight;
	        var newScrollTop = elementTop - containerTop + container.scrollTop;
	        var middleOffset = containerHeight / 2 - elementHeight / 2;
	
	        if (elementTop < containerTop) {
	            // scroll up
	            if (middle) {
	                newScrollTop -= middleOffset;
	            }
	            container.scrollTop = newScrollTop;
	        } else if (elementBottom > containerBottom) {
	            // scroll down
	            if (middle) {
	                newScrollTop += middleOffset;
	            }
	            var heightDifference = containerHeight - elementHeight;
	            container.scrollTop = newScrollTop - heightDifference;
	        }
	    },
	    formatNumber: function formatNumber(text, pattern) {
	        if (!text || text.length === 0) {
	            return '+';
	        }
	
	        // for all strings with length less than 3, just return it (1, 2 etc.)
	        // also return the same text if the selected country has no fixed format
	        if (text && text.length < 2 || !pattern || !this.props.autoFormat) {
	            return '+' + text;
	        }
	
	        var formattedObject = reduce(pattern, function (acc, character) {
	            if (acc.remainingText.length === 0) {
	                return acc;
	            }
	
	            if (character !== '.') {
	                return {
	                    formattedText: acc.formattedText + character,
	                    remainingText: acc.remainingText
	                };
	            }
	
	            return {
	                formattedText: acc.formattedText + first(acc.remainingText),
	                remainingText: tail(acc.remainingText)
	            };
	        }, { formattedText: '', remainingText: text.split('') });
	        return formattedObject.formattedText + formattedObject.remainingText.join('');
	    },
	
	
	    // put the cursor to the end of the input (usually after a focus event)
	    _cursorToEnd: function _cursorToEnd(skipFocus) {
	        var input = this.refs.numberInput;
	        if (skipFocus) {
	            this._fillDialCode();
	        } else {
	            input.focus();
	
	            if (isModernBrowser) {
	                var len = input.value.length;
	                input.setSelectionRange(len, len);
	            }
	        }
	    },
	
	    // memoize results based on the first 5/6 characters. That is all that matters
	    guessSelectedCountry: function guessSelectedCountry(inputNumber) {
	        var secondBestGuess = find(allCountries, { iso2: this.props.defaultCountry }) || this.props.onlyCountries[0];
	        var inputNumberForCountries = inputNumber.substr(0, 4);
	        if (trim(inputNumber) !== '') {
	            var bestGuess = reduce(this.props.onlyCountries, function (selectedCountry, country) {
	
	                // if the country dialCode exists WITH area code
	
	                if (allCountryCodes[inputNumberForCountries] && allCountryCodes[inputNumberForCountries][0] === country.iso2) {
	                    return country;
	
	                    // if the selected country dialCode is there with the area code
	                } else if (allCountryCodes[inputNumberForCountries] && allCountryCodes[inputNumberForCountries][0] === selectedCountry.iso2) {
	                    return selectedCountry;
	
	                    // else do the original if statement
	                } else {
	                    if (startsWith(inputNumber, country.dialCode)) {
	                        if (country.dialCode.length > selectedCountry.dialCode.length) {
	                            return country;
	                        }
	                        if (country.dialCode.length === selectedCountry.dialCode.length && country.priority < selectedCountry.priority) {
	                            return country;
	                        }
	                    }
	                }
	                return selectedCountry;
	            }, { dialCode: '', priority: 10001 }, this);
	        } else {
	            return secondBestGuess;
	        }
	
	        if (!bestGuess.name) {
	            return secondBestGuess;
	        }
	
	        return bestGuess;
	    },
	    getElement: function getElement(index) {
	        return ReactDOM.findDOMNode(this.refs['flag_no_' + index]);
	    },
	    handleFlagDropdownClick: function handleFlagDropdownClick() {
	        var _this = this;
	
	        if (this.props.disabled) {
	            return;
	        }
	        // need to put the highlight on the current selected country if the dropdown is going to open up
	        this.setState({
	            showDropDown: !this.state.showDropDown,
	            highlightCountry: find(this.props.onlyCountries, this.state.selectedCountry),
	            highlightCountryIndex: findIndex(this.state.preferredCountries.concat(this.props.onlyCountries), this.state.selectedCountry)
	        }, function () {
	            // only need to scrool if the dropdown list is alive
	            if (_this.state.showDropDown) {
	                _this.scrollTo(_this.getElement(_this.state.highlightCountryIndex + _this.state.preferredCountries.length));
	            }
	        });
	    },
	    handleInput: function handleInput(event) {
	        var formattedNumber = '',
	            newSelectedCountry = this.state.selectedCountry,
	            freezeSelection = 0; //this.state.freezeSelection;
	
	        // if the input is the same as before, must be some special key like enter etc.
	        if (event.target.value === this.state.formattedNumber) {
	            return;
	        }
	
	        // ie hack
	        if (event.preventDefault) {
	            event.preventDefault();
	        } else {
	            event.returnValue = false;
	        }
	
	        if (event.target.value.length > 0) {
	            // before entering the number in new format, lets check if the dial code now matches some other country
	            //var inputNumber = event.target.value.replace(/\D/g, '');
	            var inputNumber = event.target.value;
	            // we don't need to send the whole number to guess the country... only the first 6 characters are enough
	            // the guess country function can then use memoization much more effectively since the set of input it gets has drastically reduced
	            if (!this.state.freezeSelection || this.state.selectedCountry.dialCode.length > inputNumber.length) {
	                newSelectedCountry = this.guessSelectedCountry(inputNumber.substring(0, 6));
	                freezeSelection = false;
	            }
	            // let us remove all non numerals from the input
	            //formattedNumber = this.formatNumber(inputNumber, newSelectedCountry.format);
	            formattedNumber = inputNumber;
	        }
	
	        var caretPosition = event.target.selectionStart;
	        var oldFormattedText = this.state.formattedNumber;
	        var diff = formattedNumber.length - oldFormattedText.length;
	
	        this.setState({
	            formattedNumber: formattedNumber,
	            freezeSelection: freezeSelection,
	            selectedCountry: newSelectedCountry.dialCode.length > 0 ? newSelectedCountry : this.state.selectedCountry
	        }, function () {
	            if (isModernBrowser) {
	                if (caretPosition === 1 && formattedNumber.length === 2) {
	                    caretPosition++;
	                }
	
	                if (diff > 0) {
	                    caretPosition = caretPosition - diff;
	                }
	
	                if (caretPosition > 0 && oldFormattedText.length >= formattedNumber.length) {
	                    this.refs.numberInput.setSelectionRange(caretPosition, caretPosition);
	                }
	            }
	
	            if (this.props.onChange) {
	                this.props.onChange(this.state.formattedNumber, this.state.selectedCountry);
	            }
	        });
	    },
	    handleInputClick: function handleInputClick() {
	        this.setState({ showDropDown: false });
	    },
	    handleFlagItemClick: function handleFlagItemClick(country) {
	        var currentSelectedCountry = this.state.selectedCountry;
	        var nextSelectedCountry = find(this.props.onlyCountries, country);
	
	        // tiny optimization
	        if (currentSelectedCountry.iso2 !== nextSelectedCountry.iso2) {
	
	            var newNumber = '+' + nextSelectedCountry.dialCode;
	            if (this.state.formattedNumber.length && this.state.formattedNumber[0] === '+') {
	                var dialCodeRegex = RegExp('^(\\+' + currentSelectedCountry.dialCode + ')|\\+');
	                newNumber = this.state.formattedNumber.replace(dialCodeRegex, '+' + nextSelectedCountry.dialCode);
	            }
	
	            var formattedNumber = this.formatNumber(newNumber.replace(/\D/g, ''), nextSelectedCountry.format);
	
	            this.setState({
	                showDropDown: false,
	                selectedCountry: nextSelectedCountry,
	                freezeSelection: true,
	                formattedNumber: formattedNumber
	            }, function () {
	                this._cursorToEnd();
	                if (this.props.onChange) {
	                    this.props.onChange(formattedNumber, nextSelectedCountry);
	                }
	            });
	        } else {
	            this.setState({ showDropDown: false });
	        }
	    },
	    handleInputFocus: function handleInputFocus() {
	        // trigger parent component's onFocus handler
	        if (typeof this.props.onFocus === 'function') {
	            this.props.onFocus(this.state.formattedNumer, this.state.selectedCountry);
	        }
	
	        this._fillDialCode();
	    },
	    _mapPropsToState: function _mapPropsToState(props) {
	        var firstCall = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var inputNumber = void 0;
	
	        if (props.value) {
	            inputNumber = props.value;
	        } else if (props.initialValue && firstCall) {
	            inputNumber = props.initialValue;
	        } else if (this.state && this.state.formattedNumber && this.state.formattedNumber.length > 0) {
	            inputNumber = this.state.formattedNumber;
	        } else {
	            inputNumber = '';
	        }
	
	        var selectedCountryGuess = this.guessSelectedCountry(inputNumber.replace(/\D/g, ''));
	        var selectedCountryGuessIndex = findIndex(allCountries, selectedCountryGuess);
	        var formattedNumber = this.formatNumber(inputNumber.replace(/\D/g, ''), selectedCountryGuess ? selectedCountryGuess.format : null);
	
	        return {
	            selectedCountry: selectedCountryGuess,
	            highlightCountryIndex: selectedCountryGuessIndex,
	            formattedNumber: inputNumber
	            //formattedNumber: formattedNumber
	        };
	    },
	    _fillDialCode: function _fillDialCode() {
	        // if the input is blank, insert dial code of the selected country
	        if (this.refs.numberInput.value === '+') {
	            this.setState({ formattedNumber: '+' + this.state.selectedCountry.dialCode });
	        }
	    },
	    _getHighlightCountryIndex: function _getHighlightCountryIndex(direction) {
	        // had to write own function because underscore does not have findIndex. lodash has it
	        var highlightCountryIndex = this.state.highlightCountryIndex + direction;
	
	        if (highlightCountryIndex < 0 || highlightCountryIndex >= this.props.onlyCountries.length + this.state.preferredCountries.length) {
	            return highlightCountryIndex - direction;
	        }
	
	        return highlightCountryIndex;
	    },
	
	    // memoize search results... caching all the way
	    _searchCountry: memoize(function (queryString) {
	        if (!queryString || queryString.length === 0) {
	            return null;
	        }
	        // don't include the preferred countries in search
	        var probableCountries = filter(this.props.onlyCountries, function (country) {
	            return startsWith(country.name.toLowerCase(), queryString.toLowerCase());
	        }, this);
	        return probableCountries[0];
	    }),
	    searchCountry: function searchCountry() {
	        var probableCandidate = this._searchCountry(this.state.queryString) || this.props.onlyCountries[0];
	        var probableCandidateIndex = findIndex(this.props.onlyCountries, probableCandidate) + this.state.preferredCountries.length;
	        this.scrollTo(this.getElement(probableCandidateIndex), true);
	
	        this.setState({
	            queryString: '',
	            highlightCountryIndex: probableCandidateIndex
	        });
	    },
	    handleKeydown: function handleKeydown(event) {
	        if (!this.state.showDropDown) {
	            return;
	        }
	
	        // ie hack
	        if (event.preventDefault) {
	            event.preventDefault();
	        } else {
	            event.returnValue = false;
	        }
	
	        var self = this;
	        function _moveHighlight(direction) {
	            self.setState({
	                highlightCountryIndex: self._getHighlightCountryIndex(direction)
	            }, function () {
	                self.scrollTo(self.getElement(self.state.highlightCountryIndex), true);
	            });
	        }
	
	        switch (event.which) {
	            case keys.DOWN:
	                _moveHighlight(1);
	                break;
	            case keys.UP:
	                _moveHighlight(-1);
	                break;
	            case keys.ENTER:
	                this.handleFlagItemClick(this.state.preferredCountries.concat(this.props.onlyCountries)[this.state.highlightCountryIndex], event);
	                break;
	            case keys.ESC:
	                this.setState({ showDropDown: false }, this._cursorToEnd);
	                break;
	            default:
	                if (event.which >= keys.A && event.which <= keys.Z || event.which === keys.SPACE) {
	                    this.setState({ queryString: this.state.queryString + String.fromCharCode(event.which) }, this.state.debouncedQueryStingSearcher);
	                }
	        }
	    },
	    handleInputKeyDown: function handleInputKeyDown(event) {
	        if (event.which === keys.ENTER) {
	            this.props.onEnterKeyPress(event);
	        }
	    },
	    handleClickOutside: function handleClickOutside() {
	        if (this.state.showDropDown) {
	            this.setState({
	                showDropDown: false
	            });
	        }
	    },
	    getCountryDropDownList: function getCountryDropDownList() {
	        var self = this;
	        var countryDropDownList = map(this.state.preferredCountries.concat(this.props.onlyCountries), function (country, index) {
	            var itemClasses = classNames({
	                country: true,
	                preferred: findIndex(self.state.preferredCountries, { iso2: country.iso2 }) >= 0,
	                highlight: self.state.highlightCountryIndex === index
	            });
	
	            var inputFlagClasses = 'flag ' + country.iso2;
	
	            return React.createElement(
	                'li',
	                {
	                    ref: 'flag_no_' + index,
	                    key: 'flag_no_' + index,
	                    'data-flag-key': 'flag_no_' + index,
	                    className: itemClasses,
	                    'data-dial-code': '1',
	                    'data-country-code': country.iso2,
	                    onClick: self.handleFlagItemClick.bind(self, country) },
	                React.createElement('div', { className: inputFlagClasses, style: self.getFlagStyle() }),
	                React.createElement(
	                    'span',
	                    { className: 'country-name' },
	                    country.name
	                ),
	                React.createElement(
	                    'span',
	                    { className: 'dial-code' },
	                    '+' + country.dialCode
	                )
	            );
	        });
	
	        var dashedLi = React.createElement('li', { key: "dashes", className: 'divider' });
	        // let's insert a dashed line in between preffered countries and the rest
	        countryDropDownList.splice(this.state.preferredCountries.length, 0, dashedLi);
	
	        var dropDownClasses = classNames({
	            'country-list': true,
	            'hide': !this.state.showDropDown
	        });
	        return React.createElement(
	            'ul',
	            { ref: 'flagDropdownList', className: dropDownClasses },
	            countryDropDownList
	        );
	    },
	    getFlagStyle: function getFlagStyle() {
	        return {
	            width: 16,
	            height: 11,
	            backgroundImage: 'url(' + this.props.flagsImagePath + ')'
	        };
	    },
	    handleInputBlur: function handleInputBlur() {
	        if (typeof this.props.onBlur === 'function') {
	            this.props.onBlur(this.state.formattedNumber, this.state.selectedCountry);
	        }
	    },
	    render: function render() {
	        var arrowClasses = classNames({
	            'arrow': true,
	            'up': this.state.showDropDown
	        });
	        var inputClasses = classNames({
	            'form-control': true,
	            'invalid-number': !this.props.isValid(this.state.formattedNumber.replace(/\D/g, ''))
	        });
	
	        var flagViewClasses = classNames({
	            'flag-dropdown': true,
	            'open-dropdown': this.state.showDropDown
	        });
	
	        var inputFlagClasses = 'flag ' + this.state.selectedCountry.iso2;
	        var otherProps = {};
	        if (this.props.inputId) {
	            otherProps.id = this.props.inputId;
	        }
	        return React.createElement(
	            'div',
	            { className: classNames('react-tel-input', this.props.classNames, this.props.className) },
	            React.createElement('input', (0, _extends3.default)({
	                onChange: this.handleInput,
	                onClick: this.handleInputClick,
	                onFocus: this.handleInputFocus,
	                onBlur: this.handleInputBlur,
	                onKeyDown: this.handleInputKeyDown,
	                value: this.state.formattedNumber,
	                ref: 'numberInput',
	                type: this.props.type,
	                className: inputClasses,
	                autoComplete: this.props.autoComplete,
	                pattern: this.props.pattern,
	                required: this.props.required,
	                placeholder: this.props.placeholder,
	                disabled: this.props.disabled }, otherProps)),
	            React.createElement(
	                'div',
	                { ref: 'flagDropDownButton', className: flagViewClasses, onKeyDown: this.handleKeydown },
	                React.createElement(
	                    'div',
	                    { ref: 'selectedFlag', onClick: this.handleFlagDropdownClick, className: 'selected-flag', title: this.state.selectedCountry.name + ': + ' + this.state.selectedCountry.dialCode },
	                    React.createElement(
	                        'div',
	                        { className: inputFlagClasses, style: this.getFlagStyle() },
	                        React.createElement('div', { className: arrowClasses })
	                    )
	                ),
	                this.state.showDropDown ? this.getCountryDropDownList() : ''
	            )
	        );
	    }
	}));
	
	exports.default = onClickOutside(PhoneEmailInput);

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhoneEmailInput = exports.ModalWindow = undefined;
	
	var _ModalWindow2 = __webpack_require__(1689);
	
	var _ModalWindow3 = _interopRequireDefault(_ModalWindow2);
	
	var _PhoneEmailInput2 = __webpack_require__(1690);
	
	var _PhoneEmailInput3 = _interopRequireDefault(_PhoneEmailInput2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ModalWindow = _ModalWindow3.default;
	exports.PhoneEmailInput = _PhoneEmailInput3.default;

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    MoneyValue: {
	        displayName: 'MoneyValue'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/MoneyValue/MoneyValue.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MoneyValue = _wrapComponent('MoneyValue')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(MoneyValue, _Component);
	
	    function MoneyValue(props) {
	        (0, _classCallCheck3.default)(this, MoneyValue);
	        return (0, _possibleConstructorReturn3.default)(this, (MoneyValue.__proto__ || (0, _getPrototypeOf2.default)(MoneyValue)).call(this, props));
	    }
	
	    (0, _createClass3.default)(MoneyValue, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('MoneyValue');
	
	            return _react3.default.createElement(View, this.props);
	        }
	    }]);
	    return MoneyValue;
	}(_react2.Component), _class.propTypes = {
	    value: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.number]),
	    icon: _react2.PropTypes.string,
	    icon_after_value: _react2.PropTypes.bool,
	    prefix: _react2.PropTypes.string
	}, _temp));
	
	exports.default = MoneyValue;
	module.exports = exports['default'];

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    MoneyValueView: {
	        displayName: 'MoneyValueView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/MoneyValue/default/MoneyValueView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MoneyValueView = _wrapComponent('MoneyValueView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(MoneyValueView, _Component);
	
	    function MoneyValueView(props) {
	        (0, _classCallCheck3.default)(this, MoneyValueView);
	        return (0, _possibleConstructorReturn3.default)(this, (MoneyValueView.__proto__ || (0, _getPrototypeOf2.default)(MoneyValueView)).call(this, props));
	    }
	
	    (0, _createClass3.default)(MoneyValueView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                value = _props.value,
	                icon = _props.icon,
	                iconAfterValue = _props.iconAfterValue,
	                prefix = _props.prefix;
	
	
	            var precisionLimit = 2;
	            if (icon === 'Br') {
	                precisionLimit = 4;
	            }
	            var formattedValue = value ? parseFloat(value).toFixed(precisionLimit) : 0;
	            var iconClassName = icon ? icon : 'fa fa-usd';
	            var prefixString = prefix ? prefix : '';
	
	            if (icon === 'L' || icon === 'Br' || icon === '₺' || icon === 'Dh' || icon === 'S$' || icon === 'сўм') {
	                return _react3.default.createElement(
	                    'span',
	                    null,
	                    prefixString,
	                    _react3.default.createElement('span', { style: { marginRight: '2px' } }),
	                    formattedValue,
	                    ' ',
	                    icon
	                );
	            }
	
	            return iconAfterValue ? _react3.default.createElement(
	                'span',
	                null,
	                prefixString,
	                formattedValue,
	                _react3.default.createElement('span', { className: iconClassName, style: { marginLeft: '2px' } })
	            ) : _react3.default.createElement(
	                'span',
	                null,
	                prefixString,
	                _react3.default.createElement('span', { className: iconClassName, style: { marginRight: '2px' } }),
	                formattedValue
	            );
	        }
	    }]);
	    return MoneyValueView;
	}(_react2.Component), _class.propTypes = {
	    value: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.number]),
	    icon: _react2.PropTypes.string,
	    iconAfterValue: _react2.PropTypes.bool,
	    prefix: _react2.PropTypes.string
	}, _temp));
	
	exports.default = MoneyValueView;
	module.exports = exports['default'];

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MoneyValue = undefined;
	
	var _MoneyValue2 = __webpack_require__(1692);
	
	var _MoneyValue3 = _interopRequireDefault(_MoneyValue2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MoneyValue = _MoneyValue3.default;

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 25.04.17.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Notification: {
	        displayName: 'Notification'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Notification/Notification.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Notification = _wrapComponent('Notification')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        setting: state.setting,
	        user: state.auth.user,
	        lang: state.lang
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Notification, _Component);
	
	    function Notification(props) {
	        (0, _classCallCheck3.default)(this, Notification);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Notification.__proto__ || (0, _getPrototypeOf2.default)(Notification)).call(this, props));
	
	        _this.checkEmptyField = function () {
	            var _this$props = _this.props,
	                setting = _this$props.setting,
	                user = _this$props.user;
	
	
	            if (user) {
	                var confirmed = user.confirmed;
	
	
	                if (setting.additionalFieldSettings) {
	                    var additionalFieldSettings = setting.additionalFieldSettings;
	
	
	                    return additionalFieldSettings.some(function (item) {
	                        var show_in_profile = item.show_in_profile,
	                            typeAdditionalField = item.typeAdditionalField;
	
	
	                        if (show_in_profile) {
	                            if (typeAdditionalField.slug === 'phone') {
	                                // данные поля в объекте confirmed называются по-другому
	                                return !confirmed['confirmed_' + typeAdditionalField.slug];
	                            } else if (typeAdditionalField.slug === 'email') {
	                                // данные поля в объекте confirmed называются по-другому
	                                return !confirmed['confirmed_' + typeAdditionalField.slug];
	                            } else if (typeAdditionalField.slug === 'username') {
	                                return !user.name;
	                            } else {
	                                return !confirmed[typeAdditionalField.slug];
	                            }
	                        }
	                    });
	                }
	
	                return !user.name || !user.phone;
	            }
	
	            return false;
	        };
	
	        _this.onClick = function () {
	            var onClick = _this.props.onClick;
	
	
	            if (onClick) {
	                onClick();
	            }
	        };
	
	        return _this;
	    }
	
	    /**
	     * Обработчик показа иконки нотификации
	     * @returns {boolean}
	     */
	
	
	    (0, _createClass3.default)(Notification, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                iconClassName = _props.iconClassName,
	                isLink = _props.isLink,
	                lang = _props.lang;
	
	
	            var View = _helpers.ThemeHelper.getViewForComponent('Notification');
	
	            return this.checkEmptyField() ? _react3.default.createElement(View, {
	                isLink: isLink,
	                className: className,
	                iconClassName: iconClassName,
	                onClick: this.onClick,
	                lang: lang
	            }) : null;
	        }
	    }]);
	    return Notification;
	}(_react2.Component), _class2.propTypes = {
	    className: _react2.PropTypes.string,
	    iconClassName: _react2.PropTypes.string,
	    onClick: _react2.PropTypes.func,
	    setting: _react2.PropTypes.object.isRequired,
	    user: _react2.PropTypes.object,
	    isLink: _react2.PropTypes.bool,
	    lang: _react2.PropTypes.object
	}, _class2.defaultProps = {
	    isLink: true
	}, _temp)) || _class));
	
	exports.default = Notification;
	module.exports = exports['default'];

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 25.04.17.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactRouter = __webpack_require__(19);
	
	__webpack_require__(1085);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    NotificationView: {
	        displayName: 'NotificationView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Notification/default/NotificationView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var NotificationView = _wrapComponent('NotificationView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(NotificationView, _Component);
	
	    function NotificationView(props) {
	        (0, _classCallCheck3.default)(this, NotificationView);
	        return (0, _possibleConstructorReturn3.default)(this, (NotificationView.__proto__ || (0, _getPrototypeOf2.default)(NotificationView)).call(this, props));
	    }
	
	    (0, _createClass3.default)(NotificationView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                iconClassName = _props.iconClassName,
	                isLink = _props.isLink,
	                onClick = _props.onClick,
	                lang = _props.lang;
	
	
	            if (isLink) {
	                return _react3.default.createElement(
	                    _reactRouter.Link,
	                    {
	                        className: className || '',
	                        onClick: onClick,
	                        title: lang['store.notification.empty_fields'],
	                        to: '/personal/profile'
	                    },
	                    _react3.default.createElement('i', { className: 'fa fa-exclamation-circle login_warning_icon' + (' ' + iconClassName || '') })
	                );
	            }
	
	            return _react3.default.createElement(
	                'span',
	                {
	                    className: className || '',
	                    title: lang['store.notification.empty_fields']
	                },
	                _react3.default.createElement('i', { className: 'fa fa-exclamation-circle login_list_warning_icon' + (' ' + iconClassName || '') })
	            );
	        }
	    }]);
	    return NotificationView;
	}(_react2.Component), _class.propTypes = {
	    className: _react2.PropTypes.string,
	    iconClassName: _react2.PropTypes.string,
	    onClick: _react2.PropTypes.func.isRequired,
	    isLink: _react2.PropTypes.bool.isRequired,
	    lang: _react2.PropTypes.object
	}, _temp));
	
	exports.default = NotificationView;
	module.exports = exports['default'];

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Notification = undefined;
	
	var _Notification2 = __webpack_require__(1695);
	
	var _Notification3 = _interopRequireDefault(_Notification2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Notification = _Notification3.default;

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    OperationsItem: {
	        displayName: 'OperationsItem'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Operations/OperationsItem.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var OperationsItem = _wrapComponent('OperationsItem')(function (_Component) {
	    (0, _inherits3.default)(OperationsItem, _Component);
	
	    function OperationsItem() {
	        (0, _classCallCheck3.default)(this, OperationsItem);
	        return (0, _possibleConstructorReturn3.default)(this, (OperationsItem.__proto__ || (0, _getPrototypeOf2.default)(OperationsItem)).call(this));
	    }
	
	    (0, _createClass3.default)(OperationsItem, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('OperationsItem', null, { folderName: 'Operations' });
	            return _react3.default.createElement(View, { item: this.props.item, lang: this.props.lang });
	        }
	    }]);
	    return OperationsItem;
	}(_react2.Component));
	
	exports.default = OperationsItem;
	module.exports = exports['default'];

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SaldoItem: {
	        displayName: 'SaldoItem'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Operations/SaldoItem.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var SaldoItem = _wrapComponent('SaldoItem')(function (_Component) {
	    (0, _inherits3.default)(SaldoItem, _Component);
	
	    function SaldoItem() {
	        (0, _classCallCheck3.default)(this, SaldoItem);
	        return (0, _possibleConstructorReturn3.default)(this, (SaldoItem.__proto__ || (0, _getPrototypeOf2.default)(SaldoItem)).call(this));
	    }
	
	    (0, _createClass3.default)(SaldoItem, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('SaldoItem', null, { folderName: 'Operations' });
	            return _react3.default.createElement(View, { item: this.props.item });
	        }
	    }]);
	    return SaldoItem;
	}(_react2.Component));
	
	exports.default = SaldoItem;
	module.exports = exports['default'];

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _moment = __webpack_require__(11);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    OprerationsItemView: {
	        displayName: 'OprerationsItemView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Operations/default/OperationsItemView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var OprerationsItemView = _wrapComponent('OprerationsItemView')(function (_Component) {
	    (0, _inherits3.default)(OprerationsItemView, _Component);
	
	    function OprerationsItemView() {
	        (0, _classCallCheck3.default)(this, OprerationsItemView);
	        return (0, _possibleConstructorReturn3.default)(this, (OprerationsItemView.__proto__ || (0, _getPrototypeOf2.default)(OprerationsItemView)).call(this));
	    }
	
	    (0, _createClass3.default)(OprerationsItemView, [{
	        key: 'render',
	        value: function render() {
	            var item = this.props.item;
	
	            var payClass = void 0,
	                payMark = void 0,
	                mark = void 0,
	                currencyName = void 0;
	
	            if (item.amount < 0) {
	                payClass = "text_color_red";
	                payMark = "";
	            } else {
	                payClass = "text_color_green";
	                payMark = "+";
	            }
	            if (item.type === 'WRITE_OFF') {
	                payClass = "text_color_red";
	                payMark = "";
	            } else {
	                payClass = "text_color_green";
	                payMark = "+";
	            }
	            if (item.currency === 'points' || item.currency === 'PTS') {
	                currencyName = this.props.lang['store.iBonus.operations.Points'];
	            } else {
	                currencyName = this.props.lang['store.iBonus.operations.Ruble'];
	            }
	
	            var dateTime = (0, _moment2.default)(item.date).format('DD.MM.YYYY HH:mm');
	            return _react3.default.createElement(
	                'div',
	                { className: 'row no-margin table_row' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-12 col-md-4 no-margin header_date' },
	                    dateTime
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-4 col-sm-4 col-md-4 no-margin price_holder ' + payClass },
	                    payMark + parseFloat(item.amount || 0).toFixed(2),
	                    mark ? _react3.default.createElement(
	                        'span',
	                        { className: 'list_operations_mark' },
	                        ' ',
	                        mark,
	                        ' '
	                    ) : null
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-12 col-md-4 no-margin price_holder' },
	                    currencyName
	                )
	            );
	        }
	    }]);
	    return OprerationsItemView;
	}(_react2.Component));
	
	exports.default = OprerationsItemView;
	module.exports = exports['default'];

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SaldoItemView: {
	        displayName: "SaldoItemView"
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: "/usr/local/ibonus/src/components/Operations/default/SaldoItemView.jsx",
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var SaldoItemView = _wrapComponent("SaldoItemView")(function (_Component) {
	    (0, _inherits3.default)(SaldoItemView, _Component);
	
	    function SaldoItemView() {
	        (0, _classCallCheck3.default)(this, SaldoItemView);
	        return (0, _possibleConstructorReturn3.default)(this, (SaldoItemView.__proto__ || (0, _getPrototypeOf2.default)(SaldoItemView)).call(this));
	    }
	
	    (0, _createClass3.default)(SaldoItemView, [{
	        key: "render",
	        value: function render() {
	            var item = this.props.item;
	
	
	            var payClass = void 0,
	                mark = void 0;
	
	            switch (item.id_currency) {
	                case 643:
	                    mark = _react3.default.createElement("span", { className: "fa fa-rub" });
	                    break;
	                case 980:
	                    mark = _react3.default.createElement(
	                        "span",
	                        { className: "ukr" },
	                        "\u20B4"
	                    );
	                    break;
	                case 498:
	                    mark = _react3.default.createElement(
	                        "span",
	                        { className: "mdl" },
	                        "L"
	                    );
	                    break;
	                case 978:
	                    mark = _react3.default.createElement("span", { className: "fa fa-eur" });
	                    break;
	                case 840:
	                    mark = _react3.default.createElement("span", { className: "fa fa-usd" });
	                    break;
	                case 826:
	                    mark = _react3.default.createElement("span", { className: "fa fa-gbr" });
	                    break;
	                case 933:
	                    mark = _react3.default.createElement(
	                        "span",
	                        { className: "byn" },
	                        "L"
	                    );
	                    break;
	                case 949:
	                    mark = _react3.default.createElement(
	                        "span",
	                        { className: "try" },
	                        "\u20BA"
	                    );
	                    break;
	                case 784:
	                    mark = _react3.default.createElement(
	                        "span",
	                        { className: "try" },
	                        "\u20BA"
	                    );
	                    break;
	                case 702:
	                    mark = _react3.default.createElement(
	                        "span",
	                        { className: "sgd" },
	                        "\u20BA"
	                    );
	                    break;
	                case 860:
	                    mark = _react3.default.createElement(
	                        "span",
	                        { className: "uzs" },
	                        "\u20BA"
	                    );
	                    break;
	                default:
	                    mark = null;
	            }
	
	            if (item.id_account != null) {
	
	                if (item.balance_after >= item.balance_begin) {
	                    payClass = "text_color_green";
	                } else {
	                    payClass = "text_color_red";
	                }
	
	                return _react3.default.createElement(
	                    "tr",
	                    { className: "table_row table_saldo" },
	                    _react3.default.createElement(
	                        "td",
	                        { className: "saldo_mark" },
	                        mark
	                    ),
	                    _react3.default.createElement(
	                        "td",
	                        { className: "text_color_green" },
	                        parseFloat(item.balance_begin || 0).toFixed(2)
	                    ),
	                    _react3.default.createElement(
	                        "td",
	                        { className: "text_color_green" },
	                        "+" + parseFloat(item.payin_now || 0).toFixed(2)
	                    ),
	                    _react3.default.createElement(
	                        "td",
	                        { className: "text_color_red" },
	                        "-" + parseFloat(item.payout_now || 0).toFixed(2)
	                    ),
	                    _react3.default.createElement(
	                        "td",
	                        { className: "" + payClass },
	                        parseFloat(item.balance_after || 0).toFixed(2)
	                    )
	                );
	            } else {
	                return null;
	            }
	        }
	    }]);
	    return SaldoItemView;
	}(_react2.Component));
	
	exports.default = SaldoItemView;
	module.exports = exports['default'];

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SaldoItem = exports.OperationsItem = undefined;
	
	var _OperationsItem2 = __webpack_require__(1698);
	
	var _OperationsItem3 = _interopRequireDefault(_OperationsItem2);
	
	var _SaldoItem2 = __webpack_require__(1699);
	
	var _SaldoItem3 = _interopRequireDefault(_SaldoItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.OperationsItem = _OperationsItem3.default;
	exports.SaldoItem = _SaldoItem3.default;

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    OrderItems: {
	        displayName: 'OrderItems'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Order/OrderItems.js',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var OrderItems = _wrapComponent('OrderItems')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang,
	        currency: state.currency
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(OrderItems, _Component);
	
	    function OrderItems(props) {
	        (0, _classCallCheck3.default)(this, OrderItems);
	        return (0, _possibleConstructorReturn3.default)(this, (OrderItems.__proto__ || (0, _getPrototypeOf2.default)(OrderItems)).call(this, props));
	    }
	
	    (0, _createClass3.default)(OrderItems, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('OrderItems', null, { folderName: 'Order' });
	
	            return _react3.default.createElement(View, this.props);
	        }
	    }]);
	    return OrderItems;
	}(_react2.Component), _class2.propTypes = {
	    onPay: _react2.PropTypes.func,
	    user: _react2.PropTypes.object,
	    paymentList: _react2.PropTypes.any,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = OrderItems;
	module.exports = exports['default'];

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    OrderItemsDetail: {
	        displayName: 'OrderItemsDetail'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Order/OrderItemsDetail.js',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var OrderItemsDetail = _wrapComponent('OrderItemsDetail')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang,
	        currency: state.currency,
	        addresses: state.address.list
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(OrderItemsDetail, _Component);
	
	    function OrderItemsDetail(props) {
	        (0, _classCallCheck3.default)(this, OrderItemsDetail);
	        return (0, _possibleConstructorReturn3.default)(this, (OrderItemsDetail.__proto__ || (0, _getPrototypeOf2.default)(OrderItemsDetail)).call(this, props));
	    }
	
	    (0, _createClass3.default)(OrderItemsDetail, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('OrderItemsDetail', null, { folderName: 'Order' });
	            return _react3.default.createElement(View, this.props);
	        }
	    }]);
	    return OrderItemsDetail;
	}(_react2.Component), _class2.propTypes = {
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = OrderItemsDetail;
	module.exports = exports['default'];

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	__webpack_require__(1086);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    OrderSteps: {
	        displayName: 'OrderSteps'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Order/OrderSteps/index.js',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var OrderSteps = _wrapComponent('OrderSteps')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(OrderSteps, _Component);
	
	    function OrderSteps(props) {
	        (0, _classCallCheck3.default)(this, OrderSteps);
	        return (0, _possibleConstructorReturn3.default)(this, (OrderSteps.__proto__ || (0, _getPrototypeOf2.default)(OrderSteps)).call(this, props));
	    }
	
	    (0, _createClass3.default)(OrderSteps, [{
	        key: 'render',
	        value: function render() {
	            var lang = this.props.lang;
	
	
	            var step = this.props.step || 0;
	            step = parseInt(step, 10) || 0;
	
	            var classes = {
	                1: '',
	                2: '',
	                3: ''
	            };
	
	            if (step) {
	                classes[step] = 'active';
	            }
	
	            var cartTitle = lang['store.common.cart'];
	            var orderDetailsStart = lang['store.order_steps.order_details.start'];
	            var orderDetailsEnd = lang['store.order_steps.order_details.end'];
	            var orderCheckoutStart = lang['store.order_steps.order_checkout.start'];
	            var orderCheckoutEnd = lang['store.order_steps.order_checkout.end'];
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'block-with-border' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'order_steps' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'steps' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'one-step ' + classes[1] },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'step-wrap' },
	                                _react3.default.createElement(
	                                    'p',
	                                    null,
	                                    cartTitle
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'number-wrap' },
	                                    _react3.default.createElement(
	                                        'span',
	                                        { className: 'step-number' },
	                                        ' 1 '
	                                    )
	                                )
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'one-step ' + classes[2] },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'step-wrap' },
	                                _react3.default.createElement(
	                                    'p',
	                                    null,
	                                    orderDetailsStart,
	                                    ' ',
	                                    _react3.default.createElement('br', null),
	                                    ' ',
	                                    orderDetailsEnd
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'number-wrap' },
	                                    _react3.default.createElement(
	                                        'span',
	                                        { className: 'step-number' },
	                                        ' 2 '
	                                    )
	                                )
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'one-step ' + classes[3] },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'step-wrap' },
	                                _react3.default.createElement(
	                                    'p',
	                                    null,
	                                    orderCheckoutStart,
	                                    ' ',
	                                    _react3.default.createElement('br', null),
	                                    ' ',
	                                    orderCheckoutEnd
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'number-wrap' },
	                                    _react3.default.createElement(
	                                        'span',
	                                        { className: 'step-number' },
	                                        ' 3 '
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react3.default.createElement('div', { className: 'line-100' })
	                )
	            );
	        }
	    }]);
	    return OrderSteps;
	}(_react2.Component), _class2.propTypes = {
	    lang: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = OrderSteps;
	module.exports = exports['default'];

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	__webpack_require__(1087);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PaymentListView: {
	        displayName: 'PaymentListView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Order/PaymentList/default/PaymentListView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	// import AdditionalFields from 'components/Order/PaymentList/AdditionalFields';
	
	var PaymentListView = _wrapComponent('PaymentListView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(PaymentListView, _Component);
	
	    function PaymentListView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, PaymentListView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PaymentListView.__proto__ || (0, _getPrototypeOf2.default)(PaymentListView)).call.apply(_ref, [this].concat(args))), _this), _this.showImg = function (icon) {
	            if (icon) {
	                return _react3.default.createElement('img', { src: icon });
	            }
	        }, _this.renderPayments = function (payments, onChange) {
	            var title = void 0;
	            var newPayments = payments.map(function (paymentItem) {
	                title = paymentItem.lang_data_rus;
	                if (_this.props.currency.code === 'GBP' || _this.props.currency.code === 'USD' || _this.props.currency.code === 'EUR' || _this.props.currency.code === 'TRY' || _this.props.currency.code === 'AED') {
	                    title = paymentItem.lang_data_eng;
	                }
	                return _react3.default.createElement(
	                    'li',
	                    { key: paymentItem.slug },
	                    _react3.default.createElement(
	                        'label',
	                        null,
	                        _react3.default.createElement('img', { src: paymentItem.icon }),
	                        ' ',
	                        title,
	                        _react3.default.createElement('input', { onChange: onChange, id: paymentItem.id, type: 'radio', value: paymentItem.slug, name: 'payment_methods', 'data-text': title, 'data-img': paymentItem.icon })
	                    )
	                );
	            });
	            return newPayments;
	        }, _this.showSelect = function (event) {
	            event.preventDefault();
	            var element = document.getElementsByClassName('select_input_wrap');
	            element = element[0];
	            var className = 'active';
	
	            if (!element || !className) {
	                return;
	            }
	
	            var classString = element.className;
	
	            if (classString == 'select_input_wrap') {
	                classString += ' ' + className;
	            } else {
	                classString = 'select_input_wrap';
	            }
	
	            element.className = classString;
	
	            return;
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(PaymentListView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                title = _props.title,
	                onChange = _props.onChange,
	                payments = _props.payments,
	                onChangeAdditionalField = _props.onChangeAdditionalField,
	                onShowAdditionalField = _props.onShowAdditionalField,
	                additionalFieldText = _props.additionalFieldText,
	                slug = _props.slug,
	                slugText = _props.slugText,
	                slugImg = _props.slugImg,
	                warning = _props.warning,
	                lang = _props.lang;
	
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'pay_method row' },
	                    title ? _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-lg-5' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'pay_method_label' },
	                            _react3.default.createElement(
	                                'label',
	                                { className: '' },
	                                title
	                            )
	                        )
	                    ) : null,
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-lg-7 ' + (warning ? 'pay_method_warning' : '') },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'select_input_wrap' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'select_input_wrap__inside' },
	                                _react3.default.createElement(
	                                    'label',
	                                    { className: 'main_field', onClick: this.showSelect },
	                                    this.showImg(slugImg),
	                                    slugText,
	                                    _react3.default.createElement('input', { type: 'text', placeholder: lang['store.payment_list.select_payment_method'], defaultValue: slug })
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'select_dropdown' },
	                                    _react3.default.createElement(
	                                        'ul',
	                                        null,
	                                        this.renderPayments(payments, onChange)
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return PaymentListView;
	}(_react2.Component), _class.propTypes = {
	    title: _react2.PropTypes.string,
	    onChange: _react2.PropTypes.func,
	    onChangeAdditionalField: _react2.PropTypes.func,
	    onShowAdditionalField: _react2.PropTypes.func,
	    payments: _react2.PropTypes.array,
	    slug: _react2.PropTypes.string,
	    additionalFieldText: _react2.PropTypes.string,
	    refAdditionalField: _react2.PropTypes.func,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object.isRequired
	}, _class.defaultProps = {
	    onChange: function onChange() {},
	    onChangeAdditionalField: function onChangeAdditionalField() {},
	    onShowAdditionalField: function onShowAdditionalField() {},
	    refAdditionalField: function refAdditionalField() {},
	    payments: [],
	    additionalFieldText: ''
	}, _temp2));
	
	exports.default = PaymentListView;
	module.exports = exports['default'];

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(68);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _slicedToArray2 = __webpack_require__(267);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(265);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _iterator2 = __webpack_require__(266);
	
	var _iterator3 = _interopRequireDefault(_iterator2);
	
	var _keys = __webpack_require__(69);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _config = __webpack_require__(192);
	
	var config = _interopRequireWildcard(_config);
	
	var _components2 = __webpack_require__(16);
	
	var _modal = __webpack_require__(26);
	
	var _payment = __webpack_require__(114);
	
	var _translate_pipo = __webpack_require__(768);
	
	var _personal = __webpack_require__(165);
	
	var _error = __webpack_require__(140);
	
	var _helpers = __webpack_require__(15);
	
	var _utils = __webpack_require__(31);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	var _modal_type = __webpack_require__(42);
	
	var _PaymentStatus = __webpack_require__(163);
	
	var _PaymentStatus2 = _interopRequireDefault(_PaymentStatus);
	
	var _isString = __webpack_require__(486);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _IBonusError = __webpack_require__(191);
	
	var _IBonusError2 = _interopRequireDefault(_IBonusError);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PaymentList: {
	        displayName: 'PaymentList'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Order/PaymentList/index.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var pickupAndCourierSlugs = [_utils.PAY_PICKUP_SLUG, _utils.PAY_COURIER_SLUG];
	
	var PaymentList = _wrapComponent('PaymentList')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        langList: state.translate_pipo.list,
	        processInput: state.payment.processInput,
	        buyInCreditActive: state.setting.buyInCreditActive,
	        buyInCredit: state.setting.buyInCredit,
	        state: state,
	        lang: state.lang,
	        user: state.auth.user,
	        currency: state.currency
	    };
	}, {
	    push: _reactRouterRedux.push,
	    showModal: _modal.showModal,
	    hide: _modal.hide,
	    throwAlertAction: _error.error,
	    getLang: _translate_pipo.getLang,
	    loadProcessInput: _payment.loadProcessInput,
	    setOrder: _personal.setOrder,
	    setPayOrder: _personal.setPayOrder,
	    setCustomPayment: _payment.setCustomPayment,
	    rePaymentByOrder: _payment.rePaymentByOrder,
	    resetProcessInput: _payment.resetProcessInput,
	    showBuyInCreditModal: _modal_type.showBuyInCreditModal
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(PaymentList, _Component);
	
	    function PaymentList(props, context) {
	        (0, _classCallCheck3.default)(this, PaymentList);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentList.__proto__ || (0, _getPrototypeOf2.default)(PaymentList)).call(this, props, context));
	
	        _this.paymentStatusHelper = null;
	
	        _this.onPay = function () {
	            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	                _ref$clientCommentary = _ref.clientCommentary,
	                clientCommentary = _ref$clientCommentary === undefined ? '' : _ref$clientCommentary,
	                _ref$delivery_address = _ref.delivery_address,
	                delivery_address = _ref$delivery_address === undefined ? '' : _ref$delivery_address,
	                _ref$discountSum = _ref.discountSum,
	                discountSum = _ref$discountSum === undefined ? 0 : _ref$discountSum,
	                _ref$couponId = _ref.couponId,
	                couponId = _ref$couponId === undefined ? null : _ref$couponId,
	                _ref$couponToken = _ref.couponToken,
	                couponToken = _ref$couponToken === undefined ? null : _ref$couponToken,
	                _ref$customerCouponId = _ref.customerCouponId,
	                customerCouponId = _ref$customerCouponId === undefined ? null : _ref$customerCouponId,
	                _ref$preloadCallback = _ref.preloadCallback,
	                preloadCallback = _ref$preloadCallback === undefined ? null : _ref$preloadCallback,
	                _ref$customFields = _ref.customFields,
	                customFields = _ref$customFields === undefined ? null : _ref$customFields,
	                _ref$childOrders = _ref.childOrders,
	                childOrders = _ref$childOrders === undefined ? null : _ref$childOrders,
	                _ref$captcha = _ref.captcha,
	                captcha = _ref$captcha === undefined ? null : _ref$captcha;
	
	            var _this$props$order = _this.props.order,
	                id = _this$props$order.id,
	                payment_in_id = _this$props$order.payment_in_id;
	
	            if (_this.props.order.sum === '0.00000000') {
	                _this.props.setPayOrder(id, clientCommentary, _this.state.selectedSlug, delivery_address, discountSum, couponId, couponToken, customerCouponId, customFields, childOrders, captcha).then(function (result) {
	                    _this.props.setCustomPayment();
	                    _this.props.hide();
	                    _this.props.push('/payment-order/' + _this.props.order.id);
	                });
	            } else if (_this.isBuyInCreditPayMethod()) {
	                _this.props.order.discount_sum = discountSum;
	                _this.props.setPayOrder(id, clientCommentary, _this.state.selectedSlug, delivery_address, discountSum, couponId, couponToken, customerCouponId, customFields, childOrders, captcha).then(function (result) {
	                    //this.props.createFormBuyInCredit();
	                    // this.createFormBuyInCredit();
	                    //this.props.showBuyInCreditModal(this.props.order, this.props.lang['onlineShop.availableServiceIn.buyInCredit'], this.props.buyInCredit);
	                    if (preloadCallback !== null) {
	                        preloadCallback();
	                        _this.props.hide();
	                        _this.props.push('/payment-order/' + _this.props.order.id);
	                    } else {
	                        _this.props.hide();
	                        _this.props.push('/payment-order/' + _this.props.order.id);
	                    }
	                });
	                return;
	            } else if (!_this.isUserHaveSelectedPayMethod()) {
	                if (preloadCallback !== null) {
	                    preloadCallback();
	                }
	                return;
	            } else if (_this.paymentStatusHelper.isCanceled()) {
	                if (preloadCallback !== null) {
	                    preloadCallback();
	                }
	                _this.throwOrderCanceledAlert();
	            } else if (_this.isSelectedIBonusPayMethod()) {
	                _this.props.setPayOrder(id, clientCommentary, null, delivery_address, discountSum, couponId, couponToken, customerCouponId, customFields, childOrders, captcha).then(function (result) {
	                    if (preloadCallback !== null) {
	                        preloadCallback();
	                    }
	                    _this.props.setCustomPayment();
	                    _this.props.showModal({
	                        title: _this.props.lang['store.payment_list.i-bonus_payment'],
	                        content: _react3.default.createElement(_components2.IBonusPayment, {
	                            orderId: id,
	                            operationId: result.payment_in_id,
	                            callbackPay: _this.callbackPay,
	                            setStepConfirm: _this.setStepConfirm,
	                            stepConfirm: _this.state.stepConfirm
	                        }),
	                        modalType: 'payment-ibonis'
	                    });
	                });
	            } else if (_this.isSelectedPickupAndCourierPayMethod()) {
	                _this.props.setPayOrder(id, clientCommentary, _this.state.selectedSlug, delivery_address, discountSum, couponId, couponToken, customerCouponId, customFields, childOrders, captcha).then(function (result) {
	                    _this.props.setCustomPayment();
	                    _this.props.loadProcessInput(result.payment_in_id, _this.state.selectedSlug, _this.state.additionalFieldName, _this.state.additionalFieldText).then(function (result) {
	                        var status = !!result.status;
	                        if (status && result.result && (0, _keys2.default)(result.result).length > 0 && (0, _keys2.default)(_this.props.processInput).length !== (0, _keys2.default)(result.result).length) {
	                            var url = '/payment-order/' + _this.props.order.id + '?pi_type=' + _this.state.selectedSlug;
	                            if (_this.state.additionalFieldName && _this.state.additionalFieldText) {
	                                url += '&pi_name=' + _this.state.additionalFieldName;
	                                url += '&pi_value=' + _this.state.additionalFieldText;
	                            }
	
	                            _this.props.push(url);
	                        } else {
	                            if (preloadCallback !== null) {
	                                preloadCallback();
	                            }
	                            var message = '',
	                                title = '',
	                                code = 0,
	                                trace = '';
	                            if ((0, _isString2.default)(result.result)) {
	                                message = result.result;
	                                title = result.result;
	                            } else if (result.hasOwnProperty('user_msg')) {
	                                message = result.user_msg;
	                                title = result.user_msg;
	                            } else {
	                                message = result.result.error.message || '';
	                                title = result.result.title || 0;
	                                code = result.result.code || 0;
	                                trace = result.result.error.trace || '';
	                            }
	                            message = _this.props.lang[message] || message;
	                            title = _this.props.lang[title] || title;
	                            _reactSAlert2.default.error(message, { position: 'top-right', effect: 'slide', timeout: 3000 });
	                            // throw new IBonusError({
	                            //     message:message,
	                            //     title: title,
	                            //     code: code,
	                            //     trace: trace,
	                            // });
	                        }
	                    });
	                });
	            } else if (_this.isSelectedPaymentNonInteractive()) {
	                if (_this.state.additionalFieldIsRequired && _this.state.additionalFieldText.length === 0) {
	                    if (_this._refAdditionalField) {
	                        _this._refAdditionalField.focus();
	                    }
	                    return;
	                }
	                _this.props.setPayOrder(id, clientCommentary, null, delivery_address, discountSum, couponId, couponToken, customerCouponId, customFields, childOrders, captcha).then(function (result) {
	                    _this.props.setCustomPayment();
	                    _this.props.loadProcessInput(result.payment_in_id, _this.state.selectedSlug, _this.state.additionalFieldName, _this.state.additionalFieldText).then(function (result) {
	                        var status = !!result.status;
	                        if (status && result.result && (0, _keys2.default)(result.result).length > 0 && (0, _keys2.default)(_this.props.processInput).length !== (0, _keys2.default)(result.result).length) {
	                            var url = '/payment-order/' + _this.props.order.id + '?pi_type=' + _this.state.selectedSlug;
	                            if (_this.state.additionalFieldName && _this.state.additionalFieldText) {
	                                url += '&pi_name=' + _this.state.additionalFieldName;
	                                url += '&pi_value=' + _this.state.additionalFieldText;
	                            }
	                            _this.props.push(url);
	                        } else {
	                            if (preloadCallback !== null) {
	                                preloadCallback();
	                            }
	                            var message = '',
	                                title = '',
	                                code = 0,
	                                trace = '';
	                            if ((0, _isString2.default)(result.result)) {
	                                message = result.result;
	                                title = result.result;
	                            } else if (result.hasOwnProperty('user_msg')) {
	                                message = result.user_msg;
	                                title = result.user_msg;
	                            } else {
	                                message = result.result.error.message || '';
	                                title = result.result.title || 0;
	                                code = result.result.code || 0;
	                                trace = result.result.error.trace || '';
	                            }
	                            message = _this.props.lang[message] || message;
	                            title = _this.props.lang[title] || title;
	                            _reactSAlert2.default.error(message, { position: 'top-right', effect: 'slide', timeout: 3000 });
	                            // throw new IBonusError({
	                            //     message:message,
	                            //     title: title,
	                            //     code: code,
	                            //     trace: trace,
	                            // });
	                        }
	                    });
	                });
	            } else if (_this.paymentStatusHelper.isOutdated) {
	                _this.props.rePaymentByOrder(id, function (newOrder) {
	                    _this.props.setPayOrder(id, clientCommentary, null, discountSum, couponId, couponToken, customerCouponId, customFields, childOrders, captcha).then(function (result) {
	                        window.location = (0, _utils.getPipoPageOnProcessInput)(newOrder.payment_in_id, _this.state.selectedSlug, _this.state.additionalFieldName, _this.state.additionalFieldText, newOrder.order_id, _this.props.currency.code);
	                    });
	                });
	            } else if (_this.paymentStatusHelper.isPayActionAvaliable()) {
	                _this.props.setPayOrder(id, clientCommentary, null, delivery_address, discountSum, couponId, couponToken, customerCouponId, customFields, childOrders, captcha).then(function (result) {
	                    window.location = (0, _utils.getPipoPageOnProcessInput)(result.payment_in_id, _this.state.selectedSlug, _this.state.additionalFieldName, _this.state.additionalFieldText, id, _this.props.currency.code);
	                });
	            }
	        };
	
	        _this.callbackPay = function () {
	            _this.props.hide();
	            _this.props.push('/payment-order/' + _this.props.order.id);
	        };
	
	        _this.handleChange = function (event) {
	            _this.setState({
	                'selectedSlug': event.target.value,
	                additionalFieldText: '',
	                'selectedSlugText': event.target.getAttribute('data-text'),
	                'selectedSlugImg': event.target.getAttribute('data-img')
	            });
	
	            _this.props.disButton(event.target.value || false);
	
	            _props$payments$entri = _this.props.payments.entries();
	
	            if (!(_props$payments$entri && (typeof _props$payments$entri[_iterator3.default] === 'function' || Array.isArray(_props$payments$entri)))) {
	                throw new TypeError('Expected _props$payments$entri to be iterable, got ' + _inspect(_props$payments$entri));
	            }
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(_props$payments$entri), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _props$payments$entri;
	
	                    var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
	                        index = _step$value[0],
	                        payment = _step$value[1];
	
	                    if (payment.slug === event.target.value) {
	                        _this.setState({ 'selectedPaymentIndex': index });
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var element = document.getElementsByClassName('select_input_wrap');
	            element = element[0];
	            if (!element) {
	                return;
	            }
	            var classString = 'select_input_wrap';
	            element.className = classString;
	        };
	
	        _this.handleChangeAdditionalField = function (value) {
	            _this.setState({
	                additionalFieldText: value
	            });
	        };
	
	        _this.handleShowAdditionalField = function (isRequired, fieldName) {
	            if (!(typeof isRequired === 'boolean')) {
	                throw new TypeError('Value of argument "isRequired" violates contract.\n\nExpected:\nboolean\n\nGot:\n' + _inspect(isRequired));
	            }
	
	            if (!(typeof fieldName === 'string')) {
	                throw new TypeError('Value of argument "fieldName" violates contract.\n\nExpected:\nstring\n\nGot:\n' + _inspect(fieldName));
	            }
	
	            _this.setState({
	                additionalFieldName: fieldName,
	                additionalFieldIsRequired: isRequired
	            });
	        };
	
	        _this.setStepConfirm = function (confirm) {
	            _this.setState({
	                stepConfirm: confirm
	            });
	        };
	
	        var order = props.order;
	
	        _this.paymentStatusHelper = new _PaymentStatus2.default(order.paymentStatus.id);
	        var slug = '';
	        var slugText = '';
	        var slugImg = '';
	        if (_this.props.payments.length > 0) {
	            slugText = _this.props.lang['store.payment_list.select_payment_method'];
	        }
	        if (_this.props.buyInCreditActive && _this.props.order.sum <= 500000 && _this.props.order.sum >= 3000) {
	            var buyInCreditOrder = _LocalStorageProxy2.default.getItem('buy_in_credit');
	            if (buyInCreditOrder === 'true') {
	                slug = 'buy_in_credit';
	                slugText = _this.props.lang['common.service_in.buy_in_credit'];
	                slugImg = config.apiHost + '/static_files/static/images/services/paytype.jpg';
	                _this.props.disButton('buy_in_credit');
	            }
	        } else if (_this.props.payments.length === 1) {
	            slug = _this.props.payments[0].slug;
	            slugText = _this.props.lang['onlineShop.buyInCredit.service'];
	            slugText = _this.props.payments[0].lang_data_rus;
	            if (_this.props.currency.code === 'GBP' || _this.props.currency.code === 'USD' || _this.props.currency.code === 'EUR' || _this.props.currency.code === 'TRY' || _this.props.currency.code === 'AED') {
	                slugText = _this.props.payments[0].lang_data_eng;
	            }
	            slugImg = _this.props.payments[0].icon;
	            _this.props.disButton(_this.props.payments[0].slug);
	        }
	
	        _this.state = {
	            selectedSlug: slug,
	            selectedSlugText: slugText,
	            selectedSlugImg: slugImg,
	            selectedPaymentIndex: 0,
	            additionalFieldText: '',
	            additionalFieldName: '',
	            additionalFieldIsRequired: false,
	            stepConfirm: false
	        };
	
	        _this.props.getInstance(_this);
	        return _this;
	    }
	
	    (0, _createClass3.default)(PaymentList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // предварительная предзагрузка языка
	            if (!this.props.langList.hasOwnProperty('pay.alfa_label')) {
	                this.props.getLang(this.props.currency.lang.slug);
	            }
	
	            this._refAdditionalField = null;
	            this.props.resetProcessInput();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var nextOrder = nextProps.order;
	            var order = this.props.order;
	
	
	            if (order.paymentStatus.id !== nextOrder.paymentStatus.id) {
	                this.paymentStatusHelper = new _PaymentStatus2.default(nextOrder.paymentStatus.id);
	            }
	
	            if (nextProps.processInput && (0, _keys2.default)(nextProps.processInput).length > 0 && (0, _keys2.default)(this.props.processInput).length !== (0, _keys2.default)(nextProps.processInput).length) {
	                var url = '/payment-order/' + this.props.order.id + '?pi_type=' + nextProps.processInput.slug;
	
	                if (this.state.additionalFieldName && this.state.additionalFieldText) {
	                    url += '&pi_name=' + this.state.additionalFieldName;
	                    url += '&pi_value=' + this.state.additionalFieldText;
	                }
	
	                this.props.push(url);
	            }
	        }
	
	        //noinspection JSAnnotator
	
	    }, {
	        key: 'isUserHaveSelectedPayMethod',
	        value: function isUserHaveSelectedPayMethod() {
	            return !!this.state.selectedSlug;
	        }
	    }, {
	        key: 'isBuyInCreditPayMethod',
	        value: function isBuyInCreditPayMethod() {
	            return this.state.selectedSlug === 'buy_in_credit';
	        }
	    }, {
	        key: 'isSelectedIBonusPayMethod',
	        value: function isSelectedIBonusPayMethod() {
	            return _components2.IBonusPayment.checkSlug(this.state.selectedSlug);
	        }
	    }, {
	        key: 'isSelectedPickupAndCourierPayMethod',
	        value: function isSelectedPickupAndCourierPayMethod() {
	            return pickupAndCourierSlugs.includes(this.state.selectedSlug);
	        }
	    }, {
	        key: 'isSelectedPaymentNonInteractive',
	        value: function isSelectedPaymentNonInteractive() {
	            var selectedPayment = this.props.payments[this.state.selectedPaymentIndex];
	            return selectedPayment && selectedPayment.non_interactive;
	        }
	    }, {
	        key: 'throwOrderCanceledAlert',
	        value: function throwOrderCanceledAlert() {
	            if (this.paymentStatusHelper.isCanceled()) {
	                this.props.throwAlertAction(this.props.lang[this.props.order.paymentStatus.lang_data]);
	            }
	        }
	    }, {
	        key: 'createFormBuyInCredit',
	        value: function createFormBuyInCredit() {
	            var _this2 = this;
	
	            var discountEpsilon = this.props.order.discount_sum;
	            var discountPercent = this.props.order.discount_sum / (this.props.order.sum / 100);
	            var promoCode = this.props.buyInCredit.promo_code === '' ? 'default' : this.props.buyInCredit.promo_code;
	            var products = this.props.order.products.map(function (item, index) {
	                var modifierOptionName = '';
	                var sale = parseFloat(item.base_price * (discountPercent / 100)).toFixed(2);
	                var price = parseFloat(item.base_price - sale).toFixed(2);
	                discountEpsilon = discountEpsilon - sale * item.quantity;
	                if (item.modifier_option_name !== null) {
	                    modifierOptionName = item.modifier_option_name;
	                }
	                if (index === _this2.props.order.products.length) {
	                    price = parseFloat(item.base_price - (sale + discountEpsilon / item.quantity)).toFixed(2);
	                }
	                return {
	                    name: item.name + modifierOptionName,
	                    quantity: item.quantity,
	                    price: price,
	                    vendorCode: item.id_yml
	                };
	            });
	            tinkoff.create({
	                shopId: this.props.buyInCredit.external_shop_id,
	                showcaseId: this.props.buyInCredit.showcase_id,
	                promoCode: promoCode,
	                sum: parseFloat(this.props.order.sum - this.props.order.discount_sum).toFixed(2),
	                orderNumber: this.props.order.order_number,
	                items: products,
	                values: {
	                    contact: {
	                        mobilePhone: this.props.user.phone,
	                        email: this.props.user.phone
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var View = _helpers.ThemeHelper.getViewForComponent('PaymentList', null, { folderName: 'Order/PaymentList' });
	            var payments = this.props.payments;
	            if (this.props.buyInCreditActive && this.props.order.sum <= 500000 && this.props.order.sum >= 3000) {
	                if (payments[0].slug !== 'buy_in_credit') {
	                    payments.unshift({
	                        id: 1,
	                        slug: 'buy_in_credit',
	                        lang_data_eng: 'Buy on credit',
	                        lang_data_rus: 'Купи в кредит',
	                        icon: config.apiHost + '/static_files/static/images/services/paytype.jpg',
	                        big_icon: config.apiHost + '/static_files/static/images/services/paytype.jpg'
	                    });
	                }
	                var buyInCreditOrder = _LocalStorageProxy2.default.getItem('buy_in_credit');
	                if (buyInCreditOrder === 'true') {
	                    payments = [{
	                        id: 1,
	                        slug: 'buy_in_credit',
	                        lang_data_eng: 'Buy on credit',
	                        lang_data_rus: 'Купи в кредит',
	                        icon: config.apiHost + '/static_files/static/images/services/paytype.jpg',
	                        big_icon: config.apiHost + '/static_files/static/images/services/paytype.jpg'
	                    }];
	                }
	            }
	            return _react3.default.createElement(View, {
	                title: this.props.title,
	                onChange: this.handleChange,
	                payments: payments,
	                slug: this.state.selectedSlug,
	                slugText: this.state.selectedSlugText,
	                slugImg: this.state.selectedSlugImg,
	                additionalFieldText: this.state.additionalFieldText,
	                onChangeAdditionalField: this.handleChangeAdditionalField,
	                onShowAdditionalField: this.handleShowAdditionalField,
	                refAdditionalField: function refAdditionalField(element) {
	                    _this3._refAdditionalField = element;
	                },
	                warning: this.props.warning,
	                lang: this.props.lang,
	                currency: this.props.currency
	            });
	        }
	    }]);
	    return PaymentList;
	}(_react2.Component), _class2.propTypes = {
	    payments: _react2.PropTypes.array.isRequired,
	    order: _react2.PropTypes.object.isRequired,
	    getInstance: _react2.PropTypes.func,
	    title: _react2.PropTypes.string,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object.isRequired
	}, _class2.defaultProps = {
	    getInstance: function getInstance() {},
	    title: null
	}, _temp)) || _class));
	
	exports.default = PaymentList;
	
	function _inspect(input, depth) {
	    var maxDepth = 4;
	    var maxKeys = 15;
	
	    if (depth === undefined) {
	        depth = 0;
	    }
	
	    depth += 1;
	
	    if (input === null) {
	        return 'null';
	    } else if (input === undefined) {
	        return 'void';
	    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	    } else if (Array.isArray(input)) {
	        if (input.length > 0) {
	            if (depth > maxDepth) return '[...]';
	
	            var first = _inspect(input[0], depth);
	
	            if (input.every(function (item) {
	                return _inspect(item, depth) === first;
	            })) {
	                return first.trim() + '[]';
	            } else {
	                return '[' + input.slice(0, maxKeys).map(function (item) {
	                    return _inspect(item, depth);
	                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	            }
	        } else {
	            return 'Array';
	        }
	    } else {
	        var keys = (0, _keys2.default)(input);
	
	        if (!keys.length) {
	            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	                return input.constructor.name;
	            } else {
	                return 'Object';
	            }
	        }
	
	        if (depth > maxDepth) return '{...}';
	        var indent = '  '.repeat(depth - 1);
	        var entries = keys.slice(0, maxKeys).map(function (key) {
	            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	        }).join('\n  ' + indent);
	
	        if (keys.length >= maxKeys) {
	            entries += '\n  ' + indent + '...';
	        }
	
	        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	        } else {
	            return '{\n  ' + indent + entries + '\n' + indent + '}';
	        }
	    }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _moment = __webpack_require__(11);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(19);
	
	var _components2 = __webpack_require__(16);
	
	var _SHARE = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Alfa: {
	        displayName: 'Alfa'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Order/ProcessInput/alfa.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Alfa = _wrapComponent('Alfa')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang,
	        currency: state.currency
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Alfa, _Component);
	
	    function Alfa(props) {
	        (0, _classCallCheck3.default)(this, Alfa);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Alfa.__proto__ || (0, _getPrototypeOf2.default)(Alfa)).call(this, props));
	
	        _this.productsTable = function () {
	            var currency = _this.props.currency;
	
	            return _this.props.products.map(function (item) {
	                var pictures = item.offer.pictures || [];
	                var image = pictures[0];
	                var quantity = parseInt(item.quantity, 10) || 0;
	                var weight = null;
	                var childWeight = null;
	                var modifier_option_name = _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-3 prod_desc' },
	                    _react3.default.createElement('div', { className: 'title' })
	                );
	
	                if (item.modifier_option_name !== null && item.modifier_option_name !== '') {
	                    modifier_option_name = _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-3 prod_desc' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'title' },
	                            item.modifier_option_name
	                        )
	                    );
	                } else if (item.modifier_option_id !== null) {
	                    modifier_option_name = _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-3 prod_desc' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'title' },
	                            item.modifiedOption.name
	                        )
	                    );
	                }
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin cart-item' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-1 col-xs-12' },
	                        image && image.preview_url ? _react3.default.createElement('img', { src: image.preview_url }) : null
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-4' },
	                        _react3.default.createElement(
	                            'div',
	                            null,
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'title' },
	                                _react3.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/product/' + item.offer.id },
	                                    item.offer.name
	                                )
	                            ),
	                            _react3.default.createElement(_SHARE.SwitherDescription, { description: item.offer.description })
	                        )
	                    ),
	                    modifier_option_name,
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'quantity cart_quantity' },
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'visible-xs' },
	                                _this.props.lang['store.common.quantity'],
	                                ': ',
	                                quantity
	                            ),
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'hidden-xs' },
	                                quantity
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'price' },
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'visible-xs' },
	                                _this.props.lang['store.common.price'],
	                                ':',
	                                _react3.default.createElement(_components2.MoneyValue, {
	                                    value: parseFloat(item.price * quantity),
	                                    icon: currency.icon,
	                                    iconAfterValue: currency.icon_after_value
	                                })
	                            ),
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'hidden-xs' },
	                                _react3.default.createElement(_components2.MoneyValue, {
	                                    value: parseFloat(item.price * quantity),
	                                    icon: currency.icon,
	                                    iconAfterValue: currency.icon_after_value
	                                })
	                            )
	                        )
	                    ),
	                    _react3.default.createElement('div', { className: 'clearfix' }),
	                    item.type_id === 5 ? item.childProducts.map(function (childItem) {
	                        if (childItem.quantity == 0) {
	                            return null;
	                        }
	                        weight = childItem.quantity / quantity;
	                        childItem.weight_offer = childItem.weight_offer * 1;
	                        if ((childItem.unit.slug === 'kg' || childItem.unit.slug === 'mg') && childItem.weight_offer && childItem.weight_offer > 0 && childItem.quantity > 0) {
	                            weight = childItem.weight_offer * childItem.quantity / quantity;
	                            weight = weight.toFixed(3);
	                            if (childItem.weight_offer < 0.01 && childItem.quantity < 1 || childItem.weight_offer < 1 && childItem.quantity < 0.01) {
	                                weight = item.weight_offer * 1;
	                            }
	                            if (childItem.weight_offer < 0.1 && childItem.quantity < 0.1) {
	                                weight = childItem.weight_offer * 1;
	                            }
	                        }
	                        return _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin' },
	                            _react3.default.createElement('div', { className: 'col-sm-1  col-xs-12' }),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-4 visible-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'title', style: { paddingLeft: '20px' } },
	                                    '\u2022 ',
	                                    childItem.name,
	                                    ' ',
	                                    childItem.modifier_option_name
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { style: { paddingLeft: '30px' } },
	                                    _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        _this.props.lang['store.common.quantity'],
	                                        ': '
	                                    ),
	                                    childItem.type_id === 5 ? _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        childItem.quantity / quantity
	                                    ) : _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        weight,
	                                        ' ',
	                                        _this.props.lang[childItem.unit.title_lang_data]
	                                    )
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-4 hidden-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'title', style: { paddingLeft: '20px' } },
	                                    '\u2022 ',
	                                    childItem.name
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-3 hidden-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'title' },
	                                    childItem.modifier_option_name
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2 hidden-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { style: { textAlign: 'center' } },
	                                    _react3.default.createElement(
	                                        'span',
	                                        { className: 'visible-xs' },
	                                        _this.props.lang['store.common.quantity'],
	                                        ': '
	                                    ),
	                                    childItem.type_id === 5 ? _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        childItem.quantity / quantity
	                                    ) : _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        weight,
	                                        ' ',
	                                        _this.props.lang[childItem.unit.title_lang_data]
	                                    )
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2' },
	                                _react3.default.createElement('div', { className: 'price' })
	                            ),
	                            _react3.default.createElement('div', { className: 'clearfix' }),
	                            childItem.type_id === 5 ? childItem.childProducts.map(function (childChildItem) {
	                                if (childChildItem.quantity == 0) {
	                                    return null;
	                                }
	                                childWeight = childChildItem.quantity / childItem.quantity;
	                                childChildItem.weight_offer = childChildItem.weight_offer * 1;
	                                if ((childChildItem.unit.slug === 'kg' || childChildItem.unit.slug === 'mg') && childChildItem.weight_offer && childChildItem.weight_offer > 0 && childChildItem.quantity > 0) {
	                                    childWeight = childChildItem.weight_offer * childChildItem.quantity / childItem.quantity;
	                                    childWeight = childWeight.toFixed(3);
	                                    if (childChildItem.weight_offer < 0.01 && childChildItem.quantity < 1 || childChildItem.weight_offer < 1 && childChildItem.quantity < 0.01) {
	                                        childWeight = childChildItem.weight_offer * 1;
	                                    }
	                                    if (childChildItem.weight_offer < 0.1 && childChildItem.quantity < 0.1) {
	                                        childWeight = childChildItem.weight_offer * 1;
	                                    }
	                                }
	                                return _react3.default.createElement(
	                                    'div',
	                                    { className: 'row no-margin' },
	                                    _react3.default.createElement('div', { className: 'col-sm-1 col-xs-12' }),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-4 visible-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'title', style: { paddingLeft: '40px' } },
	                                            '- ',
	                                            childChildItem.name,
	                                            ' ',
	                                            childChildItem.modifier_option_name
	                                        ),
	                                        _react3.default.createElement(
	                                            'div',
	                                            { style: { paddingLeft: '49px' } },
	                                            _react3.default.createElement(
	                                                'span',
	                                                null,
	                                                _this.props.lang['store.common.quantity'],
	                                                ': ',
	                                                childWeight,
	                                                ' ',
	                                                _this.props.lang[childChildItem.unit.title_lang_data]
	                                            )
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-4 hidden-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'title', style: { paddingLeft: '40px' } },
	                                            '- ',
	                                            childChildItem.name
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-3 hidden-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            childChildItem.modifier_option_name
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-2 hidden-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { style: { textAlign: 'center' } },
	                                            _react3.default.createElement(
	                                                'span',
	                                                { className: 'visible-xs' },
	                                                _this.props.lang['store.common.quantity'],
	                                                ': '
	                                            ),
	                                            _react3.default.createElement(
	                                                'span',
	                                                null,
	                                                childWeight,
	                                                ' ',
	                                                _this.props.lang[childChildItem.unit.title_lang_data]
	                                            )
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-2' },
	                                        _react3.default.createElement('div', { className: 'price' })
	                                    )
	                                );
	                            }) : null
	                        );
	                    }) : null
	                );
	            });
	        };
	
	        _this.renderUserInfo = function () {
	            var data = _this.props.data;
	            if (data.error === 0) {
	                return _react3.default.createElement(
	                    'p',
	                    null,
	                    _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.check_instruction }),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.bill_number }),
	                    ':\xA0',
	                    _react3.default.createElement(
	                        'b',
	                        null,
	                        data.inner_id
	                    ),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.invoice_in_alfa, raw: true }),
	                    ':\xA0',
	                    _react3.default.createElement(
	                        'b',
	                        null,
	                        data.id_invoice
	                    ),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.sum_to_pay }),
	                    ':\xA0',
	                    _react3.default.createElement(
	                        'b',
	                        null,
	                        data.amount,
	                        ' ',
	                        data.currency_code
	                    ),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement('br', null)
	                );
	            } else {
	                return _react3.default.createElement(
	                    'p',
	                    null,
	                    _react3.default.createElement(_components2.TranslatePipo, { title: data.message }),
	                    _react3.default.createElement('br', null)
	                );
	            }
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(Alfa, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                lang = _props.lang,
	                currency = _props.currency,
	                sumTotal = _props.sumTotal;
	
	            var data = this.props.data;
	            var date = (0, _moment2.default)(this.props.data.operation.crtime);
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 process_input' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'small-9 columns' },
	                        _react3.default.createElement(
	                            'h2',
	                            { className: 'section-title special_title' },
	                            lang['store.common.order'],
	                            ' \u2116',
	                            this.props.orderId
	                        ),
	                        _react3.default.createElement(
	                            'h5',
	                            null,
	                            '' + date.format('DD.MM.YYYY')
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'small-12 columns' },
	                        _react3.default.createElement(_components2.TranslatePipo, { title: 'events.account' }),
	                        ' \u2116',
	                        data.inner_id
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'small-12 columns' },
	                        _react3.default.createElement(
	                            'h2',
	                            { className: 'pay-type-title' },
	                            _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.instruction })
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'range' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'user-info' },
	                                _react3.default.createElement('br', null),
	                                this.renderUserInfo()
	                            )
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row', id: 'personal-order-detail' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 items-holder no-margin' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin cart-item hidden-xs' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-1' },
	                                lang['store.cart.photo']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-4' },
	                                lang['store.cart.title']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-3' },
	                                lang['store.cart.modifiers']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-2 text-center' },
	                                lang['store.cart.quantity']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-2 text-center' },
	                                lang['store.cart.price']
	                            )
	                        ),
	                        this.productsTable()
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 products_total_price' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-3 col-sm-offset-9 text-center' },
	                            _react3.default.createElement(_components2.MoneyValue, {
	                                value: parseFloat(sumTotal),
	                                icon: currency.icon,
	                                iconAfterValue: currency.icon_after_value,
	                                prefix: lang['store.cart.total'] + ': '
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Alfa;
	}(_react2.Component), _class2.propTypes = {
	    data: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Alfa;
	module.exports = exports['default'];

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _terminal = __webpack_require__(1712);
	
	var _terminal2 = _interopRequireDefault(_terminal);
	
	var _alfa = __webpack_require__(1708);
	
	var _alfa2 = _interopRequireDefault(_alfa);
	
	var _qiwi = __webpack_require__(1710);
	
	var _qiwi2 = _interopRequireDefault(_qiwi);
	
	var _static = __webpack_require__(1711);
	
	var _static2 = _interopRequireDefault(_static);
	
	var _utils = __webpack_require__(31);
	
	var _paymentSlug = __webpack_require__(1715);
	
	var _reactRedux = __webpack_require__(12);
	
	__webpack_require__(1088);
	
	var _utils2 = __webpack_require__(384);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ProcessInput: {
	        displayName: 'ProcessInput'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Order/ProcessInput/index.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ProcessInput = _wrapComponent('ProcessInput')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        predefinedInstructions: (0, _utils2.extractInstructions)(state.payment.pipoList)
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(ProcessInput, _Component);
	
	    function ProcessInput() {
	        (0, _classCallCheck3.default)(this, ProcessInput);
	        return (0, _possibleConstructorReturn3.default)(this, (ProcessInput.__proto__ || (0, _getPrototypeOf2.default)(ProcessInput)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(ProcessInput, [{
	        key: 'injectPredefinedInstructions',
	
	        // TODO: Пока не нужен, если не будет в будущем использоваться можно удалить
	        value: function injectPredefinedInstructions(data) {
	            var result = (0, _extends3.default)({}, data);
	
	            if (this.props.predefinedInstructions) {
	                for (var slug in this.props.predefinedInstructions) {
	                    if (result.slug === slug) {
	                        result.labels = (0, _extends3.default)({}, result.labels, {
	                            instruction: this.props.predefinedInstructions[slug]
	                        });
	                    }
	                }
	            }
	
	            return result;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            // const data = this.injectPredefinedInstructions(this.props.data);
	            var data = this.props.data;
	
	
	            if (this.props.data.slug === _paymentSlug.TERMINAL) {
	                return _react3.default.createElement(_terminal2.default, { data: data, orderId: this.props.orderId, products: this.props.products, sumTotal: this.props.sumTotal });
	            } else if (this.props.data.slug === _paymentSlug.ALFABANK_SLUG) {
	                return _react3.default.createElement(_alfa2.default, { data: data, orderId: this.props.orderId, products: this.props.products, sumTotal: this.props.sumTotal });
	            } else if ((0, _paymentSlug.isQiwiSlug)(this.props.data.slug)) {
	                return _react3.default.createElement(_qiwi2.default, { data: data, orderId: this.props.orderId, products: this.props.products, sumTotal: this.props.sumTotal });
	            } else if (this.props.data.slug === _utils.PAY_COURIER_SLUG || this.props.data.slug === _utils.PAY_PICKUP_SLUG) {
	                return _react3.default.createElement(_static2.default, { data: data, orderId: this.props.orderId, products: this.props.products, sumTotal: this.props.sumTotal });
	            }
	
	            return _react3.default.createElement('div', null);
	        }
	    }]);
	    return ProcessInput;
	}(_react2.Component), _class2.propTypes = {
	    data: _react2.PropTypes.object.isRequired,
	    orderId: _react2.PropTypes.number.isRequired
	}, _temp)) || _class));
	
	exports.default = ProcessInput;
	module.exports = exports['default'];

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _moment = __webpack_require__(11);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(19);
	
	var _components2 = __webpack_require__(16);
	
	var _SHARE = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Qiwi: {
	        displayName: 'Qiwi'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Order/ProcessInput/qiwi.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Qiwi = _wrapComponent('Qiwi')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang,
	        currency: state.currency
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Qiwi, _Component);
	
	    function Qiwi(props) {
	        (0, _classCallCheck3.default)(this, Qiwi);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Qiwi.__proto__ || (0, _getPrototypeOf2.default)(Qiwi)).call(this, props));
	
	        _this.productsTable = function () {
	            var currency = _this.props.currency;
	
	            return _this.props.products.map(function (item) {
	                var pictures = item.offer.pictures || [];
	                var image = pictures[0];
	                var quantity = parseInt(item.quantity, 10) || 0;
	                var weight = null;
	                var childWeight = null;
	                var modifier_option_name = _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-3 prod_desc' },
	                    _react3.default.createElement('div', { className: 'title' })
	                );
	
	                if (item.modifier_option_name !== null && item.modifier_option_name !== '') {
	                    modifier_option_name = _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-3 prod_desc' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'title' },
	                            item.modifier_option_name
	                        )
	                    );
	                } else if (item.modifier_option_id !== null) {
	                    modifier_option_name = _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-3 prod_desc' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'title' },
	                            item.modifiedOption.name
	                        )
	                    );
	                }
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin cart-item' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-1 col-xs-12' },
	                        image && image.preview_url ? _react3.default.createElement('img', { src: image.preview_url }) : ''
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-4' },
	                        _react3.default.createElement(
	                            'div',
	                            null,
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'title' },
	                                _react3.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/product/' + item.offer.id },
	                                    item.offer.name
	                                )
	                            ),
	                            _react3.default.createElement(_SHARE.SwitherDescription, { description: item.offer.description })
	                        )
	                    ),
	                    modifier_option_name,
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'quantity cart_quantity' },
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'visible-xs' },
	                                _this.props.lang['store.common.quantity'],
	                                ': ',
	                                quantity
	                            ),
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'hidden-xs' },
	                                quantity
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'price' },
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'visible-xs' },
	                                _this.props.lang['store.common.price'],
	                                ':',
	                                _react3.default.createElement(_components2.MoneyValue, {
	                                    value: parseFloat(item.price * quantity),
	                                    icon: currency.icon,
	                                    iconAfterValue: currency.icon_after_value
	                                })
	                            ),
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'hidden-xs' },
	                                _react3.default.createElement(_components2.MoneyValue, {
	                                    value: parseFloat(item.price * quantity),
	                                    icon: currency.icon,
	                                    iconAfterValue: currency.icon_after_value
	                                })
	                            )
	                        )
	                    ),
	                    _react3.default.createElement('div', { className: 'clearfix' }),
	                    item.type_id === 5 ? item.childProducts.map(function (childItem) {
	                        if (childItem.quantity == 0) {
	                            return null;
	                        }
	                        weight = childItem.quantity / quantity;
	                        childItem.weight_offer = childItem.weight_offer * 1;
	                        if ((childItem.unit.slug === 'kg' || childItem.unit.slug === 'mg') && childItem.weight_offer && childItem.weight_offer > 0 && childItem.quantity > 0) {
	                            weight = childItem.weight_offer * childItem.quantity / quantity;
	                            weight = weight.toFixed(3);
	                            if (childItem.weight_offer < 0.01 && childItem.quantity < 1 || childItem.weight_offer < 1 && childItem.quantity < 0.01) {
	                                weight = item.weight_offer * 1;
	                            }
	                            if (childItem.weight_offer < 0.1 && childItem.quantity < 0.1) {
	                                weight = childItem.weight_offer * 1;
	                            }
	                        }
	                        return _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin' },
	                            _react3.default.createElement('div', { className: 'col-sm-1  col-xs-12' }),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-4 visible-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'title', style: { paddingLeft: '20px' } },
	                                    '\u2022 ',
	                                    childItem.name,
	                                    ' ',
	                                    childItem.modifier_option_name
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { style: { paddingLeft: '30px' } },
	                                    _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        _this.props.lang['store.common.quantity'],
	                                        ': '
	                                    ),
	                                    childItem.type_id === 5 ? _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        childItem.quantity / quantity
	                                    ) : _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        weight,
	                                        ' ',
	                                        _this.props.lang[childItem.unit.title_lang_data]
	                                    )
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-4 hidden-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'title', style: { paddingLeft: '20px' } },
	                                    '\u2022 ',
	                                    childItem.name
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-3 hidden-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'title' },
	                                    childItem.modifier_option_name
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2 hidden-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { style: { textAlign: 'center' } },
	                                    _react3.default.createElement(
	                                        'span',
	                                        { className: 'visible-xs' },
	                                        _this.props.lang['store.common.quantity'],
	                                        ': '
	                                    ),
	                                    childItem.type_id === 5 ? _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        childItem.quantity / quantity
	                                    ) : _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        weight,
	                                        ' ',
	                                        _this.props.lang[childItem.unit.title_lang_data]
	                                    )
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2' },
	                                _react3.default.createElement('div', { className: 'price' })
	                            ),
	                            _react3.default.createElement('div', { className: 'clearfix' }),
	                            childItem.type_id === 5 ? childItem.childProducts.map(function (childChildItem) {
	                                if (childChildItem.quantity == 0) {
	                                    return null;
	                                }
	                                childWeight = childChildItem.quantity / childItem.quantity;
	                                childChildItem.weight_offer = childChildItem.weight_offer * 1;
	                                if ((childChildItem.unit.slug === 'kg' || childChildItem.unit.slug === 'mg') && childChildItem.weight_offer && childChildItem.weight_offer > 0 && childChildItem.quantity > 0) {
	                                    childWeight = childChildItem.weight_offer * childChildItem.quantity / childItem.quantity;
	                                    childWeight = childWeight.toFixed(3);
	                                    if (childChildItem.weight_offer < 0.01 && childChildItem.quantity < 1 || childChildItem.weight_offer < 1 && childChildItem.quantity < 0.01) {
	                                        childWeight = childChildItem.weight_offer * 1;
	                                    }
	                                    if (childChildItem.weight_offer < 0.1 && childChildItem.quantity < 0.1) {
	                                        childWeight = childChildItem.weight_offer * 1;
	                                    }
	                                }
	                                if (childItem.quantity === 0) {
	                                    childWeight = 0;
	                                }
	                                return _react3.default.createElement(
	                                    'div',
	                                    { className: 'row no-margin' },
	                                    _react3.default.createElement('div', { className: 'col-sm-1 col-xs-12' }),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-4 visible-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'title', style: { paddingLeft: '40px' } },
	                                            '- ',
	                                            childChildItem.name,
	                                            ' ',
	                                            childChildItem.modifier_option_name
	                                        ),
	                                        _react3.default.createElement(
	                                            'div',
	                                            { style: { paddingLeft: '49px' } },
	                                            _react3.default.createElement(
	                                                'span',
	                                                null,
	                                                _this.props.lang['store.common.quantity'],
	                                                ': ',
	                                                childWeight,
	                                                ' ',
	                                                _this.props.lang[childChildItem.unit.title_lang_data]
	                                            )
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-4 hidden-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'title', style: { paddingLeft: '40px' } },
	                                            '- ',
	                                            childChildItem.name
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-3 hidden-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            childChildItem.modifier_option_name
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-2 hidden-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { style: { textAlign: 'center' } },
	                                            _react3.default.createElement(
	                                                'span',
	                                                { className: 'visible-xs' },
	                                                _this.props.lang['store.common.quantity'],
	                                                ': '
	                                            ),
	                                            _react3.default.createElement(
	                                                'span',
	                                                null,
	                                                childWeight,
	                                                ' ',
	                                                _this.props.lang[childChildItem.unit.title_lang_data]
	                                            )
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-2' },
	                                        _react3.default.createElement('div', { className: 'price' })
	                                    )
	                                );
	                            }) : null
	                        );
	                    }) : null
	                );
	            });
	        };
	
	        _this.renderUserInfo = function () {
	            var data = _this.props.data;
	            if (data.error === 0) {
	                return _react3.default.createElement(
	                    'p',
	                    null,
	                    _react3.default.createElement(
	                        'a',
	                        { href: data.labels.url, target: '__blank' },
	                        _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.main_text })
	                    ),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.bill_number }),
	                    ':\xA0',
	                    _react3.default.createElement(
	                        'b',
	                        null,
	                        data.inner_id
	                    ),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.bill_number_on }),
	                    ':\xA0',
	                    _react3.default.createElement(
	                        'b',
	                        null,
	                        data.bill_id
	                    ),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement(
	                        'b',
	                        null,
	                        _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.your_phone })
	                    ),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement(
	                        'b',
	                        null,
	                        data.phone
	                    ),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.sum_to_pay }),
	                    ':\xA0',
	                    _react3.default.createElement(
	                        'b',
	                        null,
	                        data.amount,
	                        ' ',
	                        data.currency_code
	                    ),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement('br', null)
	                );
	            } else {
	                return _react3.default.createElement(
	                    'p',
	                    null,
	                    _react3.default.createElement(_components2.TranslatePipo, { title: data.message }),
	                    _react3.default.createElement('br', null)
	                );
	            }
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(Qiwi, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                lang = _props.lang,
	                currency = _props.currency,
	                sumTotal = _props.sumTotal;
	
	            var data = this.props.data;
	            var date = (0, _moment2.default)(this.props.data.operation.crtime);
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 process_input' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'small-9 columns' },
	                        _react3.default.createElement(
	                            'h2',
	                            { className: 'section-title special_title' },
	                            lang['store.common.order'],
	                            ' \u2116',
	                            this.props.orderId
	                        ),
	                        _react3.default.createElement(
	                            'h5',
	                            null,
	                            '' + date.format('DD.MM.YYYY')
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'small-12 columns' },
	                        _react3.default.createElement(_components2.TranslatePipo, { title: 'events.account' }),
	                        ' \u2116',
	                        data.inner_id
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'small-12 columns' },
	                        _react3.default.createElement(
	                            'h2',
	                            { className: 'pay-type-title' },
	                            _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.instruction })
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'range' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'user-info' },
	                                _react3.default.createElement('br', null),
	                                this.renderUserInfo()
	                            )
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row', id: 'personal-order-detail' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 items-holder no-margin' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin cart-item hidden-xs' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-1' },
	                                lang['store.cart.photo']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-4' },
	                                lang['store.cart.title']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-3' },
	                                lang['store.cart.modifiers']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-2 text-center' },
	                                lang['store.cart.quantity']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-2 text-center' },
	                                lang['store.cart.price']
	                            )
	                        ),
	                        this.productsTable()
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 products_total_price' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-3 col-sm-offset-9 text-center' },
	                            _react3.default.createElement(_components2.MoneyValue, {
	                                value: parseFloat(sumTotal),
	                                icon: currency.icon,
	                                iconAfterValue: currency.icon_after_value,
	                                prefix: lang['store.cart.total'] + ': '
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Qiwi;
	}(_react2.Component), _class2.propTypes = {
	    data: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Qiwi;
	module.exports = exports['default'];

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _moment = __webpack_require__(11);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(19);
	
	var _components2 = __webpack_require__(16);
	
	var _SHARE = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Static: {
	        displayName: 'Static'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Order/ProcessInput/static.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Static = _wrapComponent('Static')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang,
	        currency: state.currency
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Static, _Component);
	
	    function Static(props) {
	        (0, _classCallCheck3.default)(this, Static);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Static.__proto__ || (0, _getPrototypeOf2.default)(Static)).call(this, props));
	
	        _this.productsTable = function () {
	            var currency = _this.props.currency;
	
	            return _this.props.products.map(function (item) {
	                var pictures = item.offer.pictures || [];
	                var image = pictures[0];
	                var quantity = parseInt(item.quantity, 10) || 0;
	                var weight = null;
	                var childWeight = null;
	                var modifier_option_name = _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-3 prod_desc' },
	                    _react3.default.createElement('div', { className: 'title' })
	                );
	                item.additionalInfo = item.additional_info ? JSON.parse(item.additional_info) : null;
	                if (item.additionalInfo && item.additionalInfo.custom_fields) {
	                    item.custom_fields = item.additionalInfo.custom_fields;
	                }
	
	                if (item.modifier_option_name !== null && item.modifier_option_name !== '') {
	                    modifier_option_name = _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-3 prod_desc' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'title' },
	                            item.modifier_option_name
	                        )
	                    );
	                } else if (item.modifier_option_id !== null) {
	                    modifier_option_name = _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-3 prod_desc' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'title' },
	                            item.modifiedOption.name
	                        )
	                    );
	                }
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin cart-item' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-1 col-xs-12' },
	                        image && image.preview_url ? _react3.default.createElement('img', { src: image.preview_url }) : ''
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-4' },
	                        _react3.default.createElement(
	                            'div',
	                            null,
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'title' },
	                                _react3.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/product/' + item.offer.id },
	                                    item.offer.name
	                                )
	                            ),
	                            _react3.default.createElement(_SHARE.SwitherDescription, { description: item.offer.description }),
	                            item.custom_fields ? item.custom_fields.map(function (product, i) {
	                                return _react3.default.createElement(
	                                    'label',
	                                    null,
	                                    product.name,
	                                    ': ',
	                                    product.value
	                                );
	                            }) : null
	                        )
	                    ),
	                    modifier_option_name,
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'quantity cart_quantity' },
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'visible-xs' },
	                                _this.props.lang['store.common.quantity'],
	                                ': ',
	                                quantity
	                            ),
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'hidden-xs' },
	                                quantity
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'price' },
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'visible-xs' },
	                                _this.props.lang['store.common.price'],
	                                ':',
	                                _react3.default.createElement(_components2.MoneyValue, {
	                                    value: parseFloat(item.price * quantity),
	                                    icon: currency.icon,
	                                    iconAfterValue: currency.icon_after_value
	                                })
	                            ),
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'hidden-xs' },
	                                _react3.default.createElement(_components2.MoneyValue, {
	                                    value: parseFloat(item.price * quantity),
	                                    icon: currency.icon,
	                                    iconAfterValue: currency.icon_after_value
	                                })
	                            )
	                        )
	                    ),
	                    _react3.default.createElement('div', { className: 'clearfix' }),
	                    item.type_id === 5 ? item.childProducts.map(function (childItem) {
	                        if (childItem.quantity == 0) {
	                            return null;
	                        }
	                        weight = childItem.quantity / quantity;
	                        childItem.weight_offer = childItem.weight_offer * 1;
	                        if ((childItem.unit.slug === 'kg' || childItem.unit.slug === 'mg') && childItem.weight_offer && childItem.weight_offer > 0 && childItem.quantity > 0) {
	                            weight = childItem.weight_offer * childItem.quantity / quantity;
	                            weight = weight.toFixed(3);
	                            if (childItem.weight_offer < 0.01 && childItem.quantity < 1 || childItem.weight_offer < 1 && childItem.quantity < 0.01) {
	                                weight = item.weight_offer * 1;
	                            }
	                            if (childItem.weight_offer < 0.1 && childItem.quantity < 0.1) {
	                                weight = childItem.weight_offer * 1;
	                            }
	                        }
	                        return _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin' },
	                            _react3.default.createElement('div', { className: 'col-sm-1  col-xs-12' }),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-4 visible-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'title', style: { paddingLeft: '20px' } },
	                                    '\u2022 ',
	                                    childItem.name,
	                                    ' ',
	                                    childItem.modifier_option_name
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { style: { paddingLeft: '30px' } },
	                                    _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        _this.props.lang['store.common.quantity'],
	                                        ': '
	                                    ),
	                                    childItem.type_id === 5 ? _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        childItem.quantity / quantity
	                                    ) : _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        weight,
	                                        ' ',
	                                        _this.props.lang[childItem.unit.title_lang_data]
	                                    )
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-4 hidden-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'title', style: { paddingLeft: '20px' } },
	                                    '\u2022 ',
	                                    childItem.name
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-3 hidden-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'title' },
	                                    childItem.modifier_option_name
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2 hidden-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { style: { textAlign: 'center' } },
	                                    _react3.default.createElement(
	                                        'span',
	                                        { className: 'visible-xs' },
	                                        _this.props.lang['store.common.quantity'],
	                                        ': '
	                                    ),
	                                    childItem.type_id === 5 ? _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        childItem.quantity / quantity
	                                    ) : _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        weight,
	                                        ' ',
	                                        _this.props.lang[childItem.unit.title_lang_data]
	                                    )
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2' },
	                                _react3.default.createElement('div', { className: 'price' })
	                            ),
	                            _react3.default.createElement('div', { className: 'clearfix' }),
	                            childItem.type_id === 5 ? childItem.childProducts.map(function (childChildItem) {
	                                if (childChildItem.quantity == 0) {
	                                    return null;
	                                }
	                                childWeight = childChildItem.quantity / childItem.quantity;
	                                childChildItem.weight_offer = childChildItem.weight_offer * 1;
	                                if ((childChildItem.unit.slug === 'kg' || childChildItem.unit.slug === 'mg') && childChildItem.weight_offer && childChildItem.weight_offer > 0 && childChildItem.quantity > 0) {
	                                    childWeight = childChildItem.weight_offer * childChildItem.quantity / childItem.quantity;
	                                    childWeight = childWeight.toFixed(3);
	                                    if (childChildItem.weight_offer < 0.01 && childChildItem.quantity < 1 || childChildItem.weight_offer < 1 && childChildItem.quantity < 0.01) {
	                                        childWeight = childChildItem.weight_offer * 1;
	                                    }
	                                    if (childChildItem.weight_offer < 0.1 && childChildItem.quantity < 0.1) {
	                                        childWeight = childChildItem.weight_offer * 1;
	                                    }
	                                }
	                                if (childItem.quantity === 0) {
	                                    childWeight = 0;
	                                }
	                                return _react3.default.createElement(
	                                    'div',
	                                    { className: 'row no-margin' },
	                                    _react3.default.createElement('div', { className: 'col-sm-1 col-xs-12' }),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-4 visible-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'title', style: { paddingLeft: '40px' } },
	                                            '- ',
	                                            childChildItem.name,
	                                            ' ',
	                                            childChildItem.modifier_option_name
	                                        ),
	                                        _react3.default.createElement(
	                                            'div',
	                                            { style: { paddingLeft: '49px' } },
	                                            _react3.default.createElement(
	                                                'span',
	                                                null,
	                                                _this.props.lang['store.common.quantity'],
	                                                ': ',
	                                                childWeight,
	                                                ' ',
	                                                _this.props.lang[childChildItem.unit.title_lang_data]
	                                            )
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-4 hidden-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'title', style: { paddingLeft: '40px' } },
	                                            '- ',
	                                            childChildItem.name
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-3 hidden-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            childChildItem.modifier_option_name
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-2 hidden-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { style: { textAlign: 'center' } },
	                                            _react3.default.createElement(
	                                                'span',
	                                                { className: 'visible-xs' },
	                                                _this.props.lang['store.common.quantity'],
	                                                ': '
	                                            ),
	                                            _react3.default.createElement(
	                                                'span',
	                                                null,
	                                                childWeight,
	                                                ' ',
	                                                _this.props.lang[childChildItem.unit.title_lang_data]
	                                            )
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-2' },
	                                        _react3.default.createElement('div', { className: 'price' })
	                                    )
	                                );
	                            }) : null
	                        );
	                    }) : null
	                );
	            });
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(Static, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                lang = _props.lang,
	                currency = _props.currency,
	                sumTotal = _props.sumTotal;
	
	            var data = this.props.data.result;
	            var date = (0, _moment2.default)(this.props.data.result.operation.crtime);
	
	            if (data.error > 0) {
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 process_input' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react3.default.createElement(
	                            'p',
	                            null,
	                            _react3.default.createElement(_components2.TranslatePipo, { title: data.message }),
	                            _react3.default.createElement('br', null)
	                        )
	                    )
	                );
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 process_input' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'small-9 columns' },
	                        _react3.default.createElement(
	                            'h2',
	                            { className: 'section-title special_title' },
	                            lang['store.common.order'],
	                            ' \u2116',
	                            this.props.orderId
	                        ),
	                        _react3.default.createElement(
	                            'h5',
	                            null,
	                            '' + date.format('DD.MM.YYYY')
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'small-12 columns' },
	                        _react3.default.createElement(
	                            'p',
	                            null,
	                            _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.part3 })
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row', id: 'personal-order-detail' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 items-holder no-margin' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin cart-item hidden-xs' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-1' },
	                                lang['store.cart.photo']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-4' },
	                                lang['store.cart.title']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-3' },
	                                lang['store.cart.modifiers']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-2 text-center' },
	                                lang['store.cart.quantity']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-2 text-center' },
	                                lang['store.cart.price']
	                            )
	                        ),
	                        this.productsTable()
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 products_total_price' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-3 col-sm-offset-9 text-center' },
	                            _react3.default.createElement(_components2.MoneyValue, {
	                                value: parseFloat(sumTotal),
	                                icon: currency.icon,
	                                iconAfterValue: currency.icon_after_value,
	                                prefix: lang['store.cart.total'] + ': '
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Static;
	}(_react2.Component), _class2.propTypes = {
	    data: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Static;
	module.exports = exports['default'];

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _moment = __webpack_require__(11);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(19);
	
	var _SHARE = __webpack_require__(93);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Terminal: {
	        displayName: 'Terminal'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Order/ProcessInput/terminal.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Terminal = _wrapComponent('Terminal')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang,
	        currency: state.currency
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Terminal, _Component);
	
	    function Terminal(props) {
	        (0, _classCallCheck3.default)(this, Terminal);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Terminal.__proto__ || (0, _getPrototypeOf2.default)(Terminal)).call(this, props));
	
	        _this.productsTable = function () {
	            var currency = _this.props.currency;
	
	            return _this.props.products.map(function (item) {
	                var pictures = item.offer.pictures || [];
	                var image = pictures[0];
	                var quantity = parseInt(item.quantity, 10) || 0;
	                var weight = null;
	                var childWeight = null;
	                var modifier_option_name = _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-3 prod_desc' },
	                    _react3.default.createElement('div', { className: 'title' })
	                );
	                item.additionalInfo = item.additional_info ? JSON.parse(item.additional_info) : null;
	                if (item.additionalInfo && item.additionalInfo.custom_fields) {
	                    item.custom_fields = item.additionalInfo.custom_fields;
	                }
	
	                if (item.modifier_option_name !== null && item.modifier_option_name !== '') {
	                    modifier_option_name = _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-3 prod_desc' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'title' },
	                            item.modifier_option_name
	                        )
	                    );
	                } else if (item.modifier_option_id !== null) {
	                    modifier_option_name = _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-3 prod_desc' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'title' },
	                            item.modifiedOption.name
	                        )
	                    );
	                }
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin cart-item' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-1 col-xs-12' },
	                        image && image.preview_url ? _react3.default.createElement('img', { src: image.preview_url }) : null
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-4' },
	                        _react3.default.createElement(
	                            'div',
	                            null,
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'title' },
	                                _react3.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/product/' + item.offer.id },
	                                    item.offer.name
	                                ),
	                                item.custom_fields ? item.custom_fields.map(function (product, i) {
	                                    return _react3.default.createElement(
	                                        'label',
	                                        null,
	                                        product.name,
	                                        ': ',
	                                        product.value
	                                    );
	                                }) : null
	                            ),
	                            _react3.default.createElement(_SHARE.SwitherDescription, { description: item.offer.description })
	                        )
	                    ),
	                    modifier_option_name,
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'quantity cart_quantity' },
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'visible-xs' },
	                                _this.props.lang['store.common.quantity'],
	                                ': ',
	                                quantity
	                            ),
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'hidden-xs' },
	                                quantity
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'price' },
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'visible-xs' },
	                                _this.props.lang['store.common.price'],
	                                ':',
	                                _react3.default.createElement(_components2.MoneyValue, {
	                                    value: parseFloat(item.price * quantity),
	                                    icon: currency.icon,
	                                    iconAfterValue: currency.icon_after_value
	                                })
	                            ),
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'hidden-xs' },
	                                _react3.default.createElement(_components2.MoneyValue, {
	                                    value: parseFloat(item.price * quantity),
	                                    icon: currency.icon,
	                                    iconAfterValue: currency.icon_after_value
	                                })
	                            )
	                        )
	                    ),
	                    _react3.default.createElement('div', { className: 'clearfix' }),
	                    item.type_id === 5 ? item.childProducts.map(function (childItem) {
	                        if (childItem.quantity == 0) {
	                            return null;
	                        }
	                        weight = childItem.quantity / quantity;
	                        childItem.weight_offer = childItem.weight_offer * 1;
	                        if ((childItem.unit.slug === 'kg' || childItem.unit.slug === 'mg') && childItem.weight_offer && childItem.weight_offer > 0 && childItem.quantity > 0) {
	                            weight = childItem.weight_offer * childItem.quantity / quantity;
	                            weight = weight.toFixed(3);
	                            if (childItem.weight_offer < 0.01 && childItem.quantity < 1 || childItem.weight_offer < 1 && childItem.quantity < 0.01) {
	                                weight = item.weight_offer * 1;
	                            }
	                            if (childItem.weight_offer < 0.1 && childItem.quantity < 0.1) {
	                                weight = childItem.weight_offer * 1;
	                            }
	                        }
	                        return _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin' },
	                            _react3.default.createElement('div', { className: 'col-sm-1  col-xs-12' }),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-4 visible-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'title', style: { paddingLeft: '20px' } },
	                                    '\u2022 ',
	                                    childItem.name,
	                                    ' ',
	                                    childItem.modifier_option_name
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { style: { paddingLeft: '30px' } },
	                                    _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        _this.props.lang['store.common.quantity'],
	                                        ': '
	                                    ),
	                                    childItem.type_id === 5 ? _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        childItem.quantity / quantity
	                                    ) : _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        weight,
	                                        ' ',
	                                        _this.props.lang[childItem.unit.title_lang_data]
	                                    )
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-4 hidden-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'title', style: { paddingLeft: '20px' } },
	                                    '\u2022 ',
	                                    childItem.name
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-3 hidden-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'title' },
	                                    childItem.modifier_option_name
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2 hidden-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { style: { textAlign: 'center' } },
	                                    _react3.default.createElement(
	                                        'span',
	                                        { className: 'visible-xs' },
	                                        _this.props.lang['store.common.quantity'],
	                                        ': '
	                                    ),
	                                    childItem.type_id === 5 ? _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        childItem.quantity / quantity
	                                    ) : _react3.default.createElement(
	                                        'span',
	                                        null,
	                                        weight,
	                                        ' ',
	                                        _this.props.lang[childItem.unit.title_lang_data]
	                                    )
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2 hidden-xs' },
	                                _react3.default.createElement('div', { className: 'price' })
	                            ),
	                            _react3.default.createElement('div', { className: 'clearfix' }),
	                            childItem.type_id === 5 ? childItem.childProducts.map(function (childChildItem) {
	                                if (childChildItem.quantity == 0) {
	                                    return null;
	                                }
	                                childWeight = childChildItem.quantity / childItem.quantity;
	                                childChildItem.weight_offer = childChildItem.weight_offer * 1;
	                                if ((childChildItem.unit.slug === 'kg' || childChildItem.unit.slug === 'mg') && childChildItem.weight_offer && childChildItem.weight_offer > 0 && childChildItem.quantity > 0) {
	                                    childWeight = childChildItem.weight_offer * childChildItem.quantity / childItem.quantity;
	                                    childWeight = childWeight.toFixed(3);
	                                    if (childChildItem.weight_offer < 0.01 && childChildItem.quantity < 1 || childChildItem.weight_offer < 1 && childChildItem.quantity < 0.01) {
	                                        childWeight = childChildItem.weight_offer * 1;
	                                    }
	                                    if (childChildItem.weight_offer < 0.1 && childChildItem.quantity < 0.1) {
	                                        childWeight = childChildItem.weight_offer * 1;
	                                    }
	                                }
	                                if (childItem.quantity === 0) {
	                                    childWeight = 0;
	                                }
	                                return _react3.default.createElement(
	                                    'div',
	                                    { className: 'row no-margin' },
	                                    _react3.default.createElement('div', { className: 'col-sm-1 col-xs-12' }),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-sm-4 visible-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'title', style: { paddingLeft: '40px' } },
	                                            '- ',
	                                            childChildItem.name,
	                                            ' ',
	                                            childChildItem.modifier_option_name
	                                        ),
	                                        _react3.default.createElement(
	                                            'div',
	                                            { style: { paddingLeft: '49px' } },
	                                            _react3.default.createElement(
	                                                'span',
	                                                null,
	                                                _this.props.lang['store.common.quantity'],
	                                                ': ',
	                                                childWeight,
	                                                ' ',
	                                                _this.props.lang[childChildItem.unit.title_lang_data]
	                                            )
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-4 hidden-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'title', style: { paddingLeft: '40px' } },
	                                            '- ',
	                                            childChildItem.name
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-3 hidden-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            childChildItem.modifier_option_name
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-2 hidden-xs' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { style: { textAlign: 'center' } },
	                                            _react3.default.createElement(
	                                                'span',
	                                                { className: 'visible-xs' },
	                                                _this.props.lang['store.common.quantity'],
	                                                ': '
	                                            ),
	                                            _react3.default.createElement(
	                                                'span',
	                                                null,
	                                                childWeight,
	                                                ' ',
	                                                _this.props.lang[childChildItem.unit.title_lang_data]
	                                            )
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-sm-2' },
	                                        _react3.default.createElement('div', { className: 'price' })
	                                    )
	                                );
	                            }) : null
	                        );
	                    }) : null
	                );
	            });
	        };
	
	        _this.renderItems = function () {
	            if (_this.props.products.length === 0) {
	                return _react3.default.createElement('div', { className: 'col-xs-12 items-holder no-margin' });
	            }
	            return _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 items-holder no-margin' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin cart-item hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-1' },
	                        lang['store.cart.photo']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-4' },
	                        lang['store.cart.title']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-3' },
	                        lang['store.cart.modifiers']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-2 text-center' },
	                        lang['store.cart.quantity']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-2 text-center' },
	                        lang['store.cart.price']
	                    )
	                ),
	                _this.productsTable()
	            );
	        };
	
	        _this.renderUserInfo = function () {
	            var data = _this.props.data.result;
	
	            if (data.error === 0) {
	                return _react3.default.createElement(
	                    'p',
	                    null,
	                    _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.main_text, raw: true }),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.bill_number }),
	                    ':\xA0',
	                    _react3.default.createElement(
	                        'b',
	                        null,
	                        data.inner_id
	                    ),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement(
	                        'b',
	                        null,
	                        _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.your_phone })
	                    ),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement(
	                        'b',
	                        null,
	                        data.operation.phone
	                    ),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.sum_to_pay }),
	                    ':\xA0',
	                    _react3.default.createElement(
	                        'b',
	                        null,
	                        data.sum_str,
	                        ' ',
	                        data.currency_code
	                    ),
	                    _react3.default.createElement('br', null),
	                    _react3.default.createElement('br', null)
	                );
	            } else {
	                return _react3.default.createElement(
	                    'p',
	                    null,
	                    _react3.default.createElement(_components2.TranslatePipo, { title: data.message }),
	                    _react3.default.createElement('br', null)
	                );
	            }
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(Terminal, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                lang = _props.lang,
	                currency = _props.currency,
	                sumTotal = _props.sumTotal;
	
	            var data = this.props.data.result;
	            var date = (0, _moment2.default)(this.props.data.result.operation.crtime);
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 process_input' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'small-9 columns' },
	                        _react3.default.createElement(
	                            'h2',
	                            { className: 'section-title special_title' },
	                            lang['store.common.order'],
	                            ' \u2116',
	                            this.props.orderId
	                        ),
	                        _react3.default.createElement(
	                            'h5',
	                            null,
	                            '' + date.format('DD.MM.YYYY')
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'small-12 columns' },
	                        _react3.default.createElement(_components2.TranslatePipo, { title: 'events.account' }),
	                        ' \u2116',
	                        data.inner_id
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'small-12 columns' },
	                        _react3.default.createElement(
	                            'h2',
	                            { className: 'pay-type-title' },
	                            _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.instruction })
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'range' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'user-info' },
	                                _react3.default.createElement('br', null),
	                                this.renderUserInfo()
	                            )
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row', id: 'personal-order-detail' },
	                    this.renderItems(),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 products_total_price' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-3 col-sm-offset-9 text-center' },
	                            _react3.default.createElement(_components2.MoneyValue, {
	                                value: parseFloat(sumTotal),
	                                icon: currency.icon,
	                                iconAfterValue: currency.icon_after_value,
	                                prefix: lang['store.cart.total'] + ': '
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Terminal;
	}(_react2.Component), _class2.propTypes = {
	    data: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Terminal;
	module.exports = exports['default'];

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _moment = __webpack_require__(11);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(19);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _SHARE = __webpack_require__(93);
	
	var _helpers = __webpack_require__(15);
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1089);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	var _windowOrGlobal = __webpack_require__(264);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    OrderItemsDetail: {
	        displayName: 'OrderItemsDetail'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Order/default/OrderItemsDetailView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	function LinkPay(_ref) {
	    var onPay = _ref.onPay,
	        disabled = _ref.disabled,
	        lang = _ref.lang;
	
	    return _react3.default.createElement(
	        'div',
	        { className: 'buttons-holder' },
	        _react3.default.createElement(
	            'button',
	            { disabled: disabled, onClick: onPay, className: 'le-button big' },
	            lang['store.common.pay']
	        )
	    );
	}
	
	var OrderItemsDetail = _wrapComponent('OrderItemsDetail')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(OrderItemsDetail, _Component);
	
	    function OrderItemsDetail(props) {
	        var _this2 = this;
	
	        (0, _classCallCheck3.default)(this, OrderItemsDetail);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (OrderItemsDetail.__proto__ || (0, _getPrototypeOf2.default)(OrderItemsDetail)).call(this, props));
	
	        _this.onPay = function (event) {
	            event.preventDefault();
	            _this.props.onPay();
	        };
	
	        _this.editOrder = function (event) {
	            event.preventDefault();
	            _this.props.editOrder();
	        };
	
	        _this.cancelOrder = function (event) {
	            event.preventDefault();
	            _this.props.cancelOrder();
	        };
	
	        _this.renderTitleProduct = function (_ref2) {
	            var product = _ref2.product,
	                is_coupon = _ref2.is_coupon;
	
	            var offer = product.offer;
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'title' },
	                    _react3.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/product/' + offer.id },
	                        offer.name
	                    )
	                ),
	                _react3.default.createElement(_SHARE.SwitherDescription, { description: offer.description }),
	                product.custom_fields ? product.custom_fields.map(function (item, i) {
	                    return _react3.default.createElement(
	                        'label',
	                        null,
	                        item.name,
	                        ': ',
	                        item.value
	                    );
	                }) : null
	            );
	        };
	
	        _this.renderTitleModifierOptionName = function (_ref3) {
	            var offer = _ref3.offer;
	
	            if (offer.modifier_option_name !== null && offer.modifier_option_name !== '') {
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'title' },
	                    offer.modifier_option_name
	                );
	            } else if (offer.modifier_option_id !== null) {
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'title' },
	                    offer.modifiedOption.name
	                );
	            } else {
	                return _react3.default.createElement('div', { className: 'title' });
	            }
	        };
	
	        _this.renderDate = function (_ref4) {
	            var date = _ref4.date;
	
	            date = (0, _moment2.default)(date);
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'date' },
	                _react3.default.createElement(
	                    'span',
	                    null,
	                    date.format('DD.MM.YYYY')
	                )
	            );
	        };
	
	        _this.renderSum = function (_ref5) {
	            var sum = _ref5.sum;
	            var currency = _this.props.currency;
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'price' },
	                _react3.default.createElement(_components2.MoneyValue, {
	                    value: sum,
	                    icon: currency.icon,
	                    iconAfterValue: currency.icon_after_value
	                })
	            );
	        };
	
	        _this.renderProduct = function (item, index) {
	            var price = parseFloat(item.base_price);
	            var itemQty = item.refundedProduct && _this.props.isRevert ? item.refundedProduct.quantity : item.quantity;
	            var quantity = parseInt(item.quantity, 10) || 0;
	            var quantityForChilds = parseInt(itemQty, 10) || 0;
	            var pictures = item.offer.pictures || [];
	            var image = pictures[0];
	            var weight = null;
	            var childWeight = null;
	            return _react3.default.createElement(
	                'div',
	                { key: index, className: 'row no-margin cart-item' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-1 col-xs-12' },
	                    image && image.preview_url ? _react3.default.createElement('img', { src: image.preview_url }) : ''
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-4' },
	                    _react3.default.createElement(_this2.renderTitleProduct, { product: item, is_coupon: item.is_coupon || item.isCoupon })
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-3' },
	                    _react3.default.createElement(_this2.renderTitleModifierOptionName, { offer: item })
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-2 hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'quantity cart_quantity' },
	                        _react3.default.createElement(
	                            'span',
	                            null,
	                            quantity
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-2 hidden-xs' },
	                    _react3.default.createElement(_this2.renderSum, { sum: price * quantity })
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-2 visible-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'quantity cart_quantity', style: { textAlign: 'left' } },
	                        _react3.default.createElement(
	                            'span',
	                            null,
	                            _this.props.lang['store.common.quantity'],
	                            ': ',
	                            quantity
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-2 visible-xs price', style: { textAlign: 'left' } },
	                    _react3.default.createElement(
	                        'span',
	                        { className: 'visible-xs' },
	                        _this.props.lang['store.common.price'],
	                        ': ',
	                        _react3.default.createElement(_components2.MoneyValue, {
	                            value: price * quantity,
	                            icon: _this.props.currency.icon,
	                            iconAfterValue: _this.props.currency.icon_after_value
	                        })
	                    )
	                ),
	                item.type_id === 5 ? item.childProducts.map(function (childItem) {
	                    return _this.renderNested(childItem, quantityForChilds);
	                }) : null
	            );
	        };
	
	        _this.renderNested = function (childItem, quantity) {
	            var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	            if (childItem.quantity == 0) {
	                return null;
	            }
	            var weight = childItem.quantity / quantity;
	            childItem.weight_offer = childItem.weight_offer * 1;
	            if ((childItem.unit.slug === 'kg' || childItem.unit.slug === 'mg') && childItem.weight_offer && childItem.weight_offer > 0 && childItem.quantity > 0) {
	                weight = childItem.weight_offer * childItem.quantity / quantity;
	                weight = weight.toFixed(3);
	                if (childItem.weight_offer < 0.01 && childItem.quantity < 1 || childItem.weight_offer < 1 && childItem.quantity < 0.01) {
	                    weight = item.weight_offer * 1;
	                }
	                if (childItem.weight_offer < 0.1 && childItem.quantity < 0.1) {
	                    weight = childItem.weight_offer * 1;
	                }
	            }
	            var paddingLeft = level * 30 + 'px';
	            return _react3.default.createElement(
	                'div',
	                { className: 'row no-margin', style: { clear: 'both' } },
	                _react3.default.createElement('div', { className: 'col-sm-1 col-xs-12' }),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-4 visible-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title', style: { paddingLeft: paddingLeft } },
	                        '- ',
	                        childItem.name,
	                        ' ',
	                        childItem.modifier_option_name
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { style: { paddingLeft: '30px' } },
	                        _react3.default.createElement(
	                            'span',
	                            null,
	                            _this.props.lang['store.common.quantity'],
	                            ': '
	                        ),
	                        childItem.type_id === 5 ? _react3.default.createElement(
	                            'span',
	                            null,
	                            childItem.quantity / quantity
	                        ) : _react3.default.createElement(
	                            'span',
	                            null,
	                            weight,
	                            ' ',
	                            _this.props.lang[childItem.unit.title_lang_data]
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-4 hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title', style: { paddingLeft: paddingLeft } },
	                        '- ',
	                        childItem.name
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-3 hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        childItem.modifier_option_name
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-2 hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { style: { textAlign: 'center' } },
	                        _react3.default.createElement(
	                            'span',
	                            { className: 'visible-xs' },
	                            _this.props.lang['store.common.quantity'],
	                            ': '
	                        ),
	                        childItem.type_id === 5 ? _react3.default.createElement(
	                            'span',
	                            null,
	                            childItem.quantity / quantity
	                        ) : _react3.default.createElement(
	                            'span',
	                            null,
	                            weight,
	                            ' ',
	                            _this.props.lang[childItem.unit.title_lang_data]
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-2' },
	                    _react3.default.createElement('div', { className: 'price' })
	                ),
	                childItem.type_id === 5 ? childItem.childProducts.map(function (childChildItem) {
	                    return _this.renderNested(childChildItem, quantity, level + 1);
	                }) : null
	            );
	        };
	
	        _this.renderButtonAndStatusPay = function () {
	            var _this$props = _this.props,
	                _this$props$showPay = _this$props.showPay,
	                showPay = _this$props$showPay === undefined ? false : _this$props$showPay,
	                _this$props$hidePayBu = _this$props.hidePayButton,
	                hidePayButton = _this$props$hidePayBu === undefined ? false : _this$props$hidePayBu,
	                _this$props$disabled = _this$props.disabled,
	                disabled = _this$props$disabled === undefined ? true : _this$props$disabled,
	                lang = _this$props.lang;
	
	            if (showPay) {
	                if (hidePayButton) {
	                    return null;
	                }
	                return _react3.default.createElement(LinkPay, { onPay: _this.onPay, disabled: disabled, lang: lang });
	            }
	            return null;
	        };
	
	        _this.renderSumPrice = function () {
	            var AccountsList = _this.props.user.amount[0];
	            var coupons = _this.props.user.coupons;
	
	            var _this$props2 = _this.props,
	                sum = _this$props2.sum,
	                showPay = _this$props2.showPay,
	                _this$props2$hideAll = _this$props2.hideAll,
	                hideAll = _this$props2$hideAll === undefined ? false : _this$props2$hideAll,
	                bonusValue = _this$props2.bonusValue,
	                paymentInId = _this$props2.paymentInId,
	                sumDiscount = _this$props2.sumDiscount,
	                setting = _this$props2.setting,
	                currency = _this$props2.currency,
	                lang = _this$props2.lang;
	
	            var discountSum = (sum - sumDiscount) / 2;
	            if (_this.props.ibonus_data) {
	                var IBonusData = _windowOrGlobal.JSON.parse(_this.props.ibonus_data);
	                if (IBonusData.discount_sum && IBonusData.discount_sum > discountSum) {
	                    discountSum = IBonusData.discount_sum * 1;
	                }
	            }
	            var addAmount = 0;
	            if (sumDiscount > 0) {
	                addAmount = sumDiscount * 1;
	            }
	            if (AccountsList.amount + addAmount > 0 && AccountsList.amount + addAmount < discountSum) {
	                discountSum = AccountsList.amount * 1 + addAmount;
	            }
	            if (sum - discountSum < 1) {
	                discountSum = sum - 1;
	                if (discountSum < 0) discountSum = 0;
	            }
	            discountSum = Math.floor(discountSum);
	            var totalSum = sum - sumDiscount - bonusValue;
	            var sumTotal = sum - sumDiscount;
	            var text = lang['store.cart.total'] + ': ';
	            var cashbackValue = '';
	            var couponsSlider = '';
	            var cashbackCoupon = '';
	            var useCoupon = false;
	            _this.props.products.forEach(function (item) {
	                if (item.is_coupon === true) {
	                    useCoupon = true;
	                }
	            });
	            var sumDiscountAmount = '';
	            if (sumDiscount > 0) {
	                sumDiscountAmount = _react3.default.createElement(
	                    'div',
	                    { className: 'items-holder' },
	                    _react3.default.createElement(_components2.MoneyValue, {
	                        value: parseFloat(sumDiscount),
	                        icon: currency.icon,
	                        iconAfterValue: currency.icon_after_value,
	                        prefix: lang['store.common.discountInOrder'] + ': '
	                    })
	                );
	            }
	            setting.loyaltySettingsData = _this.props.user.loyaltySettings;
	            if (setting.loyaltySettingsActive && !hideAll && setting.loyaltySettingsData.customerSettings !== undefined && setting.loyaltySettingsData.newCustomerSettings !== undefined) {
	                if (AccountsList.notFirstOrder !== true) {
	                    if (setting.loyaltySettingsData.newCustomerSettings.coupon !== null && setting.loyaltySettingsData.newCustomerSettings.coupon !== undefined && setting.loyaltySettingsData.newCustomerSettings.coupon.deleted !== true) {
	                        cashbackCoupon = _react3.default.createElement(
	                            'div',
	                            null,
	                            lang['store.iBonus.order.afterPaymentCoupon'],
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'text-center', style: { maxWidth: '100px', border: '4px solid #008000', borderRadius: '8px', marginLeft: 'auto', marginRight: 'auto' } },
	                                setting.loyaltySettingsData.newCustomerSettings.coupon.imagePath !== null ? _react3.default.createElement(
	                                    'div',
	                                    { className: 'text-center', style: { padding: '4px' } },
	                                    _react3.default.createElement('img', { style: { maxWidth: '68px', maxHeight: '68px', marginLeft: 'auto', marginRight: 'auto' }, src: setting.loyaltySettingsData.newCustomerSettings.coupon.imagePath })
	                                ) : _react3.default.createElement('div', { style: { width: '72px', height: '72px', padding: '4px' } }),
	                                _react3.default.createElement(
	                                    'div',
	                                    null,
	                                    setting.loyaltySettingsData.newCustomerSettings.coupon.header
	                                )
	                            )
	                        );
	                    }
	                    if (setting.loyaltySettingsData.newCustomerSettings.cashBackType === 'percentage') {
	                        cashbackValue = _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin summ_row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 text-center' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'total_price' },
	                                    lang['store.iBonus.order.afterPaymentPointsFirstOrder'],
	                                    ' ',
	                                    (totalSum / 100 * setting.loyaltySettingsData.newCustomerSettings.amount).toFixed(2),
	                                    '      ',
	                                    lang['store.iBonus.order.points']
	                                ),
	                                cashbackCoupon
	                            )
	                        );
	                    } else {
	                        cashbackValue = _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin summ_row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 text-center' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'total_price' },
	                                    lang['store.iBonus.order.afterPaymentPointsFirstOrder'],
	                                    ' ',
	                                    setting.loyaltySettingsData.newCustomerSettings.amount,
	                                    '      ',
	                                    lang['store.iBonus.order.points']
	                                ),
	                                cashbackCoupon
	                            )
	                        );
	                    }
	                } else {
	                    if (setting.loyaltySettingsData.customerSettings.coupon !== null && setting.loyaltySettingsData.customerSettings.coupon !== undefined && setting.loyaltySettingsData.customerSettings.coupon.deleted !== true) {
	                        cashbackCoupon = _react3.default.createElement(
	                            'div',
	                            null,
	                            lang['store.iBonus.order.afterPaymentCoupon'],
	                            _react3.default.createElement(
	                                'div',
	                                { style: { maxWidth: '100px', border: '4px solid #008000', borderRadius: '8px', marginLeft: 'auto', marginRight: 'auto' } },
	                                setting.loyaltySettingsData.customerSettings.coupon.imagePath !== null ? _react3.default.createElement(
	                                    'div',
	                                    { className: 'text-center', style: { padding: '4px' } },
	                                    _react3.default.createElement('img', { style: { maxWidth: '68px', maxHeight: '68px', marginLeft: 'auto', marginRight: 'auto' }, src: setting.loyaltySettingsData.customerSettings.coupon.imagePath })
	                                ) : _react3.default.createElement('div', { style: { width: '72px', height: '72px', padding: '4px' } }),
	                                _react3.default.createElement(
	                                    'div',
	                                    null,
	                                    setting.loyaltySettingsData.customerSettings.coupon.header
	                                )
	                            )
	                        );
	                    }
	                    if (setting.loyaltySettingsData.customerSettings.cashBackType === 'percentage') {
	                        cashbackValue = _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin summ_row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 text-center' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'total_price' },
	                                    lang['store.iBonus.order.afterPaymentPoints'],
	                                    ' ',
	                                    (totalSum / 100 * setting.loyaltySettingsData.customerSettings.amount).toFixed(2),
	                                    ' ',
	                                    lang['store.iBonus.order.points']
	                                ),
	                                cashbackCoupon
	                            )
	                        );
	                    } else {
	                        cashbackValue = _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin summ_row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 text-center' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'total_price' },
	                                    lang['store.iBonus.order.afterPaymentPoints'],
	                                    ' ',
	                                    setting.loyaltySettingsData.customerSettings.amount,
	                                    ' ',
	                                    lang['store.iBonus.order.points']
	                                ),
	                                cashbackCoupon
	                            )
	                        );
	                    }
	                }
	                if (coupons.length > 0) {
	                    var couponStyleSelect = '';
	                    couponsSlider = _react3.default.createElement(
	                        'div',
	                        { className: 'row no-margin summ_row' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'total_price' },
	                            lang['store.iBonus.order.availableCoupons']
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { style: { overflow: 'auto' } },
	                            _react3.default.createElement(
	                                'table',
	                                null,
	                                _react3.default.createElement(
	                                    'tbody',
	                                    null,
	                                    _react3.default.createElement(
	                                        'tr',
	                                        { key: 1 },
	                                        coupons.map(function (item, index) {
	                                            couponStyleSelect = '4px solid #fff';
	                                            if (_this.props.couponId === item.id) {
	                                                couponStyleSelect = '4px solid #008000';
	                                            }
	                                            if (item.imagePath !== null) {
	                                                return _react3.default.createElement(
	                                                    'td',
	                                                    { style: { padding: '8px' } },
	                                                    _react3.default.createElement(
	                                                        'div',
	                                                        { className: 'text-center', style: { border: couponStyleSelect, borderRadius: '8px' } },
	                                                        _react3.default.createElement(
	                                                            'a',
	                                                            { onClick: function onClick(e) {
	                                                                    _this.props.couponSelect(item);
	                                                                } },
	                                                            _react3.default.createElement(
	                                                                'div',
	                                                                { style: { maxWidth: '72px', maxHeight: '72px', padding: '4px' } },
	                                                                _react3.default.createElement('img', { style: { maxWidth: '68px', maxHeight: '68px' }, src: item.imagePath })
	                                                            ),
	                                                            _react3.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                item.header
	                                                            )
	                                                        )
	                                                    )
	                                                );
	                                            } else {
	                                                return _react3.default.createElement(
	                                                    'td',
	                                                    { style: { padding: '8px' } },
	                                                    _react3.default.createElement(
	                                                        'div',
	                                                        { className: 'text-center', style: { border: couponStyleSelect, borderRadius: '8px' } },
	                                                        _react3.default.createElement(
	                                                            'a',
	                                                            { onClick: function onClick(e) {
	                                                                    _this.props.couponSelect(item);
	                                                                } },
	                                                            _react3.default.createElement('div', { style: { width: '72px', height: '72px', padding: '4px' } }),
	                                                            _react3.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                item.header
	                                                            )
	                                                        )
	                                                    )
	                                                );
	                                            }
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    );
	                }
	            }
	            if (hideAll) {
	                setting.loyaltySettingsActive = false;
	            }
	            return _react3.default.createElement(
	                'div',
	                null,
	                setting.loyaltySettingsActive && AccountsList.amount > 0 && sum !== '0.00000000' && showPay && !hideAll ? _react3.default.createElement(
	                    'div',
	                    null,
	                    couponsSlider,
	                    AccountsList.amount > 0 && !hideAll ? _react3.default.createElement(
	                        'div',
	                        null,
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-12' },
	                                lang['store.iBonus.order.bonusesToUseAreAvailable'],
	                                ' ',
	                                (AccountsList.amount * 1 + addAmount).toFixed(2)
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2' },
	                                lang['store.iBonus.order.bonusesUse']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-6' },
	                                _react3.default.createElement('input', { type: 'range', min: 0, max: discountSum, step: 1, value: bonusValue, onChange: _this.props.onChangeBonusValue })
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react3.default.createElement('div', { className: 'col-xs-12 col-sm-2' }),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-3' },
	                                '0'
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-3 text-right' },
	                                discountSum
	                            )
	                        )
	                    ) : null,
	                    cashbackValue,
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'summ_price items-holder' },
	                            sumDiscountAmount,
	                            _react3.default.createElement(_components2.MoneyValue, {
	                                value: parseFloat(totalSum),
	                                icon: currency.icon,
	                                iconAfterValue: currency.icon_after_value,
	                                prefix: text
	                            })
	                        )
	                    )
	                ) : null,
	                setting.loyaltySettingsActive && paymentInId !== null && !showPay ? _react3.default.createElement(
	                    'div',
	                    null,
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-12' },
	                                lang['store.iBonus.order.bonusesUsed'],
	                                ' ',
	                                parseFloat(sumDiscount).toFixed(2),
	                                ' ',
	                                lang['store.iBonus.order.bonuses']
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'summ_price' },
	                            sumDiscountAmount,
	                            _react3.default.createElement(_components2.MoneyValue, {
	                                value: parseFloat(sumTotal),
	                                icon: currency.icon,
	                                iconAfterValue: currency.icon_after_value,
	                                prefix: text
	                            })
	                        )
	                    )
	                ) : null,
	                !setting.loyaltySettingsActive ? _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 text-center' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'summ_price' },
	                        sumDiscountAmount,
	                        _react3.default.createElement(_components2.MoneyValue, {
	                            value: parseFloat(sum - sumDiscount),
	                            icon: currency.icon,
	                            iconAfterValue: currency.icon_after_value,
	                            prefix: text
	                        })
	                    )
	                ) : null
	            );
	        };
	
	        _this.renderMergedOrder = function () {
	            var _this$props3 = _this.props,
	                url = _this$props3.url,
	                sum = _this$props3.sum,
	                _this$props3$before = _this$props3.before,
	                before = _this$props3$before === undefined ? null : _this$props3$before,
	                _this$props3$after = _this$props3.after,
	                after = _this$props3$after === undefined ? null : _this$props3$after,
	                _this$props3$showPay = _this$props3.showPay,
	                showPay = _this$props3$showPay === undefined ? false : _this$props3$showPay,
	                token = _this$props3.token,
	                _this$props3$paymentL = _this$props3.paymentList,
	                paymentList = _this$props3$paymentL === undefined ? null : _this$props3$paymentL,
	                _this$props3$hideAll = _this$props3.hideAll,
	                hideAll = _this$props3$hideAll === undefined ? false : _this$props3$hideAll,
	                lang = _this$props3.lang,
	                setting = _this$props3.setting,
	                delivery_address = _this$props3.delivery_address,
	                userAddresses = _this$props3.userAddresses,
	                addresses = _this$props3.addresses,
	                client_comment = _this$props3.client_comment,
	                onDeliveryAddressChange = _this$props3.onDeliveryAddressChange,
	                onDeliveryAddressSave = _this$props3.onDeliveryAddressSave,
	                onClientCommentChange = _this$props3.onClientCommentChange,
	                onAddAddress = _this$props3.onAddAddress,
	                isOrderWasPaid = _this$props3.isOrderWasPaid,
	                isRevert = _this$props3.isRevert,
	                currency = _this$props3.currency,
	                order_type_id = _this$props3.order_type_id,
	                childOrders = _this$props3.childOrders;
	
	            return _react3.default.createElement(
	                'div',
	                { style: { paddingLeft: '10px' }, className: 'col-xs-12 no-margin personal-order-detail' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 items-holder no-margin' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'row no-margin summ_row' },
	                        _react3.default.createElement(
	                            'h4',
	                            null,
	                            lang['store.postpone.combinesOrders'],
	                            ':'
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin cart-item hidden-xs' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-9 text-center' },
	                                lang['store.common.order']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-3 text-center' },
	                                lang['store.common.sum']
	                            )
	                        ),
	                        childOrders.map(function (childOrder) {
	                            return _react3.default.createElement(
	                                'div',
	                                { className: 'row no-margin cart-item hidden-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-9 text-center' },
	                                    _react3.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/personal/order/' + childOrder.id },
	                                        childOrder.order_number
	                                    )
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-3 text-center' },
	                                    _react3.default.createElement(_components2.MoneyValue, {
	                                        value: childOrder.sum,
	                                        icon: currency.icon,
	                                        iconAfterValue: currency.icon_after_value
	                                    })
	                                )
	                            );
	                        })
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'row no-margin summ_row' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-sm-12 hidden-xs' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-7 col-md-8' },
	                                !showPay && !hideAll && sum !== '0.00000000' ? _react3.default.createElement(
	                                    'button',
	                                    {
	                                        className: 'le-button receipt',
	                                        onClick: function onClick() {
	                                            return (0, _helpers.getCheckByOrder)(_this.props);
	                                        },
	                                        title: lang['store.order_items_detail.get_check']
	                                    },
	                                    lang['store.order_items_detail.check']
	                                ) : null
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 text-center' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'summ_price items-holder' },
	                                _react3.default.createElement(_components2.MoneyValue, {
	                                    value: parseFloat(sum),
	                                    icon: _this.props.currency.icon,
	                                    iconAfterValue: _this.props.currency.icon_after_value,
	                                    prefix: lang['store.cart.total']
	                                })
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 hidden-sm hidden-lg hidden-md' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12' },
	                                !showPay && !hideAll && sum !== '0.00000000' ? _react3.default.createElement(
	                                    'button',
	                                    {
	                                        className: 'le-button receipt',
	                                        onClick: function onClick() {
	                                            return (0, _helpers.getCheckByOrder)(_this.props);
	                                        },
	                                        title: lang['store.order_items_detail.get_check']
	                                    },
	                                    lang['store.order_items_detail.check']
	                                ) : null
	                            )
	                        )
	                    ),
	                    paymentList && showPay && !hideAll ? _react3.default.createElement(
	                        'div',
	                        null,
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row', style: { paddingLeft: '10px' } },
	                            _react3.default.createElement('div', { className: 'col-xs-12 col-sm-9' }),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-3 text-center' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'buttons-holder' },
	                                    _react3.default.createElement(
	                                        'button',
	                                        { onClick: _this.cancelOrder, className: 'le-button' },
	                                        lang['store.common.cancelOrder.button.cancelOrder']
	                                    )
	                                )
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row', style: { paddingLeft: '10px' } },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-8' },
	                                paymentList
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-4 col-xs-12 text-center' },
	                                _this.renderButtonAndStatusPay()
	                            )
	                        )
	                    ) : null
	                )
	            );
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(OrderItemsDetail, [{
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                url = _props.url,
	                _props$products = _props.products,
	                products = _props$products === undefined ? [] : _props$products,
	                sum = _props.sum,
	                _props$before = _props.before,
	                before = _props$before === undefined ? null : _props$before,
	                _props$after = _props.after,
	                after = _props$after === undefined ? null : _props$after,
	                _props$showPay = _props.showPay,
	                showPay = _props$showPay === undefined ? false : _props$showPay,
	                token = _props.token,
	                _props$paymentList = _props.paymentList,
	                paymentList = _props$paymentList === undefined ? null : _props$paymentList,
	                orderDate = _props.orderDate,
	                _props$hideAll = _props.hideAll,
	                hideAll = _props$hideAll === undefined ? false : _props$hideAll,
	                lang = _props.lang,
	                setting = _props.setting,
	                delivery_address = _props.delivery_address,
	                userAddresses = _props.userAddresses,
	                addresses = _props.addresses,
	                client_comment = _props.client_comment,
	                onDeliveryAddressChange = _props.onDeliveryAddressChange,
	                onDeliveryAddressSave = _props.onDeliveryAddressSave,
	                onClientCommentChange = _props.onClientCommentChange,
	                onAddAddress = _props.onAddAddress,
	                isOrderWasPaid = _props.isOrderWasPaid,
	                isRevert = _props.isRevert,
	                order_type_id = _props.order_type_id;
	
	
	            var date = (0, _moment2.default)(orderDate);
	
	            var commentFieldPlaceholderDefaultValue = lang['store.order_items.comment_field_placeholder'];
	            var commentFieldTitleDefaultValue = lang['store.order_items.comment_field_title'];
	
	            // setting.deliveryFieldShow = true;
	
	            var _setting$commentField = setting.commentFieldPlaceholder,
	                commentFieldPlaceholder = _setting$commentField === undefined ? commentFieldPlaceholderDefaultValue : _setting$commentField,
	                commentFieldShow = setting.commentFieldShow,
	                deliveryFieldShow = setting.deliveryFieldShow,
	                _setting$commentField2 = setting.commentFieldTitle,
	                commentFieldTitle = _setting$commentField2 === undefined ? commentFieldTitleDefaultValue : _setting$commentField2;
	
	
	            if (order_type_id === 7) {
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'personal-order-detail' },
	                    _react3.default.createElement(
	                        'h2',
	                        { className: 'section-title special_title', style: { paddingLeft: '10px' } },
	                        _react3.default.createElement(
	                            'span',
	                            null,
	                            lang['store.common.order'],
	                            ' \u2116 ',
	                            this.props.order_number
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'excerpt special_status' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'status-payment' },
	                                this.props.payStatus
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'h5',
	                        { style: { paddingLeft: '10px' } },
	                        '' + date.format('DD.MM.YYYY')
	                    ),
	                    this.renderMergedOrder()
	                );
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'personal-order-detail' },
	                _react3.default.createElement(
	                    'h2',
	                    { className: 'section-title special_title', style: { paddingLeft: '10px' } },
	                    _react3.default.createElement(
	                        'span',
	                        null,
	                        lang['store.common.order'],
	                        ' \u2116 ',
	                        this.props.order_number
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'excerpt special_status' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'status-payment' },
	                            this.props.payStatus
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'h5',
	                    { style: { paddingLeft: '10px' } },
	                    '' + date.format('DD.MM.YYYY')
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { style: { paddingLeft: '10px' }, className: 'col-xs-12 no-margin personal-order-detail' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 items-holder no-margin' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin cart-item hidden-xs' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-1' },
	                                lang['store.cart.photo']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-4' },
	                                lang['store.cart.title']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-3' },
	                                lang['store.cart.modifiers']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-2 text-center' },
	                                lang['store.cart.quantity']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-2 text-center' },
	                                lang['store.cart.price']
	                            )
	                        ),
	                        products.map(this.renderProduct),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin summ_row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-12 hidden-xs' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-7 col-md-8' },
	                                    !showPay && !hideAll && sum !== '0.00000000' ? _react3.default.createElement(
	                                        'button',
	                                        {
	                                            className: 'le-button receipt',
	                                            onClick: function onClick() {
	                                                return (0, _helpers.getCheckByOrder)(_this3.props);
	                                            },
	                                            title: lang['store.order_items_detail.get_check']
	                                        },
	                                        lang['store.order_items_detail.check']
	                                    ) : null
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    null,
	                                    this.renderSumPrice()
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 hidden-sm hidden-lg hidden-md' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-12' },
	                                    this.renderSumPrice()
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-12' },
	                                    !showPay && !hideAll && sum !== '0.00000000' ? _react3.default.createElement(
	                                        'button',
	                                        {
	                                            className: 'le-button receipt',
	                                            onClick: function onClick() {
	                                                return (0, _helpers.getCheckByOrder)(_this3.props);
	                                            },
	                                            title: lang['store.order_items_detail.get_check']
	                                        },
	                                        lang['store.order_items_detail.check']
	                                    ) : null
	                                )
	                            )
	                        ),
	                        deliveryFieldShow ? _react3.default.createElement(
	                            'div',
	                            { className: 'row', style: { paddingLeft: '15px' } },
	                            !showPay && !hideAll && sum !== '0.00000000' ? _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { className: 'col-xs-12 col-sm-7' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.FormGroup,
	                                    { className: 'col-xs-12 col-sm-7' },
	                                    delivery_address !== '' && delivery_address !== null ? _react3.default.createElement(
	                                        _reactBootstrap.ControlLabel,
	                                        null,
	                                        lang['store.common.delivery_address']
	                                    ) : null,
	                                    delivery_address !== '' && delivery_address !== null ? _react3.default.createElement(
	                                        'div',
	                                        null,
	                                        delivery_address
	                                    ) : null
	                                )
	                            ) : _react3.default.createElement(_components2.AddressInput, {
	                                isOrderWasPaid: isOrderWasPaid,
	                                placeholder: lang['store.common.delivery_address_placeholder'],
	                                value: delivery_address,
	                                options: addresses,
	                                label: lang['store.common.delivery_address'],
	                                buttonText: lang['store.common.select_on_map'],
	                                buttonAddAddressText: lang['user.address.button.addNewAddress'],
	                                noOptionsMessageText: lang['user.address.noAddress'],
	                                onAddressChange: onDeliveryAddressChange,
	                                onAddressSave: onDeliveryAddressSave,
	                                onAddAddress: onAddAddress
	                            })
	                        ) : null,
	                        commentFieldShow ? _react3.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            !showPay && !hideAll && sum !== '0.00000000' ? _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { className: 'col-xs-12 col-sm-7' },
	                                client_comment !== '' && client_comment !== null ? _react3.default.createElement(
	                                    _reactBootstrap.ControlLabel,
	                                    null,
	                                    commentFieldTitle
	                                ) : null,
	                                client_comment !== '' && client_comment !== null ? _react3.default.createElement(
	                                    'div',
	                                    null,
	                                    client_comment
	                                ) : null
	                            ) : _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { className: 'col-xs-12 col-sm-7' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.ControlLabel,
	                                    null,
	                                    commentFieldTitle
	                                ),
	                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                    value: client_comment,
	                                    type: 'text',
	                                    placeholder: commentFieldPlaceholder,
	                                    onChange: onClientCommentChange,
	                                    componentClass: 'textarea',
	                                    className: 'textarea_disable-resize'
	                                })
	                            )
	                        ) : null,
	                        paymentList && showPay && !hideAll ? _react3.default.createElement(
	                            'div',
	                            null,
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'row', style: { paddingLeft: '10px' } },
	                                _react3.default.createElement('div', { className: 'col-xs-12 col-sm-6' }),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-3 col-xs-12 text-right' },
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'buttons-holder' },
	                                        _react3.default.createElement(
	                                            'button',
	                                            { onClick: this.editOrder, className: 'le-button' },
	                                            lang['store.common.editOrder.button.editOrder']
	                                        )
	                                    )
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-12 col-sm-3 text-center' },
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'buttons-holder' },
	                                        _react3.default.createElement(
	                                            'button',
	                                            { onClick: this.cancelOrder, className: 'le-button' },
	                                            lang['store.common.cancelOrder.button.cancelOrder']
	                                        )
	                                    )
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'row', style: { paddingLeft: '10px' } },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-12 col-sm-8' },
	                                    paymentList
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-sm-4 col-xs-12 text-center' },
	                                    this.renderButtonAndStatusPay()
	                                )
	                            )
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	    return OrderItemsDetail;
	}(_react2.Component), _class.propTypes = {
	    isOrderWasPaid: _react2.PropTypes.bool.isRequired,
	    onPay: _react2.PropTypes.func.isRequired,
	    paymentList: _react2.PropTypes.any,
	    hidePayButton: _react2.PropTypes.bool,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object,
	    setting: _react2.PropTypes.object.isRequired,
	    delivery_address: _react2.PropTypes.string.isRequired,
	    addresses: _react2.PropTypes.array.isRequired,
	    client_comment: _react2.PropTypes.string.isRequired,
	    onDeliveryAddressChange: _react2.PropTypes.func.isRequired,
	    onDeliveryAddressSave: _react2.PropTypes.func.isRequired,
	    onClientCommentChange: _react2.PropTypes.func.isRequired,
	    onAddAddress: _react2.PropTypes.func.isRequired,
	    isRevert: _react2.PropTypes.bool.isRequired
	}, _class.defaultProps = {
	    hidePayButton: false
	}, _temp));
	
	exports.default = OrderItemsDetail;
	module.exports = exports['default'];

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactRouter = __webpack_require__(19);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _SHARE = __webpack_require__(93);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1090);
	
	var _windowOrGlobal = __webpack_require__(264);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    OrderItemsView: {
	        displayName: 'OrderItemsView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Order/default/OrderItemsView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var OrderItemsView = _wrapComponent('OrderItemsView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(OrderItemsView, _Component);
	
	    function OrderItemsView(props) {
	        var _this2 = this;
	
	        (0, _classCallCheck3.default)(this, OrderItemsView);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (OrderItemsView.__proto__ || (0, _getPrototypeOf2.default)(OrderItemsView)).call(this, props));
	
	        _this.onPay = function (event) {
	            event.preventDefault();
	            _this.props.onPay(_this.props.comment, _this.props.deliveryAddress);
	        };
	
	        _this.renderTitleProduct = function (_ref) {
	            var product = _ref.product,
	                is_coupon = _ref.is_coupon;
	
	            var offer = product.offer;
	            return _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-4' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'title prod_desc hidden-xs' },
	                    _react3.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/product/' + offer.id },
	                        offer.name
	                    ),
	                    _react3.default.createElement(_SHARE.SwitherDescription, { description: offer.description }),
	                    product.custom_fields ? product.custom_fields.map(function (item, i) {
	                        return _react3.default.createElement(
	                            'label',
	                            null,
	                            item.name,
	                            ': ',
	                            item.value
	                        );
	                    }) : null
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'title visible-xs', style: { padding: '0' } },
	                    _react3.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/product/' + offer.id },
	                        offer.name
	                    ),
	                    _react3.default.createElement(_SHARE.SwitherDescription, { description: offer.description }),
	                    product.custom_fields ? product.custom_fields.map(function (item, i) {
	                        return _react3.default.createElement(
	                            'label',
	                            null,
	                            item.name,
	                            ': ',
	                            item.value
	                        );
	                    }) : null
	                )
	            );
	        };
	
	        _this.renderTitleModifierOptionName = function (_ref2) {
	            var offer = _ref2.offer;
	
	            if (offer.modifier_option_name !== null && offer.modifier_option_name !== '') {
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title prod_desc hidden-xs' },
	                        offer.modifier_option_name
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title prod_desc visible-xs', style: { padding: '0' } },
	                        offer.modifier_option_name
	                    )
	                );
	            } else if (offer.modifier_option_id !== null) {
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title prod_desc hidden-xs' },
	                        offer.modifiedOption.name
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title prod_desc visible-xs', style: { padding: '0' } },
	                        offer.modifiedOption.name
	                    )
	                );
	            } else {
	                return _react3.default.createElement('div', { className: 'col-xs-12 col-sm-2' });
	            }
	        };
	
	        _this.renderQuantity = function (_ref3) {
	            var quantity = _ref3.quantity;
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-3' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'quantity cart_quantity hidden-xs' },
	                    _react3.default.createElement(
	                        'span',
	                        null,
	                        quantity
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'quantity cart_quantity visible-xs', style: { padding: '0' } },
	                    _react3.default.createElement(
	                        'span',
	                        { className: 'visible-xs' },
	                        _this.props.lang['store.common.quantity'],
	                        ': ',
	                        quantity
	                    )
	                )
	            );
	        };
	
	        _this.renderSum = function (_ref4) {
	            var sum = _ref4.sum;
	            var currency = _this.props.currency;
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-2' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'price cart_price hidden-xs' },
	                    _react3.default.createElement(
	                        'span',
	                        { className: 'visible-xs' },
	                        _this.props.lang['store.common.price'],
	                        ': '
	                    ),
	                    _react3.default.createElement(_components2.MoneyValue, {
	                        value: sum,
	                        icon: currency.icon,
	                        iconAfterValue: currency.icon_after_value
	                    })
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'price cart_price visible-xs', style: { padding: '0' } },
	                    _react3.default.createElement(
	                        'span',
	                        { className: 'visible-xs' },
	                        _this.props.lang['store.common.price'],
	                        ': '
	                    ),
	                    _react3.default.createElement(_components2.MoneyValue, {
	                        value: sum,
	                        icon: currency.icon,
	                        iconAfterValue: currency.icon_after_value
	                    })
	                )
	            );
	        };
	
	        _this.renderImage = function (_ref5) {
	            var _ref5$pictures = _ref5.pictures,
	                pictures = _ref5$pictures === undefined ? [] : _ref5$pictures;
	
	
	            var image = pictures[0];
	
	            if (image && image.preview_url) {
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-1' },
	                    _react3.default.createElement('img', { src: image.preview_url })
	                );
	            }
	
	            return _react3.default.createElement('div', { className: 'col-xs-12 col-sm-1' });
	        };
	
	        _this.renderProduct = function (item) {
	            var price = parseFloat(item.base_price);
	            var quantity = parseInt(item.quantity, 10) || 0;
	            var weight = null;
	            var childWeight = null;
	            return _react3.default.createElement(
	                'div',
	                { key: item.id, className: 'row no-margin cart-item' },
	                _react3.default.createElement(_this2.renderImage, { pictures: item.offer.pictures }),
	                _react3.default.createElement(_this2.renderTitleProduct, { product: item, is_coupon: item.is_coupon || item.isCoupon }),
	                _react3.default.createElement(_this2.renderTitleModifierOptionName, { offer: item }),
	                _react3.default.createElement(_this2.renderQuantity, { quantity: quantity }),
	                _react3.default.createElement(_this2.renderSum, { sum: price * quantity }),
	                item.type_id === 5 ? item.childProducts.map(function (childItem) {
	                    return _this.renderNested(childItem, quantity);
	                }) : null
	            );
	        };
	
	        _this.renderNested = function (childItem, quantity) {
	            var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	            if (childItem.quantity == 0) {
	                return null;
	            }
	            var weight = childItem.quantity / quantity;
	            childItem.weight_offer = childItem.weight_offer * 1;
	            if ((childItem.unit.slug === 'kg' || childItem.unit.slug === 'mg') && childItem.weight_offer && childItem.weight_offer > 0 && childItem.quantity > 0) {
	                weight = childItem.weight_offer * childItem.quantity / quantity;
	                weight = weight.toFixed(3);
	                if (childItem.weight_offer < 0.01 && childItem.quantity < 1 || childItem.weight_offer < 1 && childItem.quantity < 0.01) {
	                    weight = item.weight_offer * 1;
	                }
	                if (childItem.weight_offer < 0.1 && childItem.quantity < 0.1) {
	                    weight = childItem.weight_offer * 1;
	                }
	            }
	            var paddingLeft = level * 30 + 'px';
	            return _react3.default.createElement(
	                'div',
	                { className: 'row no-margin', style: { clear: 'both' } },
	                _react3.default.createElement('div', { className: 'col-xs-12 col-sm-1' }),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-4 visible-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title', style: { paddingLeft: paddingLeft } },
	                        '- ',
	                        childItem.name,
	                        ' ',
	                        childItem.modifier_option_name
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { style: { paddingLeft: paddingLeft } },
	                        _react3.default.createElement(
	                            'span',
	                            null,
	                            _this.props.lang['store.common.quantity'],
	                            ': '
	                        ),
	                        childItem.type_id === 5 ? _react3.default.createElement(
	                            'span',
	                            null,
	                            childItem.quantity / quantity
	                        ) : _react3.default.createElement(
	                            'span',
	                            null,
	                            weight,
	                            ' ',
	                            _this.props.lang[childItem.unit.title_lang_data]
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-4 hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title', style: { paddingLeft: paddingLeft } },
	                        '- ',
	                        childItem.name
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2 hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        childItem.modifier_option_name
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-3 hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { style: { textAlign: 'center' } },
	                        _react3.default.createElement(
	                            'span',
	                            { className: 'visible-xs' },
	                            _this.props.lang['store.common.quantity'],
	                            ': '
	                        ),
	                        childItem.type_id === 5 ? _react3.default.createElement(
	                            'span',
	                            null,
	                            childItem.quantity / quantity
	                        ) : _react3.default.createElement(
	                            'span',
	                            null,
	                            weight,
	                            ' ',
	                            _this.props.lang[childItem.unit.title_lang_data]
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2' },
	                    _react3.default.createElement('div', { className: 'price cart_price' })
	                ),
	                childItem.type_id === 5 ? childItem.childProducts.map(function (childChildItem) {
	                    return _this.renderNested(childChildItem, quantity, level + 1);
	                }) : null
	            );
	        };
	
	        _this.renderMergedOrder = function () {
	            var _this$props = _this.props,
	                url = _this$props.url,
	                sum = _this$props.sum,
	                _this$props$before = _this$props.before,
	                before = _this$props$before === undefined ? null : _this$props$before,
	                _this$props$after = _this$props.after,
	                after = _this$props$after === undefined ? null : _this$props$after,
	                _this$props$showPay = _this$props.showPay,
	                showPay = _this$props$showPay === undefined ? false : _this$props$showPay,
	                token = _this$props.token,
	                _this$props$paymentLi = _this$props.paymentList,
	                paymentList = _this$props$paymentLi === undefined ? null : _this$props$paymentLi,
	                _this$props$hideAll = _this$props.hideAll,
	                hideAll = _this$props$hideAll === undefined ? false : _this$props$hideAll,
	                lang = _this$props.lang,
	                setting = _this$props.setting,
	                delivery_address = _this$props.delivery_address,
	                userAddresses = _this$props.userAddresses,
	                addresses = _this$props.addresses,
	                client_comment = _this$props.client_comment,
	                onDeliveryAddressChange = _this$props.onDeliveryAddressChange,
	                onDeliveryAddressSave = _this$props.onDeliveryAddressSave,
	                onClientCommentChange = _this$props.onClientCommentChange,
	                onAddAddress = _this$props.onAddAddress,
	                isOrderWasPaid = _this$props.isOrderWasPaid,
	                isRevert = _this$props.isRevert,
	                currency = _this$props.currency,
	                order_type_id = _this$props.order_type_id,
	                childOrders = _this$props.childOrders,
	                onChangeInput = _this$props.onChangeInput,
	                addressOptions = _this$props.addressOptions,
	                comment = _this$props.comment,
	                deliveryAddress = _this$props.deliveryAddress,
	                childOrdersAdditional = _this$props.childOrdersAdditional;
	
	
	            var commentFieldPlaceholderDefaultValue = lang['store.order_items.comment_field_placeholder'];
	            var commentFieldTitleDefaultValue = lang['store.order_items.comment_field_title'];
	            var _setting$commentField = setting.commentFieldPlaceholder,
	                commentFieldPlaceholder = _setting$commentField === undefined ? commentFieldPlaceholderDefaultValue : _setting$commentField,
	                commentFieldShow = setting.commentFieldShow,
	                deliveryFieldShow = setting.deliveryFieldShow,
	                _setting$commentField2 = setting.commentFieldTitle,
	                commentFieldTitle = _setting$commentField2 === undefined ? commentFieldTitleDefaultValue : _setting$commentField2;
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin summ_row' },
	                    _react3.default.createElement(
	                        'h4',
	                        null,
	                        lang['store.postpone.combinesOrders'],
	                        ':'
	                    ),
	                    childOrders.map(function (childOrder) {
	                        return _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin cart-item' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-4 text-center' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.ControlLabel,
	                                    null,
	                                    lang['store.postpone.postpone.orderNumber'],
	                                    _react3.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/personal/order/' + childOrder.id },
	                                        childOrder.order_number
	                                    )
	                                ),
	                                _react3.default.createElement(
	                                    _reactBootstrap.ControlLabel,
	                                    null,
	                                    lang['store.common.sum'] + ': ',
	                                    _react3.default.createElement(_components2.MoneyValue, {
	                                        value: childOrder.sum,
	                                        icon: currency.icon,
	                                        iconAfterValue: currency.icon_after_value
	                                    })
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-sm-8 text-center' },
	                                deliveryFieldShow ? _react3.default.createElement(_components2.AddressInput
	                                // id={childOrder.id}
	                                , { placeholder: lang['store.common.delivery_address_placeholder'],
	                                    value: childOrdersAdditional[childOrder.id].deliveryAddress,
	                                    options: addressOptions,
	                                    label: lang['store.common.delivery_address'],
	                                    buttonText: lang['store.common.select_on_map'],
	                                    onAddressChange: childOrdersAdditional[childOrder.id].onAddressChangeChildOrder,
	                                    onAddAddress: onAddAddress
	                                }) : null,
	                                commentFieldShow ? _react3.default.createElement(
	                                    _reactBootstrap.FormGroup,
	                                    { className: 'col-xs-12 col-sm-12' },
	                                    _react3.default.createElement(
	                                        _reactBootstrap.ControlLabel,
	                                        null,
	                                        commentFieldTitle
	                                    ),
	                                    _react3.default.createElement(_reactBootstrap.FormControl
	                                    // id_ert={childOrder.id}
	                                    , { value: childOrdersAdditional[childOrder.id].comment,
	                                        type: 'text',
	                                        placeholder: commentFieldPlaceholder,
	                                        onChange: childOrdersAdditional[childOrder.id].onCommentChangeChildOrder,
	                                        componentClass: 'textarea',
	                                        className: 'textarea_disable-resize'
	                                    })
	                                ) : null
	                            )
	                        );
	                    })
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin summ_row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'total_price items-holder' },
	                            _react3.default.createElement(_components2.MoneyValue, {
	                                value: parseFloat(sum),
	                                icon: currency.icon,
	                                iconAfterValue: currency.icon_after_value,
	                                prefix: lang['store.cart.total'] + ': '
	                            })
	                        )
	                    )
	                )
	            );
	        };
	
	        _this.showCaptcha = function () {
	            if (_this.props.showCaptcha) {
	                return _react3.default.createElement(
	                    _reactBootstrap.FormGroup,
	                    null,
	                    _this.props.showCaptcha()
	                );
	            }
	
	            return '';
	        };
	
	        _this.renderCaptcha = function () {
	            return _react3.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _this.props.renderCaptcha()
	            );
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(OrderItemsView, [{
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var AccountsList = this.props.user.amount[0];
	            var coupons = this.props.user.coupons;
	            var _props = this.props,
	                comment = _props.comment,
	                deliveryAddress = _props.deliveryAddress,
	                url = _props.url,
	                _props$products = _props.products,
	                products = _props$products === undefined ? [] : _props$products,
	                sum = _props.sum,
	                _props$before = _props.before,
	                before = _props$before === undefined ? null : _props$before,
	                _props$after = _props.after,
	                after = _props$after === undefined ? null : _props$after,
	                _props$paymentList = _props.paymentList,
	                paymentList = _props$paymentList === undefined ? null : _props$paymentList,
	                _props$disabled = _props.disabled,
	                disabled = _props$disabled === undefined ? true : _props$disabled,
	                bonusValue = _props.bonusValue,
	                setting = _props.setting,
	                lang = _props.lang,
	                currency = _props.currency,
	                onDeliveryAddressChange = _props.onDeliveryAddressChange,
	                onAddAddress = _props.onAddAddress,
	                onChangeInput = _props.onChangeInput,
	                addressOptions = _props.addressOptions,
	                sumDiscount = _props.sumDiscount,
	                customFields = _props.customFields,
	                changeCustomFields = _props.changeCustomFields,
	                order_type_id = _props.order_type_id;
	
	
	            var commentFieldPlaceholderDefaultValue = lang['store.order_items.comment_field_placeholder'];
	            var commentFieldTitleDefaultValue = lang['store.order_items.comment_field_title'];
	
	            var _setting$commentField3 = setting.commentFieldPlaceholder,
	                commentFieldPlaceholder = _setting$commentField3 === undefined ? commentFieldPlaceholderDefaultValue : _setting$commentField3,
	                commentFieldShow = setting.commentFieldShow,
	                deliveryFieldShow = setting.deliveryFieldShow,
	                _setting$commentField4 = setting.commentFieldTitle,
	                commentFieldTitle = _setting$commentField4 === undefined ? commentFieldTitleDefaultValue : _setting$commentField4;
	
	
	            var discountSum = (sum - sumDiscount) / 2;
	            var addAmount = 0;
	            if (sumDiscount > 0) {
	                addAmount = sumDiscount * 1;
	            }
	            if (AccountsList.amount * 1 + addAmount > 0 && AccountsList.amount * 1 + addAmount < discountSum) {
	                discountSum = AccountsList.amount * 1 + addAmount;
	            }
	            if (sum - discountSum < 1) {
	                discountSum = sum - 1;
	                if (discountSum < 0) discountSum = 0;
	            }
	            if (this.props.ibonus_data) {
	                var IBonusData = _windowOrGlobal.JSON.parse(this.props.ibonus_data);
	                if (IBonusData.discount_sum && IBonusData.discount_sum > discountSum) {
	                    discountSum = IBonusData.discount_sum * 1;
	                }
	            }
	            discountSum = Math.floor(discountSum);
	            var totalSum = sum - sumDiscount - bonusValue;
	
	            if (order_type_id === 7) {
	                return _react3.default.createElement(
	                    'section',
	                    { id: 'cart-page' },
	                    before,
	                    this.props.failError.length > 0 ? _react3.default.createElement(
	                        'div',
	                        { className: 'row no-margin' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'small-12 columns' },
	                            _react3.default.createElement(
	                                'b',
	                                null,
	                                this.props.failError
	                            )
	                        )
	                    ) : null,
	                    this.renderMergedOrder(),
	                    paymentList ? _react3.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        sum === '0.00000000' || sum === 0 ? _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-8', style: { visibility: 'hidden' } },
	                            paymentList
	                        ) : _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-8' },
	                            paymentList
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-sm-4 col-xs-12 text-center' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'buttons-holder inline_block button_width_100' },
	                                sum === '0.00000000' || sum === 0 ? _react3.default.createElement(
	                                    'button',
	                                    { onClick: this.onPay, className: 'le-button big pay_order_button button_width_100' },
	                                    lang['store.common.continue']
	                                ) : _react3.default.createElement(
	                                    'button',
	                                    { disabled: disabled, onClick: this.onPay, className: 'le-button big pay_order_button button_width_100' },
	                                    lang['store.order_items.pay']
	                                )
	                            )
	                        )
	                    ) : null,
	                    after
	                );
	            }
	
	            var sumDiscountAmount = '';
	            if (sumDiscount > 0) {
	                sumDiscountAmount = _react3.default.createElement(
	                    'div',
	                    { className: 'items-holder' },
	                    _react3.default.createElement(_components2.MoneyValue, {
	                        value: parseFloat(sumDiscount),
	                        icon: currency.icon,
	                        iconAfterValue: currency.icon_after_value,
	                        prefix: lang['store.common.discountInOrder'] + ': '
	                    })
	                );
	            }
	            var cashbackValue = '';
	            var couponsSlider = '';
	            var cashbackCoupon = '';
	            var useCoupon = false;
	            products.forEach(function (item) {
	                if (item.is_coupon === true) {
	                    useCoupon = true;
	                }
	            });
	            setting.loyaltySettingsData = this.props.user.loyaltySettings;
	            if (setting.loyaltySettingsActive && sum !== '0.00000000' && setting.loyaltySettingsData.customerSettings !== undefined && setting.loyaltySettingsData.newCustomerSettings !== undefined) {
	                if (AccountsList.notFirstOrder !== true) {
	                    if (setting.loyaltySettingsData.newCustomerSettings.coupon !== null && setting.loyaltySettingsData.newCustomerSettings.coupon !== undefined && setting.loyaltySettingsData.newCustomerSettings.coupon.deleted !== true) {
	                        cashbackCoupon = _react3.default.createElement(
	                            'div',
	                            null,
	                            lang['store.iBonus.order.afterPaymentCoupon'],
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'text-center', style: { maxWidth: '100px', border: '4px solid #008000', borderRadius: '8px', marginLeft: 'auto', marginRight: 'auto' } },
	                                setting.loyaltySettingsData.newCustomerSettings.coupon.imagePath !== null ? _react3.default.createElement(
	                                    'div',
	                                    { className: 'text-center', style: { padding: '4px' } },
	                                    _react3.default.createElement('img', { style: { maxWidth: '68px', maxHeight: '68px', marginLeft: 'auto', marginRight: 'auto' }, src: setting.loyaltySettingsData.newCustomerSettings.coupon.imagePath })
	                                ) : _react3.default.createElement('div', { style: { width: '72px', height: '72px', padding: '4px' } }),
	                                _react3.default.createElement(
	                                    'div',
	                                    null,
	                                    setting.loyaltySettingsData.newCustomerSettings.coupon.header
	                                )
	                            )
	                        );
	                    }
	                    if (setting.loyaltySettingsData.newCustomerSettings.cashBackType === 'percentage') {
	                        cashbackValue = _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin summ_row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 text-center' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'total_price' },
	                                    lang['store.iBonus.order.afterPaymentPointsFirstOrder'],
	                                    ' ',
	                                    (totalSum / 100 * setting.loyaltySettingsData.newCustomerSettings.amount).toFixed(2),
	                                    ' ',
	                                    lang['store.iBonus.order.points']
	                                ),
	                                cashbackCoupon
	                            )
	                        );
	                    } else {
	                        cashbackValue = _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin summ_row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 text-center' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'total_price' },
	                                    lang['store.iBonus.order.afterPaymentPointsFirstOrder'],
	                                    ' ',
	                                    setting.loyaltySettingsData.newCustomerSettings.amount,
	                                    ' ',
	                                    lang['store.iBonus.order.points']
	                                ),
	                                cashbackCoupon
	                            )
	                        );
	                    }
	                } else {
	                    if (setting.loyaltySettingsData.customerSettings.coupon !== null && setting.loyaltySettingsData.customerSettings.coupon !== undefined && setting.loyaltySettingsData.customerSettings.coupon.deleted !== true) {
	                        cashbackCoupon = _react3.default.createElement(
	                            'div',
	                            null,
	                            lang['store.iBonus.order.afterPaymentCoupon'],
	                            _react3.default.createElement(
	                                'div',
	                                { style: { maxWidth: '100px', border: '4px solid #008000', borderRadius: '8px', marginLeft: 'auto', marginRight: 'auto' } },
	                                setting.loyaltySettingsData.customerSettings.coupon.imagePath !== null ? _react3.default.createElement(
	                                    'div',
	                                    { className: 'text-center', style: { padding: '4px' } },
	                                    _react3.default.createElement('img', { style: { maxWidth: '68px', maxHeight: '68px', marginLeft: 'auto', marginRight: 'auto' }, src: setting.loyaltySettingsData.customerSettings.coupon.imagePath })
	                                ) : _react3.default.createElement('div', { style: { width: '72px', height: '72px', padding: '4px' } }),
	                                _react3.default.createElement(
	                                    'div',
	                                    null,
	                                    setting.loyaltySettingsData.customerSettings.coupon.header
	                                )
	                            )
	                        );
	                    }
	                    if (setting.loyaltySettingsData.customerSettings.cashBackType === 'percentage') {
	                        cashbackValue = _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin summ_row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 text-center' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'total_price' },
	                                    lang['store.iBonus.order.afterPaymentPoints'],
	                                    ' ',
	                                    (totalSum / 100 * setting.loyaltySettingsData.customerSettings.amount).toFixed(2),
	                                    ' ',
	                                    lang['store.iBonus.order.points']
	                                ),
	                                cashbackCoupon
	                            )
	                        );
	                    } else {
	                        cashbackValue = _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin summ_row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 text-center' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'total_price' },
	                                    lang['store.iBonus.order.afterPaymentPoints'],
	                                    ' ',
	                                    setting.loyaltySettingsData.customerSettings.amount,
	                                    ' ',
	                                    lang['store.iBonus.order.points']
	                                ),
	                                cashbackCoupon
	                            )
	                        );
	                    }
	                }
	                if (coupons.length > 0) {
	                    var couponStyleSelect = '';
	                    couponsSlider = _react3.default.createElement(
	                        'div',
	                        { className: 'row no-margin summ_row' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'total_price' },
	                            lang['store.iBonus.order.availableCoupons']
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { style: { overflow: 'auto' } },
	                            _react3.default.createElement(
	                                'table',
	                                null,
	                                _react3.default.createElement(
	                                    'tbody',
	                                    null,
	                                    _react3.default.createElement(
	                                        'tr',
	                                        null,
	                                        coupons.map(function (item, index) {
	                                            couponStyleSelect = '4px solid #fff';
	                                            if (_this3.props.couponId === item.id) {
	                                                couponStyleSelect = '4px solid #008000';
	                                            }
	                                            if (item.imagePath !== null) {
	                                                return _react3.default.createElement(
	                                                    'td',
	                                                    { key: index, style: { padding: '8px' } },
	                                                    _react3.default.createElement(
	                                                        'div',
	                                                        { className: 'text-center',
	                                                            style: { border: couponStyleSelect, borderRadius: '8px' } },
	                                                        _react3.default.createElement(
	                                                            'a',
	                                                            { onClick: function onClick(e) {
	                                                                    _this3.props.couponSelect(item);
	                                                                } },
	                                                            _react3.default.createElement(
	                                                                'div',
	                                                                { style: {
	                                                                        maxWidth: '72px',
	                                                                        maxHeight: '72px',
	                                                                        padding: '4px'
	                                                                    } },
	                                                                _react3.default.createElement('img', { style: { maxWidth: '68px', maxHeight: '68px' },
	                                                                    src: item.imagePath })
	                                                            ),
	                                                            _react3.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                item.header
	                                                            )
	                                                        )
	                                                    )
	                                                );
	                                            } else {
	                                                return _react3.default.createElement(
	                                                    'td',
	                                                    { style: { padding: '8px' } },
	                                                    _react3.default.createElement(
	                                                        'div',
	                                                        { className: 'text-center',
	                                                            style: { border: couponStyleSelect, borderRadius: '8px' } },
	                                                        _react3.default.createElement(
	                                                            'a',
	                                                            { onClick: function onClick(e) {
	                                                                    _this3.props.couponSelect(item);
	                                                                } },
	                                                            _react3.default.createElement('div', { style: {
	                                                                    width: '72px',
	                                                                    height: '72px',
	                                                                    padding: '4px'
	                                                                } }),
	                                                            _react3.default.createElement(
	                                                                'div',
	                                                                null,
	                                                                item.header
	                                                            )
	                                                        )
	                                                    )
	                                                );
	                                            }
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    );
	                }
	            }
	            return _react3.default.createElement(
	                'section',
	                { id: 'cart-page' },
	                before,
	                this.props.failError.length > 0 ? _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'small-12 columns' },
	                        _react3.default.createElement(
	                            'b',
	                            null,
	                            this.props.failError
	                        )
	                    )
	                ) : null,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin cart-item hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-1 text-center' },
	                        lang['store.cart.photo']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-4' },
	                        lang['store.cart.title']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2' },
	                        lang['store.cart.modifiers']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-3 no-margin text-center' },
	                        lang['store.cart.quantity']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2 no-margin text-center' },
	                        lang['store.cart.price']
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'items-holder' },
	                    products.map(this.renderProduct)
	                ),
	                customFields.length > 0 ? _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin summ_row' },
	                    customFields.map(function (item, i) {
	                        return _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-12 no-margin' },
	                            item.type === 'text' ? _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { className: 'col-xs-12 col-sm-7' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.ControlLabel,
	                                    null,
	                                    item.name
	                                ),
	                                _react3.default.createElement('input', {
	                                    id: i,
	                                    value: item.value,
	                                    className: 'form-control',
	                                    type: 'text',
	                                    onChange: changeCustomFields
	                                })
	                            ) : _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { className: 'col-xs-12 col-sm-7' },
	                                _react3.default.createElement('input', { type: 'checkbox', className: 'form-check-input', id: i,
	                                    onChange: changeCustomFields,
	                                    checked: item.value }),
	                                _react3.default.createElement(
	                                    'label',
	                                    { className: 'form-check-label', htmlFor: i },
	                                    '\xA0 ',
	                                    item.name
	                                )
	                            )
	                        );
	                    })
	                ) : null,
	                couponsSlider,
	                AccountsList.amount > 0 && discountSum > 0 ? _react3.default.createElement(
	                    'div',
	                    null,
	                    _react3.default.createElement(
	                        'div',
	                        null,
	                        lang['store.iBonus.order.bonusesToUseAreAvailable'],
	                        ' ',
	                        (AccountsList.amount * 1 + addAmount).toFixed(2)
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-2' },
	                            lang['store.iBonus.order.bonusesUse']
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-6' },
	                            _react3.default.createElement('input', { type: 'range', min: 0, max: discountSum, step: 1, value: bonusValue, onChange: this.props.onChangeBonusValue })
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react3.default.createElement('div', { className: 'col-xs-12 col-sm-2' }),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-3' },
	                            '0'
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-3 text-right' },
	                            discountSum
	                        )
	                    )
	                ) : null,
	                cashbackValue,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin summ_row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'total_price items-holder' },
	                            sumDiscountAmount,
	                            _react3.default.createElement(_components2.MoneyValue, {
	                                value: parseFloat(totalSum),
	                                icon: currency.icon,
	                                iconAfterValue: currency.icon_after_value,
	                                prefix: lang['store.cart.total'] + ': '
	                            })
	                        )
	                    )
	                ),
	                deliveryFieldShow ? _react3.default.createElement(_components2.AddressInput, {
	                    placeholder: lang['store.common.delivery_address_placeholder'],
	                    value: deliveryAddress,
	                    options: addressOptions,
	                    label: lang['store.common.delivery_address'],
	                    buttonText: lang['store.common.select_on_map'],
	                    onAddressChange: onDeliveryAddressChange,
	                    onAddAddress: onAddAddress
	                }) : null,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    commentFieldShow ? _react3.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        { className: 'col-xs-12 col-sm-7' },
	                        _react3.default.createElement(
	                            _reactBootstrap.ControlLabel,
	                            null,
	                            commentFieldTitle
	                        ),
	                        _react3.default.createElement(_reactBootstrap.FormControl, {
	                            value: comment,
	                            type: 'text',
	                            placeholder: commentFieldPlaceholder,
	                            onChange: onChangeInput,
	                            componentClass: 'textarea',
	                            className: 'textarea_disable-resize'
	                        })
	                    ) : null
	                ),
	                this.showCaptcha(),
	                this.renderCaptcha(),
	                paymentList ? _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    sum === '0.00000000' || sum === 0 ? _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-8', style: { visibility: 'hidden' } },
	                        paymentList
	                    ) : _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-8' },
	                        paymentList
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-4 col-xs-12 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'buttons-holder inline_block button_width_100' },
	                            sum === '0.00000000' || sum === 0 ? _react3.default.createElement(
	                                'button',
	                                { onClick: this.onPay, className: 'le-button big pay_order_button button_width_100' },
	                                lang['store.common.continue']
	                            ) : _react3.default.createElement(
	                                'button',
	                                { disabled: disabled, onClick: this.onPay, className: 'le-button big pay_order_button button_width_100' },
	                                lang['store.order_items.pay']
	                            )
	                        )
	                    )
	                ) : null,
	                after
	            );
	        }
	    }]);
	    return OrderItemsView;
	}(_react2.Component), _class.propTypes = {
	    onPay: _react2.PropTypes.func.isRequired,
	    user: _react2.PropTypes.object,
	    paymentList: _react2.PropTypes.any,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp));
	
	exports.default = OrderItemsView;
	module.exports = exports['default'];

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.checkValidSlug = checkValidSlug;
	exports.isQiwiSlug = isQiwiSlug;
	var TERMINAL = exports.TERMINAL = 'terminals_ru';
	var QIWI_SLUG = exports.QIWI_SLUG = 'qiwi';
	var SMS_SLUG = exports.SMS_SLUG = 'sms';
	var ALFABANK_SLUG = exports.ALFABANK_SLUG = 'alfa';
	
	function checkValidSlug(slug) {
	    return isQiwiSlug(slug) || slug === SMS_SLUG || slug === ALFABANK_SLUG;
	}
	
	function isQiwiSlug(slug) {
	    return slug.indexOf(QIWI_SLUG) === 0;
	}

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by maximus on 08.11.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Paginator: {
	        displayName: 'Paginator'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Paginator/Paginator.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var limit = 9;
	var limitsArray = ['12', '24', '48', '96', 'Все'];
	
	var Paginator = _wrapComponent('Paginator')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Paginator, _Component);
	
	    function Paginator(props) {
	        (0, _classCallCheck3.default)(this, Paginator);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Paginator.__proto__ || (0, _getPrototypeOf2.default)(Paginator)).call(this, props));
	
	        _this.getPaginatorSize = function (size, limit) {
	            if (limit === 0 || size < limit) {
	                return 0;
	            } else if (size % limit === 0) {
	                return size / limit;
	            }
	            return Math.floor(size / limit) + 1;
	        };
	
	        _this.handleChangeActivePage = function (page) {
	            _this.props.handleChangePage(page, _this.props.limit);
	        };
	
	        _this.handleChangeSelect = function (value) {
	            var limit = limitsArray[value] === 'Все' ? _this.props.count : parseInt(limitsArray[value]);
	            _this.props.handleChangePage(1, limit);
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(Paginator, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                activePage = _props.activePage,
	                count = _props.count,
	                limit = _props.limit,
	                lang = _props.lang;
	
	            var arrayOfLimits = this.props.limitsArray || limitsArray;
	            var pages = this.getPaginatorSize(count, limit);
	            var pageLimit = limit === count ? 'Все' : limit;
	            //limit === count && ( limit = 'Все');
	
	            var View = _helpers.ThemeHelper.getViewForComponent('Paginator');
	
	            return _react3.default.createElement(View, {
	                activePage: activePage,
	                pages: pages,
	                limitsArray: arrayOfLimits,
	                limit: pageLimit,
	                count: count,
	                handleChangeActivePage: this.handleChangeActivePage,
	                handleChangeSelect: this.handleChangeSelect,
	                lang: lang
	            });
	        }
	    }]);
	    return Paginator;
	}(_react2.Component), _class2.propTypes = {
	    activePage: _react2.PropTypes.any,
	    count: _react2.PropTypes.any,
	    limit: _react2.PropTypes.any,
	    lang: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Paginator;
	;
	module.exports = exports['default'];

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by maximus on 08.11.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1091);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Paginator: {
	        displayName: 'Paginator'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Paginator/default/PaginatorView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Paginator = _wrapComponent('Paginator')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(Paginator, _Component);
	
	    function Paginator(props) {
	        (0, _classCallCheck3.default)(this, Paginator);
	        return (0, _possibleConstructorReturn3.default)(this, (Paginator.__proto__ || (0, _getPrototypeOf2.default)(Paginator)).call(this, props));
	    }
	
	    (0, _createClass3.default)(Paginator, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                activePage = _props.activePage,
	                count = _props.count,
	                pages = _props.pages,
	                limitsArray = _props.limitsArray,
	                limit = _props.limit,
	                lang = _props.lang;
	
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'pagination-holder' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'my_pagination row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12  col-sm-6' },
	                        pages > 1 ? _react3.default.createElement(_reactBootstrap.Pagination, {
	                            activePage: activePage,
	                            boundaryLinks: true,
	                            items: pages,
	                            maxButtons: 3,
	                            onSelect: this.props.handleChangeActivePage
	                        }) : null
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12  col-sm-6  text-right' },
	                        count < limit && count < limitsArray[0] ? null : _react3.default.createElement(
	                            'div',
	                            { className: 'drop_down_limit' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'drop_down_limit_label' },
	                                lang['store.paginator.quantity'],
	                                ':'
	                            ),
	                            _react3.default.createElement(_components2.DropdownSelect, {
	                                onChange: this.props.handleChangeSelect,
	                                title: limit,
	                                selected: limitsArray.indexOf(limit + ''),
	                                items: limitsArray
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Paginator;
	}(_react2.Component), _class.propTypes = {
	    activePage: _react2.PropTypes.any,
	    handleChangeActivePage: _react2.PropTypes.func.isRequired,
	    handleChangeSelect: _react2.PropTypes.func.isRequired,
	    limit: _react2.PropTypes.any,
	    limitsArray: _react2.PropTypes.any,
	    pages: _react2.PropTypes.number,
	    lang: _react2.PropTypes.object
	}, _temp));
	
	exports.default = Paginator;
	;
	module.exports = exports['default'];

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Paginator = undefined;
	
	var _Paginator2 = __webpack_require__(1716);
	
	var _Paginator3 = _interopRequireDefault(_Paginator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Paginator = _Paginator3.default; /**
	                                          * Created by maximus on 08.11.16.
	                                          */

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _modal = __webpack_require__(26);
	
	var _auth = __webpack_require__(53);
	
	var _modal_type = __webpack_require__(42);
	
	var _pass_recovery = __webpack_require__(164);
	
	var _constants = __webpack_require__(18);
	
	var _PassRecovery = __webpack_require__(753);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PassRecovery: {
	        displayName: 'PassRecovery'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/PassRecovery/PassRecovery.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var PassRecovery = _wrapComponent('PassRecovery')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        user: state.auth.user,
	        step: state.passRecovery.step,
	        preload: state.auth.preload,
	        login: state.passRecovery.phone,
	        lang: state.lang
	    };
	}, {
	    hide: _modal.hide,
	    load: _auth.load,
	    resetStep: _pass_recovery.resetStep,
	    sendCode: _pass_recovery.sendCode,
	    showModalRegistration: _modal_type.showModalRegistration
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(PassRecovery, _Component);
	
	    function PassRecovery(props) {
	        (0, _classCallCheck3.default)(this, PassRecovery);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PassRecovery.__proto__ || (0, _getPrototypeOf2.default)(PassRecovery)).call(this, props));
	
	        _this.changeFieldLogin = function (login) {
	            _this.setState({ 'login': login });
	        };
	
	        _this.changeFieldPassword = function (password) {
	            _this.setState({ 'password': password });
	        };
	
	        _this.changeFieldCode = function (code) {
	            _this.setState({ 'code': code });
	        };
	
	        _this.renderComponent = function () {
	            switch (_this.props.step) {
	                case _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_2:
	                    return _react3.default.createElement(_PassRecovery.PassRecoveryStepTwo, {
	                        login: _this.state.login,
	                        password: _this.state.password,
	                        code: _this.state.code,
	                        changeFieldCode: _this.changeFieldCode,
	                        changeFieldPassword: _this.changeFieldPassword
	                    });
	
	                case _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_3:
	                    return _react3.default.createElement(_components2.Preloader, { preload: true });
	
	                case _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_1:
	                default:
	                    return _react3.default.createElement(_PassRecovery.PassRecoveryStepOne, {
	                        login: _this.state.login,
	                        changeFieldLogin: _this.changeFieldLogin
	                    });
	            }
	        };
	
	        _this.state = {
	            login: props.login,
	            password: '',
	            code: ''
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(PassRecovery, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if (nextProps.step === _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_3) {
	                this.setState({
	                    password: '',
	                    login: '',
	                    code: ''
	                });
	
	                this.props.load();
	                if (!!nextProps.user) {
	                    this.props.hide();
	                    setTimeout(function () {
	                        _reactSAlert2.default.success(_this2.props.lang['store.password_recovery.success'], { position: 'top-right', effect: 'slide', timeout: 5000 });
	                    }, 1000);
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.resetStep();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react3.default.createElement(
	                'div',
	                null,
	                this.renderComponent()
	            );
	        }
	    }]);
	    return PassRecovery;
	}(_react2.Component), _class2.propTypes = {
	    hide: _react2.PropTypes.func.isRequired,
	    load: _react2.PropTypes.func.isRequired,
	    resetStep: _react2.PropTypes.func.isRequired,
	    sendCode: _react2.PropTypes.func.isRequired,
	    showModalRegistration: _react2.PropTypes.func.isRequired,
	    lang: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = PassRecovery;
	module.exports = exports['default'];

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _modal = __webpack_require__(26);
	
	var _pass_recovery = __webpack_require__(164);
	
	var _modal_type = __webpack_require__(42);
	
	var _BaseForm2 = __webpack_require__(66);
	
	var _BaseForm3 = _interopRequireDefault(_BaseForm2);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PassRecoveryStepOne = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        preload: state.auth.preload,
	        passRecoveryError: state.passRecovery.error,
	        shopId: state.setting.shopId,
	        passRecoveryErrorCode: state.passRecovery.errorCode,
	        lang: state.lang
	    };
	}, {
	    hide: _modal.hide,
	    sendCode: _pass_recovery.sendCode,
	    showModalRegistration: _modal_type.showModalRegistration
	}), _dec(_class = (_temp = _class2 = function (_BaseForm) {
	    (0, _inherits3.default)(PassRecoveryStepOne, _BaseForm);
	
	    function PassRecoveryStepOne(props) {
	        (0, _classCallCheck3.default)(this, PassRecoveryStepOne);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PassRecoveryStepOne.__proto__ || (0, _getPrototypeOf2.default)(PassRecoveryStepOne)).call(this));
	
	        _this.onClickRegistration = function (event) {
	            _this.props.showModalRegistration(_this.props.lang);
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(PassRecoveryStepOne, [{
	        key: 'onSubmit',
	        value: function onSubmit(event) {
	            event.preventDefault();
	            this.props.sendCode(this.props.login, this.props.shopId);
	        }
	    }, {
	        key: 'isValid',
	        value: function isValid() {
	            return this.props.login.length > 1;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('PassRecoveryStepOne', null, { folderName: 'PassRecovery/PassRecoveryStepOne' });
	
	            return _react2.default.createElement(View, {
	                changeFieldLogin: this.props.changeFieldLogin,
	                disabledSubmit: !this.isValid(),
	                onClickRegistration: this.onClickRegistration,
	                onSubmit: this.onSubmit,
	                login: this.props.login,
	                preload: this.props.preload,
	                error: this.props.passRecoveryError,
	                errorCode: this.props.passRecoveryErrorCode,
	                lang: this.props.lang
	            });
	        }
	    }]);
	    return PassRecoveryStepOne;
	}(_BaseForm3.default), _class2.propTypes = {
	    changeFieldLogin: _react.PropTypes.func,
	    hide: _react.PropTypes.func.isRequired,
	    login: _react.PropTypes.string.isRequired,
	    sendCode: _react.PropTypes.func.isRequired,
	    showModalRegistration: _react.PropTypes.func.isRequired,
	    lang: _react.PropTypes.object
	}, _class2.defaultProps = {
	    changeFieldLogin: function changeFieldLogin() {}
	}, _temp)) || _class);
	exports.default = PassRecoveryStepOne;
	module.exports = exports['default'];

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactRouter = __webpack_require__(19);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PassRecoveryStepOneView: {
	        displayName: 'PassRecoveryStepOneView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/PassRecovery/PassRecoveryStepOne/default/PassRecoveryStepOneView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var PassRecoveryStepOneView = _wrapComponent('PassRecoveryStepOneView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(PassRecoveryStepOneView, _Component);
	
	    function PassRecoveryStepOneView(props) {
	        (0, _classCallCheck3.default)(this, PassRecoveryStepOneView);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PassRecoveryStepOneView.__proto__ || (0, _getPrototypeOf2.default)(PassRecoveryStepOneView)).call(this, props));
	
	        _this.onClickRegistration = function (event) {
	            event.preventDefault();
	            if (_this.props.onClickRegistration) {
	                _this.props.onClickRegistration(event);
	            }
	        };
	
	        _this.handlePhoneChange = function (phone, country) {
	            _this.props.changeFieldLogin(phone);
	        };
	
	        _this.showError = function () {
	            var _this$props = _this.props,
	                error = _this$props.error,
	                errorCode = _this$props.errorCode,
	                lang = _this$props.lang;
	
	            if (error) {
	                if (errorCode === null || errorCode === undefined) {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang['store.common.server_is_unavailable']
	                    );
	                } else {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang[error]
	                    );
	                }
	            }
	
	            return '';
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(PassRecoveryStepOneView, [{
	        key: 'render',
	        value: function render() {
	            var lang = this.props.lang;
	
	
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload },
	                this.showError(),
	                _react3.default.createElement(
	                    'main',
	                    { id: 'authentication' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'container__' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react3.default.createElement(
	                                    'section',
	                                    { id: 'auth-form', className: 'sign-in' },
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'bordered' },
	                                        _react3.default.createElement(
	                                            'form',
	                                            { role: 'form', className: 'login-form', onSubmit: this.props.onSubmit },
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                { controlId: 'formLogin' },
	                                                _react3.default.createElement(
	                                                    _reactBootstrap.ControlLabel,
	                                                    null,
	                                                    lang['store.login.phone_or_email']
	                                                ),
	                                                _react3.default.createElement(_components2.PhoneEmailInput, {
	                                                    autoComplete: 'username',
	                                                    value: this.props.login,
	                                                    initialValue: '',
	                                                    defaultCountry: '',
	                                                    flagsImagePath: '/assets/images/flags.png',
	                                                    onChange: this.handlePhoneChange,
	                                                    classNames: 'super_telephone_input',
	                                                    placeholder: lang['store.login.email_or_phone_placeholder']
	                                                })
	                                            ),
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                null,
	                                                _react3.default.createElement(
	                                                    _reactBootstrap.Button,
	                                                    {
	                                                        type: 'submit',
	                                                        bsStyle: 'primary',
	                                                        className: 'form-control',
	                                                        disabled: this.props.disabledSubmit
	                                                    },
	                                                    lang['store.password_recovery.send_code']
	                                                )
	                                            ),
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                null,
	                                                _react3.default.createElement(
	                                                    'div',
	                                                    { className: 'text-center to-page-registration' },
	                                                    _react3.default.createElement(
	                                                        _reactRouter.Link,
	                                                        { to: '/registration', onClick: this.onClickRegistration },
	                                                        lang['store.common.sign_up']
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return PassRecoveryStepOneView;
	}(_react2.Component), _class.propTypes = {
	    onSend: _react2.PropTypes.func,
	    lang: _react2.PropTypes.object
	}, _class.contextTypes = {}, _temp));
	
	exports.default = PassRecoveryStepOneView;
	module.exports = exports['default'];

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PassRecoveryStepOne = undefined;
	
	var _PassRecoveryStepOne2 = __webpack_require__(1720);
	
	var _PassRecoveryStepOne3 = _interopRequireDefault(_PassRecoveryStepOne2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.PassRecoveryStepOne = _PassRecoveryStepOne3.default;

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _modal_type = __webpack_require__(42);
	
	var _auth = __webpack_require__(53);
	
	var _modal = __webpack_require__(26);
	
	var _BaseForm2 = __webpack_require__(66);
	
	var _BaseForm3 = _interopRequireDefault(_BaseForm2);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PassRecoveryStepThree = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        preload: state.auth.preload,
	        lang: state.lang
	    };
	}, { showModalAuth: _modal_type.showModalAuth, load: _auth.load, hide: _modal.hide }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
	    (0, _inherits3.default)(PassRecoveryStepThree, _BaseForm);
	    (0, _createClass3.default)(PassRecoveryStepThree, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.load();
	        }
	    }]);
	
	    function PassRecoveryStepThree(props) {
	        (0, _classCallCheck3.default)(this, PassRecoveryStepThree);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PassRecoveryStepThree.__proto__ || (0, _getPrototypeOf2.default)(PassRecoveryStepThree)).call(this, props));
	
	        _this.onShowAuth = function () {
	            _this.props.showModalAuth(_this.props.lang);
	        };
	
	        _this.hideModal = function (e) {
	            e.preventDefault();
	            _this.props.hide();
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(PassRecoveryStepThree, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('PassRecoveryStepThree', null, { folderName: "PassRecovery/PassRecoveryStepThree" });
	
	            return _react2.default.createElement(View, {
	                handleClick: this.hideModal,
	                lang: this.props.lang
	            });
	        }
	    }]);
	    return PassRecoveryStepThree;
	}(_BaseForm3.default), _class2.propTypes = {
	    lang: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = PassRecoveryStepThree;
	module.exports = exports['default'];

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactRouter = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PassRecoveryStepThreeView: {
	        displayName: 'PassRecoveryStepThreeView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/PassRecovery/PassRecoveryStepThree/default/PassRecoveryStepThreeView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var PassRecoveryStepThreeView = _wrapComponent('PassRecoveryStepThreeView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(PassRecoveryStepThreeView, _Component);
	
	    function PassRecoveryStepThreeView(props) {
	        (0, _classCallCheck3.default)(this, PassRecoveryStepThreeView);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PassRecoveryStepThreeView.__proto__ || (0, _getPrototypeOf2.default)(PassRecoveryStepThreeView)).call(this, props));
	
	        _this.onShowAuth = function (event) {
	            event.preventDefault();
	            _this.props.onShowAuth(event);
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(PassRecoveryStepThreeView, [{
	        key: 'render',
	        value: function render() {
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'text-center' },
	                _react3.default.createElement(
	                    'p',
	                    null,
	                    this.props.lang['store.password_recovery.success'],
	                    '!'
	                ),
	                _react3.default.createElement(
	                    'a',
	                    { href: '#', onClick: this.props.handleClick },
	                    '\u0412\u043E\u0439\u0442\u0438'
	                )
	            );
	        }
	    }]);
	    return PassRecoveryStepThreeView;
	}(_react2.Component), _class.propTypes = {
	    lang: _react2.PropTypes.object
	}, _temp));
	
	exports.default = PassRecoveryStepThreeView;
	module.exports = exports['default'];

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PassRecoveryStepThree = undefined;
	
	var _PassRecoveryStepThree2 = __webpack_require__(1723);
	
	var _PassRecoveryStepThree3 = _interopRequireDefault(_PassRecoveryStepThree2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.PassRecoveryStepThree = _PassRecoveryStepThree3.default;

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(102);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _modal = __webpack_require__(26);
	
	var _pass_recovery = __webpack_require__(164);
	
	var _voice_code = __webpack_require__(141);
	
	var _BaseForm2 = __webpack_require__(66);
	
	var _BaseForm3 = _interopRequireDefault(_BaseForm2);
	
	var _helpers = __webpack_require__(15);
	
	var _Validators = __webpack_require__(1729);
	
	var Validators = _interopRequireWildcard(_Validators);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PassRecoveryStepTwo = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        preload: state.passRecovery.preload,
	        error: state.passRecovery.error,
	        errorCode: state.passRecovery.errorCode,
	        lang: state.lang
	    };
	}, { hide: _modal.hide, confirmPassRecovery: _pass_recovery.confirmPassRecovery, resetVoiceCode: _voice_code.resetVoiceCode, showError: _pass_recovery.showError }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
	    (0, _inherits3.default)(PassRecoveryStepTwo, _BaseForm);
	
	    function PassRecoveryStepTwo(props, context) {
	        (0, _classCallCheck3.default)(this, PassRecoveryStepTwo);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PassRecoveryStepTwo.__proto__ || (0, _getPrototypeOf2.default)(PassRecoveryStepTwo)).call(this, props, context));
	
	        _this.changeFieldCode = function (event) {
	            event.preventDefault();
	            _this.props.changeFieldCode(event.target.value);
	        };
	
	        _this.changeFieldPassword = function (event) {
	            event.preventDefault();
	            _this.props.changeFieldPassword(event.target.value);
	        };
	
	        _this.isMinValid = function () {
	            return _this.props.password.length > 0 && _this.props.code.length > 0;
	        };
	
	        _this.showOuterAlert = function (alert) {
	            _this.setState({ outerAlert: alert });
	        };
	
	        _this.state = {
	            alert: null,
	            outerAlert: null,
	            error: null,
	            errorCode: null
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(PassRecoveryStepTwo, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.resetVoiceCode();
	        }
	    }, {
	        key: 'onSubmit',
	        value: function onSubmit(event) {
	            event.preventDefault();
	            (0, _get3.default)(PassRecoveryStepTwo.prototype.__proto__ || (0, _getPrototypeOf2.default)(PassRecoveryStepTwo.prototype), 'onSubmit', this).call(this, event);
	
	            if (this.isValid()) {
	                //this.setState({error: '', errorCode: null});
	                this.props.resetVoiceCode();
	                this.props.confirmPassRecovery(this.props.login, this.props.password, this.props.code);
	            }
	        }
	    }, {
	        key: 'isValid',
	        value: function isValid() {
	            var errorMessage = this.props.lang['store.password_recovery.pass_length_error'];
	            if (!Validators.minLength(this.props.password, 6)) {
	                //this.setState({error: errorMessage, errorCode: 400});
	                this.props.showError({ message: errorMessage, code: 400 });
	                return false;
	            }
	
	            return true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('PassRecoveryStepTwo', null, { folderName: "PassRecovery/PassRecoveryStepTwo" });
	
	            return _react2.default.createElement(View, {
	                changeFieldCode: this.changeFieldCode,
	                changeFieldPassword: this.changeFieldPassword,
	                disabledSubmit: !this.isMinValid(),
	                onSubmit: this.onSubmit,
	                code: this.props.code,
	                password: this.props.password,
	                preload: this.props.preload,
	                alert: this.state.alert,
	                error: this.state.error || this.props.error || '',
	                login: this.props.login,
	                showOuterAlert: this.showOuterAlert,
	                outerAlert: this.state.outerAlert,
	                errorCode: this.state.errorCode || this.props.errorCode,
	                isEmail: /@/.test(this.props.login),
	                lang: this.props.lang
	            });
	        }
	    }]);
	    return PassRecoveryStepTwo;
	}(_BaseForm3.default), _class2.propTypes = {
	    password: _react.PropTypes.string.isRequired,
	    code: _react.PropTypes.string.isRequired,
	    login: _react.PropTypes.string.isRequired,
	    changeFieldCode: _react.PropTypes.func,
	    changeFieldPassword: _react.PropTypes.func,
	    lang: _react.PropTypes.object
	}, _class2.defaultProps = {
	    changeFieldCode: function changeFieldCode() {},
	    changeFieldPassword: function changeFieldPassword() {}
	}, _temp)) || _class);
	exports.default = PassRecoveryStepTwo;
	module.exports = exports['default'];

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _utils = __webpack_require__(31);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PassRecoveryStepTwoView: {
	        displayName: 'PassRecoveryStepTwoView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/PassRecovery/PassRecoveryStepTwo/default/PassRecoveryStepTwoView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var PassRecoveryStepTwoView = _wrapComponent('PassRecoveryStepTwoView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(PassRecoveryStepTwoView, _Component);
	
	    function PassRecoveryStepTwoView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, PassRecoveryStepTwoView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PassRecoveryStepTwoView.__proto__ || (0, _getPrototypeOf2.default)(PassRecoveryStepTwoView)).call.apply(_ref, [this].concat(args))), _this), _this.showAlert = function (alert) {
	            var _this$props = _this.props,
	                error = _this$props.error,
	                errorCode = _this$props.errorCode,
	                lang = _this$props.lang;
	
	
	            if (error) {
	                if (errorCode === null || errorCode === undefined) {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang['store.common.server_is_unavailable']
	                    );
	                } else {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang[error]
	                    );
	                }
	            } else if (_this.props.alert || alert) {
	                var _ref2 = _this.props.alert || alert,
	                    message = _ref2.message,
	                    style = _ref2.style;
	
	                return _react3.default.createElement(
	                    _reactBootstrap.Alert,
	                    { bsStyle: style || 'danger', className: 'inner-right-xs' },
	                    message
	                );
	            }
	
	            return '';
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(PassRecoveryStepTwoView, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                isEmail = _props.isEmail,
	                lang = _props.lang;
	
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload },
	                this.props.outerAlert ? this.showAlert(this.props.outerAlert) : this.showAlert(),
	                _react3.default.createElement(
	                    'main',
	                    { id: 'authentication' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'container__' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react3.default.createElement(
	                                    'section',
	                                    { id: 'auth-form', className: 'sign-in' },
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'bordered' },
	                                        _react3.default.createElement(
	                                            'form',
	                                            { name: 'sms', autoComplete: 'sms-code', className: 'login-form', onSubmit: this.props.onSubmit },
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                { controlId: 'sms' },
	                                                isEmail ? _react3.default.createElement(
	                                                    _reactBootstrap.ControlLabel,
	                                                    { htmlFor: 'sms' },
	                                                    lang['store.password_recovery.code_from_email']
	                                                ) : _react3.default.createElement(
	                                                    _reactBootstrap.ControlLabel,
	                                                    { htmlFor: 'sms' },
	                                                    lang['store.password_recovery.code_from_sms']
	                                                ),
	                                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                                    autoComplete: 'sms-code',
	                                                    type: (0, _utils.isMobileDevice)() ? "number" : "text",
	                                                    name: 'SMS',
	                                                    placeholder: '1234',
	                                                    pattern: '\\d*',
	                                                    value: this.props.code,
	                                                    onChange: function onChange(e) {
	                                                        if ((0, _utils.validateNumeric)(e.target.value)) {
	                                                            _this2.props.changeFieldCode(e);
	                                                        }
	                                                    }
	                                                })
	                                            ),
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                { controlId: 'pass_new' },
	                                                _react3.default.createElement(
	                                                    _reactBootstrap.ControlLabel,
	                                                    { htmlFor: 'pass_new' },
	                                                    lang['store.password_recovery.new_password']
	                                                ),
	                                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                                    autoComplete: 'pass-code',
	                                                    type: 'password',
	                                                    name: 'pass_new',
	                                                    value: this.props.password,
	                                                    onChange: this.props.changeFieldPassword,
	                                                    placeholder: lang['login.password']
	                                                })
	                                            ),
	                                            _react3.default.createElement(
	                                                _reactBootstrap.FormGroup,
	                                                null,
	                                                _react3.default.createElement(
	                                                    _reactBootstrap.Button,
	                                                    {
	                                                        type: 'submit',
	                                                        bsStyle: 'primary',
	                                                        className: 'form-control',
	                                                        disabled: this.props.disabledSubmit
	                                                    },
	                                                    lang['store.password_recovery.change_password']
	                                                )
	                                            ),
	                                            isEmail ? null : _react3.default.createElement(_components2.VoiceCode, {
	                                                login: this.props.login,
	                                                source: 'restore_password',
	                                                showAlert: this.props.showOuterAlert,
	                                                whiteList: true
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return PassRecoveryStepTwoView;
	}(_react2.Component), _class.propTypes = {
	    alert: _react2.PropTypes.shape({
	        message: _react2.PropTypes.string,
	        style: _react2.PropTypes.string,
	        lang: _react2.PropTypes.object
	    })
	}, _temp2));
	
	exports.default = PassRecoveryStepTwoView;
	module.exports = exports['default'];

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PassRecoveryStepTwo = undefined;
	
	var _PassRecoveryStepTwo2 = __webpack_require__(1726);
	
	var _PassRecoveryStepTwo3 = _interopRequireDefault(_PassRecoveryStepTwo2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.PassRecoveryStepTwo = _PassRecoveryStepTwo3.default;

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.validateField = validateField;
	exports.phoneNumber = phoneNumber;
	exports.minLength = minLength;
	exports.email = email;
	var REGEX_PHONE_NUMBER = /^(\+7)[\s][\(](9)(\d{2})[\)][\s][\d]{3}[\s][\d]{2}[\s][\d]{2}$/;
	var REGEX_EMAIL = /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/;
	
	function validateField(value, validateType) {
	    var _Validators;
	
	    switch (validateType) {
	        case ATTRIBUTE_VALIDATOR_PHONE:
	            for (var _len = arguments.length, params = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	                params[_key - 2] = arguments[_key];
	            }
	
	            return (_Validators = Validators).phoneNumber.apply(_Validators, [value].concat(params));
	            break;
	    }
	}
	
	/**
	 * Валидация номера телефона
	 *
	 * @param {String} phone
	 *
	 * @return {boolean}
	 */
	function phoneNumber(phone) {
	    return REGEX_PHONE_NUMBER.test(phone);
	}
	
	/**
	 * Валидация длины строки на минимальное кол-во символов
	 *
	 * @param {String} string
	 * @param {int} minLength
	 *
	 * @return {boolean}
	 */
	function minLength(string) {
	    var minLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	
	    return string.length >= minLength;
	}
	
	/**
	 * Валидация почтового ящика
	 *
	 * @param {String} email
	 *
	 * @return {bool}
	 */
	function email(email) {
	    return REGEX_EMAIL.test(email);
	}

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(102);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _user = __webpack_require__(115);
	
	var _BaseForm2 = __webpack_require__(66);
	
	var _BaseForm3 = _interopRequireDefault(_BaseForm2);
	
	var _modal = __webpack_require__(26);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _helpers = __webpack_require__(15);
	
	var _Validators = __webpack_require__(1731);
	
	var Validators = _interopRequireWildcard(_Validators);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PasswordChange = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        change: state.user.change,
	        error: state.user.error,
	        errorCode: state.user.errorCode,
	        preload: state.user.preload,
	        server_not_found: state.error.server_not_found,
	        user: state.auth.user,
	        lang: state.lang
	    };
	}, {
	    changePassword: _user.changePassword,
	    hide: _modal.hide,
	    resetError: _user.resetError
	}), _dec(_class = (_temp = _class2 = function (_BaseForm) {
	    (0, _inherits3.default)(PasswordChange, _BaseForm);
	
	    function PasswordChange(props, context) {
	        (0, _classCallCheck3.default)(this, PasswordChange);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordChange.__proto__ || (0, _getPrototypeOf2.default)(PasswordChange)).call(this, props, context));
	
	        _this.handlerChangeNewPass = function (event) {
	            _this.setState({
	                newPass: event.target.value
	            });
	        };
	
	        _this.handlerChangeNewRePass = function (event) {
	            _this.setState({
	                newRePass: event.target.value
	            });
	        };
	
	        _this.handlerChangeOldPass = function (event) {
	            _this.setState({
	                oldPass: event.target.value
	            });
	        };
	
	        _this.state = {
	            error: '',
	            errorCode: null,
	            newPass: '',
	            newRePass: '',
	            oldPass: ''
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(PasswordChange, [{
	        key: 'onSubmit',
	        value: function onSubmit(event) {
	            (0, _get3.default)(PasswordChange.prototype.__proto__ || (0, _getPrototypeOf2.default)(PasswordChange.prototype), 'onSubmit', this).call(this, event);
	
	            if (this.isValid()) {
	                var user = this.props.user;
	
	
	                this.props.changePassword(user.phone || user.email, this.state.newPass, this.state.newRePass, this.state.oldPass);
	
	                this.props.resetError();
	                this.setState({
	                    error: '',
	                    errorCode: null,
	                    newPass: '',
	                    newRePass: '',
	                    oldPass: ''
	                });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.resetError();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _props = this.props,
	                change = _props.change,
	                lang = _props.lang;
	
	
	            if (change !== nextProps.change && nextProps.change) {
	                this.props.hide();
	                setTimeout(function () {
	                    _reactSAlert2.default.success(lang['store.password_recovery.success'], { position: 'top-right', effect: 'slide', timeout: 5000 });
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'isValid',
	        value: function isValid() {
	            this.props.resetError();
	
	            var lang = this.props.lang;
	
	            var lengthError = lang['store.password_recovery.pass_length_error'];
	            var mismatchError = lang['store.password_change.password_mismatch'];
	
	            if (!Validators.minLength(this.state.newPass, 6)) {
	                this.setState({ error: lengthError, errorCode: 400 });
	                return false;
	            }
	
	            if (this.state.newPass !== this.state.newRePass) {
	                this.setState({ error: mismatchError, errorCode: 400 });
	                return false;
	            }
	
	            return true;
	        }
	    }, {
	        key: 'isMinValid',
	
	
	        /**
	         * Валидация по всем методам проверки
	         * @returns {boolean}
	         */
	        value: function isMinValid() {
	            return this.state.newPass.length > 0 && this.state.newRePass.length > 0 && this.state.oldPass.length > 0;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('PasswordChange', null, { folderName: 'PasswordChange' });
	
	            return _react2.default.createElement(View, {
	                disabledSubmit: !this.isMinValid(),
	                error: this.props.error || this.state.error,
	                errorCode: this.state.errorCode || this.props.errorCode,
	                newPass: this.state.newPass,
	                newRePass: this.state.newRePass,
	                oldPass: this.state.oldPass,
	                onChangeNewPass: this.handlerChangeNewPass,
	                onChangeNewRePass: this.handlerChangeNewRePass,
	                onChangeOldPass: this.handlerChangeOldPass,
	                onSubmit: this.onSubmit,
	                preload: this.props.preload,
	                server_not_found: this.props.server_not_found,
	                lang: this.props.lang
	            });
	        }
	    }]);
	    return PasswordChange;
	}(_BaseForm3.default), _class2.propTypes = {
	    change: _react.PropTypes.any,
	    changePassword: _react.PropTypes.func.isRequired,
	    error: _react.PropTypes.any,
	    errorCode: _react.PropTypes.any,
	    hide: _react.PropTypes.func.isRequired,
	    preload: _react.PropTypes.any,
	    resetError: _react.PropTypes.func.isRequired,
	    server_not_found: _react.PropTypes.any,
	    user: _react.PropTypes.object.isRequired,
	    lang: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = PasswordChange;
	module.exports = exports['default'];

/***/ }),
/* 1731 */
1729,
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PasswordChangeView: {
	        displayName: 'PasswordChangeView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/PasswordChange/default/PasswordChangeView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	//import ReactAlert from 'react-s-alert';
	
	var PasswordChangeView = _wrapComponent('PasswordChangeView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(PasswordChangeView, _Component);
	
	    function PasswordChangeView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, PasswordChangeView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PasswordChangeView.__proto__ || (0, _getPrototypeOf2.default)(PasswordChangeView)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
	            event.preventDefault();
	            _this.props.onSubmit(event);
	        }, _this.showError = function () {
	            var _this$props = _this.props,
	                error = _this$props.error,
	                errorCode = _this$props.errorCode,
	                lang = _this$props.lang;
	
	
	            if (error) {
	                if (errorCode === null || errorCode === undefined) {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang['store.common.server_is_unavailable']
	                    );
	                } else {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang[error]
	                    );
	                }
	            }
	
	            return '';
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(PasswordChangeView, [{
	        key: 'render',
	        value: function render() {
	            var lang = this.props.lang;
	
	
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload },
	                this.showError(),
	                _react3.default.createElement(
	                    'section',
	                    { className: 'registration_page', id: 'registration-form' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'bordered' },
	                        _react3.default.createElement(
	                            _reactBootstrap.Form,
	                            { onSubmit: this.onSubmit },
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { controlId: 'password' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.ControlLabel,
	                                    null,
	                                    lang['store.password_change.previous_password']
	                                ),
	                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                    type: 'password',
	                                    name: 'PASSWORD',
	                                    value: this.props.oldPass,
	                                    onChange: this.props.onChangeOldPass,
	                                    placeholder: lang['store.password_change.enter_previous_password']
	                                })
	                            ),
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { controlId: 'passwordNew' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.ControlLabel,
	                                    null,
	                                    lang['store.password_change.enter_new_password']
	                                ),
	                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                    type: 'password',
	                                    name: 'PASSWORD_NEW',
	                                    value: this.props.newPass,
	                                    onChange: this.props.onChangeNewPass,
	                                    placeholder: lang['store.password_change.create_password']
	                                })
	                            ),
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { controlId: 'repasswordNew' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.ControlLabel,
	                                    null,
	                                    lang['store.password_change.repeat_new_password']
	                                ),
	                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                    type: 'password',
	                                    name: 'REPASSWORD_NEW',
	                                    value: this.props.newRePass,
	                                    onChange: this.props.onChangeNewRePass,
	                                    placeholder: lang['store.password_change.repeat_password']
	                                })
	                            ),
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                null,
	                                _react3.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        type: 'submit',
	                                        bsStyle: 'primary',
	                                        className: 'form-control',
	                                        disabled: this.props.disabledSubmit
	                                    },
	                                    lang['store.password_change.change_password']
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return PasswordChangeView;
	}(_react2.Component), _class.propTypes = {
	    disabledSubmit: _react2.PropTypes.bool.isRequired,
	    error: _react2.PropTypes.string,
	    newPass: _react2.PropTypes.string.isRequired,
	    newRePass: _react2.PropTypes.string.isRequired,
	    oldPass: _react2.PropTypes.string.isRequired,
	    onSubmit: _react2.PropTypes.func.isRequired,
	    lang: _react2.PropTypes.object
	}, _temp2));
	
	exports.default = PasswordChangeView;
	module.exports = exports['default'];

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PasswordChange = undefined;
	
	var _PasswordChange2 = __webpack_require__(1730);
	
	var _PasswordChange3 = _interopRequireDefault(_PasswordChange2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.PasswordChange = _PasswordChange3.default;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PaymentStatusLabelView: {
	        displayName: 'PaymentStatusLabelView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/PaymentStatusLabel/default/PaymentStatusLabelView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var PaymentStatusLabelView = _wrapComponent('PaymentStatusLabelView')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(PaymentStatusLabelView, _Component);
	
	    function PaymentStatusLabelView() {
	        (0, _classCallCheck3.default)(this, PaymentStatusLabelView);
	        return (0, _possibleConstructorReturn3.default)(this, (PaymentStatusLabelView.__proto__ || (0, _getPrototypeOf2.default)(PaymentStatusLabelView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(PaymentStatusLabelView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                type = _props.type,
	                labelText = _props.labelText,
	                lang = _props.lang;
	
	            var className = 'label-' + type;
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(
	                    'div',
	                    { className: className, style: {
	                            display: 'inline-block',
	                            padding: '.3em .6em .4em', fontSize: '75%', fontWeight: 'bold', lineHeight: 1,
	                            color: '#fff', textAlign: 'center',
	                            verticalAlign: 'baseline',
	                            borderRadius: '.25em' } },
	                    lang[labelText]
	                )
	            );
	        }
	    }]);
	    return PaymentStatusLabelView;
	}(_react2.Component), _class2.propType = {
	    type: _propTypes2.default.string.isRequired,
	    labelText: _propTypes2.default.string.isRequired,
	    lang: _propTypes2.default.object.isRequired
	}, _temp)) || _class));
	
	exports.default = PaymentStatusLabelView;
	module.exports = exports['default'];

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp2;
	
	var _reactRedux = __webpack_require__(12);
	
	var _Preloader = __webpack_require__(755);
	
	var _Preloader2 = _interopRequireDefault(_Preloader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PreloaderGlobal: {
	        displayName: 'PreloaderGlobal'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Preloader/PreloaderGlobal.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var globalShow = 'on'; //on Показывать, one_show показать один раз, off не показывать
	
	var PreloaderGlobal = _wrapComponent('PreloaderGlobal')((_dec = (0, _reactRedux.connect)(function (state) {
	    return { show_preloader: state.preloader.show };
	}), _dec(_class = (_temp2 = _class2 = function (_Component) {
	    (0, _inherits3.default)(PreloaderGlobal, _Component);
	
	    function PreloaderGlobal() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, PreloaderGlobal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PreloaderGlobal.__proto__ || (0, _getPrototypeOf2.default)(PreloaderGlobal)).call.apply(_ref, [this].concat(args))), _this), _this.show = function () {
	            if (globalShow == 'off') {
	                return false;
	            }
	            if (globalShow == 'one_show') {
	                globalShow = 'off';
	            }
	            return _this.props.show_preloader;
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(PreloaderGlobal, [{
	        key: 'render',
	        value: function render() {
	            var show_preloader = this.props.show_preloader;
	
	
	            return _react3.default.createElement(
	                _Preloader2.default,
	                { preload: this.show() },
	                this.props.children
	            );
	        }
	    }]);
	    return PreloaderGlobal;
	}(_react2.Component), _class2.propTypes = {
	    show_preloader: _react2.PropTypes.bool.isRequired
	}, _class2.toogleShow = function () {
	    var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'on';
	
	    globalShow = show;
	}, _temp2)) || _class));
	
	exports.default = PreloaderGlobal;
	module.exports = exports['default'];

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 01.11.16
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	__webpack_require__(1092);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PreloaderView: {
	        displayName: 'PreloaderView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Preloader/default/PreloaderView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var PreloaderView = _wrapComponent('PreloaderView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(PreloaderView, _Component);
	
	    function PreloaderView() {
	        (0, _classCallCheck3.default)(this, PreloaderView);
	        return (0, _possibleConstructorReturn3.default)(this, (PreloaderView.__proto__ || (0, _getPrototypeOf2.default)(PreloaderView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(PreloaderView, [{
	        key: 'render',
	        value: function render() {
	            var color = this.props.color;
	
	
	            return _react3.default.createElement(
	                'div',
	                { className: "wrap-preload " + this.props.classNames },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'preload' },
	                    _react3.default.createElement('img', { src: '/assets/images/' + color + '.svg', alt: '' })
	                )
	            );
	        }
	    }]);
	    return PreloaderView;
	}(_react2.Component), _class.propTypes = {
	    color: _react2.PropTypes.string.isRequired
	}, _temp));
	
	exports.default = PreloaderView;
	module.exports = exports['default'];

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PreloaderGlobal = exports.Preloader = undefined;
	
	var _Preloader2 = __webpack_require__(755);
	
	var _Preloader3 = _interopRequireDefault(_Preloader2);
	
	var _PreloaderGlobal2 = __webpack_require__(1735);
	
	var _PreloaderGlobal3 = _interopRequireDefault(_PreloaderGlobal2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Preloader = _Preloader3.default;
	exports.PreloaderGlobal = _PreloaderGlobal3.default;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by maximus on 14.10.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Products: {
	        displayName: 'Products'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Products/Products.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Products = _wrapComponent('Products')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(Products, _Component);
	
	    function Products(props) {
	        (0, _classCallCheck3.default)(this, Products);
	        return (0, _possibleConstructorReturn3.default)(this, (Products.__proto__ || (0, _getPrototypeOf2.default)(Products)).call(this, props));
	    }
	
	    (0, _createClass3.default)(Products, [{
	        key: 'render',
	        value: function render() {
	            var products = this.props.products || [];
	            var View = _helpers.ThemeHelper.getViewForComponent('Products');
	
	            return _react3.default.createElement(View, { products: products });
	        }
	    }]);
	    return Products;
	}(_react2.Component), _class.propTypes = {
	    products: _react2.PropTypes.array.isRequired
	}, _temp));
	
	exports.default = Products;
	module.exports = exports['default'];

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by maximus on 14.10.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(19);
	
	var _textEllipsis = __webpack_require__(262);
	
	var _textEllipsis2 = _interopRequireDefault(_textEllipsis);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Product: {
	        displayName: 'Product'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Products/default/Product.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Product = _wrapComponent('Product')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        currency: state.currency,
	        orderInOneClick: state.setting.orderInOneClick,
	        buyInCreditActive: state.setting.buyInCreditActive
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Product, _Component);
	
	    function Product(props) {
	        (0, _classCallCheck3.default)(this, Product);
	        return (0, _possibleConstructorReturn3.default)(this, (Product.__proto__ || (0, _getPrototypeOf2.default)(Product)).call(this, props));
	    }
	
	    (0, _createClass3.default)(Product, [{
	        key: 'getRemainder',
	        value: function getRemainder(nestedOffer, quantityTechCard, product_detail) {
	            if (nestedOffer.childOffer === null) {
	                return null;
	            }
	            if (nestedOffer.quantity > 0) {
	                var quantity = void 0;
	                quantity = nestedOffer.quantity;
	                if (nestedOffer.childOffer.modifier_option_id !== null) {
	                    nestedOffer.childOffer.modOption = nestedOffer.childOffer.modifiedOption.reduce(function (mod, modifier) {
	                        if (modifier.id === nestedOffer.childOffer.modifier_option_id) {
	                            return modifier;
	                        }
	                        return mod;
	                    }, null);
	                    if (nestedOffer.childOffer.modOption !== null && nestedOffer.childOffer.type_id !== 5) {
	                        nestedOffer.childOffer.unit = nestedOffer.childOffer.modOption.unit;
	                        if (nestedOffer.childOffer.modOption.storable === true && nestedOffer.childOffer.modOption.storage_strict) {
	                            product_detail.storable = true;
	                            if (nestedOffer.childOffer.modOption.remainder.length === 0) {
	                                product_detail.remainder = [{ quantity: 0 }];
	                            } else if (nestedOffer.childOffer.modOption.remainder[0].quantity > 0) {
	                                if ((nestedOffer.childOffer.modOption.unit_id === 2 || nestedOffer.childOffer.modOption.unit_id === 8) && nestedOffer.childOffer.modOption.weight && nestedOffer.childOffer.modOption.weight > 0) {
	                                    quantity = nestedOffer.childOffer.modOption.weight * nestedOffer.quantity;
	                                }
	                                quantityTechCard = Math.floor(nestedOffer.childOffer.modOption.remainder[0].quantity / quantity);
	                                if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
	                                    product_detail.remainder = [{ quantity: quantityTechCard }];
	                                }
	                            } else {
	                                product_detail.remainder = [{ quantity: 0 }];
	                            }
	                        }
	                    }
	                }
	                if (nestedOffer.childOffer.modOption === null || nestedOffer.childOffer.type_id === 5) {
	                    if (nestedOffer.childOffer.storable === true && nestedOffer.childOffer.storage_strict) {
	                        product_detail.storable = true;
	                        if (nestedOffer.childOffer.remainder.length === 0) {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        } else if (nestedOffer.childOffer.remainder[0].quantity > 0) {
	                            if ((nestedOffer.childOffer.unit_id === 2 || nestedOffer.childOffer.unit_id === 8) && nestedOffer.childOffer.weight && nestedOffer.childOffer.weight > 0) {
	                                quantity = nestedOffer.childOffer.weight * nestedOffer.quantity;
	                            }
	                            quantityTechCard = Math.floor(nestedOffer.childOffer.remainder[0].quantity / quantity);
	                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
	                                product_detail.remainder = [{ quantity: quantityTechCard }];
	                            }
	                        } else {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        }
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var currency = this.props.currency;
	            var _props$data = this.props.data,
	                id = _props$data.id,
	                price = _props$data.price,
	                name = _props$data.name,
	                pictures = _props$data.pictures;
	
	
	            var cartButtonClassName = 'add-cart-button add-to-cart';
	            var cartProductClassName = 'col-sm-6 col-md-4 no-margin product-item-holder hover';
	            if (this.props.orderInOneClick && this.props.buyInCreditActive && price <= 500000 && price >= 3000) {
	                cartButtonClassName = 'add-cart-button-three  add-to-cart';
	                cartProductClassName = 'col-sm-6 col-md-4 no-margin product-item-holder hover credit';
	            }
	            price = parseFloat(price);
	            var imgSrc = '/assets/images/placeholder.png';
	            if (pictures[0]) {
	                if (pictures[0].preview_url) {
	                    imgSrc = pictures[0].preview_url;
	                } else {
	                    if (pictures[0].url) {
	                        imgSrc = pictures[0].url;
	                    }
	                }
	            }
	            if (this.props.data.type_id === 5) {
	                this.props.data.storable = false;
	                this.props.data.storage_strict = true;
	                this.props.data.remainder = [];
	                var quantityTechCard = 1;
	                var priceComponent = 0;
	                var modifierComponent = null;
	                var modifierComponentTwo = null;
	                var storableComponent = false;
	                this.props.data.is_quantity_change = false;
	                this.props.data.nestedOffers.forEach(function (nestedOffer) {
	                    if (nestedOffer.quantity > 0 && nestedOffer.childOffer) {
	                        modifierComponent = null;
	                        if (nestedOffer.childOffer.type_id === 5) {
	                            nestedOffer.childOffer.remainder = [];
	                            nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
	                                _this2.getRemainder(nestedOfferTwo, nestedOffer.quantity, _this2.props.data);
	                            });
	                        } else {
	                            _this2.getRemainder(nestedOffer, quantityTechCard, _this2.props.data);
	                        }
	                    }
	                    if (nestedOffer.is_quantity_change) {
	                        _this2.props.data.is_quantity_change = true;
	                    }
	                });
	                price = parseFloat(this.props.data.price);
	                if (this.props.data.modifier_option_id !== undefined) {
	                    this.props.data.modifier_option.storable = this.props.data.storable;
	                    this.props.data.modifier_option.remainder[0] = this.props.data.remainder[0];
	                }
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: cartProductClassName },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'product-item flying-to-cart-holder' },
	                    _react3.default.createElement(_components2.ProductWishIcon, { product: this.props.data, inCard: true }),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'image' },
	                        _react3.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/product/' + id },
	                            _react3.default.createElement('img', { className: 'flying-to-cart-img', alt: '', src: imgSrc })
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'body' },
	                        _react3.default.createElement('div', { className: 'label-discount clear' }),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'title text-center' },
	                            _react3.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/product/' + id },
	                                _react3.default.createElement(
	                                    'span',
	                                    { className: 'visible-lg text-theme-color' },
	                                    (0, _textEllipsis2.default)(name, 160, { ellipsis: '...' })
	                                ),
	                                _react3.default.createElement(
	                                    'span',
	                                    { className: 'hidden-lg hidden-xs text-theme-color' },
	                                    (0, _textEllipsis2.default)(name, 80, { ellipsis: '...' })
	                                ),
	                                _react3.default.createElement(
	                                    'span',
	                                    { className: 'visible-xs text-theme-color' },
	                                    (0, _textEllipsis2.default)(name, 120, { ellipsis: '...' })
	                                )
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'prices' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'price-current text-center text-theme-color' },
	                            _react3.default.createElement(_components2.MoneyValue, {
	                                value: price,
	                                icon: currency.icon,
	                                iconAfterValue: currency.icon_after_value
	                            })
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'hover-area' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: cartButtonClassName },
	                            _react3.default.createElement(_components2.AddToBasket, { product: this.props.data })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return Product;
	}(_react2.Component), _class2.propTypes = {
	    data: _react2.PropTypes.object.isRequired,
	    currency: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Product;
	module.exports = exports['default'];

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 26.10.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _Product = __webpack_require__(1739);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	__webpack_require__(1093);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ProductsView: {
	        displayName: 'ProductsView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Products/default/ProductsView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ProductsView = _wrapComponent('ProductsView')(function (_Component) {
	    (0, _inherits3.default)(ProductsView, _Component);
	
	    function ProductsView() {
	        (0, _classCallCheck3.default)(this, ProductsView);
	        return (0, _possibleConstructorReturn3.default)(this, (ProductsView.__proto__ || (0, _getPrototypeOf2.default)(ProductsView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(ProductsView, [{
	        key: 'render',
	        value: function render() {
	            var products = this.props.products || [];
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'product-grid-holder' },
	                products.map(function (item, i) {
	                    return _react3.default.createElement(_Product2.default, { key: "_Product" + i, data: item });
	                }),
	                _react3.default.createElement('div', { className: 'clearfix' })
	            );
	        }
	    }]);
	    return ProductsView;
	}(_react2.Component));
	
	exports.default = ProductsView;
	module.exports = exports['default'];

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Products = undefined;
	
	var _Products2 = __webpack_require__(1738);
	
	var _Products3 = _interopRequireDefault(_Products2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Products = _Products3.default;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp2;
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    QuantityProduct: {
	        displayName: 'QuantityProduct'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/QuantityProduct/QuantityProduct.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var QuantityProduct = _wrapComponent('QuantityProduct')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang
	    };
	}), _dec(_class = (_temp2 = _class2 = function (_Component) {
	    (0, _inherits3.default)(QuantityProduct, _Component);
	
	    function QuantityProduct() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, QuantityProduct);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = QuantityProduct.__proto__ || (0, _getPrototypeOf2.default)(QuantityProduct)).call.apply(_ref, [this].concat(args))), _this), _this.onClickPlus = function (event) {
	            event.preventDefault();
	            var currentValue = parseInt(_this.props.value, 10) || 0;
	            _this.props.callback(currentValue + 1);
	        }, _this.onClickMinus = function (event) {
	            event.preventDefault();
	            var currentValue = parseInt(_this.props.value, 10) || 0;
	            if (currentValue > 1) {
	                _this.props.callback(currentValue - 1);
	            }
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    /**
	     * @param event
	     */
	
	
	    (0, _createClass3.default)(QuantityProduct, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('QuantityProduct');
	
	            return _react3.default.createElement(View, {
	                onClickMinus: this.onClickMinus,
	                onClickPlus: this.onClickPlus,
	                checkValue: this.props.checkValue,
	                checkCount: this.props.checkCount,
	                value: this.props.value,
	                lang: this.props.lang });
	        }
	    }]);
	    return QuantityProduct;
	}(_react2.Component), _class2.propTypes = {
	    value: _react2.PropTypes.number.isRequired,
	    callback: _react2.PropTypes.func.isRequired,
	    checkValue: _react2.PropTypes.bool,
	    checkCount: _react2.PropTypes.number,
	    lang: _react2.PropTypes.object
	}, _temp2)) || _class));
	
	exports.default = QuantityProduct;
	module.exports = exports['default'];

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 26.10.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	__webpack_require__(1094);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    QuantityProductView: {
	        displayName: 'QuantityProductView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/QuantityProduct/default/QuantityProductView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var QuantityProductView = _wrapComponent('QuantityProductView')(function (_Component) {
	    (0, _inherits3.default)(QuantityProductView, _Component);
	
	    function QuantityProductView() {
	        (0, _classCallCheck3.default)(this, QuantityProductView);
	        return (0, _possibleConstructorReturn3.default)(this, (QuantityProductView.__proto__ || (0, _getPrototypeOf2.default)(QuantityProductView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(QuantityProductView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                onClickMinus = _props.onClickMinus,
	                onClickPlus = _props.onClickPlus,
	                value = _props.value,
	                checkValue = _props.checkValue,
	                checkCount = _props.checkCount,
	                lang = _props.lang;
	
	            if (checkCount < 0) {
	                checkCount = 0;
	            }
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'le-quantity' },
	                    _react3.default.createElement(
	                        'form',
	                        null,
	                        _react3.default.createElement('a', { className: 'minus', onClick: onClickMinus, style: { cursor: 'pointer' } }),
	                        _react3.default.createElement('input', { name: 'quantity', readOnly: 'readonly', type: 'text', value: value }),
	                        _react3.default.createElement('a', { className: 'plus', onClick: onClickPlus, style: { cursor: 'pointer' } })
	                    )
	                ),
	                checkValue && value > checkCount ? _react3.default.createElement(
	                    'div',
	                    { className: 'basket_item_error' },
	                    _react3.default.createElement('i', { className: 'fa fa-exclamation-circle' }),
	                    lang['store.common.available_in_stock'],
	                    ' ',
	                    checkCount
	                ) : null
	            );
	        }
	    }]);
	    return QuantityProductView;
	}(_react2.Component));
	
	exports.default = QuantityProductView;
	module.exports = exports['default'];

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QuantityProduct = undefined;
	
	var _QuantityProduct2 = __webpack_require__(1742);
	
	var _QuantityProduct3 = _interopRequireDefault(_QuantityProduct2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.QuantityProduct = _QuantityProduct3.default;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _registration = __webpack_require__(194);
	
	var _error = __webpack_require__(140);
	
	var _constants = __webpack_require__(757);
	
	var _Registration = __webpack_require__(758);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Registration: {
	        displayName: 'Registration'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Registration/Registration.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Registration = _wrapComponent('Registration')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        regError: state.registration.errorsList,
	        preload: state.registration.preload,
	        step: state.registration.step,
	        user: state.auth.user
	    };
	}, {
	    confirmRegistration: _registration.confirmRegistration,
	    error: _error.error,
	    pushState: _reactRouterRedux.push,
	    registration: _registration.registration,
	    resetStep: _registration.resetStep
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Registration, _Component);
	
	    function Registration(props) {
	        (0, _classCallCheck3.default)(this, Registration);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Registration.__proto__ || (0, _getPrototypeOf2.default)(Registration)).call(this, props));
	
	        _this.changeFields = function (newState) {
	            // if (newState.hasOwnProperty('phone')) {
	            //     this.setState({phone: newState.phone});
	            // }
	            if (newState.hasOwnProperty('password')) {
	                _this.setState({ password: newState.password });
	            }
	        };
	
	        _this.updateFormData = function (formData) {
	            _this.setState(function (prevState) {
	                return (0, _extends3.default)({}, prevState, formData);
	            });
	        };
	
	        _this.renderComponent = function () {
	            switch (_this.props.step) {
	                case _constants.REGISTRATION_STEP_CONFIRMED:
	                    return _react3.default.createElement(_Registration.RegistrationConfirm, {
	                        changeField: _this.changeFields,
	                        formData: _this.state
	                    });
	                    break;
	
	                case _constants.REGISTRATION_STEP_CONFIRMED_SUCCESS:
	                    return _react3.default.createElement(_Registration.RegistrationSuccess, {
	                        formData: _this.state
	                    });
	                    break;
	
	                case _constants.REGISTRATION_STEP_FORM:
	                default:
	                    return _react3.default.createElement(_Registration.RegistrationForm, {
	                        onChange: _this.changeFields,
	                        updateFormData: _this.updateFormData
	                    });
	                    break;
	            }
	        };
	
	        _this.state = {
	            password: ''
	        };
	
	        _this.initialState = _this.state;
	        return _this;
	    }
	
	    (0, _createClass3.default)(Registration, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.props.user) {
	                this.props.pushState('/');
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.resetStep();
	        }
	
	        /**
	         * Обработчик обновления состояния для его передачи в другие компоненты
	         * @param formData
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react3.default.createElement(
	                'div',
	                null,
	                this.renderComponent()
	            );
	        }
	    }]);
	    return Registration;
	}(_react2.Component), _class2.propTypes = {
	    confirmRegistration: _react2.PropTypes.func.isRequired,
	    error: _react2.PropTypes.func.isRequired,
	    pushState: _react2.PropTypes.func.isRequired,
	    registration: _react2.PropTypes.func.isRequired,
	    resetStep: _react2.PropTypes.func.isRequired,
	    step: _react2.PropTypes.string.isRequired,
	    user: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Registration;
	module.exports = exports['default'];

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(102);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _registration = __webpack_require__(194);
	
	var _voice_code = __webpack_require__(141);
	
	var _BaseForm2 = __webpack_require__(66);
	
	var _BaseForm3 = _interopRequireDefault(_BaseForm2);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistrationConfirm = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        errorsList: state.registration.errorsList,
	        preload: state.registration.preload,
	        errorCode: state.registration.errorCode,
	        settings: state.setting,
	        lang: state.lang
	    };
	}, { confirmRegistration: _registration.confirmRegistration, resetVoiceCode: _voice_code.resetVoiceCode, resetError: _registration.resetError }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
	    (0, _inherits3.default)(RegistrationConfirm, _BaseForm);
	
	    function RegistrationConfirm(props, context) {
	        (0, _classCallCheck3.default)(this, RegistrationConfirm);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (RegistrationConfirm.__proto__ || (0, _getPrototypeOf2.default)(RegistrationConfirm)).call(this, props, context));
	
	        _this.showOuterAlert = function (alert) {
	            _this.setState({ outerAlert: alert });
	        };
	
	        _this.state = {
	            smsCode: '',
	            emailCode: '',
	            outerAlert: null
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(RegistrationConfirm, [{
	        key: 'onSubmit',
	        value: function onSubmit(event) {
	            (0, _get3.default)(RegistrationConfirm.prototype.__proto__ || (0, _getPrototypeOf2.default)(RegistrationConfirm.prototype), 'onSubmit', this).call(this, event);
	
	            if (this.isValid()) {
	                var formData = this.props.formData;
	
	                var codes = {};
	
	                if (this.state.smsCode) {
	                    codes['sms_code'] = this.state.smsCode;
	                }
	
	                if (this.state.emailCode) {
	                    codes['email_code'] = this.state.emailCode;
	                }
	
	                this.props.confirmRegistration((0, _extends3.default)({
	                    shopId: this.props.settings.shopId
	                }, formData, codes));
	                this.props.resetVoiceCode();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.resetError();
	            this.props.resetVoiceCode();
	        }
	
	        /**
	         * Валидация по всем методам проверки
	         * @returns {boolean}
	         */
	
	    }, {
	        key: 'isValid',
	        value: function isValid() {
	            //return this.state.smsCode.length > 0;
	            return true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('RegistrationConfirm', null, { folderName: "Registration/RegistrationConfirm" });
	
	            return _react2.default.createElement(View, {
	                smsCode: this.state.smsCode,
	                emailCode: this.state.emailCode,
	                changeField: this.changeField,
	                formData: this.props.formData,
	                onSubmit: this.onSubmit,
	                disabledSubmit: !this.isValid(),
	                preload: this.props.preload,
	                errorsList: this.props.errorsList,
	                showOuterAlert: this.showOuterAlert,
	                outerAlert: this.state.outerAlert,
	                errorCode: this.props.errorCode,
	                settings: this.props.settings,
	                lang: this.props.lang
	            });
	        }
	    }]);
	    return RegistrationConfirm;
	}(_BaseForm3.default), _class2.propTypes = {
	    changeField: _react.PropTypes.func.isRequired,
	    formData: _react.PropTypes.object.isRequired,
	    lang: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = RegistrationConfirm;
	module.exports = exports['default'];

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _utils = __webpack_require__(31);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    RegistrationConfirmView: {
	        displayName: 'RegistrationConfirmView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Registration/RegistrationConfirm/default/RegistrationConfirmView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var RegistrationConfirmView = _wrapComponent('RegistrationConfirmView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(RegistrationConfirmView, _Component);
	
	    function RegistrationConfirmView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, RegistrationConfirmView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RegistrationConfirmView.__proto__ || (0, _getPrototypeOf2.default)(RegistrationConfirmView)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
	            event.preventDefault();
	            _this.props.onSubmit(event);
	        }, _this.showAlert = function (alert) {
	            var lang = _this.props.lang;
	
	
	            if (_this.props.errorsList) {
	                if (_this.props.errorCode === null || _this.props.errorCode === undefined) {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang['store.common.server_is_unavailable']
	                    );
	                } else {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        _this.renderErrorList(_this.props.errorsList)
	                    );
	                }
	            } else if (_this.props.alert || alert) {
	                var _ref2 = _this.props.alert || alert,
	                    message = _ref2.message,
	                    style = _ref2.style;
	
	                return _react3.default.createElement(
	                    _reactBootstrap.Alert,
	                    { bsStyle: style || 'danger', className: 'inner-right-xs' },
	                    message
	                );
	            }
	
	            return '';
	        }, _this.renderVoiceCode = function () {
	            var additionalFieldSettings = _this.props.settings.additionalFieldSettings;
	
	            if (additionalFieldSettings.find(function (item) {
	                return item.typeAdditionalField.slug == 'phone' && item.required_in_registration;
	            })) {
	
	                return _react3.default.createElement(_components2.VoiceCode, {
	                    login: _this.props.formData.phone,
	                    source: 'registration',
	                    showAlert: _this.props.showOuterAlert,
	                    whiteList: false
	                });
	            }
	            return null;
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(RegistrationConfirmView, [{
	        key: 'renderErrorList',
	        value: function renderErrorList(list) {
	            var _this2 = this;
	
	            if (Array.isArray(list)) {
	                return list.map(function (text, i) {
	                    return _react3.default.createElement(
	                        'p',
	                        { key: i },
	                        _this2.props.lang[text]
	                    );
	                });
	            } else if (typeof list === 'string') {
	                return this.props.lang[list];
	            } else {
	                return null;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var additionalFieldSettings = this.props.settings.additionalFieldSettings;
	
	
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload },
	                this.props.outerAlert ? this.showAlert(this.props.outerAlert) : this.showAlert(),
	                _react3.default.createElement(
	                    'section',
	                    { id: 'registration-form' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'bordered' },
	                        _react3.default.createElement(
	                            _reactBootstrap.Form,
	                            { onSubmit: this.onSubmit },
	                            additionalFieldSettings.map(function (item, i) {
	                                var typeAdditionalField = item.typeAdditionalField,
	                                    required_in_registration = item.required_in_registration;
	
	                                if (typeAdditionalField.slug == 'phone' && required_in_registration) {
	                                    return _react3.default.createElement(
	                                        _reactBootstrap.FormGroup,
	                                        { controlId: 'sms', key: i },
	                                        _react3.default.createElement(
	                                            _reactBootstrap.ControlLabel,
	                                            null,
	                                            _this3.props.lang['store.common.enter_sms_code'],
	                                            '*'
	                                        ),
	                                        _react3.default.createElement(_reactBootstrap.FormControl, {
	                                            type: (0, _utils.isMobileDevice)() ? "number" : "text",
	                                            pattern: '\\d*',
	                                            placeholder: '1234',
	                                            value: _this3.props.smsCode,
	                                            onChange: function onChange(e) {
	                                                if ((0, _utils.validateNumeric)(e.target.value)) {
	                                                    _this3.props.changeField('smsCode')(e);
	                                                }
	                                            }
	                                        })
	                                    );
	                                } else if (typeAdditionalField.slug == 'email' && required_in_registration) {
	                                    return _react3.default.createElement(
	                                        _reactBootstrap.FormGroup,
	                                        { controlId: 'email_code', key: i },
	                                        _react3.default.createElement(
	                                            _reactBootstrap.ControlLabel,
	                                            null,
	                                            _this3.props.lang['store.registration_form.enter_code_from_mail'],
	                                            '*'
	                                        ),
	                                        _react3.default.createElement(_reactBootstrap.FormControl, {
	                                            type: (0, _utils.isMobileDevice)() ? "number" : "text",
	                                            pattern: '\\d*',
	                                            placeholder: '1234',
	                                            value: _this3.props.emailCode,
	                                            onChange: function onChange(e) {
	                                                if ((0, _utils.validateNumeric)(e.target.value)) {
	                                                    _this3.props.changeField('emailCode')(e);
	                                                }
	                                            }
	                                        })
	                                    );
	                                }
	                                return null;
	                            }),
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                null,
	                                _react3.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        type: 'submit',
	                                        className: 'form-control',
	                                        bsStyle: 'primary',
	                                        disabled: this.props.disabledSubmit
	                                    },
	                                    this.props.lang['store.common.confirm']
	                                )
	                            ),
	                            this.renderVoiceCode()
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return RegistrationConfirmView;
	}(_react2.Component), _class.propTypes = {
	    smsCode: _react2.PropTypes.string.isRequired,
	    changeField: _react2.PropTypes.func.isRequired,
	    onSubmit: _react2.PropTypes.func.isRequired,
	    disabledSubmit: _react2.PropTypes.bool.isRequired,
	    errorsList: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.array]),
	    lang: _react2.PropTypes.object
	}, _temp2));
	
	exports.default = RegistrationConfirmView;
	module.exports = exports['default'];

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegistrationConfirm = undefined;
	
	var _RegistrationConfirm2 = __webpack_require__(1746);
	
	var _RegistrationConfirm3 = _interopRequireDefault(_RegistrationConfirm2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.RegistrationConfirm = _RegistrationConfirm3.default;

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(102);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactGoogleRecaptcha = __webpack_require__(340);
	
	var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _modal_type = __webpack_require__(42);
	
	var _registration = __webpack_require__(194);
	
	var _pass_recovery = __webpack_require__(164);
	
	var _BaseForm2 = __webpack_require__(66);
	
	var _BaseForm3 = _interopRequireDefault(_BaseForm2);
	
	var _helpers = __webpack_require__(15);
	
	var _Validators = __webpack_require__(1758);
	
	var Validators = _interopRequireWildcard(_Validators);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistrationForm = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        errorsList: state.registration.errorsList,
	        errorCode: state.registration.errorCode,
	        lang: state.lang,
	        preload: state.registration.preload,
	        setting: state.setting,
	        shopId: state.setting.shopId,
	        googleCaptcha: state.setting.googleCaptcha,
	        googleCaptchaSitekey: state.setting.googleCaptchaSitekey
	    };
	}, { showModalAuth: _modal_type.showModalAuth, registration: _registration.registration, resetError: _registration.resetError, showModalPassRecovery: _modal_type.showModalPassRecovery, sendPhoneToReducer: _pass_recovery.sendPhoneToReducer, resetStep: _pass_recovery.resetStep }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
	    (0, _inherits3.default)(RegistrationForm, _BaseForm);
	
	    function RegistrationForm(props, context) {
	        (0, _classCallCheck3.default)(this, RegistrationForm);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (RegistrationForm.__proto__ || (0, _getPrototypeOf2.default)(RegistrationForm)).call(this, props, context));
	
	        _this.checkInn = function (typeAdditionalField) {
	            var REGEX_INN = /^[\d]+$/igm;
	
	            return _this.state[typeAdditionalField.slug] && REGEX_INN.test(_this.state[typeAdditionalField.slug]) && (_this.state[typeAdditionalField.slug].length === 10 || _this.state[typeAdditionalField.slug].length === 12);
	        };
	
	        _this.checkCustomField = function () {
	            var setting = _this.props.setting;
	
	
	            if (setting.additionalFieldSettings) {
	                // если есть в настройках магазина настройки для полей
	                // достаем все обязательные поля
	                var requiredField = setting.additionalFieldSettings.filter(function (item) {
	                    return item.required_in_registration;
	                });
	
	                var flag = void 0;
	
	                requiredField.forEach(function (item) {
	                    var typeAdditionalField = item.typeAdditionalField;
	
	
	                    if (typeAdditionalField.slug === 'inn') {
	                        if (!flag && !_this.checkInn(typeAdditionalField)) {
	                            flag = true;
	                        }
	                    } else {
	                        if (!flag && !_this.state[typeAdditionalField.slug]) {
	                            flag = true;
	                        }
	                    }
	                });
	
	                // отдельно валидируем ИНН даже если это не обязательное поле
	                // получаем поле ИНН
	                var innField = setting.additionalFieldSettings.filter(function (fieldItem) {
	                    return fieldItem.show_in_registration && fieldItem.typeAdditionalField && fieldItem.typeAdditionalField.slug === 'inn';
	                })[0];
	                // если есть поле ИНН
	                if (innField) {
	                    if (!flag && _this.state.inn && !_this.checkInn(innField.typeAdditionalField)) {
	                        flag = true;
	                    }
	                }
	
	                return !flag;
	            }
	
	            return true;
	        };
	
	        _this.isMinValid = function () {
	            return _this.checkCustomField() && _this.state.password.length > 0;
	        };
	
	        _this.onClickAuth = function (event) {
	            _this.props.showModalAuth(_this.props.lang);
	        };
	
	        _this.onClickPassRecovery = function (event) {
	            _this.props.resetStep();
	            _this.props.sendPhoneToReducer(_this.state.phone);
	            _this.props.showModalPassRecovery(_this.props.lang);
	        };
	
	        _this.onSuccessCaptcha = function (value) {
	            _this.setState({ captcha: value });
	        };
	
	        _this.showCaptcha = function () {
	            if (_this.props.googleCaptcha) {
	                setTimeout(function () {
	                    grecaptcha.execute(_this.props.googleCaptchaSitekey, { action: 'submit' }).then(_this.onSuccessCaptcha);
	                }, 500);
	                // return (
	                //     <Recaptcha
	                //         sitekey={this.props.googleCaptchaSitekey}
	                //         render="explicit"
	                //         onChange={this.onSuccessCaptcha}
	                //     />
	                // );
	            }
	
	            return '';
	        };
	
	        _this.state = {
	            password: '',
	            errorsList: null,
	            errorCode: null,
	            captcha: null
	        };
	
	        _this.init = (0, _extends3.default)({}, _this.state);
	        return _this;
	    }
	
	    (0, _createClass3.default)(RegistrationForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.resetError();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.resetError();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.errorsList) {// при возникновении ошибки
	                // this.setState((prevState) => {
	                //     return { // сбрасываем состояние
	                //         ...prevState,
	                //         email: '',
	                //         inn: '',
	                //         ul_name: '',
	                //     };
	                // });
	            }
	        }
	    }, {
	        key: 'onSubmit',
	        value: function onSubmit(event) {
	            (0, _get3.default)(RegistrationForm.prototype.__proto__ || (0, _getPrototypeOf2.default)(RegistrationForm.prototype), 'onSubmit', this).call(this, event);
	
	            if (this.isValid()) {
	                if (this.props.googleCaptcha && this.state.captcha == null) {
	                    var alertMessage = this.props.lang['user.errorInvalidCaptcha'];
	                    setTimeout(function () {
	                        _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                    }, 0);
	                    return null;
	                }
	                var updateFormData = this.props.updateFormData;
	
	
	                this.setState({
	                    errorsList: '',
	                    errorCode: null
	                });
	
	                var temp = (0, _extends3.default)({}, this.state);
	
	                delete temp.errorsList;
	                delete temp.errorCode;
	                delete temp.password;
	                if (temp.hasOwnProperty('phone') && temp.phone.length < 6) {
	                    delete temp.phone;
	                }
	
	                // обновляем состояние родительского компонента
	                updateFormData(temp);
	
	                this.props.registration((0, _extends3.default)({
	                    password: this.state.password,
	                    shopId: this.props.shopId
	                }, temp));
	            }
	        }
	    }, {
	        key: 'isValid',
	
	
	        /**
	         * Валидация по всем методам проверки
	         * @returns {boolean}
	         */
	        value: function isValid() {
	            var errorMessage = this.props.lang['store.password_recovery.pass_length_error'];
	            if (!Validators.minLength(this.state.password, 6)) {
	                this.setState({ errorsList: errorMessage, errorCode: 400 });
	                return false;
	            }
	
	            return true;
	        }
	
	        /**
	         * Валидация ИНН
	         * @param typeAdditionalField
	         * @returns {boolean}
	         */
	
	
	        /**
	         * Dалидация настраиваемых полей
	         * @returns {boolean}
	         */
	
	
	        /**
	         * Обработчик активации кнопки "Зарегистрироваться"
	         * @returns {boolean}
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('RegistrationForm', null, { folderName: 'Registration/RegistrationForm' });
	
	            return _react2.default.createElement(View, {
	                changeField: this.changeField,
	                disabledSubmit: !this.isMinValid(),
	                email: this.state.email,
	                errorsList: this.state.errorsList || this.props.errorsList || '',
	                errorCode: this.state.errorCode || this.props.errorCode,
	                inn: this.state.inn,
	                lang: this.props.lang,
	                onClickAuth: this.onClickAuth,
	                onClickPassRecovery: this.onClickPassRecovery,
	                onSubmit: this.onSubmit,
	                password: this.state.password,
	                phone: this.state.phone,
	                preload: this.props.preload,
	                setting: this.props.setting,
	                ul_name: this.state.ul_name,
	                username: this.state.username,
	                showCaptcha: this.showCaptcha
	            });
	        }
	    }]);
	    return RegistrationForm;
	}(_BaseForm3.default), _class2.propTypes = {
	    errorsList: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array]),
	    lang: _react.PropTypes.object,
	    onChange: _react.PropTypes.func,
	    setting: _react.PropTypes.object.isRequired,
	    showModalAuth: _react.PropTypes.func.isRequired,
	    updateFormData: _react.PropTypes.func.isRequired
	}, _temp)) || _class);
	exports.default = RegistrationForm;
	module.exports = exports['default'];

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _reactMaskedinput = __webpack_require__(1422);
	
	var _reactMaskedinput2 = _interopRequireDefault(_reactMaskedinput);
	
	var _reactRouter = __webpack_require__(19);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1095);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    RegistrationFormView: {
	        displayName: 'RegistrationFormView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Registration/RegistrationForm/default/RegistrationFormView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	// import PhoneInput from 'react-telephone-input';
	
	
	var RegistrationFormView = _wrapComponent('RegistrationFormView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(RegistrationFormView, _Component);
	
	    function RegistrationFormView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, RegistrationFormView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RegistrationFormView.__proto__ || (0, _getPrototypeOf2.default)(RegistrationFormView)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAuth = function (event) {
	            event.preventDefault();
	            if (_this.props.onClickAuth) {
	                _this.props.onClickAuth(event);
	            }
	        }, _this.showError = function () {
	            var _this$props = _this.props,
	                lang = _this$props.lang,
	                errorsList = _this$props.errorsList;
	
	
	            if (errorsList) {
	                if (_this.props.errorCode === null || _this.props.errorCode === undefined) {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        lang['store.common.server_is_unavailable']
	                    );
	                } else if (errorsList === 'registration.errorDuplicatePhone' || errorsList === 'error.duplicatePhone' || _this.props.errorsList === 'registration.errorDuplicateEmail' || _this.props.errorsList === 'errorDuplicateEmail') {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        _this.renderErrorList(errorsList),
	                        _react3.default.createElement(
	                            'a',
	                            { className: 'rec_pass', onClick: _this.onClickPassRecovery },
	                            lang['store.registration_form.restore_password']
	                        )
	                    );
	                } else {
	                    return _react3.default.createElement(
	                        _reactBootstrap.Alert,
	                        { bsStyle: 'danger', className: 'inner-right-xs' },
	                        _this.renderErrorList(errorsList)
	                    );
	                }
	            }
	
	            return '';
	        }, _this.onClickPassRecovery = function (event) {
	            event.preventDefault();
	            if (_this.props.onClickPassRecovery) {
	                _this.props.onClickPassRecovery(event);
	            }
	        }, _this.handlePhoneChange = function (phone, country) {
	            _this.props.changeField('phone')(null, phone);
	        }, _this.renderField = function () {
	            var _this$props2 = _this.props,
	                changeField = _this$props2.changeField,
	                lang = _this$props2.lang,
	                setting = _this$props2.setting;
	
	
	            var result = [];
	
	            if (setting.additionalFieldSettings) {
	                var additionalFieldSettings = setting.additionalFieldSettings;
	
	
	                result = additionalFieldSettings.map(function (item, i) {
	                    var typeAdditionalField = item.typeAdditionalField,
	                        show_in_registration = item.show_in_registration,
	                        required_in_registration = item.required_in_registration;
	
	                    var formInput = null;
	
	                    if (show_in_registration) {
	                        if (typeAdditionalField && typeAdditionalField.slug === 'phone') {
	                            formInput = _react3.default.createElement(_components2.PhoneEmailInput, {
	                                value: _this.props.phone,
	                                defaultCountry: '',
	                                flagsImagePath: '/assets/images/flags.png',
	                                placeholder: lang['register.placeholderPhone'],
	                                onChange: _this.handlePhoneChange
	                            });
	                        } else {
	                            formInput = _react3.default.createElement(_reactBootstrap.FormControl, {
	                                name: typeAdditionalField.slug,
	                                onChange: changeField(typeAdditionalField.slug),
	                                placeholder: lang[typeAdditionalField.placeholder_lang_data] || lang[typeAdditionalField.lang_data],
	                                type: 'text',
	                                value: _this.props[typeAdditionalField.slug]
	                            });
	                        }
	
	                        return _react3.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            {
	                                controlId: typeAdditionalField.slug,
	                                key: typeAdditionalField.slug + '-' + i
	                            },
	                            _react3.default.createElement(
	                                _reactBootstrap.ControlLabel,
	                                null,
	                                '' + (lang[typeAdditionalField.lang_data] || typeAdditionalField.description) + (required_in_registration ? '*' : ' ')
	                            ),
	                            formInput
	                        );
	                    }
	                });
	            }
	
	            return result;
	        }, _this.showCaptcha = function () {
	            if (_this.props.showCaptcha) {
	                return _react3.default.createElement(
	                    _reactBootstrap.FormGroup,
	                    null,
	                    _this.props.showCaptcha()
	                );
	            }
	
	            return '';
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(RegistrationFormView, [{
	        key: 'renderErrorList',
	        value: function renderErrorList(list) {
	            var _this2 = this;
	
	            if (Array.isArray(list)) {
	                return list.map(function (text, i) {
	                    return _react3.default.createElement(
	                        'p',
	                        { key: i },
	                        _this2.props.lang[text]
	                    );
	                });
	            } else if (typeof list === 'string') {
	                return this.props.lang[list];
	            } else {
	                return null;
	            }
	        }
	
	        /**
	         * Рендер включенных полей для регистрации
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                changeField = _props.changeField,
	                linkField = _props.linkField,
	                onSubmit = _props.onSubmit,
	                setting = _props.setting,
	                lang = _props.lang,
	                preload = _props.preload;
	
	
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: preload },
	                this.showError(),
	                _react3.default.createElement(
	                    'section',
	                    { id: 'registration-form', className: 'registration_page' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'bordered' },
	                        _react3.default.createElement(
	                            _reactBootstrap.Form,
	                            { onSubmit: onSubmit },
	                            this.renderField(),
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                { controlId: 'password' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.ControlLabel,
	                                    null,
	                                    lang['login.password'],
	                                    '*'
	                                ),
	                                _react3.default.createElement(_reactBootstrap.FormControl, {
	                                    type: 'password',
	                                    name: 'PASSWORD',
	                                    value: this.props.password,
	                                    onChange: changeField('password'),
	                                    placeholder: lang['register.placeholderPassword']
	                                })
	                            ),
	                            this.showCaptcha(),
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                null,
	                                _react3.default.createElement(
	                                    _reactBootstrap.Button,
	                                    {
	                                        type: 'submit',
	                                        bsStyle: 'primary',
	                                        className: 'form-control g-recaptcha',
	                                        disabled: this.props.disabledSubmit
	                                    },
	                                    lang['store.common.sign_up']
	                                )
	                            ),
	                            _react3.default.createElement(
	                                _reactBootstrap.FormGroup,
	                                null,
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'text-center to-page-registration' },
	                                    _react3.default.createElement(
	                                        _reactRouter.Link,
	                                        { className: 'login_link', to: '#', onClick: this.onClickAuth },
	                                        lang['login.logIn']
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return RegistrationFormView;
	}(_react2.Component), _class.propTypes = {
	    changeField: _react2.PropTypes.func.isRequired,
	    errorsList: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.array]),
	    lang: _react2.PropTypes.object,
	    onClickAuth: _react2.PropTypes.func,
	    onSubmit: _react2.PropTypes.func.isRequired,
	    password: _react2.PropTypes.string.isRequired,
	    preload: _react2.PropTypes.bool,
	    setting: _react2.PropTypes.object.isRequired
	
	}, _temp2));
	
	exports.default = RegistrationFormView;
	module.exports = exports['default'];

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegistrationForm = undefined;
	
	var _RegistrationForm2 = __webpack_require__(1749);
	
	var _RegistrationForm3 = _interopRequireDefault(_RegistrationForm2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.RegistrationForm = _RegistrationForm3.default;

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 10.11.16.
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp2;
	
	var _reactRedux = __webpack_require__(12);
	
	var _modal_type = __webpack_require__(42);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    RegistrationHeader: {
	        displayName: 'RegistrationHeader'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Registration/RegistrationHeader/RegistrationHeader.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var RegistrationHeader = _wrapComponent('RegistrationHeader')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang
	    };
	}, { showModalRegistration: _modal_type.showModalRegistration }), _dec(_class = (_temp2 = _class2 = function (_Component) {
	    (0, _inherits3.default)(RegistrationHeader, _Component);
	
	    function RegistrationHeader() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, RegistrationHeader);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RegistrationHeader.__proto__ || (0, _getPrototypeOf2.default)(RegistrationHeader)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
	            _this.props.showModalRegistration(_this.props.lang);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(RegistrationHeader, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('RegistrationHeader', null, { folderName: "Registration/RegistrationHeader" });
	
	            return _react3.default.createElement(View, { onClick: this.onClick, lang: this.props.lang });
	        }
	    }]);
	    return RegistrationHeader;
	}(_react2.Component), _class2.propTypes = {
	    showModalRegistration: _react2.PropTypes.func.isRequired,
	    lang: _react2.PropTypes.object
	}, _temp2)) || _class));
	
	exports.default = RegistrationHeader;
	module.exports = exports['default'];

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 30.11.16.
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _reactRouter = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    RegistrationHeaderView: {
	        displayName: "RegistrationHeaderView"
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: "/usr/local/ibonus/src/components/Registration/RegistrationHeader/default/RegistrationHeaderView.jsx",
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var RegistrationHeaderView = _wrapComponent("RegistrationHeaderView")((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(RegistrationHeaderView, _Component);
	
	    function RegistrationHeaderView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, RegistrationHeaderView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RegistrationHeaderView.__proto__ || (0, _getPrototypeOf2.default)(RegistrationHeaderView)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
	            event.preventDefault();
	            _this.props.onClick(event);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(RegistrationHeaderView, [{
	        key: "render",
	        value: function render() {
	            // Чтобы юзер не успел перейти на страницу регистрации
	            // до того, как подгрузятся скрипты. Если скрипты не успевают подхватит и
	            // юзер кликает на ссылку, то вместо модалки переходит на саму страницу.
	            // Было рещено, что так не надо делать.
	            if (false) {
	                return _react3.default.createElement(
	                    "a",
	                    { href: "#" },
	                    _react3.default.createElement(
	                        "span",
	                        { className: "auth_span" },
	                        this.props.lang['store.register.register']
	                    )
	                );
	            }
	
	            return _react3.default.createElement(
	                _reactRouter.Link,
	                { to: "/registration", onClick: this.onClick },
	                _react3.default.createElement(
	                    "span",
	                    { className: "auth_span" },
	                    this.props.lang['store.register.register']
	                )
	            );
	        }
	    }]);
	    return RegistrationHeaderView;
	}(_react2.Component), _class.propTypes = {
	    onClick: _react2.PropTypes.func,
	    lang: _react2.PropTypes.object
	}, _temp2));
	
	exports.default = RegistrationHeaderView;
	module.exports = exports['default'];

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegistrationHeader = undefined;
	
	var _RegistrationHeader2 = __webpack_require__(1752);
	
	var _RegistrationHeader3 = _interopRequireDefault(_RegistrationHeader2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.RegistrationHeader = _RegistrationHeader3.default;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp2;
	
	var _reactRedux = __webpack_require__(12);
	
	var _modal = __webpack_require__(26);
	
	var _modal_type = __webpack_require__(42);
	
	var _auth = __webpack_require__(53);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    RegistrationSuccess: {
	        displayName: 'RegistrationSuccess'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Registration/RegistrationSuccess/RegistrationSuccess.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var RegistrationSuccess = _wrapComponent('RegistrationSuccess')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        preload: state.auth.preload,
	        settings: state.setting,
	        user: state.auth.user,
	        lang: state.lang
	    };
	}, { showModalAuth: _modal_type.showModalAuth, login: _auth.login, hide: _modal.hide }), _dec(_class = (_temp2 = _class2 = function (_Component) {
	    (0, _inherits3.default)(RegistrationSuccess, _Component);
	
	    function RegistrationSuccess() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, RegistrationSuccess);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RegistrationSuccess.__proto__ || (0, _getPrototypeOf2.default)(RegistrationSuccess)).call.apply(_ref, [this].concat(args))), _this), _this.onShowAuth = function () {
	            var _this$props = _this.props,
	                formData = _this$props.formData,
	                settings = _this$props.settings;
	
	            var login = '';
	            settings.additionalFieldSettings.find(function (item) {
	                if (item.type_id == 1 && item.required_in_registration) {
	                    login = formData.phone;
	                    return true;
	                } else if (item.type_id == 2 && item.required_in_registration) {
	                    login = formData.email;
	                    return true;
	                }
	            });
	
	            _this.props.login({ login: login, password: formData.password, captcha: null, callback: _this._closeModal });
	            //this.props.showModalAuth(this.props.lang);
	        }, _this._closeModal = function () {
	            _this.props.hide();
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(RegistrationSuccess, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.onShowAuth();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('RegistrationSuccess', null, { folderName: "Registration/RegistrationSuccess" }),
	                _props = this.props,
	                preload = _props.preload,
	                user = _props.user;
	
	
	            return _react3.default.createElement(View, {
	                preload: preload
	            });
	        }
	    }]);
	    return RegistrationSuccess;
	}(_react2.Component), _class2.propTypes = {
	    showModalAuth: _react2.PropTypes.func.isRequired,
	    user: _react2.PropTypes.object,
	    setting: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object
	}, _temp2)) || _class));
	
	exports.default = RegistrationSuccess;
	module.exports = exports['default'];

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 30.11.16.
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _reactRouter = __webpack_require__(19);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    RegistrationSuccessView: {
	        displayName: "RegistrationSuccessView"
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: "/usr/local/ibonus/src/components/Registration/RegistrationSuccess/default/RegistrationSuccessView.jsx",
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var RegistrationSuccessView = _wrapComponent("RegistrationSuccessView")(function (_Component) {
	    (0, _inherits3.default)(RegistrationSuccessView, _Component);
	
	    function RegistrationSuccessView(props) {
	        (0, _classCallCheck3.default)(this, RegistrationSuccessView);
	        return (0, _possibleConstructorReturn3.default)(this, (RegistrationSuccessView.__proto__ || (0, _getPrototypeOf2.default)(RegistrationSuccessView)).call(this, props));
	    }
	
	    (0, _createClass3.default)(RegistrationSuccessView, [{
	        key: "render",
	        value: function render() {
	            var preload = this.props.preload;
	
	
	            return _react3.default.createElement(_components2.Preloader, { preload: preload });
	        }
	    }]);
	    return RegistrationSuccessView;
	}(_react2.Component));
	
	exports.default = RegistrationSuccessView;
	module.exports = exports['default'];

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegistrationSuccess = undefined;
	
	var _RegistrationSuccess2 = __webpack_require__(1755);
	
	var _RegistrationSuccess3 = _interopRequireDefault(_RegistrationSuccess2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.RegistrationSuccess = _RegistrationSuccess3.default;

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.validateField = validateField;
	exports.phoneNumber = phoneNumber;
	exports.minLength = minLength;
	exports.email = email;
	var REGEX_PHONE_NUMBER = /^(\+7)[\s][\(](9)(\d{2})[\)][\s][\d]{3}[\s][\d]{2}[\s][\d]{2}$/;
	var REGEX_EMAIL = /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/;
	
	function validateField(value, validateType) {
	    var _Validators;
	
	    switch (validateType) {
	        case ATTRIBUTE_VALIDATOR_PHONE:
	            for (var _len = arguments.length, params = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	                params[_key - 2] = arguments[_key];
	            }
	
	            return (_Validators = Validators).phoneNumber.apply(_Validators, [value].concat(params));
	            break;
	    }
	}
	
	/**
	 * Валидация номера телефона
	 *
	 * @param {String} phone
	 *
	 * @return {boolean}
	 */
	function phoneNumber(phone) {
	    return REGEX_PHONE_NUMBER.test(phone);
	}
	
	/**
	 * Валидация длины строки на минимальное кол-во символов
	 *
	 * @param {String} string
	 * @param {int} minLength
	 *
	 * @return {boolean}
	 */
	function minLength(string) {
	    var minLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	
	    return string.length >= minLength;
	}
	
	/**
	 * Валидация почтового ящика
	 *
	 * @param {String} email
	 *
	 * @return {boolean}
	 */
	function email(email) {
	    return REGEX_EMAIL.test(email);
	}

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _utils = __webpack_require__(31);
	
	__webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SwitcherDescription: {
	        displayName: 'SwitcherDescription'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/SHARE/SwitherDescription/SwitcherDescription.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var SwitcherDescription = _wrapComponent('SwitcherDescription')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(SwitcherDescription, _Component);
	
	    function SwitcherDescription(props) {
	        (0, _classCallCheck3.default)(this, SwitcherDescription);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (SwitcherDescription.__proto__ || (0, _getPrototypeOf2.default)(SwitcherDescription)).call(this, props));
	
	        _this.onClick = function () {
	            return _this.setState(function (prevState) {
	                return {
	                    short: !prevState.short
	                };
	            });
	        };
	
	        _this.state = {
	            short: true
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(SwitcherDescription, [{
	        key: 'render',
	        value: function render() {
	            var short = this.state.short;
	            var description = this.props.description;
	
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'brand' },
	                _react3.default.createElement('div', {
	                    className: 'brand__short' + (short ? '_is-active' : '') + ' ',
	                    dangerouslySetInnerHTML: { __html: (0, _utils.stripTags)(description) },
	                    onClick: this.onClick
	                }),
	                _react3.default.createElement('div', {
	                    className: 'brand__full' + (short ? '' : '_is-active') + ' ',
	                    dangerouslySetInnerHTML: { __html: description },
	                    onClick: this.onClick
	                })
	            );
	        }
	
	        /**
	         * Обработчик клика по тексту
	         */
	
	    }]);
	    return SwitcherDescription;
	}(_react2.Component), _class.defaultProps = {
	    description: ''
	}, _class.propTypes = {
	    description: _react2.PropTypes.string
	}, _temp));
	
	exports.default = SwitcherDescription;
	module.exports = exports['default'];

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactAutocomplete = __webpack_require__(1294);
	
	var _reactAutocomplete2 = _interopRequireDefault(_reactAutocomplete);
	
	var _catalog = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AutocompleteSearch: {
	        displayName: 'AutocompleteSearch'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Search/Autocomplete/index.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var TIMEOUT_AJAX = 300;
	
	var AutocompleteSearch = _wrapComponent('AutocompleteSearch')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        searchProducts: state.catalog.searchProducts,
	        searchLoaded: state.catalog.searchLoaded,
	        closeSearch: state.catalog.closeSearch
	    };
	}, { searchProductsAction: _catalog.searchProducts, resetSearchProducts: _catalog.resetSearchProducts, setSearchClose: _catalog.setSearchClose }), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(AutocompleteSearch, _Component);
	
	    function AutocompleteSearch(props, context) {
	        (0, _classCallCheck3.default)(this, AutocompleteSearch);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AutocompleteSearch.__proto__ || (0, _getPrototypeOf2.default)(AutocompleteSearch)).call(this, props, context));
	
	        _this._isEscapePressed = false;
	
	        _this.ajax = function (value) {
	            _this.props.searchProductsAction(value);
	        };
	
	        _this.timeoutAjax = function (value) {
	            _this.cleanTimeoutAjax();
	            _this._setTimeOut = setTimeout(function () {
	                _this.ajax(value);
	            }, TIMEOUT_AJAX);
	        };
	
	        _this.cleanTimeoutAjax = function () {
	            if (_this._setTimeOut) {
	                clearTimeout(_this._setTimeOut);
	            }
	        };
	
	        _this.onChange = function (event, value) {
	            if (_this._isEscapePressed === true) {
	                _this._isEscapePressed = false;
	                _this.cleanTimeoutAjax();
	                return;
	            }
	
	            if (value.length === 0) {
	                _this.props.resetSearchProducts();
	            }
	
	            _this.setState({ search: value });
	            if (value.length > 0) {
	                _this.timeoutAjax(value);
	            }
	
	            if (_this.props.onChange) {
	                _this.props.onChange(value);
	            }
	        };
	
	        _this.onSelect = function (value, item) {
	            _this.setState({ search: value });
	            _this.props.resetSearchProducts();
	            if (_this.props.onSelect) {
	                _this.props.onSelect(value);
	            }
	        };
	
	        _this.onKeyDown = function (event) {
	            if (event.key === 'Escape') {
	                _this._isEscapePressed = true;
	            }
	        };
	
	        _this.state = {
	            search: '',
	            isShow: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(AutocompleteSearch, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if (nextProps.closeSearch) {
	                //Сброс инпута после выхода со страницы поиска
	                this.setState({ search: '' }, function () {
	                    _this2.props.setSearchClose(false);
	                });
	            }
	            if (nextProps.hasOwnProperty('searchLoaded') && this.props.loader) {
	                if (this.props.searchLoaded === false && nextProps.searchLoaded === true) {
	                    this.props.loader.style.display = 'inline-block';
	                } else if (this.props.searchLoaded === true && nextProps.searchLoaded === false) {
	                    this.props.loader.style.display = 'none';
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var inputProps = {
	                onKeyDown: this.onKeyDown
	            };
	
	            if (this.props.classNameInput) {
	                inputProps.className = this.props.classNameInput;
	            }
	            if (this.props.placeholderInput) {
	                inputProps.placeholder = this.props.placeholderInput;
	            }
	            if (this.props.onKeyPress) {
	                inputProps.onKeyPress = this.props.onKeyPress;
	            }
	            if (this.props.typeInput) {
	                inputProps.type = this.props.typeInput;
	            }
	
	            var wrapperClassName = 'search-wrapper';
	            if (this.state.isShow) {
	                wrapperClassName += ' show';
	            }
	
	            return _react3.default.createElement(_reactAutocomplete2.default, {
	                value: this.state.search,
	                items: this.props.searchProducts || [],
	                inputProps: inputProps,
	                wrapperProps: {
	                    className: wrapperClassName
	                },
	                onMenuVisibilityChange: function onMenuVisibilityChange(isOpen) {
	                    _this3.setState({ isShow: isOpen }, function () {
	                        _this3.props.onShow(isOpen);
	                    });
	                    if (isOpen === false) {
	                        _this3.props.resetSearchProducts();
	                    }
	                },
	                renderMenu: function renderMenu(items, value, style) {
	                    return _react3.default.createElement(
	                        'div',
	                        { className: 'search-menu-wrapper' },
	                        _react3.default.createElement('div', { className: _this3.props.classMenu + ' ' + (items.length ? '' : 'no_border'), children: items })
	                    );
	                },
	                onChange: this.onChange,
	                onSelect: this.onSelect,
	                getItemValue: function getItemValue(item) {
	                    return item.name;
	                },
	                renderItem: function renderItem(item, isHighlighted) {
	                    return _react3.default.createElement(
	                        'div',
	                        {
	                            className: 'search-item' + (isHighlighted ? ' highlighted' : ''),
	                            key: item.id,
	                            id: item.id
	                        },
	                        item.name
	                    );
	                }
	            });
	        }
	    }]);
	    return AutocompleteSearch;
	}(_react2.Component), _class2.propTypes = {
	    searchProducts: _react2.PropTypes.array,
	    searchLoaded: _react2.PropTypes.bool,
	    searchProductsAction: _react2.PropTypes.func,
	    resetSearchProducts: _react2.PropTypes.func,
	    onChange: _react2.PropTypes.func,
	    onSelect: _react2.PropTypes.func,
	    classNameInput: _react2.PropTypes.string,
	    placeholderInput: _react2.PropTypes.string,
	    typeInput: _react2.PropTypes.string,
	    onKeyPress: _react2.PropTypes.func,
	    classMenu: _react2.PropTypes.string,
	    loader: _react2.PropTypes.any,
	    onShow: _react2.PropTypes.func
	}, _class2.defaultProps = {
	    searchLoaded: false,
	    searchProducts: [],
	    classMenu: '',
	    loader: null,
	    onShow: function onShow() {}
	}, _temp)) || _class));
	
	exports.default = AutocompleteSearch;
	module.exports = exports['default'];

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _modal = __webpack_require__(26);
	
	var _coupons = __webpack_require__(1861);
	
	var _helpers = __webpack_require__(15);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _basket = __webpack_require__(101);
	
	var _registration = __webpack_require__(194);
	
	var _BaseForm2 = __webpack_require__(66);
	
	var _BaseForm3 = _interopRequireDefault(_BaseForm2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CouponSearchModal = (_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        user: state.auth.user,
	        shopId: state.setting.shopId,
	        preload: state.coupons.preload,
	        preloadAuth: state.auth.preload,
	        lang: state.lang
	    };
	}, { couponsSearch: _coupons.couponsSearch, hide: _modal.hide, addCouponInBasket: _basket.addCouponInBasket, confirmRegistrationOneClick: _registration.confirmRegistrationOneClick, registrationOneClick: _registration.registrationOneClick }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
	    (0, _inherits3.default)(CouponSearchModal, _BaseForm);
	
	    function CouponSearchModal(props, context) {
	        (0, _classCallCheck3.default)(this, CouponSearchModal);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CouponSearchModal.__proto__ || (0, _getPrototypeOf2.default)(CouponSearchModal)).call(this, props, context));
	
	        _this.handlerChangeInput = function (event) {
	            _this.setState({
	                token: event.target.value
	            });
	        };
	
	        _this.onSearch = function () {
	            if (_this.props.user) {
	                _this.props.couponsSearch(_this.state.token, _this.props.user.id).then(function (result) {
	                    if (result === null || result.coupon === null) {
	                        var alertMessage = _this.props.lang['store.iBonus.modals.couponNotFound'];
	                        _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 3000 });
	                    } else {
	                        _this.props.addCouponInBasket({
	                            description: result.coupon.offer.description,
	                            id: result.coupon.offer.id,
	                            name: result.coupon.offer.name,
	                            price: parseFloat(0),
	                            picture: result.coupon.imagePath,
	                            count: 1,
	                            type_id: result.coupon.offer.type_id,
	                            modifier_option_id: result.coupon.modifier_option_id !== undefined ? result.coupon.modifier_option_id : null,
	                            modifier_option: result.coupon.modifiedOption !== undefined ? result.coupon.modifiedOption : null,
	                            remainder_quantity: 1,
	                            is_coupon: true,
	                            coupon_id: result.coupon.id,
	                            coupon_token: _this.state.token,
	                            customer_coupon_id: _this.state.customer_coupon_id
	                        });
	                        var _alertMessage = _this.props.lang['store.iBonus.modals.couponAddedToCart'];
	                        _reactSAlert2.default.success(_alertMessage, { position: 'top-right', effect: 'slide', timeout: 3000 });
	                        _this.props.hide();
	                    }
	                });
	            } else {
	                _this.props.couponsSearch(_this.state.token).then(function (result) {
	                    if (result === null) {
	                        var alertMessage = _this.props.lang['store.iBonus.modals.couponNotFound'];
	                        _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 3000 });
	                    } else {
	                        if (result.phone !== undefined || result.email !== undefined) {
	                            _this.setState({ newUser: result.new_user });
	                            if (result.send_for_phone) {
	                                _this.setState({ codeSendFor: 'phone' });
	                                _this.setState({ login: result.phone });
	                            } else if (result.send_for_email) {
	                                _this.setState({ codeSendFor: 'email' });
	                                _this.setState({ login: result.email });
	                            }
	                            _this.setState({ timeToResentCode: 60 });
	                            _this.setState({ coupon: result.coupon });
	                            var timerId = setInterval(function () {
	                                _this.setState({ timeToResentCode: _this.state.timeToResentCode - 1 });
	                            }, 1000);
	                            setTimeout(function () {
	                                clearInterval(timerId);
	                            }, 60000);
	                        } else {
	                            _this.props.addCouponInBasket({
	                                description: result.coupon.offer.description,
	                                id: result.coupon.offer.id,
	                                name: result.coupon.offer.name,
	                                price: parseFloat(0),
	                                picture: result.coupon.imagePath,
	                                count: 1,
	                                type_id: result.coupon.offer.type_id,
	                                modifier_option_id: result.coupon.modifier_option_id !== undefined ? result.coupon.modifier_option_id : null,
	                                modifier_option: result.coupon.modifiedOption !== undefined ? result.coupon.modifiedOption : null,
	                                remainder_quantity: 1,
	                                is_coupon: true,
	                                coupon_id: result.coupon.id,
	                                coupon_token: _this.state.token,
	                                customer_coupon_id: _this.state.customer_coupon_id
	                            });
	                            var _alertMessage2 = _this.props.lang['store.iBonus.modals.couponAddedToCart'];
	                            _reactSAlert2.default.success(_alertMessage2, { position: 'top-right', effect: 'slide', timeout: 3000 });
	                            _this.props.hide();
	                        }
	                    }
	                });
	            }
	        };
	
	        _this.closeModal = function () {
	            _this.props.hide();
	        };
	
	        _this.onClickConfirmOneClick = function (event) {
	            _this.props.confirmRegistrationOneClick({
	                shopId: _this.props.shopId,
	                login: _this.state.login,
	                emailCode: _this.state.emailCode,
	                smsCode: _this.state.phoneCode
	            }).then(function (result) {
	                _this.props.addCouponInBasket({
	                    description: _this.state.coupon.offer.description,
	                    id: _this.state.coupon.offer.id,
	                    name: _this.state.coupon.offer.name,
	                    price: parseFloat(0),
	                    picture: _this.state.coupon.imagePath,
	                    count: 1,
	                    type_id: _this.state.coupon.offer.type_id,
	                    modifier_option_id: _this.state.coupon.modifier_option_id !== undefined ? _this.state.coupon.modifier_option_id : null,
	                    modifier_option: _this.state.coupon.modifiedOption !== undefined ? _this.state.coupon.modifiedOption : null,
	                    remainder_quantity: 1,
	                    is_coupon: true,
	                    coupon_id: _this.state.coupon.id,
	                    coupon_token: _this.state.token,
	                    customer_coupon_id: _this.state.customer_coupon_id
	                });
	                var alertMessage = _this.props.lang['store.iBonus.modals.couponAddedToCart'];
	                _reactSAlert2.default.success(alertMessage, { position: 'top-right', effect: 'slide', timeout: 3000 });
	                _this.props.hide();
	            });
	        };
	
	        _this.onClickResendCode = function (event) {
	            _this.props.registrationOneClick({ shopId: _this.props.shopId, login: _this.state.login }).then(function (result) {
	                _this.setState({ timeToResentCode: 60 });
	                var timerId = setInterval(function () {
	                    _this.setState({ timeToResentCode: _this.state.timeToResentCode - 1 });
	                }, 1000);
	                setTimeout(function () {
	                    clearInterval(timerId);
	                }, 60000);
	            });
	        };
	
	        _this.state = {
	            token: '',
	            login: '',
	            codeSendFor: '',
	            timeToResentCode: 0,
	            coupon: null
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(CouponSearchModal, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('CouponSearchModal', null, { folderName: "Search/CouponSearchModal" });
	
	            return _react2.default.createElement(View, (0, _extends3.default)({}, this.props, {
	                closeModal: this.closeModal,
	                token: this.state.token,
	                coupon: this.state.coupon,
	                onChange: this.handlerChangeInput,
	                onSubmit: this.onSearch,
	                preload: this.props.preload || this.props.preloadAuth,
	                onClickConfirmOneClick: this.onClickConfirmOneClick,
	                codeSendFor: this.state.codeSendFor,
	                login: this.state.login,
	                timeToResentCode: this.state.timeToResentCode,
	                onClickResendCode: this.onClickResendCode,
	                changeField: this.changeField,
	                lang: this.props.lang
	            }));
	        }
	    }]);
	    return CouponSearchModal;
	}(_BaseForm3.default), _class2.propTypes = {
	    hide: _react.PropTypes.func.isRequired,
	    lang: _react.PropTypes.object
	}, _temp)) || _class);
	exports.default = CouponSearchModal;
	module.exports = exports['default'];

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _components2 = __webpack_require__(16);
	
	var _utils = __webpack_require__(31);
	
	__webpack_require__(1097);
	
	var _reactBootstrap = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    CouponSearchModalView: {
	        displayName: 'CouponSearchModalView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Search/CouponSearchModal/default/CouponSearchModalView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var CouponSearchModalView = _wrapComponent('CouponSearchModalView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(CouponSearchModalView, _Component);
	
	    function CouponSearchModalView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, CouponSearchModalView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CouponSearchModalView.__proto__ || (0, _getPrototypeOf2.default)(CouponSearchModalView)).call.apply(_ref, [this].concat(args))), _this), _this.renderVoiceCode = function () {
	            if (_this.props.codeSendFor === 'phone') {
	                return _react3.default.createElement(_components2.VoiceCode, {
	                    login: _this.props.login,
	                    source: 'registration',
	                    showAlert: _this.showOuterAlert,
	                    whiteList: false
	                });
	            }
	            return null;
	        }, _this.showOuterAlert = function (alert) {
	            // this.setState({outerAlert: alert});
	        }, _this.renderTimer = function () {
	            return _react3.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'voice_wrap text-center' },
	                    _this.props.timeToResentCode > 0 ? _react3.default.createElement(
	                        'p',
	                        { id: 'voice_call_time_wrap', className: 'active' },
	                        _this.props.lang['store.iBonus.modals.resendCodeReRequest'],
	                        ' ',
	                        _react3.default.createElement(
	                            'span',
	                            { id: 'voice_call_time active' },
	                            _this.props.timeToResentCode
	                        ),
	                        ' ',
	                        _this.props.lang['store.iBonus.modals.resendCodeReRequest.seconds']
	                    ) : _react3.default.createElement(
	                        _components2.Preloader,
	                        { classNames: 'mini_preload', preload: _this.props.preloader },
	                        _react3.default.createElement(
	                            'a',
	                            { id: 'get_voice_call', href: '#', onClick: _this.props.onClickResendCode },
	                            _this.props.lang['store.iBonus.modals.resendCode']
	                        )
	                    )
	                )
	            );
	        }, _this.onClickConfirmOneClick = function (event) {
	            event.preventDefault();
	            _this.props.onClickConfirmOneClick(event);
	        }, _this.showOneClickConfirm = function () {
	            if (_this.props.codeSendFor !== '') {
	                if (_this.props.codeSendFor === 'email') {
	                    var _description = _this.props.lang['store.iBonus.modals.codeEmail'];
	                    return _react3.default.createElement(
	                        'div',
	                        { className: 'bordered' },
	                        _react3.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            null,
	                            _description
	                        ),
	                        _react3.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            { style: { marginBottom: '0px' } },
	                            _react3.default.createElement(
	                                _reactBootstrap.ControlLabel,
	                                null,
	                                _this.props.lang['store.iBonus.modals.enterCodeEmail'],
	                                '*'
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-7 text-right no-padding' },
	                            _react3.default.createElement(_reactBootstrap.FormControl, {
	                                type: (0, _utils.isMobileDevice)() ? "number" : "text",
	                                pattern: '\\d*',
	                                placeholder: '1234',
	                                value: _this.props.emailCode,
	                                onChange: function onChange(e) {
	                                    if ((0, _utils.validateNumeric)(e.target.value)) {
	                                        _this.props.changeField('emailCode')(e);
	                                    }
	                                }
	                            })
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-sm-5 text-right inline_block button_width_100' },
	                            _react3.default.createElement(
	                                _reactBootstrap.Button,
	                                {
	                                    type: 'submit',
	                                    bsStyle: 'primary',
	                                    className: 'form-control',
	                                    disabled: _this.props.disabledSubmitOneClick,
	                                    onClick: _this.onClickConfirmOneClick
	                                },
	                                _this.props.lang['store.iBonus.modals.Confirm']
	                            )
	                        ),
	                        _react3.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            { style: { paddingTop: '26px', marginTop: '20px' } },
	                            _this.renderTimer()
	                        )
	                    );
	                }
	                var description = _this.props.lang['store.iBonus.modals.codeSms'];
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'bordered' },
	                    _react3.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        null,
	                        description
	                    ),
	                    _react3.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        { style: { marginBottom: '0px' } },
	                        _react3.default.createElement(
	                            _reactBootstrap.ControlLabel,
	                            null,
	                            _this.props.lang['store.iBonus.modals.enterCodeSms'],
	                            '*'
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-7 text-right no-padding' },
	                        _react3.default.createElement(_reactBootstrap.FormControl, {
	                            type: (0, _utils.isMobileDevice)() ? "number" : "text",
	                            pattern: '\\d*',
	                            placeholder: '1234',
	                            value: _this.props.phoneCode,
	                            onChange: function onChange(e) {
	                                if ((0, _utils.validateNumeric)(e.target.value)) {
	                                    _this.props.changeField('phoneCode')(e);
	                                }
	                            }
	                        })
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-5 text-right inline_block button_width_100' },
	                        _react3.default.createElement(
	                            _reactBootstrap.Button,
	                            {
	                                type: 'submit',
	                                bsStyle: 'primary',
	                                className: 'form-control',
	                                disabled: _this.props.disabledSubmitOneClick,
	                                onClick: _this.onClickConfirmOneClick
	                            },
	                            _this.props.lang['store.iBonus.modals.Confirm']
	                        )
	                    ),
	                    _react3.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        { style: { paddingTop: '26px', marginTop: '20px' } },
	                        _this.renderVoiceCode()
	                    ),
	                    _react3.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        null,
	                        _this.renderTimer()
	                    )
	                );
	            }
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(CouponSearchModalView, [{
	        key: 'render',
	        value: function render() {
	            var couponsImage = null;
	            if (this.props.coupon !== null) {
	                couponsImage = _react3.default.createElement('div', { style: { width: '72px', height: '72px', padding: '4px' } });
	                if (this.props.coupon.imagePath !== null) {
	                    couponsImage = _react3.default.createElement(
	                        'div',
	                        { className: 'text-center', style: { maxWidth: '72px', maxHeight: '72px', padding: '4px' } },
	                        _react3.default.createElement('img', { style: { maxWidth: '68px', maxHeight: '68px', marginLeft: 'auto', marginRight: 'auto' }, src: this.props.coupon.imagePath })
	                    );
	                }
	            }
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload },
	                _react3.default.createElement(
	                    'section',
	                    { id: 'search-coupon-form' },
	                    this.props.coupon === null ? _react3.default.createElement(
	                        'div',
	                        null,
	                        _react3.default.createElement(
	                            _reactBootstrap.FormGroup,
	                            null,
	                            _react3.default.createElement(
	                                _reactBootstrap.ControlLabel,
	                                null,
	                                this.props.lang['store.iBonus.modals.token']
	                            ),
	                            _react3.default.createElement(_reactBootstrap.FormControl, {
	                                value: this.props.token,
	                                type: 'text',
	                                placeholder: '123456',
	                                onChange: this.props.onChange
	                            })
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-6 col-md-36' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.FormGroup,
	                                    null,
	                                    _react3.default.createElement(
	                                        _reactBootstrap.Button,
	                                        {
	                                            type: 'submit',
	                                            className: 'form-control',
	                                            bsStyle: 'primary',
	                                            onClick: this.props.onSubmit
	                                        },
	                                        'OK'
	                                    )
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-6 col-md-6' },
	                                _react3.default.createElement(
	                                    _reactBootstrap.FormGroup,
	                                    null,
	                                    _react3.default.createElement(
	                                        _reactBootstrap.Button,
	                                        { type: 'submit', bsStyle: 'success', className: 'form-control', onClick: this.props.closeModal },
	                                        this.props.lang['store.common.cancel']
	                                    )
	                                )
	                            )
	                        )
	                    ) : null,
	                    this.showOneClickConfirm()
	                )
	            );
	        }
	    }]);
	    return CouponSearchModalView;
	}(_react2.Component), _class.propTypes = {}, _temp2));
	
	exports.default = CouponSearchModalView;
	module.exports = exports['default'];

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CouponSearchModal = undefined;
	
	var _CouponSearchModal2 = __webpack_require__(1761);
	
	var _CouponSearchModal3 = _interopRequireDefault(_CouponSearchModal2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CouponSearchModal = _CouponSearchModal3.default;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _constants = __webpack_require__(18);
	
	var _catalog = __webpack_require__(67);
	
	var _modal_type = __webpack_require__(42);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Header: {
	        displayName: 'Header'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Search/Search.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Header = _wrapComponent('Header')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        theme: state.setting.theme,
	        searchProducts: state.catalog.searchProducts,
	        closeSearch: state.catalog.closeSearch,
	        orderInOneClick: state.setting.orderInOneClick,
	        loyaltySettingsActive: state.setting.loyaltySettingsActive,
	        user: state.auth.user,
	        lang: state.lang
	    };
	}, { push: _reactRouterRedux.push, setSearchClose: _catalog.setSearchClose, showCouponSearchModal: _modal_type.showCouponSearchModal }), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Header, _Component);
	
	    function Header(props) {
	        (0, _classCallCheck3.default)(this, Header);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call(this, props));
	
	        _this.handleEnter = function (e) {
	            if (e.key === 'Enter') {
	                _this.handleClick(e);
	            }
	        };
	
	        _this.handleClick = function (e) {
	            e.preventDefault();
	            if (_this.state.inputState.length > 0) {
	                _this.props.push('/search/' + _this.state.inputState + '?limit=' + _constants.CatalogNumericConstants.SEARCH_PAGE_LIMIT + '&page=' + 1);
	            }
	        };
	
	        _this.handleChangeInput = function (value) {
	            _this.setState({ inputState: value });
	        };
	
	        _this.handleSelect = function (value) {
	            _this.setState({ inputState: value });
	            _this.props.push('/search/' + _this.state.inputState + '?limit=' + _constants.CatalogNumericConstants.SEARCH_PAGE_LIMIT + '&page=' + 1);
	        };
	
	        _this.onFindCoupon = function (e) {
	            _this.props.showCouponSearchModal(_this.props.lang);
	        };
	
	        _this.state = {
	            inputState: ''
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Header, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if (nextProps.closeSearch) {
	                //Сброс инпута после выхода со страницы поиска
	                this.setState({ inputState: '' }, function () {
	                    _this2.props.setSearchClose(false);
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('Search');
	
	            return _react3.default.createElement(View, {
	                handleClick: this.handleClick,
	                handleEnter: this.handleEnter,
	                handleChangeInput: this.handleChangeInput,
	                inputState: this.state.inputState,
	                onSelect: this.handleSelect,
	                theme: this.props.theme,
	                searchProducts: this.props.searchProducts,
	                lang: this.props.lang,
	                onFindCoupon: this.onFindCoupon,
	                loyaltySettingsActive: this.props.loyaltySettingsActive
	            });
	        }
	    }]);
	    return Header;
	}(_react2.Component), _class2.propsType = {
	    theme: _react2.PropTypes.string.isRequired,
	    lang: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _reactRouter = __webpack_require__(19);
	
	var _Search = __webpack_require__(759);
	
	var _constants = __webpack_require__(18);
	
	__webpack_require__(1098);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SearchView: {
	        displayName: 'SearchView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Search/default/SearchView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var SearchView = _wrapComponent('SearchView')(function (_Component) {
	    (0, _inherits3.default)(SearchView, _Component);
	
	    function SearchView(props, context) {
	        (0, _classCallCheck3.default)(this, SearchView);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchView.__proto__ || (0, _getPrototypeOf2.default)(SearchView)).call(this, props, context));
	
	        _this._loader = null;
	
	
	        _this.state = {
	            isShow: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(SearchView, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var className = 'search-area';
	
	            if (this.state.isShow && this.props.searchProducts.length) {
	                className += ' show';
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'top-search-holder' },
	                _react3.default.createElement(
	                    'div',
	                    { className: className },
	                    _react3.default.createElement(
	                        'form',
	                        null,
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'control-group', style: { position: 'relative' } },
	                            _react3.default.createElement(_Search.Autocomplete, {
	                                onChange: this.props.handleChangeInput,
	                                onKeyPress: this.props.handleEnter,
	                                classNameInput: 'search-field',
	                                placeholderInput: this.props.lang['store.search.product_search'],
	                                typeInput: 'search',
	                                onSelect: this.props.onSelect,
	                                classMenu: 'search-menu',
	                                loader: this._loader,
	                                onShow: function onShow(isShow) {
	                                    _this2.setState({ "isShow": isShow });
	                                }
	                            }),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'search-loader', ref: function ref(element) {
	                                        _this2._loader = element;
	                                    } },
	                                _react3.default.createElement('img', { src: '/assets/images/' + this.props.theme + '.svg', alt: '' })
	                            ),
	                            _react3.default.createElement('a', {
	                                href: '#',
	                                onClick: this.props.handleClick,
	                                className: 'search-button'
	                            }),
	                            _react3.default.createElement('div', { style: { clear: 'both' } })
	                        )
	                    )
	                ),
	                this.props.loyaltySettingsActive ? _react3.default.createElement(
	                    'div',
	                    { className: 'text-right' },
	                    _react3.default.createElement(
	                        'a',
	                        { onClick: this.props.onFindCoupon },
	                        this.props.lang['store.iBonus.i_have_a_coupon']
	                    )
	                ) : null
	            );
	        }
	    }]);
	    return SearchView;
	}(_react2.Component));
	
	exports.default = SearchView;
	module.exports = exports['default'];

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(68);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(69);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _server = __webpack_require__(645);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Slider: {
	        displayName: 'Slider'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Slider/Slider.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Slider = _wrapComponent('Slider')(function (_Component) {
	    (0, _inherits3.default)(Slider, _Component);
	
	    function Slider(props) {
	        (0, _classCallCheck3.default)(this, Slider);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).call(this, props));
	
	        _this.goToSlide = _this.goToSlide.bind(_this);
	
	        if (!(typeof _this.goToSlide === 'function')) {
	            throw new TypeError('Value of "this.goToSlide" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.goToSlide));
	        }
	
	        _this.handleDragStart = _this.handleDragStart.bind(_this);
	
	        if (!(typeof _this.handleDragStart === 'function')) {
	            throw new TypeError('Value of "this.handleDragStart" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.handleDragStart));
	        }
	
	        _this.handleDragMove = _this.handleDragMove.bind(_this);
	
	        if (!(typeof _this.handleDragMove === 'function')) {
	            throw new TypeError('Value of "this.handleDragMove" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.handleDragMove));
	        }
	
	        _this.handleDragEnd = _this.handleDragEnd.bind(_this);
	
	        if (!(typeof _this.handleDragEnd === 'function')) {
	            throw new TypeError('Value of "this.handleDragEnd" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.handleDragEnd));
	        }
	
	        return _this;
	    }
	
	    /*getDefaultProps() {
	        return {
	            loop: false,
	            selected: 0,
	            showArrows: true,
	            showNav: true,
	        };
	    }
	     getInitialState() {
	        return {
	            dragStart: 0,
	            dragStartTime: new Date(),
	            index: 0,
	            lastIndex: 0,
	            transition: false,
	        };
	    }*/
	
	    (0, _createClass3.default)(Slider, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var selected = this.props.selected;
	
	
	            this.setState({
	                index: selected,
	                lastIndex: selected
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var selected = this.props.selected;
	
	
	            if (selected !== nextProps.selected) {
	                this.goToSlide(nextProps.selected);
	            }
	        }
	    }, {
	        key: 'getDragX',
	        value: function getDragX(event, isTouch) {
	            return isTouch ? event.touches[0].pageX : event.pageX;
	        }
	    }, {
	        key: 'handleDragStart',
	        value: function handleDragStart(event, isTouch) {
	            var x = this.getDragX(event, isTouch);
	
	            this.setState({
	                dragStart: x,
	                dragStartTime: new Date(),
	                transition: false,
	                slideWidth: _server2.default.findDOMNode(this.refs.slider).offsetWidth
	            });
	        }
	    }, {
	        key: 'handleDragMove',
	        value: function handleDragMove(event, isTouch) {
	            var _state = this.state,
	                dragStart = _state.dragStart,
	                lastIndex = _state.lastIndex,
	                slideWidth = _state.slideWidth;
	
	
	            var x = this.getDragX(event, isTouch);
	            var offset = dragStart - x;
	            var percentageOffset = offset / slideWidth;
	            var newIndex = lastIndex + percentageOffset;
	            var SCROLL_OFFSET_TO_STOP_SCROLL = 30;
	
	            // Stop scrolling if you slide more than 30 pixels
	            if (Math.abs(offset) > SCROLL_OFFSET_TO_STOP_SCROLL) {
	                event.stopPropagation();
	                event.preventDefault();
	            }
	
	            this.setState({
	                index: newIndex
	            });
	        }
	    }, {
	        key: 'handleDragEnd',
	        value: function handleDragEnd() {
	            var children = this.props.children;
	            var _state2 = this.state,
	                dragStartTime = _state2.dragStartTime,
	                index = _state2.index,
	                lastIndex = _state2.lastIndex;
	
	
	            var timeElapsed = new Date().getTime() - dragStartTime.getTime();
	            var offset = lastIndex - index;
	            var velocity = Math.round(offset / timeElapsed * 10000);
	
	            var newIndex = Math.round(index);
	
	            if (Math.abs(velocity) > 5) {
	                newIndex = velocity < 0 ? lastIndex + 1 : lastIndex - 1;
	            }
	
	            if (newIndex < 0) {
	                newIndex = 0;
	            } else if (newIndex >= children.length) {
	                newIndex = children.length - 1;
	            }
	
	            this.setState({
	                dragStart: 0,
	                index: newIndex,
	                lastIndex: newIndex,
	                transition: true
	            });
	        }
	    }, {
	        key: 'goToSlide',
	        value: function goToSlide(index, event) {
	            var _this2 = this;
	
	            var _props = this.props,
	                children = _props.children,
	                loop = _props.loop;
	
	
	            if (event) {
	                event.preventDefault();
	                event.stopPropagation();
	            }
	
	            if (index < 0) {
	                index = loop ? children.length - 1 : 0;
	            } else if (index >= children.length) {
	                index = loop ? 0 : children.length - 1;
	            }
	
	            this.setState({
	                index: index,
	                lastIndex: index,
	                transition: true
	            }, function () {
	                if (_this2.props.onSlide) {
	                    _this2.props.onSlide({
	                        index: _this2.state.index,
	                        lastIndex: _this2.state.lastIndex,
	                        element: _this2.props.children[_this2.state.index]
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var View = _helpers.ThemeHelper.getViewForComponent('Slider');
	
	            return _react3.default.createElement(
	                View,
	                {
	                    handleDragStart: this.handleDragStart,
	                    handleDragMove: this.handleDragMove,
	                    handleDragEnd: this.handleDragEnd,
	                    transition: this.state.transition,
	                    index: this.state.index,
	                    showArrows: this.props.showArrows,
	                    showNav: this.props.showNav,
	                    loop: this.props.loop,
	                    lastIndex: this.state.lastIndex,
	                    goToSlide: this.goToSlide
	                },
	                this.props.children
	            );
	        }
	    }]);
	    return Slider;
	}(_react2.Component));
	
	exports.default = Slider;
	
	function _inspect(input, depth) {
	    var maxDepth = 4;
	    var maxKeys = 15;
	
	    if (depth === undefined) {
	        depth = 0;
	    }
	
	    depth += 1;
	
	    if (input === null) {
	        return 'null';
	    } else if (input === undefined) {
	        return 'void';
	    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	    } else if (Array.isArray(input)) {
	        if (input.length > 0) {
	            if (depth > maxDepth) return '[...]';
	
	            var first = _inspect(input[0], depth);
	
	            if (input.every(function (item) {
	                return _inspect(item, depth) === first;
	            })) {
	                return first.trim() + '[]';
	            } else {
	                return '[' + input.slice(0, maxKeys).map(function (item) {
	                    return _inspect(item, depth);
	                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	            }
	        } else {
	            return 'Array';
	        }
	    } else {
	        var keys = (0, _keys2.default)(input);
	
	        if (!keys.length) {
	            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	                return input.constructor.name;
	            } else {
	                return 'Object';
	            }
	        }
	
	        if (depth > maxDepth) return '{...}';
	        var indent = '  '.repeat(depth - 1);
	        var entries = keys.slice(0, maxKeys).map(function (key) {
	            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	        }).join('\n  ' + indent);
	
	        if (keys.length >= maxKeys) {
	            entries += '\n  ' + indent + '...';
	        }
	
	        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	        } else {
	            return '{\n  ' + indent + entries + '\n' + indent + '}';
	        }
	    }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	__webpack_require__(1099);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SliderView: {
	        displayName: 'SliderView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/Slider/default/SliderView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var SliderView = _wrapComponent('SliderView')(function (_Component) {
	    (0, _inherits3.default)(SliderView, _Component);
	
	    function SliderView() {
	        (0, _classCallCheck3.default)(this, SliderView);
	        return (0, _possibleConstructorReturn3.default)(this, (SliderView.__proto__ || (0, _getPrototypeOf2.default)(SliderView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(SliderView, [{
	        key: 'renderNav',
	        value: function renderNav() {
	            var _props = this.props,
	                children = _props.children,
	                lastIndex = _props.lastIndex,
	                goToSlide = _props.goToSlide;
	
	
	            var nav = children.map(function (slide, i) {
	                var buttonClasses = i === lastIndex ? 'Slider-navButton Slider-navButton--active' : 'Slider-navButton';
	                return _react3.default.createElement('button', {
	                    className: buttonClasses,
	                    key: i,
	                    onClick: function onClick(event) {
	                        return goToSlide(i, event);
	                    } });
	            });
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'Slider-nav' },
	                nav
	            );
	        }
	    }, {
	        key: 'renderArrows',
	        value: function renderArrows() {
	            var _props2 = this.props,
	                children = _props2.children,
	                loop = _props2.loop,
	                showNav = _props2.showNav,
	                lastIndex = _props2.lastIndex,
	                goToSlide = _props2.goToSlide;
	
	
	            var arrowsClasses = showNav ? 'Slider-arrows' : 'Slider-arrows Slider-arrows--noNav';
	
	            return _react3.default.createElement(
	                'div',
	                { className: arrowsClasses },
	                loop || lastIndex > 0 ? _react3.default.createElement('button', {
	                    className: 'Slider-arrow Slider-arrow--left',
	                    onClick: function onClick(event) {
	                        return goToSlide(lastIndex - 1, event);
	                    } }) : null,
	                loop || lastIndex < children.length - 1 ? _react3.default.createElement('button', {
	                    className: 'Slider-arrow Slider-arrow--right',
	                    onClick: function onClick(event) {
	                        return goToSlide(lastIndex + 1, event);
	                    } }) : null
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                children = _props3.children,
	                showArrows = _props3.showArrows,
	                showNav = _props3.showNav,
	                transition = _props3.transition,
	                index = _props3.index;
	
	
	            var slidesStyles = {
	                width: 100 * children.length + '%',
	                transform: 'translateX(' + -1 * index * (100 / children.length) + '%)'
	            };
	            var slidesClasses = transition ? 'Slider-slides Slider-slides--transition' : 'Slider-slides';
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'Slider', ref: 'slider' },
	                showArrows ? this.renderArrows() : null,
	                showNav ? this.renderNav() : null,
	                _react3.default.createElement(
	                    'div',
	                    {
	                        className: 'Slider-inner',
	                        onTouchStart: function onTouchStart(event) {
	                            return _this2.props.handleDragStart(event, true);
	                        },
	                        onTouchMove: function onTouchMove(event) {
	                            return _this2.props.handleDragMove(event, true);
	                        },
	                        onTouchEnd: function onTouchEnd() {
	                            return _this2.props.handleDragEnd(true);
	                        } },
	                    _react3.default.createElement(
	                        'div',
	                        {
	                            className: slidesClasses,
	                            style: slidesStyles },
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	    return SliderView;
	}(_react2.Component));
	
	exports.default = SliderView;
	module.exports = exports['default'];

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SliderWithQR: {
	        displayName: 'SliderWithQR'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/SliderWithQR/SliderWithQR.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var SliderWithQR = _wrapComponent('SliderWithQR')((_temp = _class = function (_React$Component) {
	    (0, _inherits3.default)(SliderWithQR, _React$Component);
	
	    function SliderWithQR() {
	        (0, _classCallCheck3.default)(this, SliderWithQR);
	        return (0, _possibleConstructorReturn3.default)(this, (SliderWithQR.__proto__ || (0, _getPrototypeOf2.default)(SliderWithQR)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(SliderWithQR, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('SliderWithQR');
	            return _react3.default.createElement(View, {
	                items: this.props.items,
	                autoplay: this.props.autoplay,
	                autoplaySpeed: this.props.autoplaySpeed,
	                count: 1,
	                updateProducts: this.props.updateProducts
	            });
	        }
	    }]);
	    return SliderWithQR;
	}(_react3.default.Component), _class.propTypes = {
	    items: _propTypes2.default.array,
	    updateProducts: _propTypes2.default.func
	}, _temp));
	
	exports.default = SliderWithQR;
	module.exports = exports['default'];

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(19);
	
	var _textEllipsis = __webpack_require__(262);
	
	var _textEllipsis2 = _interopRequireDefault(_textEllipsis);
	
	var _qrcode = __webpack_require__(1260);
	
	var _qrcode2 = _interopRequireDefault(_qrcode);
	
	var _helpers = __webpack_require__(15);
	
	var _components2 = __webpack_require__(16);
	
	var _utils = __webpack_require__(31);
	
	__webpack_require__(1100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SlideWithQR: {
	        displayName: 'SlideWithQR'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/SliderWithQR/default/SlideWithQR.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MAX_TITLE_LENGTH = 20;
	
	var SlideWithQR = _wrapComponent('SlideWithQR')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        currency: state.currency
	    };
	}), _dec(_class = (_temp = _class2 = function (_React$Component) {
	    (0, _inherits3.default)(SlideWithQR, _React$Component);
	
	    function SlideWithQR(props) {
	        (0, _classCallCheck3.default)(this, SlideWithQR);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (SlideWithQR.__proto__ || (0, _getPrototypeOf2.default)(SlideWithQR)).call(this, props));
	
	        _this.renderQRCode = function () {
	            if ((true) && _this.props.product) {
	                return _react3.default.createElement(_qrcode2.default, { value: window.location.origin + '/product/' + _this.props.product.id });
	            }
	
	            return null;
	        };
	
	        _this.state = {
	            countForSendBasket: 1
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(SlideWithQR, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                product = _props.product,
	                currency = _props.currency;
	            var id = product.id,
	                price = product.price,
	                name = product.name,
	                pictures = product.pictures,
	                description = product.description;
	
	            price = parseFloat(price);
	            var imgSrc = (0, _helpers.checkPicture)(pictures, true);
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'SlideWithQR u-full-height text-center', id: 'single-product' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'product-item-holder size-big single-product-gallery u-full-height' },
	                    _react3.default.createElement(_components2.ProductWishIcon, { product: product, inCard: true }),
	                    _react3.default.createElement(
	                        'div',
	                        { id: 'owl-single-product', className: 'flying-to-cart-holder u-full-height' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'SlideWithQR__content' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'single-product-gallery-item big', id: 'slide1' },
	                                _react3.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/product/' + id },
	                                    _react3.default.createElement('img', { className: ' flying-to-cart-img', alt: '', src: imgSrc })
	                                )
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'SlideWithQR__footer' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'container-fluid' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'row bottom-active' },
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'hidden-xs hidden-sm col-lg-3 col-md-3 qr-col' },
	                                            _react3.default.createElement(
	                                                'div',
	                                                { className: 'qr-wrapper' },
	                                                this.renderQRCode()
	                                            )
	                                        ),
	                                        _react3.default.createElement('div', { id: 'productName', className: 'col-xs-12 col-lg-6 col-md-4 product_title',
	                                            dangerouslySetInnerHTML: { __html: (0, _utils.cutText)(name, MAX_TITLE_LENGTH) }
	                                        }),
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'col-xs-12 visible-xs visible-sm' },
	                                            this.renderQRCode()
	                                        ),
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'col-lg-2 col-xs-12 col-md-4 col-sm-offset-0 col-md-offset-0 product_title' },
	                                            _react3.default.createElement(
	                                                'div',
	                                                { className: 'body-holder', id: 'active' },
	                                                _react3.default.createElement(
	                                                    'div',
	                                                    { className: 'body' },
	                                                    _react3.default.createElement(
	                                                        'div',
	                                                        { className: 'prices' },
	                                                        _react3.default.createElement(
	                                                            'div',
	                                                            { className: 'price-current' },
	                                                            _react3.default.createElement(_components2.MoneyValue, {
	                                                                value: price,
	                                                                icon: currency.icon,
	                                                                iconAfterValue: currency.icon_after_value
	                                                            })
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 bottom-row' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { id: 'addToBasketAndCount',
	                                                className: 'col-xs-12 col-lg-offset-4 col-sm-offset-3 col-lg-8 col-md-6 col-md-offset-6 counter' },
	                                            _react3.default.createElement(
	                                                'div',
	                                                { className: 'body-holder', id: 'active' },
	                                                _react3.default.createElement(_components2.QuantityProduct, {
	                                                    value: this.state.countForSendBasket,
	                                                    callback: function callback(newCount) {
	                                                        _this2.setState({ countForSendBasket: newCount });
	                                                    }
	                                                }),
	                                                _react3.default.createElement(_components2.AddToBasket, {
	                                                    id: 'addto-cart',
	                                                    product: product,
	                                                    className: ['huge'],
	                                                    style: { marginTop: '11px' },
	                                                    count: this.state.countForSendBasket,
	                                                    updateProducts: this.props.updateProducts
	                                                })
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return SlideWithQR;
	}(_react3.default.Component), _class2.propTypes = {
	    product: _propTypes2.default.object,
	    updateProducts: _propTypes2.default.func,
	    currency: _propTypes2.default.object
	}, _temp)) || _class));
	
	exports.default = SlideWithQR;
	module.exports = exports['default'];

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(68);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(69);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSlick = __webpack_require__(756);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _lodash = __webpack_require__(177);
	
	var _SlideWithQR = __webpack_require__(1769);
	
	var _SlideWithQR2 = _interopRequireDefault(_SlideWithQR);
	
	__webpack_require__(1103);
	
	__webpack_require__(1102);
	
	__webpack_require__(1101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SliderWithQRView: {
	        displayName: 'SliderWithQRView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/SliderWithQR/default/SliderWithQRView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	// id таймера автоплея
	var timerId = void 0;
	// список продуктов, которые ожидают обновления
	var _preparedItemsForUpdate = null;
	
	var SliderWithQRView = _wrapComponent('SliderWithQRView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(SliderWithQRView, _Component);
	
	    function SliderWithQRView(props) {
	        (0, _classCallCheck3.default)(this, SliderWithQRView);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (SliderWithQRView.__proto__ || (0, _getPrototypeOf2.default)(SliderWithQRView)).call(this));
	
	        _this.checkForPreparedAndUpdate = _this.checkForPreparedAndUpdate.bind(_this);
	        // Передаем в стейт, чтобы можно было контролировать обновление списка
	
	        if (!(typeof _this.checkForPreparedAndUpdate === 'function')) {
	            throw new TypeError('Value of "this.checkForPreparedAndUpdate" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.checkForPreparedAndUpdate));
	        }
	
	        _this.state = {
	            items: props.items
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(SliderWithQRView, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.stopAutoplay();
	            this.startAutoplay();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nProps) {
	            // Если список обновлися свыше
	            if (!(0, _lodash.isEqual)(nProps.items, this.state.items)) {
	                // Если текущий список пустой
	                if (!Array.isArray(this.state.items) || !this.state.items.length) {
	                    return this.setState({
	                        items: nProps.items
	                    });
	                }
	                // Подготовливаем к след. тику обновления
	                _preparedItemsForUpdate = nProps.items;
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nProp, nState) {
	            // Не обновляем если ничего не поменялось
	            return !(0, _lodash.isEqual)(this.state, nState);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.stopAutoplay();
	            this.startAutoplay();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.stopAutoplay();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var items = this.state.items;
	            // Свои классы применяеются только на внутреннем span, на внешний - слайдер
	            // навешивает свое барахло
	
	            var prevArrow = _react3.default.createElement(
	                'span',
	                null,
	                _react3.default.createElement(
	                    'span',
	                    { className: 'SliderWithQR__prev-arrow' },
	                    _react3.default.createElement('img', { src: '/assets/images/prev.svg', alt: 'Prev Slide' })
	                )
	            );
	
	            var nextArrow = _react3.default.createElement(
	                'span',
	                null,
	                _react3.default.createElement(
	                    'span',
	                    { className: 'SliderWithQR__next-arrow' },
	                    _react3.default.createElement('img', { src: '/assets/images/next.svg', alt: 'Next Slide' })
	                )
	            );
	            var slideCount = this.props.count || 3;
	            var sliderON = true;
	            if (items.length === 1) {
	                sliderON = false;
	            }
	
	            var settings = {
	                arrows: sliderON,
	                className: 'SlickSlider SliderWithQR__slick-slider u-full-height',
	                centerMode: false,
	                dots: false,
	                infinite: sliderON,
	                lazyLoad: false,
	                // Реализуем сами, чтобы можно было сделать паузу
	                autoplay: false,
	                // autoplaySpeed: this.props.autoplaySpeed,
	
	                // responsive: [
	                //         { breakpoint: 480, settings: { slidesToShow: 1 } },
	                //         { breakpoint: 768, settings: { slidesToShow: 1 } },
	                //         { breakpoint: 992, settings: { slidesToShow: 1 } },
	                //         { breakpoint: 12000, settings: { slidesToShow: slideCount } },
	                //     ],
	                nextArrow: nextArrow,
	                prevArrow: prevArrow,
	                speed: 500, //?
	                slidesToShow: slideCount,
	                slidesToScroll: 1,
	                swipeToSlide: sliderON,
	                // После смены слайда(конец анимации) делаем обновление списка, если возможно
	                afterChange: this.checkForPreparedAndUpdate
	            };
	            if (items.length === 0) {
	                return null;
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'SliderWithQR u-full-height' },
	                _react3.default.createElement(
	                    _reactSlick2.default,
	                    (0, _extends3.default)({ ref: function ref(s) {
	                            return _this2.slickSliderComponent = s;
	                        } }, settings),
	                    items.map(function (item, i) {
	                        return _react3.default.createElement(
	                            'div',
	                            { className: 'SliderWithQR__slide u-full-height', key: item.$uid },
	                            _react3.default.createElement(_SlideWithQR2.default, { product: item, updateProducts: _this2.props.updateProducts })
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'startAutoplay',
	        value: function startAutoplay() {
	            var _this3 = this;
	
	            if (!this.props.autoplay) {
	                return;
	            }
	
	            timerId = setTimeout(function () {
	                return _this3.nextSlide(), _this3.startAutoplay();
	            }, this.props.autoplaySpeed);
	        }
	    }, {
	        key: 'stopAutoplay',
	        value: function stopAutoplay() {
	            clearTimeout(timerId);
	        }
	    }, {
	        key: 'nextSlide',
	        value: function nextSlide() {
	            this.slickSliderComponent.slickNext();
	        }
	    }, {
	        key: 'prevSlide',
	        value: function prevSlide() {
	            this.slickSliderComponent.slickPrev();
	        }
	    }, {
	        key: 'checkForPreparedAndUpdate',
	        value: function checkForPreparedAndUpdate() {
	            if (_preparedItemsForUpdate !== null) {
	                this.setState({
	                    items: _preparedItemsForUpdate
	                });
	
	                _preparedItemsForUpdate = null;
	            }
	        }
	    }]);
	    return SliderWithQRView;
	}(_react2.Component), _class.propTypes = {
	    items: _propTypes2.default.array,
	    count: _propTypes2.default.number,
	    autoplay: _propTypes2.default.bool,
	    autoplaySpeed: _propTypes2.default.number,
	    updateProducts: _propTypes2.default.func
	}, _temp));
	
	exports.default = SliderWithQRView;
	
	function _inspect(input, depth) {
	    var maxDepth = 4;
	    var maxKeys = 15;
	
	    if (depth === undefined) {
	        depth = 0;
	    }
	
	    depth += 1;
	
	    if (input === null) {
	        return 'null';
	    } else if (input === undefined) {
	        return 'void';
	    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	    } else if (Array.isArray(input)) {
	        if (input.length > 0) {
	            if (depth > maxDepth) return '[...]';
	
	            var first = _inspect(input[0], depth);
	
	            if (input.every(function (item) {
	                return _inspect(item, depth) === first;
	            })) {
	                return first.trim() + '[]';
	            } else {
	                return '[' + input.slice(0, maxKeys).map(function (item) {
	                    return _inspect(item, depth);
	                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	            }
	        } else {
	            return 'Array';
	        }
	    } else {
	        var keys = (0, _keys2.default)(input);
	
	        if (!keys.length) {
	            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	                return input.constructor.name;
	            } else {
	                return 'Object';
	            }
	        }
	
	        if (depth > maxDepth) return '{...}';
	        var indent = '  '.repeat(depth - 1);
	        var entries = keys.slice(0, maxKeys).map(function (key) {
	            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	        }).join('\n  ' + indent);
	
	        if (keys.length >= maxKeys) {
	            entries += '\n  ' + indent + '...';
	        }
	
	        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	        } else {
	            return '{\n  ' + indent + entries + '\n' + indent + '}';
	        }
	    }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderWithQR = undefined;
	
	var _SliderWithQR2 = __webpack_require__(1768);
	
	var _SliderWithQR3 = _interopRequireDefault(_SliderWithQR2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SliderWithQR = _SliderWithQR3.default;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _ThemeHelper = __webpack_require__(113);
	
	var _ThemeHelper2 = _interopRequireDefault(_ThemeHelper);
	
	var _helpers = __webpack_require__(15);
	
	var _utils = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SocialRow: {
	        displayName: 'SocialRow'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/SocialRow/SocialRow.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var SocialRow = _wrapComponent('SocialRow')(function (_Component) {
	    (0, _inherits3.default)(SocialRow, _Component);
	
	    function SocialRow() {
	        (0, _classCallCheck3.default)(this, SocialRow);
	        return (0, _possibleConstructorReturn3.default)(this, (SocialRow.__proto__ || (0, _getPrototypeOf2.default)(SocialRow)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(SocialRow, [{
	        key: 'render',
	        value: function render() {
	            var View = _ThemeHelper2.default.getViewForComponent('SocialRow');
	            var _props$product = this.props.product,
	                name = _props$product.name,
	                description = _props$product.description,
	                pictures = _props$product.pictures,
	                seoParams = _props$product.seoParams;
	
	            description = (0, _utils.stripTags)(description);
	            if (description.length > 250) {
	                description = description.substr(0, 250) + '...';
	            }
	            var url = "";
	            if (true) {
	                url = global.location.host;
	            } else {
	                url = global.__HostName__;
	            }
	            var imgSrc = (0, _helpers.checkPicture)(pictures);
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'social-block' },
	                _react3.default.createElement(_reactHelmet2.default, {
	                    meta: [{ property: "og:url", content: url }, { property: "og:type", content: "article" }, { property: "og:title", content: name }, { property: "og:description", content: description }, { property: "og:image", content: imgSrc }, { property: "twitter:description", content: (0, _utils.stripTags)(description) }] }),
	                _react3.default.createElement(View, this.props)
	            );
	        }
	    }]);
	    return SocialRow;
	}(_react2.Component));
	
	exports.default = SocialRow;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _reactDom = __webpack_require__(28);
	
	var _helpers = __webpack_require__(15);
	
	var _utils = __webpack_require__(31);
	
	__webpack_require__(1104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SocialRowView: {
	        displayName: 'SocialRowView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/SocialRow/default/SocialRowView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var SocialRowView = _wrapComponent('SocialRowView')(function (_Component) {
	    (0, _inherits3.default)(SocialRowView, _Component);
	
	    function SocialRowView() {
	        (0, _classCallCheck3.default)(this, SocialRowView);
	        return (0, _possibleConstructorReturn3.default)(this, (SocialRowView.__proto__ || (0, _getPrototypeOf2.default)(SocialRowView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(SocialRowView, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props$product = this.props.product,
	                name = _props$product.name,
	                description = _props$product.description,
	                pictures = _props$product.pictures,
	                seoParams = _props$product.seoParams;
	
	            var url = global.location.href; //.href - полный путь host - короткий
	            var imgSrc = (0, _helpers.checkPicture)(pictures);
	            description = description ? (0, _utils.stripTags)(description) : " ";
	            if (description.length > 250) {
	                description = description.substr(0, 250) + '...';
	            }
	            var myShare = this.refs.yandex_buttons;
	            try {
	                var share = Ya.share2(myShare, {
	                    content: {
	                        url: url,
	                        title: name,
	                        description: description,
	                        image: imgSrc
	                    },
	                    theme: {
	                        services: 'vkontakte,facebook,twitter,odnoklassniki'
	                    }
	                });
	            } catch (e) {}
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react3.default.createElement('div', { className: 'social-row' });
	        }
	    }]);
	    return SocialRowView;
	}(_react2.Component));
	
	exports.default = SocialRowView;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SocialRow = undefined;
	
	var _SocialRow2 = __webpack_require__(1772);
	
	var _SocialRow3 = _interopRequireDefault(_SocialRow2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SocialRow = _SocialRow3.default;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp2;
	
	var _reactRedux = __webpack_require__(12);
	
	var _translate_pipo = __webpack_require__(768);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    TranslatePipo: {
	        displayName: 'TranslatePipo'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/TranslatePipo/index.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var TranslatePipo = _wrapComponent('TranslatePipo')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        langList: state.translate_pipo.list,
	        currency: state.currency
	    };
	}, { getLang: _translate_pipo.getLang }), _dec(_class = (_temp2 = _class2 = function (_Component) {
	    (0, _inherits3.default)(TranslatePipo, _Component);
	
	    function TranslatePipo() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, TranslatePipo);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TranslatePipo.__proto__ || (0, _getPrototypeOf2.default)(TranslatePipo)).call.apply(_ref, [this].concat(args))), _this), _this.renderLang = function () {
	            var _this$props = _this.props,
	                title = _this$props.title,
	                langList = _this$props.langList;
	
	
	            if (langList.hasOwnProperty(title)) {
	                var strOut = langList[title];
	
	                if (_this.props.additionalValues) {
	                    _this.props.additionalValues.forEach(function (item, i) {
	                        var re = new RegExp('\\{' + i + '\\}', 'g');
	                        var putItem = langList.hasOwnProperty(item) ? langList[item] : item;
	                        strOut = strOut.replace(re, putItem);
	                    });
	                }
	
	                return strOut;
	            }
	
	            if (_this.props['default']) {
	                return _this.props['default'];
	            }
	
	            return title;
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(TranslatePipo, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!this.props.langList.hasOwnProperty(this.props.title)) {
	                this.props.getLang(this.props.currency.lang.slug);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            if (this.props.raw) {
	                return _react3.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.renderLang() } });
	            }
	
	            return _react3.default.createElement(
	                'span',
	                null,
	                this.renderLang()
	            );
	        }
	    }]);
	    return TranslatePipo;
	}(_react2.Component), _class2.propTypes = {
	    title: _react2.PropTypes.string.isRequired,
	    default: _react2.PropTypes.string,
	    getLang: _react2.PropTypes.func,
	    langList: _react2.PropTypes.object,
	    raw: _react2.PropTypes.bool, //с html  тегами
	    additionalValues: _react2.PropTypes.array, //для вставки в {0} {1}
	    currency: _react2.PropTypes.object.isRequired
	}, _class2.defaultProps = {
	    raw: false
	}, _temp2)) || _class));
	
	exports.default = TranslatePipo;
	module.exports = exports['default'];

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 28.11.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    UserInfo: {
	        displayName: 'UserInfo'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/UserProfile/UserInfo/UserInfo.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var UserInfo = _wrapComponent('UserInfo')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(UserInfo, _Component);
	
	    function UserInfo(props) {
	        (0, _classCallCheck3.default)(this, UserInfo);
	        return (0, _possibleConstructorReturn3.default)(this, (UserInfo.__proto__ || (0, _getPrototypeOf2.default)(UserInfo)).call(this, props));
	    }
	
	    (0, _createClass3.default)(UserInfo, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('UserInfo', null, { folderName: 'UserProfile/UserInfo' });
	
	            return _react3.default.createElement(View, this.props);
	        }
	    }]);
	    return UserInfo;
	}(_react2.Component), _class.propTypes = {
	    acceptValue: _react2.PropTypes.func.isRequired,
	    activeField: _react2.PropTypes.func.isRequired,
	    changeField: _react2.PropTypes.func.isRequired,
	    changePassword: _react2.PropTypes.func.isRequired,
	    confirmMail: _react2.PropTypes.func.isRequired,
	    confirmPhone: _react2.PropTypes.func.isRequired,
	    lang: _react2.PropTypes.object.isRequired,
	    profile: _react2.PropTypes.object.isRequired,
	    resetField: _react2.PropTypes.func.isRequired,
	    setting: _react2.PropTypes.object.isRequired,
	    user: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object.isRequired
	}, _temp));
	
	exports.default = UserInfo;
	module.exports = exports['default'];

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	__webpack_require__(1105);
	
	var _Slider = __webpack_require__(760);
	
	var _UserProfile = __webpack_require__(382);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  UserInfoView: {
	    displayName: 'UserInfoView'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/usr/local/ibonus/src/components/UserProfile/UserInfo/default/UserInfoView.jsx',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var UserInfoView = _wrapComponent('UserInfoView')((_temp = _class = function (_Component) {
	  (0, _inherits3.default)(UserInfoView, _Component);
	
	  function UserInfoView(props) {
	    (0, _classCallCheck3.default)(this, UserInfoView);
	    return (0, _possibleConstructorReturn3.default)(this, (UserInfoView.__proto__ || (0, _getPrototypeOf2.default)(UserInfoView)).call(this, props));
	  }
	
	  (0, _createClass3.default)(UserInfoView, [{
	    key: 'render',
	    value: function render() {
	      return _react3.default.createElement(
	        'div',
	        { className: 'profile' },
	        _react3.default.createElement(
	          'h2',
	          { className: 'title' },
	          this.props.lang['store.user_profile_menu.profile']
	        ),
	        _react3.default.createElement(
	          'div',
	          { className: 'row' },
	          _react3.default.createElement(
	            'form',
	            { className: 'form-horizontal col-sm-12' },
	            _react3.default.createElement(
	              'div',
	              { className: 'row' },
	              this.renderUserBalance(),
	              this.renderUserProfileFields(),
	              _react3.default.createElement(
	                'div',
	                { className: 'form-group align-bottom col-sm-12 col-xs-12' },
	                _react3.default.createElement(
	                  'div',
	                  { className: 'row' },
	                  _react3.default.createElement(
	                    'div',
	                    { className: 'col-md-10 col-sm-9 col-sm-offset-3 col-md-offset-2 col-xs-12' },
	                    _react3.default.createElement(
	                      'a',
	                      { className: 'button_more', onClick: this.props.changePassword },
	                      this.props.lang['store.password_change.change_password']
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderUserBalance',
	    value: function renderUserBalance() {
	      var _props = this.props,
	          lang = _props.lang,
	          currency = _props.currency;
	
	      var AccountsList = this.props.user.amount;
	
	      if (!Array.isArray(AccountsList) || AccountsList.length === 0) {
	        return null;
	      }
	
	      return _react3.default.createElement(
	        'div',
	        { className: 'col-xs-12' },
	        _react3.default.createElement(
	          'div',
	          { className: 'amount_wrap' },
	          _react3.default.createElement(
	            'p',
	            { className: 'balans_title' },
	            lang['store.user_info.balance'],
	            ':'
	          ),
	          _react3.default.createElement(
	            _Slider.Slider,
	            { loop: false, selected: 0, showArrows: true, showNav: true },
	            AccountsList.map(function (account) {
	              var symbol = account.currency.toUpperCase();
	              var amount = account.amount;
	
	              // Костыль. По хорошему, нужно получать весь список иконок из api
	
	              var symbolToIconMap = {
	                RUB: {
	                  icon: 'fas fa-ruble-sign',
	                  icon_after_value: true
	                },
	                UAH: {
	                  icon: 'fas fa-hryvnia',
	                  icon_after_value: true
	                },
	                KZT: {
	                  icon: 'fas fa-tenge',
	                  icon_after_value: true
	                },
	                EUR: {
	                  icon: 'fas fa-euro-sign',
	                  icon_after_value: false
	                },
	                USD: {
	                  icon: 'fas fa-dollar-sign',
	                  icon_after_value: false
	                },
	                GBP: {
	                  icon: 'fas fa-pound-sign',
	                  icon_after_value: false
	                },
	                MDL: {
	                  icon: 'L',
	                  icon_after_value: false
	                },
	                BYN: {
	                  icon: 'Br',
	                  icon_after_value: false
	                },
	                TRY: {
	                  icon: '₺',
	                  icon_after_value: false
	                },
	                AED: {
	                  icon: 'Dh',
	                  icon_after_value: false
	                },
	                SGD: {
	                  icon: 'S$',
	                  icon_after_value: false
	                },
	                UZS: {
	                  icon: 'сўм',
	                  icon_after_value: false
	                }
	              };
	
	              return symbolToIconMap[symbol] ? _react3.default.createElement(
	                'div',
	                { className: 'one_slider', style: { backgroundColor: '#fff' }, key: symbol },
	                _react3.default.createElement(_components2.MoneyValue, {
	                  value: amount,
	                  icon: symbolToIconMap[symbol].icon,
	                  iconAfterValue: symbolToIconMap[symbol].icon_after_value
	                })
	              ) : _react3.default.createElement(
	                'div',
	                { className: 'one_slider', style: { backgroundColor: '#fff' }, key: symbol },
	                amount
	              );
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderUserProfileFields',
	    value: function renderUserProfileFields() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          lang = _props2.lang,
	          setting = _props2.setting,
	          profile = _props2.profile,
	          user = _props2.user;
	      var additionalFieldSettings = setting.additionalFieldSettings;
	
	
	      if (!Array.isArray(additionalFieldSettings) || additionalFieldSettings.length === 0) {
	        return null;
	      }
	
	      return additionalFieldSettings.map(function (field, i) {
	        var typeAdditionalField = field.typeAdditionalField,
	            show_in_profile = field.show_in_profile;
	
	        var slug = typeAdditionalField.slug === 'username' ? 'name' : typeAdditionalField.slug;
	        var currentValue = '';
	
	        if (!show_in_profile) {
	          return null;
	        }
	
	        if (slug === 'ul_name' || slug === 'inn') {
	          currentValue = user.confirmed[slug];
	        } else {
	          currentValue = user[slug];
	        }
	
	        return _react3.default.createElement(_UserProfile.UserInfoRowItem, {
	          currentValue: currentValue,
	          description: typeAdditionalField.description,
	          disabled: profile['disabled_' + slug],
	          id: slug,
	          key: 'UserInfoRowItem-' + i,
	          label: typeAdditionalField.lang_data,
	          lang: lang,
	          onClickAccept: function onClickAccept() {
	            return _this2.props.acceptValue(slug);
	          },
	          onClickCancel: function onClickCancel() {
	            return _this2.props.resetField(slug);
	          },
	          onClickChange: function onClickChange() {
	            return _this2.props.activeField(slug);
	          },
	          onClickConfirm_email: _this2.props.confirmMail,
	          onClickConfirm_phone: _this2.props.confirmPhone,
	          user: user,
	          validate: profile.validate,
	          value: profile[slug],
	          onChange: function onChange(e) {
	            return _this2.props.changeField({
	              name: slug,
	              value: e.target.value
	            });
	          }
	        });
	      });
	    }
	  }]);
	  return UserInfoView;
	}(_react2.Component), _class.propTypes = {
	  acceptValue: _react2.PropTypes.func.isRequired,
	  activeField: _react2.PropTypes.func.isRequired,
	  changeField: _react2.PropTypes.func.isRequired,
	  changePassword: _react2.PropTypes.func.isRequired,
	  confirmMail: _react2.PropTypes.func.isRequired,
	  confirmPhone: _react2.PropTypes.func.isRequired,
	  lang: _react2.PropTypes.object.isRequired,
	  profile: _react2.PropTypes.object.isRequired,
	  resetField: _react2.PropTypes.func.isRequired,
	  setting: _react2.PropTypes.object.isRequired,
	  user: _react2.PropTypes.object,
	  currency: _react2.PropTypes.object.isRequired
	}, _class.defaultProps = {
	  user: {
	    confirmed: {}
	  }
	}, _temp));
	
	exports.default = UserInfoView;
	module.exports = exports['default'];

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserInfo = undefined;
	
	var _UserInfo2 = __webpack_require__(1776);
	
	var _UserInfo3 = _interopRequireDefault(_UserInfo2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.UserInfo = _UserInfo3.default;

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 21.04.17.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    UserInfoRowItem: {
	        displayName: 'UserInfoRowItem'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/UserProfile/UserInfoRowItem/UserInfoRowItem.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var UserInfoRowItem = _wrapComponent('UserInfoRowItem')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(UserInfoRowItem, _Component);
	
	    function UserInfoRowItem(props) {
	        (0, _classCallCheck3.default)(this, UserInfoRowItem);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (UserInfoRowItem.__proto__ || (0, _getPrototypeOf2.default)(UserInfoRowItem)).call(this, props));
	
	        _this.onClickConfirm = function (slug) {
	            var funcConfirm = _this.props['onClickConfirm_' + slug];
	
	            if (funcConfirm) {
	                // если передан обработчик - вызовем его
	                funcConfirm();
	            }
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(UserInfoRowItem, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('UserInfoRowItem', null, { folderName: 'UserProfile/UserInfoRowItem' });
	
	            return _react3.default.createElement(View, (0, _extends3.default)({}, this.props, {
	                onClickConfirm: this.onClickConfirm
	            }));
	        }
	    }]);
	    return UserInfoRowItem;
	}(_react2.Component), _class.propTypes = {
	    currentValue: _react2.PropTypes.string,
	    description: _react2.PropTypes.string,
	    disabled: _react2.PropTypes.bool,
	    id: _react2.PropTypes.string,
	    label: _react2.PropTypes.string,
	    lang: _react2.PropTypes.object.isRequired,
	    onChange: _react2.PropTypes.func,
	    onClickAccept: _react2.PropTypes.func,
	    onClickCancel: _react2.PropTypes.func,
	    onClickChange: _react2.PropTypes.func,
	    onClickConfirm: _react2.PropTypes.func,
	    user: _react2.PropTypes.object,
	    validate: _react2.PropTypes.object,
	    value: _react2.PropTypes.string
	}, _temp));
	
	exports.default = UserInfoRowItem;
	module.exports = exports['default'];

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 21.04.17.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	__webpack_require__(1106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	  UserInfoRowItemView: {
	    displayName: 'UserInfoRowItemView'
	  }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	  filename: '/usr/local/ibonus/src/components/UserProfile/UserInfoRowItem/default/UserInfoRowItemView.jsx',
	  components: _components,
	  locals: [],
	  imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	  return function (Component) {
	    return _reactTransformCatchErrors2(Component, id);
	  };
	}
	
	var UserInfoRowItemView = _wrapComponent('UserInfoRowItemView')((_temp = _class = function (_Component) {
	  (0, _inherits3.default)(UserInfoRowItemView, _Component);
	
	  function UserInfoRowItemView(props) {
	    (0, _classCallCheck3.default)(this, UserInfoRowItemView);
	    return (0, _possibleConstructorReturn3.default)(this, (UserInfoRowItemView.__proto__ || (0, _getPrototypeOf2.default)(UserInfoRowItemView)).call(this, props));
	  }
	
	  (0, _createClass3.default)(UserInfoRowItemView, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          user = _props.user,
	          id = _props.id,
	          lang = _props.lang;
	
	      var fieldName = id === 'username' ? 'name' : id;
	
	      return _react3.default.createElement(
	        'div',
	        { className: 'form-group col-sm-12 col-xs-12' },
	        _react3.default.createElement(
	          'div',
	          { className: 'row' },
	          _react3.default.createElement(
	            'div',
	            { className: 'col-xs-3 col-md-2' },
	            _react3.default.createElement(
	              'label',
	              {
	                htmlFor: fieldName,
	                className: 'control-label'
	              },
	              lang[this.props.label]
	            )
	          ),
	          _react3.default.createElement(
	            'div',
	            { className: 'col-xs-7 col-md-8' },
	            _react3.default.createElement('input', {
	              className: 'form-control le-input',
	              disabled: !this.props.disabled,
	              id: fieldName,
	              onChange: this.props.onChange,
	              type: 'text',
	              value: this.props.value
	            }),
	            this.props.validate[fieldName] ? _react3.default.createElement(
	              'div',
	              null,
	              _react3.default.createElement('i', { className: 'fa fa-exclamation-circle input_after_icon' }),
	              _react3.default.createElement(
	                'span',
	                null,
	                this.props.validate[fieldName]
	              )
	            ) : null,
	            !this.props.currentValue || !this.props.value ? _react3.default.createElement(
	              'div',
	              null,
	              _react3.default.createElement('i', { className: 'fa fa-exclamation-circle input_after_icon' }),
	              fieldName === 'name' ? _react3.default.createElement(
	                'span',
	                null,
	                lang['store.user_info_row_item.enter_name']
	              ) : _react3.default.createElement(
	                'span',
	                null,
	                lang['store.user_info_row_item.required']
	              )
	            ) : null,
	            user[fieldName] && fieldName !== 'name' && !user.confirmed['confirmed_' + id] && !user.confirmed[id] && this.props.value ? _react3.default.createElement(
	              'div',
	              { className: 'accept-area' },
	              _react3.default.createElement('i', { className: 'fa fa-exclamation-circle input_after_icon' }),
	              _react3.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    _this2.props.onClickConfirm(id);
	                  } },
	                lang['store.user_info_row_item.confirm']
	              )
	            ) : null
	          ),
	          _react3.default.createElement(
	            'div',
	            { className: 'col-xs-2 edit_buttons_wrap' },
	            !this.props.disabled ? _react3.default.createElement(
	              'button',
	              {
	                className: 'edit_pencil',
	                'data-show': !this.props.disabled,
	                onClick: this.props.onClickChange,
	                type: 'button'
	              },
	              _react3.default.createElement('i', { className: 'fa fa-pencil-square' })
	            ) : null,
	            _react3.default.createElement(
	              'button',
	              {
	                className: 'edit_cancel',
	                'data-show': !this.props.disabled,
	                onClick: this.props.onClickCancel,
	                type: 'button'
	              },
	              _react3.default.createElement('i', { className: 'fa fa-window-close' })
	            ),
	            _react3.default.createElement(
	              'button',
	              {
	                className: 'edit_ok',
	                'data-show': !this.props.disabled,
	                onClick: this.props.onClickAccept,
	                type: 'button'
	              },
	              _react3.default.createElement('i', { className: 'fa fa-check-square' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return UserInfoRowItemView;
	}(_react2.Component), _class.propTypes = {
	  currentValue: _react2.PropTypes.string,
	  description: _react2.PropTypes.string,
	  disabled: _react2.PropTypes.bool,
	  id: _react2.PropTypes.string,
	  label: _react2.PropTypes.string,
	  lang: _react2.PropTypes.object,
	  onChange: _react2.PropTypes.func,
	  onClickAccept: _react2.PropTypes.func,
	  onClickCancel: _react2.PropTypes.func,
	  onClickChange: _react2.PropTypes.func,
	  onClickConfirm: _react2.PropTypes.func,
	  user: _react2.PropTypes.object,
	  validate: _react2.PropTypes.object,
	  value: _react2.PropTypes.string
	}, _temp));
	
	exports.default = UserInfoRowItemView;
	module.exports = exports['default'];

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserInfoRowItem = undefined;
	
	var _UserInfoRowItem2 = __webpack_require__(1779);
	
	var _UserInfoRowItem3 = _interopRequireDefault(_UserInfoRowItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.UserInfoRowItem = _UserInfoRowItem3.default;

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 08.11.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    UserProfile: {
	        displayName: 'UserProfile'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/UserProfile/UserProfile.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var UserProfile = _wrapComponent('UserProfile')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(UserProfile, _Component);
	
	    function UserProfile() {
	        (0, _classCallCheck3.default)(this, UserProfile);
	        return (0, _possibleConstructorReturn3.default)(this, (UserProfile.__proto__ || (0, _getPrototypeOf2.default)(UserProfile)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(UserProfile, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('UserProfile');
	
	            return _react3.default.createElement(View, this.props);
	        }
	    }]);
	    return UserProfile;
	}(_react2.Component), _class.propTypes = {
	    acceptValue: _react2.PropTypes.func.isRequired,
	    activeField: _react2.PropTypes.func.isRequired,
	    changeField: _react2.PropTypes.func.isRequired,
	    changePassword: _react2.PropTypes.func.isRequired,
	    confirmMail: _react2.PropTypes.func.isRequired,
	    confirmPhone: _react2.PropTypes.func.isRequired,
	    lang: _react2.PropTypes.object.isRequired,
	    profile: _react2.PropTypes.object.isRequired,
	    resetField: _react2.PropTypes.func.isRequired,
	    setting: _react2.PropTypes.object.isRequired,
	    user: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object.isRequired
	}, _temp));
	
	exports.default = UserProfile;
	module.exports = exports['default'];

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    UserProfileMenu: {
	        displayName: 'UserProfileMenu'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/UserProfile/UserProfileMenu/UserProfileMenu.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var UserProfileMenu = _wrapComponent('UserProfileMenu')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        user: state.auth.user,
	        lang: state.lang
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(UserProfileMenu, _Component);
	
	    function UserProfileMenu() {
	        (0, _classCallCheck3.default)(this, UserProfileMenu);
	        return (0, _possibleConstructorReturn3.default)(this, (UserProfileMenu.__proto__ || (0, _getPrototypeOf2.default)(UserProfileMenu)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(UserProfileMenu, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('UserProfileMenu', null, { folderName: 'UserProfile/UserProfileMenu' }),
	                _props = this.props,
	                active = _props.active,
	                user = _props.user,
	                lang = _props.lang;
	
	
	            return _react3.default.createElement(View, {
	                active: active,
	                user: user,
	                lang: lang
	            });
	        }
	    }]);
	    return UserProfileMenu;
	}(_react2.Component), _class2.propTypes = {
	    active: _react2.PropTypes.string.isRequired,
	    user: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object
	}, _class2.defaultProps = {
	    user: {}
	}, _temp)) || _class));
	
	exports.default = UserProfileMenu;
	module.exports = exports['default'];

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp2;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _reactRouter = __webpack_require__(19);
	
	var _constants = __webpack_require__(18);
	
	__webpack_require__(1107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    UserProfileMenuView: {
	        displayName: 'UserProfileMenuView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/UserProfile/UserProfileMenu/default/UserProfileMenuView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var UserProfileMenuView = _wrapComponent('UserProfileMenuView')((_dec = (0, _reactRedux.connect)(null, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
	    (0, _inherits3.default)(UserProfileMenuView, _Component);
	
	    function UserProfileMenuView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, UserProfileMenuView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = UserProfileMenuView.__proto__ || (0, _getPrototypeOf2.default)(UserProfileMenuView)).call.apply(_ref, [this].concat(args))), _this), _this.handleRedirect = function (e) {
	            var pushState = _this.props.pushState;
	
	
	            pushState('/personal/' + e.target.value);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    /**
	     * Редирект от выбора селекта
	     */
	
	
	    (0, _createClass3.default)(UserProfileMenuView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                active = _props.active,
	                user = _props.user,
	                lang = _props.lang;
	
	
	            var resultFull = void 0,
	                resultShort = void 0,
	                username = void 0;
	
	            var activePage = {
	                activeProfile: false,
	                activeOrder: false,
	                activeAddresses: false,
	                activeBasket: false,
	                activeFavor: false,
	                activeOperations: false
	            };
	            var activeSelect = 'profile';
	
	            // TODO LANG проверить, как будет работать при языке, отличном от русского
	            switch (active) {
	                case 'Профиль':
	                    activePage.activeProfile = true;
	                    activeSelect = 'profile';
	                    break;
	                case 'Заказы':
	                    activePage.activeOrder = true;
	                    activeSelect = 'order-list';
	                    break;
	                case 'Адреса':
	                    activePage.activeAddresses = true;
	                    activeSelect = 'addresses';
	                    break;
	                case 'Выписка по счёту':
	                    activePage.activeOperations = true;
	                    activeSelect = 'operations';
	                    break;
	                case 'Избранное':
	                    activePage.activeFavor = true;
	                    activeSelect = 'wishlist';
	                    break;
	                case 'basket':
	                    activePage.activeBasket = true;
	                    activeSelect = 'basket';
	                    break;
	            }
	
	            resultFull = _react3.default.createElement(
	                'div',
	                { className: 'hidden-xs' },
	                _react3.default.createElement(
	                    'ul',
	                    { className: 'nav nav-pills nav-stacked nav-pills-stacked-example' },
	                    _react3.default.createElement(
	                        'li',
	                        { role: 'presentation', className: activePage.activeProfile ? ' active ' : '' },
	                        _react3.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/personal/profile' },
	                            lang['store.user_profile_menu.profile']
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'li',
	                        { role: 'presentation', className: activePage.activeOrder ? ' active ' : '' },
	                        _react3.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/personal/order-list?limit=' + _constants.Personal.OrderNumericConstants.ORDERS_PAGE_LIMIT + '&page=1' },
	                            lang['store.user_profile_menu.orders']
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'li',
	                        { role: 'presentation', className: activePage.activeAddresses ? ' active ' : '' },
	                        _react3.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/personal/addresses' },
	                            lang['store.user_profile_menu.addresses']
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'li',
	                        { role: 'presentation', className: activePage.activeOperations ? ' active ' : '' },
	                        _react3.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/personal/operations' },
	                            lang['store.user_profile_menu.operations']
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'li',
	                        { role: 'presentation', className: activePage.activeFavor ? ' active ' : '' },
	                        _react3.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/personal/wishlist' },
	                            lang['store.user_profile_menu.wish_list']
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'li',
	                        { role: 'presentation', className: activePage.activeBasket ? ' active ' : '' },
	                        _react3.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/personal/basket' },
	                            lang['store.user_profile_menu.cart']
	                        )
	                    )
	                )
	            );
	
	            resultShort = _react3.default.createElement(
	                'div',
	                { className: 'short-list' },
	                _react3.default.createElement(
	                    'select',
	                    { className: 'form-control', onChange: this.handleRedirect, value: activeSelect },
	                    _react3.default.createElement(
	                        'option',
	                        { value: 'profile' },
	                        lang['store.user_profile_menu.profile']
	                    ),
	                    _react3.default.createElement(
	                        'option',
	                        { value: 'order-list' },
	                        lang['store.user_profile_menu.orders']
	                    ),
	                    _react3.default.createElement(
	                        'option',
	                        { value: 'operations' },
	                        lang['store.user_profile_menu.operations']
	                    ),
	                    _react3.default.createElement(
	                        'option',
	                        { value: 'wishlist' },
	                        lang['store.user_profile_menu.wish_list']
	                    ),
	                    _react3.default.createElement(
	                        'option',
	                        { value: 'basket' },
	                        lang['store.user_profile_menu.cart']
	                    )
	                )
	            );
	
	            if (user && user.hasOwnProperty('name') && (user.hasOwnProperty('email') || user.hasOwnProperty('phone'))) {
	                var name = user.name,
	                    email = user.email,
	                    phone = user.phone;
	
	
	                username = _react3.default.createElement(
	                    'div',
	                    null,
	                    _react3.default.createElement(
	                        'p',
	                        { className: 'name' },
	                        name
	                    ),
	                    _react3.default.createElement(
	                        'p',
	                        { className: 'email' },
	                        email
	                    ),
	                    _react3.default.createElement(
	                        'p',
	                        { className: 'email' },
	                        phone
	                    )
	                );
	            }
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'username' },
	                    username
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'menu text-center' },
	                    resultFull,
	                    resultShort
	                )
	            );
	        }
	    }]);
	    return UserProfileMenuView;
	}(_react2.Component), _class2.propTypes = {
	    pushState: _react2.PropTypes.func.isRequired,
	    active: _react2.PropTypes.string.isRequired,
	    user: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object
	}, _temp2)) || _class));
	
	exports.default = UserProfileMenuView;
	module.exports = exports['default'];

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserProfileMenu = undefined;
	
	var _UserProfileMenu2 = __webpack_require__(1783);
	
	var _UserProfileMenu3 = _interopRequireDefault(_UserProfileMenu2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.UserProfileMenu = _UserProfileMenu3.default;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 08.11.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _UserProfile = __webpack_require__(382);
	
	__webpack_require__(1108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    UserProfileView: {
	        displayName: 'UserProfileView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/UserProfile/default/UserProfileView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var UserProfileView = _wrapComponent('UserProfileView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(UserProfileView, _Component);
	
	    function UserProfileView() {
	        (0, _classCallCheck3.default)(this, UserProfileView);
	        return (0, _possibleConstructorReturn3.default)(this, (UserProfileView.__proto__ || (0, _getPrototypeOf2.default)(UserProfileView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(UserProfileView, [{
	        key: 'render',
	        value: function render() {
	            return _react3.default.createElement(
	                'section',
	                { className: 'user-profile' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'rows' },
	                    _react3.default.createElement(_UserProfile.UserInfo, this.props)
	                )
	            );
	        }
	    }]);
	    return UserProfileView;
	}(_react2.Component), _class.propTypes = {
	    acceptValue: _react2.PropTypes.func.isRequired,
	    activeField: _react2.PropTypes.func.isRequired,
	    changeField: _react2.PropTypes.func.isRequired,
	    changePassword: _react2.PropTypes.func.isRequired,
	    confirmMail: _react2.PropTypes.func.isRequired,
	    confirmPhone: _react2.PropTypes.func.isRequired,
	    lang: _react2.PropTypes.object.isRequired,
	    profile: _react2.PropTypes.object.isRequired,
	    resetField: _react2.PropTypes.func.isRequired,
	    setting: _react2.PropTypes.object.isRequired,
	    user: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object.isRequired
	}, _temp));
	
	exports.default = UserProfileView;
	module.exports = exports['default'];

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _voice_code = __webpack_require__(141);
	
	var _user = __webpack_require__(115);
	
	var _payment = __webpack_require__(114);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    VoiceCode: {
	        displayName: 'VoiceCode'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/VoiceCode/VoiceCode.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var VoiceCode = _wrapComponent('VoiceCode')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        is_send_voice_code: state.voiceCode.is_send_voice_code,
	        timerRepeat: state.voiceCode.timerRepeat,
	        error: state.voiceCode.error,
	        errorPassRecovery: state.passRecovery.error,
	        currentTime: state.voiceCode.currentTime,
	        preloader: state.voiceCode.preloader,
	        lang: state.lang
	    };
	}, { sendVoiceCode: _voice_code.sendVoiceCode, resetVoiceCode: _voice_code.resetVoiceCode, resetError: _user.resetError, startTimer: _voice_code.startTimer, resetPaymentIbonus: _payment.resetPaymentIbonus }), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(VoiceCode, _Component);
	
	    function VoiceCode(props) {
	        (0, _classCallCheck3.default)(this, VoiceCode);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (VoiceCode.__proto__ || (0, _getPrototypeOf2.default)(VoiceCode)).call(this, props));
	
	        _this.onCallbackVoice = function (event) {
	            event.preventDefault();
	            _this.props.resetError();
	            _this.props.resetPaymentIbonus();
	            _this.props.sendVoiceCode(_this.props.login, _this.props.source, _this.props.phone);
	        };
	
	        _this.timer = function () {
	            _this.props.startTimer(_this.props.timerRepeat);
	        };
	
	        _this.showOuterAlert = function () {
	            _this.props.showAlert(_this.alert);
	        };
	
	        _this.alert = null;
	        return _this;
	    }
	
	    (0, _createClass3.default)(VoiceCode, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var messageStart = this.props.lang['store.voice_code.message.start'];
	            var messageEnd = this.props.lang['store.voice_code.message.end'];
	
	            if (nextProps.error && nextProps.error !== this.props.error) {
	
	                this.alert = {
	                    message: this.props.lang[nextProps.error],
	                    style: 'danger'
	                };
	            } else if (nextProps.is_send_voice_code === true && this.props.is_send_voice_code !== nextProps.is_send_voice_code) {
	
	                this.alert = {
	                    message: messageStart + ' ' + this.props.timerRepeat + ' ' + messageEnd, style: 'success'
	                };
	                this.timer();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.resetVoiceCode();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForComponent('VoiceCode');
	
	            return _react3.default.createElement(View, {
	                alert: this.alert,
	                onCallbackVoice: this.onCallbackVoice,
	                sendVoiceTime: this.props.timerRepeat,
	                showAlert: this.showOuterAlert,
	                currentTime: this.props.currentTime,
	                preloader: this.props.preloader,
	                lang: this.props.lang
	            });
	        }
	    }]);
	    return VoiceCode;
	}(_react2.Component), _class2.propTypes = {
	    lang: _react2.PropTypes.object
	}, _class2.defaultProps = {}, _temp)) || _class));
	
	exports.default = VoiceCode;
	module.exports = exports['default'];

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    VoiceCodeView: {
	        displayName: 'VoiceCodeView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/VoiceCode/default/VoiceCodeView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var VoiceCodeView = _wrapComponent('VoiceCodeView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(VoiceCodeView, _Component);
	
	    function VoiceCodeView() {
	        (0, _classCallCheck3.default)(this, VoiceCodeView);
	        return (0, _possibleConstructorReturn3.default)(this, (VoiceCodeView.__proto__ || (0, _getPrototypeOf2.default)(VoiceCodeView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(VoiceCodeView, [{
	        key: 'render',
	        value: function render() {
	            var lang = this.props.lang;
	
	            var retry_in = lang['store.timer.retry'] + ' ';
	            var seconds = ' ' + lang['store.timer.sec'] + ' ';
	
	            if (this.props.alert) {
	                this.props.showAlert();
	            }
	
	            return _react3.default.createElement(
	                _reactBootstrap.FormGroup,
	                null,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'voice_wrap text-center' },
	                    this.props.currentTime > 0 ? _react3.default.createElement(
	                        'p',
	                        { id: 'voice_call_time_wrap', className: 'active' },
	                        retry_in,
	                        _react3.default.createElement(
	                            'span',
	                            { id: 'voice_call_time active' },
	                            this.props.currentTime
	                        ),
	                        seconds
	                    ) : _react3.default.createElement(
	                        _components2.Preloader,
	                        { classNames: 'mini_preload', preload: this.props.preloader },
	                        _react3.default.createElement(
	                            'a',
	                            { id: 'get_voice_call', href: '#', onClick: this.props.onCallbackVoice },
	                            lang['store.voice_code.request_voice_call']
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return VoiceCodeView;
	}(_react2.Component), _class.propTypes = {
	    currentTime: _react2.PropTypes.number,
	    lang: _react2.PropTypes.object
	}, _temp));
	
	exports.default = VoiceCodeView;
	module.exports = exports['default'];

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VoiceCode = undefined;
	
	var _VoiceCode2 = __webpack_require__(1787);
	
	var _VoiceCode3 = _interopRequireDefault(_VoiceCode2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.VoiceCode = _VoiceCode3.default;

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(19);
	
	var _modal_type = __webpack_require__(42);
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ProductWishIcon: {
	        displayName: 'ProductWishIcon'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/WishList/HeaderWishIcon/HeaderWishIcon.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ProductWishIcon = _wrapComponent('ProductWishIcon')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        wishProducts: state.wishList.wishProducts,
	        user: state.auth.user
	    };
	}, { showModalAuth: _modal_type.showModalAuth }), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(ProductWishIcon, _Component);
	
	    function ProductWishIcon(props) {
	        (0, _classCallCheck3.default)(this, ProductWishIcon);
	        return (0, _possibleConstructorReturn3.default)(this, (ProductWishIcon.__proto__ || (0, _getPrototypeOf2.default)(ProductWishIcon)).call(this, props));
	    }
	
	    (0, _createClass3.default)(ProductWishIcon, [{
	        key: 'render',
	        value: function render() {
	            var wishProducts = this.props.wishProducts;
	
	            if (wishProducts === null) {
	                wishProducts = [];
	            }
	            var classActive = wishProducts.length > 0 ? " active_wish " : "";
	            var isActive = wishProducts.length ? " active_icon" : "";
	
	            var content = _react3.default.createElement(
	                'div',
	                { className: 'header_icon-holder' },
	                _react3.default.createElement('i', { className: "fa fa-heart header_icon " + isActive }),
	                wishProducts.length > 0 ? _react3.default.createElement(
	                    'div',
	                    { className: 'header_icon_text-holder' },
	                    _react3.default.createElement(
	                        'span',
	                        { className: 'header_icon_text' },
	                        wishProducts.length
	                    )
	                ) : null
	            );
	
	            return _react3.default.createElement(
	                _reactRouter.Link,
	                { to: '/wishlist' },
	                content
	            );
	        }
	    }]);
	    return ProductWishIcon;
	}(_react2.Component), _class2.propTypes = {
	    //product: PropTypes.obj.isRequired
	}, _temp)) || _class));
	
	exports.default = ProductWishIcon;
	module.exports = exports['default'];

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	var _wish_list = __webpack_require__(166);
	
	var _modal_type = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ProductWishIcon: {
	        displayName: 'ProductWishIcon'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/components/WishList/ProductWishIcon/ProductWishIcon.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ProductWishIcon = _wrapComponent('ProductWishIcon')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        wishProducts: state.wishList.wishProducts,
	        user: state.auth.user,
	        lang: state.lang
	    };
	}, { addToWishList: _wish_list.addToWishList, delFromWishList: _wish_list.delFromWishList, showModifierModal: _modal_type.showModifierModal, setWishList: _wish_list.setWishList }), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(ProductWishIcon, _Component);
	
	    function ProductWishIcon(props) {
	        (0, _classCallCheck3.default)(this, ProductWishIcon);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (ProductWishIcon.__proto__ || (0, _getPrototypeOf2.default)(ProductWishIcon)).call(this, props));
	
	        _this.handleAddToWish = function (e) {
	            e.preventDefault();
	            var _this$props = _this.props,
	                user = _this$props.user,
	                product = _this$props.product;
	
	            if (_this.props.product.modifier !== undefined && _this.props.product.modifier !== null && _this.props.product.modifier.length !== 0) {
	                var modNames = [];
	                if (_this.props.product.modifier[0] !== undefined) {
	                    modNames.push(_this.props.product.modifier[0].name);
	                }
	                if (_this.props.product.modifier[1] !== undefined) {
	                    modNames.push(_this.props.product.modifier[1].name);
	                }
	                if (_this.props.product.modifier[2] !== undefined) {
	                    modNames.push(_this.props.product.modifier[2].name);
	                }
	                var choose = _this.props.lang['store.wish_list.choose'];
	                // if (this.props.isCartProduct && this.props.product.modifier_option_id === undefined) {
	                //     Alert.info('Необходимо выбрать ' + modNames.join(', '), {
	                //         position: 'top-right',
	                //         effect: 'slide',
	                //         timeout: 3000
	                //     });
	                // }
	                // if (this.props.isCartProduct !== true) {
	                _this.props.showModifierModal(_this.props.product, choose + ' ' + modNames.join(', '));
	                // }
	                if (_this.props.isModal === true || _this.props.isCartProduct && _this.props.product.modifier_option_id !== undefined) {
	                    _this.props.addToWishList(product, user ? user.id : null);
	                    setTimeout(_this.props.setWishList(_LocalStorageProxy2.default.getItem('wishlist.common')), 50000);
	                }
	            } else {
	                _this.props.addToWishList(product, user ? user.id : null);
	                setTimeout(_this.props.setWishList(_LocalStorageProxy2.default.getItem('wishlist.common')), 50000);
	            }
	        };
	
	        _this.handleDelFromWish = function (e) {
	            e.preventDefault();
	            var _this$props2 = _this.props,
	                user = _this$props2.user,
	                product = _this$props2.product;
	
	            if (_this.props.product.modifier !== undefined && _this.props.product.modifier !== null && _this.props.product.modifier.length !== 0) {
	                var modNames = [];
	                if (_this.props.product.modifier[0] !== undefined) {
	                    modNames.push(_this.props.product.modifier[0].name);
	                }
	                if (_this.props.product.modifier[1] !== undefined) {
	                    modNames.push(_this.props.product.modifier[1].name);
	                }
	                if (_this.props.product.modifier[2] !== undefined) {
	                    modNames.push(_this.props.product.modifier[2].name);
	                }
	                var choose = _this.props.lang['store.wish_list.choose'];
	
	                _this.props.showModifierModal(_this.props.product, choose + ' ' + modNames.join(', '));
	
	                if (_this.props.isModal === true || _this.props.isCartProduct && _this.props.product.modifier_option_id !== undefined) {
	                    _this.props.delFromWishList(product, user ? user.id : null);
	                    setTimeout(_this.props.setWishList(_LocalStorageProxy2.default.getItem('wishlist.common')), 50000);
	                }
	            } else {
	                _this.props.delFromWishList(product, user ? user.id : null);
	                setTimeout(_this.props.setWishList(_LocalStorageProxy2.default.getItem('wishlist.common')), 50000);
	            }
	        };
	
	        _this.inWishList = function () {
	            var _this$props3 = _this.props,
	                wishProducts = _this$props3.wishProducts,
	                product = _this$props3.product;
	
	            if (wishProducts === null) {
	                return false;
	            }
	            for (var i = 0; i < wishProducts.length; i++) {
	                if (product.id === wishProducts[i].id && wishProducts[i].modifier_option_id === product.modifier_option_id) return true;
	            }
	            return false;
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(ProductWishIcon, [{
	        key: 'render',
	        value: function render() {
	            var inWishList = this.inWishList();
	            var _props = this.props,
	                inCard = _props.inCard,
	                lang = _props.lang;
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'buttons-holder' },
	                inCard ? inWishList ? _react3.default.createElement('a', { onClick: this.handleDelFromWish, className: 'btn-add-to-wishlist active_wish', href: '#' }) : _react3.default.createElement('a', { onClick: this.handleAddToWish, className: 'btn-add-to-wishlist', href: '#' }) : inWishList ? _react3.default.createElement(
	                    'a',
	                    { onClick: this.handleDelFromWish, className: 'btn-add-to-wishlist active_wish text-theme-color', href: '#' },
	                    lang['store.wish_list.item_in_list']
	                ) : _react3.default.createElement(
	                    'a',
	                    { onClick: this.handleAddToWish, className: 'btn-add-to-wishlist text-theme-color', href: '#' },
	                    lang['store.wish_list.add_to_wish_list']
	                )
	            );
	        }
	
	        /**
	         * Проверяет находится ли товар в избранном
	         */
	
	    }]);
	    return ProductWishIcon;
	}(_react2.Component), _class2.propTypes = {
	    //product: PropTypes.obj.isRequired
	}, _temp)) || _class));
	
	exports.default = ProductWishIcon;
	module.exports = exports['default'];

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeaderWishIcon = exports.ProductWishIcon = undefined;
	
	var _ProductWishIcon2 = __webpack_require__(1791);
	
	var _ProductWishIcon3 = _interopRequireDefault(_ProductWishIcon2);
	
	var _HeaderWishIcon2 = __webpack_require__(1790);
	
	var _HeaderWishIcon3 = _interopRequireDefault(_HeaderWishIcon2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ProductWishIcon = _ProductWishIcon3.default;
	exports.HeaderWishIcon = _HeaderWishIcon3.default;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuccessfulModal = function SuccessfulModal(_ref) {
	    var successfulMessage = _ref.successfulMessage;
	    return _react2.default.createElement(
	        "div",
	        { className: "row no-margin" },
	        _react2.default.createElement(
	            "div",
	            { className: "col-xs-12" },
	            successfulMessage
	        )
	    );
	};
	
	exports.default = SuccessfulModal;
	module.exports = exports['default'];

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SuccessfulModal = undefined;
	
	var _SuccessfulModal2 = __webpack_require__(1793);
	
	var _SuccessfulModal3 = _interopRequireDefault(_SuccessfulModal2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SuccessfulModal = _SuccessfulModal3.default;

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SuccessfulModal = __webpack_require__(1794);
	
	Object.defineProperty(exports, 'SuccessfulModal', {
	  enumerable: true,
	  get: function get() {
	    return _SuccessfulModal.SuccessfulModal;
	  }
	});

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(68);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(69);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _AddressListInput = __webpack_require__(1598);
	
	var _AddressListInput2 = _interopRequireDefault(_AddressListInput);
	
	var _addresses = __webpack_require__(260);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AddressList: {
	        displayName: 'AddressList'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/AddressList/index.js',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var AddressList = _wrapComponent('AddressList')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var params = _ref.params,
	            location = _ref.location,
	            _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	        return dispatch((0, _addresses.loadAddresses)());
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        addresses: state.address.list,
	        lang: state.lang
	    };
	}, {
	    addAddress: _addresses.addAddress,
	    updateAddress: _addresses.updateAddress,
	    deleteAddress: _addresses.deleteAddress
	}), _dec(_class = _dec2(_class = function (_React$Component) {
	    (0, _inherits3.default)(AddressList, _React$Component);
	
	    function AddressList(props) {
	        (0, _classCallCheck3.default)(this, AddressList);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (AddressList.__proto__ || (0, _getPrototypeOf2.default)(AddressList)).call(this, props));
	
	        _this.handleSetNewMode = function (value) {
	            _this.setState({ isNewMode: value });
	        };
	
	        _this.handleUpdateAddress = function (id, value, is_default) {
	            _this.props.updateAddress(id, value, is_default).then(function () {
	                return _reactSAlert2.default.success(_this.props.lang['store.common.addresses.updated'], { position: 'top-right', effect: 'slide', timeout: 5000 });
	            });;
	        };
	
	        _this.handleDeleteAddress = function (id) {
	            _this.props.deleteAddress(id).then(function () {
	                return _reactSAlert2.default.success(_this.props.lang['store.common.addresses.deleted'], { position: 'top-right', effect: 'slide', timeout: 5000 });
	            });;
	        };
	
	        _this.sortAddresses = function (addresses) {
	            var defaultIdx = addresses.findIndex(function (address) {
	                return address.is_default;
	            });
	            if (defaultIdx < 0) return addresses.sort(function (a, b) {
	                return b.id - a.id;
	            });
	            var defaultAddress = (0, _extends3.default)({}, addresses[defaultIdx]);
	            addresses.splice(defaultIdx, 1);
	            addresses.sort(function (a, b) {
	                return b.id - a.id;
	            });
	            addresses.unshift(defaultAddress);
	            return addresses;
	        };
	
	        _this.handleAddressAdd = _this.handleAddressAdd.bind(_this);
	
	        if (!(typeof _this.handleAddressAdd === 'function')) {
	            throw new TypeError('Value of "this.handleAddressAdd" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.handleAddressAdd));
	        }
	
	        _this.state = {
	            isNewMode: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(AddressList, [{
	        key: 'handleAddressAdd',
	        value: function handleAddressAdd(address) {
	            var _this2 = this;
	
	            this.props.addAddress(address).then(function () {
	                _reactSAlert2.default.success(_this2.props.lang['store.common.addresses.added'], { position: 'top-right', effect: 'slide', timeout: 5000 });
	                _this2.setState({ isNewMode: false });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                addresses = _props.addresses,
	                lang = _props.lang;
	            var isNewMode = this.state.isNewMode;
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(
	                    'h2',
	                    { className: 'section-title' },
	                    lang['store.common.addresses.title']
	                ),
	                this.sortAddresses(addresses).map(function (address) {
	                    return _react3.default.createElement(_AddressListInput2.default, {
	                        key: address.id,
	                        handleUpdateAddress: _this3.handleUpdateAddress,
	                        handleDeleteAddress: _this3.handleDeleteAddress,
	                        id: address.id,
	                        value: address.address,
	                        is_default: address.is_default
	                    });
	                }),
	                isNewMode ? _react3.default.createElement(_AddressListInput2.default, {
	                    disableNewMode: function disableNewMode() {
	                        return _this3.handleSetNewMode(false);
	                    },
	                    isNew: true, handleAddressAdd: this.handleAddressAdd
	                }) : addresses.length < 5 && _react3.default.createElement(
	                    'button',
	                    { onClick: function onClick() {
	                            return _this3.handleSetNewMode(true);
	                        }, className: 'le-button pay_order_button' },
	                    lang['store.common.addresses.add']
	                )
	            );
	        }
	    }]);
	    return AddressList;
	}(_react3.default.Component)) || _class) || _class));
	
	exports.default = AddressList;
	
	function _inspect(input, depth) {
	    var maxDepth = 4;
	    var maxKeys = 15;
	
	    if (depth === undefined) {
	        depth = 0;
	    }
	
	    depth += 1;
	
	    if (input === null) {
	        return 'null';
	    } else if (input === undefined) {
	        return 'void';
	    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	    } else if (Array.isArray(input)) {
	        if (input.length > 0) {
	            if (depth > maxDepth) return '[...]';
	
	            var first = _inspect(input[0], depth);
	
	            if (input.every(function (item) {
	                return _inspect(item, depth) === first;
	            })) {
	                return first.trim() + '[]';
	            } else {
	                return '[' + input.slice(0, maxKeys).map(function (item) {
	                    return _inspect(item, depth);
	                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	            }
	        } else {
	            return 'Array';
	        }
	    } else {
	        var keys = (0, _keys2.default)(input);
	
	        if (!keys.length) {
	            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	                return input.constructor.name;
	            } else {
	                return 'Object';
	            }
	        }
	
	        if (depth > maxDepth) return '{...}';
	        var indent = '  '.repeat(depth - 1);
	        var entries = keys.slice(0, maxKeys).map(function (key) {
	            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	        }).join('\n  ' + indent);
	
	        if (keys.length >= maxKeys) {
	            entries += '\n  ' + indent + '...';
	        }
	
	        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	        } else {
	            return '{\n  ' + indent + entries + '\n' + indent + '}';
	        }
	    }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//TODO Во всех компонентах привести импорты в порядок, сначала должны идти импорты из React, потом из подключаемых библиотек, потом из наших компонент, потом экшены и прочее. После каждого блока импортов - пустая строка. Макар
	//TODO добавить CSS класс, отвечающий за uppercase, добавить его в элементы, где он необходим. из кода Uppercase выпилить. Макар
	//TODO убрать из asyncConnect массив промисов, там где этот массив из одного элемента. возвращать просто промис. Макар
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(68);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _promise = __webpack_require__(58);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp2;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _auth = __webpack_require__(53);
	
	var _error = __webpack_require__(140);
	
	var _catalog = __webpack_require__(67);
	
	var _wish_list = __webpack_require__(166);
	
	var _basket = __webpack_require__(101);
	
	var _helpers = __webpack_require__(15);
	
	var _components2 = __webpack_require__(16);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	var _config = __webpack_require__(193);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    App: {
	        displayName: 'App'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/App/App.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var App = _wrapComponent('App')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var location = _ref.location,
	            _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	        var promises = [];
	        if (!getState().catalog.catalogIsLoaded) {
	            promises.push(dispatch((0, _catalog.getCategories)()));
	        }
	
	        // if (getState().catalog.lastCatalogUpdateDate === null) {
	        //     promises.push(dispatch(checkCatalogForUpdates()));
	        // }
	
	        if (!(0, _auth.isLoaded)(getState()) && (0, _auth.isLoadedInServer)(getState())) {
	            promises.push(dispatch((0, _auth.load)()));
	        }
	
	        return _promise2.default.all(promises);
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        setting: state.setting,
	        user: state.auth.user,
	        show_404: state.error.is_show_404,
	        currency: state.currency
	    };
	}, { logout: _auth.logout, pushState: _reactRouterRedux.push, disable404: _error.disable404, wishListFromLocalStorage: _wish_list.wishListFromLocalStorage, basketFromLocalStorage: _basket.basketFromLocalStorage }), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	    (0, _inherits3.default)(App, _Component);
	
	    function App() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, App);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref2, [this].concat(args))), _this), _this.handleLogout = function (event) {
	            event.preventDefault();
	            _this.props.logout();
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(App, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.wishListFromLocalStorage();
	            this.props.basketFromLocalStorage();
	            this.mountGoogleMapsScript();
	        }
	    }, {
	        key: '_currentLangToGoogleLangCode',
	        value: function _currentLangToGoogleLangCode(langSlug) {
	            switch (langSlug) {
	                case 'rus':
	                    return 'ru';
	                case 'eng':
	                case 'gbr':
	                case 'eur':
	                    return 'en';
	                case 'kaz':
	                    return 'kk';
	                case 'ukr':
	                    return 'uk';
	                default:
	                    return 'en';
	            }
	        }
	
	        // МЕТОД ПРЕДНАЗНАЧЕН ТОЛЬКО ДЛЯ ВЫЗОВА НА КЛИЕНТЕ В componentDidMount!
	
	    }, {
	        key: 'mountGoogleMapsScript',
	        value: function mountGoogleMapsScript() {
	            var currency = this.props.currency;
	
	            var scriptId = 'googleMapsScript';
	            var lang = 'en';
	            if (!!currency.lang) {
	                lang = this._currentLangToGoogleLangCode(currency.lang.slug || 'en');
	            }
	
	            var script = document.createElement('script');
	            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + _config2.default.gapi.key + '&language=' + lang + '&libraries=places';
	            script.defer = true;
	            script.async = true;
	            script.id = scriptId;
	
	            if (!document.getElementById(scriptId)) {
	                document.head.appendChild(script);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!this.props.user && nextProps.user) {
	                // login
	                //this.props.pushState('/loginSuccess');
	            } else if (this.props.user && !nextProps.user) {
	                // logout
	                //this.props.pushState('/');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.props.location.query.utm_source || this.props.location.query.utm_medium || this.props.location.query.utm_campaign || this.props.location.query.utm_content || this.props.location.query.utm_term) {
	                var utm = {
	                    utm_source: this.props.location.query.utm_source,
	                    utm_medium: this.props.location.query.utm_medium,
	                    utm_campaign: this.props.location.query.utm_campaign,
	                    utm_content: this.props.location.query.utm_content,
	                    utm_term: this.props.location.query.utm_term,
	                    time: +new Date()
	                };
	                _LocalStorageProxy2.default.setItem('utm_redirect_data', (0, _stringify2.default)(utm));
	            }
	
	            //todo сделать что бы 404 отображалась только с дроп меню
	            var link = ["/", "/category", "/search"],
	                // массив страниц, на которых Menu будет статичным
	            pattern = /^[\/]\w*/,
	                path = this.props.location.pathname.match(pattern),
	                drop = true,
	                viewSearchAndMenu = this.props.location.pathname !== "/registration" && this.props.location.pathname !== "/slide",
	                viewFooter = this.props.location.pathname !== "/slide";
	
	            for (var i = 0; i < link.length; i++) {
	                if (path && link[i] === path[0]) {
	                    drop = false;
	                    break;
	                }
	            }
	
	            var View = _helpers.ThemeHelper.getViewForContainer('App');
	            var _props = this.props,
	                user = _props.user,
	                setting = _props.setting;
	
	
	            var description = setting.seoDescription || null;
	            var keywords = setting.seoKeywords || null;
	            var noindex = setting.seoIndexation === false;
	
	            if (!user && this.props.location.query.payment_in_id) {
	                _LocalStorageProxy2.default.setItem('redirect_before_auth', this.props.location.pathname + this.props.location.search);
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'App u-full-height' },
	                keywords ? _react3.default.createElement(_reactHelmet2.default, { meta: [{ name: "keywords", content: keywords }] }) : null,
	                description ? _react3.default.createElement(_reactHelmet2.default, { meta: [{ name: "description", content: description }] }) : null,
	                noindex ? _react3.default.createElement(_reactHelmet2.default, { meta: [{ name: "robots", content: 'noindex, nofollow' }] }) : null,
	                _react3.default.createElement(_reactHelmet2.default, { meta: [{ property: "og:image", content: setting.logo }, { property: "og:image", content: '/android-chrome-512x512.png' }] }),
	                _react3.default.createElement(
	                    View,
	                    { drop: drop, viewSearchAndMenu: viewSearchAndMenu, viewFooter: viewFooter, user: user },
	                    _react3.default.createElement(
	                        _helpers.NotFoundDecorator,
	                        null,
	                        _react3.default.createElement(
	                            _components2.PreloaderGlobal,
	                            null,
	                            this.props.children
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return App;
	}(_react2.Component), _class2.propTypes = {
	    children: _react2.PropTypes.object.isRequired,
	    user: _react2.PropTypes.object,
	    logout: _react2.PropTypes.func.isRequired,
	    pushState: _react2.PropTypes.func.isRequired,
	    currency: _react2.PropTypes.object.isRequired
	}, _class2.contextTypes = {
	    store: _react2.PropTypes.object.isRequired
	}, _temp2)) || _class) || _class));
	
	exports.default = App;
	module.exports = exports['default'];

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _components2 = __webpack_require__(16);
	
	var _config = __webpack_require__(193);
	
	var _config2 = _interopRequireDefault(_config);
	
	__webpack_require__(456);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    AppView: {
	        displayName: 'AppView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/App/default/AppView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var AppView = _wrapComponent('AppView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(AppView, _Component);
	
	    function AppView() {
	        (0, _classCallCheck3.default)(this, AppView);
	        return (0, _possibleConstructorReturn3.default)(this, (AppView.__proto__ || (0, _getPrototypeOf2.default)(AppView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(AppView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                drop = _props.drop,
	                viewSearchAndMenu = _props.viewSearchAndMenu,
	                user = _props.user,
	                viewFooter = _props.viewFooter;
	
	            var result = null;
	
	            if (viewSearchAndMenu) {
	                // if (true) {
	                result = _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(_components2.Menu, { drop: drop }),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-8 col-md-9' },
	                        _react3.default.createElement(_components2.Search, null),
	                        !drop ? this.props.children : ''
	                    )
	                );
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'App__view u-full-height' },
	                _react3.default.createElement(_reactHelmet2.default, _config2.default.app.head),
	                _react3.default.createElement(_components2.Header, { user: user }),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'flex_wrapper' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'flex_content ' + (viewFooter ? '' : 'u-full-height') },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'App__content u-full-height' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'container u-full-height' },
	                                _react3.default.createElement(_components2.AlertError, null),
	                                result,
	                                drop ? this.props.children : ''
	                            )
	                        )
	                    ),
	                    viewFooter ? _react3.default.createElement(_components2.Footer, null) : null
	                ),
	                _react3.default.createElement(_components2.ModalWindow, null)
	            );
	        }
	    }]);
	    return AppView;
	}(_react2.Component), _class.propTypes = {
	    children: _react2.PropTypes.object.isRequired,
	    drop: _react2.PropTypes.bool,
	    viewSearchAndMenu: _react2.PropTypes.bool.isRequired,
	    viewFooter: _react2.PropTypes.bool.isRequired,
	    user: _react2.PropTypes.object
	}, _temp));
	
	exports.default = AppView;
	module.exports = exports['default'];

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.App = undefined;
	
	var _App2 = __webpack_require__(1797);
	
	var _App3 = _interopRequireDefault(_App2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.App = _App3.default;

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _components2 = __webpack_require__(16);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _basket = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Basket: {
	        displayName: 'Basket'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Basket/Basket.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Basket = _wrapComponent('Basket')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	        var products = getState().basket.items;
	        if (products) {
	            return dispatch((0, _extends3.default)({}, (0, _basket.getActualPrices)(products)));
	        }
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang
	    };
	}), _dec(_class = _dec2(_class = function (_Component) {
	    (0, _inherits3.default)(Basket, _Component);
	
	    function Basket() {
	        (0, _classCallCheck3.default)(this, Basket);
	        return (0, _possibleConstructorReturn3.default)(this, (Basket.__proto__ || (0, _getPrototypeOf2.default)(Basket)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Basket, [{
	        key: 'render',
	        value: function render() {
	            var helmetTitle = this.props.lang['store.helmet.cart'];
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(_reactHelmet2.default, { title: helmetTitle }),
	                _react3.default.createElement(_components2.Basket, { before: _react3.default.createElement(_components2.OrderSteps, { step: '1' }) })
	            );
	        }
	    }]);
	    return Basket;
	}(_react2.Component)) || _class) || _class));
	
	exports.default = Basket;
	module.exports = exports['default'];

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class;
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _basket = __webpack_require__(101);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ShareBasket: {
	        displayName: 'ShareBasket'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Basket/ShareBasket.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ShareBasket = _wrapComponent('ShareBasket')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var params = _ref.params,
	            location = _ref.location,
	            _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	        var code = params.code || '';
	
	        return dispatch((0, _extends3.default)({}, (0, _basket.getSharedBasket)(code)));
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang
	    };
	}), _dec(_class = _dec2(_class = function (_Component) {
	    (0, _inherits3.default)(ShareBasket, _Component);
	
	    function ShareBasket(props) {
	        (0, _classCallCheck3.default)(this, ShareBasket);
	        return (0, _possibleConstructorReturn3.default)(this, (ShareBasket.__proto__ || (0, _getPrototypeOf2.default)(ShareBasket)).call(this, props));
	    }
	
	    (0, _createClass3.default)(ShareBasket, [{
	        key: 'render',
	        value: function render() {
	            var helmetTitle = this.props.lang['store.helmet.cart'];
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(_reactHelmet2.default, { title: helmetTitle }),
	                _react3.default.createElement(_components2.Basket, { before: _react3.default.createElement(_components2.OrderSteps, { step: '1' }) })
	            );
	        }
	    }]);
	    return ShareBasket;
	}(_react2.Component)) || _class) || _class));
	
	exports.default = ShareBasket;
	module.exports = exports['default'];

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShareBasket = exports.Basket = undefined;
	
	var _Basket2 = __webpack_require__(1800);
	
	var _Basket3 = _interopRequireDefault(_Basket2);
	
	var _ShareBasket2 = __webpack_require__(1801);
	
	var _ShareBasket3 = _interopRequireDefault(_ShareBasket2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Basket = _Basket3.default;
	exports.ShareBasket = _ShareBasket3.default;

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _catalog = __webpack_require__(67);
	
	var _theme = __webpack_require__(1860);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    CartProduct: {
	        displayName: 'CartProduct'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/CartProduct/CartProduct.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var CartProduct = _wrapComponent('CartProduct')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var params = _ref.params,
	            location = _ref.location,
	            _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	        var id = params.id;
	        return dispatch((0, _extends3.default)({}, (0, _catalog.getProduct)(id), { show_404: location.pathname }));
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        product_detail: state.catalog.product_detail
	    };
	}, { getProduct: _catalog.getProduct }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(CartProduct, _Component);
	
	    function CartProduct() {
	        (0, _classCallCheck3.default)(this, CartProduct);
	        return (0, _possibleConstructorReturn3.default)(this, (CartProduct.__proto__ || (0, _getPrototypeOf2.default)(CartProduct)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(CartProduct, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.product_detail.seo && this.props.product_detail.seo.semantic_url) {
	                history.replaceState(null, null, '/product/' + this.props.product_detail.seo.semantic_url);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var product_detail = this.props.product_detail;
	
	
	            var View = _theme.ThemeHelper.getViewForContainer('CartProduct');
	
	            var title = product_detail && product_detail.seo && product_detail.seo.title || product_detail.name || '';
	            var noindex = product_detail && product_detail.seo && product_detail.seo.indexation === false;
	
	            var seo = product_detail.seo || {};
	
	            var meta = [];
	
	            if (seo.description) {
	                meta.push({ name: 'description', content: seo.description });
	            }
	            if (seo.keywords) {
	                meta.push({ name: 'keywords', content: seo.keywords });
	            }
	            if (noindex) {
	                meta.push({ name: 'robots', content: 'noindex, nofollow' });
	            }
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(_reactHelmet2.default, { title: title }),
	                meta.length > 0 ? _react3.default.createElement(_reactHelmet2.default, { meta: meta }) : null,
	                _react3.default.createElement(View, { product_detail: product_detail })
	            );
	        }
	    }]);
	    return CartProduct;
	}(_react2.Component), _class2.propTypes = {
	    product_detail: _react2.PropTypes.object.isRequired,
	    getProduct: _react2.PropTypes.func.isRequired
	}, _temp)) || _class) || _class));
	
	exports.default = CartProduct;
	module.exports = exports['default'];

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _reactRedux = __webpack_require__(12);
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    CartProductView: {
	        displayName: 'CartProductView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/CartProduct/default/CartProductView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var CartProductView = _wrapComponent('CartProductView')(function (_Component) {
	    (0, _inherits3.default)(CartProductView, _Component);
	
	    function CartProductView(props) {
	        (0, _classCallCheck3.default)(this, CartProductView);
	
	        // вызовем родительский конструктор, чтобы ничего не сломалось
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CartProductView.__proto__ || (0, _getPrototypeOf2.default)(CartProductView)).call(this, props));
	
	        _this.handleClickOnVideo = function () {
	            _this.setState({
	                full_screen_mode: true,
	                video_mode: true,
	                start_index_preview: 0
	            });
	        };
	
	        _this.handleClickOnActiveSlide = function () {
	            _this.setState({ // если режим включен - выключаем его, иначе - включаем
	                full_screen_mode: !_this.state.full_screen_mode,
	                video_mode: false,
	                start_index_preview: 0
	            });
	        };
	
	        _this.handleChangeSlide = function (prop) {
	            _this.setState({
	                video_mode: false,
	                active_slide: prop
	            });
	        };
	
	        _this.clickOnActiveSlide = function () {
	            var clickOnActive = _this.props.clickOnActive;
	
	            clickOnActive();
	        };
	
	        _this.clickOnPrev = function (countPreview) {
	            var active_index = void 0;
	
	            // узнаем индекс активного слайда
	            for (var i = 0; i <= _this.props.product_detail.pictures.length; ++i) {
	                if (_this.props.product_detail.pictures[i].id == _this.state.active_slide) {
	                    active_index = i;
	                    break;
	                }
	            }
	
	            // если слайд не первый
	            if (active_index != 0) {
	                _this.setState({
	                    active_slide: _this.props.product_detail.pictures[active_index - 1].id
	                });
	            } else {
	                _this.setState({
	                    active_slide: _this.props.product_detail.pictures[_this.props.product_detail.pictures.length - 1].id,
	                    start_index_preview: _this.props.product_detail.pictures.length - countPreview
	                });
	            }
	
	            if (active_index < _this.props.product_detail.pictures.length - 2) {
	                _this.clickOnPrevPreview();
	            }
	        };
	
	        _this.clickOnNext = function (countPreview) {
	            var active_index = void 0;
	
	            // узнаем индекс активного слайда
	            for (var i = 0; i <= _this.props.product_detail.pictures.length; ++i) {
	                if (_this.props.product_detail.pictures[i].id == _this.state.active_slide) {
	                    active_index = i;
	                    break;
	                }
	            }
	
	            // если слайд не последний
	            if (active_index != _this.props.product_detail.pictures.length - 1) {
	                _this.setState({
	                    active_slide: _this.props.product_detail.pictures[active_index + 1].id
	                });
	            } else {
	                _this.setState({
	                    active_slide: _this.props.product_detail.pictures[0].id,
	                    start_index_preview: 0
	                });
	            }
	
	            if (active_index > 1) {
	                _this.clickOnNextPreview(countPreview);
	            }
	        };
	
	        _this.clickOnPrevPreview = function () {
	            if (_this.state.start_index_preview - 1 >= 0) {
	                _this.setState({
	                    start_index_preview: _this.state.start_index_preview - 1
	                });
	            }
	        };
	
	        _this.clickOnNextPreview = function (count) {
	            var start_index_preview = _this.state.start_index_preview;
	
	            var length = _this.props.product_detail.pictures.length;
	            if (start_index_preview < length - count) {
	                _this.setState({
	                    start_index_preview: _this.state.start_index_preview + 1
	                });
	            }
	        };
	
	        if (!_this.props.product_detail.pictures) {
	            _this.props.product_detail.pictures = [];
	        }
	
	        _this.state = {
	            active_slide: _this.props.product_detail.pictures[0] ? _this.props.product_detail.pictures[0].id : 0, // ставим активным первую фото в массиве pictures
	            video_mode: false, //режим просмотра видео
	            full_screen_mode: false, // полноэкранный режим слайдера
	            start_index_preview: 0
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(CartProductView, [{
	        key: 'render',
	        value: function render() {
	            var product_detail = this.props.product_detail;
	
	
	            var slider = _react3.default.createElement(_components2.Slider, {
	                active_slide: this.state.active_slide,
	                video_mode: this.state.video_mode,
	                full_screen_mode: this.state.full_screen_mode,
	                start_index_preview: this.state.start_index_preview,
	                product_detail: product_detail,
	                clickOnActive: this.handleClickOnActiveSlide,
	                onAddToBasket: this.props.addProduct,
	                handleChangeSlide: this.handleChangeSlide,
	                clickOnActiveSlide: this.clickOnActiveSlide,
	                clickOnVideo: this.handleClickOnVideo,
	                clickOnPrev: this.clickOnPrev,
	                clickOnNext: this.clickOnNext,
	                clickOnPrevPreview: this.clickOnPrevPreview,
	                clickOnNextPreview: this.clickOnNextPreview
	            });
	            if (this.state.full_screen_mode) {
	                // если полноэкранный режим слайдера включен
	                return _react3.default.createElement(
	                    _reactBootstrap.Modal,
	                    {
	                        show: this.state.full_screen_mode,
	                        dialogClassName: 'slider-modal' },
	                    _react3.default.createElement(
	                        _reactBootstrap.Modal.Header,
	                        null,
	                        _react3.default.createElement(
	                            _reactBootstrap.Modal.Title,
	                            null,
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'container' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'no-margin col-xs-12 col-sm-7 body-holder', id: 'active' },
	                                    _react3.default.createElement(
	                                        'div',
	                                        { className: 'body', id: 'active' },
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _react3.default.createElement(
	                                                'a',
	                                                {
	                                                    href: product_detail.url },
	                                                product_detail.name
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        _reactBootstrap.Modal.Body,
	                        null,
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react3.default.createElement(
	                                'div',
	                                { id: 'single-product' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'container' },
	                                    slider
	                                )
	                            )
	                        )
	                    )
	                );
	            } else {
	                // если полноэкранный режим слайдера выключен
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'col-md-12', style: { borderRadius: '7px' } },
	                    _react3.default.createElement(
	                        'div',
	                        { id: 'single-product', className: 'flying-to-cart-holder' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            slider,
	                            _react3.default.createElement(_components2.ShortDescription, { product_detail: product_detail })
	                        )
	                    )
	                );
	            }
	        }
	
	        /**
	         * Обработчик открытия слайдера в режиме видео
	         */
	
	
	        /**
	         * Обработчик раскрытия слайдера на весь экран
	         */
	
	
	        /**
	         * Обработчик изменения активного слайда
	         * @param prop
	         */
	
	
	        /**
	         * Обработчик раскрытия слайдера по нажатию на активное фото
	         */
	
	
	        /**
	         * Обработчик нажатия на кнопку "Назад" у активного фото
	         */
	
	
	        /**
	         * Обработчик нажатия на кнопку "Далее" у активного фото
	         */
	
	
	        /**
	         * Обработчик нажатия на кнопку "Назад" у ряда превьюх
	         */
	
	
	        /**
	         * Обработчик нажатия на кнопку "Далее" у ряда превьюх
	         */
	
	    }]);
	    return CartProductView;
	}(_react2.Component));
	
	exports.default = CartProductView;
	module.exports = exports['default'];

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CartProduct = undefined;
	
	var _CartProduct2 = __webpack_require__(1803);
	
	var _CartProduct3 = _interopRequireDefault(_CartProduct2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CartProduct = _CartProduct3.default;

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp2;
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _helpers = __webpack_require__(15);
	
	var _constants = __webpack_require__(18);
	
	var _catalog = __webpack_require__(67);
	
	var _utils = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Category: {
	        displayName: 'Category'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Category/Category.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Category = _wrapComponent('Category')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var params = _ref.params,
	            location = _ref.location,
	            _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	        var id = params.id,
	            limit = parseInt(location.query.limit, 10) || _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT,
	            page = parseInt(location.query.page, 10) || 1;
	
	        if (limit > _constants.CatalogNumericConstants.MAX_LIMIT) {
	            limit = _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT;
	        }
	        if (page > _constants.CatalogNumericConstants.MAX_PAGE) {
	            page = 1;
	        }
	
	        return dispatch((0, _extends3.default)({}, (0, _catalog.getProductByCategory)({ id: id, page: --page, limit: limit }), { show_404: location.pathname }));
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        setting: state.setting,
	        catalog: state.catalog,
	        lang: state.lang
	    };
	}, { getProductByCategory: _catalog.getProductByCategory, getCategoryRecommended: _catalog.getCategoryRecommended, push: _reactRouterRedux.push }), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	    (0, _inherits3.default)(Category, _Component);
	
	    function Category() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, Category);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Category.__proto__ || (0, _getPrototypeOf2.default)(Category)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChangePage = function (page, limit) {
	            _this.props.push('/category/' + _this.props.catalog.id + '?limit=' + limit + '&page=' + page);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(Category, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props$catalog = this.props.catalog,
	                categorySeo = _props$catalog.categorySeo,
	                limit = _props$catalog.limit,
	                activePage = _props$catalog.activePage,
	                id = _props$catalog.id,
	                recommendedId = _props$catalog.recommendedId;
	
	            history.replaceState(null, null, '/category/' + (categorySeo && categorySeo.semantic_url ? categorySeo.semantic_url : id) + '?limit=' + limit + '&page=' + activePage);
	
	            if (id && id !== recommendedId) {
	                this.props.getCategoryRecommended(id);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForContainer('Category');
	
	            var _props$catalog2 = this.props.catalog,
	                activePage = _props$catalog2.activePage,
	                categoryRecommended = _props$catalog2.categoryRecommended,
	                categoryPreload = _props$catalog2.categoryPreload,
	                categoryId = _props$catalog2.categoryId,
	                count = _props$catalog2.count,
	                id = _props$catalog2.id,
	                limit = _props$catalog2.limit,
	                products = _props$catalog2.products,
	                title = _props$catalog2.title,
	                description = _props$catalog2.description,
	                picture = _props$catalog2.picture;
	            var lang = this.props.lang;
	
	            var categorySeo = this.props.catalog.categorySeo || {};
	            var headTitle = categorySeo && categorySeo.title || title;
	            var orderInOneClick = this.props.setting.orderInOneClick;
	            var buyInCreditActive = this.props.setting.buyInCreditActive;
	            var meta = [];
	
	            if (categorySeo.description) {
	                meta.push({ name: "description", content: categorySeo.description });
	            }
	            if (categorySeo.keywords) {
	                meta.push({ name: "keywords", content: categorySeo.keywords });
	            }
	            if (categorySeo.indexation === false) {
	                meta.push({ name: "robots", content: 'noindex, nofollow' });
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'tab-content' },
	                _react3.default.createElement(_reactHelmet2.default, { title: headTitle }),
	                meta.length > 0 ? _react3.default.createElement(_reactHelmet2.default, { meta: meta }) : null,
	                _react3.default.createElement(View, {
	                    activePage: activePage,
	                    count: count,
	                    limit: limit,
	                    products: products,
	                    title: categorySeo && categorySeo.h1 || lang[title] || title,
	                    picture: picture,
	                    description: description,
	                    handleChangePage: this.handleChangePage,
	                    sliderContent: categoryRecommended,
	                    orderInOneClick: orderInOneClick,
	                    buyInCreditActive: buyInCreditActive,
	                    preload: categoryPreload,
	                    lang: lang
	                })
	            );
	        }
	    }]);
	    return Category;
	}(_react2.Component), _class2.propTypes = {
	    getProductByCategory: _react2.PropTypes.func.isRequired
	}, _temp2)) || _class) || _class));
	
	exports.default = Category;
	module.exports = exports['default'];

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    CategoryView: {
	        displayName: 'CategoryView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Category/default/CategoryView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var CategoryView = _wrapComponent('CategoryView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(CategoryView, _Component);
	
	    function CategoryView(props) {
	        (0, _classCallCheck3.default)(this, CategoryView);
	        return (0, _possibleConstructorReturn3.default)(this, (CategoryView.__proto__ || (0, _getPrototypeOf2.default)(CategoryView)).call(this, props));
	    }
	
	    (0, _createClass3.default)(CategoryView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                activePage = _props.activePage,
	                limit = _props.limit,
	                count = _props.count,
	                products = _props.products,
	                sliderContent = _props.sliderContent,
	                title = _props.title,
	                orderInOneClick = _props.orderInOneClick,
	                buyInCreditActive = _props.buyInCreditActive,
	                lang = _props.lang,
	                picture = _props.picture,
	                description = _props.description;
	
	
	            var body = null;
	
	            if (products.length === 0) {
	                body = _react3.default.createElement(
	                    'h3',
	                    null,
	                    lang['store.category.nothing_found']
	                );
	            } else {
	                body = _react3.default.createElement(_components2.Paginator, {
	                    activePage: activePage,
	                    limit: limit,
	                    count: count,
	                    handleChangePage: this.props.handleChangePage
	                });
	            }
	            return _react3.default.createElement(
	                'div',
	                { className: 'tab-pane active category_container', id: 'featured' },
	                _react3.default.createElement(
	                    'ul',
	                    null,
	                    picture ? _react3.default.createElement(
	                        'li',
	                        { style: { verticalAlign: 'middle' }, className: 'category-picture' },
	                        _react3.default.createElement('img', { src: picture, alt: '', style: { maxHeight: '110px' } })
	                    ) : null,
	                    _react3.default.createElement(
	                        'li',
	                        { style: { verticalAlign: 'middle', paddingLeft: '0px', display: 'inline-block' } },
	                        _react3.default.createElement(
	                            'h1',
	                            null,
	                            title
	                        )
	                    )
	                ),
	                description ? _react3.default.createElement(
	                    'div',
	                    { style: { marginBottom: '22px', marginTop: '37px' } },
	                    _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: description } })
	                ) : null,
	                sliderContent && sliderContent.length > 0 ? _react3.default.createElement(
	                    'div',
	                    null,
	                    _react3.default.createElement(
	                        'h2',
	                        { className: 'best_sailers_header text-theme' },
	                        lang['store.category.recommended']
	                    ),
	                    _react3.default.createElement(_components2.GoodsSlider, {
	                        items: sliderContent,
	                        count: 3,
	                        contentType: "product",
	                        orderInOneClick: orderInOneClick,
	                        buyInCreditActive: buyInCreditActive
	                    })
	                ) : null,
	                _react3.default.createElement(
	                    _components2.Preloader,
	                    { preload: this.props.preload },
	                    _react3.default.createElement(_components2.Products, { products: products })
	                ),
	                body
	            );
	        }
	    }]);
	    return CategoryView;
	}(_react2.Component), _class.defaultProps = {
	    preload: false
	}, _class.propTypes = {
	    title: _react2.PropTypes.string,
	    lang: _react2.PropTypes.object
	}, _temp));
	
	exports.default = CategoryView;
	module.exports = exports['default'];

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Category = undefined;
	
	var _Category2 = __webpack_require__(1806);
	
	var _Category3 = _interopRequireDefault(_Category2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Category = _Category3.default;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 18.11.16.
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    CheckAuth: {
	        displayName: 'CheckAuth'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/CheckAuth/CheckAuth.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var CheckAuth = _wrapComponent('CheckAuth')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        user: state.auth.user
	    };
	}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(CheckAuth, _Component);
	
	    function CheckAuth() {
	        (0, _classCallCheck3.default)(this, CheckAuth);
	        return (0, _possibleConstructorReturn3.default)(this, (CheckAuth.__proto__ || (0, _getPrototypeOf2.default)(CheckAuth)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(CheckAuth, [{
	        key: 'render',
	        value: function render() {
	            if (!this.props.user) {
	                this.props.pushState('/');
	                return null;
	            }
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                this.props.children
	            );
	        }
	    }]);
	    return CheckAuth;
	}(_react2.Component), _class2.propTypes = {
	    children: _react2.PropTypes.node,
	    pushState: _react2.PropTypes.func.isRequired,
	    user: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = CheckAuth;
	module.exports = exports['default'];

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckAuth = undefined;
	
	var _CheckAuth2 = __webpack_require__(1809);
	
	var _CheckAuth3 = _interopRequireDefault(_CheckAuth2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CheckAuth = _CheckAuth3.default;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class;
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _catalog = __webpack_require__(67);
	
	var _modal_type = __webpack_require__(42);
	
	var _sliders = __webpack_require__(767);
	
	var _sliders2 = __webpack_require__(261);
	
	var _constants = __webpack_require__(18);
	
	var _helpers = __webpack_require__(15);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Main: {
	        displayName: 'Main'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Main/Main.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Main = _wrapComponent('Main')((_dec = (0, _reduxAsyncConnect.asyncConnect)([
	// {promise: ({store: {dispatch, getState}}) => {
	//     return dispatch(refreshCatalog());
	// }},
	{ promise: function promise(_ref) {
	        var _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	        if (getState().setting.slider_novelty) {
	            return dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_NEW));
	        }return null;
	    } }, { promise: function promise(_ref2) {
	        var _ref2$store = _ref2.store,
	            dispatch = _ref2$store.dispatch,
	            getState = _ref2$store.getState;
	
	        if (getState().setting.slider_hits) {
	            return dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_HIT));
	        }return null;
	    } }, { promise: function promise(_ref3) {
	        var _ref3$store = _ref3.store,
	            dispatch = _ref3$store.dispatch,
	            getState = _ref3$store.getState;
	
	        if (getState().setting.slider_popular) {
	            return dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_POPULAR));
	        }return null;
	    } }]
	// {promise: ({location, store: {dispatch, getState}}) => {
	//         let id = getState().setting.rootCategory.id || 0,
	//             limit = parseInt(location.query.limit, 10) || CatalogNumericConstants.CATEGORY_PAGE_LIMIT,
	//             page = parseInt(location.query.page, 10) || 1;
	//
	//         if (limit > CatalogNumericConstants.MAX_LIMIT) {
	//             limit = CatalogNumericConstants.CATEGORY_PAGE_LIMIT;
	//         }
	//         if (page > CatalogNumericConstants.MAX_PAGE) {
	//             page = 1;
	//         }
	//
	//         return dispatch(getByCategory({id, page: --page, limit}));
	// }}
	), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        setting: state.setting,
	        sliders: state.sliders,
	        catalog: state.catalog,
	        user: state.auth.user,
	        lang: state.lang
	    };
	}, {
	    push: _reactRouterRedux.push,
	    getProductForSlider: _sliders.getProductForSlider,
	    showModalAuth: _modal_type.showModalAuth
	}), _dec(_class = _dec2(_class = function (_Component) {
	    (0, _inherits3.default)(Main, _Component);
	
	    function Main() {
	        var _ref4;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, Main);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref4 = Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call.apply(_ref4, [this].concat(args))), _this), _this.updateProducts = function () {
	            var result = [];
	            if (_this.props.setting.slider_novelty) {
	                result.push(_this.props.getProductForSlider(_sliders2.SLIDER_NEW));
	            }
	            if (_this.props.setting.slider_hits) {
	                result.push(_this.props.getProductForSlider(_sliders2.SLIDER_HIT));
	            }
	            if (_this.props.setting.slider_popular) {
	                result.push(_this.props.getProductForSlider(_sliders2.SLIDER_POPULAR));
	            }
	            return result;
	        }, _this.handleChangePage = function (page, limit) {
	            _this.props.push('/?limit=' + limit + '&page=' + page);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(Main, [{
	        key: 'render',
	        value: function render() {
	            var _props$setting = this.props.setting,
	                slider_novelty = _props$setting.slider_novelty,
	                slider_hits = _props$setting.slider_hits,
	                slider_popular = _props$setting.slider_popular,
	                orderInOneClick = _props$setting.orderInOneClick,
	                buyInCreditActive = _props$setting.buyInCreditActive,
	                buyInCredit = _props$setting.buyInCredit;
	            var _props$catalog = this.props.catalog,
	                activePage = _props$catalog.activePage,
	                categories = _props$catalog.categories,
	                categoryPreload = _props$catalog.categoryPreload,
	                count = _props$catalog.count,
	                limit = _props$catalog.limit,
	                products = _props$catalog.products;
	            var _props = this.props,
	                setting = _props.setting,
	                sliders = _props.sliders,
	                lang = _props.lang;
	
	            var View = _helpers.ThemeHelper.getViewForContainer('Main');
	
	            var sliderSettings = {
	                slider_novelty: slider_novelty,
	                slider_hits: slider_hits,
	                slider_popular: slider_popular,
	                orderInOneClick: orderInOneClick,
	                buyInCreditActive: buyInCreditActive,
	                buyInCredit: buyInCredit
	            };
	
	            var title = setting.seoTitle || lang['menu.main'];
	            var redirectAuthBefore = _LocalStorageProxy2.default.getItem('redirect_before_auth');
	
	            if (!this.props.user && redirectAuthBefore) {
	                this.props.showModalAuth(lang);
	            } else if (redirectAuthBefore) {
	                _LocalStorageProxy2.default.removeItem('redirect_before_auth');
	                this.props.push(redirectAuthBefore);
	            }
	            return _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 no-margin' },
	                _react3.default.createElement(_reactHelmet2.default, { title: title }),
	                _react3.default.createElement(View, {
	                    activePage: activePage,
	                    categories: categories,
	                    count: count,
	                    limit: limit,
	                    products: products,
	                    sliders: sliders,
	                    sliderSettings: sliderSettings,
	                    preload: categoryPreload,
	                    settings: setting,
	                    handleChangePage: this.handleChangePage,
	                    updateProducts: this.updateProducts,
	                    lang: lang
	                })
	            );
	        }
	    }]);
	    return Main;
	}(_react2.Component)) || _class) || _class));
	
	exports.default = Main;
	module.exports = exports['default'];

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1113);
	
	var _reactRouter = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    MainView: {
	        displayName: 'MainView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Main/default/MainView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MainView = _wrapComponent('MainView')(function (_Component) {
	    (0, _inherits3.default)(MainView, _Component);
	
	    function MainView() {
	        (0, _classCallCheck3.default)(this, MainView);
	        return (0, _possibleConstructorReturn3.default)(this, (MainView.__proto__ || (0, _getPrototypeOf2.default)(MainView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(MainView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                activePage = _props.activePage,
	                count = _props.count,
	                handleChangePage = _props.handleChangePage,
	                limit = _props.limit,
	                preload = _props.preload,
	                products = _props.products,
	                settings = _props.settings,
	                sliderSettings = _props.sliderSettings,
	                sliders = _props.sliders,
	                lang = _props.lang;
	            var seoH1 = settings.seoH1;
	
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement('div', { className: 'main_promo_text text-theme', dangerouslySetInnerHTML: { __html: seoH1 } }),
	                sliderSettings.slider_novelty && sliders.products_novelty.length ? _react3.default.createElement(
	                    'div',
	                    null,
	                    _react3.default.createElement(
	                        'h2',
	                        { className: 'best_sailers_header text-theme' },
	                        lang['store.main.new']
	                    ),
	                    _react3.default.createElement(_components2.GoodsSlider, {
	                        items: sliders.products_novelty,
	                        count: 3,
	                        contentType: "product",
	                        updateProducts: this.props.updateProducts,
	                        orderInOneClick: sliderSettings.orderInOneClick,
	                        buyInCreditActive: sliderSettings.buyInCreditActive
	                    })
	                ) : null,
	                sliderSettings.slider_hits && sliders.products_hits.length ? _react3.default.createElement(
	                    'div',
	                    null,
	                    _react3.default.createElement(
	                        'h2',
	                        { className: 'best_sailers_header text-theme' },
	                        lang['store.main.hits']
	                    ),
	                    _react3.default.createElement(_components2.GoodsSlider, {
	                        items: sliders.products_hits,
	                        count: 3,
	                        contentType: "product",
	                        updateProducts: this.props.updateProducts,
	                        orderInOneClick: sliderSettings.orderInOneClick,
	                        buyInCreditActive: sliderSettings.buyInCreditActive
	                    })
	                ) : null,
	                sliderSettings.slider_popular && sliders.products_popular.length ? _react3.default.createElement(
	                    'div',
	                    null,
	                    _react3.default.createElement(
	                        'h2',
	                        { className: 'best_sailers_header text-theme' },
	                        lang['store.main.sale']
	                    ),
	                    _react3.default.createElement(_components2.GoodsSlider, {
	                        items: sliders.products_popular,
	                        count: 3,
	                        contentType: "product",
	                        updateProducts: this.props.updateProducts,
	                        orderInOneClick: sliderSettings.orderInOneClick,
	                        buyInCreditActive: sliderSettings.buyInCreditActive
	                    })
	                ) : null,
	                _react3.default.createElement(
	                    _components2.Preloader,
	                    { preload: preload },
	                    _react3.default.createElement(_components2.Products, { products: products })
	                ),
	                products.length != 0 ? _react3.default.createElement(_components2.Paginator, {
	                    activePage: activePage,
	                    limit: limit,
	                    count: count,
	                    handleChangePage: handleChangePage
	                }) : null
	            );
	        }
	    }]);
	    return MainView;
	}(_react2.Component));
	
	exports.default = MainView;
	module.exports = exports['default'];

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Main = undefined;
	
	var _Main2 = __webpack_require__(1811);
	
	var _Main3 = _interopRequireDefault(_Main2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Main = _Main3.default;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    NotFound: {
	        displayName: 'NotFound'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/NotFound/NotFound.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var NotFound = _wrapComponent('NotFound')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang
	    };
	}), _dec(_class = function (_Component) {
	    (0, _inherits3.default)(NotFound, _Component);
	
	    function NotFound(props) {
	        (0, _classCallCheck3.default)(this, NotFound);
	        return (0, _possibleConstructorReturn3.default)(this, (NotFound.__proto__ || (0, _getPrototypeOf2.default)(NotFound)).call(this, props));
	    }
	
	    (0, _createClass3.default)(NotFound, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForContainer('NotFound');
	
	            var helmetTitle = this.props.lang['store.helmet.not_found'];
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'row' },
	                _react3.default.createElement(_reactHelmet2.default, { title: helmetTitle }),
	                _react3.default.createElement(View, { lang: this.props.lang })
	            );
	        }
	    }]);
	    return NotFound;
	}(_react2.Component)) || _class));
	
	exports.default = NotFound;
	module.exports = exports['default'];

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	__webpack_require__(1114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    NotFound: {
	        displayName: 'NotFound'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/NotFound/default/NotFoundView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var NotFound = _wrapComponent('NotFound')(function (_Component) {
	    (0, _inherits3.default)(NotFound, _Component);
	
	    function NotFound() {
	        (0, _classCallCheck3.default)(this, NotFound);
	        return (0, _possibleConstructorReturn3.default)(this, (NotFound.__proto__ || (0, _getPrototypeOf2.default)(NotFound)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(NotFound, [{
	        key: 'render',
	        value: function render() {
	            return _react3.default.createElement(
	                'div',
	                { className: 'col-sm-6 col-sm-offset-3 col-xs-12' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'not_found_wrap' },
	                    _react3.default.createElement(
	                        'h1',
	                        null,
	                        '404'
	                    ),
	                    _react3.default.createElement(
	                        'p',
	                        null,
	                        this.props.lang['store.not_found.message']
	                    ),
	                    _react3.default.createElement('i', { className: 'fa fa-frown-o' })
	                )
	            );
	        }
	    }]);
	    return NotFound;
	}(_react2.Component));
	
	exports.default = NotFound;
	module.exports = exports['default'];

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NotFound = undefined;
	
	var _NotFound2 = __webpack_require__(1814);
	
	var _NotFound3 = _interopRequireDefault(_NotFound2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.NotFound = _NotFound3.default;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    NotFoundServer: {
	        displayName: 'NotFoundServer'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/NotFoundServer/NotFoundServer.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var NotFoundServer = _wrapComponent('NotFoundServer')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang
	    };
	}), _dec(_class = function (_Component) {
	    (0, _inherits3.default)(NotFoundServer, _Component);
	
	    function NotFoundServer() {
	        (0, _classCallCheck3.default)(this, NotFoundServer);
	        return (0, _possibleConstructorReturn3.default)(this, (NotFoundServer.__proto__ || (0, _getPrototypeOf2.default)(NotFoundServer)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(NotFoundServer, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForContainer('NotFoundServer');
	            var helmetTitle = this.props.lang['store.helmet.server_is_unavailable'];
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'row' },
	                _react3.default.createElement(_reactHelmet2.default, { title: helmetTitle }),
	                _react3.default.createElement(View, { lang: this.props.lang })
	            );
	        }
	    }]);
	    return NotFoundServer;
	}(_react2.Component)) || _class));
	
	exports.default = NotFoundServer;
	module.exports = exports['default'];

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	__webpack_require__(1115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    NotFoundServer: {
	        displayName: 'NotFoundServer'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/NotFoundServer/default/NotFoundServerView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var NotFoundServer = _wrapComponent('NotFoundServer')(function (_Component) {
	    (0, _inherits3.default)(NotFoundServer, _Component);
	
	    function NotFoundServer(props) {
	        (0, _classCallCheck3.default)(this, NotFoundServer);
	        return (0, _possibleConstructorReturn3.default)(this, (NotFoundServer.__proto__ || (0, _getPrototypeOf2.default)(NotFoundServer)).call(this, props));
	    }
	
	    (0, _createClass3.default)(NotFoundServer, [{
	        key: 'render',
	        value: function render() {
	            return _react3.default.createElement(
	                'div',
	                { className: 'col-md-6 col-md-offset-3 col-xs-12' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'not_found_wrap' },
	                    _react3.default.createElement(
	                        'h1',
	                        null,
	                        this.props.lang['store.common.server_is_unavailable']
	                    )
	                )
	            );
	        }
	    }]);
	    return NotFoundServer;
	}(_react2.Component));
	
	exports.default = NotFoundServer;
	module.exports = exports['default'];

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NotFoundServer = undefined;
	
	var _NotFoundServer2 = __webpack_require__(1817);
	
	var _NotFoundServer3 = _interopRequireDefault(_NotFoundServer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.NotFoundServer = _NotFoundServer3.default;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _promise = __webpack_require__(58);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _utils = __webpack_require__(31);
	
	var _components2 = __webpack_require__(16);
	
	var _payment = __webpack_require__(114);
	
	var _personal = __webpack_require__(165);
	
	var _modal = __webpack_require__(26);
	
	var _modal_type = __webpack_require__(42);
	
	var _auth = __webpack_require__(53);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	var _utils2 = __webpack_require__(384);
	
	var orderUtils = _interopRequireWildcard(_utils2);
	
	var _addresses = __webpack_require__(260);
	
	var _windowOrGlobal = __webpack_require__(264);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    CreateOrder: {
	        displayName: 'CreateOrder'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Order/CreateOrder.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var CreateOrder = _wrapComponent('CreateOrder')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState,
	            params = _ref.params,
	            location = _ref.location;
	
	        var pipoId = getState().setting.pipoOnlineShopId;
	
	        var _getState = getState(),
	            user = _getState.auth.user;
	
	        var promise = [];
	        if (user) {
	            var id = parseInt(params.order_id, 10);
	
	            promise = [dispatch((0, _personal.getPersonalOrderDetail)(id)), dispatch((0, _payment.getPayment)()), dispatch((0, _payment.getPaymentsParamsFromPIPObyId)(pipoId)), dispatch((0, _auth.load)()), dispatch((0, _addresses.loadAddresses)())];
	        }
	        return _promise2.default.all(promise);
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        address: state.address,
	        payments: orderUtils.mergePaymentParameters(state.payment.list, state.payment.pipoList),
	        order: state.personal_order_detail.order,
	        user: state.auth.user,
	        setting: state.setting,
	        preload: state.personal_order_detail.preload,
	        preloadPay: state.payment.preload,
	        turnstileCaptcha: state.setting.turnstileCaptcha,
	        turnstileCaptchaSitekey: state.setting.turnstileCaptchaSitekey,
	        lang: state.lang
	    };
	}, { push: _reactRouterRedux.push, setPaymentId: _payment.setPaymentId, addAddress: _addresses.addAddress, showModal: _modal.showModal, hide: _modal.hide, setOrder: _personal.setOrder, showModalAuth: _modal_type.showModalAuth }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(CreateOrder, _Component);
	
	    function CreateOrder(props, context) {
	        (0, _classCallCheck3.default)(this, CreateOrder);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (CreateOrder.__proto__ || (0, _getPrototypeOf2.default)(CreateOrder)).call(this, props, context));
	
	        _this.handleAddressAdd = function (address) {
	            _this.props.addAddress(address.address).then(function () {
	                return _reactSAlert2.default.success(_this.props.lang['store.common.addresses.added'], { position: 'top-right', effect: 'slide', timeout: 5000 });
	            });
	        };
	
	        _this.onPay = function () {
	            var lang = _this.props.lang;
	
	            var captcha = void 0;
	            if (_this.props.turnstileCaptcha) {
	                captcha = turnstile.getResponse();
	                if (captcha == undefined || captcha == null) {
	                    var alertMessage = _this.props.lang['user.errorInvalidCaptcha'];
	                    setTimeout(function () {
	                        _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                    }, 0);
	                    return null;
	                }
	            }
	
	            var access_token = _LocalStorageProxy2.default.getItem('ibonus.access_token') || null,
	                refresh_token = _LocalStorageProxy2.default.getItem('ibonus.refresh_token') || null;
	
	            // проверяем авторизацию поьзователя
	            if (_this.props.user && access_token && refresh_token) {
	                if (_this.props.payments.length === 0) {
	                    _this.props.showModal({
	                        title: lang['store.create_order.order_payment'],
	                        content: _react3.default.createElement(
	                            'div',
	                            null,
	                            lang['store.create_order.order_payment_error.first'],
	                            '.',
	                            _react3.default.createElement('br', null),
	                            lang['store.create_order.order_payment_error.second'],
	                            '.',
	                            _react3.default.createElement('br', null),
	                            lang['store.create_order.order_payment_error.third'],
	                            '.'
	                        ),
	                        modalType: 'order_create'
	                    });
	                } else {
	                    if (_this.props.order.sum < 1) {
	                        var _alertMessage = (0, _utils.replaceCharToArrayIndex)(_this.props.lang['error.pipo.operationInvalidMinimalSum'], [_this.props.lang.code]);
	                        setTimeout(function () {
	                            _reactSAlert2.default.error(_alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                        }, 0);
	                        return null;
	                    }
	                    _LocalStorageProxy2.default.setItem('shared_coupons', '');
	                    _this.setState({ preload: true });
	                    _this._onPay({
	                        clientCommentary: _this.state.comment,
	                        delivery_address: _this.state.deliveryAddress,
	                        discountSum: _this.state.bonusValue,
	                        couponId: _this.state.couponId,
	                        couponToken: _this.state.couponToken,
	                        customerCouponId: _this.state.customerCouponId,
	                        preloadCallback: _this.onPreloadState,
	                        customFields: _this.state.customFields,
	                        childOrders: _this.state.childOrdersAdditional,
	                        captcha: captcha
	                    });
	                }
	            } else {
	                _this.props.showModalAuth(lang);
	            }
	        };
	
	        _this.onPreloadState = function () {
	            _this.setState({ preload: false });
	        };
	
	        _this.onChangeInput = function (e) {
	            _this.setState({ comment: e.target.value });
	        };
	
	        _this.onDeliveryAddressChange = function (e) {
	            _this.setState({ deliveryAddress: e.target.value });
	        };
	
	        _this.onChangeBonusValue = function (e) {
	            _this.setState({ bonusValue: e.target.value });
	        };
	
	        _this.couponSelect = function (coupon) {
	            var lang = _this.props.lang;
	
	            if (coupon.id === _this.state.couponId) {
	                _this.setState({ couponId: null });
	                _this.setState({ couponToken: null });
	                _this.setState({ customerCouponId: null });
	                _this.props.order.products = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this.props.order.productsCurrent));
	                _this.props.order.sum = _this.props.order.sumCurrent;
	            } else {
	                var useCoupon = false;
	                _this.props.order.products.forEach(function (item) {
	                    if (item.offer.id === coupon.offer.id && item.modifier_option_id === coupon.modifier_option_id && item.isCoupon !== true) {
	                        useCoupon = true;
	                    }
	                });
	                if (!useCoupon) {
	                    var modalContent = _react3.default.createElement(
	                        'div',
	                        { className: 'row no-margin' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            lang['store.useCoupon.popup.confirmation.p1'],
	                            ' ',
	                            coupon.offer.name,
	                            ' ',
	                            lang['store.useCoupon.popup.confirmation.p2']
	                        )
	                    );
	
	                    _this.props.showModal({
	                        title: lang['store.useCoupon.popup.title'],
	                        content: modalContent,
	                        titleSuccess: lang['store.common.yes'],
	                        titleClose: lang['store.common.no'],
	                        onSuccess: function onSuccess() {
	                            _this.props.order.sum = _this.props.order.sumCurrent;
	                            _this.props.order.products = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this.props.order.productsCurrent));
	                            _this.props.order.products.push({
	                                id: coupon.id,
	                                isCoupon: true,
	                                quantity: 1, price: 0, base_price: 0,
	                                modifier_option_id: coupon.modifier_option_id,
	                                modifiedOption: coupon.modifiedOption,
	                                offer: coupon.offer
	                            });
	                            _this.setState({ couponId: coupon.id });
	                            _this.setState({ couponToken: coupon.token });
	                            _this.setState({ customerCouponId: coupon.customer_coupon_id });
	                        },
	                        modalType: 'del'
	                    });
	                } else {
	                    _this.props.order.sum = _this.props.order.sumCurrent;
	                    _this.props.order.products = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this.props.order.productsCurrent));
	                    _this.props.order.products.forEach(function (item) {
	                        if (item.offer.id === coupon.offer.id && item.modifier_option_id === coupon.modifier_option_id) {
	                            if (item.quantity === 1) {
	                                _this.props.order.sum = _this.props.order.sum - item.base_price;
	                                item.price = 0;
	                                item.base_price = 0;
	                                item.isCoupon = true;
	                            } else {
	                                item.quantity = item.quantity - 1;
	                                _this.props.order.sum = _this.props.order.sum - item.base_price;
	                                _this.props.order.products.push({
	                                    id: coupon.id,
	                                    isCoupon: true,
	                                    quantity: 1,
	                                    price: 0,
	                                    base_price: 0,
	                                    modifier_option_id: coupon.modifier_option_id,
	                                    modifiedOption: coupon.modifiedOption,
	                                    offer: coupon.offer
	                                });
	                            }
	                            _this.setState({ couponId: coupon.id });
	                            _this.setState({ couponToken: coupon.token });
	                            _this.setState({ customerCouponId: coupon.customer_coupon_id });
	                        }
	                    });
	                }
	            }
	        };
	
	        _this.changeCustomFields = function (e) {
	            if (_this.state.customFields[e.target.id].type === 'text') {
	                _this.state.customFields[e.target.id].value = e.target.value;
	            } else {
	                _this.state.customFields[e.target.id].value = e.target.checked;
	            }
	            _this.setState({ customFields: _this.state.customFields });
	        };
	
	        _this.onSuccessCaptcha = function (value) {
	            _this.setState({ captcha: value });
	        };
	
	        _this.showCaptcha = function () {
	            if (_this.props.turnstileCaptcha) {
	                return _react3.default.createElement('div', {
	                    id: 'myWidgetTurnstile',
	                    className: 'cf-turnstile',
	                    'data-sitekey': _this.props.turnstileCaptchaSitekey,
	                    'data-callback': _this.onSuccessCaptcha
	                });
	            }
	            return '';
	        };
	
	        _this.renderCaptcha = function () {
	            if (_this.props.turnstileCaptcha) {
	                setTimeout(function () {
	                    if (_this.state.renderCaptcha) {
	                        var elm = document.getElementById('myWidgetTurnstile');
	                        turnstile.render(elm, {
	                            sitekey: _this.props.turnstileCaptchaSitekey
	                        });
	                        _this.setState({ renderCaptcha: false });
	                    }
	                }, 1500);
	            }
	            return '';
	        };
	
	        var order = props.order || {};
	        if (!order.id) {
	            // если заказ не найден
	            _reactSAlert2.default.error(props.lang['error.orderNotFind'], { position: 'top-right', effect: 'slide', timeout: 3000 });
	            props.push('/personal/order-list'); // редиректим на "список заказов"
	        } else {
	            var AccountsList = props.user.amount[0];
	            var discountSum = props.order.sum / 2;
	            var addAmount = 0;
	            if (order.discount_sum > 0) {
	                discountSum = order.discount_sum * 1;
	                addAmount = order.discount_sum * 1;
	            }
	            if (AccountsList.amount + addAmount > 0 && AccountsList.amount + addAmount < discountSum) {
	                discountSum = AccountsList.amount * 1 + addAmount;
	            }
	            if (AccountsList.amount == 0 || props.order.sum <= 1) {
	                discountSum = 0;
	            }
	            if (props.order.sum - discountSum < 1) {
	                discountSum = props.order.sum - 1;
	                if (discountSum < 0) discountSum = 0;
	            }
	            discountSum = Math.floor(discountSum);
	            var defaultAddressString = null;
	            if (props.setting.deliveryFieldShow === true) {
	                var defaultAddress = (props.address.list || []).find(function (address) {
	                    return address.is_default;
	                });
	                defaultAddressString = (defaultAddress || {}).address;
	            }
	            var bonusValue = discountSum;
	            var customFields = [];
	            if (order.ibonus_data !== null) {
	                var IBonusData = _windowOrGlobal.JSON.parse(order.ibonus_data);
	                bonusValue = 0;
	                if (IBonusData.discount_sum) {
	                    bonusValue = IBonusData.discount_sum * 1;
	                }
	                if (IBonusData.custom_fields !== undefined && IBonusData.custom_fields !== null) {
	                    customFields = IBonusData.custom_fields;
	                }
	            } else if (order.discount_sum > 0) {
	                bonusValue = 0;
	            }
	            var childOrders = {};
	            if (order.childOrders) {
	                order.childOrders.forEach(function (item) {
	                    childOrders[item.id] = {
	                        id: item.id,
	                        comment: item.client_comment,
	                        deliveryAddress: item.delivery_address
	                    };
	                    childOrders[item.id].onAddressChangeChildOrder = function (e) {
	                        var orderId = item.id;
	                        _this._onAddressChangeByChildOrders(orderId, e.target.value);
	                    };
	                    childOrders[item.id].onCommentChangeChildOrder = function (e) {
	                        var orderId = item.id;
	                        _this._onCommentChangeByChildOrders(orderId, e.target.value);
	                    };
	                });
	            }
	
	            _this.state = {
	                comment: '',
	                failError: '',
	                bonusValue: bonusValue,
	                couponId: null,
	                couponToken: null,
	                customerCouponId: null,
	                deliveryAddress: defaultAddressString,
	                preload: false,
	                customFields: customFields,
	                childOrdersAdditional: childOrders,
	                renderCaptcha: true,
	                widgetId: null
	            };
	            if (_this.props.order.client_comment) {
	                _this.state.comment = _this.props.order.client_comment;
	            }
	
	            _this.props.order.productsCurrent = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this.props.order.products));
	            _this.props.order.sumCurrent = _this.props.order.sum;
	            if (_this.props.order.delivery_address) {
	                _this.state.deliveryAddress = _this.props.order.delivery_address;
	            }
	            var useCoupon = false;
	            var couponProduct = null;
	            _this.props.order.productsCurrent.forEach(function (item) {
	                if (item.is_coupon === true) {
	                    useCoupon = true;
	                    couponProduct = item;
	                }
	            });
	            if (useCoupon) {
	                var productsCurrent = _this.props.order.products.filter(function (item) {
	                    return item.id !== couponProduct.id;
	                });
	                _this.props.order.productsCurrent = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(productsCurrent));
	                var changeCount = false;
	                _this.props.order.productsCurrent.forEach(function (item) {
	                    if (item.offer.id === couponProduct.offer.id && item.modifier_option_id === couponProduct.modifier_option_id && item.is_coupon !== true && item.isCoupon !== true) {
	                        changeCount = true;
	                        item.quantity++;
	                        _this.props.order.sumCurrent = _this.props.order.sumCurrent * 1 + couponProduct.offer.price * 1;
	                    }
	                });
	                if (!changeCount) {
	                    couponProduct.price = couponProduct.offer.price;
	                    couponProduct.base_price = couponProduct.offer.price;
	                    _this.props.order.productsCurrent.push(couponProduct);
	                    _this.props.order.sumCurrent = _this.props.order.sumCurrent * 1 + couponProduct.offer.price * 1;
	                }
	                _this.props.user.coupons.forEach(function (item) {
	                    if (item.offer_id === couponProduct.offer_id && item.modifier_option_id === couponProduct.modifier_option_id) {
	                        _this.state.couponId = item.id;
	                    }
	                });
	            }
	        }
	        _this._onPay = function () {};
	        return _this;
	    }
	
	    (0, _createClass3.default)(CreateOrder, [{
	        key: '_onAddressChangeByChildOrders',
	        value: function _onAddressChangeByChildOrders(orderId, address) {
	            this.state.childOrdersAdditional[orderId].deliveryAddress = address;
	            this.setState({ customFields: this.state.customFields });
	        }
	    }, {
	        key: '_onCommentChangeByChildOrders',
	        value: function _onCommentChangeByChildOrders(orderId, comment) {
	            this.state.childOrdersAdditional[orderId].comment = comment;
	            this.setState({ customFields: this.state.customFields });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.address[0]) this.setState({ deliveryAddress: this.props.address[0] });
	            if (this.props.location.query.hasOwnProperty('fail') && this.props.location.query.hasOwnProperty('error')) {
	                this.setState({ complite: false, failError: this.props.location.query.error });
	            } else if (this.props.location.query.hasOwnProperty('fail') && this.props.location.query.hasOwnProperty('error_message')) {
	                this.setState({ complite: false, failError: this.props.location.query.error_message });
	            } else if (this.props.location.query.hasOwnProperty('fail')) {
	                this.setState({ complite: false, failError: 'При оплате произошла ошибка.' });
	            }
	        }
	    }, {
	        key: '_getPriceSaleWithIBonusDiscount',
	        value: function _getPriceSaleWithIBonusDiscount(product) {
	            var discount_to_product = this._getIbonusDiscountToProduct(product);
	            if (discount_to_product <= 0) {
	                return Number(product.base_price);
	            }
	            return Number(product.base_price) - discount_to_product;
	        }
	    }, {
	        key: '_getIbonusDiscountToProduct',
	        value: function _getIbonusDiscountToProduct(product) {
	            if (this.state.bonusValue) {
	                var orderSum = this.props.order.sum;
	                var discountPercent = this.state.bonusValue / (orderSum / 100);
	                var bonusDiscountToProduct = product.base_price * (discountPercent / 100);
	                return bonusDiscountToProduct;
	            }
	            return 0;
	        }
	    }, {
	        key: 'callbackCaptcha',
	        value: function callbackCaptcha(token) {
	            this.setState({ captcha: token });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            if (this.props.order == null) {
	                return null;
	            }
	            if (!this.props.user) {
	                return null;
	            }
	            var _props$order = this.props.order,
	                _props$order$products = _props$order.products,
	                products = _props$order$products === undefined ? [] : _props$order$products,
	                sum = _props$order.sum;
	
	            if (sum - this.state.bonusValue < 0 || this.state.bonusValue < 0) {
	                this.setState({ bonusValue: 0 });
	                this.state.bonusValue = 0;
	            }
	            var sumDiscount = this.props.order.discount_sum * 1;
	            if (sum > 0) {
	                var AccountsList = this.props.user.amount[0];
	
	                var discountSum = sum / 2;
	                var addAmount = 0;
	                if (this.props.order.discount_sum > 0) {
	                    addAmount = this.props.order.discount_sum * 1;
	                }
	                if (AccountsList.amount + addAmount > 0 && AccountsList.amount + addAmount < discountSum) {
	                    discountSum = AccountsList.amount * 1 + addAmount;
	                }
	                if (sum - discountSum < 1) {
	                    discountSum = sum - 1;
	                    if (discountSum < 0) discountSum = 0;
	                }
	                discountSum = Math.floor(discountSum);
	                if (this.state.bonusValue > discountSum) {
	                    this.setState({ bonusValue: discountSum });
	                    this.state.bonusValue = discountSum;
	                }
	                if (this.props.order.ibonus_data !== null) {
	                    var IBonusData = _windowOrGlobal.JSON.parse(this.props.order.ibonus_data);
	                    if (IBonusData.discount_sum) {
	                        sumDiscount = this.props.order.discount_sum * 1 - IBonusData.discount_sum * 1;
	                    }
	                    // if (IBonusData.custom_fields !== undefined && IBonusData.custom_fields !== null) {
	                    //     this.props.customFields = IBonusData.custom_fields;
	                    // }
	                }
	                sumDiscount = 0;
	                this.props.order.products.forEach(function (product) {
	                    var discountPerPiece = _this2.props.order.orderDiscounts.reduce(function (discountPerPiece, discount) {
	                        var isAdd = product.productDiscounts.find(function (productDiscount) {
	                            return productDiscount.discount_id === discount.discount_id;
	                        });
	                        if (!isAdd) {
	                            product.productDiscounts.push(discount);
	                        }
	                        var sum = discount.rate_in_percent / 100 * _this2._getPriceSaleWithIBonusDiscount(product);
	                        var result = discountPerPiece + sum;
	                        return +result;
	                    }, 0);
	                    // Сделаем общий метод пробежки по массиву и пересчитаем общую сумму со всеми скидками сразу
	                    if (product.productDiscounts.length) {
	                        discountPerPiece = product.productDiscounts.reduce(function (discountPerPiece, discount) {
	                            var sum = discount.rate_in_percent / 100 * _this2._getPriceSaleWithIBonusDiscount(product);
	                            var result = discountPerPiece + sum;
	                            return +result;
	                        }, 0);
	                    }
	                    product.discountPerPiece = discountPerPiece;
	                    sumDiscount += discountPerPiece * product.quantity;
	                    product.additionalInfo = product.additional_info ? _windowOrGlobal.JSON.parse(product.additional_info) : null;
	                    if (product.additionalInfo && product.additionalInfo.custom_fields) {
	                        product.custom_fields = product.additionalInfo.custom_fields;
	                    }
	                });
	            }
	            if (this.props.payments.length === 0) {
	                return _react3.default.createElement(
	                    _components2.Preloader,
	                    { preload: this.props.preload || this.props.preloadPay || this.state.preload },
	                    _react3.default.createElement(_components2.OrderItems, {
	                        onAddAddress: this.handleAddressAdd,
	                        addressOptions: this.props.address.list,
	                        comment: this.state.comment,
	                        setting: this.props.setting,
	                        products: products,
	                        sum: sum,
	                        failError: this.state.failError,
	                        onChangeInput: this.onChangeInput,
	                        onPay: this.onPay,
	                        couponSelect: this.couponSelect,
	                        couponId: this.state.couponId,
	                        user: this.props.user,
	                        bonusValue: this.state.bonusValue,
	                        sumDiscount: sumDiscount,
	                        ibonus_data: this.props.order.ibonus_data,
	                        order_type_id: this.props.order.type_id,
	                        childOrders: this.props.order.childOrders,
	                        childOrdersAdditional: this.state.childOrdersAdditional,
	                        paymentInId: this.props.order.payment_in_id,
	                        onChangeBonusValue: this.onChangeBonusValue,
	                        before: _react3.default.createElement(_components2.OrderSteps, { step: '2' }),
	                        deliveryAddress: this.state.deliveryAddress,
	                        onDeliveryAddressChange: this.onDeliveryAddressChange,
	                        customFields: this.state.customFields,
	                        changeCustomFields: this.changeCustomFields,
	                        showCaptcha: this.showCaptcha,
	                        renderCaptcha: this.renderCaptcha
	                    })
	                );
	            }
	
	            var disButton = function disButton() {
	                var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	                _this2.setState({ disabled: !slug });
	            };
	
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload || this.props.preloadPay || this.state.preload },
	                _react3.default.createElement(_components2.OrderItems, {
	                    onAddAddress: this.handleAddressAdd,
	                    addressOptions: this.props.address.list,
	                    comment: this.state.comment,
	                    setting: this.props.setting,
	                    products: products,
	                    sum: sum,
	                    onChangeInput: this.onChangeInput,
	                    onPay: this.onPay,
	                    couponSelect: this.couponSelect,
	                    couponId: this.state.couponId,
	                    user: this.props.user,
	                    bonusValue: this.state.bonusValue,
	                    sumDiscount: sumDiscount,
	                    ibonus_data: this.props.order.ibonus_data,
	                    order_type_id: this.props.order.type_id,
	                    childOrders: this.props.order.childOrders,
	                    childOrdersAdditional: this.state.childOrdersAdditional,
	                    paymentInId: this.props.order.payment_in_id,
	                    onChangeBonusValue: this.onChangeBonusValue,
	                    before: _react3.default.createElement(_components2.OrderSteps, { step: '2' }),
	                    disabled: this.state.disabled,
	                    failError: this.state.failError,
	                    paymentList: _react3.default.createElement(_components2.PaymentList, {
	                        disButton: disButton,
	                        payments: this.props.payments,
	                        order: this.props.order,
	                        getInstance: function getInstance(PaymentListComponent) {
	                            _this2._onPay = PaymentListComponent.onPay;
	                        }
	                    }),
	                    deliveryAddress: this.state.deliveryAddress,
	                    onDeliveryAddressChange: this.onDeliveryAddressChange,
	                    customFields: this.state.customFields,
	                    changeCustomFields: this.changeCustomFields,
	                    showCaptcha: this.showCaptcha,
	                    renderCaptcha: this.renderCaptcha
	                })
	            );
	        }
	    }]);
	    return CreateOrder;
	}(_react2.Component), _class2.propTypes = {
	    order: _react2.PropTypes.object,
	    payments: _react2.PropTypes.array,
	    showModal: _react2.PropTypes.func,
	    hide: _react2.PropTypes.func,
	    user: _react2.PropTypes.any,
	    showModalAuth: _react2.PropTypes.func,
	    setting: _react2.PropTypes.object.isRequired,
	    push: _react2.PropTypes.func.isRequired,
	    lang: _react2.PropTypes.object,
	    preload: _react2.PropTypes.bool
	}, _temp)) || _class) || _class));
	
	exports.default = CreateOrder;
	module.exports = exports['default'];

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(69);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _promise = __webpack_require__(58);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _ApiClient = __webpack_require__(741);
	
	var _ApiClient2 = _interopRequireDefault(_ApiClient);
	
	var _IBonusProxy = __webpack_require__(742);
	
	var _IBonusProxy2 = _interopRequireDefault(_IBonusProxy);
	
	var _helpers = __webpack_require__(15);
	
	var _error = __webpack_require__(140);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _payment = __webpack_require__(114);
	
	var _constants = __webpack_require__(1822);
	
	var _personal = __webpack_require__(165);
	
	var _utils = __webpack_require__(384);
	
	var orderUtils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PaymentOrder: {
	        displayName: 'PaymentOrder'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Order/PaymentOrder.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var PaymentOrder = _wrapComponent('PaymentOrder')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref, helpers) {
	        var _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState,
	            params = _ref.params,
	            query = _ref.location.query;
	
	        var promises = [];
	        var pipoId = getState().setting.pipoOnlineShopId;
	
	        if (params && params.order_id > 0) {
	            var resolveWait = void 0;
	            var waitOrderPromise = new _promise2.default(function (resolve) {
	                return resolveWait = resolve;
	            });
	
	            promises.push(dispatch((0, _personal.getPersonalOrderDetail)(params.order_id)).then(function (result) {
	                resolveWait(result);
	                return result;
	            }));
	
	            promises.push(waitOrderPromise.then(function (result) {
	                if (query && query.hasOwnProperty('pi_type')) {
	                    var type = query.pi_type;
	
	                    var name = query.pi_name || '';
	                    var value = query.pi_value || '';
	
	                    return dispatch((0, _payment.loadProcessInput)(result.payment_in_id, type, name, value));
	                }
	
	                return _promise2.default.resolve(null);
	            }));
	        }
	
	        promises.push(dispatch((0, _payment.getPayment)()));
	        promises.push(dispatch((0, _payment.getPaymentsParamsFromPIPObyId)(pipoId)));
	
	        return _promise2.default.all(promises);
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        payments: orderUtils.mergePaymentParameters(state.payment.list, state.payment.pipoList),
	        payment_in_id: state.personal_order_detail.order.payment_in_id,
	        channelId: state.setting.channelId,
	        profileId: state.setting.profileId,
	        buyInCreditActive: state.setting.buyInCreditActive,
	        buyInCredit: state.setting.buyInCredit,
	        processInput: state.payment.processInput,
	        showCustomPayment: state.payment.isCustomPayment,
	        orderId: state.personal_order_detail.order.id,
	        products: state.personal_order_detail.order.products,
	        orderDetail: state.personal_order_detail.order,
	        state: state,
	        lang: state.lang,
	        currency: state.currency
	    };
	}, { resetCustomPayment: _payment.resetCustomPayment, resetProcessInput: _payment.resetProcessInput }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(PaymentOrder, _Component);
	
	    function PaymentOrder(props) {
	        (0, _classCallCheck3.default)(this, PaymentOrder);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentOrder.__proto__ || (0, _getPrototypeOf2.default)(PaymentOrder)).call(this, props));
	
	        _this.setTimeoutId = null;
	        _this.orderId = 0;
	        _this.showProcessInput = false;
	
	        _this.clearTimeout = function () {
	            if (_this.setTimeoutId) {
	                clearTimeout(_this.setTimeoutId);
	                _this.setTimeoutId = null;
	            }
	        };
	
	        _this.handleSuccessStatusOrder = function (result) {
	            if (result.paymentStatus) {
	                var statusPay = parseInt(result.paymentStatus.id, 10) || 0;
	                if (statusPay === _helpers.OrderHelper.PaymentStatusConstants.PAYMENT_STATUS_PAY || statusPay === _helpers.OrderHelper.PaymentStatusConstants.PAYMENT_STATUS_MONEY_TRANSFER) {
	                    _this.setState({ complite: true });
	                    _this.clearTimeout();
	
	                    return;
	                }
	            }
	
	            _this.setTimeoutId = setTimeout(_this.intervalStatusOrder, 3000);
	        };
	
	        _this.intervalStatusOrder = function () {
	            if (_this.orderId) {
	                var ibonus = new _IBonusProxy2.default(new _ApiClient2.default());
	                ibonus.channelId = _this.props.channelId;
	                ibonus.profileId = _this.props.profileId;
	                ibonus.getOrderById(_this.orderId).then(_this.handleSuccessStatusOrder, function (err) {
	                    (0, _error.error)(err.message); // todo: перепроверить
	                    _this.clearTimeout();
	                });
	            }
	        };
	
	        if (props.params && props.params.order_id) {
	            _this.orderId = parseInt(props.params.order_id, 10) || 0;
	        }
	
	        _this.state = {
	            complite: false,
	            failError: ''
	        };
	        if (props.orderDetail.sum > 0) {
	            _this.showProcessInput = (0, _keys2.default)(props.processInput).length > 0;
	        }
	        return _this;
	    }
	
	    (0, _createClass3.default)(PaymentOrder, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.location.query.hasOwnProperty('fail') && this.props.location.query.hasOwnProperty('error')) {
	                this.setState({ complite: false, failError: this.props.location.query.error });
	            } else if (this.props.location.query.hasOwnProperty('fail') && this.props.location.query.hasOwnProperty('error_message')) {
	                this.setState({ complite: false, failError: this.props.location.query.error_message });
	            } else if (this.props.location.query.hasOwnProperty('fail')) {
	                var errorText = this.props.lang['store.payment_order.error_while_paying'];
	                this.setState({ complite: false, failError: errorText });
	            } else if (this.props.showCustomPayment || this.props.location.query.hasOwnProperty('success')) {
	                this.setState({ complite: true });
	            } else if (this.orderId > 0 && !this.showProcessInput) {
	                this.setTimeoutId = setTimeout(this.intervalStatusOrder, 3000);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.showCustomPayment == false && nextProps.showCustomPayment == true) {
	                this.setState({ complite: true });
	            }
	
	            if (this.orderId && nextProps.complite === true && !this.showProcessInput) {
	                this.clearTimeout();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (!this.showProcessInput) {
	                this.clearTimeout();
	            }
	            this.props.resetCustomPayment();
	            if (!this.props.location.query.pi_type) {
	                this.props.resetProcessInput();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var result = 'dark-green';
	            var View = _helpers.ThemeHelper.getViewForContainer('PaymentOrder', null, { folderName: 'Order' });
	            var _props = this.props,
	                payments = _props.payments,
	                payment_in_id = _props.payment_in_id,
	                processInput = _props.processInput,
	                orderId = _props.orderId,
	                products = _props.products,
	                orderDetail = _props.orderDetail,
	                lang = _props.lang,
	                currency = _props.currency;
	
	
	            if (true) {
	                var color = document.body.classList[0];
	
	                switch (color) {
	                    case _constants.GREEN:
	                        result = 'cube';
	                        break;
	                    case _constants.BLUE:
	                        result = 'blue';
	                        break;
	                    case _constants.ORANGE:
	                        result = 'orange';
	                        break;
	                    case _constants.RED:
	                        result = 'red';
	                        break;
	                    case _constants.NAVY:
	                        result = 'navy';
	                        break;
	                    case _constants.DARK_THEME:
	                        result = 'dark';
	                        break;
	                }
	            }
	
	            return _react3.default.createElement(View, {
	                buyInCreditActive: this.props.buyInCreditActive,
	                buyInCredit: this.props.buyInCredit,
	                isCompleted: this.state.complite,
	                failError: this.state.failError,
	                color: result,
	                payments: payments,
	                payment_in_id: payment_in_id,
	                processInput: processInput,
	                showProcessInput: this.showProcessInput,
	                orderId: orderId,
	                products: products,
	                orderDetail: orderDetail,
	                lang: lang,
	                currency: currency
	            });
	        }
	    }]);
	    return PaymentOrder;
	}(_react2.Component), _class2.propTypes = {
	    payments: _react2.PropTypes.array.isRequired,
	    payment_in_id: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.number]),
	    processInput: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp)) || _class) || _class));
	
	exports.default = PaymentOrder;
	module.exports = exports['default'];

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GREEN = exports.GREEN = 'green-theme';
	var BLUE = exports.BLUE = 'blue-theme';
	var ORANGE = exports.ORANGE = 'orange-theme';
	var RED = exports.RED = 'red-theme';
	var NAVY = exports.NAVY = 'navy-theme';
	var DARK_GREEN = exports.DARK_GREEN = 'dark-green-theme';
	var DARK_THEME = exports.DARK_THEME = 'dark-theme';

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _moment = __webpack_require__(11);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(19);
	
	var _SHARE = __webpack_require__(93);
	
	var _components2 = __webpack_require__(16);
	
	var _ProcessInput = __webpack_require__(1709);
	
	var _ProcessInput2 = _interopRequireDefault(_ProcessInput);
	
	__webpack_require__(1116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PaymentOrderView: {
	        displayName: 'PaymentOrderView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Order/default/PaymentOrderView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var PaymentOrderView = _wrapComponent('PaymentOrderView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(PaymentOrderView, _Component);
	
	    function PaymentOrderView(props) {
	        (0, _classCallCheck3.default)(this, PaymentOrderView);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentOrderView.__proto__ || (0, _getPrototypeOf2.default)(PaymentOrderView)).call(this, props));
	
	        _this.onPay = function (event) {
	            event.preventDefault();
	            _this.props.onPay();
	        };
	
	        _this.productsTable = function () {
	            var currency = _this.props.currency;
	
	            return _this.props.products.map(function (item) {
	                var pictures = item.offer.pictures || [];
	                var image = pictures[0];
	                var quantity = parseInt(item.quantity, 10) || 0;
	                var weight = null;
	                var childWeight = null;
	                var modifier_option_name = _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-3 prod_desc' },
	                    _react3.default.createElement('div', { className: 'title' })
	                );
	                item.additionalInfo = item.additional_info ? JSON.parse(item.additional_info) : null;
	                if (item.additionalInfo && item.additionalInfo.custom_fields) {
	                    item.custom_fields = item.additionalInfo.custom_fields;
	                }
	
	                if (item.modifier_option_name !== null && item.modifier_option_name !== '') {
	                    modifier_option_name = _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-3 prod_desc' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'title' },
	                            item.modifier_option_name
	                        )
	                    );
	                } else if (item.modifier_option_id !== null) {
	                    modifier_option_name = _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-3 prod_desc' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'title' },
	                            item.modifiedOption.name
	                        )
	                    );
	                }
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin cart-item' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-1 col-xs-12' },
	                        image && image.preview_url ? _react3.default.createElement('img', { src: image.preview_url }) : null
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-4' },
	                        _react3.default.createElement(
	                            'div',
	                            null,
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'title' },
	                                _react3.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/product/' + item.offer.id },
	                                    item.offer.name
	                                )
	                            ),
	                            _react3.default.createElement(_SHARE.SwitherDescription, { description: item.offer.description }),
	                            item.custom_fields ? item.custom_fields.map(function (product, i) {
	                                return _react3.default.createElement(
	                                    'label',
	                                    null,
	                                    product.name,
	                                    ': ',
	                                    product.value
	                                );
	                            }) : null
	                        )
	                    ),
	                    modifier_option_name,
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'quantity cart_quantity' },
	                            _react3.default.createElement(
	                                'span',
	                                { className: 'visible-xs' },
	                                _this.props.lang['store.common.quantity'],
	                                ': '
	                            ),
	                            _react3.default.createElement(
	                                'span',
	                                null,
	                                quantity
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2 text-center' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'price' },
	                            _react3.default.createElement(_components2.MoneyValue, {
	                                value: parseFloat(item.price * quantity),
	                                icon: currency.icon,
	                                iconAfterValue: currency.icon_after_value
	                            })
	                        )
	                    ),
	                    _react3.default.createElement('div', { className: 'clearfix' }),
	                    item.type_id === 5 ? item.childProducts.map(function (childItem) {
	                        return _this.renderNested(childItem);
	                    }) : null
	                );
	            });
	        };
	
	        _this.renderNested = function (childItem) {
	            var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	            var weight = childItem.quantity;
	            childItem.weight_offer = childItem.weight_offer * 1;
	            if ((childItem.unit.slug === 'kg' || childItem.unit.slug === 'mg') && childItem.weight_offer && childItem.weight_offer > 0 && childItem.quantity > 0) {
	                weight = childItem.weight_offer * childItem.quantity;
	                weight = weight.toFixed(3);
	                if (childItem.weight_offer < 0.01 && childItem.quantity < 1 || childItem.weight_offer < 1 && childItem.quantity < 0.01) {
	                    weight = item.weight_offer * 1;
	                }
	                if (childItem.weight_offer < 0.1 && childItem.quantity < 0.1) {
	                    weight = childItem.weight_offer * 1;
	                }
	            }
	            var paddingLeft = level * 30 + 'px';
	            return _react3.default.createElement(
	                'div',
	                { className: 'row no-margin' },
	                _react3.default.createElement('div', { className: 'col-sm-1  col-xs-12' }),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-4' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title', style: { paddingLeft: paddingLeft } },
	                        '- ',
	                        childItem.name
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-3' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        childItem.modifier_option_name
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2' },
	                    _react3.default.createElement(
	                        'div',
	                        { style: { textAlign: 'center' } },
	                        _react3.default.createElement(
	                            'span',
	                            { className: 'visible-xs' },
	                            _this.props.lang['store.common.quantity'],
	                            ': '
	                        ),
	                        childItem.type_id === 5 ? _react3.default.createElement(
	                            'span',
	                            null,
	                            childItem.quantity
	                        ) : _react3.default.createElement(
	                            'span',
	                            null,
	                            weight,
	                            ' ',
	                            _this.props.lang[childItem.unit.title_lang_data]
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2' },
	                    _react3.default.createElement('div', { className: 'price' })
	                ),
	                _react3.default.createElement('div', { className: 'clearfix' }),
	                childItem.type_id === 5 ? childItem.childProducts.map(function (childChildItem) {
	                    return _this.renderNested(childChildItem, level + 1);
	                }) : null
	            );
	        };
	
	        _this.renderItems = function () {
	            var _this$props = _this.props,
	                lang = _this$props.lang,
	                orderDetail = _this$props.orderDetail;
	
	            if (orderDetail.type_id === 7) {
	                return _react3.default.createElement('div', { className: 'col-xs-12 items-holder no-margin' });
	            }
	            return _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 items-holder no-margin' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin cart-item hidden-xs' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-1' },
	                        lang['store.cart.photo']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-4' },
	                        lang['store.cart.title']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-3' },
	                        lang['store.cart.modifiers']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-2 text-center' },
	                        lang['store.cart.quantity']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-sm-2 text-center' },
	                        lang['store.cart.price']
	                    )
	                ),
	                _this.productsTable()
	            );
	        };
	
	        _this.totalRow = function (text) {
	            var lang = _this.props.lang;
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 products_total_price' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-sm-offset-8 col-sm-4 col-xs-12 text-center' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'summ_price' },
	                        _react3.default.createElement(_components2.MoneyValue, {
	                            value: text,
	                            icon: _this.props.currency.icon,
	                            iconAfterValue: _this.props.currency.icon_after_value,
	                            prefix: lang['store.cart.total'] + ': '
	                        })
	                    )
	                )
	            );
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(PaymentOrderView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                color = _props.color,
	                processInput = _props.processInput,
	                showProcessInput = _props.showProcessInput,
	                orderId = _props.orderId,
	                products = _props.products,
	                orderDetail = _props.orderDetail,
	                lang = _props.lang;
	
	            var sumTotal = orderDetail.sum - orderDetail.discount_sum;
	            var date = (0, _moment2.default)(this.props.orderDetail.time_create);
	
	            if (showProcessInput) {
	                return _react3.default.createElement(
	                    'section',
	                    { id: 'payment-page' },
	                    _react3.default.createElement(_components2.OrderSteps, { step: '3' }),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'row no-margin' },
	                        _react3.default.createElement(_ProcessInput2.default, { data: processInput, orderId: orderId, products: products, sumTotal: sumTotal })
	                    )
	                );
	            }
	
	            if (this.props.isCompleted || this.props.failError.length > 0) {
	                return _react3.default.createElement(
	                    'section',
	                    { id: 'payment-page' },
	                    _react3.default.createElement(_components2.OrderSteps, { step: '3' }),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'payment-order-success' },
	                                _react3.default.createElement(
	                                    'h2',
	                                    { className: 'section-title special_title' },
	                                    lang['store.common.order'],
	                                    ' \u2116',
	                                    orderDetail.order_number
	                                ),
	                                _react3.default.createElement(
	                                    'h5',
	                                    null,
	                                    '' + date.format('DD.MM.YYYY')
	                                )
	                            )
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'small-12 columns' },
	                                this.props.isCompleted ? lang['store.payment_order.payment_success'] : this.props.failError
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'row', id: 'personal-order-detail' },
	                        this.renderItems(),
	                        this.totalRow('' + parseFloat(sumTotal).toFixed(2))
	                    )
	                );
	            }
	            var creditButton = null;
	            if (orderDetail.service_in_slug === 'buy_in_credit' && this.props.buyInCreditActive) {
	                var discountEpsilon = orderDetail.discount_sum;
	                var discountPercent = orderDetail.discount_sum / (orderDetail.sum / 100);
	                var itemsStr = '';
	                orderDetail.products.forEach(function (item, index) {
	                    var modifierOptionName = '';
	                    var sale = parseFloat(item.base_price * (discountPercent / 100)).toFixed(2);
	                    var price = parseFloat(item.base_price - sale).toFixed(2);
	                    discountEpsilon = discountEpsilon - sale * item.quantity;
	                    if (item.modifier_option_name !== null) {
	                        modifierOptionName = item.modifier_option_name;
	                    }
	                    if (index === orderDetail.products.length) {
	                        price = parseFloat(item.base_price - (sale + discountEpsilon / item.quantity)).toFixed(2);
	                    }
	                    itemsStr = itemsStr + 'items.' + index + '.name=' + item.name + ' ' + modifierOptionName + '&items.' + index + '.price=' + price + '&items.' + index + '.quantity=' + item.quantity + '&items.' + index + '.vendorCode=' + item.id_yml + '&';
	                });
	                itemsStr = itemsStr + 'demoFlow=reject&promoCode=' + (this.props.buyInCredit.promo_code === '' ? 'default' : this.props.buyInCredit.promo_code) + '&sum=' + parseFloat(orderDetail.sum - orderDetail.discount_sum).toFixed(2) + '&orderNumber=' + orderDetail.order_number + '&values.contact.mobilePhone=' + orderDetail.client.phone + '&values.contact.email=' + orderDetail.client.email;
	                var buyInCreditButtonName = this.props.lang['onlineShop.buyInCredit.button1'] + parseFloat((orderDetail.sum - orderDetail.discount_sum) / 19 || 0).toFixed(2) + ' ' + this.props.lang['onlineShop.buyInCredit.button2'];
	                var uiData = 'productType=credit';
	                if (this.props.buyInCredit.is_credit == false) {
	                    buyInCreditButtonName = this.props.lang['onlineShop.buyInCredit.installments.button1'] + parseFloat((orderDetail.sum - orderDetail.discount_sum) / 19 || 0).toFixed(2) + ' ' + this.props.lang['onlineShop.buyInCredit.button2'];
	                    uiData = 'productType=installment';
	                }
	                creditButton = _react3.default.createElement('tinkoff-create-button', {
	                    subtext: buyInCreditButtonName,
	                    shopId: this.props.buyInCredit.external_shop_id,
	                    showcaseId: this.props.buyInCredit.showcase_id,
	                    'ui-data': uiData,
	                    'payment-data': itemsStr
	                });
	            }
	            return _react3.default.createElement(
	                'section',
	                { id: 'payment-page' },
	                _react3.default.createElement(_components2.OrderSteps, { step: '3' }),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'small-9 columns' },
	                            _react3.default.createElement(
	                                'h2',
	                                { className: 'section-title special_title' },
	                                lang['store.common.order'],
	                                ' \u2116 ',
	                                orderDetail.order_number
	                            ),
	                            _react3.default.createElement(
	                                'h5',
	                                null,
	                                '' + date.format('DD.MM.YYYY')
	                            )
	                        )
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'wait-block' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'payment-wait' },
	                                lang['store.payment_order.payment_waiting']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'preload-wait' },
	                                _react3.default.createElement('img', { src: '/assets/images/' + color + '.svg', alt: '' })
	                            )
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row', id: 'personal-order-detail' },
	                    this.renderItems(),
	                    this.totalRow('' + parseFloat(sumTotal).toFixed(2)),
	                    creditButton
	                )
	            );
	        }
	    }]);
	    return PaymentOrderView;
	}(_react2.Component), _class.propTypes = {
	    isCompleted: _react2.PropTypes.bool,
	    failError: _react2.PropTypes.string,
	    color: _react2.PropTypes.string.isRequired,
	    processInput: _react2.PropTypes.object,
	    showProcessInput: _react2.PropTypes.bool,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _class.defaultProps = {
	    showProcessInput: false,
	    isCompleted: false,
	    failError: ''
	}, _temp));
	
	exports.default = PaymentOrderView;
	module.exports = exports['default'];

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaymentOrder = exports.CreateOrder = undefined;
	
	var _CreateOrder2 = __webpack_require__(1820);
	
	var _CreateOrder3 = _interopRequireDefault(_CreateOrder2);
	
	var _PaymentOrder2 = __webpack_require__(1821);
	
	var _PaymentOrder3 = _interopRequireDefault(_PaymentOrder2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CreateOrder = _CreateOrder3.default;
	exports.PaymentOrder = _PaymentOrder3.default;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _page = __webpack_require__(766);
	
	var _error = __webpack_require__(140);
	
	__webpack_require__(1117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Page: {
	        displayName: 'Page'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Page/index.js',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Page = _wrapComponent('Page')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var params = _ref.params,
	            location = _ref.location,
	            _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	
	        var url = params.page_url;
	        if (['1B1TTklHsZDbqZ6MGKrDk+vXpx1q-1', '1B1TTklHsZDbqZ6MGKrDk+vXpx1t-2', '1B1TTklHsZDbqZ6MGKrDk+vXpx1i-3', '1B1TTklHsZDbqZ6MGKrDk+vXpx1w-4', '1B1TTklHsZDbqZ6MGKrDk+vXpx1y-5', '1B1TTklHsZDbqZ6MGKrDk+vXpx1o-6', '1B1TTklHsZDbqZ6MGKrDk+vXpx1e-7', '1B1TTklHsZDbqZ6MGKrDk+vXpx1u-8', '1B1TTklHsZDbqZ6MGKrDk+vXpx1p-9', '1B1TTklHsZDbqZ6MGKrDk+vXpx1r-10'].includes(params.page_url) || params.page_url === '1B1TTklHsZDbqZ6MGKrDk+vXpx1q-1') {
	            return dispatch((0, _extends3.default)({}, (0, _page.loadPageDetail)(params.page_url, getState().setting.shopId), { show_404: location.pathname }));
	        }
	        var pageList = getState().page.list || [];
	        var pageId = 0;
	        pageList.map(function (page) {
	            if (page.url_pages === url) {
	                pageId = page.id;
	            }
	        });
	
	        if (pageId) {
	            return dispatch((0, _extends3.default)({}, (0, _page.loadPageDetail)(pageId, getState().setting.shopId), { show_404: location.pathname }));
	        }
	
	        return dispatch((0, _error.show404)());
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        page: state.page.detail
	    };
	}, { push: _reactRouterRedux.push }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Page, _Component);
	
	    function Page(props, context) {
	        (0, _classCallCheck3.default)(this, Page);
	        return (0, _possibleConstructorReturn3.default)(this, (Page.__proto__ || (0, _getPrototypeOf2.default)(Page)).call(this, props, context));
	    }
	
	    (0, _createClass3.default)(Page, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props$page = this.props.page,
	                _props$page$content = _props$page.content,
	                content = _props$page$content === undefined ? '' : _props$page$content,
	                _props$page$seo_h = _props$page.seo_h1,
	                seo_h1 = _props$page$seo_h === undefined ? '' : _props$page$seo_h,
	                _props$page$seo_title = _props$page.seo_title,
	                seo_title = _props$page$seo_title === undefined ? '' : _props$page$seo_title,
	                _props$page$seo_descr = _props$page.seo_description,
	                seo_description = _props$page$seo_descr === undefined ? '' : _props$page$seo_descr,
	                _props$page$keywords = _props$page.keywords,
	                keywords = _props$page$keywords === undefined ? '' : _props$page$keywords,
	                _props$page$indexatio = _props$page.indexation,
	                indexation = _props$page$indexatio === undefined ? true : _props$page$indexatio;
	
	            if (['1B1TTklHsZDbqZ6MGKrDk+vXpx1q-1', '1B1TTklHsZDbqZ6MGKrDk+vXpx1t-2', '1B1TTklHsZDbqZ6MGKrDk+vXpx1i-3', '1B1TTklHsZDbqZ6MGKrDk+vXpx1w-4', '1B1TTklHsZDbqZ6MGKrDk+vXpx1y-5', '1B1TTklHsZDbqZ6MGKrDk+vXpx1o-6', '1B1TTklHsZDbqZ6MGKrDk+vXpx1e-7', '1B1TTklHsZDbqZ6MGKrDk+vXpx1u-8', '1B1TTklHsZDbqZ6MGKrDk+vXpx1p-9', '1B1TTklHsZDbqZ6MGKrDk+vXpx1r-10'].includes(this.props.page.id)) {
	                setTimeout(function () {
	                    _this2.props.push('/page/' + content);
	                }, 2000);
	            }
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement('div', { className: 'col-xs-3 no-margin hidden-xs' }),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-9 no-margin hidden-xs page_holder text-theme', style: { paddingLeft: '7px' } },
	                    _react3.default.createElement(_reactHelmet2.default, {
	                        title: seo_title,
	                        meta: [{ "name": "description", "content": seo_description }, { "name": "keywords", "content": keywords }]
	                    }),
	                    !indexation ? _react3.default.createElement(_reactHelmet2.default, { meta: [{ name: "robots", content: 'noindex, nofollow' }] }) : null,
	                    seo_h1 ? _react3.default.createElement(
	                        'h1',
	                        null,
	                        seo_h1
	                    ) : '',
	                    _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: content } })
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'visible-xs page_holder text-theme' },
	                    _react3.default.createElement(_reactHelmet2.default, {
	                        title: seo_title,
	                        meta: [{ "name": "description", "content": seo_description }, { "name": "keywords", "content": keywords }]
	                    }),
	                    !indexation ? _react3.default.createElement(_reactHelmet2.default, { meta: [{ name: "robots", content: 'noindex, nofollow' }] }) : null,
	                    seo_h1 ? _react3.default.createElement(
	                        'h1',
	                        null,
	                        seo_h1
	                    ) : '',
	                    _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: content } })
	                )
	            );
	        }
	    }]);
	    return Page;
	}(_react2.Component), _class2.propTypes = {}, _temp)) || _class) || _class));
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Basket: {
	        displayName: 'Basket'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Personal/Basket/index.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Basket = _wrapComponent('Basket')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang
	    };
	}), _dec(_class = function (_Component) {
	    (0, _inherits3.default)(Basket, _Component);
	
	    function Basket(props) {
	        (0, _classCallCheck3.default)(this, Basket);
	        return (0, _possibleConstructorReturn3.default)(this, (Basket.__proto__ || (0, _getPrototypeOf2.default)(Basket)).call(this, props));
	    }
	
	    (0, _createClass3.default)(Basket, [{
	        key: 'render',
	        value: function render() {
	            var helmetTitle = this.props.lang['store.helmet.cart'];
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(_reactHelmet2.default, { title: helmetTitle }),
	                _react3.default.createElement(_components2.Basket, null)
	            );
	        }
	    }]);
	    return Basket;
	}(_react2.Component)) || _class));
	
	exports.default = Basket;
	module.exports = exports['default'];

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _components2 = __webpack_require__(16);
	
	var _reactBootstrapDatePicker = __webpack_require__(1295);
	
	var _reactBootstrapDatePicker2 = _interopRequireDefault(_reactBootstrapDatePicker);
	
	var _reactBootstrap = __webpack_require__(24);
	
	__webpack_require__(1118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    OperationsView: {
	        displayName: 'OperationsView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Personal/Operations/default/OperationsView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var OperationsView = _wrapComponent('OperationsView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(OperationsView, _Component);
	
	    function OperationsView(props) {
	        (0, _classCallCheck3.default)(this, OperationsView);
	        return (0, _possibleConstructorReturn3.default)(this, (OperationsView.__proto__ || (0, _getPrototypeOf2.default)(OperationsView)).call(this, props));
	    }
	
	    (0, _createClass3.default)(OperationsView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                activeSelect = _props.activeSelect,
	                amount = _props.amount,
	                count = _props.count,
	                balance = _props.balance,
	                items = _props.items,
	                handleMoreClick = _props.handleMoreClick,
	                handleSelect = _props.handleSelect,
	                preload = _props.preload,
	                morePreload = _props.morePreload,
	                lang = _props.lang;
	
	
	            var dayLabels = [lang['store.common.week.sunday'], lang['store.common.week.monday'], lang['store.common.week.tuesday'], lang['store.common.week.wednesday'], lang['store.common.week.thursday'], lang['store.common.week.friday'], lang['store.common.week.saturday']];
	            var monthLabels = [lang['store.common.months.january'], lang['store.common.months.february'], lang['store.common.months.march'], lang['store.common.months.april'], lang['store.common.months.may'], lang['store.common.months.june'], lang['store.common.months.july'], lang['store.common.months.august'], lang['store.common.months.september'], lang['store.common.months.october'], lang['store.common.months.november'], lang['store.common.months.december']];
	
	            return _react3.default.createElement(
	                'section',
	                { id: 'personal-operations' },
	                _react3.default.createElement(
	                    'h1',
	                    null,
	                    lang['store.operations.account_operations']
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-sm-4 col-md-3 filter_item' },
	                        _react3.default.createElement(_reactBootstrapDatePicker2.default, {
	                            dateFormat: 'DD.MM.YYYY',
	                            dayLabels: dayLabels,
	                            monthLabels: monthLabels,
	                            onChange: this.props.onChangeBeginDate,
	                            showClearButton: false,
	                            todayButtonLabel: lang['store.common.today'],
	                            value: this.props.begDate,
	                            weekStartsOnMonday: true
	                        })
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-sm-4 col-md-3 filter_item' },
	                        _react3.default.createElement(_reactBootstrapDatePicker2.default, {
	                            dateFormat: 'DD.MM.YYYY',
	                            dayLabels: dayLabels,
	                            monthLabels: monthLabels,
	                            onChange: this.props.onChangeEndDate,
	                            showClearButton: false,
	                            todayButtonLabel: lang['store.common.today'],
	                            value: this.props.endDate,
	                            weekStartsOnMonday: true
	                        })
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-4 col-md-3 filter_item' },
	                        _react3.default.createElement(
	                            'button',
	                            { className: 'le-button button_operation', onClick: this.props.onClick },
	                            lang['store.common.show']
	                        )
	                    )
	                ),
	                _react3.default.createElement(
	                    _components2.Preloader,
	                    { preload: preload },
	                    _react3.default.createElement(
	                        'div',
	                        null,
	                        items.length > 0 ? _react3.default.createElement(
	                            'div',
	                            { className: 'operations_holder' },
	                            _react3.default.createElement(
	                                'h2',
	                                null,
	                                lang['store.operations.operations']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'row no-margin table_head hidden-xs hidden-sm' },
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-4 no-margin' },
	                                    lang['store.common.date_and_time']
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-4 no-margin' },
	                                    lang['store.common.sum']
	                                ),
	                                _react3.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-4 no-margin' },
	                                    lang['discount.type']
	                                )
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                null,
	                                items.map(function (item, i) {
	                                    return _react3.default.createElement(_components2.OperationsItem, { key: i, item: item, lang: lang });
	                                })
	                            ),
	                            _react3.default.createElement(_components2.Preloader, { preload: morePreload }),
	                            items.length < count ? _react3.default.createElement(
	                                'div',
	                                { className: 'text-center' },
	                                _react3.default.createElement(
	                                    'span',
	                                    { onClick: handleMoreClick, className: 'button_more' },
	                                    lang['store.common.show_more']
	                                )
	                            ) : null
	                        ) : _react3.default.createElement(
	                            'div',
	                            { className: 'operations_holder text-center' },
	                            _react3.default.createElement(
	                                'h2',
	                                null,
	                                lang['store.operations.empty']
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	    return OperationsView;
	}(_react2.Component), _class.propTypes = {
	    activeSelect: _react2.PropTypes.any,
	    amount: _react2.PropTypes.array,
	    balance: _react2.PropTypes.array,
	    begDate: _react2.PropTypes.any,
	    count: _react2.PropTypes.number,
	    endDate: _react2.PropTypes.any,
	    handleMoreClick: _react2.PropTypes.any,
	    handleSelect: _react2.PropTypes.func.isRequired,
	    items: _react2.PropTypes.array,
	    morePreload: _react2.PropTypes.any,
	    onChangeBeginDate: _react2.PropTypes.any,
	    onChangeEndDate: _react2.PropTypes.func.isRequired,
	    onClick: _react2.PropTypes.func.isRequired,
	    preload: _react2.PropTypes.any,
	    lang: _react2.PropTypes.object
	}, _class.defaultProps = {
	    amount: [],
	    balance: [],
	    items: []
	}, _temp));
	
	exports.default = OperationsView;
	module.exports = exports['default'];

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _personal = __webpack_require__(165);
	
	var _payment = __webpack_require__(114);
	
	var _helpers = __webpack_require__(15);
	
	var _config = __webpack_require__(383);
	
	var _constants = __webpack_require__(18);
	
	var _moment = __webpack_require__(11);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _operations = __webpack_require__(1862);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Operations: {
	        displayName: "Operations"
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: "/usr/local/ibonus/src/containers/Personal/Operations/index.js",
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var MOMENT_DATE_FORMAT_SHOT = 'DD.MM.YYYY';
	var MOMENT_DATE_FORMAT_ISO = 'YYYY-MM-DD[T]HH:mm:ss.SSSZZ';
	
	var Operations = _wrapComponent("Operations")((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var params = _ref.params,
	            _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	        return dispatch((0, _operations.getPipoOperations)((0, _moment2.default)().subtract(30, 'day').format('DD.MM.YYYY'), (0, _moment2.default)().format('DD.MM.YYYY')));
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        begDate: state.operations.begDate,
	        count: state.operations.count,
	        endDate: state.operations.endDate,
	        items: state.operations.items,
	        morePreload: state.operations.morePreload,
	        multiBalans: state.operations.multiBalans,
	        page: state.operations.page,
	        preload: state.operations.preload,
	        user: state.auth.user,
	        lang: state.lang
	    };
	}, { push: _reactRouterRedux.push, getPipoOperations: _operations.getPipoOperations, morePipoOperations: _operations.morePipoOperations }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Operations, _Component);
	
	    function Operations(props) {
	        (0, _classCallCheck3.default)(this, Operations);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Operations.__proto__ || (0, _getPrototypeOf2.default)(Operations)).call(this, props));
	
	        _this.onChangeBeginDate = function (value, formattedValue) {
	            _this.setState({
	                begDate: formattedValue,
	                begDateISO: value
	            });
	            //
	            // const beginDateMoment = moment(formattedValue, MOMENT_DATE_FORMAT_SHOT);
	            // const beginDateMomentPlus90 = moment(formattedValue, MOMENT_DATE_FORMAT_SHOT).add(90, 'days');
	            // const endDateMoment = moment(this.state.endDate, MOMENT_DATE_FORMAT_SHOT);
	            //
	            // if (!endDateMoment.isBetween(beginDateMoment, beginDateMomentPlus90)) {
	            //     this.setState({
	            //         endDate: beginDateMomentPlus90.format(MOMENT_DATE_FORMAT_SHOT),
	            //         endDateISO: beginDateMomentPlus90.format(MOMENT_DATE_FORMAT_ISO),
	            //     });
	            // }
	        };
	
	        _this.onChangeEndDate = function (value, formattedValue) {
	            _this.setState({
	                endDate: formattedValue,
	                endDateISO: value
	            });
	            //
	            // const endDateMoment = moment(formattedValue, MOMENT_DATE_FORMAT_SHOT);
	            // const endDateMomentMinus90 = moment(formattedValue, MOMENT_DATE_FORMAT_SHOT).subtract(90, 'days');
	            // const beginDateMoment = moment(this.state.begDate, MOMENT_DATE_FORMAT_SHOT);
	            //
	            // if (!beginDateMoment.isBetween(endDateMomentMinus90, endDateMoment)) {
	            //     this.setState({
	            //         begDate: endDateMomentMinus90.format(MOMENT_DATE_FORMAT_SHOT),
	            //         begDateISO: endDateMomentMinus90.format(MOMENT_DATE_FORMAT_ISO),
	            //     });
	            // }
	        };
	
	        _this.handleSelect = function (e) {
	            _this.setState({ activeSelect: e.target.value });
	            var amount = e.target.value === 'all' ? -1 : e.target.value;
	            _this.props.getPipoOperations(_this.state.begDate, _this.state.endDate, amount);
	        };
	
	        _this.onClick = function () {
	            var amount = _this.state.activeSelect === 'all' ? -1 : _this.state.activeSelect;
	            _this.props.getPipoOperations(_this.state.begDate, _this.state.endDate, amount);
	        };
	
	        _this.handleMoreClick = function (e) {
	            var _this$props = _this.props,
	                items = _this$props.items,
	                page = _this$props.page;
	
	            var amount = _this.state.activeSelect === 'all' ? -1 : _this.state.activeSelect;
	            _this.props.morePipoOperations(_this.state.begDate, _this.state.endDate, amount, page + 1, _constants.OperationsNumericConstants.OPERATIONS_PAGE_LIMIT);
	        };
	
	        _this.state = {
	            activeSelect: "all", // all или счёт пользователя
	            begDate: _this.props.begDate,
	            begDateISO: (0, _moment2.default)(_this.props.begDate, MOMENT_DATE_FORMAT_SHOT).format(MOMENT_DATE_FORMAT_ISO),
	            endDate: _this.props.endDate,
	            endDateISO: (0, _moment2.default)(_this.props.endDate, MOMENT_DATE_FORMAT_SHOT).format(MOMENT_DATE_FORMAT_ISO)
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(Operations, [{
	        key: "render",
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForContainer('Operations', null, { folderName: 'Personal/Operations' });
	            var _state = this.state,
	                begDateISO = _state.begDateISO,
	                endDateISO = _state.endDateISO;
	            var _props = this.props,
	                count = _props.count,
	                multiBalans = _props.multiBalans,
	                morePreload = _props.morePreload,
	                preload = _props.preload,
	                user = _props.user,
	                lang = _props.lang;
	
	
	            if (user) {
	                return _react3.default.createElement(View, {
	                    activeSelect: this.state.activeSelect,
	                    amount: user.amount,
	                    balance: multiBalans,
	                    begDate: begDateISO,
	                    count: count,
	                    endDate: endDateISO,
	                    handleMoreClick: this.handleMoreClick,
	                    handleSelect: this.handleSelect,
	                    items: this.props.items,
	                    morePreload: morePreload,
	                    onChangeBeginDate: this.onChangeBeginDate,
	                    onChangeEndDate: this.onChangeEndDate,
	                    onClick: this.onClick,
	                    preload: preload,
	                    lang: lang
	                });
	            }
	
	            return null;
	        }
	    }]);
	    return Operations;
	}(_react2.Component), _class2.propTypes = {
	    begDate: _react2.PropTypes.any,
	    count: _react2.PropTypes.any,
	    endDate: _react2.PropTypes.any,
	    item: _react2.PropTypes.array,
	    items: _react2.PropTypes.any,
	    morePreload: _react2.PropTypes.any,
	    multiBalans: _react2.PropTypes.any,
	    page: _react2.PropTypes.any,
	    preload: _react2.PropTypes.any,
	    user: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object
	}, _class2.defaultProps = {
	    item: []
	}, _temp)) || _class) || _class));
	
	exports.default = Operations;
	module.exports = exports['default'];

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp, _initialiseProps;
	
	var _reactRedux = __webpack_require__(12);
	
	var _components2 = __webpack_require__(16);
	
	var _modal = __webpack_require__(26);
	
	var _addresses = __webpack_require__(260);
	
	var _PaymentStatus = __webpack_require__(163);
	
	var _PaymentStatus2 = _interopRequireDefault(_PaymentStatus);
	
	var _PaymentStatusLabel = __webpack_require__(754);
	
	var _PaymentStatusLabel2 = _interopRequireDefault(_PaymentStatusLabel);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	var _modal_type = __webpack_require__(42);
	
	var _utils = __webpack_require__(31);
	
	__webpack_require__(1119);
	
	var _windowOrGlobal = __webpack_require__(264);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    OrderDetailView: {
	        displayName: 'OrderDetailView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Personal/OrderDetail/default/OrderDetailView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var OrderDetailView = _wrapComponent('OrderDetailView')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang,
	        preload: state.personal_order_detail.preload,
	        preloadPay: state.payment.preload
	    };
	}, { showModal: _modal.showModal, hide: _modal.hide, addAddress: _addresses.addAddress, showSuccessfulModal: _modal_type.showSuccessfulModal }), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(OrderDetailView, _Component);
	
	    function OrderDetailView(props, context) {
	        (0, _classCallCheck3.default)(this, OrderDetailView);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (OrderDetailView.__proto__ || (0, _getPrototypeOf2.default)(OrderDetailView)).call(this, props, context));
	
	        _initialiseProps.call(_this);
	
	        _this._onPay = function () {};
	
	        var AccountsList = props.user.amount[0];
	        var discountSum = props.order.sum / 2;
	        if (props.order.discount_sum > 0) {
	            discountSum = props.order.discount_sum * 1;
	        }
	
	        if (AccountsList.amount > 0 && AccountsList.amount < discountSum) {
	            discountSum = AccountsList.amount * 1;
	        }
	        if (AccountsList.amount == 0 || props.order.sum <= 1) {
	            discountSum = 0;
	        }
	        if (props.order.sum - discountSum < 1) {
	            discountSum = props.order.sum - 1;
	            if (discountSum < 0) discountSum = 0;
	        }
	        discountSum = Math.floor(discountSum);
	        var bonusValue = discountSum;
	        if (props.order.ibonus_data !== null) {
	            var IBonusData = _windowOrGlobal.JSON.parse(props.order.ibonus_data);
	            bonusValue = 0;
	            if (IBonusData.discount_sum) {
	                bonusValue = IBonusData.discount_sum * 1;
	            }
	        } else if (props.order.discount_sum > 0) {
	            bonusValue = 0;
	        }
	        _this.state = {
	            disabled: true,
	            disabledClick: false,
	            bonusValue: bonusValue,
	            couponId: null,
	            couponToken: null,
	            customerCouponId: null,
	            delivery_address: props.order && props.order.delivery_address ? props.order.delivery_address : '',
	            userAddresses: props.user && props.user.addresses ? props.user.addresses : [],
	            client_comment: props.order && props.order.client_comment ? props.order.client_comment : '',
	            preload: false
	        };
	        _this.props.order.productsCurrent = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this.props.order.products));
	        // Втыкаем хак для получения товаров из возврата
	        _this.props.order.forwardProducts = _this.props.order.forwardOrder ? _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this.props.order.forwardOrder.products)) : [];
	        _this.props.order.sumCurrent = _this.props.order.sum;
	        var useCoupon = false;
	        var couponProduct = null;
	        _this.props.order.productsCurrent.forEach(function (item) {
	            if (item.is_coupon === true) {
	                useCoupon = true;
	                couponProduct = item;
	            }
	        });
	        if (useCoupon) {
	            var productsCurrent = _this.props.order.products.filter(function (item) {
	                return item.id !== couponProduct.id;
	            });
	            _this.props.order.productsCurrent = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(productsCurrent));
	            var changeCount = false;
	            _this.props.order.productsCurrent.forEach(function (item) {
	                if (item.offer.id === couponProduct.offer.id && item.modifier_option_id === couponProduct.modifier_option_id && item.is_coupon !== true && item.isCoupon !== true) {
	                    changeCount = true;
	                    item.quantity++;
	                    _this.props.order.sumCurrent = _this.props.order.sumCurrent * 1 + couponProduct.offer.price * 1;
	                }
	            });
	            if (!changeCount) {
	                couponProduct.price = couponProduct.offer.price;
	                couponProduct.base_price = couponProduct.offer.price;
	                _this.props.order.productsCurrent.push(couponProduct);
	                _this.props.order.sumCurrent = _this.props.order.sumCurrent * 1 + couponProduct.offer.price * 1;
	            }
	            _this.props.user.coupons.forEach(function (item) {
	                if (item.offer_id === couponProduct.offer_id && item.modifier_option_id === couponProduct.modifier_option_id) {
	                    _this.state.couponId = item.id;
	                    _this.state.customerCouponId = item.customer_coupon_id;
	                }
	            });
	        }
	        return _this;
	    }
	
	    // Хак по аналогии с ЛК мерчанта
	
	
	    (0, _createClass3.default)(OrderDetailView, [{
	        key: '_getPriceSaleWithIBonusDiscount',
	        value: function _getPriceSaleWithIBonusDiscount(product) {
	            var discount_to_product = this._getIbonusDiscountToProduct(product);
	            if (discount_to_product <= 0) {
	                return Number(product.base_price);
	            }
	            return Number(product.base_price) - discount_to_product;
	        }
	    }, {
	        key: '_getIbonusDiscountToProduct',
	        value: function _getIbonusDiscountToProduct(product) {
	            if (this.state.bonusValue) {
	                var orderSum = this.props.order.sum;
	                var discountPercent = this.state.bonusValue / (orderSum / 100);
	                var bonusDiscountToProduct = product.base_price * (discountPercent / 100);
	                return bonusDiscountToProduct;
	            }
	            return 0;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                _props$order = _props.order,
	                order = _props$order === undefined ? {} : _props$order,
	                onSaveOrder = _props.onSaveOrder,
	                urlToExternalPaymentService = _props.urlToExternalPaymentService,
	                setting = _props.setting;
	
	
	            var products = order.products || [];
	            var forwardProducts = order.forwardProducts || [];
	            /** @type PaymentStatus */
	            var paymentStatus = order.paymentStatus != null ? order.paymentStatus.id : null;
	            paymentStatus = new _PaymentStatus2.default(paymentStatus);
	
	            if (forwardProducts.length && this.isRevertOrder(paymentStatus)) {
	                this.applyRevertProductsToOrderProducts(products, forwardProducts);
	            }
	
	            if (order.sum - this.state.bonusValue < 0 || this.state.bonusValue < 0) {
	                this.setState({ bonusValue: 0 });
	                this.state.bonusValue = 0;
	            }
	            var sumDiscount = this.props.order.discount_sum * 1;
	            if (order.sum > 0) {
	                var AccountsList = this.props.user.amount[0];
	                var discountSum = order.sum / 2;
	                var addAmount = 0;
	                if (order.discount_sum > 0) {
	                    addAmount = order.discount_sum * 1;
	                }
	                if (AccountsList.amount + addAmount > 0 && AccountsList.amount + addAmount < discountSum) {
	                    discountSum = AccountsList.amount * 1 + addAmount;
	                }
	                if (order.sum - discountSum < 1) {
	                    discountSum = order.sum - 1;
	                    if (discountSum < 0) discountSum = 0;
	                }
	
	                discountSum = Math.floor(discountSum);
	                if (this.state.bonusValue > discountSum) {
	                    this.setState({ bonusValue: discountSum });
	                    this.state.bonusValue = discountSum;
	                }
	                if (this.props.order.ibonus_data !== null) {
	                    var IBonusData = _windowOrGlobal.JSON.parse(this.props.order.ibonus_data);
	                    if (IBonusData.discount_sum) {
	                        sumDiscount = this.props.order.discount_sum * 1 - IBonusData.discount_sum * 1;
	                    }
	                }
	                sumDiscount = 0;
	                this.props.order.products.forEach(function (product) {
	                    var discountPerPiece = _this2.props.order.orderDiscounts.reduce(function (discountPerPiece, discount) {
	                        var isAdd = product.productDiscounts.find(function (productDiscount) {
	                            return productDiscount.discount_id === discount.discount_id;
	                        });
	                        if (!isAdd) {
	                            product.productDiscounts.push(discount);
	                        }
	                        var sum = discount.rate_in_percent / 100 * _this2._getPriceSaleWithIBonusDiscount(product);
	                        var result = discountPerPiece + sum;
	                        return +result;
	                    }, 0);
	                    // Сделаем общий метод пробежки по массиву и пересчитаем общую сумму со всеми скидками сразу
	                    if (product.productDiscounts.length) {
	                        discountPerPiece = product.productDiscounts.reduce(function (discountPerPiece, discount) {
	                            var sum = discount.rate_in_percent / 100 * _this2._getPriceSaleWithIBonusDiscount(product);
	                            var result = discountPerPiece + sum;
	                            return +result;
	                        }, 0);
	                    }
	                    product.discountPerPiece = discountPerPiece;
	                    sumDiscount += discountPerPiece * product.quantity;
	                    product.additionalInfo = product.additional_info ? _windowOrGlobal.JSON.parse(product.additional_info) : null;
	                    if (product.additionalInfo && product.additionalInfo.custom_fields) {
	                        product.custom_fields = product.additionalInfo.custom_fields;
	                    }
	                });
	            }
	            var isOrderWasPaid = this.isOrderWasPaid();
	
	            if (this.props.payments.length === 0) {
	                return _react3.default.createElement(
	                    _components2.Preloader,
	                    { preload: this.props.preload || this.props.preloadPay || this.state.preload },
	                    _react3.default.createElement(
	                        'section',
	                        { id: 'personal-order-detail' },
	                        _react3.default.createElement(_components2.OrderItemsDetail, {
	                            isOrderWasPaid: isOrderWasPaid,
	                            isRevert: this.isRevertOrder(paymentStatus),
	                            products: products,
	                            sum: order.sum,
	                            onPay: this.onPay,
	                            editOrder: this.props.editOrder,
	                            cancelOrder: this.props.cancelOrder,
	                            id: order.id,
	                            user: this.props.user,
	                            bonusValue: this.state.bonusValue,
	                            onChangeBonusValue: this.onChangeBonusValue,
	                            couponSelect: this.couponSelect,
	                            couponId: this.state.couponId,
	                            sumDiscount: sumDiscount,
	                            paymentInId: order.payment_in_id,
	                            order_number: order.order_number,
	                            setting: setting,
	                            delivery_address: this.state.delivery_address,
	                            userAddresses: this.state.userAddresses,
	                            client_comment: this.state.client_comment,
	                            onDeliveryAddressChange: this.onDeliveryAddressChange,
	                            onDeliveryAddressSave: function onDeliveryAddressSave() {
	                                return onSaveOrder({ delivery_address: _this2.state.delivery_address });
	                            },
	                            onClientCommentChange: this.onClientCommentChange,
	                            onAddAddress: this.onAddAddress,
	                            token: order.view_token,
	                            ibonus_data: order.ibonus_data,
	                            order_type_id: order.type_id,
	                            childOrders: order.childOrders,
	                            showPay: paymentStatus.isPayActionAvaliable(),
	                            payStatus: _react3.default.createElement(_PaymentStatusLabel2.default, { rawStatus: paymentStatus.status }),
	                            hidePayButton: true
	                        })
	                    )
	                );
	            }
	
	            var disButton = function disButton() {
	                var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	                _this2.setState({
	                    disabled: !slug || !paymentStatus.isPayActionAvaliable()
	                });
	            };
	
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload || this.props.preloadPay || this.state.preload },
	                _react3.default.createElement(
	                    'section',
	                    { id: 'personal-order-detail' },
	                    _react3.default.createElement(_components2.OrderItemsDetail, {
	                        isOrderWasPaid: isOrderWasPaid,
	                        isRevert: this.isRevertOrder(paymentStatus),
	                        products: products,
	                        sum: order.sum,
	                        onPay: this.onPay,
	                        editOrder: this.props.editOrder,
	                        cancelOrder: this.props.cancelOrder,
	                        id: order.id,
	                        user: this.props.user,
	                        bonusValue: this.state.bonusValue,
	                        onChangeBonusValue: this.onChangeBonusValue,
	                        couponSelect: this.couponSelect,
	                        couponId: this.state.couponId,
	                        sumDiscount: sumDiscount,
	                        paymentInId: order.payment_in_id,
	                        order_number: order.order_number,
	                        setting: setting,
	                        delivery_address: this.state.delivery_address,
	                        userAddresses: this.state.userAddresses,
	                        client_comment: this.state.client_comment,
	                        onDeliveryAddressChange: this.onDeliveryAddressChange,
	                        onDeliveryAddressSave: function onDeliveryAddressSave() {
	                            return onSaveOrder({ delivery_address: _this2.state.delivery_address });
	                        },
	                        onClientCommentChange: this.onClientCommentChange,
	                        onAddAddress: this.onAddAddress,
	                        token: order.view_token,
	                        orderDate: order.time_create,
	                        ibonus_data: order.ibonus_data,
	                        order_type_id: order.type_id,
	                        childOrders: order.childOrders,
	                        showPay: paymentStatus.isPayActionAvaliable(),
	                        hideAll: paymentStatus.isOutdated || paymentStatus.isCanceled(),
	                        payStatus: _react3.default.createElement(_PaymentStatusLabel2.default, { rawStatus: paymentStatus.status }),
	                        disabled: this.state.disabled,
	                        disabledClick: this.state.disabledClick,
	                        paymentList: !paymentStatus.isCanceled() ? _react3.default.createElement(_components2.PaymentList, {
	                            payments: this.props.payments,
	                            disButton: disButton,
	                            order: this.props.order,
	                            getInstance: function getInstance(PaymentListComponent) {
	                                _this2._onPay = PaymentListComponent.onPay;
	                            },
	                            warning: this.state.disabledClick && this.state.disabled
	                        }) : null
	                    })
	                )
	            );
	        }
	    }]);
	    return OrderDetailView;
	}(_react2.Component), _class2.propTypes = {
	    order: _react2.PropTypes.object.isRequired,
	    payments: _react2.PropTypes.array,
	    showModal: _react2.PropTypes.func,
	    onPay: _react2.PropTypes.func,
	    onSaveOrder: _react2.PropTypes.func.isRequired,
	    setting: _react2.PropTypes.object.isRequired
	}, _initialiseProps = function _initialiseProps() {
	    var _this3 = this;
	
	    this.onPay = function () {
	        if (_this3.state.disabled) {
	            _this3.setState({ disabledClick: true });
	        } else {
	            if (_this3.props.order.sum < 1) {
	                var alertMessage = (0, _utils.replaceCharToArrayIndex)(_this3.props.lang['error.pipo.operationInvalidMinimalSum'], [_this3.props.lang.code]);
	                setTimeout(function () {
	                    _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
	                }, 0);
	                return null;
	            }
	            _LocalStorageProxy2.default.setItem('shared_coupons', '');
	            _this3.setState({ preload: true });
	            _this3._onPay({
	                clientCommentary: _this3.state.client_comment,
	                delivery_address: _this3.state.delivery_address,
	                discountSum: _this3.state.bonusValue,
	                couponId: _this3.state.couponId,
	                couponToken: _this3.state.couponToken,
	                customerCouponId: _this3.state.customerCouponId,
	                preloadCallback: _this3.onPreloadState
	            });
	        }
	    };
	
	    this.onPreloadState = function () {
	        _this3.setState({ preload: false });
	    };
	
	    this.onChangeBonusValue = function (e) {
	        _this3.setState({ bonusValue: e.target.value });
	    };
	
	    this.couponSelect = function (coupon) {
	        var lang = _this3.props.lang;
	
	        if (coupon.id === _this3.state.couponId) {
	            _this3.setState({ couponId: null });
	            _this3.setState({ couponToken: null });
	            _this3.setState({ customerCouponId: null });
	            _this3.props.order.products = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this3.props.order.productsCurrent));
	            _this3.props.order.sum = _this3.props.order.sumCurrent;
	        } else {
	            var useCoupon = false;
	            _this3.props.order.products.forEach(function (item) {
	                if (item.offer.id === coupon.offer.id && item.modifier_option_id === coupon.modifier_option_id && item.isCoupon !== true) {
	                    useCoupon = true;
	                }
	            });
	            if (!useCoupon) {
	                var modalContent = _react3.default.createElement(
	                    'div',
	                    { className: 'row no-margin' },
	                    _react3.default.createElement(
	                        'div',
	                        {
	                            className: 'col-xs-12' },
	                        lang['store.useCoupon.popup.confirmation.p1'],
	                        ' ',
	                        coupon.offer.name,
	                        ' ',
	                        lang['store.useCoupon.popup.confirmation.p2']
	                    )
	                );
	
	                _this3.props.showModal({
	                    title: lang['store.useCoupon.popup.title'],
	                    content: modalContent,
	                    titleSuccess: lang['store.common.yes'],
	                    titleClose: lang['store.common.no'],
	                    onSuccess: function onSuccess() {
	                        _this3.props.order.sum = _this3.props.order.sumCurrent;
	                        _this3.props.order.products = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this3.props.order.productsCurrent));
	                        _this3.props.order.products.push({
	                            id: coupon.id,
	                            isCoupon: true,
	                            quantity: 1, price: 0, base_price: 0,
	                            modifier_option_id: coupon.modifier_option_id,
	                            modifiedOption: coupon.modifiedOption,
	                            offer: coupon.offer
	                        });
	                        _this3.setState({ couponId: coupon.id });
	                        _this3.setState({ couponToken: coupon.token });
	                        _this3.setState({ customerCouponId: coupon.customer_coupon_id });
	                    },
	                    modalType: 'del'
	                });
	            } else {
	                _this3.props.order.sum = _this3.props.order.sumCurrent;
	                _this3.props.order.products = _windowOrGlobal.JSON.parse(_windowOrGlobal.JSON.stringify(_this3.props.order.productsCurrent));
	                _this3.props.order.products.forEach(function (item) {
	                    if (item.offer.id === coupon.offer.id && item.modifier_option_id === coupon.modifier_option_id) {
	                        if (item.quantity === 1) {
	                            _this3.props.order.sum = _this3.props.order.sum - item.base_price;
	                            item.price = 0;
	                            item.base_price = 0;
	                            item.isCoupon = true;
	                        } else {
	                            item.quantity = item.quantity - 1;
	                            _this3.props.order.sum = _this3.props.order.sum - item.base_price;
	                            _this3.props.order.products.push({
	                                id: coupon.id,
	                                isCoupon: true,
	                                quantity: 1,
	                                price: 0, base_price: 0,
	                                modifier_option_id: coupon.modifier_option_id,
	                                modifiedOption: coupon.modifiedOption,
	                                offer: coupon.offer
	                            });
	                        }
	                        _this3.setState({ couponId: coupon.id });
	                        _this3.setState({ couponToken: coupon.token });
	                        _this3.setState({ customerCouponId: coupon.customer_coupon_id });
	                    }
	                });
	            }
	        }
	    };
	
	    this.isOrderWasPaid = function () {
	        return _this3.props.order.orderStatus.lang_data === 'order.order_status.done';
	    };
	
	    this.isRevertOrder = function (paymentStatus) {
	        return paymentStatus.isRevert();
	    };
	
	    this.onDeliveryAddressChange = function (e) {
	        _this3.setState({ delivery_address: e.target.value });
	    };
	
	    this.onClientCommentChange = function (e) {
	        _this3.setState({ client_comment: e.target.value });
	    };
	
	    this.onAddAddress = function (_ref) {
	        var _ref$address = _ref.address,
	            address = _ref$address === undefined ? null : _ref$address;
	
	        _this3.props.showSuccessfulModal('Адрес сохранен успешно');
	        _this3.props.addAddress(address);
	    };
	
	    this.applyRevertProductsToOrderProducts = function (products, forwardProducts) {
	        products.forEach(function (product) {
	            var refunded = forwardProducts.find(function (refunded) {
	                return refunded.id_yml === product.id_yml && refunded.name === product.name && refunded.offer_id === product.offer_id;
	            });
	
	            if (refunded) {
	                product.refundedProduct = refunded;
	                // Рекурсивно апдейтим все дочернии элементы
	                if (product.childProducts && refunded.childProducts) {
	                    _this3.applyRevertProductsToOrderProducts(product.childProducts, refunded.childProducts);
	                }
	            }
	        });
	    };
	}, _temp)) || _class));
	
	exports.default = OrderDetailView;
	module.exports = exports['default'];

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toConsumableArray2 = __webpack_require__(103);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(58);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _personal = __webpack_require__(165);
	
	var _payment = __webpack_require__(114);
	
	var _auth = __webpack_require__(53);
	
	var _basket = __webpack_require__(101);
	
	var _catalog = __webpack_require__(67);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	var _modal = __webpack_require__(26);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _helpers = __webpack_require__(15);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	var _addresses = __webpack_require__(260);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    OrderDetail: {
	        displayName: 'OrderDetail'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Personal/OrderDetail/index.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var OrderDetail = _wrapComponent('OrderDetail')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var params = _ref.params,
	            location = _ref.location,
	            _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	        var _getState = getState(),
	            user = _getState.auth.user;
	
	        var promise = [];
	
	        if (user) {
	            var id = parseInt(params.order_id, 10);
	
	            promise = [dispatch((0, _personal.getPersonalOrderDetail)(id)), dispatch((0, _payment.getPayment)()), dispatch((0, _auth.load)()), dispatch((0, _addresses.loadAddresses)())];
	        }
	
	        return _promise2.default.all([].concat((0, _toConsumableArray3.default)(promise), [dispatch((0, _personal.loadPage)(location))]));
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        personal_order_detail: state.personal_order_detail,
	        payments: state.payment.list,
	        user: state.auth.user,
	        setting: state.setting,
	        lang: state.lang
	    };
	}, {
	    getPayment: _payment.getPayment,
	    getPersonalOrderDetail: _personal.getPersonalOrderDetail,
	    setOrder: _personal.setOrder,
	    pushState: _reactRouterRedux.push,
	    addProduct: _basket.addProduct,
	    getProduct: _catalog.getProduct,
	    clearBasket: _basket.clearBasket,
	    cancelOrder: _personal.cancelOrder,
	    showModal: _modal.showModal,
	    hide: _modal.hide,
	    storage: _LocalStorageProxy2.default
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(OrderDetail, _Component);
	
	    function OrderDetail(props) {
	        (0, _classCallCheck3.default)(this, OrderDetail);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (OrderDetail.__proto__ || (0, _getPrototypeOf2.default)(OrderDetail)).call(this, props));
	
	        _this.onCancelOrder = function () {
	            var lang = _this.props.lang;
	
	
	            var modalContent = _react3.default.createElement(
	                'div',
	                { className: 'row no-margin' },
	                _react3.default.createElement(
	                    'div',
	                    {
	                        className: 'col-xs-12'
	                    },
	                    lang['store.cancelOrder.popup.confirmation']
	                )
	            );
	
	            _this.props.showModal({
	                title: lang['store.cancelOrder.popup.title'],
	                content: modalContent,
	                titleSuccess: lang['store.common.yes'],
	                titleClose: lang['store.common.no'],
	                onSuccess: function onSuccess() {
	                    if (_this.props.personal_order_detail.order.paymentStatus != null) {
	                        _this.props.personal_order_detail.order.paymentStatus.id = 8;
	                        _this.setState({ is_cancel: true });
	                    }
	                    _this.props.cancelOrder(_this.props.personal_order_detail.order);
	                },
	                modalType: 'del'
	            });
	        };
	
	        _this.editOrder = function () {
	            _this.props.clearBasket();
	            var product = null;
	            var remainderQuantity = null;
	            _LocalStorageProxy2.default.setItem('basket.edit_order_number', _this.props.personal_order_detail.order.order_number);
	            _LocalStorageProxy2.default.setItem('basket.edit_order_id', _this.props.personal_order_detail.order.id);
	            _this.props.personal_order_detail.order.products.forEach(function (productOrder, i) {
	                product = null;
	                remainderQuantity = null;
	                _this.props.getProduct(productOrder.offer_id).then(function (result) {
	                    product = result;
	                    if (productOrder.modifier_option_id !== null && productOrder.modifiedOption.storable && product.type_id !== 5) {
	                        product.modifier_option = result.modifiedOption.filter(function (value) {
	                            return value.id === productOrder.modifier_option_id;
	                        })[0];
	                        remainderQuantity = product.modifier_option.remainder[0].quantity;
	                        _this.props.addProduct({
	                            description: product.description,
	                            id: product.id,
	                            name: product.name,
	                            price: parseFloat(product.price),
	                            picture: product.pictures ? product.pictures[0] : {},
	                            count: productOrder.quantity,
	                            type_id: product.type_id,
	                            modifier_option_id: productOrder.modifier_option_id !== undefined ? productOrder.modifier_option_id : null,
	                            modifier_option: productOrder.modifiedOption,
	                            modifier_option_name: productOrder.modifier_option_name,
	                            remainder_quantity: remainderQuantity
	                        });
	                    } else if (productOrder.modifier_option_id === null && product.storable && product.remainder[0] && product.type_id !== 5) {
	                        if (product.storable) {
	                            remainderQuantity = product.remainder[0].quantity;
	                        }
	                        _this.props.addProduct({
	                            description: product.description,
	                            id: product.id,
	                            name: product.name,
	                            price: parseFloat(product.price),
	                            picture: product.pictures ? product.pictures[0] : {},
	                            count: productOrder.quantity,
	                            type_id: product.type_id,
	                            modifier_option_id: productOrder.modifier_option_id !== undefined ? productOrder.modifier_option_id : null,
	                            modifier_option: productOrder.modifiedOption !== undefined ? product.modifiedOption : null,
	                            modifier_option_name: productOrder.modifier_option_name,
	                            remainder_quantity: remainderQuantity
	                        });
	                    } else if (product.storable && product.remainder[0] && product.type_id === 5) {
	                        var quantityTechCard = 1;
	                        result.remainder = [];
	                        var childOffers = [];
	                        var childOffer = void 0;
	                        var childOffersTwo = [];
	                        var childOfferTwo = void 0;
	                        var quantity = void 0;
	                        result.nestedOffers.forEach(function (nestedOffer) {
	                            productOrder.childProducts.forEach(function (actualNestedOffer) {
	                                if (actualNestedOffer.offer_id === nestedOffer.childOffer.id) {
	                                    nestedOffer.quantity = actualNestedOffer.quantity;
	                                    nestedOffer.modifier_option_id = actualNestedOffer.modifier_option_id;
	                                    nestedOffer.childOffer.modifierName = actualNestedOffer.modifier_option_name;
	                                    nestedOffer.price = actualNestedOffer.price;
	                                    if (nestedOffer.childOffer.type_id === 5) {
	                                        nestedOffer.childOffer.remainder = [];
	                                        nestedOffer.childOffer.storable = false;
	                                        nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
	                                            actualNestedOffer.childProducts.forEach(function (actualNestedOfferTwo) {
	                                                if (actualNestedOfferTwo.offer_id === nestedOfferTwo.childOffer.id) {
	                                                    nestedOfferTwo.quantity = actualNestedOfferTwo.quantity;
	                                                    nestedOfferTwo.modifier_option_id = actualNestedOfferTwo.modifier_option_id;
	                                                    nestedOfferTwo.childOffer.modifierName = actualNestedOfferTwo.modifier_option_name;
	                                                    nestedOfferTwo.price = actualNestedOfferTwo.price;
	                                                }
	                                            });
	                                            _this.getRemainder(nestedOfferTwo, nestedOffer.quantity, result);
	                                        });
	                                    } else {
	                                        _this.getRemainder(nestedOffer, quantityTechCard, result);
	                                    }
	                                }
	                            });
	                            // if (nestedOffer.quantity > 0) {
	                            //     this.getRemainder(nestedOffer, quantityTechCard, result);
	                            // }
	                        });
	                        remainderQuantity = result.remainder[0].quantity;
	                        _this.props.addProduct({
	                            description: product.description,
	                            id: product.id,
	                            name: product.name,
	                            price: parseFloat(productOrder.price + productOrder.discount_sum / productOrder.quantit),
	                            picture: product.pictures ? product.pictures[0] : {},
	                            count: productOrder.quantity,
	                            type_id: product.type_id,
	                            modifier_option_id: productOrder.modifier_option_id !== undefined ? productOrder.modifier_option_id : null,
	                            modifier_option: productOrder.modifiedOption !== undefined ? productOrder.modifiedOption : null,
	                            remainder_quantity: remainderQuantity,
	                            modifier_option_name: productOrder.modifier_option_name,
	                            nested_offer: result.nestedOffers
	                            // values_mods: product.valuesMods,
	                        });
	                    } else {
	                        if (result.nestedOffers) {
	                            result.nestedOffers.forEach(function (nestedOffer) {
	                                productOrder.childProducts.forEach(function (actualNestedOffer) {
	                                    if (actualNestedOffer.offer_id === nestedOffer.childOffer.id) {
	                                        nestedOffer.quantity = actualNestedOffer.quantity;
	                                        nestedOffer.modifier_option_id = actualNestedOffer.modifier_option_id;
	                                        nestedOffer.childOffer.modifierName = actualNestedOffer.modifier_option_name;
	                                        nestedOffer.price = actualNestedOffer.price;
	                                        if (nestedOffer.childOffer.type_id === 5) {
	                                            nestedOffer.childOffer.remainder = [];
	                                            nestedOffer.childOffer.storable = false;
	                                            nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
	                                                actualNestedOffer.childProducts.forEach(function (actualNestedOfferTwo) {
	                                                    if (actualNestedOfferTwo.offer_id === nestedOfferTwo.childOffer.id) {
	                                                        nestedOfferTwo.quantity = actualNestedOfferTwo.quantity;
	                                                        nestedOfferTwo.modifier_option_id = actualNestedOfferTwo.modifier_option_id;
	                                                        nestedOfferTwo.childOffer.modifierName = actualNestedOfferTwo.modifier_option_name;
	                                                        nestedOfferTwo.price = actualNestedOfferTwo.price;
	                                                    }
	                                                });
	                                            });
	                                        }
	                                    }
	                                });
	                            });
	                        }
	                        _this.props.addProduct({
	                            description: product.description,
	                            id: product.id,
	                            name: product.name,
	                            price: parseFloat(product.price),
	                            picture: product.pictures ? product.pictures[0] : {},
	                            count: productOrder.quantity,
	                            type_id: product.type_id,
	                            modifier_option_id: productOrder.modifier_option_id !== undefined ? productOrder.modifier_option_id : null,
	                            modifier_option: productOrder.modifiedOption,
	                            modifier_option_name: productOrder.modifier_option_name,
	                            remainder_quantity: remainderQuantity,
	                            nested_offer: result.nestedOffers
	                        });
	                    }
	                    if (i === _this.props.personal_order_detail.order.products.length - 1) {
	                        setTimeout(function () {
	                            _this.props.pushState('/basket');
	                        }, 500);
	                    }
	                });
	            });
	        };
	
	        var location = props.location,
	            params = props.params,
	            personal_order_detail = props.personal_order_detail,
	            pushState = props.pushState,
	            user = props.user;
	        var order_id = params.order_id;
	        var query = location.query;
	
	
	        if (!user) {
	            if (!query.payment_in_id || !order_id) {
	                pushState('/');
	            }
	        }
	
	        var order = personal_order_detail.order || {};
	        _this.state = {
	            is_cancel: false
	        };
	        if (!order.id) {
	            // если заказ не найден
	            pushState('/personal/order-list'); // редиректим на "список заказов"
	        }
	
	        /**
	         * Пока что, временно, данный функционал
	         * относится только к сохранению адреса доставки
	         */
	        _this.onSaveOrder = function () {
	            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	                _ref2$delivery_addres = _ref2.delivery_address,
	                delivery_address = _ref2$delivery_addres === undefined ? null : _ref2$delivery_addres,
	                _ref2$client_comment = _ref2.client_comment,
	                client_comment = _ref2$client_comment === undefined ? null : _ref2$client_comment,
	                _ref2$service_in_slug = _ref2.service_in_slug,
	                service_in_slug = _ref2$service_in_slug === undefined ? null : _ref2$service_in_slug;
	
	            _reactSAlert2.default.success(_this.props.lang['store.onSaveOrder.success'], { position: 'top-right', effect: 'slide', timeout: 7000 });
	            _this.props.setOrder(order_id, client_comment, service_in_slug, delivery_address);
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(OrderDetail, [{
	        key: 'getRemainder',
	        value: function getRemainder(nestedOffer, quantityParent, product_detail) {
	            var _this2 = this;
	
	            if (nestedOffer.childOffer === null) {
	                return null;
	            }
	            if (nestedOffer.quantity > 0) {
	                var quantity = void 0;
	                var quantityTechCard = void 0;
	                quantity = nestedOffer.quantity;
	                if (nestedOffer.childOffer.modifier_option_id !== null && nestedOffer.childOffer.modOption === null) {
	                    nestedOffer.childOffer.modOption = nestedOffer.childOffer.modifiedOption.reduce(function (mod, modifier) {
	                        if (modifier.id === nestedOffer.childOffer.modifier_option_id) {
	                            return modifier;
	                        }
	                        return mod;
	                    }, null);
	                }
	                if (nestedOffer.childOffer.modOption !== null && nestedOffer.childOffer.type_id !== 5) {
	                    nestedOffer.childOffer.unit = nestedOffer.childOffer.modOption.unit;
	                    if (nestedOffer.childOffer.modOption.storable === true && nestedOffer.childOffer.modOption.storage_strict) {
	                        product_detail.storable = true;
	                        if (nestedOffer.childOffer.modOption.remainder.length === 0) {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        } else if (nestedOffer.childOffer.modOption.remainder[0].quantity > 0) {
	                            if ((nestedOffer.childOffer.modOption.unit_id === 2 || nestedOffer.childOffer.modOption.unit_id === 8) && nestedOffer.childOffer.modOption.weight && nestedOffer.childOffer.modOption.weight > 0) {
	                                quantity = nestedOffer.childOffer.modOption.weight * nestedOffer.quantity;
	                            }
	                            quantity = quantity * quantityParent;
	                            quantityTechCard = Math.floor(nestedOffer.childOffer.modOption.remainder[0].quantity / quantity);
	                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
	                                product_detail.remainder = [{ quantity: quantityTechCard }];
	                            }
	                        } else {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        }
	                    }
	                }
	                if (nestedOffer.childOffer.modOption === null && nestedOffer.childOffer.type_id !== 5) {
	                    if (nestedOffer.childOffer.storable === true && nestedOffer.childOffer.storage_strict) {
	                        product_detail.storable = true;
	                        if (nestedOffer.childOffer.remainder.length === 0) {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        } else if (nestedOffer.childOffer.remainder[0].quantity > 0) {
	                            if ((nestedOffer.childOffer.unit_id === 2 || nestedOffer.childOffer.unit_id === 8) && nestedOffer.childOffer.weight && nestedOffer.childOffer.weight > 0) {
	                                quantity = nestedOffer.childOffer.weight * nestedOffer.quantity;
	                            }
	                            quantity = quantity * quantityParent;
	                            quantityTechCard = Math.floor(nestedOffer.childOffer.remainder[0].quantity / quantity);
	                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
	                                product_detail.remainder = [{ quantity: quantityTechCard }];
	                            }
	                        } else {
	                            product_detail.remainder = [{ quantity: 0 }];
	                        }
	                    }
	                }
	                if (nestedOffer.childOffer.type_id === 5) {
	                    nestedOffer.childOffer.remainder = [];
	                    nestedOffer.childOffer.storable = false;
	                    quantity = nestedOffer.quantity * quantityParent;
	                    nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
	                        _this2.getRemainder(nestedOfferTwo, quantity, product_detail);
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                order = _props.personal_order_detail.order,
	                user = _props.user,
	                payments = _props.payments,
	                setting = _props.setting;
	
	            var View = _helpers.ThemeHelper.getViewForContainer('OrderDetail', null, { folderName: 'Personal/OrderDetail' });
	
	            if (order == null || user == null) {
	                return null;
	            }
	            var helmetTitle = this.props.lang['store.common.order'] + ' № ' + order.order_number;
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(_reactHelmet2.default, { title: helmetTitle }),
	                _react3.default.createElement(View, {
	                    onSaveOrder: this.onSaveOrder,
	                    order: order,
	                    payments: this.props.payments,
	                    user: this.props.user,
	                    setting: this.props.setting,
	                    editOrder: this.editOrder,
	                    cancelOrder: this.onCancelOrder,
	                    isCancel: this.state.is_cancel
	                })
	            );
	        }
	    }]);
	    return OrderDetail;
	}(_react2.Component), _class2.propTypes = {
	    getPayment: _react2.PropTypes.func.isRequired,
	    getPersonalOrderDetail: _react2.PropTypes.func.isRequired,
	    location: _react2.PropTypes.object.isRequired,
	    params: _react2.PropTypes.object.isRequired,
	    payments: _react2.PropTypes.array,
	    personal_order_detail: _react2.PropTypes.object.isRequired,
	    pushState: _react2.PropTypes.func.isRequired,
	    user: _react2.PropTypes.object,
	    setting: _react2.PropTypes.object.isRequired
	}, _temp)) || _class) || _class));
	
	exports.default = OrderDetail;
	module.exports = exports['default'];

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _components2 = __webpack_require__(16);
	
	var _OrderListItemView = __webpack_require__(762);
	
	var _OrderListItemView2 = _interopRequireDefault(_OrderListItemView);
	
	__webpack_require__(1120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    OrderListView: {
	        displayName: 'OrderListView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Personal/OrderList/default/OrderListView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var OrderListView = _wrapComponent('OrderListView')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang,
	        currency: state.currency
	    };
	}, { push: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(OrderListView, _Component);
	
	    function OrderListView() {
	        (0, _classCallCheck3.default)(this, OrderListView);
	        return (0, _possibleConstructorReturn3.default)(this, (OrderListView.__proto__ || (0, _getPrototypeOf2.default)(OrderListView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(OrderListView, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var orders = this.props.orders || [];
	            var _props = this.props,
	                activePage = _props.activePage,
	                limit = _props.limit,
	                count = _props.count,
	                handleChangePage = _props.handleChangePage,
	                lang = _props.lang,
	                currency = _props.currency;
	
	
	            if (orders.length === 0) {
	                return _react3.default.createElement(
	                    'section',
	                    { id: 'category-grid' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-9' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'grid-list-orders' },
	                            _react3.default.createElement(
	                                'h2',
	                                { className: 'section-title' },
	                                lang['store.order_list.order_list']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'empty-block' },
	                                lang['store.order_list.empty_list']
	                            )
	                        )
	                    )
	                );
	            }
	
	            return _react3.default.createElement(
	                'section',
	                { id: 'category-grid' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'grid-list-orders' },
	                    _react3.default.createElement(
	                        'h2',
	                        { className: 'section-title' },
	                        lang['store.order_list.order_list']
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'products-grid' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'orders-list' },
	                            orders.map(function (item) {
	                                return _react3.default.createElement(_OrderListItemView2.default, {
	                                    key: item.id,
	                                    order: item,
	                                    onPay: function onPay(event) {
	                                        _this2.props.onPay(item);
	                                    },
	                                    lang: lang,
	                                    currency: currency
	                                });
	                            })
	                        ),
	                        _react3.default.createElement(_components2.Paginator, {
	                            activePage: activePage,
	                            limit: limit,
	                            count: count,
	                            handleChangePage: handleChangePage
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	    return OrderListView;
	}(_react2.Component), _class2.propTypes = {
	    orders: _react2.PropTypes.array,
	    onPay: _react2.PropTypes.func,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _class2.defaultProps = {
	    onPay: function onPay() {}
	}, _temp)) || _class));
	
	exports.default = OrderListView;
	module.exports = exports['default'];

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp2;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _personal = __webpack_require__(165);
	
	var _payment = __webpack_require__(114);
	
	var _error = __webpack_require__(140);
	
	var _constants = __webpack_require__(18);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _helpers = __webpack_require__(15);
	
	var _utils = __webpack_require__(31);
	
	var _PaymentStatus = __webpack_require__(163);
	
	var _PaymentStatus2 = _interopRequireDefault(_PaymentStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    OrderList: {
	        displayName: 'OrderList'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Personal/OrderList/index.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var OrderList = _wrapComponent('OrderList')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var params = _ref.params,
	            location = _ref.location,
	            _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	
	        var limit = parseInt(location.query.limit, 10) || _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT,
	            page = parseInt(location.query.page, 10) || 1;
	
	        if (limit > _constants.CatalogNumericConstants.MAX_LIMIT) {
	            limit = _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT;
	        }
	        if (page > _constants.CatalogNumericConstants.MAX_PAGE) {
	            page = 1;
	        }
	        return dispatch((0, _personal.getPersonalOrderList)(page, limit));
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        ordersList: state.personal_order_list,
	        user: state.auth.user,
	        lang: state.lang
	    };
	}, {
	    pushState: _reactRouterRedux.push,
	    rePaymentByOrder: _payment.rePaymentByOrder,
	    throwAlertAction: _error.error
	}), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	    (0, _inherits3.default)(OrderList, _Component);
	
	    function OrderList() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, OrderList);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = OrderList.__proto__ || (0, _getPrototypeOf2.default)(OrderList)).call.apply(_ref2, [this].concat(args))), _this), _this.onPay = function (_ref3) {
	            var id = _ref3.id,
	                payment_in_id = _ref3.payment_in_id,
	                paymentStatus = _ref3.paymentStatus;
	
	            var paymentStatusHelper = new _PaymentStatus2.default(paymentStatus.id);
	
	            if (paymentStatusHelper.isCanceled()) {
	                _this.props.throwAlertAction(_this.props.lang[paymentStatus.lang_data]);
	            } else if (paymentStatusHelper.isOutdated) {
	                _this.props.rePaymentByOrder(id, function (newOrder) {
	                    _this.props.pushState('/create-order/' + newOrder.order_id);
	                });
	            } else {
	                _this.props.pushState('/create-order/' + id);
	            }
	        }, _this.handleChangePage = function (page, limit) {
	            _this.props.pushState('/personal/order-list?limit=' + limit + '&page=' + page);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(OrderList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props$ordersList = this.props.ordersList,
	                limit = _props$ordersList.limit,
	                activePage = _props$ordersList.activePage;
	
	            history.replaceState(null, null, '/personal/order-list?limit=' + limit + '&page=' + activePage);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                lang = _props.lang;
	
	
	            var View = _helpers.ThemeHelper.getViewForContainer('OrderList', null, { folderName: 'Personal/OrderList' });
	            var _props$ordersList2 = this.props.ordersList,
	                activePage = _props$ordersList2.activePage,
	                count = _props$ordersList2.count,
	                limit = _props$ordersList2.limit,
	                orders = _props$ordersList2.orders;
	
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(_reactHelmet2.default, { title: lang['store.helmet.order_list'] }),
	                user ? _react3.default.createElement(View, {
	                    activePage: activePage,
	                    count: count,
	                    handleChangePage: this.handleChangePage,
	                    limit: limit,
	                    onPay: this.onPay,
	                    orders: orders
	                }) : null
	            );
	        }
	    }]);
	    return OrderList;
	}(_react2.Component), _class2.propTypes = {
	    orders: _react2.PropTypes.array,
	    pushState: _react2.PropTypes.func.isRequired,
	    rePaymentByOrder: _react2.PropTypes.func.isRequired,
	    user: _react2.PropTypes.object,
	    lang: _react2.PropTypes.object
	}, _temp2)) || _class) || _class));
	
	exports.default = OrderList;
	module.exports = exports['default'];

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Personal = undefined;
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Personal: {
	        displayName: 'Personal'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Personal/Personal.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	} /**
	   * Created by maximus on 28.12.16.
	   */
	
	var Personal = exports.Personal = _wrapComponent('Personal')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        show_preloader: state.preloader.show,
	        user: state.auth.user
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Personal, _Component);
	
	    function Personal(props) {
	        (0, _classCallCheck3.default)(this, Personal);
	        return (0, _possibleConstructorReturn3.default)(this, (Personal.__proto__ || (0, _getPrototypeOf2.default)(Personal)).call(this, props));
	    }
	
	    (0, _createClass3.default)(Personal, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                user = _props.user;
	
	
	            var View = _helpers.ThemeHelper.getViewForContainer('Personal', null, { folderName: 'Personal' });
	
	            return _react3.default.createElement(View, (0, _extends3.default)({}, this.props, { show_menu: !!user }), children);
	        }
	    }]);
	    return Personal;
	}(_react2.Component), _class2.propTypes = {
	    children: _react2.PropTypes.node,
	    show_preloader: _react2.PropTypes.any.isRequired,
	    user: _react2.PropTypes.object
	}, _temp)) || _class));

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(68);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getIterator2 = __webpack_require__(265);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _iterator2 = __webpack_require__(266);
	
	var _iterator3 = _interopRequireDefault(_iterator2);
	
	var _keys = __webpack_require__(69);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(197);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends3 = __webpack_require__(9);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _helpers = __webpack_require__(15);
	
	var _auth = __webpack_require__(53);
	
	var _user = __webpack_require__(115);
	
	var _modal_type = __webpack_require__(42);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Profile: {
	        displayName: 'Profile'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Personal/Profile/Profile.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Profile = _wrapComponent('Profile')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	        return dispatch((0, _extends4.default)({}, (0, _auth.load)()));
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang,
	        setting: state.setting,
	        user: state.auth.user,
	        error: state.user.error,
	        currency: state.currency
	    };
	}, {
	    pushState: _reactRouterRedux.push,
	    changeInn: _user.changeInn,
	    changeMail: _user.changeMail,
	    changeName: _user.changeName,
	    changePhone: _user.changePhone,
	    changeUlName: _user.changeUlName,
	    confirmMail: _user.confirmMail,
	    confirmPhone: _user.confirmPhone,
	    showModalChangePassword: _modal_type.showModalChangePassword,
	    showModalConfirmMail: _modal_type.showModalConfirmMail,
	    showModalConfirmOldMail: _modal_type.showModalConfirmOldMail,
	    showModalConfirmPhone: _modal_type.showModalConfirmPhone,
	    load: _auth.load,
	    showModalConfirmChangePhone: _modal_type.showModalConfirmChangePhone
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Profile, _Component);
	
	    function Profile(props, context) {
	        (0, _classCallCheck3.default)(this, Profile);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (Profile.__proto__ || (0, _getPrototypeOf2.default)(Profile)).call(this, props, context));
	
	        _this.activeField = function (name) {
	            _this.setState(function (prevState) {
	                var state = {};
	
	                if (name) {
	                    state['disabled_' + name] = !prevState['disabled_' + name];
	                }
	
	                return (0, _extends4.default)({}, prevState, state);
	            });
	        };
	
	        _this.changeField = function (_ref2) {
	            var name = _ref2.name,
	                value = _ref2.value;
	
	            _this.setState(function (prevState) {
	                var _extends2;
	
	                var validate = {};
	
	                if (_this.state.validate.hasOwnProperty(name)) {
	                    validate[name] = undefined;
	                }
	
	                return (0, _extends4.default)({}, prevState, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, name, value), (0, _defineProperty3.default)(_extends2, 'validate', (0, _extends4.default)({}, prevState.validate, validate)), _extends2));
	            });
	        };
	
	        _this.resetField = function (name) {
	            var user = _this.props.user;
	            var confirmed = user.confirmed;
	
	
	            _this.setState(function (prevState) {
	                var state = {};
	                var validate = {};
	
	                switch (name) {
	                    case 'name':
	                        {
	                            state[name] = user.name;
	                            break;
	                        }
	
	                    case 'phone':
	                        {
	                            state[name] = user.phone;
	                            break;
	                        }
	
	                    case 'email':
	                        {
	                            state[name] = user.email;
	                            break;
	                        }
	
	                    default:
	                        {
	                            if (name) {
	                                state[name] = confirmed[name] || '';
	                            }
	                            break;
	                        }
	                }
	
	                if (name) {
	                    state['disabled_' + name] = !prevState['disabled_' + name];
	                    validate[name] = undefined;
	                }
	
	                return (0, _extends4.default)({}, prevState, state, {
	                    validate: (0, _extends4.default)({}, prevState.validate, validate)
	                });
	            });
	        };
	
	        _this.changeName = function (pipoId, name, newName) {
	            _this.props.changeName(pipoId, name, newName);
	            _this.activeField('name');
	        };
	
	        _this.changeMail = function (pipoId, newEmail, code) {
	            if (newEmail !== _this.props.user.email && newEmail !== '') {
	                _this.props.changeMail(pipoId, newEmail, code, function (message) {
	                    _this.props.showModalConfirmMail(pipoId, newEmail, message, _this.props.lang);
	                });
	            } else {
	                _this.setState({
	                    disabledMail: !_this.state.disabledMail,
	                    inputValueMail: _this.props.user.email
	                });
	                return;
	            }
	
	            _this.activeField('email');
	        };
	
	        _this.changePhone = function (pipoId, newPhone, code) {
	            var lang = _this.props.lang;
	
	
	            if (newPhone !== _this.props.user.phone && newPhone !== '') {
	                _this.props.changePhone(pipoId, newPhone, code, function () {
	                    _this.props.showModalConfirmChangePhone(pipoId, newPhone, lang['store.profile.phone_change_confirmation'], lang['store.profile.phone_change_success']);
	                }, function () {
	                    _this.setState({
	                        disabledPhone: !_this.state.disabledPhone,
	                        inputValuePhone: _this.props.user.phone
	                    });
	                });
	            } else {
	                _this.setState({
	                    disabledPhone: !_this.state.disabledPhone,
	                    inputValuePhone: _this.props.user.phone
	                });
	                return;
	            }
	
	            _this.activeField('phone');
	        };
	
	        _this.acceptValue = function (name) {
	            var _this$props = _this.props,
	                changeInn = _this$props.changeInn,
	                changeUlName = _this$props.changeUlName,
	                user = _this$props.user,
	                lang = _this$props.lang;
	
	
	            switch (name) {
	                case 'name':
	                    {
	                        _this.changeName(user.pipo_id, user.name, _this.state.name);
	                        break;
	                    }
	
	                case 'phone':
	                    {
	                        _this.changePhone(user.pipo_id, _this.state.phone);
	                        break;
	                    }
	
	                case 'email':
	                    {
	                        _this.changeMail(user.pipo_id, _this.state.email);
	                        break;
	                    }
	
	                case 'ul_name':
	                    {
	                        changeUlName(_this.state.ul_name);
	
	                        _this.activeField('ul_name');
	                        break;
	                    }
	
	                case 'inn':
	                    {
	                        var REGEX_INN = /^[\d]+$/igm;
	                        var innErrorMessage = lang['store.profile.wrong_identifier_format'];
	
	                        if (_this.state.inn && REGEX_INN.test(_this.state.inn)) {
	                            if (_this.state.inn.length === 10 || _this.state.inn.length === 12) {
	                                changeInn(_this.state.inn);
	
	                                _this.activeField('inn');
	                            } else {
	                                _this.setState({
	                                    validate: {
	                                        inn: innErrorMessage
	                                    }
	                                });
	                            }
	                        } else {
	                            _this.setState({
	                                validate: {
	                                    inn: innErrorMessage
	                                }
	                            });
	                        }
	                        break;
	                    }
	
	                default:
	                    {
	                        _this.activeField(name);
	                        break;
	                    }
	            }
	        };
	
	        _this.confirmMail = function () {
	            var _this$props2 = _this.props,
	                confirmMail = _this$props2.confirmMail,
	                showModalConfirmOldMail = _this$props2.showModalConfirmOldMail,
	                user = _this$props2.user,
	                lang = _this$props2.lang;
	
	
	            confirmMail(user.pipo_id, user.email);
	            showModalConfirmOldMail(lang);
	        };
	
	        _this.confirmPhone = function () {
	            var _this$props3 = _this.props,
	                confirmPhone = _this$props3.confirmPhone,
	                showModalConfirmPhone = _this$props3.showModalConfirmPhone,
	                user = _this$props3.user,
	                lang = _this$props3.lang;
	
	
	            confirmPhone(user.pipo_id, user.phone);
	            showModalConfirmPhone(user.pipo_id, user.phone, lang['store.profile.phone_verification'], lang['store.profile.phone_verification_success']);
	        };
	
	        _this.changePassword = function (e) {
	            e.preventDefault();
	            _this.props.showModalChangePassword(_this.props.lang);
	        };
	
	        _this.state = {
	            email: _this.props.user ? _this.props.user.email : '',
	            name: _this.props.user ? _this.props.user.name : '',
	            phone: _this.props.user ? _this.props.user.phone : '',
	            validate: {}
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(Profile, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var user = this.props.user;
	            var confirmed = user.confirmed;
	
	            var temp = (0, _extends4.default)({}, confirmed);
	
	            // свойство телефон уже есть
	            delete temp.confirmed_phone;
	
	            // динамически затолкаем в состояние значение других свойств
	            _Object$keys = (0, _keys2.default)(temp);
	
	            if (!(_Object$keys && (typeof _Object$keys[_iterator3.default] === 'function' || Array.isArray(_Object$keys)))) {
	                throw new TypeError('Expected _Object$keys to be iterable, got ' + _inspect(_Object$keys));
	            }
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(_Object$keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _Object$keys;
	
	                    var prop = _step.value;
	
	                    this.changeField({
	                        name: prop,
	                        value: temp[prop]
	                    });
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	
	        /**
	         * Активация поля для редактирования
	         * @param name
	         */
	
	
	        /**
	         * Обработчик изменения текста
	         * @param name
	         * @param value
	         */
	
	
	        /**
	         * Обработчик сброса значения
	         * @param name
	         */
	
	
	        /**
	         * Обработчик смены email'а
	         * @param pipoId
	         * @param newEmail
	         * @param code
	         */
	
	
	        /**
	         * Обработчик смены телефона
	         * @param pipoId
	         * @param newPhone
	         * @param code
	         */
	
	
	        /**
	         * Обработчик смены значения у поля
	         * @param name
	         */
	
	
	        /**
	         * Обработчик подтверждения email
	         */
	
	
	        /**
	         * Обработчик подтверждения телефона
	         */
	
	
	        /**
	         * Обработчик смены пароля
	         * @param e
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                lang = _props.lang,
	                setting = _props.setting,
	                user = _props.user,
	                currency = _props.currency;
	
	
	            var View = _helpers.ThemeHelper.getViewForContainer('Profile', null, { folderName: 'Personal/Profile' });
	
	            if (user) {
	                return _react3.default.createElement(
	                    'div',
	                    null,
	                    _react3.default.createElement(_reactHelmet2.default, { title: '\u041F\u0440\u043E\u0444\u0438\u043B\u044C' }),
	                    _react3.default.createElement(View, {
	                        acceptValue: this.acceptValue,
	                        activeField: this.activeField,
	                        changeField: this.changeField,
	                        changePassword: this.changePassword,
	                        confirmMail: this.confirmMail,
	                        confirmPhone: this.confirmPhone,
	                        lang: lang,
	                        profile: this.state,
	                        resetField: this.resetField,
	                        setting: setting,
	                        user: user,
	                        currency: currency
	                    })
	                );
	            }
	
	            return null;
	        }
	    }]);
	    return Profile;
	}(_react2.Component), _class2.propTypes = {
	    changeInn: _react2.PropTypes.func.isRequired,
	    changeMail: _react2.PropTypes.func.isRequired,
	    changeName: _react2.PropTypes.func.isRequired,
	    changePhone: _react2.PropTypes.func.isRequired,
	    changeUlName: _react2.PropTypes.func.isRequired,
	    confirmMail: _react2.PropTypes.func.isRequired,
	    confirmPhone: _react2.PropTypes.func.isRequired,
	    lang: _react2.PropTypes.object.isRequired,
	    setting: _react2.PropTypes.object.isRequired,
	    showModalChangePassword: _react2.PropTypes.func.isRequired,
	    showModalConfirmMail: _react2.PropTypes.func.isRequired,
	    showModalConfirmOldMail: _react2.PropTypes.func.isRequired,
	    showModalConfirmPhone: _react2.PropTypes.func.isRequired,
	    showModalConfirmChangePhone: _react2.PropTypes.func.isRequired,
	    user: _react2.PropTypes.object,
	    pushState: _react2.PropTypes.func.isRequired,
	    currency: _react2.PropTypes.object.isRequired
	}, _class2.defaultProps = {
	    user: {}
	}, _temp)) || _class) || _class));
	
	exports.default = Profile;
	
	function _inspect(input, depth) {
	    var maxDepth = 4;
	    var maxKeys = 15;
	
	    if (depth === undefined) {
	        depth = 0;
	    }
	
	    depth += 1;
	
	    if (input === null) {
	        return 'null';
	    } else if (input === undefined) {
	        return 'void';
	    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
	        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
	    } else if (Array.isArray(input)) {
	        if (input.length > 0) {
	            if (depth > maxDepth) return '[...]';
	
	            var first = _inspect(input[0], depth);
	
	            if (input.every(function (item) {
	                return _inspect(item, depth) === first;
	            })) {
	                return first.trim() + '[]';
	            } else {
	                return '[' + input.slice(0, maxKeys).map(function (item) {
	                    return _inspect(item, depth);
	                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
	            }
	        } else {
	            return 'Array';
	        }
	    } else {
	        var keys = (0, _keys2.default)(input);
	
	        if (!keys.length) {
	            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	                return input.constructor.name;
	            } else {
	                return 'Object';
	            }
	        }
	
	        if (depth > maxDepth) return '{...}';
	        var indent = '  '.repeat(depth - 1);
	        var entries = keys.slice(0, maxKeys).map(function (key) {
	            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
	        }).join('\n  ' + indent);
	
	        if (keys.length >= maxKeys) {
	            entries += '\n  ' + indent + '...';
	        }
	
	        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
	            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
	        } else {
	            return '{\n  ' + indent + entries + '\n' + indent + '}';
	        }
	    }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    ProfileView: {
	        displayName: 'ProfileView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Personal/Profile/default/ProfileView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var ProfileView = _wrapComponent('ProfileView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(ProfileView, _Component);
	
	    function ProfileView() {
	        (0, _classCallCheck3.default)(this, ProfileView);
	        return (0, _possibleConstructorReturn3.default)(this, (ProfileView.__proto__ || (0, _getPrototypeOf2.default)(ProfileView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(ProfileView, [{
	        key: 'render',
	        value: function render() {
	            return _react3.default.createElement(_components2.UserProfile, this.props);
	        }
	    }]);
	    return ProfileView;
	}(_react2.Component), _class.propTypes = {
	    acceptValue: _react2.PropTypes.func.isRequired,
	    activeField: _react2.PropTypes.func.isRequired,
	    changeField: _react2.PropTypes.func.isRequired,
	    changePassword: _react2.PropTypes.func.isRequired,
	    confirmMail: _react2.PropTypes.func.isRequired,
	    confirmPhone: _react2.PropTypes.func.isRequired,
	    lang: _react2.PropTypes.object.isRequired,
	    profile: _react2.PropTypes.object.isRequired,
	    resetField: _react2.PropTypes.func.isRequired,
	    setting: _react2.PropTypes.object.isRequired,
	    user: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object.isRequired
	}, _temp));
	
	exports.default = ProfileView;
	module.exports = exports['default'];

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Profile = undefined;
	
	var _Profile2 = __webpack_require__(1834);
	
	var _Profile3 = _interopRequireDefault(_Profile2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Profile = _Profile3.default;

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PersonalView: {
	        displayName: 'PersonalView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Personal/default/PersonalView.js',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var PersonalView = _wrapComponent('PersonalView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(PersonalView, _Component);
	
	    function PersonalView(props) {
	        (0, _classCallCheck3.default)(this, PersonalView);
	        return (0, _possibleConstructorReturn3.default)(this, (PersonalView.__proto__ || (0, _getPrototypeOf2.default)(PersonalView)).call(this, props));
	    }
	
	    (0, _createClass3.default)(PersonalView, [{
	        key: 'render',
	        value: function render() {
	            var show_menu = this.props.show_menu;
	            var route = this.props.children.props.route;
	
	            var active = '';
	
	            // TODO LANG проверить, как будет работать при языке, отличном от русского
	            switch (route.path) {
	                case 'profile':
	                    active = 'Профиль';
	                    break;
	                case 'order-list':
	                    active = 'Заказы';
	                    break;
	                case 'order/:order_id':
	                    active = 'Заказы';
	                    break;
	                case 'addresses':
	                    active = 'Адреса';
	                    break;
	                case 'operations':
	                    active = 'Выписка по счёту';
	                    break;
	                case 'wishlist':
	                    active = 'Избранное';
	                    break;
	                case 'basket':
	                    active = 'basket';
	                    break;
	            }
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'row' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-4 col-md-3 sidemenu-holder', id: 'UserProfileMenu' },
	                    show_menu ? _react3.default.createElement(_components2.UserProfileMenu, { active: active }) : null
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-8 col-md-9' },
	                    _react3.default.createElement(
	                        _components2.Preloader,
	                        { preload: this.props.show_preloader },
	                        this.props.children
	                    )
	                )
	            );
	        }
	    }]);
	    return PersonalView;
	}(_react2.Component), _class.propTypes = {
	    show_menu: _react2.PropTypes.bool,
	    show_preloader: _react2.PropTypes.any.isRequired
	}, _temp));
	
	exports.default = PersonalView;
	module.exports = exports['default'];

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PersonalBasket = exports.Operations = exports.Personal = exports.Profile = exports.OrderDetail = exports.OrderList = undefined;
	
	var _Profile = __webpack_require__(1836);
	
	Object.defineProperty(exports, 'Profile', {
	  enumerable: true,
	  get: function get() {
	    return _Profile.Profile;
	  }
	});
	
	var _Personal = __webpack_require__(1833);
	
	Object.defineProperty(exports, 'Personal', {
	  enumerable: true,
	  get: function get() {
	    return _Personal.Personal;
	  }
	});
	
	var _OrderList2 = __webpack_require__(1832);
	
	var _OrderList3 = _interopRequireDefault(_OrderList2);
	
	var _OrderDetail2 = __webpack_require__(1830);
	
	var _OrderDetail3 = _interopRequireDefault(_OrderDetail2);
	
	var _Operations2 = __webpack_require__(1828);
	
	var _Operations3 = _interopRequireDefault(_Operations2);
	
	var _Basket = __webpack_require__(1826);
	
	var _Basket2 = _interopRequireDefault(_Basket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.OrderList = _OrderList3.default;
	exports.OrderDetail = _OrderDetail3.default;
	exports.Operations = _Operations3.default;
	exports.PersonalBasket = _Basket2.default;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _basket = __webpack_require__(101);
	
	var _modal = __webpack_require__(26);
	
	var _helpers = __webpack_require__(15);
	
	var _components2 = __webpack_require__(16);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PostponeBasket: {
	        displayName: 'PostponeBasket'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/PostponeBasket/PostponeBasket.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var PostponeBasket = _wrapComponent('PostponeBasket')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var params = _ref.params,
	            _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	        return dispatch((0, _basket.getPostpone)());
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        setting: state.setting,
	        wishProducts: state.wishList.wishProducts,
	        items: state.basket.itemsPostpone,
	        lang: state.lang,
	        preload: state.basket.preload,
	        currency: state.currency
	    };
	}, { addProduct: _basket.addProduct, clearBasket: _basket.clearBasket, getPostpone: _basket.getPostpone, deletePostpone: _basket.deletePostpone, showModal: _modal.showModal, hide: _modal.hide, mergePostpone: _basket.mergePostpone, push: _reactRouterRedux.push }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(PostponeBasket, _Component);
	
	    function PostponeBasket(props) {
	        (0, _classCallCheck3.default)(this, PostponeBasket);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (PostponeBasket.__proto__ || (0, _getPrototypeOf2.default)(PostponeBasket)).call(this, props));
	
	        _this.onDelete = function (id) {
	            var lang = _this.props.lang;
	
	
	            var modalContent = _react3.default.createElement(
	                'div',
	                { className: 'row no-margin' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    lang['store.postpone.deletePostpone.confirm']
	                )
	            );
	
	            _this.props.showModal({
	                title: lang['store.wish_list.remove'],
	                content: modalContent,
	                titleSuccess: lang['store.common.yes'],
	                titleClose: lang['store.common.no'],
	                onSuccess: function onSuccess() {
	                    _this.props.deletePostpone(id);
	                    // setTimeout(this.props.setWishList(storage.getItem('wishlist.common')), 50000);
	                },
	                modalType: 'del'
	            });
	        };
	
	        _this.mergeBaskets = function () {
	            var postponeIds = [];
	            _this.state.selected.forEach(function (item, i) {
	                if (item === true) {
	                    postponeIds.push(i);
	                }
	            });
	            _this.props.mergePostpone(postponeIds);
	        };
	
	        _this.inBasket = function (products) {
	            _this.props.clearBasket();
	            products.map(function (product) {
	                _this.props.addProduct(product);
	            });
	            _this.props.push('/basket');
	        };
	
	        _this.inBasketMerged = function (childrenPostpone) {
	            _this.props.clearBasket();
	            var products = null;
	
	            childrenPostpone.forEach(function (item, index) {
	                products = JSON.parse(item.items_data);
	                products.forEach(function (product) {
	                    product.basket_number = index;
	                    _this.props.addProduct(product);
	                });
	            });
	            _this.props.push('/basket');
	        };
	
	        _this.changeSelected = function (e) {
	            _this.state.selected[e.target.id] = e.target.checked;
	            var countSelected = 0;
	            _this.state.selected.forEach(function (item) {
	                if (item === true) {
	                    countSelected++;
	                }
	            });
	            _this.setState({ countSelected: countSelected });
	        };
	
	        var selected = [];
	        props.items.map(function (item) {
	            selected[item.id] = false;
	        });
	        _this.state = {
	            selected: selected,
	            countSelected: 0
	        };
	        return _this;
	    }
	
	    (0, _createClass3.default)(PostponeBasket, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForContainer('PostponeBasket');
	            var orderInOneClick = this.props.setting;
	            return _react3.default.createElement(
	                _components2.Preloader,
	                { preload: this.props.preload },
	                _react3.default.createElement(View, {
	                    products: this.props.wishProducts,
	                    onDelete: this.onDelete,
	                    inBasket: this.inBasket,
	                    inBasketMerged: this.inBasketMerged,
	                    orderInOneClick: orderInOneClick,
	                    lang: this.props.lang,
	                    currency: this.props.currency,
	                    items: this.props.items,
	                    changeSelected: this.changeSelected,
	                    selected: this.state.selected,
	                    countSelected: this.state.countSelected,
	                    mergeBaskets: this.mergeBaskets
	                })
	            );
	        }
	    }]);
	    return PostponeBasket;
	}(_react2.Component), _class2.propTypes = {
	    wishProducts: _react2.PropTypes.array,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp)) || _class) || _class));
	
	exports.default = PostponeBasket;
	module.exports = exports['default'];

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _helpers = __webpack_require__(15);
	
	var _reactRouter = __webpack_require__(19);
	
	var _components2 = __webpack_require__(16);
	
	var _SHARE = __webpack_require__(93);
	
	__webpack_require__(1121);
	
	var _reactBootstrap = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    PostponeBasketView: {
	        displayName: 'PostponeBasketView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/PostponeBasket/default/PostponeBasketView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var PostponeBasketView = _wrapComponent('PostponeBasketView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(PostponeBasketView, _Component);
	
	    function PostponeBasketView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, PostponeBasketView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PostponeBasketView.__proto__ || (0, _getPrototypeOf2.default)(PostponeBasketView)).call.apply(_ref, [this].concat(args))), _this), _this.renderPostpones = function (item) {
	            var _this$props = _this.props,
	                currency = _this$props.currency,
	                lang = _this$props.lang;
	
	            var products = null;
	            var sumByBasket = 0;
	            if (item.items_data === null) {
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'row cart-item flying-to-cart-holder', style: { backgroundColor: '#fff', borderRadius: '7px' } },
	                    _react3.default.createElement('div', { className: 'col-xs-12 col-sm-1 text-center' }),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-7' },
	                        item.childrenPostpone.map(function (childrenPostpone, i) {
	                            products = JSON.parse(childrenPostpone.items_data);
	                            return _react3.default.createElement(
	                                'div',
	                                null,
	                                _react3.default.createElement(
	                                    'h4',
	                                    null,
	                                    '\u041A\u043E\u0440\u0437\u0438\u043D\u0430 ',
	                                    i + 1
	                                ),
	                                products.map(function (product) {
	                                    sumByBasket = sumByBasket + product.count * product.price;
	                                    return _react3.default.createElement(
	                                        'div',
	                                        null,
	                                        _react3.default.createElement(
	                                            'div',
	                                            { className: 'row no-margin' },
	                                            _react3.default.createElement(
	                                                'div',
	                                                { className: 'col-xs-12 col-sm-8' },
	                                                product.name
	                                            ),
	                                            _react3.default.createElement(
	                                                'div',
	                                                { className: 'col-xs-12 col-sm-2 text-center' },
	                                                product.count
	                                            ),
	                                            _react3.default.createElement(
	                                                'div',
	                                                { className: 'col-xs-12 col-sm-2 text-center' },
	                                                _react3.default.createElement(_components2.MoneyValue, {
	                                                    value: product.price,
	                                                    icon: currency.icon,
	                                                    iconAfterValue: currency.icon_after_value
	                                                })
	                                            )
	                                        )
	                                    );
	                                })
	                            );
	                        })
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2 text-center' },
	                        _react3.default.createElement(_components2.MoneyValue, {
	                            value: sumByBasket,
	                            icon: currency.icon,
	                            iconAfterValue: currency.icon_after_value
	                        })
	                    ),
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-sm-2' },
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'buttons-holder inline_block button_width_100' },
	                            _react3.default.createElement(
	                                'a',
	                                { href: '#', onClick: function onClick(e) {
	                                        e.preventDefault();
	                                        _this.props.inBasketMerged(item.childrenPostpone);
	                                    }, className: 'le-button big button_width_100' },
	                                lang['store.postpone.checkout']
	                            )
	                        ),
	                        _react3.default.createElement('a', { className: 'close-btn pointer', style: { marginLeft: '5px' }, onClick: function onClick(e) {
	                                e.preventDefault();
	                                _this.props.onDelete(item.id);
	                            } })
	                    )
	                );
	            }
	            products = JSON.parse(item.items_data);
	            return _react3.default.createElement(
	                'div',
	                { className: 'row cart-item flying-to-cart-holder', style: { backgroundColor: '#fff', borderRadius: '7px' } },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-1 text-center' },
	                    item.parent_id == null ? _react3.default.createElement(
	                        _reactBootstrap.FormGroup,
	                        null,
	                        _react3.default.createElement('input', {
	                            type: 'checkbox',
	                            className: 'form-check-input',
	                            id: item.id,
	                            onChange: _this.props.changeSelected,
	                            checked: _this.props.selected[item.value]
	                        })
	                    ) : null
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-7' },
	                    products.map(function (product) {
	                        sumByBasket = sumByBasket + product.count * product.price;
	                        return _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-8' },
	                                product.name
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2 text-center' },
	                                product.count
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2 text-center' },
	                                _react3.default.createElement(_components2.MoneyValue, {
	                                    value: product.price,
	                                    icon: currency.icon,
	                                    iconAfterValue: currency.icon_after_value
	                                })
	                            )
	                        );
	                    })
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2 text-center' },
	                    _react3.default.createElement(_components2.MoneyValue, {
	                        value: sumByBasket,
	                        icon: currency.icon,
	                        iconAfterValue: currency.icon_after_value
	                    })
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'buttons-holder inline_block button_width_100' },
	                        _react3.default.createElement(
	                            'a',
	                            { href: '#', onClick: function onClick(e) {
	                                    e.preventDefault();
	                                    _this.props.inBasket(products);
	                                }, className: 'le-button big button_width_100' },
	                            lang['store.common.add_to_cart']
	                        )
	                    ),
	                    _react3.default.createElement('a', { className: 'close-btn pointer', style: { marginLeft: '5px' }, onClick: function onClick(e) {
	                            e.preventDefault();
	                            _this.props.onDelete(item.id);
	                        } })
	                )
	            );
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(PostponeBasketView, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                products = _props.products,
	                lang = _props.lang,
	                items = _props.items;
	
	
	            return _react3.default.createElement(
	                'section',
	                { className: 'user-profile' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'wishlist' },
	                    _react3.default.createElement(
	                        'h2',
	                        { className: 'section-title' },
	                        lang['store.postpone.postponeBasket.title']
	                    ),
	                    items.length ? _react3.default.createElement(
	                        'div',
	                        null,
	                        this.props.countSelected > 1 ? _react3.default.createElement(
	                            'div',
	                            { className: 'buttons-holder' },
	                            _react3.default.createElement(
	                                'a',
	                                { href: '#', onClick: function onClick(e) {
	                                        e.preventDefault();
	                                        _this2.props.mergeBaskets();
	                                    }, className: 'le-button big button_width_100' },
	                                lang['store.postpone.mergeButton']
	                            )
	                        ) : null,
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin cart-item hidden-xs wish_head' },
	                            _react3.default.createElement('div', { className: 'col-xs-12 col-sm-1' }),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-7 text-center' },
	                                lang['store.postpone.offers']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2' },
	                                lang['store.common.sum']
	                            ),
	                            _react3.default.createElement('div', { className: 'col-xs-12 col-sm-2' })
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'items-holder' },
	                            items.map(this.renderPostpones)
	                        ),
	                        this.props.countSelected > 1 ? _react3.default.createElement(
	                            'div',
	                            { className: 'buttons-holder' },
	                            _react3.default.createElement(
	                                'a',
	                                { href: '#', onClick: function onClick(e) {
	                                        e.preventDefault();
	                                        _this2.props.mergeBaskets();
	                                    }, className: 'le-button big button_width_100' },
	                                lang['store.postpone.mergeButton']
	                            )
	                        ) : null
	                    ) : _react3.default.createElement(
	                        'div',
	                        { className: 'empty-block' },
	                        lang['store.wish_list.empty_wish_list']
	                    )
	                )
	            );
	        }
	    }]);
	    return PostponeBasketView;
	}(_react2.Component), _class.propTypes = {
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp2));
	
	exports.default = PostponeBasketView;
	module.exports = exports['default'];

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PostponeBasket = undefined;
	
	var _PostponeBasket2 = __webpack_require__(1839);
	
	var _PostponeBasket3 = _interopRequireDefault(_PostponeBasket2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.PostponeBasket = _PostponeBasket3.default; /**
	                                                    * Created by maximus on 16.12.16.
	                                                    */

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class, _class2, _temp;
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(12);
	
	var _components2 = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Registration: {
	        displayName: 'Registration'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Registration/Registration.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Registration = _wrapComponent('Registration')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang
	    };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(Registration, _Component);
	
	    function Registration(props) {
	        (0, _classCallCheck3.default)(this, Registration);
	        return (0, _possibleConstructorReturn3.default)(this, (Registration.__proto__ || (0, _getPrototypeOf2.default)(Registration)).call(this, props));
	    }
	
	    (0, _createClass3.default)(Registration, [{
	        key: 'render',
	        value: function render() {
	            var helmetTitle = this.props.lang['store.helmet.registration.registration'];
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(_reactHelmet2.default, { title: helmetTitle }),
	                _react3.default.createElement(_components2.Registration, null)
	            );
	        }
	    }]);
	    return Registration;
	}(_react2.Component), _class2.propTypes = {
	    lang: _react2.PropTypes.object
	}, _temp)) || _class));
	
	exports.default = Registration;
	module.exports = exports['default'];

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 10.11.16.
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _reactBootstrap = __webpack_require__(24);
	
	var _components2 = __webpack_require__(16);
	
	__webpack_require__(1122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    RegistrationView: {
	        displayName: 'RegistrationView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Registration/default/RegistrationView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var RegistrationView = _wrapComponent('RegistrationView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(RegistrationView, _Component);
	
	    function RegistrationView() {
	        (0, _classCallCheck3.default)(this, RegistrationView);
	        return (0, _possibleConstructorReturn3.default)(this, (RegistrationView.__proto__ || (0, _getPrototypeOf2.default)(RegistrationView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(RegistrationView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                changeField = _props.changeField,
	                handleOnClick = _props.handleOnClick,
	                handleOnEnter = _props.handleOnEnter,
	                onHide = _props.onHide,
	                preload = _props.preload,
	                state = _props.state,
	                status = _props.status,
	                title = _props.title;
	
	
	            return _react3.default.createElement(
	                _reactBootstrap.Modal,
	                {
	                    show: true,
	                    dialogClassName: 'registration-modal',
	                    onHide: onHide
	                },
	                _react3.default.createElement(
	                    _reactBootstrap.Modal.Header,
	                    { closeButton: true },
	                    _react3.default.createElement(
	                        'h4',
	                        { className: 'modal-title' },
	                        title
	                    )
	                ),
	                _react3.default.createElement(
	                    _reactBootstrap.Modal.Body,
	                    null,
	                    _react3.default.createElement(
	                        _components2.Preloader,
	                        { preload: preload },
	                        _react3.default.createElement(_components2.RegistrationFull, {
	                            state: state,
	                            status: status,
	                            changeField: changeField,
	                            handleOnClick: handleOnClick,
	                            handleOnEnter: handleOnEnter
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	    return RegistrationView;
	}(_react2.Component), _class.propTypes = {
	    changeField: _react2.PropTypes.func.isRequired,
	    handleOnClick: _react2.PropTypes.func.isRequired,
	    handleOnEnter: _react2.PropTypes.func.isRequired,
	    onHide: _react2.PropTypes.func.isRequired,
	    preload: _react2.PropTypes.bool.isRequired,
	    state: _react2.PropTypes.object.isRequired,
	    status: _react2.PropTypes.object.isRequired,
	    title: _react2.PropTypes.string.isRequired
	}, _temp));
	
	exports.default = RegistrationView;
	module.exports = exports['default'];

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Registration = undefined;
	
	var _Registration2 = __webpack_require__(1842);
	
	var _Registration3 = _interopRequireDefault(_Registration2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Registration = _Registration3.default;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp2;
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _catalog = __webpack_require__(67);
	
	var _constants = __webpack_require__(18);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Search: {
	        displayName: 'Search'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Search/Search.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Search = _wrapComponent('Search')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var params = _ref.params,
	            location = _ref.location,
	            _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	        var limit = parseInt(location.query.limit, 10) || _constants.CatalogNumericConstants.SEARCH_PAGE_LIMIT,
	            page = parseInt(location.query.page, 10);
	
	        if (limit > _constants.CatalogNumericConstants.MAX_LIMIT) {
	            limit = _constants.CatalogNumericConstants.SEARCH_PAGE_LIMIT;
	        }
	        if (page > _constants.CatalogNumericConstants.MAX_PAGE) {
	            page = 1;
	        }
	
	        return dispatch((0, _catalog.getProducts)(params.input_state, --page, limit));
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        products: state.catalog.products,
	        count: state.catalog.count,
	        activePage: state.catalog.activePage,
	        limit: state.catalog.limit,
	        searchName: state.catalog.searchName,
	        lang: state.lang
	    };
	}, { push: _reactRouterRedux.push, setSearchClose: _catalog.setSearchClose }), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	    (0, _inherits3.default)(Search, _Component);
	
	    function Search() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, Search);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChangePage = function (page, limit) {
	            _this.props.push('/search/' + _this.props.searchName + '?limit=' + limit + '&page=' + page);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(Search, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForContainer('Search');
	            var helmetTitle = this.props.lang['store.helmet.search_results'];
	
	            return _react3.default.createElement(
	                'div',
	                null,
	                _react3.default.createElement(_reactHelmet2.default, { title: helmetTitle }),
	                _react3.default.createElement(View, (0, _extends3.default)({ handleChangePage: this.handleChangePage }, this.props))
	            );
	        }
	    }]);
	    return Search;
	}(_react2.Component), _class2.propTypes = {
	    products: _react2.PropTypes.array.isRequired,
	    lang: _react2.PropTypes.object
	}, _temp2)) || _class) || _class));
	
	exports.default = Search;
	module.exports = exports['default'];

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SearchView: {
	        displayName: 'SearchView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Search/default/SearchView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var SearchView = _wrapComponent('SearchView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(SearchView, _Component);
	
	    function SearchView() {
	        (0, _classCallCheck3.default)(this, SearchView);
	        return (0, _possibleConstructorReturn3.default)(this, (SearchView.__proto__ || (0, _getPrototypeOf2.default)(SearchView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(SearchView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                activePage = _props.activePage,
	                count = _props.count,
	                limit = _props.limit,
	                products = _props.products,
	                handleChangePage = _props.handleChangePage,
	                lang = _props.lang;
	
	
	            var CategoryView = _helpers.ThemeHelper.getViewForContainer('Category');
	            var resultTitle = lang['store.search.result'] + ":";
	
	            return _react3.default.createElement(CategoryView, {
	                activePage: activePage,
	                count: count,
	                limit: limit,
	                products: products,
	                title: resultTitle,
	                handleChangePage: handleChangePage,
	                lang: lang
	            });
	        }
	    }]);
	    return SearchView;
	}(_react2.Component), _class.propTypes = {
	    products: _react2.PropTypes.array.isRequired,
	    lang: _react2.PropTypes.object
	}, _temp));
	
	exports.default = SearchView;
	module.exports = exports['default'];

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Search = undefined;
	
	var _Search2 = __webpack_require__(1845);
	
	var _Search3 = _interopRequireDefault(_Search2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Search = _Search3.default;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(58);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class;
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _catalog = __webpack_require__(67);
	
	var _sliders = __webpack_require__(767);
	
	var _sliders2 = __webpack_require__(261);
	
	var _constants = __webpack_require__(18);
	
	var _lodash = __webpack_require__(177);
	
	var _helpers = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Slide: {
	        displayName: 'Slide'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Slide/Slide.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var timerId = void 0;
	
	// Интервал автообновления списка слайдов
	var SYNC_SLIDES_TIMEOUT = 1000 * 60 * 5;
	
	var Slide = _wrapComponent('Slide')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{ promise: function promise(_ref) {
	        var _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	        if (getState().setting.slider_novelty) {
	            return dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_NEW));
	        }return null;
	    } }, { promise: function promise(_ref2) {
	        var _ref2$store = _ref2.store,
	            dispatch = _ref2$store.dispatch,
	            getState = _ref2$store.getState;
	
	        if (getState().setting.slider_hits) {
	            return dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_HIT));
	        }return null;
	    } }, { promise: function promise(_ref3) {
	        var _ref3$store = _ref3.store,
	            dispatch = _ref3$store.dispatch,
	            getState = _ref3$store.getState;
	
	        if (getState().setting.slider_popular) {
	            return dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_POPULAR));
	        }return null;
	    } }]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        settings: state.setting,
	        sliders: state.sliders
	    };
	}, function (dispatch) {
	    return {
	        fetchProducts: function fetchProducts() {
	            return [dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_NEW)), dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_HIT)), dispatch((0, _sliders.getProductForSlider)(_sliders2.SLIDER_POPULAR))];
	        }
	    };
	}), _dec(_class = _dec2(_class = function (_Component) {
	    (0, _inherits3.default)(Slide, _Component);
	
	    function Slide() {
	        (0, _classCallCheck3.default)(this, Slide);
	        return (0, _possibleConstructorReturn3.default)(this, (Slide.__proto__ || (0, _getPrototypeOf2.default)(Slide)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Slide, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.stopSync();
	            this.startSync();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.stopSync();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForContainer('Slide');
	            var list = this.createSlidesList(this.props.settings, this.props.sliders);
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'Slide u-full-height' },
	                _react3.default.createElement(_reactHelmet2.default, { title: '\u0421\u043B\u0430\u0439\u0434\u0435\u0440' }),
	                _react3.default.createElement(View, { slidesList: list, updateProducts: this.props.fetchProducts })
	            );
	        }
	    }, {
	        key: 'startSync',
	        value: function startSync() {
	            var _this2 = this;
	
	            timerId = setTimeout(function () {
	                return _promise2.default.all(_this2.props.fetchProducts()), _this2.startSync();
	            }, SYNC_SLIDES_TIMEOUT);
	        }
	    }, {
	        key: 'stopSync',
	        value: function stopSync() {
	            clearTimeout(timerId);
	        }
	
	        // Проставляем для подуктов уникальные id-и
	        // (для железности, если товар по ошибке продублируется в массиве 2-а раза,
	        //  то будет ошибка при рендере)
	
	    }, {
	        key: 'createUniqueIdForEach',
	        value: function createUniqueIdForEach(arrayItems, prefix) {
	            if (Array.isArray(arrayItems)) {
	                arrayItems.forEach(function (item) {
	                    item.$uid = prefix + ':' + item.id;
	                });
	            }
	
	            return arrayItems;
	        }
	    }, {
	        key: 'createSlidesList',
	        value: function createSlidesList() {
	            var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var slides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            var list = [];
	
	            if (settings.slider_novelty && Array.isArray(slides.products_novelty)) {
	                list = list.concat(this.createUniqueIdForEach(slides.products_novelty, _sliders2.SLIDER_NEW));
	            }
	
	            if (settings.slider_hits && Array.isArray(slides.products_hits)) {
	                list = list.concat(this.createUniqueIdForEach(slides.products_hits, _sliders2.SLIDER_HIT));
	            }
	
	            if (settings.slider_popular && Array.isArray(slides.products_popular)) {
	                list = list.concat(this.createUniqueIdForEach(slides.products_popular, _sliders2.SLIDER_POPULAR));
	            }
	
	            return list;
	        }
	    }]);
	    return Slide;
	}(_react2.Component)) || _class) || _class));
	
	exports.default = Slide;
	module.exports = exports['default'];

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _components2 = __webpack_require__(16);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    SlideView: {
	        displayName: 'SlideView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Slide/default/SlideView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var SlideView = _wrapComponent('SlideView')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(SlideView, _Component);
	
	    function SlideView() {
	        (0, _classCallCheck3.default)(this, SlideView);
	        return (0, _possibleConstructorReturn3.default)(this, (SlideView.__proto__ || (0, _getPrototypeOf2.default)(SlideView)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(SlideView, [{
	        key: 'render',
	        value: function render() {
	            var sliderComp = _react3.default.createElement(_components2.SliderWithQR, {
	                items: this.props.slidesList,
	                autoplay: true,
	                autoplaySpeed: 10000,
	                updateProducts: this.props.updateProducts
	            });
	
	            if (this.props.slidesList.length !== 0) {
	                return _react3.default.createElement(
	                    'div',
	                    { className: 'Slide__view u-full-height' },
	                    sliderComp
	                );
	            }
	
	            return null;
	        }
	    }]);
	    return SlideView;
	}(_react2.Component), _class.propTypes = {
	    slidesList: _propTypes2.default.array,
	    updateProducts: _propTypes2.default.func
	}, _class.defaultProps = {
	    slidesList: []
	}, _temp));
	
	exports.default = SlideView;
	module.exports = exports['default'];

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Slide = __webpack_require__(1848);
	
	Object.defineProperty(exports, 'Slide', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Slide).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Компонент заглушка для статичных страниц
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Static: {
	        displayName: 'Static'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/Static/Static.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Static = _wrapComponent('Static')((_dec = (0, _reactRedux.connect)(function (state) {
	    return {
	        lang: state.lang
	    };
	}), _dec(_class = function (_Component) {
	    (0, _inherits3.default)(Static, _Component);
	
	    function Static(props) {
	        (0, _classCallCheck3.default)(this, Static);
	        return (0, _possibleConstructorReturn3.default)(this, (Static.__proto__ || (0, _getPrototypeOf2.default)(Static)).call(this, props));
	    }
	
	    (0, _createClass3.default)(Static, [{
	        key: 'render',
	        value: function render() {
	            var helmetTitle = this.props.lang['store.static.empty_page'];
	
	            return _react3.default.createElement(
	                'div',
	                { className: 'row' },
	                _react3.default.createElement(_reactHelmet2.default, { title: helmetTitle }),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    _react3.default.createElement(
	                        'h1',
	                        null,
	                        helmetTitle
	                    )
	                )
	            );
	        }
	    }]);
	    return Static;
	}(_react2.Component)) || _class));
	
	exports.default = Static;
	module.exports = exports['default'];

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Static = undefined;
	
	var _Static2 = __webpack_require__(1851);
	
	var _Static3 = _interopRequireDefault(_Static2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Static = _Static3.default;

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _reactRedux = __webpack_require__(12);
	
	var _wish_list = __webpack_require__(166);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	var _modal = __webpack_require__(26);
	
	var _helpers = __webpack_require__(15);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    WishList: {
	        displayName: 'WishList'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/WishList/WishList.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var WishList = _wrapComponent('WishList')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
	    promise: function promise(_ref) {
	        var _ref$store = _ref.store,
	            dispatch = _ref$store.dispatch,
	            getState = _ref$store.getState;
	
	        var products = getState().wishList.wishProducts;
	        if (products) {
	            return dispatch((0, _extends3.default)({}, (0, _wish_list.getActualPricesWishList)(products)));
	        }
	    }
	}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	    return {
	        setting: state.setting,
	        wishProducts: state.wishList.wishProducts,
	        lang: state.lang,
	        currency: state.currency
	    };
	}, { delFromWishList: _wish_list.delFromWishList, showModal: _modal.showModal, hide: _modal.hide, setWishList: _wish_list.setWishList }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    (0, _inherits3.default)(WishList, _Component);
	
	    function WishList(props) {
	        (0, _classCallCheck3.default)(this, WishList);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (WishList.__proto__ || (0, _getPrototypeOf2.default)(WishList)).call(this, props));
	
	        _this.onDelete = function (id) {
	            var lang = _this.props.lang;
	
	
	            var modalContent = _react3.default.createElement(
	                'div',
	                { className: 'row no-margin' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    lang['store.wish_list.confirm_removal']
	                )
	            );
	
	            _this.props.showModal({
	                title: lang['store.wish_list.remove'],
	                content: modalContent,
	                titleSuccess: lang['store.common.yes'],
	                titleClose: lang['store.common.no'],
	                onSuccess: function onSuccess() {
	                    _this.props.delFromWishList(id);
	                    setTimeout(_this.props.setWishList(_LocalStorageProxy2.default.getItem('wishlist.common')), 50000);
	                },
	                modalType: 'del'
	            });
	        };
	
	        return _this;
	    }
	
	    (0, _createClass3.default)(WishList, [{
	        key: 'render',
	        value: function render() {
	            var View = _helpers.ThemeHelper.getViewForContainer('WishList');
	            var orderInOneClick = this.props.setting;
	            return _react3.default.createElement(View, {
	                products: this.props.wishProducts,
	                onDelete: this.onDelete,
	                orderInOneClick: orderInOneClick,
	                lang: this.props.lang,
	                currency: this.props.currency
	            });
	        }
	    }]);
	    return WishList;
	}(_react2.Component), _class2.propTypes = {
	    wishProducts: _react2.PropTypes.array,
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp)) || _class) || _class));
	
	exports.default = WishList;
	module.exports = exports['default'];

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp2;
	
	var _helpers = __webpack_require__(15);
	
	var _reactRouter = __webpack_require__(19);
	
	var _components2 = __webpack_require__(16);
	
	var _SHARE = __webpack_require__(93);
	
	__webpack_require__(1123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    WishListView: {
	        displayName: 'WishListView'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/containers/WishList/default/WishListView.jsx',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var WishListView = _wrapComponent('WishListView')((_temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(WishListView, _Component);
	
	    function WishListView() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, WishListView);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WishListView.__proto__ || (0, _getPrototypeOf2.default)(WishListView)).call.apply(_ref, [this].concat(args))), _this), _this.renderProduct = function (item) {
	            var currency = _this.props.currency;
	
	            var price = parseFloat(item.price);
	            var picture = (0, _helpers.checkPicture)(item.pictures);
	
	            var modifier_option_name = _react3.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-2 prod_desc' },
	                _react3.default.createElement('div', { className: 'title' })
	            );
	            if (item.modifier_option_id !== null && item.modifier_option_id !== undefined) {
	                modifier_option_name = _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2 prod_desc' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        item.modifier_option.name
	                    )
	                );
	            } else if (item.modifierName !== null && item.modifierName !== undefined) {
	                modifier_option_name = _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2 prod_desc' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        item.modifierName
	                    )
	                );
	            }
	            return _react3.default.createElement(
	                'div',
	                { className: 'row cart-item flying-to-cart-holder', style: { backgroundColor: '#fff', borderRadius: '7px' } },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2 text-center' },
	                    _react3.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/product/' + item.id, className: 'pointer' },
	                        _react3.default.createElement('img', { className: 'flying-to-cart-img', src: picture })
	                    ),
	                    _react3.default.createElement('a', { className: 'close-btn pointer visible-xs', onClick: function onClick(e) {
	                            e.preventDefault();
	                            _this.props.onDelete(item);
	                        } })
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        _react3.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/product/' + item.id },
	                            item.name
	                        )
	                    ),
	                    _react3.default.createElement(_SHARE.SwitherDescription, { description: item.description })
	                ),
	                modifier_option_name,
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-2' },
	                    _react3.default.createElement(
	                        'div',
	                        { className: 'price' },
	                        _react3.default.createElement(_components2.MoneyValue, {
	                            value: price,
	                            icon: _this.props.currency.icon,
	                            iconAfterValue: _this.props.currency.icon_after_value
	                        })
	                    )
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-4 text-center hidden-xs' },
	                    _react3.default.createElement(_components2.AddToBasket, { product: item, style: { marginRight: '3px', marginTop: '5px', marginBottom: '5px', width: '90%' }, count: 1 }),
	                    _react3.default.createElement('a', { className: 'close-btn pointer', style: { marginLeft: '5px' }, onClick: function onClick(e) {
	                            e.preventDefault();
	                            _this.props.onDelete(item);
	                        } })
	                ),
	                _react3.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 button_holder' },
	                    _react3.default.createElement(_components2.AddToBasket, { id: 'addto-cart', product: item, count: 1 })
	                )
	            );
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(WishListView, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                products = _props.products,
	                lang = _props.lang;
	
	
	            return _react3.default.createElement(
	                'section',
	                { className: 'user-profile' },
	                _react3.default.createElement(
	                    'div',
	                    { className: 'wishlist' },
	                    _react3.default.createElement(
	                        'h2',
	                        { className: 'section-title' },
	                        lang['store.wish_list.wish_list']
	                    ),
	                    products.length ? _react3.default.createElement(
	                        'div',
	                        null,
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'row no-margin cart-item hidden-xs wish_head' },
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2 text-center' },
	                                lang['store.cart.photo']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2' },
	                                lang['store.cart.title']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2' },
	                                lang['store.cart.modifiers']
	                            ),
	                            _react3.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-sm-2' },
	                                lang['store.cart.price']
	                            ),
	                            _react3.default.createElement('div', { className: 'col-xs-12 col-sm-4' })
	                        ),
	                        _react3.default.createElement(
	                            'div',
	                            { className: 'items-holder' },
	                            products.map(this.renderProduct)
	                        )
	                    ) : _react3.default.createElement(
	                        'div',
	                        { className: 'empty-block' },
	                        lang['store.wish_list.empty_wish_list']
	                    )
	                )
	            );
	        }
	    }]);
	    return WishListView;
	}(_react2.Component), _class.propTypes = {
	    lang: _react2.PropTypes.object,
	    currency: _react2.PropTypes.object
	}, _temp2));
	
	exports.default = WishListView;
	module.exports = exports['default'];

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WishList = undefined;
	
	var _WishList2 = __webpack_require__(1853);
	
	var _WishList3 = _interopRequireDefault(_WishList2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.WishList = _WishList3.default; /**
	                                        * Created by maximus on 16.12.16.
	                                        */

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(69);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _class, _temp;
	
	var _server = __webpack_require__(645);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _serializeJavascript = __webpack_require__(1569);
	
	var _serializeJavascript2 = _interopRequireDefault(_serializeJavascript);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _helpers = __webpack_require__(15);
	
	var _utils = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    Html: {
	        displayName: 'Html'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/helpers/Html.js',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var Html = _wrapComponent('Html')((_temp = _class = function (_Component) {
	    (0, _inherits3.default)(Html, _Component);
	
	    function Html() {
	        (0, _classCallCheck3.default)(this, Html);
	        return (0, _possibleConstructorReturn3.default)(this, (Html.__proto__ || (0, _getPrototypeOf2.default)(Html)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Html, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                assets = _props.assets,
	                component = _props.component,
	                store = _props.store,
	                color_id = _props.color_id,
	                beforeEndBody = _props.beforeEndBody,
	                beforeEndHead = _props.beforeEndHead,
	                afterBeginHead = _props.afterBeginHead,
	                afterBeginBody = _props.afterBeginBody;
	
	            var content = component ? _server2.default.renderToString(component) : '';
	            var head = _reactHelmet2.default.rewind();
	            var storeData = store.getState();
	
	            try {
	                var storeDataTest = (0, _serializeJavascript2.default)(store.getState());
	            } catch (e) {
	                storeData = {};
	                var storeDataForError = store.getState();
	                var item = void 0;
	                for (var key in storeDataForError) {
	                    try {
	                        if (key == 'modal') {
	                            continue;
	                        }
	                        item = (0, _serializeJavascript2.default)(storeDataForError[key]);
	                        storeData[key] = storeDataForError[key];
	                    } catch (e) {
	                        // Пробуем найти причину падения
	                        console.error('FAIL serialize JSON, KEY - ' + key);
	                    }
	                }
	            }
	
	            return _react3.default.createElement(
	                'html',
	                { lang: 'ru' },
	                _react3.default.createElement(
	                    'head',
	                    null,
	                    _react3.default.createElement('meta', { charSet: 'utf-8' }),
	                    typeof afterBeginHead === 'function' ? _react3.default.createElement('div', {
	                        dangerouslySetInnerHTML: { __html: typeof afterBeginHead === 'function' && afterBeginHead() } }) : '',
	                    head.base.toComponent(),
	                    head.title.toComponent(),
	                    head.meta.toComponent(),
	                    head.link.toComponent(),
	                    head.script.toComponent(),
	                    _react3.default.createElement('link', { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' }),
	                    _react3.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' }),
	                    _react3.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' }),
	                    _react3.default.createElement('link', { rel: 'icon', type: 'image/ico', href: '/favicon.ico' }),
	                    _react3.default.createElement('link', { rel: 'manifest', href: '/manifest.json' }),
	                    _react3.default.createElement('meta', { name: 'msapplication-TileColor', content: '#00aba9' }),
	                    _react3.default.createElement('meta', { name: 'msapplication-TileImage', content: '/mstile-144x144.png' }),
	                    _react3.default.createElement('meta', { name: 'theme-color', content: '#ffffff' }),
	                    _react3.default.createElement('meta', { name: 'msapplication-config', content: '/browserconfig.xml' }),
	                    _react3.default.createElement('meta', { name: 'viewport',
	                        content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no' }),
	                    _react3.default.createElement('link', { href: 'https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800', rel: 'stylesheet',
	                        type: 'text/css' }),
	                    (0, _keys2.default)(assets.styles).map(function (style, key) {
	                        return _react3.default.createElement('link', { href: assets.styles[style], key: key, media: 'screen, projection', rel: 'stylesheet',
	                            type: 'text/css', charSet: 'UTF-8' });
	                    }),
	                    (0, _keys2.default)(assets.styles).length === 0 ? _react3.default.createElement('style', { dangerouslySetInnerHTML: { __html: __webpack_require__(456) } }) : null,
	                    _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: typeof beforeEndHead === 'function' && beforeEndHead() } })
	                ),
	                _react3.default.createElement(
	                    'body',
	                    { className: (0, _utils.getClassColorByColorId)(color_id) },
	                    typeof afterBeginHead === 'function' ? _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: typeof afterBeginBody === 'function' && afterBeginBody() } }) : '',
	                    _react3.default.createElement('script', { src: 'https://forma.tinkoff.ru/static/onlineScript.js' }),
	                    _react3.default.createElement('script', { src: 'https://yastatic.net/es5-shims/0.0.2/es5-shims.min.js' }),
	                    _react3.default.createElement('script', { src: 'https://yastatic.net/share2/share.js' }),
	                    _react3.default.createElement('div', { id: 'content', className: 'u-full-height', dangerouslySetInnerHTML: { __html: content } }),
	                    _react3.default.createElement('script', { src: 'https://code.jquery.com/jquery-3.1.1.min.js' }),
	                    _react3.default.createElement('script', { src: '//ajax.googleapis.com/ajax/libs/jqueryui/1.11.2/jquery-ui.min.js' }),
	                    _react3.default.createElement('script', { dangerouslySetInnerHTML: { __html: 'window.__data=' + (0, _serializeJavascript2.default)(storeData) + ';' },
	                        charSet: 'UTF-8' }),
	                    _react3.default.createElement('script', { src: assets.javascript.main, charSet: 'UTF-8' }),
	                    this.props.googleCaptcha ? _react3.default.createElement('script', { src: this.props.googleCaptchaUrl }) : '',
	                    this.props.turnstileCaptcha ? _react3.default.createElement('script', { src: 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit' }) : '',
	                    _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: typeof beforeEndBody === 'function' && beforeEndBody() } })
	                )
	            );
	        }
	    }]);
	    return Html;
	}(_react2.Component), _class.propTypes = {
	    assets: _react2.PropTypes.object,
	    component: _react2.PropTypes.node,
	    store: _react2.PropTypes.object,
	    color_id: _react2.PropTypes.number
	}, _temp));
	
	exports.default = Html;
	module.exports = exports['default'];

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(6);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _redboxReact2 = __webpack_require__(8);
	
	var _redboxReact3 = _interopRequireDefault(_redboxReact2);
	
	var _react2 = __webpack_require__(1);
	
	var _react3 = _interopRequireDefault(_react2);
	
	var _reactTransformCatchErrors3 = __webpack_require__(7);
	
	var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);
	
	var _dec, _class;
	
	var _reactRedux = __webpack_require__(12);
	
	var _containers = __webpack_require__(763);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _components = {
	    NotFoundDecorator: {
	        displayName: 'NotFoundDecorator'
	    }
	};
	
	var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
	    filename: '/usr/local/ibonus/src/helpers/NotFoundDecorator/index.js',
	    components: _components,
	    locals: [],
	    imports: [_react3.default, _redboxReact3.default]
	});
	
	function _wrapComponent(id) {
	    return function (Component) {
	        return _reactTransformCatchErrors2(Component, id);
	    };
	}
	
	var NotFoundDecorator = _wrapComponent('NotFoundDecorator')((_dec = (0, _reactRedux.connect)(function (state) {
	    return { show_404: state.error.is_show_404, server_not_found: state.error.server_not_found };
	}), _dec(_class = function (_Component) {
	    (0, _inherits3.default)(NotFoundDecorator, _Component);
	
	    function NotFoundDecorator() {
	        (0, _classCallCheck3.default)(this, NotFoundDecorator);
	        return (0, _possibleConstructorReturn3.default)(this, (NotFoundDecorator.__proto__ || (0, _getPrototypeOf2.default)(NotFoundDecorator)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(NotFoundDecorator, [{
	        key: 'render',
	        value: function render() {
	            if (this.props.show_404) {
	                return _react3.default.createElement(_containers.NotFound, null);
	            } else if (this.props.server_not_found) {
	                return _react3.default.createElement(_containers.NotFoundServer, null);
	            }
	
	            return this.props.children;
	        }
	    }]);
	    return NotFoundDecorator;
	}(_react2.Component)) || _class));
	
	exports.default = NotFoundDecorator;
	module.exports = exports['default'];

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaymentStatus = exports.PaymentStatusConstants = undefined;
	
	var _PaymentStatusConstants2 = __webpack_require__(385);
	
	var _PaymentStatusConstants = _interopRequireWildcard(_PaymentStatusConstants2);
	
	var _PaymentStatus2 = __webpack_require__(163);
	
	var _PaymentStatus3 = _interopRequireDefault(_PaymentStatus2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.PaymentStatusConstants = _PaymentStatusConstants;
	exports.PaymentStatus = _PaymentStatus3.default;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ConfirmationEmailByUrlParamsProcessor = undefined;
	
	var _promise = __webpack_require__(58);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(5);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _class, _temp;
	
	var _user = __webpack_require__(115);
	
	var _auth = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmationEmailByUrlParamsProcessor = exports.ConfirmationEmailByUrlParamsProcessor = (_temp = _class = function () {
	    function ConfirmationEmailByUrlParamsProcessor(location, params, store) {
	        (0, _classCallCheck3.default)(this, ConfirmationEmailByUrlParamsProcessor);
	        this.confirmationKey = null;
	        this.orderId = null;
	
	        this.location = location;
	        this.store = store;
	        this.params = params;
	    }
	
	    (0, _createClass3.default)(ConfirmationEmailByUrlParamsProcessor, [{
	        key: 'tryToConfirm',
	        value: function tryToConfirm() {
	            var _this = this;
	
	            this.retriveParams();
	            if (this.confirmationKey === null || this.isEmailAlredyConfirmed()) {
	                return _promise2.default.resolve(true);
	            }
	            var state = this.store.getState();
	            if (!state.auth.user) {
	                return _promise2.default.resolve(false);
	            }
	            if (this.store && typeof this.store.dispatch === 'function') {
	                return this.store.dispatch((0, _user.confirmEMailBySignature)(this.orderId, this.confirmationKey)).then(function () {
	                    return _this.store.dispatch((0, _auth.load)());
	                }).then(function () {
	                    return _this.isEmailAlredyConfirmed();
	                });
	            }
	
	            return _promise2.default.resolve(false);
	        }
	    }, {
	        key: 'isEmailAlredyConfirmed',
	        value: function isEmailAlredyConfirmed() {
	            if (this.store && typeof this.store.getState === 'function') {
	                var state = this.store.getState();
	                if (state.auth && state.auth.user && state.auth.user.confirmed) {
	                    var confirmations = state.auth.user.confirmed;
	                    return !!confirmations.confirmed_email;
	                }
	            }
	            return false;
	        }
	    }, {
	        key: 'retriveParams',
	        value: function retriveParams() {
	            var keyInQuery = ConfirmationEmailByUrlParamsProcessor.CONFIRMATION_KEY_NAME_IN_URL;
	            var orderIdInParams = ConfirmationEmailByUrlParamsProcessor.CONFIRMATION_ORDER_ID_IN_URL;
	
	            if (this.location && this.location.query != null) {
	                if (Object.hasOwnProperty.call(this.location.query, keyInQuery)) {
	                    if (typeof (this.confirmationKey = this.location.query[keyInQuery]) === 'string') {
	                        if (!this.confirmationKey.length) {
	                            this.confirmationKey = null;
	                        }
	                    }
	                }
	            }
	
	            if (this.params && Object.hasOwnProperty.call(this.params, orderIdInParams)) {
	                this.orderId = this.params[orderIdInParams];
	            }
	        }
	    }]);
	    return ConfirmationEmailByUrlParamsProcessor;
	}(), _class.CONFIRMATION_KEY_NAME_IN_URL = 'confirm_signature', _class.CONFIRMATION_ORDER_ID_IN_URL = 'order_id', _temp);

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ThemeHelper = undefined;
	
	var _ThemeHelper2 = __webpack_require__(113);
	
	var _ThemeHelper3 = _interopRequireDefault(_ThemeHelper2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ThemeHelper = _ThemeHelper3.default;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.couponsSearch = couponsSearch;
	
	var _constants = __webpack_require__(18);
	
	function couponsSearch(token) {
	    var user_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    return {
	        types: [_constants.CouponsConstants.LOAD_COUPONS, _constants.CouponsConstants.LOAD_COUPONS_SUCCESS, _constants.CouponsConstants.LOAD_COUPONS_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getCouponsByToken(token, user_id);
	        }
	    };
	}

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getPipoOperations = getPipoOperations;
	exports.morePipoOperations = morePipoOperations;
	
	var _constants = __webpack_require__(18);
	
	/**
	 * Created by maximus on 07.02.17.
	 */
	
	function getPipoOperations(begDate, endDate) {
	    var id_account = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
	    var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	    var pageSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _constants.OperationsNumericConstants.OPERATIONS_PAGE_LIMIT;
	
	    return {
	        types: [_constants.OperationsConstants.OPERATION_LOAD, _constants.OperationsConstants.OPERATION_LOAD_SUCCESS, _constants.OperationsConstants.OPERATION_LOAD_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getPipoOperations(begDate, endDate, id_account, page, pageSize).then(function (result) {
	                return {
	                    data: result,
	                    begDate: begDate,
	                    endDate: endDate,
	                    page: page
	                };
	            });
	        }
	    };
	}
	
	function morePipoOperations(begDate, endDate) {
	    var id_account = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
	    var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	    var pageSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _constants.OperationsNumericConstants.OPERATIONS_PAGE_LIMIT;
	
	    return {
	        types: [_constants.OperationsConstants.MORE_LOAD, _constants.OperationsConstants.MORE_LOAD_SUCCESS, _constants.OperationsConstants.OPERATION_LOAD_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getPipoOperations(begDate, endDate, id_account, page, pageSize).then(function (result) {
	                return {
	                    data: result,
	                    begDate: begDate,
	                    endDate: endDate,
	                    page: page
	                };
	            });
	        }
	    };
	}

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setSetting = setSetting;
	exports.loadSettings = loadSettings;
	
	var _constants = __webpack_require__(18);
	
	function setSetting(params) {
	    return {
	        type: _constants.SettingConstants.SET_SETTING,
	        result: params
	    };
	}
	
	function loadSettings(domain) {
	    return {
	        types: [_constants.SettingConstants.LOAD_SETTINGS, _constants.SettingConstants.LOAD_SETTINGS_SUCCESS, _constants.SettingConstants.LOAD_SETTINGS_FAIL],
	        promise: function promise(client, iBonus) {
	            return iBonus.getDomainInfo(domain);
	        }
	    };
	}

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AddressConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddressConstants = exports.AddressConstants = (0, _keymirror2.default)({
	    ADDRESSES_LOAD: null,
	    ADDRESSES_LOAD_SUCCESS: null,
	    ADDRESSES_LOAD_FAIL: null,
	    ADDRESS_ADD: null,
	    ADDRESS_ADD_SUCCESS: null,
	    ADDRESS_ADD_FAIL: null,
	    ADDRESS_UPDATE: null,
	    ADDRESS_UPDATE_SUCCESS: null,
	    ADDRESS_UPDATE_FAIL: null,
	    ADDRESS_DELETE: null,
	    ADDRESS_DELETE_SUCCESS: null,
	    ADDRESS_DELETE_FAIL: null
	});

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AuthConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthConstants = exports.AuthConstants = (0, _keymirror2.default)({
	    AUTH_LOAD: null,
	    AUTH_LOAD_SUCCESS: null,
	    AUTH_LOAD_FAIL: null,
	    AUTH_LOAD_IN_SERVER: null,
	    LOGIN: null,
	    LOGIN_SUCCESS: null,
	    LOGIN_FAIL: null,
	    LOGOUT: null,
	    LOGOUT_SUCCESS: null,
	    LOGOUT_FAIL: null,
	    AUTH_RESET_ERROR: null,
	    AUTH_RESET: null,
	    REFRESH_LOGOUT_SUCCESS: null,
	    ONE_CLICK_SUCCESS: null,
	    ONE_CLICK_CONFIRM_ERROR: null
	});

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BasketConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BasketConstants = exports.BasketConstants = (0, _keymirror2.default)({
	    ADD_BASKET: null,
	    REMOVE_BASKET: null,
	    CHANGE_COUNT_PRODUCT_IN_BASKET: null,
	    CLEAR_BASKET: null,
	    CHANGE_BASKET: null,
	    ORDER_LOAD: null,
	    ORDER_LOAD_SUCCESS: null,
	    ORDER_LOAD_FAIL: null,
	    COPY_TO_BASKET: null,
	
	    SHARE_BASKET_LOAD: null,
	    SHARE_BASKET_SUCCESS: null,
	    SHARE_BASKET_FAIL: null,
	
	    GET_SHARE_BASKET_FAIL: null,
	    GET_SHARE_BASKET_SUCCESS: null,
	    GET_SHARE_BASKET_LOAD: null,
	
	    BASKET_RESET_SHARE_CODE: null,
	
	    BASKET_CHANGE_SHARE: null,
	
	    GET_ACTUAL_PRICES_FAIL: null,
	    GET_ACTUAL_PRICES_SUCCESS: null,
	    GET_ACTUAL_PRICES_LOAD: null,
	    ADD_COUPON_IN_BASKET: null,
	
	    POSTPONE_BASKET_LOAD: null,
	    POSTPONE_BASKET_SUCCESS: null,
	    POSTPONE_BASKET_FAIL: null,
	
	    GET_POSTPONE_BASKET_LOAD: null,
	    GET_POSTPONE_BASKET_SUCCESS: null,
	    GET_POSTPONE_BASKET_FAIL: null,
	
	    DELETE_POSTPONE_LOAD: null,
	    DELETE_POSTPONE_SUCCESS: null,
	    DELETE_POSTPONE_FAIL: null,
	
	    MERGE_POSTPONE_LOAD: null,
	    MERGE_POSTPONE_SUCCESS: null,
	    MERGE_POSTPONE_FAIL: null
	});

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CatalogNumericConstants = exports.CatalogConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogConstants = exports.CatalogConstants = (0, _keymirror2.default)({
	    LOAD_HAS_OFFERS_IN_ROOT: null,
	    LOAD_HAS_OFFERS_IN_ROOT_SUCCESS: null,
	    LOAD_HAS_OFFERS_IN_ROOT_FAIL: null,
	
	    LOAD: null,
	    LOAD_SUCCESS: null,
	    LOAD_FAIL: null,
	
	    LOAD_DETAIL: null,
	    LOAD_DETAIL_SUCCESS: null,
	    LOAD_DETAIL_FAIL: null,
	
	    LOAD_CATALOG: null,
	    LOAD_CATALOG_FAIL: null,
	    LOAD_CATALOG_SUCCESS: null,
	
	    LOAD_CATEGORIES: null,
	    LOAD_CATEGORIES_SUCCESS: null,
	    LOAD_CATEGORIES_FAIL: null,
	
	    LOAD_PRODUCT_BY_CATEGORIES: null,
	    LOAD_PRODUCT_BY_CATEGORIES_SUCCESS: null,
	    LOAD_PRODUCT_BY_CATEGORIES_FAIL: null,
	
	    LOAD_BY_CATEGORIES: null,
	    LOAD_BY_CATEGORIES_SUCCESS: null,
	    LOAD_BY_CATEGORIES_FAIL: null,
	
	    CATEGORY_RECOMENDED_LOAD: null,
	    CATEGORY_RECOMENDED_LOAD_SUCCESS: null,
	    CATEGORY_RECOMENDED_LOAD_FAIL: null,
	
	    SEARCH_PRODUCTS_LOAD: null,
	    SEARCH_PRODUCTS_LOAD_SUCCESS: null,
	    SEARCH_PRODUCTS_LOAD_FAIL: null,
	
	    SEARCH_PRODUCTS_RESET: null,
	    SET_SEARCH_CLOSE: null,
	
	    LOAD_LAST_CATALOG_UPDATE_DATE: null,
	    LOAD_LAST_CATALOG_UPDATE_DATE_SUCCESS: null,
	    LOAD_LAST_CATALOG_UPDATE_DATE_FAIL: null,
	
	    REFRESH_CATALOG_LOAD: null,
	    REFRESH_CATALOG_LOAD_SUCCESS: null,
	    REFRESH_CATALOG_LOAD_FAIL: null
	});
	
	var CatalogNumericConstants = exports.CatalogNumericConstants = {
	    CATEGORY_PAGE_LIMIT: 12,
	    MAX_LIMIT: 999999,
	    MAX_PAGE: 999999,
	    SEARCH_PAGE_LIMIT: 12
	};

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CouponsConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CouponsConstants = exports.CouponsConstants = (0, _keymirror2.default)({
	    LOAD_COUPONS: null,
	    LOAD_COUPONS_SUCCESS: null,
	    LOAD_COUPONS_FAIL: null
	});

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CurrencyConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CurrencyConstants = exports.CurrencyConstants = (0, _keymirror2.default)({
	    LOAD_DATA: null
	});

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.HeadInfoConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeadInfoConstants = exports.HeadInfoConstants = (0, _keymirror2.default)({
	    SHOW_SIDEMENU: null,
	    HIDE_SIDEMENU: null
	});

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 26.04.17.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LangConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LangConstants = exports.LangConstants = (0, _keymirror2.default)({
	  LOAD_DATA: null
	});

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalConstants = exports.ModalConstants = (0, _keymirror2.default)({
	    MODAL_SHOW: null,
	    MODAL_HIDE: null
	});

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OperationsNumericConstants = exports.OperationsConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OperationsConstants = exports.OperationsConstants = (0, _keymirror2.default)({
	    OPERATION_LOAD: null,
	    OPERATION_LOAD_SUCCESS: null,
	    OPERATION_LOAD_FAIL: null,
	    MORE_LOAD: null,
	    MORE_LOAD_SUCCESS: null
	});
	
	var OperationsNumericConstants = exports.OperationsNumericConstants = {
	    OPERATIONS_PAGE_LIMIT: 15
	};

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PageConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageConstants = exports.PageConstants = (0, _keymirror2.default)({
	    SET_PAGE_LIST: null,
	
	    PAGE_DETAIL_LOAD_REQUEST: null,
	    PAGE_DETAIL_LOAD_SUCCES: null,
	    PAGE_DETAIL_LOAD_FAIL: null
	});

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PassRecoveryConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PassRecoveryConstants = exports.PassRecoveryConstants = (0, _keymirror2.default)({
	    PASS_RECOVERY_FORM_REQUEST: null,
	    PASS_RECOVERY_FORM_SUCCESS: null,
	    PASS_RECOVERY_FORM_FAIL: null,
	
	    PASS_RECOVERY_CONFIRM_REQUEST: null,
	    PASS_RECOVERY_CONFIRM_SUCCESS: null,
	    PASS_RECOVERY_CONFIRM_FAIL: null,
	
	    PASS_RECOVERY_RESET_STEP: null,
	
	    PASS_RECOVERY_RESET_ERROR: null,
	
	    PASS_RECOVERY_STEP_1: null,
	    PASS_RECOVERY_STEP_2: null,
	    PASS_RECOVERY_STEP_3: null,
	
	    PASS_RECOVERY_VOICE_FORM_REQUEST: null,
	    PASS_RECOVERY_VOICE_FORM_SUCCESS: null,
	    PASS_RECOVERY_VOICE_FORM_FAIL: null,
	    PASS_RECOVERY_VOICE_RESET: null,
	
	    PASS_RECOVERY_SET_PHONE: null,
	    PASS_RECOVERY_SHOW_ERROR: null
	});

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PaymentConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentConstants = exports.PaymentConstants = (0, _keymirror2.default)({
	    SHOW: null,
	    SHOW_SUCCESS: null,
	    SHOW_FAIL: null,
	
	    PAY_INNER_PIPO_REQUEST: null,
	    PAY_INNER_PIPO_SUCCESS: null,
	    PAY_INNER_PIPO_FAIL: null,
	
	    CHECK_CODE_SEND_INNER_PIPO_REQUEST: null,
	    CHECK_CODE_SEND_INNER_PIPO_SUCCESS: null,
	    CHECK_CODE_SEND_INNER_PIPO_FAIL: null,
	
	    PAY_INNER_PIPO_RESET: null,
	
	    PIPO_PROCESS_INPUT_REQUEST: null,
	    PIPO_PROCESS_INPUT_SUCCESS: null,
	    PIPO_PROCESS_INPUT_FAIL: null,
	    PIPO_PROCESS_INPUT_RESET: null,
	
	    SET_CUSTOM_PAYMENT: null,
	    RESET_CUSTOM_PAYMENT: null,
	
	    REPAYMENT_ORDER_REQUEST: null,
	    REPAYMENT_ORDER_SUCCESS: null,
	    REPAYMENT_ORDER_FAIL: null,
	
	    PIPO_PAY_PARAMS_REQUEST: null,
	    PIPO_PAY_PARAMS_SUCCESS: null,
	    PIPO_PAY_PARAMS_FAIL: null
	});

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OrderDetail = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderDetail = exports.OrderDetail = (0, _keymirror2.default)({
	    PERSONAL_ORDER_DETAIL_LOAD: null,
	    PERSONAL_ORDER_DETAIL_SUCCESS: null,
	    PERSONAL_ORDER_DETAIL_FAIL: null,
	    SET_PAYMENT_ID: null,
	    LOAD_PAGE: null
	});

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OrderNumericConstants = exports.OrderList = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderList = exports.OrderList = (0, _keymirror2.default)({
	    PERSONAL_ORDER_LIST_LOAD: null,
	    PERSONAL_ORDER_LIST_SUCCESS: null,
	    PERSONAL_ORDER_LIST_FAIL: null,
	
	    ORDER_SETTING_SUCCESS: null,
	    ORDER_SETTING_SEND: null,
	    ORDER_SETTING_FAIL: null,
	
	    ORDER_SET_FAIL: null
	});
	
	var OrderNumericConstants = exports.OrderNumericConstants = {
	    ORDERS_PAGE_LIMIT: 12
	};

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RegistrationConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistrationConstants = exports.RegistrationConstants = (0, _keymirror2.default)({
	    REGISTRATION_FORM_REQUEST: null,
	    REGISTRATION_FORM_SUCCESS: null,
	    REGISTRATION_FORM_FAIL: null,
	
	    REGISTRATION_CONFIRM_REQUEST: null,
	    REGISTRATION_CONFIRM_SUCCESS: null,
	    REGISTRATION_CONFIRM_FAIL: null,
	
	    REGISTRATION_RESET_STEP: null,
	
	    REGISTRATION_VOICE_FORM_REQUEST: null,
	    REGISTRATION_VOICE_FORM_SUCCESS: null,
	    REGISTRATION_VOICE_FORM_FAIL: null,
	    REGISTRATION_VOICE_RESET: null,
	
	    REGISTRATION_RESET_ERROR: null
	});

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SettingConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingConstants = exports.SettingConstants = (0, _keymirror2.default)({
	    SET_SETTING: null,
	
	    LOAD_SETTINGS: null,
	    LOAD_SETTINGS_SUCCESS: null,
	    LOAD_SETTINGS_FAIL: null
	});

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TranslatePipoConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TranslatePipoConstants = exports.TranslatePipoConstants = (0, _keymirror2.default)({
	    TRANSLATE_PIPO_REQUEST: null,
	    TRANSLATE_PIPO_SUCCESS: null,
	    TRANSLATE_PIPO_FAIL: null
	});

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UserMenuItems = exports.UserConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserConstants = exports.UserConstants = (0, _keymirror2.default)({
	    USER_CHANGE: null,
	    USER_CHANGE_SUCCESS: null,
	    USER_CHANGE_FAIL: null,
	
	    USER_CHANGE_MAIL: null,
	    USER_CHANGE_MAIL_SUCCESS: null,
	    USER_CHANGE_MAIL_FAIL: null,
	
	    USER_CHANGE_MAIL_CODE: null,
	    USER_CHANGE_MAIL_CODE_SUCCESS: null,
	    USER_CHANGE_MAIL_CODE_FAIL: null,
	
	    USER_CHANGE_PHONE: null,
	    USER_CHANGE_PHONE_SUCCESS: null,
	    USER_CHANGE_PHONE_FAIL: null,
	
	    USER_CHANGE_PHONE_CODE: null,
	    USER_CHANGE_PHONE_CODE_SUCCESS: null,
	    USER_CHANGE_PHONE_CODE_FAIL: null,
	
	    USER_CHANGE_INN: null,
	    USER_CHANGE_INN_SUCCESS: null,
	    USER_CHANGE_INN_FAIL: null,
	
	    USER_CHANGE_UL_NAME: null,
	    USER_CHANGE_UL_NAME_SUCCESS: null,
	    USER_CHANGE_UL_NAME_FAIL: null,
	
	    USER_CONFIRM_MAIL: null,
	    USER_CONFIRM_MAIL_SUCCESS: null,
	    USER_CONFIRM_MAIL_FAIL: null,
	
	    USER_CONFIRM_MAIL_CODE: null,
	    USER_CONFIRM_MAIL_CODE_SUCCESS: null,
	    USER_CONFIRM_MAIL_CODE_FAIL: null,
	
	    USER_CONFIRM_PHONE: null,
	    USER_CONFIRM_PHONE_SUCCESS: null,
	    USER_CONFIRM_PHONE_FAIL: null,
	
	    USER_CONFIRM_PHONE_CODE: null,
	    USER_CONFIRM_PHONE_CODE_SUCCESS: null,
	    USER_CONFIRM_PHONE_CODE_FAIL: null,
	
	    USER_RESET_ERROR: null,
	
	    USER_CHANGE_PASSWORD: null,
	    USER_CHANGE_PASSWORD_SUCCESS: null,
	    USER_CHANGE_PASSWORD_FAIL: null,
	
	    USER_CONFIRM_MAIL_BY_SIGNATURE: null,
	    USER_CONFIRM_MAIL_BY_SIGNATURE_SUCCESS: null,
	    USER_CONFIRM_MAIL_BY_SIGNATURE_FAIL: null,
	
	    USER_ADD_ADDRESS: null,
	    USER_ADD_ADDRESS_SUCCESS: null,
	    USER_ADD_ADDRESS_FAIL: null
	});
	
	var UserMenuItems = exports.UserMenuItems = [{ id: 1, name: 'Личный кабинет', link: '/personal/profile', showNotification: true, lang_mark: 'store.auth_header.user_menu_items.profile' }, { id: 2, name: 'Список заказов', link: '/personal/order-list', lang_mark: 'store.auth_header.user_menu_items.order_list' }, { id: 7, name: 'Адреса', link: '/personal/addresses', lang_mark: 'store.auth_header.user_menu_items.addresses' }, { id: 3, name: 'Выписка по счёту', link: '/personal/operations', lang_mark: 'store.auth_header.user_menu_items.operations' }, { id: 4, name: 'Корзина', link: '/personal/basket', lang_mark: 'store.auth_header.user_menu_items.cart' }, { id: 5, name: 'Избранное', link: '/personal/wishlist', lang_mark: 'store.auth_header.user_menu_items.favorites' }, { id: 6, name: 'Выйти', link: '', method: 'logout', lang_mark: 'store.auth_header.user_menu_items.logout' }];

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.VoiceCodeConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VoiceCodeConstants = exports.VoiceCodeConstants = (0, _keymirror2.default)({
	
	    VOICE_CODE_FORM_REQUEST: null,
	    VOICE_CODE_FORM_SUCCESS: null,
	    VOICE_CODE_FORM_FAIL: null,
	    VOICE_CODE_FORM_RESET: null,
	    SET_TIMER: null
	});

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WishConstants = undefined;
	
	var _keymirror = __webpack_require__(36);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WishConstants = exports.WishConstants = (0, _keymirror2.default)({
	    ADD_TO_WISHLIST: null,
	    DEL_FROM_WISHLIST: null,
	    COPY_TO_WISHLIST: null,
	    COPY_TO_WISHLIST_AUTHUSER: null,
	    UPDATE_PRODUCT_FOR_WISHLIST: null,
	    GET_ACTUAL_PRICES_FAIL_WISHLIST: null,
	    GET_ACTUAL_PRICES_SUCCESS_WISHLIST: null,
	    GET_ACTUAL_PRICES_LOAD_WISHLIST: null,
	    SET_WISHLIST: null,
	    SET_WISHLIST_FAIL: null,
	    SET_WISHLIST_SUCCESS: null
	});

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = createStore;
	
	var _redux = __webpack_require__(381);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _clientMiddleware = __webpack_require__(1887);
	
	var _clientMiddleware2 = _interopRequireDefault(_clientMiddleware);
	
	var _userAuthMiddleware = __webpack_require__(1892);
	
	var _userAuthMiddleware2 = _interopRequireDefault(_userAuthMiddleware);
	
	var _errorMiddleware = __webpack_require__(1888);
	
	var _errorMiddleware2 = _interopRequireDefault(_errorMiddleware);
	
	var _filterMiddleware = __webpack_require__(1889);
	
	var _filterMiddleware2 = _interopRequireDefault(_filterMiddleware);
	
	var _timerMiddleware = __webpack_require__(1891);
	
	var _timerMiddleware2 = _interopRequireDefault(_timerMiddleware);
	
	var _catalogMiddleware = __webpack_require__(1886);
	
	var _catalogMiddleware2 = _interopRequireDefault(_catalogMiddleware);
	
	var _shopMiddleware = __webpack_require__(1890);
	
	var _shopMiddleware2 = _interopRequireDefault(_shopMiddleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createStore(history, client, ibonus, data) {
	    // Sync dispatched route actions to the history
	    var reduxRouterMiddleware = (0, _reactRouterRedux.routerMiddleware)(history);
	
	    var middleware = [(0, _clientMiddleware2.default)(client, ibonus), (0, _errorMiddleware2.default)(), (0, _timerMiddleware2.default)(), (0, _userAuthMiddleware2.default)(ibonus), (0, _filterMiddleware2.default)(ibonus), (0, _catalogMiddleware2.default)(ibonus), (0, _shopMiddleware2.default)(client, ibonus), reduxRouterMiddleware];
	
	    var finalCreateStore = void 0;
	    if (false) {
	        var _require = require('redux-devtools'),
	            persistState = _require.persistState;
	
	        var DevTools = require('../containers/DevTools/DevTools');
	        finalCreateStore = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(), persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)))(_redux.createStore);
	    } else {
	        finalCreateStore = _redux.applyMiddleware.apply(undefined, middleware)(_redux.createStore);
	    }
	
	    var reducer = __webpack_require__(1893);
	    var store = finalCreateStore(reducer, data);
	
	    if (false) {
	        module.hot.accept('./reducer', function () {
	            store.replaceReducer(require('./reducer'));
	        });
	    }
	
	    return store;
	}
	module.exports = exports['default'];

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = catalogMiddleware;
	
	var _constants = __webpack_require__(18);
	
	var _catalog = __webpack_require__(67);
	
	var _reactSAlert = __webpack_require__(41);
	
	var _reactSAlert2 = _interopRequireDefault(_reactSAlert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function catalogMiddleware() {
	    return function (_ref) {
	        var dispatch = _ref.dispatch,
	            getState = _ref.getState;
	
	        return function (next) {
	            return function (action) {
	                switch (action.type) {
	                    case _constants.CatalogConstants.LOAD_LAST_CATALOG_UPDATE_DATE_SUCCESS:
	                        next(action);
	                        if (getState().catalog.hasUpdates) {
	                            _reactSAlert2.default.info(getState().lang['notify.categories.updatingCatalog'], {
	                                position: 'top-right',
	                                effect: 'slide',
	                                timeout: 2000
	                            });
	                        }
	                        return;
	                    default:
	                        break;
	                }
	
	                return next(action);
	            };
	        };
	    };
	}
	module.exports = exports['default'];

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(267);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(13);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = clientMiddleware;
	
	var _utils = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function clientMiddleware(client, ibonus) {
	    return function (_ref) {
	        var dispatch = _ref.dispatch,
	            getState = _ref.getState;
	
	        var _getState = getState(),
	            lang = _getState.lang;
	
	        return function (next) {
	            return function (action) {
	                if (typeof action === 'function') {
	                    return action(dispatch, getState);
	                }
	
	                var promise = action.promise,
	                    types = action.types,
	                    preloader = action.preloader,
	                    rest = (0, _objectWithoutProperties3.default)(action, ['promise', 'types', 'preloader']); // eslint-disable-line no-redeclare
	
	                if (!promise) {
	                    return next(action);
	                }
	
	                var show_preloader = false,
	                    hide_preloader = false;
	
	                if (preloader) {
	                    show_preloader = true;
	                    hide_preloader = true;
	                }
	
	                var _types = (0, _slicedToArray3.default)(types, 3),
	                    REQUEST = _types[0],
	                    SUCCESS = _types[1],
	                    FAILURE = _types[2];
	
	                next((0, _extends3.default)({}, rest, { show_preloader: show_preloader, type: REQUEST }));
	
	                var actionPromise = promise(client, ibonus, { dispatch: dispatch, getState: getState });
	                actionPromise.then(function (result) {
	                    next((0, _extends3.default)({}, rest, { result: result, hide_preloader: hide_preloader, show_error: false, type: SUCCESS }));
	                }, function (err) {
	                    var error = (0, _extends3.default)({}, err);
	
	                    if (!error.message) {
	                        error.message = (0, _utils.replaceCharToArrayIndex)(lang[error.title], error.dataError);
	                    }
	                    next((0, _extends3.default)({}, rest, { error: error, hide_preloader: hide_preloader, show_error: true, type: FAILURE }));
	                }).catch(function (err) {
	                    console.error('MIDDLEWARE ERROR:', err);
	
	                    var error = (0, _extends3.default)({}, err);
	
	                    //На тесте приходит message в ошибке, а на бою нет
	                    if (!error.message) {
	                        error.message = (0, _utils.replaceCharToArrayIndex)(lang[error.title], error.dataError);
	                    }
	
	                    next((0, _extends3.default)({}, rest, { error: error, hide_preloader: hide_preloader, show_error: true, type: FAILURE }));
	                });
	
	                return actionPromise;
	            };
	        };
	    };
	}
	module.exports = exports['default'];

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = errorMiddleware;
	
	var _utils = __webpack_require__(31);
	
	var _constants = __webpack_require__(18);
	
	var _auth = __webpack_require__(53);
	
	var _errors = __webpack_require__(744);
	
	function errorMiddleware() {
	    return function (_ref) {
	        var dispatch = _ref.dispatch,
	            getState = _ref.getState;
	
	        var _getState = getState(),
	            lang = _getState.lang;
	
	        return function (next) {
	            return function (action) {
	                if (action.type === 'error') {
	                    return next(action);
	                } else if (action.show_error) {
	
	                    if (action.hasOwnProperty('show_404') && action.show_404 === true) {
	                        return next(action);
	                    }
	
	                    var _ref2 = action.error || {},
	                        code = _ref2.code;
	
	                    if (Number(code) !== 0) {
	                        code = parseInt(code, 10) || null;
	                    } else {
	                        code = Number(code);
	                    }
	
	                    // это решение принудительное, так как ошибка авторизации моежт быть в любом из заданных пунктов.
	                    if (code === _errors.ERROR_CODE_INVALID_ACCESS_TOKEN) {
	                        action.error.message = lang['store.error_middleware.auth_error'];
	                    }
	
	                    // Подавляем ошибку refresh_token.
	                    if (code === _errors.ERROR_CODE_INVALID_REFRESH_TOKEN) {
	                        action.show_error = false; // подавляем ошибку
	                        action.server_not_found = false;
	                        dispatch((0, _auth.refreshLogout)());
	                        return next(action);
	                    }
	
	                    //Подавление ошибки для неправильной категории или товаре
	                    if (action.error.code === 139) {
	                        //error.title === 'humanFriendlyException.doesNotExistCategory'
	                        action.show_error = false;
	                        return next(action);
	                    }
	
	                    //Подавление ошибки при наличии алкоголя в корзине
	                    if (action.error.code === 136) {
	                        //error.title === 'error.orderExciseMarkBarcodeIsRequired'
	                        action.show_error = false;
	                        return next(action);
	                    }
	
	                    switch (action.type) {
	                        case _constants.AuthConstants.LOGIN_FAIL:
	                        case _constants.PaymentConstants.PAY_INNER_PIPO_FAIL:
	                        case _constants.RegistrationConstants.REGISTRATION_CONFIRM_FAIL:
	                        case _constants.RegistrationConstants.REGISTRATION_FORM_FAIL:
	                        case _constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_FAIL:
	                        case _constants.PassRecoveryConstants.PASS_RECOVERY_FORM_FAIL:
	                        case _constants.UserConstants.USER_CHANGE_PASSWORD_FAIL:
	                        case _constants.UserConstants.USER_CHANGE_PHONE_CODE_FAIL:
	                        case _constants.UserConstants.USER_CHANGE_MAIL_CODE_FAIL:
	                        case _constants.UserConstants.USER_CONFIRM_MAIL_CODE_FAIL:
	                        case _constants.UserConstants.USER_CONFIRM_PHONE_CODE_FAIL:
	                        case _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_FORM_FAIL:
	                        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_FAIL:
	                        case _constants.RegistrationConstants.REGISTRATION_VOICE_FORM_FAIL:
	                        case _constants.PaymentConstants.CHECK_CODE_SEND_INNER_PIPO_FAIL:
	                        case _constants.Personal.OrderList.ORDER_SETTING_FAIL: //подавление ошибки при редиректе в фаерфоксе
	                        case _constants.SliderConstants.SLIDER_LOAD_FAIL:
	                            if (!action.error.message) {
	                                action.error.message = (0, _utils.replaceCharToArrayIndex)(lang[action.error.title], action.error.dataError);
	                            }
	
	                            action.show_error = false; // подавляем ошибку, ошибка будет выводится в самом окне авторизации или регистрации
	                            return next(action);
	                    }
	
	                    switch (code) {
	                        case null:
	                            action.server_not_found = true;
	                            action.show_error = false;
	                            break;
	                        case _errors.ERROR_CODE_CONNECTION_CLOSE_UBNORMAL:
	                            action.server_not_found = false;
	                            action.show_error = false;
	                            break;
	                        case _errors.ERROR_CODE_INVALID_ACCESS_TOKEN:
	                            next((0, _auth.resetAuth)()); // сбрасываем пользователя
	                            action.error.message = (0, _utils.replaceCharToArrayIndex)(lang['store.error_middleware.auth_error']);
	                            break;
	                        case _errors.ERROR_CODE_TARIFF:
	                        case _errors.ERROR_CODE_GENERAL_ERROR:
	                            action.error.message = (0, _utils.replaceCharToArrayIndex)(lang['store.error_middleware.general_error']);
	                            break;
	                        case _errors.ERROR_FEW_PRODUCTS:
	                            action.show_error = false;
	                            break;
	                        case _errors.ERROR_UNKNOWN_ERROR:
	                            break;
	                        default:
	                            action.error.message = lang['store.error_middleware.error'] + ': ' + lang[action.error.title];
	                            break;
	                    }
	                }
	
	                return next(action);
	            };
	        };
	    };
	}
	module.exports = exports['default'];

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = filterMiddleware;
	
	var _constants = __webpack_require__(18);
	
	function filterPaymentByIsMobileField(action) {
	    if (action.result && action.result.services) {
	        var services = action.result.services || [];
	        services = services.filter(function (item) {
	            return item.hasOwnProperty('is_mobile') && item.is_mobile === false || !item.hasOwnProperty('is_mobile');
	        });
	
	        action.result.services = services;
	    }
	}
	
	function filterPaymentByEnable(action) {
	    if (action.result && action.result.services) {
	        var services = action.result.services || [];
	        services = services.filter(function (item) {
	            return item.enabled && !item.disabled && item.settings && item.settings.enable;
	        });
	
	        action.result.services = services;
	    }
	}
	
	var filterWords = ['pay.alfa_label', 'pay.mail_label', 'pay.your_number', 'pay.required', 'pay.enter_phone_number', 'pay.enter_phone_number_qiwi', 'services.title', 'pay.bill', 'common.print', 'paymentin.cyberplat.maintext', 'paymentin.bill_number', 'paymentin.your_phone', 'paymentin.sum_to_pay', 'paymentin.back_to_shop', 'paymentin.back_to_profile', 'paymentin.cyberplat.maintext', 'events.account', 'paymentin.cyberplat.purpose', 'services.alfa.check.instruction', 'services.alfa.connect_error', 'services.alfa.invoice_in_alfa', 'services.alfa.login_error', 'services.alfa.unknown_error', 'services.ruru.invoice', 'services.ruru.sum_to_pay'];
	
	function filterMiddleware(ibonus) {
	    return function (_ref) {
	        var dispatch = _ref.dispatch,
	            getState = _ref.getState;
	
	        return function (next) {
	            return function (action) {
	                if (action.type) {
	                    switch (action.type) {
	                        case _constants.PaymentConstants.SHOW_SUCCESS:
	                            filterPaymentByIsMobileField(action);
	                            filterPaymentByEnable(action);
	                            break;
	                    }
	                }
	                return next(action);
	            };
	        };
	    };
	}
	module.exports = exports['default'];

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = shopMiddleware;
	
	var _constants = __webpack_require__(18);
	
	var _page = __webpack_require__(766);
	
	function shopMiddleware() {
	    return function (_ref) {
	        var dispatch = _ref.dispatch,
	            getState = _ref.getState;
	
	        return function (next) {
	            return function (action) {
	                switch (action.type) {
	                    case _constants.SettingConstants.SET_SETTING:
	                    case _constants.SettingConstants.LOAD_SETTINGS_SUCCESS:
	                        next(action);
	                        dispatch((0, _page.setSettingPage)(action.result.onlineShopPages));
	                        break;
	                    default:
	                        break;
	                }
	
	                return next(action);
	            };
	        };
	    };
	}
	module.exports = exports['default'];

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	exports.default = timerMiddleware;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function timerMiddleware() {
	    return function (_ref) {
	        var dispatch = _ref.dispatch,
	            getState = _ref.getState;
	
	        return function (next) {
	            return function (action) {
	                if (action.hasOwnProperty('timerState') && action.timerState == 'start') {
	                    var timer = new Timer(next, action);
	                    timer.start(action.time);
	                }
	
	                return next(action);
	            };
	        };
	    };
	}
	
	var Timer = function Timer(next, action) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, Timer);
	
	    this.start = function (t) {
	        _this.time = t;
	        setTimeout(_this.change, 1000);
	    };
	
	    this.change = function () {
	        _this.time--;
	        if (_this.time > 0) setTimeout(_this.change, 1000);
	        return _this.next((0, _extends3.default)({}, _this.action, { time: _this.time, timerState: 'change' }));
	    };
	
	    this.next = next;
	    this.action = action;
	    this.time = 0;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = userAuthMiddleware;
	
	var _constants = __webpack_require__(18);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function userAuthMiddleware(ibonus) {
	    return function (_ref) {
	        var dispatch = _ref.dispatch,
	            getState = _ref.getState;
	        return function (next) {
	            return function (action) {
	                if (action.type) {
	                    switch (action.type) {
	                        // при успешном восстановлении пароля, сохраним токены в localStorage
	                        case _constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_SUCCESS:
	                            {
	                                if (action.result && action.result.access_token && action.result.refresh_token && (true)) {
	                                    _LocalStorageProxy2.default.setItem('ibonus.access_token', action.result.access_token);
	                                    _LocalStorageProxy2.default.setItem('ibonus.refresh_token', action.result.refresh_token);
	                                }
	
	                                break;
	                            }
	
	                        case _constants.AuthConstants.LOGIN_SUCCESS:
	                            {
	                                if (action.result && action.result.access_token && action.result.refresh_token && (true)) {
	                                    _LocalStorageProxy2.default.setItem('ibonus.access_token', action.result.access_token);
	                                    _LocalStorageProxy2.default.setItem('ibonus.refresh_token', action.result.refresh_token);
	                                    var wishList = _LocalStorageProxy2.default.getItem('wishlist.common');
	                                    ibonus.getWishList(wishList).then(function (result) {
	                                        _LocalStorageProxy2.default.setItem('wishlist.common', result);
	                                    });
	                                    return ibonus.getUserData(action.result.access_token).then(function (result) {
	                                        return next({ result: result, type: _constants.AuthConstants.LOGIN_SUCCESS });
	                                    }, function (error) {
	                                        return next({ error: error, type: _constants.AuthConstants.LOGIN_FAIL });
	                                    }).catch(function (error) {
	                                        next({ error: error, type: _constants.AuthConstants.LOGIN_FAIL });
	                                    });
	                                }
	
	                                break;
	                            }
	
	                        case _constants.AuthConstants.LOGOUT_SUCCESS:
	                            {
	                                _LocalStorageProxy2.default.removeItem('ibonus.access_token');
	                                _LocalStorageProxy2.default.removeItem('ibonus.refresh_token');
	                                break;
	                            }
	                    }
	                }
	                return next(action);
	            };
	        };
	    };
	}
	module.exports = exports['default'];

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(381);
	
	var _reactRouterRedux = __webpack_require__(35);
	
	var _reduxAsyncConnect = __webpack_require__(43);
	
	var _reducers = __webpack_require__(1902);
	
	var Reducers = _interopRequireWildcard(_reducers);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)((0, _extends3.default)({
	    routing: _reactRouterRedux.routerReducer,
	    reduxAsyncConnect: _reduxAsyncConnect.reducer
	}, Reducers));
	module.exports = exports['default'];

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(103);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = address;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    list: []
	};
	
	function address() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _constants.AddressConstants.ADDRESSES_LOAD_SUCCESS:
	            {
	                return (0, _extends3.default)({}, state, {
	                    list: action.result
	                });
	            }
	        case _constants.AddressConstants.ADDRESS_ADD_SUCCESS:
	            {
	                return (0, _extends3.default)({}, state, {
	                    list: [action.result].concat((0, _toConsumableArray3.default)(state.list))
	                });
	            }
	        case _constants.AddressConstants.ADDRESS_UPDATE_SUCCESS:
	            {
	                var newList = [].concat((0, _toConsumableArray3.default)(state.list));
	                var idx = newList.findIndex(function (address) {
	                    return address.id === action.payload.id;
	                });
	                newList[idx].address = action.payload.address;
	                newList[idx].is_default = action.payload.is_default;
	                if (newList[idx].is_default) {
	                    var prevDefaultItemIdx = newList.findIndex(function (address) {
	                        return address.is_default && address.id !== action.payload.id;
	                    });
	                    if (prevDefaultItemIdx >= 0) newList[prevDefaultItemIdx].is_default = false;
	                }
	                return (0, _extends3.default)({}, state, {
	                    list: newList
	                });
	            }
	        case _constants.AddressConstants.ADDRESS_DELETE_SUCCESS:
	            {
	                var _newList = [].concat((0, _toConsumableArray3.default)(state.list));
	                var _idx = _newList.findIndex(function (address) {
	                    return address.id === action.payload;
	                });
	                _newList.splice(_idx, 1);
	                return (0, _extends3.default)({}, state, { list: _newList });
	            }
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = auth;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    loadedInServer: false,
	    loaded: null,
	    loading: false,
	    loggingIn: false,
	    user: null
	};
	
	function auth() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.AuthConstants.AUTH_LOAD:
	            return (0, _extends3.default)({}, state, {
	                loading: true
	            });
	        case _constants.AuthConstants.AUTH_LOAD_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                loading: false,
	                loaded: true,
	                user: action.result
	            });
	        case _constants.AuthConstants.AUTH_LOAD_FAIL:
	            return (0, _extends3.default)({}, state, {
	                loading: false,
	                loaded: false,
	                error: action.error
	            });
	        case _constants.AuthConstants.AUTH_LOAD_IN_SERVER:
	            return (0, _extends3.default)({}, state, {
	                loadedInServer: true
	            });
	        case _constants.AuthConstants.LOGIN:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                loggingIn: true,
	                loginError: null
	            });
	        case _constants.AuthConstants.LOGIN_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                loggingIn: false,
	                user: action.result,
	                loginError: null
	            });
	        case _constants.AuthConstants.ONE_CLICK_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false
	            });
	        case _constants.AuthConstants.ONE_CLICK_CONFIRM_ERROR:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                loggingIn: false,
	                user: null,
	                loginError: action.error.title,
	                loginErrorCode: action.error.title
	            });
	        case _constants.AuthConstants.LOGIN_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                loggingIn: false,
	                user: null,
	                loginError: action.error.title,
	                loginErrorCode: action.error.title
	            });
	        case _constants.AuthConstants.LOGOUT:
	            return (0, _extends3.default)({}, state, {
	                loggingOut: true
	            });
	        case _constants.AuthConstants.LOGOUT_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                loggingOut: false,
	                user: null
	            });
	        case _constants.AuthConstants.REFRESH_LOGOUT_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                loggingOut: false,
	                user: null
	            });
	        case _constants.AuthConstants.LOGOUT_FAIL:
	            return (0, _extends3.default)({}, state, {
	                loggingOut: false,
	                logoutError: action.error.title
	            });
	        case _constants.AuthConstants.AUTH_RESET_ERROR:
	            return (0, _extends3.default)({}, state, {
	                logoutError: null,
	                loginError: null,
	                loginErrorCode: null
	            });
	
	        case _constants.AuthConstants.AUTH_RESET:
	            return (0, _extends3.default)({}, state, {
	                loaded: null,
	                user: null,
	                loadedInServer: false
	            });
	
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(103);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(68);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.default = basket;
	
	var _constants = __webpack_require__(18);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    items: [],
	    dataError: [],
	    preload: false,
	    is_coped_items: false,
	    isServerLoad: false,
	    sharePreload: false,
	    actualPricesPreload: false,
	    shareCode: '',
	    showShare: false
	};
	
	function basket() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    var arrayItems = [];
	
	    switch (action.type) {
	        case _constants.BasketConstants.ADD_BASKET:
	            var items = state.items.slice(),
	                flagPush = true;
	            if (action.product.type_id !== 5 && action.product.basket_number === undefined && action.product.custom_fields == null) {
	                for (var i = 0; i < items.length; i++) {
	                    if (items[i].id === action.product.id && items[i].modifier_option_id === action.product.modifier_option_id) {
	                        items[i].count += action.product.count;
	                        flagPush = false;
	                        break;
	                    }
	                }
	            } else if (action.product.basket_number !== undefined) {
	                flagPush = true;
	            } else if (action.product.custom_fields != null && action.product.custom_fields.length > 0) {
	                flagPush = true;
	            } else {
	                var key = null;
	                for (var _i = 0; _i < items.length; _i++) {
	                    if (items[_i].id === action.product.id && items[_i].modifier_option_name === action.product.modifier_option_name) {
	                        key = _i;
	                        for (var j = 0; j < items[_i].nested_offer.length; j++) {
	                            if (items[_i].nested_offer[j].childOffer.type_id === 5) {
	                                for (var k = 0; k < items[_i].nested_offer[j].childOffer.nestedOffers.length; k++) {
	                                    if (items[_i].nested_offer[j].childOffer.nestedOffers[k].quantity !== action.product.nested_offer[j].childOffer.nestedOffers[k].quantity) {
	                                        key = null;
	                                    }
	                                }
	                                if (items[_i].nested_offer[j].modifierName !== action.product.nested_offer[j].modifierName) {
	                                    key = null;
	                                }
	                            } else if (items[_i].nested_offer[j].quantity !== action.product.nested_offer[j].quantity) {
	                                key = null;
	                            }
	                        }
	                        if (key !== null) {
	                            items[_i].count += action.product.count;
	                            flagPush = false;
	                            break;
	                        }
	                    }
	                }
	            }
	
	            flagPush == true && items.push(action.product);
	
	            _LocalStorageProxy2.default.setItem('basket.common', (0, _stringify2.default)(items));
	
	            return (0, _extends3.default)({}, state, {
	                shareCode: '',
	                showShare: false,
	                items: items
	            });
	
	        case _constants.BasketConstants.REMOVE_BASKET:
	            var itemsArray = null;
	            if (action.keyArray !== null && state.items[action.keyArray].id === action.id && state.items[action.keyArray].modifier_option_id === action.modifier_option_id) {
	                itemsArray = state.items.filter(function (item, key) {
	                    if (key === action.keyArray) {
	                        return false;
	                    }
	                    return true;
	                });
	            } else {
	                itemsArray = state.items.filter(function (item) {
	                    if (item.id && item.id === action.id && item.modifier_option_id === action.modifier_option_id) {
	                        return false;
	                    }
	                    return true;
	                });
	            }
	
	            _LocalStorageProxy2.default.setItem('basket.common', (0, _stringify2.default)(itemsArray));
	
	            return (0, _extends3.default)({}, state, {
	                shareCode: '',
	                showShare: false,
	                items: itemsArray,
	                dataError: []
	            });
	
	        case _constants.BasketConstants.CHANGE_COUNT_PRODUCT_IN_BASKET:
	            var changeCountArray = null;
	            if (action.keyArray !== null && state.items[action.keyArray].id === action.id && state.items[action.keyArray].modifier_option_id === action.modifier_option_id) {
	                changeCountArray = state.items.map(function (item, key) {
	                    if (key === action.keyArray) {
	                        item.count = action.count;
	                    }
	                    return item;
	                });
	            } else {
	                changeCountArray = state.items.map(function (item) {
	                    if (item.id && item.id === action.id && item.modifier_option_id === action.modifier_option_id) {
	                        item.count = action.count;
	                    }
	                    return item;
	                });
	            }
	            _LocalStorageProxy2.default.setItem('basket.common', (0, _stringify2.default)(changeCountArray));
	
	            return (0, _extends3.default)({}, state, {
	                items: changeCountArray,
	                shareCode: '',
	                showShare: false
	            });
	
	        case _constants.BasketConstants.COPY_TO_BASKET:
	
	            if (!state.serverLoad) {
	
	                var itemsCopy = void 0;
	
	                try {
	                    itemsCopy = JSON.parse(_LocalStorageProxy2.default.getItem('basket.common'));
	                } catch (e) {
	                    itemsCopy = null;
	                }
	
	                if (!Array.isArray(itemsCopy)) {
	                    itemsCopy = [];
	                }
	
	                return (0, _extends3.default)({}, state, {
	                    is_coped_items: true,
	                    items: itemsCopy
	                });
	            } else {
	                _LocalStorageProxy2.default.setItem('basket.common', (0, _stringify2.default)(state.items));
	                return (0, _extends3.default)({}, state, {
	                    is_coped_items: true
	                });
	            }
	
	        case _constants.BasketConstants.CLEAR_BASKET:
	
	            _LocalStorageProxy2.default.setItem('basket.common', []);
	
	            return (0, _extends3.default)({}, state, {
	                items: [],
	                shareCode: ''
	            });
	
	        case _constants.BasketConstants.ORDER_LOAD:
	            return (0, _extends3.default)({}, state, {
	                preload: true
	            });
	
	        case _constants.BasketConstants.ORDER_LOAD_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                dataError: []
	            });
	
	        case _constants.BasketConstants.ORDER_LOAD_FAIL:
	            var dataError = action.error.dataError || [];
	            return (0, _extends3.default)({}, state, {
	                dataError: [].concat((0, _toConsumableArray3.default)(dataError)),
	                preload: false
	            });
	
	        case _constants.BasketConstants.SHARE_BASKET_LOAD:
	            return (0, _extends3.default)({}, state, {
	                sharePreload: true
	            });
	
	        case _constants.BasketConstants.SHARE_BASKET_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                sharePreload: false,
	                showShare: true,
	                shareCode: action.result
	            });
	
	        case _constants.BasketConstants.SHARE_BASKET_FAIL:
	            return (0, _extends3.default)({}, state, {
	                sharePreload: false
	            });
	
	        case _constants.BasketConstants.GET_SHARE_BASKET_LOAD:
	            return (0, _extends3.default)({}, state, {
	                preload: true
	            });
	
	        case _constants.BasketConstants.GET_SHARE_BASKET_SUCCESS:
	            // arrayItems = action.result.cartItems.map((item)=>{
	            //     return {
	            //         ...item.offer,
	            //         picture: item.offer.pictures[0] || null,
	            //         count: item.count
	            //     }
	            // });
	            arrayItems = action.result.products;
	
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                serverLoad: true,
	                items: arrayItems,
	                fields: action.result.fields
	            });
	
	        case _constants.BasketConstants.GET_SHARE_BASKET_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false
	            });
	
	        case _constants.BasketConstants.BASKET_CHANGE_SHARE:
	            return (0, _extends3.default)({}, state, {
	                showShare: action.payload
	            });
	
	        case _constants.BasketConstants.GET_ACTUAL_PRICES_LOAD:
	            return (0, _extends3.default)({}, state, {
	                actualPricesPreload: true
	            });
	
	        case _constants.BasketConstants.GET_ACTUAL_PRICES_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                actualPricesPreload: false,
	                serverLoad: true,
	                items: action.result
	            });
	
	        case _constants.BasketConstants.GET_ACTUAL_PRICES_FAIL:
	            return (0, _extends3.default)({}, state, {
	                actualPricesPreload: false
	            });
	
	        case _constants.BasketConstants.ADD_COUPON_IN_BASKET:
	            var basketItems = state.items.filter(function (item) {
	                if (item.is_coupon !== undefined) {
	                    return false;
	                }
	                return true;
	            });
	
	            basketItems.push(action.product);
	
	            _LocalStorageProxy2.default.setItem('basket.common', (0, _stringify2.default)(basketItems));
	
	            return (0, _extends3.default)({}, state, {
	                shareCode: '',
	                showShare: false,
	                items: basketItems
	            });
	
	        case _constants.BasketConstants.POSTPONE_BASKET_LOAD:
	            return (0, _extends3.default)({}, state, {
	                preload: true
	            });
	        case _constants.BasketConstants.POSTPONE_BASKET_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                dataError: []
	            });
	        case _constants.BasketConstants.POSTPONE_BASKET_FAIL:
	            var dataError = action.error.dataError || [];
	            return (0, _extends3.default)({}, state, {
	                dataError: [].concat((0, _toConsumableArray3.default)(dataError)),
	                preload: false
	            });
	
	        case _constants.BasketConstants.GET_POSTPONE_BASKET_LOAD:
	            return (0, _extends3.default)({}, state, {
	                preload: true
	            });
	        case _constants.BasketConstants.GET_POSTPONE_BASKET_SUCCESS:
	            // console.log(action.result);
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                dataError: [],
	                itemsPostpone: action.result
	            });
	
	        case _constants.BasketConstants.GET_POSTPONE_BASKET_FAIL:
	            var dataError = action.error.dataError || [];
	            return (0, _extends3.default)({}, state, {
	                dataError: [].concat((0, _toConsumableArray3.default)(dataError)),
	                preload: false
	            });
	
	        case _constants.BasketConstants.DELETE_POSTPONE_LOAD:
	            return (0, _extends3.default)({}, state, {
	                preload: true
	            });
	        case _constants.BasketConstants.DELETE_POSTPONE_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                dataError: [],
	                itemsPostpone: action.result
	            });
	
	        case _constants.BasketConstants.DELETE_POSTPONE_FAIL:
	            var dataError = action.error.dataError || [];
	            return (0, _extends3.default)({}, state, {
	                dataError: [].concat((0, _toConsumableArray3.default)(dataError)),
	                preload: false
	            });
	        case _constants.BasketConstants.MERGE_POSTPONE_LOAD:
	            return (0, _extends3.default)({}, state, {
	                preload: true
	            });
	        case _constants.BasketConstants.MERGE_POSTPONE_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                dataError: [],
	                itemsPostpone: action.result
	            });
	
	        case _constants.BasketConstants.MERGE_POSTPONE_FAIL:
	            var dataError = action.error.dataError || [];
	            return (0, _extends3.default)({}, state, {
	                dataError: [].concat((0, _toConsumableArray3.default)(dataError)),
	                preload: false
	            });
	
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(103);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = catalog;
	
	var _constants = __webpack_require__(18);
	
	var _utils = __webpack_require__(31);
	
	var _utils2 = __webpack_require__(386);
	
	var _moment = __webpack_require__(11);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    products: [],
	    product_detail: {},
	    categories: [],
	    categoriesLoading: false,
	    id: -1,
	    title: '',
	    count: 0,
	    countAll: 0,
	    categoryId: -1,
	    activePage: 1,
	    searchName: '',
	    searchLoaded: false,
	    searchProducts: [],
	    limit: _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT,
	    categorySeo: null,
	    closeSearch: false,
	    categoryRecommended: [],
	    recommendedId: -1,
	    categoryPreload: false,
	    catalogIsLoaded: false,
	
	    isCheckingForUpdates: false,
	    checkForUpdateError: false,
	    lastCatalogUpdateDate: null,
	    hasUpdates: false,
	
	    isRefreshingCatalog: false
	};
	
	function catalog() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	        case _constants.CatalogConstants.LOAD_DETAIL:
	        case _constants.CatalogConstants.LOAD_CATALOG:
	        case _constants.CatalogConstants.LOAD:
	            return state;
	
	        case _constants.CatalogConstants.LOAD_CATEGORIES:
	            return (0, _extends3.default)({}, state, {
	                categoriesLoading: true
	            });
	
	        case _constants.CatalogConstants.LOAD_PRODUCT_BY_CATEGORIES:
	            return (0, _extends3.default)({}, state, {
	                categoryPreload: true
	            });
	
	        case _constants.CatalogConstants.LOAD_BY_CATEGORIES:
	            return (0, _extends3.default)({}, state, {
	                categoryPreload: true
	            });
	
	        case _constants.CatalogConstants.LOAD_CATEGORIES_SUCCESS:
	            var array = [].concat((0, _toConsumableArray3.default)(action.result));
	            (0, _utils.sortCategoryBylength)(array);
	
	            return (0, _extends3.default)({}, state, {
	                catalogIsLoaded: true,
	                categories: array,
	                categoriesLoading: false,
	                hasUpdates: false
	            });
	
	        case _constants.CatalogConstants.LOAD_SUCCESS:
	            var products = [].concat((0, _toConsumableArray3.default)(action.result.offers));
	            products = products.map(function (product_detail) {
	                if (product_detail.nestedOffers && product_detail.nestedOffers.length) {
	                    product_detail.nestedOffers = product_detail.nestedOffers.map(function (item) {
	                        return (0, _utils2.addMinValueToOffer)(item);
	                    });
	                }
	                return product_detail;
	            });
	
	            return (0, _extends3.default)({}, state, {
	                products: products,
	                count: action.result.count,
	                countAll: action.result.countAll,
	                limit: action.result.limit,
	                activePage: action.result.activePage,
	                searchName: action.result.searchName
	            });
	
	        case _constants.CatalogConstants.LOAD_CATALOG_SUCCESS:
	            return (0, _extends3.default)({}, state);
	
	        case _constants.CatalogConstants.LOAD_CATALOG_FAIL:
	            return state;
	
	        case _constants.CatalogConstants.LOAD_FAIL:
	            return state;
	
	        case _constants.CatalogConstants.LOAD_CATEGORIES_FAIL:
	            return (0, _extends3.default)({}, state, {
	                categoriesLoading: false
	            });
	
	        case _constants.CatalogConstants.LOAD_DETAIL_SUCCESS:
	            var product_detail = (0, _extends3.default)({}, action.result);
	            if (product_detail.nestedOffers && product_detail.nestedOffers.length) {
	                product_detail.nestedOffers = product_detail.nestedOffers.map(function (item) {
	                    return (0, _utils2.addMinValueToOffer)(item);
	                });
	            }
	            return (0, _extends3.default)({}, state, {
	                product_detail: product_detail
	            });
	
	        case _constants.CatalogConstants.LOAD_DETAIL_FAIL:
	            return (0, _extends3.default)({}, state, {
	                product_detail: {}
	            });
	
	        case _constants.CatalogConstants.LOAD_PRODUCT_BY_CATEGORIES_SUCCESS:
	            products = [].concat((0, _toConsumableArray3.default)(action.result.offers));
	            products = products.map(function (product_detail) {
	                if (product_detail.nestedOffers && product_detail.nestedOffers.length) {
	                    product_detail.nestedOffers = product_detail.nestedOffers.map(function (item) {
	                        return (0, _utils2.addMinValueToOffer)(item);
	                    });
	                }
	                return product_detail;
	            });
	            return (0, _extends3.default)({}, state, {
	                products: products,
	                title: action.result.title,
	                description: action.result.description,
	                picture: action.result.picture,
	                id: action.result.id,
	                count: action.result.count,
	                limit: action.result.limit,
	                activePage: action.result.activePage,
	                categorySeo: action.result.seo,
	                categoryPreload: false
	            });
	
	        case _constants.CatalogConstants.LOAD_BY_CATEGORIES_SUCCESS:
	            products = [].concat((0, _toConsumableArray3.default)(action.result.offers));
	            products = products.map(function (product_detail) {
	                if (product_detail.nestedOffers && product_detail.nestedOffers.length) {
	                    product_detail.nestedOffers = product_detail.nestedOffers.map(function (item) {
	                        return (0, _utils2.addMinValueToOffer)(item);
	                    });
	                }
	                return product_detail;
	            });
	            return (0, _extends3.default)({}, state, {
	                id: action.result.id,
	                products: products,
	                title: action.result.title,
	                description: action.result.description,
	                picture: action.result.picture,
	                limit: action.result.limit,
	                count: action.result.count,
	                categorySeo: action.result.seo,
	                activePage: action.result.activePage,
	                categoryPreload: false
	            });
	
	        case _constants.CatalogConstants.LOAD_PRODUCT_BY_CATEGORIES_FAIL:
	            return (0, _extends3.default)({}, state, {
	                categoryPreload: false
	            });
	
	        case _constants.CatalogConstants.LOAD_BY_CATEGORIES_FAIL:
	            return (0, _extends3.default)({}, state, {
	                categoryPreload: false
	            });
	
	        case _constants.CatalogConstants.CATEGORY_RECOMENDED_LOAD:
	            return (0, _extends3.default)({}, state, {
	                categoryRecommended: []
	            });
	
	        case _constants.CatalogConstants.CATEGORY_RECOMENDED_LOAD_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                recommendedId: action.result.id,
	                categoryRecommended: action.result.offers.map(function (item) {
	                    return item.offer;
	                })
	            });
	
	        case _constants.CatalogConstants.CATEGORY_RECOMENDED_LOAD_FAIL:
	            return (0, _extends3.default)({}, state);
	
	        case _constants.CatalogConstants.SEARCH_PRODUCTS_LOAD:
	            return (0, _extends3.default)({}, state, {
	                searchLoaded: true
	            });
	
	        case _constants.CatalogConstants.SEARCH_PRODUCTS_LOAD_SUCCESS:
	            var searchProducts = [].concat((0, _toConsumableArray3.default)(action.result));
	            searchProducts = searchProducts.map(function (product_detail) {
	                if (product_detail.nestedOffers && product_detail.nestedOffers.length) {
	                    product_detail.nestedOffers = product_detail.nestedOffers.map(function (item) {
	                        return (0, _utils2.addMinValueToOffer)(item);
	                    });
	                }
	                return product_detail;
	            });
	            return (0, _extends3.default)({}, state, {
	                searchLoaded: false,
	                searchProducts: searchProducts
	            });
	
	        case _constants.CatalogConstants.SEARCH_PRODUCTS_LOAD_FAIL:
	            return (0, _extends3.default)({}, state, {
	                searchLoaded: false
	            });
	
	        case _constants.CatalogConstants.SEARCH_PRODUCTS_RESET:
	            return (0, _extends3.default)({}, state, {
	                searchLoaded: false,
	                searchProducts: []
	            });
	
	        case '@@router/LOCATION_CHANGE':
	
	            return (0, _extends3.default)({}, state, {
	                closeSearch: !/(\/search\/)/.test(action.payload.pathname)
	            });
	
	        case _constants.CatalogConstants.SET_SEARCH_CLOSE:
	            return (0, _extends3.default)({}, state, {
	                closeSearch: action.payload.close
	            });
	        case _constants.CatalogConstants.LOAD_LAST_CATALOG_UPDATE_DATE:
	            return (0, _extends3.default)({}, state, {
	                isCheckingForUpdates: true,
	                updateCatalogError: false
	            });
	        case _constants.CatalogConstants.LOAD_LAST_CATALOG_UPDATE_DATE_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                isCheckingForUpdates: false,
	                updateCatalogError: false,
	                lastCatalogUpdateDate: action.result,
	                hasUpdates: state.hasUpdates ? state.hasUpdates : state.lastCatalogUpdateDate === null ? false : action.result !== state.lastCatalogUpdateDate
	
	            });
	        case _constants.CatalogConstants.LOAD_LAST_CATALOG_UPDATE_DATE_FAIL:
	            return (0, _extends3.default)({}, state, {
	                isCheckingForUpdates: false,
	                updateCatalogError: true
	            });
	        case _constants.CatalogConstants.REFRESH_CATALOG_LOAD:
	            return (0, _extends3.default)({}, state, {
	                isRefreshingCatalog: true
	            });
	        case _constants.CatalogConstants.REFRESH_CATALOG_LOAD_SUCCESS:
	        case _constants.CatalogConstants.REFRESH_CATALOG_LOAD_FAIL:
	            return (0, _extends3.default)({}, state, {
	                isRefreshingCatalog: false
	            });
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = coupons;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    coupon: null,
	    preload: false
	};
	
	function coupons() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.CouponsConstants.LOAD_COUPONS:
	            return (0, _extends3.default)({}, state, {
	                preload: true
	            });
	        case _constants.CouponsConstants.LOAD_SETTINGS_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                coupon: action.result
	            });
	        default:
	            return (0, _extends3.default)({}, state, {
	                preload: false
	            });
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = currency;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	function currency() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.CurrencyConstants.LOAD_DATA:
	            {
	                return (0, _extends3.default)({}, state, action.result);
	            }
	
	        default:
	            {
	                return state;
	            }
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = error;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    show_error: false,
	    message_error: '',
	    count_errors: 0,
	    is_show_404: false,
	    showAlert: false,
	    alertType: null,
	    server_not_found: false,
	    error_code: '',
	    error_title: ''
	};
	
	function error() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    if (action.type == '@@router/LOCATION_CHANGE' && (true)) {
	        if (action.payload.pathname !== state.is_show_404) {
	            return (0, _extends3.default)({}, state, {
	                is_show_404: false,
	                show_error: false
	            });
	        }
	    }
	
	    if (action.show_error === true) {
	        return (0, _extends3.default)({}, state, {
	            show_error: true,
	            message_error: action.error.message || '',
	            count_errors: state.count_errors + 1,
	            is_show_404: action.show_404,
	            error_code: action.error.code,
	            error_title: action.error.title
	        });
	    } else if (action.show_error === false) {
	        return (0, _extends3.default)({}, state, {
	            show_error: false,
	            message_error: '',
	            count_errors: 0,
	            server_not_found: action.server_not_found,
	            error_code: '',
	            error_title: ''
	        });
	    } else if (action.disable_404) {
	        return (0, _extends3.default)({}, state, {
	            is_show_404: false
	        });
	    }
	
	    return state;
	}
	module.exports = exports['default'];

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = headInfo;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    isShowSideMenu: false
	}; /**
	    * Created by maximus on 23.11.16.
	    */
	function headInfo() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	    switch (action.type) {
	
	        case _constants.HeadInfoConstants.SHOW_SIDEMENU:
	            return (0, _extends3.default)({}, state, {
	                isShowSideMenu: true
	            });
	
	        case _constants.HeadInfoConstants.HIDE_SIDEMENU:
	            return (0, _extends3.default)({}, state, {
	                isShowSideMenu: false
	            });
	
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.operations = exports.address = exports.currency = exports.coupons = exports.lang = exports.voiceCode = exports.user = exports.page = exports.passRecovery = exports.translate_pipo = exports.sliders = exports.setting = exports.payment = exports.wishList = exports.modal = exports.headInfo = exports.preloader = exports.personal_order_list = exports.personal_order_detail = exports.error = exports.registration = exports.catalog = exports.basket = exports.auth = undefined;
	
	var _auth2 = __webpack_require__(1895);
	
	var _auth3 = _interopRequireDefault(_auth2);
	
	var _basket2 = __webpack_require__(1896);
	
	var _basket3 = _interopRequireDefault(_basket2);
	
	var _catalog2 = __webpack_require__(1897);
	
	var _catalog3 = _interopRequireDefault(_catalog2);
	
	var _registration2 = __webpack_require__(1912);
	
	var _registration3 = _interopRequireDefault(_registration2);
	
	var _error2 = __webpack_require__(1900);
	
	var _error3 = _interopRequireDefault(_error2);
	
	var _personal_order_detail2 = __webpack_require__(1909);
	
	var _personal_order_detail3 = _interopRequireDefault(_personal_order_detail2);
	
	var _personal_order_list2 = __webpack_require__(1910);
	
	var _personal_order_list3 = _interopRequireDefault(_personal_order_list2);
	
	var _preloader2 = __webpack_require__(1911);
	
	var _preloader3 = _interopRequireDefault(_preloader2);
	
	var _headInfo2 = __webpack_require__(1901);
	
	var _headInfo3 = _interopRequireDefault(_headInfo2);
	
	var _modal2 = __webpack_require__(1904);
	
	var _modal3 = _interopRequireDefault(_modal2);
	
	var _wish_list = __webpack_require__(1918);
	
	var _wish_list2 = _interopRequireDefault(_wish_list);
	
	var _payment2 = __webpack_require__(1908);
	
	var _payment3 = _interopRequireDefault(_payment2);
	
	var _setting2 = __webpack_require__(1913);
	
	var _setting3 = _interopRequireDefault(_setting2);
	
	var _sliders2 = __webpack_require__(1914);
	
	var _sliders3 = _interopRequireDefault(_sliders2);
	
	var _translate_pipo2 = __webpack_require__(1915);
	
	var _translate_pipo3 = _interopRequireDefault(_translate_pipo2);
	
	var _pass_recovery = __webpack_require__(1907);
	
	var _pass_recovery2 = _interopRequireDefault(_pass_recovery);
	
	var _page2 = __webpack_require__(1906);
	
	var _page3 = _interopRequireDefault(_page2);
	
	var _user2 = __webpack_require__(1916);
	
	var _user3 = _interopRequireDefault(_user2);
	
	var _voice_code = __webpack_require__(1917);
	
	var _voice_code2 = _interopRequireDefault(_voice_code);
	
	var _lang2 = __webpack_require__(1903);
	
	var _lang3 = _interopRequireDefault(_lang2);
	
	var _coupons2 = __webpack_require__(1898);
	
	var _coupons3 = _interopRequireDefault(_coupons2);
	
	var _currency2 = __webpack_require__(1899);
	
	var _currency3 = _interopRequireDefault(_currency2);
	
	var _address2 = __webpack_require__(1894);
	
	var _address3 = _interopRequireDefault(_address2);
	
	var _operations2 = __webpack_require__(1905);
	
	var _operations3 = _interopRequireDefault(_operations2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.auth = _auth3.default;
	exports.basket = _basket3.default;
	exports.catalog = _catalog3.default;
	exports.registration = _registration3.default;
	exports.error = _error3.default;
	exports.personal_order_detail = _personal_order_detail3.default;
	exports.personal_order_list = _personal_order_list3.default;
	exports.preloader = _preloader3.default;
	exports.headInfo = _headInfo3.default;
	exports.modal = _modal3.default;
	exports.wishList = _wish_list2.default;
	exports.payment = _payment3.default;
	exports.setting = _setting3.default;
	exports.sliders = _sliders3.default;
	exports.translate_pipo = _translate_pipo3.default;
	exports.passRecovery = _pass_recovery2.default;
	exports.page = _page3.default;
	exports.user = _user3.default;
	exports.voiceCode = _voice_code2.default;
	exports.lang = _lang3.default;
	exports.coupons = _coupons3.default;
	exports.currency = _currency3.default;
	exports.address = _address3.default;
	exports.operations = _operations3.default;

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by i.lovenkov on 26.04.17.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = lang;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	function lang() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.LangConstants.LOAD_DATA:
	            {
	                return (0, _extends3.default)({}, state, action.result);
	            }
	
	        default:
	            {
	                return state;
	            }
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = modal;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    is_show: false,
	    title: '',
	    content: null,
	    titleSuccess: 'OK',
	    titleClose: 'Отмена',
	    onSuccess: function onSuccess() {},
	    modalType: null,
	    timerId: null
	};
	
	function modal() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.ModalConstants.MODAL_SHOW:
	            return (0, _extends3.default)({}, state, action.state, {
	                is_show: true
	            });
	        case _constants.ModalConstants.MODAL_HIDE:
	            if (state.timerId) {
	                clearTimeout(state.timerId);
	            }
	
	            return (0, _extends3.default)({}, state, {
	                timerId: null,
	                is_show: false
	            });
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(103);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = operations;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    preload: false,
	    morePreload: false,
	    items: [],
	    count: 0,
	    endDate: "",
	    begDate: "",
	    page: 1
	};
	
	function operations() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.OperationsConstants.OPERATION_LOAD:
	            return (0, _extends3.default)({}, state, {
	                preload: true
	            });
	
	        case _constants.OperationsConstants.MORE_LOAD:
	            return (0, _extends3.default)({}, state, {
	                morePreload: true
	            });
	
	        case _constants.OperationsConstants.OPERATION_LOAD_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                items: action.result.data.items,
	                count: action.result.data.count,
	                endDate: action.result.endDate,
	                begDate: action.result.begDate,
	                multiBalans: action.result.multi_balans,
	                page: action.result.page,
	                preload: false,
	                morePreload: false
	            });
	
	        case _constants.OperationsConstants.MORE_LOAD_SUCCESS:
	            var newItems = state.items.concat([].concat((0, _toConsumableArray3.default)(action.result.data.items)));
	
	            return (0, _extends3.default)({}, state, {
	                items: newItems,
	                count: action.result.data.count,
	                endDate: action.result.endDate,
	                begDate: action.result.begDate,
	                multiBalans: action.result.multi_balans,
	                page: action.result.page,
	                preload: false,
	                morePreload: false
	            });
	
	        case _constants.OperationsConstants.OPERATION_LOAD_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                morePreload: false
	            });
	
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = page;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    list: [],
	    detail: {}
	};
	
	function page() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.PageConstants.SET_PAGE_LIST:
	            var buffer = action.result;
	            buffer.sort(function (a, b) {
	                return a.position - b.position;
	            });
	            return (0, _extends3.default)({}, state, {
	                list: buffer
	            });
	        case _constants.PageConstants.PAGE_DETAIL_LOAD_REQUEST:
	            return (0, _extends3.default)({}, state, {
	                detail: {}
	            });
	        case _constants.PageConstants.PAGE_DETAIL_LOAD_SUCCES:
	            return (0, _extends3.default)({}, state, {
	                detail: action.result
	            });
	        case _constants.PageConstants.PAGE_DETAIL_LOAD_FAIL:
	            return (0, _extends3.default)({}, state);
	
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = passRecovery;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    preload: false,
	    step: _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_1,
	    error: '',
	    is_send_voice_code: false,
	    phone: '',
	    timerRepeat: 30,
	    errorCode: null
	};
	
	function passRecovery() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                error: '',
	                errorCode: null
	            });
	
	        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_FAIL:
	            return (0, _extends3.default)({}, state, {
	                error: action.error.title,
	                is_send_voice_code: false,
	                errorCode: action.error.code
	            });
	        case _constants.PassRecoveryConstants.PASS_RECOVERY_FORM_REQUEST:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                error: null,
	                errorCode: null
	            });
	        case _constants.PassRecoveryConstants.PASS_RECOVERY_FORM_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                step: _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_2,
	                preload: false,
	                error: null,
	                errorCode: null
	            });
	        case _constants.PassRecoveryConstants.PASS_RECOVERY_FORM_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                error: action.error.title,
	                errorCode: action.error.code
	            });
	
	        case _constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_REQUEST:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                error: null,
	                errorCode: null
	            });
	        case _constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                step: _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_3,
	                preload: false,
	                error: null,
	                errorCode: null
	            });
	        case _constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                error: action.error.title,
	                errorCode: action.error.code
	            });
	
	        case _constants.PassRecoveryConstants.PASS_RECOVERY_RESET_STEP:
	            return (0, _extends3.default)({}, state, {
	                step: _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_1,
	                preload: false,
	                error: null,
	                errorCode: null
	            });
	
	        case _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_FORM_REQUEST:
	        case _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_FORM_FAIL:
	        case _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_RESET:
	            return (0, _extends3.default)({}, state, {
	                is_send_voice_code: false
	            });
	        case _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_FORM_SUCCESS:
	            //Если телефон не в белом списке
	            var inWhiteList = action.result.sendingStatus ? true : "not_white";
	            return (0, _extends3.default)({}, state, {
	                is_send_voice_code: inWhiteList,
	                timerRepeat: action.result.timeToRepeat
	            });
	
	        case _constants.PassRecoveryConstants.PASS_RECOVERY_SET_PHONE:
	            return (0, _extends3.default)({}, state, {
	                phone: action.phone
	            });
	
	        case _constants.PassRecoveryConstants.PASS_RECOVERY_SHOW_ERROR:
	            return (0, _extends3.default)({}, state, {
	                error: action.error.title,
	                errorCode: action.error.code
	            });
	
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = payment;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    isPayOrder: false,
	    isCustomPayment: false,
	    preload: false,
	    processInput: {},
	    list: [],
	    pipoList: [],
	    errorPay: null,
	    errorCode: null
	};
	
	function payment() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.PaymentConstants.CHECK_CODE_SEND_INNER_PIPO_FAIL:
	            return (0, _extends3.default)({}, state, {
	                errorPay: action.error.message,
	                errorCode: action.error.code
	            });
	            break;
	        case _constants.PaymentConstants.SHOW:
	            return state;
	            break;
	        case _constants.PaymentConstants.SHOW_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                list: action.result.services
	            });
	            break;
	        case _constants.PaymentConstants.SHOW_FAIL:
	            return state;
	            break;
	
	        case _constants.PaymentConstants.PAY_INNER_PIPO_RESET:
	            return (0, _extends3.default)({}, state, {
	                isPayOrder: false,
	                errorPay: null,
	                errorCode: null
	            });
	            break;
	        case _constants.PaymentConstants.PAY_INNER_PIPO_FAIL:
	            return (0, _extends3.default)({}, state, {
	                isPayOrder: false,
	                preload: false,
	                errorPay: action.error.message,
	                errorCode: action.error.code
	            });
	            break;
	        case _constants.PaymentConstants.PAY_INNER_PIPO_REQUEST:
	            return (0, _extends3.default)({}, state, {
	                isPayOrder: false,
	                preload: true,
	                errorPay: null,
	                errorCode: null
	            });
	            break;
	        case _constants.PaymentConstants.PAY_INNER_PIPO_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                isPayOrder: true,
	                preload: false,
	                errorPay: null,
	                errorCode: null
	            });
	            break;
	
	        case _constants.PaymentConstants.PIPO_PROCESS_INPUT_REQUEST:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                processInput: {}
	            });
	            break;
	        case _constants.PaymentConstants.PIPO_PROCESS_INPUT_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                processInput: action.result
	            });
	            break;
	        case _constants.PaymentConstants.PIPO_PROCESS_INPUT_RESET:
	        case _constants.PaymentConstants.PIPO_PROCESS_INPUT_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                processInput: {}
	            });
	            break;
	        case _constants.PaymentConstants.PIPO_PAY_PARAMS_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                pipoList: action.result.params
	            });
	            break;
	
	        case _constants.PaymentConstants.SET_CUSTOM_PAYMENT:
	            return (0, _extends3.default)({}, state, {
	                isCustomPayment: true
	            });
	            break;
	        case _constants.PaymentConstants.RESET_CUSTOM_PAYMENT:
	            return (0, _extends3.default)({}, state, {
	                isCustomPayment: false
	            });
	            break;
	
	        default:
	            return state;
	            break;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = personal_order_detail;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    order: {},
	    payment_in_id: null,
	    preload: false
	};
	
	function personal_order_detail() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.Personal.OrderDetail.PERSONAL_ORDER_DETAIL_LOAD:
	            return (0, _extends3.default)({}, state);
	        case _constants.Personal.OrderDetail.PERSONAL_ORDER_DETAIL_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                order: action.result
	            });
	        case _constants.Personal.OrderDetail.PERSONAL_ORDER_DETAIL_FAIL:
	            return (0, _extends3.default)({}, state, {
	                order: {}
	            });
	        case _constants.Personal.OrderDetail.SET_PAYMENT_ID:
	            {
	                return {
	                    payment_in_id: action.paymentId
	                };
	            }
	        case _constants.Personal.OrderList.ORDER_SETTING_SEND:
	            return (0, _extends3.default)({}, state, {
	                preload: true
	            });
	        case _constants.Personal.OrderList.ORDER_SETTING_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                result: action.result
	            });
	        case _constants.Personal.OrderList.ORDER_SETTING_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false
	            });
	        case _constants.Personal.OrderList.ORDER_SET_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false
	            });
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = personal_order_list;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    orders: [],
	    count: 0
	};
	
	function personal_order_list() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.Personal.OrderList.PERSONAL_ORDER_LIST_LOAD:
	            return (0, _extends3.default)({}, state);
	        case _constants.Personal.OrderList.PERSONAL_ORDER_LIST_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                orders: action.result.orders,
	                count: action.result.count,
	                activePage: action.result.activePage,
	                limit: action.result.limit
	            });
	        case _constants.Personal.OrderList.PERSONAL_ORDER_LIST_FAIL:
	            return (0, _extends3.default)({}, state, {
	                orders: []
	            });
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = preloader;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    show: false
	};
	
	function preloader() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (action.show_preloader || action.type === 'reduxAsyncConnect/BEGIN_GLOBAL_LOAD') {
	        return (0, _extends3.default)({}, state, {
	            show: true
	        });
	    } else if (state.hide_preloader || action.type === 'reduxAsyncConnect/END_GLOBAL_LOAD') {
	        return (0, _extends3.default)({}, state, {
	            show: false
	        });
	    }
	
	    return state;
	}
	module.exports = exports['default'];

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = auth;
	
	var _constants = __webpack_require__(18);
	
	var _constants2 = __webpack_require__(757);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    preload: false,
	    step: _constants2.REGISTRATION_STEP_FORM, // REG_START
	    errorsList: '',
	    is_send_voice_code: false,
	    timerRepeat: 30,
	    errorCode: null
	};
	
	function auth() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_FAIL:
	            return (0, _extends3.default)({}, state, {
	                errorsList: action.error.title,
	                errorCode: action.error.code,
	                is_send_voice_code: false
	            });
	        case _constants.RegistrationConstants.REGISTRATION_FORM_REQUEST:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                errorsList: null,
	                errorCode: null
	            });
	        case _constants.RegistrationConstants.REGISTRATION_FORM_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                step: _constants2.REGISTRATION_STEP_CONFIRMED,
	                errorsList: null,
	                errorCode: null
	            });
	            break;
	        case _constants.RegistrationConstants.REGISTRATION_FORM_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                errorsList: action.error.title,
	                errorCode: action.error.code
	            });
	            break;
	
	        case _constants.RegistrationConstants.REGISTRATION_CONFIRM_REQUEST:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                errorsList: null,
	                errorCode: null
	            });
	            break;
	
	        case _constants.RegistrationConstants.REGISTRATION_CONFIRM_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                step: _constants2.REGISTRATION_STEP_CONFIRMED_SUCCESS,
	                errorsList: null,
	                errorCode: null
	            });
	            break;
	
	        case _constants.RegistrationConstants.REGISTRATION_CONFIRM_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                errorsList: action.error.title,
	                errorCode: action.error.code
	            });
	            break;
	
	        case _constants.RegistrationConstants.REGISTRATION_RESET_STEP:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                step: _constants2.REGISTRATION_STEP_FORM,
	                errorsList: null,
	                errorCode: null
	            });
	            break;
	
	        case _constants.RegistrationConstants.REGISTRATION_VOICE_FORM_REQUEST:
	        case _constants.RegistrationConstants.REGISTRATION_VOICE_FORM_FAIL:
	        case _constants.RegistrationConstants.REGISTRATION_VOICE_RESET:
	            return (0, _extends3.default)({}, state, {
	                is_send_voice_code: false
	            });
	        case _constants.RegistrationConstants.REGISTRATION_VOICE_FORM_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                is_send_voice_code: true,
	                timerRepeat: action.result.timeRepeat
	            });
	
	        case _constants.RegistrationConstants.REGISTRATION_RESET_ERROR:
	            return (0, _extends3.default)({}, state, {
	                errorsList: '',
	                errorCode: null
	            });
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = setting;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	function setting() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.SettingConstants.SET_SETTING:
	        case _constants.SettingConstants.LOAD_SETTINGS_SUCCESS:
	            return (0, _extends3.default)({}, action.result);
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(103);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = sliders;
	
	var _constants = __webpack_require__(18);
	
	var _sliders = __webpack_require__(261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    products_novelty: [],
	    products_popular: [],
	    products_hits: [],
	    category: []
	};
	
	function sliders() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	
	        case _constants.SliderConstants.SLIDER_LOAD:
	        case _constants.SliderConstants.SLIDER_LOAD_CATEGORY:
	            return state;
	
	        case _constants.SliderConstants.SLIDER_LOAD_SUCCESS:
	
	            if (action.result.sliderType === _sliders.SLIDER_NEW) {
	                return (0, _extends3.default)({}, state, {
	                    products_novelty: [].concat((0, _toConsumableArray3.default)(action.result.offers))
	                });
	            }
	            if (action.result.sliderType === _sliders.SLIDER_POPULAR) {
	                return (0, _extends3.default)({}, state, {
	                    products_popular: [].concat((0, _toConsumableArray3.default)(action.result.offers))
	                });
	            }
	            if (action.result.sliderType === _sliders.SLIDER_HIT) {
	                return (0, _extends3.default)({}, state, {
	                    products_hits: [].concat((0, _toConsumableArray3.default)(action.result.offers))
	                });
	            }
	            return state;
	
	        case _constants.SliderConstants.SLIDER_LOAD_CATEGORY_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                category: [].concat((0, _toConsumableArray3.default)(action.result.category))
	            });
	
	        case _constants.SliderConstants.SLIDER_LOAD_FAIL:
	        case _constants.SliderConstants.SLIDER_LOAD_CATEGORY_FAIL:
	            return state;
	
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = translate_pipo;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    list: {}
	};
	
	function translate_pipo() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.TranslatePipoConstants.TRANSLATE_PIPO_REQUEST:
	        case _constants.TranslatePipoConstants.TRANSLATE_PIPO_FAIL:
	            return state;
	            break;
	        case _constants.TranslatePipoConstants.TRANSLATE_PIPO_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                list: action.result
	            });
	            break;
	
	        default:
	            return state;
	            break;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = user;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    change: false,
	    error: '',
	    preload: false,
	    changeWithCode: false,
	    errorCode: null
	};
	
	function user() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	        case _constants.UserConstants.USER_CHANGE:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                change: false,
	                error: '',
	                errorCode: null
	            });
	        case _constants.UserConstants.USER_CHANGE_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                change: !!action.result
	            });
	        case _constants.UserConstants.USER_CHANGE_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                error: action.error.title,
	                change: false,
	                errorCode: action.error.code
	            });
	        case _constants.UserConstants.USER_CHANGE_MAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                change: false,
	                error: '',
	                errorCode: null
	            });
	        case _constants.UserConstants.USER_CHANGE_MAIL_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                change: !!action.result
	            });
	        case _constants.UserConstants.USER_CHANGE_MAIL_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                error: action.error.title,
	                change: false,
	                errorCode: action.error.code
	            });
	        case _constants.UserConstants.USER_CHANGE_MAIL_CODE:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                changeWithCode: false,
	                error: '',
	                errorCode: null
	            });
	        case _constants.UserConstants.USER_CHANGE_MAIL_CODE_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                changeWithCode: !!action.result
	            });
	        case _constants.UserConstants.USER_CHANGE_MAIL_CODE_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                error: action.error.title,
	                changeWithCode: false,
	                errorCode: action.error.code
	            });
	        case _constants.UserConstants.USER_CHANGE_PHONE:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                change: false,
	                error: '',
	                errorCode: null
	            });
	        case _constants.UserConstants.USER_CHANGE_PHONE_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                change: !!action.result
	            });
	        case _constants.UserConstants.USER_CHANGE_PHONE_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                error: action.error.title,
	                change: false,
	                errorCode: action.error.code
	            });
	
	        case _constants.UserConstants.USER_CHANGE_PHONE_CODE:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                changeWithCode: false,
	                error: '',
	                errorCode: null
	            });
	        case _constants.UserConstants.USER_CHANGE_PHONE_CODE_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                changeWithCode: !!action.result
	            });
	        case _constants.UserConstants.USER_CHANGE_PHONE_CODE_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                error: action.error.title,
	                changeWithCode: false,
	                errorCode: action.error.code
	            });
	        case _constants.UserConstants.USER_CONFIRM_MAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                change: false,
	                error: '',
	                errorCode: null
	            });
	        case _constants.UserConstants.USER_CONFIRM_MAIL_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                change: !!action.result
	            });
	        case _constants.UserConstants.USER_CONFIRM_MAIL_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                error: action.error.title,
	                change: false,
	                errorCode: action.error.code
	            });
	        case _constants.UserConstants.USER_CONFIRM_MAIL_CODE:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                changeWithCode: false,
	                error: '',
	                errorCode: null
	            });
	        case _constants.UserConstants.USER_CONFIRM_MAIL_CODE_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                changeWithCode: !!action.result
	            });
	        case _constants.UserConstants.USER_CONFIRM_MAIL_CODE_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                error: action.error.title,
	                changeWithCode: false,
	                errorCode: action.error.code
	            });
	        case _constants.UserConstants.USER_CONFIRM_PHONE:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                change: false,
	                error: '',
	                errorCode: null
	            });
	        case _constants.UserConstants.USER_CONFIRM_PHONE_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                change: !!action.result
	            });
	        case _constants.UserConstants.USER_CONFIRM_PHONE_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                error: action.error.title,
	                change: false,
	                errorCode: action.error.code
	            });
	        case _constants.UserConstants.USER_CONFIRM_PHONE_CODE:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                changeWithCode: false,
	                error: '',
	                errorCode: null
	            });
	        case _constants.UserConstants.USER_CONFIRM_PHONE_CODE_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                changeWithCode: !!action.result
	            });
	        case _constants.UserConstants.USER_CONFIRM_PHONE_CODE_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                error: action.error.title,
	                changeWithCode: false,
	                errorCode: action.error.code
	            });
	        case _constants.UserConstants.USER_RESET_ERROR:
	            return (0, _extends3.default)({}, state, {
	                error: '',
	                errorCode: null
	            });
	        case _constants.UserConstants.USER_CHANGE_PASSWORD:
	            return (0, _extends3.default)({}, state, {
	                preload: true,
	                change: false,
	                error: '',
	                errorCode: null
	            });
	        case _constants.UserConstants.USER_CHANGE_PASSWORD_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                change: !!action.result
	            });
	        case _constants.UserConstants.USER_CHANGE_PASSWORD_FAIL:
	            return (0, _extends3.default)({}, state, {
	                preload: false,
	                error: action.error.title,
	                change: false,
	                errorCode: action.error.code
	            });
	        case _constants.UserConstants.USER_CHANGE_INN:
	            {
	                return (0, _extends3.default)({}, state, {
	                    preload: true,
	                    change: false,
	                    error: '',
	                    errorCode: null
	                });
	            }
	        case _constants.UserConstants.USER_CHANGE_INN_SUCCESS:
	            {
	                return (0, _extends3.default)({}, state, {
	                    preload: false,
	                    change: !!action.result
	                });
	            }
	        case _constants.UserConstants.USER_CHANGE_INN_FAIL:
	            {
	                return (0, _extends3.default)({}, state, {
	                    preload: false,
	                    error: action.error.title,
	                    change: false,
	                    errorCode: action.error.code
	                });
	            }
	        case _constants.UserConstants.USER_CHANGE_UL_NAME:
	            {
	                return (0, _extends3.default)({}, state, {
	                    preload: true,
	                    change: false,
	                    error: '',
	                    errorCode: null
	                });
	            }
	        case _constants.UserConstants.USER_CHANGE_UL_NAME_SUCCESS:
	            {
	                return (0, _extends3.default)({}, state, {
	                    preload: false,
	                    change: !!action.result
	                });
	            }
	        case _constants.UserConstants.USER_CHANGE_UL_NAME_FAIL:
	            {
	                return (0, _extends3.default)({}, state, {
	                    preload: false,
	                    error: action.error.title,
	                    change: false,
	                    errorCode: action.error.code
	                });
	            }
	        case _constants.UserConstants.USER_ADD_ADDRESS:
	            {
	                return (0, _extends3.default)({}, state, {
	                    preload: true,
	                    change: false,
	                    error: '',
	                    errorCode: null
	                });
	            }
	        case _constants.UserConstants.USER_ADD_ADDRESS_SUCCESS:
	            {
	                return (0, _extends3.default)({}, state, {
	                    preload: false,
	                    change: !!action.result
	                });
	            }
	        case _constants.UserConstants.USER_ADD_ADDRESS_FAIL:
	            {
	                return (0, _extends3.default)({}, state, {
	                    preload: false,
	                    error: action.error.title,
	                    change: false,
	                    errorCode: action.error.code
	                });
	            }
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = voiceCode;
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    error: '',
	    is_send_voice_code: false,
	    timerRepeat: 30,
	    currentTime: 0,
	    preloader: false
	};
	
	function voiceCode() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    switch (action.type) {
	
	        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_FAIL:
	            return (0, _extends3.default)({}, state, {
	                error: action.error.message,
	                is_send_voice_code: false,
	                preloader: false
	            });
	        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_REQUEST:
	            return (0, _extends3.default)({}, state, {
	                is_send_voice_code: false,
	                preloader: true
	            });
	        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_RESET:
	            return (0, _extends3.default)({}, state, {
	                error: ''
	            });
	        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_SUCCESS:
	            return (0, _extends3.default)({}, state, {
	                is_send_voice_code: action.result.sendingStatus,
	                timerRepeat: action.result.timeToRepeat,
	                currentTime: action.result.timeToRepeat,
	                error: '',
	                preloader: false
	            });
	        case _constants.VoiceCodeConstants.SET_TIMER:
	            return (0, _extends3.default)({}, state, {
	                currentTime: action.time
	            });
	
	        default:
	            return state;
	    }
	}
	module.exports = exports['default'];

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by maximus on 16.12.16.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(9);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(68);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(142);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(103);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = wishList;
	
	var _constants = __webpack_require__(18);
	
	var _LocalStorageProxy = __webpack_require__(45);
	
	var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);
	
	var _Basket = __webpack_require__(747);
	
	var _Basket2 = _interopRequireDefault(_Basket);
	
	var _wish_list = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  wishProducts: []
	};
	
	function wishList() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	
	  switch (action.type) {
	
	    case _constants.WishConstants.ADD_TO_WISHLIST:
	      var items = [].concat((0, _toConsumableArray3.default)(state.wishProducts)),
	          flagPush = true;
	      // action.product.modifier_option_id_copy=action.product.modifier_option_id;
	      if (action.product) {
	        if (items === undefined || items == null || items == '') {
	          items = [];
	        }
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].id === action.product.id && items[i].modifier_option_id === action.product.modifier_option_id) {
	            flagPush = false;
	            break;
	          }
	        }
	
	        flagPush && items.push((0, _assign2.default)({}, action.product));
	      }
	
	      _LocalStorageProxy2.default.setItem('wishlist.common', (0, _stringify2.default)(items));
	      // setWishList(JSON.stringify(items));
	
	      return (0, _extends3.default)({}, state, {
	        wishProducts: items
	      });
	
	    case _constants.WishConstants.DEL_FROM_WISHLIST:
	      var arrItems = [].concat((0, _toConsumableArray3.default)(state.wishProducts));
	      for (var _i = 0; _i < arrItems.length; _i++) {
	        if (arrItems[_i].id === action.product.id && arrItems[_i].modifier_option_id === action.product.modifier_option_id) {
	          arrItems.splice(_i, 1);
	          break;
	        }
	      }
	
	      _LocalStorageProxy2.default.setItem('wishlist.common', (0, _stringify2.default)(arrItems));
	
	      return (0, _extends3.default)({}, state, {
	        wishProducts: arrItems
	      });
	
	    case _constants.WishConstants.COPY_TO_WISHLIST:
	
	      var _wishList = void 0;
	
	      try {
	        _wishList = JSON.parse(_LocalStorageProxy2.default.getItem('wishlist.common'));
	      } catch (e) {
	        _wishList = null;
	      }
	
	      if (!Array.isArray(_wishList)) {
	        _wishList = [];
	      }
	
	      return (0, _extends3.default)({}, state, {
	        wishProducts: _wishList
	      });
	
	    case _constants.WishConstants.UPDATE_PRODUCT_FOR_WISHLIST:
	      var itemsUpdate = [].concat((0, _toConsumableArray3.default)(state.wishProducts));
	      return (0, _extends3.default)({}, state, {
	        wishProducts: itemsUpdate
	      });
	
	    case _constants.WishConstants.GET_ACTUAL_PRICES_LOAD_WISHLIST:
	      return (0, _extends3.default)({}, state, {
	        preload: true
	      });
	
	    case _constants.WishConstants.GET_ACTUAL_PRICES_SUCCESS_WISHLIST:
	      _LocalStorageProxy2.default.setItem('wishlist.common', (0, _stringify2.default)(action.result));
	      return (0, _extends3.default)({}, state, {
	        preload: false,
	        serverLoad: true,
	        wishProducts: action.result
	      });
	
	    case _constants.WishConstants.GET_ACTUAL_PRICES_FAIL_WISHLIST:
	      return (0, _extends3.default)({}, state, {
	        preload: false
	      });
	
	    case _constants.AuthConstants.LOGIN_SUCCESS:
	      var wishListUpdate = JSON.parse(_LocalStorageProxy2.default.getItem('wishlist.common'));
	      return (0, _extends3.default)({}, state, {
	        wishProducts: wishListUpdate
	      });
	    //
	    // case WishConstants.SET_WISHLIST:
	    //     return {
	    //         ...state,
	    //         preload: false
	    //     };
	    //
	    // case WishConstants.SET_WISHLIST_SUCCESS:
	    //     return {
	    //         ...state,
	    //         preload: false
	    //     };
	
	    default:
	      return state;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(48);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.getRouteSettings = getRouteSettings;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(177);
	
	var _reactRouter = __webpack_require__(19);
	
	var _auth = __webpack_require__(53);
	
	var _modal_type = __webpack_require__(42);
	
	var _confirmation = __webpack_require__(1859);
	
	var _containers = __webpack_require__(763);
	
	var _components2 = __webpack_require__(16);
	
	var _AddressList = __webpack_require__(1796);
	
	var _AddressList2 = _interopRequireDefault(_AddressList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isNeedToShowRegModal = false;
	
	exports.default = function (store) {
	    var requireLogin = function requireLogin(nextState, replace, cb) {
	        var dispatch = store.dispatch,
	            getState = store.getState;
	
	        var _getState = getState(),
	            user = _getState.auth.user;
	
	        function checkAuth() {
	            var REGEXP_ORDER_ROUTE = /(\/personal\/order\/)[\d]+/g;
	            var REGEXP_CREATE_ORDER_ROUTE = /(\/create-order\/)[\d]+/g;
	
	            if (!{ auth: { user: user } } && !REGEXP_ORDER_ROUTE.test(nextState.location.pathname) && !REGEXP_CREATE_ORDER_ROUTE.test(nextState.location.pathname)) {
	                // роут для карточки заказа не перекидываем на главную
	                replace('/');
	            }
	
	            cb();
	        }
	
	        if (!(0, _auth.isLoaded)(getState()) && (0, _auth.isLoadedInServer)(getState())) {
	            dispatch((0, _auth.load)()).then(checkAuth);
	        } else {
	            checkAuth();
	        }
	    };
	
	    var onEnter = function onEnter() {
	        _components2.PreloaderGlobal.toogleShow('one_show');
	    };
	
	    var onLeave = function onLeave() {
	        _components2.PreloaderGlobal.toogleShow('on');
	    };
	
	    var onEnterRegPage = function onEnterRegPage(nextState, replace, cb) {
	        isNeedToShowRegModal = true;
	        if (true) {
	            replace('/');
	        }
	        cb();
	    };
	
	    var onEnterMainPage = function onEnterMainPage(nextState, replace, cb) {
	        var dispatch = store.dispatch;
	
	        if (isNeedToShowRegModal) {
	            dispatch((0, _modal_type.showModalRegistration)());
	        }
	
	        isNeedToShowRegModal = false;
	
	        cb();
	    };
	
	    var onEnterToOrderDetails = function onEnterToOrderDetails(nextState, replace, cb) {
	        var confirmProcessor = new _confirmation.ConfirmationEmailByUrlParamsProcessor(nextState.location, nextState.params, store);
	        confirmProcessor.tryToConfirm().then(function () {
	            return cb();
	        }).catch(function () {
	            return cb();
	        });
	    };
	    /**
	     * Please keep routes in alphabetical order
	     */
	    return _react2.default.createElement(
	        _reactRouter.Route,
	        { path: '/', component: _containers.App, onEnter: onEnterMainPage },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Main, onEnter: onEnter, onLeave: onLeave }),
	        _react2.default.createElement(
	            _reactRouter.Route,
	            { component: _containers.CheckAuth, onEnter: requireLogin },
	            _react2.default.createElement(_reactRouter.Route, { path: 'create-order/:order_id', component: _containers.CreateOrder, onEnter: onEnterToOrderDetails }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'payment-order/:order_id', component: _containers.PaymentOrder }),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'personal', component: _containers.Personal, onEnter: onEnter, onLeave: onLeave },
	                _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'profile' }),
	                _react2.default.createElement(_reactRouter.Route, { path: 'order-list', component: _containers.OrderList }),
	                _react2.default.createElement(_reactRouter.Route, { path: 'addresses', component: _AddressList2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: 'order/:order_id', component: _containers.OrderDetail, onEnter: onEnterToOrderDetails }),
	                _react2.default.createElement(_reactRouter.Route, { path: 'profile', component: _containers.Profile }),
	                _react2.default.createElement(_reactRouter.Route, { path: 'wishlist', component: _containers.WishList }),
	                _react2.default.createElement(_reactRouter.Route, { path: 'basket', component: _containers.PersonalBasket }),
	                _react2.default.createElement(_reactRouter.Route, { path: 'operations', component: _containers.Operations })
	            )
	        ),
	        _react2.default.createElement(_reactRouter.Route, { path: 'registration', onEnter: onEnterRegPage, component: _containers.Registration }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'product/:id', component: _containers.CartProduct }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'basket', component: _containers.Basket }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'basket/:code', component: _containers.ShareBasket }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'wishlist', component: _containers.WishList }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'postpone', component: _containers.PostponeBasket }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'category/:id', component: _containers.Category, onEnter: onEnter, onLeave: onLeave }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'search/:input_state', component: _containers.Search }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'slide', component: _containers.Slide, settings: { includeOnlineAdvisorCode: false } }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'page/:page_url', component: _containers.Page }),
	        _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
	    );
	};
	
	// Получаем кастомные настройки с роута <Route path="/" settings={{ opt1: true }}>
	
	
	function getRouteSettings(routes) {
	    var settings = {};
	    if (Array.isArray(routes)) {
	        routes.forEach(function (route) {
	            if ((0, _typeof3.default)(route.settings) === 'object') {
	                (0, _lodash.merge)(settings, route.settings);
	            }
	        });
	    } else if ((0, _lodash.isPlainObject)(routes)) {
	        if ((0, _typeof3.default)(routes.settings) === 'object') {
	            (0, _lodash.merge)(settings, route.settings);
	        }
	    }
	
	    return settings;
	}

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(1923);
	var reduce = __webpack_require__(1561);
	var requestBase = __webpack_require__(1921);
	var isObject = __webpack_require__(769);
	
	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  root = this;
	}
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Expose `request`.
	 */
	
	var request = module.exports = __webpack_require__(1922).bind(null, Request);
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pushEncodedKeyValuePair(pairs, key, obj[key]);
	        }
	      }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (Array.isArray(val)) {
	    return val.forEach(function(v) {
	      pushEncodedKeyValuePair(pairs, key, v);
	    });
	  }
	  pairs.push(encodeURIComponent(key)
	    + '=' + encodeURIComponent(val));
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype.parseBody = function(str){
	  var parse = request.parse[this.type];
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype.setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
	      // issue #876: return the http status code if the response parsing fails
	      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    if (err) {
	      return self.callback(err, res);
	    }
	
	    if (res.status >= 200 && res.status < 300) {
	      return self.callback(err, res);
	    }
	
	    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	    new_err.original = err;
	    new_err.response = res;
	    new_err.status = res.status;
	
	    self.callback(new_err, res);
	  });
	}
	
	/**
	 * Mixin `Emitter` and `requestBase`.
	 */
	
	Emitter(Request.prototype);
	for (var key in requestBase) {
	  Request.prototype[key] = requestBase[key];
	}
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	
	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr && this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set responseType to `val`. Presently valid responseTypes are 'blob' and 
	 * 'arraybuffer'.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (!options) {
	    options = {
	      type: 'basic'
	    }
	  }
	
	  switch (options.type) {
	    case 'basic':
	      var str = btoa(user + ':' + pass);
	      this.set('Authorization', 'Basic ' + str);
	    break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	  }
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  this._getFormData().append(field, file, filename || file.name);
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this._header['content-type'];
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || isHost(data)) return this;
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * @deprecated
	 */
	Response.prototype.parse = function serialize(fn){
	  if (root.console) {
	    console.warn("Client-side parse() method has been renamed to serialize(). This method is not compatible with superagent v2.0");
	  }
	  this.serialize(fn);
	  return this;
	};
	
	Response.prototype.serialize = function serialize(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self.timeoutError();
	      if (self.aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(e){
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = 'download';
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    xhr.onprogress = handleProgress;
	  }
	  try {
	    if (xhr.upload && this.hasListeners('progress')) {
	      xhr.upload.onprogress = handleProgress;
	    }
	  } catch(e) {
	    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	    // Reported here:
	    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	
	  // initiate request
	  if (this.username && this.password) {
	    xhr.open(this.method, this.url, true, this.username, this.password);
	  } else {
	    xhr.open(this.method, this.url, true);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._parser || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(769);
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.clearTimeout = function _clearTimeout(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Force given parser
	 *
	 * Sets the body parser no matter type.
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.timeout = function timeout(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Faux promise support
	 *
	 * @param {Function} fulfill
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	exports.then = function then(fulfill, reject) {
	  return this.end(function(err, res) {
	    err ? reject(err) : fulfill(res);
	  });
	}
	
	/**
	 * Allow for extension
	 */
	
	exports.use = function use(fn) {
	  fn(this);
	  return this;
	}
	
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	exports.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	exports.getHeader = exports.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	exports.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	exports.field = function(name, val) {
	  this._getFormData().append(name, val);
	  return this;
	};


/***/ }),
/* 1922 */
/***/ (function(module, exports) {

	// The node and browser modules expose versions of this with the
	// appropriate constructor function bound as first argument
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(RequestConstructor, method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new RequestConstructor('GET', method).end(url);
	  }
	
	  // url first
	  if (2 == arguments.length) {
	    return new RequestConstructor('GET', method);
	  }
	
	  return new RequestConstructor(method, url);
	}
	
	module.exports = request;


/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1925);


/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1926);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(167)(module)))

/***/ }),
/* 1926 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 1927 */
/***/ (function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(1929);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(47);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(1931);
	var v4 = __webpack_require__(1932);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(771);
	var bytesToUuid = __webpack_require__(770);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	// random #'s we need to init node and clockseq
	var _seedBytes = rng();
	
	// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	var _nodeId = [
	  _seedBytes[0] | 0x01,
	  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
	];
	
	// Per 4.2.2, randomize (14 bit) clockseq
	var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	// Previous uuid creation time
	var _lastMSecs = 0, _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  var node = options.node || _nodeId;
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(771);
	var bytesToUuid = __webpack_require__(770);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options == 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PlayerStates = __webpack_require__(1935);
	
	var _PlayerStates2 = _interopRequireDefault(_PlayerStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  pauseVideo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
	    stateChangeRequired: false
	  },
	  playVideo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
	    stateChangeRequired: false
	  },
	  seekTo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
	    stateChangeRequired: true,
	
	    // TRICKY: `seekTo` may not cause a state change if no buffering is
	    // required.
	    timeout: 3000
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debug = __webpack_require__(309);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _functionNames = __webpack_require__(1937);
	
	var _functionNames2 = _interopRequireDefault(_functionNames);
	
	var _eventNames = __webpack_require__(1936);
	
	var _eventNames2 = _interopRequireDefault(_eventNames);
	
	var _FunctionStateMap = __webpack_require__(1933);
	
	var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _debug2.default)('youtube-player');
	
	var YouTubePlayer = {};
	
	/**
	 * Construct an object that defines an event handler for all of the YouTube
	 * player events. Proxy captured events through an event emitter.
	 *
	 * @todo Capture event parameters.
	 * @see https://developers.google.com/youtube/iframe_api_reference#Events
	 */
	YouTubePlayer.proxyEvents = function (emitter) {
	  var events = {};
	
	  var _loop = function _loop(eventName) {
	    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);
	
	    events[onEventName] = function (event) {
	      debug('event "%s"', onEventName, event);
	
	      emitter.trigger(eventName, event);
	    };
	  };
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var eventName = _step.value;
	
	      _loop(eventName);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return events;
	};
	
	/**
	 * Delays player API method execution until player state is ready.
	 *
	 * @todo Proxy all of the methods using Object.keys.
	 * @todo See TRICKY below.
	 * @param playerAPIReady Promise that resolves when player is ready.
	 * @param strictState A flag designating whether or not to wait for
	 * an acceptable state when calling supported functions.
	 * @returns {Object}
	 */
	YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
	  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var functions = {};
	
	  var _loop2 = function _loop2(functionName) {
	    if (strictState && _FunctionStateMap2.default[functionName]) {
	      functions[functionName] = function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return playerAPIReady.then(function (player) {
	          var stateInfo = _FunctionStateMap2.default[functionName];
	          var playerState = player.getPlayerState();
	
	          // eslint-disable-next-line no-warning-comments
	          // TODO: Just spread the args into the function once Babel is fixed:
	          // https://github.com/babel/babel/issues/4270
	          //
	          // eslint-disable-next-line prefer-spread
	          var value = player[functionName].apply(player, args);
	
	          // TRICKY: For functions like `seekTo`, a change in state must be
	          // triggered given that the resulting state could match the initial
	          // state.
	          if (stateInfo.stateChangeRequired ||
	
	          // eslint-disable-next-line no-extra-parens
	          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
	            return new Promise(function (resolve) {
	              var onPlayerStateChange = function onPlayerStateChange() {
	                var playerStateAfterChange = player.getPlayerState();
	
	                var timeout = void 0;
	
	                if (typeof stateInfo.timeout === 'number') {
	                  timeout = setTimeout(function () {
	                    player.removeEventListener('onStateChange', onPlayerStateChange);
	
	                    resolve();
	                  }, stateInfo.timeout);
	                }
	
	                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
	                  player.removeEventListener('onStateChange', onPlayerStateChange);
	
	                  clearTimeout(timeout);
	
	                  resolve();
	                }
	              };
	
	              player.addEventListener('onStateChange', onPlayerStateChange);
	            }).then(function () {
	              return value;
	            });
	          }
	
	          return value;
	        });
	      };
	    } else {
	      functions[functionName] = function () {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        return playerAPIReady.then(function (player) {
	          // eslint-disable-next-line no-warning-comments
	          // TODO: Just spread the args into the function once Babel is fixed:
	          // https://github.com/babel/babel/issues/4270
	          //
	          // eslint-disable-next-line prefer-spread
	          return player[functionName].apply(player, args);
	        });
	      };
	    }
	  };
	
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var functionName = _step2.value;
	
	      _loop2(functionName);
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return functions;
	};
	
	exports.default = YouTubePlayer;
	module.exports = exports['default'];

/***/ }),
/* 1935 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  BUFFERING: 3,
	  ENDED: 0,
	  PAUSED: 2,
	  PLAYING: 1,
	  UNSTARTED: -1,
	  VIDEO_CUED: 5
	};
	module.exports = exports["default"];

/***/ }),
/* 1936 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Events
	 * `volumeChange` is not officially supported but seems to work
	 * it emits an object: `{volume: 82.6923076923077, muted: false}`
	 */
	exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
	module.exports = exports['default'];

/***/ }),
/* 1937 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
	 */
	exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
	module.exports = exports['default'];

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _sister = __webpack_require__(1570);
	
	var _sister2 = _interopRequireDefault(_sister);
	
	var _loadYouTubeIframeApi = __webpack_require__(1939);
	
	var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);
	
	var _YouTubePlayer = __webpack_require__(1934);
	
	var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @typedef YT.Player
	 * @see https://developers.google.com/youtube/iframe_api_reference
	 * */
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
	 */
	var youtubeIframeAPI = void 0;
	
	/**
	 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
	 *
	 * @param elementId Either An existing YT.Player instance,
	 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
	 * @param options See `options` (Ignored when using an existing YT.Player instance).
	 * @param strictState A flag designating whether or not to wait for
	 * an acceptable state when calling supported functions. Default: `false`.
	 * See `FunctionStateMap.js` for supported functions and acceptable states.
	 */
	
	exports.default = function (maybeElementId) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var emitter = (0, _sister2.default)();
	
	  if (!youtubeIframeAPI) {
	    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)();
	  }
	
	  if (options.events) {
	    throw new Error('Event handlers cannot be overwritten.');
	  }
	
	  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
	    throw new Error('Element "' + maybeElementId + '" does not exist.');
	  }
	
	  options.events = _YouTubePlayer2.default.proxyEvents(emitter);
	
	  var playerAPIReady = new Promise(function (resolve) {
	    if (typeof maybeElementId === 'string' || maybeElementId instanceof HTMLElement) {
	      // eslint-disable-next-line promise/catch-or-return
	      youtubeIframeAPI.then(function (YT) {
	        var player = new YT.Player(maybeElementId, options);
	
	        emitter.on('ready', function () {
	          resolve(player);
	        });
	
	        return null;
	      });
	    } else if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
	      var player = maybeElementId;
	
	      resolve(player);
	    } else {
	      throw new TypeError('Unexpected state.');
	    }
	  });
	
	  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);
	
	  playerApi.on = emitter.on;
	  playerApi.off = emitter.off;
	
	  return playerApi;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loadScript = __webpack_require__(1135);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  /**
	   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
	   * The promise is resolved with a reference to window.YT object.
	   */
	  var iframeAPIReady = new Promise(function (resolve) {
	    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
	      resolve(window.YT);
	
	      return;
	    }
	
	    var previous = window.onYouTubeIframeAPIReady;
	
	    // The API will call this function when page has finished downloading
	    // the JavaScript for the player API.
	    window.onYouTubeIframeAPIReady = function () {
	      if (previous) {
	        previous();
	      }
	
	      resolve(window.YT);
	    };
	  });
	
	  var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
	
	  (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api');
	
	  return iframeAPIReady;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./AddressInput/default/AddressInputView": 1596,
		"./AddressListInput/default/AddressListInputView": 745,
		"./Auth/default/AuthHeaderView": 1606,
		"./Auth/default/AuthOneClickView": 1607,
		"./Auth/default/AuthView": 1608,
		"./Basket/AddToBasket/default/AddToBasketView": 1611,
		"./Basket/AddToBasket/default/ModalContentView": 1612,
		"./Basket/BuyInCreditModal/default/BuyInCreditModalView": 1615,
		"./Basket/ModifierModal/default/ModifierModalView": 1618,
		"./Basket/default/BasketView": 1620,
		"./CartProduct/Breads/default/BreadsView": 1625,
		"./CartProduct/FullDescription/default/FullDescriptionView": 1628,
		"./CartProduct/ShortDescription/default/ShortDescriptionView": 1631,
		"./CartProduct/Slider/default/SliderView": 1636,
		"./CartProduct/Stars/default/StarsView": 1639,
		"./ConfirmChangePhone/default/ConfirmChangePhoneView": 1644,
		"./ConfirmMail/default/ConfirmMailView": 1647,
		"./ConfirmOldMail/default/ConfirmOldMailView": 1650,
		"./ConfirmPhone/default/ConfirmPhoneView": 1653,
		"./DropdownSelect/default/DropdownSelectView": 1657,
		"./Footer/default/FooterView": 1660,
		"./GoodsSlider/default/GoodsSliderView": 1663,
		"./Hamburger/MobileCatalog/default/MobileCatalogView": 1669,
		"./Hamburger/MyMenu/default/MyMenuView": 1671,
		"./Hamburger/default/HamburgerView": 1672,
		"./Header/Logo/default/LogoView": 1676,
		"./Header/default/HeaderView": 1677,
		"./Menu/default/MenuView": 1684,
		"./MiniBasket/default/MiniBasketView": 1687,
		"./MoneyValue/default/MoneyValueView": 1693,
		"./Notification/default/NotificationView": 1696,
		"./Operations/default/OperationsItemView": 1700,
		"./Operations/default/SaldoItemView": 1701,
		"./Order/PaymentList/default/PaymentListView": 1706,
		"./Order/default/OrderItemsDetailView": 1713,
		"./Order/default/OrderItemsView": 1714,
		"./Paginator/default/PaginatorView": 1717,
		"./PassRecovery/PassRecoveryStepOne/default/PassRecoveryStepOneView": 1721,
		"./PassRecovery/PassRecoveryStepThree/default/PassRecoveryStepThreeView": 1724,
		"./PassRecovery/PassRecoveryStepTwo/default/PassRecoveryStepTwoView": 1727,
		"./PasswordChange/default/PasswordChangeView": 1732,
		"./PaymentStatusLabel/default/PaymentStatusLabelView": 1734,
		"./Preloader/default/PreloaderView": 1736,
		"./Products/default/ProductsView": 1740,
		"./QuantityProduct/default/QuantityProductView": 1743,
		"./Registration/RegistrationConfirm/default/RegistrationConfirmView": 1747,
		"./Registration/RegistrationForm/default/RegistrationFormView": 1750,
		"./Registration/RegistrationHeader/default/RegistrationHeaderView": 1753,
		"./Registration/RegistrationSuccess/default/RegistrationSuccessView": 1756,
		"./Search/CouponSearchModal/default/CouponSearchModalView": 1762,
		"./Search/default/SearchView": 1765,
		"./Slider/default/SliderView": 1767,
		"./SliderWithQR/default/SliderWithQRView": 1770,
		"./SocialRow/default/SocialRowView": 1773,
		"./UserProfile/UserInfo/default/UserInfoView": 1777,
		"./UserProfile/UserInfoRowItem/default/UserInfoRowItemView": 1780,
		"./UserProfile/UserProfileMenu/default/UserProfileMenuView": 1784,
		"./UserProfile/default/UserProfileView": 1786,
		"./VoiceCode/default/VoiceCodeView": 1788
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1940;


/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./App/default/AppView": 1798,
		"./CartProduct/default/CartProductView": 1804,
		"./Category/default/CategoryView": 1807,
		"./Main/default/MainView": 1812,
		"./NotFound/default/NotFoundView": 1815,
		"./NotFoundServer/default/NotFoundServerView": 1818,
		"./Order/default/PaymentOrderView": 1823,
		"./Personal/Operations/default/OperationsView": 1827,
		"./Personal/OrderDetail/default/OrderDetailView": 1829,
		"./Personal/OrderList/default/OrderListItemView": 762,
		"./Personal/OrderList/default/OrderListView": 1831,
		"./Personal/Profile/default/ProfileView": 1835,
		"./Personal/default/PersonalView": 1837,
		"./PostponeBasket/default/PostponeBasketView": 1840,
		"./Registration/default/RegistrationView": 1843,
		"./Search/default/SearchView": 1846,
		"./Slide/default/SlideView": 1849,
		"./WishList/default/WishListView": 1854
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1941;


/***/ }),
/* 1942 */
/***/ (function(module, exports) {

	function webpackContext(req) {
		throw new Error("Cannot find module '" + req + "'.");
	}
	webpackContext.keys = function() { return []; };
	webpackContext.resolve = webpackContext;
	module.exports = webpackContext;
	webpackContext.id = 1942;


/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = { "default": __webpack_require__(__webpack_module_template_argument_0__), __esModule: true };

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = { "default": __webpack_require__(__webpack_module_template_argument_0__), __esModule: true };

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var invoke = __webpack_require__(__webpack_module_template_argument_2__);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var call = __webpack_require__(__webpack_module_template_argument_1__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_2__);
	var anObject = __webpack_require__(__webpack_module_template_argument_3__);
	var toLength = __webpack_require__(__webpack_module_template_argument_4__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_5__);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create = __webpack_require__(__webpack_module_template_argument_0__);
	var descriptor = __webpack_require__(__webpack_module_template_argument_1__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_2__);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var hide = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_5__);
	var $iterCreate = __webpack_require__(__webpack_module_template_argument_6__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_7__);
	var getPrototypeOf = __webpack_require__(__webpack_module_template_argument_8__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_9__)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META = __webpack_require__(__webpack_module_template_argument_0__)('meta');
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var has = __webpack_require__(__webpack_module_template_argument_2__);
	var setDesc = __webpack_require__(__webpack_module_template_argument_3__).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var macrotask = __webpack_require__(__webpack_module_template_argument_1__).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(__webpack_module_template_argument_2__)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if (Observer) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	var toObject = __webpack_require__(__webpack_module_template_argument_3__);
	var IObject = __webpack_require__(__webpack_module_template_argument_4__);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(__webpack_module_template_argument_5__)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPN = __webpack_require__(__webpack_module_template_argument_1__).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var fails = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var isEnum = __webpack_require__(__webpack_module_template_argument_2__).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var newPromiseCapability = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f;
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_1__);
	var SPECIES = __webpack_require__(__webpack_module_template_argument_2__)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var invoke = __webpack_require__(__webpack_module_template_argument_1__);
	var html = __webpack_require__(__webpack_module_template_argument_2__);
	var cel = __webpack_require__(__webpack_module_template_argument_3__);
	var global = __webpack_require__(__webpack_module_template_argument_4__);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(__webpack_module_template_argument_5__)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_2__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_3__);
	var defineProperty = __webpack_require__(__webpack_module_template_argument_4__).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	exports.f = __webpack_require__(__webpack_module_template_argument_0__);


/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var call = __webpack_require__(__webpack_module_template_argument_3__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_4__);
	var toLength = __webpack_require__(__webpack_module_template_argument_5__);
	var createProperty = __webpack_require__(__webpack_module_template_argument_6__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_7__);
	
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_8__)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__);
	var step = __webpack_require__(__webpack_module_template_argument_1__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_1__), 'Object', { defineProperty: __webpack_require__(__webpack_module_template_argument_2__).f });


/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $getOwnPropertyDescriptor = __webpack_require__(__webpack_module_template_argument_1__).f;
	
	__webpack_require__(__webpack_module_template_argument_2__)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(__webpack_module_template_argument_0__)('getOwnPropertyNames', function () {
	  return __webpack_require__(__webpack_module_template_argument_1__).f;
	});


/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $getPrototypeOf = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(__webpack_module_template_argument_1__).set });


/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var ctx = __webpack_require__(__webpack_module_template_argument_2__);
	var classof = __webpack_require__(__webpack_module_template_argument_3__);
	var $export = __webpack_require__(__webpack_module_template_argument_4__);
	var isObject = __webpack_require__(__webpack_module_template_argument_5__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_6__);
	var anInstance = __webpack_require__(__webpack_module_template_argument_7__);
	var forOf = __webpack_require__(__webpack_module_template_argument_8__);
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_9__);
	var task = __webpack_require__(__webpack_module_template_argument_10__).set;
	var microtask = __webpack_require__(__webpack_module_template_argument_11__)();
	var newPromiseCapabilityModule = __webpack_require__(__webpack_module_template_argument_12__);
	var perform = __webpack_require__(__webpack_module_template_argument_13__);
	var promiseResolve = __webpack_require__(__webpack_module_template_argument_14__);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(__webpack_module_template_argument_15__)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  if (promise._h == 1) return false;
	  var chain = promise._a || promise._c;
	  var i = 0;
	  var reaction;
	  while (chain.length > i) {
	    reaction = chain[i++];
	    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
	  } return true;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(__webpack_module_template_argument_16__)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(__webpack_module_template_argument_17__)($Promise, PROMISE);
	__webpack_require__(__webpack_module_template_argument_18__)(PROMISE);
	Wrapper = __webpack_require__(__webpack_module_template_argument_19__)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(__webpack_module_template_argument_20__)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var create = __webpack_require__(__webpack_module_template_argument_1__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_2__);
	var anObject = __webpack_require__(__webpack_module_template_argument_3__);
	var isObject = __webpack_require__(__webpack_module_template_argument_4__);
	var fails = __webpack_require__(__webpack_module_template_argument_5__);
	var bind = __webpack_require__(__webpack_module_template_argument_6__);
	var rConstruct = (__webpack_require__(__webpack_module_template_argument_7__).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__, __webpack_module_template_argument_26__, __webpack_module_template_argument_27__, __webpack_module_template_argument_28__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_2__);
	var $export = __webpack_require__(__webpack_module_template_argument_3__);
	var redefine = __webpack_require__(__webpack_module_template_argument_4__);
	var META = __webpack_require__(__webpack_module_template_argument_5__).KEY;
	var $fails = __webpack_require__(__webpack_module_template_argument_6__);
	var shared = __webpack_require__(__webpack_module_template_argument_7__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_8__);
	var uid = __webpack_require__(__webpack_module_template_argument_9__);
	var wks = __webpack_require__(__webpack_module_template_argument_10__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_11__);
	var wksDefine = __webpack_require__(__webpack_module_template_argument_12__);
	var enumKeys = __webpack_require__(__webpack_module_template_argument_13__);
	var isArray = __webpack_require__(__webpack_module_template_argument_14__);
	var anObject = __webpack_require__(__webpack_module_template_argument_15__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_16__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_17__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_18__);
	var _create = __webpack_require__(__webpack_module_template_argument_19__);
	var gOPNExt = __webpack_require__(__webpack_module_template_argument_20__);
	var $GOPD = __webpack_require__(__webpack_module_template_argument_21__);
	var $DP = __webpack_require__(__webpack_module_template_argument_22__);
	var $keys = __webpack_require__(__webpack_module_template_argument_23__);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(__webpack_module_template_argument_24__).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(__webpack_module_template_argument_25__).f = $propertyIsEnumerable;
	  __webpack_require__(__webpack_module_template_argument_26__).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(__webpack_module_template_argument_27__)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(__webpack_module_template_argument_28__)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $entries = __webpack_require__(__webpack_module_template_argument_1__)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $values = __webpack_require__(__webpack_module_template_argument_1__)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var global = __webpack_require__(__webpack_module_template_argument_2__);
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_3__);
	var promiseResolve = __webpack_require__(__webpack_module_template_argument_4__);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var newPromiseCapability = __webpack_require__(__webpack_module_template_argument_1__);
	var perform = __webpack_require__(__webpack_module_template_argument_2__);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('asyncIterator');


/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('observable');


/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	var _Object$assign = __webpack_require__(__webpack_module_template_argument_0__)["default"];
	
	exports["default"] = _Object$assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	__webpack_require__(__webpack_module_template_argument_0__);
	module.exports = __webpack_require__(__webpack_module_template_argument_1__).Object.assign;

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var global    = __webpack_require__(__webpack_module_template_argument_0__)
	  , core      = __webpack_require__(__webpack_module_template_argument_1__)
	  , ctx       = __webpack_require__(__webpack_module_template_argument_2__)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(__webpack_module_template_argument_0__)
	  , toObject = __webpack_require__(__webpack_module_template_argument_1__)
	  , IObject  = __webpack_require__(__webpack_module_template_argument_2__);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(__webpack_module_template_argument_3__)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(__webpack_module_template_argument_1__)});

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
	}
	module.exports = exports['default'];

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;
	
	var _inDOM = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = 'transform';
	var prefix = void 0,
	    transitionEnd = void 0,
	    animationEnd = void 0;
	var transitionProperty = void 0,
	    transitionDuration = void 0,
	    transitionTiming = void 0,
	    transitionDelay = void 0;
	var animationName = void 0,
	    animationDuration = void 0,
	    animationTiming = void 0,
	    animationDelay = void 0;
	
	if (_inDOM2.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	
	
	  exports.transform = transform = prefix + '-' + transform;
	  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
	  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
	  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
	  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';
	
	  exports.animationName = animationName = prefix + '-animation-name';
	  exports.animationDuration = animationDuration = prefix + '-animation-duration';
	  exports.animationTiming = animationTiming = prefix + '-animation-delay';
	  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
	}
	
	exports.transform = transform;
	exports.transitionProperty = transitionProperty;
	exports.transitionTiming = transitionTiming;
	exports.transitionDelay = transitionDelay;
	exports.transitionDuration = transitionDuration;
	exports.transitionEnd = transitionEnd;
	exports.animationName = animationName;
	exports.animationDuration = animationDuration;
	exports.animationTiming = animationTiming;
	exports.animationDelay = animationDelay;
	exports.animationEnd = animationEnd;
	exports.default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	
	  var vendorMap = {
	    O: function O(e) {
	      return 'o' + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return 'webkit' + e;
	    },
	    ms: function ms(e) {
	      return 'MS' + e;
	    }
	  };
	
	  var vendors = Object.keys(vendorMap);
	
	  var transitionEnd = void 0,
	      animationEnd = void 0;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + 'TransitionProperty' in style) {
	      prefix = '-' + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	
	  style = null;
	
	  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
	}

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = undefined;
	
	var _Slider2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Slider3 = _interopRequireDefault(_Slider2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Slider = _Slider3.default;

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// main-ae72afff0cc0bd34b3e7.js